(function(scope){
'use strict';

function F(arity, fun, wrapper) {
  wrapper.a = arity;
  wrapper.f = fun;
  return wrapper;
}

function F2(fun) {
  return F(2, fun, function(a) { return function(b) { return fun(a,b); }; })
}
function F3(fun) {
  return F(3, fun, function(a) {
    return function(b) { return function(c) { return fun(a, b, c); }; };
  });
}
function F4(fun) {
  return F(4, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return fun(a, b, c, d); }; }; };
  });
}
function F5(fun) {
  return F(5, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return fun(a, b, c, d, e); }; }; }; };
  });
}
function F6(fun) {
  return F(6, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return fun(a, b, c, d, e, f); }; }; }; }; };
  });
}
function F7(fun) {
  return F(7, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return fun(a, b, c, d, e, f, g); }; }; }; }; }; };
  });
}
function F8(fun) {
  return F(8, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return function(h) {
    return fun(a, b, c, d, e, f, g, h); }; }; }; }; }; }; };
  });
}
function F9(fun) {
  return F(9, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return function(h) { return function(i) {
    return fun(a, b, c, d, e, f, g, h, i); }; }; }; }; }; }; }; };
  });
}

function A2(fun, a, b) {
  return fun.a === 2 ? fun.f(a, b) : fun(a)(b);
}
function A3(fun, a, b, c) {
  return fun.a === 3 ? fun.f(a, b, c) : fun(a)(b)(c);
}
function A4(fun, a, b, c, d) {
  return fun.a === 4 ? fun.f(a, b, c, d) : fun(a)(b)(c)(d);
}
function A5(fun, a, b, c, d, e) {
  return fun.a === 5 ? fun.f(a, b, c, d, e) : fun(a)(b)(c)(d)(e);
}
function A6(fun, a, b, c, d, e, f) {
  return fun.a === 6 ? fun.f(a, b, c, d, e, f) : fun(a)(b)(c)(d)(e)(f);
}
function A7(fun, a, b, c, d, e, f, g) {
  return fun.a === 7 ? fun.f(a, b, c, d, e, f, g) : fun(a)(b)(c)(d)(e)(f)(g);
}
function A8(fun, a, b, c, d, e, f, g, h) {
  return fun.a === 8 ? fun.f(a, b, c, d, e, f, g, h) : fun(a)(b)(c)(d)(e)(f)(g)(h);
}
function A9(fun, a, b, c, d, e, f, g, h, i) {
  return fun.a === 9 ? fun.f(a, b, c, d, e, f, g, h, i) : fun(a)(b)(c)(d)(e)(f)(g)(h)(i);
}

console.warn('Compiled in DEV mode. Follow the advice at https://elm-lang.org/0.19.1/optimize for better performance and smaller assets.');


var _List_Nil_UNUSED = { $: 0 };
var _List_Nil = { $: '[]' };

function _List_Cons_UNUSED(hd, tl) { return { $: 1, a: hd, b: tl }; }
function _List_Cons(hd, tl) { return { $: '::', a: hd, b: tl }; }


var _List_cons = F2(_List_Cons);

function _List_fromArray(arr)
{
	var out = _List_Nil;
	for (var i = arr.length; i--; )
	{
		out = _List_Cons(arr[i], out);
	}
	return out;
}

function _List_toArray(xs)
{
	for (var out = []; xs.b; xs = xs.b) // WHILE_CONS
	{
		out.push(xs.a);
	}
	return out;
}

var _List_map2 = F3(function(f, xs, ys)
{
	for (var arr = []; xs.b && ys.b; xs = xs.b, ys = ys.b) // WHILE_CONSES
	{
		arr.push(A2(f, xs.a, ys.a));
	}
	return _List_fromArray(arr);
});

var _List_map3 = F4(function(f, xs, ys, zs)
{
	for (var arr = []; xs.b && ys.b && zs.b; xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A3(f, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_map4 = F5(function(f, ws, xs, ys, zs)
{
	for (var arr = []; ws.b && xs.b && ys.b && zs.b; ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A4(f, ws.a, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_map5 = F6(function(f, vs, ws, xs, ys, zs)
{
	for (var arr = []; vs.b && ws.b && xs.b && ys.b && zs.b; vs = vs.b, ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A5(f, vs.a, ws.a, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_sortBy = F2(function(f, xs)
{
	return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
		return _Utils_cmp(f(a), f(b));
	}));
});

var _List_sortWith = F2(function(f, xs)
{
	return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
		var ord = A2(f, a, b);
		return ord === $elm$core$Basics$EQ ? 0 : ord === $elm$core$Basics$LT ? -1 : 1;
	}));
});



var _JsArray_empty = [];

function _JsArray_singleton(value)
{
    return [value];
}

function _JsArray_length(array)
{
    return array.length;
}

var _JsArray_initialize = F3(function(size, offset, func)
{
    var result = new Array(size);

    for (var i = 0; i < size; i++)
    {
        result[i] = func(offset + i);
    }

    return result;
});

var _JsArray_initializeFromList = F2(function (max, ls)
{
    var result = new Array(max);

    for (var i = 0; i < max && ls.b; i++)
    {
        result[i] = ls.a;
        ls = ls.b;
    }

    result.length = i;
    return _Utils_Tuple2(result, ls);
});

var _JsArray_unsafeGet = F2(function(index, array)
{
    return array[index];
});

var _JsArray_unsafeSet = F3(function(index, value, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = array[i];
    }

    result[index] = value;
    return result;
});

var _JsArray_push = F2(function(value, array)
{
    var length = array.length;
    var result = new Array(length + 1);

    for (var i = 0; i < length; i++)
    {
        result[i] = array[i];
    }

    result[length] = value;
    return result;
});

var _JsArray_foldl = F3(function(func, acc, array)
{
    var length = array.length;

    for (var i = 0; i < length; i++)
    {
        acc = A2(func, array[i], acc);
    }

    return acc;
});

var _JsArray_foldr = F3(function(func, acc, array)
{
    for (var i = array.length - 1; i >= 0; i--)
    {
        acc = A2(func, array[i], acc);
    }

    return acc;
});

var _JsArray_map = F2(function(func, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = func(array[i]);
    }

    return result;
});

var _JsArray_indexedMap = F3(function(func, offset, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = A2(func, offset + i, array[i]);
    }

    return result;
});

var _JsArray_slice = F3(function(from, to, array)
{
    return array.slice(from, to);
});

var _JsArray_appendN = F3(function(n, dest, source)
{
    var destLen = dest.length;
    var itemsToCopy = n - destLen;

    if (itemsToCopy > source.length)
    {
        itemsToCopy = source.length;
    }

    var size = destLen + itemsToCopy;
    var result = new Array(size);

    for (var i = 0; i < destLen; i++)
    {
        result[i] = dest[i];
    }

    for (var i = 0; i < itemsToCopy; i++)
    {
        result[i + destLen] = source[i];
    }

    return result;
});



// LOG

var _Debug_log_UNUSED = F2(function(tag, value)
{
	return value;
});

var _Debug_log = F2(function(tag, value)
{
	console.log(tag + ': ' + _Debug_toString(value));
	return value;
});


// TODOS

function _Debug_todo(moduleName, region)
{
	return function(message) {
		_Debug_crash(8, moduleName, region, message);
	};
}

function _Debug_todoCase(moduleName, region, value)
{
	return function(message) {
		_Debug_crash(9, moduleName, region, value, message);
	};
}


// TO STRING

function _Debug_toString_UNUSED(value)
{
	return '<internals>';
}

function _Debug_toString(value)
{
	return _Debug_toAnsiString(false, value);
}

function _Debug_toAnsiString(ansi, value)
{
	if (typeof value === 'function')
	{
		return _Debug_internalColor(ansi, '<function>');
	}

	if (typeof value === 'boolean')
	{
		return _Debug_ctorColor(ansi, value ? 'True' : 'False');
	}

	if (typeof value === 'number')
	{
		return _Debug_numberColor(ansi, value + '');
	}

	if (value instanceof String)
	{
		return _Debug_charColor(ansi, "'" + _Debug_addSlashes(value, true) + "'");
	}

	if (typeof value === 'string')
	{
		return _Debug_stringColor(ansi, '"' + _Debug_addSlashes(value, false) + '"');
	}

	if (typeof value === 'object' && '$' in value)
	{
		var tag = value.$;

		if (typeof tag === 'number')
		{
			return _Debug_internalColor(ansi, '<internals>');
		}

		if (tag[0] === '#')
		{
			var output = [];
			for (var k in value)
			{
				if (k === '$') continue;
				output.push(_Debug_toAnsiString(ansi, value[k]));
			}
			return '(' + output.join(',') + ')';
		}

		if (tag === 'Set_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Set')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Set$toList(value));
		}

		if (tag === 'RBNode_elm_builtin' || tag === 'RBEmpty_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Dict')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Dict$toList(value));
		}

		if (tag === 'Array_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Array')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Array$toList(value));
		}

		if (tag === '::' || tag === '[]')
		{
			var output = '[';

			value.b && (output += _Debug_toAnsiString(ansi, value.a), value = value.b)

			for (; value.b; value = value.b) // WHILE_CONS
			{
				output += ',' + _Debug_toAnsiString(ansi, value.a);
			}
			return output + ']';
		}

		var output = '';
		for (var i in value)
		{
			if (i === '$') continue;
			var str = _Debug_toAnsiString(ansi, value[i]);
			var c0 = str[0];
			var parenless = c0 === '{' || c0 === '(' || c0 === '[' || c0 === '<' || c0 === '"' || str.indexOf(' ') < 0;
			output += ' ' + (parenless ? str : '(' + str + ')');
		}
		return _Debug_ctorColor(ansi, tag) + output;
	}

	if (typeof DataView === 'function' && value instanceof DataView)
	{
		return _Debug_stringColor(ansi, '<' + value.byteLength + ' bytes>');
	}

	if (typeof File !== 'undefined' && value instanceof File)
	{
		return _Debug_internalColor(ansi, '<' + value.name + '>');
	}

	if (typeof value === 'object')
	{
		var output = [];
		for (var key in value)
		{
			var field = key[0] === '_' ? key.slice(1) : key;
			output.push(_Debug_fadeColor(ansi, field) + ' = ' + _Debug_toAnsiString(ansi, value[key]));
		}
		if (output.length === 0)
		{
			return '{}';
		}
		return '{ ' + output.join(', ') + ' }';
	}

	return _Debug_internalColor(ansi, '<internals>');
}

function _Debug_addSlashes(str, isChar)
{
	var s = str
		.replace(/\\/g, '\\\\')
		.replace(/\n/g, '\\n')
		.replace(/\t/g, '\\t')
		.replace(/\r/g, '\\r')
		.replace(/\v/g, '\\v')
		.replace(/\0/g, '\\0');

	if (isChar)
	{
		return s.replace(/\'/g, '\\\'');
	}
	else
	{
		return s.replace(/\"/g, '\\"');
	}
}

function _Debug_ctorColor(ansi, string)
{
	return ansi ? '\x1b[96m' + string + '\x1b[0m' : string;
}

function _Debug_numberColor(ansi, string)
{
	return ansi ? '\x1b[95m' + string + '\x1b[0m' : string;
}

function _Debug_stringColor(ansi, string)
{
	return ansi ? '\x1b[93m' + string + '\x1b[0m' : string;
}

function _Debug_charColor(ansi, string)
{
	return ansi ? '\x1b[92m' + string + '\x1b[0m' : string;
}

function _Debug_fadeColor(ansi, string)
{
	return ansi ? '\x1b[37m' + string + '\x1b[0m' : string;
}

function _Debug_internalColor(ansi, string)
{
	return ansi ? '\x1b[36m' + string + '\x1b[0m' : string;
}

function _Debug_toHexDigit(n)
{
	return String.fromCharCode(n < 10 ? 48 + n : 55 + n);
}


// CRASH


function _Debug_crash_UNUSED(identifier)
{
	throw new Error('https://github.com/elm/core/blob/1.0.0/hints/' + identifier + '.md');
}


function _Debug_crash(identifier, fact1, fact2, fact3, fact4)
{
	switch(identifier)
	{
		case 0:
			throw new Error('What node should I take over? In JavaScript I need something like:\n\n    Elm.Main.init({\n        node: document.getElementById("elm-node")\n    })\n\nYou need to do this with any Browser.sandbox or Browser.element program.');

		case 1:
			throw new Error('Browser.application programs cannot handle URLs like this:\n\n    ' + document.location.href + '\n\nWhat is the root? The root of your file system? Try looking at this program with `elm reactor` or some other server.');

		case 2:
			var jsonErrorString = fact1;
			throw new Error('Problem with the flags given to your Elm program on initialization.\n\n' + jsonErrorString);

		case 3:
			var portName = fact1;
			throw new Error('There can only be one port named `' + portName + '`, but your program has multiple.');

		case 4:
			var portName = fact1;
			var problem = fact2;
			throw new Error('Trying to send an unexpected type of value through port `' + portName + '`:\n' + problem);

		case 5:
			throw new Error('Trying to use `(==)` on functions.\nThere is no way to know if functions are "the same" in the Elm sense.\nRead more about this at https://package.elm-lang.org/packages/elm/core/latest/Basics#== which describes why it is this way and what the better version will look like.');

		case 6:
			var moduleName = fact1;
			throw new Error('Your page is loading multiple Elm scripts with a module named ' + moduleName + '. Maybe a duplicate script is getting loaded accidentally? If not, rename one of them so I know which is which!');

		case 8:
			var moduleName = fact1;
			var region = fact2;
			var message = fact3;
			throw new Error('TODO in module `' + moduleName + '` ' + _Debug_regionToString(region) + '\n\n' + message);

		case 9:
			var moduleName = fact1;
			var region = fact2;
			var value = fact3;
			var message = fact4;
			throw new Error(
				'TODO in module `' + moduleName + '` from the `case` expression '
				+ _Debug_regionToString(region) + '\n\nIt received the following value:\n\n    '
				+ _Debug_toString(value).replace('\n', '\n    ')
				+ '\n\nBut the branch that handles it says:\n\n    ' + message.replace('\n', '\n    ')
			);

		case 10:
			throw new Error('Bug in https://github.com/elm/virtual-dom/issues');

		case 11:
			throw new Error('Cannot perform mod 0. Division by zero error.');
	}
}

function _Debug_regionToString(region)
{
	if (region.start.line === region.end.line)
	{
		return 'on line ' + region.start.line;
	}
	return 'on lines ' + region.start.line + ' through ' + region.end.line;
}



// EQUALITY

function _Utils_eq(x, y)
{
	for (
		var pair, stack = [], isEqual = _Utils_eqHelp(x, y, 0, stack);
		isEqual && (pair = stack.pop());
		isEqual = _Utils_eqHelp(pair.a, pair.b, 0, stack)
		)
	{}

	return isEqual;
}

function _Utils_eqHelp(x, y, depth, stack)
{
	if (x === y)
	{
		return true;
	}

	if (typeof x !== 'object' || x === null || y === null)
	{
		typeof x === 'function' && _Debug_crash(5);
		return false;
	}

	if (depth > 100)
	{
		stack.push(_Utils_Tuple2(x,y));
		return true;
	}

	/**/
	if (x.$ === 'Set_elm_builtin')
	{
		x = $elm$core$Set$toList(x);
		y = $elm$core$Set$toList(y);
	}
	if (x.$ === 'RBNode_elm_builtin' || x.$ === 'RBEmpty_elm_builtin')
	{
		x = $elm$core$Dict$toList(x);
		y = $elm$core$Dict$toList(y);
	}
	//*/

	/**_UNUSED/
	if (x.$ < 0)
	{
		x = $elm$core$Dict$toList(x);
		y = $elm$core$Dict$toList(y);
	}
	//*/

	for (var key in x)
	{
		if (!_Utils_eqHelp(x[key], y[key], depth + 1, stack))
		{
			return false;
		}
	}
	return true;
}

var _Utils_equal = F2(_Utils_eq);
var _Utils_notEqual = F2(function(a, b) { return !_Utils_eq(a,b); });



// COMPARISONS

// Code in Generate/JavaScript.hs, Basics.js, and List.js depends on
// the particular integer values assigned to LT, EQ, and GT.

function _Utils_cmp(x, y, ord)
{
	if (typeof x !== 'object')
	{
		return x === y ? /*EQ*/ 0 : x < y ? /*LT*/ -1 : /*GT*/ 1;
	}

	/**/
	if (x instanceof String)
	{
		var a = x.valueOf();
		var b = y.valueOf();
		return a === b ? 0 : a < b ? -1 : 1;
	}
	//*/

	/**_UNUSED/
	if (typeof x.$ === 'undefined')
	//*/
	/**/
	if (x.$[0] === '#')
	//*/
	{
		return (ord = _Utils_cmp(x.a, y.a))
			? ord
			: (ord = _Utils_cmp(x.b, y.b))
				? ord
				: _Utils_cmp(x.c, y.c);
	}

	// traverse conses until end of a list or a mismatch
	for (; x.b && y.b && !(ord = _Utils_cmp(x.a, y.a)); x = x.b, y = y.b) {} // WHILE_CONSES
	return ord || (x.b ? /*GT*/ 1 : y.b ? /*LT*/ -1 : /*EQ*/ 0);
}

var _Utils_lt = F2(function(a, b) { return _Utils_cmp(a, b) < 0; });
var _Utils_le = F2(function(a, b) { return _Utils_cmp(a, b) < 1; });
var _Utils_gt = F2(function(a, b) { return _Utils_cmp(a, b) > 0; });
var _Utils_ge = F2(function(a, b) { return _Utils_cmp(a, b) >= 0; });

var _Utils_compare = F2(function(x, y)
{
	var n = _Utils_cmp(x, y);
	return n < 0 ? $elm$core$Basics$LT : n ? $elm$core$Basics$GT : $elm$core$Basics$EQ;
});


// COMMON VALUES

var _Utils_Tuple0_UNUSED = 0;
var _Utils_Tuple0 = { $: '#0' };

function _Utils_Tuple2_UNUSED(a, b) { return { a: a, b: b }; }
function _Utils_Tuple2(a, b) { return { $: '#2', a: a, b: b }; }

function _Utils_Tuple3_UNUSED(a, b, c) { return { a: a, b: b, c: c }; }
function _Utils_Tuple3(a, b, c) { return { $: '#3', a: a, b: b, c: c }; }

function _Utils_chr_UNUSED(c) { return c; }
function _Utils_chr(c) { return new String(c); }


// RECORDS

function _Utils_update(oldRecord, updatedFields)
{
	var newRecord = {};

	for (var key in oldRecord)
	{
		newRecord[key] = oldRecord[key];
	}

	for (var key in updatedFields)
	{
		newRecord[key] = updatedFields[key];
	}

	return newRecord;
}


// APPEND

var _Utils_append = F2(_Utils_ap);

function _Utils_ap(xs, ys)
{
	// append Strings
	if (typeof xs === 'string')
	{
		return xs + ys;
	}

	// append Lists
	if (!xs.b)
	{
		return ys;
	}
	var root = _List_Cons(xs.a, ys);
	xs = xs.b
	for (var curr = root; xs.b; xs = xs.b) // WHILE_CONS
	{
		curr = curr.b = _List_Cons(xs.a, ys);
	}
	return root;
}



// MATH

var _Basics_add = F2(function(a, b) { return a + b; });
var _Basics_sub = F2(function(a, b) { return a - b; });
var _Basics_mul = F2(function(a, b) { return a * b; });
var _Basics_fdiv = F2(function(a, b) { return a / b; });
var _Basics_idiv = F2(function(a, b) { return (a / b) | 0; });
var _Basics_pow = F2(Math.pow);

var _Basics_remainderBy = F2(function(b, a) { return a % b; });

// https://www.microsoft.com/en-us/research/wp-content/uploads/2016/02/divmodnote-letter.pdf
var _Basics_modBy = F2(function(modulus, x)
{
	var answer = x % modulus;
	return modulus === 0
		? _Debug_crash(11)
		:
	((answer > 0 && modulus < 0) || (answer < 0 && modulus > 0))
		? answer + modulus
		: answer;
});


// TRIGONOMETRY

var _Basics_pi = Math.PI;
var _Basics_e = Math.E;
var _Basics_cos = Math.cos;
var _Basics_sin = Math.sin;
var _Basics_tan = Math.tan;
var _Basics_acos = Math.acos;
var _Basics_asin = Math.asin;
var _Basics_atan = Math.atan;
var _Basics_atan2 = F2(Math.atan2);


// MORE MATH

function _Basics_toFloat(x) { return x; }
function _Basics_truncate(n) { return n | 0; }
function _Basics_isInfinite(n) { return n === Infinity || n === -Infinity; }

var _Basics_ceiling = Math.ceil;
var _Basics_floor = Math.floor;
var _Basics_round = Math.round;
var _Basics_sqrt = Math.sqrt;
var _Basics_log = Math.log;
var _Basics_isNaN = isNaN;


// BOOLEANS

function _Basics_not(bool) { return !bool; }
var _Basics_and = F2(function(a, b) { return a && b; });
var _Basics_or  = F2(function(a, b) { return a || b; });
var _Basics_xor = F2(function(a, b) { return a !== b; });



var _String_cons = F2(function(chr, str)
{
	return chr + str;
});

function _String_uncons(string)
{
	var word = string.charCodeAt(0);
	return !isNaN(word)
		? $elm$core$Maybe$Just(
			0xD800 <= word && word <= 0xDBFF
				? _Utils_Tuple2(_Utils_chr(string[0] + string[1]), string.slice(2))
				: _Utils_Tuple2(_Utils_chr(string[0]), string.slice(1))
		)
		: $elm$core$Maybe$Nothing;
}

var _String_append = F2(function(a, b)
{
	return a + b;
});

function _String_length(str)
{
	return str.length;
}

var _String_map = F2(function(func, string)
{
	var len = string.length;
	var array = new Array(len);
	var i = 0;
	while (i < len)
	{
		var word = string.charCodeAt(i);
		if (0xD800 <= word && word <= 0xDBFF)
		{
			array[i] = func(_Utils_chr(string[i] + string[i+1]));
			i += 2;
			continue;
		}
		array[i] = func(_Utils_chr(string[i]));
		i++;
	}
	return array.join('');
});

var _String_filter = F2(function(isGood, str)
{
	var arr = [];
	var len = str.length;
	var i = 0;
	while (i < len)
	{
		var char = str[i];
		var word = str.charCodeAt(i);
		i++;
		if (0xD800 <= word && word <= 0xDBFF)
		{
			char += str[i];
			i++;
		}

		if (isGood(_Utils_chr(char)))
		{
			arr.push(char);
		}
	}
	return arr.join('');
});

function _String_reverse(str)
{
	var len = str.length;
	var arr = new Array(len);
	var i = 0;
	while (i < len)
	{
		var word = str.charCodeAt(i);
		if (0xD800 <= word && word <= 0xDBFF)
		{
			arr[len - i] = str[i + 1];
			i++;
			arr[len - i] = str[i - 1];
			i++;
		}
		else
		{
			arr[len - i] = str[i];
			i++;
		}
	}
	return arr.join('');
}

var _String_foldl = F3(function(func, state, string)
{
	var len = string.length;
	var i = 0;
	while (i < len)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		i++;
		if (0xD800 <= word && word <= 0xDBFF)
		{
			char += string[i];
			i++;
		}
		state = A2(func, _Utils_chr(char), state);
	}
	return state;
});

var _String_foldr = F3(function(func, state, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		state = A2(func, _Utils_chr(char), state);
	}
	return state;
});

var _String_split = F2(function(sep, str)
{
	return str.split(sep);
});

var _String_join = F2(function(sep, strs)
{
	return strs.join(sep);
});

var _String_slice = F3(function(start, end, str) {
	return str.slice(start, end);
});

function _String_trim(str)
{
	return str.trim();
}

function _String_trimLeft(str)
{
	return str.replace(/^\s+/, '');
}

function _String_trimRight(str)
{
	return str.replace(/\s+$/, '');
}

function _String_words(str)
{
	return _List_fromArray(str.trim().split(/\s+/g));
}

function _String_lines(str)
{
	return _List_fromArray(str.split(/\r\n|\r|\n/g));
}

function _String_toUpper(str)
{
	return str.toUpperCase();
}

function _String_toLower(str)
{
	return str.toLowerCase();
}

var _String_any = F2(function(isGood, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		if (isGood(_Utils_chr(char)))
		{
			return true;
		}
	}
	return false;
});

var _String_all = F2(function(isGood, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		if (!isGood(_Utils_chr(char)))
		{
			return false;
		}
	}
	return true;
});

var _String_contains = F2(function(sub, str)
{
	return str.indexOf(sub) > -1;
});

var _String_startsWith = F2(function(sub, str)
{
	return str.indexOf(sub) === 0;
});

var _String_endsWith = F2(function(sub, str)
{
	return str.length >= sub.length &&
		str.lastIndexOf(sub) === str.length - sub.length;
});

var _String_indexes = F2(function(sub, str)
{
	var subLen = sub.length;

	if (subLen < 1)
	{
		return _List_Nil;
	}

	var i = 0;
	var is = [];

	while ((i = str.indexOf(sub, i)) > -1)
	{
		is.push(i);
		i = i + subLen;
	}

	return _List_fromArray(is);
});


// TO STRING

function _String_fromNumber(number)
{
	return number + '';
}


// INT CONVERSIONS

function _String_toInt(str)
{
	var total = 0;
	var code0 = str.charCodeAt(0);
	var start = code0 == 0x2B /* + */ || code0 == 0x2D /* - */ ? 1 : 0;

	for (var i = start; i < str.length; ++i)
	{
		var code = str.charCodeAt(i);
		if (code < 0x30 || 0x39 < code)
		{
			return $elm$core$Maybe$Nothing;
		}
		total = 10 * total + code - 0x30;
	}

	return i == start
		? $elm$core$Maybe$Nothing
		: $elm$core$Maybe$Just(code0 == 0x2D ? -total : total);
}


// FLOAT CONVERSIONS

function _String_toFloat(s)
{
	// check if it is a hex, octal, or binary number
	if (s.length === 0 || /[\sxbo]/.test(s))
	{
		return $elm$core$Maybe$Nothing;
	}
	var n = +s;
	// faster isNaN check
	return n === n ? $elm$core$Maybe$Just(n) : $elm$core$Maybe$Nothing;
}

function _String_fromList(chars)
{
	return _List_toArray(chars).join('');
}




function _Char_toCode(char)
{
	var code = char.charCodeAt(0);
	if (0xD800 <= code && code <= 0xDBFF)
	{
		return (code - 0xD800) * 0x400 + char.charCodeAt(1) - 0xDC00 + 0x10000
	}
	return code;
}

function _Char_fromCode(code)
{
	return _Utils_chr(
		(code < 0 || 0x10FFFF < code)
			? '\uFFFD'
			:
		(code <= 0xFFFF)
			? String.fromCharCode(code)
			:
		(code -= 0x10000,
			String.fromCharCode(Math.floor(code / 0x400) + 0xD800, code % 0x400 + 0xDC00)
		)
	);
}

function _Char_toUpper(char)
{
	return _Utils_chr(char.toUpperCase());
}

function _Char_toLower(char)
{
	return _Utils_chr(char.toLowerCase());
}

function _Char_toLocaleUpper(char)
{
	return _Utils_chr(char.toLocaleUpperCase());
}

function _Char_toLocaleLower(char)
{
	return _Utils_chr(char.toLocaleLowerCase());
}



/**/
function _Json_errorToString(error)
{
	return $elm$json$Json$Decode$errorToString(error);
}
//*/


// CORE DECODERS

function _Json_succeed(msg)
{
	return {
		$: 0,
		a: msg
	};
}

function _Json_fail(msg)
{
	return {
		$: 1,
		a: msg
	};
}

function _Json_decodePrim(decoder)
{
	return { $: 2, b: decoder };
}

var _Json_decodeInt = _Json_decodePrim(function(value) {
	return (typeof value !== 'number')
		? _Json_expecting('an INT', value)
		:
	(-2147483647 < value && value < 2147483647 && (value | 0) === value)
		? $elm$core$Result$Ok(value)
		:
	(isFinite(value) && !(value % 1))
		? $elm$core$Result$Ok(value)
		: _Json_expecting('an INT', value);
});

var _Json_decodeBool = _Json_decodePrim(function(value) {
	return (typeof value === 'boolean')
		? $elm$core$Result$Ok(value)
		: _Json_expecting('a BOOL', value);
});

var _Json_decodeFloat = _Json_decodePrim(function(value) {
	return (typeof value === 'number')
		? $elm$core$Result$Ok(value)
		: _Json_expecting('a FLOAT', value);
});

var _Json_decodeValue = _Json_decodePrim(function(value) {
	return $elm$core$Result$Ok(_Json_wrap(value));
});

var _Json_decodeString = _Json_decodePrim(function(value) {
	return (typeof value === 'string')
		? $elm$core$Result$Ok(value)
		: (value instanceof String)
			? $elm$core$Result$Ok(value + '')
			: _Json_expecting('a STRING', value);
});

function _Json_decodeList(decoder) { return { $: 3, b: decoder }; }
function _Json_decodeArray(decoder) { return { $: 4, b: decoder }; }

function _Json_decodeNull(value) { return { $: 5, c: value }; }

var _Json_decodeField = F2(function(field, decoder)
{
	return {
		$: 6,
		d: field,
		b: decoder
	};
});

var _Json_decodeIndex = F2(function(index, decoder)
{
	return {
		$: 7,
		e: index,
		b: decoder
	};
});

function _Json_decodeKeyValuePairs(decoder)
{
	return {
		$: 8,
		b: decoder
	};
}

function _Json_mapMany(f, decoders)
{
	return {
		$: 9,
		f: f,
		g: decoders
	};
}

var _Json_andThen = F2(function(callback, decoder)
{
	return {
		$: 10,
		b: decoder,
		h: callback
	};
});

function _Json_oneOf(decoders)
{
	return {
		$: 11,
		g: decoders
	};
}


// DECODING OBJECTS

var _Json_map1 = F2(function(f, d1)
{
	return _Json_mapMany(f, [d1]);
});

var _Json_map2 = F3(function(f, d1, d2)
{
	return _Json_mapMany(f, [d1, d2]);
});

var _Json_map3 = F4(function(f, d1, d2, d3)
{
	return _Json_mapMany(f, [d1, d2, d3]);
});

var _Json_map4 = F5(function(f, d1, d2, d3, d4)
{
	return _Json_mapMany(f, [d1, d2, d3, d4]);
});

var _Json_map5 = F6(function(f, d1, d2, d3, d4, d5)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5]);
});

var _Json_map6 = F7(function(f, d1, d2, d3, d4, d5, d6)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6]);
});

var _Json_map7 = F8(function(f, d1, d2, d3, d4, d5, d6, d7)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7]);
});

var _Json_map8 = F9(function(f, d1, d2, d3, d4, d5, d6, d7, d8)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7, d8]);
});


// DECODE

var _Json_runOnString = F2(function(decoder, string)
{
	try
	{
		var value = JSON.parse(string);
		return _Json_runHelp(decoder, value);
	}
	catch (e)
	{
		return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, 'This is not valid JSON! ' + e.message, _Json_wrap(string)));
	}
});

var _Json_run = F2(function(decoder, value)
{
	return _Json_runHelp(decoder, _Json_unwrap(value));
});

function _Json_runHelp(decoder, value)
{
	switch (decoder.$)
	{
		case 2:
			return decoder.b(value);

		case 5:
			return (value === null)
				? $elm$core$Result$Ok(decoder.c)
				: _Json_expecting('null', value);

		case 3:
			if (!_Json_isArray(value))
			{
				return _Json_expecting('a LIST', value);
			}
			return _Json_runArrayDecoder(decoder.b, value, _List_fromArray);

		case 4:
			if (!_Json_isArray(value))
			{
				return _Json_expecting('an ARRAY', value);
			}
			return _Json_runArrayDecoder(decoder.b, value, _Json_toElmArray);

		case 6:
			var field = decoder.d;
			if (typeof value !== 'object' || value === null || !(field in value))
			{
				return _Json_expecting('an OBJECT with a field named `' + field + '`', value);
			}
			var result = _Json_runHelp(decoder.b, value[field]);
			return ($elm$core$Result$isOk(result)) ? result : $elm$core$Result$Err(A2($elm$json$Json$Decode$Field, field, result.a));

		case 7:
			var index = decoder.e;
			if (!_Json_isArray(value))
			{
				return _Json_expecting('an ARRAY', value);
			}
			if (index >= value.length)
			{
				return _Json_expecting('a LONGER array. Need index ' + index + ' but only see ' + value.length + ' entries', value);
			}
			var result = _Json_runHelp(decoder.b, value[index]);
			return ($elm$core$Result$isOk(result)) ? result : $elm$core$Result$Err(A2($elm$json$Json$Decode$Index, index, result.a));

		case 8:
			if (typeof value !== 'object' || value === null || _Json_isArray(value))
			{
				return _Json_expecting('an OBJECT', value);
			}

			var keyValuePairs = _List_Nil;
			// TODO test perf of Object.keys and switch when support is good enough
			for (var key in value)
			{
				if (value.hasOwnProperty(key))
				{
					var result = _Json_runHelp(decoder.b, value[key]);
					if (!$elm$core$Result$isOk(result))
					{
						return $elm$core$Result$Err(A2($elm$json$Json$Decode$Field, key, result.a));
					}
					keyValuePairs = _List_Cons(_Utils_Tuple2(key, result.a), keyValuePairs);
				}
			}
			return $elm$core$Result$Ok($elm$core$List$reverse(keyValuePairs));

		case 9:
			var answer = decoder.f;
			var decoders = decoder.g;
			for (var i = 0; i < decoders.length; i++)
			{
				var result = _Json_runHelp(decoders[i], value);
				if (!$elm$core$Result$isOk(result))
				{
					return result;
				}
				answer = answer(result.a);
			}
			return $elm$core$Result$Ok(answer);

		case 10:
			var result = _Json_runHelp(decoder.b, value);
			return (!$elm$core$Result$isOk(result))
				? result
				: _Json_runHelp(decoder.h(result.a), value);

		case 11:
			var errors = _List_Nil;
			for (var temp = decoder.g; temp.b; temp = temp.b) // WHILE_CONS
			{
				var result = _Json_runHelp(temp.a, value);
				if ($elm$core$Result$isOk(result))
				{
					return result;
				}
				errors = _List_Cons(result.a, errors);
			}
			return $elm$core$Result$Err($elm$json$Json$Decode$OneOf($elm$core$List$reverse(errors)));

		case 1:
			return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, decoder.a, _Json_wrap(value)));

		case 0:
			return $elm$core$Result$Ok(decoder.a);
	}
}

function _Json_runArrayDecoder(decoder, value, toElmValue)
{
	var len = value.length;
	var array = new Array(len);
	for (var i = 0; i < len; i++)
	{
		var result = _Json_runHelp(decoder, value[i]);
		if (!$elm$core$Result$isOk(result))
		{
			return $elm$core$Result$Err(A2($elm$json$Json$Decode$Index, i, result.a));
		}
		array[i] = result.a;
	}
	return $elm$core$Result$Ok(toElmValue(array));
}

function _Json_isArray(value)
{
	return Array.isArray(value) || (typeof FileList !== 'undefined' && value instanceof FileList);
}

function _Json_toElmArray(array)
{
	return A2($elm$core$Array$initialize, array.length, function(i) { return array[i]; });
}

function _Json_expecting(type, value)
{
	return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, 'Expecting ' + type, _Json_wrap(value)));
}


// EQUALITY

function _Json_equality(x, y)
{
	if (x === y)
	{
		return true;
	}

	if (x.$ !== y.$)
	{
		return false;
	}

	switch (x.$)
	{
		case 0:
		case 1:
			return x.a === y.a;

		case 2:
			return x.b === y.b;

		case 5:
			return x.c === y.c;

		case 3:
		case 4:
		case 8:
			return _Json_equality(x.b, y.b);

		case 6:
			return x.d === y.d && _Json_equality(x.b, y.b);

		case 7:
			return x.e === y.e && _Json_equality(x.b, y.b);

		case 9:
			return x.f === y.f && _Json_listEquality(x.g, y.g);

		case 10:
			return x.h === y.h && _Json_equality(x.b, y.b);

		case 11:
			return _Json_listEquality(x.g, y.g);
	}
}

function _Json_listEquality(aDecoders, bDecoders)
{
	var len = aDecoders.length;
	if (len !== bDecoders.length)
	{
		return false;
	}
	for (var i = 0; i < len; i++)
	{
		if (!_Json_equality(aDecoders[i], bDecoders[i]))
		{
			return false;
		}
	}
	return true;
}


// ENCODE

var _Json_encode = F2(function(indentLevel, value)
{
	return JSON.stringify(_Json_unwrap(value), null, indentLevel) + '';
});

function _Json_wrap(value) { return { $: 0, a: value }; }
function _Json_unwrap(value) { return value.a; }

function _Json_wrap_UNUSED(value) { return value; }
function _Json_unwrap_UNUSED(value) { return value; }

function _Json_emptyArray() { return []; }
function _Json_emptyObject() { return {}; }

var _Json_addField = F3(function(key, value, object)
{
	object[key] = _Json_unwrap(value);
	return object;
});

function _Json_addEntry(func)
{
	return F2(function(entry, array)
	{
		array.push(_Json_unwrap(func(entry)));
		return array;
	});
}

var _Json_encodeNull = _Json_wrap(null);




// STRINGS


var _Parser_isSubString = F5(function(smallString, offset, row, col, bigString)
{
	var smallLength = smallString.length;
	var isGood = offset + smallLength <= bigString.length;

	for (var i = 0; isGood && i < smallLength; )
	{
		var code = bigString.charCodeAt(offset);
		isGood =
			smallString[i++] === bigString[offset++]
			&& (
				code === 0x000A /* \n */
					? ( row++, col=1 )
					: ( col++, (code & 0xF800) === 0xD800 ? smallString[i++] === bigString[offset++] : 1 )
			)
	}

	return _Utils_Tuple3(isGood ? offset : -1, row, col);
});



// CHARS


var _Parser_isSubChar = F3(function(predicate, offset, string)
{
	return (
		string.length <= offset
			? -1
			:
		(string.charCodeAt(offset) & 0xF800) === 0xD800
			? (predicate(_Utils_chr(string.substr(offset, 2))) ? offset + 2 : -1)
			:
		(predicate(_Utils_chr(string[offset]))
			? ((string[offset] === '\n') ? -2 : (offset + 1))
			: -1
		)
	);
});


var _Parser_isAsciiCode = F3(function(code, offset, string)
{
	return string.charCodeAt(offset) === code;
});



// NUMBERS


var _Parser_chompBase10 = F2(function(offset, string)
{
	for (; offset < string.length; offset++)
	{
		var code = string.charCodeAt(offset);
		if (code < 0x30 || 0x39 < code)
		{
			return offset;
		}
	}
	return offset;
});


var _Parser_consumeBase = F3(function(base, offset, string)
{
	for (var total = 0; offset < string.length; offset++)
	{
		var digit = string.charCodeAt(offset) - 0x30;
		if (digit < 0 || base <= digit) break;
		total = base * total + digit;
	}
	return _Utils_Tuple2(offset, total);
});


var _Parser_consumeBase16 = F2(function(offset, string)
{
	for (var total = 0; offset < string.length; offset++)
	{
		var code = string.charCodeAt(offset);
		if (0x30 <= code && code <= 0x39)
		{
			total = 16 * total + code - 0x30;
		}
		else if (0x41 <= code && code <= 0x46)
		{
			total = 16 * total + code - 55;
		}
		else if (0x61 <= code && code <= 0x66)
		{
			total = 16 * total + code - 87;
		}
		else
		{
			break;
		}
	}
	return _Utils_Tuple2(offset, total);
});



// FIND STRING


var _Parser_findSubString = F5(function(smallString, offset, row, col, bigString)
{
	var newOffset = bigString.indexOf(smallString, offset);
	var target = newOffset < 0 ? bigString.length : newOffset + smallString.length;

	while (offset < target)
	{
		var code = bigString.charCodeAt(offset++);
		code === 0x000A /* \n */
			? ( col=1, row++ )
			: ( col++, (code & 0xF800) === 0xD800 && offset++ )
	}

	return _Utils_Tuple3(newOffset, row, col);
});



var _Bitwise_and = F2(function(a, b)
{
	return a & b;
});

var _Bitwise_or = F2(function(a, b)
{
	return a | b;
});

var _Bitwise_xor = F2(function(a, b)
{
	return a ^ b;
});

function _Bitwise_complement(a)
{
	return ~a;
};

var _Bitwise_shiftLeftBy = F2(function(offset, a)
{
	return a << offset;
});

var _Bitwise_shiftRightBy = F2(function(offset, a)
{
	return a >> offset;
});

var _Bitwise_shiftRightZfBy = F2(function(offset, a)
{
	return a >>> offset;
});


// CREATE

var _Regex_never = /.^/;

var _Regex_fromStringWith = F2(function(options, string)
{
	var flags = 'g';
	if (options.multiline) { flags += 'm'; }
	if (options.caseInsensitive) { flags += 'i'; }

	try
	{
		return $elm$core$Maybe$Just(new RegExp(string, flags));
	}
	catch(error)
	{
		return $elm$core$Maybe$Nothing;
	}
});


// USE

var _Regex_contains = F2(function(re, string)
{
	return string.match(re) !== null;
});


var _Regex_findAtMost = F3(function(n, re, str)
{
	var out = [];
	var number = 0;
	var string = str;
	var lastIndex = re.lastIndex;
	var prevLastIndex = -1;
	var result;
	while (number++ < n && (result = re.exec(string)))
	{
		if (prevLastIndex == re.lastIndex) break;
		var i = result.length - 1;
		var subs = new Array(i);
		while (i > 0)
		{
			var submatch = result[i];
			subs[--i] = submatch
				? $elm$core$Maybe$Just(submatch)
				: $elm$core$Maybe$Nothing;
		}
		out.push(A4($elm$regex$Regex$Match, result[0], result.index, number, _List_fromArray(subs)));
		prevLastIndex = re.lastIndex;
	}
	re.lastIndex = lastIndex;
	return _List_fromArray(out);
});


var _Regex_replaceAtMost = F4(function(n, re, replacer, string)
{
	var count = 0;
	function jsReplacer(match)
	{
		if (count++ >= n)
		{
			return match;
		}
		var i = arguments.length - 3;
		var submatches = new Array(i);
		while (i > 0)
		{
			var submatch = arguments[i];
			submatches[--i] = submatch
				? $elm$core$Maybe$Just(submatch)
				: $elm$core$Maybe$Nothing;
		}
		return replacer(A4($elm$regex$Regex$Match, match, arguments[arguments.length - 2], count, _List_fromArray(submatches)));
	}
	return string.replace(re, jsReplacer);
});

var _Regex_splitAtMost = F3(function(n, re, str)
{
	var string = str;
	var out = [];
	var start = re.lastIndex;
	var restoreLastIndex = re.lastIndex;
	while (n--)
	{
		var result = re.exec(string);
		if (!result) break;
		out.push(string.slice(start, result.index));
		start = re.lastIndex;
	}
	out.push(string.slice(start));
	re.lastIndex = restoreLastIndex;
	return _List_fromArray(out);
});

var _Regex_infinity = Infinity;



// TASKS

function _Scheduler_succeed(value)
{
	return {
		$: 0,
		a: value
	};
}

function _Scheduler_fail(error)
{
	return {
		$: 1,
		a: error
	};
}

function _Scheduler_binding(callback)
{
	return {
		$: 2,
		b: callback,
		c: null
	};
}

var _Scheduler_andThen = F2(function(callback, task)
{
	return {
		$: 3,
		b: callback,
		d: task
	};
});

var _Scheduler_onError = F2(function(callback, task)
{
	return {
		$: 4,
		b: callback,
		d: task
	};
});

function _Scheduler_receive(callback)
{
	return {
		$: 5,
		b: callback
	};
}


// PROCESSES

var _Scheduler_guid = 0;

function _Scheduler_rawSpawn(task)
{
	var proc = {
		$: 0,
		e: _Scheduler_guid++,
		f: task,
		g: null,
		h: []
	};

	_Scheduler_enqueue(proc);

	return proc;
}

function _Scheduler_spawn(task)
{
	return _Scheduler_binding(function(callback) {
		callback(_Scheduler_succeed(_Scheduler_rawSpawn(task)));
	});
}

function _Scheduler_rawSend(proc, msg)
{
	proc.h.push(msg);
	_Scheduler_enqueue(proc);
}

var _Scheduler_send = F2(function(proc, msg)
{
	return _Scheduler_binding(function(callback) {
		_Scheduler_rawSend(proc, msg);
		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
});

function _Scheduler_kill(proc)
{
	return _Scheduler_binding(function(callback) {
		var task = proc.f;
		if (task.$ === 2 && task.c)
		{
			task.c();
		}

		proc.f = null;

		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
}


/* STEP PROCESSES

type alias Process =
  { $ : tag
  , id : unique_id
  , root : Task
  , stack : null | { $: SUCCEED | FAIL, a: callback, b: stack }
  , mailbox : [msg]
  }

*/


var _Scheduler_working = false;
var _Scheduler_queue = [];


function _Scheduler_enqueue(proc)
{
	_Scheduler_queue.push(proc);
	if (_Scheduler_working)
	{
		return;
	}
	_Scheduler_working = true;
	while (proc = _Scheduler_queue.shift())
	{
		_Scheduler_step(proc);
	}
	_Scheduler_working = false;
}


function _Scheduler_step(proc)
{
	while (proc.f)
	{
		var rootTag = proc.f.$;
		if (rootTag === 0 || rootTag === 1)
		{
			while (proc.g && proc.g.$ !== rootTag)
			{
				proc.g = proc.g.i;
			}
			if (!proc.g)
			{
				return;
			}
			proc.f = proc.g.b(proc.f.a);
			proc.g = proc.g.i;
		}
		else if (rootTag === 2)
		{
			proc.f.c = proc.f.b(function(newRoot) {
				proc.f = newRoot;
				_Scheduler_enqueue(proc);
			});
			return;
		}
		else if (rootTag === 5)
		{
			if (proc.h.length === 0)
			{
				return;
			}
			proc.f = proc.f.b(proc.h.shift());
		}
		else // if (rootTag === 3 || rootTag === 4)
		{
			proc.g = {
				$: rootTag === 3 ? 0 : 1,
				b: proc.f.b,
				i: proc.g
			};
			proc.f = proc.f.d;
		}
	}
}



function _Process_sleep(time)
{
	return _Scheduler_binding(function(callback) {
		var id = setTimeout(function() {
			callback(_Scheduler_succeed(_Utils_Tuple0));
		}, time);

		return function() { clearTimeout(id); };
	});
}




// PROGRAMS


var _Platform_worker = F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.init,
		impl.update,
		impl.subscriptions,
		function() { return function() {} }
	);
});



// INITIALIZE A PROGRAM


function _Platform_initialize(flagDecoder, args, init, update, subscriptions, stepperBuilder)
{
	var result = A2(_Json_run, flagDecoder, _Json_wrap(args ? args['flags'] : undefined));
	$elm$core$Result$isOk(result) || _Debug_crash(2 /**/, _Json_errorToString(result.a) /**/);
	var managers = {};
	var initPair = init(result.a);
	var model = initPair.a;
	var stepper = stepperBuilder(sendToApp, model);
	var ports = _Platform_setupEffects(managers, sendToApp);

	function sendToApp(msg, viewMetadata)
	{
		var pair = A2(update, msg, model);
		stepper(model = pair.a, viewMetadata);
		_Platform_enqueueEffects(managers, pair.b, subscriptions(model));
	}

	_Platform_enqueueEffects(managers, initPair.b, subscriptions(model));

	return ports ? { ports: ports } : {};
}



// TRACK PRELOADS
//
// This is used by code in elm/browser and elm/http
// to register any HTTP requests that are triggered by init.
//


var _Platform_preload;


function _Platform_registerPreload(url)
{
	_Platform_preload.add(url);
}



// EFFECT MANAGERS


var _Platform_effectManagers = {};


function _Platform_setupEffects(managers, sendToApp)
{
	var ports;

	// setup all necessary effect managers
	for (var key in _Platform_effectManagers)
	{
		var manager = _Platform_effectManagers[key];

		if (manager.a)
		{
			ports = ports || {};
			ports[key] = manager.a(key, sendToApp);
		}

		managers[key] = _Platform_instantiateManager(manager, sendToApp);
	}

	return ports;
}


function _Platform_createManager(init, onEffects, onSelfMsg, cmdMap, subMap)
{
	return {
		b: init,
		c: onEffects,
		d: onSelfMsg,
		e: cmdMap,
		f: subMap
	};
}


function _Platform_instantiateManager(info, sendToApp)
{
	var router = {
		g: sendToApp,
		h: undefined
	};

	var onEffects = info.c;
	var onSelfMsg = info.d;
	var cmdMap = info.e;
	var subMap = info.f;

	function loop(state)
	{
		return A2(_Scheduler_andThen, loop, _Scheduler_receive(function(msg)
		{
			var value = msg.a;

			if (msg.$ === 0)
			{
				return A3(onSelfMsg, router, value, state);
			}

			return cmdMap && subMap
				? A4(onEffects, router, value.i, value.j, state)
				: A3(onEffects, router, cmdMap ? value.i : value.j, state);
		}));
	}

	return router.h = _Scheduler_rawSpawn(A2(_Scheduler_andThen, loop, info.b));
}



// ROUTING


var _Platform_sendToApp = F2(function(router, msg)
{
	return _Scheduler_binding(function(callback)
	{
		router.g(msg);
		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
});


var _Platform_sendToSelf = F2(function(router, msg)
{
	return A2(_Scheduler_send, router.h, {
		$: 0,
		a: msg
	});
});



// BAGS


function _Platform_leaf(home)
{
	return function(value)
	{
		return {
			$: 1,
			k: home,
			l: value
		};
	};
}


function _Platform_batch(list)
{
	return {
		$: 2,
		m: list
	};
}


var _Platform_map = F2(function(tagger, bag)
{
	return {
		$: 3,
		n: tagger,
		o: bag
	}
});



// PIPE BAGS INTO EFFECT MANAGERS
//
// Effects must be queued!
//
// Say your init contains a synchronous command, like Time.now or Time.here
//
//   - This will produce a batch of effects (FX_1)
//   - The synchronous task triggers the subsequent `update` call
//   - This will produce a batch of effects (FX_2)
//
// If we just start dispatching FX_2, subscriptions from FX_2 can be processed
// before subscriptions from FX_1. No good! Earlier versions of this code had
// this problem, leading to these reports:
//
//   https://github.com/elm/core/issues/980
//   https://github.com/elm/core/pull/981
//   https://github.com/elm/compiler/issues/1776
//
// The queue is necessary to avoid ordering issues for synchronous commands.


// Why use true/false here? Why not just check the length of the queue?
// The goal is to detect "are we currently dispatching effects?" If we
// are, we need to bail and let the ongoing while loop handle things.
//
// Now say the queue has 1 element. When we dequeue the final element,
// the queue will be empty, but we are still actively dispatching effects.
// So you could get queue jumping in a really tricky category of cases.
//
var _Platform_effectsQueue = [];
var _Platform_effectsActive = false;


function _Platform_enqueueEffects(managers, cmdBag, subBag)
{
	_Platform_effectsQueue.push({ p: managers, q: cmdBag, r: subBag });

	if (_Platform_effectsActive) return;

	_Platform_effectsActive = true;
	for (var fx; fx = _Platform_effectsQueue.shift(); )
	{
		_Platform_dispatchEffects(fx.p, fx.q, fx.r);
	}
	_Platform_effectsActive = false;
}


function _Platform_dispatchEffects(managers, cmdBag, subBag)
{
	var effectsDict = {};
	_Platform_gatherEffects(true, cmdBag, effectsDict, null);
	_Platform_gatherEffects(false, subBag, effectsDict, null);

	for (var home in managers)
	{
		_Scheduler_rawSend(managers[home], {
			$: 'fx',
			a: effectsDict[home] || { i: _List_Nil, j: _List_Nil }
		});
	}
}


function _Platform_gatherEffects(isCmd, bag, effectsDict, taggers)
{
	switch (bag.$)
	{
		case 1:
			var home = bag.k;
			var effect = _Platform_toEffect(isCmd, home, taggers, bag.l);
			effectsDict[home] = _Platform_insert(isCmd, effect, effectsDict[home]);
			return;

		case 2:
			for (var list = bag.m; list.b; list = list.b) // WHILE_CONS
			{
				_Platform_gatherEffects(isCmd, list.a, effectsDict, taggers);
			}
			return;

		case 3:
			_Platform_gatherEffects(isCmd, bag.o, effectsDict, {
				s: bag.n,
				t: taggers
			});
			return;
	}
}


function _Platform_toEffect(isCmd, home, taggers, value)
{
	function applyTaggers(x)
	{
		for (var temp = taggers; temp; temp = temp.t)
		{
			x = temp.s(x);
		}
		return x;
	}

	var map = isCmd
		? _Platform_effectManagers[home].e
		: _Platform_effectManagers[home].f;

	return A2(map, applyTaggers, value)
}


function _Platform_insert(isCmd, newEffect, effects)
{
	effects = effects || { i: _List_Nil, j: _List_Nil };

	isCmd
		? (effects.i = _List_Cons(newEffect, effects.i))
		: (effects.j = _List_Cons(newEffect, effects.j));

	return effects;
}



// PORTS


function _Platform_checkPortName(name)
{
	if (_Platform_effectManagers[name])
	{
		_Debug_crash(3, name)
	}
}



// OUTGOING PORTS


function _Platform_outgoingPort(name, converter)
{
	_Platform_checkPortName(name);
	_Platform_effectManagers[name] = {
		e: _Platform_outgoingPortMap,
		u: converter,
		a: _Platform_setupOutgoingPort
	};
	return _Platform_leaf(name);
}


var _Platform_outgoingPortMap = F2(function(tagger, value) { return value; });


function _Platform_setupOutgoingPort(name)
{
	var subs = [];
	var converter = _Platform_effectManagers[name].u;

	// CREATE MANAGER

	var init = _Process_sleep(0);

	_Platform_effectManagers[name].b = init;
	_Platform_effectManagers[name].c = F3(function(router, cmdList, state)
	{
		for ( ; cmdList.b; cmdList = cmdList.b) // WHILE_CONS
		{
			// grab a separate reference to subs in case unsubscribe is called
			var currentSubs = subs;
			var value = _Json_unwrap(converter(cmdList.a));
			for (var i = 0; i < currentSubs.length; i++)
			{
				currentSubs[i](value);
			}
		}
		return init;
	});

	// PUBLIC API

	function subscribe(callback)
	{
		subs.push(callback);
	}

	function unsubscribe(callback)
	{
		// copy subs into a new array in case unsubscribe is called within a
		// subscribed callback
		subs = subs.slice();
		var index = subs.indexOf(callback);
		if (index >= 0)
		{
			subs.splice(index, 1);
		}
	}

	return {
		subscribe: subscribe,
		unsubscribe: unsubscribe
	};
}



// INCOMING PORTS


function _Platform_incomingPort(name, converter)
{
	_Platform_checkPortName(name);
	_Platform_effectManagers[name] = {
		f: _Platform_incomingPortMap,
		u: converter,
		a: _Platform_setupIncomingPort
	};
	return _Platform_leaf(name);
}


var _Platform_incomingPortMap = F2(function(tagger, finalTagger)
{
	return function(value)
	{
		return tagger(finalTagger(value));
	};
});


function _Platform_setupIncomingPort(name, sendToApp)
{
	var subs = _List_Nil;
	var converter = _Platform_effectManagers[name].u;

	// CREATE MANAGER

	var init = _Scheduler_succeed(null);

	_Platform_effectManagers[name].b = init;
	_Platform_effectManagers[name].c = F3(function(router, subList, state)
	{
		subs = subList;
		return init;
	});

	// PUBLIC API

	function send(incomingValue)
	{
		var result = A2(_Json_run, converter, _Json_wrap(incomingValue));

		$elm$core$Result$isOk(result) || _Debug_crash(4, name, result.a);

		var value = result.a;
		for (var temp = subs; temp.b; temp = temp.b) // WHILE_CONS
		{
			sendToApp(temp.a(value));
		}
	}

	return { send: send };
}



// EXPORT ELM MODULES
//
// Have DEBUG and PROD versions so that we can (1) give nicer errors in
// debug mode and (2) not pay for the bits needed for that in prod mode.
//


function _Platform_export_UNUSED(exports)
{
	scope['Elm']
		? _Platform_mergeExportsProd(scope['Elm'], exports)
		: scope['Elm'] = exports;
}


function _Platform_mergeExportsProd(obj, exports)
{
	for (var name in exports)
	{
		(name in obj)
			? (name == 'init')
				? _Debug_crash(6)
				: _Platform_mergeExportsProd(obj[name], exports[name])
			: (obj[name] = exports[name]);
	}
}


function _Platform_export(exports)
{
	scope['Elm']
		? _Platform_mergeExportsDebug('Elm', scope['Elm'], exports)
		: scope['Elm'] = exports;
}


function _Platform_mergeExportsDebug(moduleName, obj, exports)
{
	for (var name in exports)
	{
		(name in obj)
			? (name == 'init')
				? _Debug_crash(6, moduleName)
				: _Platform_mergeExportsDebug(moduleName + '.' + name, obj[name], exports[name])
			: (obj[name] = exports[name]);
	}
}



function _Time_now(millisToPosix)
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(millisToPosix(Date.now())));
	});
}

var _Time_setInterval = F2(function(interval, task)
{
	return _Scheduler_binding(function(callback)
	{
		var id = setInterval(function() { _Scheduler_rawSpawn(task); }, interval);
		return function() { clearInterval(id); };
	});
});

function _Time_here()
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(
			A2($elm$time$Time$customZone, -(new Date().getTimezoneOffset()), _List_Nil)
		));
	});
}


function _Time_getZoneName()
{
	return _Scheduler_binding(function(callback)
	{
		try
		{
			var name = $elm$time$Time$Name(Intl.DateTimeFormat().resolvedOptions().timeZone);
		}
		catch (e)
		{
			var name = $elm$time$Time$Offset(new Date().getTimezoneOffset());
		}
		callback(_Scheduler_succeed(name));
	});
}
var $elm$core$Basics$EQ = {$: 'EQ'};
var $elm$core$Basics$LT = {$: 'LT'};
var $elm$core$List$cons = _List_cons;
var $elm$core$Elm$JsArray$foldr = _JsArray_foldr;
var $elm$core$Array$foldr = F3(
	function (func, baseCase, _v0) {
		var tree = _v0.c;
		var tail = _v0.d;
		var helper = F2(
			function (node, acc) {
				if (node.$ === 'SubTree') {
					var subTree = node.a;
					return A3($elm$core$Elm$JsArray$foldr, helper, acc, subTree);
				} else {
					var values = node.a;
					return A3($elm$core$Elm$JsArray$foldr, func, acc, values);
				}
			});
		return A3(
			$elm$core$Elm$JsArray$foldr,
			helper,
			A3($elm$core$Elm$JsArray$foldr, func, baseCase, tail),
			tree);
	});
var $elm$core$Array$toList = function (array) {
	return A3($elm$core$Array$foldr, $elm$core$List$cons, _List_Nil, array);
};
var $elm$core$Dict$foldr = F3(
	function (func, acc, t) {
		foldr:
		while (true) {
			if (t.$ === 'RBEmpty_elm_builtin') {
				return acc;
			} else {
				var key = t.b;
				var value = t.c;
				var left = t.d;
				var right = t.e;
				var $temp$func = func,
					$temp$acc = A3(
					func,
					key,
					value,
					A3($elm$core$Dict$foldr, func, acc, right)),
					$temp$t = left;
				func = $temp$func;
				acc = $temp$acc;
				t = $temp$t;
				continue foldr;
			}
		}
	});
var $elm$core$Dict$toList = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, list) {
				return A2(
					$elm$core$List$cons,
					_Utils_Tuple2(key, value),
					list);
			}),
		_List_Nil,
		dict);
};
var $elm$core$Dict$keys = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, keyList) {
				return A2($elm$core$List$cons, key, keyList);
			}),
		_List_Nil,
		dict);
};
var $elm$core$Set$toList = function (_v0) {
	var dict = _v0.a;
	return $elm$core$Dict$keys(dict);
};
var $elm$core$Basics$GT = {$: 'GT'};
var $elm$core$Maybe$Nothing = {$: 'Nothing'};
var $elm$core$Basics$identity = function (x) {
	return x;
};
var $author$project$DataEngine$DataCache$DataCache = function (a) {
	return {$: 'DataCache', a: a};
};
var $krisajenkins$remotedata$RemoteData$NotAsked = {$: 'NotAsked'};
var $author$project$LoadableLocale$empty = _Utils_Tuple2($krisajenkins$remotedata$RemoteData$NotAsked, $elm$core$Maybe$Nothing);
var $author$project$LoadableTimeZone$empty = _Utils_Tuple2($krisajenkins$remotedata$RemoteData$NotAsked, $elm$core$Maybe$Nothing);
var $author$project$UuidDict$UuidDict = function (a) {
	return {$: 'UuidDict', a: a};
};
var $elm$core$Dict$RBEmpty_elm_builtin = {$: 'RBEmpty_elm_builtin'};
var $elm$core$Dict$empty = $elm$core$Dict$RBEmpty_elm_builtin;
var $author$project$UuidDict$empty = $author$project$UuidDict$UuidDict($elm$core$Dict$empty);
var $author$project$DataEngine$DataCache$empty = $author$project$DataEngine$DataCache$DataCache(
	{dataElementStates: $author$project$UuidDict$empty, feedbackData: $krisajenkins$remotedata$RemoteData$NotAsked, locale: $author$project$LoadableLocale$empty, manifests: _List_Nil, timeZone: $author$project$LoadableTimeZone$empty});
var $elm$core$Basics$composeR = F3(
	function (f, g, x) {
		return g(
			f(x));
	});
var $elm$core$Result$Err = function (a) {
	return {$: 'Err', a: a};
};
var $elm$json$Json$Decode$Failure = F2(
	function (a, b) {
		return {$: 'Failure', a: a, b: b};
	});
var $elm$json$Json$Decode$Field = F2(
	function (a, b) {
		return {$: 'Field', a: a, b: b};
	});
var $elm$json$Json$Decode$Index = F2(
	function (a, b) {
		return {$: 'Index', a: a, b: b};
	});
var $elm$core$Result$Ok = function (a) {
	return {$: 'Ok', a: a};
};
var $elm$json$Json$Decode$OneOf = function (a) {
	return {$: 'OneOf', a: a};
};
var $elm$core$Basics$False = {$: 'False'};
var $elm$core$Basics$add = _Basics_add;
var $elm$core$Maybe$Just = function (a) {
	return {$: 'Just', a: a};
};
var $elm$core$String$all = _String_all;
var $elm$core$Basics$and = _Basics_and;
var $elm$core$Basics$append = _Utils_append;
var $elm$json$Json$Encode$encode = _Json_encode;
var $elm$core$String$fromInt = _String_fromNumber;
var $elm$core$String$join = F2(
	function (sep, chunks) {
		return A2(
			_String_join,
			sep,
			_List_toArray(chunks));
	});
var $elm$core$String$split = F2(
	function (sep, string) {
		return _List_fromArray(
			A2(_String_split, sep, string));
	});
var $elm$json$Json$Decode$indent = function (str) {
	return A2(
		$elm$core$String$join,
		'\n    ',
		A2($elm$core$String$split, '\n', str));
};
var $elm$core$List$foldl = F3(
	function (func, acc, list) {
		foldl:
		while (true) {
			if (!list.b) {
				return acc;
			} else {
				var x = list.a;
				var xs = list.b;
				var $temp$func = func,
					$temp$acc = A2(func, x, acc),
					$temp$list = xs;
				func = $temp$func;
				acc = $temp$acc;
				list = $temp$list;
				continue foldl;
			}
		}
	});
var $elm$core$List$length = function (xs) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (_v0, i) {
				return i + 1;
			}),
		0,
		xs);
};
var $elm$core$List$map2 = _List_map2;
var $elm$core$Basics$le = _Utils_le;
var $elm$core$Basics$sub = _Basics_sub;
var $elm$core$List$rangeHelp = F3(
	function (lo, hi, list) {
		rangeHelp:
		while (true) {
			if (_Utils_cmp(lo, hi) < 1) {
				var $temp$lo = lo,
					$temp$hi = hi - 1,
					$temp$list = A2($elm$core$List$cons, hi, list);
				lo = $temp$lo;
				hi = $temp$hi;
				list = $temp$list;
				continue rangeHelp;
			} else {
				return list;
			}
		}
	});
var $elm$core$List$range = F2(
	function (lo, hi) {
		return A3($elm$core$List$rangeHelp, lo, hi, _List_Nil);
	});
var $elm$core$List$indexedMap = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$map2,
			f,
			A2(
				$elm$core$List$range,
				0,
				$elm$core$List$length(xs) - 1),
			xs);
	});
var $elm$core$Char$toCode = _Char_toCode;
var $elm$core$Char$isLower = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (97 <= code) && (code <= 122);
};
var $elm$core$Char$isUpper = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (code <= 90) && (65 <= code);
};
var $elm$core$Basics$or = _Basics_or;
var $elm$core$Char$isAlpha = function (_char) {
	return $elm$core$Char$isLower(_char) || $elm$core$Char$isUpper(_char);
};
var $elm$core$Char$isDigit = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (code <= 57) && (48 <= code);
};
var $elm$core$Char$isAlphaNum = function (_char) {
	return $elm$core$Char$isLower(_char) || ($elm$core$Char$isUpper(_char) || $elm$core$Char$isDigit(_char));
};
var $elm$core$List$reverse = function (list) {
	return A3($elm$core$List$foldl, $elm$core$List$cons, _List_Nil, list);
};
var $elm$core$String$uncons = _String_uncons;
var $elm$json$Json$Decode$errorOneOf = F2(
	function (i, error) {
		return '\n\n(' + ($elm$core$String$fromInt(i + 1) + (') ' + $elm$json$Json$Decode$indent(
			$elm$json$Json$Decode$errorToString(error))));
	});
var $elm$json$Json$Decode$errorToString = function (error) {
	return A2($elm$json$Json$Decode$errorToStringHelp, error, _List_Nil);
};
var $elm$json$Json$Decode$errorToStringHelp = F2(
	function (error, context) {
		errorToStringHelp:
		while (true) {
			switch (error.$) {
				case 'Field':
					var f = error.a;
					var err = error.b;
					var isSimple = function () {
						var _v1 = $elm$core$String$uncons(f);
						if (_v1.$ === 'Nothing') {
							return false;
						} else {
							var _v2 = _v1.a;
							var _char = _v2.a;
							var rest = _v2.b;
							return $elm$core$Char$isAlpha(_char) && A2($elm$core$String$all, $elm$core$Char$isAlphaNum, rest);
						}
					}();
					var fieldName = isSimple ? ('.' + f) : ('[\'' + (f + '\']'));
					var $temp$error = err,
						$temp$context = A2($elm$core$List$cons, fieldName, context);
					error = $temp$error;
					context = $temp$context;
					continue errorToStringHelp;
				case 'Index':
					var i = error.a;
					var err = error.b;
					var indexName = '[' + ($elm$core$String$fromInt(i) + ']');
					var $temp$error = err,
						$temp$context = A2($elm$core$List$cons, indexName, context);
					error = $temp$error;
					context = $temp$context;
					continue errorToStringHelp;
				case 'OneOf':
					var errors = error.a;
					if (!errors.b) {
						return 'Ran into a Json.Decode.oneOf with no possibilities' + function () {
							if (!context.b) {
								return '!';
							} else {
								return ' at json' + A2(
									$elm$core$String$join,
									'',
									$elm$core$List$reverse(context));
							}
						}();
					} else {
						if (!errors.b.b) {
							var err = errors.a;
							var $temp$error = err,
								$temp$context = context;
							error = $temp$error;
							context = $temp$context;
							continue errorToStringHelp;
						} else {
							var starter = function () {
								if (!context.b) {
									return 'Json.Decode.oneOf';
								} else {
									return 'The Json.Decode.oneOf at json' + A2(
										$elm$core$String$join,
										'',
										$elm$core$List$reverse(context));
								}
							}();
							var introduction = starter + (' failed in the following ' + ($elm$core$String$fromInt(
								$elm$core$List$length(errors)) + ' ways:'));
							return A2(
								$elm$core$String$join,
								'\n\n',
								A2(
									$elm$core$List$cons,
									introduction,
									A2($elm$core$List$indexedMap, $elm$json$Json$Decode$errorOneOf, errors)));
						}
					}
				default:
					var msg = error.a;
					var json = error.b;
					var introduction = function () {
						if (!context.b) {
							return 'Problem with the given value:\n\n';
						} else {
							return 'Problem with the value at json' + (A2(
								$elm$core$String$join,
								'',
								$elm$core$List$reverse(context)) + ':\n\n    ');
						}
					}();
					return introduction + ($elm$json$Json$Decode$indent(
						A2($elm$json$Json$Encode$encode, 4, json)) + ('\n\n' + msg));
			}
		}
	});
var $elm$core$Array$branchFactor = 32;
var $elm$core$Array$Array_elm_builtin = F4(
	function (a, b, c, d) {
		return {$: 'Array_elm_builtin', a: a, b: b, c: c, d: d};
	});
var $elm$core$Elm$JsArray$empty = _JsArray_empty;
var $elm$core$Basics$ceiling = _Basics_ceiling;
var $elm$core$Basics$fdiv = _Basics_fdiv;
var $elm$core$Basics$logBase = F2(
	function (base, number) {
		return _Basics_log(number) / _Basics_log(base);
	});
var $elm$core$Basics$toFloat = _Basics_toFloat;
var $elm$core$Array$shiftStep = $elm$core$Basics$ceiling(
	A2($elm$core$Basics$logBase, 2, $elm$core$Array$branchFactor));
var $elm$core$Array$empty = A4($elm$core$Array$Array_elm_builtin, 0, $elm$core$Array$shiftStep, $elm$core$Elm$JsArray$empty, $elm$core$Elm$JsArray$empty);
var $elm$core$Elm$JsArray$initialize = _JsArray_initialize;
var $elm$core$Array$Leaf = function (a) {
	return {$: 'Leaf', a: a};
};
var $elm$core$Basics$apL = F2(
	function (f, x) {
		return f(x);
	});
var $elm$core$Basics$apR = F2(
	function (x, f) {
		return f(x);
	});
var $elm$core$Basics$eq = _Utils_equal;
var $elm$core$Basics$floor = _Basics_floor;
var $elm$core$Elm$JsArray$length = _JsArray_length;
var $elm$core$Basics$gt = _Utils_gt;
var $elm$core$Basics$max = F2(
	function (x, y) {
		return (_Utils_cmp(x, y) > 0) ? x : y;
	});
var $elm$core$Basics$mul = _Basics_mul;
var $elm$core$Array$SubTree = function (a) {
	return {$: 'SubTree', a: a};
};
var $elm$core$Elm$JsArray$initializeFromList = _JsArray_initializeFromList;
var $elm$core$Array$compressNodes = F2(
	function (nodes, acc) {
		compressNodes:
		while (true) {
			var _v0 = A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, nodes);
			var node = _v0.a;
			var remainingNodes = _v0.b;
			var newAcc = A2(
				$elm$core$List$cons,
				$elm$core$Array$SubTree(node),
				acc);
			if (!remainingNodes.b) {
				return $elm$core$List$reverse(newAcc);
			} else {
				var $temp$nodes = remainingNodes,
					$temp$acc = newAcc;
				nodes = $temp$nodes;
				acc = $temp$acc;
				continue compressNodes;
			}
		}
	});
var $elm$core$Tuple$first = function (_v0) {
	var x = _v0.a;
	return x;
};
var $elm$core$Array$treeFromBuilder = F2(
	function (nodeList, nodeListSize) {
		treeFromBuilder:
		while (true) {
			var newNodeSize = $elm$core$Basics$ceiling(nodeListSize / $elm$core$Array$branchFactor);
			if (newNodeSize === 1) {
				return A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, nodeList).a;
			} else {
				var $temp$nodeList = A2($elm$core$Array$compressNodes, nodeList, _List_Nil),
					$temp$nodeListSize = newNodeSize;
				nodeList = $temp$nodeList;
				nodeListSize = $temp$nodeListSize;
				continue treeFromBuilder;
			}
		}
	});
var $elm$core$Array$builderToArray = F2(
	function (reverseNodeList, builder) {
		if (!builder.nodeListSize) {
			return A4(
				$elm$core$Array$Array_elm_builtin,
				$elm$core$Elm$JsArray$length(builder.tail),
				$elm$core$Array$shiftStep,
				$elm$core$Elm$JsArray$empty,
				builder.tail);
		} else {
			var treeLen = builder.nodeListSize * $elm$core$Array$branchFactor;
			var depth = $elm$core$Basics$floor(
				A2($elm$core$Basics$logBase, $elm$core$Array$branchFactor, treeLen - 1));
			var correctNodeList = reverseNodeList ? $elm$core$List$reverse(builder.nodeList) : builder.nodeList;
			var tree = A2($elm$core$Array$treeFromBuilder, correctNodeList, builder.nodeListSize);
			return A4(
				$elm$core$Array$Array_elm_builtin,
				$elm$core$Elm$JsArray$length(builder.tail) + treeLen,
				A2($elm$core$Basics$max, 5, depth * $elm$core$Array$shiftStep),
				tree,
				builder.tail);
		}
	});
var $elm$core$Basics$idiv = _Basics_idiv;
var $elm$core$Basics$lt = _Utils_lt;
var $elm$core$Array$initializeHelp = F5(
	function (fn, fromIndex, len, nodeList, tail) {
		initializeHelp:
		while (true) {
			if (fromIndex < 0) {
				return A2(
					$elm$core$Array$builderToArray,
					false,
					{nodeList: nodeList, nodeListSize: (len / $elm$core$Array$branchFactor) | 0, tail: tail});
			} else {
				var leaf = $elm$core$Array$Leaf(
					A3($elm$core$Elm$JsArray$initialize, $elm$core$Array$branchFactor, fromIndex, fn));
				var $temp$fn = fn,
					$temp$fromIndex = fromIndex - $elm$core$Array$branchFactor,
					$temp$len = len,
					$temp$nodeList = A2($elm$core$List$cons, leaf, nodeList),
					$temp$tail = tail;
				fn = $temp$fn;
				fromIndex = $temp$fromIndex;
				len = $temp$len;
				nodeList = $temp$nodeList;
				tail = $temp$tail;
				continue initializeHelp;
			}
		}
	});
var $elm$core$Basics$remainderBy = _Basics_remainderBy;
var $elm$core$Array$initialize = F2(
	function (len, fn) {
		if (len <= 0) {
			return $elm$core$Array$empty;
		} else {
			var tailLen = len % $elm$core$Array$branchFactor;
			var tail = A3($elm$core$Elm$JsArray$initialize, tailLen, len - tailLen, fn);
			var initialFromIndex = (len - tailLen) - $elm$core$Array$branchFactor;
			return A5($elm$core$Array$initializeHelp, fn, initialFromIndex, len, _List_Nil, tail);
		}
	});
var $elm$core$Basics$True = {$: 'True'};
var $elm$core$Result$isOk = function (result) {
	if (result.$ === 'Ok') {
		return true;
	} else {
		return false;
	}
};
var $elm$json$Json$Decode$decodeValue = _Json_run;
var $elm$json$Json$Decode$field = _Json_decodeField;
var $elm$json$Json$Decode$andThen = _Json_andThen;
var $enkidatron$elm_cldr$Internal$DayPeriodRule$At = F2(
	function (a, b) {
		return {$: 'At', a: a, b: b};
	});
var $enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore = F3(
	function (a, b, c) {
		return {$: 'FromBefore', a: a, b: b, c: c};
	});
var $elm$core$Dict$Black = {$: 'Black'};
var $elm$core$Dict$RBNode_elm_builtin = F5(
	function (a, b, c, d, e) {
		return {$: 'RBNode_elm_builtin', a: a, b: b, c: c, d: d, e: e};
	});
var $elm$core$Dict$Red = {$: 'Red'};
var $elm$core$Dict$balance = F5(
	function (color, key, value, left, right) {
		if ((right.$ === 'RBNode_elm_builtin') && (right.a.$ === 'Red')) {
			var _v1 = right.a;
			var rK = right.b;
			var rV = right.c;
			var rLeft = right.d;
			var rRight = right.e;
			if ((left.$ === 'RBNode_elm_builtin') && (left.a.$ === 'Red')) {
				var _v3 = left.a;
				var lK = left.b;
				var lV = left.c;
				var lLeft = left.d;
				var lRight = left.e;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					$elm$core$Dict$Red,
					key,
					value,
					A5($elm$core$Dict$RBNode_elm_builtin, $elm$core$Dict$Black, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, $elm$core$Dict$Black, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					color,
					rK,
					rV,
					A5($elm$core$Dict$RBNode_elm_builtin, $elm$core$Dict$Red, key, value, left, rLeft),
					rRight);
			}
		} else {
			if ((((left.$ === 'RBNode_elm_builtin') && (left.a.$ === 'Red')) && (left.d.$ === 'RBNode_elm_builtin')) && (left.d.a.$ === 'Red')) {
				var _v5 = left.a;
				var lK = left.b;
				var lV = left.c;
				var _v6 = left.d;
				var _v7 = _v6.a;
				var llK = _v6.b;
				var llV = _v6.c;
				var llLeft = _v6.d;
				var llRight = _v6.e;
				var lRight = left.e;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					$elm$core$Dict$Red,
					lK,
					lV,
					A5($elm$core$Dict$RBNode_elm_builtin, $elm$core$Dict$Black, llK, llV, llLeft, llRight),
					A5($elm$core$Dict$RBNode_elm_builtin, $elm$core$Dict$Black, key, value, lRight, right));
			} else {
				return A5($elm$core$Dict$RBNode_elm_builtin, color, key, value, left, right);
			}
		}
	});
var $elm$core$Basics$compare = _Utils_compare;
var $elm$core$Dict$insertHelp = F3(
	function (key, value, dict) {
		if (dict.$ === 'RBEmpty_elm_builtin') {
			return A5($elm$core$Dict$RBNode_elm_builtin, $elm$core$Dict$Red, key, value, $elm$core$Dict$RBEmpty_elm_builtin, $elm$core$Dict$RBEmpty_elm_builtin);
		} else {
			var nColor = dict.a;
			var nKey = dict.b;
			var nValue = dict.c;
			var nLeft = dict.d;
			var nRight = dict.e;
			var _v1 = A2($elm$core$Basics$compare, key, nKey);
			switch (_v1.$) {
				case 'LT':
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						A3($elm$core$Dict$insertHelp, key, value, nLeft),
						nRight);
				case 'EQ':
					return A5($elm$core$Dict$RBNode_elm_builtin, nColor, nKey, value, nLeft, nRight);
				default:
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						nLeft,
						A3($elm$core$Dict$insertHelp, key, value, nRight));
			}
		}
	});
var $elm$core$Dict$insert = F3(
	function (key, value, dict) {
		var _v0 = A3($elm$core$Dict$insertHelp, key, value, dict);
		if ((_v0.$ === 'RBNode_elm_builtin') && (_v0.a.$ === 'Red')) {
			var _v1 = _v0.a;
			var k = _v0.b;
			var v = _v0.c;
			var l = _v0.d;
			var r = _v0.e;
			return A5($elm$core$Dict$RBNode_elm_builtin, $elm$core$Dict$Black, k, v, l, r);
		} else {
			var x = _v0;
			return x;
		}
	});
var $elm$core$Dict$fromList = function (assocs) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (_v0, dict) {
				var key = _v0.a;
				var value = _v0.b;
				return A3($elm$core$Dict$insert, key, value, dict);
			}),
		$elm$core$Dict$empty,
		assocs);
};
var $enkidatron$elm_cldr$Generated$Af$dayPeriods = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			'af',
			_List_fromArray(
				[
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(12, 0),
					_Utils_Tuple2(18, 0),
					'afternoon1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(18, 0),
					_Utils_Tuple2(24, 0),
					'evening1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(0, 0),
					'midnight'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(5, 0),
					_Utils_Tuple2(12, 0),
					'morning1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(0, 0),
					_Utils_Tuple2(5, 0),
					'night1')
				]))
		]));
var $enkidatron$elm_cldr$Internal$Locale$Lang = F4(
	function (a, b, c, d) {
		return {$: 'Lang', a: a, b: b, c: c, d: d};
	});
var $enkidatron$elm_cldr$Internal$Locale$Locale = function (a) {
	return {$: 'Locale', a: a};
};
var $joneshf$elm_tagged$Tagged$Tagged = function (a) {
	return {$: 'Tagged', a: a};
};
var $cuducos$elm_format_number$FormatNumber$Locales$Min = function (a) {
	return {$: 'Min', a: a};
};
var $cuducos$elm_format_number$FormatNumber$Locales$Western = {$: 'Western'};
var $cuducos$elm_format_number$FormatNumber$Locales$base = {
	decimalSeparator: '.',
	decimals: $cuducos$elm_format_number$FormatNumber$Locales$Min(0),
	negativePrefix: '−',
	negativeSuffix: '',
	positivePrefix: '',
	positiveSuffix: '',
	system: $cuducos$elm_format_number$FormatNumber$Locales$Western,
	thousandSeparator: '',
	zeroPrefix: '',
	zeroSuffix: ''
};
var $enkidatron$elm_cldr$Internal$Locale$empty = $enkidatron$elm_cldr$Internal$Locale$Locale(
	{
		availableFormats: _List_Nil,
		currencyNumberFormat: $cuducos$elm_format_number$FormatNumber$Locales$base,
		currencySymbols: $elm$core$Dict$empty,
		dateSymbols: {full: _List_Nil, _long: _List_Nil, medium: _List_Nil, _short: _List_Nil},
		dateTimeTokens: {full: _List_Nil, _long: _List_Nil, medium: _List_Nil, _short: _List_Nil},
		dayPeriodRuleSet: _List_Nil,
		decimalNumberFormat: $cuducos$elm_format_number$FormatNumber$Locales$base,
		eraNames: {
			abbreviated: {ad: 'CE', bc: 'BCE'},
			narrow: {ad: 'CE', bc: 'BCE'},
			wide: {ad: 'CE', bc: 'BCE'}
		},
		hour12ByDefault: false,
		languageId: A4(
			$enkidatron$elm_cldr$Internal$Locale$Lang,
			$joneshf$elm_tagged$Tagged$Tagged(''),
			$elm$core$Maybe$Nothing,
			$elm$core$Maybe$Nothing,
			$elm$core$Maybe$Nothing),
		monthFormatNames: {
			abbreviated: {apr: 'M04', aug: 'M08', dec: 'M12', feb: 'M02', jan: 'M01', jul: 'M07', jun: 'M06', mar: 'M03', may: 'M05', nov: 'M11', oct: 'M10', sep: 'M09'},
			narrow: {apr: '4', aug: '8', dec: '12', feb: '2', jan: '1', jul: '7', jun: '6', mar: '3', may: '5', nov: '11', oct: '10', sep: '9'},
			wide: {apr: 'M04', aug: 'M08', dec: 'M12', feb: 'M02', jan: 'M01', jul: 'M07', jun: 'M06', mar: 'M03', may: 'M05', nov: 'M11', oct: 'M10', sep: 'M09'}
		},
		monthStandaloneNames: {
			abbreviated: {apr: 'M04', aug: 'M08', dec: 'M12', feb: 'M02', jan: 'M01', jul: 'M07', jun: 'M06', mar: 'M03', may: 'M05', nov: 'M11', oct: 'M10', sep: 'M09'},
			narrow: {apr: '4', aug: '8', dec: '12', feb: '2', jan: '1', jul: '7', jun: '6', mar: '3', may: '5', nov: '11', oct: '10', sep: '9'},
			wide: {apr: 'M04', aug: 'M08', dec: 'M12', feb: 'M02', jan: 'M01', jul: 'M07', jun: 'M06', mar: 'M03', may: 'M05', nov: 'M11', oct: 'M10', sep: 'M09'}
		},
		percentNumberFormat: $cuducos$elm_format_number$FormatNumber$Locales$base,
		periodNames: {
			abbreviated: {
				am: 'AM',
				dayPeriods: $elm$core$Dict$fromList(_List_Nil),
				pm: 'PM'
			},
			narrow: {
				am: 'AM',
				dayPeriods: $elm$core$Dict$fromList(_List_Nil),
				pm: 'PM'
			},
			wide: {
				am: 'AM',
				dayPeriods: $elm$core$Dict$fromList(_List_Nil),
				pm: 'PM'
			}
		},
		timeSymbols: {full: _List_Nil, _long: _List_Nil, medium: _List_Nil, _short: _List_Nil},
		weekdayFormatNames: {
			abbreviated: {fri: 'Fri', mon: 'Mon', sat: 'Sat', sun: 'Sun', thu: 'Thu', tue: 'Tue', wed: 'Wed'},
			narrow: {fri: 'F', mon: 'M', sat: 'S', sun: 'S', thu: 'T', tue: 'T', wed: 'W'},
			wide: {fri: 'Fri', mon: 'Mon', sat: 'Sat', sun: 'Sun', thu: 'Thu', tue: 'Tue', wed: 'Wed'}
		},
		weekdayStandaloneNames: {
			abbreviated: {fri: 'Fri', mon: 'Mon', sat: 'Sat', sun: 'Sun', thu: 'Thu', tue: 'Tue', wed: 'Wed'},
			narrow: {fri: 'F', mon: 'M', sat: 'S', sun: 'S', thu: 'T', tue: 'T', wed: 'W'},
			wide: {fri: 'Fri', mon: 'Mon', sat: 'Sat', sun: 'Sun', thu: 'Thu', tue: 'Tue', wed: 'Wed'}
		}
	});
var $elm$core$Maybe$andThen = F2(
	function (callback, maybeValue) {
		if (maybeValue.$ === 'Just') {
			var value = maybeValue.a;
			return callback(value);
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $elm$core$Maybe$withDefault = F2(
	function (_default, maybe) {
		if (maybe.$ === 'Just') {
			var value = maybe.a;
			return value;
		} else {
			return _default;
		}
	});
var $enkidatron$elm_cldr$Internal$LanguageInfo$expand = function (info) {
	return {
		availableFormats: info.availableFormats,
		currencyNumberFormat: info.currencyNumberFormat,
		currencySymbols: info.currencySymbols,
		datePatterns: info.datePatterns,
		dateTimePatterns: info.dateTimePatterns,
		decimalNumberFormat: info.decimalNumberFormat,
		eraNames: info.eraNames,
		language: info.language,
		monthFormatNames: info.monthFormatNames,
		monthStandaloneNames: A2($elm$core$Maybe$withDefault, info.monthFormatNames, info.monthStandaloneNames),
		percentNumberFormat: info.percentNumberFormat,
		periodNames: info.periodNames,
		script: info.script,
		territory: info.territory,
		timePatterns: info.timePatterns,
		timeSkeletons: info.timeSkeletons,
		variant: info.variant,
		weekdayFormatNames: info.weekdayFormatNames,
		weekdayStandaloneNames: A2($elm$core$Maybe$withDefault, info.weekdayFormatNames, info.weekdayStandaloneNames)
	};
};
var $elm$core$Maybe$map = F2(
	function (f, maybe) {
		if (maybe.$ === 'Just') {
			var value = maybe.a;
			return $elm$core$Maybe$Just(
				f(value));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $enkidatron$elm_cldr$Internal$LanguageInfo$Compact = function (language) {
	return function (script) {
		return function (territory) {
			return function (variant) {
				return function (periodNames) {
					return function (datePatterns) {
						return function (monthFormatNames) {
							return function (monthStandaloneNames) {
								return function (weekdayFormatNames) {
									return function (weekdayStandaloneNames) {
										return function (eraNames) {
											return function (timePatterns) {
												return function (dateTimePatterns) {
													return function (availableFormats) {
														return function (timeSkeletons) {
															return function (decimalNumberFormat) {
																return function (currencyNumberFormat) {
																	return function (percentNumberFormat) {
																		return function (currencySymbols) {
																			return {availableFormats: availableFormats, currencyNumberFormat: currencyNumberFormat, currencySymbols: currencySymbols, datePatterns: datePatterns, dateTimePatterns: dateTimePatterns, decimalNumberFormat: decimalNumberFormat, eraNames: eraNames, language: language, monthFormatNames: monthFormatNames, monthStandaloneNames: monthStandaloneNames, percentNumberFormat: percentNumberFormat, periodNames: periodNames, script: script, territory: territory, timePatterns: timePatterns, timeSkeletons: timeSkeletons, variant: variant, weekdayFormatNames: weekdayFormatNames, weekdayStandaloneNames: weekdayStandaloneNames};
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $elm$parser$Parser$ExpectingEnd = {$: 'ExpectingEnd'};
var $elm$parser$Parser$Advanced$Bad = F2(
	function (a, b) {
		return {$: 'Bad', a: a, b: b};
	});
var $elm$parser$Parser$Advanced$Good = F3(
	function (a, b, c) {
		return {$: 'Good', a: a, b: b, c: c};
	});
var $elm$parser$Parser$Advanced$Parser = function (a) {
	return {$: 'Parser', a: a};
};
var $elm$parser$Parser$Advanced$AddRight = F2(
	function (a, b) {
		return {$: 'AddRight', a: a, b: b};
	});
var $elm$parser$Parser$Advanced$DeadEnd = F4(
	function (row, col, problem, contextStack) {
		return {col: col, contextStack: contextStack, problem: problem, row: row};
	});
var $elm$parser$Parser$Advanced$Empty = {$: 'Empty'};
var $elm$parser$Parser$Advanced$fromState = F2(
	function (s, x) {
		return A2(
			$elm$parser$Parser$Advanced$AddRight,
			$elm$parser$Parser$Advanced$Empty,
			A4($elm$parser$Parser$Advanced$DeadEnd, s.row, s.col, x, s.context));
	});
var $elm$core$String$length = _String_length;
var $elm$parser$Parser$Advanced$end = function (x) {
	return $elm$parser$Parser$Advanced$Parser(
		function (s) {
			return _Utils_eq(
				$elm$core$String$length(s.src),
				s.offset) ? A3($elm$parser$Parser$Advanced$Good, false, _Utils_Tuple0, s) : A2(
				$elm$parser$Parser$Advanced$Bad,
				false,
				A2($elm$parser$Parser$Advanced$fromState, s, x));
		});
};
var $elm$parser$Parser$end = $elm$parser$Parser$Advanced$end($elm$parser$Parser$ExpectingEnd);
var $enkidatron$elm_cldr$Internal$Structures$EraNames = F2(
	function (bc, ad) {
		return {ad: ad, bc: bc};
	});
var $elm$core$Basics$always = F2(
	function (a, _v0) {
		return a;
	});
var $elm$parser$Parser$Advanced$map2 = F3(
	function (func, _v0, _v1) {
		var parseA = _v0.a;
		var parseB = _v1.a;
		return $elm$parser$Parser$Advanced$Parser(
			function (s0) {
				var _v2 = parseA(s0);
				if (_v2.$ === 'Bad') {
					var p = _v2.a;
					var x = _v2.b;
					return A2($elm$parser$Parser$Advanced$Bad, p, x);
				} else {
					var p1 = _v2.a;
					var a = _v2.b;
					var s1 = _v2.c;
					var _v3 = parseB(s1);
					if (_v3.$ === 'Bad') {
						var p2 = _v3.a;
						var x = _v3.b;
						return A2($elm$parser$Parser$Advanced$Bad, p1 || p2, x);
					} else {
						var p2 = _v3.a;
						var b = _v3.b;
						var s2 = _v3.c;
						return A3(
							$elm$parser$Parser$Advanced$Good,
							p1 || p2,
							A2(func, a, b),
							s2);
					}
				}
			});
	});
var $elm$parser$Parser$Advanced$ignorer = F2(
	function (keepParser, ignoreParser) {
		return A3($elm$parser$Parser$Advanced$map2, $elm$core$Basics$always, keepParser, ignoreParser);
	});
var $elm$parser$Parser$ignorer = $elm$parser$Parser$Advanced$ignorer;
var $elm$parser$Parser$Advanced$keeper = F2(
	function (parseFunc, parseArg) {
		return A3($elm$parser$Parser$Advanced$map2, $elm$core$Basics$apL, parseFunc, parseArg);
	});
var $elm$parser$Parser$keeper = $elm$parser$Parser$Advanced$keeper;
var $elm$parser$Parser$ExpectingSymbol = function (a) {
	return {$: 'ExpectingSymbol', a: a};
};
var $elm$parser$Parser$Advanced$Token = F2(
	function (a, b) {
		return {$: 'Token', a: a, b: b};
	});
var $elm$core$String$isEmpty = function (string) {
	return string === '';
};
var $elm$parser$Parser$Advanced$isSubString = _Parser_isSubString;
var $elm$core$Basics$negate = function (n) {
	return -n;
};
var $elm$core$Basics$not = _Basics_not;
var $elm$parser$Parser$Advanced$token = function (_v0) {
	var str = _v0.a;
	var expecting = _v0.b;
	var progress = !$elm$core$String$isEmpty(str);
	return $elm$parser$Parser$Advanced$Parser(
		function (s) {
			var _v1 = A5($elm$parser$Parser$Advanced$isSubString, str, s.offset, s.row, s.col, s.src);
			var newOffset = _v1.a;
			var newRow = _v1.b;
			var newCol = _v1.c;
			return _Utils_eq(newOffset, -1) ? A2(
				$elm$parser$Parser$Advanced$Bad,
				false,
				A2($elm$parser$Parser$Advanced$fromState, s, expecting)) : A3(
				$elm$parser$Parser$Advanced$Good,
				progress,
				_Utils_Tuple0,
				{col: newCol, context: s.context, indent: s.indent, offset: newOffset, row: newRow, src: s.src});
		});
};
var $elm$parser$Parser$Advanced$symbol = $elm$parser$Parser$Advanced$token;
var $elm$parser$Parser$symbol = function (str) {
	return $elm$parser$Parser$Advanced$symbol(
		A2(
			$elm$parser$Parser$Advanced$Token,
			str,
			$elm$parser$Parser$ExpectingSymbol(str)));
};
var $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$pipe = $elm$parser$Parser$symbol('|');
var $elm$parser$Parser$Advanced$isSubChar = _Parser_isSubChar;
var $elm$parser$Parser$Advanced$chompWhileHelp = F5(
	function (isGood, offset, row, col, s0) {
		chompWhileHelp:
		while (true) {
			var newOffset = A3($elm$parser$Parser$Advanced$isSubChar, isGood, offset, s0.src);
			if (_Utils_eq(newOffset, -1)) {
				return A3(
					$elm$parser$Parser$Advanced$Good,
					_Utils_cmp(s0.offset, offset) < 0,
					_Utils_Tuple0,
					{col: col, context: s0.context, indent: s0.indent, offset: offset, row: row, src: s0.src});
			} else {
				if (_Utils_eq(newOffset, -2)) {
					var $temp$isGood = isGood,
						$temp$offset = offset + 1,
						$temp$row = row + 1,
						$temp$col = 1,
						$temp$s0 = s0;
					isGood = $temp$isGood;
					offset = $temp$offset;
					row = $temp$row;
					col = $temp$col;
					s0 = $temp$s0;
					continue chompWhileHelp;
				} else {
					var $temp$isGood = isGood,
						$temp$offset = newOffset,
						$temp$row = row,
						$temp$col = col + 1,
						$temp$s0 = s0;
					isGood = $temp$isGood;
					offset = $temp$offset;
					row = $temp$row;
					col = $temp$col;
					s0 = $temp$s0;
					continue chompWhileHelp;
				}
			}
		}
	});
var $elm$parser$Parser$Advanced$chompWhile = function (isGood) {
	return $elm$parser$Parser$Advanced$Parser(
		function (s) {
			return A5($elm$parser$Parser$Advanced$chompWhileHelp, isGood, s.offset, s.row, s.col, s);
		});
};
var $elm$parser$Parser$chompWhile = $elm$parser$Parser$Advanced$chompWhile;
var $elm$core$String$slice = _String_slice;
var $elm$parser$Parser$Advanced$mapChompedString = F2(
	function (func, _v0) {
		var parse = _v0.a;
		return $elm$parser$Parser$Advanced$Parser(
			function (s0) {
				var _v1 = parse(s0);
				if (_v1.$ === 'Bad') {
					var p = _v1.a;
					var x = _v1.b;
					return A2($elm$parser$Parser$Advanced$Bad, p, x);
				} else {
					var p = _v1.a;
					var a = _v1.b;
					var s1 = _v1.c;
					return A3(
						$elm$parser$Parser$Advanced$Good,
						p,
						A2(
							func,
							A3($elm$core$String$slice, s0.offset, s1.offset, s0.src),
							a),
						s1);
				}
			});
	});
var $elm$parser$Parser$Advanced$getChompedString = function (parser) {
	return A2($elm$parser$Parser$Advanced$mapChompedString, $elm$core$Basics$always, parser);
};
var $elm$parser$Parser$getChompedString = $elm$parser$Parser$Advanced$getChompedString;
var $elm$core$Basics$neq = _Utils_notEqual;
var $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$pipeDelimitedString = $elm$parser$Parser$getChompedString(
	$elm$parser$Parser$chompWhile(
		function (_char) {
			return !_Utils_eq(
				_char,
				_Utils_chr('|'));
		}));
var $elm$parser$Parser$Advanced$succeed = function (a) {
	return $elm$parser$Parser$Advanced$Parser(
		function (s) {
			return A3($elm$parser$Parser$Advanced$Good, false, a, s);
		});
};
var $elm$parser$Parser$succeed = $elm$parser$Parser$Advanced$succeed;
var $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$eraNamesParser = A2(
	$elm$parser$Parser$keeper,
	A2(
		$elm$parser$Parser$keeper,
		$elm$parser$Parser$succeed($enkidatron$elm_cldr$Internal$Structures$EraNames),
		A2($elm$parser$Parser$ignorer, $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$pipeDelimitedString, $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$pipe)),
	A2($elm$parser$Parser$ignorer, $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$pipeDelimitedString, $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$pipe));
var $cuducos$elm_format_number$FormatNumber$Locales$Locale = function (decimals) {
	return function (system) {
		return function (thousandSeparator) {
			return function (decimalSeparator) {
				return function (negativePrefix) {
					return function (negativeSuffix) {
						return function (positivePrefix) {
							return function (positiveSuffix) {
								return function (zeroPrefix) {
									return function (zeroSuffix) {
										return {decimalSeparator: decimalSeparator, decimals: decimals, negativePrefix: negativePrefix, negativeSuffix: negativeSuffix, positivePrefix: positivePrefix, positiveSuffix: positiveSuffix, system: system, thousandSeparator: thousandSeparator, zeroPrefix: zeroPrefix, zeroSuffix: zeroSuffix};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $cuducos$elm_format_number$FormatNumber$Locales$Exact = function (a) {
	return {$: 'Exact', a: a};
};
var $cuducos$elm_format_number$FormatNumber$Locales$Max = function (a) {
	return {$: 'Max', a: a};
};
var $elm$parser$Parser$Advanced$andThen = F2(
	function (callback, _v0) {
		var parseA = _v0.a;
		return $elm$parser$Parser$Advanced$Parser(
			function (s0) {
				var _v1 = parseA(s0);
				if (_v1.$ === 'Bad') {
					var p = _v1.a;
					var x = _v1.b;
					return A2($elm$parser$Parser$Advanced$Bad, p, x);
				} else {
					var p1 = _v1.a;
					var a = _v1.b;
					var s1 = _v1.c;
					var _v2 = callback(a);
					var parseB = _v2.a;
					var _v3 = parseB(s1);
					if (_v3.$ === 'Bad') {
						var p2 = _v3.a;
						var x = _v3.b;
						return A2($elm$parser$Parser$Advanced$Bad, p1 || p2, x);
					} else {
						var p2 = _v3.a;
						var b = _v3.b;
						var s2 = _v3.c;
						return A3($elm$parser$Parser$Advanced$Good, p1 || p2, b, s2);
					}
				}
			});
	});
var $elm$parser$Parser$andThen = $elm$parser$Parser$Advanced$andThen;
var $elm$parser$Parser$UnexpectedChar = {$: 'UnexpectedChar'};
var $elm$parser$Parser$Advanced$chompIf = F2(
	function (isGood, expecting) {
		return $elm$parser$Parser$Advanced$Parser(
			function (s) {
				var newOffset = A3($elm$parser$Parser$Advanced$isSubChar, isGood, s.offset, s.src);
				return _Utils_eq(newOffset, -1) ? A2(
					$elm$parser$Parser$Advanced$Bad,
					false,
					A2($elm$parser$Parser$Advanced$fromState, s, expecting)) : (_Utils_eq(newOffset, -2) ? A3(
					$elm$parser$Parser$Advanced$Good,
					true,
					_Utils_Tuple0,
					{col: 1, context: s.context, indent: s.indent, offset: s.offset + 1, row: s.row + 1, src: s.src}) : A3(
					$elm$parser$Parser$Advanced$Good,
					true,
					_Utils_Tuple0,
					{col: s.col + 1, context: s.context, indent: s.indent, offset: newOffset, row: s.row, src: s.src}));
			});
	});
var $elm$parser$Parser$chompIf = function (isGood) {
	return A2($elm$parser$Parser$Advanced$chompIf, isGood, $elm$parser$Parser$UnexpectedChar);
};
var $elm$parser$Parser$ExpectingInt = {$: 'ExpectingInt'};
var $elm$parser$Parser$Advanced$consumeBase = _Parser_consumeBase;
var $elm$parser$Parser$Advanced$consumeBase16 = _Parser_consumeBase16;
var $elm$parser$Parser$Advanced$bumpOffset = F2(
	function (newOffset, s) {
		return {col: s.col + (newOffset - s.offset), context: s.context, indent: s.indent, offset: newOffset, row: s.row, src: s.src};
	});
var $elm$parser$Parser$Advanced$chompBase10 = _Parser_chompBase10;
var $elm$parser$Parser$Advanced$isAsciiCode = _Parser_isAsciiCode;
var $elm$parser$Parser$Advanced$consumeExp = F2(
	function (offset, src) {
		if (A3($elm$parser$Parser$Advanced$isAsciiCode, 101, offset, src) || A3($elm$parser$Parser$Advanced$isAsciiCode, 69, offset, src)) {
			var eOffset = offset + 1;
			var expOffset = (A3($elm$parser$Parser$Advanced$isAsciiCode, 43, eOffset, src) || A3($elm$parser$Parser$Advanced$isAsciiCode, 45, eOffset, src)) ? (eOffset + 1) : eOffset;
			var newOffset = A2($elm$parser$Parser$Advanced$chompBase10, expOffset, src);
			return _Utils_eq(expOffset, newOffset) ? (-newOffset) : newOffset;
		} else {
			return offset;
		}
	});
var $elm$parser$Parser$Advanced$consumeDotAndExp = F2(
	function (offset, src) {
		return A3($elm$parser$Parser$Advanced$isAsciiCode, 46, offset, src) ? A2(
			$elm$parser$Parser$Advanced$consumeExp,
			A2($elm$parser$Parser$Advanced$chompBase10, offset + 1, src),
			src) : A2($elm$parser$Parser$Advanced$consumeExp, offset, src);
	});
var $elm$parser$Parser$Advanced$finalizeInt = F5(
	function (invalid, handler, startOffset, _v0, s) {
		var endOffset = _v0.a;
		var n = _v0.b;
		if (handler.$ === 'Err') {
			var x = handler.a;
			return A2(
				$elm$parser$Parser$Advanced$Bad,
				true,
				A2($elm$parser$Parser$Advanced$fromState, s, x));
		} else {
			var toValue = handler.a;
			return _Utils_eq(startOffset, endOffset) ? A2(
				$elm$parser$Parser$Advanced$Bad,
				_Utils_cmp(s.offset, startOffset) < 0,
				A2($elm$parser$Parser$Advanced$fromState, s, invalid)) : A3(
				$elm$parser$Parser$Advanced$Good,
				true,
				toValue(n),
				A2($elm$parser$Parser$Advanced$bumpOffset, endOffset, s));
		}
	});
var $elm$parser$Parser$Advanced$fromInfo = F4(
	function (row, col, x, context) {
		return A2(
			$elm$parser$Parser$Advanced$AddRight,
			$elm$parser$Parser$Advanced$Empty,
			A4($elm$parser$Parser$Advanced$DeadEnd, row, col, x, context));
	});
var $elm$core$String$toFloat = _String_toFloat;
var $elm$parser$Parser$Advanced$finalizeFloat = F6(
	function (invalid, expecting, intSettings, floatSettings, intPair, s) {
		var intOffset = intPair.a;
		var floatOffset = A2($elm$parser$Parser$Advanced$consumeDotAndExp, intOffset, s.src);
		if (floatOffset < 0) {
			return A2(
				$elm$parser$Parser$Advanced$Bad,
				true,
				A4($elm$parser$Parser$Advanced$fromInfo, s.row, s.col - (floatOffset + s.offset), invalid, s.context));
		} else {
			if (_Utils_eq(s.offset, floatOffset)) {
				return A2(
					$elm$parser$Parser$Advanced$Bad,
					false,
					A2($elm$parser$Parser$Advanced$fromState, s, expecting));
			} else {
				if (_Utils_eq(intOffset, floatOffset)) {
					return A5($elm$parser$Parser$Advanced$finalizeInt, invalid, intSettings, s.offset, intPair, s);
				} else {
					if (floatSettings.$ === 'Err') {
						var x = floatSettings.a;
						return A2(
							$elm$parser$Parser$Advanced$Bad,
							true,
							A2($elm$parser$Parser$Advanced$fromState, s, invalid));
					} else {
						var toValue = floatSettings.a;
						var _v1 = $elm$core$String$toFloat(
							A3($elm$core$String$slice, s.offset, floatOffset, s.src));
						if (_v1.$ === 'Nothing') {
							return A2(
								$elm$parser$Parser$Advanced$Bad,
								true,
								A2($elm$parser$Parser$Advanced$fromState, s, invalid));
						} else {
							var n = _v1.a;
							return A3(
								$elm$parser$Parser$Advanced$Good,
								true,
								toValue(n),
								A2($elm$parser$Parser$Advanced$bumpOffset, floatOffset, s));
						}
					}
				}
			}
		}
	});
var $elm$parser$Parser$Advanced$number = function (c) {
	return $elm$parser$Parser$Advanced$Parser(
		function (s) {
			if (A3($elm$parser$Parser$Advanced$isAsciiCode, 48, s.offset, s.src)) {
				var zeroOffset = s.offset + 1;
				var baseOffset = zeroOffset + 1;
				return A3($elm$parser$Parser$Advanced$isAsciiCode, 120, zeroOffset, s.src) ? A5(
					$elm$parser$Parser$Advanced$finalizeInt,
					c.invalid,
					c.hex,
					baseOffset,
					A2($elm$parser$Parser$Advanced$consumeBase16, baseOffset, s.src),
					s) : (A3($elm$parser$Parser$Advanced$isAsciiCode, 111, zeroOffset, s.src) ? A5(
					$elm$parser$Parser$Advanced$finalizeInt,
					c.invalid,
					c.octal,
					baseOffset,
					A3($elm$parser$Parser$Advanced$consumeBase, 8, baseOffset, s.src),
					s) : (A3($elm$parser$Parser$Advanced$isAsciiCode, 98, zeroOffset, s.src) ? A5(
					$elm$parser$Parser$Advanced$finalizeInt,
					c.invalid,
					c.binary,
					baseOffset,
					A3($elm$parser$Parser$Advanced$consumeBase, 2, baseOffset, s.src),
					s) : A6(
					$elm$parser$Parser$Advanced$finalizeFloat,
					c.invalid,
					c.expecting,
					c._int,
					c._float,
					_Utils_Tuple2(zeroOffset, 0),
					s)));
			} else {
				return A6(
					$elm$parser$Parser$Advanced$finalizeFloat,
					c.invalid,
					c.expecting,
					c._int,
					c._float,
					A3($elm$parser$Parser$Advanced$consumeBase, 10, s.offset, s.src),
					s);
			}
		});
};
var $elm$parser$Parser$Advanced$int = F2(
	function (expecting, invalid) {
		return $elm$parser$Parser$Advanced$number(
			{
				binary: $elm$core$Result$Err(invalid),
				expecting: expecting,
				_float: $elm$core$Result$Err(invalid),
				hex: $elm$core$Result$Err(invalid),
				_int: $elm$core$Result$Ok($elm$core$Basics$identity),
				invalid: invalid,
				octal: $elm$core$Result$Err(invalid)
			});
	});
var $elm$parser$Parser$int = A2($elm$parser$Parser$Advanced$int, $elm$parser$Parser$ExpectingInt, $elm$parser$Parser$ExpectingInt);
var $elm$parser$Parser$Advanced$map = F2(
	function (func, _v0) {
		var parse = _v0.a;
		return $elm$parser$Parser$Advanced$Parser(
			function (s0) {
				var _v1 = parse(s0);
				if (_v1.$ === 'Good') {
					var p = _v1.a;
					var a = _v1.b;
					var s1 = _v1.c;
					return A3(
						$elm$parser$Parser$Advanced$Good,
						p,
						func(a),
						s1);
				} else {
					var p = _v1.a;
					var x = _v1.b;
					return A2($elm$parser$Parser$Advanced$Bad, p, x);
				}
			});
	});
var $elm$parser$Parser$map = $elm$parser$Parser$Advanced$map;
var $elm$core$List$any = F2(
	function (isOkay, list) {
		any:
		while (true) {
			if (!list.b) {
				return false;
			} else {
				var x = list.a;
				var xs = list.b;
				if (isOkay(x)) {
					return true;
				} else {
					var $temp$isOkay = isOkay,
						$temp$list = xs;
					isOkay = $temp$isOkay;
					list = $temp$list;
					continue any;
				}
			}
		}
	});
var $elm$core$List$member = F2(
	function (x, xs) {
		return A2(
			$elm$core$List$any,
			function (a) {
				return _Utils_eq(a, x);
			},
			xs);
	});
var $elm$parser$Parser$Problem = function (a) {
	return {$: 'Problem', a: a};
};
var $elm$parser$Parser$Advanced$problem = function (x) {
	return $elm$parser$Parser$Advanced$Parser(
		function (s) {
			return A2(
				$elm$parser$Parser$Advanced$Bad,
				false,
				A2($elm$parser$Parser$Advanced$fromState, s, x));
		});
};
var $elm$parser$Parser$problem = function (msg) {
	return $elm$parser$Parser$Advanced$problem(
		$elm$parser$Parser$Problem(msg));
};
var $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$formatNumberDecimalsParser = A2(
	$elm$parser$Parser$andThen,
	function (tag) {
		switch (tag) {
			case 'N':
				return A2($elm$parser$Parser$map, $cuducos$elm_format_number$FormatNumber$Locales$Min, $elm$parser$Parser$int);
			case 'X':
				return A2($elm$parser$Parser$map, $cuducos$elm_format_number$FormatNumber$Locales$Max, $elm$parser$Parser$int);
			case 'E':
				return A2($elm$parser$Parser$map, $cuducos$elm_format_number$FormatNumber$Locales$Exact, $elm$parser$Parser$int);
			default:
				var other = tag;
				return $elm$parser$Parser$problem('Error while parsing a FormatNumber.Locales.Decimals, found: ' + other);
		}
	},
	$elm$parser$Parser$getChompedString(
		$elm$parser$Parser$chompIf(
			function (_char) {
				return A2(
					$elm$core$List$member,
					_char,
					_List_fromArray(
						[
							_Utils_chr('N'),
							_Utils_chr('X'),
							_Utils_chr('E')
						]));
			})));
var $cuducos$elm_format_number$FormatNumber$Locales$Indian = {$: 'Indian'};
var $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$formatNumberSystemParser = A2(
	$elm$parser$Parser$andThen,
	function (tag) {
		switch (tag) {
			case 'W':
				return $elm$parser$Parser$succeed($cuducos$elm_format_number$FormatNumber$Locales$Western);
			case 'I':
				return $elm$parser$Parser$succeed($cuducos$elm_format_number$FormatNumber$Locales$Indian);
			default:
				var other = tag;
				return $elm$parser$Parser$problem('Error while parsing a FormatNumber.Locales.System, found: ' + other);
		}
	},
	$elm$parser$Parser$getChompedString(
		$elm$parser$Parser$chompIf(
			function (_char) {
				return A2(
					$elm$core$List$member,
					_char,
					_List_fromArray(
						[
							_Utils_chr('W'),
							_Utils_chr('I')
						]));
			})));
var $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$formatNumberLocaleParser = A2(
	$elm$parser$Parser$keeper,
	A2(
		$elm$parser$Parser$keeper,
		A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$keeper,
				A2(
					$elm$parser$Parser$keeper,
					A2(
						$elm$parser$Parser$keeper,
						A2(
							$elm$parser$Parser$keeper,
							A2(
								$elm$parser$Parser$keeper,
								A2(
									$elm$parser$Parser$keeper,
									A2(
										$elm$parser$Parser$keeper,
										$elm$parser$Parser$succeed($cuducos$elm_format_number$FormatNumber$Locales$Locale),
										$enkidatron$elm_cldr$Internal$LanguageInfo$Parse$formatNumberDecimalsParser),
									$enkidatron$elm_cldr$Internal$LanguageInfo$Parse$formatNumberSystemParser),
								A2($elm$parser$Parser$ignorer, $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$pipeDelimitedString, $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$pipe)),
							A2($elm$parser$Parser$ignorer, $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$pipeDelimitedString, $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$pipe)),
						A2($elm$parser$Parser$ignorer, $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$pipeDelimitedString, $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$pipe)),
					A2($elm$parser$Parser$ignorer, $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$pipeDelimitedString, $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$pipe)),
				A2($elm$parser$Parser$ignorer, $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$pipeDelimitedString, $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$pipe)),
			A2($elm$parser$Parser$ignorer, $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$pipeDelimitedString, $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$pipe)),
		A2($elm$parser$Parser$ignorer, $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$pipeDelimitedString, $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$pipe)),
	A2($elm$parser$Parser$ignorer, $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$pipeDelimitedString, $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$pipe));
var $elm$parser$Parser$Done = function (a) {
	return {$: 'Done', a: a};
};
var $elm$parser$Parser$Loop = function (a) {
	return {$: 'Loop', a: a};
};
var $elm$parser$Parser$Advanced$loopHelp = F4(
	function (p, state, callback, s0) {
		loopHelp:
		while (true) {
			var _v0 = callback(state);
			var parse = _v0.a;
			var _v1 = parse(s0);
			if (_v1.$ === 'Good') {
				var p1 = _v1.a;
				var step = _v1.b;
				var s1 = _v1.c;
				if (step.$ === 'Loop') {
					var newState = step.a;
					var $temp$p = p || p1,
						$temp$state = newState,
						$temp$callback = callback,
						$temp$s0 = s1;
					p = $temp$p;
					state = $temp$state;
					callback = $temp$callback;
					s0 = $temp$s0;
					continue loopHelp;
				} else {
					var result = step.a;
					return A3($elm$parser$Parser$Advanced$Good, p || p1, result, s1);
				}
			} else {
				var p1 = _v1.a;
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, p || p1, x);
			}
		}
	});
var $elm$parser$Parser$Advanced$loop = F2(
	function (state, callback) {
		return $elm$parser$Parser$Advanced$Parser(
			function (s) {
				return A4($elm$parser$Parser$Advanced$loopHelp, false, state, callback, s);
			});
	});
var $elm$parser$Parser$Advanced$Done = function (a) {
	return {$: 'Done', a: a};
};
var $elm$parser$Parser$Advanced$Loop = function (a) {
	return {$: 'Loop', a: a};
};
var $elm$parser$Parser$toAdvancedStep = function (step) {
	if (step.$ === 'Loop') {
		var s = step.a;
		return $elm$parser$Parser$Advanced$Loop(s);
	} else {
		var a = step.a;
		return $elm$parser$Parser$Advanced$Done(a);
	}
};
var $elm$parser$Parser$loop = F2(
	function (state, callback) {
		return A2(
			$elm$parser$Parser$Advanced$loop,
			state,
			function (s) {
				return A2(
					$elm$parser$Parser$map,
					$elm$parser$Parser$toAdvancedStep,
					callback(s));
			});
	});
var $elm$core$Tuple$pair = F2(
	function (a, b) {
		return _Utils_Tuple2(a, b);
	});
var $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$listOfPairOfStringParser = A2(
	$elm$parser$Parser$andThen,
	function (count) {
		return A2(
			$elm$parser$Parser$loop,
			_Utils_Tuple2(count, _List_Nil),
			function (_v0) {
				var x = _v0.a;
				var revItems = _v0.b;
				return (x > 0) ? A2(
					$elm$parser$Parser$map,
					function (item) {
						return $elm$parser$Parser$Loop(
							_Utils_Tuple2(
								x - 1,
								A2($elm$core$List$cons, item, revItems)));
					},
					A2(
						$elm$parser$Parser$keeper,
						A2(
							$elm$parser$Parser$keeper,
							$elm$parser$Parser$succeed($elm$core$Tuple$pair),
							A2($elm$parser$Parser$ignorer, $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$pipeDelimitedString, $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$pipe)),
						A2($elm$parser$Parser$ignorer, $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$pipeDelimitedString, $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$pipe))) : $elm$parser$Parser$succeed(
					$elm$parser$Parser$Done(
						$elm$core$List$reverse(revItems)));
			});
	},
	A2($elm$parser$Parser$ignorer, $elm$parser$Parser$int, $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$pipe));
var $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$maybeParser = function (innerParser) {
	return A2(
		$elm$parser$Parser$andThen,
		function (x) {
			switch (x) {
				case 0:
					return $elm$parser$Parser$succeed($elm$core$Maybe$Nothing);
				case 1:
					return A2($elm$parser$Parser$map, $elm$core$Maybe$Just, innerParser);
				default:
					return $elm$parser$Parser$problem('Unexpected number encountered while evaulating a Maybe');
			}
		},
		A2($elm$parser$Parser$ignorer, $elm$parser$Parser$int, $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$pipe));
};
var $elm_community$string_extra$String$Extra$nonEmpty = function (string) {
	return $elm$core$String$isEmpty(string) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(string);
};
var $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$maybeStringParser = A2($elm$parser$Parser$map, $elm_community$string_extra$String$Extra$nonEmpty, $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$pipeDelimitedString);
var $enkidatron$elm_cldr$Internal$Structures$MonthNames = function (jan) {
	return function (feb) {
		return function (mar) {
			return function (apr) {
				return function (may) {
					return function (jun) {
						return function (jul) {
							return function (aug) {
								return function (sep) {
									return function (oct) {
										return function (nov) {
											return function (dec) {
												return {apr: apr, aug: aug, dec: dec, feb: feb, jan: jan, jul: jul, jun: jun, mar: mar, may: may, nov: nov, oct: oct, sep: sep};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$monthNamesParser = A2(
	$elm$parser$Parser$keeper,
	A2(
		$elm$parser$Parser$keeper,
		A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$keeper,
				A2(
					$elm$parser$Parser$keeper,
					A2(
						$elm$parser$Parser$keeper,
						A2(
							$elm$parser$Parser$keeper,
							A2(
								$elm$parser$Parser$keeper,
								A2(
									$elm$parser$Parser$keeper,
									A2(
										$elm$parser$Parser$keeper,
										A2(
											$elm$parser$Parser$keeper,
											A2(
												$elm$parser$Parser$keeper,
												$elm$parser$Parser$succeed($enkidatron$elm_cldr$Internal$Structures$MonthNames),
												A2($elm$parser$Parser$ignorer, $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$pipeDelimitedString, $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$pipe)),
											A2($elm$parser$Parser$ignorer, $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$pipeDelimitedString, $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$pipe)),
										A2($elm$parser$Parser$ignorer, $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$pipeDelimitedString, $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$pipe)),
									A2($elm$parser$Parser$ignorer, $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$pipeDelimitedString, $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$pipe)),
								A2($elm$parser$Parser$ignorer, $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$pipeDelimitedString, $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$pipe)),
							A2($elm$parser$Parser$ignorer, $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$pipeDelimitedString, $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$pipe)),
						A2($elm$parser$Parser$ignorer, $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$pipeDelimitedString, $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$pipe)),
					A2($elm$parser$Parser$ignorer, $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$pipeDelimitedString, $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$pipe)),
				A2($elm$parser$Parser$ignorer, $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$pipeDelimitedString, $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$pipe)),
			A2($elm$parser$Parser$ignorer, $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$pipeDelimitedString, $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$pipe)),
		A2($elm$parser$Parser$ignorer, $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$pipeDelimitedString, $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$pipe)),
	A2($elm$parser$Parser$ignorer, $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$pipeDelimitedString, $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$pipe));
var $enkidatron$elm_cldr$Internal$Structures$Pattern3 = F3(
	function (abbreviated, wide, narrow) {
		return {abbreviated: abbreviated, narrow: narrow, wide: wide};
	});
var $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$pattern3Parser = function (innerParser) {
	return A2(
		$elm$parser$Parser$keeper,
		A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$keeper,
				$elm$parser$Parser$succeed($enkidatron$elm_cldr$Internal$Structures$Pattern3),
				innerParser),
			innerParser),
		innerParser);
};
var $enkidatron$elm_cldr$Internal$Structures$Patterns = F4(
	function (_short, medium, _long, full) {
		return {full: full, _long: _long, medium: medium, _short: _short};
	});
var $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$patternsParser = function (innerParser) {
	return A2(
		$elm$parser$Parser$keeper,
		A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$keeper,
				A2(
					$elm$parser$Parser$keeper,
					$elm$parser$Parser$succeed($enkidatron$elm_cldr$Internal$Structures$Patterns),
					innerParser),
				innerParser),
			innerParser),
		innerParser);
};
var $enkidatron$elm_cldr$Internal$Structures$PeriodNames = F3(
	function (am, pm, dayPeriods) {
		return {am: am, dayPeriods: dayPeriods, pm: pm};
	});
var $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$dayPeriodsParser = A2($elm$parser$Parser$map, $elm$core$Dict$fromList, $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$listOfPairOfStringParser);
var $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$periodNamesParser = A2(
	$elm$parser$Parser$keeper,
	A2(
		$elm$parser$Parser$keeper,
		A2(
			$elm$parser$Parser$keeper,
			$elm$parser$Parser$succeed($enkidatron$elm_cldr$Internal$Structures$PeriodNames),
			A2($elm$parser$Parser$ignorer, $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$pipeDelimitedString, $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$pipe)),
		A2($elm$parser$Parser$ignorer, $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$pipeDelimitedString, $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$pipe)),
	$enkidatron$elm_cldr$Internal$LanguageInfo$Parse$dayPeriodsParser);
var $enkidatron$elm_cldr$Internal$Structures$WeekdayNames = F7(
	function (sun, mon, tue, wed, thu, fri, sat) {
		return {fri: fri, mon: mon, sat: sat, sun: sun, thu: thu, tue: tue, wed: wed};
	});
var $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$weekdayNamesParser = A2(
	$elm$parser$Parser$keeper,
	A2(
		$elm$parser$Parser$keeper,
		A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$keeper,
				A2(
					$elm$parser$Parser$keeper,
					A2(
						$elm$parser$Parser$keeper,
						A2(
							$elm$parser$Parser$keeper,
							$elm$parser$Parser$succeed($enkidatron$elm_cldr$Internal$Structures$WeekdayNames),
							A2($elm$parser$Parser$ignorer, $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$pipeDelimitedString, $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$pipe)),
						A2($elm$parser$Parser$ignorer, $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$pipeDelimitedString, $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$pipe)),
					A2($elm$parser$Parser$ignorer, $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$pipeDelimitedString, $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$pipe)),
				A2($elm$parser$Parser$ignorer, $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$pipeDelimitedString, $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$pipe)),
			A2($elm$parser$Parser$ignorer, $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$pipeDelimitedString, $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$pipe)),
		A2($elm$parser$Parser$ignorer, $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$pipeDelimitedString, $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$pipe)),
	A2($elm$parser$Parser$ignorer, $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$pipeDelimitedString, $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$pipe));
var $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$parser = A2(
	$elm$parser$Parser$keeper,
	A2(
		$elm$parser$Parser$keeper,
		A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$keeper,
				A2(
					$elm$parser$Parser$keeper,
					A2(
						$elm$parser$Parser$keeper,
						A2(
							$elm$parser$Parser$keeper,
							A2(
								$elm$parser$Parser$keeper,
								A2(
									$elm$parser$Parser$keeper,
									A2(
										$elm$parser$Parser$keeper,
										A2(
											$elm$parser$Parser$keeper,
											A2(
												$elm$parser$Parser$keeper,
												A2(
													$elm$parser$Parser$keeper,
													A2(
														$elm$parser$Parser$keeper,
														A2(
															$elm$parser$Parser$keeper,
															A2(
																$elm$parser$Parser$keeper,
																A2(
																	$elm$parser$Parser$keeper,
																	A2(
																		$elm$parser$Parser$keeper,
																		A2(
																			$elm$parser$Parser$keeper,
																			$elm$parser$Parser$succeed($enkidatron$elm_cldr$Internal$LanguageInfo$Compact),
																			A2($elm$parser$Parser$ignorer, $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$pipeDelimitedString, $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$pipe)),
																		A2($elm$parser$Parser$ignorer, $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$maybeStringParser, $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$pipe)),
																	A2($elm$parser$Parser$ignorer, $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$maybeStringParser, $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$pipe)),
																A2($elm$parser$Parser$ignorer, $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$maybeStringParser, $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$pipe)),
															$enkidatron$elm_cldr$Internal$LanguageInfo$Parse$pattern3Parser($enkidatron$elm_cldr$Internal$LanguageInfo$Parse$periodNamesParser)),
														$enkidatron$elm_cldr$Internal$LanguageInfo$Parse$patternsParser(
															A2($elm$parser$Parser$ignorer, $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$pipeDelimitedString, $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$pipe))),
													$enkidatron$elm_cldr$Internal$LanguageInfo$Parse$pattern3Parser($enkidatron$elm_cldr$Internal$LanguageInfo$Parse$monthNamesParser)),
												$enkidatron$elm_cldr$Internal$LanguageInfo$Parse$maybeParser(
													$enkidatron$elm_cldr$Internal$LanguageInfo$Parse$pattern3Parser($enkidatron$elm_cldr$Internal$LanguageInfo$Parse$monthNamesParser))),
											$enkidatron$elm_cldr$Internal$LanguageInfo$Parse$pattern3Parser($enkidatron$elm_cldr$Internal$LanguageInfo$Parse$weekdayNamesParser)),
										$enkidatron$elm_cldr$Internal$LanguageInfo$Parse$maybeParser(
											$enkidatron$elm_cldr$Internal$LanguageInfo$Parse$pattern3Parser($enkidatron$elm_cldr$Internal$LanguageInfo$Parse$weekdayNamesParser))),
									$enkidatron$elm_cldr$Internal$LanguageInfo$Parse$pattern3Parser($enkidatron$elm_cldr$Internal$LanguageInfo$Parse$eraNamesParser)),
								$enkidatron$elm_cldr$Internal$LanguageInfo$Parse$patternsParser(
									A2($elm$parser$Parser$ignorer, $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$pipeDelimitedString, $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$pipe))),
							$enkidatron$elm_cldr$Internal$LanguageInfo$Parse$patternsParser(
								A2($elm$parser$Parser$ignorer, $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$pipeDelimitedString, $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$pipe))),
						$enkidatron$elm_cldr$Internal$LanguageInfo$Parse$listOfPairOfStringParser),
					$enkidatron$elm_cldr$Internal$LanguageInfo$Parse$patternsParser(
						A2($elm$parser$Parser$ignorer, $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$pipeDelimitedString, $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$pipe))),
				$enkidatron$elm_cldr$Internal$LanguageInfo$Parse$formatNumberLocaleParser),
			$enkidatron$elm_cldr$Internal$LanguageInfo$Parse$formatNumberLocaleParser),
		$enkidatron$elm_cldr$Internal$LanguageInfo$Parse$formatNumberLocaleParser),
	A2($elm$parser$Parser$ignorer, $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$listOfPairOfStringParser, $elm$parser$Parser$end));
var $elm$core$List$foldrHelper = F4(
	function (fn, acc, ctr, ls) {
		if (!ls.b) {
			return acc;
		} else {
			var a = ls.a;
			var r1 = ls.b;
			if (!r1.b) {
				return A2(fn, a, acc);
			} else {
				var b = r1.a;
				var r2 = r1.b;
				if (!r2.b) {
					return A2(
						fn,
						a,
						A2(fn, b, acc));
				} else {
					var c = r2.a;
					var r3 = r2.b;
					if (!r3.b) {
						return A2(
							fn,
							a,
							A2(
								fn,
								b,
								A2(fn, c, acc)));
					} else {
						var d = r3.a;
						var r4 = r3.b;
						var res = (ctr > 500) ? A3(
							$elm$core$List$foldl,
							fn,
							acc,
							$elm$core$List$reverse(r4)) : A4($elm$core$List$foldrHelper, fn, acc, ctr + 1, r4);
						return A2(
							fn,
							a,
							A2(
								fn,
								b,
								A2(
									fn,
									c,
									A2(fn, d, res))));
					}
				}
			}
		}
	});
var $elm$core$List$foldr = F3(
	function (fn, acc, ls) {
		return A4($elm$core$List$foldrHelper, fn, acc, 0, ls);
	});
var $elm$core$List$map = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$foldr,
			F2(
				function (x, acc) {
					return A2(
						$elm$core$List$cons,
						f(x),
						acc);
				}),
			_List_Nil,
			xs);
	});
var $elm$parser$Parser$DeadEnd = F3(
	function (row, col, problem) {
		return {col: col, problem: problem, row: row};
	});
var $elm$parser$Parser$problemToDeadEnd = function (p) {
	return A3($elm$parser$Parser$DeadEnd, p.row, p.col, p.problem);
};
var $elm$parser$Parser$Advanced$bagToList = F2(
	function (bag, list) {
		bagToList:
		while (true) {
			switch (bag.$) {
				case 'Empty':
					return list;
				case 'AddRight':
					var bag1 = bag.a;
					var x = bag.b;
					var $temp$bag = bag1,
						$temp$list = A2($elm$core$List$cons, x, list);
					bag = $temp$bag;
					list = $temp$list;
					continue bagToList;
				default:
					var bag1 = bag.a;
					var bag2 = bag.b;
					var $temp$bag = bag1,
						$temp$list = A2($elm$parser$Parser$Advanced$bagToList, bag2, list);
					bag = $temp$bag;
					list = $temp$list;
					continue bagToList;
			}
		}
	});
var $elm$parser$Parser$Advanced$run = F2(
	function (_v0, src) {
		var parse = _v0.a;
		var _v1 = parse(
			{col: 1, context: _List_Nil, indent: 1, offset: 0, row: 1, src: src});
		if (_v1.$ === 'Good') {
			var value = _v1.b;
			return $elm$core$Result$Ok(value);
		} else {
			var bag = _v1.b;
			return $elm$core$Result$Err(
				A2($elm$parser$Parser$Advanced$bagToList, bag, _List_Nil));
		}
	});
var $elm$parser$Parser$run = F2(
	function (parser, source) {
		var _v0 = A2($elm$parser$Parser$Advanced$run, parser, source);
		if (_v0.$ === 'Ok') {
			var a = _v0.a;
			return $elm$core$Result$Ok(a);
		} else {
			var problems = _v0.a;
			return $elm$core$Result$Err(
				A2($elm$core$List$map, $elm$parser$Parser$problemToDeadEnd, problems));
		}
	});
var $elm$core$Result$toMaybe = function (result) {
	if (result.$ === 'Ok') {
		var v = result.a;
		return $elm$core$Maybe$Just(v);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$parse = function (words) {
	return A2(
		$elm$core$Maybe$map,
		$enkidatron$elm_cldr$Internal$LanguageInfo$expand,
		$elm$core$Result$toMaybe(
			A2($elm$parser$Parser$run, $enkidatron$elm_cldr$Internal$LanguageInfo$Parse$parser, words)));
};
var $enkidatron$elm_cldr$Internal$Locale$Internal = function (monthFormatNames) {
	return function (monthStandaloneNames) {
		return function (weekdayFormatNames) {
			return function (weekdayStandaloneNames) {
				return function (eraNames) {
					return function (periodNames) {
						return function (dayPeriodRuleSet) {
							return function (dateSymbols) {
								return function (timeSymbols) {
									return function (dateTimeTokens) {
										return function (languageId) {
											return function (availableFormats) {
												return function (hour12ByDefault) {
													return function (decimalNumberFormat) {
														return function (currencyNumberFormat) {
															return function (percentNumberFormat) {
																return function (currencySymbols) {
																	return {availableFormats: availableFormats, currencyNumberFormat: currencyNumberFormat, currencySymbols: currencySymbols, dateSymbols: dateSymbols, dateTimeTokens: dateTimeTokens, dayPeriodRuleSet: dayPeriodRuleSet, decimalNumberFormat: decimalNumberFormat, eraNames: eraNames, hour12ByDefault: hour12ByDefault, languageId: languageId, monthFormatNames: monthFormatNames, monthStandaloneNames: monthStandaloneNames, percentNumberFormat: percentNumberFormat, periodNames: periodNames, timeSymbols: timeSymbols, weekdayFormatNames: weekdayFormatNames, weekdayStandaloneNames: weekdayStandaloneNames};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $elm$core$Maybe$map2 = F3(
	function (func, ma, mb) {
		if (ma.$ === 'Nothing') {
			return $elm$core$Maybe$Nothing;
		} else {
			var a = ma.a;
			if (mb.$ === 'Nothing') {
				return $elm$core$Maybe$Nothing;
			} else {
				var b = mb.a;
				return $elm$core$Maybe$Just(
					A2(func, a, b));
			}
		}
	});
var $elm_community$maybe_extra$Maybe$Extra$andMap = $elm$core$Maybe$map2($elm$core$Basics$apR);
var $elm_community$maybe_extra$Maybe$Extra$combineHelp = F2(
	function (list, acc) {
		combineHelp:
		while (true) {
			if (list.b) {
				var head = list.a;
				var tail = list.b;
				if (head.$ === 'Just') {
					var a = head.a;
					var $temp$list = tail,
						$temp$acc = A2($elm$core$List$cons, a, acc);
					list = $temp$list;
					acc = $temp$acc;
					continue combineHelp;
				} else {
					return $elm$core$Maybe$Nothing;
				}
			} else {
				return $elm$core$Maybe$Just(
					$elm$core$List$reverse(acc));
			}
		}
	});
var $elm_community$maybe_extra$Maybe$Extra$combine = function (list) {
	return A2($elm_community$maybe_extra$Maybe$Extra$combineHelp, list, _List_Nil);
};
var $elm$core$List$filter = F2(
	function (isGood, list) {
		return A3(
			$elm$core$List$foldr,
			F2(
				function (x, xs) {
					return isGood(x) ? A2($elm$core$List$cons, x, xs) : xs;
				}),
			_List_Nil,
			list);
	});
var $elm$core$String$endsWith = _String_endsWith;
var $elm$core$Dict$get = F2(
	function (targetKey, dict) {
		get:
		while (true) {
			if (dict.$ === 'RBEmpty_elm_builtin') {
				return $elm$core$Maybe$Nothing;
			} else {
				var key = dict.b;
				var value = dict.c;
				var left = dict.d;
				var right = dict.e;
				var _v1 = A2($elm$core$Basics$compare, targetKey, key);
				switch (_v1.$) {
					case 'LT':
						var $temp$targetKey = targetKey,
							$temp$dict = left;
						targetKey = $temp$targetKey;
						dict = $temp$dict;
						continue get;
					case 'EQ':
						return $elm$core$Maybe$Just(value);
					default:
						var $temp$targetKey = targetKey,
							$temp$dict = right;
						targetKey = $temp$targetKey;
						dict = $temp$dict;
						continue get;
				}
			}
		}
	});
var $elm$core$Dict$member = F2(
	function (key, dict) {
		var _v0 = A2($elm$core$Dict$get, key, dict);
		if (_v0.$ === 'Just') {
			return true;
		} else {
			return false;
		}
	});
var $elm$core$Set$member = F2(
	function (key, _v0) {
		var dict = _v0.a;
		return A2($elm$core$Dict$member, key, dict);
	});
var $elm$core$Set$Set_elm_builtin = function (a) {
	return {$: 'Set_elm_builtin', a: a};
};
var $elm$core$Set$empty = $elm$core$Set$Set_elm_builtin($elm$core$Dict$empty);
var $elm$core$Set$insert = F2(
	function (key, _v0) {
		var dict = _v0.a;
		return $elm$core$Set$Set_elm_builtin(
			A3($elm$core$Dict$insert, key, _Utils_Tuple0, dict));
	});
var $elm$core$Set$fromList = function (list) {
	return A3($elm$core$List$foldl, $elm$core$Set$insert, $elm$core$Set$empty, list);
};
var $enkidatron$elm_cldr$Internal$Parse$unsupportedKeys = $elm$core$Set$fromList(
	_List_fromArray(
		['MMMMW-count-zero', 'MMMMW-count-one', 'MMMMW-count-two', 'MMMMW-count-few', 'MMMMW-count-many', 'MMMMW-count-other', 'MEd-alt-variant', 'Md-alt-variant', 'MMdd-alt-variant', 'yQ', 'yQQQ', 'yQQQQ', 'yMEd-alt-variant', 'yMd-alt-variant', 'yw-count-zero', 'yw-count-one', 'yw-count-two', 'yw-count-few', 'yw-count-many', 'yw-count-other']));
var $enkidatron$elm_cldr$Internal$Parse$isSupportedKey = function (key) {
	return (!A2($elm$core$Set$member, key, $enkidatron$elm_cldr$Internal$Parse$unsupportedKeys)) && (!A2($elm$core$String$endsWith, '-alt-ascii', key));
};
var $enkidatron$elm_cldr$Internal$Locale$DateAF = function (a) {
	return {$: 'DateAF', a: a};
};
var $enkidatron$elm_cldr$Internal$Locale$DateTimeAF = function (a) {
	return {$: 'DateTimeAF', a: a};
};
var $enkidatron$elm_cldr$Internal$Locale$TimeAF = function (a) {
	return {$: 'TimeAF', a: a};
};
var $enkidatron$elm_cldr$Internal$FormatSymbols$Abbreviated = {$: 'Abbreviated'};
var $enkidatron$elm_cldr$Internal$FormatSymbols$Day = function (a) {
	return {$: 'Day', a: a};
};
var $enkidatron$elm_cldr$Internal$FormatSymbols$Era = function (a) {
	return {$: 'Era', a: a};
};
var $enkidatron$elm_cldr$Internal$FormatSymbols$Month = function (a) {
	return {$: 'Month', a: a};
};
var $enkidatron$elm_cldr$Internal$FormatSymbols$MonthStandalone = function (a) {
	return {$: 'MonthStandalone', a: a};
};
var $enkidatron$elm_cldr$Internal$FormatSymbols$Narrow = {$: 'Narrow'};
var $enkidatron$elm_cldr$Internal$FormatSymbols$Weekday = function (a) {
	return {$: 'Weekday', a: a};
};
var $enkidatron$elm_cldr$Internal$FormatSymbols$WeekdayStandalone = function (a) {
	return {$: 'WeekdayStandalone', a: a};
};
var $enkidatron$elm_cldr$Internal$FormatSymbols$Wide = {$: 'Wide'};
var $enkidatron$elm_cldr$Internal$FormatSymbols$Year = function (a) {
	return {$: 'Year', a: a};
};
var $enkidatron$elm_cldr$Internal$FormatSymbols$YearOfWeek = function (a) {
	return {$: 'YearOfWeek', a: a};
};
var $elm$parser$Parser$Advanced$Append = F2(
	function (a, b) {
		return {$: 'Append', a: a, b: b};
	});
var $elm$parser$Parser$Advanced$oneOfHelp = F3(
	function (s0, bag, parsers) {
		oneOfHelp:
		while (true) {
			if (!parsers.b) {
				return A2($elm$parser$Parser$Advanced$Bad, false, bag);
			} else {
				var parse = parsers.a.a;
				var remainingParsers = parsers.b;
				var _v1 = parse(s0);
				if (_v1.$ === 'Good') {
					var step = _v1;
					return step;
				} else {
					var step = _v1;
					var p = step.a;
					var x = step.b;
					if (p) {
						return step;
					} else {
						var $temp$s0 = s0,
							$temp$bag = A2($elm$parser$Parser$Advanced$Append, bag, x),
							$temp$parsers = remainingParsers;
						s0 = $temp$s0;
						bag = $temp$bag;
						parsers = $temp$parsers;
						continue oneOfHelp;
					}
				}
			}
		}
	});
var $elm$parser$Parser$Advanced$oneOf = function (parsers) {
	return $elm$parser$Parser$Advanced$Parser(
		function (s) {
			return A3($elm$parser$Parser$Advanced$oneOfHelp, s, $elm$parser$Parser$Advanced$Empty, parsers);
		});
};
var $elm$parser$Parser$oneOf = $elm$parser$Parser$Advanced$oneOf;
var $enkidatron$elm_cldr$Internal$FormatSymbols$MinimumDigits = {$: 'MinimumDigits'};
var $enkidatron$elm_cldr$Internal$FormatSymbols$TwoDigit = {$: 'TwoDigit'};
var $enkidatron$elm_cldr$Internal$Parse$parseWord = F2(
	function (word, item) {
		return A2(
			$elm$parser$Parser$map,
			function (_v0) {
				return item;
			},
			$elm$parser$Parser$symbol(word));
	});
var $elm$core$Bitwise$and = _Bitwise_and;
var $elm$core$Bitwise$shiftRightBy = _Bitwise_shiftRightBy;
var $elm$core$String$repeatHelp = F3(
	function (n, chunk, result) {
		return (n <= 0) ? result : A3(
			$elm$core$String$repeatHelp,
			n >> 1,
			_Utils_ap(chunk, chunk),
			(!(n & 1)) ? result : _Utils_ap(result, chunk));
	});
var $elm$core$String$repeat = F2(
	function (n, chunk) {
		return A3($elm$core$String$repeatHelp, n, chunk, '');
	});
var $enkidatron$elm_cldr$Internal$Parse$parseNumberWidth2 = F2(
	function (baseCharacter, toItem) {
		return $elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					A2(
					$enkidatron$elm_cldr$Internal$Parse$parseWord,
					A2($elm$core$String$repeat, 2, baseCharacter),
					toItem($enkidatron$elm_cldr$Internal$FormatSymbols$TwoDigit)),
					A2(
					$enkidatron$elm_cldr$Internal$Parse$parseWord,
					baseCharacter,
					toItem($enkidatron$elm_cldr$Internal$FormatSymbols$MinimumDigits))
				]));
	});
var $enkidatron$elm_cldr$Internal$Parse$parseTextWidth5 = F2(
	function (baseCharacter, toItem) {
		return $elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					A2(
					$enkidatron$elm_cldr$Internal$Parse$parseWord,
					A2($elm$core$String$repeat, 5, baseCharacter),
					toItem($enkidatron$elm_cldr$Internal$FormatSymbols$Narrow)),
					A2(
					$enkidatron$elm_cldr$Internal$Parse$parseWord,
					A2($elm$core$String$repeat, 4, baseCharacter),
					toItem($enkidatron$elm_cldr$Internal$FormatSymbols$Wide)),
					A2(
					$enkidatron$elm_cldr$Internal$Parse$parseWord,
					A2($elm$core$String$repeat, 3, baseCharacter),
					toItem($enkidatron$elm_cldr$Internal$FormatSymbols$Abbreviated)),
					A2(
					$enkidatron$elm_cldr$Internal$Parse$parseWord,
					A2($elm$core$String$repeat, 2, baseCharacter),
					toItem($enkidatron$elm_cldr$Internal$FormatSymbols$Abbreviated)),
					A2(
					$enkidatron$elm_cldr$Internal$Parse$parseWord,
					baseCharacter,
					toItem($enkidatron$elm_cldr$Internal$FormatSymbols$Abbreviated))
				]));
	});
var $enkidatron$elm_cldr$Internal$FormatSymbols$Number = function (a) {
	return {$: 'Number', a: a};
};
var $enkidatron$elm_cldr$Internal$FormatSymbols$Text = function (a) {
	return {$: 'Text', a: a};
};
var $enkidatron$elm_cldr$Internal$Parse$parseWidth5 = F2(
	function (baseCharacter, toItem) {
		return $elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					A2(
					$enkidatron$elm_cldr$Internal$Parse$parseWord,
					A2($elm$core$String$repeat, 5, baseCharacter),
					toItem(
						$enkidatron$elm_cldr$Internal$FormatSymbols$Text($enkidatron$elm_cldr$Internal$FormatSymbols$Narrow))),
					A2(
					$enkidatron$elm_cldr$Internal$Parse$parseWord,
					A2($elm$core$String$repeat, 4, baseCharacter),
					toItem(
						$enkidatron$elm_cldr$Internal$FormatSymbols$Text($enkidatron$elm_cldr$Internal$FormatSymbols$Wide))),
					A2(
					$enkidatron$elm_cldr$Internal$Parse$parseWord,
					A2($elm$core$String$repeat, 3, baseCharacter),
					toItem(
						$enkidatron$elm_cldr$Internal$FormatSymbols$Text($enkidatron$elm_cldr$Internal$FormatSymbols$Abbreviated))),
					A2(
					$enkidatron$elm_cldr$Internal$Parse$parseWord,
					A2($elm$core$String$repeat, 2, baseCharacter),
					toItem(
						$enkidatron$elm_cldr$Internal$FormatSymbols$Number($enkidatron$elm_cldr$Internal$FormatSymbols$TwoDigit))),
					A2(
					$enkidatron$elm_cldr$Internal$Parse$parseWord,
					baseCharacter,
					toItem(
						$enkidatron$elm_cldr$Internal$FormatSymbols$Number($enkidatron$elm_cldr$Internal$FormatSymbols$MinimumDigits)))
				]));
	});
var $enkidatron$elm_cldr$Internal$Parse$dateSymbolParser = $elm$parser$Parser$oneOf(
	_List_fromArray(
		[
			A2($enkidatron$elm_cldr$Internal$Parse$parseTextWidth5, 'G', $enkidatron$elm_cldr$Internal$FormatSymbols$Era),
			A2($enkidatron$elm_cldr$Internal$Parse$parseNumberWidth2, 'y', $enkidatron$elm_cldr$Internal$FormatSymbols$Year),
			A2($enkidatron$elm_cldr$Internal$Parse$parseNumberWidth2, 'Y', $enkidatron$elm_cldr$Internal$FormatSymbols$YearOfWeek),
			A2($enkidatron$elm_cldr$Internal$Parse$parseWidth5, 'M', $enkidatron$elm_cldr$Internal$FormatSymbols$Month),
			A2($enkidatron$elm_cldr$Internal$Parse$parseWidth5, 'L', $enkidatron$elm_cldr$Internal$FormatSymbols$MonthStandalone),
			A2($enkidatron$elm_cldr$Internal$Parse$parseTextWidth5, 'E', $enkidatron$elm_cldr$Internal$FormatSymbols$Weekday),
			A2(
			$enkidatron$elm_cldr$Internal$Parse$parseWord,
			'ccccc',
			$enkidatron$elm_cldr$Internal$FormatSymbols$WeekdayStandalone($enkidatron$elm_cldr$Internal$FormatSymbols$Narrow)),
			A2(
			$enkidatron$elm_cldr$Internal$Parse$parseWord,
			'cccc',
			$enkidatron$elm_cldr$Internal$FormatSymbols$WeekdayStandalone($enkidatron$elm_cldr$Internal$FormatSymbols$Wide)),
			A2(
			$enkidatron$elm_cldr$Internal$Parse$parseWord,
			'ccc',
			$enkidatron$elm_cldr$Internal$FormatSymbols$WeekdayStandalone($enkidatron$elm_cldr$Internal$FormatSymbols$Abbreviated)),
			A2($enkidatron$elm_cldr$Internal$Parse$parseNumberWidth2, 'd', $enkidatron$elm_cldr$Internal$FormatSymbols$Day)
		]));
var $enkidatron$elm_cldr$Internal$FormatSymbols$Date = function (a) {
	return {$: 'Date', a: a};
};
var $enkidatron$elm_cldr$Internal$FormatSymbols$Time = function (a) {
	return {$: 'Time', a: a};
};
var $enkidatron$elm_cldr$Internal$FormatSymbols$FlexibleDayPeriod = function (a) {
	return {$: 'FlexibleDayPeriod', a: a};
};
var $enkidatron$elm_cldr$Internal$FormatSymbols$FractionalSeconds = function (a) {
	return {$: 'FractionalSeconds', a: a};
};
var $enkidatron$elm_cldr$Internal$FormatSymbols$Hour12From0 = function (a) {
	return {$: 'Hour12From0', a: a};
};
var $enkidatron$elm_cldr$Internal$FormatSymbols$Hour12From1 = function (a) {
	return {$: 'Hour12From1', a: a};
};
var $enkidatron$elm_cldr$Internal$FormatSymbols$Hour24From0 = function (a) {
	return {$: 'Hour24From0', a: a};
};
var $enkidatron$elm_cldr$Internal$FormatSymbols$Hour24From1 = function (a) {
	return {$: 'Hour24From1', a: a};
};
var $enkidatron$elm_cldr$Internal$FormatSymbols$Long = {$: 'Long'};
var $enkidatron$elm_cldr$Internal$FormatSymbols$Minute = function (a) {
	return {$: 'Minute', a: a};
};
var $enkidatron$elm_cldr$Internal$FormatSymbols$Period = function (a) {
	return {$: 'Period', a: a};
};
var $enkidatron$elm_cldr$Internal$FormatSymbols$Second = function (a) {
	return {$: 'Second', a: a};
};
var $enkidatron$elm_cldr$Internal$FormatSymbols$Short = {$: 'Short'};
var $enkidatron$elm_cldr$Internal$FormatSymbols$ZoneGenericNonLocationFormat = function (a) {
	return {$: 'ZoneGenericNonLocationFormat', a: a};
};
var $enkidatron$elm_cldr$Internal$FormatSymbols$ZoneGmtFormat = function (a) {
	return {$: 'ZoneGmtFormat', a: a};
};
var $enkidatron$elm_cldr$Internal$FormatSymbols$ZoneIso8601Basic = {$: 'ZoneIso8601Basic'};
var $enkidatron$elm_cldr$Internal$FormatSymbols$ZoneNonLocationFormat = function (a) {
	return {$: 'ZoneNonLocationFormat', a: a};
};
var $enkidatron$elm_cldr$Internal$Parse$timeSymbolParser = $elm$parser$Parser$oneOf(
	_List_fromArray(
		[
			A2($enkidatron$elm_cldr$Internal$Parse$parseTextWidth5, 'a', $enkidatron$elm_cldr$Internal$FormatSymbols$Period),
			A2($enkidatron$elm_cldr$Internal$Parse$parseTextWidth5, 'B', $enkidatron$elm_cldr$Internal$FormatSymbols$FlexibleDayPeriod),
			A2($enkidatron$elm_cldr$Internal$Parse$parseNumberWidth2, 'h', $enkidatron$elm_cldr$Internal$FormatSymbols$Hour12From1),
			A2($enkidatron$elm_cldr$Internal$Parse$parseNumberWidth2, 'H', $enkidatron$elm_cldr$Internal$FormatSymbols$Hour24From0),
			A2($enkidatron$elm_cldr$Internal$Parse$parseNumberWidth2, 'K', $enkidatron$elm_cldr$Internal$FormatSymbols$Hour12From0),
			A2($enkidatron$elm_cldr$Internal$Parse$parseNumberWidth2, 'k', $enkidatron$elm_cldr$Internal$FormatSymbols$Hour24From1),
			A2($enkidatron$elm_cldr$Internal$Parse$parseNumberWidth2, 'm', $enkidatron$elm_cldr$Internal$FormatSymbols$Minute),
			A2($enkidatron$elm_cldr$Internal$Parse$parseNumberWidth2, 's', $enkidatron$elm_cldr$Internal$FormatSymbols$Second),
			A2(
			$enkidatron$elm_cldr$Internal$Parse$parseWord,
			'SSS',
			$enkidatron$elm_cldr$Internal$FormatSymbols$FractionalSeconds(3)),
			A2(
			$enkidatron$elm_cldr$Internal$Parse$parseWord,
			'SS',
			$enkidatron$elm_cldr$Internal$FormatSymbols$FractionalSeconds(2)),
			A2(
			$enkidatron$elm_cldr$Internal$Parse$parseWord,
			'S',
			$enkidatron$elm_cldr$Internal$FormatSymbols$FractionalSeconds(1)),
			A2(
			$enkidatron$elm_cldr$Internal$Parse$parseWord,
			'zzzz',
			$enkidatron$elm_cldr$Internal$FormatSymbols$ZoneNonLocationFormat($enkidatron$elm_cldr$Internal$FormatSymbols$Long)),
			A2(
			$enkidatron$elm_cldr$Internal$Parse$parseWord,
			'zzz',
			$enkidatron$elm_cldr$Internal$FormatSymbols$ZoneNonLocationFormat($enkidatron$elm_cldr$Internal$FormatSymbols$Short)),
			A2(
			$enkidatron$elm_cldr$Internal$Parse$parseWord,
			'zz',
			$enkidatron$elm_cldr$Internal$FormatSymbols$ZoneNonLocationFormat($enkidatron$elm_cldr$Internal$FormatSymbols$Short)),
			A2(
			$enkidatron$elm_cldr$Internal$Parse$parseWord,
			'z',
			$enkidatron$elm_cldr$Internal$FormatSymbols$ZoneNonLocationFormat($enkidatron$elm_cldr$Internal$FormatSymbols$Short)),
			A2($enkidatron$elm_cldr$Internal$Parse$parseWord, 'Z', $enkidatron$elm_cldr$Internal$FormatSymbols$ZoneIso8601Basic),
			A2(
			$enkidatron$elm_cldr$Internal$Parse$parseWord,
			'OOOO',
			$enkidatron$elm_cldr$Internal$FormatSymbols$ZoneGmtFormat($enkidatron$elm_cldr$Internal$FormatSymbols$Long)),
			A2(
			$enkidatron$elm_cldr$Internal$Parse$parseWord,
			'O',
			$enkidatron$elm_cldr$Internal$FormatSymbols$ZoneGmtFormat($enkidatron$elm_cldr$Internal$FormatSymbols$Short)),
			A2(
			$enkidatron$elm_cldr$Internal$Parse$parseWord,
			'vvvv',
			$enkidatron$elm_cldr$Internal$FormatSymbols$ZoneGenericNonLocationFormat($enkidatron$elm_cldr$Internal$FormatSymbols$Long)),
			A2(
			$enkidatron$elm_cldr$Internal$Parse$parseWord,
			'v',
			$enkidatron$elm_cldr$Internal$FormatSymbols$ZoneGenericNonLocationFormat($enkidatron$elm_cldr$Internal$FormatSymbols$Short))
		]));
var $enkidatron$elm_cldr$Internal$Parse$formatSymbolParser = $elm$parser$Parser$oneOf(
	_List_fromArray(
		[
			A2($elm$parser$Parser$map, $enkidatron$elm_cldr$Internal$FormatSymbols$Date, $enkidatron$elm_cldr$Internal$Parse$dateSymbolParser),
			A2($elm$parser$Parser$map, $enkidatron$elm_cldr$Internal$FormatSymbols$Time, $enkidatron$elm_cldr$Internal$Parse$timeSymbolParser)
		]));
var $enkidatron$elm_cldr$Internal$Options$DateSet = function (a) {
	return {$: 'DateSet', a: a};
};
var $enkidatron$elm_cldr$Internal$Options$DateTimeSet = function (a) {
	return {$: 'DateTimeSet', a: a};
};
var $enkidatron$elm_cldr$Internal$Options$EmptySet = {$: 'EmptySet'};
var $enkidatron$elm_cldr$Internal$Options$TimeSet = function (a) {
	return {$: 'TimeSet', a: a};
};
var $enkidatron$elm_cldr$Internal$Options$dateSubset = function (opts) {
	return {day: opts.day, era: opts.era, month: opts.month, weekday: opts.weekday, year: opts.year};
};
var $enkidatron$elm_cldr$Internal$Options$hasDateFields = function (opts) {
	return A2(
		$elm$core$List$any,
		$elm$core$Basics$identity,
		_List_fromArray(
			[
				!_Utils_eq(opts.era, $elm$core$Maybe$Nothing),
				!_Utils_eq(opts.year, $elm$core$Maybe$Nothing),
				!_Utils_eq(opts.month, $elm$core$Maybe$Nothing),
				!_Utils_eq(opts.day, $elm$core$Maybe$Nothing),
				!_Utils_eq(opts.weekday, $elm$core$Maybe$Nothing)
			]));
};
var $enkidatron$elm_cldr$Internal$Options$hasTimeFields = function (opts) {
	return A2(
		$elm$core$List$any,
		$elm$core$Basics$identity,
		_List_fromArray(
			[
				!_Utils_eq(opts.period, $elm$core$Maybe$Nothing),
				!_Utils_eq(opts.hour, $elm$core$Maybe$Nothing),
				!_Utils_eq(opts.minute, $elm$core$Maybe$Nothing),
				!_Utils_eq(opts.second, $elm$core$Maybe$Nothing),
				!_Utils_eq(opts.fractionalSecondDigits, $elm$core$Maybe$Nothing),
				!_Utils_eq(opts.zone, $elm$core$Maybe$Nothing)
			]));
};
var $enkidatron$elm_cldr$Internal$Options$timeSubset = function (opts) {
	return {dayPeriod: opts.dayPeriod, fractionalSecondDigits: opts.fractionalSecondDigits, hour: opts.hour, hour12: opts.hour12, minute: opts.minute, period: opts.period, second: opts.second, zone: opts.zone};
};
var $enkidatron$elm_cldr$Internal$Options$shrinkOptions = function (opts) {
	var _v0 = _Utils_Tuple2(
		$enkidatron$elm_cldr$Internal$Options$hasDateFields(opts),
		$enkidatron$elm_cldr$Internal$Options$hasTimeFields(opts));
	if (_v0.a) {
		if (_v0.b) {
			return $enkidatron$elm_cldr$Internal$Options$DateTimeSet(opts);
		} else {
			return $enkidatron$elm_cldr$Internal$Options$DateSet(
				$enkidatron$elm_cldr$Internal$Options$dateSubset(opts));
		}
	} else {
		if (_v0.b) {
			return $enkidatron$elm_cldr$Internal$Options$TimeSet(
				$enkidatron$elm_cldr$Internal$Options$timeSubset(opts));
		} else {
			return $enkidatron$elm_cldr$Internal$Options$EmptySet;
		}
	}
};
var $elm$parser$Parser$Optional = {$: 'Optional'};
var $elm$parser$Parser$Advanced$revAlways = F2(
	function (_v0, b) {
		return b;
	});
var $elm$parser$Parser$Advanced$skip = F2(
	function (iParser, kParser) {
		return A3($elm$parser$Parser$Advanced$map2, $elm$parser$Parser$Advanced$revAlways, iParser, kParser);
	});
var $elm$parser$Parser$Advanced$sequenceEndForbidden = F5(
	function (ender, ws, parseItem, sep, revItems) {
		var chompRest = function (item) {
			return A5(
				$elm$parser$Parser$Advanced$sequenceEndForbidden,
				ender,
				ws,
				parseItem,
				sep,
				A2($elm$core$List$cons, item, revItems));
		};
		return A2(
			$elm$parser$Parser$Advanced$skip,
			ws,
			$elm$parser$Parser$Advanced$oneOf(
				_List_fromArray(
					[
						A2(
						$elm$parser$Parser$Advanced$skip,
						sep,
						A2(
							$elm$parser$Parser$Advanced$skip,
							ws,
							A2(
								$elm$parser$Parser$Advanced$map,
								function (item) {
									return $elm$parser$Parser$Advanced$Loop(
										A2($elm$core$List$cons, item, revItems));
								},
								parseItem))),
						A2(
						$elm$parser$Parser$Advanced$map,
						function (_v0) {
							return $elm$parser$Parser$Advanced$Done(
								$elm$core$List$reverse(revItems));
						},
						ender)
					])));
	});
var $elm$parser$Parser$Advanced$sequenceEndMandatory = F4(
	function (ws, parseItem, sep, revItems) {
		return $elm$parser$Parser$Advanced$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$parser$Parser$Advanced$map,
					function (item) {
						return $elm$parser$Parser$Advanced$Loop(
							A2($elm$core$List$cons, item, revItems));
					},
					A2(
						$elm$parser$Parser$Advanced$ignorer,
						parseItem,
						A2(
							$elm$parser$Parser$Advanced$ignorer,
							ws,
							A2($elm$parser$Parser$Advanced$ignorer, sep, ws)))),
					A2(
					$elm$parser$Parser$Advanced$map,
					function (_v0) {
						return $elm$parser$Parser$Advanced$Done(
							$elm$core$List$reverse(revItems));
					},
					$elm$parser$Parser$Advanced$succeed(_Utils_Tuple0))
				]));
	});
var $elm$parser$Parser$Advanced$sequenceEndOptional = F5(
	function (ender, ws, parseItem, sep, revItems) {
		var parseEnd = A2(
			$elm$parser$Parser$Advanced$map,
			function (_v0) {
				return $elm$parser$Parser$Advanced$Done(
					$elm$core$List$reverse(revItems));
			},
			ender);
		return A2(
			$elm$parser$Parser$Advanced$skip,
			ws,
			$elm$parser$Parser$Advanced$oneOf(
				_List_fromArray(
					[
						A2(
						$elm$parser$Parser$Advanced$skip,
						sep,
						A2(
							$elm$parser$Parser$Advanced$skip,
							ws,
							$elm$parser$Parser$Advanced$oneOf(
								_List_fromArray(
									[
										A2(
										$elm$parser$Parser$Advanced$map,
										function (item) {
											return $elm$parser$Parser$Advanced$Loop(
												A2($elm$core$List$cons, item, revItems));
										},
										parseItem),
										parseEnd
									])))),
						parseEnd
					])));
	});
var $elm$parser$Parser$Advanced$sequenceEnd = F5(
	function (ender, ws, parseItem, sep, trailing) {
		var chompRest = function (item) {
			switch (trailing.$) {
				case 'Forbidden':
					return A2(
						$elm$parser$Parser$Advanced$loop,
						_List_fromArray(
							[item]),
						A4($elm$parser$Parser$Advanced$sequenceEndForbidden, ender, ws, parseItem, sep));
				case 'Optional':
					return A2(
						$elm$parser$Parser$Advanced$loop,
						_List_fromArray(
							[item]),
						A4($elm$parser$Parser$Advanced$sequenceEndOptional, ender, ws, parseItem, sep));
				default:
					return A2(
						$elm$parser$Parser$Advanced$ignorer,
						A2(
							$elm$parser$Parser$Advanced$skip,
							ws,
							A2(
								$elm$parser$Parser$Advanced$skip,
								sep,
								A2(
									$elm$parser$Parser$Advanced$skip,
									ws,
									A2(
										$elm$parser$Parser$Advanced$loop,
										_List_fromArray(
											[item]),
										A3($elm$parser$Parser$Advanced$sequenceEndMandatory, ws, parseItem, sep))))),
						ender);
			}
		};
		return $elm$parser$Parser$Advanced$oneOf(
			_List_fromArray(
				[
					A2($elm$parser$Parser$Advanced$andThen, chompRest, parseItem),
					A2(
					$elm$parser$Parser$Advanced$map,
					function (_v0) {
						return _List_Nil;
					},
					ender)
				]));
	});
var $elm$parser$Parser$Advanced$sequence = function (i) {
	return A2(
		$elm$parser$Parser$Advanced$skip,
		$elm$parser$Parser$Advanced$token(i.start),
		A2(
			$elm$parser$Parser$Advanced$skip,
			i.spaces,
			A5(
				$elm$parser$Parser$Advanced$sequenceEnd,
				$elm$parser$Parser$Advanced$token(i.end),
				i.spaces,
				i.item,
				$elm$parser$Parser$Advanced$token(i.separator),
				i.trailing)));
};
var $elm$parser$Parser$Advanced$Forbidden = {$: 'Forbidden'};
var $elm$parser$Parser$Advanced$Mandatory = {$: 'Mandatory'};
var $elm$parser$Parser$Advanced$Optional = {$: 'Optional'};
var $elm$parser$Parser$toAdvancedTrailing = function (trailing) {
	switch (trailing.$) {
		case 'Forbidden':
			return $elm$parser$Parser$Advanced$Forbidden;
		case 'Optional':
			return $elm$parser$Parser$Advanced$Optional;
		default:
			return $elm$parser$Parser$Advanced$Mandatory;
	}
};
var $elm$parser$Parser$Expecting = function (a) {
	return {$: 'Expecting', a: a};
};
var $elm$parser$Parser$toToken = function (str) {
	return A2(
		$elm$parser$Parser$Advanced$Token,
		str,
		$elm$parser$Parser$Expecting(str));
};
var $elm$parser$Parser$sequence = function (i) {
	return $elm$parser$Parser$Advanced$sequence(
		{
			end: $elm$parser$Parser$toToken(i.end),
			item: i.item,
			separator: $elm$parser$Parser$toToken(i.separator),
			spaces: i.spaces,
			start: $elm$parser$Parser$toToken(i.start),
			trailing: $elm$parser$Parser$toAdvancedTrailing(i.trailing)
		});
};
var $enkidatron$elm_cldr$Internal$Parse$symbolListParserHelper = function (innerParser) {
	return A2(
		$elm$parser$Parser$ignorer,
		$elm$parser$Parser$sequence(
			{
				end: '',
				item: innerParser,
				separator: '',
				spaces: $elm$parser$Parser$succeed(_Utils_Tuple0),
				start: '',
				trailing: $elm$parser$Parser$Optional
			}),
		$elm$parser$Parser$end);
};
var $enkidatron$elm_cldr$Internal$FormatSymbols$Literal = function (a) {
	return {$: 'Literal', a: a};
};
var $enkidatron$elm_cldr$Internal$FormatSymbols$Symbol = function (a) {
	return {$: 'Symbol', a: a};
};
var $elm$parser$Parser$Advanced$findSubString = _Parser_findSubString;
var $elm$parser$Parser$Advanced$chompUntil = function (_v0) {
	var str = _v0.a;
	var expecting = _v0.b;
	return $elm$parser$Parser$Advanced$Parser(
		function (s) {
			var _v1 = A5($elm$parser$Parser$Advanced$findSubString, str, s.offset, s.row, s.col, s.src);
			var newOffset = _v1.a;
			var newRow = _v1.b;
			var newCol = _v1.c;
			return _Utils_eq(newOffset, -1) ? A2(
				$elm$parser$Parser$Advanced$Bad,
				false,
				A4($elm$parser$Parser$Advanced$fromInfo, newRow, newCol, expecting, s.context)) : A3(
				$elm$parser$Parser$Advanced$Good,
				_Utils_cmp(s.offset, newOffset) < 0,
				_Utils_Tuple0,
				{col: newCol, context: s.context, indent: s.indent, offset: newOffset, row: newRow, src: s.src});
		});
};
var $elm$parser$Parser$chompUntil = function (str) {
	return $elm$parser$Parser$Advanced$chompUntil(
		$elm$parser$Parser$toToken(str));
};
var $elm$parser$Parser$ExpectingVariable = {$: 'ExpectingVariable'};
var $elm$parser$Parser$Advanced$varHelp = F7(
	function (isGood, offset, row, col, src, indent, context) {
		varHelp:
		while (true) {
			var newOffset = A3($elm$parser$Parser$Advanced$isSubChar, isGood, offset, src);
			if (_Utils_eq(newOffset, -1)) {
				return {col: col, context: context, indent: indent, offset: offset, row: row, src: src};
			} else {
				if (_Utils_eq(newOffset, -2)) {
					var $temp$isGood = isGood,
						$temp$offset = offset + 1,
						$temp$row = row + 1,
						$temp$col = 1,
						$temp$src = src,
						$temp$indent = indent,
						$temp$context = context;
					isGood = $temp$isGood;
					offset = $temp$offset;
					row = $temp$row;
					col = $temp$col;
					src = $temp$src;
					indent = $temp$indent;
					context = $temp$context;
					continue varHelp;
				} else {
					var $temp$isGood = isGood,
						$temp$offset = newOffset,
						$temp$row = row,
						$temp$col = col + 1,
						$temp$src = src,
						$temp$indent = indent,
						$temp$context = context;
					isGood = $temp$isGood;
					offset = $temp$offset;
					row = $temp$row;
					col = $temp$col;
					src = $temp$src;
					indent = $temp$indent;
					context = $temp$context;
					continue varHelp;
				}
			}
		}
	});
var $elm$parser$Parser$Advanced$variable = function (i) {
	return $elm$parser$Parser$Advanced$Parser(
		function (s) {
			var firstOffset = A3($elm$parser$Parser$Advanced$isSubChar, i.start, s.offset, s.src);
			if (_Utils_eq(firstOffset, -1)) {
				return A2(
					$elm$parser$Parser$Advanced$Bad,
					false,
					A2($elm$parser$Parser$Advanced$fromState, s, i.expecting));
			} else {
				var s1 = _Utils_eq(firstOffset, -2) ? A7($elm$parser$Parser$Advanced$varHelp, i.inner, s.offset + 1, s.row + 1, 1, s.src, s.indent, s.context) : A7($elm$parser$Parser$Advanced$varHelp, i.inner, firstOffset, s.row, s.col + 1, s.src, s.indent, s.context);
				var name = A3($elm$core$String$slice, s.offset, s1.offset, s.src);
				return A2($elm$core$Set$member, name, i.reserved) ? A2(
					$elm$parser$Parser$Advanced$Bad,
					false,
					A2($elm$parser$Parser$Advanced$fromState, s, i.expecting)) : A3($elm$parser$Parser$Advanced$Good, true, name, s1);
			}
		});
};
var $elm$parser$Parser$variable = function (i) {
	return $elm$parser$Parser$Advanced$variable(
		{expecting: $elm$parser$Parser$ExpectingVariable, inner: i.inner, reserved: i.reserved, start: i.start});
};
var $enkidatron$elm_cldr$Internal$Parse$withLiteralParser = function (innerParser) {
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				A2($elm$parser$Parser$map, $enkidatron$elm_cldr$Internal$FormatSymbols$Symbol, innerParser),
				A2(
				$elm$parser$Parser$map,
				$enkidatron$elm_cldr$Internal$FormatSymbols$Literal,
				$elm$parser$Parser$variable(
					{
						inner: function (c) {
							return (!$elm$core$Char$isAlpha(c)) && (!_Utils_eq(
								c,
								_Utils_chr('\'')));
						},
						reserved: $elm$core$Set$empty,
						start: function (c) {
							return (!$elm$core$Char$isAlpha(c)) && (!_Utils_eq(
								c,
								_Utils_chr('\'')));
						}
					})),
				A2(
				$elm$parser$Parser$keeper,
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed($enkidatron$elm_cldr$Internal$FormatSymbols$Literal),
					$elm$parser$Parser$symbol('\'')),
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$getChompedString(
						$elm$parser$Parser$chompUntil('\'')),
					$elm$parser$Parser$symbol('\'')))
			]));
};
var $enkidatron$elm_cldr$Internal$Parse$availableFormatForOptions = F2(
	function (options, pattern) {
		var _v0 = $enkidatron$elm_cldr$Internal$Options$shrinkOptions(options);
		switch (_v0.$) {
			case 'DateTimeSet':
				var dtOpts = _v0.a;
				return A2(
					$elm$core$Maybe$map,
					function (symbols) {
						return $enkidatron$elm_cldr$Internal$Locale$DateTimeAF(
							{formatSymbols: symbols, options: dtOpts});
					},
					$elm$core$Result$toMaybe(
						A2(
							$elm$parser$Parser$run,
							$enkidatron$elm_cldr$Internal$Parse$symbolListParserHelper(
								$enkidatron$elm_cldr$Internal$Parse$withLiteralParser($enkidatron$elm_cldr$Internal$Parse$formatSymbolParser)),
							pattern)));
			case 'DateSet':
				var dOpts = _v0.a;
				return A2(
					$elm$core$Maybe$map,
					function (symbols) {
						return $enkidatron$elm_cldr$Internal$Locale$DateAF(
							{formatSymbols: symbols, options: dOpts});
					},
					$elm$core$Result$toMaybe(
						A2(
							$elm$parser$Parser$run,
							$enkidatron$elm_cldr$Internal$Parse$symbolListParserHelper(
								$enkidatron$elm_cldr$Internal$Parse$withLiteralParser($enkidatron$elm_cldr$Internal$Parse$dateSymbolParser)),
							pattern)));
			case 'TimeSet':
				var tOpts = _v0.a;
				return A2(
					$elm$core$Maybe$map,
					function (symbols) {
						return $enkidatron$elm_cldr$Internal$Locale$TimeAF(
							{formatSymbols: symbols, options: tOpts});
					},
					$elm$core$Result$toMaybe(
						A2(
							$elm$parser$Parser$run,
							$enkidatron$elm_cldr$Internal$Parse$symbolListParserHelper(
								$enkidatron$elm_cldr$Internal$Parse$withLiteralParser($enkidatron$elm_cldr$Internal$Parse$timeSymbolParser)),
							pattern)));
			default:
				return $elm$core$Maybe$Nothing;
		}
	});
var $elm$core$Tuple$second = function (_v0) {
	var y = _v0.b;
	return y;
};
var $enkidatron$elm_cldr$Internal$Parse$buildKeyOptions = function (era) {
	return function (year) {
		return function (month) {
			return function (weekday) {
				return function (day) {
					return function (period) {
						return function (dayPeriod) {
							return function (hourAndType) {
								return function (minute) {
									return function (second) {
										return function (zone) {
											return {
												day: day,
												dayPeriod: dayPeriod,
												era: era,
												fractionalSecondDigits: $elm$core$Maybe$Nothing,
												hour: A2($elm$core$Maybe$map, $elm$core$Tuple$first, hourAndType),
												hour12: A2($elm$core$Maybe$map, $elm$core$Tuple$second, hourAndType),
												minute: minute,
												month: month,
												period: period,
												second: second,
												weekday: weekday,
												year: year,
												zone: zone
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $enkidatron$elm_cldr$Cldr$Format$Options$Numeric = {$: 'Numeric'};
var $enkidatron$elm_cldr$Cldr$Format$Options$TwoDigit = {$: 'TwoDigit'};
var $enkidatron$elm_cldr$Internal$Parse$parseOptionalWords = function (list) {
	return $elm$parser$Parser$oneOf(
		_Utils_ap(
			A2(
				$elm$core$List$map,
				function (_v0) {
					var word = _v0.a;
					var item = _v0.b;
					return A2(
						$enkidatron$elm_cldr$Internal$Parse$parseWord,
						word,
						$elm$core$Maybe$Just(item));
				},
				list),
			_List_fromArray(
				[
					$elm$parser$Parser$succeed($elm$core$Maybe$Nothing)
				])));
};
var $enkidatron$elm_cldr$Internal$Parse$parseDay = $enkidatron$elm_cldr$Internal$Parse$parseOptionalWords(
	_List_fromArray(
		[
			_Utils_Tuple2('dd', $enkidatron$elm_cldr$Cldr$Format$Options$TwoDigit),
			_Utils_Tuple2('d', $enkidatron$elm_cldr$Cldr$Format$Options$Numeric)
		]));
var $enkidatron$elm_cldr$Cldr$Format$Options$Long = {$: 'Long'};
var $enkidatron$elm_cldr$Cldr$Format$Options$Narrow = {$: 'Narrow'};
var $enkidatron$elm_cldr$Cldr$Format$Options$Short = {$: 'Short'};
var $enkidatron$elm_cldr$Internal$Parse$parseDayPeriod = $enkidatron$elm_cldr$Internal$Parse$parseOptionalWords(
	_List_fromArray(
		[
			_Utils_Tuple2('BBBBB', $enkidatron$elm_cldr$Cldr$Format$Options$Narrow),
			_Utils_Tuple2('BBBB', $enkidatron$elm_cldr$Cldr$Format$Options$Long),
			_Utils_Tuple2('BBB', $enkidatron$elm_cldr$Cldr$Format$Options$Short),
			_Utils_Tuple2('BB', $enkidatron$elm_cldr$Cldr$Format$Options$Short),
			_Utils_Tuple2('B', $enkidatron$elm_cldr$Cldr$Format$Options$Short)
		]));
var $enkidatron$elm_cldr$Internal$Parse$parseEra = $enkidatron$elm_cldr$Internal$Parse$parseOptionalWords(
	_List_fromArray(
		[
			_Utils_Tuple2('GGGGG', $enkidatron$elm_cldr$Cldr$Format$Options$Narrow),
			_Utils_Tuple2('GGGG', $enkidatron$elm_cldr$Cldr$Format$Options$Long),
			_Utils_Tuple2('G', $enkidatron$elm_cldr$Cldr$Format$Options$Short)
		]));
var $enkidatron$elm_cldr$Cldr$Format$Options$Hour12 = {$: 'Hour12'};
var $enkidatron$elm_cldr$Cldr$Format$Options$Hour24 = {$: 'Hour24'};
var $enkidatron$elm_cldr$Internal$Parse$parseHour = $enkidatron$elm_cldr$Internal$Parse$parseOptionalWords(
	_List_fromArray(
		[
			_Utils_Tuple2(
			'hh',
			_Utils_Tuple2($enkidatron$elm_cldr$Cldr$Format$Options$TwoDigit, $enkidatron$elm_cldr$Cldr$Format$Options$Hour12)),
			_Utils_Tuple2(
			'h',
			_Utils_Tuple2($enkidatron$elm_cldr$Cldr$Format$Options$Numeric, $enkidatron$elm_cldr$Cldr$Format$Options$Hour12)),
			_Utils_Tuple2(
			'HH',
			_Utils_Tuple2($enkidatron$elm_cldr$Cldr$Format$Options$TwoDigit, $enkidatron$elm_cldr$Cldr$Format$Options$Hour24)),
			_Utils_Tuple2(
			'H',
			_Utils_Tuple2($enkidatron$elm_cldr$Cldr$Format$Options$Numeric, $enkidatron$elm_cldr$Cldr$Format$Options$Hour24))
		]));
var $enkidatron$elm_cldr$Internal$Parse$parseMinute = $enkidatron$elm_cldr$Internal$Parse$parseOptionalWords(
	_List_fromArray(
		[
			_Utils_Tuple2('mm', $enkidatron$elm_cldr$Cldr$Format$Options$TwoDigit),
			_Utils_Tuple2('m', $enkidatron$elm_cldr$Cldr$Format$Options$Numeric)
		]));
var $enkidatron$elm_cldr$Cldr$Format$Options$Number = function (a) {
	return {$: 'Number', a: a};
};
var $enkidatron$elm_cldr$Cldr$Format$Options$Text = function (a) {
	return {$: 'Text', a: a};
};
var $enkidatron$elm_cldr$Internal$Parse$parseMonth = $enkidatron$elm_cldr$Internal$Parse$parseOptionalWords(
	_List_fromArray(
		[
			_Utils_Tuple2(
			'MMMMM',
			$enkidatron$elm_cldr$Cldr$Format$Options$Text($enkidatron$elm_cldr$Cldr$Format$Options$Narrow)),
			_Utils_Tuple2(
			'MMMM',
			$enkidatron$elm_cldr$Cldr$Format$Options$Text($enkidatron$elm_cldr$Cldr$Format$Options$Long)),
			_Utils_Tuple2(
			'MMM',
			$enkidatron$elm_cldr$Cldr$Format$Options$Text($enkidatron$elm_cldr$Cldr$Format$Options$Short)),
			_Utils_Tuple2(
			'MM',
			$enkidatron$elm_cldr$Cldr$Format$Options$Number($enkidatron$elm_cldr$Cldr$Format$Options$TwoDigit)),
			_Utils_Tuple2(
			'M',
			$enkidatron$elm_cldr$Cldr$Format$Options$Number($enkidatron$elm_cldr$Cldr$Format$Options$Numeric))
		]));
var $enkidatron$elm_cldr$Internal$Parse$parsePeriod = $enkidatron$elm_cldr$Internal$Parse$parseOptionalWords(
	_List_fromArray(
		[
			_Utils_Tuple2('aaaaa', $enkidatron$elm_cldr$Cldr$Format$Options$Narrow),
			_Utils_Tuple2('aaaa', $enkidatron$elm_cldr$Cldr$Format$Options$Long),
			_Utils_Tuple2('a', $enkidatron$elm_cldr$Cldr$Format$Options$Short)
		]));
var $enkidatron$elm_cldr$Internal$Parse$parseSecond = $enkidatron$elm_cldr$Internal$Parse$parseOptionalWords(
	_List_fromArray(
		[
			_Utils_Tuple2('ss', $enkidatron$elm_cldr$Cldr$Format$Options$TwoDigit),
			_Utils_Tuple2('s', $enkidatron$elm_cldr$Cldr$Format$Options$Numeric)
		]));
var $enkidatron$elm_cldr$Internal$Parse$parseWeekday = $enkidatron$elm_cldr$Internal$Parse$parseOptionalWords(
	_List_fromArray(
		[
			_Utils_Tuple2('EEEEE', $enkidatron$elm_cldr$Cldr$Format$Options$Narrow),
			_Utils_Tuple2('EEEE', $enkidatron$elm_cldr$Cldr$Format$Options$Long),
			_Utils_Tuple2('E', $enkidatron$elm_cldr$Cldr$Format$Options$Short),
			_Utils_Tuple2('cccc', $enkidatron$elm_cldr$Cldr$Format$Options$Long)
		]));
var $enkidatron$elm_cldr$Internal$Parse$parseYear = $enkidatron$elm_cldr$Internal$Parse$parseOptionalWords(
	_List_fromArray(
		[
			_Utils_Tuple2('yy', $enkidatron$elm_cldr$Cldr$Format$Options$TwoDigit),
			_Utils_Tuple2('y', $enkidatron$elm_cldr$Cldr$Format$Options$Numeric)
		]));
var $enkidatron$elm_cldr$Cldr$Format$Options$LongName = {$: 'LongName'};
var $enkidatron$elm_cldr$Cldr$Format$Options$ShortName = {$: 'ShortName'};
var $enkidatron$elm_cldr$Internal$Parse$parseZone = $enkidatron$elm_cldr$Internal$Parse$parseOptionalWords(
	_List_fromArray(
		[
			_Utils_Tuple2('zzzz', $enkidatron$elm_cldr$Cldr$Format$Options$LongName),
			_Utils_Tuple2('z', $enkidatron$elm_cldr$Cldr$Format$Options$ShortName),
			_Utils_Tuple2('vvvv', $enkidatron$elm_cldr$Cldr$Format$Options$LongName),
			_Utils_Tuple2('v', $enkidatron$elm_cldr$Cldr$Format$Options$ShortName),
			_Utils_Tuple2('Z', $enkidatron$elm_cldr$Cldr$Format$Options$ShortName)
		]));
var $enkidatron$elm_cldr$Internal$Parse$availableFormatKeyOptionsParser = A2(
	$elm$parser$Parser$keeper,
	A2(
		$elm$parser$Parser$keeper,
		A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$keeper,
				A2(
					$elm$parser$Parser$keeper,
					A2(
						$elm$parser$Parser$keeper,
						A2(
							$elm$parser$Parser$keeper,
							A2(
								$elm$parser$Parser$keeper,
								A2(
									$elm$parser$Parser$keeper,
									A2(
										$elm$parser$Parser$keeper,
										A2(
											$elm$parser$Parser$keeper,
											$elm$parser$Parser$succeed($enkidatron$elm_cldr$Internal$Parse$buildKeyOptions),
											$enkidatron$elm_cldr$Internal$Parse$parseEra),
										$enkidatron$elm_cldr$Internal$Parse$parseYear),
									$enkidatron$elm_cldr$Internal$Parse$parseMonth),
								$enkidatron$elm_cldr$Internal$Parse$parseWeekday),
							$enkidatron$elm_cldr$Internal$Parse$parseDay),
						$enkidatron$elm_cldr$Internal$Parse$parsePeriod),
					$enkidatron$elm_cldr$Internal$Parse$parseDayPeriod),
				$enkidatron$elm_cldr$Internal$Parse$parseHour),
			$enkidatron$elm_cldr$Internal$Parse$parseMinute),
		$enkidatron$elm_cldr$Internal$Parse$parseSecond),
	A2($elm$parser$Parser$ignorer, $enkidatron$elm_cldr$Internal$Parse$parseZone, $elm$parser$Parser$end));
var $enkidatron$elm_cldr$Internal$Parse$parseOptionsFromAvailableFormatKey = $elm$parser$Parser$run($enkidatron$elm_cldr$Internal$Parse$availableFormatKeyOptionsParser);
var $enkidatron$elm_cldr$Internal$Parse$parseAvailableFormat = function (_v0) {
	var key = _v0.a;
	var pattern = _v0.b;
	return A2(
		$elm$core$Maybe$andThen,
		function (opts) {
			return A2($enkidatron$elm_cldr$Internal$Parse$availableFormatForOptions, opts, pattern);
		},
		$elm$core$Result$toMaybe(
			$enkidatron$elm_cldr$Internal$Parse$parseOptionsFromAvailableFormatKey(key)));
};
var $enkidatron$elm_cldr$Internal$Parse$availableFormatList = function (info) {
	return $elm_community$maybe_extra$Maybe$Extra$combine(
		A2(
			$elm$core$List$map,
			$enkidatron$elm_cldr$Internal$Parse$parseAvailableFormat,
			A2(
				$elm$core$List$filter,
				A2($elm$core$Basics$composeR, $elm$core$Tuple$first, $enkidatron$elm_cldr$Internal$Parse$isSupportedKey),
				info.availableFormats)));
};
var $elm$core$Maybe$map4 = F5(
	function (func, ma, mb, mc, md) {
		if (ma.$ === 'Nothing') {
			return $elm$core$Maybe$Nothing;
		} else {
			var a = ma.a;
			if (mb.$ === 'Nothing') {
				return $elm$core$Maybe$Nothing;
			} else {
				var b = mb.a;
				if (mc.$ === 'Nothing') {
					return $elm$core$Maybe$Nothing;
				} else {
					var c = mc.a;
					if (md.$ === 'Nothing') {
						return $elm$core$Maybe$Nothing;
					} else {
						var d = md.a;
						return $elm$core$Maybe$Just(
							A4(func, a, b, c, d));
					}
				}
			}
		}
	});
var $enkidatron$elm_cldr$Internal$Parse$andThenMaybePattern = F2(
	function (innerFun, pattern) {
		return A5(
			$elm$core$Maybe$map4,
			$enkidatron$elm_cldr$Internal$Structures$Patterns,
			innerFun(pattern._short),
			innerFun(pattern.medium),
			innerFun(pattern._long),
			innerFun(pattern.full));
	});
var $enkidatron$elm_cldr$Internal$Parse$dateSymbols = function (info) {
	return A2(
		$enkidatron$elm_cldr$Internal$Parse$andThenMaybePattern,
		A2(
			$elm$core$Basics$composeR,
			$elm$parser$Parser$run(
				$enkidatron$elm_cldr$Internal$Parse$symbolListParserHelper(
					$enkidatron$elm_cldr$Internal$Parse$withLiteralParser($enkidatron$elm_cldr$Internal$Parse$dateSymbolParser))),
			$elm$core$Result$toMaybe),
		info.datePatterns);
};
var $enkidatron$elm_cldr$Internal$Locale$DateGoesHere = {$: 'DateGoesHere'};
var $enkidatron$elm_cldr$Internal$Locale$Text = function (a) {
	return {$: 'Text', a: a};
};
var $enkidatron$elm_cldr$Internal$Locale$TimeGoesHere = {$: 'TimeGoesHere'};
var $enkidatron$elm_cldr$Internal$Parse$dateTimeTokenParser = $elm$parser$Parser$oneOf(
	_List_fromArray(
		[
			A2($enkidatron$elm_cldr$Internal$Parse$parseWord, '{1}', $enkidatron$elm_cldr$Internal$Locale$DateGoesHere),
			A2($enkidatron$elm_cldr$Internal$Parse$parseWord, '{0}', $enkidatron$elm_cldr$Internal$Locale$TimeGoesHere),
			A2(
			$elm$parser$Parser$map,
			$enkidatron$elm_cldr$Internal$Locale$Text,
			$elm$parser$Parser$variable(
				{
					inner: function (c) {
						return (!$elm$core$Char$isAlpha(c)) && ((!_Utils_eq(
							c,
							_Utils_chr('\''))) && (!_Utils_eq(
							c,
							_Utils_chr('{'))));
					},
					reserved: $elm$core$Set$empty,
					start: function (c) {
						return (!$elm$core$Char$isAlpha(c)) && ((!_Utils_eq(
							c,
							_Utils_chr('\''))) && (!_Utils_eq(
							c,
							_Utils_chr('{'))));
					}
				})),
			A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$ignorer,
				$elm$parser$Parser$succeed($enkidatron$elm_cldr$Internal$Locale$Text),
				$elm$parser$Parser$symbol('\'')),
			A2(
				$elm$parser$Parser$ignorer,
				$elm$parser$Parser$getChompedString(
					$elm$parser$Parser$chompUntil('\'')),
				$elm$parser$Parser$symbol('\'')))
		]));
var $enkidatron$elm_cldr$Internal$Parse$dateTimeTokens = function (info) {
	return A2(
		$enkidatron$elm_cldr$Internal$Parse$andThenMaybePattern,
		A2(
			$elm$core$Basics$composeR,
			$elm$parser$Parser$run(
				$enkidatron$elm_cldr$Internal$Parse$symbolListParserHelper($enkidatron$elm_cldr$Internal$Parse$dateTimeTokenParser)),
			$elm$core$Result$toMaybe),
		info.dateTimePatterns);
};
var $elm$core$List$maybeCons = F3(
	function (f, mx, xs) {
		var _v0 = f(mx);
		if (_v0.$ === 'Just') {
			var x = _v0.a;
			return A2($elm$core$List$cons, x, xs);
		} else {
			return xs;
		}
	});
var $elm$core$List$filterMap = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$foldr,
			$elm$core$List$maybeCons(f),
			_List_Nil,
			xs);
	});
var $elm_community$maybe_extra$Maybe$Extra$or = F2(
	function (ma, mb) {
		if (ma.$ === 'Nothing') {
			return mb;
		} else {
			return ma;
		}
	});
var $enkidatron$elm_cldr$Internal$Parse$dayPeriodRules = F2(
	function (dayPeriods, info) {
		var fullTag = A2(
			$elm$core$String$join,
			'-',
			A2(
				$elm$core$List$filterMap,
				$elm$core$Basics$identity,
				_List_fromArray(
					[
						$elm$core$Maybe$Just(info.language),
						info.script,
						info.territory,
						info.variant
					])));
		return A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm_community$maybe_extra$Maybe$Extra$or,
				A2($elm$core$Dict$get, fullTag, dayPeriods),
				A2($elm$core$Dict$get, info.language, dayPeriods)));
	});
var $enkidatron$elm_cldr$Internal$Parse$timeSymbols = function (info) {
	return A2(
		$enkidatron$elm_cldr$Internal$Parse$andThenMaybePattern,
		A2(
			$elm$core$Basics$composeR,
			$elm$parser$Parser$run(
				$enkidatron$elm_cldr$Internal$Parse$symbolListParserHelper(
					$enkidatron$elm_cldr$Internal$Parse$withLiteralParser($enkidatron$elm_cldr$Internal$Parse$timeSymbolParser))),
			$elm$core$Result$toMaybe),
		info.timePatterns);
};
var $enkidatron$elm_cldr$Internal$Locale$Root = {$: 'Root'};
var $enkidatron$elm_cldr$Internal$Locale$checkAlias = F2(
	function (aliasDict, key) {
		return A2(
			$elm$core$Maybe$withDefault,
			key,
			A2($elm$core$Dict$get, key, aliasDict));
	});
var $enkidatron$elm_cldr$Generated$Alias$lang = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2('aa-saaho', 'ssy'),
			_Utils_Tuple2('aam', 'aas'),
			_Utils_Tuple2('aar', 'aa'),
			_Utils_Tuple2('abk', 'ab'),
			_Utils_Tuple2('adp', 'dz'),
			_Utils_Tuple2('afr', 'af'),
			_Utils_Tuple2('agp', 'apf'),
			_Utils_Tuple2('ais', 'ami'),
			_Utils_Tuple2('ajp', 'apc'),
			_Utils_Tuple2('ajt', 'aeb'),
			_Utils_Tuple2('aju', 'jrb'),
			_Utils_Tuple2('aka', 'ak'),
			_Utils_Tuple2('alb', 'sq'),
			_Utils_Tuple2('als', 'sq'),
			_Utils_Tuple2('amh', 'am'),
			_Utils_Tuple2('ara', 'ar'),
			_Utils_Tuple2('arb', 'ar'),
			_Utils_Tuple2('arg', 'an'),
			_Utils_Tuple2('arm', 'hy'),
			_Utils_Tuple2('art-lojban', 'jbo'),
			_Utils_Tuple2('asd', 'snz'),
			_Utils_Tuple2('asm', 'as'),
			_Utils_Tuple2('aue', 'ktz'),
			_Utils_Tuple2('ava', 'av'),
			_Utils_Tuple2('ave', 'ae'),
			_Utils_Tuple2('aym', 'ay'),
			_Utils_Tuple2('ayr', 'ay'),
			_Utils_Tuple2('ayx', 'nun'),
			_Utils_Tuple2('aze', 'az'),
			_Utils_Tuple2('azj', 'az'),
			_Utils_Tuple2('bak', 'ba'),
			_Utils_Tuple2('bam', 'bm'),
			_Utils_Tuple2('baq', 'eu'),
			_Utils_Tuple2('baz', 'nvo'),
			_Utils_Tuple2('bcc', 'bal'),
			_Utils_Tuple2('bcl', 'bik'),
			_Utils_Tuple2('bel', 'be'),
			_Utils_Tuple2('ben', 'bn'),
			_Utils_Tuple2('bgm', 'bcg'),
			_Utils_Tuple2('bh', 'bho'),
			_Utils_Tuple2('bhk', 'fbl'),
			_Utils_Tuple2('bic', 'bir'),
			_Utils_Tuple2('bih', 'bho'),
			_Utils_Tuple2('bis', 'bi'),
			_Utils_Tuple2('bjd', 'drl'),
			_Utils_Tuple2('bjq', 'bzc'),
			_Utils_Tuple2('bkb', 'ebk'),
			_Utils_Tuple2('blg', 'iba'),
			_Utils_Tuple2('bod', 'bo'),
			_Utils_Tuple2('bos', 'bs'),
			_Utils_Tuple2('bre', 'br'),
			_Utils_Tuple2('btb', 'beb'),
			_Utils_Tuple2('bul', 'bg'),
			_Utils_Tuple2('bur', 'my'),
			_Utils_Tuple2('bxk', 'luy'),
			_Utils_Tuple2('bxr', 'bua'),
			_Utils_Tuple2('cat', 'ca'),
			_Utils_Tuple2('ccq', 'rki'),
			_Utils_Tuple2('cel-gaulish', 'xtg'),
			_Utils_Tuple2('ces', 'cs'),
			_Utils_Tuple2('cha', 'ch'),
			_Utils_Tuple2('che', 'ce'),
			_Utils_Tuple2('chi', 'zh'),
			_Utils_Tuple2('chu', 'cu'),
			_Utils_Tuple2('chv', 'cv'),
			_Utils_Tuple2('cjr', 'mom'),
			_Utils_Tuple2('cka', 'cmr'),
			_Utils_Tuple2('cld', 'syr'),
			_Utils_Tuple2('cls', 'sa'),
			_Utils_Tuple2('cmk', 'xch'),
			_Utils_Tuple2('cmn', 'zh'),
			_Utils_Tuple2('cnr', 'sr-ME'),
			_Utils_Tuple2('cor', 'kw'),
			_Utils_Tuple2('cos', 'co'),
			_Utils_Tuple2('coy', 'pij'),
			_Utils_Tuple2('cqu', 'quh'),
			_Utils_Tuple2('cre', 'cr'),
			_Utils_Tuple2('cwd', 'cr'),
			_Utils_Tuple2('cym', 'cy'),
			_Utils_Tuple2('cze', 'cs'),
			_Utils_Tuple2('daf', 'dnj'),
			_Utils_Tuple2('dan', 'da'),
			_Utils_Tuple2('dap', 'njz'),
			_Utils_Tuple2('deu', 'de'),
			_Utils_Tuple2('dgo', 'doi'),
			_Utils_Tuple2('dhd', 'mwr'),
			_Utils_Tuple2('dik', 'din'),
			_Utils_Tuple2('diq', 'zza'),
			_Utils_Tuple2('dit', 'dif'),
			_Utils_Tuple2('div', 'dv'),
			_Utils_Tuple2('djl', 'dze'),
			_Utils_Tuple2('dkl', 'aqd'),
			_Utils_Tuple2('drh', 'mn'),
			_Utils_Tuple2('drr', 'kzk'),
			_Utils_Tuple2('drw', 'fa-AF'),
			_Utils_Tuple2('dud', 'uth'),
			_Utils_Tuple2('duj', 'dwu'),
			_Utils_Tuple2('dut', 'nl'),
			_Utils_Tuple2('dwl', 'dbt'),
			_Utils_Tuple2('dzo', 'dz'),
			_Utils_Tuple2('ekk', 'et'),
			_Utils_Tuple2('ell', 'el'),
			_Utils_Tuple2('elp', 'amq'),
			_Utils_Tuple2('emk', 'man'),
			_Utils_Tuple2('en-GB-oed', 'en-GB-oxendict'),
			_Utils_Tuple2('eng', 'en'),
			_Utils_Tuple2('epo', 'eo'),
			_Utils_Tuple2('esk', 'ik'),
			_Utils_Tuple2('est', 'et'),
			_Utils_Tuple2('eus', 'eu'),
			_Utils_Tuple2('ewe', 'ee'),
			_Utils_Tuple2('fao', 'fo'),
			_Utils_Tuple2('fas', 'fa'),
			_Utils_Tuple2('fat', 'ak'),
			_Utils_Tuple2('fij', 'fj'),
			_Utils_Tuple2('fin', 'fi'),
			_Utils_Tuple2('fra', 'fr'),
			_Utils_Tuple2('fre', 'fr'),
			_Utils_Tuple2('fry', 'fy'),
			_Utils_Tuple2('fuc', 'ff'),
			_Utils_Tuple2('ful', 'ff'),
			_Utils_Tuple2('gav', 'dev'),
			_Utils_Tuple2('gaz', 'om'),
			_Utils_Tuple2('gbc', 'wny'),
			_Utils_Tuple2('gbo', 'grb'),
			_Utils_Tuple2('geo', 'ka'),
			_Utils_Tuple2('ger', 'de'),
			_Utils_Tuple2('gfx', 'vaj'),
			_Utils_Tuple2('ggn', 'gvr'),
			_Utils_Tuple2('ggo', 'esg'),
			_Utils_Tuple2('ggr', 'gtu'),
			_Utils_Tuple2('gio', 'aou'),
			_Utils_Tuple2('gla', 'gd'),
			_Utils_Tuple2('gle', 'ga'),
			_Utils_Tuple2('glg', 'gl'),
			_Utils_Tuple2('gli', 'kzk'),
			_Utils_Tuple2('glv', 'gv'),
			_Utils_Tuple2('gno', 'gon'),
			_Utils_Tuple2('gom', 'kok'),
			_Utils_Tuple2('gre', 'el'),
			_Utils_Tuple2('grn', 'gn'),
			_Utils_Tuple2('gti', 'nyc'),
			_Utils_Tuple2('gug', 'gn'),
			_Utils_Tuple2('guj', 'gu'),
			_Utils_Tuple2('guv', 'duz'),
			_Utils_Tuple2('gya', 'gba'),
			_Utils_Tuple2('hat', 'ht'),
			_Utils_Tuple2('hau', 'ha'),
			_Utils_Tuple2('hbs', 'sr-Latn'),
			_Utils_Tuple2('hdn', 'hai'),
			_Utils_Tuple2('hea', 'hmn'),
			_Utils_Tuple2('heb', 'he'),
			_Utils_Tuple2('her', 'hz'),
			_Utils_Tuple2('him', 'srx'),
			_Utils_Tuple2('hin', 'hi'),
			_Utils_Tuple2('hmo', 'ho'),
			_Utils_Tuple2('hrr', 'jal'),
			_Utils_Tuple2('hrv', 'hr'),
			_Utils_Tuple2('hun', 'hu'),
			_Utils_Tuple2('hy-arevmda', 'hyw'),
			_Utils_Tuple2('hye', 'hy'),
			_Utils_Tuple2('i-ami', 'ami'),
			_Utils_Tuple2('i-bnn', 'bnn'),
			_Utils_Tuple2('i-default', 'en-x-i-default'),
			_Utils_Tuple2('i-enochian', 'und-x-i-enochian'),
			_Utils_Tuple2('i-hak', 'hak'),
			_Utils_Tuple2('i-klingon', 'tlh'),
			_Utils_Tuple2('i-lux', 'lb'),
			_Utils_Tuple2('i-mingo', 'see-x-i-mingo'),
			_Utils_Tuple2('i-navajo', 'nv'),
			_Utils_Tuple2('i-pwn', 'pwn'),
			_Utils_Tuple2('i-tao', 'tao'),
			_Utils_Tuple2('i-tay', 'tay'),
			_Utils_Tuple2('i-tsu', 'tsu'),
			_Utils_Tuple2('ibi', 'opa'),
			_Utils_Tuple2('ibo', 'ig'),
			_Utils_Tuple2('ice', 'is'),
			_Utils_Tuple2('ido', 'io'),
			_Utils_Tuple2('iii', 'ii'),
			_Utils_Tuple2('ike', 'iu'),
			_Utils_Tuple2('iku', 'iu'),
			_Utils_Tuple2('ile', 'ie'),
			_Utils_Tuple2('ill', 'ilm'),
			_Utils_Tuple2('ilw', 'gal'),
			_Utils_Tuple2('in', 'id'),
			_Utils_Tuple2('ina', 'ia'),
			_Utils_Tuple2('ind', 'id'),
			_Utils_Tuple2('ipk', 'ik'),
			_Utils_Tuple2('isl', 'is'),
			_Utils_Tuple2('ita', 'it'),
			_Utils_Tuple2('iw', 'he'),
			_Utils_Tuple2('izi', 'eza'),
			_Utils_Tuple2('jar', 'jgk'),
			_Utils_Tuple2('jav', 'jv'),
			_Utils_Tuple2('jeg', 'oyb'),
			_Utils_Tuple2('ji', 'yi'),
			_Utils_Tuple2('jpn', 'ja'),
			_Utils_Tuple2('jw', 'jv'),
			_Utils_Tuple2('kal', 'kl'),
			_Utils_Tuple2('kan', 'kn'),
			_Utils_Tuple2('kas', 'ks'),
			_Utils_Tuple2('kat', 'ka'),
			_Utils_Tuple2('kau', 'kr'),
			_Utils_Tuple2('kaz', 'kk'),
			_Utils_Tuple2('kdv', 'zkd'),
			_Utils_Tuple2('kgc', 'tdf'),
			_Utils_Tuple2('kgd', 'ncq'),
			_Utils_Tuple2('kgh', 'kml'),
			_Utils_Tuple2('kgm', 'plu'),
			_Utils_Tuple2('khk', 'mn'),
			_Utils_Tuple2('khm', 'km'),
			_Utils_Tuple2('kik', 'ki'),
			_Utils_Tuple2('kin', 'rw'),
			_Utils_Tuple2('kir', 'ky'),
			_Utils_Tuple2('kmr', 'ku'),
			_Utils_Tuple2('knc', 'kr'),
			_Utils_Tuple2('kng', 'kg'),
			_Utils_Tuple2('koj', 'kwv'),
			_Utils_Tuple2('kom', 'kv'),
			_Utils_Tuple2('kon', 'kg'),
			_Utils_Tuple2('kor', 'ko'),
			_Utils_Tuple2('kpp', 'jkm'),
			_Utils_Tuple2('kpv', 'kv'),
			_Utils_Tuple2('krm', 'bmf'),
			_Utils_Tuple2('ktr', 'dtp'),
			_Utils_Tuple2('kua', 'kj'),
			_Utils_Tuple2('kur', 'ku'),
			_Utils_Tuple2('kvs', 'gdj'),
			_Utils_Tuple2('kwq', 'yam'),
			_Utils_Tuple2('kxe', 'tvd'),
			_Utils_Tuple2('kxl', 'kru'),
			_Utils_Tuple2('kzh', 'dgl'),
			_Utils_Tuple2('kzj', 'dtp'),
			_Utils_Tuple2('kzt', 'dtp'),
			_Utils_Tuple2('lak', 'ksp'),
			_Utils_Tuple2('lao', 'lo'),
			_Utils_Tuple2('lat', 'la'),
			_Utils_Tuple2('lav', 'lv'),
			_Utils_Tuple2('lbk', 'bnc'),
			_Utils_Tuple2('leg', 'enl'),
			_Utils_Tuple2('lii', 'raq'),
			_Utils_Tuple2('lim', 'li'),
			_Utils_Tuple2('lin', 'ln'),
			_Utils_Tuple2('lit', 'lt'),
			_Utils_Tuple2('llo', 'ngt'),
			_Utils_Tuple2('lmm', 'rmx'),
			_Utils_Tuple2('ltz', 'lb'),
			_Utils_Tuple2('lub', 'lu'),
			_Utils_Tuple2('lug', 'lg'),
			_Utils_Tuple2('lvs', 'lv'),
			_Utils_Tuple2('mac', 'mk'),
			_Utils_Tuple2('mah', 'mh'),
			_Utils_Tuple2('mal', 'ml'),
			_Utils_Tuple2('mao', 'mi'),
			_Utils_Tuple2('mar', 'mr'),
			_Utils_Tuple2('may', 'ms'),
			_Utils_Tuple2('meg', 'cir'),
			_Utils_Tuple2('mgx', 'jbk'),
			_Utils_Tuple2('mhr', 'chm'),
			_Utils_Tuple2('mkd', 'mk'),
			_Utils_Tuple2('mlg', 'mg'),
			_Utils_Tuple2('mlt', 'mt'),
			_Utils_Tuple2('mnk', 'man'),
			_Utils_Tuple2('mnt', 'wnn'),
			_Utils_Tuple2('mo', 'ro'),
			_Utils_Tuple2('mof', 'xnt'),
			_Utils_Tuple2('mol', 'ro'),
			_Utils_Tuple2('mon', 'mn'),
			_Utils_Tuple2('mri', 'mi'),
			_Utils_Tuple2('msa', 'ms'),
			_Utils_Tuple2('mst', 'mry'),
			_Utils_Tuple2('mup', 'raj'),
			_Utils_Tuple2('mwd', 'dmw'),
			_Utils_Tuple2('mwj', 'vaj'),
			_Utils_Tuple2('mya', 'my'),
			_Utils_Tuple2('myd', 'aog'),
			_Utils_Tuple2('myt', 'mry'),
			_Utils_Tuple2('nad', 'xny'),
			_Utils_Tuple2('nau', 'na'),
			_Utils_Tuple2('nav', 'nv'),
			_Utils_Tuple2('nbf', 'nru'),
			_Utils_Tuple2('nbl', 'nr'),
			_Utils_Tuple2('nbx', 'gll'),
			_Utils_Tuple2('ncp', 'kdz'),
			_Utils_Tuple2('nde', 'nd'),
			_Utils_Tuple2('ndo', 'ng'),
			_Utils_Tuple2('nep', 'ne'),
			_Utils_Tuple2('nld', 'nl'),
			_Utils_Tuple2('nln', 'azd'),
			_Utils_Tuple2('nlr', 'nrk'),
			_Utils_Tuple2('nno', 'nn'),
			_Utils_Tuple2('nns', 'nbr'),
			_Utils_Tuple2('nnx', 'ngv'),
			_Utils_Tuple2('no-bok', 'nb'),
			_Utils_Tuple2('no-bokmal', 'nb'),
			_Utils_Tuple2('no-nyn', 'nn'),
			_Utils_Tuple2('no-nynorsk', 'nn'),
			_Utils_Tuple2('nob', 'nb'),
			_Utils_Tuple2('nom', 'cbr'),
			_Utils_Tuple2('noo', 'dtd'),
			_Utils_Tuple2('nor', 'no'),
			_Utils_Tuple2('npi', 'ne'),
			_Utils_Tuple2('nts', 'pij'),
			_Utils_Tuple2('nxu', 'bpp'),
			_Utils_Tuple2('nya', 'ny'),
			_Utils_Tuple2('oci', 'oc'),
			_Utils_Tuple2('ojg', 'oj'),
			_Utils_Tuple2('oji', 'oj'),
			_Utils_Tuple2('ori', 'or'),
			_Utils_Tuple2('orm', 'om'),
			_Utils_Tuple2('ory', 'or'),
			_Utils_Tuple2('oss', 'os'),
			_Utils_Tuple2('oun', 'vaj'),
			_Utils_Tuple2('pan', 'pa'),
			_Utils_Tuple2('pat', 'kxr'),
			_Utils_Tuple2('pbu', 'ps'),
			_Utils_Tuple2('pcr', 'adx'),
			_Utils_Tuple2('per', 'fa'),
			_Utils_Tuple2('pes', 'fa'),
			_Utils_Tuple2('pli', 'pi'),
			_Utils_Tuple2('plt', 'mg'),
			_Utils_Tuple2('pmc', 'huw'),
			_Utils_Tuple2('pmk', 'crr'),
			_Utils_Tuple2('pmu', 'phr'),
			_Utils_Tuple2('pnb', 'lah'),
			_Utils_Tuple2('pol', 'pl'),
			_Utils_Tuple2('por', 'pt'),
			_Utils_Tuple2('ppa', 'bfy'),
			_Utils_Tuple2('ppr', 'lcq'),
			_Utils_Tuple2('prp', 'gu'),
			_Utils_Tuple2('prs', 'fa-AF'),
			_Utils_Tuple2('pry', 'prt'),
			_Utils_Tuple2('pus', 'ps'),
			_Utils_Tuple2('puz', 'pub'),
			_Utils_Tuple2('que', 'qu'),
			_Utils_Tuple2('quz', 'qu'),
			_Utils_Tuple2('rmr', 'emx'),
			_Utils_Tuple2('rmy', 'rom'),
			_Utils_Tuple2('roh', 'rm'),
			_Utils_Tuple2('ron', 'ro'),
			_Utils_Tuple2('rum', 'ro'),
			_Utils_Tuple2('run', 'rn'),
			_Utils_Tuple2('rus', 'ru'),
			_Utils_Tuple2('sag', 'sg'),
			_Utils_Tuple2('san', 'sa'),
			_Utils_Tuple2('sap', 'aqt'),
			_Utils_Tuple2('sca', 'hle'),
			_Utils_Tuple2('scc', 'sr'),
			_Utils_Tuple2('scr', 'hr'),
			_Utils_Tuple2('sgl', 'isk'),
			_Utils_Tuple2('sgn-BE-FR', 'sfb'),
			_Utils_Tuple2('sgn-BE-NL', 'vgt'),
			_Utils_Tuple2('sgn-BR', 'bzs'),
			_Utils_Tuple2('sgn-CH-DE', 'sgg'),
			_Utils_Tuple2('sgn-CO', 'csn'),
			_Utils_Tuple2('sgn-DE', 'gsg'),
			_Utils_Tuple2('sgn-DK', 'dsl'),
			_Utils_Tuple2('sgn-ES', 'ssp'),
			_Utils_Tuple2('sgn-FR', 'fsl'),
			_Utils_Tuple2('sgn-GB', 'bfi'),
			_Utils_Tuple2('sgn-GR', 'gss'),
			_Utils_Tuple2('sgn-IE', 'isg'),
			_Utils_Tuple2('sgn-IT', 'ise'),
			_Utils_Tuple2('sgn-JP', 'jsl'),
			_Utils_Tuple2('sgn-MX', 'mfs'),
			_Utils_Tuple2('sgn-NI', 'ncs'),
			_Utils_Tuple2('sgn-NL', 'dse'),
			_Utils_Tuple2('sgn-NO', 'nsi'),
			_Utils_Tuple2('sgn-PT', 'psr'),
			_Utils_Tuple2('sgn-SE', 'swl'),
			_Utils_Tuple2('sgn-US', 'ase'),
			_Utils_Tuple2('sgn-ZA', 'sfs'),
			_Utils_Tuple2('sh', 'sr-Latn'),
			_Utils_Tuple2('sin', 'si'),
			_Utils_Tuple2('skk', 'oyb'),
			_Utils_Tuple2('slk', 'sk'),
			_Utils_Tuple2('slo', 'sk'),
			_Utils_Tuple2('slv', 'sl'),
			_Utils_Tuple2('smd', 'kmb'),
			_Utils_Tuple2('sme', 'se'),
			_Utils_Tuple2('smo', 'sm'),
			_Utils_Tuple2('sna', 'sn'),
			_Utils_Tuple2('snb', 'iba'),
			_Utils_Tuple2('snd', 'sd'),
			_Utils_Tuple2('som', 'so'),
			_Utils_Tuple2('sot', 'st'),
			_Utils_Tuple2('spa', 'es'),
			_Utils_Tuple2('spy', 'kln'),
			_Utils_Tuple2('sqi', 'sq'),
			_Utils_Tuple2('src', 'sc'),
			_Utils_Tuple2('srd', 'sc'),
			_Utils_Tuple2('srp', 'sr'),
			_Utils_Tuple2('ssw', 'ss'),
			_Utils_Tuple2('sul', 'sgd'),
			_Utils_Tuple2('sum', 'ulw'),
			_Utils_Tuple2('sun', 'su'),
			_Utils_Tuple2('swa', 'sw'),
			_Utils_Tuple2('swc', 'sw-CD'),
			_Utils_Tuple2('swe', 'sv'),
			_Utils_Tuple2('swh', 'sw'),
			_Utils_Tuple2('szd', 'umi'),
			_Utils_Tuple2('tah', 'ty'),
			_Utils_Tuple2('tam', 'ta'),
			_Utils_Tuple2('tat', 'tt'),
			_Utils_Tuple2('tdu', 'dtp'),
			_Utils_Tuple2('tel', 'te'),
			_Utils_Tuple2('tgg', 'bjp'),
			_Utils_Tuple2('tgk', 'tg'),
			_Utils_Tuple2('tgl', 'fil'),
			_Utils_Tuple2('tha', 'th'),
			_Utils_Tuple2('thc', 'tpo'),
			_Utils_Tuple2('thw', 'ola'),
			_Utils_Tuple2('thx', 'oyb'),
			_Utils_Tuple2('tib', 'bo'),
			_Utils_Tuple2('tid', 'itd'),
			_Utils_Tuple2('tie', 'ras'),
			_Utils_Tuple2('tir', 'ti'),
			_Utils_Tuple2('tkk', 'twm'),
			_Utils_Tuple2('tl', 'fil'),
			_Utils_Tuple2('tlw', 'weo'),
			_Utils_Tuple2('tmk', 'tdg'),
			_Utils_Tuple2('tmp', 'tyj'),
			_Utils_Tuple2('tne', 'kak'),
			_Utils_Tuple2('tnf', 'fa-AF'),
			_Utils_Tuple2('ton', 'to'),
			_Utils_Tuple2('tpw', 'tpn'),
			_Utils_Tuple2('tsf', 'taj'),
			_Utils_Tuple2('tsn', 'tn'),
			_Utils_Tuple2('tso', 'ts'),
			_Utils_Tuple2('ttq', 'tmh'),
			_Utils_Tuple2('tuk', 'tk'),
			_Utils_Tuple2('tur', 'tr'),
			_Utils_Tuple2('tw', 'ak'),
			_Utils_Tuple2('twi', 'ak'),
			_Utils_Tuple2('uig', 'ug'),
			_Utils_Tuple2('ukr', 'uk'),
			_Utils_Tuple2('umu', 'del'),
			_Utils_Tuple2('und-aaland', 'und-AX'),
			_Utils_Tuple2('und-arevela', 'und'),
			_Utils_Tuple2('und-arevmda', 'und'),
			_Utils_Tuple2('und-bokmal', 'und'),
			_Utils_Tuple2('und-hakka', 'und'),
			_Utils_Tuple2('und-hepburn-heploc', 'und-alalc97'),
			_Utils_Tuple2('und-lojban', 'und'),
			_Utils_Tuple2('und-nynorsk', 'und'),
			_Utils_Tuple2('und-saaho', 'und'),
			_Utils_Tuple2('und-xiang', 'und'),
			_Utils_Tuple2('unp', 'wro'),
			_Utils_Tuple2('uok', 'ema'),
			_Utils_Tuple2('urd', 'ur'),
			_Utils_Tuple2('uzb', 'uz'),
			_Utils_Tuple2('uzn', 'uz'),
			_Utils_Tuple2('ven', 've'),
			_Utils_Tuple2('vie', 'vi'),
			_Utils_Tuple2('vol', 'vo'),
			_Utils_Tuple2('wel', 'cy'),
			_Utils_Tuple2('wgw', 'wgb'),
			_Utils_Tuple2('wit', 'nol'),
			_Utils_Tuple2('wiw', 'nwo'),
			_Utils_Tuple2('wln', 'wa'),
			_Utils_Tuple2('wol', 'wo'),
			_Utils_Tuple2('xba', 'cax'),
			_Utils_Tuple2('xho', 'xh'),
			_Utils_Tuple2('xia', 'acn'),
			_Utils_Tuple2('xkh', 'waw'),
			_Utils_Tuple2('xpe', 'kpe'),
			_Utils_Tuple2('xrq', 'dmw'),
			_Utils_Tuple2('xsj', 'suj'),
			_Utils_Tuple2('xsl', 'den'),
			_Utils_Tuple2('xss', 'zko'),
			_Utils_Tuple2('ybd', 'rki'),
			_Utils_Tuple2('ydd', 'yi'),
			_Utils_Tuple2('yen', 'ynq'),
			_Utils_Tuple2('yid', 'yi'),
			_Utils_Tuple2('yiy', 'yrm'),
			_Utils_Tuple2('yma', 'lrr'),
			_Utils_Tuple2('ymt', 'mtm'),
			_Utils_Tuple2('yor', 'yo'),
			_Utils_Tuple2('yos', 'zom'),
			_Utils_Tuple2('yuu', 'yug'),
			_Utils_Tuple2('zai', 'zap'),
			_Utils_Tuple2('zh-cmn', 'zh'),
			_Utils_Tuple2('zh-cmn-Hans', 'zh-Hans'),
			_Utils_Tuple2('zh-cmn-Hant', 'zh-Hant'),
			_Utils_Tuple2('zh-gan', 'gan'),
			_Utils_Tuple2('zh-guoyu', 'zh'),
			_Utils_Tuple2('zh-hakka', 'hak'),
			_Utils_Tuple2('zh-min', 'nan-x-zh-min'),
			_Utils_Tuple2('zh-min-nan', 'nan'),
			_Utils_Tuple2('zh-wuu', 'wuu'),
			_Utils_Tuple2('zh-xiang', 'hsn'),
			_Utils_Tuple2('zh-yue', 'yue'),
			_Utils_Tuple2('zha', 'za'),
			_Utils_Tuple2('zho', 'zh'),
			_Utils_Tuple2('zir', 'scv'),
			_Utils_Tuple2('zkb', 'kjh'),
			_Utils_Tuple2('zsm', 'ms'),
			_Utils_Tuple2('zul', 'zu'),
			_Utils_Tuple2('zyb', 'za')
		]));
var $joneshf$elm_tagged$Tagged$map = F2(
	function (f, _v0) {
		var x = _v0.a;
		return $joneshf$elm_tagged$Tagged$Tagged(
			f(x));
	});
var $elm$core$String$toLower = _String_toLower;
var $enkidatron$elm_cldr$Internal$Locale$normalizeLang = function () {
	var helper = function (inner) {
		return A2(
			$enkidatron$elm_cldr$Internal$Locale$checkAlias,
			$enkidatron$elm_cldr$Generated$Alias$lang,
			$elm$core$String$toLower(inner));
	};
	return $joneshf$elm_tagged$Tagged$map(helper);
}();
var $enkidatron$elm_cldr$Generated$Alias$region = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2('004', 'AF'),
			_Utils_Tuple2('008', 'AL'),
			_Utils_Tuple2('010', 'AQ'),
			_Utils_Tuple2('012', 'DZ'),
			_Utils_Tuple2('016', 'AS'),
			_Utils_Tuple2('020', 'AD'),
			_Utils_Tuple2('024', 'AO'),
			_Utils_Tuple2('028', 'AG'),
			_Utils_Tuple2('031', 'AZ'),
			_Utils_Tuple2('032', 'AR'),
			_Utils_Tuple2('036', 'AU'),
			_Utils_Tuple2('040', 'AT'),
			_Utils_Tuple2('044', 'BS'),
			_Utils_Tuple2('048', 'BH'),
			_Utils_Tuple2('050', 'BD'),
			_Utils_Tuple2('051', 'AM'),
			_Utils_Tuple2('052', 'BB'),
			_Utils_Tuple2('056', 'BE'),
			_Utils_Tuple2('060', 'BM'),
			_Utils_Tuple2('062', '034 143'),
			_Utils_Tuple2('064', 'BT'),
			_Utils_Tuple2('068', 'BO'),
			_Utils_Tuple2('070', 'BA'),
			_Utils_Tuple2('072', 'BW'),
			_Utils_Tuple2('074', 'BV'),
			_Utils_Tuple2('076', 'BR'),
			_Utils_Tuple2('084', 'BZ'),
			_Utils_Tuple2('086', 'IO'),
			_Utils_Tuple2('090', 'SB'),
			_Utils_Tuple2('092', 'VG'),
			_Utils_Tuple2('096', 'BN'),
			_Utils_Tuple2('100', 'BG'),
			_Utils_Tuple2('104', 'MM'),
			_Utils_Tuple2('108', 'BI'),
			_Utils_Tuple2('112', 'BY'),
			_Utils_Tuple2('116', 'KH'),
			_Utils_Tuple2('120', 'CM'),
			_Utils_Tuple2('124', 'CA'),
			_Utils_Tuple2('132', 'CV'),
			_Utils_Tuple2('136', 'KY'),
			_Utils_Tuple2('140', 'CF'),
			_Utils_Tuple2('144', 'LK'),
			_Utils_Tuple2('148', 'TD'),
			_Utils_Tuple2('152', 'CL'),
			_Utils_Tuple2('156', 'CN'),
			_Utils_Tuple2('158', 'TW'),
			_Utils_Tuple2('162', 'CX'),
			_Utils_Tuple2('166', 'CC'),
			_Utils_Tuple2('170', 'CO'),
			_Utils_Tuple2('172', 'RU AM AZ BY GE KG KZ MD TJ TM UA UZ'),
			_Utils_Tuple2('174', 'KM'),
			_Utils_Tuple2('175', 'YT'),
			_Utils_Tuple2('178', 'CG'),
			_Utils_Tuple2('180', 'CD'),
			_Utils_Tuple2('184', 'CK'),
			_Utils_Tuple2('188', 'CR'),
			_Utils_Tuple2('191', 'HR'),
			_Utils_Tuple2('192', 'CU'),
			_Utils_Tuple2('196', 'CY'),
			_Utils_Tuple2('200', 'CZ SK'),
			_Utils_Tuple2('203', 'CZ'),
			_Utils_Tuple2('204', 'BJ'),
			_Utils_Tuple2('208', 'DK'),
			_Utils_Tuple2('212', 'DM'),
			_Utils_Tuple2('214', 'DO'),
			_Utils_Tuple2('218', 'EC'),
			_Utils_Tuple2('222', 'SV'),
			_Utils_Tuple2('226', 'GQ'),
			_Utils_Tuple2('230', 'ET'),
			_Utils_Tuple2('231', 'ET'),
			_Utils_Tuple2('232', 'ER'),
			_Utils_Tuple2('233', 'EE'),
			_Utils_Tuple2('234', 'FO'),
			_Utils_Tuple2('238', 'FK'),
			_Utils_Tuple2('239', 'GS'),
			_Utils_Tuple2('242', 'FJ'),
			_Utils_Tuple2('246', 'FI'),
			_Utils_Tuple2('248', 'AX'),
			_Utils_Tuple2('249', 'FR'),
			_Utils_Tuple2('250', 'FR'),
			_Utils_Tuple2('254', 'GF'),
			_Utils_Tuple2('258', 'PF'),
			_Utils_Tuple2('260', 'TF'),
			_Utils_Tuple2('262', 'DJ'),
			_Utils_Tuple2('266', 'GA'),
			_Utils_Tuple2('268', 'GE'),
			_Utils_Tuple2('270', 'GM'),
			_Utils_Tuple2('275', 'PS'),
			_Utils_Tuple2('276', 'DE'),
			_Utils_Tuple2('278', 'DE'),
			_Utils_Tuple2('280', 'DE'),
			_Utils_Tuple2('288', 'GH'),
			_Utils_Tuple2('292', 'GI'),
			_Utils_Tuple2('296', 'KI'),
			_Utils_Tuple2('300', 'GR'),
			_Utils_Tuple2('304', 'GL'),
			_Utils_Tuple2('308', 'GD'),
			_Utils_Tuple2('312', 'GP'),
			_Utils_Tuple2('316', 'GU'),
			_Utils_Tuple2('320', 'GT'),
			_Utils_Tuple2('324', 'GN'),
			_Utils_Tuple2('328', 'GY'),
			_Utils_Tuple2('332', 'HT'),
			_Utils_Tuple2('334', 'HM'),
			_Utils_Tuple2('336', 'VA'),
			_Utils_Tuple2('340', 'HN'),
			_Utils_Tuple2('344', 'HK'),
			_Utils_Tuple2('348', 'HU'),
			_Utils_Tuple2('352', 'IS'),
			_Utils_Tuple2('356', 'IN'),
			_Utils_Tuple2('360', 'ID'),
			_Utils_Tuple2('364', 'IR'),
			_Utils_Tuple2('368', 'IQ'),
			_Utils_Tuple2('372', 'IE'),
			_Utils_Tuple2('376', 'IL'),
			_Utils_Tuple2('380', 'IT'),
			_Utils_Tuple2('384', 'CI'),
			_Utils_Tuple2('388', 'JM'),
			_Utils_Tuple2('392', 'JP'),
			_Utils_Tuple2('398', 'KZ'),
			_Utils_Tuple2('400', 'JO'),
			_Utils_Tuple2('404', 'KE'),
			_Utils_Tuple2('408', 'KP'),
			_Utils_Tuple2('410', 'KR'),
			_Utils_Tuple2('414', 'KW'),
			_Utils_Tuple2('417', 'KG'),
			_Utils_Tuple2('418', 'LA'),
			_Utils_Tuple2('422', 'LB'),
			_Utils_Tuple2('426', 'LS'),
			_Utils_Tuple2('428', 'LV'),
			_Utils_Tuple2('430', 'LR'),
			_Utils_Tuple2('434', 'LY'),
			_Utils_Tuple2('438', 'LI'),
			_Utils_Tuple2('440', 'LT'),
			_Utils_Tuple2('442', 'LU'),
			_Utils_Tuple2('446', 'MO'),
			_Utils_Tuple2('450', 'MG'),
			_Utils_Tuple2('454', 'MW'),
			_Utils_Tuple2('458', 'MY'),
			_Utils_Tuple2('462', 'MV'),
			_Utils_Tuple2('466', 'ML'),
			_Utils_Tuple2('470', 'MT'),
			_Utils_Tuple2('474', 'MQ'),
			_Utils_Tuple2('478', 'MR'),
			_Utils_Tuple2('480', 'MU'),
			_Utils_Tuple2('484', 'MX'),
			_Utils_Tuple2('492', 'MC'),
			_Utils_Tuple2('496', 'MN'),
			_Utils_Tuple2('498', 'MD'),
			_Utils_Tuple2('499', 'ME'),
			_Utils_Tuple2('500', 'MS'),
			_Utils_Tuple2('504', 'MA'),
			_Utils_Tuple2('508', 'MZ'),
			_Utils_Tuple2('512', 'OM'),
			_Utils_Tuple2('516', 'NA'),
			_Utils_Tuple2('520', 'NR'),
			_Utils_Tuple2('524', 'NP'),
			_Utils_Tuple2('528', 'NL'),
			_Utils_Tuple2('530', 'CW SX BQ'),
			_Utils_Tuple2('531', 'CW'),
			_Utils_Tuple2('532', 'CW SX BQ'),
			_Utils_Tuple2('533', 'AW'),
			_Utils_Tuple2('534', 'SX'),
			_Utils_Tuple2('535', 'BQ'),
			_Utils_Tuple2('536', 'SA IQ'),
			_Utils_Tuple2('540', 'NC'),
			_Utils_Tuple2('548', 'VU'),
			_Utils_Tuple2('554', 'NZ'),
			_Utils_Tuple2('558', 'NI'),
			_Utils_Tuple2('562', 'NE'),
			_Utils_Tuple2('566', 'NG'),
			_Utils_Tuple2('570', 'NU'),
			_Utils_Tuple2('574', 'NF'),
			_Utils_Tuple2('578', 'NO'),
			_Utils_Tuple2('580', 'MP'),
			_Utils_Tuple2('581', 'UM'),
			_Utils_Tuple2('582', 'FM MH MP PW'),
			_Utils_Tuple2('583', 'FM'),
			_Utils_Tuple2('584', 'MH'),
			_Utils_Tuple2('585', 'PW'),
			_Utils_Tuple2('586', 'PK'),
			_Utils_Tuple2('591', 'PA'),
			_Utils_Tuple2('598', 'PG'),
			_Utils_Tuple2('600', 'PY'),
			_Utils_Tuple2('604', 'PE'),
			_Utils_Tuple2('608', 'PH'),
			_Utils_Tuple2('612', 'PN'),
			_Utils_Tuple2('616', 'PL'),
			_Utils_Tuple2('620', 'PT'),
			_Utils_Tuple2('624', 'GW'),
			_Utils_Tuple2('626', 'TL'),
			_Utils_Tuple2('630', 'PR'),
			_Utils_Tuple2('634', 'QA'),
			_Utils_Tuple2('638', 'RE'),
			_Utils_Tuple2('642', 'RO'),
			_Utils_Tuple2('643', 'RU'),
			_Utils_Tuple2('646', 'RW'),
			_Utils_Tuple2('652', 'BL'),
			_Utils_Tuple2('654', 'SH'),
			_Utils_Tuple2('659', 'KN'),
			_Utils_Tuple2('660', 'AI'),
			_Utils_Tuple2('662', 'LC'),
			_Utils_Tuple2('663', 'MF'),
			_Utils_Tuple2('666', 'PM'),
			_Utils_Tuple2('670', 'VC'),
			_Utils_Tuple2('674', 'SM'),
			_Utils_Tuple2('678', 'ST'),
			_Utils_Tuple2('682', 'SA'),
			_Utils_Tuple2('686', 'SN'),
			_Utils_Tuple2('688', 'RS'),
			_Utils_Tuple2('690', 'SC'),
			_Utils_Tuple2('694', 'SL'),
			_Utils_Tuple2('702', 'SG'),
			_Utils_Tuple2('703', 'SK'),
			_Utils_Tuple2('704', 'VN'),
			_Utils_Tuple2('705', 'SI'),
			_Utils_Tuple2('706', 'SO'),
			_Utils_Tuple2('710', 'ZA'),
			_Utils_Tuple2('716', 'ZW'),
			_Utils_Tuple2('720', 'YE'),
			_Utils_Tuple2('724', 'ES'),
			_Utils_Tuple2('728', 'SS'),
			_Utils_Tuple2('729', 'SD'),
			_Utils_Tuple2('732', 'EH'),
			_Utils_Tuple2('736', 'SD'),
			_Utils_Tuple2('740', 'SR'),
			_Utils_Tuple2('744', 'SJ'),
			_Utils_Tuple2('748', 'SZ'),
			_Utils_Tuple2('752', 'SE'),
			_Utils_Tuple2('756', 'CH'),
			_Utils_Tuple2('760', 'SY'),
			_Utils_Tuple2('762', 'TJ'),
			_Utils_Tuple2('764', 'TH'),
			_Utils_Tuple2('768', 'TG'),
			_Utils_Tuple2('772', 'TK'),
			_Utils_Tuple2('776', 'TO'),
			_Utils_Tuple2('780', 'TT'),
			_Utils_Tuple2('784', 'AE'),
			_Utils_Tuple2('788', 'TN'),
			_Utils_Tuple2('792', 'TR'),
			_Utils_Tuple2('795', 'TM'),
			_Utils_Tuple2('796', 'TC'),
			_Utils_Tuple2('798', 'TV'),
			_Utils_Tuple2('800', 'UG'),
			_Utils_Tuple2('804', 'UA'),
			_Utils_Tuple2('807', 'MK'),
			_Utils_Tuple2('810', 'RU AM AZ BY EE GE KZ KG LV LT MD TJ TM UA UZ'),
			_Utils_Tuple2('818', 'EG'),
			_Utils_Tuple2('826', 'GB'),
			_Utils_Tuple2('830', 'JE GG'),
			_Utils_Tuple2('831', 'GG'),
			_Utils_Tuple2('832', 'JE'),
			_Utils_Tuple2('833', 'IM'),
			_Utils_Tuple2('834', 'TZ'),
			_Utils_Tuple2('840', 'US'),
			_Utils_Tuple2('850', 'VI'),
			_Utils_Tuple2('854', 'BF'),
			_Utils_Tuple2('858', 'UY'),
			_Utils_Tuple2('860', 'UZ'),
			_Utils_Tuple2('862', 'VE'),
			_Utils_Tuple2('876', 'WF'),
			_Utils_Tuple2('882', 'WS'),
			_Utils_Tuple2('886', 'YE'),
			_Utils_Tuple2('887', 'YE'),
			_Utils_Tuple2('890', 'RS ME SI HR MK BA'),
			_Utils_Tuple2('891', 'RS ME'),
			_Utils_Tuple2('894', 'ZM'),
			_Utils_Tuple2('958', 'AA'),
			_Utils_Tuple2('959', 'QM'),
			_Utils_Tuple2('960', 'QN'),
			_Utils_Tuple2('962', 'QP'),
			_Utils_Tuple2('963', 'QQ'),
			_Utils_Tuple2('964', 'QR'),
			_Utils_Tuple2('965', 'QS'),
			_Utils_Tuple2('966', 'QT'),
			_Utils_Tuple2('967', 'EU'),
			_Utils_Tuple2('968', 'QV'),
			_Utils_Tuple2('969', 'QW'),
			_Utils_Tuple2('970', 'QX'),
			_Utils_Tuple2('971', 'QY'),
			_Utils_Tuple2('972', 'QZ'),
			_Utils_Tuple2('973', 'XA'),
			_Utils_Tuple2('974', 'XB'),
			_Utils_Tuple2('975', 'XC'),
			_Utils_Tuple2('976', 'XD'),
			_Utils_Tuple2('977', 'XE'),
			_Utils_Tuple2('978', 'XF'),
			_Utils_Tuple2('979', 'XG'),
			_Utils_Tuple2('980', 'XH'),
			_Utils_Tuple2('981', 'XI'),
			_Utils_Tuple2('982', 'XJ'),
			_Utils_Tuple2('983', 'XK'),
			_Utils_Tuple2('984', 'XL'),
			_Utils_Tuple2('985', 'XM'),
			_Utils_Tuple2('986', 'XN'),
			_Utils_Tuple2('987', 'XO'),
			_Utils_Tuple2('988', 'XP'),
			_Utils_Tuple2('989', 'XQ'),
			_Utils_Tuple2('990', 'XR'),
			_Utils_Tuple2('991', 'XS'),
			_Utils_Tuple2('992', 'XT'),
			_Utils_Tuple2('993', 'XU'),
			_Utils_Tuple2('994', 'XV'),
			_Utils_Tuple2('995', 'XW'),
			_Utils_Tuple2('996', 'XX'),
			_Utils_Tuple2('997', 'XY'),
			_Utils_Tuple2('998', 'XZ'),
			_Utils_Tuple2('999', 'ZZ'),
			_Utils_Tuple2('AAA', 'AA'),
			_Utils_Tuple2('ABW', 'AW'),
			_Utils_Tuple2('AFG', 'AF'),
			_Utils_Tuple2('AGO', 'AO'),
			_Utils_Tuple2('AIA', 'AI'),
			_Utils_Tuple2('ALA', 'AX'),
			_Utils_Tuple2('ALB', 'AL'),
			_Utils_Tuple2('AN', 'CW SX BQ'),
			_Utils_Tuple2('AND', 'AD'),
			_Utils_Tuple2('ANT', 'CW SX BQ'),
			_Utils_Tuple2('ARE', 'AE'),
			_Utils_Tuple2('ARG', 'AR'),
			_Utils_Tuple2('ARM', 'AM'),
			_Utils_Tuple2('ASC', 'AC'),
			_Utils_Tuple2('ASM', 'AS'),
			_Utils_Tuple2('ATA', 'AQ'),
			_Utils_Tuple2('ATF', 'TF'),
			_Utils_Tuple2('ATG', 'AG'),
			_Utils_Tuple2('AUS', 'AU'),
			_Utils_Tuple2('AUT', 'AT'),
			_Utils_Tuple2('AZE', 'AZ'),
			_Utils_Tuple2('BDI', 'BI'),
			_Utils_Tuple2('BEL', 'BE'),
			_Utils_Tuple2('BEN', 'BJ'),
			_Utils_Tuple2('BES', 'BQ'),
			_Utils_Tuple2('BFA', 'BF'),
			_Utils_Tuple2('BGD', 'BD'),
			_Utils_Tuple2('BGR', 'BG'),
			_Utils_Tuple2('BHR', 'BH'),
			_Utils_Tuple2('BHS', 'BS'),
			_Utils_Tuple2('BIH', 'BA'),
			_Utils_Tuple2('BLM', 'BL'),
			_Utils_Tuple2('BLR', 'BY'),
			_Utils_Tuple2('BLZ', 'BZ'),
			_Utils_Tuple2('BMU', 'BM'),
			_Utils_Tuple2('BOL', 'BO'),
			_Utils_Tuple2('BRA', 'BR'),
			_Utils_Tuple2('BRB', 'BB'),
			_Utils_Tuple2('BRN', 'BN'),
			_Utils_Tuple2('BTN', 'BT'),
			_Utils_Tuple2('BU', 'MM'),
			_Utils_Tuple2('BUR', 'MM'),
			_Utils_Tuple2('BVT', 'BV'),
			_Utils_Tuple2('BWA', 'BW'),
			_Utils_Tuple2('CAF', 'CF'),
			_Utils_Tuple2('CAN', 'CA'),
			_Utils_Tuple2('CCK', 'CC'),
			_Utils_Tuple2('CHE', 'CH'),
			_Utils_Tuple2('CHL', 'CL'),
			_Utils_Tuple2('CHN', 'CN'),
			_Utils_Tuple2('CIV', 'CI'),
			_Utils_Tuple2('CMR', 'CM'),
			_Utils_Tuple2('COD', 'CD'),
			_Utils_Tuple2('COG', 'CG'),
			_Utils_Tuple2('COK', 'CK'),
			_Utils_Tuple2('COL', 'CO'),
			_Utils_Tuple2('COM', 'KM'),
			_Utils_Tuple2('CPT', 'CP'),
			_Utils_Tuple2('CPV', 'CV'),
			_Utils_Tuple2('CRI', 'CR'),
			_Utils_Tuple2('CS', 'RS ME'),
			_Utils_Tuple2('CT', 'KI'),
			_Utils_Tuple2('CUB', 'CU'),
			_Utils_Tuple2('CUW', 'CW'),
			_Utils_Tuple2('CXR', 'CX'),
			_Utils_Tuple2('CYM', 'KY'),
			_Utils_Tuple2('CYP', 'CY'),
			_Utils_Tuple2('CZE', 'CZ'),
			_Utils_Tuple2('DD', 'DE'),
			_Utils_Tuple2('DDR', 'DE'),
			_Utils_Tuple2('DEU', 'DE'),
			_Utils_Tuple2('DGA', 'DG'),
			_Utils_Tuple2('DJI', 'DJ'),
			_Utils_Tuple2('DMA', 'DM'),
			_Utils_Tuple2('DNK', 'DK'),
			_Utils_Tuple2('DOM', 'DO'),
			_Utils_Tuple2('DY', 'BJ'),
			_Utils_Tuple2('DZA', 'DZ'),
			_Utils_Tuple2('ECU', 'EC'),
			_Utils_Tuple2('EGY', 'EG'),
			_Utils_Tuple2('ERI', 'ER'),
			_Utils_Tuple2('ESH', 'EH'),
			_Utils_Tuple2('ESP', 'ES'),
			_Utils_Tuple2('EST', 'EE'),
			_Utils_Tuple2('ETH', 'ET'),
			_Utils_Tuple2('FIN', 'FI'),
			_Utils_Tuple2('FJI', 'FJ'),
			_Utils_Tuple2('FLK', 'FK'),
			_Utils_Tuple2('FQ', 'AQ TF'),
			_Utils_Tuple2('FRA', 'FR'),
			_Utils_Tuple2('FRO', 'FO'),
			_Utils_Tuple2('FSM', 'FM'),
			_Utils_Tuple2('FX', 'FR'),
			_Utils_Tuple2('FXX', 'FR'),
			_Utils_Tuple2('GAB', 'GA'),
			_Utils_Tuple2('GBR', 'GB'),
			_Utils_Tuple2('GEO', 'GE'),
			_Utils_Tuple2('GGY', 'GG'),
			_Utils_Tuple2('GHA', 'GH'),
			_Utils_Tuple2('GIB', 'GI'),
			_Utils_Tuple2('GIN', 'GN'),
			_Utils_Tuple2('GLP', 'GP'),
			_Utils_Tuple2('GMB', 'GM'),
			_Utils_Tuple2('GNB', 'GW'),
			_Utils_Tuple2('GNQ', 'GQ'),
			_Utils_Tuple2('GRC', 'GR'),
			_Utils_Tuple2('GRD', 'GD'),
			_Utils_Tuple2('GRL', 'GL'),
			_Utils_Tuple2('GTM', 'GT'),
			_Utils_Tuple2('GUF', 'GF'),
			_Utils_Tuple2('GUM', 'GU'),
			_Utils_Tuple2('GUY', 'GY'),
			_Utils_Tuple2('HKG', 'HK'),
			_Utils_Tuple2('HMD', 'HM'),
			_Utils_Tuple2('HND', 'HN'),
			_Utils_Tuple2('HRV', 'HR'),
			_Utils_Tuple2('HTI', 'HT'),
			_Utils_Tuple2('HUN', 'HU'),
			_Utils_Tuple2('HV', 'BF'),
			_Utils_Tuple2('IDN', 'ID'),
			_Utils_Tuple2('IMN', 'IM'),
			_Utils_Tuple2('IND', 'IN'),
			_Utils_Tuple2('IOT', 'IO'),
			_Utils_Tuple2('IRL', 'IE'),
			_Utils_Tuple2('IRN', 'IR'),
			_Utils_Tuple2('IRQ', 'IQ'),
			_Utils_Tuple2('ISL', 'IS'),
			_Utils_Tuple2('ISR', 'IL'),
			_Utils_Tuple2('ITA', 'IT'),
			_Utils_Tuple2('JAM', 'JM'),
			_Utils_Tuple2('JEY', 'JE'),
			_Utils_Tuple2('JOR', 'JO'),
			_Utils_Tuple2('JPN', 'JP'),
			_Utils_Tuple2('JT', 'UM'),
			_Utils_Tuple2('KAZ', 'KZ'),
			_Utils_Tuple2('KEN', 'KE'),
			_Utils_Tuple2('KGZ', 'KG'),
			_Utils_Tuple2('KHM', 'KH'),
			_Utils_Tuple2('KIR', 'KI'),
			_Utils_Tuple2('KNA', 'KN'),
			_Utils_Tuple2('KOR', 'KR'),
			_Utils_Tuple2('KWT', 'KW'),
			_Utils_Tuple2('LAO', 'LA'),
			_Utils_Tuple2('LBN', 'LB'),
			_Utils_Tuple2('LBR', 'LR'),
			_Utils_Tuple2('LBY', 'LY'),
			_Utils_Tuple2('LCA', 'LC'),
			_Utils_Tuple2('LIE', 'LI'),
			_Utils_Tuple2('LKA', 'LK'),
			_Utils_Tuple2('LSO', 'LS'),
			_Utils_Tuple2('LTU', 'LT'),
			_Utils_Tuple2('LUX', 'LU'),
			_Utils_Tuple2('LVA', 'LV'),
			_Utils_Tuple2('MAC', 'MO'),
			_Utils_Tuple2('MAF', 'MF'),
			_Utils_Tuple2('MAR', 'MA'),
			_Utils_Tuple2('MCO', 'MC'),
			_Utils_Tuple2('MDA', 'MD'),
			_Utils_Tuple2('MDG', 'MG'),
			_Utils_Tuple2('MDV', 'MV'),
			_Utils_Tuple2('MEX', 'MX'),
			_Utils_Tuple2('MHL', 'MH'),
			_Utils_Tuple2('MI', 'UM'),
			_Utils_Tuple2('MKD', 'MK'),
			_Utils_Tuple2('MLI', 'ML'),
			_Utils_Tuple2('MLT', 'MT'),
			_Utils_Tuple2('MMR', 'MM'),
			_Utils_Tuple2('MNE', 'ME'),
			_Utils_Tuple2('MNG', 'MN'),
			_Utils_Tuple2('MNP', 'MP'),
			_Utils_Tuple2('MOZ', 'MZ'),
			_Utils_Tuple2('MRT', 'MR'),
			_Utils_Tuple2('MSR', 'MS'),
			_Utils_Tuple2('MTQ', 'MQ'),
			_Utils_Tuple2('MUS', 'MU'),
			_Utils_Tuple2('MWI', 'MW'),
			_Utils_Tuple2('MYS', 'MY'),
			_Utils_Tuple2('MYT', 'YT'),
			_Utils_Tuple2('NAM', 'NA'),
			_Utils_Tuple2('NCL', 'NC'),
			_Utils_Tuple2('NER', 'NE'),
			_Utils_Tuple2('NFK', 'NF'),
			_Utils_Tuple2('NGA', 'NG'),
			_Utils_Tuple2('NH', 'VU'),
			_Utils_Tuple2('NIC', 'NI'),
			_Utils_Tuple2('NIU', 'NU'),
			_Utils_Tuple2('NLD', 'NL'),
			_Utils_Tuple2('NOR', 'NO'),
			_Utils_Tuple2('NPL', 'NP'),
			_Utils_Tuple2('NQ', 'AQ'),
			_Utils_Tuple2('NRU', 'NR'),
			_Utils_Tuple2('NT', 'SA IQ'),
			_Utils_Tuple2('NTZ', 'SA IQ'),
			_Utils_Tuple2('NZL', 'NZ'),
			_Utils_Tuple2('OMN', 'OM'),
			_Utils_Tuple2('PAK', 'PK'),
			_Utils_Tuple2('PAN', 'PA'),
			_Utils_Tuple2('PC', 'FM MH MP PW'),
			_Utils_Tuple2('PCN', 'PN'),
			_Utils_Tuple2('PER', 'PE'),
			_Utils_Tuple2('PHL', 'PH'),
			_Utils_Tuple2('PLW', 'PW'),
			_Utils_Tuple2('PNG', 'PG'),
			_Utils_Tuple2('POL', 'PL'),
			_Utils_Tuple2('PRI', 'PR'),
			_Utils_Tuple2('PRK', 'KP'),
			_Utils_Tuple2('PRT', 'PT'),
			_Utils_Tuple2('PRY', 'PY'),
			_Utils_Tuple2('PSE', 'PS'),
			_Utils_Tuple2('PU', 'UM'),
			_Utils_Tuple2('PYF', 'PF'),
			_Utils_Tuple2('PZ', 'PA'),
			_Utils_Tuple2('QAT', 'QA'),
			_Utils_Tuple2('QMM', 'QM'),
			_Utils_Tuple2('QNN', 'QN'),
			_Utils_Tuple2('QPP', 'QP'),
			_Utils_Tuple2('QQQ', 'QQ'),
			_Utils_Tuple2('QRR', 'QR'),
			_Utils_Tuple2('QSS', 'QS'),
			_Utils_Tuple2('QTT', 'QT'),
			_Utils_Tuple2('QU', 'EU'),
			_Utils_Tuple2('QUU', 'EU'),
			_Utils_Tuple2('QVV', 'QV'),
			_Utils_Tuple2('QWW', 'QW'),
			_Utils_Tuple2('QXX', 'QX'),
			_Utils_Tuple2('QYY', 'QY'),
			_Utils_Tuple2('QZZ', 'QZ'),
			_Utils_Tuple2('REU', 'RE'),
			_Utils_Tuple2('RH', 'ZW'),
			_Utils_Tuple2('ROU', 'RO'),
			_Utils_Tuple2('RUS', 'RU'),
			_Utils_Tuple2('RWA', 'RW'),
			_Utils_Tuple2('SAU', 'SA'),
			_Utils_Tuple2('SCG', 'RS ME'),
			_Utils_Tuple2('SDN', 'SD'),
			_Utils_Tuple2('SEN', 'SN'),
			_Utils_Tuple2('SGP', 'SG'),
			_Utils_Tuple2('SGS', 'GS'),
			_Utils_Tuple2('SHN', 'SH'),
			_Utils_Tuple2('SJM', 'SJ'),
			_Utils_Tuple2('SLB', 'SB'),
			_Utils_Tuple2('SLE', 'SL'),
			_Utils_Tuple2('SLV', 'SV'),
			_Utils_Tuple2('SMR', 'SM'),
			_Utils_Tuple2('SOM', 'SO'),
			_Utils_Tuple2('SPM', 'PM'),
			_Utils_Tuple2('SRB', 'RS'),
			_Utils_Tuple2('SSD', 'SS'),
			_Utils_Tuple2('STP', 'ST'),
			_Utils_Tuple2('SU', 'RU AM AZ BY EE GE KZ KG LV LT MD TJ TM UA UZ'),
			_Utils_Tuple2('SUN', 'RU AM AZ BY EE GE KZ KG LV LT MD TJ TM UA UZ'),
			_Utils_Tuple2('SUR', 'SR'),
			_Utils_Tuple2('SVK', 'SK'),
			_Utils_Tuple2('SVN', 'SI'),
			_Utils_Tuple2('SWE', 'SE'),
			_Utils_Tuple2('SWZ', 'SZ'),
			_Utils_Tuple2('SXM', 'SX'),
			_Utils_Tuple2('SYC', 'SC'),
			_Utils_Tuple2('SYR', 'SY'),
			_Utils_Tuple2('TAA', 'TA'),
			_Utils_Tuple2('TCA', 'TC'),
			_Utils_Tuple2('TCD', 'TD'),
			_Utils_Tuple2('TGO', 'TG'),
			_Utils_Tuple2('THA', 'TH'),
			_Utils_Tuple2('TJK', 'TJ'),
			_Utils_Tuple2('TKL', 'TK'),
			_Utils_Tuple2('TKM', 'TM'),
			_Utils_Tuple2('TLS', 'TL'),
			_Utils_Tuple2('TMP', 'TL'),
			_Utils_Tuple2('TON', 'TO'),
			_Utils_Tuple2('TP', 'TL'),
			_Utils_Tuple2('TTO', 'TT'),
			_Utils_Tuple2('TUN', 'TN'),
			_Utils_Tuple2('TUR', 'TR'),
			_Utils_Tuple2('TUV', 'TV'),
			_Utils_Tuple2('TWN', 'TW'),
			_Utils_Tuple2('TZA', 'TZ'),
			_Utils_Tuple2('UGA', 'UG'),
			_Utils_Tuple2('UK', 'GB'),
			_Utils_Tuple2('UKR', 'UA'),
			_Utils_Tuple2('UMI', 'UM'),
			_Utils_Tuple2('URY', 'UY'),
			_Utils_Tuple2('USA', 'US'),
			_Utils_Tuple2('UZB', 'UZ'),
			_Utils_Tuple2('VAT', 'VA'),
			_Utils_Tuple2('VCT', 'VC'),
			_Utils_Tuple2('VD', 'VN'),
			_Utils_Tuple2('VEN', 'VE'),
			_Utils_Tuple2('VGB', 'VG'),
			_Utils_Tuple2('VIR', 'VI'),
			_Utils_Tuple2('VNM', 'VN'),
			_Utils_Tuple2('VUT', 'VU'),
			_Utils_Tuple2('WK', 'UM'),
			_Utils_Tuple2('WLF', 'WF'),
			_Utils_Tuple2('WSM', 'WS'),
			_Utils_Tuple2('XAA', 'XA'),
			_Utils_Tuple2('XBB', 'XB'),
			_Utils_Tuple2('XCC', 'XC'),
			_Utils_Tuple2('XDD', 'XD'),
			_Utils_Tuple2('XEE', 'XE'),
			_Utils_Tuple2('XFF', 'XF'),
			_Utils_Tuple2('XGG', 'XG'),
			_Utils_Tuple2('XHH', 'XH'),
			_Utils_Tuple2('XII', 'XI'),
			_Utils_Tuple2('XJJ', 'XJ'),
			_Utils_Tuple2('XKK', 'XK'),
			_Utils_Tuple2('XLL', 'XL'),
			_Utils_Tuple2('XMM', 'XM'),
			_Utils_Tuple2('XNN', 'XN'),
			_Utils_Tuple2('XOO', 'XO'),
			_Utils_Tuple2('XPP', 'XP'),
			_Utils_Tuple2('XQQ', 'XQ'),
			_Utils_Tuple2('XRR', 'XR'),
			_Utils_Tuple2('XSS', 'XS'),
			_Utils_Tuple2('XTT', 'XT'),
			_Utils_Tuple2('XUU', 'XU'),
			_Utils_Tuple2('XVV', 'XV'),
			_Utils_Tuple2('XWW', 'XW'),
			_Utils_Tuple2('XXX', 'XX'),
			_Utils_Tuple2('XYY', 'XY'),
			_Utils_Tuple2('XZZ', 'XZ'),
			_Utils_Tuple2('YD', 'YE'),
			_Utils_Tuple2('YEM', 'YE'),
			_Utils_Tuple2('YMD', 'YE'),
			_Utils_Tuple2('YU', 'RS ME'),
			_Utils_Tuple2('YUG', 'RS ME'),
			_Utils_Tuple2('ZAF', 'ZA'),
			_Utils_Tuple2('ZAR', 'CD'),
			_Utils_Tuple2('ZMB', 'ZM'),
			_Utils_Tuple2('ZR', 'CD'),
			_Utils_Tuple2('ZWE', 'ZW'),
			_Utils_Tuple2('ZZZ', 'ZZ')
		]));
var $elm$core$String$toUpper = _String_toUpper;
var $enkidatron$elm_cldr$Internal$Locale$normalizeRegion = function () {
	var helper = function (inner) {
		return A2(
			$enkidatron$elm_cldr$Internal$Locale$checkAlias,
			$enkidatron$elm_cldr$Generated$Alias$region,
			$elm$core$String$toUpper(inner));
	};
	return $joneshf$elm_tagged$Tagged$map(helper);
}();
var $enkidatron$elm_cldr$Generated$Alias$script = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2('Qaai', 'Zinh')
		]));
var $elm$regex$Regex$Match = F4(
	function (match, index, number, submatches) {
		return {index: index, match: match, number: number, submatches: submatches};
	});
var $elm$regex$Regex$fromStringWith = _Regex_fromStringWith;
var $elm$regex$Regex$fromString = function (string) {
	return A2(
		$elm$regex$Regex$fromStringWith,
		{caseInsensitive: false, multiline: false},
		string);
};
var $elm$regex$Regex$never = _Regex_never;
var $elm_community$string_extra$String$Extra$regexFromString = A2(
	$elm$core$Basics$composeR,
	$elm$regex$Regex$fromString,
	$elm$core$Maybe$withDefault($elm$regex$Regex$never));
var $elm$regex$Regex$replace = _Regex_replaceAtMost(_Regex_infinity);
var $elm$core$String$cons = _String_cons;
var $elm_community$string_extra$String$Extra$changeCase = F2(
	function (mutator, word) {
		return A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				function (_v0) {
					var head = _v0.a;
					var tail = _v0.b;
					return A2(
						$elm$core$String$cons,
						mutator(head),
						tail);
				},
				$elm$core$String$uncons(word)));
	});
var $elm$core$Char$toUpper = _Char_toUpper;
var $elm_community$string_extra$String$Extra$toSentenceCase = function (word) {
	return A2($elm_community$string_extra$String$Extra$changeCase, $elm$core$Char$toUpper, word);
};
var $elm_community$string_extra$String$Extra$toTitleCase = function (ws) {
	var uppercaseMatch = A2(
		$elm$regex$Regex$replace,
		$elm_community$string_extra$String$Extra$regexFromString('\\w+'),
		A2(
			$elm$core$Basics$composeR,
			function ($) {
				return $.match;
			},
			$elm_community$string_extra$String$Extra$toSentenceCase));
	return A3(
		$elm$regex$Regex$replace,
		$elm_community$string_extra$String$Extra$regexFromString('^([a-z])|\\s+([a-z])'),
		A2(
			$elm$core$Basics$composeR,
			function ($) {
				return $.match;
			},
			uppercaseMatch),
		ws);
};
var $enkidatron$elm_cldr$Internal$Locale$normalizeScript = function () {
	var helper = function (inner) {
		return A2(
			$enkidatron$elm_cldr$Internal$Locale$checkAlias,
			$enkidatron$elm_cldr$Generated$Alias$script,
			$elm_community$string_extra$String$Extra$toTitleCase(inner));
	};
	return $joneshf$elm_tagged$Tagged$map(helper);
}();
var $enkidatron$elm_cldr$Generated$Alias$variant = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2('heploc', 'alalc97'),
			_Utils_Tuple2('polytoni', 'polyton')
		]));
var $enkidatron$elm_cldr$Internal$Locale$normalizeVariant = function () {
	var helper = function (inner) {
		return A2(
			$enkidatron$elm_cldr$Internal$Locale$checkAlias,
			$enkidatron$elm_cldr$Generated$Alias$variant,
			$elm$core$String$toUpper(inner));
	};
	return $joneshf$elm_tagged$Tagged$map(helper);
}();
var $enkidatron$elm_cldr$Internal$Locale$normalize = function (langId) {
	if (langId.$ === 'Root') {
		return $enkidatron$elm_cldr$Internal$Locale$Root;
	} else {
		var langTag = langId.a;
		var maybeScript = langId.b;
		var maybeRegion = langId.c;
		var maybeVariant = langId.d;
		return A4(
			$enkidatron$elm_cldr$Internal$Locale$Lang,
			$enkidatron$elm_cldr$Internal$Locale$normalizeLang(langTag),
			A2($elm$core$Maybe$map, $enkidatron$elm_cldr$Internal$Locale$normalizeScript, maybeScript),
			A2($elm$core$Maybe$map, $enkidatron$elm_cldr$Internal$Locale$normalizeRegion, maybeRegion),
			A2($elm$core$Maybe$map, $enkidatron$elm_cldr$Internal$Locale$normalizeVariant, maybeVariant));
	}
};
var $enkidatron$elm_cldr$Internal$Parse$toLanguageId = function (info) {
	return (info.language === 'root') ? $enkidatron$elm_cldr$Internal$Locale$Root : $enkidatron$elm_cldr$Internal$Locale$normalize(
		A4(
			$enkidatron$elm_cldr$Internal$Locale$Lang,
			$joneshf$elm_tagged$Tagged$Tagged(info.language),
			A2($elm$core$Maybe$map, $joneshf$elm_tagged$Tagged$Tagged, info.script),
			A2($elm$core$Maybe$map, $joneshf$elm_tagged$Tagged$Tagged, info.territory),
			A2($elm$core$Maybe$map, $joneshf$elm_tagged$Tagged$Tagged, info.variant)));
};
var $elm$core$String$contains = _String_contains;
var $enkidatron$elm_cldr$Internal$Parse$twelveHourByDefault = function (info) {
	var allPatterns = _List_fromArray(
		[info.timeSkeletons._short, info.timeSkeletons.medium, info.timeSkeletons._long, info.timeSkeletons.full]);
	var contains12Hour = A2(
		$elm$core$List$any,
		$elm$core$String$contains('h'),
		allPatterns);
	var contains24Hour = A2(
		$elm$core$List$any,
		$elm$core$String$contains('H'),
		allPatterns);
	var _v0 = _Utils_Tuple2(contains12Hour, contains24Hour);
	if (_v0.a) {
		if (_v0.b) {
			return $elm$core$Maybe$Nothing;
		} else {
			return $elm$core$Maybe$Just(true);
		}
	} else {
		if (_v0.b) {
			return $elm$core$Maybe$Just(false);
		} else {
			return $elm$core$Maybe$Nothing;
		}
	}
};
var $enkidatron$elm_cldr$Internal$Parse$parseInfo = F2(
	function (dayPeriods, info) {
		return A2(
			$elm$core$Maybe$map,
			$enkidatron$elm_cldr$Internal$Locale$Locale,
			A2(
				$elm$core$Maybe$map,
				$elm$core$Basics$apR(
					$elm$core$Dict$fromList(info.currencySymbols)),
				A2(
					$elm$core$Maybe$map,
					$elm$core$Basics$apR(info.percentNumberFormat),
					A2(
						$elm$core$Maybe$map,
						$elm$core$Basics$apR(info.currencyNumberFormat),
						A2(
							$elm$core$Maybe$map,
							$elm$core$Basics$apR(info.decimalNumberFormat),
							A2(
								$elm_community$maybe_extra$Maybe$Extra$andMap,
								$enkidatron$elm_cldr$Internal$Parse$twelveHourByDefault(info),
								A2(
									$elm_community$maybe_extra$Maybe$Extra$andMap,
									$enkidatron$elm_cldr$Internal$Parse$availableFormatList(info),
									A2(
										$elm$core$Maybe$map,
										$elm$core$Basics$apR(
											$enkidatron$elm_cldr$Internal$Parse$toLanguageId(info)),
										A2(
											$elm_community$maybe_extra$Maybe$Extra$andMap,
											$enkidatron$elm_cldr$Internal$Parse$dateTimeTokens(info),
											A2(
												$elm_community$maybe_extra$Maybe$Extra$andMap,
												$enkidatron$elm_cldr$Internal$Parse$timeSymbols(info),
												A2(
													$elm_community$maybe_extra$Maybe$Extra$andMap,
													$enkidatron$elm_cldr$Internal$Parse$dateSymbols(info),
													A2(
														$elm$core$Maybe$map,
														$elm$core$Basics$apR(
															A2($enkidatron$elm_cldr$Internal$Parse$dayPeriodRules, dayPeriods, info)),
														A2(
															$elm$core$Maybe$map,
															$elm$core$Basics$apR(info.periodNames),
															A2(
																$elm$core$Maybe$map,
																$elm$core$Basics$apR(info.eraNames),
																A2(
																	$elm$core$Maybe$map,
																	$elm$core$Basics$apR(info.weekdayStandaloneNames),
																	A2(
																		$elm$core$Maybe$map,
																		$elm$core$Basics$apR(info.weekdayFormatNames),
																		A2(
																			$elm$core$Maybe$map,
																			$elm$core$Basics$apR(info.monthStandaloneNames),
																			A2(
																				$elm$core$Maybe$map,
																				$elm$core$Basics$apR(info.monthFormatNames),
																				$elm$core$Maybe$Just($enkidatron$elm_cldr$Internal$Locale$Internal)))))))))))))))))));
	});
var $enkidatron$elm_cldr$Internal$Parse$parse = F2(
	function (dayPeriods, text) {
		return A2(
			$elm$core$Maybe$andThen,
			$enkidatron$elm_cldr$Internal$Parse$parseInfo(dayPeriods),
			$enkidatron$elm_cldr$Internal$LanguageInfo$Parse$parse(text));
	});
var $enkidatron$elm_cldr$Generated$Af$af = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Af$dayPeriods, 'af||||vm.|nm.|7|afternoon1|die middag|am|vm.|evening1|die aand|midnight|middernag|morning1|die oggend|night1|die nag|pm|nm.|vm.|nm.|7|afternoon1|die middag|am|vm.|evening1|die aand|midnight|middernag|morning1|die oggend|night1|die nag|pm|nm.|v|n|7|afternoon1|m|am|v|evening1|a|midnight|mn|morning1|o|night1|n|pm|n|y-MM-dd|dd MMM y|dd MMMM y|EEEE dd MMMM y|Jan.|Feb.|Mrt.|Apr.|Mei|Jun.|Jul.|Aug.|Sep.|Okt.|Nov.|Des.|Januarie|Februarie|Maart|April|Mei|Junie|Julie|Augustus|September|Oktober|November|Desember|J|F|M|A|M|J|J|A|S|O|N|D|0|So.|Ma.|Di.|Wo.|Do.|Vr.|Sa.|Sondag|Maandag|Dinsdag|Woensdag|Donderdag|Vrydag|Saterdag|S|M|D|W|D|V|S|0|v.C.|n.C.|voor Christus|ná Christus|v.C.|n.C.|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1} {0}|{1} {0}|{1} {0}|{1} {0}|50|Bh|h B|Bhm|hh:mm B|Bhms|hh:mm:ss B|d|d|E|ccc|EBhm|E hh:mm B|EBhms|E hh:mm:ss B|Ed|E d|Ehm|E hh:mm\u202Fa|EHm|E HH:mm|Ehms|E hh:mm:ss\u202Fa|EHms|E HH:mm:ss|Gy|y G|GyMd|GGGGG y-MM-dd|GyMMM|MMM y G|GyMMMd|dd MMM y G|GyMMMEd|E dd MMM y G|h|h\u202Fa|H|HH|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|Hmv|HH:mm v|M|L|Md|dd-MM|MEd|E d/M|MMM|LLL|MMMd|d MMM|MMMEd|E d MMM|MMMMd|d MMMM|MMMMEd|E d MMMM|MMMMW-count-one|\'week\' W \'van\' MMMM|MMMMW-count-other|\'week\' W \'van\' MMMM|ms|mm:ss|y|y|yM|MM-y|yMd|y-MM-dd|yMEd|E y-MM-dd|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\'week\' w \'van\' Y|yw-count-other|\'week\' w \'van\' Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W\u00A0|,|-||||||E2W\u00A0|,|-¤||¤||¤||E0W\u00A0|,|-|%||%||%|107|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CAD|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MXN|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|leu|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|USD|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XCG|Cg.|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$af = $enkidatron$elm_cldr$Generated$Af$af;
var $enkidatron$elm_cldr$Generated$Am$dayPeriods = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			'am',
			_List_fromArray(
				[
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(12, 0),
					_Utils_Tuple2(18, 0),
					'afternoon1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(18, 0),
					_Utils_Tuple2(24, 0),
					'evening1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(0, 0),
					'midnight'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(6, 0),
					_Utils_Tuple2(12, 0),
					'morning1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(0, 0),
					_Utils_Tuple2(6, 0),
					'night1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(12, 0),
					'noon')
				]))
		]));
var $enkidatron$elm_cldr$Generated$Am$am = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Am$dayPeriods, 'am||||ጥዋት|ከሰዓት|8|afternoon1|ከሰዓት|am|ጥዋት|evening1|በምሽት|midnight|እኩለ ሌሊት|morning1|ጥዋት|night1|በሌሊት|noon|ቀትር|pm|ከሰዓት|ጥዋት|ከሰዓት|8|afternoon1|ከሰዓት|am|ጥዋት|evening1|በምሽት|midnight|እኩለ ሌሊት|morning1|ጥዋት|night1|በሌሊት|noon|ቀትር|pm|ከሰዓት|ጠ|ከ|8|afternoon1|ከሰዓት|am|ጠ|evening1|በምሽት|midnight|እኩለ ሌሊት|morning1|ጥዋት|night1|በሌሊት|noon|ቀ|pm|ከ|dd/MM/y|d MMM y|d MMMM y|EEEE d MMMM y|ጃን|ፌብ|ማርች|ኤፕሪ|ሜይ|ጁን|ጁላይ|ኦገስ|ሴፕቴ|ኦክቶ|ኖቬም|ዲሴም|ጃንዋሪ|ፌብሩዋሪ|ማርች|ኤፕሪል|ሜይ|ጁን|ጁላይ|ኦገስት|ሴፕቴምበር|ኦክቶበር|ኖቬምበር|ዲሴምበር|ጃ|ፌ|ማ|ኤ|ሜ|ጁ|ጁ|ኦ|ሴ|ኦ|ኖ|ዲ|0|እሑድ|ሰኞ|ማክሰ|ረቡዕ|ሐሙስ|ዓርብ|ቅዳሜ|እሑድ|ሰኞ|ማክሰኞ|ረቡዕ|ሐሙስ|ዓርብ|ቅዳሜ|እ|ሰ|ማ|ረ|ሐ|ዓ|ቅ|0|ዓ/ዓ|ዓ/ም|ዓመተ ዓለም|ዓመተ ምሕረት|ዓ/ዓ|ዓ/ም|h:mm a|h:mm:ss a|h:mm:ss a z|h:mm:ss a zzzz|{1} {0}|{1} {0}|{1} {0}|{1} {0}|50|Bh|B h|Bhm|B h:mm|Bhms|B h:mm:ss|d|d|E|ccc|EBhm|E B h:mm|EBhms|E B h:mm:ss|Ed|E d|Ehm|E a h:mm|EHm|E HH:mm|Ehms|E a h:mm:ss|EHms|E HH:mm:ss|Gy|y G|GyMd|d/M/y GGGGG|GyMMM|MMM y G|GyMMMd|MMM d y G|GyMMMEd|E MMM d y G|h|a h|H|H|hm|a h:mm|Hm|HH:mm|hms|a h:mm:ss|Hms|HH:mm:ss|hmsv|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm a v|Hmv|HH:mm v|M|L|Md|d/M|MEd|E፣ d/M|MMM|LLL|MMMd|MMM d|MMMEd|E፣ MMM d|MMMMd|MMMM d|MMMMEd|E፣ MMMM d|MMMMW-count-one|የMMMM Wኛ ሳምንት|MMMMW-count-other|የMMMM Wኛ ሳምንት|ms|mm:ss|y|y|yM|M/y|yMd|d/M/y|yMEd|E፣ d/M/y|yMMM|MMM y|yMMMd|MMM d y|yMMMEd|E፣ MMM d y|yMMMM|MMMM y|yQQQ|y QQQ|yQQQQ|y QQQQ|yw-count-one|የY wኛ ሳምንት|yw-count-other|የY wኛ ሳምንት|ahmm|ahmmss|ahmmssz|ahmmsszzzz|X3W,|.|-||||||E2W,|.|-¤||¤||¤||E0W,|.|-|%||%||%|108|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|AU$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|ETB|ብር|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XCG|Cg.|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$am = $enkidatron$elm_cldr$Generated$Am$am;
var $enkidatron$elm_cldr$Generated$Ar$dayPeriods = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			'ar',
			_List_fromArray(
				[
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(12, 0),
					_Utils_Tuple2(13, 0),
					'afternoon1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(13, 0),
					_Utils_Tuple2(18, 0),
					'afternoon2'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(18, 0),
					_Utils_Tuple2(24, 0),
					'evening1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(3, 0),
					_Utils_Tuple2(6, 0),
					'morning1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(6, 0),
					_Utils_Tuple2(12, 0),
					'morning2'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(0, 0),
					_Utils_Tuple2(1, 0),
					'night1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(1, 0),
					_Utils_Tuple2(3, 0),
					'night2')
				]))
		]));
var $enkidatron$elm_cldr$Generated$Ar$ar = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Ar$dayPeriods, 'ar||||ص|م|9|afternoon1|ظهرًا|afternoon2|بعد الظهر|am|ص|evening1|مساءً|morning1|فجرًا|morning2|ص|night1|في المساء|night2|ليلاً|pm|م|ص|م|9|afternoon1|ظهرًا|afternoon2|بعد الظهر|am|ص|evening1|مساءً|morning1|في الصباح|morning2|صباحًا|night1|في المساء|night2|ليلاً|pm|م|ص|م|9|afternoon1|ظهرًا|afternoon2|بعد الظهر|am|ص|evening1|مساءً|morning1|فجرًا|morning2|صباحًا|night1|منتصف الليل|night2|ليلاً|pm|م|d\u200F/M\u200F/y|dd\u200F/MM\u200F/y|d MMMM y|EEEE، d MMMM y|يناير|فبراير|مارس|أبريل|مايو|يونيو|يوليو|أغسطس|سبتمبر|أكتوبر|نوفمبر|ديسمبر|يناير|فبراير|مارس|أبريل|مايو|يونيو|يوليو|أغسطس|سبتمبر|أكتوبر|نوفمبر|ديسمبر|ي|ف|م|أ|و|ن|ل|غ|س|ك|ب|د|0|الأحد|الاثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت|الأحد|الاثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت|ح|ن|ث|ر|خ|ج|س|0|ق.م|م|قبل الميلاد|ميلادي|ق.م|م|h:mm a|h:mm:ss a|h:mm:ss a z|h:mm:ss a zzzz|{1}، {0}|{1}، {0}|{1}، {0}|{1}، {0}|60|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E، d|Ehm|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss a|EHms|E HH:mm:ss|Gy|y G|GyMd|dd-MM-y GGGGG|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E، d MMM y G|h|h\u202Fa|H|HH|hm|h:mm a|Hm|HH:mm|hms|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm a v|Hmv|HH:mm v|M|L|Md|d\u200F/M|MEd|E، d\u200F/M|MMdd|dd\u200F/MM|MMM|LLL|MMMd|d MMM|MMMEd|E، d MMM|MMMMd|d MMMM|MMMMEd|E، d MMMM|MMMMW-count-zero|الأسبوع W من MMMM|MMMMW-count-one|الأسبوع W من MMMM|MMMMW-count-two|الأسبوع W من MMMM|MMMMW-count-few|الأسبوع W من MMMM|MMMMW-count-many|الأسبوع W من MMMM|MMMMW-count-other|الأسبوع W من MMMM|ms|mm:ss|y|y|yM|M\u200F/y|yMd|d\u200F/M\u200F/y|yMEd|E، d\u200F/M\u200F/y|yMM|MM\u200F/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E، d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-zero|الأسبوع w من سنة Y|yw-count-one|الأسبوع w من سنة Y|yw-count-two|الأسبوع w من سنة Y|yw-count-few|الأسبوع w من سنة Y|yw-count-many|الأسبوع w من سنة Y|yw-count-other|الأسبوع w من سنة Y|ahmm|ahmmss|ahmmssz|ahmmsszzzz|X3W,|.|\u200E-||||||E2W,|.|\u200F-|\u00A0¤|\u200F|\u00A0¤|\u200F|\u00A0¤|E0W,|.|\u200E-|%||%||%|124|AED|د.إ.\u200F|AFN|؋|AMD|֏|AOA|Kz|ARS|AR$|AUD|AU$|AZN|₼|BAM|KM|BBD|BB$|BDT|৳|BHD|د.ب.\u200F|BMD|BM$|BND|BN$|BOB|Bs|BRL|R$|BSD|BS$|BWP|P|BYN|р.|BZD|BZ$|CAD|CA$|CLP|CL$|CNY|CN¥|COP|CO$|CRC|₡|CUC|$|CUP|CU$|CZK|Kč|DKK|kr|DOP|DO$|DZD|د.ج.\u200F|EGP|ج.م.\u200F|ESP|₧|EUR|€|FJD|FJ$|FKP|£|GBP|UK£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|GY$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|IQD|د.ع.\u200F|IRR|ر.إ.|ISK|kr|JMD|JM$|JOD|د.أ.\u200F|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KWD|د.ك.\u200F|KYD|KY$|KZT|₸|LAK|₭|LBP|ل.ل.\u200F|LKR|Rs|LRD|$LR|LTL|Lt|LVL|Ls|LYD|د.ل.\u200F|MAD|د.م.\u200F|MGA|Ar|MMK|K|MNT|₮|MRU|أ.م.|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|OMR|ر.ع.\u200F|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|QAR|ر.ق.\u200F|RON|lei|RUB|₽|RWF|RF|SAR|ر.س.\u200F|SBD|SB$|SDD|د.س.\u200F|SDG|ج.س.|SEK|kr|SGD|$|SHP|£|SRD|SR$|SSP|£|STN|Db|SYP|ل.س.\u200F|THB|฿|TND|د.ت.\u200F|TOP|T$|TRY|₺|TTD|TT$|TWD|NT$|UAH|₴|USD|US$|UYU|UY$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XCG|Cg.|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|YER|ر.ي.\u200F|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$ar = $enkidatron$elm_cldr$Generated$Ar$ar;
var $enkidatron$elm_cldr$Generated$Az$dayPeriods = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			'az',
			_List_fromArray(
				[
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(12, 0),
					_Utils_Tuple2(17, 0),
					'afternoon1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(17, 0),
					_Utils_Tuple2(19, 0),
					'evening1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(0, 0),
					'midnight'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(4, 0),
					_Utils_Tuple2(6, 0),
					'morning1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(6, 0),
					_Utils_Tuple2(12, 0),
					'morning2'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(19, 0),
					_Utils_Tuple2(24, 0),
					'night1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(0, 0),
					_Utils_Tuple2(4, 0),
					'night2'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(12, 0),
					'noon')
				]))
		]));
var $enkidatron$elm_cldr$Generated$Az$az = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Az$dayPeriods, 'az||||AM|PM|10|afternoon1|gündüz|am|AM|evening1|axşamüstü|midnight|gecəyarı|morning1|sübh|morning2|səhər|night1|axşam|night2|gecə|noon|günorta|pm|PM|AM|PM|10|afternoon1|gündüz|am|AM|evening1|axşamüstü|midnight|gecəyarı|morning1|sübh|morning2|səhər|night1|axşam|night2|gecə|noon|günorta|pm|PM|a|p|10|afternoon1|gündüz|am|a|evening1|axşamüstü|midnight|gecəyarı|morning1|sübh|morning2|səhər|night1|axşam|night2|gecə|noon|g|pm|p|dd.MM.yy|d MMM y|d MMMM y|d MMMM y, EEEE|yan|fev|mar|apr|may|iyn|iyl|avq|sen|okt|noy|dek|yanvar|fevral|mart|aprel|may|iyun|iyul|avqust|sentyabr|oktyabr|noyabr|dekabr|1|2|3|4|5|6|7|8|9|10|11|12|0|B.|B.e.|Ç.a.|Ç.|C.a.|C.|Ş.|bazar|bazar ertəsi|çərşənbə axşamı|çərşənbə|cümə axşamı|cümə|şənbə|7|1|2|3|4|5|6|1|B.|B.E.|Ç.A.|Ç.|C.A.|C.|Ş.|bazar|bazar ertəsi|çərşənbə axşamı|çərşənbə|cümə axşamı|cümə|şənbə|7|1|2|3|4|5|6|e.ə.|y.e.|eramızdan əvvəl|yeni era|e.ə.|y.e.|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1} {0}|{1} {0}|{1} {0}|{1} {0}|49|Bh|B h|Bhm|B h:mm|Bhms|B h:mm:ss|d|d|E|ccc|EBhm|E B h:mm|EBhms|E B h:mm:ss|Ed|d E|Ehm|E h:mm\u202Fa|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|EHms|E HH:mm:ss|Gy|G y|GyMd|GGGGG d MMM y|GyMMM|G MMM y|GyMMMd|G d MMM y|GyMMMEd|G d MMM y, E|h|h\u202Fa|H|HH|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|Hmv|HH:mm v|M|L|Md|dd.MM|MEd|dd.MM, E|MMM|LLL|MMMd|d MMM|MMMEd|d MMM, E|MMMMd|d MMMM|MMMMW-count-one|MMMM, W \'həftə\'|MMMMW-count-other|MMMM, W \'həftə\'|ms|mm:ss|y|y|yM|MM.y|yMd|dd.MM.y|yMEd|dd.MM.y, E|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|d MMM y, E|yMMMM|MMMM y|yQQQ|y QQQ|yQQQQ|y QQQQ|yw-count-one|Y, w \'həftə\'|yw-count-other|Y, w \'həftə\'|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W.|,|-||||||E2W.|,|-|\u00A0¤||\u00A0¤||\u00A0¤|E0W.|,|-|%||%||%|107|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|ley|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|S£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XCG|Cg.|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$az = $enkidatron$elm_cldr$Generated$Az$az;
var $enkidatron$elm_cldr$Generated$Be$dayPeriods = $elm$core$Dict$fromList(_List_Nil);
var $enkidatron$elm_cldr$Generated$Be$be = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Be$dayPeriods, 'be||||AM|PM|2|am|AM|pm|PM|AM|PM|2|am|AM|pm|PM|am|pm|2|am|am|pm|pm|d.MM.yy|d MMM y\u202F\'г\'.|d MMMM y\u202F\'г\'.|EEEE, d MMMM y\u202F\'г\'.|сту|лют|сак|кра|мая|чэр|ліп|жні|вер|кас|ліс|сне|студзеня|лютага|сакавіка|красавіка|мая|чэрвеня|ліпеня|жніўня|верасня|кастрычніка|лістапада|снежня|с|л|с|к|м|ч|л|ж|в|к|л|с|1|сту|лют|сак|кра|май|чэр|ліп|жні|вер|кас|ліс|сне|студзень|люты|сакавік|красавік|май|чэрвень|ліпень|жнівень|верасень|кастрычнік|лістапад|снежань|с|л|с|к|м|ч|л|ж|в|к|л|с|нд|пн|аў|ср|чц|пт|сб|нядзеля|панядзелак|аўторак|серада|чацвер|пятніца|субота|н|п|а|с|ч|п|с|0|да н.э.|н.э.|да нараджэння Хрыстова|ад нараджэння Хрыстова|да н.э.|н.э.|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss, zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|54|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|d, E|Ehm|E h:mm\u202Fa|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|EHms|E HH:mm:ss|Gy|y\u202F\'г\'. G|GyMd|dd.MM.y GGGGG|GyMMM|LLL y\u202F\'г\'. G|GyMMMd|d MMM y\u202F\'г\'. G|GyMMMEd|E, d MMM y\u202F\'г\'. G|h|hh\u202Fa|H|HH|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|Hmv|HH:mm v|M|L|Md|d.M|MEd|E, d.M|MMM|LLL|MMMd|d MMM|MMMEd|E, d MMM|MMMMd|d MMMM|MMMMEd|E, d MMMM|MMMMW-count-one|W \'тыдзень\' MMMM|MMMMW-count-few|W \'тыдзень\' MMMM|MMMMW-count-many|W \'тыдзень\' MMMM|MMMMW-count-other|W \'тыдзень\' MMMM|ms|mm.ss|y|y|yM|M.y|yMd|d.M.y|yMEd|E, d.M.y|yMMM|LLL y|yMMMd|d MMM y|yMMMEd|E, d MMM y|yMMMM|LLLL y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|w \'тыдзень\' Y|yw-count-few|w \'тыдзень\' Y|yw-count-many|w \'тыдзень\' Y|yw-count-other|w \'тыдзень\' Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W\u00A0|,|-||||||E2W\u00A0|,|-|\u00A0¤||\u00A0¤||\u00A0¤|E0W\u00A0|,|-|\u00A0%||\u00A0%||\u00A0%|107|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|Bds$|BDT|৳|BMD|BD$|BND|$|BOB|Bs|BRL|BRL|BSD|B$|BWP|P|BYN|Br|BZD|BZ$|CAD|CAD|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|CUC$|CUP|$MN|CZK|Kč|DKK|kr|DOP|RD$|EGP|E£|ESP|₧|EUR|€|FJD|FJ$|FKP|FK£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|G$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|Íkr|JMD|J$|JPY|¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|CI$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|L$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|N$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZD|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|SI$|SEK|kr|SGD|S$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|TT$|TWD|NT$|UAH|₴|USD|$|UYU|$U|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XCG|Cg.|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$be = $enkidatron$elm_cldr$Generated$Be$be;
var $enkidatron$elm_cldr$Generated$Bg$dayPeriods = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			'bg',
			_List_fromArray(
				[
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(14, 0),
					_Utils_Tuple2(18, 0),
					'afternoon1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(18, 0),
					_Utils_Tuple2(22, 0),
					'evening1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(0, 0),
					'midnight'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(4, 0),
					_Utils_Tuple2(11, 0),
					'morning1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(11, 0),
					_Utils_Tuple2(14, 0),
					'morning2'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(22, 0),
					_Utils_Tuple2(4, 0),
					'night1')
				]))
		]));
var $enkidatron$elm_cldr$Generated$Bg$bg = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Bg$dayPeriods, 'bg||||am|pm|8|afternoon1|следобед|am|am|evening1|вечерта|midnight|полунощ|morning1|сутринта|morning2|на обяд|night1|през нощта|pm|pm|пр.об.|сл.об.|8|afternoon1|следобед|am|пр.об.|evening1|вечерта|midnight|полунощ|morning1|сутринта|morning2|на обяд|night1|през нощта|pm|сл.об.|am|pm|8|afternoon1|следобед|am|am|evening1|вечерта|midnight|полунощ|morning1|сутринта|morning2|на обяд|night1|през нощта|pm|pm|d.MM.yy\u202F\'г\'.|d.MM.y\u202F\'г\'.|d MMMM y\u202F\'г\'.|EEEE, d MMMM y\u202F\'г\'.|яну|фев|март|апр|май|юни|юли|авг|сеп|окт|ное|дек|януари|февруари|март|април|май|юни|юли|август|септември|октомври|ноември|декември|я|ф|м|а|м|ю|ю|а|с|о|н|д|0|нд|пн|вт|ср|чт|пт|сб|неделя|понеделник|вторник|сряда|четвъртък|петък|събота|н|п|в|с|ч|п|с|0|пр.Хр.|сл.Хр.|преди Христа|след Христа|пр.Хр.|сл.Хр.|H:mm|H:mm:ss|H:mm:ss \'ч\'. z|H:mm:ss \'ч\'. zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|57|Bh|h \'ч\'. B|Bhm|h:mm \'ч\'. B|Bhms|h:mm:ss \'ч\'. B|d|d|E|ccc|EBhm|E, h:mm \'ч\'. B|EBhms|E, h:mm:ss \'ч\'. B|Ed|E, d|Ehm|E, h:mm \'ч\'. a|EHm|E, HH:mm \'ч\'.|Ehms|E, h:mm:ss \'ч\'. a|EHms|E, HH:mm:ss \'ч\'.|Gy|y\u202F\'г\'. G|GyMd|dd.MM.y\u202F\'г\'. GGGGG|GyMMM|MM.y\u202F\'г\'. G|GyMMMd|d.MM.y\u202F\'г\'. G|GyMMMEd|E, d.MM.y\u202F\'г\'. G|GyMMMM|MMMM y\u202F\'г\'. G|GyMMMMd|d MMMM y\u202F\'г\'. G|GyMMMMEd|E, d MMMM y\u202F\'г\'. G|h|h \'ч\'. a|H|HH \'ч\'.|hm|h:mm \'ч\'. a|Hm|HH:mm \'ч\'.|hms|h:mm:ss \'ч\'. a|Hms|HH:mm:ss \'ч\'.|hmsv|h:mm:ss \'ч\'. a v|Hmsv|HH:mm:ss \'ч\'. v|hmv|h:mm \'ч\'. a v|Hmv|HH:mm \'ч\'. v|M|L|Md|d.MM|MEd|E, d.MM|MMM|MM|MMMd|d.MM|MMMEd|E, d.MM|MMMM|LLLL|MMMMd|d MMMM|MMMMdd|d MMMM|MMMMEd|E, d MMMM|MMMMW-count-one|\'седмица\' W \'от\' MMMM|MMMMW-count-other|\'седмица\' W \'от\' MMMM|ms|m:ss|y|y\u202F\'г\'.|yM|MM.y\u202F\'г\'.|yMd|d.MM.y\u202F\'г\'.|yMEd|E, d.MM.y\u202F\'г\'.|yMMM|MM.y\u202F\'г\'.|yMMMd|d.MM.y\u202F\'г\'.|yMMMEd|E, d.MM.y\u202F\'г\'.|yMMMM|MMMM y\u202F\'г\'.|yMMMMd|d MMMM y\u202F\'г\'.|yMMMMEd|E, d MMMM y\u202F\'г\'.|yQQQ|QQQ y\u202F\'г\'.|yQQQQ|QQQQ y\u202F\'г\'.|yw-count-one|\'седмица\' w \'от\' Y \'г\'.|yw-count-other|\'седмица\' w \'от\' Y \'г\'.|Hmm|Hmmss|Hmmssz|Hmmsszzzz|X3W\u00A0|,|-||||||E2W\u00A0|,|-|\u00A0¤||\u00A0¤||\u00A0¤|E0W\u00A0|,|-|%||%||%|107|AFN|Af|AMD|AMD|AOA|Kz|ARS|ARS|AUD|AUD|AZN|AZN|BAM|KM|BBD|BBD|BDT|BDT|BGN|лв.|BMD|BMD|BND|BND|BOB|Bs|BRL|BRL|BSD|BSD|BWP|P|BZD|BZD|CAD|CAD|CLP|CLP|CNY|CNY|COP|COP|CRC|CRC|CUC|$|CUP|CUP|CZK|Kč|DKK|kr|DOP|DOP|EGP|E£|ESP|₧|EUR|€|FJD|FJD|FKP|FKP|GBP|GBP|GEL|₾|GHS|GHS|GIP|GIP|GNF|FG|GTQ|Q|GYD|GYD|HKD|HKD|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|ILS|INR|INR|ISK|kr|JMD|JMD|JPY|JPY|KGS|\u20C0|KHR|KHR|KMF|CF|KPW|₩|KRW|KRW|KYD|KYD|KZT|KZT|LAK|LAK|LBP|L£|LKR|Rs|LRD|LRD|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|MNT|MUR|Rs|MXN|MXN|MYR|RM|NAD|NAD|NGN|NGN|NIO|C$|NOK|kr|NPR|Rs|NZD|NZD|PHP|PHP|PKR|Rs|PLN|zł|PYG|PYG|RON|RON|RUB|₽|RWF|RF|SBD|SBD|SEK|kr|SGD|SGD|SHP|£|SRD|SRD|SSP|SSP|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|TRY|TTD|TTD|TWD|TWD|UAH|UAH|USD|щ.д.|UYU|UYU|VEF|Bs|VND|VND|XAF|FCFA|XCD|XCD|XCG|Cg.|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$bg = $enkidatron$elm_cldr$Generated$Bg$bg;
var $enkidatron$elm_cldr$Generated$Bn$dayPeriods = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			'bn',
			_List_fromArray(
				[
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(12, 0),
					_Utils_Tuple2(16, 0),
					'afternoon1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(16, 0),
					_Utils_Tuple2(18, 0),
					'afternoon2'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(18, 0),
					_Utils_Tuple2(20, 0),
					'evening1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(4, 0),
					_Utils_Tuple2(6, 0),
					'morning1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(6, 0),
					_Utils_Tuple2(12, 0),
					'morning2'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(20, 0),
					_Utils_Tuple2(4, 0),
					'night1')
				]))
		]));
var $enkidatron$elm_cldr$Generated$Bn$bn = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Bn$dayPeriods, 'bn||||AM|PM|8|afternoon1|দুপুর|afternoon2|বিকাল|am|AM|evening1|সন্ধ্যা|morning1|ভোর|morning2|সকাল|night1|রাত্রি|pm|PM|AM|PM|8|afternoon1|দুপুরবেলায়|afternoon2|বিকাল|am|AM|evening1|সন্ধ্যাবেলায়|morning1|ভোরবেলায়|morning2|সকালবেলায়|night1|রাত্রিবেলায়|pm|PM|AM|PM|8|afternoon1|দুপুর|afternoon2|বিকাল|am|AM|evening1|সন্ধ্যা|morning1|ভোর|morning2|সকাল|night1|রাত্রি|pm|PM|d/M/yy|d MMM, y|d MMMM, y|EEEE, d MMMM, y|জানু|ফেব|মার্চ|এপ্রি|মে|জুন|জুল|আগ|সেপ|অক্টো|নভে|ডিসে|জানুয়ারী|ফেব্রুয়ারী|মার্চ|এপ্রিল|মে|জুন|জুলাই|আগস্ট|সেপ্টেম্বর|অক্টোবর|নভেম্বর|ডিসেম্বর|জা|ফে|মা|এ|মে|জুন|জু|আ|সে|অ|ন|ডি|1|জানু|ফেব|মার্চ|এপ্রিল|মে|জুন|জুলাই|আগস্ট|সেপ্টেম্বর|অক্টোবর|নভেম্বর|ডিসেম্বর|জানুয়ারী|ফেব্রুয়ারী|মার্চ|এপ্রিল|মে|জুন|জুলাই|আগস্ট|সেপ্টেম্বর|অক্টোবর|নভেম্বর|ডিসেম্বর|জা|ফে|মা|এ|মে|জুন|জু|আ|সে|অ|ন|ডি|রবি|সোম|মঙ্গল|বুধ|বৃহস্পতি|শুক্র|শনি|রবিবার|সোমবার|মঙ্গলবার|বুধবার|বৃহস্পতিবার|শুক্রবার|শনিবার|র|সো|ম|বু|বৃ|শু|শ|0|খ্রিস্টপূর্ব|খৃষ্টাব্দ|খ্রিস্টপূর্ব|খ্রীষ্টাব্দ|খ্রিস্টপূর্ব|খৃষ্টাব্দ|h:mm a|h:mm:ss a|h:mm:ss a z|h:mm:ss a zzzz|{1} {0}|{1} {0}|{1} {0}|{1} {0}|52|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|d E|Ehm|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss a|EHms|E HH:mm:ss|Gy|y G|GyMd|dd-MM-y GGGGG|GyMMM|MMM y G|GyMMMd|d MMM, y G|GyMMMEd|E, d MMM, y G|h|h\u202Fa|H|HH|hm|h:mm a|Hm|HH:mm|hms|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm a v|Hmv|HH:mm v|M|L|Md|d/M|MEd|E, d-M|MMdd|dd-MM|MMM|LLL|MMMd|d MMM|MMMEd|E d MMM|MMMMd|d MMMM|MMMMEd|E d MMMM|MMMMW-count-one|MMMM এর Wয় সপ্তাহ|MMMMW-count-other|MMMM এর Wয় সপ্তাহ|ms|mm:ss|y|y|yM|M/y|yMd|d/M/y|yMEd|E, d/M/y|yMM|MM-y|yMMM|MMM y|yMMMd|d MMM, y|yMMMEd|E, d MMM, y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|Y এর wতম সপ্তাহ|yw-count-other|Y এর wতম সপ্তাহ|ahmm|ahmmss|ahmmssz|ahmmsszzzz|X3I,|.|-||||||E2I,|.|-|¤||¤||¤|E0I,|.|-|%||%||%|107|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XCG|Cg.|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$bn = $enkidatron$elm_cldr$Generated$Bn$bn;
var $enkidatron$elm_cldr$Generated$Bs$dayPeriods = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			'bs',
			_List_fromArray(
				[
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(12, 0),
					_Utils_Tuple2(18, 0),
					'afternoon1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(18, 0),
					_Utils_Tuple2(21, 0),
					'evening1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(0, 0),
					'midnight'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(4, 0),
					_Utils_Tuple2(12, 0),
					'morning1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(21, 0),
					_Utils_Tuple2(4, 0),
					'night1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(12, 0),
					'noon')
				]))
		]));
var $enkidatron$elm_cldr$Generated$Bs$bs = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Bs$dayPeriods, 'bs||||a.\u202Fm.|p.\u202Fm.|8|afternoon1|poslijepodne|am|a.\u202Fm.|evening1|navečer|midnight|ponoć|morning1|ujutro|night1|po noći|noon|podne|pm|p.\u202Fm.|prijepodne|popodne|8|afternoon1|poslijepodne|am|prijepodne|evening1|navečer|midnight|ponoć|morning1|ujutro|night1|po noći|noon|podne|pm|popodne|a.\u202Fm.|p.\u202Fm.|8|afternoon1|poslijepodne|am|a.\u202Fm.|evening1|navečer|midnight|ponoć|morning1|ujutro|night1|po noći|noon|podne|pm|p.\u202Fm.|d. M. y.|d. MMM y.|d. MMMM y.|EEEE, d. MMMM y.|jan|feb|mar|apr|maj|jun|jul|aug|sep|okt|nov|dec|januar|februar|mart|april|maj|juni|juli|august|septembar|oktobar|novembar|decembar|j|f|m|a|m|j|j|a|s|o|n|d|0|ned|pon|uto|sri|čet|pet|sub|nedjelja|ponedjeljak|utorak|srijeda|četvrtak|petak|subota|N|P|U|S|Č|P|S|1|ned|pon|uto|sri|čet|pet|sub|nedjelja|ponedjeljak|utorak|srijeda|četvrtak|petak|subota|n|p|u|s|č|p|s|p. n. e.|n. e.|prije nove ere|nove ere|p.n.e.|n. e.|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1} {0}|{1} {0}|{1}, {0}|{1}, {0}|54|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d.|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E, d.|Ehm|E h:mm\u202Fa|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|EHms|E HH:mm:ss|Gy|y. G|GyMd|d. M. y. G|GyMMM|MMM y. G|GyMMMd|d. MMM y. G|GyMMMEd|E, d. MMM y. G|h|h\u202Fa|H|HH|hm|hh:mm\u202Fa|Hm|HH:mm|hms|hh:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa (v)|Hmsv|HH:mm:ss (v)|hmv|h:mm\u202Fa (v)|Hmv|HH:mm (v)|M|L|Md|d. M.|MEd|E, d. M.|MMdd|d. M.|MMM|LLL|MMMd|d. MMM|MMMEd|E, d. MMM|MMMMd|d. MMMM|MMMMEd|E, d. MMMM|MMMMW-count-one|W. \'sedmica\' \'mjesec\' MMMM|MMMMW-count-few|W. \'sedmica\' \'mjesec\' MMMM|MMMMW-count-other|W. \'sedmica\' \'mjesec\' MMMM|ms|mm:ss|y|y.|yM|MM/y|yMd|d. M. y.|yMEd|E, d. M. y.|yMM|M. y.|yMMM|MMM y.|yMMMd|d. MMM y.|yMMMEd|E, d. MMM y.|yMMMM|LLLL y.|yQQQ|QQQ y.|yQQQQ|QQQQ y.|yw-count-one|w. \'sedmica\' \'u\' Y.|yw-count-few|w. \'sedmica\' \'u\' Y.|yw-count-other|w. \'sedmica\' \'u\' Y.|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W.|,|-||||||E2W.|,|-|\u00A0¤||\u00A0¤||\u00A0¤|E0W.|,|-|%||%||%|108|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|AUD|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|BRL|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CAD|CLP|$|CNY|CNY|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|GBP|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HKD|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|ILS|INR|₹|ISK|kr|JMD|$|JPY|¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MXN|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZD|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RSD|din.|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|USD|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|XCD|XCG|Cg.|XOF|F\u202FCFA|XPF|XPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$bs = $enkidatron$elm_cldr$Generated$Bs$bs;
var $enkidatron$elm_cldr$Generated$Ca$dayPeriods = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			'ca',
			_List_fromArray(
				[
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(12, 0),
					_Utils_Tuple2(13, 0),
					'afternoon1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(13, 0),
					_Utils_Tuple2(19, 0),
					'afternoon2'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(19, 0),
					_Utils_Tuple2(21, 0),
					'evening1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(0, 0),
					'midnight'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(0, 0),
					_Utils_Tuple2(6, 0),
					'morning1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(6, 0),
					_Utils_Tuple2(12, 0),
					'morning2'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(21, 0),
					_Utils_Tuple2(24, 0),
					'night1')
				]))
		]));
var $enkidatron$elm_cldr$Generated$Ca$ca = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Ca$dayPeriods, 'ca||||a.\u202Fm.|p.\u202Fm.|9|afternoon1|migdia|afternoon2|tarda|am|a.\u202Fm.|evening1|vespre|midnight|mitjanit|morning1|matinada|morning2|matí|night1|nit|pm|p.\u202Fm.|a.\u00A0m.|p.\u00A0m.|9|afternoon1|migdia|afternoon2|tarda|am|a.\u00A0m.|evening1|vespre|midnight|mitjanit|morning1|matinada|morning2|matí|night1|nit|pm|p.\u00A0m.|a.\u202Fm.|p.\u202Fm.|9|afternoon1|migdia|afternoon2|tarda|am|a.\u202Fm.|evening1|vespre|midnight|mitjanit|morning1|matinada|morning2|matí|night1|nit|pm|p.\u202Fm.|d/M/yy|d MMM y|d MMMM \'del\' y|EEEE, d MMMM \'del\' y|de gen.|de febr.|de març|d’abr.|de maig|de juny|de jul.|d’ag.|de set.|d’oct.|de nov.|de des.|de gener|de febrer|de març|d’abril|de maig|de juny|de juliol|d’agost|de setembre|d’octubre|de novembre|de desembre|GN|FB|MÇ|AB|MG|JN|JL|AG|ST|OC|NV|DS|1|gen.|febr.|març|abr.|maig|juny|jul.|ag.|set.|oct.|nov.|des.|gener|febrer|març|abril|maig|juny|juliol|agost|setembre|octubre|novembre|desembre|GN|FB|MÇ|AB|MG|JN|JL|AG|ST|OC|NV|DS|dg.|dl.|dt.|dc.|dj.|dv.|ds.|diumenge|dilluns|dimarts|dimecres|dijous|divendres|dissabte|dg.|dl.|dt.|dc.|dj.|dv.|ds.|0|aC|dC|abans de Crist|després de Crist|aC|dC|H:mm|H:mm:ss|H:mm:ss z|H:mm:ss (zzzz)|{1} {0}|{1}, {0}|{1}, {0}|{1}, {0}|59|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E h:mm\u202Fa|EHm|E H:mm|Ehms|E h:mm:ss\u202Fa|EHms|E H:mm:ss|Gy|y G|GyMd|dd-MM-y GGGGG|GyMMM|LLL y G|GyMMMd|d MMM \'del\' y G|GyMMMEd|E, d MMM \'del\' y G|GyMMMM|LLLL \'del\' y G|GyMMMMd|d MMMM \'del\' y G|GyMMMMEd|E, d MMMM \'del\' y G|h|h\u202Fa|H|H|hm|h:mm\u202Fa|Hm|H:mm|hms|h:mm:ss\u202Fa|Hms|H:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|H:mm:ss v|hmsvvvv|h:mm:ss\u202Fa (vvvv)|Hmsvvvv|H:mm:ss (vvvv)|hmv|h:mm\u202Fa v|Hmv|H:mm v|hmvvvv|h:mm\u202Fa (vvvv)|Hmvvvv|H:mm (vvvv)|M|L|Md|d/M|MEd|E d/M|MMM|LLL|MMMd|d MMM|MMMEd|E, d MMM|MMMMd|d MMMM|MMMMEd|E, d MMMM|MMMMW-count-one|\'setmana\' W MMMM|MMMMW-count-other|\'setmana\' W MMMM|ms|mm:ss|y|y|yM|M/y|yMd|d/M/y|yMEd|E, d/M/y|yMMM|LLL \'del\' y|yMMMd|d MMM \'del\' y|yMMMEd|E, d MMM y|yMMMM|LLLL \'del\' y|yMMMMd|d MMMM \'del\' y|yMMMMEd|E, d MMMM \'del\' y|yQQQ|QQQ y|yQQQQ|QQQQ \'del\' y|yw-count-one|\'setmana\' w \'del\' Y|yw-count-other|\'setmana\' w \'del\' Y|Hmm|Hmmss|Hmmssz|Hmmsszzzz|X3W.|,|-||||||E2W.|,|-|\u00A0¤||\u00A0¤||\u00A0¤|E0W.|,|-|\u00A0%||\u00A0%||\u00A0%|107|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|AU$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|BRL|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CAD|CLP|$|CNY|CNY|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MXN|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|USD|UYU|$|VEF|Bs F|VND|₫|XAF|FCFA|XCD|XCD|XCG|Cg.|XOF|F\u202FCFA|XPF|CFPF|XXX|XXX|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$ca = $enkidatron$elm_cldr$Generated$Ca$ca;
var $enkidatron$elm_cldr$Generated$Chr$dayPeriods = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			'chr',
			_List_fromArray(
				[
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(12, 0),
					_Utils_Tuple2(24, 0),
					'afternoon1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(0, 0),
					_Utils_Tuple2(12, 0),
					'morning1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(12, 0),
					'noon')
				]))
		]));
var $enkidatron$elm_cldr$Generated$Chr$chr = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Chr$dayPeriods, 'chr||||ᏌᎾᎴ|ᏒᎯᏱᎢ|5|afternoon1|ᏒᎯᏱᎢᏗᏢ|am|ᏌᎾᎴ|morning1|ᏌᎾᎴ|noon|ᎢᎦ|pm|ᏒᎯᏱᎢ|ᏌᎾᎴ|ᏒᎯᏱᎢᏗᏢ|5|afternoon1|ᏒᎯᏱᎢᏗᏢ|am|ᏌᎾᎴ|morning1|ᏌᎾᎴ|noon|ᎢᎦ|pm|ᏒᎯᏱᎢᏗᏢ|Ꮜ|Ꮢ|5|afternoon1|ᏒᎯᏱᎢᏗᏢ|am|Ꮜ|morning1|ᏌᎾᎴ|noon|Ꭲ|pm|Ꮢ|M/d/yy|MMM d, y|MMMM d, y|EEEE, MMMM d, y|ᎤᏃ|ᎧᎦ|ᎠᏅ|ᎧᏬ|ᎠᏂ|ᏕᎭ|ᎫᏰ|ᎦᎶ|ᏚᎵ|ᏚᏂ|ᏅᏓ|ᎥᏍ|ᎤᏃᎸᏔᏅ|ᎧᎦᎵ|ᎠᏅᏱ|ᎧᏬᏂ|ᎠᏂᏍᎬᏘ|ᏕᎭᎷᏱ|ᎫᏰᏉᏂ|ᎦᎶᏂ|ᏚᎵᏍᏗ|ᏚᏂᏅᏗ|ᏅᏓᏕᏆ|ᎥᏍᎩᏱ|Ꭴ|Ꭷ|Ꭰ|Ꭷ|Ꭰ|Ꮥ|Ꭻ|Ꭶ|Ꮪ|Ꮪ|Ꮕ|Ꭵ|0|ᏆᏍᎬ|ᏉᏅᎯ|ᏔᎵᏁ|ᏦᎢᏁ|ᏅᎩᏁ|ᏧᎾᎩ|ᏈᏕᎾ|ᎤᎾᏙᏓᏆᏍᎬ|ᎤᎾᏙᏓᏉᏅᎯ|ᏔᎵᏁᎢᎦ|ᏦᎢᏁᎢᎦ|ᏅᎩᏁᎢᎦ|ᏧᎾᎩᎶᏍᏗ|ᎤᎾᏙᏓᏈᏕᎾ|Ꮖ|Ꮙ|Ꮤ|Ꮶ|Ꮕ|Ꮷ|Ꭴ|0|BC|AD|ᏧᏓᎷᎸ ᎤᎷᎯᏍᏗ ᎦᎶᏁᏛ|ᎠᏃ ᏙᎻᏂ|BC|AD|h:mm a|h:mm:ss a|h:mm:ss a z|h:mm:ss a zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|49|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|d E|Ehm|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss a|EHms|E HH:mm:ss|Gy|y G|GyMd|M/d/y GGGGG|GyMMM|MMM y G|GyMMMd|MMM d, y G|GyMMMEd|E, MMM d, y G|h|h\u202Fa|H|HH|hm|h:mm a|Hm|HH:mm|hms|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm a v|Hmv|HH:mm v|M|L|Md|M/d|MEd|E, M/d|MMM|LLL|MMMd|MMM d|MMMEd|E, MMM d|MMMMd|MMMM d|MMMMW-count-one|ᏒᎾᏙᏓᏆᏍᏗ W ᎾᎿ MMMM|MMMMW-count-other|ᏒᎾᏙᏓᏆᏍᏗ W ᎾᎿ MMMM|ms|mm:ss|y|y|yM|M/y|yMd|M/d/y|yMEd|E, M/d/y|yMMM|MMM y|yMMMd|MMM d, y|yMMMEd|E, MMM d, y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|’ᏒᎾᏙᏓᏆᏍᏗ’ w ’ᎾᎿ’ Y|yw-count-other|’ᏒᎾᏙᏓᏆᏍᏗ’ w ’ᎾᎿ’ Y|ahmm|ahmmss|ahmmssz|ahmmsszzzz|X3W,|.|-||||||E2W,|.|-¤||¤||¤||E0W,|.|-|%||%||%|107|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XCG|Cg.|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$chr = $enkidatron$elm_cldr$Generated$Chr$chr;
var $enkidatron$elm_cldr$Generated$Cs$dayPeriods = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			'cs',
			_List_fromArray(
				[
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(12, 0),
					_Utils_Tuple2(18, 0),
					'afternoon1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(18, 0),
					_Utils_Tuple2(22, 0),
					'evening1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(0, 0),
					'midnight'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(4, 0),
					_Utils_Tuple2(9, 0),
					'morning1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(9, 0),
					_Utils_Tuple2(12, 0),
					'morning2'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(22, 0),
					_Utils_Tuple2(4, 0),
					'night1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(12, 0),
					'noon')
				]))
		]));
var $enkidatron$elm_cldr$Generated$Cs$cs = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Cs$dayPeriods, 'cs||||dop.|odp.|9|afternoon1|odp.|am|dop.|evening1|več.|midnight|půln.|morning1|r.|morning2|dop.|night1|v n.|noon|pol.|pm|odp.|dop.|odp.|9|afternoon1|odpoledne|am|dop.|evening1|večer|midnight|půlnoc|morning1|ráno|morning2|dopoledne|night1|v noci|noon|poledne|pm|odp.|dop.|odp.|9|afternoon1|o.|am|dop.|evening1|v.|midnight|půl.|morning1|r.|morning2|d.|night1|n.|noon|pol.|pm|odp.|dd.MM.yy|d. M. y|d. MMMM y|EEEE d. MMMM y|led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro|ledna|února|března|dubna|května|června|července|srpna|září|října|listopadu|prosince|1|2|3|4|5|6|7|8|9|10|11|12|1|led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro|leden|únor|březen|duben|květen|červen|červenec|srpen|září|říjen|listopad|prosinec|1|2|3|4|5|6|7|8|9|10|11|12|ne|po|út|st|čt|pá|so|neděle|pondělí|úterý|středa|čtvrtek|pátek|sobota|N|P|Ú|S|Č|P|S|0|př. n. l.|n. l.|před naším letopočtem|našeho letopočtu|př.n.l.|n.l.|H:mm|H:mm:ss|H:mm:ss z|H:mm:ss, zzzz|{1} {0}|{1} {0}|{1} {0}|{1} {0}|62|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d.|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d.|Ehm|E h:mm\u202Fa|EHm|E H:mm|Ehms|E h:mm:ss\u202Fa|EHms|E H:mm:ss|Gy|y G|GyMd|d. M. y GGGGG|GyMMM|LLLL y G|GyMMMd|d. M. y G|GyMMMEd|E d. M. y G|GyMMMMd|d. MMMM y G|GyMMMMEd|E d. MMMM y G|h|h\u202Fa|H|H|hm|h:mm\u202Fa|Hm|H:mm|hms|h:mm:ss\u202Fa|Hms|H:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|H:mm:ss v|hmsvvvv|h:mm:ss\u202Fa, vvvv|Hmsvvvv|H:mm:ss, vvvv|hmv|h:mm\u202Fa v|Hmv|H:mm v|hmvvvv|h:mm\u202Fa, vvvv|Hmvvvv|H:mm, vvvv|M|L|Md|d. M.|MEd|E d. M.|MMM|LLL|MMMd|d. M.|MMMEd|E d. M.|MMMMd|d. MMMM|MMMMEd|E d. MMMM|MMMMW-count-one|W. \'týden\' MMMM|MMMMW-count-few|W. \'týden\' MMMM|MMMMW-count-many|W. \'týden\' MMMM|MMMMW-count-other|W. \'týden\' MMMM|ms|mm:ss|y|y|yM|M/y|yMd|d. M. y|yMEd|E d. M. y|yMMM|LLLL y|yMMMd|d. M. y|yMMMEd|E d. M. y|yMMMM|LLLL y|yMMMMd|d. MMMM y|yMMMMEd|E d. MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|w. \'týden\' \'roku\' Y|yw-count-few|w. \'týden\' \'roku\' Y|yw-count-many|w. \'týden\' \'roku\' Y|yw-count-other|w. \'týden\' \'roku\' Y|Hmm|Hmmss|Hmmssz|Hmmsszzzz|X3W\u00A0|,|-||||||E2W\u00A0|,|-|\u00A0¤||\u00A0¤||\u00A0¤|E0W\u00A0|,|-|\u00A0%||\u00A0%||\u00A0%|110|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|AU$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CSK|Kčs|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|ILS|INR|INR|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|L|RUB|₽|RUR|р.|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|VND|XAF|FCFA|XCD|EC$|XCG|Cg.|XEU|ECU|XOF|F\u202FCFA|XPF|CFPF|XXX|XXX|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$cs = $enkidatron$elm_cldr$Generated$Cs$cs;
var $enkidatron$elm_cldr$Generated$Cy$dayPeriods = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			'cy',
			_List_fromArray(
				[
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(12, 0),
					_Utils_Tuple2(18, 0),
					'afternoon1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(18, 0),
					_Utils_Tuple2(24, 0),
					'evening1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(0, 0),
					'midnight'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(0, 0),
					_Utils_Tuple2(12, 0),
					'morning1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(12, 0),
					'noon')
				]))
		]));
var $enkidatron$elm_cldr$Generated$Cy$cy = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Cy$dayPeriods, 'cy||||AM|PM|7|afternoon1|y prynhawn|am|AM|evening1|yr hwyr|midnight|canol nos|morning1|y bore|noon|canol dydd|pm|PM|yb|yh|7|afternoon1|y prynhawn|am|yb|evening1|yr hwyr|midnight|canol nos|morning1|y bore|noon|canol dydd|pm|yh|b|h|7|afternoon1|yn y prynhawn|am|b|evening1|min nos|midnight|canol nos|morning1|yn y bore|noon|canol dydd|pm|h|dd/MM/yy|d MMM y|d MMMM y|EEEE, d MMMM y|Ion|Chwef|Maw|Ebr|Mai|Meh|Gorff|Awst|Medi|Hyd|Tach|Rhag|Ionawr|Chwefror|Mawrth|Ebrill|Mai|Mehefin|Gorffennaf|Awst|Medi|Hydref|Tachwedd|Rhagfyr|I|Ch|M|E|M|M|G|A|M|H|T|Rh|1|Ion|Chw|Maw|Ebr|Mai|Meh|Gor|Awst|Medi|Hyd|Tach|Rhag|Ionawr|Chwefror|Mawrth|Ebrill|Mai|Mehefin|Gorffennaf|Awst|Medi|Hydref|Tachwedd|Rhagfyr|I|Ch|M|E|M|M|G|A|M|H|T|Rh|Sul|Llun|Maw|Mer|Iau|Gwen|Sad|Dydd Sul|Dydd Llun|Dydd Mawrth|Dydd Mercher|Dydd Iau|Dydd Gwener|Dydd Sadwrn|S|Ll|M|M|I|G|S|1|Sul|Llun|Maw|Mer|Iau|Gwe|Sad|Dydd Sul|Dydd Llun|Dydd Mawrth|Dydd Mercher|Dydd Iau|Dydd Gwener|Dydd Sadwrn|S|Ll|M|M|I|G|S|CC|OC|Cyn Crist|Oed Crist|C|O|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1} {0}|{1} {0}|{1}, {0}|{1}, {0}|58|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|d, E|Ehm|E, h:mm\u202Fa|EHm|E, HH:mm|Ehms|E, h:mm:ss\u202Fa|EHms|E, HH:mm:ss|Gy|y G|GyMd|M/d/y GGGGG|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E, d MMM y G|h|h\u202Fa|H|HH|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|Hmv|HH:mm v|M|L|Md|d/M|MEd|E, d/M|MMM|LLL|MMMd|d MMM|MMMEd|E, d MMM|MMMMd|MMMM d|MMMMW-count-zero|\'wythnos\' W \'o\' MMMM|MMMMW-count-one|\'wythnos\' W \'o\' MMMM|MMMMW-count-two|\'wythnos\' W \'o\' MMMM|MMMMW-count-few|\'wythnos\' W \'o\' MMMM|MMMMW-count-many|\'wythnos\' W \'o\' MMMM|MMMMW-count-other|\'wythnos\' W \'o\' MMMM|ms|mm:ss|y|y|yM|M/y|yMd|d/M/y|yMEd|E, d/M/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E, d MMM y|yMMMM|MMMM y|yQ|Q y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-zero|\'wythnos\' w \'o\' Y|yw-count-one|\'wythnos\' w \'o\' Y|yw-count-two|\'wythnos\' w \'o\' Y|yw-count-few|\'wythnos\' w \'o\' Y|yw-count-many|\'wythnos\' w \'o\' Y|yw-count-other|\'wythnos\' w \'o\' Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W,|.|-||||||E2W,|.|-¤||¤||¤||E0W,|.|-|%||%||%|107|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|TK|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|BWP|BYN|р.|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|KRW|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XCG|Cg.|XOF|F\u202FCFA|XPF|CFPF|XXX|XXX|ZAR|ZAR|ZMW|ZMW|'));
var $enkidatron$elm_cldr$Cldr$Locale$cy = $enkidatron$elm_cldr$Generated$Cy$cy;
var $enkidatron$elm_cldr$Generated$Da$dayPeriods = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			'da',
			_List_fromArray(
				[
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(12, 0),
					_Utils_Tuple2(18, 0),
					'afternoon1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(18, 0),
					_Utils_Tuple2(24, 0),
					'evening1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(0, 0),
					'midnight'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(5, 0),
					_Utils_Tuple2(10, 0),
					'morning1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(10, 0),
					_Utils_Tuple2(12, 0),
					'morning2'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(0, 0),
					_Utils_Tuple2(5, 0),
					'night1')
				]))
		]));
var $enkidatron$elm_cldr$Generated$Da$da = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Da$dayPeriods, 'da||||AM|PM|8|afternoon1|om eftermiddagen|am|AM|evening1|om aftenen|midnight|midnat|morning1|om morgenen|morning2|om formiddagen|night1|om natten|pm|PM|AM|PM|8|afternoon1|om eftermiddagen|am|AM|evening1|om aftenen|midnight|midnat|morning1|om morgenen|morning2|om formiddagen|night1|om natten|pm|PM|a|p|8|afternoon1|om eftermiddagen|am|a|evening1|om aftenen|midnight|midnat|morning1|om morgenen|morning2|om formiddagen|night1|om natten|pm|p|dd.MM.y|d. MMM y|d. MMMM y|EEEE \'den\' d. MMMM y|jan.|feb.|mar.|apr.|maj|jun.|jul.|aug.|sep.|okt.|nov.|dec.|januar|februar|marts|april|maj|juni|juli|august|september|oktober|november|december|J|F|M|A|M|J|J|A|S|O|N|D|0|søn.|man.|tirs.|ons.|tors.|fre.|lør.|søndag|mandag|tirsdag|onsdag|torsdag|fredag|lørdag|S|M|T|O|T|F|L|0|f.Kr.|e.Kr.|før Kristus|efter Kristus|fKr|eKr|HH.mm|HH.mm.ss|HH.mm.ss z|HH.mm.ss zzzz|{1} {0}|{1} {0}|{1} {0}|{1} {0}|52|Bh|h B|Bhm|h.mm B|Bhms|h.mm.ss B|d|d.|E|ccc|EBhm|E h.mm B|EBhms|E h.mm.ss B|Ed|E \'den\' d.|Ehm|E h.mm\u202Fa|EHm|E HH.mm|Ehms|E h.mm.ss\u202Fa|EHms|E HH.mm.ss|Gy|y G|GyMd|d.M.y GGGGG|GyMMM|MMM y G|GyMMMd|d. MMM y G|GyMMMEd|E d. MMM y G|h|h\u202Fa|H|HH|hm|h.mm\u202Fa|Hm|HH.mm|hms|h.mm.ss\u202Fa|Hms|HH.mm.ss|hmsv|h.mm.ss\u202Fa v|Hmsv|HH.mm.ss v|hmv|h.mm\u202Fa v|Hmv|HH.mm v|M|M|Md|d.M|MEd|E d.M|MMdd|dd.MM|MMM|MMM|MMMd|d. MMM|MMMEd|E d. MMM|MMMMd|d. MMMM|MMMMEd|E d. MMMM|MMMMW-count-one|W. \'uge\' \'i\' MMMM|MMMMW-count-other|W. \'uge\' \'i\' MMMM|ms|mm.ss|y|y|yM|M.y|yMd|d.M.y|yMEd|E d.M.y|yMM|MM.y|yMMM|MMM y|yMMMd|d. MMM y|yMMMEd|E d. MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\'uge\' w \'i\' Y|yw-count-other|\'uge\' w \'i\' Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W.|,|-||||||E2W.|,|-|\u00A0¤||\u00A0¤||\u00A0¤|E0W.|,|-|\u00A0%||\u00A0%||\u00A0%|107|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|AU$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|Br.|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr.|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr.|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr.|NPR|Rs|NZD|NZ$|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|L|RUB|₽|RWF|RF|SBD|$|SEK|kr.|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XCG|Cg.|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$da = $enkidatron$elm_cldr$Generated$Da$da;
var $enkidatron$elm_cldr$Generated$De$dayPeriods = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			'de',
			_List_fromArray(
				[
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(12, 0),
					_Utils_Tuple2(13, 0),
					'afternoon1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(13, 0),
					_Utils_Tuple2(18, 0),
					'afternoon2'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(18, 0),
					_Utils_Tuple2(24, 0),
					'evening1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(0, 0),
					'midnight'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(5, 0),
					_Utils_Tuple2(10, 0),
					'morning1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(10, 0),
					_Utils_Tuple2(12, 0),
					'morning2'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(0, 0),
					_Utils_Tuple2(5, 0),
					'night1')
				]))
		]));
var $enkidatron$elm_cldr$Generated$De$de = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$De$dayPeriods, 'de||||AM|PM|9|afternoon1|mittags|afternoon2|nachm.|am|AM|evening1|abends|midnight|Mitternacht|morning1|morgens|morning2|vorm.|night1|nachts|pm|PM|AM|PM|9|afternoon1|mittags|afternoon2|nachmittags|am|AM|evening1|abends|midnight|Mitternacht|morning1|morgens|morning2|vormittags|night1|nachts|pm|PM|AM|PM|9|afternoon1|mittags|afternoon2|nachm.|am|AM|evening1|abends|midnight|Mitternacht|morning1|morgens|morning2|vorm.|night1|nachts|pm|PM|dd.MM.yy|dd.MM.y|d. MMMM y|EEEE, d. MMMM y|Jan.|Feb.|März|Apr.|Mai|Juni|Juli|Aug.|Sept.|Okt.|Nov.|Dez.|Januar|Februar|März|April|Mai|Juni|Juli|August|September|Oktober|November|Dezember|J|F|M|A|M|J|J|A|S|O|N|D|1|Jan|Feb|Mär|Apr|Mai|Jun|Jul|Aug|Sep|Okt|Nov|Dez|Januar|Februar|März|April|Mai|Juni|Juli|August|September|Oktober|November|Dezember|J|F|M|A|M|J|J|A|S|O|N|D|So.|Mo.|Di.|Mi.|Do.|Fr.|Sa.|Sonntag|Montag|Dienstag|Mittwoch|Donnerstag|Freitag|Samstag|S|M|D|M|D|F|S|1|So|Mo|Di|Mi|Do|Fr|Sa|Sonntag|Montag|Dienstag|Mittwoch|Donnerstag|Freitag|Samstag|S|M|D|M|D|F|S|v. Chr.|n. Chr.|v. Chr.|n. Chr.|v. Chr.|n. Chr.|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|54|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E, d.|Ehm|E h:mm\u202Fa|EHm|E, HH:mm|Ehms|E, h:mm:ss\u202Fa|EHms|E, HH:mm:ss|Gy|y G|GyMd|dd.MM.y G|GyMMM|MMM y G|GyMMMd|d. MMM y G|GyMMMEd|E, d. MMM y G|h|h \'Uhr\' a|H|HH \'Uhr\'|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|Hmv|HH:mm v|M|L|Md|d.M.|MEd|E, d.M.|MMd|d.MM.|MMdd|dd.MM.|MMM|LLL|MMMd|d. MMM|MMMEd|E, d. MMM|MMMMd|d. MMMM|MMMMEd|E, d. MMMM|MMMMW-count-one|\'Woche\' W \'im\' MMMM|MMMMW-count-other|\'Woche\' W \'im\' MMMM|ms|mm:ss|y|y|yM|M/y|yMd|d.M.y|yMEd|E, d.M.y|yMM|MM.y|yMMdd|dd.MM.y|yMMM|MMM y|yMMMd|d. MMM y|yMMMEd|E, d. MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\'Woche\' w \'des\' \'Jahres\' Y|yw-count-other|\'Woche\' w \'des\' \'Jahres\' Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W.|,|-||||||E2W.|,|-|\u00A0¤||\u00A0¤||\u00A0¤|E0W.|,|-|\u00A0%||\u00A0%||\u00A0%|112|AFN|؋|AMD|֏|AOA|Kz|ARS|$|ATS|öS|AUD|AU$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BGM|BGK|BGO|BGJ|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|Cub$|CUP|$|CZK|Kč|DEM|DM|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|Fl£|GBP|£|GEL|₾|GHS|₵|GIP|£|GNF|F.G.|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|¥|KGS|\u20C0|KHR|៛|KMF|FC|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|L|RUB|₽|RUR|р.|RWF|F.Rw|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|SYP|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XCG|Cg.|XOF|F\u202FCFA|XPF|CFPF|XXX|XXX|ZAR|R|ZMW|K|'));
var $enkidatron$elm_cldr$Cldr$Locale$de = $enkidatron$elm_cldr$Generated$De$de;
var $enkidatron$elm_cldr$Generated$Dsb$dayPeriods = $elm$core$Dict$fromList(_List_Nil);
var $enkidatron$elm_cldr$Generated$Dsb$dsb = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Dsb$dayPeriods, 'dsb||||dop.|wótp.|2|am|dop.|pm|wótp.|dopołdnja|wótpołdnja|2|am|dopołdnja|pm|wótpołdnja|dop.|wótp.|2|am|dop.|pm|wótp.|d.M.yy|d.M.y|d. MMMM y|EEEE, d. MMMM y|jan.|feb.|měr.|apr.|maj.|jun.|jul.|awg.|sep.|okt.|now.|dec.|januara|februara|měrca|apryla|maja|junija|julija|awgusta|septembra|oktobra|nowembra|decembra|j|f|m|a|m|j|j|a|s|o|n|d|1|jan|feb|měr|apr|maj|jun|jul|awg|sep|okt|now|dec|januar|februar|měrc|apryl|maj|junij|julij|awgust|september|oktober|nowember|december|j|f|m|a|m|j|j|a|s|o|n|d|nje|pón|wał|srj|stw|pět|sob|njeźela|pónjeźele|wałtora|srjoda|stwórtk|pětk|sobota|n|p|w|s|s|p|s|0|pś.Chr.n.|pó Chr.n.|pśed Kristusowym naroźenim|pó Kristusowem naroźenju|pś.Chr.n.|pó Chr.n.|H:mm|H:mm:ss|H:mm:ss z|H:mm:ss zzzz|{1} {0}|{1} {0}|{1} {0}|{1} {0}|53|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d.|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E, d.|Ehm|E, h:mm\u202Fa|EHm|E, \'zeg\'. H:mm|Ehms|E, h:mm:ss\u202Fa|EHms|E, HH:mm:ss|Gy|y G|GyMd|d.M.y GGGGG|GyMMM|MMM y G|GyMMMd|d. MMM y G|GyMMMEd|E, d. MMM y G|h|h\u202Fa|H|\'zeg\'. H|hm|h:mm\u202Fa|Hm|\'zeg\'. H:mm|hms|h:mm:ss\u202Fa|Hms|H:mm:ss|hmsv|h:mm:ss a v|Hmsv|H:mm:ss v|hmv|h:mm a v|Hmv|H:mm v|M|L|Md|d.M.|MEd|E, d.M.|MMM|LLL|MMMd|d. MMM|MMMEd|E, d. MMM|MMMMd|d. MMMM|MMMMW-count-one|W. \'tyźeń\' MMMM|MMMMW-count-two|W. \'tyźeń\' MMMM|MMMMW-count-few|W. \'tyźeń\' MMMM|MMMMW-count-other|W. \'tyźeń\' MMMM|ms|mm:ss|y|y|yM|M.y|yMd|d.M.y|yMEd|E, d.M.y|yMMM|MMM y|yMMMd|d. MMM y|yMMMEd|E, d. MMM y|yMMMM|LLLL y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|w. \'tyźeń\' \'lěta\' Y|yw-count-two|w. \'tyźeń\' \'lěta\' Y|yw-count-few|w. \'tyźeń\' \'lěta\' Y|yw-count-other|w. \'tyźeń\' \'lěta\' Y|Hmm|Hmmss|Hmmssz|Hmmsszzzz|X3W.|,|-||||||E2W.|,|-|\u00A0¤||\u00A0¤||\u00A0¤|E0W.|,|-|\u00A0%||\u00A0%||\u00A0%|106|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|AUD|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|₱|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XCG|Cg.|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$dsb = $enkidatron$elm_cldr$Generated$Dsb$dsb;
var $enkidatron$elm_cldr$Generated$El$dayPeriods = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			'el',
			_List_fromArray(
				[
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(12, 0),
					_Utils_Tuple2(17, 0),
					'afternoon1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(17, 0),
					_Utils_Tuple2(20, 0),
					'evening1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(4, 0),
					_Utils_Tuple2(12, 0),
					'morning1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(20, 0),
					_Utils_Tuple2(4, 0),
					'night1')
				]))
		]));
var $enkidatron$elm_cldr$Generated$El$el = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$El$dayPeriods, 'el||||π.μ.|μ.μ.|6|afternoon1|μεσημ.|am|π.μ.|evening1|απόγ.|morning1|πρωί|night1|βράδυ|pm|μ.μ.|π.μ.|μ.μ.|6|afternoon1|το μεσημέρι|am|π.μ.|evening1|το απόγευμα|morning1|το πρωί|night1|το βράδυ|pm|μ.μ.|πμ|μμ|6|afternoon1|μεσημ.|am|πμ|evening1|απόγ.|morning1|πρωί|night1|βράδυ|pm|μμ|d/M/yy|d MMM y|d MMMM y|EEEE d MMMM y|Ιαν|Φεβ|Μαρ|Απρ|Μαΐ|Ιουν|Ιουλ|Αυγ|Σεπ|Οκτ|Νοε|Δεκ|Ιανουαρίου|Φεβρουαρίου|Μαρτίου|Απριλίου|Μαΐου|Ιουνίου|Ιουλίου|Αυγούστου|Σεπτεμβρίου|Οκτωβρίου|Νοεμβρίου|Δεκεμβρίου|Ι|Φ|Μ|Α|Μ|Ι|Ι|Α|Σ|Ο|Ν|Δ|1|Ιαν|Φεβ|Μάρ|Απρ|Μάι|Ιούν|Ιούλ|Αύγ|Σεπ|Οκτ|Νοέ|Δεκ|Ιανουάριος|Φεβρουάριος|Μάρτιος|Απρίλιος|Μάιος|Ιούνιος|Ιούλιος|Αύγουστος|Σεπτέμβριος|Οκτώβριος|Νοέμβριος|Δεκέμβριος|Ι|Φ|Μ|Α|Μ|Ι|Ι|Α|Σ|Ο|Ν|Δ|Κυρ|Δευ|Τρί|Τετ|Πέμ|Παρ|Σάβ|Κυριακή|Δευτέρα|Τρίτη|Τετάρτη|Πέμπτη|Παρασκευή|Σάββατο|Κ|Δ|Τ|Τ|Π|Π|Σ|0|π.Χ.|μ.Χ.|προ Χριστού|μετά Χριστόν|π.Χ.|μ.Χ.|h:mm\u202Fa|h:mm:ss\u202Fa|h:mm:ss\u202Fa z|h:mm:ss\u202Fa zzzz|{1}, {0}|{1}, {0}|{1} - {0}|{1} - {0}|50|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E h:mm\u202Fa|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|EHms|E HH:mm:ss|Gy|y G|GyMd|d/M/y GGGGG|GyMMM|LLL y G|GyMMMd|d MMM y G|GyMMMEd|E d MMM y G|h|h\u202Fa|H|HH|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|Hmv|HH:mm v|M|L|Md|d/M|MEd|E d/M|MMM|MMM|MMMd|d MMM|MMMEd|E d MMM|MMMMd|d MMMM|MMMMEd|E d MMMM|MMMMW-count-one|εβδομάδα W του MMMM|MMMMW-count-other|εβδομάδα W του MMMM|ms|mm:ss|y|y|yM|M/y|yMd|d/M/y|yMEd|E d/M/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E d MMM y|yMMMM|LLLL y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|εβδομάδα w του Y|yw-count-other|εβδομάδα w του Y|ahmm|ahmmss|ahmmssz|ahmmsszzzz|X3W.|,|-||||||E2W.|,|-|\u00A0¤||\u00A0¤||\u00A0¤|E0W.|,|-|%||%||%|108|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GRD|Δρχ|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XCG|Cg.|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$el = $enkidatron$elm_cldr$Generated$El$el;
var $enkidatron$elm_cldr$Generated$En$dayPeriods = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			'en',
			_List_fromArray(
				[
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(12, 0),
					_Utils_Tuple2(18, 0),
					'afternoon1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(18, 0),
					_Utils_Tuple2(21, 0),
					'evening1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(0, 0),
					'midnight'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(0, 0),
					_Utils_Tuple2(12, 0),
					'morning1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(21, 0),
					_Utils_Tuple2(24, 0),
					'night1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(12, 0),
					'noon')
				]))
		]));
var $enkidatron$elm_cldr$Generated$En$en = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$En$dayPeriods, 'en||||AM|PM|10|afternoon1|in the afternoon|am|AM|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|PM|pm-alt-variant|pm|AM|PM|10|afternoon1|in the afternoon|am|AM|am-alt-variant|am|evening1|in the evening|midnight|midnight|morning1|in the morning|night1|at night|noon|noon|pm|PM|pm-alt-variant|pm|a|p|10|afternoon1|in the afternoon|am|a|am-alt-variant|am|evening1|in the evening|midnight|mi|morning1|in the morning|night1|at night|noon|n|pm|p|pm-alt-variant|pm|M/d/yy|MMM d, y|MMMM d, y|EEEE, MMMM d, y|Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec|January|February|March|April|May|June|July|August|September|October|November|December|J|F|M|A|M|J|J|A|S|O|N|D|0|Sun|Mon|Tue|Wed|Thu|Fri|Sat|Sunday|Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|S|M|T|W|T|F|S|0|BC|AD|Before Christ|Anno Domini|B|A|h:mm\u202Fa|h:mm:ss\u202Fa|h:mm:ss\u202Fa z|h:mm:ss\u202Fa zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|56|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|d E|Ehm|E h:mm\u202Fa|Ehm-alt-ascii|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|Ehms-alt-ascii|E h:mm:ss a|EHms|E HH:mm:ss|Gy|y G|GyMd|M/d/y G|GyMMM|MMM y G|GyMMMd|MMM d, y G|GyMMMEd|E, MMM d, y G|h|h\u202Fa|h-alt-ascii|h a|H|HH|hm|h:mm\u202Fa|hm-alt-ascii|h:mm a|Hm|HH:mm|hms|h:mm:ss\u202Fa|hms-alt-ascii|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|hmsv-alt-ascii|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|hmv-alt-ascii|h:mm a v|Hmv|HH:mm v|M|L|Md|M/d|MEd|E, M/d|MMM|LLL|MMMd|MMM d|MMMEd|E, MMM d|MMMMd|MMMM d|MMMMW-count-one|\'week\' W \'of\' MMMM|MMMMW-count-other|\'week\' W \'of\' MMMM|ms|mm:ss|y|y|yM|M/y|yMd|M/d/y|yMEd|E, M/d/y|yMMM|MMM y|yMMMd|MMM d, y|yMMMEd|E, MMM d, y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\'week\' w \'of\' Y|yw-count-other|\'week\' w \'of\' Y|ahmm|ahmmss|ahmmssz|ahmmsszzzz|X3W,|.|-||||||E2W,|.|-¤||¤||¤||E0W,|.|-|%||%||%|164|AED|AED|AFN|AFN|ALL|ALL|AMD|AMD|ANG|ANG|AOA|AOA|ARS|ARS|AUD|A$|AWG|AWG|AZN|AZN|BAM|BAM|BBD|BBD|BDT|BDT|BGN|BGN|BHD|BHD|BIF|BIF|BMD|BMD|BND|BND|BOB|BOB|BRL|R$|BSD|BSD|BTN|BTN|BWP|BWP|BYN|BYN|BZD|BZD|CAD|CA$|CDF|CDF|CHF|CHF|CLP|CLP|CNH|CNH|CNY|CN¥|COP|COP|CRC|CRC|CUC|CUC|CUP|CUP|CVE|CVE|CZK|CZK|DJF|DJF|DKK|DKK|DOP|DOP|DZD|DZD|EGP|EGP|ERN|ERN|ESP|₧|ETB|ETB|EUR|€|FJD|FJD|FKP|FKP|GBP|£|GEL|GEL|GHS|GHS|GIP|GIP|GMD|GMD|GNF|GNF|GTQ|GTQ|GYD|GYD|HKD|HK$|HNL|HNL|HRK|HRK|HTG|HTG|HUF|HUF|IDR|IDR|ILS|₪|INR|₹|IQD|IQD|IRR|IRR|ISK|ISK|JMD|JMD|JOD|JOD|JPY|¥|KES|KES|KGS|KGS|KHR|KHR|KMF|KMF|KPW|KPW|KRW|₩|KWD|KWD|KYD|KYD|KZT|KZT|LAK|LAK|LBP|LBP|LKR|LKR|LRD|LRD|LSL|LSL|LTL|Lt|LVL|Ls|LYD|LYD|MAD|MAD|MDL|MDL|MGA|MGA|MKD|MKD|MMK|MMK|MNT|MNT|MOP|MOP|MRU|MRU|MUR|MUR|MVR|MVR|MWK|MWK|MXN|MX$|MYR|MYR|MZN|MZN|NAD|NAD|NGN|NGN|NIO|NIO|NOK|NOK|NPR|NPR|NZD|NZ$|OMR|OMR|PAB|PAB|PEN|PEN|PGK|PGK|PHP|₱|PKR|PKR|PLN|PLN|PYG|PYG|QAR|QAR|RON|RON|RSD|RSD|RUB|RUB|RWF|RWF|SAR|SAR|SBD|SBD|SCR|SCR|SDG|SDG|SEK|SEK|SGD|SGD|SHP|SHP|SLE|SLE|SLL|SLL|SOS|SOS|SRD|SRD|SSP|SSP|STN|STN|SYP|SYP|SZL|SZL|THB|THB|TJS|TJS|TMT|TMT|TND|TND|TOP|TOP|TRY|TRY|TTD|TTD|TWD|NT$|TZS|TZS|UAH|UAH|UGX|UGX|USD|$|UYU|UYU|UZS|UZS|VEF|Bs|VES|VES|VND|₫|VUV|VUV|WST|WST|XAF|FCFA|XCD|EC$|XCG|Cg.|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|YER|YER|ZAR|ZAR|ZMW|ZMW|ZWG|ZWG|'));
var $enkidatron$elm_cldr$Cldr$Locale$en = $enkidatron$elm_cldr$Generated$En$en;
var $enkidatron$elm_cldr$Generated$Es$dayPeriods = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			'es',
			_List_fromArray(
				[
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(12, 0),
					_Utils_Tuple2(20, 0),
					'evening1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(0, 0),
					_Utils_Tuple2(6, 0),
					'morning1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(6, 0),
					_Utils_Tuple2(12, 0),
					'morning2'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(20, 0),
					_Utils_Tuple2(24, 0),
					'night1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(12, 0),
					'noon')
				])),
			_Utils_Tuple2(
			'es_co',
			_List_fromArray(
				[
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(12, 0),
					_Utils_Tuple2(20, 0),
					'evening1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(0, 0),
					_Utils_Tuple2(12, 0),
					'morning2'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(20, 0),
					_Utils_Tuple2(24, 0),
					'night1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(12, 0),
					'noon')
				]))
		]));
var $enkidatron$elm_cldr$Generated$Es$es = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Es$dayPeriods, 'es||||a.\u202Fm.|p.\u202Fm.|7|am|a.\u202Fm.|evening1|de la tarde|morning1|de la madrugada|morning2|de la mañana|night1|de la noche|noon|del mediodía|pm|p.\u202Fm.|a.\u00A0m.|p.\u00A0m.|7|am|a.\u00A0m.|evening1|de la tarde|morning1|de la madrugada|morning2|de la mañana|night1|de la noche|noon|del mediodía|pm|p.\u00A0m.|a.\u202Fm.|p.\u202Fm.|7|am|a.\u202Fm.|evening1|de la tarde|morning1|de la madrugada|morning2|de la mañana|night1|de la noche|noon|del mediodía|pm|p.\u202Fm.|d/M/yy|d MMM y|d \'de\' MMMM \'de\' y|EEEE, d \'de\' MMMM \'de\' y|ene|feb|mar|abr|may|jun|jul|ago|sept|oct|nov|dic|enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|E|F|M|A|M|J|J|A|S|O|N|D|0|dom|lun|mar|mié|jue|vie|sáb|domingo|lunes|martes|miércoles|jueves|viernes|sábado|D|L|M|X|J|V|S|0|a. C.|d. C.|antes de Cristo|después de Cristo|a. C.|d. C.|H:mm|H:mm:ss|H:mm:ss z|H:mm:ss (zzzz)|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|60|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E, h:mm\u202Fa|EHm|E, H:mm|Ehms|E, h:mm:ss\u202Fa|EHms|E, H:mm:ss|Gy|y G|GyMd|d/M/y GGGGG|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E, d MMM y G|GyMMMM|MMMM \'de\' y G|GyMMMMd|d \'de\' MMMM \'de\' y G|GyMMMMEd|E, d \'de\' MMMM \'de\' y G|h|h\u202Fa|H|H|hm|h:mm\u202Fa|Hm|H:mm|hms|h:mm:ss\u202Fa|Hms|H:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|H:mm:ss v|hmsvvvv|h:mm:ss\u202Fa (vvvv)|Hmsvvvv|H:mm:ss (vvvv)|hmv|h:mm\u202Fa v|Hmv|H:mm v|M|L|Md|d/M|MEd|E, d/M|MMd|d/M|MMdd|d/M|MMM|LLL|MMMd|d MMM|MMMEd|E, d MMM|MMMMd|d \'de\' MMMM|MMMMEd|E, d \'de\' MMMM|MMMMW-count-one|\'semana\' W \'de\' MMMM|MMMMW-count-other|\'semana\' W \'de\' MMMM|ms|mm:ss|y|y|yM|M/y|yMd|d/M/y|yMEd|EEE, d/M/y|yMM|M/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|EEE, d MMM y|yMMMM|MMMM \'de\' y|yMMMMd|d \'de\' MMMM \'de\' y|yMMMMEd|EEE, d \'de\' MMMM \'de\' y|yQQQ|QQQ y|yQQQQ|QQQQ \'de\' y|yw-count-one|\'semana\' w \'de\' Y|yw-count-other|\'semana\' w \'de\' Y|Hmm|Hmmss|Hmmssz|Hmmsszzzz|X3W.|,|-||||||E2W.|,|-|\u00A0¤||\u00A0¤||\u00A0¤|E0W.|,|-|\u00A0%||\u00A0%||\u00A0%|107|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|AUD|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|BRL|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CAD|CLP|$|CNY|CNY|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|EGP|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|GBP|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HKD|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|ILS|INR|INR|ISK|kr|JMD|$|JPY|JPY|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|KRW|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MXN|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZD|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|L|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|TWD|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|XAF|XCD|XCD|XCG|Cg.|XOF|XOF|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$es = $enkidatron$elm_cldr$Generated$Es$es;
var $enkidatron$elm_cldr$Generated$Et$dayPeriods = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			'et',
			_List_fromArray(
				[
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(12, 0),
					_Utils_Tuple2(18, 0),
					'afternoon1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(18, 0),
					_Utils_Tuple2(23, 0),
					'evening1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(0, 0),
					'midnight'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(5, 0),
					_Utils_Tuple2(12, 0),
					'morning1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(23, 0),
					_Utils_Tuple2(5, 0),
					'night1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(12, 0),
					'noon')
				]))
		]));
var $enkidatron$elm_cldr$Generated$Et$et = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Et$dayPeriods, 'et||||AM|PM|8|afternoon1|pärastlõunal|am|AM|evening1|õhtul|midnight|keskööl|morning1|hommikul|night1|öösel|noon|keskpäeval|pm|PM|AM|PM|8|afternoon1|pärastlõunal|am|AM|evening1|õhtul|midnight|keskööl|morning1|hommikul|night1|öösel|noon|keskpäeval|pm|PM|AM|PM|8|afternoon1|pärastlõunal|am|AM|evening1|õhtul|midnight|keskööl|morning1|hommikul|night1|öösel|noon|keskpäeval|pm|PM|dd.MM.yy|d. MMM y|d. MMMM y|EEEE, d. MMMM y|jaan|veebr|märts|apr|mai|juuni|juuli|aug|sept|okt|nov|dets|jaanuar|veebruar|märts|aprill|mai|juuni|juuli|august|september|oktoober|november|detsember|J|V|M|A|M|J|J|A|S|O|N|D|0|P|E|T|K|N|R|L|pühapäev|esmaspäev|teisipäev|kolmapäev|neljapäev|reede|laupäev|P|E|T|K|N|R|L|0|eKr|pKr|enne Kristust|pärast Kristust|eKr|pKr|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1} {0}|{1} {0}|{1} {0}|{1} {0}|51|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E, d|Ehm|E h:mm\u202Fa|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|EHms|E HH:mm:ss|Gy|y G|GyMd|d.MM.y GGGGG|GyMMM|MMM y G|GyMMMd|d. MMM y G|GyMMMEd|E, d. MMMM y G|h|h\u202Fa|H|HH|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|Hmv|HH:mm v|M|M|Md|d.M|MEd|E, d.M|MMM|MMMM|MMMd|d. MMM|MMMEd|E, d. MMM|MMMMd|d. MMMM|MMMMEd|E, d. MMMM|MMMMW-count-one|MMMM (W. \'nädal\')|MMMMW-count-other|MMMM (W. \'nädal\')|mmss|mm:ss|ms|mm:ss|y|y|yM|M.y|yMd|d.M.y|yMEd|E, d.M.y|yMMM|MMM y|yMMMd|d. MMM y|yMMMEd|E, d. MMMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|w. \'nädal\' (Y)|yw-count-other|w. \'nädal\' (Y)|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W\u00A0|,|−||||||E2W\u00A0|,|−|\u00A0¤||\u00A0¤||\u00A0¤|E0W\u00A0|,|−|%||%||%|107|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|AU$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EEK|kr|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XCG|Cg.|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$et = $enkidatron$elm_cldr$Generated$Et$et;
var $enkidatron$elm_cldr$Generated$Eu$dayPeriods = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			'eu',
			_List_fromArray(
				[
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(12, 0),
					_Utils_Tuple2(14, 0),
					'afternoon1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(14, 0),
					_Utils_Tuple2(19, 0),
					'afternoon2'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(19, 0),
					_Utils_Tuple2(21, 0),
					'evening1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(0, 0),
					'midnight'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(0, 0),
					_Utils_Tuple2(6, 0),
					'morning1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(6, 0),
					_Utils_Tuple2(12, 0),
					'morning2'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(21, 0),
					_Utils_Tuple2(24, 0),
					'night1')
				]))
		]));
var $enkidatron$elm_cldr$Generated$Eu$eu = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Eu$dayPeriods, 'eu||||AM|PM|9|afternoon1|eguerd.|afternoon2|arrats.|am|AM|evening1|iluntz.|midnight|gauerdia|morning1|goizald.|morning2|goizeko|night1|gaueko|pm|PM|AM|PM|9|afternoon1|eguerdiko|afternoon2|arratsaldeko|am|AM|evening1|iluntzeko|midnight|gauerdia|morning1|goizaldeko|morning2|goizeko|night1|gaueko|pm|PM|g|a|9|afternoon1|eguerd.|afternoon2|arrats.|am|g|evening1|iluntz.|midnight|gauerd.|morning1|goizald.|morning2|goizeko|night1|gaueko|pm|a|yy/M/d|y(\'e\')\'ko\' MMM d(\'a\')|y(\'e\')\'ko\' MMMM\'ren\' d(\'a\')|y(\'e\')\'ko\' MMMM\'ren\' d(\'a\'), EEEE|urt.|ots.|mar.|api.|mai.|eka.|uzt.|abu.|ira.|urr.|aza.|abe.|urtarrila|otsaila|martxoa|apirila|maiatza|ekaina|uztaila|abuztua|iraila|urria|azaroa|abendua|U|O|M|A|M|E|U|A|I|U|A|A|0|ig.|al.|ar.|az.|og.|or.|lr.|igandea|astelehena|asteartea|asteazkena|osteguna|ostirala|larunbata|I|A|A|A|O|O|L|0|K.a.|K.o.|Kristo aurretik|Kristo ondoren|a|o|HH:mm|HH:mm:ss|HH:mm:ss (z)|HH:mm:ss (zzzz)|{1} ({0})|{1} ({0})|{1} ({0})|{1} ({0})|51|Bh|B h|Bhm|B h:mm|Bhms|B h:mm:ss|d|d|E|ccc|EBhm|E B h:mm|EBhms|E B h:mm:ss|Ed|d, E|Ehm|E h:mm\u202Fa|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|EHms|E HH:mm:ss|Gy|G y|GyMd|GGGGG y-MM-dd|GyMMM|G y. \'urteko\' MMM|GyMMMd|G y. \'urteko\' MMM d(\'a\')|GyMMMEd|G y. \'urteko\' MMM d(\'a\'), E|h|h\u202Fa|H|HH|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|Hmv|HH:mm v|M|L|Md|M/d|MEd|M/d, E|MMM|LLL|MMMd|MMM d(\'a\')|MMMEd|MMM d(\'a\'), E|MMMMd|MMMM\'ren\' d(\'a\')|MMMMW-count-one|MMMM\'ren\' W. \'astea\'|MMMMW-count-other|MMMM\'ren\' W. \'astea\'|ms|mm:ss|y|y|yM|y/M|yMd|y/M/d|yMEd|y/M/d, E|yMMM|y MMM|yMMMd|y MMM d(\'a\')|yMMMEd|y MMM d(\'a\'), E|yMMMM|y(\'e\')\'ko\' MMMM|yMMMMd|y(\'e\')\'ko\' MMMM\'ren\' d(\'a\')|yMMMMEd|y(\'e\')\'ko\' MMMM\'ren\' d(\'a\'), E|yQQQ|y(\'e\')\'ko\' QQQ|yQQQQ|y(\'e\')\'ko\' QQQQ|yw-count-one|Y. \'urteko\' w. \'astea\'|yw-count-other|Y. \'urteko\' w. \'astea\'|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W.|,|−||||||E2W.|,|−|\u00A0¤||\u00A0¤||\u00A0¤|E0W.|,|−%\u00A0||%\u00A0||%\u00A0||107|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XCG|Cg.|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$eu = $enkidatron$elm_cldr$Generated$Eu$eu;
var $enkidatron$elm_cldr$Generated$Fa$dayPeriods = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			'fa',
			_List_fromArray(
				[
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(12, 0),
					_Utils_Tuple2(13, 0),
					'afternoon1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(13, 0),
					_Utils_Tuple2(19, 0),
					'afternoon2'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(1, 0),
					_Utils_Tuple2(4, 0),
					'morning1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(4, 0),
					_Utils_Tuple2(12, 0),
					'morning2'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(19, 0),
					_Utils_Tuple2(24, 0),
					'night1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(0, 0),
					_Utils_Tuple2(1, 0),
					'night2')
				]))
		]));
var $enkidatron$elm_cldr$Generated$Fa$fa = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Fa$dayPeriods, 'fa||||ق.ظ.|ب.ظ.|8|afternoon1|ظهر|afternoon2|عصر|am|ق.ظ.|morning1|بامداد|morning2|صبح|night1|شب|night2|نیمه\u200Cشب|pm|ب.ظ.|قبل\u200Cازظهر|بعدازظهر|8|afternoon1|بعدازظهر|afternoon2|عصر|am|قبل\u200Cازظهر|morning1|بامداد|morning2|صبح|night1|شب|night2|نیمه\u200Cشب|pm|بعدازظهر|ق|ب|8|afternoon1|ظهر|afternoon2|عصر|am|ق|morning1|بامداد|morning2|صبح|night1|شب|night2|نیمه\u200Cشب|pm|ب|y/M/d|d MMM y|d MMMM y|EEEE d MMMM y|ژانویه|فوریه|مارس|آوریل|مه|ژوئن|ژوئیه|اوت|سپتامبر|اکتبر|نوامبر|دسامبر|ژانویهٔ|فوریهٔ|مارس|آوریل|مهٔ|ژوئن|ژوئیهٔ|اوت|سپتامبر|اکتبر|نوامبر|دسامبر|ژ|ف|م|آ|م|ژ|ژ|ا|س|ا|ن|د|1|ژانویه|فوریه|مارس|آوریل|مه|ژوئن|ژوئیه|اوت|سپتامبر|اکتبر|نوامبر|دسامبر|ژانویه|فوریه|مارس|آوریل|مه|ژوئن|ژوئیه|اوت|سپتامبر|اکتبر|نوامبر|دسامبر|ژ|ف|م|آ|م|ژ|ژ|ا|س|ا|ن|د|یکشنبه|دوشنبه|سه\u200Cشنبه|چهارشنبه|پنجشنبه|جمعه|شنبه|یکشنبه|دوشنبه|سه\u200Cشنبه|چهارشنبه|پنجشنبه|جمعه|شنبه|ی|د|س|چ|پ|ج|ش|0|ق.م.|م.|قبل از میلاد|میلادی|ق|م|H:mm|H:mm:ss|H:mm:ss (z)|H:mm:ss (zzzz)|{1}،\u200F {0}|{1}،\u200F {0}|{1}، ساعت {0}|{1}، ساعت {0}|53|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E h:mm a|EHm|E H:mm|Ehms|E h:mm:ss a|EHms|E H:mm:ss|Gy|y G|GyMd|y/M/d GGGGG|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E d MMM y G|h|h\u202Fa|H|H|HHmmZ|HH:mm (Z)|hm|h:mm a|Hm|H:mm|hms|h:mm:ss a|Hms|H:mm:ss|hmsv|h:mm:ss a v|Hmsv|H:mm:ss v|hmv|h:mm a v|Hmv|H:mm v|M|L|Md|M/d|MEd|E M/d|MMM|LLL|MMMd|d LLL|MMMEd|E d LLL|MMMMd|d LLLL|MMMMEd|E d LLLL|MMMMW-count-one|هفتهٔ Wم LLLL|MMMMW-count-other|هفتهٔ Wم LLLL|mmss|mm:ss|ms|m:ss|y|y|yM|y/M|yMd|y/M/d|yMEd|E y/M/d|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E d MMM y|yMMMM|MMMM y|yMMMMEEEEd|EEEE d MMMM y|yQQQ|QQQQ y|yQQQQ|QQQQ y|yw-count-one|هفتهٔ wم Y|yw-count-other|هفتهٔ wم Y|Hmm|Hmmss|Hmmssz|Hmmsszzzz|X3W,|.|\u200E−||||||E2W,|.|\u200E−\u200E¤\u00A0||\u200E¤\u00A0||\u200E¤\u00A0||E0W,|.|\u200E−|%||%||%|108|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|Br|BZD|$|CAD|$CA|CLP|$|CNY|¥CN|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|$HK|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|IRR|ریال|ISK|kr|JMD|$|JPY|¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|$MX|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|$NZ|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|$EC|XCG|Cg.|XOF|فرانک\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$fa = $enkidatron$elm_cldr$Generated$Fa$fa;
var $enkidatron$elm_cldr$Generated$Fi$dayPeriods = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			'fi',
			_List_fromArray(
				[
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(12, 0),
					_Utils_Tuple2(18, 0),
					'afternoon1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(18, 0),
					_Utils_Tuple2(23, 0),
					'evening1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(0, 0),
					'midnight'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(5, 0),
					_Utils_Tuple2(10, 0),
					'morning1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(10, 0),
					_Utils_Tuple2(12, 0),
					'morning2'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(23, 0),
					_Utils_Tuple2(5, 0),
					'night1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(12, 0),
					'noon')
				]))
		]));
var $enkidatron$elm_cldr$Generated$Fi$fi = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Fi$dayPeriods, 'fi||||ap.|ip.|9|afternoon1|iltap.|am|ap.|evening1|illalla|midnight|keskiyöllä|morning1|aamulla|morning2|aamup.|night1|yöllä|noon|keskip.|pm|ip.|ap.|ip.|9|afternoon1|iltapäivällä|am|ap.|evening1|illalla|midnight|keskiyöllä|morning1|aamulla|morning2|aamupäivällä|night1|yöllä|noon|keskipäivällä|pm|ip.|ap.|ip.|9|afternoon1|ip.|am|ap.|evening1|illalla|midnight|ky.|morning1|aamulla|morning2|ap.|night1|yöllä|noon|kp.|pm|ip.|d.M.y|d.M.y|d. MMMM y|cccc d. MMMM y|tammi|helmi|maalis|huhti|touko|kesä|heinä|elo|syys|loka|marras|joulu|tammikuuta|helmikuuta|maaliskuuta|huhtikuuta|toukokuuta|kesäkuuta|heinäkuuta|elokuuta|syyskuuta|lokakuuta|marraskuuta|joulukuuta|T|H|M|H|T|K|H|E|S|L|M|J|1|tammi|helmi|maalis|huhti|touko|kesä|heinä|elo|syys|loka|marras|joulu|tammikuu|helmikuu|maaliskuu|huhtikuu|toukokuu|kesäkuu|heinäkuu|elokuu|syyskuu|lokakuu|marraskuu|joulukuu|T|H|M|H|T|K|H|E|S|L|M|J|su|ma|ti|ke|to|pe|la|sunnuntai|maanantaina|tiistaina|keskiviikkona|torstaina|perjantaina|lauantaina|S|M|T|K|T|P|L|1|su|ma|ti|ke|to|pe|la|sunnuntai|maanantai|tiistai|keskiviikko|torstai|perjantai|lauantai|S|M|T|K|T|P|L|eKr.|jKr.|ennen Kristuksen syntymää|jälkeen Kristuksen syntymän|eKr|jKr|H.mm|H.mm.ss|H.mm.ss z|H.mm.ss zzzz|{1} {0}|{1} {0}|{1} {0}|{1} {0}|56|Bh|h B|Bhm|h.mm B|Bhms|h.mm.ss B|d|d|E|ccc|EBhm|E h.mm B|EBhms|E h.mm.ss B|Ed|E d.|Ehm|E h.mm\u202Fa|EHm|E H.mm|Ehms|E h.mm.ss\u202Fa|EHms|E H.mm.ss|Gy|y G|GyMd|M.d.y G|GyMMM|LLL y G|GyMMMd|d.M.y G|GyMMMEd|E d.M.y G|GyMMMMd|d. MMMM y G|GyMMMMEd|E d. MMMM y G|h|h\u202Fa|H|H|hm|h.mm\u202Fa|Hm|H.mm|hms|h.mm.ss\u202Fa|Hms|H.mm.ss|hmsv|h.mm.ss\u202Fa v|Hmsv|H.mm.ss v|hmv|h.mm\u202Fa v|Hmv|H.mm v|M|L|Md|d.M.|MEd|E d.M.|MMM|LLL|MMMd|d.M.|MMMEd|ccc d.M.|MMMMd|d. MMMM|MMMMEd|ccc d. MMMM|MMMMW-count-one|LLLL\'n\' W. \'viikko\'|MMMMW-count-other|LLLL\'n\' W. \'viikko\'|ms|m.ss|y|y|yM|L.y|yMd|d.M.y|yMEd|E d.M.y|yMM|M.y|yMMM|LLL y|yMMMd|d.M.y|yMMMEd|E d.M.y|yMMMM|LLLL y|yMMMMccccd|cccc d. MMMM y|yMMMMd|d. MMMM y|yMMMMEd|E d. MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\'vuoden\' Y \'viikko\' w|yw-count-other|\'vuoden\' Y \'viikko\' w|Hmm|Hmmss|Hmmssz|Hmmsszzzz|X3W\u00A0|,|−||||||E2W\u00A0|,|−|\u00A0¤||\u00A0¤||\u00A0¤|E0W\u00A0|,|−|\u00A0%||\u00A0%||\u00A0%|107|AFN|؋|AMD|֏|AOA|AOA|ARS|ARS|AUD|AUD|AZN|₼|BAM|BAM|BBD|BBD|BDT|BDT|BMD|BMD|BND|BND|BOB|BOB|BRL|BRL|BSD|BSD|BWP|BWP|BZD|BZD|CAD|CAD|CLP|CLP|CNY|CNY|COP|COP|CRC|CRC|CUC|CUC|CUP|CUP|CZK|CZK|DKK|DKK|DOP|DOP|EGP|EGP|ESP|ESP|EUR|€|FIM|mk|FJD|FJD|FKP|FKP|GBP|£|GEL|GEL|GHS|GH₵|GIP|GIP|GNF|GNF|GTQ|GTQ|GYD|GYD|HKD|HKD|HNL|HNL|HRK|HRK|HUF|HUF|IDR|IDR|ILS|ILS|INR|INR|ISK|ISK|JMD|JMD|JPY|¥|KGS|\u20C0|KHR|KHR|KMF|KMF|KPW|KPW|KRW|KRW|KYD|KYD|KZT|KZT|LAK|LAK|LBP|LBP|LKR|LKR|LRD|LRD|LTL|LTL|LVL|LVL|MGA|MGA|MMK|MMK|MNT|MNT|MUR|MUR|MXN|MXN|MYR|MYR|NAD|NAD|NGN|NGN|NIO|NIO|NOK|NOK|NPR|NPR|NZD|NZD|PHP|PHP|PKR|PKR|PLN|PLN|PYG|PYG|RON|RON|RUB|₽|RWF|RWF|SBD|SBD|SEK|SEK|SGD|SGD|SHP|SHP|SRD|SRD|SSP|SSP|STN|STD|SYP|SYP|THB|THB|TOP|TOP|TRY|TRY|TTD|TTD|TWD|TWD|UAH|UAH|USD|$|UYU|UYU|VEF|VEF|VND|VND|XAF|FCFA|XCD|XCD|XCG|Cg.|XOF|F\u202FCFA|XPF|XPF|XXX|XXX|ZAR|ZAR|ZMW|ZMW|'));
var $enkidatron$elm_cldr$Cldr$Locale$fi = $enkidatron$elm_cldr$Generated$Fi$fi;
var $enkidatron$elm_cldr$Generated$Fil$dayPeriods = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			'fil',
			_List_fromArray(
				[
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(12, 0),
					_Utils_Tuple2(16, 0),
					'afternoon1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(16, 0),
					_Utils_Tuple2(18, 0),
					'evening1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(0, 0),
					'midnight'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(0, 0),
					_Utils_Tuple2(6, 0),
					'morning1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(6, 0),
					_Utils_Tuple2(12, 0),
					'morning2'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(18, 0),
					_Utils_Tuple2(24, 0),
					'night1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(12, 0),
					'noon')
				]))
		]));
var $enkidatron$elm_cldr$Generated$Fil$fil = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Fil$dayPeriods, 'fil||||AM|PM|9|afternoon1|ng hapon|am|AM|evening1|ng gabi|midnight|hatinggabi|morning1|ng umaga|morning2|madaling-araw|night1|ng gabi|noon|tanghaling-tapat|pm|PM|AM|PM|9|afternoon1|ng hapon|am|AM|evening1|ng gabi|midnight|hatinggabi|morning1|ng umaga|morning2|madaling-araw|night1|ng gabi|noon|tanghaling-tapat|pm|PM|am|pm|9|afternoon1|ng hapon|am|am|evening1|ng gabi|midnight|hatinggabi|morning1|ng umaga|morning2|madaling-araw|night1|ng gabi|noon|tanghaling-tapat|pm|pm|M/d/yy|MMM d, y|MMMM d, y|EEEE, MMMM d, y|Ene|Peb|Mar|Abr|May|Hun|Hul|Ago|Set|Okt|Nob|Dis|Enero|Pebrero|Marso|Abril|Mayo|Hunyo|Hulyo|Agosto|Setyembre|Oktubre|Nobyembre|Disyembre|Ene|Peb|Mar|Abr|May|Hun|Hul|Ago|Set|Okt|Nob|Dis|1|Ene|Peb|Mar|Abr|May|Hun|Hul|Ago|Set|Okt|Nob|Dis|Enero|Pebrero|Marso|Abril|Mayo|Hunyo|Hulyo|Agosto|Setyembre|Oktubre|Nobyembre|Disyembre|E|P|M|A|M|Hun|Hul|Ago|Set|Okt|Nob|Dis|Lin|Lun|Mar|Miy|Huw|Biy|Sab|Linggo|Lunes|Martes|Miyerkules|Huwebes|Biyernes|Sabado|Lin|Lun|Mar|Miy|Huw|Biy|Sab|0|BC|AD|Before Christ|Anno Domini|BC|AD|h:mm\u202Fa|h:mm:ss\u202Fa|h:mm:ss\u202Fa z|h:mm:ss\u202Fa zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|51|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|d E|Ehm|E h:mm\u202Fa|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|EHms|E HH:mm:ss|Gy|y G|GyMd|M/d/y G|GyMMM|MMM y G|GyMMMd|MMM d, y G|GyMMMEd|E, MMM d, y G|h|h\u202Fa|H|HH|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|Hmv|HH:mm v|M|L|Md|M/d|MEd|E, M/d|MMM|LLL|MMMd|MMM d|MMMEd|E, MMM d|MMMMd|MMMM d|MMMMEd|E, MMMM d|MMMMW-count-one|\'linggo\' W \'ng\' MMMM|MMMMW-count-other|\'linggo\' W \'ng\' MMMM|ms|mm:ss|y|y|yM|M/y|yMd|M/d/y|yMEd|E, M/d/y|yMM|MM/y|yMMM|MMM y|yMMMd|MMM d, y|yMMMEd|E, MMM d, y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\'ika\'-w \'linggo\' \'ng\' Y|yw-count-other|\'linggo\' w \'ng\' Y|ahmm|ahmmss|ahmmssz|ahmmsszzzz|X3W,|.|-||||||E2W,|.|-¤||¤||¤||E0W,|.|-|%||%||%|107|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|₱|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XCG|Cg.|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$fil = $enkidatron$elm_cldr$Generated$Fil$fil;
var $enkidatron$elm_cldr$Generated$Fr$dayPeriods = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			'fr',
			_List_fromArray(
				[
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(12, 0),
					_Utils_Tuple2(18, 0),
					'afternoon1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(18, 0),
					_Utils_Tuple2(24, 0),
					'evening1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(0, 0),
					'midnight'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(4, 0),
					_Utils_Tuple2(12, 0),
					'morning1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(0, 0),
					_Utils_Tuple2(4, 0),
					'night1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(12, 0),
					'noon')
				]))
		]));
var $enkidatron$elm_cldr$Generated$Fr$fr = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Fr$dayPeriods, 'fr||||AM|PM|8|afternoon1|après-midi|am|AM|evening1|soir|midnight|minuit|morning1|matin|night1|matin|noon|midi|pm|PM|AM|PM|8|afternoon1|de l’après-midi|am|AM|evening1|du soir|midnight|minuit|morning1|du matin|night1|du matin|noon|midi|pm|PM|AM|PM|8|afternoon1|ap.m.|am|AM|evening1|soir|midnight|minuit|morning1|mat.|night1|matin|noon|midi|pm|PM|dd/MM/y|d MMM y|d MMMM y|EEEE d MMMM y|janv.|févr.|mars|avr.|mai|juin|juil.|août|sept.|oct.|nov.|déc.|janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre|J|F|M|A|M|J|J|A|S|O|N|D|0|dim.|lun.|mar.|mer.|jeu.|ven.|sam.|dimanche|lundi|mardi|mercredi|jeudi|vendredi|samedi|D|L|M|M|J|V|S|0|av. J.-C.|ap. J.-C.|avant Jésus-Christ|après Jésus-Christ|av. J.-C.|ap. J.-C.|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1} {0}|{1}, {0}|{1}, {0}|{1}, {0}|49|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|E|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E h:mm\u202Fa|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|EHms|E HH:mm:ss|Gy|y G|GyMd|dd/MM/y GGGGG|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E d MMM y G|h|h\u202Fa|H|HH \'h\'|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|Hmv|HH:mm v|M|L|Md|dd/MM|MEd|E dd/MM|MMM|LLL|MMMd|d MMM|MMMEd|E d MMM|MMMMd|d MMMM|MMMMW-count-one|\'semaine\' W (MMMM)|MMMMW-count-other|\'semaine\' W (MMMM)|ms|mm:ss|y|y|yM|MM/y|yMd|dd/MM/y|yMEd|E dd/MM/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\'semaine\' w \'de\' Y|yw-count-other|\'semaine\' w \'de\' Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W\u202F|,|-||||||E2W\u202F|,|-|\u00A0¤||\u00A0¤||\u00A0¤|E0W\u202F|,|-|\u00A0%||\u00A0%||\u00A0%|116|AFN|؋|AMD|֏|AOA|Kz|ARS|$AR|AUD|$AU|AZN|₼|BAM|KM|BBD|$|BDT|৳|BEF|FB|BMD|$BM|BND|$BN|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$BZ|CAD|$CA|CLP|$CL|CNY|CNY|COP|$CO|CRC|₡|CUC|$|CUP|$|CYP|£CY|CZK|Kč|DKK|kr|DOP|$|EGP|£E|ESP|₧|EUR|€|FJD|$FJ|FKP|£FK|FRF|F|GBP|£GB|GEL|₾|GHS|GH₵|GIP|£GI|GNF|FG|GTQ|Q|GYD|$|HKD|HKD|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|IEP|£IE|ILP|£IL|ILS|₪|INR|₹|ISK|kr|ITL|₤IT|JMD|$|JPY|JPY|KGS|\u20C0|KHR|៛|KMF|FC|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|£LB|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MTP|£MT|MUR|Rs|MXN|$MX|MYR|RM|NAD|$NA|NGN|₦|NIO|$C|NOK|kr|NPR|Rs|NZD|$NZ|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RHD|$RH|RON|L|RUB|₽|RWF|FR|SBD|$SB|SEK|kr|SGD|$SG|SHP|£|SRD|$SR|SSP|£|STN|Db|SYP|£|THB|฿|TOP|$T|TRY|₺|TTD|$TT|TWD|TWD|UAH|₴|USD|$US|UYU|$UY|VEF|Bs|VND|₫|WST|$WS|XAF|FCFA|XCD|XCD|XCG|Cg.|XOF|F\u202FCFA|XPF|FCFP|XXX|¤|ZAR|R|ZMW|Kw|'));
var $enkidatron$elm_cldr$Cldr$Locale$fr = $enkidatron$elm_cldr$Generated$Fr$fr;
var $enkidatron$elm_cldr$Generated$Ga$dayPeriods = $elm$core$Dict$fromList(_List_Nil);
var $enkidatron$elm_cldr$Generated$Ga$ga = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Ga$dayPeriods, 'ga||||r.n.|i.n.|2|am|r.n.|pm|i.n.|r.n.|i.n.|2|am|r.n.|pm|i.n.|r.n.|i.n.|2|am|r.n.|pm|i.n.|dd/MM/y|d MMM y|d MMMM y|EEEE d MMMM y|Ean|Feabh|Márta|Aib|Beal|Meith|Iúil|Lún|MFómh|DFómh|Samh|Noll|Eanáir|Feabhra|Márta|Aibreán|Bealtaine|Meitheamh|Iúil|Lúnasa|Meán Fómhair|Deireadh Fómhair|Samhain|Nollaig|E|F|M|A|B|M|I|L|M|D|S|N|0|Domh|Luan|Máirt|Céad|Déar|Aoine|Sath|Dé Domhnaigh|Dé Luain|Dé Máirt|Dé Céadaoin|Déardaoin|Dé hAoine|Dé Sathairn|D|L|M|C|D|A|S|0|RC|AD|Roimh Chríost|Anno Domini|RC|AD|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1} {0}|{1} {0}|{1} {0}|{1} {0}|55|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E h:mm\u202Fa|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|EHms|E HH:mm:ss|Gy|y G|GyMd|dd/MM/y GGGGG|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E d MMM y G|h|h\u202Fa|H|HH|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|Hmv|HH:mm v|M|LL|Md|dd/MM|MEd|E dd/MM|MMM|LLL|MMMd|d MMM|MMMEd|E d MMM|MMMMd|d MMMM|MMMMW-count-one|\'seachtain\' \'a\' W \'i\' MMMM|MMMMW-count-two|\'seachtain\' \'a\' W \'i\' MMMM|MMMMW-count-few|\'seachtain\' \'a\' W \'i\' MMMM|MMMMW-count-many|\'seachtain\' \'a\' W \'i\' MMMM|MMMMW-count-other|\'seachtain\' \'a\' W \'i\' MMMM|ms|mm:ss|y|y|yM|MM/y|yMd|dd/MM/y|yMEd|E dd/MM/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\'seachtain\' \'a\' w \'in\' Y|yw-count-two|\'seachtain\' \'a\' w \'in\' Y|yw-count-few|\'seachtain\' \'a\' w \'in\' Y|yw-count-many|\'seachtain\' \'a\' w \'in\' Y|yw-count-other|\'seachtain\' \'a\' w \'in\' Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W,|.|-||||||E2W,|.|-¤||¤||¤||E0W,|.|-|%||%||%|107|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|₱|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RUR|р.|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XCG|Cg.|XOF|F\u202FCFA|XPF|CFPF|XXX|XXX|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$ga = $enkidatron$elm_cldr$Generated$Ga$ga;
var $enkidatron$elm_cldr$Generated$Gd$dayPeriods = $elm$core$Dict$fromList(_List_Nil);
var $enkidatron$elm_cldr$Generated$Gd$gd = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Gd$dayPeriods, 'gd||||m|f|2|am|m|pm|f|m|f|2|am|m|pm|f|m|f|2|am|m|pm|f|dd/MM/y|d\'mh\' MMM y|d\'mh\' MMMM y|EEEE, d\'mh\' MMMM y|Faoi|Gearr|Màrt|Gibl|Cèit|Ògmh|Iuch|Lùna|Sult|Dàmh|Samh|Dùbh|dhen Fhaoilleach|dhen Ghearran|dhen Mhàrt|dhen Ghiblean|dhen Chèitean|dhen Ògmhios|dhen Iuchar|dhen Lùnastal|dhen t-Sultain|dhen Dàmhair|dhen t-Samhain|dhen Dùbhlachd|F|G|M|G|C|Ò|I|L|S|D|S|D|1|Faoi|Gearr|Màrt|Gibl|Cèit|Ògmh|Iuch|Lùna|Sult|Dàmh|Samh|Dùbh|Am Faoilleach|An Gearran|Am Màrt|An Giblean|An Cèitean|An t-Ògmhios|An t-Iuchar|An Lùnastal|An t-Sultain|An Dàmhair|An t-Samhain|An Dùbhlachd|F|G|M|G|C|Ò|I|L|S|D|S|D|DiD|DiL|DiM|DiC|Dia|Dih|DiS|DiDòmhnaich|DiLuain|DiMàirt|DiCiadain|DiarDaoin|DihAoine|DiSathairne|D|L|M|C|A|H|S|0|RC|AD|Ro Chrìosta|An dèidh Chrìosta|R|A|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1} {0}|{1} {0}|{1} {0}|{1} {0}|55|Bh|hB|Bhm|h:mmB|Bhms|h:mm:ssB|d|d|E|ccc|EBhm|E h:mmB|EBhms|E h:mm:ssB|Ed|E, d|Ehm|E h:mma|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|EHms|E HH:mm:ss|Gy|y G|GyMd|d/M/y G|GyMMM|LLL y G|GyMMMd|d\'mh\' MMM y G|GyMMMEd|E, d\'mh\' MMM y G|h|ha|H|HH|hm|h:mma|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmv|h:mma v|Hmv|HH:mm v|M|L|Md|d/M|MEd|E, d/M|MMdd|dd/MM|MMM|LLL|MMMd|d MMM|MMMEd|E, d MMM|MMMMd|d\'mh\' MMMM|MMMMW-count-one|\'seachdain\' W MMMM|MMMMW-count-two|\'seachdain\' W MMMM|MMMMW-count-few|\'seachdain\' W MMMM|MMMMW-count-other|\'seachdain\' W MMMM|ms|mm:ss|y|y|yM|L/y|yMd|d/M/y|yMEd|E, d/M/y|yMM|LL/y|yMMM|LLL Y|yMMMd|d MMM y|yMMMEd|E, d MMM y|yMMMM|LLLL y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\'seachdain\' w \'dhe\' Y|yw-count-two|\'seachdain\' w \'dhe\' Y|yw-count-few|\'seachdain\' w \'dhe\' Y|yw-count-other|\'seachdain\' w \'dhe\' Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W,|.|-||||||E2W,|.|-¤||¤||¤||E0W,|.|-|%||%||%|108|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|leu|RUB|₽|RUR|р.|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XCG|Cg.|XOF|F\u202FCFA|XPF|CFPF|XXX|XXX|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$gd = $enkidatron$elm_cldr$Generated$Gd$gd;
var $enkidatron$elm_cldr$Generated$Gl$dayPeriods = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			'gl',
			_List_fromArray(
				[
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(12, 0),
					_Utils_Tuple2(13, 0),
					'afternoon1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(13, 0),
					_Utils_Tuple2(21, 0),
					'evening1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(0, 0),
					'midnight'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(0, 0),
					_Utils_Tuple2(6, 0),
					'morning1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(6, 0),
					_Utils_Tuple2(12, 0),
					'morning2'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(21, 0),
					_Utils_Tuple2(24, 0),
					'night1')
				]))
		]));
var $enkidatron$elm_cldr$Generated$Gl$gl = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Gl$dayPeriods, 'gl||||a.m.|p.m.|8|afternoon1|do mediodía|am|a.m.|evening1|da tarde|midnight|da noite|morning1|da madrugada|morning2|da mañá|night1|da noite|pm|p.m.|a.m.|p.m.|8|afternoon1|do mediodía|am|a.m.|evening1|da tarde|midnight|da noite|morning1|da madrugada|morning2|da mañá|night1|da noite|pm|p.m.|a.m.|p.m.|8|afternoon1|do mediodía|am|a.m.|evening1|da tarde|midnight|da noite|morning1|da madrugada|morning2|da mañá|night1|da noite|pm|p.m.|dd/MM/yy|d \'de\' MMM \'de\' y|d \'de\' MMMM \'de\' y|EEEE, d \'de\' MMMM \'de\' y|xan.|feb.|mar.|abr.|maio|xuño|xul.|ago.|set.|out.|nov.|dec.|xaneiro|febreiro|marzo|abril|maio|xuño|xullo|agosto|setembro|outubro|novembro|decembro|x.|f.|m.|a.|m.|x.|x.|a.|s.|o.|n.|d.|1|xan.|feb.|mar.|abr.|maio|xuño|xul.|ago.|set.|out.|nov.|dec.|xaneiro|febreiro|marzo|abril|maio|xuño|xullo|agosto|setembro|outubro|novembro|decembro|X|F|M|A|M|X|X|A|S|O|N|D|dom.|luns|mar.|mér.|xov.|ven.|sáb.|domingo|luns|martes|mércores|xoves|venres|sábado|d.|l.|m.|m.|x.|v.|s.|1|dom.|luns|mar.|mér.|xov.|ven.|sáb.|domingo|luns|martes|mércores|xoves|venres|sábado|D|L|M|M|X|V|S|a.C.|d.C.|antes de Cristo|despois de Cristo|a.C.|d.C.|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|52|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E, h:mm B|EBhms|E, h:mm:ss B|Ed|E d|Ehm|E, h:mm\u202Fa|EHm|E, HH:mm|Ehms|E, h:mm:ss\u202Fa|EHms|E, HH:mm:ss|Gy|y G|GyMd|d/M/y GGGGG|GyMMM|MMM \'de\' y G|GyMMMd|d \'de\' MMM \'de\' y G|GyMMMEd|E, d \'de\' MMM \'de\' y G|h|h\u202Fa|H|HH|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|Hmv|HH:mm v|M|L|Md|d/M|MEd|E, d/M|MMdd|dd/MM|MMM|LLL|MMMd|d \'de\' MMM|MMMEd|E, d \'de\' MMM|MMMMd|d \'de\' MMMM|MMMMEd|E, d \'de\' MMMM|MMMMW-count-one|W.\'ª\' \'semana\' \'de\' MMMM|MMMMW-count-other|W.\'ª\' \'semana\' \'de\' MMMM|ms|mm:ss|y|y|yM|M/y|yMd|d/M/y|yMEd|E, d/M/y|yMM|MM/y|yMMM|MMM \'de\' y|yMMMd|d \'de\' MMM \'de\' y|yMMMEd|E, d \'de\' MMM \'de\' y|yMMMM|MMMM \'de\' y|yQQQ|QQQ y|yQQQQ|QQQQ \'de\' y|yw-count-one|w.\'ª\' \'semana\' \'de\' Y|yw-count-other|w.\'ª\' \'semana\' \'de\' Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W.|,|-||||||E2W.|,|-|\u00A0¤||\u00A0¤||\u00A0¤|E0W.|,|-|\u00A0%||\u00A0%||\u00A0%|107|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|Br|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|FC|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|$MX|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|руб|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|XCD|XCG|Cg.|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$gl = $enkidatron$elm_cldr$Generated$Gl$gl;
var $enkidatron$elm_cldr$Generated$Gu$dayPeriods = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			'gu',
			_List_fromArray(
				[
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(12, 0),
					_Utils_Tuple2(16, 0),
					'afternoon1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(16, 0),
					_Utils_Tuple2(20, 0),
					'evening1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(0, 0),
					'midnight'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(4, 0),
					_Utils_Tuple2(12, 0),
					'morning1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(20, 0),
					_Utils_Tuple2(4, 0),
					'night1')
				]))
		]));
var $enkidatron$elm_cldr$Generated$Gu$gu = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Gu$dayPeriods, 'gu||||AM|PM|7|afternoon1|બપોરે|am|AM|evening1|સાંજે|midnight|મધ્યરાત્રિ|morning1|સવારે|night1|રાત્રે|pm|PM|AM|PM|7|afternoon1|બપોરે|am|AM|evening1|સાંજે|midnight|મધ્યરાત્રિ|morning1|સવારે|night1|રાત્રે|pm|PM|AM|PM|7|afternoon1|બપોરે|am|AM|evening1|સાંજે|midnight|મ.રાત્રિ|morning1|સવારે|night1|રાત્રે|pm|PM|d/M/yy|d MMM, y|d MMMM, y|EEEE, d MMMM, y|જાન્યુ|ફેબ્રુ|માર્ચ|એપ્રિલ|મે|જૂન|જુલાઈ|ઑગસ્ટ|સપ્ટે|ઑક્ટો|નવે|ડિસે|જાન્યુઆરી|ફેબ્રુઆરી|માર્ચ|એપ્રિલ|મે|જૂન|જુલાઈ|ઑગસ્ટ|સપ્ટેમ્બર|ઑક્ટોબર|નવેમ્બર|ડિસેમ્બર|જા|ફે|મા|એ|મે|જૂ|જુ|ઑ|સ|ઑ|ન|ડિ|0|રવિ|સોમ|મંગળ|બુધ|ગુરુ|શુક્ર|શનિ|રવિવાર|સોમવાર|મંગળવાર|બુધવાર|ગુરુવાર|શુક્રવાર|શનિવાર|ર|સો|મં|બુ|ગુ|શુ|શ|0|ઈ.સ.પૂર્વે|ઈ.સ.|ઈસવીસન પૂર્વે|ઇસવીસન|ઇ સ પુ|ઇસ|hh:mm a|hh:mm:ss a|hh:mm:ss a z|hh:mm:ss a zzzz|{1} {0}|{1} {0}|{1} {0}|{1} {0}|51|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss a|EHms|E HH:mm:ss|Gy|G y|GyMd|GGGGG y-MM-dd|GyMMM|MMM, G y|GyMMMd|d MMM, G y|GyMMMEd|E, d MMM, G y|h|h\u202Fa|H|HH|hm|h:mm a|Hm|HH:mm|hms|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm a v|Hmv|HH:mm v|M|L|Md|d/M|MEd|E, d/M|MMdd|dd-MM|MMM|LLL|MMMd|d MMM|MMMEd|E, d MMM|MMMMd|d MMMM|MMMMW-count-one|MMMMના W અઠવાડિયા|MMMMW-count-other|MMMMના W અઠવાડિયા|ms|mm:ss|y|y|yM|M/y|yMd|d/M/y|yMEd|E, d/M/y|yMM|MM-y|yMMM|MMM y|yMMMd|d MMM, y|yMMMEd|E, d MMM, y|yMMMM|MMMM y|yQQQ|y QQQ|yQQQQ|y QQQQ|yw-count-one|Y ના w અઠવાડિયા|yw-count-other|Y ના w અઠવાડિયા|ahhmm|ahhmmss|ahhmmssz|ahhmmsszzzz|X3I,|.|-||||||E2I,|.|-¤||¤||¤||E0I,|.|-|%||%||%|107|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|રૂ.|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XCG|Cg.|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$gu = $enkidatron$elm_cldr$Generated$Gu$gu;
var $enkidatron$elm_cldr$Generated$Ha$dayPeriods = $elm$core$Dict$fromList(_List_Nil);
var $enkidatron$elm_cldr$Generated$Ha$ha = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Ha$dayPeriods, 'ha||||SF|YM|2|am|SF|pm|YM|Safiya|Yamma|2|am|Safiya|pm|Yamma|SF|YM|2|am|SF|pm|YM|d/M/yy|d MMM, y|d MMMM, y|EEEE d MMMM, y|Jan|Fab|Mar|Afi|May|Yun|Yul|Agu|Sat|Okt|Nuw|Dis|Janairu|Faburairu|Maris|Afirilu|Mayu|Yuni|Yuli|Agusta|Satumba|Oktoba|Nuwamba|Disamba|J|F|M|A|M|Y|Y|A|S|O|N|D|0|Lah|Lit|Tal|Lar|Alh|Jum|Asa|Lahadi|Litinin|Talata|Laraba|Alhamis|Jummaʼa|Asabar|L|L|T|L|A|J|A|0|K.H|BHAI|Kafin haihuwar annab|Bayan haihuwar annab|K.H|BHAI|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1} {0}|50|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E, d|Ehm|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss a|EHms|E HH:mm:ss|Gy|G y|GyMd|GGGGG y-MM-dd|GyMMM|G y MMM|GyMMMd|G y MMM d|GyMMMEd|G y MMM d, E|h|h\u202Fa|H|HH|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm a v|Hmv|HH:mm v|M|L|Md|M/d|MEd|E, M/d|MMM|LLL|MMMd|MMM d|MMMEd|E, MMM d|MMMMd|MMMM d|MMMMEd|E, MMMM d|MMMMW-count-one|\'satin\' W \'cikin\' MMMM|MMMMW-count-other|\'satin\' W \'cikin\' MMMM|ms|mm:ss|y|y|yM|M/y|yMd|y-MM-dd|yMEd|E, M/d/y|yMMM|MMM y|yMMMd|d MMM, y|yMMMEd|y MMM d, E|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\'sati\' w \'cikin\' Y|yw-count-other|\'sati\' w \'cikin\' Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W,|.|-||||||E2W,|.|-¤\u00A0||¤\u00A0||¤\u00A0||E0W,|.|-|%||%||%|106|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|₱|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XCG|Cg.|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$ha = $enkidatron$elm_cldr$Generated$Ha$ha;
var $enkidatron$elm_cldr$Generated$He$dayPeriods = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			'he',
			_List_fromArray(
				[
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(12, 0),
					_Utils_Tuple2(16, 0),
					'afternoon1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(16, 0),
					_Utils_Tuple2(18, 0),
					'afternoon2'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(18, 0),
					_Utils_Tuple2(22, 0),
					'evening1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(0, 0),
					'midnight'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(6, 0),
					_Utils_Tuple2(12, 0),
					'morning1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(22, 0),
					_Utils_Tuple2(3, 0),
					'night1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(3, 0),
					_Utils_Tuple2(6, 0),
					'night2')
				]))
		]));
var $enkidatron$elm_cldr$Generated$He$he = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$He$dayPeriods, 'he||||AM|PM|9|afternoon1|צהריים|afternoon2|אחר הצהריים|am|AM|evening1|ערב|midnight|חצות|morning1|בוקר|night1|לילה|night2|לפנות בוקר|pm|PM|AM|PM|9|afternoon1|בצהריים|afternoon2|אחר הצהריים|am|AM|evening1|בערב|midnight|חצות|morning1|בבוקר|night1|בלילה|night2|לפנות בוקר|pm|PM|AM|PM|9|afternoon1|בצהריים|afternoon2|אחה״צ|am|AM|evening1|בערב|midnight|חצות|morning1|בבוקר|night1|בלילה|night2|לפנות בוקר|pm|PM|d.M.y|d בMMM y|d בMMMM y|EEEE, d בMMMM y|ינו׳|פבר׳|מרץ|אפר׳|מאי|יוני|יולי|אוג׳|ספט׳|אוק׳|נוב׳|דצמ׳|ינואר|פברואר|מרץ|אפריל|מאי|יוני|יולי|אוגוסט|ספטמבר|אוקטובר|נובמבר|דצמבר|1|2|3|4|5|6|7|8|9|10|11|12|0|יום א׳|יום ב׳|יום ג׳|יום ד׳|יום ה׳|יום ו׳|שבת|יום ראשון|יום שני|יום שלישי|יום רביעי|יום חמישי|יום שישי|יום שבת|א׳|ב׳|ג׳|ד׳|ה׳|ו׳|ש׳|0|לפנה״ס|לספירה|לפני הספירה|לספירה|לפני|אחריי|H:mm|H:mm:ss|H:mm:ss z|H:mm:ss zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|52|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E ה-d|Ehm|E h:mm a|EHm|E H:mm|Ehms|E h:mm:ss a|EHms|E H:mm:ss|Gy|y G|GyMd|d/M/y G|GyMMM|MMM y G|GyMMMd|d בMMM y G|GyMMMEd|E, d בMMM y G|h|\u200Fh a|H|H|hm|h:mm a|Hm|H:mm|hms|h:mm:ss a|Hms|H:mm:ss|hmsv|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm a v|Hmv|HH:mm v|M|L|Md|d.M|MEd|E, d.M|MMM|LLL|MMMd|d בMMM|MMMEd|E, d בMMM|MMMMd|d בMMMM|MMMMW-count-one|שבוע W בMMMM|MMMMW-count-two|שבוע W בMMMM|MMMMW-count-other|שבוע W בMMMM|ms|mm:ss|y|y|yM|M.y|yMd|d.M.y|yMEd|E, d.M.y|yMM|M.y|yMMM|MMM y|yMMMd|d בMMM y|yMMMEd|E, d בMMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|שבוע w בשנת Y|yw-count-two|שבוע w בשנת Y|yw-count-other|שבוע w בשנת Y|Hmm|Hmmss|Hmmssz|Hmmsszzzz|X3W,|.|\u200E-||||||E2W,|.|\u200F-|\u00A0\u200F¤|\u200F|\u00A0\u200F¤|\u200F|\u00A0\u200F¤|E0W,|.|\u200E-|%||%||%|108|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р|BZD|$|CAD|CA$|CLP|$|CNY|\u200ECN¥\u200E|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILP|ל״י|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XCG|Cg.|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$he = $enkidatron$elm_cldr$Generated$He$he;
var $enkidatron$elm_cldr$Generated$Hi$dayPeriods = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			'hi',
			_List_fromArray(
				[
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(12, 0),
					_Utils_Tuple2(16, 0),
					'afternoon1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(16, 0),
					_Utils_Tuple2(20, 0),
					'evening1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(0, 0),
					'midnight'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(4, 0),
					_Utils_Tuple2(12, 0),
					'morning1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(20, 0),
					_Utils_Tuple2(4, 0),
					'night1')
				])),
			_Utils_Tuple2(
			'hi_latn',
			_List_fromArray(
				[
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(12, 0),
					_Utils_Tuple2(16, 0),
					'afternoon1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(16, 0),
					_Utils_Tuple2(20, 0),
					'evening1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(0, 0),
					'midnight'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(4, 0),
					_Utils_Tuple2(12, 0),
					'morning1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(20, 0),
					_Utils_Tuple2(4, 0),
					'night1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(12, 0),
					'noon')
				]))
		]));
var $enkidatron$elm_cldr$Generated$Hi$hi = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Hi$dayPeriods, 'hi||||am|pm|7|afternoon1|दोपहर|am|am|evening1|शाम|midnight|मध्यरात्रि|morning1|सुबह|night1|रात|pm|pm|am|pm|7|afternoon1|दोपहर|am|am|evening1|शाम|midnight|मध्यरात्रि|morning1|सुबह|night1|रात|pm|pm|am|pm|7|afternoon1|दोपहर|am|am|evening1|शाम|midnight|मध्यरात्रि|morning1|सुबह|night1|रात|pm|pm|d/M/yy|d MMM y|d MMMM y|EEEE, d MMMM y|जन॰|फ़र॰|मार्च|अप्रैल|मई|जून|जुल॰|अग॰|सित॰|अक्टू॰|नव॰|दिस॰|जनवरी|फ़रवरी|मार्च|अप्रैल|मई|जून|जुलाई|अगस्त|सितंबर|अक्टूबर|नवंबर|दिसंबर|ज|फ़|मा|अ|म|जू|जु|अ|सि|अ|न|दि|0|रवि|सोम|मंगल|बुध|गुरु|शुक्र|शनि|रविवार|सोमवार|मंगलवार|बुधवार|गुरुवार|शुक्रवार|शनिवार|र|सो|मं|बु|गु|शु|श|0|ईसा-पूर्व|ईस्वी|ईसा-पूर्व|ईसवी सन|ईसा-पूर्व|ईस्वी|h:mm a|h:mm:ss a|h:mm:ss a z|h:mm:ss a zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|53|Bh|B h|Bhm|B h:mm|Bhms|B h:mm:ss|d|d|E|ccc|EBhm|E B h:mm|EBhms|E B h:mm:ss|Ed|E d|Ehm|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss a|EHms|E HH:mm:ss|Gy|y G|GyMd|GGGGG d/M/y|GyMMM|MMM G y|GyMMMd|d MMM y G|GyMMMEd|E, d MMM y G|h|h\u202Fa|H|HH|hm|h:mm a|Hm|HH:mm|hms|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm a v|Hmv|HH:mm v|M|L|Md|d/M|MEd|E, d/M|MMdd|dd/MM|MMM|LLL|MMMd|d MMM|MMMEd|E, d MMM|MMMMd|d MMMM|MMMMEd|E, d MMMM|MMMMW-count-one|MMMM का सप्ताह W|MMMMW-count-other|MMMM का सप्ताह W|ms|mm:ss|y|y|yM|M/y|yMd|d/M/y|yMEd|E, d/M/y|yMM|MM/y|yMMdd|dd/MM/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E, d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|Y का सप्ताह w|yw-count-other|Y का सप्ताह w|ahmm|ahmmss|ahmmssz|ahmmsszzzz|X3I,|.|-||||||E2I,|.|-¤||¤||¤||E0I,|.|-|%||%||%|107|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|लेई|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XCG|Cg.|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$hi = $enkidatron$elm_cldr$Generated$Hi$hi;
var $enkidatron$elm_cldr$Generated$Hr$dayPeriods = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			'hr',
			_List_fromArray(
				[
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(12, 0),
					_Utils_Tuple2(18, 0),
					'afternoon1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(18, 0),
					_Utils_Tuple2(21, 0),
					'evening1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(0, 0),
					'midnight'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(4, 0),
					_Utils_Tuple2(12, 0),
					'morning1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(21, 0),
					_Utils_Tuple2(4, 0),
					'night1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(12, 0),
					'noon')
				]))
		]));
var $enkidatron$elm_cldr$Generated$Hr$hr = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Hr$dayPeriods, 'hr||||AM|PM|8|afternoon1|popodne|am|AM|evening1|navečer|midnight|ponoć|morning1|ujutro|night1|noću|noon|podne|pm|PM|AM|PM|8|afternoon1|poslije podne|am|AM|evening1|navečer|midnight|ponoć|morning1|ujutro|night1|noću|noon|podne|pm|PM|AM|PM|8|afternoon1|popodne|am|AM|evening1|navečer|midnight|ponoć|morning1|ujutro|night1|noću|noon|podne|pm|PM|dd. MM. y.|d. MMM y.|d. MMMM y.|EEEE, d. MMMM y.|sij|velj|ožu|tra|svi|lip|srp|kol|ruj|lis|stu|pro|siječnja|veljače|ožujka|travnja|svibnja|lipnja|srpnja|kolovoza|rujna|listopada|studenoga|prosinca|1.|2.|3.|4.|5.|6.|7.|8.|9.|10.|11.|12.|1|sij|velj|ožu|tra|svi|lip|srp|kol|ruj|lis|stu|pro|siječanj|veljača|ožujak|travanj|svibanj|lipanj|srpanj|kolovoz|rujan|listopad|studeni|prosinac|1.|2.|3.|4.|5.|6.|7.|8.|9.|10.|11.|12.|ned|pon|uto|sri|čet|pet|sub|nedjelja|ponedjeljak|utorak|srijeda|četvrtak|petak|subota|N|P|U|S|Č|P|S|1|ned|pon|uto|sri|čet|pet|sub|nedjelja|ponedjeljak|utorak|srijeda|četvrtak|petak|subota|n|p|u|s|č|p|s|pr. Kr.|po. Kr.|prije Krista|poslije Krista|pr.n.e.|AD|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss (zzzz)|{1} {0}|{1} {0}|{1} {0}|{1} {0}|54|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d.|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E, d.|Ehm|E h:mm\u202Fa|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|EHms|E HH:mm:ss|Gy|y. G|GyMd|d. M. y. GGGGG|GyMMM|LLL y. G|GyMMMd|d. MMM y. G|GyMMMEd|E, d. MMM y. G|h|h\u202Fa|H|HH|hm|hh:mm\u202Fa|Hm|HH:mm|hms|hh:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|Hmv|HH:mm v|M|L.|Md|dd. MM.|MEd|E, dd. MM.|MMdd|dd. MM.|MMM|LLL|MMMd|d. MMM|MMMEd|E, d. MMM|MMMMd|d. MMMM|MMMMEd|E, d. MMMM|MMMMW-count-one|W. \'tjedan\' MMMM|MMMMW-count-few|W. \'tjedan\' MMMM|MMMMW-count-other|W. \'tjedan\' MMMM|ms|mm:ss|y|y.|yM|MM. y.|yMd|dd. MM. y.|yMEd|E, dd. MM. y.|yMM|MM. y.|yMMM|LLL y.|yMMMd|d. MMM y.|yMMMEd|E, d. MMM y.|yMMMM|LLLL y.|yQQQ|QQQ y.|yQQQQ|QQQQ y.|yw-count-one|w. \'tjedan\' \'u\' Y.|yw-count-few|w. \'tjedan\' \'u\' Y.|yw-count-other|w. \'tjedan\' \'u\' Y.|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W.|,|−||||||E2W.|,|−|\u00A0¤||\u00A0¤||\u00A0¤|E0W.|,|−|\u00A0%||\u00A0%||\u00A0%|108|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|AUD|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|BRL|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CAD|CLP|$|CNY|CNY|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|GBP|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HKD|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|ILS|INR|INR|ISK|kr|JMD|$|JPY|JPY|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|KRW|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MXN|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZD|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RUR|р.|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|TWD|UAH|₴|USD|USD|UYU|$|VEF|Bs|VND|VND|XAF|FCFA|XCD|XCD|XCG|Cg.|XOF|F\u202FCFA|XPF|XPF|XXX|XXX|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$hr = $enkidatron$elm_cldr$Generated$Hr$hr;
var $enkidatron$elm_cldr$Generated$Hsb$dayPeriods = $elm$core$Dict$fromList(_List_Nil);
var $enkidatron$elm_cldr$Generated$Hsb$hsb = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Hsb$dayPeriods, 'hsb||||dop.|pop.|2|am|dop.|pm|pop.|dopołdnja|popołdnju|2|am|dopołdnja|pm|popołdnju|dop.|pop.|2|am|dop.|pm|pop.|d.M.yy|d.M.y|d. MMMM y|EEEE, d. MMMM y|jan.|feb.|měr.|apr.|mej.|jun.|jul.|awg.|sep.|okt.|now.|dec.|januara|februara|měrca|apryla|meje|junija|julija|awgusta|septembra|oktobra|nowembra|decembra|j|f|m|a|m|j|j|a|s|o|n|d|1|jan|feb|měr|apr|mej|jun|jul|awg|sep|okt|now|dec|januar|februar|měrc|apryl|meja|junij|julij|awgust|september|oktober|nowember|december|j|f|m|a|m|j|j|a|s|o|n|d|nje|pón|wut|srj|štw|pja|sob|njedźela|póndźela|wutora|srjeda|štwórtk|pjatk|sobota|n|p|w|s|š|p|s|0|př.Chr.n.|po Chr.n.|před Chrystowym narodźenjom|po Chrystowym narodźenju|př.Chr.n.|po Chr.n.|H:mm \'hodź\'.|H:mm:ss|H:mm:ss z|H:mm:ss zzzz|{1} {0}|{1} {0}|{1} {0}|{1} {0}|53|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d.|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E, d.|Ehm|E, h:mm\u202Fa|EHm|E, H:mm \'hodź\'.|Ehms|E, h:mm:ss\u202Fa|EHms|E, HH:mm:ss|Gy|y G|GyMd|d.M.y GGGGG|GyMMM|MMM y G|GyMMMd|d. MMM y G|GyMMMEd|E, d. MMM y G|h|h\u202Fa|H|H \'hodź\'.|hm|h:mm\u202Fa|Hm|H:mm \'hodź\'.|hms|h:mm:ss\u202Fa|Hms|H:mm:ss|hmsv|h:mm:ss a v|Hmsv|H:mm:ss v|hmv|h:mm a v|Hmv|H:mm v|M|L|Md|d.M.|MEd|E, d.M.|MMM|LLL|MMMd|d. MMM|MMMEd|E, d. MMM|MMMMd|d. MMMM|MMMMW-count-one|W. \'tydźeń\' MMMM|MMMMW-count-two|W. \'tydźeń\' MMMM|MMMMW-count-few|W. \'tydźeń\' MMMM|MMMMW-count-other|W. \'tydźeń\' MMMM|ms|mm:ss|y|y|yM|M.y|yMd|d.M.y|yMEd|E, d.M.y|yMMM|MMM y|yMMMd|d. MMM y|yMMMEd|E, d. MMM y|yMMMM|LLLL y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|w. \'tydźeń\' \'lěta\' Y|yw-count-two|w. \'tydźeń\' \'lěta\' Y|yw-count-few|w. \'tydźeń\' \'lěta\' Y|yw-count-other|w. \'tydźeń\' \'lěta\' Y|Hmm|Hmmss|Hmmssz|Hmmsszzzz|X3W.|,|-||||||E2W.|,|-|\u00A0¤||\u00A0¤||\u00A0¤|E0W.|,|-|\u00A0%||\u00A0%||\u00A0%|106|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|AUD|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|₱|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XCG|Cg.|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$hsb = $enkidatron$elm_cldr$Generated$Hsb$hsb;
var $enkidatron$elm_cldr$Generated$Ht$dayPeriods = $elm$core$Dict$fromList(_List_Nil);
var $enkidatron$elm_cldr$Generated$Ht$ht = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Ht$dayPeriods, 'ht||||AM|PM|8|afternoon1|après-midi|am|AM|evening1|soir|midnight|minuit|morning1|matin|night1|matin|noon|midi|pm|PM|AM|PM|8|afternoon1|de l’après-midi|am|AM|evening1|du soir|midnight|minuit|morning1|du matin|night1|de la nuit|noon|midi|pm|PM|AM|PM|8|afternoon1|ap.m.|am|AM|evening1|soir|midnight|minuit|morning1|mat.|night1|matin|noon|midi|pm|PM|dd/MM/y|d MMM y|d MMMM y|EEEE d MMMM y|janv.|févr.|mars|avr.|mai|juin|juil.|août|sept.|oct.|nov.|déc.|janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre|J|F|M|A|M|J|J|A|S|O|N|D|0|dim.|lun.|mar.|mer.|jeu.|ven.|sam.|dimanche|lundi|mardi|mercredi|jeudi|vendredi|samedi|D|L|M|M|J|V|S|0|av. J.-C.|ap. J.-C.|avant Jésus-Christ|après Jésus-Christ|av. J.-C.|ap. J.-C.|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1} {0}|{1}, {0}|{1}, {0}|{1}, {0}|49|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|E|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E h:mm\u202Fa|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|EHms|E HH:mm:ss|Gy|y G|GyMd|dd/MM/y GGGGG|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E d MMM y G|h|h\u202Fa|H|HH \'h\'|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|Hmv|HH:mm v|M|L|Md|dd/MM|MEd|E dd/MM|MMM|LLL|MMMd|d MMM|MMMEd|E d MMM|MMMMd|d MMMM|MMMMW-count-one|\'semaine\' W (MMMM)|MMMMW-count-other|\'semaine\' W (MMMM)|ms|mm:ss|y|y|yM|MM/y|yMd|dd/MM/y|yMEd|E dd/MM/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\'semaine\' w \'de\' Y|yw-count-other|\'semaine\' w \'de\' Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W\u00A0|,|-||||||E2W\u00A0|,|-|\u00A0¤||\u00A0¤||\u00A0¤|E0W\u00A0|,|-|\u00A0%||\u00A0%||\u00A0%|117|AFN|؋|AMD|֏|AOA|Kz|ARS|$AR|AUD|$AU|AZN|₼|BAM|KM|BBD|$|BDT|৳|BEF|FB|BMD|$BM|BND|$BN|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$BZ|CAD|$CA|CLP|$CL|CNY|CNY|COP|$CO|CRC|₡|CUC|$|CUP|$|CYP|£CY|CZK|Kč|DKK|kr|DOP|$|EGP|£E|ESP|₧|EUR|€|FJD|$FJ|FKP|£FK|FRF|F|GBP|£GB|GEL|₾|GHS|GH₵|GIP|£GI|GNF|FG|GTQ|Q|GYD|$|HKD|HKD|HNL|L|HRK|kn|HTG|G|HUF|Ft|IDR|Rp|IEP|£IE|ILP|£IL|ILS|₪|INR|₹|ISK|kr|ITL|₤IT|JMD|$|JPY|JPY|KGS|\u20C0|KHR|៛|KMF|FC|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|£LB|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MTP|£MT|MUR|Rs|MXN|$MX|MYR|RM|NAD|$NA|NGN|₦|NIO|$C|NOK|kr|NPR|Rs|NZD|$NZ|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RHD|$RH|RON|L|RUB|₽|RWF|FR|SBD|$SB|SEK|kr|SGD|$SG|SHP|£|SRD|$SR|SSP|£|STN|Db|SYP|£|THB|฿|TOP|$T|TRY|₺|TTD|$TT|TWD|TWD|UAH|₴|USD|$US|UYU|$UY|VEF|Bs|VND|₫|WST|$WS|XAF|FCFA|XCD|XCD|XCG|Cg.|XOF|F\u202FCFA|XPF|FCFP|XXX|¤|ZAR|R|ZMW|Kw|'));
var $enkidatron$elm_cldr$Cldr$Locale$ht = $enkidatron$elm_cldr$Generated$Ht$ht;
var $enkidatron$elm_cldr$Generated$Hu$dayPeriods = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			'hu',
			_List_fromArray(
				[
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(12, 0),
					_Utils_Tuple2(18, 0),
					'afternoon1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(18, 0),
					_Utils_Tuple2(21, 0),
					'evening1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(0, 0),
					'midnight'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(6, 0),
					_Utils_Tuple2(9, 0),
					'morning1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(9, 0),
					_Utils_Tuple2(12, 0),
					'morning2'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(21, 0),
					_Utils_Tuple2(4, 0),
					'night1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(4, 0),
					_Utils_Tuple2(6, 0),
					'night2'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(12, 0),
					'noon')
				]))
		]));
var $enkidatron$elm_cldr$Generated$Hu$hu = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Hu$dayPeriods, 'hu||||de.|du.|10|afternoon1|du.|am|de.|evening1|este|midnight|éjfél|morning1|reggel|morning2|de.|night1|éjjel|night2|hajnal|noon|dél|pm|du.|de.|du.|10|afternoon1|délután|am|de.|evening1|este|midnight|éjfél|morning1|reggel|morning2|délelőtt|night1|éjjel|night2|hajnal|noon|dél|pm|du.|de.|du.|10|afternoon1|du.|am|de.|evening1|este|midnight|éjfél|morning1|reggel|morning2|de.|night1|éjjel|night2|hajnal|noon|dél|pm|du.|y. MM. dd.|y. MMM d.|y. MMMM d.|y. MMMM d., EEEE|jan.|febr.|márc.|ápr.|máj.|jún.|júl.|aug.|szept.|okt.|nov.|dec.|január|február|március|április|május|június|július|augusztus|szeptember|október|november|december|J|F|M|Á|M|J|J|A|Sz|O|N|D|0|V|H|K|Sze|Cs|P|Szo|vasárnap|hétfő|kedd|szerda|csütörtök|péntek|szombat|V|H|K|Sz|Cs|P|Sz|0|i. e.|i. sz.|Krisztus előtt|időszámításunk szerint|ie.|isz.|H:mm|H:mm:ss|H:mm:ss z|H:mm:ss zzzz|{1} {0}|{1} {0}|{1} {0}|{1} {0}|50|Bh|B h|Bhm|B h:mm|Bhms|B h:mm:ss|d|d|E|ccc|EBhm|E B h:mm|EBhms|E B h:mm:ss|Ed|d., E|Ehm|E h:mm\u202Fa|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|EHms|E HH:mm:ss|Gy|G y.|GyMd|GGGGG y. MM. dd.|GyMMM|G y. MMM|GyMMMd|G y. MMM d.|GyMMMEd|G y. MMM d., E|h|a\u202Fh|H|H|hm|a\u202Fh:mm|Hm|H:mm|hms|a\u202Fh:mm:ss|Hms|H:mm:ss|hmsv|a\u202Fh:mm:ss v|Hmsv|HH:mm:ss v|hmv|a\u202Fh:mm v|Hmv|HH:mm v|M|L|Md|M. d.|MEd|M. d., E|MMM|LLL|MMMd|MMM d.|MMMEd|MMM d., E|MMMMd|MMMM d.|MMMMW-count-one|MMMM W. \'hete\'|MMMMW-count-other|MMMM W. \'hete\'|mmss|mm:ss|ms|mm:ss|y|y.|yM|y. M.|yMd|y. MM. dd.|yMEd|y. MM. dd., E|yMMM|y. MMM|yMMMd|y. MMM d.|yMMMEd|y. MMM d., E|yMMMM|y. MMMM|yQQQ|y. QQQ|yQQQQ|y. QQQQ|yw-count-one|Y w. \'hete\'|yw-count-other|Y w. \'hete\'|Hmm|Hmmss|Hmmssz|Hmmsszzzz|X3W\u00A0|,|-||||||E2W\u00A0|,|-|\u00A0¤||\u00A0¤||\u00A0¤|E0W\u00A0|,|-|%||%||%|107|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|AUD|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|BRL|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CAD|CLP|$|CNY|CNY|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|EUR|FJD|$|FKP|£|GBP|GBP|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HKD|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|ILS|INR|INR|ISK|kr|JMD|$|JPY|¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|KRW|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MXN|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZD|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|TWD|UAH|₴|USD|USD|UYU|$|VEF|Bs|VND|VND|XAF|FCFA|XCD|XCD|XCG|Cg.|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$hu = $enkidatron$elm_cldr$Generated$Hu$hu;
var $enkidatron$elm_cldr$Generated$Hy$dayPeriods = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			'hy',
			_List_fromArray(
				[
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(12, 0),
					_Utils_Tuple2(18, 0),
					'afternoon1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(18, 0),
					_Utils_Tuple2(24, 0),
					'evening1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(0, 0),
					'midnight'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(6, 0),
					_Utils_Tuple2(12, 0),
					'morning1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(0, 0),
					_Utils_Tuple2(6, 0),
					'night1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(12, 0),
					'noon')
				]))
		]));
var $enkidatron$elm_cldr$Generated$Hy$hy = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Hy$dayPeriods, 'hy||||AM|PM|8|afternoon1|ցերեկը|am|AM|evening1|երեկոյան|midnight|կեսգիշեր|morning1|առավոտյան|night1|գիշերը|noon|կեսօր|pm|PM|AM|PM|8|afternoon1|ցերեկվա|am|AM|evening1|երեկոյան|midnight|կեսգիշերին|morning1|առավոտյան|night1|գիշերվա|noon|կեսօրին|pm|PM|ա|հ|8|afternoon1|ցրկ|am|ա|evening1|երկ|midnight|կգ․|morning1|առվ|night1|գշր|noon|կօ․|pm|հ|dd.MM.yy|dd MMM, y թ.|dd MMMM, y թ.|y թ. MMMM d, EEEE|հնվ|փտվ|մրտ|ապր|մյս|հնս|հլս|օգս|սեպ|հոկ|նոյ|դեկ|հունվարի|փետրվարի|մարտի|ապրիլի|մայիսի|հունիսի|հուլիսի|օգոստոսի|սեպտեմբերի|հոկտեմբերի|նոյեմբերի|դեկտեմբերի|Հ|Փ|Մ|Ա|Մ|Հ|Հ|Օ|Ս|Հ|Ն|Դ|1|հնվ|փտվ|մրտ|ապր|մյս|հնս|հլս|օգս|սեպ|հոկ|նոյ|դեկ|հունվար|փետրվար|մարտ|ապրիլ|մայիս|հունիս|հուլիս|օգոստոս|սեպտեմբեր|հոկտեմբեր|նոյեմբեր|դեկտեմբեր|Հ|Փ|Մ|Ա|Մ|Հ|Հ|Օ|Ս|Հ|Ն|Դ|կիր|երկ|երք|չրք|հնգ|ուր|շբթ|կիրակի|երկուշաբթի|երեքշաբթի|չորեքշաբթի|հինգշաբթի|ուրբաթ|շաբաթ|Կ|Ե|Ե|Չ|Հ|Ո|Շ|0|մ.թ.ա.|մ.թ.|Քրիստոսից առաջ|Քրիստոսից հետո|մ.թ.ա.|մ.թ.|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|49|Bh|B h-ին|Bhm|B h:mm-ին|Bhms|B h:mm:ss|d|d|E|ccc|EBhm|E B h:mm-ին|EBhms|E B h:mm:ss|Ed|d, ccc|Ehm|E, h:mm a|EHm|E, HH:mm|Ehms|E, h:mm:ss a|EHms|E, HH:mm:ss|Gy|G y թ.|GyMd|dd.MM.y GGGGG|GyMMM|G y թ. MMM|GyMMMd|G y թ․ MMM d|GyMMMEd|G y թ. MMM d, E|h|h\u202Fa|H|H|hm|h:mm a|Hm|H:mm|hms|h:mm:ss a|Hms|H:mm:ss|hmsv|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm a v|Hmv|HH:mm v|M|L|Md|dd.MM|MEd|dd.MM, E|MMM|LLL|MMMd|d MMM|MMMEd|d MMM, E|MMMMd|d MMMM|MMMMW-count-one|MMMM W-ին շաբաթ|MMMMW-count-other|MMMM W-րդ շաբաթ|ms|mm:ss|y|y|yM|MM.y|yMd|dd.MM.y|yMEd|d.MM.y թ., E|yMMM|y թ. LLL|yMMMd|d MMM, y թ.|yMMMEd|y թ. MMM d, E|yMMMM|y թ․ LLLL|yQQQ|y թ. QQQ|yQQQQ|y թ. QQQQ|yw-count-one|Y թ․ w-ին շաբաթ|yw-count-other|Y թ․ w-րդ շաբաթ|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W\u00A0|,|-||||||E2W\u00A0|,|-|\u00A0¤||\u00A0¤||\u00A0¤|E0W\u00A0|,|-|%||%||%|107|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XCG|Cg.|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$hy = $enkidatron$elm_cldr$Generated$Hy$hy;
var $enkidatron$elm_cldr$Generated$Id$dayPeriods = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			'id',
			_List_fromArray(
				[
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(10, 0),
					_Utils_Tuple2(15, 0),
					'afternoon1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(15, 0),
					_Utils_Tuple2(18, 0),
					'evening1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(0, 0),
					'midnight'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(0, 0),
					_Utils_Tuple2(10, 0),
					'morning1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(18, 0),
					_Utils_Tuple2(24, 0),
					'night1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(12, 0),
					'noon')
				]))
		]));
var $enkidatron$elm_cldr$Generated$Id$id = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Id$dayPeriods, 'id||||AM|PM|8|afternoon1|siang|am|AM|evening1|sore|midnight|tengah malam|morning1|pagi|night1|malam|noon|tengah hari|pm|PM|AM|PM|8|afternoon1|siang|am|AM|evening1|sore|midnight|tengah malam|morning1|pagi|night1|malam|noon|tengah hari|pm|PM|AM|PM|8|afternoon1|siang|am|AM|evening1|sore|midnight|tengah malam|morning1|pagi|night1|malam|noon|tengah hari|pm|PM|dd/MM/yy|d MMM y|d MMMM y|EEEE, dd MMMM y|Jan|Feb|Mar|Apr|Mei|Jun|Jul|Agu|Sep|Okt|Nov|Des|Januari|Februari|Maret|April|Mei|Juni|Juli|Agustus|September|Oktober|November|Desember|J|F|M|A|M|J|J|A|S|O|N|D|0|Min|Sen|Sel|Rab|Kam|Jum|Sab|Minggu|Senin|Selasa|Rabu|Kamis|Jumat|Sabtu|M|S|S|R|K|J|S|0|SM|M|Sebelum Masehi|Masehi|SM|M|HH.mm|HH.mm.ss|HH.mm.ss z|HH.mm.ss zzzz|{1} {0}|{1} {0}|{1} {0}|{1} {0}|48|Bh|h B|Bhm|h.mm B|Bhms|h.mm.ss B|d|d|E|ccc|EBhm|E h.mm B|EBhms|E h.mm.ss B|Ed|E, d|Ehm|E h.mm\u202Fa|EHm|E HH.mm|Ehms|E h.mm.ss\u202Fa|EHms|E HH.mm.ss|Gy|y G|GyMd|d/M/y GGGGG|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E, d MMM y G|h|h\u202Fa|H|HH|hm|h.mm\u202Fa|Hm|HH.mm|hms|h.mm.ss\u202Fa|Hms|HH.mm.ss|hmsv|h.mm.ss. a v|Hmsv|HH.mm.ss v|hmv|h.mm\u202Fa v|Hmv|HH.mm v|M|L|Md|d/M|MEd|E, d/M|MMM|LLL|MMMd|d MMM|MMMEd|E, d MMM|MMMMd|d MMMM|MMMMEd|E, d MMMM|MMMMW-count-other|\'minggu\' \'ke\'-W MMMM|ms|mm.ss|y|y|yM|M/y|yMd|d/M/y|yMEd|E, d/M/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E, d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-other|\'minggu\' \'ke\'-w Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W.|,|-||||||E2W.|,|-¤||¤||¤||E0W.|,|-|%||%||%|107|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|AU$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|Rs|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XCG|Cg.|XOF|F\u202FCFA|XPF|CFPF|XXX|XXX|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$id = $enkidatron$elm_cldr$Generated$Id$id;
var $enkidatron$elm_cldr$Generated$Ig$dayPeriods = $elm$core$Dict$fromList(_List_Nil);
var $enkidatron$elm_cldr$Generated$Ig$ig = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Ig$dayPeriods, 'ig||||N’ụtụtụ|N’abalị|2|am|N’ụtụtụ|pm|N’abalị|N’ụtụtụ|N’abali|2|am|N’ụtụtụ|pm|N’abali|N’ụtụtụ|N’abalị|2|am|N’ụtụtụ|pm|N’abalị|d/M/yy|d MMM y|d MMMM y|EEEE, d MMMM y|Jen|Feb|Maa|Epr|Mee|Juu|Jul|Ọgọ|Sep|Ọkt|Nov|Dis|Jenụwarị|Febrụwarị|Maachị|Epreel|Mee|Jun|Julaị|Ọgọọst|Septemba|Ọktoba|Novemba|Disemba|J|F|M|E|M|J|J|Ọ|S|Ọ|N|D|0|Sọn|Mọn|Tiu|Wen|Tọọ|Fraị|Sat|Sọndee|Mọnde|Tiuzdee|Wenezdee|Tọọzdee|Fraịdee|Satọdee|S|M|T|W|T|F|S|0|BC|AD|Tupu Kraist|Afọ Kraịst|BC|AD|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|48|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|d, E|Ehm|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss a|EHms|E HH:mm:ss|Gy|G y|GyMd|GGGGG y-MM-dd|GyMMM|MMM G y|GyMMMd|d MMM, G y|GyMMMEd|E, d MMM, G y|h|h\u202Fa|H|HH|hm|h:mm a|Hm|HH:mm|hms|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm a v|Hmv|HH:mm v|M|L|Md|d/M|MEd|E, d/M|MMM|LLL|MMMd|d MMM|MMMEd|E, d MMM|MMMMd|d MMMM|MMMMEd|E, d MMMM|MMMMW-count-other|\'Izu\' W \'n\'‘\'ime\' MMMM|ms|mm:ss|y|y|yM|M/y|yMd|d/M/y|yMEd|E, d/M/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E, d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-other|\'Izu\' w \'n\' \'ime\' Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W,|.|-||||||E2W,|.|-¤||¤||¤||E0W,|.|-|%||%||%|106|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|₱|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XCG|Cg.|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$ig = $enkidatron$elm_cldr$Generated$Ig$ig;
var $enkidatron$elm_cldr$Generated$Is$dayPeriods = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			'is',
			_List_fromArray(
				[
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(12, 0),
					_Utils_Tuple2(18, 0),
					'afternoon1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(18, 0),
					_Utils_Tuple2(24, 0),
					'evening1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(0, 0),
					'midnight'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(6, 0),
					_Utils_Tuple2(12, 0),
					'morning1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(0, 0),
					_Utils_Tuple2(6, 0),
					'night1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(12, 0),
					'noon')
				]))
		]));
var $enkidatron$elm_cldr$Generated$Is$is = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Is$dayPeriods, 'is||||f.h.|e.h.|8|afternoon1|síðdegis|am|f.h.|evening1|að kvöldi|midnight|miðnætti|morning1|að morgni|night1|að nóttu|noon|hádegi|pm|e.h.|f.h.|e.h.|8|afternoon1|síðdegis|am|f.h.|evening1|að kvöldi|midnight|miðnætti|morning1|að morgni|night1|að nóttu|noon|hádegi|pm|e.h.|f.|e.|8|afternoon1|sd.|am|f.|evening1|kv.|midnight|mn.|morning1|mrg.|night1|n.|noon|h.|pm|e.|d.M.y|d. MMM y|d. MMMM y|EEEE, d. MMMM y|jan.|feb.|mar.|apr.|maí|jún.|júl.|ágú.|sep.|okt.|nóv.|des.|janúar|febrúar|mars|apríl|maí|júní|júlí|ágúst|september|október|nóvember|desember|J|F|M|A|M|J|J|Á|S|O|N|D|0|sun.|mán.|þri.|mið.|fim.|fös.|lau.|sunnudagur|mánudagur|þriðjudagur|miðvikudagur|fimmtudagur|föstudagur|laugardagur|S|M|Þ|M|F|F|L|0|f.Kr.|e.Kr.|fyrir Krist|eftir Krist|f.k.|e.k.|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|50|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d.|Ehm|E, h:mm\u202Fa|EHm|E, HH:mm|Ehms|E, h:mm:ss\u202Fa|EHms|E, HH:mm:ss|Gy|y G|GyMd|d/M/y GGGGG|GyMMM|MMM y G|GyMMMd|d. MMM y G|GyMMMEd|E, d. MMM y G|h|h\u202Fa|H|HH|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|v – HH:mm:ss|hmv|h:mm\u202Fa v|Hmv|v – HH:mm|M|L|Md|d.M.|MEd|E, d.M.|MMM|LLL|MMMd|d. MMM|MMMEd|E, d. MMM|MMMMd|d. MMMM|MMMMEd|E, d. MMMM|MMMMW-count-one|\'viku\' W \'í\' MMMM|MMMMW-count-other|\'viku\' W \'í\' MMMM|ms|mm:ss|y|y|yM|M. y|yMd|d.M.y|yMEd|E, d.M.y|yMMM|MMM y|yMMMd|d. MMM y|yMMMEd|E, d. MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\'viku\' w \'af\' Y|yw-count-other|\'viku\' w \'af\' Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W.|,|-||||||E2W.|,|-|\u00A0¤||\u00A0¤||\u00A0¤|E0W.|,|-|%||%||%|106|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|AUD|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|BRL|BSD|$|BWP|P|BZD|$|CAD|CAD|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr.|DOP|$|EGP|E£|ESP|₧|EUR|EUR|FJD|$|FKP|£|GBP|GBP|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|INR|ISK|kr.|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|KRW|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MXN|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr.|NPR|Rs|NZD|NZD|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr.|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|TWD|UAH|₴|USD|USD|UYU|$|VEF|Bs|VND|VND|XAF|FCFA|XCD|EC$|XCG|Cg.|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$is = $enkidatron$elm_cldr$Generated$Is$is;
var $enkidatron$elm_cldr$Generated$It$dayPeriods = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			'it',
			_List_fromArray(
				[
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(12, 0),
					_Utils_Tuple2(18, 0),
					'afternoon1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(18, 0),
					_Utils_Tuple2(24, 0),
					'evening1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(0, 0),
					'midnight'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(6, 0),
					_Utils_Tuple2(12, 0),
					'morning1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(0, 0),
					_Utils_Tuple2(6, 0),
					'night1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(12, 0),
					'noon')
				]))
		]));
var $enkidatron$elm_cldr$Generated$It$it = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$It$dayPeriods, 'it||||AM|PM|8|afternoon1|di pomeriggio|am|AM|evening1|di sera|midnight|mezzanotte|morning1|di mattina|night1|di notte|noon|mezzogiorno|pm|PM|AM|PM|8|afternoon1|del pomeriggio|am|AM|evening1|di sera|midnight|mezzanotte|morning1|di mattina|night1|di notte|noon|mezzogiorno|pm|PM|m.|p.|8|afternoon1|di pomeriggio|am|m.|evening1|di sera|midnight|mezzanotte|morning1|di mattina|night1|di notte|noon|mezzogiorno|pm|p.|dd/MM/yy|d MMM y|d MMMM y|EEEE d MMMM y|gen|feb|mar|apr|mag|giu|lug|ago|set|ott|nov|dic|gennaio|febbraio|marzo|aprile|maggio|giugno|luglio|agosto|settembre|ottobre|novembre|dicembre|G|F|M|A|M|G|L|A|S|O|N|D|0|dom|lun|mar|mer|gio|ven|sab|domenica|lunedì|martedì|mercoledì|giovedì|venerdì|sabato|D|L|M|M|G|V|S|0|a.C.|d.C.|avanti Cristo|dopo Cristo|aC|dC|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1}, {0}|{1}, {0}|{1} {0}|{1} {0}|49|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E h:mm\u202Fa|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|EHms|E HH:mm:ss|Gy|y G|GyMd|dd/MM/y GGGGG|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E d MMM y G|h|h\u202Fa|H|HH|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|Hmv|HH:mm v|M|L|Md|dd/MM|MEd|E dd/MM|MMM|LLL|MMMd|d MMM|MMMEd|E d MMM|MMMMd|d MMMM|MMMMW-count-one|\'settimana\' W \'di\' MMMM|MMMMW-count-other|\'settimana\' W \'di\' MMMM|ms|mm:ss|y|y|yM|MM/y|yMd|dd/MM/y|yMEd|E dd/MM/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\'settimana\' w \'del\' Y|yw-count-other|\'settimana\' w \'del\' Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W.|,|-||||||E2W.|,|-|\u00A0¤||\u00A0¤||\u00A0¤|E0W.|,|-|%||%||%|107|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|BRL|BSD|$|BWP|P|BYN|Br|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|£E|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HKD|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|INR|ISK|kr|JMD|$|JPY|JPY|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|KRW|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MXN|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|NKr|NPR|Rs|NZD|NZ$|PHP|₱|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|TWD|UAH|₴|USD|USD|UYU|$|VEF|Bs|VND|VND|XAF|FCFA|XCD|EC$|XCG|Cg.|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$it = $enkidatron$elm_cldr$Generated$It$it;
var $enkidatron$elm_cldr$Generated$Ja$dayPeriods = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			'ja',
			_List_fromArray(
				[
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(12, 0),
					_Utils_Tuple2(16, 0),
					'afternoon1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(16, 0),
					_Utils_Tuple2(19, 0),
					'evening1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(0, 0),
					'midnight'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(4, 0),
					_Utils_Tuple2(12, 0),
					'morning1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(19, 0),
					_Utils_Tuple2(23, 0),
					'night1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(23, 0),
					_Utils_Tuple2(4, 0),
					'night2'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(12, 0),
					'noon')
				]))
		]));
var $enkidatron$elm_cldr$Generated$Ja$ja = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Ja$dayPeriods, 'ja||||午前|午後|9|afternoon1|昼|am|午前|evening1|夕方|midnight|真夜中|morning1|朝|night1|夜|night2|夜中|noon|正午|pm|午後|午前|午後|9|afternoon1|昼|am|午前|evening1|夕方|midnight|真夜中|morning1|朝|night1|夜|night2|夜中|noon|正午|pm|午後|午前|午後|9|afternoon1|昼|am|午前|evening1|夕方|midnight|真夜中|morning1|朝|night1|夜|night2|夜中|noon|正午|pm|午後|y/MM/dd|y/MM/dd|y年M月d日|y年M月d日EEEE|1月|2月|3月|4月|5月|6月|7月|8月|9月|10月|11月|12月|1月|2月|3月|4月|5月|6月|7月|8月|9月|10月|11月|12月|1|2|3|4|5|6|7|8|9|10|11|12|0|日|月|火|水|木|金|土|日曜日|月曜日|火曜日|水曜日|木曜日|金曜日|土曜日|日|月|火|水|木|金|土|0|紀元前|西暦|紀元前|西暦|BC|AD|H:mm|H:mm:ss|H:mm:ss z|H時mm分ss秒 zzzz|{1} {0}|{1} {0}|{1} {0}|{1} {0}|54|Bh|BK時|Bhm|BK:mm|Bhms|BK:mm:ss|d|d日|E|ccc|EBhm|BK:mm (E)|EBhms|BK:mm:ss (E)|Ed|d日(E)|EEEEd|d日EEEE|Ehm|aK:mm (E)|EHm|H:mm (E)|Ehms|aK:mm:ss (E)|EHms|H:mm:ss (E)|Gy|Gy年|GyMd|Gy/M/d|GyMMM|Gy年M月|GyMMMd|Gy年M月d日|GyMMMEd|Gy年M月d日(E)|GyMMMEEEEd|Gy年M月d日EEEE|h|aK時|H|H時|hm|aK:mm|Hm|H:mm|hms|aK:mm:ss|Hms|H:mm:ss|hmsv|aK:mm:ss v|Hmsv|H:mm:ss v|hmv|aK:mm v|Hmv|H:mm v|M|M月|Md|M/d|MEd|M/d(E)|MEEEEd|M/dEEEE|MMM|M月|MMMd|M月d日|MMMEd|M月d日(E)|MMMEEEEd|M月d日EEEE|MMMMd|M月d日|MMMMW-count-other|M月第W週|ms|mm:ss|y|y年|yM|y/M|yMd|y/M/d|yMEd|y/M/d(E)|yMEEEEd|y/M/dEEEE|yMM|y/MM|yMMM|y年M月|yMMMd|y年M月d日|yMMMEd|y年M月d日(E)|yMMMEEEEd|y年M月d日EEEE|yMMMM|y年M月|yQQQ|y/QQQ|yQQQQ|y年QQQQ|yw-count-other|Y年第w週|Hmm|Hmmss|Hmmssz|Hmmsszzzz|X3W,|.|-||||||E2W,|.|-¤||¤||¤||E0W,|.|-|%||%||%|107|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CA$|CLP|$|CNY|元|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|￥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|レイ|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XCG|Cg.|XOF|F\u202FCFA|XPF|CFPF|XXX|XXX|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$ja = $enkidatron$elm_cldr$Generated$Ja$ja;
var $enkidatron$elm_cldr$Generated$Jv$dayPeriods = $elm$core$Dict$fromList(_List_Nil);
var $enkidatron$elm_cldr$Generated$Jv$jv = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Jv$dayPeriods, 'jv||||Isuk|Wengi|2|am|Isuk|pm|Wengi|Isuk|Wengi|2|am|Isuk|pm|Wengi|Isuk|Wengi|2|am|Isuk|pm|Wengi|dd-MM-y|d MMM y|d MMMM y|EEEE, d MMMM y|Jan|Feb|Mar|Apr|Mei|Jun|Jul|Agt|Sep|Okt|Nov|Des|Januari|Februari|Maret|April|Mei|Juni|Juli|Agustus|September|Oktober|November|Desember|J|F|M|A|M|J|J|A|S|O|N|D|0|Ahad|Sen|Sel|Rab|Kam|Jum|Sab|Ahad|Senin|Selasa|Rabu|Kamis|Jumat|Sabtu|A|S|S|R|K|J|S|0|SM|M|Sakdurunge Masehi|Masehi|SM|M|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1}, {0}|{1}, {0}|{1} {0}|{1} {0}|47|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E, d|Ehm|E h:mm\u202Fa|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|EHms|E HH:mm:ss|Gy|y G|GyMd|d/M/y GGGGG|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E, d MMM y G|h|h\u202Fa|H|HH|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|Hmv|HH:mm v|M|L|Md|dd/MM|MEd|E dd/MM|MMM|LLL|MMMd|d MMM|MMMEd|E, d MMM|MMMMd|d MMMM|MMMMW-count-other|\'pekan\' W \'ing\' MMMM|ms|mm:ss|y|y|yM|MM-y|yMd|dd-MM-y|yMEd|E, dd-MM-y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E, d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-other|\'pekan\' w \'ing\' Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W.|,|-||||||E2W.|,|-¤\u00A0||¤\u00A0||¤\u00A0||E0W.|,|-|%||%||%|106|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|₱|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XCG|Cg.|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$jv = $enkidatron$elm_cldr$Generated$Jv$jv;
var $enkidatron$elm_cldr$Generated$Ka$dayPeriods = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			'ka',
			_List_fromArray(
				[
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(12, 0),
					_Utils_Tuple2(18, 0),
					'afternoon1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(18, 0),
					_Utils_Tuple2(21, 0),
					'evening1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(0, 0),
					'midnight'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(5, 0),
					_Utils_Tuple2(12, 0),
					'morning1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(21, 0),
					_Utils_Tuple2(5, 0),
					'night1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(12, 0),
					'noon')
				]))
		]));
var $enkidatron$elm_cldr$Generated$Ka$ka = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Ka$dayPeriods, 'ka||||AM|PM|8|afternoon1|ნაშუადღ.|am|AM|evening1|საღ.|midnight|შუაღამეს|morning1|დილ.|night1|ღამ.|noon|შუადღ.|pm|PM|AM|PM|8|afternoon1|ნაშუადღევს|am|AM|evening1|საღამოს|midnight|შუაღამეს|morning1|დილით|night1|ღამით|noon|შუადღეს|pm|PM|a|p|8|afternoon1|ნაშუადღ.|am|a|evening1|საღ.|midnight|შუაღამეს|morning1|დილ.|night1|ღამ.|noon|შუადღ.|pm|p|dd.MM.yy|d MMM. y|d MMMM, y|EEEE, dd MMMM, y|იან|თებ|მარ|აპრ|მაი|ივნ|ივლ|აგვ|სექ|ოქტ|ნოე|დეკ|იანვარი|თებერვალი|მარტი|აპრილი|მაისი|ივნისი|ივლისი|აგვისტო|სექტემბერი|ოქტომბერი|ნოემბერი|დეკემბერი|ი|თ|მ|ა|მ|ი|ი|ა|ს|ო|ნ|დ|0|კვი|ორშ|სამ|ოთხ|ხუთ|პარ|შაბ|კვირა|ორშაბათი|სამშაბათი|ოთხშაბათი|ხუთშაბათი|პარასკევი|შაბათი|კ|ო|ს|ო|ხ|პ|შ|0|ძვ. წ.|ახ. წ.|ძველი წელთაღრიცხვით|ახალი წელთაღრიცხვით|ძვ. წ.|ახ. წ.|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|49|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|d E|Ehm|E, h:mm a|EHm|E, HH:mm|Ehms|E, h:mm:ss a|EHms|E, HH:mm:ss|Gy|y G|GyMd|d.M.y GGGGG|GyMMM|MMM. y G|GyMMMd|d MMM. y G|GyMMMEd|E, d MMM. y G|h|h\u202Fa|H|HH|hm|h:mm a|Hm|HH:mm|hms|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm a v|Hmv|HH:mm v|M|L|Md|d.M|MEd|E, d.M|MMM|LLL|MMMd|d MMM|MMMEd|E, d MMM|MMMMd|d MMMM|MMMMW-count-one|MMMMს კვირა W|MMMMW-count-other|MMMMს კვირა W|ms|mm:ss|y|y|yM|M.y|yMd|d.M.y|yMEd|E, d.M.y|yMMM|MMM. y|yMMMd|d MMM. y|yMMMEd|E, d MMM. y|yMMMM|MMMM, y|yQQQ|QQQ, y|yQQQQ|QQQQ, y|yw-count-one|კვირა w, Y|yw-count-other|კვირა w, Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W\u00A0|,|-||||||E2W\u00A0|,|-|\u00A0¤||\u00A0¤||\u00A0¤|E0W\u00A0|,|-|%||%||%|107|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|AUD|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CA$|CLP|$|CNY|CNY|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HKD|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|ILS|INR|INR|ISK|kr|JMD|$|JPY|JPY|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|KRW|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZD|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|VND|XAF|FCFA|XCD|EC$|XCG|Cg.|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$ka = $enkidatron$elm_cldr$Generated$Ka$ka;
var $enkidatron$elm_cldr$Generated$Kk$dayPeriods = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			'kk',
			_List_fromArray(
				[
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(12, 0),
					_Utils_Tuple2(18, 0),
					'afternoon1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(18, 0),
					_Utils_Tuple2(21, 0),
					'evening1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(0, 0),
					'midnight'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(6, 0),
					_Utils_Tuple2(12, 0),
					'morning1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(21, 0),
					_Utils_Tuple2(6, 0),
					'night1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(12, 0),
					'noon')
				]))
		]));
var $enkidatron$elm_cldr$Generated$Kk$kk = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Kk$dayPeriods, 'kk||||AM|PM|8|afternoon1|түстен кейінгі|am|AM|evening1|кешкі|midnight|түн жарымы|morning1|таңғы|night1|түнгі|noon|түскі|pm|PM|AM|PM|8|afternoon1|түстен кейінгі|am|AM|evening1|кешкі|midnight|түн жарымы|morning1|таңғы|night1|түнгі|noon|түскі|pm|PM|AM|PM|8|afternoon1|түстен кейінгі|am|AM|evening1|кешкі|midnight|түнгі|morning1|таңғы|night1|түнгі|noon|түскі|pm|PM|dd.MM.yy|y\u202F\'ж\'. dd MMM|y\u202F\'ж\'. d MMMM|y\u202F\'ж\'. d MMMM, EEEE|қаң.|ақп.|нау.|сәу.|мам.|мау.|шіл.|там.|қыр.|қаз.|қар.|жел.|қаңтар|ақпан|наурыз|сәуір|мамыр|маусым|шілде|тамыз|қыркүйек|қазан|қараша|желтоқсан|Қ|А|Н|С|М|М|Ш|Т|Қ|Қ|Қ|Ж|1|қаң.|ақп.|нау.|сәу.|мам.|мау.|шіл.|там.|қыр.|қаз.|қар.|жел.|Қаңтар|Ақпан|Наурыз|Сәуір|Мамыр|Маусым|Шілде|Тамыз|Қыркүйек|Қазан|Қараша|Желтоқсан|Қ|А|Н|С|М|М|Ш|Т|Қ|Қ|Қ|Ж|жс|дс|сс|ср|бс|жм|сб|жексенбі|дүйсенбі|сейсенбі|сәрсенбі|бейсенбі|жұма|сенбі|Ж|Д|С|С|Б|Ж|С|0|б.з.д.|б.з.|Біздің заманымызға дейін|біздің заманымыз|б.з.д.|б.з.|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|49|Bh|B h|Bhm|B h:mm|Bhms|B h:mm:ss|d|d|E|ccc|EBhm|E, B h:mm|EBhms|E, B h:mm:ss|Ed|d, E|Ehm|E h:mm\u202Fa|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|EHms|E HH:mm:ss|Gy|G y\u202F\'ж\'.|GyMd|dd-MM-GGGGG y|GyMMM|G y\u202F\'ж\'. MMM|GyMMMd|G y\u202F\'ж\'. d MMM|GyMMMEd|G y\u202F\'ж\'. d MMM, E|h|h\u202Fa|H|HH|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|Hmv|HH:mm v|M|L|Md|dd.MM|MEd|dd.MM, E|MMM|LLL|MMMd|d MMM|MMMEd|d MMM, E|MMMMd|d MMMM|MMMMW-count-one|MMMM \'айының\' W-\'аптасы\'|MMMMW-count-other|MMMM \'айының\' W-\'аптасы\'|ms|mm:ss|y|y|yM|MM.y|yMd|dd.MM.y|yMEd|dd.MM.y, E|yMMM|y\u202F\'ж\'. MMM|yMMMd|y\u202F\'ж\'. d MMM|yMMMEd|y\u202F\'ж\'. d MMM, E|yMMMM|y\u202F\'ж\'. MMMM|yQQQ|y\u202F\'ж\'. QQQ|yQQQQ|y\u202F\'ж\'. QQQQ|yw-count-one|Y \'жылдың\' w-\'аптасы\'|yw-count-other|Y \'жылдың\' w-\'аптасы\'|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W\u00A0|,|-||||||E2W\u00A0|,|-|\u00A0¤||\u00A0¤||\u00A0¤|E0W\u00A0|,|-|%||%||%|108|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LSL|ЛСЛ|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XCG|Cg.|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$kk = $enkidatron$elm_cldr$Generated$Kk$kk;
var $enkidatron$elm_cldr$Generated$Km$dayPeriods = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			'km',
			_List_fromArray(
				[
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(12, 0),
					_Utils_Tuple2(18, 0),
					'afternoon1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(18, 0),
					_Utils_Tuple2(21, 0),
					'evening1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(0, 0),
					'midnight'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(0, 0),
					_Utils_Tuple2(12, 0),
					'morning1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(21, 0),
					_Utils_Tuple2(24, 0),
					'night1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(12, 0),
					'noon')
				]))
		]));
var $enkidatron$elm_cldr$Generated$Km$km = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Km$dayPeriods, 'km||||AM|PM|8|afternoon1|នៅពេលរសៀល|am|AM|evening1|នៅពេល\u200Bល្ងាច|midnight|អធ្រាត្រ|morning1|នៅពេល\u200Bព្រឹក|night1|នៅពេល\u200Bយប់|noon|ថ្ងៃត្រង់|pm|PM|AM|PM|8|afternoon1|នៅពេលរសៀល|am|AM|evening1|នៅពេល\u200Bល្ងាច|midnight|អធ្រាត្រ|morning1|នៅពេល\u200Bព្រឹក|night1|នៅពេល\u200Bយប់|noon|ថ្ងៃត្រង់|pm|PM|a|p|8|afternoon1|នៅពេលរសៀល|am|a|evening1|នៅពេល\u200Bល្ងាច|midnight|អធ្រាត្រ|morning1|នៅពេល\u200Bព្រឹក|night1|នៅពេល\u200Bយប់|noon|ថ្ងៃត្រង់|pm|p|d/M/yy|d MMM y|d MMMM y|EEEE d MMMM y|មករា|កុម្ភៈ|មីនា|មេសា|ឧសភា|មិថុនា|កក្កដា|សីហា|កញ្ញា|តុលា|វិច្ឆិកា|ធ្នូ|មករា|កុម្ភៈ|មីនា|មេសា|ឧសភា|មិថុនា|កក្កដា|សីហា|កញ្ញា|តុលា|វិច្ឆិកា|ធ្នូ|ម|ក|ម|ម|ឧ|ម|ក|ស|ក|ត|វ|ធ|0|អាទិត្យ|ចន្ទ|អង្គារ|ពុធ|ព្រហ|សុក្រ|សៅរ៍|អាទិត្យ|ច័ន្ទ|អង្គារ|ពុធ|ព្រហស្បតិ៍|សុក្រ|សៅរ៍|អ|ច|អ|ព|ព|ស|ស|1|អាទិត្យ|ចន្ទ|អង្គារ|ពុធ|ព្រហ|សុក្រ|សៅរ៍|អាទិត្យ|ចន្ទ|អង្គារ|ពុធ|ព្រហស្បតិ៍|សុក្រ|សៅរ៍|អ|ច|អ|ព|ព|ស|ស|មុន គ.ស.|គ.ស.|មុន\u200Bគ្រិស្តសករាជ|គ្រិស្តសករាជ|មុន គ.ស.|គ.ស.|h:mm a|h:mm:ss a|h:mm:ss a z|h:mm:ss a zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|47|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|d E|Ehm|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss a|EHms|E HH:mm:ss|Gy|y G|GyMd|GGGGG y-MM-dd|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E d MMM y G|h|h\u202Fa|H|HH|hm|h:mm a|Hm|HH:mm|hms|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm a v|Hmv|HH:mm v|M|L|Md|d/M|MEd|E d/M|MMM|LLL|MMMd|d MMM|MMMEd|E d MMM|MMMMd|d MMMM|MMMMW-count-other|សប្តាហ៍ទី W នៃខែ MMMM|ms|mm:ss|y|y|yM|M/y|yMd|d/M/y|yMEd|E d/M/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-other|សប្តាហ៍ទី w នៃឆ្នាំ Y|ahmm|ahmmss|ahmmssz|ahmmsszzzz|X3W,|.|-||||||E2W,|.|-|¤||¤||¤|E0W,|.|-|%||%||%|108|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LSL|ឡូទី|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XCG|Cg.|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$km = $enkidatron$elm_cldr$Generated$Km$km;
var $enkidatron$elm_cldr$Generated$Kn$dayPeriods = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			'kn',
			_List_fromArray(
				[
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(12, 0),
					_Utils_Tuple2(18, 0),
					'afternoon1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(18, 0),
					_Utils_Tuple2(21, 0),
					'evening1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(0, 0),
					'midnight'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(6, 0),
					_Utils_Tuple2(12, 0),
					'morning1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(21, 0),
					_Utils_Tuple2(6, 0),
					'night1')
				]))
		]));
var $enkidatron$elm_cldr$Generated$Kn$kn = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Kn$dayPeriods, 'kn||||AM|PM|7|afternoon1|ಮಧ್ಯಾಹ್ನ|am|AM|evening1|ಸಂಜೆ|midnight|ಮಧ್ಯ ರಾತ್ರಿ|morning1|ಬೆಳಗ್ಗೆ|night1|ರಾತ್ರಿ|pm|PM|AM|PM|7|afternoon1|ಮಧ್ಯಾಹ್ನ|am|AM|evening1|ಸಂಜೆ|midnight|ಮಧ್ಯ ರಾತ್ರಿ|morning1|ಬೆಳಗ್ಗೆ|night1|ರಾತ್ರಿ|pm|PM|a|p|7|afternoon1|ಮಧ್ಯಾಹ್ನ|am|a|evening1|ಸಂಜೆ|midnight|ಮಧ್ಯರಾತ್ರಿ|morning1|ಬೆಳಗ್ಗೆ|night1|ರಾತ್ರಿ|pm|p|d/M/yy|MMM d, y|MMMM d, y|EEEE, MMMM d, y|ಜನ|ಫೆಬ್ರ|ಮಾರ್ಚ್|ಏಪ್ರಿ|ಮೇ|ಜೂನ್|ಜುಲೈ|ಆಗ|ಸೆಪ್ಟೆಂ|ಅಕ್ಟೋ|ನವೆಂ|ಡಿಸೆಂ|ಜನವರಿ|ಫೆಬ್ರವರಿ|ಮಾರ್ಚ್|ಏಪ್ರಿಲ್|ಮೇ|ಜೂನ್|ಜುಲೈ|ಆಗಸ್ಟ್|ಸೆಪ್ಟೆಂಬರ್|ಅಕ್ಟೋಬರ್|ನವೆಂಬರ್|ಡಿಸೆಂಬರ್|ಜ|ಫೆ|ಮಾ|ಏ|ಮೇ|ಜೂ|ಜು|ಆ|ಸೆ|ಅ|ನ|ಡಿ|0|ಭಾನು|ಸೋಮ|ಮಂಗಳ|ಬುಧ|ಗುರು|ಶುಕ್ರ|ಶನಿ|ಭಾನುವಾರ|ಸೋಮವಾರ|ಮಂಗಳವಾರ|ಬುಧವಾರ|ಗುರುವಾರ|ಶುಕ್ರವಾರ|ಶನಿವಾರ|ಭಾ|ಸೋ|ಮಂ|ಬು|ಗು|ಶು|ಶ|0|ಕ್ರಿ.ಪೂ|ಕ್ರಿ.ಶ|ಕ್ರಿಸ್ತ ಪೂರ್ವ|ಕ್ರಿಸ್ತ ಶಕ|ಕ್ರಿ.ಪೂ|ಕ್ರಿ.ಶ|hh:mm a|hh:mm:ss a|hh:mm:ss a z|hh:mm:ss a zzzz|{1} {0}|{1} {0}|{1} {0}|{1} {0}|49|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|d E|Ehm|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss a|EHms|E HH:mm:ss|Gy|G y|GyMd|GGGGG y-MM-dd|GyMMM|G y MMM|GyMMMd|G y MMM d|GyMMMEd|G y MMM d, E|h|h\u202Fa|H|HH|hm|h:mm a|Hm|HH:mm|hms|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm a v|Hmv|HH:mm v|M|L|Md|d/M|MEd|d/M, E|MMdd|dd-MM|MMM|LLL|MMMd|d MMM|MMMEd|E, d MMM|MMMMd|d MMMM|MMMMW-count-other|\'week\' W \'of\' MMMM|ms|mm:ss|y|y|yM|M/y|yMd|d/M/y|yMEd|E, M/d/y|yMM|MM-y|yMMM|MMM y|yMMMd|MMM d,y|yMMMEd|E, MMM d, y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-other|\'week\' w \'of\' Y|ahhmm|ahhmmss|ahhmmssz|ahhmmsszzzz|X3W,|.|-||||||E2W,|.|-¤||¤||¤||E0W,|.|-|%||%||%|107|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|ಲೀ|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XCG|Cg.|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$kn = $enkidatron$elm_cldr$Generated$Kn$kn;
var $enkidatron$elm_cldr$Generated$Ko$dayPeriods = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			'ko',
			_List_fromArray(
				[
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(12, 0),
					_Utils_Tuple2(18, 0),
					'afternoon1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(18, 0),
					_Utils_Tuple2(21, 0),
					'evening1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(0, 0),
					'midnight'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(3, 0),
					_Utils_Tuple2(6, 0),
					'morning1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(6, 0),
					_Utils_Tuple2(12, 0),
					'morning2'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(21, 0),
					_Utils_Tuple2(3, 0),
					'night1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(12, 0),
					'noon')
				]))
		]));
var $enkidatron$elm_cldr$Generated$Ko$ko = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Ko$dayPeriods, 'ko||||AM|PM|9|afternoon1|오후|am|AM|evening1|저녁|midnight|자정|morning1|아침|morning2|오전|night1|밤|noon|정오|pm|PM|오전|오후|9|afternoon1|오후|am|오전|evening1|저녁|midnight|자정|morning1|아침|morning2|오전|night1|밤|noon|정오|pm|오후|AM|PM|9|afternoon1|오후|am|AM|evening1|저녁|midnight|자정|morning1|아침|morning2|오전|night1|밤|noon|정오|pm|PM|yy. M. d.|y. M. d.|y년 MMMM d일|y년 MMMM d일 EEEE|1월|2월|3월|4월|5월|6월|7월|8월|9월|10월|11월|12월|1월|2월|3월|4월|5월|6월|7월|8월|9월|10월|11월|12월|1월|2월|3월|4월|5월|6월|7월|8월|9월|10월|11월|12월|0|일|월|화|수|목|금|토|일요일|월요일|화요일|수요일|목요일|금요일|토요일|일|월|화|수|목|금|토|0|BC|AD|기원전|서기|BC|AD|a h:mm|a h:mm:ss|a h시 m분 s초 z|a h시 m분 s초 zzzz|{1} {0}|{1} {0}|{1} {0}|{1} {0}|56|Bh|B h시|Bhm|B h:mm|Bhms|B h:mm:ss|d|d일|E|ccc|EBhm|(E) B h:mm|EBhms|(E) B h:mm:ss|Ed|d일 (E)|EEEEd|d일 EEEE|Ehm|(E) a h:mm|EHm|(E) HH:mm|Ehms|(E) a h:mm:ss|EHms|(E) HH:mm:ss|Gy|G y년|GyMd|GGGGG y/M/d|GyMMM|G y년 MMM|GyMMMd|G y년 MMM d일|GyMMMEd|G y년 MMM d일 (E)|GyMMMEEEEd|G y년 MMM d일 EEEE|h|a h시|H|H시|HHmmss|HH:mm:ss|hm|a h:mm|Hm|HH:mm|hms|a h:mm:ss|Hms|H시 m분 s초|hmsv|a h:mm:ss v|Hmsv|H시 m분 s초 v|hmv|a h:mm v|Hmv|HH:mm v|M|M월|Md|M. d.|MEd|M. d. (E)|MEEEEd|M. d. EEEE|MMM|LLL|MMMd|MMM d일|MMMEd|MMM d일 (E)|MMMEEEEd|MMM d일 EEEE|MMMMd|MMMM d일|MMMMW-count-other|MMMM W번째 주|mmss|mm:ss|ms|mm:ss|y|y년|yM|y. M.|yMd|y. M. d.|yMEd|y. M. d. (E)|yMEEEEd|y. M. d. EEEE|yMM|y. M.|yMMM|y년 MMM|yMMMd|y년 MMM d일|yMMMEd|y년 MMM d일 (E)|yMMMEEEEd|y년 MMM d일 EEEE|yMMMM|y년 MMMM|yQQQ|y년 QQQ|yQQQQ|y년 QQQQ|yw-count-other|Y년 w번째 주|ahmm|ahmmss|ahmsz|ahmszzzz|X3W,|.|-||||||E2W,|.|-¤||¤||¤||E0W,|.|-|%||%||%|107|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|AU$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|L|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XCG|Cg.|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$ko = $enkidatron$elm_cldr$Generated$Ko$ko;
var $enkidatron$elm_cldr$Generated$Kok$dayPeriods = $elm$core$Dict$fromList(_List_Nil);
var $enkidatron$elm_cldr$Generated$Kok$kok = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Kok$dayPeriods, 'kok||||AM|PM|2|am|AM|pm|PM|सकाळीं|सांजे|2|am|सकाळीं|pm|सांजे|a|p|2|am|a|pm|p|d-M-yy|d-MMM-y|d MMMM y|EEEE d MMMM y|जानेवारी|फेब्रुवारी|मार्च|एप्रील|मे|जून|जुलय|ऑगस्ट|सप्टेंबर|ऑक्टोबर|नोव्हेंबर|डिसेंबर|जानेवारी|फेब्रुवारी|मार्च|एप्रील|मे|जून|जुलय|ऑगस्ट|सप्टेंबर|ऑक्टोबर|नोव्हेंबर|डिसेंबर|1|2|3|4|5|6|7|8|9|10|11|12|1|जाने|फेब्रु|मार्च|एप्री|मे|जून|जुल|ऑग|सप्टें|ऑक्टो|नो|डिसे|जानेवारी|फेब्रुवारी|मार्च|एप्रील|मे|जून|जुलय|ऑगस्ट|सप्टेंबर|ऑक्टोबर|नोव्हेंबर|डिसेंबर|1|2|3|4|5|6|7|8|9|10|11|12|आयतार|सोमार|मंगळार|बुधवार|बिरेस्तार|शुक्रार|शेनवार|आयतार|सोमार|मंगळार|बुधवार|बिरेस्तार|शुक्रार|शेनवार|आ|सो|मं|बु|बि|शु|शे|1|आयतार|सोमार|मंगळार|बुधवार|बिरेस्तार|शुक्रार|शेनवार|आयतार|सोमार|मंगळार|बुधवार|बिरेस्तार|शुक्रार|शेनवार|आ|सो|मं|बु|ब|शु|शे|क्रिस्तपूर्व|क्रि.श.|क्रिस्तपूर्व|क्रिस्तशक|क्रि.आ.|क्रि.श.|h:mm a|h:mm:ss a|h:mm:ss a z|h:mm:ss a zzzz|{1} {0}|{1} {0}|{1} {0}|{1} {0}|47|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|d, E|Ehm|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss a|EHms|E HH:mm:ss|Gy|G y|GyMd|GGGGG y-MM-dd|GyMMM|G y MMM|GyMMMd|G y MMM d|GyMMMEd|G y MMM d, E|h|h\u202Fa|H|HH|hm|h:mm a|Hm|HH:mm|hms|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm a v|Hmv|HH:mm v|M|L|Md|d-M|MEd|d-M, E|MMM|LLL|MMMd|d MMM|MMMEd|E, d MMM|MMMMd|d MMMM|MMMMW-count-other|\'week\' W \'of\' MMMM|ms|mm:ss|y|y|yM|M-y|yMd|d-M-y|yMEd|d-M-y, E|yMMM|MMM, y|yMMMd|d MMM, y|yMMMEd|y MMM d, E|yMMMM|MMMM, y|yQQQ|y QQQ|yQQQQ|y QQQQ|yw-count-other|\'week\' w \'of\' Y|ahmm|ahmmss|ahmmssz|ahmmsszzzz|X3W,|.|-||||||E2W,|.|-¤\u00A0||¤\u00A0||¤\u00A0||E0W,|.|-|%||%||%|107|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|रॉन|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XCG|Cg.|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$kok = $enkidatron$elm_cldr$Generated$Kok$kok;
var $enkidatron$elm_cldr$Generated$Ky$dayPeriods = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			'ky',
			_List_fromArray(
				[
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(12, 0),
					_Utils_Tuple2(18, 0),
					'afternoon1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(18, 0),
					_Utils_Tuple2(21, 0),
					'evening1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(0, 0),
					'midnight'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(6, 0),
					_Utils_Tuple2(12, 0),
					'morning1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(21, 0),
					_Utils_Tuple2(6, 0),
					'night1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(12, 0),
					'noon')
				]))
		]));
var $enkidatron$elm_cldr$Generated$Ky$ky = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Ky$dayPeriods, 'ky||||тң|тк|8|afternoon1|түштөн кийин|am|тң|evening1|кечинде|midnight|түн ортосу|morning1|эртең менен|night1|түн ичинде|noon|чак түш|pm|тк|таңкы|түштөн кийинки|8|afternoon1|түштөн кийин|am|таңкы|evening1|кечинде|midnight|түн ортосу|morning1|эртең менен|night1|түн ичинде|noon|чак түш|pm|түштөн кийинки|тң|тк|8|afternoon1|түшт кйн|am|тң|evening1|кечк|midnight|түн орт|morning1|эртң мн|night1|түн|noon|чт|pm|тк|d/M/yy|y-\'ж\'., d-MMM|y-\'ж\'., d-MMMM|y-\'ж\'., d-MMMM, EEEE|янв.|фев.|мар.|апр.|май|июн.|июл.|авг.|сен.|окт.|ноя.|дек.|январь|февраль|март|апрель|май|июнь|июль|август|сентябрь|октябрь|ноябрь|декабрь|Я|Ф|М|А|М|И|И|А|С|О|Н|Д|1|Янв|Фев|Мар|Апр|Май|Июн|Июл|Авг|Сен|Окт|Ноя|Дек|Январь|Февраль|Март|Апрель|Май|Июнь|Июль|Август|Сентябрь|Октябрь|Ноябрь|Декабрь|Я|Ф|М|А|М|И|И|А|С|О|Н|Д|жек.|дүй.|шейш.|шарш.|бейш.|жума|ишм.|жекшемби|дүйшөмбү|шейшемби|шаршемби|бейшемби|жума|ишемби|Ж|Д|Ш|Ш|Б|Ж|И|0|б.з.ч.|б.з.|биздин заманга чейин|биздин заман|б.з.ч.|б.з.|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1} {0}|{1} {0}|{1} {0}|{1} {0}|49|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|d, E|Ehm|E h:mm\u202Fa|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|EHms|E HH:mm:ss|Gy|G y-\'ж\'.|GyMd|GGGGG y-MM-dd|GyMMM|G y-\'ж\'. MMM|GyMMMd|G y-\'ж\'. d-MMM|GyMMMEd|G y-\'ж\'. d-MMM, E|h|h\u202Fa|H|HH|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|Hmv|HH:mm v|M|L|Md|dd-MM|MEd|dd-MM, E|MMM|LLL|MMMd|d-MMM|MMMEd|d-MMM, E|MMMMd|d-MMMM|MMMMW-count-one|MMMM \'айынын\' W-\'аптасы\'|MMMMW-count-other|MMMM \'айынын\' W-\'аптасы\'|ms|mm:ss|y|y|yM|y-MM|yMd|y-dd-MM|yMEd|y-dd-MM, E|yMMM|y-\'ж\'. MMM|yMMMd|y-\'ж\'. d-MMM|yMMMEd|y-\'ж\'. d-MMM, E|yMMMM|y-\'ж\'., MMMM|yQQQ|y-\'ж\'., QQQ|yQQQQ|y-\'ж\'., QQQQ|yw-count-one|Y-\'жылдын\' w-\'аптасы\'|yw-count-other|Y-\'жылдын\' w-\'аптасы\'|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W\u00A0|,|-||||||E2W\u00A0|,|-|\u00A0¤||\u00A0¤||\u00A0¤|E0W\u00A0|,|-|%||%||%|107|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|AUD|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|BD$|BND|$|BOB|Bs|BRL|BRL|BSD|B$|BWP|P|BYN|р.|BZD|BZ$|CAD|CAD|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|RD$|EGP|LE|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|GBP|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HKD|HNL|L|HRK|Kn|HUF|Ft|IDR|Rp|ILS|ILS|INR|INR|ISK|kr|JMD|J$|JPY|JP¥|KGS|сом|KHR|៛|KMF|CF|KPW|₩|KRW|KRW|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MXN|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZD|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|TT$|TWD|TWD|UAH|₴|USD|USD|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|XCD|XCG|Cg.|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$ky = $enkidatron$elm_cldr$Generated$Ky$ky;
var $enkidatron$elm_cldr$Generated$Lo$dayPeriods = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			'lo',
			_List_fromArray(
				[
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(12, 0),
					_Utils_Tuple2(16, 0),
					'afternoon1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(16, 0),
					_Utils_Tuple2(20, 0),
					'evening1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(0, 0),
					'midnight'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(5, 0),
					_Utils_Tuple2(12, 0),
					'morning1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(20, 0),
					_Utils_Tuple2(5, 0),
					'night1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(12, 0),
					'noon')
				]))
		]));
var $enkidatron$elm_cldr$Generated$Lo$lo = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Lo$dayPeriods, 'lo||||ກ່ອນທ່ຽງ|ຫຼັງທ່ຽງ|8|afternoon1|ຕອນບ່າຍ|am|ກ່ອນທ່ຽງ|evening1|ຕອນແລງ|midnight|ທ່ຽງຄືນ|morning1|ຕອນເຊົ້າ|night1|ກາງຄືນ|noon|ຕອນທ່ຽງ|pm|ຫຼັງທ່ຽງ|ກ່ອນທ່ຽງ|ຫຼັງທ່ຽງ|8|afternoon1|ຕອນບ່າຍ|am|ກ່ອນທ່ຽງ|evening1|ຕອນແລງ|midnight|ທ່ຽງຄືນ|morning1|ຕອນເຊົ້າ|night1|ຕອນກາງຄືນ|noon|ຕອນທ່ຽງ|pm|ຫຼັງທ່ຽງ|ກ່ອນທ່ຽງ|ຫຼັງທ່ຽງ|8|afternoon1|ຕອນທ່ຽງ|am|ກ່ອນທ່ຽງ|evening1|ຕອນແລງ|midnight|ທ່ຽງຄືນ|morning1|ຕອນເຊົ້າ|night1|ກາງຄືນ|noon|ຕອນທ່ຽງ|pm|ຫຼັງທ່ຽງ|d/M/y|d MMM y|d MMMM y|EEEE, d MMMM y|ມ.ກ.|ກ.ພ.|ມ.ນ.|ມ.ສ.|ພ.ພ.|ມິ.ຖ.|ກ.ລ.|ສ.ຫ.|ກ.ຍ.|ຕ.ລ.|ພ.ຈ.|ທ.ວ.|ມັງກອນ|ກຸມພາ|ມີນາ|ເມສາ|ພຶດສະພາ|ມິຖຸນາ|ກໍລະກົດ|ສິງຫາ|ກັນຍາ|ຕຸລາ|ພະຈິກ|ທັນວາ|1|2|3|4|5|6|7|8|9|10|11|12|0|ອາທິດ|ຈັນ|ອັງຄານ|ພຸດ|ພະຫັດ|ສຸກ|ເສົາ|ວັນອາທິດ|ວັນຈັນ|ວັນອັງຄານ|ວັນພຸດ|ວັນພະຫັດ|ວັນສຸກ|ວັນເສົາ|ອາ|ຈ|ອ|ພ|ພຫ|ສຸ|ສ|0|ກ່ອນ ຄ.ສ.|ຄ.ສ.|ກ່ອນຄຣິດສັກກະລາດ|ຄຣິດສັກກະລາດ|ກ່ອນ ຄ.ສ.|ຄ.ສ.|H:mm|H:mm:ss|H ໂມງ m ນາທີ ss ວິນາທີ z|H ໂມງ m ນາທີ ss ວິນາທີ zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|47|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E, d|Ehm|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss a|EHms|E HH:mm:ss|Gy|G y|GyMd|d/M/GGGGG y|GyMMM|MMM, G y|GyMMMd|d MMMM, G y|GyMMMEd|E d MMMM, G y|h|h ໂມງa|H|HH|hm|h:mm a|Hm|HH:mm|hms|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm a v|Hmv|HH:mm v|M|L|Md|d/M|MEd|E, d/M|MMM|LLL|MMMd|d MMM|MMMEd|E d MMM|MMMMd|d MMMM|MMMMW-count-other|ອາທິດທີ່ W ຂອງເດືອນ M|ms|mm:ss|y|y|yM|M/y|yMd|d/M/y|yMEd|E, d/M/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E, d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-other|ອາທິດທີ່ w ຂອງປີ Y|Hmm|Hmmss|Hmssz|Hmsszzzz|X3W.|,|-||||||E2W.|,|¤-||¤||¤||E0W.|,|-|%||%||%|107|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XCG|Cg.|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$lo = $enkidatron$elm_cldr$Generated$Lo$lo;
var $enkidatron$elm_cldr$Generated$As$dayPeriods = $elm$core$Dict$fromList(_List_Nil);
var $enkidatron$elm_cldr$Generated$As$locale_as = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$As$dayPeriods, 'as||||AM|PM|2|am|AM|pm|PM|AM|PM|2|am|AM|pm|PM|am|pm|2|am|am|pm|pm|d-M-y|dd-MM-y|d MMMM, y|EEEE, d MMMM, y|জানু|ফেব্ৰু|মাৰ্চ|এপ্ৰিল|মে’|জুন|জুলাই|আগ|ছেপ্তে|অক্টো|নৱে|ডিচে|জানুৱাৰী|ফেব্ৰুৱাৰী|মাৰ্চ|এপ্ৰিল|মে’|জুন|জুলাই|আগষ্ট|ছেপ্তেম্বৰ|অক্টোবৰ|নৱেম্বৰ|ডিচেম্বৰ|জ|ফ|ম|এ|ম|জ|জ|আ|ছ|অ|ন|ড|0|দেও|সোম|মঙ্গল|বুধ|বৃহ|শুক্ৰ|শনি|দেওবাৰ|সোমবাৰ|মঙ্গলবাৰ|বুধবাৰ|বৃহস্পতিবাৰ|শুক্ৰবাৰ|শনিবাৰ|দ|স|ম|ব|ব|শ|শ|0|খ্ৰীঃ পূঃ|খ্ৰীঃ|খ্ৰীষ্টপূৰ্ব|খ্ৰীষ্টাব্দ|খ্ৰীঃ পূঃ|খ্ৰীঃ|a h.mm|a h.mm.ss|a h.mm.ss z|a h.mm.ss zzzz|{1} {0}|{1} {0}|{1} {0}|{1} {0}|49|Bh|B h|Bhm|B h:mm|Bhms|B h:mm:ss|d|d|E|ccc|EBhm|E B h:mm|EBhms|E B h:mm:ss|Ed|E d|Ehm|E a h:mm|EHm|E HH:mm|Ehms|E a h:mm:ss|EHms|E HH:mm:ss|Gy|G y|GyMd|d/M/y GGGGG|GyMMM|G y MMM|GyMMMd|G y MMM d|GyMMMEd|G y MMM d, E|h|a h|H|HH|hm|a h:mm|Hm|HH:mm|hms|a h:mm:ss|Hms|HH:mm:ss|hmsv|a h:mm:ss v|Hmsv|HH:mm:ss v|hmv|a h:mm v|Hmv|HH:mm v|M|L|Md|dd-MM|MEd|E, dd-MM|MMM|LLL|MMMd|d MMM|MMMEd|E, d MMM|MMMMd|d MMMM|MMMMW-count-one|MMMMৰ সপ্তাহ W|MMMMW-count-other|MMMMৰ সপ্তাহ W|ms|mm:ss|y|y|yM|MM-y|yMd|dd-MM-y|yMEd|E, dd-MM-y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E, d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|Yৰ সপ্তাহ w|yw-count-other|Yৰ সপ্তাহ w|ahmm|ahmmss|ahmmssz|ahmmsszzzz|X3I,|.|-||||||E2I,|.|-¤\u00A0||¤\u00A0||¤\u00A0||E0I,|.|-|%||%||%|107|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XCG|Cg.|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$locale_as = $enkidatron$elm_cldr$Generated$As$locale_as;
var $enkidatron$elm_cldr$Generated$Lt$dayPeriods = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			'lt',
			_List_fromArray(
				[
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(12, 0),
					_Utils_Tuple2(18, 0),
					'afternoon1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(18, 0),
					_Utils_Tuple2(24, 0),
					'evening1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(0, 0),
					'midnight'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(6, 0),
					_Utils_Tuple2(12, 0),
					'morning1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(0, 0),
					_Utils_Tuple2(6, 0),
					'night1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(12, 0),
					'noon')
				]))
		]));
var $enkidatron$elm_cldr$Generated$Lt$lt = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Lt$dayPeriods, 'lt||||priešpiet|popiet|8|afternoon1|popietė|am|priešpiet|evening1|vakaras|midnight|vidurnaktis|morning1|rytas|night1|naktis|noon|perpiet|pm|popiet|priešpiet|popiet|8|afternoon1|popietė|am|priešpiet|evening1|vakaras|midnight|vidurnaktis|morning1|rytas|night1|naktis|noon|perpiet|pm|popiet|pr.\u202Fp.|pop.|8|afternoon1|popietė|am|pr.\u202Fp.|evening1|vakaras|midnight|vidurnaktis|morning1|rytas|night1|naktis|noon|perpiet|pm|pop.|y-MM-dd|y-MM-dd|y \'m\'. MMMM d \'d\'.|y \'m\'. MMMM d \'d\'., EEEE|saus.|vas.|kov.|bal.|geg.|birž.|liep.|rugp.|rugs.|spal.|lapkr.|gruod.|sausio|vasario|kovo|balandžio|gegužės|birželio|liepos|rugpjūčio|rugsėjo|spalio|lapkričio|gruodžio|S|V|K|B|G|B|L|R|R|S|L|G|1|saus.|vas.|kov.|bal.|geg.|birž.|liep.|rugp.|rugs.|spal.|lapkr.|gruod.|sausis|vasaris|kovas|balandis|gegužė|birželis|liepa|rugpjūtis|rugsėjis|spalis|lapkritis|gruodis|S|V|K|B|G|B|L|R|R|S|L|G|sk|pr|an|tr|kt|pn|št|sekmadienis|pirmadienis|antradienis|trečiadienis|ketvirtadienis|penktadienis|šeštadienis|S|P|A|T|K|P|Š|0|pr. Kr.|po Kr.|prieš Kristų|po Kristaus|pr. Kr.|po Kr.|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1} {0}|{1} {0}|{1} {0}|{1} {0}|61|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|dd|E|ccc|EBhm|h:mm B, E|EBhms|h:mm:ss B, E|Ed|d, E|Ehm|hh:mm\u202Fa, E|EHm|HH:mm, E|Ehms|hh:mm:ss\u202Fa, E|EHms|HH:mm:ss, E|Gy|y \'m\'. G|GyMd|y-MM-dd G|GyMMM|y-MM G|GyMMMd|y-MM-dd G|GyMMMEd|y-MM-dd G, E|GyMMMM|y \'m\'. G, LLLL|GyMMMMd|y \'m\'. G MMMM d \'d\'.|GyMMMMEd|y \'m\'. G MMMM d \'d\'., E|h|hh\u202Fa|H|HH|hm|hh:mm\u202Fa|Hm|HH:mm|hms|hh:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|hh:mm:ss\u202Fa; v|Hmsv|HH:mm:ss; v|hmv|hh:mm\u202Fa; v|Hmv|HH:mm; v|M|MM|Md|MM-d|MEd|MM-dd, E|MMdd|MM-dd|MMM|MM|MMMd|MM-dd|MMMEd|MM-dd, E|MMMM|LLLL|MMMMd|MMMM d \'d\'.|MMMMEd|MMMM d \'d\'., E|MMMMW-count-one|MMMM W \'sav\'.|MMMMW-count-few|MMMM W \'sav\'.|MMMMW-count-many|MMMM W \'sav\'.|MMMMW-count-other|MMMM W \'sav\'.|ms|mm:ss|y|y|yM|y-MM|yMd|y-MM-dd|yMEd|y-MM-dd, E|yMMM|y-MM|yMMMd|y-MM-dd|yMMMEd|y-MM-dd, E|yMMMM|y \'m\'. LLLL|yMMMMd|y \'m\'. MMMM d \'d\'.|yMMMMEd|y \'m\'. MMMM d \'d\'., E|yQQQ|y QQQ|yQQQQ|y QQQQ|yw-count-one|Y w \'sav\'.|yw-count-few|Y w \'sav\'.|yw-count-many|Y w \'sav\'.|yw-count-other|Y w \'sav\'.|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W\u00A0|,|−||||||E2W\u00A0|,|−|\u00A0¤||\u00A0¤||\u00A0¤|E0W\u00A0|,|−|\u00A0%||\u00A0%||\u00A0%|107|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|AUD|AZN|₼|BAM|KM|BBD|$|BDT|BDT|BMD|$|BND|$|BOB|Bs|BRL|BRL|BSD|$|BWP|P|BYN|Br|BZD|$|CAD|CAD|CLP|$|CNY|CNY|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|GBP|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HKD|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|ILS|INR|INR|ISK|kr|JMD|$|JPY|JPY|KGS|\u20C0|KHR|KHR|KMF|CF|KPW|₩|KRW|KRW|KYD|$|KZT|₸|LAK|LAK|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|MNT|MUR|Rs|MXN|MXN|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZD|PHP|PHP|PKR|Rs|PLN|zl|PYG|Gs|RON|lei|RUB|rb|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|TWD|UAH|₴|USD|USD|UYU|$|VEF|Bs|VND|VND|XAF|XAF|XCD|XCD|XCG|Cg.|XOF|XOF|XPF|XPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$lt = $enkidatron$elm_cldr$Generated$Lt$lt;
var $enkidatron$elm_cldr$Generated$Lv$dayPeriods = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			'lv',
			_List_fromArray(
				[
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(12, 0),
					_Utils_Tuple2(18, 0),
					'afternoon1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(18, 0),
					_Utils_Tuple2(23, 0),
					'evening1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(0, 0),
					'midnight'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(6, 0),
					_Utils_Tuple2(12, 0),
					'morning1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(23, 0),
					_Utils_Tuple2(6, 0),
					'night1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(12, 0),
					'noon')
				]))
		]));
var $enkidatron$elm_cldr$Generated$Lv$lv = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Lv$dayPeriods, 'lv||||priekšp.|pēcp.|8|afternoon1|pēcpusd.|am|priekšp.|evening1|vakarā|midnight|pusnaktī|morning1|no rīta|night1|naktī|noon|pusd.|pm|pēcp.|priekšpusdienā|pēcpusdienā|8|afternoon1|pēcpusdienā|am|priekšpusdienā|evening1|vakarā|midnight|pusnaktī|morning1|no rīta|night1|naktī|noon|pusdienlaikā|pm|pēcpusdienā|priekšp.|pēcp.|8|afternoon1|pēcpusd.|am|priekšp.|evening1|vakarā|midnight|pusnaktī|morning1|no rīta|night1|naktī|noon|pusd.|pm|pēcp.|dd.MM.yy|y. \'gada\' d. MMM|y. \'gada\' d. MMMM|EEEE, y. \'gada\' d. MMMM|janv.|febr.|marts|apr.|maijs|jūn.|jūl.|aug.|sept.|okt.|nov.|dec.|janvāris|februāris|marts|aprīlis|maijs|jūnijs|jūlijs|augusts|septembris|oktobris|novembris|decembris|J|F|M|A|M|J|J|A|S|O|N|D|0|svētd.|pirmd.|otrd.|trešd.|ceturtd.|piektd.|sestd.|svētdiena|pirmdiena|otrdiena|trešdiena|ceturtdiena|piektdiena|sestdiena|S|P|O|T|C|P|S|1|Svētd.|Pirmd.|Otrd.|Trešd.|Ceturtd.|Piektd.|Sestd.|Svētdiena|Pirmdiena|Otrdiena|Trešdiena|Ceturtdiena|Piektdiena|Sestdiena|S|P|O|T|C|P|S|p.m.ē.|m.ē.|pirms mūsu ēras|mūsu ērā|p.m.ē.|m.ē.|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1} {0}|{1} {0}|{1} {0}|{1} {0}|53|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E, h:mm B|EBhms|E, h:mm:ss B|Ed|E, d.|Ehm|E, h:mm\u202Fa|EHm|E, HH:mm|Ehms|E, h:mm:ss\u202Fa|EHms|E, HH:mm:ss|Gy|G y. \'g\'.|GyMd|GGGGG dd-MM-y|GyMMM|G y. \'g\'. MMM|GyMMMd|G y. \'g\'. d. MMM|GyMMMEd|E, G y. \'g\'. d. MMM|h|h\u202Fa|H|HH|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|Hmv|HH:mm v|M|L|Md|dd.MM.|MEd|E, dd.MM.|MMM|LLL|MMMd|d. MMM|MMMEd|E, d. MMM|MMMMd|d. MMMM|MMMMEd|E, d. MMMM|MMMMW-count-zero|MMMM, W. \'nedēļa\'|MMMMW-count-one|MMMM, W. \'nedēļa\'|MMMMW-count-other|MMMM, W. \'nedēļa\'|mmss|mm:ss|ms|mm:ss|y|y. \'g\'.|yM|MM.y.|yMd|d.MM.y.|yMEd|E, d.MM.y.|yMMM|y. \'g\'. MMM|yMMMd|y. \'g\'. d. MMM|yMMMEd|E, y. \'g\'. d. MMM|yMMMM|y. \'g\'. MMMM|yQQQ|y. \'g\'. QQQ|yQQQQ|y. \'g\'. QQQQ|yw-count-zero|Y. \'g\'. w. \'nedēļa\'|yw-count-one|Y. \'g\'. w. \'nedēļa\'|yw-count-other|Y. \'g\'. w. \'nedēļa\'|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W\u00A0|,|-||||||E2W\u00A0|,|-|\u00A0¤||\u00A0¤||\u00A0¤|E0W\u00A0|,|-|%||%||%|107|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|AU$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GHS|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XCG|Cg.|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$lv = $enkidatron$elm_cldr$Generated$Lv$lv;
var $enkidatron$elm_cldr$Generated$Mk$dayPeriods = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			'mk',
			_List_fromArray(
				[
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(12, 0),
					_Utils_Tuple2(18, 0),
					'afternoon1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(18, 0),
					_Utils_Tuple2(24, 0),
					'evening1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(0, 0),
					'midnight'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(4, 0),
					_Utils_Tuple2(10, 0),
					'morning1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(10, 0),
					_Utils_Tuple2(12, 0),
					'morning2'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(0, 0),
					_Utils_Tuple2(4, 0),
					'night1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(12, 0),
					'noon')
				]))
		]));
var $enkidatron$elm_cldr$Generated$Mk$mk = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Mk$dayPeriods, 'mk||||претпл.|попл.|9|afternoon1|попладне|am|претпл.|evening1|навечер|midnight|полноќ|morning1|наутро|morning2|претпладне|night1|ноќе|noon|напладне|pm|попл.|претпл.|попл.|9|afternoon1|попладне|am|претпл.|evening1|навечер|midnight|полноќ|morning1|наутро|morning2|претпладне|night1|ноќе|noon|напладне|pm|попл.|претпл.|попл.|9|afternoon1|попл.|am|претпл.|evening1|навечер|midnight|полн.|morning1|наутро|morning2|претпл.|night1|ноќе|noon|напл.|pm|попл.|d.M.yy|d.M.y\u202F\'г\'.|d MMMM y\u202F\'г\'.|EEEE, d MMMM y\u202F\'г\'.|јан.|фев.|мар.|апр.|мај|јун.|јул.|авг.|сеп.|окт.|ное.|дек.|јануари|февруари|март|април|мај|јуни|јули|август|септември|октомври|ноември|декември|ј|ф|м|а|м|ј|ј|а|с|о|н|д|0|нед.|пон.|вто.|сре.|чет.|пет.|саб.|недела|понеделник|вторник|среда|четврток|петок|сабота|н|п|в|с|ч|п|с|0|пр. н. е.|н. е.|пред нашата ера|од нашата ера|пр. н. е.|н. е.|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|51|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E, d|Ehm|E h:mm\u202Fa|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|EHms|E HH:mm:ss|Gy|y\u202F\'г\'. G|GyMd|d.M.y\u202F\'г\'. G|GyMMM|MMM y\u202F\'г\'. G|GyMMMd|d MMM y\u202F\'г\'. G|GyMMMEd|E, d MMM y\u202F\'г\'. G|h|h\u202Fa|H|HH|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|Hmv|HH:mm v|M|L|Md|d.M|Mdd|d.M|MEd|E, d.M|MMM|LLL|MMMd|d MMM|MMMEd|E, d MMM|MMMMd|d MMMM|MMMMEd|E, d MMMM|MMMMW-count-one|W. \'седмица\' \'од\' MMMM|MMMMW-count-other|W. \'седмица\' \'од\' MMMM|ms|mm:ss|y|y\u202F\'г\'.|yM|M.y\u202F\'г\'.|yMd|d.M.y\u202F\'г\'.|yMEd|E, d.M.y\u202F\'г\'.|yMMM|MMM y\u202F\'г\'.|yMMMd|d MMM y\u202F\'г\'.|yMMMEd|E, d MMM y\u202F\'г\'.|yMMMM|MMMM y\u202F\'г\'.|yQQQ|QQQ y\u202F\'г\'.|yQQQQ|QQQQ y\u202F\'г\'.|yw-count-one|w. \'седмица\' \'од\' Y|yw-count-other|w. \'седмица\' \'од\' Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W.|,|-||||||E2W.|,|-|\u00A0¤||\u00A0¤||\u00A0¤|E0W.|,|-|\u00A0%||\u00A0%||\u00A0%|108|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|AUD|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CA$|CLP|$|CNY|CNY|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|GBP|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HKD|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|ILS|INR|INR|ISK|kr|JMD|$|JPY|JPY|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|KRW|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MKD|ден.|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZD|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|TWD|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|VND|XAF|FCFA|XCD|EC$|XCG|Cg.|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$mk = $enkidatron$elm_cldr$Generated$Mk$mk;
var $enkidatron$elm_cldr$Generated$Ml$dayPeriods = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			'ml',
			_List_fromArray(
				[
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(12, 0),
					_Utils_Tuple2(14, 0),
					'afternoon1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(14, 0),
					_Utils_Tuple2(15, 0),
					'afternoon2'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(15, 0),
					_Utils_Tuple2(18, 0),
					'evening1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(18, 0),
					_Utils_Tuple2(19, 0),
					'evening2'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(0, 0),
					'midnight'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(3, 0),
					_Utils_Tuple2(6, 0),
					'morning1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(6, 0),
					_Utils_Tuple2(12, 0),
					'morning2'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(19, 0),
					_Utils_Tuple2(3, 0),
					'night1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(12, 0),
					'noon')
				]))
		]));
var $enkidatron$elm_cldr$Generated$Ml$ml = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Ml$dayPeriods, 'ml||||AM|PM|11|afternoon1|ഉച്ചയ്ക്ക്|afternoon2|ഉച്ചതിരിഞ്ഞ്|am|AM|evening1|വൈകുന്നേരം|evening2|സന്ധ്യ|midnight|അർദ്ധരാത്രി|morning1|പുലർച്ചെ|morning2|രാവിലെ|night1|രാത്രി|noon|ഉച്ച|pm|PM|AM|PM|11|afternoon1|ഉച്ചയ്ക്ക്|afternoon2|ഉച്ചതിരിഞ്ഞ്|am|AM|evening1|വൈകുന്നേരം|evening2|സന്ധ്യ|midnight|അർദ്ധരാത്രി|morning1|പുലർച്ചെ|morning2|രാവിലെ|night1|രാത്രി|noon|ഉച്ച|pm|PM|AM|PM|11|afternoon1|ഉച്ചയ്ക്ക്|afternoon2|ഉച്ചതിരിഞ്ഞ്|am|AM|evening1|വൈകുന്നേരം|evening2|സന്ധ്യ|midnight|അ|morning1|പുലർച്ചെ|morning2|രാവിലെ|night1|രാത്രി|noon|ഉച്ച|pm|PM|d/M/yy|y, MMM d|y, MMMM d|y, MMMM d, EEEE|ജനു|ഫെബ്രു|മാർ|ഏപ്രി|മേയ്|ജൂൺ|ജൂലൈ|ഓഗ|സെപ്റ്റം|ഒക്ടോ|നവം|ഡിസം|ജനുവരി|ഫെബ്രുവരി|മാർച്ച്|ഏപ്രിൽ|മേയ്|ജൂൺ|ജൂലൈ|ഓഗസ്റ്റ്|സെപ്റ്റംബർ|ഒക്\u200Cടോബർ|നവംബർ|ഡിസംബർ|ജ|ഫെ|മാ|ഏ|മെ|ജൂൺ|ജൂ|ഓ|സെ|ഒ|ന|ഡി|0|ഞായർ|തിങ്കൾ|ചൊവ്വ|ബുധൻ|വ്യാഴം|വെള്ളി|ശനി|ഞായറാഴ്\u200Cച|തിങ്കളാഴ്\u200Cച|ചൊവ്വാഴ്ച|ബുധനാഴ്\u200Cച|വ്യാഴാഴ്\u200Cച|വെള്ളിയാഴ്\u200Cച|ശനിയാഴ്\u200Cച|ഞ|തി|ചൊ|ബു|വ്യാ|വെ|ശ|1|ഞായർ|തിങ്കൾ|ചൊവ്വ|ബുധൻ|വ്യാഴം|വെള്ളി|ശനി|ഞായറാഴ്\u200Cച|തിങ്കളാഴ്\u200Cച|ചൊവ്വാഴ്\u200Cച|ബുധനാഴ്\u200Cച|വ്യാഴാഴ്\u200Cച|വെള്ളിയാഴ്\u200Cച|ശനിയാഴ്\u200Cച|ഞാ|തി|ചൊ|ബു|വ്യാ|വെ|ശ|ബി.സി.|എഡി|ക്രിസ്\u200Cതുവിന് മുമ്പ്|ആന്നോ ഡൊമിനി|ബി.സി.|എഡി|h:mm a|h:mm:ss a|h:mm:ss a z|h:mm:ss a zzzz|{1} {0}|{1} {0}|{1} {0}|{1} {0}|52|Bh|B h|Bhm|B h:mm|Bhms|B h:mm:ss|d|d|E|ccc|EBhm|E, B h:mm|EBhms|E, B h:mm:ss|Ed|d, E|Ehm|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss a|EHms|E HH:mm:ss|Gy|G y|GyMd|M/d/y G|GyMMM|G y MMM|GyMMMd|G y MMM d|GyMMMEd|G y MMM d, E|h|h\u202Fa|H|HH|hm|h:mm a|Hm|HH:mm|hms|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm a v|Hmv|HH:mm v|M|L|Md|d/M|MEd|d/M, E|MMdd|dd/MM|MMM|LLL|MMMd|MMM d|MMMEd|MMM d, E|MMMMd|MMMM d|MMMMEd|MMMM d, E|MMMMW-count-one|MMMM - ആഴ്ച W|MMMMW-count-other|MMMM - ആഴ്ച W|ms|mm:ss|y|y|yM|y-MM|yMd|d/M/y|yMEd|d-M-y, E|yMM|y-MM|yMMM|y MMM|yMMMd|y MMM d|yMMMEd|y MMM d, E|yMMMM|y MMMM|yQQQ|y QQQ|yQQQQ|y QQQQ|yw-count-one|Y-ലെ ആഴ്ച w|yw-count-other|Y-ലെ ആഴ്ച w|ahmm|ahmmss|ahmmssz|ahmmsszzzz|X3I,|.|-||||||E2W,|.|-¤||¤||¤||E0W,|.|-|%||%||%|107|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XCG|Cg.|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$ml = $enkidatron$elm_cldr$Generated$Ml$ml;
var $enkidatron$elm_cldr$Generated$Mn$dayPeriods = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			'mn',
			_List_fromArray(
				[
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(12, 0),
					_Utils_Tuple2(18, 0),
					'afternoon1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(18, 0),
					_Utils_Tuple2(21, 0),
					'evening1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(0, 0),
					'midnight'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(6, 0),
					_Utils_Tuple2(12, 0),
					'morning1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(21, 0),
					_Utils_Tuple2(6, 0),
					'night1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(12, 0),
					'noon')
				]))
		]));
var $enkidatron$elm_cldr$Generated$Mn$mn = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Mn$dayPeriods, 'mn||||ү.ө.|ү.х.|8|afternoon1|өдөр|am|ү.ө.|evening1|орой|midnight|шөнө дунд|morning1|өглөө|night1|шөнө|noon|үд дунд|pm|ү.х.|ү.ө.|ү.х.|8|afternoon1|өдөр|am|ү.ө.|evening1|орой|midnight|шөнө дунд|morning1|өглөө|night1|шөнө|noon|үд дунд|pm|ү.х.|ү.ө.|ү.х.|8|afternoon1|өдөр|am|ү.ө.|evening1|орой|midnight|шөнө дунд|morning1|өглөө|night1|шөнө|noon|үд дунд|pm|ү.х.|y.MM.dd|y\u202F\'оны\' MMM\'ын\' d|y\u202F\'оны\' MMMM\'ын\' d|y\u202F\'оны\' MMMM\'ын\' d, EEEE \'гараг\'|1-р сар|2-р сар|3-р сар|4-р сар|5-р сар|6-р сар|7-р сар|8-р сар|9-р сар|10-р сар|11-р сар|12-р сар|нэгдүгээр сар|хоёрдугаар сар|гуравдугаар сар|дөрөвдүгээр сар|тавдугаар сар|зургаадугаар сар|долоодугаар сар|наймдугаар сар|есдүгээр сар|аравдугаар сар|арван нэгдүгээр сар|арван хоёрдугаар сар|I|II|III|IV|V|VI|VII|VIII|IX|X|XI|XII|1|1-р сар|2-р сар|3-р сар|4-р сар|5-р сар|6-р сар|7-р сар|8-р сар|9-р сар|10-р сар|11-р сар|12-р сар|Нэгдүгээр сар|Хоёрдугаар сар|Гуравдугаар сар|Дөрөвдүгээр сар|Тавдугаар сар|Зургаадугаар сар|Долоодугаар сар|Наймдугаар сар|Есдүгээр сар|Аравдугаар сар|Арван нэгдүгээр сар|Арван хоёрдугаар сар|I|II|III|IV|V|VI|VII|VIII|IX|X|XI|XII|Ня|Да|Мя|Лх|Пү|Ба|Бя|ням|даваа|мягмар|лхагва|пүрэв|баасан|бямба|Ня|Да|Мя|Лх|Пү|Ба|Бя|1|Ня|Да|Мя|Лх|Пү|Ба|Бя|Ням|Даваа|Мягмар|Лхагва|Пүрэв|Баасан|Бямба|Ня|Да|Мя|Лх|Пү|Ба|Бя|МЭӨ|МЭ|манай эриний өмнөх|манай эриний|МЭӨ|МЭ|HH:mm|HH:mm:ss|HH:mm:ss (z)|HH:mm:ss (zzzz)|{1} {0}|{1} {0}|{1} {0}|{1} {0}|49|Bh|B h \'ц\'|Bhm|B h:mm|Bhms|B h:mm:ss|d|d|E|ccc|EBhm|E. B h:mm|EBhms|E. B h:mm:ss|Ed|dd. E|Ehm|E. h:mm\u202Fa|EHm|E. HH:mm|Ehms|E. h:mm:ss\u202Fa|EHms|E. HH:mm:ss|Gy|G y|GyMd|GGGGG y-MM-dd|GyMMM|G y\u202F\'оны\' MMM|GyMMMd|G y\u202F\'оны\' MMM\'ын\' d|GyMMMEd|G y\u202F\'оны\' MMM\'ын\' d. E|h|h \'ц\' a|H|HH \'ц\'|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa (v)|Hmsv|HH:mm:ss (v)|hmv|h:mm\u202Fa (v)|Hmv|HH:mm (v)|M|LLLLL|Md|MMMMM/dd|MEd|MMMMM/dd. E|MMM|LLL|MMMd|MMM\'ын\' d|MMMEd|MMM\'ын\' d. E|MMMMd|MMMM\'ын\' d|MMMMW-count-one|MMMM\'ын\' W-\'р\' \'долоо\' \'хоног\'|MMMMW-count-other|MMMM\'ын\' W-\'р\' \'долоо\' \'хоног\'|ms|mm:ss|y|y|yM|y MMMMM|yMd|y.MM.dd|yMEd|y.MM.dd. E|yMMM|y\u202F\'оны\' MMM|yMMMd|y\u202F\'оны\' MMM\'ын\' d|yMMMEd|y\u202F\'оны\' MMM\'ын\' d. E|yMMMM|y\u202F\'оны\' MMMM|yQQQ|y\u202F\'оны\' QQQ|yQQQQ|y\u202F\'оны\' QQQQ|yw-count-one|Y \'оны\' w-\'р\' \'долоо\' \'хоног\'|yw-count-other|Y \'оны\' w-\'р\' \'долоо\' \'хоног\'|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W,|.|-||||||E2W,|.|-¤\u00A0||¤\u00A0||¤\u00A0||E0W,|.|-|%||%||%|107|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|кр|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XCG|Cg.|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$mn = $enkidatron$elm_cldr$Generated$Mn$mn;
var $enkidatron$elm_cldr$Generated$Mr$dayPeriods = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			'mr',
			_List_fromArray(
				[
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(12, 0),
					_Utils_Tuple2(16, 0),
					'afternoon1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(16, 0),
					_Utils_Tuple2(21, 0),
					'evening1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(0, 0),
					'midnight'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(4, 0),
					_Utils_Tuple2(6, 0),
					'morning1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(6, 0),
					_Utils_Tuple2(12, 0),
					'morning2'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(21, 0),
					_Utils_Tuple2(4, 0),
					'night1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(12, 0),
					'noon')
				]))
		]));
var $enkidatron$elm_cldr$Generated$Mr$mr = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Mr$dayPeriods, 'mr||||AM|PM|9|afternoon1|दुपार|am|AM|evening1|संध्याकाळ|midnight|मध्यरात्र|morning1|पहाट|morning2|सकाळ|night1|रात्र|noon|मध्यान्ह|pm|PM|AM|PM|9|afternoon1|दुपार|am|AM|evening1|संध्याकाळ|midnight|मध्यरात्र|morning1|पहाट|morning2|सकाळ|night1|रात्र|noon|मध्यान्ह|pm|PM|a|p|9|afternoon1|दु|am|a|evening1|सं|midnight|म.रा.|morning1|प|morning2|स|night1|रा|noon|दु|pm|p|d/M/yy|d MMM, y|d MMMM, y|EEEE, d MMMM, y|जाने|फेब्रु|मार्च|एप्रि|मे|जून|जुलै|ऑग|सप्टें|ऑक्टो|नोव्हें|डिसें|जानेवारी|फेब्रुवारी|मार्च|एप्रिल|मे|जून|जुलै|ऑगस्ट|सप्टेंबर|ऑक्टोबर|नोव्हेंबर|डिसेंबर|जा|फे|मा|ए|मे|जू|जु|ऑ|स|ऑ|नो|डि|0|रवि|सोम|मंगळ|बुध|गुरु|शुक्र|शनि|रविवार|सोमवार|मंगळवार|बुधवार|गुरुवार|शुक्रवार|शनिवार|र|सो|मं|बु|गु|शु|श|0|ई. स. पू.|इ. स.|ईसवीसनपूर्व|ईसवीसन|ई. स. पू.|इ. स.|h:mm a|h:mm:ss a|h:mm:ss a z|h:mm:ss a zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|51|Bh|B h|Bhm|B h:mm|Bhms|B h:mm:ss|d|d|E|ccc|EBhm|E B h:mm|EBhms|E B h:mm:ss|Ed|d E|Ehm|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss a|EHms|E HH:mm:ss|Gy|G y|GyMd|GGGGG d/M/y|GyMMM|MMM G y|GyMMMd|d MMM, G y|GyMMMEd|E, d MMM, G y|h|h\u202Fa|H|HH|hm|h:mm a|Hm|H:mm|hms|h:mm:ss a|Hms|H:mm:ss|hmsv|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm a v|Hmv|HH:mm v|M|L|Md|d/M|MEd|E, d/M|MMdd|dd-MM|MMM|LLL|MMMd|d MMM|MMMEd|E, d MMM|MMMMd|d MMMM|MMMMW-count-one|MMMM चा W रा आठवडा|MMMMW-count-other|MMMM चा W रा आठवडा|ms|mm:ss|y|y|yM|M/y|yMd|d/M/y|yMEd|E, d/M/y|yMM|MM-y|yMMM|MMM y|yMMMd|d MMM, y|yMMMEd|E, d, MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|Y चा w वा आठवडा|yw-count-other|Y चा w वा आठवडा|ahmm|ahmmss|ahmmssz|ahmmsszzzz|X3I,|.|-||||||E2W,|.|-¤||¤||¤||E0W,|.|-|%||%||%|106|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XCG|Cg.|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$mr = $enkidatron$elm_cldr$Generated$Mr$mr;
var $enkidatron$elm_cldr$Generated$Ms$dayPeriods = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			'ms',
			_List_fromArray(
				[
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(12, 0),
					_Utils_Tuple2(14, 0),
					'afternoon1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(14, 0),
					_Utils_Tuple2(19, 0),
					'evening1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(0, 0),
					_Utils_Tuple2(1, 0),
					'morning1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(1, 0),
					_Utils_Tuple2(12, 0),
					'morning2'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(19, 0),
					_Utils_Tuple2(24, 0),
					'night1')
				]))
		]));
var $enkidatron$elm_cldr$Generated$Ms$ms = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Ms$dayPeriods, 'ms||||PG|PTG|7|afternoon1|tengah hari|am|PG|evening1|petang|morning1|pagi|morning2|pagi|night1|malam|pm|PTG|PG|PTG|7|afternoon1|tengah hari|am|PG|evening1|petang|morning1|tengah malam|morning2|pagi|night1|malam|pm|PTG|PG|PTG|7|afternoon1|tengah hari|am|PG|evening1|petang|morning1|pagi|morning2|pagi|night1|malam|pm|PTG|d/MM/yy|d MMM y|d MMMM y|EEEE, d MMMM y|Jan|Feb|Mac|Apr|Mei|Jun|Jul|Ogo|Sep|Okt|Nov|Dis|Januari|Februari|Mac|April|Mei|Jun|Julai|Ogos|September|Oktober|November|Disember|J|F|M|A|M|J|J|O|S|O|N|D|0|Ahd|Isn|Sel|Rab|Kha|Jum|Sab|Ahad|Isnin|Selasa|Rabu|Khamis|Jumaat|Sabtu|A|I|S|R|K|J|S|0|S.M.|TM|S.M.|TM|S.M.|TM|h:mm\u202Fa|h:mm:ss\u202Fa|h:mm:ss\u202Fa z|h:mm:ss\u202Fa zzzz|{1}, {0}|{1}, {0}|{1} {0}|{1} {0}|48|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|d E|Ehm|E h:mm\u202Fa|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|EHms|E HH:mm:ss|Gy|y G|GyMd|GGGGG y-MM-dd|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E, d MMM y G|h|h\u202Fa|H|HH|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|Hmv|HH:mm v|M|L|Md|d-M|MEd|E, d-M|MMdd|dd/MM|MMM|LLL|MMMd|d MMM|MMMEd|E, d MMM|MMMMd|d MMMM|MMMMW-count-other|\'minggu\' W \'daripada\' MMMM|ms|mm:ss|y|y|yM|M-y|yMd|d/M/y|yMEd|E, d/M/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E, d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-other|\'minggu\' w \'daripada\' Y|ahmm|ahmmss|ahmmssz|ahmmsszzzz|X3W,|.|-||||||E2W,|.|-¤||¤||¤||E0W,|.|-|%||%||%|107|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CAD|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MXN|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|USD|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XCG|Cg.|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$ms = $enkidatron$elm_cldr$Generated$Ms$ms;
var $enkidatron$elm_cldr$Generated$My$dayPeriods = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			'my',
			_List_fromArray(
				[
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(12, 0),
					_Utils_Tuple2(16, 0),
					'afternoon1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(16, 0),
					_Utils_Tuple2(19, 0),
					'evening1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(0, 0),
					'midnight'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(0, 0),
					_Utils_Tuple2(12, 0),
					'morning1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(19, 0),
					_Utils_Tuple2(24, 0),
					'night1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(12, 0),
					'noon')
				]))
		]));
var $enkidatron$elm_cldr$Generated$My$my = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$My$dayPeriods, 'my||||နံနက်|ညနေ|8|afternoon1|နေ့လယ်|am|နံနက်|evening1|ညနေ|midnight|သန်းခေါင်ယံ|morning1|နံနက်|night1|ည|noon|မွန်းတည့်|pm|ညနေ|နံနက်|ညနေ|8|afternoon1|နေ့လယ်|am|နံနက်|evening1|ညနေ|midnight|သန်းခေါင်ယံ|morning1|နံနက်|night1|ည|noon|မွန်းတည့်|pm|ညနေ|နံနက်|ညနေ|8|afternoon1|နေ့လယ်|am|နံနက်|evening1|ညနေ|midnight|သန်းခေါင်ယံ|morning1|နံနက်|night1|ည|noon|မွန်းတည့်|pm|ညနေ|d/M/yy|y MMM d|y MMMM d|y MMMM d EEEE|ဇန်|ဖေ|မတ်|ဧ|မေ|ဇွန်|ဇူ|ဩ|စက်|အောက်|နို|ဒီ|ဇန်နဝါရီ|ဖေဖော်ဝါရီ|မတ်|ဧပြီ|မေ|ဇွန်|ဇူလိုင်|ဩဂုတ်|စက်တင်ဘာ|အောက်တိုဘာ|နိုဝင်ဘာ|ဒီဇင်ဘာ|ဇ|ဖ|မ|ဧ|မ|ဇ|ဇ|ဩ|စ|အ|န|ဒ|0|တနင်္ဂနွေ|တနင်္လာ|အင်္ဂါ|ဗုဒ္ဓဟူး|ကြာသပတေး|သောကြာ|စနေ|တနင်္ဂနွေ|တနင်္လာ|အင်္ဂါ|ဗုဒ္ဓဟူး|ကြာသပတေး|သောကြာ|စနေ|တ|တ|အ|ဗ|က|သ|စ|0|ဘီစီ|အဒေီ|ခရစ်တော် မပေါ်မီနှစ်|ခရစ်နှစ်|ဘီစီ|အဒေီ|H:mm|H:mm:ss|z HH:mm:ss|zzzz HH:mm:ss|{1} {0}|{1} {0}|{1} {0}|{1} {0}|48|Bh|B h|Bhm|B h:mm|Bhms|B h:mm:ss|d|d|E|ccc|EBhm|E B h:mm|EBhms|E B h:mm:ss|Ed|d ရက် E|Ehm|E a h:mm|EHm|E HH:mm|Ehms|E a h:mm:ss|EHms|E HH:mm:ss|Gy|G y|GyMd|G y/M/d|GyMMM|G y MMM|GyMMMd|G y MMM d|GyMMMEd|G y/ MMM d/ E|h|a h|H|HH|hm|a h:mm|Hm|HH:mm|hms|a h:mm:ss|Hms|HH:mm:ss|hmsv|v a h:mm:ss|Hmsv|v HH:mm:ss|hmv|v a h:mm|Hmv|v HH:mm|M|L|Md|d/M|MEd|d/M E|MMM|LLL|MMMd|MMM d|MMMEd|MMM d E|MMMMd|MMMM d|MMMMEd|MMMM d E|MMMMW-count-other|MMMM လ W ပတ်မြောက်|ms|mm:ss|y|y|yM|y-MM|yMd|d/M/y|yMEd|d/M/y E|yMMM|y MMM|yMMMd|y MMM d|yMMMEd|y MMM d E|yMMMM|y MMMM|yQQQ|y QQQ|yQQQQ|y QQQQ|yw-count-other|Y ခု w ပတ်မြောက်|Hmm|HHmmss|HHmmssz|HHmmsszzzz|X3W,|.|-||||||E2W,|.|-|\u00A0¤||\u00A0¤||\u00A0¤|E0W,|.|-|%||%||%|111|AFN|؋|AMD|֏|ANG|NAf|AOA|Kz|ARS|$|AUD|A$|AWG|Afl|AZN|₼|BAM|KM|BBD|Bds$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|B$|BWP|P|BYN|р.|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HTG|G|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PAB|B/.|PHP|₱|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|TT$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XCG|Cg.|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$my = $enkidatron$elm_cldr$Generated$My$my;
var $enkidatron$elm_cldr$Generated$Nb$dayPeriods = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			'nb',
			_List_fromArray(
				[
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(12, 0),
					_Utils_Tuple2(18, 0),
					'afternoon1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(18, 0),
					_Utils_Tuple2(24, 0),
					'evening1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(0, 0),
					'midnight'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(6, 0),
					_Utils_Tuple2(10, 0),
					'morning1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(10, 0),
					_Utils_Tuple2(12, 0),
					'morning2'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(0, 0),
					_Utils_Tuple2(6, 0),
					'night1')
				]))
		]));
var $enkidatron$elm_cldr$Generated$Nb$nb = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Nb$dayPeriods, 'nb||||a.m.|p.m.|8|afternoon1|etterm.|am|a.m.|evening1|kveld|midnight|midn.|morning1|morg.|morning2|form.|night1|natt|pm|p.m.|a.m.|p.m.|8|afternoon1|på ettermiddagen|am|a.m.|evening1|på kvelden|midnight|midnatt|morning1|på morgenen|morning2|på formiddagen|night1|på natten|pm|p.m.|a|p|8|afternoon1|em.|am|a|evening1|kv.|midnight|mn.|morning1|mg.|morning2|fm.|night1|nt.|pm|p|dd.MM.y|d. MMM y|d. MMMM y|EEEE d. MMMM y|jan.|feb.|mars|apr.|mai|juni|juli|aug.|sep.|okt.|nov.|des.|januar|februar|mars|april|mai|juni|juli|august|september|oktober|november|desember|J|F|M|A|M|J|J|A|S|O|N|D|1|jan|feb|mar|apr|mai|jun|jul|aug|sep|okt|nov|des|januar|februar|mars|april|mai|juni|juli|august|september|oktober|november|desember|J|F|M|A|M|J|J|A|S|O|N|D|søn.|man.|tir.|ons.|tor.|fre.|lør.|søndag|mandag|tirsdag|onsdag|torsdag|fredag|lørdag|S|M|T|O|T|F|L|0|f.Kr.|e.Kr.|før Kristus|etter Kristus|f.Kr.|e.Kr.|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|51|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d.|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d.|Ehm|E h:mm\u202Fa|EHm|E \'kl\'. HH:mm|Ehms|E h:mm:ss\u202Fa|EHms|E \'kl\'. HH:mm:ss|Gy|y G|GyMd|dd.MM.y GGGGG|GyMMM|MMM y G|GyMMMd|d. MMM y G|GyMMMEd|E d. MMM y G|h|h\u202Fa|H|HH|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|Hmv|HH:mm v|M|L.|Md|d.M.|MEd|E d.M.|MMdd|d.M.|MMM|LLL|MMMd|d. MMM|MMMEd|E d. MMM|MMMMd|d. MMMM|MMMMW-count-one|\'den\' W. \'uken\' \'i\' MMMM|MMMMW-count-other|\'den\' W. \'uken\' \'i\' MMMM|ms|mm:ss|y|y|yM|M.y|yMd|d.M.y|yMEd|E d.M.y|yMM|MM.y|yMMM|MMM y|yMMMd|d. MMM y|yMMMEd|E d. MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\'uke\' w \'i\' Y|yw-count-other|\'uke\' w \'i\' Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W\u00A0|,|−||||||E2W\u00A0|,|-|\u00A0¤||\u00A0¤||\u00A0¤|E0W\u00A0|,|−|\u00A0%||\u00A0%||\u00A0%|107|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|AUD|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|BRL|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CAD|CLP|$|CNY|CNY|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HKD|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|ILS|INR|INR|ISK|kr|JMD|$|JPY|JPY|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|KRW|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MXN|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZD|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|L|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|TWD|UAH|₴|USD|USD|UYU|$|VEF|Bs|VND|VND|XAF|XAF|XCD|XCD|XCG|Cg.|XOF|F\u202FCFA|XPF|XPF|XXX|XXX|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$nb = $enkidatron$elm_cldr$Generated$Nb$nb;
var $enkidatron$elm_cldr$Generated$Ne$dayPeriods = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			'ne',
			_List_fromArray(
				[
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(12, 0),
					_Utils_Tuple2(16, 0),
					'afternoon1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(16, 0),
					_Utils_Tuple2(19, 0),
					'afternoon2'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(19, 0),
					_Utils_Tuple2(22, 0),
					'evening1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(0, 0),
					'midnight'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(4, 0),
					_Utils_Tuple2(12, 0),
					'morning1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(22, 0),
					_Utils_Tuple2(4, 0),
					'night1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(12, 0),
					'noon')
				]))
		]));
var $enkidatron$elm_cldr$Generated$Ne$ne = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Ne$dayPeriods, 'ne||||पूर्वाह्न|अपराह्न|9|afternoon1|अपरान्ह|afternoon2|साँझ|am|पूर्वाह्न|evening1|बेलुकी|midnight|मध्यरात|morning1|बिहान|night1|रात|noon|मध्यान्ह|pm|अपराह्न|पूर्वाह्न|अपराह्न|9|afternoon1|अपरान्ह|afternoon2|साँझ|am|पूर्वाह्न|evening1|बेलुकी|midnight|मध्यरात|morning1|बिहान|night1|रात|noon|मध्यान्ह|pm|अपराह्न|पूर्वाह्न|अपराह्न|9|afternoon1|अपरान्ह|afternoon2|साँझ|am|पूर्वाह्न|evening1|बेलुकी|midnight|मध्यरात|morning1|बिहान|night1|रात|noon|मध्यान्ह|pm|अपराह्न|yy/M/d|y MMM d|y MMMM d|y MMMM d, EEEE|जनवरी|फेब्रुअरी|मार्च|अप्रिल|मे|जुन|जुलाई|अगस्ट|सेप्टेम्बर|अक्टोबर|नोभेम्बर|डिसेम्बर|जनवरी|फेब्रुअरी|मार्च|अप्रिल|मे|जुन|जुलाई|अगस्ट|सेप्टेम्बर|अक्टोबर|नोभेम्बर|डिसेम्बर|जन|फेब|मार्च|अप्र|मे|जुन|जुल|अग|सेप|अक्टो|नोभे|डिसे|1|जनवरी|फेब्रुअरी|मार्च|अप्रिल|मे|जुन|जुलाई|अगस्ट|सेप्टेम्बर|अक्टोबर|नोभेम्बर|डिसेम्बर|जनवरी|फेब्रुअरी|मार्च|अप्रिल|मे|जुन|जुलाई|अगस्ट|सेप्टेम्बर|अक्टोबर|नोभेम्बर|डिसेम्बर|जन|फेेब|मार्च|अप्र|मे|जुन|जुल|अग|सेप|अक्टो|नोभे|डिसे|आइत|सोम|मङ्गल|बुध|बिहि|शुक्र|शनि|आइतबार|सोमबार|मङ्गलबार|बुधबार|बिहिबार|शुक्रबार|शनिबार|आ|सो|म|बु|बि|शु|श|0|ईसा पूर्व|सन्|ईसा पूर्व|सन्|ईसा पूर्व|सन्|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1}, {0}|{1}, {0}|{1} {0}|{1} {0}|49|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|d E|Ehm|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss a|EHms|E HH:mm:ss|Gy|G y|GyMd|M/d/y G|GyMMM|G y MMM|GyMMMd|G y MMM d|GyMMMEd|G y MMM d, E|h|h\u202Fa|H|HH|hm|h:mm a|Hm|HH:mm|hms|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm a v|Hmv|HH:mm v|M|L|Md|MM-dd|MEd|MM-dd, E|MMM|LLL|MMMd|MMM d|MMMEd|MMM d, E|MMMMd|MMMM d|MMMMW-count-one|MMMM को W हप्ता|MMMMW-count-other|MMMM को W हप्ता|ms|mm:ss|y|y|yM|y-MM|yMd|y-MM-dd|yMEd|y-MM-dd, E|yMMM|y MMM|yMMMd|y MMM d|yMMMEd|y MMM d, E|yMMMM|y MMMM|yQQQ|y QQQ|yQQQQ|y QQQQ|yw-count-one|Y को w हप्ता|yw-count-other|Y को w हप्ता|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3I,|.|-||||||E2I,|.|-¤\u00A0||¤\u00A0||¤\u00A0||E0W,|.|-|%||%||%|107|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|नेरू|NZD|NZ$|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XCG|Cg.|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$ne = $enkidatron$elm_cldr$Generated$Ne$ne;
var $enkidatron$elm_cldr$Generated$Nl$dayPeriods = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			'nl',
			_List_fromArray(
				[
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(12, 0),
					_Utils_Tuple2(18, 0),
					'afternoon1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(18, 0),
					_Utils_Tuple2(24, 0),
					'evening1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(0, 0),
					'midnight'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(6, 0),
					_Utils_Tuple2(12, 0),
					'morning1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(0, 0),
					_Utils_Tuple2(6, 0),
					'night1')
				]))
		]));
var $enkidatron$elm_cldr$Generated$Nl$nl = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Nl$dayPeriods, 'nl||||a.m.|p.m.|7|afternoon1|’s middags|am|a.m.|evening1|’s avonds|midnight|middernacht|morning1|’s ochtends|night1|’s nachts|pm|p.m.|a.m.|p.m.|7|afternoon1|’s middags|am|a.m.|evening1|’s avonds|midnight|middernacht|morning1|’s ochtends|night1|’s nachts|pm|p.m.|a.m.|p.m.|7|afternoon1|’s middags|am|a.m.|evening1|’s avonds|midnight|middernacht|morning1|’s ochtends|night1|’s nachts|pm|p.m.|dd-MM-y|d MMM y|d MMMM y|EEEE d MMMM y|jan|feb|mrt|apr|mei|jun|jul|aug|sep|okt|nov|dec|januari|februari|maart|april|mei|juni|juli|augustus|september|oktober|november|december|J|F|M|A|M|J|J|A|S|O|N|D|0|zo|ma|di|wo|do|vr|za|zondag|maandag|dinsdag|woensdag|donderdag|vrijdag|zaterdag|Z|M|D|W|D|V|Z|0|v.Chr.|n.Chr.|voor Christus|na Christus|v.C.|n.C.|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|49|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss a|EHms|E HH:mm:ss|Gy|y G|GyMd|d/M/y GGGGG|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E d MMM y G|h|h\u202Fa|H|HH|hm|h:mm a|Hm|HH:mm|hms|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm a v|Hmv|HH:mm v|M|L|Md|d-M|MEd|E d-M|MMM|LLL|MMMd|d MMM|MMMEd|E d MMM|MMMMd|d MMMM|MMMMW-count-one|\'week\' W \'van\' MMMM|MMMMW-count-other|\'week\' W \'van\' MMMM|ms|mm:ss|y|y|yM|M-y|yMd|d-M-y|yMEd|E d-M-y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\'week\' w \'in\' Y|yw-count-other|\'week\' w \'in\' Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W.|,|-||||||E2W.|,|¤\u00A0-||¤\u00A0||¤\u00A0||E0W.|,|-|%||%||%|108|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|AU$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|C$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|FJ$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RUR|р.|RWF|RF|SBD|SI$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XCG|Cg.|XOF|F\u202FCFA|XPF|XPF|XXX|XXX|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$nl = $enkidatron$elm_cldr$Generated$Nl$nl;
var $enkidatron$elm_cldr$Generated$Nn$dayPeriods = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			'nn',
			_List_fromArray(
				[
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(12, 0),
					_Utils_Tuple2(18, 0),
					'afternoon1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(18, 0),
					_Utils_Tuple2(24, 0),
					'evening1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(0, 0),
					'midnight'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(6, 0),
					_Utils_Tuple2(10, 0),
					'morning1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(10, 0),
					_Utils_Tuple2(12, 0),
					'morning2'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(0, 0),
					_Utils_Tuple2(6, 0),
					'night1')
				]))
		]));
var $enkidatron$elm_cldr$Generated$Nn$nn = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Nn$dayPeriods, 'nn||||f.m.|e.m.|8|afternoon1|etterm.|am|f.m.|evening1|kveld|midnight|midn.|morning1|morg.|morning2|form.|night1|natt|pm|e.m.|f.m.|e.m.|8|afternoon1|på ettermiddagen|am|f.m.|evening1|på kvelden|midnight|midnatt|morning1|på morgonen|morning2|på formiddagen|night1|på natta|pm|e.m.|a|p|8|afternoon1|em.|am|a|evening1|kv.|midnight|mn.|morning1|mg.|morning2|fm.|night1|nt.|pm|p|dd.MM.y|d. MMM y|d. MMMM y|EEEE d. MMMM y|jan.|feb.|mars|apr.|mai|juni|juli|aug.|sep.|okt.|nov.|des.|januar|februar|mars|april|mai|juni|juli|august|september|oktober|november|desember|J|F|M|A|M|J|J|A|S|O|N|D|1|jan|feb|mar|apr|mai|jun|jul|aug|sep|okt|nov|des|januar|februar|mars|april|mai|juni|juli|august|september|oktober|november|desember|J|F|M|A|M|J|J|A|S|O|N|D|sø.|må.|ty.|on.|to.|fr.|la.|søndag|måndag|tysdag|onsdag|torsdag|fredag|laurdag|S|M|T|O|T|F|L|1|søn|mån|tys|ons|tor|fre|lau|søndag|måndag|tysdag|onsdag|torsdag|fredag|laurdag|S|M|T|O|T|F|L|f.Kr.|e.Kr.|før Kristus|etter Kristus|f.Kr.|e.Kr.|HH:mm|HH:mm:ss|HH:mm:ss z|\'kl\'. HH:mm:ss zzzz|{1}, {0}|{1}, {0}|{1} \'kl\'. {0}|{1} {0}|51|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d.|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d.|Ehm|E h:mm\u202Fa|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|EHms|E HH:mm:ss|Gy|y G|GyMd|dd.MM.y GGGGG|GyMMM|MMM y G|GyMMMd|d. MMM y G|GyMMMEd|E d. MMM y G|h|h\u202Fa|H|HH|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|Hmv|HH:mm v|M|L.|Md|d.M.|MEd|E d.M.|MMdd|d.M.|MMM|LLL|MMMd|d. MMM|MMMEd|E d. MMM|MMMMd|d. MMMM|MMMMW-count-one|\'veke\' W \'i\' MMMM|MMMMW-count-other|\'veke\' W \'i\' MMMM|ms|mm:ss|y|y|yM|M.y|yMd|d.M.y|yMEd|E d.M.y|yMM|MM.y|yMMM|MMM y|yMMMd|d. MMM y|yMMMEd|E d. MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\'veke\' w \'i\' Y|yw-count-other|\'veke\' w \'i\' Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W\u00A0|,|−||||||E2W\u00A0|,|-|\u00A0¤||\u00A0¤||\u00A0¤|E0W\u00A0|,|−|\u00A0%||\u00A0%||\u00A0%|107|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|AUD|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|BRL|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CAD|CLP|$|CNY|CNY|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|GBP|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HKD|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|ILS|INR|INR|ISK|kr|JMD|$|JPY|JPY|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|KRW|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MXN|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZD|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|TWD|UAH|₴|USD|USD|UYU|$|VEF|Bs|VND|VND|XAF|XAF|XCD|XCD|XCG|Cg.|XOF|F\u202FCFA|XPF|XPF|XXX|XXX|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$nn = $enkidatron$elm_cldr$Generated$Nn$nn;
var $enkidatron$elm_cldr$Generated$No$dayPeriods = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			'no',
			_List_fromArray(
				[
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(12, 0),
					_Utils_Tuple2(18, 0),
					'afternoon1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(18, 0),
					_Utils_Tuple2(24, 0),
					'evening1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(0, 0),
					'midnight'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(6, 0),
					_Utils_Tuple2(10, 0),
					'morning1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(10, 0),
					_Utils_Tuple2(12, 0),
					'morning2'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(0, 0),
					_Utils_Tuple2(6, 0),
					'night1')
				]))
		]));
var $enkidatron$elm_cldr$Generated$No$no = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$No$dayPeriods, 'no||||a.m.|p.m.|8|afternoon1|etterm.|am|a.m.|evening1|kveld|midnight|midn.|morning1|morg.|morning2|form.|night1|natt|pm|p.m.|a.m.|p.m.|8|afternoon1|på ettermiddagen|am|a.m.|evening1|på kvelden|midnight|midnatt|morning1|på morgenen|morning2|på formiddagen|night1|på natten|pm|p.m.|a|p|8|afternoon1|em.|am|a|evening1|kv.|midnight|mn.|morning1|mg.|morning2|fm.|night1|nt.|pm|p|dd.MM.y|d. MMM y|d. MMMM y|EEEE d. MMMM y|jan.|feb.|mars|apr.|mai|juni|juli|aug.|sep.|okt.|nov.|des.|januar|februar|mars|april|mai|juni|juli|august|september|oktober|november|desember|J|F|M|A|M|J|J|A|S|O|N|D|1|jan|feb|mar|apr|mai|jun|jul|aug|sep|okt|nov|des|januar|februar|mars|april|mai|juni|juli|august|september|oktober|november|desember|J|F|M|A|M|J|J|A|S|O|N|D|søn.|man.|tir.|ons.|tor.|fre.|lør.|søndag|mandag|tirsdag|onsdag|torsdag|fredag|lørdag|S|M|T|O|T|F|L|0|f.Kr.|e.Kr.|før Kristus|etter Kristus|f.Kr.|e.Kr.|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|51|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d.|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d.|Ehm|E h:mm\u202Fa|EHm|E \'kl\'. HH:mm|Ehms|E h:mm:ss\u202Fa|EHms|E \'kl\'. HH:mm:ss|Gy|y G|GyMd|dd.MM.y GGGGG|GyMMM|MMM y G|GyMMMd|d. MMM y G|GyMMMEd|E d. MMM y G|h|h\u202Fa|H|HH|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|Hmv|HH:mm v|M|L.|Md|d.M.|MEd|E d.M.|MMdd|d.M.|MMM|LLL|MMMd|d. MMM|MMMEd|E d. MMM|MMMMd|d. MMMM|MMMMW-count-one|\'den\' W. \'uken\' \'i\' MMMM|MMMMW-count-other|\'den\' W. \'uken\' \'i\' MMMM|ms|mm:ss|y|y|yM|M.y|yMd|d.M.y|yMEd|E d.M.y|yMM|MM.y|yMMM|MMM y|yMMMd|d. MMM y|yMMMEd|E d. MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\'uke\' w \'i\' Y|yw-count-other|\'uke\' w \'i\' Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W\u00A0|,|−||||||E2W\u00A0|,|-|\u00A0¤||\u00A0¤||\u00A0¤|E0W\u00A0|,|−|\u00A0%||\u00A0%||\u00A0%|107|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|AUD|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|BRL|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CAD|CLP|$|CNY|CNY|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HKD|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|ILS|INR|INR|ISK|kr|JMD|$|JPY|JPY|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|KRW|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MXN|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZD|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|L|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|TWD|UAH|₴|USD|USD|UYU|$|VEF|Bs|VND|VND|XAF|XAF|XCD|XCD|XCG|Cg.|XOF|F\u202FCFA|XPF|XPF|XXX|XXX|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$no = $enkidatron$elm_cldr$Generated$No$no;
var $enkidatron$elm_cldr$Generated$Or$dayPeriods = $elm$core$Dict$fromList(_List_Nil);
var $enkidatron$elm_cldr$Generated$Or$or = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Or$dayPeriods, 'or||||AM|PM|2|am|AM|pm|PM|AM|PM|2|am|AM|pm|PM|ପୂ|ଅ|2|am|ପୂ|pm|ଅ|M/d/yy|MMM d, y|MMMM d, y|EEEE, MMMM d, y|ଜାନୁଆରୀ|ଫେବୃଆରୀ|ମାର୍ଚ୍ଚ|ଅପ୍ରେଲ|ମଇ|ଜୁନ|ଜୁଲାଇ|ଅଗଷ୍ଟ|ସେପ୍ଟେମ୍ବର|ଅକ୍ଟୋବର|ନଭେମ୍ବର|ଡିସେମ୍ବର|ଜାନୁଆରୀ|ଫେବୃଆରୀ|ମାର୍ଚ୍ଚ|ଅପ୍ରେଲ|ମଇ|ଜୁନ|ଜୁଲାଇ|ଅଗଷ୍ଟ|ସେପ୍ଟେମ୍ବର|ଅକ୍ଟୋବର|ନଭେମ୍ବର|ଡିସେମ୍ବର|ଜା|ଫେ|ମା|ଅ|ମଇ|ଜୁ|ଜୁ|ଅ|ସେ|ଅ|ନ|ଡି|0|ରବି|ସୋମ|ମଙ୍ଗଳ|ବୁଧ|ଗୁରୁ|ଶୁକ୍ର|ଶନି|ରବିବାର|ସୋମବାର|ମଙ୍ଗଳବାର|ବୁଧବାର|ଗୁରୁବାର|ଶୁକ୍ରବାର|ଶନିବାର|ର|ସୋ|ମ|ବୁ|ଗୁ|ଶୁ|ଶ|0|BC|AD|ଖ୍ରୀଷ୍ଟପୂର୍ବ|ଖ୍ରୀଷ୍ଟାବ୍ଦ|BC|AD|h:mm a|h:mm:ss a|h:mm:ss a z|h:mm:ss a zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|51|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|d E|Ehm|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss a|EHms|E HH:mm:ss|Gy|y G|GyMd|M/d/y G|GyMMM|MMM y G|GyMMMd|MMM d, y G|GyMMMEd|E, MMM d, y G|h|h\u202Fa|H|HH|hm|h:mm a|Hm|HH:mm|hms|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm a v|Hmv|HH:mm v|M|L|Md|M/d|MEd|E, M/d|MMdd|dd-MM|MMM|LLL|MMMd|MMM d|MMMEd|E, MMM d|MMMMd|MMMM d|MMMMW-count-one|MMMM ର ସପ୍ତାହ W|MMMMW-count-other|MMMM ର ସପ୍ତାହ W|ms|mm:ss|y|y|yM|M/y|yMd|M/d/y|yMEd|E, M/d/y|yMM|MM-y|yMMM|MMM y|yMMMd|MMM d, y|yMMMEd|E, MMM d, y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|Y ର ସପ୍ତାହ w|yw-count-other|Y ର ସପ୍ତାହ w|ahmm|ahmmss|ahmmssz|ahmmsszzzz|X3I,|.|-||||||E2W,|.|-¤||¤||¤||E0W,|.|-|%||%||%|107|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XCG|Cg.|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$or = $enkidatron$elm_cldr$Generated$Or$or;
var $enkidatron$elm_cldr$Generated$Pa$dayPeriods = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			'pa',
			_List_fromArray(
				[
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(12, 0),
					_Utils_Tuple2(16, 0),
					'afternoon1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(16, 0),
					_Utils_Tuple2(21, 0),
					'evening1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(0, 0),
					'midnight'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(4, 0),
					_Utils_Tuple2(12, 0),
					'morning1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(21, 0),
					_Utils_Tuple2(4, 0),
					'night1')
				]))
		]));
var $enkidatron$elm_cldr$Generated$Pa$pa = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Pa$dayPeriods, 'pa||||ਪੂ.ਦੁ.|ਬਾ.ਦੁ.|7|afternoon1|ਦੁਪਹਿਰੇ|am|ਪੂ.ਦੁ.|evening1|ਸ਼ਾਮੀਂ|midnight|ਅੱਧੀ ਰਾਤ|morning1|ਸਵੇਰੇ|night1|ਰਾਤੀਂ|pm|ਬਾ.ਦੁ.|ਪੂ.ਦੁ.|ਬਾ.ਦੁ.|7|afternoon1|ਦੁਪਹਿਰੇ|am|ਪੂ.ਦੁ.|evening1|ਸ਼ਾਮੀਂ|midnight|ਅੱਧੀ ਰਾਤ|morning1|ਸਵੇਰੇ|night1|ਰਾਤੀਂ|pm|ਬਾ.ਦੁ.|ਸ.|ਸ਼.|7|afternoon1|ਦੁਪਹਿਰੇ|am|ਸ.|evening1|ਸ਼ਾਮੀਂ|midnight|ਅੱਧੀ ਰਾਤ|morning1|ਸਵੇਰੇ|night1|ਰਾਤੀਂ|pm|ਸ਼.|d/M/yy|d MMM y|d MMMM y|EEEE, d MMMM y|ਜਨ|ਫ਼ਰ|ਮਾਰਚ|ਅਪ੍ਰੈ|ਮਈ|ਜੂਨ|ਜੁਲਾ|ਅਗ|ਸਤੰ|ਅਕਤੂ|ਨਵੰ|ਦਸੰ|ਜਨਵਰੀ|ਫ਼ਰਵਰੀ|ਮਾਰਚ|ਅਪ੍ਰੈਲ|ਮਈ|ਜੂਨ|ਜੁਲਾਈ|ਅਗਸਤ|ਸਤੰਬਰ|ਅਕਤੂਬਰ|ਨਵੰਬਰ|ਦਸੰਬਰ|ਜ|ਫ਼|ਮਾ|ਅ|ਮ|ਜੂ|ਜੁ|ਅ|ਸ|ਅ|ਨ|ਦ|0|ਐਤ|ਸੋਮ|ਮੰਗਲ|ਬੁੱਧ|ਵੀਰ|ਸ਼ੁੱਕਰ|ਸ਼ਨਿੱਚਰ|ਐਤਵਾਰ|ਸੋਮਵਾਰ|ਮੰਗਲਵਾਰ|ਬੁੱਧਵਾਰ|ਵੀਰਵਾਰ|ਸ਼ੁੱਕਰਵਾਰ|ਸ਼ਨਿੱਚਰਵਾਰ|ਐ|ਸੋ|ਮੰ|ਬੁੱ|ਵੀ|ਸ਼ੁੱ|ਸ਼|0|ਈ. ਪੂ.|ਸੰਨ|ਈਸਵੀ ਪੂਰਵ|ਈਸਵੀ ਸੰਨ|ਈ.ਪੂ.|ਸੰਨ|h:mm a|h:mm:ss a|h:mm:ss a z|h:mm:ss a zzzz|{1}, {0}|{1}, {0}|{1} {0}|{1} {0}|50|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|d, E|Ehm|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss a|EHms|E HH:mm:ss|Gy|G y|GyMd|d/M/GGGGG y|GyMMM|MMM, G y|GyMMMd|d MMM, G y|GyMMMEd|E d MMM, G y|h|h\u202Fa|H|HH|hm|h:mm a|Hm|HH:mm|hms|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm a v|Hmv|HH:mm v|M|L|Md|d/M|MEd|E, dd-MM.|MMM|LLL|MMMd|d MMM|MMMEd|E, d MMM|MMMMd|MMMM d|MMMMW-count-one|MMMM ਦਾ W ਹਫ਼ਤਾ|MMMMW-count-other|MMMM ਦਾ W ਹਫ਼ਤਾ|mmss|mm:ss|ms|mm:ss|y|y|yM|M/y|yMd|d/M/y|yMEd|E, d/M/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E, d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|Y ਦਾ w ਹਫ਼ਤਾ|yw-count-other|Y ਦਾ w ਹਫ਼ਤਾ|ahmm|ahmmss|ahmmssz|ahmmsszzzz|X3I,|.|-||||||E2I,|.|-¤||¤||¤||E0I,|.|-|%||%||%|107|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XCG|Cg.|XOF|F\u202FCFA|XPF|CFPF|XXX|XXX|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$pa = $enkidatron$elm_cldr$Generated$Pa$pa;
var $enkidatron$elm_cldr$Generated$Pcm$dayPeriods = $elm$core$Dict$fromList(_List_Nil);
var $enkidatron$elm_cldr$Generated$Pcm$pcm = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Pcm$dayPeriods, 'pcm||||FM|FI|2|am|FM|pm|FI|Fọ mọ́nin|Fọ ívnin|2|am|Fọ mọ́nin|pm|Fọ ívnin|FM|FI|2|am|FM|pm|FI|dd/MM/y|d MMM y|d MMMM y|EEEE, d MMMM y|Jén|Fẹ́b|Mach|Épr|Mee|Jun|Jul|Ọgọ|Sẹp|Ọkt|Nọv|Dis|Jénúári|Fẹ́búári|Mach|Éprel|Mee|Jun|Julai|Ọgọst|Sẹptẹ́mba|Ọktóba|Nọvẹ́mba|Disẹ́mba|J|F|M|A|M|J|J|A|S|O|N|D|1|Jén|Fẹ́b|Mach|Épr|Mee|Jun|Jul|Ọ́gọ|Sẹp|Ọkt|Nọv|Dis|Jénúári|Fẹ́búári|Mach|Éprel|Mee|Jun|Julai|Ọgọst|Sẹptẹ́mba|Ọktóba|Nọvẹ́mba|Disẹ́mba|J|F|M|A|M|J|J|A|S|O|N|D|Sọ́n|Mọ́n|Tiú|Wẹ́n|Tọ́z|Fraí|Sát|Sọ́ndè|Mọ́ndè|Tiúzdè|Wẹ́nẹ́zdè|Tọ́zdè|Fraídè|Sátọdè|S|M|T|W|T|F|S|0|BK|KIY|Bifọ́ Kraist|Kraist Im Yiẹ|BK|KIY|HH:mm|HH:mm:ss|H:mm:ss z|HH:mm:ss zzzz|{1} {0}|{1} {0}|{1}, {0}|{1}, {0}|49|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|d E|Ehm|E h:mm\u202Fa|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|EHms|E HH:mm:ss|Gy|G y|GyMd|GGGGG y-MM-dd|GyMMM|G y MMM|GyMMMd|G y MMM d|GyMMMEd|G y MMM d, E|h|h\u202Fa|H|HH|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|Hmv|HH:mm v|M|L|Md|d /M|MEd|E, d/M|MMM|LLL|MMMd|d MMM|MMMEd|E, d MMM|MMMMd|d MMMM|MMMMW-count-one|\'Wik\' W \'fọ\' MMMM|MMMMW-count-other|\'Wik\' W \'fọ\' MMMM|ms|mm:ss|y|y|yM|M/y|yMd|d/M/y|yMEd|E, d/M/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E, d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\'Wik\' w \'fọ\' Y|yw-count-other|\'Wiik\' w \'fọ\' Y|HHmm|HHmmss|Hmmssz|HHmmsszzzz|X3W,|.|-||||||E2W,|.|-¤||¤||¤||E0W,|.|-|%||%||%|107|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|p.|BZD|$|CAD|KA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XCG|Cg.|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$pcm = $enkidatron$elm_cldr$Generated$Pcm$pcm;
var $enkidatron$elm_cldr$Generated$Pl$dayPeriods = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			'pl',
			_List_fromArray(
				[
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(12, 0),
					_Utils_Tuple2(18, 0),
					'afternoon1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(18, 0),
					_Utils_Tuple2(21, 0),
					'evening1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(0, 0),
					'midnight'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(6, 0),
					_Utils_Tuple2(10, 0),
					'morning1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(10, 0),
					_Utils_Tuple2(12, 0),
					'morning2'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(21, 0),
					_Utils_Tuple2(6, 0),
					'night1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(12, 0),
					'noon')
				]))
		]));
var $enkidatron$elm_cldr$Generated$Pl$pl = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Pl$dayPeriods, 'pl||||AM|PM|9|afternoon1|po południu|am|AM|evening1|wieczorem|midnight|o północy|morning1|rano|morning2|przed południem|night1|w nocy|noon|w południe|pm|PM|AM|PM|9|afternoon1|po południu|am|AM|evening1|wieczorem|midnight|o północy|morning1|rano|morning2|przed południem|night1|w nocy|noon|w południe|pm|PM|a|p|9|afternoon1|po poł.|am|a|evening1|wiecz.|midnight|o półn.|morning1|rano|morning2|przed poł.|night1|w nocy|noon|w poł.|pm|p|d.MM.y|d MMM y|d MMMM y|EEEE, d MMMM y|sty|lut|mar|kwi|maj|cze|lip|sie|wrz|paź|lis|gru|stycznia|lutego|marca|kwietnia|maja|czerwca|lipca|sierpnia|września|października|listopada|grudnia|s|l|m|k|m|c|l|s|w|p|l|g|1|sty|lut|mar|kwi|maj|cze|lip|sie|wrz|paź|lis|gru|styczeń|luty|marzec|kwiecień|maj|czerwiec|lipiec|sierpień|wrzesień|październik|listopad|grudzień|S|L|M|K|M|C|L|S|W|P|L|G|niedz.|pon.|wt.|śr.|czw.|pt.|sob.|niedziela|poniedziałek|wtorek|środa|czwartek|piątek|sobota|n|p|w|ś|c|p|s|1|niedz.|pon.|wt.|śr.|czw.|pt.|sob.|niedziela|poniedziałek|wtorek|środa|czwartek|piątek|sobota|N|P|W|Ś|C|P|S|p.n.e.|n.e.|przed naszą erą|naszej ery|p.n.e.|n.e.|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1}, {0}|{1}, {0}|{1} {0}|{1} {0}|59|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E, d|Ehm|E, h:mm\u202Fa|EHm|E, HH:mm|Ehms|E, h:mm:ss\u202Fa|EHms|E, HH:mm:ss|Gy|y G|GyMd|d.MM.y GGGGG|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E, d MMM y G|GyMMMM|LLLL y G|GyMMMMd|d MMMM y G|GyMMMMEd|E, d MMMM y G|h|h\u202Fa|H|HH|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|Hmv|HH:mm v|M|L|Md|d.MM|MEd|E, d.MM|MMM|LLL|MMMd|d MMM|MMMEd|E, d MMM|MMMMd|d MMMM|MMMMEd|E, d MMMM|MMMMW-count-one|LLLL, \'tydz\'. W|MMMMW-count-few|LLLL, \'tydz\'. W|MMMMW-count-many|LLLL, \'tydz\'. W|MMMMW-count-other|LLLL, \'tydz\'. W|ms|mm:ss|y|y|yM|MM.y|yMd|d.MM.y|yMEd|E, d.MM.y|yMMM|LLL y|yMMMd|d MMM y|yMMMEd|E, d MMM y|yMMMM|LLLL y|yMMMMd|d MMMM y|yMMMMEd|E, d MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|Y, \'tydz\'. w|yw-count-few|Y, \'tydz\'. w|yw-count-many|Y, \'tydz\'. w|yw-count-other|Y, \'tydz\'. w|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W\u00A0|,|-||||||E2W\u00A0|,|-|\u00A0¤||\u00A0¤||\u00A0¤|E0W\u00A0|,|-|%||%||%|106|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|AUD|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BZD|$|CAD|CAD|CLP|$|CNY|CNY|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|GBP|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HKD|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|ILS|INR|INR|ISK|kr|JMD|$|JPY|JPY|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|KRW|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MXN|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZD|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|lej|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|TWD|UAH|₴|USD|USD|UYU|$|VEF|Bs|VND|VND|XAF|FCFA|XCD|EC$|XCG|Cg.|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$pl = $enkidatron$elm_cldr$Generated$Pl$pl;
var $enkidatron$elm_cldr$Generated$Ps$dayPeriods = $elm$core$Dict$fromList(_List_Nil);
var $enkidatron$elm_cldr$Generated$Ps$ps = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Ps$dayPeriods, 'ps||||AM|PM|2|am|AM|pm|PM|غ.م.|غ.و.|2|am|غ.م.|pm|غ.و.|غ.م.|غ.و.|2|am|غ.م.|pm|غ.و.|y/M/d|y MMM d|y MMMM d|EEEE د y د MMMM d|جنوري|فبروري|مارچ|اپریل|مۍ|جون|جولای|اګست|سېپتمبر|اکتوبر|نومبر|دسمبر|جنوري|فبروري|مارچ|اپریل|مۍ|جون|جولای|اګست|سېپتمبر|اکتوبر|نومبر|دسمبر|ج|ف|م|ا|م|ج|ج|ا|س|ا|ن|د|1|جنوري|فبروري|مارچ|اپریل|مۍ|جون|جولای|اګست|سپتمبر|اکتوبر|نومبر|دسمبر|جنوري|فېبروري|مارچ|اپریل|مۍ|جون|جولای|اګست|سپتمبر|اکتوبر|نومبر|دسمبر|1|2|3|4|5|6|7|8|9|10|11|12|يونۍ|دونۍ|درېنۍ|څلرنۍ|پينځنۍ|جمعه|اونۍ|يونۍ|دونۍ|درېنۍ|څلرنۍ|پينځنۍ|جمعه|اونۍ|S|M|T|W|T|F|S|0|له میلاد وړاندې|م.|له میلاد څخه وړاندې|له میلاد څخه وروسته|له میلاد وړاندې|م.|H:mm|H:mm:ss|H:mm:ss (z)|H:mm:ss (zzzz)|{1} {0}|{1} {0}|{1} {0}|{1} {0}|49|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|d, E|Ehm|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss a|EHms|E HH:mm:ss|Gy|G y|GyMd|M/d/y GGGGG|GyMMM|G y MMM|GyMMMd|G y MMM d|GyMMMEd|G y MMM d, E|h|h\u202Fa|H|HH|hm|h:mm a|Hm|HH:mm|hms|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm a v|Hmv|HH:mm v|M|L|Md|MM-dd|MEd|MM-dd, E|MMM|LLL|MMMd|MMM d|MMMEd|E, MMM d|MMMMd|MMMM d|MMMMW-count-one|اونۍ W د MMMM|MMMMW-count-other|اونۍ W د MMMM|ms|mm:ss|y|y|yM|y-MM|yMd|y-MM-dd|yMEd|y-MM-dd, E|yMMM|y MMM|yMMMd|y MMM d|yMMMEd|y MMM d, E|yMMMM|y MMMM|yQQQ|y QQQ|yQQQQ|y QQQQ|yw-count-one|اونۍ w د Y|yw-count-other|اونۍ w د Y|Hmm|Hmmss|Hmmssz|Hmmsszzzz|X3W.|,|\u200E−||||||E2W.|,|\u200E−¤\u00A0||¤\u00A0||¤\u00A0||E0W.|,|\u200E−|%||%||%|107|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|₱|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XCG|Cg.|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$ps = $enkidatron$elm_cldr$Generated$Ps$ps;
var $enkidatron$elm_cldr$Generated$Pt$dayPeriods = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			'pt',
			_List_fromArray(
				[
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(12, 0),
					_Utils_Tuple2(19, 0),
					'afternoon1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(19, 0),
					_Utils_Tuple2(24, 0),
					'evening1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(0, 0),
					'midnight'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(6, 0),
					_Utils_Tuple2(12, 0),
					'morning1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(0, 0),
					_Utils_Tuple2(6, 0),
					'night1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(12, 0),
					'noon')
				]))
		]));
var $enkidatron$elm_cldr$Generated$Pt$pt = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Pt$dayPeriods, 'pt||||AM|PM|8|afternoon1|da tarde|am|AM|evening1|da noite|midnight|meia-noite|morning1|da manhã|night1|da madrugada|noon|meio-dia|pm|PM|AM|PM|8|afternoon1|da tarde|am|AM|evening1|da noite|midnight|meia-noite|morning1|da manhã|night1|da madrugada|noon|meio-dia|pm|PM|AM|PM|8|afternoon1|da tarde|am|AM|evening1|da noite|midnight|meia-noite|morning1|da manhã|night1|da madrugada|noon|meio-dia|pm|PM|dd/MM/y|d \'de\' MMM \'de\' y|d \'de\' MMMM \'de\' y|EEEE, d \'de\' MMMM \'de\' y|jan.|fev.|mar.|abr.|mai.|jun.|jul.|ago.|set.|out.|nov.|dez.|janeiro|fevereiro|março|abril|maio|junho|julho|agosto|setembro|outubro|novembro|dezembro|J|F|M|A|M|J|J|A|S|O|N|D|0|dom.|seg.|ter.|qua.|qui.|sex.|sáb.|domingo|segunda-feira|terça-feira|quarta-feira|quinta-feira|sexta-feira|sábado|D|S|T|Q|Q|S|S|0|a.C.|d.C.|antes de Cristo|depois de Cristo|a.C.|d.C.|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1} {0}|{1} {0}|{1} {0}|{1} {0}|54|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E, d|Ehm|E, h:mm\u202Fa|EHm|E, HH:mm|Ehms|E, h:mm:ss\u202Fa|EHms|E, HH:mm:ss|Gy|y G|GyMd|dd/MM/y GGGGG|GyMMM|MMM \'de\' y G|GyMMMd|d \'de\' MMM \'de\' y G|GyMMMEd|E, d \'de\' MMM \'de\' y G|h|h\u202Fa|H|HH|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|Hmv|HH:mm v|M|L|Md|dd/MM|MEd|E, dd/MM|MMdd|dd/MM|MMM|LLL|MMMd|d \'de\' MMM|MMMEd|E, d \'de\' MMM|MMMMd|d \'de\' MMMM|MMMMEd|E, d \'de\' MMMM|MMMMW-count-one|W\'ª\' \'semana\' \'de\' MMMM|MMMMW-count-other|W\'ª\' \'semana\' \'de\' MMMM|ms|mm:ss|y|y|yM|MM/y|yMd|dd/MM/y|yMEd|E, dd/MM/y|yMM|MM/y|yMMM|MMM \'de\' y|yMMMd|d \'de\' MMM \'de\' y|yMMMEd|E, d \'de\' MMM \'de\' y|yMMMM|MMMM \'de\' y|yMMMMd|d \'de\' MMMM \'de\' y|yMMMMEd|E, d \'de\' MMMM \'de\' y|yQQQ|QQQ \'de\' y|yQQQQ|QQQQ \'de\' y|yw-count-one|w\'ª\' \'semana\' \'de\' Y|yw-count-other|w\'ª\' \'semana\' \'de\' Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W.|,|-||||||E2W.|,|-¤\u00A0||¤\u00A0||¤\u00A0||E0W.|,|-|%||%||%|108|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|AU$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|PHP|PKR|Rs|PLN|zł|PTE|Esc.|PYG|₲|RON|L|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|S£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XCG|Cg.|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$pt = $enkidatron$elm_cldr$Generated$Pt$pt;
var $enkidatron$elm_cldr$Generated$Ro$dayPeriods = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			'ro',
			_List_fromArray(
				[
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(12, 0),
					_Utils_Tuple2(18, 0),
					'afternoon1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(18, 0),
					_Utils_Tuple2(22, 0),
					'evening1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(0, 0),
					'midnight'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(5, 0),
					_Utils_Tuple2(12, 0),
					'morning1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(22, 0),
					_Utils_Tuple2(5, 0),
					'night1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(12, 0),
					'noon')
				]))
		]));
var $enkidatron$elm_cldr$Generated$Ro$ro = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Ro$dayPeriods, 'ro||||a.m.|p.m.|8|afternoon1|după-amiaza|am|a.m.|evening1|seara|midnight|miezul nopții|morning1|dimineața|night1|noaptea|noon|amiază|pm|p.m.|a.m.|p.m.|8|afternoon1|după-amiaza|am|a.m.|evening1|seara|midnight|la miezul nopții|morning1|dimineața|night1|noaptea|noon|la amiază|pm|p.m.|a.m.|p.m.|8|afternoon1|după-amiaza|am|a.m.|evening1|seara|midnight|miezul nopții|morning1|dimineața|night1|noaptea|noon|amiază|pm|p.m.|dd.MM.y|d MMM y|d MMMM y|EEEE, d MMMM y|ian.|feb.|mar.|apr.|mai|iun.|iul.|aug.|sept.|oct.|nov.|dec.|ianuarie|februarie|martie|aprilie|mai|iunie|iulie|august|septembrie|octombrie|noiembrie|decembrie|I|F|M|A|M|I|I|A|S|O|N|D|0|dum.|lun.|mar.|mie.|joi|vin.|sâm.|duminică|luni|marți|miercuri|joi|vineri|sâmbătă|D|L|M|M|J|V|S|0|î.Hr.|d.Hr.|înainte de Hristos|după Hristos|î.Hr.|d.Hr.|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|54|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E h:mm\u202Fa|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|EHms|E HH:mm:ss|Gy|y G|GyMd|dd.MM.y G|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E, d MMM y G|h|h\u202Fa|H|HH|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|Hmv|HH:mm v|M|L|Md|dd.MM|MEd|E, dd.MM|MMdd|dd.MM|MMM|LLL|MMMd|d MMM|MMMEd|E, d MMM|MMMMd|d MMMM|MMMMEd|E, d MMMM|MMMMW-count-one|\'săptămâna\' W \'din\' MMMM|MMMMW-count-few|\'săptămâna\' W \'din\' MMMM|MMMMW-count-other|\'săptămâna\' W \'din\' MMMM|ms|mm:ss|y|y|yM|MM.y|yMd|dd.MM.y|yMEd|E, dd.MM.y|yMM|MM.y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E, d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\'săptămâna\' w \'din\' Y|yw-count-few|\'săptămâna\' w \'din\' Y|yw-count-other|\'săptămâna\' w \'din\' Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W.|,|-||||||E2W.|,|-|\u00A0¤||\u00A0¤||\u00A0¤|E0W.|,|-|\u00A0%||\u00A0%||\u00A0%|107|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|AUD|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|BRL|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CAD|CLP|$|CNY|CNY|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|EUR|FJD|$|FKP|£|GBP|GBP|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HKD|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|ILS|INR|INR|ISK|kr|JMD|$|JPY|JPY|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|KRW|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MXN|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZD|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|TWD|UAH|₴|USD|USD|UYU|$|VEF|Bs|VND|VND|XAF|FCFA|XCD|XCD|XCG|Cg.|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$ro = $enkidatron$elm_cldr$Generated$Ro$ro;
var $enkidatron$elm_cldr$Generated$Root$dayPeriods = $elm$core$Dict$fromList(_List_Nil);
var $enkidatron$elm_cldr$Generated$Root$root = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Root$dayPeriods, 'root||||AM|PM|2|am|AM|pm|PM|AM|PM|2|am|AM|pm|PM|AM|PM|2|am|AM|pm|PM|y-MM-dd|y MMM d|y MMMM d|y MMMM d, EEEE|M01|M02|M03|M04|M05|M06|M07|M08|M09|M10|M11|M12|M01|M02|M03|M04|M05|M06|M07|M08|M09|M10|M11|M12|1|2|3|4|5|6|7|8|9|10|11|12|0|Sun|Mon|Tue|Wed|Thu|Fri|Sat|Sun|Mon|Tue|Wed|Thu|Fri|Sat|S|M|T|W|T|F|S|0|BCE|CE|BCE|CE|BCE|CE|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1} {0}|{1} {0}|{1} {0}|{1} {0}|47|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|d, E|Ehm|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss a|EHms|E HH:mm:ss|Gy|G y|GyMd|GGGGG y-MM-dd|GyMMM|G y MMM|GyMMMd|G y MMM d|GyMMMEd|G y MMM d, E|h|h\u202Fa|H|HH|hm|h:mm a|Hm|HH:mm|hms|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm a v|Hmv|HH:mm v|M|L|Md|MM-dd|MEd|MM-dd, E|MMM|LLL|MMMd|MMM d|MMMEd|MMM d, E|MMMMd|MMMM d|MMMMW-count-other|\'week\' W \'of\' MMMM|ms|mm:ss|y|y|yM|y-MM|yMd|y-MM-dd|yMEd|y-MM-dd, E|yMMM|y MMM|yMMMd|y MMM d|yMMMEd|y MMM d, E|yMMMM|y MMMM|yQQQ|y QQQ|yQQQQ|y QQQQ|yw-count-other|\'week\' w \'of\' Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W,|.|-||||||E2W,|.|-¤\u00A0||¤\u00A0||¤\u00A0||E0W,|.|-|%||%||%|106|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|₱|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XCG|Cg.|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$root = $enkidatron$elm_cldr$Generated$Root$root;
var $enkidatron$elm_cldr$Generated$Ru$dayPeriods = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			'ru',
			_List_fromArray(
				[
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(12, 0),
					_Utils_Tuple2(18, 0),
					'afternoon1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(18, 0),
					_Utils_Tuple2(22, 0),
					'evening1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(0, 0),
					'midnight'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(4, 0),
					_Utils_Tuple2(12, 0),
					'morning1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(22, 0),
					_Utils_Tuple2(4, 0),
					'night1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(12, 0),
					'noon')
				]))
		]));
var $enkidatron$elm_cldr$Generated$Ru$ru = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Ru$dayPeriods, 'ru||||AM|PM|8|afternoon1|дня|am|AM|evening1|вечера|midnight|полн.|morning1|утра|night1|ночи|noon|полд.|pm|PM|AM|PM|8|afternoon1|дня|am|AM|evening1|вечера|midnight|полночь|morning1|утра|night1|ночи|noon|полдень|pm|PM|AM|PM|8|afternoon1|дня|am|AM|evening1|веч.|midnight|полн.|morning1|утра|night1|ночи|noon|полд.|pm|PM|dd.MM.y|d MMM y\u202F\'г\'.|d MMMM y\u202F\'г\'.|EEEE, d MMMM y\u202F\'г\'.|янв.|февр.|мар.|апр.|мая|июн.|июл.|авг.|сент.|окт.|нояб.|дек.|января|февраля|марта|апреля|мая|июня|июля|августа|сентября|октября|ноября|декабря|Я|Ф|М|А|М|И|И|А|С|О|Н|Д|1|янв.|февр.|март|апр.|май|июнь|июль|авг.|сент.|окт.|нояб.|дек.|январь|февраль|март|апрель|май|июнь|июль|август|сентябрь|октябрь|ноябрь|декабрь|Я|Ф|М|А|М|И|И|А|С|О|Н|Д|вс|пн|вт|ср|чт|пт|сб|воскресенье|понедельник|вторник|среда|четверг|пятница|суббота|В|П|В|С|Ч|П|С|0|до н. э.|н. э.|до Рождества Христова|от Рождества Христова|до н.э.|н.э.|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|55|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|ccc, h:mm B|EBhms|ccc, h:mm:ss B|Ed|ccc, d|Ehm|E h:mm\u202Fa|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|EHms|E HH:mm:ss|Gy|y\u202F\'г\'. G|GyMd|dd.MM.y GGGGG|GyMMM|LLL y\u202F\'г\'. G|GyMMMd|d MMM y\u202F\'г\'. G|GyMMMEd|E, d MMM y\u202F\'г\'. G|h|h\u202Fa|H|HH|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|Hmv|HH:mm v|M|L|Md|dd.MM|MEd|E, dd.MM|MMdd|dd.MM|MMM|LLL|MMMd|d MMM|MMMEd|ccc, d MMM|MMMMd|d MMMM|MMMMW-count-one|W-\'я\' \'неделя\' MMMM|MMMMW-count-few|W-\'я\' \'неделя\' MMMM|MMMMW-count-many|W-\'я\' \'неделя\' MMMM|MMMMW-count-other|W-\'я\' \'неделя\' MMMM|ms|mm:ss|y|y|yM|MM.y|yMd|dd.MM.y|yMEd|ccc, dd.MM.y\u202F\'г\'.|yMM|MM.y|yMMM|LLL y\u202F\'г\'.|yMMMd|d MMM y\u202F\'г\'.|yMMMEd|E, d MMM y\u202F\'г\'.|yMMMM|LLLL y\u202F\'г\'.|yQQQ|QQQ y\u202F\'г\'.|yQQQQ|QQQQ y\u202F\'г\'.|yw-count-one|w-\'я\' \'неделя\' Y \'г\'.|yw-count-few|w-\'я\' \'неделя\' Y \'г\'.|yw-count-many|w-\'я\' \'неделя\' Y \'г\'.|yw-count-other|w-\'я\' \'неделя\' Y \'г\'.|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W\u00A0|,|-||||||E2W\u00A0|,|-|\u00A0¤||\u00A0¤||\u00A0¤|E0W\u00A0|,|-|\u00A0%||\u00A0%||\u00A0%|109|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|ლ|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|L|RUB|₽|RUR|р.|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TMT|ТМТ|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XCG|Cg.|XOF|F\u202FCFA|XPF|CFPF|XXX|XXXX|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$ru = $enkidatron$elm_cldr$Generated$Ru$ru;
var $enkidatron$elm_cldr$Generated$Sd$dayPeriods = $elm$core$Dict$fromList(_List_Nil);
var $enkidatron$elm_cldr$Generated$Sd$sd = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Sd$dayPeriods, 'sd||||صبح،\u202Fمنجهند|شام،\u202Fمنجهند|2|am|صبح،\u202Fمنجهند|pm|شام،\u202Fمنجهند|صبح، منجهند|منجهند، شام|2|am|صبح، منجهند|pm|منجهند، شام|صبح،\u202Fمنجهند|منجهند،\u202Fشام|2|am|صبح،\u202Fمنجهند|pm|منجهند،\u202Fشام|y-MM-dd|y MMM d|y MMMM d|EEEE, MMMM d, y|جنوري|فيبروري|مارچ|اپريل|مئي|جون|جولاءِ|آگسٽ|سيپٽمبر|آڪٽوبر|نومبر|ڊسمبر|جنوري|فيبروري|مارچ|اپريل|مئي|جون|جولاءِ|آگسٽ|سيپٽمبر|آڪٽوبر|نومبر|ڊسمبر|J|F|M|A|M|J|J|A|S|O|N|D|0|آچر|سومر|اڱارو|اربع|خميس|جمعو|ڇنڇر|آچر|سومر|اڱارو|اربع|خميس|جمعو|ڇنڇر|آچر|سو|اڱارو|اربع|خم|جمعو|ڇنڇر|0|BC|CD|قبل مسيح|عيسوي کان پهرين|BC|CD|h:mm a|h:mm:ss a|h:mm:ss a z|h:mm:ss a zzzz|{1} {0}|{1} {0}|{1} {0}|{1} {0}|49|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|d, E|Ehm|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss a|EHms|E HH:mm:ss|Gy|G y|GyMd|M/d/y G|GyMMM|G y MMM|GyMMMd|G y MMM d|GyMMMEd|G y MMM d, E|h|h\u202Fa|H|HH|hm|h:mm a|Hm|HH:mm|hms|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm a v|Hmv|HH:mm v|M|L|Md|MM-dd|MEd|MM-dd, E|MMM|LLL|MMMd|MMM d|MMMEd|MMM d, E|MMMMd|MMMM d|MMMMW-count-one|ھفتو W جو MMMM|MMMMW-count-other|ھفتو W جو MMMM|ms|mm:ss|y|y|yM|y-MM|yMd|y-MM-dd|yMEd|y-MM-dd, E|yMMM|y MMM|yMMMd|y MMM d|yMMMEd|y MMM d, E|yMMMM|y MMMM|yQQQ|y QQQ|yQQQQ|y QQQQ|yw-count-one|ھفتو w جو Y|yw-count-other|ھفتو w جو Y|ahmm|ahmmss|ahmmssz|ahmmsszzzz|X3W,|.|-||||||E2W,|.|-¤\u00A0||¤\u00A0||¤\u00A0||E0W,|.|-|%||%||%|107|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XCG|Cg.|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$sd = $enkidatron$elm_cldr$Generated$Sd$sd;
var $enkidatron$elm_cldr$Generated$Si$dayPeriods = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			'si',
			_List_fromArray(
				[
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(12, 0),
					_Utils_Tuple2(14, 0),
					'afternoon1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(14, 0),
					_Utils_Tuple2(18, 0),
					'evening1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(0, 0),
					'midnight'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(1, 0),
					_Utils_Tuple2(6, 0),
					'morning1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(6, 0),
					_Utils_Tuple2(12, 0),
					'morning2'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(18, 0),
					_Utils_Tuple2(24, 0),
					'night1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(0, 0),
					_Utils_Tuple2(1, 0),
					'night2'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(12, 0),
					'noon')
				]))
		]));
var $enkidatron$elm_cldr$Generated$Si$si = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Si$dayPeriods, 'si||||පෙ.ව.|ප.ව.|10|afternoon1|දවල්|am|පෙ.ව.|evening1|හවස|midnight|මැදියම|morning1|පාන්දර|morning2|උදේ|night1|රෑ|night2|මැදියමට පසු|noon|මධ්\u200Dයාහ්නය|pm|ප.ව.|පෙ.ව.|ප.ව.|10|afternoon1|දවල්|am|පෙ.ව.|evening1|හවස|midnight|මැදියම|morning1|පාන්දර|morning2|උදේ|night1|රෑ|night2|මැදියමට පසු|noon|මධ්\u200Dයාහ්නය|pm|ප.ව.|පෙ|ප|10|afternoon1|ද|am|පෙ|evening1|හ|midnight|මැ|morning1|පා|morning2|උ|night1|රෑ|night2|මැ|noon|ම|pm|ප|y-MM-dd|y MMM d|y MMMM d|y MMMM d, EEEE|ජන|පෙබ|මාර්තු|අප්\u200Dරේල්|මැයි|ජූනි|ජූලි|අගෝ|සැප්|ඔක්|නොවැ|දෙසැ|ජනවාරි|පෙබරවාරි|මාර්තු|අප්\u200Dරේල්|මැයි|ජූනි|ජූලි|අගෝස්තු|සැප්තැම්බර්|ඔක්තෝබර්|නොවැම්බර්|දෙසැම්බර්|ජ|පෙ|මා|අ|මැ|ජූ|ජූ|අ|සැ|ඔ|නෙ|දෙ|1|ජන|පෙබ|මාර්|අප්\u200Dරේල්|මැයි|ජූනි|ජූලි|අගෝ|සැප්|ඔක්|නොවැ|දෙසැ|ජනවාරි|පෙබරවාරි|මාර්තු|අප්\u200Dරේල්|මැයි|ජූනි|ජූලි|අගෝස්තු|සැප්තැම්බර්|ඔක්තෝබර්|නොවැම්බර්|දෙසැම්බර්|ජ|පෙ|මා|අ|මැ|ජූ|ජූ|අ|සැ|ඔ|නෙ|දෙ|ඉරිදා|සඳුදා|අඟහ|බදාදා|බ්\u200Dරහස්|සිකු|සෙන|ඉරිදා|සඳුදා|අඟහරුවාදා|බදාදා|බ්\u200Dරහස්පතින්දා|සිකුරාදා|සෙනසුරාදා|ඉ|ස|අ|බ|බ්\u200Dර|සි|සෙ|0|ක්\u200Dරි.පූ.|ක්\u200Dරි.ව.|ක්\u200Dරිස්තු පූර්ව|ක්\u200Dරිස්තු වර්ෂ|ක්\u200Dරි.පූ.|ක්\u200Dරි.ව.|HH.mm|HH.mm.ss|HH.mm.ss z|HH.mm.ss zzzz|{1} {0}|{1} {0}|{1} {0}|{1} {0}|49|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|d E|Ehm|E a h.mm|EHm|E HH.mm|Ehms|E a h.mm.ss|EHms|E HH.mm.ss|Gy|G y|GyMd|GGGGG y-MM-dd|GyMMM|G y MMM|GyMMMd|G y MMM d|GyMMMEd|G y MMM d, E|h|a h|H|HH|hm|a h.mm|Hm|HH.mm|hms|a h.mm.ss|Hms|HH.mm.ss|hmsv|h.mm.ss a v|Hmsv|HH.mm.ss v|hmv|h.mm a v|Hmv|HH.mm v|M|L|Md|M-d|MEd|M-d, E|MMM|LLL|MMMd|MMM d|MMMEd|MMM d E|MMMMd|MMMM d|MMMMW-count-one|MMMM සතිය W|MMMMW-count-other|MMMM සතිය W|ms|mm.ss|y|y|yM|y-M|yMd|y-M-d|yMEd|y-M-d, E|yMMM|y MMM|yMMMd|y MMM d|yMMMEd|y MMM d, E|yMMMM|y MMMM|yQQQ|y QQQ|yQQQQ|y QQQQ|yw-count-one|Y සතිය w|yw-count-other|Y සතිය w|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W,|.|-||||||E2W,|.|-¤||¤||¤||E0W,|.|-|%||%||%|107|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|රු.|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XCG|Cg.|XOF|සිෆ්එ|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$si = $enkidatron$elm_cldr$Generated$Si$si;
var $enkidatron$elm_cldr$Generated$Sk$dayPeriods = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			'sk',
			_List_fromArray(
				[
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(12, 0),
					_Utils_Tuple2(18, 0),
					'afternoon1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(18, 0),
					_Utils_Tuple2(22, 0),
					'evening1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(0, 0),
					'midnight'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(4, 0),
					_Utils_Tuple2(9, 0),
					'morning1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(9, 0),
					_Utils_Tuple2(12, 0),
					'morning2'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(22, 0),
					_Utils_Tuple2(4, 0),
					'night1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(12, 0),
					'noon')
				]))
		]));
var $enkidatron$elm_cldr$Generated$Sk$sk = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Sk$dayPeriods, 'sk||||AM|PM|9|afternoon1|popol.|am|AM|evening1|večer|midnight|o poln.|morning1|ráno|morning2|dopol.|night1|v noci|noon|napol.|pm|PM|AM|PM|9|afternoon1|popoludní|am|AM|evening1|večer|midnight|o polnoci|morning1|ráno|morning2|dopoludnia|night1|v noci|noon|napoludnie|pm|PM|AM|PM|9|afternoon1|pop.|am|AM|evening1|več.|midnight|o poln.|morning1|ráno|morning2|dop.|night1|v n.|noon|nap.|pm|PM|d. M. y|d. M. y|d. MMMM y|EEEE d. MMMM y|jan|feb|mar|apr|máj|jún|júl|aug|sep|okt|nov|dec|januára|februára|marca|apríla|mája|júna|júla|augusta|septembra|októbra|novembra|decembra|j|f|m|a|m|j|j|a|s|o|n|d|1|jan|feb|mar|apr|máj|jún|júl|aug|sep|okt|nov|dec|január|február|marec|apríl|máj|jún|júl|august|september|október|november|december|j|f|m|a|m|j|j|a|s|o|n|d|ne|po|ut|st|št|pi|so|nedeľa|pondelok|utorok|streda|štvrtok|piatok|sobota|n|p|u|s|š|p|s|0|pred Kr.|po Kr.|pred Kristom|po Kristovi|pred Kr.|po Kr.|H:mm|H:mm:ss|H:mm:ss z|H:mm:ss zzzz|{1} {0}|{1}, {0}|{1}, {0}|{1}, {0}|57|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d.|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d.|Ehm|E h:mm\u202Fa|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|EHms|E HH:mm:ss|Gy|y G|GyMd|d. M. y GGGGG|GyMMM|LLLL y G|GyMMMd|d. M. y G|GyMMMEd|E d. M. y G|GyMMMMd|d. M. y G|h|h\u202Fa|H|H|hm|h:mm\u202Fa|Hm|H:mm|hms|h:mm:ss\u202Fa|Hms|H:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|H:mm:ss v|hmv|h:mm\u202Fa v|Hmv|H:mm v|M|L.|Md|d. M.|MEd|E d. M.|MMM|LLL|MMMd|d. M.|MMMEd|E d. M.|MMMMd|d. MMMM|MMMMEd|E d. MMMM|MMMMW-count-one|W. \'týždeň\' MMMM|MMMMW-count-few|W. \'týždeň\' MMMM|MMMMW-count-many|W. \'týždeň\' MMMM|MMMMW-count-other|W. \'týždeň\' MMMM|mmss|mm:ss|ms|mm:ss|y|y|yM|M/y|yMd|d. M. y|yMEd|E d. M. y|yMMM|M/y|yMMMd|d. M. y|yMMMEd|E d. M. y|yMMMM|LLLL y|yMMMMd|d. MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|w. \'týždeň\' \'roka\' Y|yw-count-few|w. \'týždeň\' \'roka\' Y|yw-count-many|w. \'týždeň\' \'roka\' Y|yw-count-other|w. \'týždeň\' \'roka\' Y|Hmm|Hmmss|Hmmssz|Hmmsszzzz|X3W\u00A0|,|-||||||E2W\u00A0|,|-|\u00A0¤||\u00A0¤||\u00A0¤|E0W\u00A0|,|-|\u00A0%||\u00A0%||\u00A0%|108|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|AUD|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|BRL|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CAD|CLP|$|CNY|CNY|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|GBP|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HKD|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|NIS|INR|INR|ISK|kr|JMD|$|JPY|JPY|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|KRW|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZD|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RUR|р.|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|TWD|UAH|₴|USD|USD|UYU|$|VEF|Bs|VND|VND|XAF|FCFA|XCD|EC$|XCG|Cg.|XOF|F\u202FCFA|XPF|CFPF|XXX|XXX|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$sk = $enkidatron$elm_cldr$Generated$Sk$sk;
var $enkidatron$elm_cldr$Generated$Sl$dayPeriods = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			'sl',
			_List_fromArray(
				[
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(12, 0),
					_Utils_Tuple2(18, 0),
					'afternoon1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(18, 0),
					_Utils_Tuple2(22, 0),
					'evening1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(0, 0),
					'midnight'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(6, 0),
					_Utils_Tuple2(10, 0),
					'morning1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(10, 0),
					_Utils_Tuple2(12, 0),
					'morning2'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(22, 0),
					_Utils_Tuple2(6, 0),
					'night1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(12, 0),
					'noon')
				]))
		]));
var $enkidatron$elm_cldr$Generated$Sl$sl = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Sl$dayPeriods, 'sl||||dop.|pop.|9|afternoon1|pop.|am|dop.|evening1|zveč.|midnight|opoln.|morning1|zjut.|morning2|dop.|night1|ponoči|noon|opold.|pm|pop.|dop.|pop.|9|afternoon1|popoldan|am|dop.|evening1|zvečer|midnight|opolnoči|morning1|zjutraj|morning2|dopoldan|night1|ponoči|noon|opoldne|pm|pop.|d|p|9|afternoon1|p|am|d|evening1|zv|midnight|24.00|morning1|zj|morning2|d|night1|po|noon|12.00|pm|p|d. M. yy|d. MMM y|d. MMMM y|EEEE, d. MMMM y|jan.|feb.|mar.|apr.|maj|jun.|jul.|avg.|sep.|okt.|nov.|dec.|januar|februar|marec|april|maj|junij|julij|avgust|september|oktober|november|december|j|f|m|a|m|j|j|a|s|o|n|d|0|ned.|pon.|tor.|sre.|čet.|pet.|sob.|nedelja|ponedeljek|torek|sreda|četrtek|petek|sobota|n|p|t|s|č|p|s|0|pr. Kr.|po Kr.|pred Kristusom|po Kristusu|pr. Kr.|po Kr.|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1}, {0}|{1}, {0}|{1} {0}|{1} {0}|54|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d.|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E, d.|Ehm|E, h:mm\u202Fa|EHm|E, HH:mm|Ehms|E, h:mm:ss\u202Fa|EHms|E, HH:mm:ss|Gy|y G|GyM|MMM y G|GyMd|d. M. y GGGGG|GyMMM|MMM y G|GyMMMd|d. MMM y G|GyMMMEd|E, d. MMM y G|h|h\u202Fa|H|HH\'h\'|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|Hmv|HH:mm v|M|L|Md|d. M.|MEd|E, d. M.|MMM|LLL|MMMd|d. MMM|MMMEd|E, d. MMM|MMMMd|d. MMMM|MMMMW-count-one|MMMM: W. \'teden\'|MMMMW-count-two|MMMM: W. \'teden\'|MMMMW-count-few|MMMM: W. \'teden\'|MMMMW-count-other|MMMM: W. \'teden\'|ms|mm:ss|y|y|yM|M/y|yMd|d. M. y|yMEd|E, d. M. y|yMMM|MMM y|yMMMd|d. MMM y|yMMMEd|E, d. MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|w. \'teden\' \'leta\' Y|yw-count-two|w. \'teden\' \'leta\' Y|yw-count-few|w. \'teden\' \'leta\' Y|yw-count-other|w. \'teden\' \'leta\' Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W.|,|−||||||E2W.|,|−|\u00A0¤||\u00A0¤||\u00A0¤|E0W.|,|−|\u00A0%||\u00A0%||\u00A0%|107|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|AUD|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|BRL|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CAD|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|GBP|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MXN|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZD|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|TWD|UAH|₴|USD|$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|XCD|XCG|Cg.|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$sl = $enkidatron$elm_cldr$Generated$Sl$sl;
var $enkidatron$elm_cldr$Generated$So$dayPeriods = $elm$core$Dict$fromList(_List_Nil);
var $enkidatron$elm_cldr$Generated$So$so = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$So$dayPeriods, 'so||||GH|GD|2|am|GH|pm|GD|GH|GD|2|am|GH|pm|GD|h|d|2|am|h|pm|d|dd/MM/yy|dd-MMM-y|MMMM d, y|EEEE, MMMM d, y|Jan|Feb|Mar|Abr|May|Jun|Lul|Ogs|Seb|Okt|Nof|Dis|Janaayo|Febraayo|Maarso|Abriil|Maayo|Juun|Luulyo|Agosto|Sebtembar|Oktoobar|Noofeembar|Diseembar|J|F|M|A|M|J|L|O|S|O|N|D|1|Jan|Feb|Mar|Abr|May|Jun|Lul|Ogs|Seb|Okt|Nof|Dis|Jannaayo|Febraayo|Maarso|Abriil|Maayo|Juun|Luulyo|Ogosto|Sebteembar|Oktoobar|Noofeembar|Diseembar|J|F|M|A|M|J|L|O|S|O|N|D|Axd|Isn|Tldo|Arbc|Khms|Jmc|Sbti|Axad|Isniin|Talaado|Arbaco|Khamiis|Jimco|Sabti|A|I|T|A|Kh|J|S|0|BC|AD|Ciise Hortii|Ciise Dabadii|B|A|h:mm\u202Fa|h:mm:ss\u202Fa|h:mm:ss\u202Fa z|h:mm:ss\u202Fa zzzz|{1} {0}|{1} {0}|{1} {0}|{1} {0}|50|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|d, E|Ehm|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss a|EHms|E HH:mm:ss|Gy|y G|GyMd|M/d/y GGGGG|GyMMM|MMM y G|GyMMMd|MMM d, y G|GyMMMEd|E, MMM d, y G|h|h\u202Fa|H|HH|hm|h:mm a|Hm|HH:mm|hms|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmv|h:mm a v|Hmv|HH:mm v|M|L|Md|M/d|MEd|E, M/d|MMM|LLL|MMMd|MMM d|MMMEd|E, MMM d|MMMMd|MMMM d|MMMMEd|E, MMMM d|MMMMW-count-one|\'toddobaadka\' W \'ee\' MMMM|MMMMW-count-other|\'toddobaadka\' W \'ee\' MMMM|ms|mm:ss|y|y|yM|M/y|yMd|M/d/y|yMEd|E, M/d/y|yMMM|MMM y|yMMMd|MMM d, y|yMMMEd|E, MMM d, y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\'toddobaadka\' w \'ee\' Y|yw-count-other|\'toddobaadka\' w \'ee\' Y|ahmm|ahmmss|ahmmssz|ahmmsszzzz|X3W,|.|-||||||E2W,|.|-¤||¤||¤||E0W,|.|-|%||%||%|107|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|DBB|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|₱|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SOS|S|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XCG|Cg.|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$so = $enkidatron$elm_cldr$Generated$So$so;
var $enkidatron$elm_cldr$Generated$Sq$dayPeriods = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			'sq',
			_List_fromArray(
				[
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(12, 0),
					_Utils_Tuple2(18, 0),
					'afternoon1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(18, 0),
					_Utils_Tuple2(24, 0),
					'evening1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(0, 0),
					'midnight'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(4, 0),
					_Utils_Tuple2(9, 0),
					'morning1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(9, 0),
					_Utils_Tuple2(12, 0),
					'morning2'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(0, 0),
					_Utils_Tuple2(4, 0),
					'night1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(12, 0),
					'noon')
				]))
		]));
var $enkidatron$elm_cldr$Generated$Sq$sq = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Sq$dayPeriods, 'sq||||p.d.|m.d.|9|afternoon1|e pasdites|am|p.d.|evening1|e mbrëmjes|midnight|e mesnatës|morning1|e mëngjesit|morning2|e paradites|night1|e natës|noon|e mesditës|pm|m.d.|e paradites|e pasdites|9|afternoon1|e pasdites|am|e paradites|evening1|e mbrëmjes|midnight|e mesnatës|morning1|e mëngjesit|morning2|e paradites|night1|e natës|noon|e mesditës|pm|e pasdites|p.d.|m.d.|9|afternoon1|e pasdites|am|p.d.|evening1|e mbrëmjes|midnight|e mesnatës|morning1|e mëngjesit|morning2|e paradites|night1|e natës|noon|e mesditës|pm|m.d.|d.M.yy|d MMM y|d MMMM y|EEEE, d MMMM y|jan|shk|mar|pri|maj|qer|korr|gush|sht|tet|nën|dhj|janar|shkurt|mars|prill|maj|qershor|korrik|gusht|shtator|tetor|nëntor|dhjetor|j|sh|m|p|m|q|k|g|sh|t|n|dh|0|die|hën|mar|mër|enj|pre|sht|e diel|e hënë|e martë|e mërkurë|e enjte|e premte|e shtunë|d|h|m|m|e|p|sh|0|p.K.|mb.K.|para Krishtit|mbas Krishtit|p.K.|mb.K.|h:mm\u202Fa|h:mm:ss\u202Fa|h:mm:ss\u202Fa, z|h:mm:ss\u202Fa, zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|51|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E, d|Ehm|E, h:mm\u202Fa|EHm|E, HH:mm|Ehms|E, h:mm:ss\u202Fa|EHms|E, HH:mm:ss|Gy|y G|GyMd|d.M.y GGGG|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E, d MMM y G|h|h\u202Fa|H|HH|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa, v|Hmsv|HH:mm:ss, v|hmv|h:mm\u202Fa, v|Hmv|HH:mm, v|M|L|Md|d.M|MEd|E, d.M|MMdd|d.M|MMM|LLL|MMMd|d MMM|MMMEd|E, d MMM|MMMMd|d MMMM|MMMMEd|E, d MMMM|MMMMW-count-one|\'java\' W \'e\' \'muajit\' MMMM|MMMMW-count-other|\'java\' W \'e\' MMMM|ms|mm:ss|y|y|yM|M.y|yMd|d.M.y|yMEd|E, d.M.y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E, d MMM y|yMMMM|MMMM y|yQQQ|QQQ, y|yQQQQ|QQQQ, y|yw-count-one|\'java\' w \'e\' Y|yw-count-other|\'java\' w \'e\' Y|ahmm|ahmmss|ahmmssz|ahmmsszzzz|X3W\u00A0|,|-||||||E2W\u00A0|,|-|\u00A0¤||\u00A0¤||\u00A0¤|E0W\u00A0|,|-|%||%||%|107|AFN|AFN|ALL|Lekë|AMD|AMD|AOA|AOA|ARS|ARS|AUD|A$|AZN|AZN|BAM|BAM|BBD|BBD|BDT|BDT|BMD|BMD|BND|BND|BOB|BOB|BRL|BRL|BSD|BSD|BWP|BWP|BZD|BZD|CAD|CA$|CLP|CLP|CNY|CN¥|COP|COP|CRC|CRC|CUC|CUC|CUP|CUP|CZK|CZK|DKK|DKK|DOP|DOP|EGP|EGP|ESP|₧|EUR|€|FJD|FJD|FKP|FKP|GBP|£|GEL|GEL|GHS|GH₵|GIP|GIP|GNF|GNF|GTQ|GTQ|GYD|GYD|HKD|HK$|HNL|HNL|HRK|HRK|HUF|HUF|IDR|IDR|ILS|₪|INR|₹|ISK|ISK|JMD|JMD|JPY|JP¥|KGS|\u20C0|KHR|KHR|KMF|KMF|KPW|KPW|KRW|₩|KYD|KYD|KZT|KZT|LAK|LAK|LBP|LBP|LKR|LKR|LRD|LRD|LTL|Lt|LVL|Ls|MGA|MGA|MMK|MMK|MNT|MNT|MUR|MUR|MXN|MX$|MYR|MYR|NAD|NAD|NGN|NGN|NIO|NIO|NOK|NOK|NPR|NPR|NZD|NZ$|PHP|PHP|PKR|PKR|PLN|PLN|PYG|PYG|RON|RON|RUB|RUB|RWF|RWF|SBD|SBD|SEK|SEK|SGD|SGD|SHP|SHP|SRD|SRD|SSP|SSP|STN|STN|SYP|SYP|THB|฿|TOP|TOP|TRY|TRY|TTD|TTD|TWD|NT$|UAH|UAH|USD|US$|UYU|UYU|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XCG|Cg.|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|ZAR|ZMW|ZMW|'));
var $enkidatron$elm_cldr$Cldr$Locale$sq = $enkidatron$elm_cldr$Generated$Sq$sq;
var $enkidatron$elm_cldr$Generated$Sr$dayPeriods = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			'sr',
			_List_fromArray(
				[
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(12, 0),
					_Utils_Tuple2(18, 0),
					'afternoon1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(18, 0),
					_Utils_Tuple2(21, 0),
					'evening1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(0, 0),
					'midnight'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(6, 0),
					_Utils_Tuple2(12, 0),
					'morning1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(21, 0),
					_Utils_Tuple2(6, 0),
					'night1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(12, 0),
					'noon')
				]))
		]));
var $enkidatron$elm_cldr$Generated$Sr$sr = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Sr$dayPeriods, 'sr||||AM|PM|8|afternoon1|по подне|am|AM|evening1|увече|midnight|поноћ|morning1|ујутру|night1|ноћу|noon|подне|pm|PM|AM|PM|8|afternoon1|по подне|am|AM|evening1|увече|midnight|поноћ|morning1|ујутру|night1|ноћу|noon|подне|pm|PM|AM|PM|8|afternoon1|по подне|am|AM|evening1|увече|midnight|поноћ|morning1|ујутру|night1|ноћу|noon|подне|pm|PM|d. M. y.|d. M. y.|d. MMMM y.|EEEE, d. MMMM y.|јан|феб|мар|апр|мај|јун|јул|авг|сеп|окт|нов|дец|јануар|фебруар|март|април|мај|јун|јул|август|септембар|октобар|новембар|децембар|ј|ф|м|а|м|ј|ј|а|с|о|н|д|0|нед|пон|уто|сре|чет|пет|суб|недеља|понедељак|уторак|среда|четвртак|петак|субота|н|п|у|с|ч|п|с|0|п. н. е.|н. е.|пре нове ере|нове ере|п.н.е.|н.е.|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1} {0}|{1} {0}|{1} {0}|{1} {0}|56|Bh|h B|Bhm|hh:mm B|Bhms|hh:mm:ss B|d|d|E|E|EBhm|E h:mm B|EBhms|E, hh:mm:ss B|Ed|E d.|Ehm|E h:mm\u202Fa|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|EHms|E HH:mm:ss|Gy|y. G|GyMd|d.MM.y. GGGGG|GyMMM|MMM y. G|GyMMMd|d. MMM y. G|GyMMMEd|E, d. MMM y. G|h|h\u202Fa|H|HH|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|Hmv|HH:mm v|M|L|Md|d. M.|MEd|E, d. M.|MMdd|dd.MM.|MMM|LLL|MMMd|d. MMM|MMMdd|dd.MMM|MMMEd|E d. MMM|MMMMd|d. MMMM|MMMMEd|E, d. MMMM|MMMMW-count-one|MMMM: W. \'недеља\'|MMMMW-count-few|MMMM: W. \'недеља\'|MMMMW-count-other|MMMM: W. \'недеља\'|ms|mm:ss|y|y.|yM|M. y.|yMd|d. M. y.|yMEd|E, d. M. y.|yMM|MM.y.|yMMdd|dd.MM.y.|yMMM|MMM y.|yMMMd|d. MMM y.|yMMMEd|E, d. MMM y.|yMMMM|MMMM y.|yQQQ|QQQ y.|yQQQQ|QQQQ y.|yw-count-one|w. \'недеља\' \'у\' Y.|yw-count-few|w. \'недеља\' \'у\' Y.|yw-count-other|w. \'недеља\' \'у\' Y.|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W.|,|-||||||E2W.|,|-|\u00A0¤||\u00A0¤||\u00A0¤|E0W.|,|-|%||%||%|107|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|AUD|AZN|₼|BAM|КМ|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|ლ|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|KRW|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZD|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|VND|XAF|FCFA|XCD|EC$|XCG|Cg.|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$sr = $enkidatron$elm_cldr$Generated$Sr$sr;
var $enkidatron$elm_cldr$Generated$Sv$dayPeriods = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			'sv',
			_List_fromArray(
				[
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(12, 0),
					_Utils_Tuple2(18, 0),
					'afternoon1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(18, 0),
					_Utils_Tuple2(24, 0),
					'evening1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(0, 0),
					'midnight'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(5, 0),
					_Utils_Tuple2(10, 0),
					'morning1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(10, 0),
					_Utils_Tuple2(12, 0),
					'morning2'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(0, 0),
					_Utils_Tuple2(5, 0),
					'night1')
				]))
		]));
var $enkidatron$elm_cldr$Generated$Sv$sv = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Sv$dayPeriods, 'sv||||fm|em|8|afternoon1|på efterm.|am|fm|evening1|på kvällen|midnight|midnatt|morning1|på morg.|morning2|på förm.|night1|på natten|pm|em|fm|em|8|afternoon1|på eftermiddagen|am|fm|evening1|på kvällen|midnight|midnatt|morning1|på morgonen|morning2|på förmiddagen|night1|på natten|pm|em|fm|em|8|afternoon1|på efterm.|am|fm|evening1|på kvällen|midnight|midn.|morning1|på morg.|morning2|på förm.|night1|på natten|pm|em|y-MM-dd|d MMM y|d MMMM y|EEEE d MMMM y|jan.|feb.|mars|apr.|maj|juni|juli|aug.|sep.|okt.|nov.|dec.|januari|februari|mars|april|maj|juni|juli|augusti|september|oktober|november|december|J|F|M|A|M|J|J|A|S|O|N|D|0|sön|mån|tis|ons|tors|fre|lör|söndag|måndag|tisdag|onsdag|torsdag|fredag|lördag|S|M|T|O|T|F|L|0|f.Kr.|e.Kr.|före Kristus|efter Kristus|f.Kr.|e.Kr.|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1} {0}|{1} {0}|{1} {0}|{1} {0}|53|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E h:mm\u202Fa|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|EHms|E HH:mm:ss|Gy|y G|GyMd|y-MM-dd GGGGG|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E d MMM y G|h|h\u202Fa|H|HH|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|Hmv|HH:mm v|M|L|Md|d/M|MEd|E d/M|MMd|d/M|MMdd|dd/MM|MMM|LLL|MMMd|d MMM|MMMEd|E d MMM|MMMMd|d MMMM|MMMMEd|E d MMMM|MMMMW-count-one|\'vecka\' W \'i\' MMMM|MMMMW-count-other|\'vecka\' W \'i\' MMMM|ms|mm:ss|y|y|yM|y-MM|yMd|y-MM-dd|yMEd|E, y-MM-dd|yMM|y-MM|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\'vecka\' w, Y|yw-count-other|\'vecka\' w, Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W\u00A0|,|−||||||E2W\u00A0|,|−|\u00A0¤||\u00A0¤||\u00A0¤|E0W\u00A0|,|−|\u00A0%||\u00A0%||\u00A0%|109|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|AUD|AZN|₼|BAM|KM|BBD|Bds$|BDT|৳|BMD|BM$|BND|$|BOB|Bs|BRL|BR$|BSD|BS$|BWP|P|BYN|р.|BZD|BZ$|CAD|CA$|CLP|$|CNY|CNY|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|Dkr|DOP|RD$|EEK|Ekr|EGP|EG£|ESP|ESP|EUR|€|FJD|$|FKP|£|GBP|GBP|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HKD|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|IEP|IE£|ILS|₪|INR|INR|ISK|Ikr|JMD|JM$|JPY|JPY|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|KRW|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|Nkr|NPR|Rs|NZD|NZD|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|L|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|TWD|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|VND|XAF|FCFA|XCD|EC$|XCG|Cg.|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$sv = $enkidatron$elm_cldr$Generated$Sv$sv;
var $enkidatron$elm_cldr$Generated$Sw$dayPeriods = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			'sw',
			_List_fromArray(
				[
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(12, 0),
					_Utils_Tuple2(16, 0),
					'afternoon1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(16, 0),
					_Utils_Tuple2(19, 0),
					'evening1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(0, 0),
					'midnight'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(4, 0),
					_Utils_Tuple2(7, 0),
					'morning1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(7, 0),
					_Utils_Tuple2(12, 0),
					'morning2'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(19, 0),
					_Utils_Tuple2(4, 0),
					'night1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(12, 0),
					'noon')
				]))
		]));
var $enkidatron$elm_cldr$Generated$Sw$sw = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Sw$dayPeriods, 'sw||||AM|PM|9|afternoon1|mchana|am|AM|evening1|jioni|midnight|saa sita za usiku|morning1|alfajiri|morning2|asubuhi|night1|usiku|noon|adhuhuri|pm|PM|AM|PM|9|afternoon1|mchana|am|AM|evening1|jioni|midnight|saa sita za usiku|morning1|alfajiri|morning2|asubuhi|night1|usiku|noon|saa sita za mchana|pm|PM|am|pm|9|afternoon1|mchana|am|am|evening1|jioni|midnight|usiku|morning1|alfajiri|morning2|asubuhi|night1|usiku|noon|mchana|pm|pm|dd/MM/y|d MMM y|d MMMM y|EEEE, d MMMM y|Jan|Feb|Mac|Apr|Mei|Jun|Jul|Ago|Sep|Okt|Nov|Des|Januari|Februari|Machi|Aprili|Mei|Juni|Julai|Agosti|Septemba|Oktoba|Novemba|Desemba|J|F|M|A|M|J|J|A|S|O|N|D|0|Jumapili|Jumatatu|Jumanne|Jumatano|Alhamisi|Ijumaa|Jumamosi|Jumapili|Jumatatu|Jumanne|Jumatano|Alhamisi|Ijumaa|Jumamosi|S|M|T|W|T|F|S|0|KK|BK|Kabla ya Kristo|Baada ya Kristo|KK|BK|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1} {0}|{1} {0}|{1} {0}|{1} {0}|50|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E h:mm\u202Fa|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|EHms|E HH:mm:ss|Gy|y G|GyMd|d/M/y GGGGG|GyMMM|MMM y G|GyMMMd|d MMM y G|GyMMMEd|E, d MMM y G|h|h\u202Fa|H|HH|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|Hmv|HH:mm v|M|L|Md|d/M|MEd|E, d/M|MMM|LLL|MMMd|d MMM|MMMEd|E, d MMM|MMMMd|d MMMM|MMMMEd|E, d MMMM|MMMMW-count-one|\'wiki\' W \'ya\' MMMM|MMMMW-count-other|\'wiki\' W \'ya\' MMMM|ms|mm:ss|y|y|yM|M/y|yMd|d/M/y|yMEd|E, d/M/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E, d MMM y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|\'wiki\' w \'ya\' Y|yw-count-other|\'wiki\' w \'ya\' Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W,|.|-||||||E2W,|.|-¤\u00A0||¤\u00A0||¤\u00A0||E0W,|.|-|%||%||%|109|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KES|Ksh|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|TZS|TSh|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XCG|Cg.|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$sw = $enkidatron$elm_cldr$Generated$Sw$sw;
var $enkidatron$elm_cldr$Generated$Ta$dayPeriods = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			'ta',
			_List_fromArray(
				[
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(12, 0),
					_Utils_Tuple2(14, 0),
					'afternoon1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(14, 0),
					_Utils_Tuple2(16, 0),
					'afternoon2'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(16, 0),
					_Utils_Tuple2(18, 0),
					'evening1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(18, 0),
					_Utils_Tuple2(21, 0),
					'evening2'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(0, 0),
					'midnight'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(3, 0),
					_Utils_Tuple2(5, 0),
					'morning1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(5, 0),
					_Utils_Tuple2(12, 0),
					'morning2'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(21, 0),
					_Utils_Tuple2(3, 0),
					'night1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(12, 0),
					'noon')
				]))
		]));
var $enkidatron$elm_cldr$Generated$Ta$ta = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Ta$dayPeriods, 'ta||||AM|PM|11|afternoon1|மதியம்|afternoon2|பிற்பகல்|am|AM|evening1|மாலை|evening2|அந்தி மாலை|midnight|நள்ளிரவு|morning1|அதிகாலை|morning2|காலை|night1|இரவு|noon|நண்பகல்|pm|PM|AM|PM|11|afternoon1|மதியம்|afternoon2|பிற்பகல்|am|AM|evening1|மாலை|evening2|அந்தி மாலை|midnight|நள்ளிரவு|morning1|அதிகாலை|morning2|காலை|night1|இரவு|noon|நண்பகல்|pm|PM|AM|PM|11|afternoon1|மதி.|afternoon2|பிற்.|am|AM|evening1|மா.|evening2|அந்தி மா.|midnight|நள்.|morning1|அதி.|morning2|கா.|night1|இர.|noon|நண்.|pm|PM|d/M/yy|d MMM, y|d MMMM, y|EEEE, d MMMM, y|ஜன.|பிப்.|மார்.|ஏப்.|மே|ஜூன்|ஜூலை|ஆக.|செப்.|அக்.|நவ.|டிச.|ஜனவரி|பிப்ரவரி|மார்ச்|ஏப்ரல்|மே|ஜூன்|ஜூலை|ஆகஸ்ட்|செப்டம்பர்|அக்டோபர்|நவம்பர்|டிசம்பர்|ஜ|பி|மா|ஏ|மே|ஜூ|ஜூ|ஆ|செ|அ|ந|டி|0|ஞாயி.|திங்.|செவ்.|புத.|வியா.|வெள்.|சனி|ஞாயிறு|திங்கள்|செவ்வாய்|புதன்|வியாழன்|வெள்ளி|சனி|ஞா|தி|செ|பு|வி|வெ|ச|0|கி.மு.|கி.பி.|கிறிஸ்துவுக்கு முன்|அன்னோ டோமினி|கி.மு.|கி.பி.|h:mm a|h:mm:ss a|h:mm:ss a z|h:mm:ss a zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|51|Bh|B h|Bhm|B h:mm|Bhms|B h:mm:ss|d|d|E|ccc|EBhm|E B h:mm|EBhms|E B h:mm:ss|Ed|d E|Ehm|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss a|EHms|E HH:mm:ss|Gy|G y|GyMd|d/M/y G|GyMMM|G y MMM|GyMMMd|G y MMM d|GyMMMEd|G y MMM d, E|h|h\u202Fa|H|HH|hm|h:mm a|Hm|HH:mm|hms|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm a v|Hmv|HH:mm v|M|L|Md|d/M|MEd|dd-MM, E|MMdd|dd-MM|MMM|LLL|MMMd|d MMM|MMMEd|MMM d, E|MMMMd|d MMMM|MMMMW-count-one|MMMM W -ஆம் வாரம்|MMMMW-count-other|MMMM W -ஆம் வாரம்|ms|mm:ss|y|y|yM|M/y|yMd|d/M/y|yMEd|E, d/M/y|yMM|MM-y|yMMM|MMM y|yMMMd|d MMM, y|yMMMEd|E, d MMM, y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|Y ஆம் ஆண்டின் w -ஆம் வாரம்|yw-count-other|Y ஆம் ஆண்டின் w -ஆம் வாரம்|ahmm|ahmmss|ahmmssz|ahmmsszzzz|X3I,|.|-||||||E2I,|.|-¤||¤||¤||E0I,|.|-|%||%||%|107|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XCG|Cg.|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$ta = $enkidatron$elm_cldr$Generated$Ta$ta;
var $enkidatron$elm_cldr$Generated$Te$dayPeriods = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			'te',
			_List_fromArray(
				[
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(12, 0),
					_Utils_Tuple2(18, 0),
					'afternoon1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(18, 0),
					_Utils_Tuple2(21, 0),
					'evening1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(0, 0),
					'midnight'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(6, 0),
					_Utils_Tuple2(12, 0),
					'morning1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(21, 0),
					_Utils_Tuple2(6, 0),
					'night1')
				]))
		]));
var $enkidatron$elm_cldr$Generated$Te$te = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Te$dayPeriods, 'te||||AM|PM|7|afternoon1|మధ్యాహ్నం|am|AM|evening1|సాయంత్రం|midnight|అర్ధరాత్రి|morning1|ఉదయం|night1|రాత్రి|pm|PM|AM|PM|7|afternoon1|మధ్యాహ్నం|am|AM|evening1|సాయంత్రం|midnight|అర్ధరాత్రి|morning1|ఉదయం|night1|రాత్రి|pm|PM|ఉ|సా|7|afternoon1|మధ్యాహ్నం|am|ఉ|evening1|సాయంత్రం|midnight|అర్ధరాత్రి|morning1|ఉదయం|night1|రాత్రి|pm|సా|dd-MM-yy|d MMM, y|d MMMM, y|d, MMMM y, EEEE|జన|ఫిబ్ర|మార్చి|ఏప్రి|మే|జూన్|జులై|ఆగ|సెప్టెం|అక్టో|నవం|డిసెం|జనవరి|ఫిబ్రవరి|మార్చి|ఏప్రిల్|మే|జూన్|జులై|ఆగస్టు|సెప్టెంబర్|అక్టోబర్|నవంబర్|డిసెంబర్|జ|ఫి|మా|ఏ|మే|జూ|జు|ఆ|సె|అ|న|డి|0|ఆది|సోమ|మంగళ|బుధ|గురు|శుక్ర|శని|ఆదివారం|సోమవారం|మంగళవారం|బుధవారం|గురువారం|శుక్రవారం|శనివారం|ఆ|సో|మ|బు|గు|శు|శ|0|క్రీపూ|క్రీశ|క్రీస్తు పూర్వం|క్రీస్తు శకం|క్రీపూ|క్రీశ|h:mm a|h:mm:ss a|h:mm:ss a z|h:mm:ss a zzzz|{1} {0}|{1} {0}|{1} {0}|{1} {0}|51|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|d, E|Ehm|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss a|EHms|E HH:mm:ss|Gy|G y|GyMd|GGGGG y-MM-dd|GyMMM|G MMM y|GyMMMd|G d, MMM y|GyMMMEd|G, d MMM, y, E|h|h\u202Fa|H|HH|hm|h:mm a|Hm|HH:mm|hms|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm a v|Hmv|HH:mm v|M|L|Md|d/M|MEd|d/M, E|MMdd|dd-MM|MMM|LLL|MMMd|d MMM|MMMEd|d MMM, E|MMMMd|d MMMM|MMMMW-count-one|MMMMలో Wవ వారం|MMMMW-count-other|MMMMలో Wవ వారం|ms|mm:ss|y|y|yM|M/y|yMd|d/M/y|yMEd|d/M/y, E|yMM|MM-y|yMMM|MMM y|yMMMd|d, MMM y|yMMMEd|d MMM, y, E|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|Yలో wవ వారం|yw-count-other|Yలో wవ వారం|ahmm|ahmmss|ahmmssz|ahmmsszzzz|X3I,|.|-||||||E2I,|.|-¤||¤||¤||E0W,|.|-|%||%||%|107|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XCG|Cg.|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$te = $enkidatron$elm_cldr$Generated$Te$te;
var $enkidatron$elm_cldr$Generated$Th$dayPeriods = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			'th',
			_List_fromArray(
				[
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(12, 0),
					_Utils_Tuple2(13, 0),
					'afternoon1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(13, 0),
					_Utils_Tuple2(16, 0),
					'afternoon2'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(16, 0),
					_Utils_Tuple2(18, 0),
					'evening1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(18, 0),
					_Utils_Tuple2(21, 0),
					'evening2'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(0, 0),
					'midnight'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(6, 0),
					_Utils_Tuple2(12, 0),
					'morning1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(21, 0),
					_Utils_Tuple2(6, 0),
					'night1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(12, 0),
					'noon')
				]))
		]));
var $enkidatron$elm_cldr$Generated$Th$th = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Th$dayPeriods, 'th||||AM|PM|10|afternoon1|ในตอนบ่าย|afternoon2|บ่าย|am|AM|evening1|ในตอนเย็น|evening2|ค่ำ|midnight|เที่ยงคืน|morning1|ในตอนเช้า|night1|กลางคืน|noon|เที่ยง|pm|PM|ก่อนเที่ยง|หลังเที่ยง|10|afternoon1|ในตอนบ่าย|afternoon2|บ่าย|am|ก่อนเที่ยง|evening1|ในตอนเย็น|evening2|ค่ำ|midnight|เที่ยงคืน|morning1|ในตอนเช้า|night1|กลางคืน|noon|เที่ยง|pm|หลังเที่ยง|a|p|10|afternoon1|เที่ยง|afternoon2|บ่าย|am|a|evening1|เย็น|evening2|ค่ำ|midnight|เที่ยงคืน|morning1|เช้า|night1|กลางคืน|noon|เที่ยง|pm|p|d/M/yy|d MMM y|d MMMM G y|EEEEที่ d MMMM G y|ม.ค.|ก.พ.|มี.ค.|เม.ย.|พ.ค.|มิ.ย.|ก.ค.|ส.ค.|ก.ย.|ต.ค.|พ.ย.|ธ.ค.|มกราคม|กุมภาพันธ์|มีนาคม|เมษายน|พฤษภาคม|มิถุนายน|กรกฎาคม|สิงหาคม|กันยายน|ตุลาคม|พฤศจิกายน|ธันวาคม|ม.ค.|ก.พ.|มี.ค.|เม.ย.|พ.ค.|มิ.ย.|ก.ค.|ส.ค.|ก.ย.|ต.ค.|พ.ย.|ธ.ค.|0|อา.|จ.|อ.|พ.|พฤ.|ศ.|ส.|วันอาทิตย์|วันจันทร์|วันอังคาร|วันพุธ|วันพฤหัสบดี|วันศุกร์|วันเสาร์|อา|จ|อ|พ|พฤ|ศ|ส|0|ก่อน ค.ศ.|ค.ศ.|ปีก่อนคริสตกาล|คริสต์ศักราช|ก่อน ค.ศ.|ค.ศ.|HH:mm|HH:mm:ss|H นาฬิกา mm นาที ss วินาที z|H นาฬิกา mm นาที ss วินาที zzzz|{1} {0}|{1} {0}|{1} {0}|{1} {0}|56|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E d|Ehm|E h:mm a|EHm|E HH:mm น.|Ehms|E h:mm:ss a|EHms|E HH:mm:ss|Gy|G y|GyMd|d/M/GGGGG y|GyMMM|MMM G y|GyMMMd|d MMM G y|GyMMMEd|E d MMM G y|GyMMMEEEEd|EEEEที่ d MMM G y|h|h\u202Fa|H|HH|hm|h:mm a|Hm|HH:mm น.|hms|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm น. a v|Hmv|HH:mm v|M|L|Md|d/M|MEd|E d/M|MMM|LLL|MMMd|d MMM|MMMEd|E d MMM|MMMEEEEd|EEEEที่ d MMM|MMMMd|d MMMM|MMMMEd|E d MMMM|MMMMEEEEd|EEEEที่ d MMMM|MMMMW-count-other|สัปดาห์ที่ W ของเดือนMMMM|mmss|mm:ss|ms|mm:ss|y|y|yM|M/y|yMd|d/M/y|yMEd|E d/M/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E d MMM y|yMMMEEEEd|EEEEที่ d MMM y|yMMMM|MMMM y|yMMMMd|d MMMM y|yMMMMEd|E d MMMM y|yMMMMEEEEd|EEEEที่ d MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ G y|yw-count-other|สัปดาห์ที่ w ของปี Y|HHmm|HHmmss|Hmmssz|Hmmsszzzz|X3W,|.|-||||||E2W,|.|-¤||¤||¤||E0W,|.|-|%||%||%|107|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|AU$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XCG|Cg.|XOF|F\u202FCFA|XPF|CFPF|XXX|XXX|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$th = $enkidatron$elm_cldr$Generated$Th$th;
var $enkidatron$elm_cldr$Generated$Ti$dayPeriods = $elm$core$Dict$fromList(_List_Nil);
var $enkidatron$elm_cldr$Generated$Ti$ti = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Ti$dayPeriods, 'ti||||ቅ.ቀ.|ድ.ቀ.|2|am|ቅ.ቀ.|pm|ድ.ቀ.|ቅ.ቀ.|ድ.ቀ.|2|am|ቅ.ቀ.|pm|ድ.ቀ.|ቅ.ቀ.|ድ.ቀ.|2|am|ቅ.ቀ.|pm|ድ.ቀ.|M/d/yy|MMM d, y|MMMM d, y|EEEE፣ d MMMM y|ጥሪ|ለካ|መጋ|ሚያ|ግን|ሰነ|ሓም|ነሓ|መስ|ጥቅ|ሕዳ|ታሕ|ጥሪ|ለካቲት|መጋቢት|ሚያዝያ|ጉንበት|ሰነ|ሓምለ|ነሓሰ|መስከረም|ጥቅምቲ|ሕዳር|ታሕሳስ|ጥ|ለ|መ|ሚ|ግ|ሰ|ሓ|ነ|መ|ጥ|ሕ|ታ|0|ሰን|ሰኑ|ሰሉ|ረቡ|ሓሙ|ዓር|ቀዳ|ሰንበት|ሰኑይ|ሰሉስ|ረቡዕ|ሓሙስ|ዓርቢ|ቀዳም|ሰ|ሰ|ሰ|ረ|ሓ|ዓ|ቀ|0|ዓ/ዓ|ዓ/ም|ቅድመ ክርስቶስ|ዓመተ ምሕረት|ዓ/ዓ|ዓ/ም|h:mm a|h:mm:ss a|h:mm:ss a z|h:mm:ss a zzzz|{1} {0}|{1} {0}|{1} {0}|{1} {0}|52|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|d E|Ehm|E፣ h:mm a|EHm|E፣ HH:mm|Ehms|E፣ h:mm:ss a|EHms|E፣ HH:mm:ss|Gy|y G|GyMd|M/d/y G|GyMMM|MMM y G|GyMMMd|MMM d, y G|GyMMMEd|E፣ d MMM y G|h|h\u202Fa|H|HH|hm|h:mm a|Hm|HH:mm|hms|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm a v|Hmv|HH:mm v|M|L|Md|d/M|MEd|E፣ d/M|MMdd|d/M|MMM|LLL|MMMd|d MMM|MMMEd|E፣ d MMM|MMMMd|d MMMM|MMMMdd|d MMMM|MMMMW-count-one|ሰሙን W ናይ MMMM|MMMMW-count-other|ሰሙን W ናይ MMMM|ms|mm:ss|y|y|yM|M/y|yMd|M/d/y|yMEd|E፣ d/M/y|yMM|M/y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E, MMM d, y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|ሰሙን w ናይ Y|yw-count-other|ሰሙን w ናይ Y|ahmm|ahmmss|ahmmssz|ahmmsszzzz|X3W,|.|-||||||E2W,|.|-¤||¤||¤||E0W,|.|-|%||%||%|107|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BZD|$|CAD|CA$|CLP|$|CNY|CNY|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|ETB|Br|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JPY|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|₱|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XCG|Cg.|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$ti = $enkidatron$elm_cldr$Generated$Ti$ti;
var $enkidatron$elm_cldr$Generated$Tk$dayPeriods = $elm$core$Dict$fromList(_List_Nil);
var $enkidatron$elm_cldr$Generated$Tk$tk = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Tk$dayPeriods, 'tk||||go.öň|go.soň|2|am|go.öň|pm|go.soň|günortadan öň|günortadan soň|2|am|günortadan öň|pm|günortadan soň|öň|soň|2|am|öň|pm|soň|dd.MM.y|d MMM y|d MMMM y|d MMMM y EEEE|ýan|few|mart|apr|maý|iýun|iýul|awg|sen|okt|noý|dek|ýanwar|fewral|mart|aprel|maý|iýun|iýul|awgust|sentýabr|oktýabr|noýabr|dekabr|Ý|F|M|A|M|I|I|A|S|O|N|D|1|Ýan|Few|Mar|Apr|Maý|Iýun|Iýul|Awg|Sen|Okt|Noý|Dek|Ýanwar|Fewral|Mart|Aprel|Maý|Iýun|Iýul|Awgust|Sentýabr|Oktýabr|Noýabr|Dekabr|Ý|F|M|A|M|I|I|A|S|O|N|D|ýek|duş|siş|çar|pen|ann|şen|ýekşenbe|duşenbe|sişenbe|çarşenbe|penşenbe|anna|şenbe|Ý|D|S|Ç|P|A|Ş|1|Ýek|Duş|Siş|Çar|Pen|Ann|Şen|Ýekşenbe|Duşenbe|Sişenbe|Çarşenbe|Penşenbe|Anna|Şenbe|Ý|D|S|Ç|P|A|Ş|B.e.öň|B.e.|Isadan öň|Isadan soň|B.e.öň|B.e.|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1} {0}|{1} {0}|{1} {0}|{1} {0}|51|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|d E|Ehm|E h:mm\u202Fa|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|EHms|E HH:mm:ss|Gy|G y|GyMd|GGGGG dd.MM.y|GyMMM|G MMM y|GyMMMd|G d MMM y|GyMMMEd|G d MMM y, E|h|h\u202Fa|H|HH|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|Hmv|HH:mm v|M|L|Md|dd.MM|MEd|dd.MM E|MMM|LLL|MMMd|d MMM|MMMEd|d MMM E|MMMMd|d MMMM|MMMMEd|d MMMM E|MMMMW-count-one|\'hepde\' W, MMMM|MMMMW-count-other|\'hepde\' W, MMMM|mmss|mm:ss|ms|mm:ss|y|y|yM|MM.y|yMd|dd.MM.y|yMEd|dd.MM.y E|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|d MMM y E|yMMMM|MMMM y|yQQQ|y QQQ|yQQQQ|y QQQQ|yw-count-one|\'hepde\' w, Y|yw-count-other|\'hepde\' w, Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W\u00A0|,|-||||||E2W\u00A0|,|-|\u00A0¤||\u00A0¤||\u00A0¤|E0W\u00A0|,|-|\u00A0%||\u00A0%||\u00A0%|107|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|EUR|FJD|$|FKP|£|GBP|GBP|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XCG|Cg.|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$tk = $enkidatron$elm_cldr$Generated$Tk$tk;
var $enkidatron$elm_cldr$Generated$Tr$dayPeriods = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			'tr',
			_List_fromArray(
				[
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(12, 0),
					_Utils_Tuple2(18, 0),
					'afternoon1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(18, 0),
					_Utils_Tuple2(19, 0),
					'afternoon2'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(19, 0),
					_Utils_Tuple2(21, 0),
					'evening1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(0, 0),
					'midnight'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(6, 0),
					_Utils_Tuple2(11, 0),
					'morning1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(11, 0),
					_Utils_Tuple2(12, 0),
					'morning2'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(21, 0),
					_Utils_Tuple2(6, 0),
					'night1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(12, 0),
					'noon')
				]))
		]));
var $enkidatron$elm_cldr$Generated$Tr$tr = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Tr$dayPeriods, 'tr||||ÖÖ|ÖS|10|afternoon1|öğleden sonra|afternoon2|akşamüstü|am|ÖÖ|evening1|akşam|midnight|gece yarısı|morning1|sabah|morning2|öğleden önce|night1|gece|noon|öğle|pm|ÖS|ÖÖ|ÖS|10|afternoon1|öğleden sonra|afternoon2|akşamüstü|am|ÖÖ|evening1|akşam|midnight|gece yarısı|morning1|sabah|morning2|öğleden önce|night1|gece|noon|öğle|pm|ÖS|öö|ös|10|afternoon1|öğleden sonra|afternoon2|akşamüstü|am|öö|evening1|akşam|midnight|gece|morning1|sabah|morning2|öğleden önce|night1|gece|noon|ö|pm|ös|d.MM.y|d MMM y|d MMMM y|d MMMM y EEEE|Oca|Şub|Mar|Nis|May|Haz|Tem|Ağu|Eyl|Eki|Kas|Ara|Ocak|Şubat|Mart|Nisan|Mayıs|Haziran|Temmuz|Ağustos|Eylül|Ekim|Kasım|Aralık|O|Ş|M|N|M|H|T|A|E|E|K|A|0|Paz|Pzt|Sal|Çar|Per|Cum|Cmt|Pazar|Pazartesi|Salı|Çarşamba|Perşembe|Cuma|Cumartesi|P|P|S|Ç|P|C|C|0|MÖ|MS|Milattan Önce|Milattan Sonra|MÖ|MS|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1} {0}|{1} {0}|{1} {0}|{1} {0}|52|Bh|B h|Bhm|B h:mm|Bhms|B h:mm:ss|d|d|E|ccc|EBhm|E B h:mm|EBhms|E B h:mm:ss|Ed|d E|Ehm|E a\u202Fh:mm|EHm|E HH:mm|Ehms|E a\u202Fh:mm:ss|EHms|E HH:mm:ss|Gy|G y|GyMd|GGGGG dd.MM.y|GyMMM|G MMM y|GyMMMd|G d MMM y|GyMMMEd|G d MMM y E|h|a\u202Fh|H|HH|hm|a\u202Fh:mm|Hm|HH:mm|hms|a\u202Fh:mm:ss|Hms|HH:mm:ss|hmsv|a\u202Fh:mm:ss v|Hmsv|HH:mm:ss v|hmv|a\u202Fh:mm v|Hmv|HH:mm v|M|L|Md|d/M|MEd|d/MM E|MMM|LLL|MMMd|d MMM|MMMEd|d MMM E|MMMMd|d MMMM|MMMMEd|d MMMM E|MMMMW-count-one|MMMM \'ayının\' W. \'haftası\'|MMMMW-count-other|MMMM \'ayının\' W. \'haftası\'|mmss|mm:ss|ms|mm:ss|y|y|yM|MM/y|yMd|dd.MM.y|yMEd|d.M.y E|yMM|MM.y|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|d MMM y E|yMMMM|MMMM y|yQQQ|y QQQ|yQQQQ|y QQQQ|yw-count-one|Y \'yılının\' w. \'haftası\'|yw-count-other|Y \'yılının\' w. \'haftası\'|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W.|,|-||||||E2W.|,|-¤||¤||¤||E0W.|,|-%||%||%||108|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|AU$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|L|RUB|₽|RUR|р.|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XCG|Cg.|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$tr = $enkidatron$elm_cldr$Generated$Tr$tr;
var $enkidatron$elm_cldr$Generated$Uk$dayPeriods = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			'uk',
			_List_fromArray(
				[
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(12, 0),
					_Utils_Tuple2(18, 0),
					'afternoon1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(18, 0),
					_Utils_Tuple2(24, 0),
					'evening1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(0, 0),
					'midnight'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(4, 0),
					_Utils_Tuple2(12, 0),
					'morning1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(0, 0),
					_Utils_Tuple2(4, 0),
					'night1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(12, 0),
					'noon')
				]))
		]));
var $enkidatron$elm_cldr$Generated$Uk$uk = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Uk$dayPeriods, 'uk||||дп|пп|8|afternoon1|дня|am|дп|evening1|вечора|midnight|ночі|morning1|ранку|night1|ночі|noon|дня|pm|пп|дп|пп|8|afternoon1|дня|am|дп|evening1|вечора|midnight|ночі|morning1|ранку|night1|ночі|noon|дня|pm|пп|дп|пп|8|afternoon1|дня|am|дп|evening1|вечора|midnight|ночі|morning1|ранку|night1|ночі|noon|дня|pm|пп|dd.MM.yy|d MMM y\u202F\'р\'.|d MMMM y\u202F\'р\'.|EEEE, d MMMM y\u202F\'р\'.|січ.|лют.|бер.|квіт.|трав.|черв.|лип.|серп.|вер.|жовт.|лист.|груд.|січня|лютого|березня|квітня|травня|червня|липня|серпня|вересня|жовтня|листопада|грудня|с|л|б|к|т|ч|л|с|в|ж|л|г|1|січ.|лют.|бер.|квіт.|трав.|черв.|лип.|серп.|вер.|жовт.|лист.|груд.|січень|лютий|березень|квітень|травень|червень|липень|серпень|вересень|жовтень|листопад|грудень|С|Л|Б|К|Т|Ч|Л|С|В|Ж|Л|Г|нд|пн|вт|ср|чт|пт|сб|неділя|понеділок|вівторок|середа|четвер|пʼятниця|субота|Н|П|В|С|Ч|П|С|0|до н. е.|н. е.|до нашої ери|нашої ери|до н.е.|н.е.|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|54|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E, d|Ehm|E h:mm\u202Fa|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|EHms|E HH:mm:ss|Gy|y G|GyMd|dd-MM-y GGGGG|GyMMM|LLL y\u202F\'р\'. G|GyMMMd|d MMM y\u202F\'р\'. G|GyMMMEd|E, d MMM y\u202F\'р\'. G|h|h\u202Fa|H|HH|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|Hmv|HH:mm v|M|LL|Md|dd.MM|MEd|E, dd.MM|MMM|LLL|MMMd|d MMM|MMMEd|E, d MMM|MMMMd|d MMMM|MMMMEd|E, d MMMM|MMMMW-count-one|W-\'й\' \'тиж\'. MMMM|MMMMW-count-few|W-\'й\' \'тиж\'. MMMM|MMMMW-count-many|W-\'й\' \'тиж\'. MMMM|MMMMW-count-other|W-\'й\' \'тиж\'. MMMM|ms|mm:ss|y|y|yM|MM.y|yMd|dd.MM.y|yMEd|E, dd.MM.y|yMMM|LLL y\u202F\'р\'.|yMMMd|d MMM y\u202F\'р\'.|yMMMEd|E, d MMM y\u202F\'р\'.|yMMMM|LLLL y\u202F\'р\'.|yQQQ|QQQ y|yQQQQ|QQQQ y\u202F\'р\'.|yw-count-one|w-\'й\' \'тиж\'. Y \'р\'.|yw-count-few|w-\'й\' \'тиж\'. Y \'р\'.|yw-count-many|w-\'й\' \'тиж\'. Y \'р\'.|yw-count-other|w-\'й\' \'тиж\'. Y \'р\'.|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W\u00A0|,|-||||||E2W\u00A0|,|-|\u00A0¤||\u00A0¤||\u00A0¤|E0W\u00A0|,|-|%||%||%|109|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|AUD|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|BRL|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CAD|CLP|$|CNY|CNY|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|EUR|FJD|$|FKP|£|GBP|GBP|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HKD|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|ILS|INR|INR|ISK|kr|JMD|$|JPY|¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|KRW|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MXN|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZD|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RUR|р.|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|TWD|UAH|₴|UAK|крб.|USD|USD|UYU|$|VEF|Bs|VND|VND|XAF|FCFA|XCD|XCD|XCG|Cg.|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$uk = $enkidatron$elm_cldr$Generated$Uk$uk;
var $enkidatron$elm_cldr$Generated$Ur$dayPeriods = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			'ur',
			_List_fromArray(
				[
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(12, 0),
					_Utils_Tuple2(16, 0),
					'afternoon1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(16, 0),
					_Utils_Tuple2(18, 0),
					'afternoon2'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(18, 0),
					_Utils_Tuple2(20, 0),
					'evening1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(0, 0),
					'midnight'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(4, 0),
					_Utils_Tuple2(12, 0),
					'morning1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(20, 0),
					_Utils_Tuple2(4, 0),
					'night1')
				]))
		]));
var $enkidatron$elm_cldr$Generated$Ur$ur = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Ur$dayPeriods, 'ur||||AM|PM|8|afternoon1|دوپہر|afternoon2|سہ پہر|am|AM|evening1|شام|midnight|آدھی رات|morning1|صبح|night1|رات|pm|PM|AM|PM|8|afternoon1|دوپہر میں|afternoon2|سہ پہر|am|AM|evening1|شام میں|midnight|آدھی رات|morning1|صبح میں|night1|رات میں|pm|PM|a|p|8|afternoon1|دوپہر|afternoon2|سہ پہر|am|a|evening1|شام|midnight|آدھی رات|morning1|صبح|night1|رات|pm|p|d/M/yy|d MMM، y|d MMMM، y|EEEE، d MMMM، y|جنوری|فروری|مارچ|اپریل|مئی|جون|جولائی|اگست|ستمبر|اکتوبر|نومبر|دسمبر|جنوری|فروری|مارچ|اپریل|مئی|جون|جولائی|اگست|ستمبر|اکتوبر|نومبر|دسمبر|J|F|M|A|M|J|J|A|S|O|N|D|0|اتوار|پیر|منگل|بدھ|جمعرات|جمعہ|ہفتہ|اتوار|پیر|منگل|بدھ|جمعرات|جمعہ|ہفتہ|S|M|T|W|T|F|S|0|قبل مسیح|عیسوی|قبل مسیح|عیسوی|قبل مسیح|عیسوی|h:mm a|h:mm:ss a|h:mm:ss a z|h:mm:ss a zzzz|{1} {0}|{1} {0}|{1} {0}|{1} {0}|49|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|d E|Ehm|E h:mm a|EHm|E HH:mm|Ehms|E h:mm:ss a|EHms|E HH:mm:ss|Gy|y G|GyMd|d/M/y GGGGG|GyMMM|MMM y G|GyMMMd|d MMM، y G|GyMMMEd|E، d MMM، y G|h|h\u202Fa|H|HH|hm|h:mm a|Hm|HH:mm|hms|h:mm:ss a|Hms|HH:mm:ss|hmsv|h:mm:ss a v|Hmsv|HH:mm:ss v|hmv|h:mm a v|Hmv|HH:mm v|M|L|Md|d/M|MEd|E، d/M|MMM|LLL|MMMd|d MMM|MMMEd|E، d MMM|MMMMd|d MMMM|MMMMW-count-one|MMMM کا ہفتہ W|MMMMW-count-other|MMMM کا ہفتہ W|ms|mm:ss|y|y|yM|M/y|yMd|d/M/y|yMEd|E، d/M/y|yMMM|MMM y|yMMMd|d MMM، y|yMMMEd|E، d MMM، y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-one|Y کا w ہفتہ|yw-count-other|Y کا w ہفتہ|ahmm|ahmmss|ahmmssz|ahmmsszzzz|X3W,|.|\u200E-||||||E2W,|.|\u200E-¤||¤||¤||E0W,|.|\u200E-|%||%||%|107|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XCG|Cg.|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$ur = $enkidatron$elm_cldr$Generated$Ur$ur;
var $enkidatron$elm_cldr$Generated$Uz$dayPeriods = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			'uz',
			_List_fromArray(
				[
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(11, 0),
					_Utils_Tuple2(18, 0),
					'afternoon1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(18, 0),
					_Utils_Tuple2(22, 0),
					'evening1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(0, 0),
					'midnight'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(6, 0),
					_Utils_Tuple2(11, 0),
					'morning1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(22, 0),
					_Utils_Tuple2(6, 0),
					'night1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(12, 0),
					'noon')
				]))
		]));
var $enkidatron$elm_cldr$Generated$Uz$uz = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Uz$dayPeriods, 'uz||||TO|TK|8|afternoon1|kunduzi|am|TO|evening1|kechqurun|midnight|yarim tun|morning1|ertalab|night1|kechasi|noon|tush payti|pm|TK|TO|TK|8|afternoon1|kunduzi|am|TO|evening1|kechqurun|midnight|yarim tun|morning1|ertalab|night1|kechasi|noon|tush payti|pm|TK|TO|TK|8|afternoon1|kunduzi|am|TO|evening1|kechqurun|midnight|yarim tun|morning1|ertalab|night1|kechasi|noon|tush payti|pm|TK|dd/MM/yy|d-MMM, y|d-MMMM, y|EEEE, d-MMMM, y|yan|fev|mar|apr|may|iyn|iyl|avg|sen|okt|noy|dek|yanvar|fevral|mart|aprel|may|iyun|iyul|avgust|sentabr|oktabr|noyabr|dekabr|Y|F|M|A|M|I|I|A|S|O|N|D|1|Yan|Fev|Mar|Apr|May|Iyn|Iyl|Avg|Sen|Okt|Noy|Dek|Yanvar|Fevral|Mart|Aprel|May|Iyun|Iyul|Avgust|Sentabr|Oktabr|Noyabr|Dekabr|Y|F|M|A|M|I|I|A|S|O|N|D|Yak|Dush|Sesh|Chor|Pay|Jum|Shan|yakshanba|dushanba|seshanba|chorshanba|payshanba|juma|shanba|Y|D|S|C|P|J|S|0|m.a.|milodiy|miloddan avvalgi|milodiy|m.a.|milodiy|HH:mm|HH:mm:ss|H:mm:ss (z)|H:mm:ss (zzzz)|{1}, {0}|{1}, {0}|{1}, {0}|{1}, {0}|49|Bh|B h|Bhm|B h:mm|Bhms|B h:mm:ss|d|d|E|ccc|EBhm|E, B h:mm|EBhms|E, B h:mm:ss|Ed|d, E|Ehm|E, h:mm\u202Fa|EHm|E, HH:mm|Ehms|E, h:mm:ss\u202Fa|EHms|E, HH:mm:ss|Gy|G y|GyMd|dd.MM.y GGGGG|GyMMM|MMM, G y|GyMMMd|d-MMM, G y|GyMMMEd|E, d-MMM, G y|h|h\u202Fa|H|HH|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa (v)|Hmsv|HH:mm:ss (v)|hmv|h:mm\u202Fa (v)|Hmv|HH:mm (v)|M|LL|Md|dd/MM|MEd|E, dd/MM|MMM|LLL|MMMd|d-MMM|MMMEd|E, d-MMM|MMMMd|d-MMMM|MMMMW-count-one|MMMM, W-\'hafta\'|MMMMW-count-other|MMMM, W-\'hafta\'|ms|mm:ss|y|y|yM|MM.y|yMd|dd/MM/y|yMEd|E, dd/MM/y|yMMM|MMM, y|yMMMd|d-MMM, y|yMMMEd|E, d-MMM, y|yMMMM|MMMM, y|yQQQ|y, QQQ|yQQQQ|y, QQQQ|yw-count-one|Y, w-\'hafta\'|yw-count-other|Y, w-\'hafta\'|HHmm|HHmmss|Hmmssz|Hmmsszzzz|X3W\u00A0|,|-||||||E2W\u00A0|,|-|\u00A0¤||\u00A0¤||\u00A0¤|E0W\u00A0|,|-|%||%||%|108|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|UZS|soʻm|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XCG|Cg.|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$uz = $enkidatron$elm_cldr$Generated$Uz$uz;
var $enkidatron$elm_cldr$Generated$Vi$dayPeriods = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			'vi',
			_List_fromArray(
				[
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(12, 0),
					_Utils_Tuple2(18, 0),
					'afternoon1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(18, 0),
					_Utils_Tuple2(21, 0),
					'evening1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(0, 0),
					'midnight'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(4, 0),
					_Utils_Tuple2(12, 0),
					'morning1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(21, 0),
					_Utils_Tuple2(4, 0),
					'night1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(12, 0),
					'noon')
				]))
		]));
var $enkidatron$elm_cldr$Generated$Vi$vi = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Vi$dayPeriods, 'vi||||SA|CH|8|afternoon1|chiều|am|SA|evening1|tối|midnight|nửa đêm|morning1|sáng|night1|đêm|noon|TR|pm|CH|SA|CH|8|afternoon1|chiều|am|SA|evening1|tối|midnight|nửa đêm|morning1|sáng|night1|đêm|noon|trưa|pm|CH|s|c|8|afternoon1|chiều|am|s|evening1|tối|midnight|nửa đêm|morning1|sáng|night1|đêm|noon|tr|pm|c|d/M/yy|d MMM, y|d MMMM, y|EEEE, d MMMM, y|thg 1|thg 2|thg 3|thg 4|thg 5|thg 6|thg 7|thg 8|thg 9|thg 10|thg 11|thg 12|tháng 1|tháng 2|tháng 3|tháng 4|tháng 5|tháng 6|tháng 7|tháng 8|tháng 9|tháng 10|tháng 11|tháng 12|1|2|3|4|5|6|7|8|9|10|11|12|1|Tháng 1|Tháng 2|Tháng 3|Tháng 4|Tháng 5|Tháng 6|Tháng 7|Tháng 8|Tháng 9|Tháng 10|Tháng 11|Tháng 12|Tháng 1|Tháng 2|Tháng 3|Tháng 4|Tháng 5|Tháng 6|Tháng 7|Tháng 8|Tháng 9|Tháng 10|Tháng 11|Tháng 12|1|2|3|4|5|6|7|8|9|10|11|12|CN|Th 2|Th 3|Th 4|Th 5|Th 6|Th 7|Chủ Nhật|Thứ Hai|Thứ Ba|Thứ Tư|Thứ Năm|Thứ Sáu|Thứ Bảy|CN|T2|T3|T4|T5|T6|T7|0|TCN|SCN|Trước Chúa Giáng Sinh|Sau Công Nguyên|TCN|CN|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{0} {1}|{0} {1}|{0} {1}|{0} {1}|51|Bh|h \'giờ\' B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|h:mm B E|EBhms|h:mm:ss B E|Ed|E, \'ngày\' d|Ehm|h:mm\u202Fa E|EHm|HH:mm E|Ehms|h:mm:ss\u202Fa E|EHms|HH:mm:ss E|Gy|y G|GyMd|d/M/y G|GyMMM|MMM y G|GyMMMd|d MMM, y G|GyMMMEd|E, d MMM, y G|h|h\u202Fa|H|HH \'giờ\'|hm|h:mm\u202Fa|Hm|H:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|Hmv|HH:mm v|M|L|Md|d/M|MEd|E, d/M|MMdd|dd-MM|MMM|LLL|MMMd|d MMM|MMMEd|E, d MMM|MMMMd|d MMMM|MMMMEd|E, d MMMM|MMMMW-count-other|\'tuần\' W \'của\' \'tháng\' M|mmss|mm:ss|ms|mm:ss|y|y|yM|M/y|yMd|d/M/y|yMEd|E, d/M/y|yMM|\'tháng\' MM, y|yMMM|MMM y|yMMMd|d MMM, y|yMMMEd|E, d MMM, y|yMMMM|MMMM \'năm\' y|yQQQ|QQQ y|yQQQQ|QQQQ \'năm\' y|yw-count-other|\'tuần\' w \'của\' \'năm\' Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W.|,|-||||||E2W.|,|-|\u00A0¤||\u00A0¤||\u00A0¤|E0W.|,|-|%||%||%|107|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|AU$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XCG|Cg.|XOF|F\u202FCFA|XPF|CFPF|XXX|XXX|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$vi = $enkidatron$elm_cldr$Generated$Vi$vi;
var $enkidatron$elm_cldr$Generated$Yo$dayPeriods = $elm$core$Dict$fromList(_List_Nil);
var $enkidatron$elm_cldr$Generated$Yo$yo = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Yo$dayPeriods, 'yo||||Àárọ̀|Ọ̀sán|2|am|Àárọ̀|pm|Ọ̀sán|Àárọ̀|Ọ̀sán|2|am|Àárọ̀|pm|Ọ̀sán|Àárọ̀|Ọ̀sán|2|am|Àárọ̀|pm|Ọ̀sán|d/M/y|d MM y|d MMM y|EEEE, d MMM y|Oṣù Ṣẹ́rẹ́|Oṣù Èrèlè|Oṣù Ẹrẹ̀nà|Oṣù Ìgbé|Oṣù Ẹ̀bibi|Oṣù Òkúdu|Oṣù Agẹmọ|Oṣù Ògún|Oṣù Owewe|Oṣù Ọ̀wàrà|Oṣù Bélú|Oṣù Ọ̀pẹ̀|Oṣù Ṣẹ́rẹ́|Oṣù Èrèlè|Oṣù Ẹrẹ̀nà|Oṣù Ìgbé|Oṣù Ẹ̀bibi|Oṣù Òkúdu|Oṣù Agẹmọ|Oṣù Ògún|Oṣù Owewe|Oṣù Ọ̀wàrà|Oṣù Bélú|Oṣù Ọ̀pẹ̀|S|È|Ẹ|Ì|Ẹ̀|Ò|A|Ò|O|Ọ̀|B|Ọ̀|0|Àìkú|Ajé|Ìsẹ́gun|Ọjọ́rú|Ọjọ́bọ|Ẹtì|Àbámẹ́ta|Ọjọ́ Àìkú|Ọjọ́ Ajé|Ọjọ́ Ìsẹ́gun|Ọjọ́rú|Ọjọ́bọ|Ọjọ́ Ẹtì|Ọjọ́ Àbámẹ́ta|À|A|Ì|Ọ|Ọ|Ẹ|À|1|Àìkú|Ajé|Ìsẹ́gun|Ọjọ́rú|Ọjọ́bọ|Ẹtì|Àbámẹ́ta|Àìkú|Ajé|Ìsẹ́gun|Ọjọ́rú|Ọjọ́bọ|Ẹtì|Àbámẹ́ta|À|A|Ì|Ọ|Ọ|Ẹ|À|BCE|AD|Saju Kristi|Lehin Kristi|BCE|AD|H:m|H:m:s|H:mm:ss z|HH:mm:ss zzzz|{1} {0}|{1} {0}|{1} {0}|{1} {0}|48|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|E, d|Ehm|E h:mm\u202Fa|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|EHms|E HH:mm:ss|Gy|G y|GyMd|d/M/y GGGGG|GyMMM|G y MMM|GyMMMd|G y MMM d|GyMMMEd|G y MMM d, E|h|h\u202Fa|H|HH|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|Hmv|HH:mm v|M|L|Md|d/M|MEd|E, d/M|MMM|LLL|MMMd|d MMM|MMMEd|d MMM, E|MMMMd|d MMMM|MMMMEd|d, MMMM E|MMMMW-count-other|\'week\' W \'of\' MMMM|ms|mm:ss|y|y|yM|M/y|yMd|d/M/y|yMEd|d/M/y, E|yMMM|MMM y|yMMMd|d MMM y|yMMMEd|E, d MMM , y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-other|\'week\' w \'of\' Y|Hm|Hms|Hmmssz|HHmmsszzzz|X3W,|.|-||||||E2W,|.|-¤||¤||¤||E0W,|.|-|%||%||%|106|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|₱|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XCG|Cg.|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$yo = $enkidatron$elm_cldr$Generated$Yo$yo;
var $enkidatron$elm_cldr$Generated$Yue$dayPeriods = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			'yue',
			_List_fromArray(
				[
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(12, 0),
					_Utils_Tuple2(13, 0),
					'afternoon1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(13, 0),
					_Utils_Tuple2(19, 0),
					'afternoon2'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(19, 0),
					_Utils_Tuple2(24, 0),
					'evening1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(0, 0),
					'midnight'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(5, 0),
					_Utils_Tuple2(8, 0),
					'morning1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(8, 0),
					_Utils_Tuple2(12, 0),
					'morning2'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(0, 0),
					_Utils_Tuple2(5, 0),
					'night1')
				]))
		]));
var $enkidatron$elm_cldr$Generated$Yue$yue = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Yue$dayPeriods, 'yue||||上午|下午|9|afternoon1|中午|afternoon2|下晝|am|上午|evening1|夜晚|midnight|午夜|morning1|清晨|morning2|朝早|night1|凌晨|pm|下午|上午|下午|9|afternoon1|中午|afternoon2|下晝|am|上午|evening1|夜晚|midnight|午夜|morning1|清晨|morning2|朝早|night1|凌晨|pm|下午|上午|下午|9|afternoon1|中午|afternoon2|下晝|am|上午|evening1|夜晚|midnight|午夜|morning1|清晨|morning2|朝早|night1|凌晨|pm|下午|y/M/d|y年M月d日|y年M月d日|y年M月d日 EEEE|1月|2月|3月|4月|5月|6月|7月|8月|9月|10月|11月|12月|1月|2月|3月|4月|5月|6月|7月|8月|9月|10月|11月|12月|1|2|3|4|5|6|7|8|9|10|11|12|0|星期日|星期一|星期二|星期三|星期四|星期五|星期六|星期日|星期一|星期二|星期三|星期四|星期五|星期六|日|一|二|三|四|五|六|0|西元前|西元|西元前|西元|西元前|西元|ah:mm|ah:mm:ss|ah:mm:ss [z]|ah:mm:ss [zzzz]|{1} {0}|{1} {0}|{1} {0}|{1} {0}|49|Bh|Bh時|Bhm|Bh:mm|Bhms|Bh:mm:ss|d|d日|E|ccc|EBhm|E Bh:mm|EBhms|E Bh:mm:ss|Ed|d E|Ehm|E ah:mm|EHm|E HH:mm|Ehms|E ah:mm:ss|EHms|E HH:mm:ss|Gy|Gy年|GyMd|GGGGG y-MM-dd|GyMMM|Gy年M月|GyMMMd|Gy年M月d日|GyMMMEd|Gy年M月d日 E|h|ah時|H|H時|hm|ah:mm|Hm|HH:mm|hms|ah:mm:ss|Hms|HH:mm:ss|hmsv|ah:mm:ss [v]|Hmsv|HH:mm:ss [v]|hmv|ah:mm [v]|Hmv|HH:mm [v]|M|M月|Md|M/d|MEd|M/d（E）|MMdd|MM/dd|MMM|LLL|MMMd|M月d日|MMMEd|M月d日 E|MMMMd|M月d日|MMMMW-count-other|M月第W個星期|ms|mm:ss|y|y年|yM|y/M|yMd|y/M/d|yMEd|y/M/d（E）|yMM|y/MM|yMMM|y年M月|yMMMd|y年M月d日|yMMMEd|y年M月d日 E|yMMMM|y年M月|yQQQ|y年QQQ|yQQQQ|y年QQQQ|yw-count-other|Y年第w個星期|ahmm|ahmmss|ahmmssz|ahmmsszzzz|X3W,|.|-||||||E2W,|.|-¤||¤||¤||E0W,|.|-|%||%||%|108|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|AU$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|￦|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RUR|р.|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XCG|Cg.|XOF|F\u202FCFA|XPF|CFPF|XXX|XXX|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$yue = $enkidatron$elm_cldr$Generated$Yue$yue;
var $enkidatron$elm_cldr$Generated$Zh$dayPeriods = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			'zh',
			_List_fromArray(
				[
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(12, 0),
					_Utils_Tuple2(13, 0),
					'afternoon1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(13, 0),
					_Utils_Tuple2(19, 0),
					'afternoon2'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(19, 0),
					_Utils_Tuple2(24, 0),
					'evening1'),
					A2(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$At,
					_Utils_Tuple2(0, 0),
					'midnight'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(5, 0),
					_Utils_Tuple2(8, 0),
					'morning1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(8, 0),
					_Utils_Tuple2(12, 0),
					'morning2'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(0, 0),
					_Utils_Tuple2(5, 0),
					'night1')
				]))
		]));
var $enkidatron$elm_cldr$Generated$Zh$zh = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Zh$dayPeriods, 'zh||||上午|下午|9|afternoon1|中午|afternoon2|下午|am|上午|evening1|晚上|midnight|午夜|morning1|早上|morning2|上午|night1|凌晨|pm|下午|上午|下午|9|afternoon1|中午|afternoon2|下午|am|上午|evening1|晚上|midnight|午夜|morning1|清晨|morning2|上午|night1|凌晨|pm|下午|上午|下午|9|afternoon1|中午|afternoon2|下午|am|上午|evening1|晚上|midnight|午夜|morning1|早上|morning2|上午|night1|凌晨|pm|下午|y/M/d|y年M月d日|y年M月d日|y年M月d日EEEE|1月|2月|3月|4月|5月|6月|7月|8月|9月|10月|11月|12月|一月|二月|三月|四月|五月|六月|七月|八月|九月|十月|十一月|十二月|1|2|3|4|5|6|7|8|9|10|11|12|0|周日|周一|周二|周三|周四|周五|周六|星期日|星期一|星期二|星期三|星期四|星期五|星期六|日|一|二|三|四|五|六|0|公元前|公元|公元前|公元|公元前|公元|HH:mm|HH:mm:ss|z HH:mm:ss|zzzz HH:mm:ss|{1} {0}|{1} {0}|{1} {0}|{1} {0}|50|Bh|Bh时|Bhm|Bh:mm|Bhms|Bh:mm:ss|d|d日|E|ccc|EBhm|EBh:mm|EBhms|EBh:mm:ss|Ed|d日E|Ehm|Eah:mm|EHm|EHH:mm|Ehms|Eah:mm:ss|EHms|EHH:mm:ss|Gy|Gy年|GyMd|GGGGG y-MM-dd|GyMMM|Gy年M月|GyMMMd|Gy年M月d日|GyMMMEd|Gy年M月d日E|h|ah时|H|H时|hm|ah:mm|Hm|HH:mm|hms|ah:mm:ss|Hms|HH:mm:ss|hmsv|v ah:mm:ss|Hmsv|v HH:mm:ss|hmv|v ah:mm|Hmv|v HH:mm|M|M月|Md|M/d|MEd|M/dE|MMdd|MM/dd|MMM|LLL|MMMd|M月d日|MMMEd|M月d日E|MMMMd|M月d日|MMMMW-count-other|MMMM第W周|ms|mm:ss|y|y年|yM|y/M|yMd|y/M/d|yMEd|y/M/dE|yMEEEEd|y年M月d日EEEE|yMM|y年M月|yMMM|y年M月|yMMMd|y年M月d日|yMMMEd|y年M月d日E|yMMMM|y年M月|yQQQ|y年第Q季度|yQQQQ|y年第Q季度|yw-count-other|Y年第w周|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W,|.|-||||||E2W,|.|-¤||¤||¤||E0W,|.|-|%||%||%|109|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|AU$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|р.|BZD|$|CAD|CA$|CLP|$|CNY|¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|kn|HUF|Ft|IDR|Rp|ILR|ILS|ILS|₪|INR|₹|ISK|kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|kr|NPR|Rs|NZD|NZ$|PHP|PHP|PKR|Rs|PLN|zł|PYG|₲|RON|lei|RUB|₽|RUR|р.|RWF|RF|SBD|$|SEK|kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|US$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XCG|Cg.|XOF|F\u202FCFA|XPF|CFPF|XXX|XXX|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$zh = $enkidatron$elm_cldr$Generated$Zh$zh;
var $enkidatron$elm_cldr$Generated$Zu$dayPeriods = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			'zu',
			_List_fromArray(
				[
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(10, 0),
					_Utils_Tuple2(13, 0),
					'afternoon1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(13, 0),
					_Utils_Tuple2(19, 0),
					'evening1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(0, 0),
					_Utils_Tuple2(6, 0),
					'morning1'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(6, 0),
					_Utils_Tuple2(10, 0),
					'morning2'),
					A3(
					$enkidatron$elm_cldr$Internal$DayPeriodRule$FromBefore,
					_Utils_Tuple2(19, 0),
					_Utils_Tuple2(24, 0),
					'night1')
				]))
		]));
var $enkidatron$elm_cldr$Generated$Zu$zu = A2(
	$elm$core$Maybe$withDefault,
	$enkidatron$elm_cldr$Internal$Locale$empty,
	A2($enkidatron$elm_cldr$Internal$Parse$parse, $enkidatron$elm_cldr$Generated$Zu$dayPeriods, 'zu||||AM|PM|7|afternoon1|emini|am|AM|evening1|ntambama|morning1|entathakusa|morning2|ekuseni|night1|ebusuku|pm|PM|AM|PM|7|afternoon1|emini|am|AM|evening1|ntambama|morning1|entathakusa|morning2|ekuseni|night1|ebusuku|pm|PM|a|p|7|afternoon1|emini|am|a|evening1|ntambama|morning1|entathakusa|morning2|ekuseni|night1|ebusuku|pm|p|M/d/yy|MMM d, y|MMMM d, y|EEEE, MMMM d, y|Jan|Feb|Mas|Eph|Mey|Jun|Jul|Aga|Sep|Okt|Nov|Dis|Januwari|Februwari|Mashi|Ephreli|Meyi|Juni|Julayi|Agasti|Septhemba|Okthoba|Novemba|Disemba|J|F|M|E|M|J|J|A|S|O|N|D|1|Jan|Feb|Mas|Eph|Mey|Jun|Jul|Aga|Sep|Okt|Nov|Dis|Januwari|Februwari|Mashi|Ephreli|Meyi|Juni|Julayi|Agasti|Septhemba|Okthoba|Novemba|Disemba|J|F|M|A|M|J|J|A|S|O|N|D|Son|Mso|Bil|Tha|Sin|Hla|Mgq|ISonto|UMsombuluko|ULwesibili|ULwesithathu|ULwesine|ULwesihlanu|UMgqibelo|S|M|B|T|S|H|M|0|BC|AD|BC|AD|BC|AD|HH:mm|HH:mm:ss|HH:mm:ss z|HH:mm:ss zzzz|{1} {0}|{1} {0}|{1} {0}|{1} {0}|47|Bh|h B|Bhm|h:mm B|Bhms|h:mm:ss B|d|d|E|ccc|EBhm|E h:mm B|EBhms|E h:mm:ss B|Ed|d E|Ehm|E h:mm\u202Fa|EHm|E HH:mm|Ehms|E h:mm:ss\u202Fa|EHms|E HH:mm:ss|Gy|G y|GyMd|M/d/y GGGGG|GyMMM|G y MMM|GyMMMd|G y MMM d|GyMMMEd|G y MMM d, E|h|h\u202Fa|H|HH|hm|h:mm\u202Fa|Hm|HH:mm|hms|h:mm:ss\u202Fa|Hms|HH:mm:ss|hmsv|h:mm:ss\u202Fa v|Hmsv|HH:mm:ss v|hmv|h:mm\u202Fa v|Hmv|HH:mm v|M|L|Md|MM-dd|MEd|MM-dd, E|MMM|LLL|MMMd|MMM d|MMMEd|E, MMM d|MMMMd|MMMM d|MMMMW-count-other|\'week\' W \'of\' MMMM|ms|mm:ss|y|y|yM|y-MM|yMd|y-MM-dd|yMEd|y-MM-dd, E|yMMM|MMM y|yMMMd|MMM d, y|yMMMEd|E, MMM d, y|yMMMM|MMMM y|yQQQ|QQQ y|yQQQQ|QQQQ y|yw-count-other|\'week\' w \'of\' Y|HHmm|HHmmss|HHmmssz|HHmmsszzzz|X3W,|.|-||||||E2W,|.|-¤||¤||¤||E0W,|.|-|%||%||%|107|AFN|؋|AMD|֏|AOA|Kz|ARS|$|AUD|A$|AZN|₼|BAM|KM|BBD|$|BDT|৳|BMD|$|BND|$|BOB|Bs|BRL|R$|BSD|$|BWP|P|BYN|P.|BZD|$|CAD|CA$|CLP|$|CNY|CN¥|COP|$|CRC|₡|CUC|$|CUP|$|CZK|Kč|DKK|Kr|DOP|$|EGP|E£|ESP|₧|EUR|€|FJD|$|FKP|£|GBP|£|GEL|₾|GHS|GH₵|GIP|£|GNF|FG|GTQ|Q|GYD|$|HKD|HK$|HNL|L|HRK|Kn|HUF|Ft|IDR|Rp|ILS|₪|INR|₹|ISK|Kr|JMD|$|JPY|JP¥|KGS|\u20C0|KHR|៛|KMF|CF|KPW|₩|KRW|₩|KYD|$|KZT|₸|LAK|₭|LBP|L£|LKR|Rs|LRD|$|LTL|Lt|LVL|Ls|MGA|Ar|MMK|K|MNT|₮|MUR|Rs|MXN|MX$|MYR|RM|NAD|$|NGN|₦|NIO|C$|NOK|Kr|NPR|Rs|NZD|NZ$|PHP|PHP|PKR|Rs|PLN|Zł|PYG|₲|RON|lei|RUB|₽|RWF|RF|SBD|$|SEK|Kr|SGD|$|SHP|£|SRD|$|SSP|£|STN|Db|SYP|£|THB|฿|TOP|T$|TRY|₺|TTD|$|TWD|NT$|UAH|₴|USD|$|UYU|$|VEF|Bs|VND|₫|XAF|FCFA|XCD|EC$|XCG|Cg.|XOF|F\u202FCFA|XPF|CFPF|XXX|¤|ZAR|R|ZMW|ZK|'));
var $enkidatron$elm_cldr$Cldr$Locale$zu = $enkidatron$elm_cldr$Generated$Zu$zu;
var $enkidatron$elm_cldr$Cldr$Locale$basicLocales = _List_fromArray(
	[$enkidatron$elm_cldr$Cldr$Locale$af, $enkidatron$elm_cldr$Cldr$Locale$am, $enkidatron$elm_cldr$Cldr$Locale$ar, $enkidatron$elm_cldr$Cldr$Locale$locale_as, $enkidatron$elm_cldr$Cldr$Locale$az, $enkidatron$elm_cldr$Cldr$Locale$be, $enkidatron$elm_cldr$Cldr$Locale$bg, $enkidatron$elm_cldr$Cldr$Locale$bn, $enkidatron$elm_cldr$Cldr$Locale$bs, $enkidatron$elm_cldr$Cldr$Locale$ca, $enkidatron$elm_cldr$Cldr$Locale$chr, $enkidatron$elm_cldr$Cldr$Locale$cs, $enkidatron$elm_cldr$Cldr$Locale$cy, $enkidatron$elm_cldr$Cldr$Locale$da, $enkidatron$elm_cldr$Cldr$Locale$de, $enkidatron$elm_cldr$Cldr$Locale$dsb, $enkidatron$elm_cldr$Cldr$Locale$el, $enkidatron$elm_cldr$Cldr$Locale$en, $enkidatron$elm_cldr$Cldr$Locale$es, $enkidatron$elm_cldr$Cldr$Locale$et, $enkidatron$elm_cldr$Cldr$Locale$eu, $enkidatron$elm_cldr$Cldr$Locale$fa, $enkidatron$elm_cldr$Cldr$Locale$fi, $enkidatron$elm_cldr$Cldr$Locale$fil, $enkidatron$elm_cldr$Cldr$Locale$fr, $enkidatron$elm_cldr$Cldr$Locale$ga, $enkidatron$elm_cldr$Cldr$Locale$gd, $enkidatron$elm_cldr$Cldr$Locale$gl, $enkidatron$elm_cldr$Cldr$Locale$gu, $enkidatron$elm_cldr$Cldr$Locale$ha, $enkidatron$elm_cldr$Cldr$Locale$he, $enkidatron$elm_cldr$Cldr$Locale$hi, $enkidatron$elm_cldr$Cldr$Locale$hr, $enkidatron$elm_cldr$Cldr$Locale$hsb, $enkidatron$elm_cldr$Cldr$Locale$ht, $enkidatron$elm_cldr$Cldr$Locale$hu, $enkidatron$elm_cldr$Cldr$Locale$hy, $enkidatron$elm_cldr$Cldr$Locale$id, $enkidatron$elm_cldr$Cldr$Locale$ig, $enkidatron$elm_cldr$Cldr$Locale$is, $enkidatron$elm_cldr$Cldr$Locale$it, $enkidatron$elm_cldr$Cldr$Locale$ja, $enkidatron$elm_cldr$Cldr$Locale$jv, $enkidatron$elm_cldr$Cldr$Locale$ka, $enkidatron$elm_cldr$Cldr$Locale$kk, $enkidatron$elm_cldr$Cldr$Locale$km, $enkidatron$elm_cldr$Cldr$Locale$kn, $enkidatron$elm_cldr$Cldr$Locale$ko, $enkidatron$elm_cldr$Cldr$Locale$kok, $enkidatron$elm_cldr$Cldr$Locale$ky, $enkidatron$elm_cldr$Cldr$Locale$lo, $enkidatron$elm_cldr$Cldr$Locale$lt, $enkidatron$elm_cldr$Cldr$Locale$lv, $enkidatron$elm_cldr$Cldr$Locale$mk, $enkidatron$elm_cldr$Cldr$Locale$ml, $enkidatron$elm_cldr$Cldr$Locale$mn, $enkidatron$elm_cldr$Cldr$Locale$mr, $enkidatron$elm_cldr$Cldr$Locale$ms, $enkidatron$elm_cldr$Cldr$Locale$my, $enkidatron$elm_cldr$Cldr$Locale$nb, $enkidatron$elm_cldr$Cldr$Locale$ne, $enkidatron$elm_cldr$Cldr$Locale$nl, $enkidatron$elm_cldr$Cldr$Locale$nn, $enkidatron$elm_cldr$Cldr$Locale$no, $enkidatron$elm_cldr$Cldr$Locale$or, $enkidatron$elm_cldr$Cldr$Locale$pa, $enkidatron$elm_cldr$Cldr$Locale$pcm, $enkidatron$elm_cldr$Cldr$Locale$pl, $enkidatron$elm_cldr$Cldr$Locale$ps, $enkidatron$elm_cldr$Cldr$Locale$pt, $enkidatron$elm_cldr$Cldr$Locale$ro, $enkidatron$elm_cldr$Cldr$Locale$ru, $enkidatron$elm_cldr$Cldr$Locale$sd, $enkidatron$elm_cldr$Cldr$Locale$si, $enkidatron$elm_cldr$Cldr$Locale$sk, $enkidatron$elm_cldr$Cldr$Locale$sl, $enkidatron$elm_cldr$Cldr$Locale$so, $enkidatron$elm_cldr$Cldr$Locale$sq, $enkidatron$elm_cldr$Cldr$Locale$sr, $enkidatron$elm_cldr$Cldr$Locale$sv, $enkidatron$elm_cldr$Cldr$Locale$sw, $enkidatron$elm_cldr$Cldr$Locale$ta, $enkidatron$elm_cldr$Cldr$Locale$te, $enkidatron$elm_cldr$Cldr$Locale$th, $enkidatron$elm_cldr$Cldr$Locale$ti, $enkidatron$elm_cldr$Cldr$Locale$tk, $enkidatron$elm_cldr$Cldr$Locale$tr, $enkidatron$elm_cldr$Cldr$Locale$uk, $enkidatron$elm_cldr$Cldr$Locale$root, $enkidatron$elm_cldr$Cldr$Locale$ur, $enkidatron$elm_cldr$Cldr$Locale$uz, $enkidatron$elm_cldr$Cldr$Locale$vi, $enkidatron$elm_cldr$Cldr$Locale$yo, $enkidatron$elm_cldr$Cldr$Locale$yue, $enkidatron$elm_cldr$Cldr$Locale$zh, $enkidatron$elm_cldr$Cldr$Locale$zu]);
var $elm$core$Result$fromMaybe = F2(
	function (err, maybe) {
		if (maybe.$ === 'Just') {
			var v = maybe.a;
			return $elm$core$Result$Ok(v);
		} else {
			return $elm$core$Result$Err(err);
		}
	});
var $elm$json$Json$Decode$fail = _Json_fail;
var $elm$json$Json$Decode$succeed = _Json_succeed;
var $elm_community$json_extra$Json$Decode$Extra$fromResult = function (result) {
	if (result.$ === 'Ok') {
		var successValue = result.a;
		return $elm$json$Json$Decode$succeed(successValue);
	} else {
		var errorMessage = result.a;
		return $elm$json$Json$Decode$fail(errorMessage);
	}
};
var $elm$core$Basics$ge = _Utils_ge;
var $joneshf$elm_tagged$Tagged$tag = $joneshf$elm_tagged$Tagged$Tagged;
var $enkidatron$elm_cldr$Internal$Locale$langSubtagParser = A2(
	$elm$parser$Parser$keeper,
	$elm$parser$Parser$succeed($joneshf$elm_tagged$Tagged$tag),
	A2(
		$elm$parser$Parser$andThen,
		function (words) {
			var len = $elm$core$String$length(words);
			return (((len >= 2) && (len <= 3)) || ((len >= 5) && (len <= 8))) ? $elm$parser$Parser$succeed(words) : $elm$parser$Parser$problem('a language subtag must have 2-3 or 5-8 characters');
		},
		$elm$parser$Parser$getChompedString(
			$elm$parser$Parser$chompWhile($elm$core$Char$isAlpha))));
var $enkidatron$elm_cldr$Internal$Locale$maybeParse = function (innerParser) {
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				A2($elm$parser$Parser$map, $elm$core$Maybe$Just, innerParser),
				$elm$parser$Parser$succeed($elm$core$Maybe$Nothing)
			]));
};
var $elm$core$Basics$composeL = F3(
	function (g, f, x) {
		return g(
			f(x));
	});
var $elm$core$List$all = F2(
	function (isOkay, list) {
		return !A2(
			$elm$core$List$any,
			A2($elm$core$Basics$composeL, $elm$core$Basics$not, isOkay),
			list);
	});
var $elm$parser$Parser$Advanced$backtrackable = function (_v0) {
	var parse = _v0.a;
	return $elm$parser$Parser$Advanced$Parser(
		function (s0) {
			var _v1 = parse(s0);
			if (_v1.$ === 'Bad') {
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, false, x);
			} else {
				var a = _v1.b;
				var s1 = _v1.c;
				return A3($elm$parser$Parser$Advanced$Good, false, a, s1);
			}
		});
};
var $elm$parser$Parser$backtrackable = $elm$parser$Parser$Advanced$backtrackable;
var $enkidatron$elm_cldr$Internal$Locale$sepParser = $elm$parser$Parser$chompIf(
	function (_char) {
		return _Utils_eq(
			_char,
			_Utils_chr('-')) || _Utils_eq(
			_char,
			_Utils_chr('_'));
	});
var $elm$core$String$foldr = _String_foldr;
var $elm$core$String$toList = function (string) {
	return A3($elm$core$String$foldr, $elm$core$List$cons, _List_Nil, string);
};
var $enkidatron$elm_cldr$Internal$Locale$regionSubtagParser = $elm$parser$Parser$backtrackable(
	A2(
		$elm$parser$Parser$keeper,
		A2(
			$elm$parser$Parser$ignorer,
			$elm$parser$Parser$succeed($joneshf$elm_tagged$Tagged$tag),
			$enkidatron$elm_cldr$Internal$Locale$sepParser),
		A2(
			$elm$parser$Parser$andThen,
			function (words) {
				var len = $elm$core$String$length(words);
				return ((len === 2) && A2(
					$elm$core$List$all,
					$elm$core$Char$isAlpha,
					$elm$core$String$toList(words))) ? $elm$parser$Parser$succeed(words) : (((len === 3) && A2(
					$elm$core$List$all,
					$elm$core$Char$isDigit,
					$elm$core$String$toList(words))) ? $elm$parser$Parser$succeed(words) : $elm$parser$Parser$problem('a region subtag must have 2-3 characters'));
			},
			$elm$parser$Parser$getChompedString(
				$elm$parser$Parser$chompWhile($elm$core$Char$isAlphaNum)))));
var $enkidatron$elm_cldr$Internal$Locale$scriptSubtagParser = $elm$parser$Parser$backtrackable(
	A2(
		$elm$parser$Parser$keeper,
		A2(
			$elm$parser$Parser$ignorer,
			$elm$parser$Parser$succeed($joneshf$elm_tagged$Tagged$tag),
			$enkidatron$elm_cldr$Internal$Locale$sepParser),
		A2(
			$elm$parser$Parser$andThen,
			function (words) {
				return ($elm$core$String$length(words) === 4) ? $elm$parser$Parser$succeed(words) : $elm$parser$Parser$problem('a script subtag must have 4 characters');
			},
			$elm$parser$Parser$getChompedString(
				$elm$parser$Parser$chompWhile($elm$core$Char$isAlpha)))));
var $enkidatron$elm_cldr$Internal$Locale$isValidVariant = function (words) {
	var _v0 = $elm$core$String$toList(words);
	if ((((_v0.b && _v0.b.b) && _v0.b.b.b) && _v0.b.b.b.b) && (!_v0.b.b.b.b.b)) {
		var first = _v0.a;
		var _v1 = _v0.b;
		var second = _v1.a;
		var _v2 = _v1.b;
		var third = _v2.a;
		var _v3 = _v2.b;
		var fourth = _v3.a;
		return $elm$core$Char$isDigit(first) && A2(
			$elm$core$List$all,
			$elm$core$Char$isAlphaNum,
			_List_fromArray(
				[second, third, fourth]));
	} else {
		var length = $elm$core$String$length(words);
		return (length >= 5) && ((length <= 8) && A2(
			$elm$core$List$all,
			$elm$core$Char$isAlphaNum,
			$elm$core$String$toList(words)));
	}
};
var $enkidatron$elm_cldr$Internal$Locale$variantSubtagParser = A2(
	$elm$parser$Parser$keeper,
	A2(
		$elm$parser$Parser$ignorer,
		$elm$parser$Parser$succeed($joneshf$elm_tagged$Tagged$tag),
		$enkidatron$elm_cldr$Internal$Locale$sepParser),
	A2(
		$elm$parser$Parser$andThen,
		function (words) {
			return $enkidatron$elm_cldr$Internal$Locale$isValidVariant(words) ? $elm$parser$Parser$succeed(words) : $elm$parser$Parser$problem('\'' + (words + '\' is not a valid variantn subtag'));
		},
		$elm$parser$Parser$getChompedString(
			$elm$parser$Parser$chompWhile($elm$core$Char$isAlpha))));
var $enkidatron$elm_cldr$Internal$Locale$langParser = A2(
	$elm$parser$Parser$keeper,
	A2(
		$elm$parser$Parser$keeper,
		A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$keeper,
				$elm$parser$Parser$succeed($enkidatron$elm_cldr$Internal$Locale$Lang),
				$enkidatron$elm_cldr$Internal$Locale$langSubtagParser),
			$enkidatron$elm_cldr$Internal$Locale$maybeParse($enkidatron$elm_cldr$Internal$Locale$scriptSubtagParser)),
		$enkidatron$elm_cldr$Internal$Locale$maybeParse($enkidatron$elm_cldr$Internal$Locale$regionSubtagParser)),
	$enkidatron$elm_cldr$Internal$Locale$maybeParse($enkidatron$elm_cldr$Internal$Locale$variantSubtagParser));
var $elm$parser$Parser$ExpectingKeyword = function (a) {
	return {$: 'ExpectingKeyword', a: a};
};
var $elm$parser$Parser$Advanced$keyword = function (_v0) {
	var kwd = _v0.a;
	var expecting = _v0.b;
	var progress = !$elm$core$String$isEmpty(kwd);
	return $elm$parser$Parser$Advanced$Parser(
		function (s) {
			var _v1 = A5($elm$parser$Parser$Advanced$isSubString, kwd, s.offset, s.row, s.col, s.src);
			var newOffset = _v1.a;
			var newRow = _v1.b;
			var newCol = _v1.c;
			return (_Utils_eq(newOffset, -1) || (0 <= A3(
				$elm$parser$Parser$Advanced$isSubChar,
				function (c) {
					return $elm$core$Char$isAlphaNum(c) || _Utils_eq(
						c,
						_Utils_chr('_'));
				},
				newOffset,
				s.src))) ? A2(
				$elm$parser$Parser$Advanced$Bad,
				false,
				A2($elm$parser$Parser$Advanced$fromState, s, expecting)) : A3(
				$elm$parser$Parser$Advanced$Good,
				progress,
				_Utils_Tuple0,
				{col: newCol, context: s.context, indent: s.indent, offset: newOffset, row: newRow, src: s.src});
		});
};
var $elm$parser$Parser$keyword = function (kwd) {
	return $elm$parser$Parser$Advanced$keyword(
		A2(
			$elm$parser$Parser$Advanced$Token,
			kwd,
			$elm$parser$Parser$ExpectingKeyword(kwd)));
};
var $enkidatron$elm_cldr$Internal$Locale$rootParser = A2(
	$elm$parser$Parser$ignorer,
	A2(
		$elm$parser$Parser$ignorer,
		$elm$parser$Parser$succeed($enkidatron$elm_cldr$Internal$Locale$Root),
		$elm$parser$Parser$keyword('root')),
	$elm$parser$Parser$end);
var $enkidatron$elm_cldr$Internal$Locale$languageIdParser = $elm$parser$Parser$oneOf(
	_List_fromArray(
		[$enkidatron$elm_cldr$Internal$Locale$rootParser, $enkidatron$elm_cldr$Internal$Locale$langParser]));
var $enkidatron$elm_cldr$Internal$Locale$languageIdFromString = function (words) {
	return $elm$core$Result$toMaybe(
		A2($elm$parser$Parser$run, $enkidatron$elm_cldr$Internal$Locale$languageIdParser, words));
};
var $elm$core$List$head = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return $elm$core$Maybe$Just(x);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $enkidatron$elm_cldr$Internal$Locale$languageIdNoConflicts = F2(
	function (langA, langB) {
		var _v0 = _Utils_Tuple2(langA, langB);
		_v0$2:
		while (true) {
			if (_v0.a.$ === 'Root') {
				if (_v0.b.$ === 'Root') {
					var _v1 = _v0.a;
					var _v2 = _v0.b;
					return true;
				} else {
					break _v0$2;
				}
			} else {
				if (_v0.b.$ === 'Lang') {
					var _v3 = _v0.a;
					var tagA = _v3.a;
					var scriptTagA = _v3.b;
					var regionTagA = _v3.c;
					var variantTagA = _v3.d;
					var _v4 = _v0.b;
					var tagB = _v4.a;
					var scriptTagB = _v4.b;
					var regionTagB = _v4.c;
					var variantTagB = _v4.d;
					return _Utils_eq(tagA, tagB) && (A2(
						$elm$core$Maybe$withDefault,
						true,
						A3($elm$core$Maybe$map2, $elm$core$Basics$eq, scriptTagA, scriptTagB)) && (A2(
						$elm$core$Maybe$withDefault,
						true,
						A3($elm$core$Maybe$map2, $elm$core$Basics$eq, regionTagA, regionTagB)) && A2(
						$elm$core$Maybe$withDefault,
						true,
						A3($elm$core$Maybe$map2, $elm$core$Basics$eq, variantTagA, variantTagB))));
				} else {
					break _v0$2;
				}
			}
		}
		return false;
	});
var $elm$core$Basics$pow = _Basics_pow;
var $enkidatron$elm_cldr$Internal$Locale$similarityHelper = F3(
	function (points, requested, checked) {
		var _v0 = _Utils_Tuple2(requested, checked);
		if (_v0.a.$ === 'Just') {
			if (_v0.b.$ === 'Just') {
				var req = _v0.a.a;
				var chck = _v0.b.a;
				return _Utils_eq(req, chck) ? (2 * points) : 0;
			} else {
				var _v3 = _v0.b;
				return points;
			}
		} else {
			if (_v0.b.$ === 'Nothing') {
				var _v1 = _v0.a;
				var _v2 = _v0.b;
				return 2 * points;
			} else {
				var _v4 = _v0.a;
				return points;
			}
		}
	});
var $enkidatron$elm_cldr$Internal$Locale$languageIdSimilarity = F2(
	function (requested, checked) {
		var _v0 = _Utils_Tuple2(requested, checked);
		_v0$2:
		while (true) {
			if (_v0.a.$ === 'Root') {
				if (_v0.b.$ === 'Root') {
					var _v1 = _v0.a;
					var _v2 = _v0.b;
					return (-1) * A2($elm$core$Basics$pow, 10, 4);
				} else {
					break _v0$2;
				}
			} else {
				if (_v0.b.$ === 'Lang') {
					var _v3 = _v0.a;
					var langTagA = _v3.a;
					var scriptTagA = _v3.b;
					var regionTagA = _v3.c;
					var variantTagA = _v3.d;
					var _v4 = _v0.b;
					var langTagB = _v4.a;
					var scriptTagB = _v4.b;
					var regionTagB = _v4.c;
					var variantTagB = _v4.d;
					var variantPoints = A3(
						$enkidatron$elm_cldr$Internal$Locale$similarityHelper,
						A2($elm$core$Basics$pow, 10, 1),
						variantTagA,
						variantTagB);
					var scriptPoints = A3(
						$enkidatron$elm_cldr$Internal$Locale$similarityHelper,
						A2($elm$core$Basics$pow, 10, 3),
						scriptTagA,
						scriptTagB);
					var regionPoints = A3(
						$enkidatron$elm_cldr$Internal$Locale$similarityHelper,
						A2($elm$core$Basics$pow, 10, 2),
						regionTagA,
						regionTagB);
					var langPoints = _Utils_eq(langTagA, langTagB) ? A2($elm$core$Basics$pow, 10, 4) : 0;
					return (((langPoints + scriptPoints) + regionPoints) + variantPoints) * (-1);
				} else {
					break _v0$2;
				}
			}
		}
		return 0;
	});
var $elm$core$List$sortBy = _List_sortBy;
var $enkidatron$elm_cldr$Internal$Locale$unwrapLocale = function (_v0) {
	var internal = _v0.a;
	return internal;
};
var $enkidatron$elm_cldr$Internal$Locale$matchNearestLocale = F2(
	function (locales, langId) {
		var normalized = $enkidatron$elm_cldr$Internal$Locale$normalize(langId);
		return A2(
			$elm$core$Maybe$map,
			$enkidatron$elm_cldr$Internal$Locale$Locale,
			$elm$core$List$head(
				A2(
					$elm$core$List$sortBy,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.languageId;
						},
						$enkidatron$elm_cldr$Internal$Locale$languageIdSimilarity(normalized)),
					A2(
						$elm$core$List$filter,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.languageId;
							},
							$enkidatron$elm_cldr$Internal$Locale$languageIdNoConflicts(normalized)),
						A2($elm$core$List$map, $enkidatron$elm_cldr$Internal$Locale$unwrapLocale, locales)))));
	});
var $enkidatron$elm_cldr$Cldr$Locale$fromString = F2(
	function (candidateLocales, localeString) {
		return A2(
			$elm$core$Maybe$andThen,
			$enkidatron$elm_cldr$Internal$Locale$matchNearestLocale(candidateLocales),
			$enkidatron$elm_cldr$Internal$Locale$languageIdFromString(localeString));
	});
var $elm$json$Json$Decode$string = _Json_decodeString;
var $author$project$LoadableLocale$localeDecoder = A2(
	$elm$json$Json$Decode$andThen,
	A2(
		$elm$core$Basics$composeR,
		$enkidatron$elm_cldr$Cldr$Locale$fromString($enkidatron$elm_cldr$Cldr$Locale$basicLocales),
		A2(
			$elm$core$Basics$composeR,
			$elm$core$Result$fromMaybe('Locale Not Found'),
			$elm_community$json_extra$Json$Decode$Extra$fromResult)),
	$elm$json$Json$Decode$string);
var $author$project$Compiler$Flags$localeFlagDecoder = A2($elm$json$Json$Decode$field, 'locale', $author$project$LoadableLocale$localeDecoder);
var $author$project$Compiler$Flags$getLocale = A2(
	$elm$core$Basics$composeR,
	$elm$json$Json$Decode$decodeValue($author$project$Compiler$Flags$localeFlagDecoder),
	$elm$core$Result$toMaybe);
var $author$project$DataEngine$DataCache$mapLocale = F2(
	function (transform, _v0) {
		var internal = _v0.a;
		return $author$project$DataEngine$DataCache$DataCache(
			_Utils_update(
				internal,
				{
					locale: transform(internal.locale)
				}));
	});
var $author$project$StudioApp$App = function (a) {
	return {$: 'App', a: a};
};
var $author$project$DisplayElement$Column = function (a) {
	return {$: 'Column', a: a};
};
var $author$project$DataElement$DataElementCollection = function (a) {
	return {$: 'DataElementCollection', a: a};
};
var $author$project$DataElement$emptyCollection = $author$project$DataElement$DataElementCollection($author$project$UuidDict$empty);
var $mgold$elm_nonempty_list$List$Nonempty$Nonempty = F2(
	function (a, b) {
		return {$: 'Nonempty', a: a, b: b};
	});
var $mgold$elm_nonempty_list$List$Nonempty$singleton = function (x) {
	return A2($mgold$elm_nonempty_list$List$Nonempty$Nonempty, x, _List_Nil);
};
var $mgold$elm_nonempty_list$List$Nonempty$fromElement = $mgold$elm_nonempty_list$List$Nonempty$singleton;
var $author$project$Page$Page = F2(
	function (a, b) {
		return {$: 'Page', a: a, b: b};
	});
var $author$project$Page$new = $author$project$Page$Page;
var $author$project$StudioApp$new = $author$project$StudioApp$App(
	{
		dataElements: $author$project$DataElement$emptyCollection,
		pages: $mgold$elm_nonempty_list$List$Nonempty$fromElement(
			A2(
				$author$project$Page$new,
				'Main Page',
				$author$project$DisplayElement$Column(_List_Nil)))
	});
var $elm$core$Platform$Cmd$batch = _Platform_batch;
var $elm$core$Platform$Cmd$none = $elm$core$Platform$Cmd$batch(_List_Nil);
var $author$project$LoadableLocale$setDevice = F2(
	function (newLocale, _v0) {
		var user = _v0.a;
		return _Utils_Tuple2(
			user,
			$elm$core$Maybe$Just(newLocale));
	});
var $author$project$Compiler$init = function (flags) {
	var maybeLocale = $author$project$Compiler$Flags$getLocale(flags);
	return _Utils_Tuple2(
		{
			activeRequest: $elm$core$Maybe$Nothing,
			app: $author$project$StudioApp$new,
			cache: function () {
				if (maybeLocale.$ === 'Nothing') {
					return $author$project$DataEngine$DataCache$empty;
				} else {
					var deviceLocale = maybeLocale.a;
					return A2(
						$author$project$DataEngine$DataCache$mapLocale,
						$author$project$LoadableLocale$setDevice(deviceLocale),
						$author$project$DataEngine$DataCache$empty);
				}
			}()
		},
		$elm$core$Platform$Cmd$none);
};
var $author$project$Compiler$FromFrontEnd = function (a) {
	return {$: 'FromFrontEnd', a: a};
};
var $author$project$Compiler$FromPreview = function (a) {
	return {$: 'FromPreview', a: a};
};
var $author$project$Compiler$NoOp = {$: 'NoOp'};
var $author$project$Compiler$RxFeedbackData = function (a) {
	return {$: 'RxFeedbackData', a: a};
};
var $author$project$Compiler$RxUserLocale = function (a) {
	return {$: 'RxUserLocale', a: a};
};
var $author$project$Compiler$RxUserTimeZone = function (a) {
	return {$: 'RxUserTimeZone', a: a};
};
var $elm$core$Platform$Sub$batch = _Platform_batch;
var $author$project$Compiler$FromFrontEndMsg$ConfigChange = function (a) {
	return {$: 'ConfigChange', a: a};
};
var $author$project$Compiler$FromFrontEndMsg$PurgeAllDataElementsAndManifests = {$: 'PurgeAllDataElementsAndManifests'};
var $author$project$Compiler$FromFrontEndMsg$RxManifests = function (a) {
	return {$: 'RxManifests', a: a};
};
var $author$project$Manifest$Manifest = F5(
	function (tagName, widgetUuid, versionUuid, properties, fileName) {
		return {fileName: fileName, properties: properties, tagName: tagName, versionUuid: versionUuid, widgetUuid: widgetUuid};
	});
var $elm$json$Json$Decode$at = F2(
	function (fields, decoder) {
		return A3($elm$core$List$foldr, $elm$json$Json$Decode$field, decoder, fields);
	});
var $danyx23$elm_uuid$Uuid$Uuid = function (a) {
	return {$: 'Uuid', a: a};
};
var $elm$regex$Regex$contains = _Regex_contains;
var $danyx23$elm_uuid$Uuid$Barebones$uuidRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('^[0-9A-Fa-f]{8,8}-[0-9A-Fa-f]{4,4}-[1-5][0-9A-Fa-f]{3,3}-[8-9A-Ba-b][0-9A-Fa-f]{3,3}-[0-9A-Fa-f]{12,12}$'));
var $danyx23$elm_uuid$Uuid$Barebones$isValidUuid = function (uuidAsString) {
	return A2($elm$regex$Regex$contains, $danyx23$elm_uuid$Uuid$Barebones$uuidRegex, uuidAsString);
};
var $danyx23$elm_uuid$Uuid$fromString = function (text) {
	return $danyx23$elm_uuid$Uuid$Barebones$isValidUuid(text) ? $elm$core$Maybe$Just(
		$danyx23$elm_uuid$Uuid$Uuid(
			$elm$core$String$toLower(text))) : $elm$core$Maybe$Nothing;
};
var $danyx23$elm_uuid$Uuid$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		var _v0 = $danyx23$elm_uuid$Uuid$fromString(string);
		if (_v0.$ === 'Just') {
			var uuid = _v0.a;
			return $elm$json$Json$Decode$succeed(uuid);
		} else {
			return $elm$json$Json$Decode$fail('Not a valid UUID');
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Manifest$extractFileName = function (path) {
	return A2(
		$elm$core$Maybe$withDefault,
		'',
		$elm$core$List$head(
			$elm$core$List$reverse(
				A2($elm$core$String$split, '/', path))));
};
var $elm$json$Json$Decode$index = _Json_decodeIndex;
var $elm$json$Json$Decode$map = _Json_map1;
var $elm$json$Json$Decode$map5 = _Json_map5;
var $elm$json$Json$Decode$list = _Json_decodeList;
var $elm$json$Json$Decode$map2 = _Json_map2;
var $author$project$FieldType$BoolType = {$: 'BoolType'};
var $author$project$FieldType$DateTimeType = {$: 'DateTimeType'};
var $author$project$FieldType$DateType = {$: 'DateType'};
var $author$project$FieldType$NumberType = {$: 'NumberType'};
var $author$project$Manifest$SingleValue = F2(
	function (a, b) {
		return {$: 'SingleValue', a: a, b: b};
	});
var $author$project$FieldType$StringType = {$: 'StringType'};
var $author$project$Manifest$Optional = {$: 'Optional'};
var $author$project$Manifest$Required = {$: 'Required'};
var $author$project$Manifest$nameToRequired = function (name) {
	return A2($elm$core$String$endsWith, '?', name) ? $author$project$Manifest$Optional : $author$project$Manifest$Required;
};
var $elm$core$Result$map2 = F3(
	function (func, ra, rb) {
		if (ra.$ === 'Err') {
			var x = ra.a;
			return $elm$core$Result$Err(x);
		} else {
			var a = ra.a;
			if (rb.$ === 'Err') {
				var x = rb.a;
				return $elm$core$Result$Err(x);
			} else {
				var b = rb.a;
				return $elm$core$Result$Ok(
					A2(func, a, b));
			}
		}
	});
var $elm_community$result_extra$Result$Extra$combine = A2(
	$elm$core$List$foldr,
	$elm$core$Result$map2($elm$core$List$cons),
	$elm$core$Result$Ok(_List_Nil));
var $author$project$Manifest$ArrayValue = F2(
	function (a, b) {
		return {$: 'ArrayValue', a: a, b: b};
	});
var $author$project$Manifest$makeArrayValue = F2(
	function (name, list) {
		return A2(
			$author$project$Manifest$ArrayValue,
			$author$project$Manifest$nameToRequired(name),
			$elm$core$Dict$fromList(list));
	});
var $elm$core$Result$map = F2(
	function (func, ra) {
		if (ra.$ === 'Ok') {
			var a = ra.a;
			return $elm$core$Result$Ok(
				func(a));
		} else {
			var e = ra.a;
			return $elm$core$Result$Err(e);
		}
	});
var $author$project$Manifest$ArrayElement = F2(
	function (required, fieldType) {
		return {fieldType: fieldType, required: required};
	});
var $elm$core$String$replace = F3(
	function (before, after, string) {
		return A2(
			$elm$core$String$join,
			after,
			A2($elm$core$String$split, before, string));
	});
var $author$project$Manifest$sanitizeName = function (name) {
	return A3($elm$core$String$replace, '?', '', name);
};
var $elm$core$String$trim = _String_trim;
var $author$project$Manifest$nameAndArrayItemHelper = function (words) {
	return function (list) {
		_v0$5:
		while (true) {
			if ((list.b && list.b.b) && (!list.b.b.b)) {
				switch (list.b.a) {
					case 'string':
						var name = list.a;
						var _v1 = list.b;
						return $elm$core$Result$Ok(
							_Utils_Tuple2(
								$author$project$Manifest$sanitizeName(name),
								A2(
									$author$project$Manifest$ArrayElement,
									$author$project$Manifest$nameToRequired(name),
									$author$project$FieldType$StringType)));
					case 'number':
						var name = list.a;
						var _v2 = list.b;
						return $elm$core$Result$Ok(
							_Utils_Tuple2(
								$author$project$Manifest$sanitizeName(name),
								A2(
									$author$project$Manifest$ArrayElement,
									$author$project$Manifest$nameToRequired(name),
									$author$project$FieldType$NumberType)));
					case 'StudioDate':
						var name = list.a;
						var _v3 = list.b;
						return $elm$core$Result$Ok(
							_Utils_Tuple2(
								$author$project$Manifest$sanitizeName(name),
								A2(
									$author$project$Manifest$ArrayElement,
									$author$project$Manifest$nameToRequired(name),
									$author$project$FieldType$DateType)));
					case 'StudioDateTime':
						var name = list.a;
						var _v4 = list.b;
						return $elm$core$Result$Ok(
							_Utils_Tuple2(
								$author$project$Manifest$sanitizeName(name),
								A2(
									$author$project$Manifest$ArrayElement,
									$author$project$Manifest$nameToRequired(name),
									$author$project$FieldType$DateTimeType)));
					case 'boolean':
						var name = list.a;
						var _v5 = list.b;
						return $elm$core$Result$Ok(
							_Utils_Tuple2(
								$author$project$Manifest$sanitizeName(name),
								A2(
									$author$project$Manifest$ArrayElement,
									$author$project$Manifest$nameToRequired(name),
									$author$project$FieldType$BoolType)));
					default:
						break _v0$5;
				}
			} else {
				break _v0$5;
			}
		}
		return $elm$core$Result$Err('could not parse ' + words);
	}(
		A2(
			$elm$core$List$map,
			$elm$core$String$trim,
			A2($elm$core$String$split, ':', words)));
};
var $elm$core$String$startsWith = _String_startsWith;
var $author$project$Manifest$propertyArrayHelper = F2(
	function (name, typeString) {
		return (A2($elm$core$String$startsWith, 'Array<{', typeString) && A2($elm$core$String$endsWith, '}>', typeString)) ? A2(
			$elm$core$Result$map,
			$author$project$Manifest$makeArrayValue(name),
			$elm_community$result_extra$Result$Extra$combine(
				A2(
					$elm$core$List$map,
					$author$project$Manifest$nameAndArrayItemHelper,
					A2(
						$elm$core$List$map,
						$elm$core$String$trim,
						A2(
							$elm$core$String$split,
							',',
							A3($elm$core$String$slice, 7, -2, typeString)))))) : $elm$core$Result$Err('Could not parse ' + typeString);
	});
var $author$project$Manifest$propertyHelper = F2(
	function (name, typeString) {
		switch (typeString) {
			case 'string':
				return $elm$core$Result$Ok(
					A2(
						$author$project$Manifest$SingleValue,
						$author$project$Manifest$nameToRequired(name),
						$author$project$FieldType$StringType));
			case 'number':
				return $elm$core$Result$Ok(
					A2(
						$author$project$Manifest$SingleValue,
						$author$project$Manifest$nameToRequired(name),
						$author$project$FieldType$NumberType));
			case 'StudioDate':
				return $elm$core$Result$Ok(
					A2(
						$author$project$Manifest$SingleValue,
						$author$project$Manifest$nameToRequired(name),
						$author$project$FieldType$DateType));
			case 'StudioDateTime':
				return $elm$core$Result$Ok(
					A2(
						$author$project$Manifest$SingleValue,
						$author$project$Manifest$nameToRequired(name),
						$author$project$FieldType$DateTimeType));
			case 'boolean':
				return $elm$core$Result$Ok(
					A2(
						$author$project$Manifest$SingleValue,
						$author$project$Manifest$nameToRequired(name),
						$author$project$FieldType$BoolType));
			default:
				return A2($author$project$Manifest$propertyArrayHelper, name, typeString);
		}
	});
var $author$project$Manifest$propertyDecoder = A2(
	$elm$json$Json$Decode$andThen,
	$elm_community$json_extra$Json$Decode$Extra$fromResult,
	A3(
		$elm$json$Json$Decode$map2,
		$author$project$Manifest$propertyHelper,
		A2($elm$json$Json$Decode$field, 'name', $elm$json$Json$Decode$string),
		A2(
			$elm$json$Json$Decode$at,
			_List_fromArray(
				['type', 'text']),
			$elm$json$Json$Decode$string)));
var $author$project$Manifest$nameAndPropertyDecoder = A3(
	$elm$json$Json$Decode$map2,
	$elm$core$Tuple$pair,
	A2(
		$elm$json$Json$Decode$map,
		$author$project$Manifest$sanitizeName,
		A2($elm$json$Json$Decode$field, 'name', $elm$json$Json$Decode$string)),
	$author$project$Manifest$propertyDecoder);
var $author$project$Manifest$nameAndPropertyMaybeDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (kind) {
		return ($elm$core$String$toLower(kind) === 'field') ? A2(
			$elm$json$Json$Decode$andThen,
			function (name) {
				return A2($elm$core$String$startsWith, '#', name) ? $elm$json$Json$Decode$succeed($elm$core$Maybe$Nothing) : A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $author$project$Manifest$nameAndPropertyDecoder);
			},
			A2($elm$json$Json$Decode$field, 'name', $elm$json$Json$Decode$string)) : $elm$json$Json$Decode$succeed($elm$core$Maybe$Nothing);
	},
	A2($elm$json$Json$Decode$field, 'kind', $elm$json$Json$Decode$string));
var $author$project$Manifest$propertyDictDecoder = A2(
	$elm$json$Json$Decode$map,
	A2(
		$elm$core$Basics$composeR,
		$elm$core$List$filterMap($elm$core$Basics$identity),
		$elm$core$Dict$fromList),
	$elm$json$Json$Decode$list($author$project$Manifest$nameAndPropertyMaybeDecoder));
var $author$project$Manifest$complicatedDecoder = A6(
	$elm$json$Json$Decode$map5,
	$author$project$Manifest$Manifest,
	A2(
		$elm$json$Json$Decode$at,
		_List_fromArray(
			['manifest', 'modules']),
		A2(
			$elm$json$Json$Decode$index,
			0,
			A2(
				$elm$json$Json$Decode$field,
				'declarations',
				A2(
					$elm$json$Json$Decode$index,
					0,
					A2($elm$json$Json$Decode$field, 'tagName', $elm$json$Json$Decode$string))))),
	A2($elm$json$Json$Decode$field, 'widgetUuid', $danyx23$elm_uuid$Uuid$decoder),
	A2($elm$json$Json$Decode$field, 'versionUuid', $danyx23$elm_uuid$Uuid$decoder),
	A2(
		$elm$json$Json$Decode$at,
		_List_fromArray(
			['manifest', 'modules']),
		A2(
			$elm$json$Json$Decode$index,
			0,
			A2(
				$elm$json$Json$Decode$field,
				'declarations',
				A2(
					$elm$json$Json$Decode$index,
					0,
					A2($elm$json$Json$Decode$field, 'members', $author$project$Manifest$propertyDictDecoder))))),
	A2(
		$elm$json$Json$Decode$at,
		_List_fromArray(
			['manifest', 'modules']),
		A2(
			$elm$json$Json$Decode$index,
			0,
			A2(
				$elm$json$Json$Decode$field,
				'path',
				A2($elm$json$Json$Decode$map, $author$project$Manifest$extractFileName, $elm$json$Json$Decode$string)))));
var $elm$json$Json$Decode$oneOf = _Json_oneOf;
var $author$project$Manifest$simpleDecoder = A6(
	$elm$json$Json$Decode$map5,
	$author$project$Manifest$Manifest,
	A2($elm$json$Json$Decode$field, 'tagName', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'widgetUuid', $danyx23$elm_uuid$Uuid$decoder),
	A2($elm$json$Json$Decode$field, 'versionUuid', $danyx23$elm_uuid$Uuid$decoder),
	A2($elm$json$Json$Decode$field, 'properties', $author$project$Manifest$propertyDictDecoder),
	A2($elm$json$Json$Decode$field, 'fileName', $elm$json$Json$Decode$string));
var $author$project$Manifest$decoder = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[$author$project$Manifest$complicatedDecoder, $author$project$Manifest$simpleDecoder]));
var $author$project$StudioApp$AppInternals = F2(
	function (pages, dataElements) {
		return {dataElements: dataElements, pages: pages};
	});
var $author$project$DataElement$DataElement = F2(
	function (a, b) {
		return {$: 'DataElement', a: a, b: b};
	});
var $author$project$DataElement$CallAttendees = {$: 'CallAttendees'};
var $author$project$DataElement$DatepickerSelection = function (a) {
	return {$: 'DatepickerSelection', a: a};
};
var $author$project$DataElement$InteractiveSelectSelection = function (a) {
	return {$: 'InteractiveSelectSelection', a: a};
};
var $author$project$DataElement$Now = {$: 'Now'};
var $author$project$DataElement$RecordList = function (a) {
	return {$: 'RecordList', a: a};
};
var $author$project$DataElement$Singleton = function (a) {
	return {$: 'Singleton', a: a};
};
var $author$project$DataElement$Today = {$: 'Today'};
var $author$project$DataElement$FeedbackAccountChannelGoals = function (a) {
	return {$: 'FeedbackAccountChannelGoals', a: a};
};
var $author$project$DataElement$FeedbackAccountChannelGoals$Info = function (fields) {
	return {fields: fields};
};
var $author$project$FieldName$FieldName = function (a) {
	return {$: 'FieldName', a: a};
};
var $author$project$FieldName$decoder = A2($elm$json$Json$Decode$map, $author$project$FieldName$FieldName, $elm$json$Json$Decode$string);
var $author$project$FieldType$fromString = function (words) {
	var _v0 = $elm$core$String$toLower(words);
	switch (_v0) {
		case 'string':
			return $elm$core$Result$Ok($author$project$FieldType$StringType);
		case 'int':
			return $elm$core$Result$Ok($author$project$FieldType$NumberType);
		case 'integer':
			return $elm$core$Result$Ok($author$project$FieldType$NumberType);
		case 'float':
			return $elm$core$Result$Ok($author$project$FieldType$NumberType);
		case 'number':
			return $elm$core$Result$Ok($author$project$FieldType$NumberType);
		case 'date':
			return $elm$core$Result$Ok($author$project$FieldType$DateType);
		case 'date/time':
			return $elm$core$Result$Ok($author$project$FieldType$DateTimeType);
		case 'datetime':
			return $elm$core$Result$Ok($author$project$FieldType$DateTimeType);
		case 'bool':
			return $elm$core$Result$Ok($author$project$FieldType$BoolType);
		case 'boolean':
			return $elm$core$Result$Ok($author$project$FieldType$BoolType);
		default:
			return $elm$core$Result$Err('\'' + (words + '\' is not a valid FieldType'));
	}
};
var $author$project$FieldType$pickDecoder = A2($elm$core$Basics$composeR, $author$project$FieldType$fromString, $elm_community$json_extra$Json$Decode$Extra$fromResult);
var $author$project$FieldType$decoder = A2($elm$json$Json$Decode$andThen, $author$project$FieldType$pickDecoder, $elm$json$Json$Decode$string);
var $pzp1997$assoc_list$AssocList$D = function (a) {
	return {$: 'D', a: a};
};
var $pzp1997$assoc_list$AssocList$remove = F2(
	function (targetKey, _v0) {
		var alist = _v0.a;
		return $pzp1997$assoc_list$AssocList$D(
			A2(
				$elm$core$List$filter,
				function (_v1) {
					var key = _v1.a;
					return !_Utils_eq(key, targetKey);
				},
				alist));
	});
var $pzp1997$assoc_list$AssocList$insert = F3(
	function (key, value, dict) {
		var _v0 = A2($pzp1997$assoc_list$AssocList$remove, key, dict);
		var alteredAlist = _v0.a;
		return $pzp1997$assoc_list$AssocList$D(
			A2(
				$elm$core$List$cons,
				_Utils_Tuple2(key, value),
				alteredAlist));
	});
var $pzp1997$assoc_list$AssocList$fromList = function (alist) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (_v0, result) {
				var key = _v0.a;
				var value = _v0.b;
				return A3($pzp1997$assoc_list$AssocList$insert, key, value, result);
			}),
		$pzp1997$assoc_list$AssocList$D(_List_Nil),
		alist);
};
var $author$project$DataElement$selectedFieldsDecoder = A2(
	$elm$json$Json$Decode$field,
	'selectedFields',
	A2(
		$elm$json$Json$Decode$map,
		$pzp1997$assoc_list$AssocList$fromList,
		$elm$json$Json$Decode$list(
			A3(
				$elm$json$Json$Decode$map2,
				$elm$core$Tuple$pair,
				A2($elm$json$Json$Decode$field, 'name', $author$project$FieldName$decoder),
				A2($elm$json$Json$Decode$field, 'type', $author$project$FieldType$decoder)))));
var $author$project$DataElement$accountChannelGoalsDecoder = A2(
	$elm$json$Json$Decode$map,
	A2($elm$core$Basics$composeR, $author$project$DataElement$FeedbackAccountChannelGoals, $author$project$DataElement$RecordList),
	A2($elm$json$Json$Decode$map, $author$project$DataElement$FeedbackAccountChannelGoals$Info, $author$project$DataElement$selectedFieldsDecoder));
var $author$project$DataElement$FeedbackAccountData = function (a) {
	return {$: 'FeedbackAccountData', a: a};
};
var $author$project$DataElement$FeedbackAccountData$Info = function (fields) {
	return {fields: fields};
};
var $author$project$DataElement$accountDataDecoder = A2(
	$elm$json$Json$Decode$map,
	A2($elm$core$Basics$composeR, $author$project$DataElement$FeedbackAccountData, $author$project$DataElement$RecordList),
	A2($elm$json$Json$Decode$map, $author$project$DataElement$FeedbackAccountData$Info, $author$project$DataElement$selectedFieldsDecoder));
var $author$project$DataElement$FeedbackAccountProductGoals = function (a) {
	return {$: 'FeedbackAccountProductGoals', a: a};
};
var $author$project$DataElement$FeedbackAccountProductGoals$Info = function (fields) {
	return {fields: fields};
};
var $author$project$DataElement$accountProductGoalsDecoder = A2(
	$elm$json$Json$Decode$map,
	A2($elm$core$Basics$composeR, $author$project$DataElement$FeedbackAccountProductGoals, $author$project$DataElement$RecordList),
	A2($elm$json$Json$Decode$map, $author$project$DataElement$FeedbackAccountProductGoals$Info, $author$project$DataElement$selectedFieldsDecoder));
var $author$project$DataElement$FeedbackAccountProductMetrics = function (a) {
	return {$: 'FeedbackAccountProductMetrics', a: a};
};
var $author$project$DataElement$FeedbackAccountProductMetrics$Info = function (fields) {
	return {fields: fields};
};
var $author$project$DataElement$accountProductMetricsDecoder = A2(
	$elm$json$Json$Decode$map,
	A2($elm$core$Basics$composeR, $author$project$DataElement$FeedbackAccountProductMetrics, $author$project$DataElement$RecordList),
	A2($elm$json$Json$Decode$map, $author$project$DataElement$FeedbackAccountProductMetrics$Info, $author$project$DataElement$selectedFieldsDecoder));
var $author$project$DataElement$AlignedTerritories = function (a) {
	return {$: 'AlignedTerritories', a: a};
};
var $author$project$MyInsights$AlignedTerritoriesOnly = {$: 'AlignedTerritoriesOnly'};
var $author$project$MyInsights$IncludeChildTerritories = {$: 'IncludeChildTerritories'};
var $author$project$DataElement$AlignedTerritories$Info = function (includeChildren) {
	return {includeChildren: includeChildren};
};
var $elm$json$Json$Decode$bool = _Json_decodeBool;
var $author$project$DataElement$alignedTerritoriesDecoder = function () {
	var helper = function (bool) {
		return bool ? $author$project$MyInsights$IncludeChildTerritories : $author$project$MyInsights$AlignedTerritoriesOnly;
	};
	return A2(
		$elm$json$Json$Decode$map,
		A2($elm$core$Basics$composeR, $author$project$DataElement$AlignedTerritories, $author$project$DataElement$RecordList),
		A2(
			$elm$json$Json$Decode$map,
			$author$project$DataElement$AlignedTerritories$Info,
			A2(
				$elm$json$Json$Decode$map,
				helper,
				A2($elm$json$Json$Decode$field, 'includeChildren', $elm$json$Json$Decode$bool))));
}();
var $author$project$DataElement$FeedbackChannelGoals = function (a) {
	return {$: 'FeedbackChannelGoals', a: a};
};
var $author$project$DataElement$FeedbackChannelGoals$Info = function (fields) {
	return {fields: fields};
};
var $author$project$DataElement$channelGoalsDecoder = A2(
	$elm$json$Json$Decode$map,
	A2($elm$core$Basics$composeR, $author$project$DataElement$FeedbackChannelGoals, $author$project$DataElement$RecordList),
	A2($elm$json$Json$Decode$map, $author$project$DataElement$FeedbackChannelGoals$Info, $author$project$DataElement$selectedFieldsDecoder));
var $author$project$DataElement$ContextQuery = function (a) {
	return {$: 'ContextQuery', a: a};
};
var $author$project$ValidContextObject$Account = {$: 'Account'};
var $author$project$ValidContextObject$AccountPlan = {$: 'AccountPlan'};
var $author$project$ValidContextObject$Call = {$: 'Call'};
var $author$project$ValidContextObject$EMSpeaker = {$: 'EMSpeaker'};
var $author$project$ValidContextObject$HTMLReport = {$: 'HTMLReport'};
var $author$project$ValidContextObject$InventoryMonitoring = {$: 'InventoryMonitoring'};
var $author$project$ValidContextObject$Order = {$: 'Order'};
var $author$project$ValidContextObject$TSF = {$: 'TSF'};
var $author$project$ValidContextObject$User = {$: 'User'};
var $author$project$ValidContextObject$pickDecoder = function (objectName) {
	var _v0 = $elm$core$String$toLower(objectName);
	switch (_v0) {
		case 'account':
			return $elm$json$Json$Decode$succeed($author$project$ValidContextObject$Account);
		case 'account_plan_vod__c':
			return $elm$json$Json$Decode$succeed($author$project$ValidContextObject$AccountPlan);
		case 'accountplan':
			return $elm$json$Json$Decode$succeed($author$project$ValidContextObject$AccountPlan);
		case 'html_report_vod__c':
			return $elm$json$Json$Decode$succeed($author$project$ValidContextObject$HTMLReport);
		case 'htmlreport':
			return $elm$json$Json$Decode$succeed($author$project$ValidContextObject$HTMLReport);
		case 'order_vod__c':
			return $elm$json$Json$Decode$succeed($author$project$ValidContextObject$Order);
		case 'order':
			return $elm$json$Json$Decode$succeed($author$project$ValidContextObject$Order);
		case 'tsf_vod__c':
			return $elm$json$Json$Decode$succeed($author$project$ValidContextObject$TSF);
		case 'tsf':
			return $elm$json$Json$Decode$succeed($author$project$ValidContextObject$TSF);
		case 'user':
			return $elm$json$Json$Decode$succeed($author$project$ValidContextObject$User);
		case 'inventory_monitoring_vod__c':
			return $elm$json$Json$Decode$succeed($author$project$ValidContextObject$InventoryMonitoring);
		case 'inventorymonitoring':
			return $elm$json$Json$Decode$succeed($author$project$ValidContextObject$InventoryMonitoring);
		case 'em_speaker_vod__c':
			return $elm$json$Json$Decode$succeed($author$project$ValidContextObject$EMSpeaker);
		case 'call2_vod__c':
			return $elm$json$Json$Decode$succeed($author$project$ValidContextObject$Call);
		default:
			return $elm$json$Json$Decode$fail('Invalid context object');
	}
};
var $author$project$ValidContextObject$decoder = A2($elm$json$Json$Decode$andThen, $author$project$ValidContextObject$pickDecoder, $elm$json$Json$Decode$string);
var $elm$json$Json$Decode$keyValuePairs = _Json_decodeKeyValuePairs;
var $author$project$DataElement$ContextQueryInfo = F4(
	function (objectName, fieldName, fieldType, objectTag) {
		return {fieldName: fieldName, fieldType: fieldType, objectName: objectName, objectTag: objectTag};
	});
var $author$project$FieldName$fromString = $author$project$FieldName$FieldName;
var $pzp1997$assoc_list$AssocList$get = F2(
	function (targetKey, _v0) {
		get:
		while (true) {
			var alist = _v0.a;
			if (!alist.b) {
				return $elm$core$Maybe$Nothing;
			} else {
				var _v2 = alist.a;
				var key = _v2.a;
				var value = _v2.b;
				var rest = alist.b;
				if (_Utils_eq(key, targetKey)) {
					return $elm$core$Maybe$Just(value);
				} else {
					var $temp$targetKey = targetKey,
						$temp$_v0 = $pzp1997$assoc_list$AssocList$D(rest);
					targetKey = $temp$targetKey;
					_v0 = $temp$_v0;
					continue get;
				}
			}
		}
	});
var $author$project$DataElement$makeContextQueryInfo = F3(
	function (elementName, fields, objectTags) {
		if (fields.b && (!fields.b.b)) {
			var _v1 = fields.a;
			var fieldName = _v1.a;
			var fieldType = _v1.b;
			return $elm$core$Result$Ok(
				A4(
					$author$project$DataElement$ContextQueryInfo,
					elementName,
					$author$project$FieldName$fromString(fieldName),
					fieldType,
					A2(
						$pzp1997$assoc_list$AssocList$get,
						$author$project$FieldName$fromString(fieldName),
						objectTags)));
		} else {
			return $elm$core$Result$Err('A Context Query must have exactly one field');
		}
	});
var $elm$json$Json$Decode$map3 = _Json_map3;
var $author$project$ObjectName$ObjectName = function (a) {
	return {$: 'ObjectName', a: a};
};
var $author$project$ObjectName$decoder = A2($elm$json$Json$Decode$map, $author$project$ObjectName$ObjectName, $elm$json$Json$Decode$string);
var $pzp1997$assoc_list$AssocList$empty = $pzp1997$assoc_list$AssocList$D(_List_Nil);
var $elm$core$Tuple$mapFirst = F2(
	function (func, _v0) {
		var x = _v0.a;
		var y = _v0.b;
		return _Utils_Tuple2(
			func(x),
			y);
	});
var $elm$json$Json$Decode$null = _Json_decodeNull;
var $elm$json$Json$Decode$nullable = function (decoder) {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				$elm$json$Json$Decode$null($elm$core$Maybe$Nothing),
				A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, decoder)
			]));
};
var $elm$json$Json$Decode$value = _Json_decodeValue;
var $elm_community$json_extra$Json$Decode$Extra$optionalField = F2(
	function (fieldName, decoder) {
		var finishDecoding = function (json) {
			var _v0 = A2(
				$elm$json$Json$Decode$decodeValue,
				A2($elm$json$Json$Decode$field, fieldName, $elm$json$Json$Decode$value),
				json);
			if (_v0.$ === 'Ok') {
				var val = _v0.a;
				return A2(
					$elm$json$Json$Decode$map,
					$elm$core$Maybe$Just,
					A2($elm$json$Json$Decode$field, fieldName, decoder));
			} else {
				return $elm$json$Json$Decode$succeed($elm$core$Maybe$Nothing);
			}
		};
		return A2($elm$json$Json$Decode$andThen, finishDecoding, $elm$json$Json$Decode$value);
	});
var $elm_community$json_extra$Json$Decode$Extra$optionalNullableField = F2(
	function (fieldName, decoder) {
		return A2(
			$elm$json$Json$Decode$map,
			$elm$core$Maybe$andThen($elm$core$Basics$identity),
			A2(
				$elm_community$json_extra$Json$Decode$Extra$optionalField,
				fieldName,
				$elm$json$Json$Decode$nullable(decoder)));
	});
var $author$project$DataElement$objectTagsDecoder = A2(
	$elm$json$Json$Decode$map,
	$elm$core$Maybe$withDefault($pzp1997$assoc_list$AssocList$empty),
	A2(
		$elm_community$json_extra$Json$Decode$Extra$optionalNullableField,
		'objectTags',
		A2(
			$elm$json$Json$Decode$map,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$map(
					$elm$core$Tuple$mapFirst($author$project$FieldName$fromString)),
				$pzp1997$assoc_list$AssocList$fromList),
			$elm$json$Json$Decode$keyValuePairs($author$project$ObjectName$decoder))));
var $author$project$DataElement$contextQueryDecoder = A2(
	$elm$json$Json$Decode$map,
	A2($elm$core$Basics$composeR, $author$project$DataElement$ContextQuery, $author$project$DataElement$Singleton),
	A2(
		$elm$json$Json$Decode$andThen,
		$elm_community$json_extra$Json$Decode$Extra$fromResult,
		A4(
			$elm$json$Json$Decode$map3,
			$author$project$DataElement$makeContextQueryInfo,
			A2($elm$json$Json$Decode$field, 'object', $author$project$ValidContextObject$decoder),
			A2(
				$elm$json$Json$Decode$field,
				'fields',
				$elm$json$Json$Decode$keyValuePairs(
					A2($elm$json$Json$Decode$field, 'dataType', $author$project$FieldType$decoder))),
			$author$project$DataElement$objectTagsDecoder)));
var $author$project$DataElement$CrmDataEngineQuery$Info = F5(
	function (table, fields, whereClause, sort, limit) {
		return {fields: fields, limit: limit, sort: sort, table: table, whereClause: whereClause};
	});
var $author$project$DataElement$CrmDataEngine$Field$Concat = function (a) {
	return {$: 'Concat', a: a};
};
var $author$project$DataElement$CrmDataEngine$Field$Count = function (a) {
	return {$: 'Count', a: a};
};
var $author$project$DataElement$CrmDataEngine$Field$CountDistinct = function (a) {
	return {$: 'CountDistinct', a: a};
};
var $author$project$DataElement$CrmDataEngine$Field$DateTruncate = F2(
	function (a, b) {
		return {$: 'DateTruncate', a: a, b: b};
	});
var $author$project$DataElement$CrmDataEngine$Field$DimensionField = F2(
	function (a, b) {
		return {$: 'DimensionField', a: a, b: b};
	});
var $author$project$DataElement$CrmDataEngine$Field$Divide = F2(
	function (a, b) {
		return {$: 'Divide', a: a, b: b};
	});
var $author$project$DataElement$CrmDataEngine$Field$Max = F2(
	function (a, b) {
		return {$: 'Max', a: a, b: b};
	});
var $author$project$DataElement$CrmDataEngine$Field$MetricField = F2(
	function (a, b) {
		return {$: 'MetricField', a: a, b: b};
	});
var $author$project$DataElement$CrmDataEngine$Field$Min = F2(
	function (a, b) {
		return {$: 'Min', a: a, b: b};
	});
var $author$project$DataElement$CrmDataEngine$Field$Minus = F2(
	function (a, b) {
		return {$: 'Minus', a: a, b: b};
	});
var $author$project$DataElement$CrmDataEngine$Field$Multiply = F2(
	function (a, b) {
		return {$: 'Multiply', a: a, b: b};
	});
var $author$project$DataElement$CrmDataEngine$Field$Plus = F2(
	function (a, b) {
		return {$: 'Plus', a: a, b: b};
	});
var $author$project$DataElement$CrmDataEngine$Field$PureField = F2(
	function (a, b) {
		return {$: 'PureField', a: a, b: b};
	});
var $author$project$DataElement$CrmDataEngine$Field$Sum = function (a) {
	return {$: 'Sum', a: a};
};
var $author$project$DataElement$CrmDataEngine$Field$ConcatField = function (a) {
	return {$: 'ConcatField', a: a};
};
var $author$project$DataElement$CrmDataEngine$Field$concatFragmentFieldDecoder = A2($elm$json$Json$Decode$map, $author$project$DataElement$CrmDataEngine$Field$ConcatField, $author$project$FieldName$decoder);
var $author$project$DataElement$CrmDataEngine$Field$ConcatQuote = function (a) {
	return {$: 'ConcatQuote', a: a};
};
var $author$project$DataElement$CrmDataEngine$Field$concatFragmentQuoteDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$DataElement$CrmDataEngine$Field$ConcatQuote,
	A2($elm$json$Json$Decode$field, 'text', $elm$json$Json$Decode$string));
var $author$project$DataElement$CrmDataEngine$Field$concatFragmentDecoder = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[$author$project$DataElement$CrmDataEngine$Field$concatFragmentQuoteDecoder, $author$project$DataElement$CrmDataEngine$Field$concatFragmentFieldDecoder]));
var $author$project$ComparableType$DateComp = {$: 'DateComp'};
var $author$project$ComparableType$DateTimeComp = {$: 'DateTimeComp'};
var $author$project$ComparableType$NumberComp = {$: 'NumberComp'};
var $author$project$ComparableType$StringComp = {$: 'StringComp'};
var $author$project$ComparableType$fromString = function (words) {
	var _v0 = $elm$core$String$toLower(words);
	switch (_v0) {
		case 'string':
			return $elm$core$Result$Ok($author$project$ComparableType$StringComp);
		case 'int':
			return $elm$core$Result$Ok($author$project$ComparableType$NumberComp);
		case 'float':
			return $elm$core$Result$Ok($author$project$ComparableType$NumberComp);
		case 'number':
			return $elm$core$Result$Ok($author$project$ComparableType$NumberComp);
		case 'date':
			return $elm$core$Result$Ok($author$project$ComparableType$DateComp);
		case 'date/time':
			return $elm$core$Result$Ok($author$project$ComparableType$DateTimeComp);
		case 'datetime':
			return $elm$core$Result$Ok($author$project$ComparableType$DateTimeComp);
		default:
			return $elm$core$Result$Err('\'' + (words + '\' is not a valid ComparableType'));
	}
};
var $author$project$ComparableType$pickDecoder = A2($elm$core$Basics$composeR, $author$project$ComparableType$fromString, $elm_community$json_extra$Json$Decode$Extra$fromResult);
var $author$project$ComparableType$decoder = A2($elm$json$Json$Decode$andThen, $author$project$ComparableType$pickDecoder, $elm$json$Json$Decode$string);
var $author$project$DataElement$CrmDataEngine$ExpandedDateInterval$Century = {$: 'Century'};
var $author$project$DataElement$CrmDataEngine$ExpandedDateInterval$Day = {$: 'Day'};
var $author$project$DataElement$CrmDataEngine$ExpandedDateInterval$Decade = {$: 'Decade'};
var $author$project$DataElement$CrmDataEngine$ExpandedDateInterval$Hour = {$: 'Hour'};
var $author$project$DataElement$CrmDataEngine$ExpandedDateInterval$Millennium = {$: 'Millennium'};
var $author$project$DataElement$CrmDataEngine$ExpandedDateInterval$Milliseconds = {$: 'Milliseconds'};
var $author$project$DataElement$CrmDataEngine$ExpandedDateInterval$Minute = {$: 'Minute'};
var $author$project$DataElement$CrmDataEngine$ExpandedDateInterval$Month = {$: 'Month'};
var $author$project$DataElement$CrmDataEngine$ExpandedDateInterval$Quarter = {$: 'Quarter'};
var $author$project$DataElement$CrmDataEngine$ExpandedDateInterval$Second = {$: 'Second'};
var $author$project$DataElement$CrmDataEngine$ExpandedDateInterval$Week = {$: 'Week'};
var $author$project$DataElement$CrmDataEngine$ExpandedDateInterval$Year = {$: 'Year'};
var $author$project$DataElement$CrmDataEngine$ExpandedDateInterval$fromString = function (words) {
	var _v0 = $elm$core$String$toLower(words);
	switch (_v0) {
		case 'milliseconds':
			return $elm$core$Result$Ok($author$project$DataElement$CrmDataEngine$ExpandedDateInterval$Milliseconds);
		case 'second':
			return $elm$core$Result$Ok($author$project$DataElement$CrmDataEngine$ExpandedDateInterval$Second);
		case 'minute':
			return $elm$core$Result$Ok($author$project$DataElement$CrmDataEngine$ExpandedDateInterval$Minute);
		case 'hour':
			return $elm$core$Result$Ok($author$project$DataElement$CrmDataEngine$ExpandedDateInterval$Hour);
		case 'day':
			return $elm$core$Result$Ok($author$project$DataElement$CrmDataEngine$ExpandedDateInterval$Day);
		case 'week':
			return $elm$core$Result$Ok($author$project$DataElement$CrmDataEngine$ExpandedDateInterval$Week);
		case 'month':
			return $elm$core$Result$Ok($author$project$DataElement$CrmDataEngine$ExpandedDateInterval$Month);
		case 'quarter':
			return $elm$core$Result$Ok($author$project$DataElement$CrmDataEngine$ExpandedDateInterval$Quarter);
		case 'year':
			return $elm$core$Result$Ok($author$project$DataElement$CrmDataEngine$ExpandedDateInterval$Year);
		case 'decade':
			return $elm$core$Result$Ok($author$project$DataElement$CrmDataEngine$ExpandedDateInterval$Decade);
		case 'century':
			return $elm$core$Result$Ok($author$project$DataElement$CrmDataEngine$ExpandedDateInterval$Century);
		case 'millennium':
			return $elm$core$Result$Ok($author$project$DataElement$CrmDataEngine$ExpandedDateInterval$Millennium);
		default:
			return $elm$core$Result$Err('Could not parse \'' + (words + '\' as a Date Interval'));
	}
};
var $author$project$DataElement$CrmDataEngine$ExpandedDateInterval$decoder = A2(
	$elm$json$Json$Decode$andThen,
	A2($elm$core$Basics$composeR, $author$project$DataElement$CrmDataEngine$ExpandedDateInterval$fromString, $elm_community$json_extra$Json$Decode$Extra$fromResult),
	$elm$json$Json$Decode$string);
var $author$project$FieldName$toString = function (_v0) {
	var name = _v0.a;
	return name;
};
var $author$project$DataElement$CrmDataEngine$Field$fieldTypeToDecoder = function (type_) {
	var _v0 = $elm$core$String$toLower(
		$author$project$FieldName$toString(type_));
	switch (_v0) {
		case 'field':
			return A3(
				$elm$json$Json$Decode$map2,
				$author$project$DataElement$CrmDataEngine$Field$PureField,
				A2($elm$json$Json$Decode$field, 'field', $author$project$FieldName$decoder),
				A2($elm$json$Json$Decode$field, 'dataType', $author$project$FieldType$decoder));
		case 'concat':
			return A3(
				$elm$json$Json$Decode$map2,
				$author$project$DataElement$CrmDataEngine$Field$DimensionField,
				A2($elm$json$Json$Decode$field, 'as', $author$project$FieldName$decoder),
				A2(
					$elm$json$Json$Decode$map,
					$author$project$DataElement$CrmDataEngine$Field$Concat,
					A2(
						$elm$json$Json$Decode$field,
						'arguments',
						$elm$json$Json$Decode$list($author$project$DataElement$CrmDataEngine$Field$concatFragmentDecoder))));
		case 'date_trunc':
			return A3(
				$elm$json$Json$Decode$map2,
				$author$project$DataElement$CrmDataEngine$Field$DimensionField,
				A2($elm$json$Json$Decode$field, 'as', $author$project$FieldName$decoder),
				A3(
					$elm$json$Json$Decode$map2,
					$author$project$DataElement$CrmDataEngine$Field$DateTruncate,
					A2($elm$json$Json$Decode$field, 'field', $author$project$FieldName$decoder),
					A2($elm$json$Json$Decode$field, 'interval', $author$project$DataElement$CrmDataEngine$ExpandedDateInterval$decoder)));
		case 'div':
			return A3(
				$elm$json$Json$Decode$map2,
				$author$project$DataElement$CrmDataEngine$Field$DimensionField,
				A2($elm$json$Json$Decode$field, 'as', $author$project$FieldName$decoder),
				A3(
					$elm$json$Json$Decode$map2,
					$author$project$DataElement$CrmDataEngine$Field$Divide,
					A2($elm$json$Json$Decode$field, 'fieldA', $author$project$FieldName$decoder),
					A2($elm$json$Json$Decode$field, 'fieldB', $author$project$FieldName$decoder)));
		case 'multi':
			return A3(
				$elm$json$Json$Decode$map2,
				$author$project$DataElement$CrmDataEngine$Field$DimensionField,
				A2($elm$json$Json$Decode$field, 'as', $author$project$FieldName$decoder),
				A3(
					$elm$json$Json$Decode$map2,
					$author$project$DataElement$CrmDataEngine$Field$Multiply,
					A2($elm$json$Json$Decode$field, 'fieldA', $author$project$FieldName$decoder),
					A2($elm$json$Json$Decode$field, 'fieldB', $author$project$FieldName$decoder)));
		case 'minus':
			return A3(
				$elm$json$Json$Decode$map2,
				$author$project$DataElement$CrmDataEngine$Field$DimensionField,
				A2($elm$json$Json$Decode$field, 'as', $author$project$FieldName$decoder),
				A3(
					$elm$json$Json$Decode$map2,
					$author$project$DataElement$CrmDataEngine$Field$Minus,
					A2($elm$json$Json$Decode$field, 'fieldA', $author$project$FieldName$decoder),
					A2($elm$json$Json$Decode$field, 'fieldB', $author$project$FieldName$decoder)));
		case 'plus':
			return A3(
				$elm$json$Json$Decode$map2,
				$author$project$DataElement$CrmDataEngine$Field$DimensionField,
				A2($elm$json$Json$Decode$field, 'as', $author$project$FieldName$decoder),
				A3(
					$elm$json$Json$Decode$map2,
					$author$project$DataElement$CrmDataEngine$Field$Plus,
					A2($elm$json$Json$Decode$field, 'fieldA', $author$project$FieldName$decoder),
					A2($elm$json$Json$Decode$field, 'fieldB', $author$project$FieldName$decoder)));
		case 'sum':
			return A3(
				$elm$json$Json$Decode$map2,
				$author$project$DataElement$CrmDataEngine$Field$MetricField,
				A2($elm$json$Json$Decode$field, 'as', $author$project$FieldName$decoder),
				A2(
					$elm$json$Json$Decode$map,
					$author$project$DataElement$CrmDataEngine$Field$Sum,
					A2($elm$json$Json$Decode$field, 'field', $author$project$FieldName$decoder)));
		case 'count':
			return A3(
				$elm$json$Json$Decode$map2,
				$author$project$DataElement$CrmDataEngine$Field$MetricField,
				A2($elm$json$Json$Decode$field, 'as', $author$project$FieldName$decoder),
				A2(
					$elm$json$Json$Decode$map,
					$author$project$DataElement$CrmDataEngine$Field$Count,
					A2($elm$json$Json$Decode$field, 'field', $author$project$FieldName$decoder)));
		case 'count_distinct':
			return A3(
				$elm$json$Json$Decode$map2,
				$author$project$DataElement$CrmDataEngine$Field$MetricField,
				A2($elm$json$Json$Decode$field, 'as', $author$project$FieldName$decoder),
				A2(
					$elm$json$Json$Decode$map,
					$author$project$DataElement$CrmDataEngine$Field$CountDistinct,
					A2($elm$json$Json$Decode$field, 'field', $author$project$FieldName$decoder)));
		case 'max':
			return A3(
				$elm$json$Json$Decode$map2,
				$author$project$DataElement$CrmDataEngine$Field$MetricField,
				A2($elm$json$Json$Decode$field, 'as', $author$project$FieldName$decoder),
				A3(
					$elm$json$Json$Decode$map2,
					$author$project$DataElement$CrmDataEngine$Field$Max,
					A2($elm$json$Json$Decode$field, 'field', $author$project$FieldName$decoder),
					A2($elm$json$Json$Decode$field, 'dataType', $author$project$ComparableType$decoder)));
		case 'min':
			return A3(
				$elm$json$Json$Decode$map2,
				$author$project$DataElement$CrmDataEngine$Field$MetricField,
				A2($elm$json$Json$Decode$field, 'as', $author$project$FieldName$decoder),
				A3(
					$elm$json$Json$Decode$map2,
					$author$project$DataElement$CrmDataEngine$Field$Min,
					A2($elm$json$Json$Decode$field, 'field', $author$project$FieldName$decoder),
					A2($elm$json$Json$Decode$field, 'dataType', $author$project$ComparableType$decoder)));
		default:
			return $elm$json$Json$Decode$fail(
				'Could not parse ' + ($author$project$FieldName$toString(type_) + 'as a field.'));
	}
};
var $author$project$DataElement$CrmDataEngine$Field$decoder = A2(
	$elm$json$Json$Decode$andThen,
	$author$project$DataElement$CrmDataEngine$Field$fieldTypeToDecoder,
	A2($elm$json$Json$Decode$field, 'type', $author$project$FieldName$decoder));
var $author$project$DataElement$CrmDataEngine$Where$AllOf = function (a) {
	return {$: 'AllOf', a: a};
};
var $author$project$DataElement$CrmDataEngine$Where$AnyOf = function (a) {
	return {$: 'AnyOf', a: a};
};
var $author$project$DataElement$CrmDataEngine$Where$Eq = F2(
	function (a, b) {
		return {$: 'Eq', a: a, b: b};
	});
var $author$project$DataElement$CrmDataEngine$Where$Gt = F2(
	function (a, b) {
		return {$: 'Gt', a: a, b: b};
	});
var $author$project$DataElement$CrmDataEngine$Where$Gte = F2(
	function (a, b) {
		return {$: 'Gte', a: a, b: b};
	});
var $author$project$DataElement$CrmDataEngine$Where$In = F2(
	function (a, b) {
		return {$: 'In', a: a, b: b};
	});
var $author$project$DataElement$CrmDataEngine$Where$IsNotNull = function (a) {
	return {$: 'IsNotNull', a: a};
};
var $author$project$DataElement$CrmDataEngine$Where$IsNull = function (a) {
	return {$: 'IsNull', a: a};
};
var $author$project$DataElement$CrmDataEngine$Where$Lt = F2(
	function (a, b) {
		return {$: 'Lt', a: a, b: b};
	});
var $author$project$DataElement$CrmDataEngine$Where$Lte = F2(
	function (a, b) {
		return {$: 'Lte', a: a, b: b};
	});
var $author$project$DataElement$CrmDataEngine$Where$NotEq = F2(
	function (a, b) {
		return {$: 'NotEq', a: a, b: b};
	});
var $author$project$DataElement$CrmDataEngine$Where$BetweenDate = F3(
	function (a, b, c) {
		return {$: 'BetweenDate', a: a, b: b, c: c};
	});
var $author$project$DataElement$CrmDataEngine$Where$BetweenDateTime = F3(
	function (a, b, c) {
		return {$: 'BetweenDateTime', a: a, b: b, c: c};
	});
var $author$project$DataElement$CrmDataEngine$Where$BetweenNumber = F3(
	function (a, b, c) {
		return {$: 'BetweenNumber', a: a, b: b, c: c};
	});
var $author$project$DataElement$CrmDataEngine$Where$BetweenString = F3(
	function (a, b, c) {
		return {$: 'BetweenString', a: a, b: b, c: c};
	});
var $author$project$DataElement$CrmDataEngine$Where$betweenDecoder = F2(
	function (constructor, innerDecoder) {
		return A4(
			$elm$json$Json$Decode$map3,
			constructor,
			A2($elm$json$Json$Decode$field, 'field', $author$project$FieldName$decoder),
			A2($elm$json$Json$Decode$field, 'startValue', innerDecoder),
			A2($elm$json$Json$Decode$field, 'endValue', innerDecoder));
	});
var $author$project$DataElement$Expression$GlobalAdd = F2(
	function (a, b) {
		return {$: 'GlobalAdd', a: a, b: b};
	});
var $author$project$DataElement$Expression$GlobalAll = function (a) {
	return {$: 'GlobalAll', a: a};
};
var $author$project$DataElement$Expression$GlobalAllBoolsInField = F2(
	function (a, b) {
		return {$: 'GlobalAllBoolsInField', a: a, b: b};
	});
var $author$project$DataElement$Expression$GlobalAllDateTimesInField = F2(
	function (a, b) {
		return {$: 'GlobalAllDateTimesInField', a: a, b: b};
	});
var $author$project$DataElement$Expression$GlobalAllDatesInField = F2(
	function (a, b) {
		return {$: 'GlobalAllDatesInField', a: a, b: b};
	});
var $author$project$DataElement$Expression$GlobalAllNumbersInField = F2(
	function (a, b) {
		return {$: 'GlobalAllNumbersInField', a: a, b: b};
	});
var $author$project$DataElement$Expression$GlobalAllStringsInField = F2(
	function (a, b) {
		return {$: 'GlobalAllStringsInField', a: a, b: b};
	});
var $author$project$DataElement$Expression$GlobalAny = function (a) {
	return {$: 'GlobalAny', a: a};
};
var $author$project$DataElement$Expression$GlobalBoolExpr = function (a) {
	return {$: 'GlobalBoolExpr', a: a};
};
var $author$project$DataElement$Expression$GlobalBoolHardcoded = function (a) {
	return {$: 'GlobalBoolHardcoded', a: a};
};
var $author$project$DataElement$Expression$GlobalBoolIf = F3(
	function (a, b, c) {
		return {$: 'GlobalBoolIf', a: a, b: b, c: c};
	});
var $author$project$DataElement$Expression$GlobalBoolListIf = F3(
	function (a, b, c) {
		return {$: 'GlobalBoolListIf', a: a, b: b, c: c};
	});
var $author$project$DataElement$Expression$GlobalBoolLookup = F2(
	function (a, b) {
		return {$: 'GlobalBoolLookup', a: a, b: b};
	});
var $author$project$DataElement$Expression$GlobalBoolsAsList = function (a) {
	return {$: 'GlobalBoolsAsList', a: a};
};
var $author$project$DataElement$Expression$GlobalChallengeReasons = function (a) {
	return {$: 'GlobalChallengeReasons', a: a};
};
var $author$project$DataElement$Expression$GlobalCompDateListExpr = function (a) {
	return {$: 'GlobalCompDateListExpr', a: a};
};
var $author$project$DataElement$Expression$GlobalCompDateTimeListExpr = function (a) {
	return {$: 'GlobalCompDateTimeListExpr', a: a};
};
var $author$project$DataElement$Expression$GlobalCompNumberListExpr = function (a) {
	return {$: 'GlobalCompNumberListExpr', a: a};
};
var $author$project$DataElement$Expression$GlobalCompStringListExpr = function (a) {
	return {$: 'GlobalCompStringListExpr', a: a};
};
var $author$project$DataElement$Expression$GlobalConcat = F2(
	function (a, b) {
		return {$: 'GlobalConcat', a: a, b: b};
	});
var $author$project$DataElement$Expression$GlobalCountUnique = function (a) {
	return {$: 'GlobalCountUnique', a: a};
};
var $author$project$DataElement$Expression$GlobalDateAdd = F3(
	function (a, b, c) {
		return {$: 'GlobalDateAdd', a: a, b: b, c: c};
	});
var $author$project$DataElement$Expression$GlobalDateCeiling = F2(
	function (a, b) {
		return {$: 'GlobalDateCeiling', a: a, b: b};
	});
var $author$project$DataElement$Expression$GlobalDateExpr = function (a) {
	return {$: 'GlobalDateExpr', a: a};
};
var $author$project$DataElement$Expression$GlobalDateFloor = F2(
	function (a, b) {
		return {$: 'GlobalDateFloor', a: a, b: b};
	});
var $author$project$DataElement$Expression$GlobalDateHardcoded = function (a) {
	return {$: 'GlobalDateHardcoded', a: a};
};
var $author$project$DataElement$Expression$GlobalDateIf = F3(
	function (a, b, c) {
		return {$: 'GlobalDateIf', a: a, b: b, c: c};
	});
var $author$project$DataElement$Expression$GlobalDateListIf = F3(
	function (a, b, c) {
		return {$: 'GlobalDateListIf', a: a, b: b, c: c};
	});
var $author$project$DataElement$Expression$GlobalDateLookup = F2(
	function (a, b) {
		return {$: 'GlobalDateLookup', a: a, b: b};
	});
var $author$project$DataElement$Expression$GlobalDateSubtract = F3(
	function (a, b, c) {
		return {$: 'GlobalDateSubtract', a: a, b: b, c: c};
	});
var $author$project$DataElement$Expression$GlobalDateTimeExpr = function (a) {
	return {$: 'GlobalDateTimeExpr', a: a};
};
var $author$project$DataElement$Expression$GlobalDateTimeHardcoded = function (a) {
	return {$: 'GlobalDateTimeHardcoded', a: a};
};
var $author$project$DataElement$Expression$GlobalDateTimeIf = F3(
	function (a, b, c) {
		return {$: 'GlobalDateTimeIf', a: a, b: b, c: c};
	});
var $author$project$DataElement$Expression$GlobalDateTimeListIf = F3(
	function (a, b, c) {
		return {$: 'GlobalDateTimeListIf', a: a, b: b, c: c};
	});
var $author$project$DataElement$Expression$GlobalDateTimeLookup = F2(
	function (a, b) {
		return {$: 'GlobalDateTimeLookup', a: a, b: b};
	});
var $author$project$DataElement$Expression$GlobalDateTimeToDate = function (a) {
	return {$: 'GlobalDateTimeToDate', a: a};
};
var $author$project$DataElement$Expression$GlobalDateTimesAsList = function (a) {
	return {$: 'GlobalDateTimesAsList', a: a};
};
var $author$project$DataElement$Expression$GlobalDatesAsList = function (a) {
	return {$: 'GlobalDatesAsList', a: a};
};
var $author$project$DataElement$Expression$GlobalDayInMonth = function (a) {
	return {$: 'GlobalDayInMonth', a: a};
};
var $author$project$DataElement$Expression$GlobalDivide = F2(
	function (a, b) {
		return {$: 'GlobalDivide', a: a, b: b};
	});
var $author$project$DataElement$Expression$GlobalEqualBool = F2(
	function (a, b) {
		return {$: 'GlobalEqualBool', a: a, b: b};
	});
var $author$project$DataElement$Expression$GlobalEqualDate = F2(
	function (a, b) {
		return {$: 'GlobalEqualDate', a: a, b: b};
	});
var $author$project$DataElement$Expression$GlobalEqualDateTime = F2(
	function (a, b) {
		return {$: 'GlobalEqualDateTime', a: a, b: b};
	});
var $author$project$DataElement$Expression$GlobalEqualNumber = F2(
	function (a, b) {
		return {$: 'GlobalEqualNumber', a: a, b: b};
	});
var $author$project$DataElement$Expression$GlobalEqualString = F2(
	function (a, b) {
		return {$: 'GlobalEqualString', a: a, b: b};
	});
var $author$project$DataElement$Expression$GlobalFormatDate = F2(
	function (a, b) {
		return {$: 'GlobalFormatDate', a: a, b: b};
	});
var $author$project$DataElement$Expression$GlobalFormatDateLocaleAware = function (a) {
	return {$: 'GlobalFormatDateLocaleAware', a: a};
};
var $author$project$DataElement$Expression$GlobalFormatDateTime = function (a) {
	return {$: 'GlobalFormatDateTime', a: a};
};
var $author$project$DataElement$Expression$GlobalFormatNumber = F2(
	function (a, b) {
		return {$: 'GlobalFormatNumber', a: a, b: b};
	});
var $author$project$DataElement$Expression$GlobalGTDate = F2(
	function (a, b) {
		return {$: 'GlobalGTDate', a: a, b: b};
	});
var $author$project$DataElement$Expression$GlobalGTDateTime = F2(
	function (a, b) {
		return {$: 'GlobalGTDateTime', a: a, b: b};
	});
var $author$project$DataElement$Expression$GlobalGTEDate = F2(
	function (a, b) {
		return {$: 'GlobalGTEDate', a: a, b: b};
	});
var $author$project$DataElement$Expression$GlobalGTEDateTime = F2(
	function (a, b) {
		return {$: 'GlobalGTEDateTime', a: a, b: b};
	});
var $author$project$DataElement$Expression$GlobalGTENumber = F2(
	function (a, b) {
		return {$: 'GlobalGTENumber', a: a, b: b};
	});
var $author$project$DataElement$Expression$GlobalGTEString = F2(
	function (a, b) {
		return {$: 'GlobalGTEString', a: a, b: b};
	});
var $author$project$DataElement$Expression$GlobalGTNumber = F2(
	function (a, b) {
		return {$: 'GlobalGTNumber', a: a, b: b};
	});
var $author$project$DataElement$Expression$GlobalGTString = F2(
	function (a, b) {
		return {$: 'GlobalGTString', a: a, b: b};
	});
var $author$project$DataElement$Expression$GlobalIsNotNull = function (a) {
	return {$: 'GlobalIsNotNull', a: a};
};
var $author$project$DataElement$Expression$GlobalIsNull = function (a) {
	return {$: 'GlobalIsNull', a: a};
};
var $author$project$DataElement$Expression$GlobalLTDate = F2(
	function (a, b) {
		return {$: 'GlobalLTDate', a: a, b: b};
	});
var $author$project$DataElement$Expression$GlobalLTDateTime = F2(
	function (a, b) {
		return {$: 'GlobalLTDateTime', a: a, b: b};
	});
var $author$project$DataElement$Expression$GlobalLTEDate = F2(
	function (a, b) {
		return {$: 'GlobalLTEDate', a: a, b: b};
	});
var $author$project$DataElement$Expression$GlobalLTEDateTime = F2(
	function (a, b) {
		return {$: 'GlobalLTEDateTime', a: a, b: b};
	});
var $author$project$DataElement$Expression$GlobalLTENumber = F2(
	function (a, b) {
		return {$: 'GlobalLTENumber', a: a, b: b};
	});
var $author$project$DataElement$Expression$GlobalLTEString = F2(
	function (a, b) {
		return {$: 'GlobalLTEString', a: a, b: b};
	});
var $author$project$DataElement$Expression$GlobalLTNumber = F2(
	function (a, b) {
		return {$: 'GlobalLTNumber', a: a, b: b};
	});
var $author$project$DataElement$Expression$GlobalLTString = F2(
	function (a, b) {
		return {$: 'GlobalLTString', a: a, b: b};
	});
var $author$project$DataElement$Expression$GlobalMaxDate = function (a) {
	return {$: 'GlobalMaxDate', a: a};
};
var $author$project$DataElement$Expression$GlobalMaxDateTime = function (a) {
	return {$: 'GlobalMaxDateTime', a: a};
};
var $author$project$DataElement$Expression$GlobalMaxNumber = function (a) {
	return {$: 'GlobalMaxNumber', a: a};
};
var $author$project$DataElement$Expression$GlobalMaxString = function (a) {
	return {$: 'GlobalMaxString', a: a};
};
var $author$project$DataElement$Expression$GlobalMinDate = function (a) {
	return {$: 'GlobalMinDate', a: a};
};
var $author$project$DataElement$Expression$GlobalMinDateTime = function (a) {
	return {$: 'GlobalMinDateTime', a: a};
};
var $author$project$DataElement$Expression$GlobalMinNumber = function (a) {
	return {$: 'GlobalMinNumber', a: a};
};
var $author$project$DataElement$Expression$GlobalMinString = function (a) {
	return {$: 'GlobalMinString', a: a};
};
var $author$project$DataElement$Expression$GlobalMonthNumber = function (a) {
	return {$: 'GlobalMonthNumber', a: a};
};
var $author$project$DataElement$Expression$GlobalMultiply = F2(
	function (a, b) {
		return {$: 'GlobalMultiply', a: a, b: b};
	});
var $author$project$DataElement$Expression$GlobalNot = function (a) {
	return {$: 'GlobalNot', a: a};
};
var $author$project$DataElement$Expression$GlobalNotEqualBool = F2(
	function (a, b) {
		return {$: 'GlobalNotEqualBool', a: a, b: b};
	});
var $author$project$DataElement$Expression$GlobalNotEqualDate = F2(
	function (a, b) {
		return {$: 'GlobalNotEqualDate', a: a, b: b};
	});
var $author$project$DataElement$Expression$GlobalNotEqualDateTime = F2(
	function (a, b) {
		return {$: 'GlobalNotEqualDateTime', a: a, b: b};
	});
var $author$project$DataElement$Expression$GlobalNotEqualNumber = F2(
	function (a, b) {
		return {$: 'GlobalNotEqualNumber', a: a, b: b};
	});
var $author$project$DataElement$Expression$GlobalNotEqualString = F2(
	function (a, b) {
		return {$: 'GlobalNotEqualString', a: a, b: b};
	});
var $author$project$DataElement$Expression$GlobalNumberExpr = function (a) {
	return {$: 'GlobalNumberExpr', a: a};
};
var $author$project$DataElement$Expression$GlobalNumberHardcoded = function (a) {
	return {$: 'GlobalNumberHardcoded', a: a};
};
var $author$project$DataElement$Expression$GlobalNumberIf = F3(
	function (a, b, c) {
		return {$: 'GlobalNumberIf', a: a, b: b, c: c};
	});
var $author$project$DataElement$Expression$GlobalNumberListIf = F3(
	function (a, b, c) {
		return {$: 'GlobalNumberListIf', a: a, b: b, c: c};
	});
var $author$project$DataElement$Expression$GlobalNumberLookup = F2(
	function (a, b) {
		return {$: 'GlobalNumberLookup', a: a, b: b};
	});
var $author$project$DataElement$Expression$GlobalNumbersAsList = function (a) {
	return {$: 'GlobalNumbersAsList', a: a};
};
var $author$project$DataElement$Expression$GlobalPickBool = function (a) {
	return {$: 'GlobalPickBool', a: a};
};
var $author$project$DataElement$Expression$GlobalPickDate = function (a) {
	return {$: 'GlobalPickDate', a: a};
};
var $author$project$DataElement$Expression$GlobalPickDateTime = function (a) {
	return {$: 'GlobalPickDateTime', a: a};
};
var $author$project$DataElement$Expression$GlobalPickNumber = function (a) {
	return {$: 'GlobalPickNumber', a: a};
};
var $author$project$DataElement$Expression$GlobalPickString = function (a) {
	return {$: 'GlobalPickString', a: a};
};
var $author$project$DataElement$Expression$GlobalProduct = function (a) {
	return {$: 'GlobalProduct', a: a};
};
var $author$project$DataElement$Expression$GlobalRound = function (a) {
	return {$: 'GlobalRound', a: a};
};
var $author$project$DataElement$Expression$GlobalStringExpr = function (a) {
	return {$: 'GlobalStringExpr', a: a};
};
var $author$project$DataElement$Expression$GlobalStringHardcoded = function (a) {
	return {$: 'GlobalStringHardcoded', a: a};
};
var $author$project$DataElement$Expression$GlobalStringIf = F3(
	function (a, b, c) {
		return {$: 'GlobalStringIf', a: a, b: b, c: c};
	});
var $author$project$DataElement$Expression$GlobalStringIn = F2(
	function (a, b) {
		return {$: 'GlobalStringIn', a: a, b: b};
	});
var $author$project$DataElement$Expression$GlobalStringListIf = F3(
	function (a, b, c) {
		return {$: 'GlobalStringListIf', a: a, b: b, c: c};
	});
var $author$project$DataElement$Expression$GlobalStringLookup = F2(
	function (a, b) {
		return {$: 'GlobalStringLookup', a: a, b: b};
	});
var $author$project$DataElement$Expression$GlobalStringNotIn = F2(
	function (a, b) {
		return {$: 'GlobalStringNotIn', a: a, b: b};
	});
var $author$project$DataElement$Expression$GlobalStringsAsList = function (a) {
	return {$: 'GlobalStringsAsList', a: a};
};
var $author$project$DataElement$Expression$GlobalSubtract = F2(
	function (a, b) {
		return {$: 'GlobalSubtract', a: a, b: b};
	});
var $author$project$DataElement$Expression$GlobalSum = function (a) {
	return {$: 'GlobalSum', a: a};
};
var $author$project$DataElement$Expression$GlobalTargetChallengeReasons = function (a) {
	return {$: 'GlobalTargetChallengeReasons', a: a};
};
var $author$project$DataElement$Expression$GlobalYearNumber = function (a) {
	return {$: 'GlobalYearNumber', a: a};
};
var $author$project$DataElement$Expression$compareDecoder = function (info) {
	return A2(
		$elm$json$Json$Decode$andThen,
		function (comp) {
			switch (comp.$) {
				case 'StringComp':
					return A3(
						$elm$json$Json$Decode$map2,
						info.stringCompare,
						A2($elm$json$Json$Decode$field, 'expression1', info.stringDecoder),
						A2($elm$json$Json$Decode$field, 'expression2', info.stringDecoder));
				case 'NumberComp':
					return A3(
						$elm$json$Json$Decode$map2,
						info.numberCompare,
						A2($elm$json$Json$Decode$field, 'expression1', info.numberDecoder),
						A2($elm$json$Json$Decode$field, 'expression2', info.numberDecoder));
				case 'DateComp':
					return A3(
						$elm$json$Json$Decode$map2,
						info.dateCompare,
						A2($elm$json$Json$Decode$field, 'expression1', info.dateDecoder),
						A2($elm$json$Json$Decode$field, 'expression2', info.dateDecoder));
				default:
					return A3(
						$elm$json$Json$Decode$map2,
						info.dateTimeCompare,
						A2($elm$json$Json$Decode$field, 'expression1', info.dateTimeDecoder),
						A2($elm$json$Json$Decode$field, 'expression2', info.dateTimeDecoder));
			}
		},
		A2($elm$json$Json$Decode$field, 'inputDataType', $author$project$ComparableType$decoder));
};
var $author$project$DataElement$Expression$compareFieldDecoder = function (info) {
	return A2(
		$elm$json$Json$Decode$andThen,
		function (fieldType) {
			switch (fieldType.$) {
				case 'StringType':
					return A3(
						$elm$json$Json$Decode$map2,
						info.stringCompare,
						A2($elm$json$Json$Decode$field, 'expression1', info.stringDecoder),
						A2($elm$json$Json$Decode$field, 'expression2', info.stringDecoder));
				case 'NumberType':
					return A3(
						$elm$json$Json$Decode$map2,
						info.numberCompare,
						A2($elm$json$Json$Decode$field, 'expression1', info.numberDecoder),
						A2($elm$json$Json$Decode$field, 'expression2', info.numberDecoder));
				case 'DateType':
					return A3(
						$elm$json$Json$Decode$map2,
						info.dateCompare,
						A2($elm$json$Json$Decode$field, 'expression1', info.dateDecoder),
						A2($elm$json$Json$Decode$field, 'expression2', info.dateDecoder));
				case 'DateTimeType':
					return A3(
						$elm$json$Json$Decode$map2,
						info.dateTimeCompare,
						A2($elm$json$Json$Decode$field, 'expression1', info.dateTimeDecoder),
						A2($elm$json$Json$Decode$field, 'expression2', info.dateTimeDecoder));
				default:
					return A3(
						$elm$json$Json$Decode$map2,
						info.boolCompare,
						A2($elm$json$Json$Decode$field, 'expression1', info.boolDecoder),
						A2($elm$json$Json$Decode$field, 'expression2', info.boolDecoder));
			}
		},
		A2($elm$json$Json$Decode$field, 'inputDataType', $author$project$FieldType$decoder));
};
var $author$project$FieldType$toString = function (fieldType) {
	switch (fieldType.$) {
		case 'StringType':
			return 'string';
		case 'NumberType':
			return 'number';
		case 'DateType':
			return 'date';
		case 'DateTimeType':
			return 'datetime';
		default:
			return 'bool';
	}
};
var $author$project$DataElement$Expression$confirmDataType = F2(
	function (intendedType, innerDecoder) {
		return A2(
			$elm$json$Json$Decode$andThen,
			function (fieldType) {
				return _Utils_eq(fieldType, intendedType) ? innerDecoder : $elm$json$Json$Decode$fail(
					'dataType should be ' + ($author$project$FieldType$toString(intendedType) + (' but it is ' + $author$project$FieldType$toString(fieldType))));
			},
			A2($elm$json$Json$Decode$field, 'dataType', $author$project$FieldType$decoder));
	});
var $justinmimbs$date$Date$deadEndToString = function (_v0) {
	var problem = _v0.problem;
	if (problem.$ === 'Problem') {
		var message = problem.a;
		return message;
	} else {
		return 'Expected a date in ISO 8601 format';
	}
};
var $elm$core$Result$mapError = F2(
	function (f, result) {
		if (result.$ === 'Ok') {
			var v = result.a;
			return $elm$core$Result$Ok(v);
		} else {
			var e = result.a;
			return $elm$core$Result$Err(
				f(e));
		}
	});
var $justinmimbs$date$Date$MonthAndDay = F2(
	function (a, b) {
		return {$: 'MonthAndDay', a: a, b: b};
	});
var $justinmimbs$date$Date$OrdinalDay = function (a) {
	return {$: 'OrdinalDay', a: a};
};
var $justinmimbs$date$Date$WeekAndWeekday = F2(
	function (a, b) {
		return {$: 'WeekAndWeekday', a: a, b: b};
	});
var $elm$parser$Parser$Advanced$commit = function (a) {
	return $elm$parser$Parser$Advanced$Parser(
		function (s) {
			return A3($elm$parser$Parser$Advanced$Good, true, a, s);
		});
};
var $elm$parser$Parser$commit = $elm$parser$Parser$Advanced$commit;
var $elm$parser$Parser$mapChompedString = $elm$parser$Parser$Advanced$mapChompedString;
var $elm$core$String$toInt = _String_toInt;
var $justinmimbs$date$Date$int1 = A2(
	$elm$parser$Parser$mapChompedString,
	F2(
		function (str, _v0) {
			return A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$String$toInt(str));
		}),
	$elm$parser$Parser$chompIf($elm$core$Char$isDigit));
var $justinmimbs$date$Date$int2 = A2(
	$elm$parser$Parser$mapChompedString,
	F2(
		function (str, _v0) {
			return A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$String$toInt(str));
		}),
	A2(
		$elm$parser$Parser$ignorer,
		A2(
			$elm$parser$Parser$ignorer,
			$elm$parser$Parser$succeed(_Utils_Tuple0),
			$elm$parser$Parser$chompIf($elm$core$Char$isDigit)),
		$elm$parser$Parser$chompIf($elm$core$Char$isDigit)));
var $justinmimbs$date$Date$int3 = A2(
	$elm$parser$Parser$mapChompedString,
	F2(
		function (str, _v0) {
			return A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$String$toInt(str));
		}),
	A2(
		$elm$parser$Parser$ignorer,
		A2(
			$elm$parser$Parser$ignorer,
			A2(
				$elm$parser$Parser$ignorer,
				$elm$parser$Parser$succeed(_Utils_Tuple0),
				$elm$parser$Parser$chompIf($elm$core$Char$isDigit)),
			$elm$parser$Parser$chompIf($elm$core$Char$isDigit)),
		$elm$parser$Parser$chompIf($elm$core$Char$isDigit)));
var $elm$parser$Parser$token = function (str) {
	return $elm$parser$Parser$Advanced$token(
		$elm$parser$Parser$toToken(str));
};
var $justinmimbs$date$Date$dayOfYear = $elm$parser$Parser$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$ignorer,
				$elm$parser$Parser$succeed($elm$core$Basics$identity),
				$elm$parser$Parser$token('-')),
			$elm$parser$Parser$oneOf(
				_List_fromArray(
					[
						$elm$parser$Parser$backtrackable(
						A2(
							$elm$parser$Parser$andThen,
							$elm$parser$Parser$commit,
							A2($elm$parser$Parser$map, $justinmimbs$date$Date$OrdinalDay, $justinmimbs$date$Date$int3))),
						A2(
						$elm$parser$Parser$keeper,
						A2(
							$elm$parser$Parser$keeper,
							$elm$parser$Parser$succeed($justinmimbs$date$Date$MonthAndDay),
							$justinmimbs$date$Date$int2),
						$elm$parser$Parser$oneOf(
							_List_fromArray(
								[
									A2(
									$elm$parser$Parser$keeper,
									A2(
										$elm$parser$Parser$ignorer,
										$elm$parser$Parser$succeed($elm$core$Basics$identity),
										$elm$parser$Parser$token('-')),
									$justinmimbs$date$Date$int2),
									$elm$parser$Parser$succeed(1)
								]))),
						A2(
						$elm$parser$Parser$keeper,
						A2(
							$elm$parser$Parser$keeper,
							A2(
								$elm$parser$Parser$ignorer,
								$elm$parser$Parser$succeed($justinmimbs$date$Date$WeekAndWeekday),
								$elm$parser$Parser$token('W')),
							$justinmimbs$date$Date$int2),
						$elm$parser$Parser$oneOf(
							_List_fromArray(
								[
									A2(
									$elm$parser$Parser$keeper,
									A2(
										$elm$parser$Parser$ignorer,
										$elm$parser$Parser$succeed($elm$core$Basics$identity),
										$elm$parser$Parser$token('-')),
									$justinmimbs$date$Date$int1),
									$elm$parser$Parser$succeed(1)
								])))
					]))),
			$elm$parser$Parser$backtrackable(
			A2(
				$elm$parser$Parser$andThen,
				$elm$parser$Parser$commit,
				A2(
					$elm$parser$Parser$keeper,
					A2(
						$elm$parser$Parser$keeper,
						$elm$parser$Parser$succeed($justinmimbs$date$Date$MonthAndDay),
						$justinmimbs$date$Date$int2),
					$elm$parser$Parser$oneOf(
						_List_fromArray(
							[
								$justinmimbs$date$Date$int2,
								$elm$parser$Parser$succeed(1)
							]))))),
			A2($elm$parser$Parser$map, $justinmimbs$date$Date$OrdinalDay, $justinmimbs$date$Date$int3),
			A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$keeper,
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed($justinmimbs$date$Date$WeekAndWeekday),
					$elm$parser$Parser$token('W')),
				$justinmimbs$date$Date$int2),
			$elm$parser$Parser$oneOf(
				_List_fromArray(
					[
						$justinmimbs$date$Date$int1,
						$elm$parser$Parser$succeed(1)
					]))),
			$elm$parser$Parser$succeed(
			$justinmimbs$date$Date$OrdinalDay(1))
		]));
var $justinmimbs$date$Date$RD = function (a) {
	return {$: 'RD', a: a};
};
var $elm$core$Basics$modBy = _Basics_modBy;
var $justinmimbs$date$Date$isLeapYear = function (y) {
	return ((!A2($elm$core$Basics$modBy, 4, y)) && (!(!A2($elm$core$Basics$modBy, 100, y)))) || (!A2($elm$core$Basics$modBy, 400, y));
};
var $justinmimbs$date$Date$daysBeforeMonth = F2(
	function (y, m) {
		var leapDays = $justinmimbs$date$Date$isLeapYear(y) ? 1 : 0;
		switch (m.$) {
			case 'Jan':
				return 0;
			case 'Feb':
				return 31;
			case 'Mar':
				return 59 + leapDays;
			case 'Apr':
				return 90 + leapDays;
			case 'May':
				return 120 + leapDays;
			case 'Jun':
				return 151 + leapDays;
			case 'Jul':
				return 181 + leapDays;
			case 'Aug':
				return 212 + leapDays;
			case 'Sep':
				return 243 + leapDays;
			case 'Oct':
				return 273 + leapDays;
			case 'Nov':
				return 304 + leapDays;
			default:
				return 334 + leapDays;
		}
	});
var $justinmimbs$date$Date$floorDiv = F2(
	function (a, b) {
		return $elm$core$Basics$floor(a / b);
	});
var $justinmimbs$date$Date$daysBeforeYear = function (y1) {
	var y = y1 - 1;
	var leapYears = (A2($justinmimbs$date$Date$floorDiv, y, 4) - A2($justinmimbs$date$Date$floorDiv, y, 100)) + A2($justinmimbs$date$Date$floorDiv, y, 400);
	return (365 * y) + leapYears;
};
var $justinmimbs$date$Date$daysInMonth = F2(
	function (y, m) {
		switch (m.$) {
			case 'Jan':
				return 31;
			case 'Feb':
				return $justinmimbs$date$Date$isLeapYear(y) ? 29 : 28;
			case 'Mar':
				return 31;
			case 'Apr':
				return 30;
			case 'May':
				return 31;
			case 'Jun':
				return 30;
			case 'Jul':
				return 31;
			case 'Aug':
				return 31;
			case 'Sep':
				return 30;
			case 'Oct':
				return 31;
			case 'Nov':
				return 30;
			default:
				return 31;
		}
	});
var $justinmimbs$date$Date$isBetweenInt = F3(
	function (a, b, x) {
		return (_Utils_cmp(a, x) < 1) && (_Utils_cmp(x, b) < 1);
	});
var $justinmimbs$date$Date$monthToName = function (m) {
	switch (m.$) {
		case 'Jan':
			return 'January';
		case 'Feb':
			return 'February';
		case 'Mar':
			return 'March';
		case 'Apr':
			return 'April';
		case 'May':
			return 'May';
		case 'Jun':
			return 'June';
		case 'Jul':
			return 'July';
		case 'Aug':
			return 'August';
		case 'Sep':
			return 'September';
		case 'Oct':
			return 'October';
		case 'Nov':
			return 'November';
		default:
			return 'December';
	}
};
var $elm$time$Time$Apr = {$: 'Apr'};
var $elm$time$Time$Aug = {$: 'Aug'};
var $elm$time$Time$Dec = {$: 'Dec'};
var $elm$time$Time$Feb = {$: 'Feb'};
var $elm$time$Time$Jan = {$: 'Jan'};
var $elm$time$Time$Jul = {$: 'Jul'};
var $elm$time$Time$Jun = {$: 'Jun'};
var $elm$time$Time$Mar = {$: 'Mar'};
var $elm$time$Time$May = {$: 'May'};
var $elm$time$Time$Nov = {$: 'Nov'};
var $elm$time$Time$Oct = {$: 'Oct'};
var $elm$time$Time$Sep = {$: 'Sep'};
var $justinmimbs$date$Date$numberToMonth = function (mn) {
	var _v0 = A2($elm$core$Basics$max, 1, mn);
	switch (_v0) {
		case 1:
			return $elm$time$Time$Jan;
		case 2:
			return $elm$time$Time$Feb;
		case 3:
			return $elm$time$Time$Mar;
		case 4:
			return $elm$time$Time$Apr;
		case 5:
			return $elm$time$Time$May;
		case 6:
			return $elm$time$Time$Jun;
		case 7:
			return $elm$time$Time$Jul;
		case 8:
			return $elm$time$Time$Aug;
		case 9:
			return $elm$time$Time$Sep;
		case 10:
			return $elm$time$Time$Oct;
		case 11:
			return $elm$time$Time$Nov;
		default:
			return $elm$time$Time$Dec;
	}
};
var $justinmimbs$date$Date$fromCalendarParts = F3(
	function (y, mn, d) {
		return (!A3($justinmimbs$date$Date$isBetweenInt, 1, 12, mn)) ? $elm$core$Result$Err(
			'Invalid date: ' + (('month ' + ($elm$core$String$fromInt(mn) + ' is out of range')) + (' (1 to 12)' + ('; received (year ' + ($elm$core$String$fromInt(y) + (', month ' + ($elm$core$String$fromInt(mn) + (', day ' + ($elm$core$String$fromInt(d) + ')'))))))))) : ((!A3(
			$justinmimbs$date$Date$isBetweenInt,
			1,
			A2(
				$justinmimbs$date$Date$daysInMonth,
				y,
				$justinmimbs$date$Date$numberToMonth(mn)),
			d)) ? $elm$core$Result$Err(
			'Invalid date: ' + (('day ' + ($elm$core$String$fromInt(d) + ' is out of range')) + ((' (1 to ' + ($elm$core$String$fromInt(
				A2(
					$justinmimbs$date$Date$daysInMonth,
					y,
					$justinmimbs$date$Date$numberToMonth(mn))) + ')')) + ((' for ' + $justinmimbs$date$Date$monthToName(
				$justinmimbs$date$Date$numberToMonth(mn))) + ((((mn === 2) && (d === 29)) ? (' (' + ($elm$core$String$fromInt(y) + ' is not a leap year)')) : '') + ('; received (year ' + ($elm$core$String$fromInt(y) + (', month ' + ($elm$core$String$fromInt(mn) + (', day ' + ($elm$core$String$fromInt(d) + ')'))))))))))) : $elm$core$Result$Ok(
			$justinmimbs$date$Date$RD(
				($justinmimbs$date$Date$daysBeforeYear(y) + A2(
					$justinmimbs$date$Date$daysBeforeMonth,
					y,
					$justinmimbs$date$Date$numberToMonth(mn))) + d)));
	});
var $justinmimbs$date$Date$fromOrdinalParts = F2(
	function (y, od) {
		var daysInYear = $justinmimbs$date$Date$isLeapYear(y) ? 366 : 365;
		return (!A3($justinmimbs$date$Date$isBetweenInt, 1, daysInYear, od)) ? $elm$core$Result$Err(
			'Invalid ordinal date: ' + (('ordinal-day ' + ($elm$core$String$fromInt(od) + ' is out of range')) + ((' (1 to ' + ($elm$core$String$fromInt(daysInYear) + ')')) + ((' for ' + $elm$core$String$fromInt(y)) + ('; received (year ' + ($elm$core$String$fromInt(y) + (', ordinal-day ' + ($elm$core$String$fromInt(od) + ')')))))))) : $elm$core$Result$Ok(
			$justinmimbs$date$Date$RD(
				$justinmimbs$date$Date$daysBeforeYear(y) + od));
	});
var $justinmimbs$date$Date$weekdayNumber = function (_v0) {
	var rd = _v0.a;
	var _v1 = A2($elm$core$Basics$modBy, 7, rd);
	if (!_v1) {
		return 7;
	} else {
		var n = _v1;
		return n;
	}
};
var $justinmimbs$date$Date$daysBeforeWeekYear = function (y) {
	var jan4 = $justinmimbs$date$Date$daysBeforeYear(y) + 4;
	return jan4 - $justinmimbs$date$Date$weekdayNumber(
		$justinmimbs$date$Date$RD(jan4));
};
var $justinmimbs$date$Date$firstOfYear = function (y) {
	return $justinmimbs$date$Date$RD(
		$justinmimbs$date$Date$daysBeforeYear(y) + 1);
};
var $justinmimbs$date$Date$is53WeekYear = function (y) {
	var wdnJan1 = $justinmimbs$date$Date$weekdayNumber(
		$justinmimbs$date$Date$firstOfYear(y));
	return (wdnJan1 === 4) || ((wdnJan1 === 3) && $justinmimbs$date$Date$isLeapYear(y));
};
var $justinmimbs$date$Date$fromWeekParts = F3(
	function (wy, wn, wdn) {
		var weeksInYear = $justinmimbs$date$Date$is53WeekYear(wy) ? 53 : 52;
		return (!A3($justinmimbs$date$Date$isBetweenInt, 1, weeksInYear, wn)) ? $elm$core$Result$Err(
			'Invalid week date: ' + (('week ' + ($elm$core$String$fromInt(wn) + ' is out of range')) + ((' (1 to ' + ($elm$core$String$fromInt(weeksInYear) + ')')) + ((' for ' + $elm$core$String$fromInt(wy)) + ('; received (year ' + ($elm$core$String$fromInt(wy) + (', week ' + ($elm$core$String$fromInt(wn) + (', weekday ' + ($elm$core$String$fromInt(wdn) + ')')))))))))) : ((!A3($justinmimbs$date$Date$isBetweenInt, 1, 7, wdn)) ? $elm$core$Result$Err(
			'Invalid week date: ' + (('weekday ' + ($elm$core$String$fromInt(wdn) + ' is out of range')) + (' (1 to 7)' + ('; received (year ' + ($elm$core$String$fromInt(wy) + (', week ' + ($elm$core$String$fromInt(wn) + (', weekday ' + ($elm$core$String$fromInt(wdn) + ')'))))))))) : $elm$core$Result$Ok(
			$justinmimbs$date$Date$RD(
				($justinmimbs$date$Date$daysBeforeWeekYear(wy) + ((wn - 1) * 7)) + wdn)));
	});
var $justinmimbs$date$Date$fromYearAndDayOfYear = function (_v0) {
	var y = _v0.a;
	var doy = _v0.b;
	switch (doy.$) {
		case 'MonthAndDay':
			var mn = doy.a;
			var d = doy.b;
			return A3($justinmimbs$date$Date$fromCalendarParts, y, mn, d);
		case 'WeekAndWeekday':
			var wn = doy.a;
			var wdn = doy.b;
			return A3($justinmimbs$date$Date$fromWeekParts, y, wn, wdn);
		default:
			var od = doy.a;
			return A2($justinmimbs$date$Date$fromOrdinalParts, y, od);
	}
};
var $justinmimbs$date$Date$int4 = A2(
	$elm$parser$Parser$mapChompedString,
	F2(
		function (str, _v0) {
			return A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$String$toInt(str));
		}),
	A2(
		$elm$parser$Parser$ignorer,
		A2(
			$elm$parser$Parser$ignorer,
			A2(
				$elm$parser$Parser$ignorer,
				A2(
					$elm$parser$Parser$ignorer,
					A2(
						$elm$parser$Parser$ignorer,
						$elm$parser$Parser$succeed(_Utils_Tuple0),
						$elm$parser$Parser$oneOf(
							_List_fromArray(
								[
									$elm$parser$Parser$chompIf(
									function (c) {
										return _Utils_eq(
											c,
											_Utils_chr('-'));
									}),
									$elm$parser$Parser$succeed(_Utils_Tuple0)
								]))),
					$elm$parser$Parser$chompIf($elm$core$Char$isDigit)),
				$elm$parser$Parser$chompIf($elm$core$Char$isDigit)),
			$elm$parser$Parser$chompIf($elm$core$Char$isDigit)),
		$elm$parser$Parser$chompIf($elm$core$Char$isDigit)));
var $justinmimbs$date$Date$resultToParser = function (result) {
	if (result.$ === 'Ok') {
		var x = result.a;
		return $elm$parser$Parser$succeed(x);
	} else {
		var message = result.a;
		return $elm$parser$Parser$problem(message);
	}
};
var $justinmimbs$date$Date$parser = A2(
	$elm$parser$Parser$andThen,
	A2($elm$core$Basics$composeR, $justinmimbs$date$Date$fromYearAndDayOfYear, $justinmimbs$date$Date$resultToParser),
	A2(
		$elm$parser$Parser$keeper,
		A2(
			$elm$parser$Parser$keeper,
			$elm$parser$Parser$succeed($elm$core$Tuple$pair),
			$justinmimbs$date$Date$int4),
		$justinmimbs$date$Date$dayOfYear));
var $justinmimbs$date$Date$fromIsoString = A2(
	$elm$core$Basics$composeR,
	$elm$parser$Parser$run(
		A2(
			$elm$parser$Parser$keeper,
			$elm$parser$Parser$succeed($elm$core$Basics$identity),
			A2(
				$elm$parser$Parser$ignorer,
				$justinmimbs$date$Date$parser,
				A2(
					$elm$parser$Parser$andThen,
					$justinmimbs$date$Date$resultToParser,
					$elm$parser$Parser$oneOf(
						_List_fromArray(
							[
								A2($elm$parser$Parser$map, $elm$core$Result$Ok, $elm$parser$Parser$end),
								A2(
								$elm$parser$Parser$map,
								$elm$core$Basics$always(
									$elm$core$Result$Err('Expected a date only, not a date and time')),
								$elm$parser$Parser$chompIf(
									$elm$core$Basics$eq(
										_Utils_chr('T')))),
								$elm$parser$Parser$succeed(
								$elm$core$Result$Err('Expected a date only'))
							])))))),
	$elm$core$Result$mapError(
		A2(
			$elm$core$Basics$composeR,
			$elm$core$List$head,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$Maybe$map($justinmimbs$date$Date$deadEndToString),
				$elm$core$Maybe$withDefault('')))));
var $author$project$DataElement$Expression$dateDecoder = A2(
	$elm$json$Json$Decode$andThen,
	A2($elm$core$Basics$composeR, $justinmimbs$date$Date$fromIsoString, $elm_community$json_extra$Json$Decode$Extra$fromResult),
	$elm$json$Json$Decode$string);
var $author$project$DateInterval$Month = {$: 'Month'};
var $author$project$DateInterval$Quarter = {$: 'Quarter'};
var $author$project$DateInterval$Week = {$: 'Week'};
var $author$project$DateInterval$Year = {$: 'Year'};
var $author$project$DateInterval$fromString = function (words) {
	var _v0 = $elm$core$String$toLower(words);
	switch (_v0) {
		case 'week':
			return $elm$core$Result$Ok($author$project$DateInterval$Week);
		case 'month':
			return $elm$core$Result$Ok($author$project$DateInterval$Month);
		case 'quarter':
			return $elm$core$Result$Ok($author$project$DateInterval$Quarter);
		case 'year':
			return $elm$core$Result$Ok($author$project$DateInterval$Year);
		default:
			return $elm$core$Result$Err('Could not parse \'' + (words + '\' as a Date Interval'));
	}
};
var $author$project$DateInterval$decoder = A2(
	$elm$json$Json$Decode$andThen,
	A2($elm$core$Basics$composeR, $author$project$DateInterval$fromString, $elm_community$json_extra$Json$Decode$Extra$fromResult),
	$elm$json$Json$Decode$string);
var $author$project$DateUnit$Days = {$: 'Days'};
var $author$project$DateUnit$Months = {$: 'Months'};
var $author$project$DateUnit$Weeks = {$: 'Weeks'};
var $author$project$DateUnit$Years = {$: 'Years'};
var $author$project$DateUnit$fromString = function (words) {
	var _v0 = $elm$core$String$toLower(words);
	switch (_v0) {
		case 'days':
			return $elm$core$Result$Ok($author$project$DateUnit$Days);
		case 'weeks':
			return $elm$core$Result$Ok($author$project$DateUnit$Weeks);
		case 'months':
			return $elm$core$Result$Ok($author$project$DateUnit$Months);
		case 'years':
			return $elm$core$Result$Ok($author$project$DateUnit$Years);
		default:
			return $elm$core$Result$Err('Could not parse \'' + (words + '\' as a Date Unit'));
	}
};
var $author$project$DateUnit$decoder = A2(
	$elm$json$Json$Decode$andThen,
	A2($elm$core$Basics$composeR, $author$project$DateUnit$fromString, $elm_community$json_extra$Json$Decode$Extra$fromResult),
	$elm$json$Json$Decode$string);
var $elm$core$String$concat = function (strings) {
	return A2($elm$core$String$join, '', strings);
};
var $rtfeldman$elm_iso8601_date_strings$DeadEnds$problemToString = function (p) {
	switch (p.$) {
		case 'Expecting':
			var s = p.a;
			return 'expecting \'' + (s + '\'');
		case 'ExpectingInt':
			return 'expecting int';
		case 'ExpectingHex':
			return 'expecting hex';
		case 'ExpectingOctal':
			return 'expecting octal';
		case 'ExpectingBinary':
			return 'expecting binary';
		case 'ExpectingFloat':
			return 'expecting float';
		case 'ExpectingNumber':
			return 'expecting number';
		case 'ExpectingVariable':
			return 'expecting variable';
		case 'ExpectingSymbol':
			var s = p.a;
			return 'expecting symbol \'' + (s + '\'');
		case 'ExpectingKeyword':
			var s = p.a;
			return 'expecting keyword \'' + (s + '\'');
		case 'ExpectingEnd':
			return 'expecting end';
		case 'UnexpectedChar':
			return 'unexpected char';
		case 'Problem':
			var s = p.a;
			return 'problem ' + s;
		default:
			return 'bad repeat';
	}
};
var $rtfeldman$elm_iso8601_date_strings$DeadEnds$deadEndToString = function (deadend) {
	return $rtfeldman$elm_iso8601_date_strings$DeadEnds$problemToString(deadend.problem) + (' at row ' + ($elm$core$String$fromInt(deadend.row) + (', col ' + $elm$core$String$fromInt(deadend.col))));
};
var $elm$core$List$intersperse = F2(
	function (sep, xs) {
		if (!xs.b) {
			return _List_Nil;
		} else {
			var hd = xs.a;
			var tl = xs.b;
			var step = F2(
				function (x, rest) {
					return A2(
						$elm$core$List$cons,
						sep,
						A2($elm$core$List$cons, x, rest));
				});
			var spersed = A3($elm$core$List$foldr, step, _List_Nil, tl);
			return A2($elm$core$List$cons, hd, spersed);
		}
	});
var $rtfeldman$elm_iso8601_date_strings$DeadEnds$deadEndsToString = function (deadEnds) {
	return $elm$core$String$concat(
		A2(
			$elm$core$List$intersperse,
			'; ',
			A2($elm$core$List$map, $rtfeldman$elm_iso8601_date_strings$DeadEnds$deadEndToString, deadEnds)));
};
var $elm$core$Basics$round = _Basics_round;
var $rtfeldman$elm_iso8601_date_strings$Iso8601$fractionsOfASecondInMs = A2(
	$elm$parser$Parser$andThen,
	function (str) {
		if ($elm$core$String$length(str) <= 9) {
			var _v0 = $elm$core$String$toFloat('0.' + str);
			if (_v0.$ === 'Just') {
				var floatVal = _v0.a;
				return $elm$parser$Parser$succeed(
					$elm$core$Basics$round(floatVal * 1000));
			} else {
				return $elm$parser$Parser$problem('Invalid float: \"' + (str + '\"'));
			}
		} else {
			return $elm$parser$Parser$problem(
				'Expected at most 9 digits, but got ' + $elm$core$String$fromInt(
					$elm$core$String$length(str)));
		}
	},
	$elm$parser$Parser$getChompedString(
		$elm$parser$Parser$chompWhile($elm$core$Char$isDigit)));
var $elm$time$Time$Posix = function (a) {
	return {$: 'Posix', a: a};
};
var $elm$time$Time$millisToPosix = $elm$time$Time$Posix;
var $rtfeldman$elm_iso8601_date_strings$Iso8601$fromParts = F6(
	function (monthYearDayMs, hour, minute, second, ms, utcOffsetMinutes) {
		return $elm$time$Time$millisToPosix((((monthYearDayMs + (((hour * 60) * 60) * 1000)) + (((minute - utcOffsetMinutes) * 60) * 1000)) + (second * 1000)) + ms);
	});
var $elm$core$String$append = _String_append;
var $rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt = function (quantity) {
	var helper = function (str) {
		if (_Utils_eq(
			$elm$core$String$length(str),
			quantity)) {
			var _v0 = $elm$core$String$toInt(str);
			if (_v0.$ === 'Just') {
				var intVal = _v0.a;
				return A2(
					$elm$parser$Parser$map,
					$elm$parser$Parser$Done,
					$elm$parser$Parser$succeed(intVal));
			} else {
				return $elm$parser$Parser$problem('Invalid integer: \"' + (str + '\"'));
			}
		} else {
			return A2(
				$elm$parser$Parser$map,
				function (nextChar) {
					return $elm$parser$Parser$Loop(
						A2($elm$core$String$append, str, nextChar));
				},
				$elm$parser$Parser$getChompedString(
					$elm$parser$Parser$chompIf($elm$core$Char$isDigit)));
		}
	};
	return A2($elm$parser$Parser$loop, '', helper);
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$epochYear = 1970;
var $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay = function (day) {
	return $elm$parser$Parser$problem(
		'Invalid day: ' + $elm$core$String$fromInt(day));
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$isLeapYear = function (year) {
	return (!A2($elm$core$Basics$modBy, 4, year)) && ((!(!A2($elm$core$Basics$modBy, 100, year))) || (!A2($elm$core$Basics$modBy, 400, year)));
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$leapYearsBefore = function (y1) {
	var y = y1 - 1;
	return (((y / 4) | 0) - ((y / 100) | 0)) + ((y / 400) | 0);
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$msPerDay = 86400000;
var $rtfeldman$elm_iso8601_date_strings$Iso8601$msPerYear = 31536000000;
var $rtfeldman$elm_iso8601_date_strings$Iso8601$yearMonthDay = function (_v0) {
	var year = _v0.a;
	var month = _v0.b;
	var dayInMonth = _v0.c;
	if (dayInMonth < 0) {
		return $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth);
	} else {
		var succeedWith = function (extraMs) {
			var yearMs = $rtfeldman$elm_iso8601_date_strings$Iso8601$msPerYear * (year - $rtfeldman$elm_iso8601_date_strings$Iso8601$epochYear);
			var days = ((month < 3) || (!$rtfeldman$elm_iso8601_date_strings$Iso8601$isLeapYear(year))) ? (dayInMonth - 1) : dayInMonth;
			var dayMs = $rtfeldman$elm_iso8601_date_strings$Iso8601$msPerDay * (days + ($rtfeldman$elm_iso8601_date_strings$Iso8601$leapYearsBefore(year) - $rtfeldman$elm_iso8601_date_strings$Iso8601$leapYearsBefore($rtfeldman$elm_iso8601_date_strings$Iso8601$epochYear)));
			return $elm$parser$Parser$succeed((extraMs + yearMs) + dayMs);
		};
		switch (month) {
			case 1:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(0);
			case 2:
				return ((dayInMonth > 29) || ((dayInMonth === 29) && (!$rtfeldman$elm_iso8601_date_strings$Iso8601$isLeapYear(year)))) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(2678400000);
			case 3:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(5097600000);
			case 4:
				return (dayInMonth > 30) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(7776000000);
			case 5:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(10368000000);
			case 6:
				return (dayInMonth > 30) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(13046400000);
			case 7:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(15638400000);
			case 8:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(18316800000);
			case 9:
				return (dayInMonth > 30) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(20995200000);
			case 10:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(23587200000);
			case 11:
				return (dayInMonth > 30) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(26265600000);
			case 12:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(28857600000);
			default:
				return $elm$parser$Parser$problem(
					'Invalid month: \"' + ($elm$core$String$fromInt(month) + '\"'));
		}
	}
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$monthYearDayInMs = A2(
	$elm$parser$Parser$andThen,
	$rtfeldman$elm_iso8601_date_strings$Iso8601$yearMonthDay,
	A2(
		$elm$parser$Parser$keeper,
		A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$keeper,
				$elm$parser$Parser$succeed(
					F3(
						function (year, month, day) {
							return _Utils_Tuple3(year, month, day);
						})),
				$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(4)),
			$elm$parser$Parser$oneOf(
				_List_fromArray(
					[
						A2(
						$elm$parser$Parser$keeper,
						A2(
							$elm$parser$Parser$ignorer,
							$elm$parser$Parser$succeed($elm$core$Basics$identity),
							$elm$parser$Parser$symbol('-')),
						$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
						$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)
					]))),
		$elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$parser$Parser$keeper,
					A2(
						$elm$parser$Parser$ignorer,
						$elm$parser$Parser$succeed($elm$core$Basics$identity),
						$elm$parser$Parser$symbol('-')),
					$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
					$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)
				]))));
var $rtfeldman$elm_iso8601_date_strings$Iso8601$utcOffsetInMinutes = function () {
	var utcOffsetMinutesFromParts = F3(
		function (multiplier, hours, minutes) {
			return (multiplier * (hours * 60)) + minutes;
		});
	return A2(
		$elm$parser$Parser$keeper,
		$elm$parser$Parser$succeed($elm$core$Basics$identity),
		$elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$parser$Parser$map,
					function (_v0) {
						return 0;
					},
					$elm$parser$Parser$symbol('Z')),
					A2(
					$elm$parser$Parser$keeper,
					A2(
						$elm$parser$Parser$keeper,
						A2(
							$elm$parser$Parser$keeper,
							$elm$parser$Parser$succeed(utcOffsetMinutesFromParts),
							$elm$parser$Parser$oneOf(
								_List_fromArray(
									[
										A2(
										$elm$parser$Parser$map,
										function (_v1) {
											return 1;
										},
										$elm$parser$Parser$symbol('+')),
										A2(
										$elm$parser$Parser$map,
										function (_v2) {
											return -1;
										},
										$elm$parser$Parser$symbol('-'))
									]))),
						$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
					$elm$parser$Parser$oneOf(
						_List_fromArray(
							[
								A2(
								$elm$parser$Parser$keeper,
								A2(
									$elm$parser$Parser$ignorer,
									$elm$parser$Parser$succeed($elm$core$Basics$identity),
									$elm$parser$Parser$symbol(':')),
								$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
								$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2),
								$elm$parser$Parser$succeed(0)
							]))),
					A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed(0),
					$elm$parser$Parser$end)
				])));
}();
var $rtfeldman$elm_iso8601_date_strings$Iso8601$iso8601 = A2(
	$elm$parser$Parser$andThen,
	function (datePart) {
		return $elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$parser$Parser$keeper,
					A2(
						$elm$parser$Parser$keeper,
						A2(
							$elm$parser$Parser$keeper,
							A2(
								$elm$parser$Parser$keeper,
								A2(
									$elm$parser$Parser$keeper,
									A2(
										$elm$parser$Parser$ignorer,
										$elm$parser$Parser$succeed(
											$rtfeldman$elm_iso8601_date_strings$Iso8601$fromParts(datePart)),
										$elm$parser$Parser$symbol('T')),
									$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
								$elm$parser$Parser$oneOf(
									_List_fromArray(
										[
											A2(
											$elm$parser$Parser$keeper,
											A2(
												$elm$parser$Parser$ignorer,
												$elm$parser$Parser$succeed($elm$core$Basics$identity),
												$elm$parser$Parser$symbol(':')),
											$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
											$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)
										]))),
							$elm$parser$Parser$oneOf(
								_List_fromArray(
									[
										A2(
										$elm$parser$Parser$keeper,
										A2(
											$elm$parser$Parser$ignorer,
											$elm$parser$Parser$succeed($elm$core$Basics$identity),
											$elm$parser$Parser$symbol(':')),
										$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
										$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2),
										$elm$parser$Parser$succeed(0)
									]))),
						$elm$parser$Parser$oneOf(
							_List_fromArray(
								[
									A2(
									$elm$parser$Parser$keeper,
									A2(
										$elm$parser$Parser$ignorer,
										$elm$parser$Parser$succeed($elm$core$Basics$identity),
										$elm$parser$Parser$symbol('.')),
									$rtfeldman$elm_iso8601_date_strings$Iso8601$fractionsOfASecondInMs),
									$elm$parser$Parser$succeed(0)
								]))),
					A2($elm$parser$Parser$ignorer, $rtfeldman$elm_iso8601_date_strings$Iso8601$utcOffsetInMinutes, $elm$parser$Parser$end)),
					A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed(
						A6($rtfeldman$elm_iso8601_date_strings$Iso8601$fromParts, datePart, 0, 0, 0, 0, 0)),
					$elm$parser$Parser$end)
				]));
	},
	$rtfeldman$elm_iso8601_date_strings$Iso8601$monthYearDayInMs);
var $rtfeldman$elm_iso8601_date_strings$Iso8601$toTime = function (str) {
	return A2($elm$parser$Parser$run, $rtfeldman$elm_iso8601_date_strings$Iso8601$iso8601, str);
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (str) {
		var _v0 = $rtfeldman$elm_iso8601_date_strings$Iso8601$toTime(str);
		if (_v0.$ === 'Err') {
			var deadEnds = _v0.a;
			return $elm$json$Json$Decode$fail(
				$rtfeldman$elm_iso8601_date_strings$DeadEnds$deadEndsToString(deadEnds));
		} else {
			var time = _v0.a;
			return $elm$json$Json$Decode$succeed(time);
		}
	},
	$elm$json$Json$Decode$string);
var $elm$json$Json$Decode$float = _Json_decodeFloat;
var $author$project$DataElement$Expression$ifDecoder = F3(
	function (maker, boolDecoder, innerDecoder) {
		return A4(
			$elm$json$Json$Decode$map3,
			maker,
			A2($elm$json$Json$Decode$field, 'ifExpression', boolDecoder),
			A2($elm$json$Json$Decode$field, 'thenExpression', innerDecoder),
			A2($elm$json$Json$Decode$field, 'elseExpression', innerDecoder));
	});
var $elm$json$Json$Decode$int = _Json_decodeInt;
var $author$project$DataElement$Expression$pickOneDecoder = F2(
	function (maker, listDecoder) {
		return A2(
			$elm$json$Json$Decode$map,
			maker,
			A2($elm$json$Json$Decode$field, 'expression', listDecoder));
	});
var $author$project$DataElement$Reference$Reference = function (a) {
	return {$: 'Reference', a: a};
};
var $author$project$DataElement$Reference$recordListReferenceDecoder = A2($elm$json$Json$Decode$map, $author$project$DataElement$Reference$Reference, $danyx23$elm_uuid$Uuid$decoder);
var $author$project$DataElement$Reference$singletonReferenceDecoder = A2($elm$json$Json$Decode$map, $author$project$DataElement$Reference$Reference, $danyx23$elm_uuid$Uuid$decoder);
var $author$project$DataElement$Expression$typeDecoder = function (pickDecoder) {
	return A2(
		$elm$json$Json$Decode$andThen,
		pickDecoder,
		A2($elm$json$Json$Decode$field, 'type', $elm$json$Json$Decode$string));
};
function $author$project$DataElement$Expression$cyclic$globalBoolDecoder() {
	return A2(
		$author$project$DataElement$Expression$confirmDataType,
		$author$project$FieldType$BoolType,
		$author$project$DataElement$Expression$typeDecoder(
			function (words) {
				var _v11 = $elm$core$String$toLower(words);
				switch (_v11) {
					case 'singleton field':
						return A3(
							$elm$json$Json$Decode$map2,
							$author$project$DataElement$Expression$GlobalBoolLookup,
							A2($elm$json$Json$Decode$field, 'dataElement', $author$project$DataElement$Reference$singletonReferenceDecoder),
							A2($elm$json$Json$Decode$field, 'field', $author$project$FieldName$decoder));
					case 'static':
						return A2(
							$elm$json$Json$Decode$map,
							$author$project$DataElement$Expression$GlobalBoolHardcoded,
							A2($elm$json$Json$Decode$field, 'value', $elm$json$Json$Decode$bool));
					case 'gt':
						return $author$project$DataElement$Expression$compareDecoder(
							{
								dateCompare: $author$project$DataElement$Expression$GlobalGTDate,
								dateDecoder: $author$project$DataElement$Expression$cyclic$globalDateDecoder(),
								dateTimeCompare: $author$project$DataElement$Expression$GlobalGTDateTime,
								dateTimeDecoder: $author$project$DataElement$Expression$cyclic$globalDateTimeDecoder(),
								numberCompare: $author$project$DataElement$Expression$GlobalGTNumber,
								numberDecoder: $author$project$DataElement$Expression$cyclic$globalNumberDecoder(),
								stringCompare: $author$project$DataElement$Expression$GlobalGTString,
								stringDecoder: $author$project$DataElement$Expression$cyclic$globalStringDecoder()
							});
					case 'gte':
						return $author$project$DataElement$Expression$compareDecoder(
							{
								dateCompare: $author$project$DataElement$Expression$GlobalGTEDate,
								dateDecoder: $author$project$DataElement$Expression$cyclic$globalDateDecoder(),
								dateTimeCompare: $author$project$DataElement$Expression$GlobalGTEDateTime,
								dateTimeDecoder: $author$project$DataElement$Expression$cyclic$globalDateTimeDecoder(),
								numberCompare: $author$project$DataElement$Expression$GlobalGTENumber,
								numberDecoder: $author$project$DataElement$Expression$cyclic$globalNumberDecoder(),
								stringCompare: $author$project$DataElement$Expression$GlobalGTEString,
								stringDecoder: $author$project$DataElement$Expression$cyclic$globalStringDecoder()
							});
					case 'lt':
						return $author$project$DataElement$Expression$compareDecoder(
							{
								dateCompare: $author$project$DataElement$Expression$GlobalLTDate,
								dateDecoder: $author$project$DataElement$Expression$cyclic$globalDateDecoder(),
								dateTimeCompare: $author$project$DataElement$Expression$GlobalLTDateTime,
								dateTimeDecoder: $author$project$DataElement$Expression$cyclic$globalDateTimeDecoder(),
								numberCompare: $author$project$DataElement$Expression$GlobalLTNumber,
								numberDecoder: $author$project$DataElement$Expression$cyclic$globalNumberDecoder(),
								stringCompare: $author$project$DataElement$Expression$GlobalLTString,
								stringDecoder: $author$project$DataElement$Expression$cyclic$globalStringDecoder()
							});
					case 'lte':
						return $author$project$DataElement$Expression$compareDecoder(
							{
								dateCompare: $author$project$DataElement$Expression$GlobalLTEDate,
								dateDecoder: $author$project$DataElement$Expression$cyclic$globalDateDecoder(),
								dateTimeCompare: $author$project$DataElement$Expression$GlobalLTEDateTime,
								dateTimeDecoder: $author$project$DataElement$Expression$cyclic$globalDateTimeDecoder(),
								numberCompare: $author$project$DataElement$Expression$GlobalLTENumber,
								numberDecoder: $author$project$DataElement$Expression$cyclic$globalNumberDecoder(),
								stringCompare: $author$project$DataElement$Expression$GlobalLTEString,
								stringDecoder: $author$project$DataElement$Expression$cyclic$globalStringDecoder()
							});
					case 'equal':
						return $author$project$DataElement$Expression$compareFieldDecoder(
							{
								boolCompare: $author$project$DataElement$Expression$GlobalEqualBool,
								boolDecoder: $author$project$DataElement$Expression$cyclic$globalBoolDecoder(),
								dateCompare: $author$project$DataElement$Expression$GlobalEqualDate,
								dateDecoder: $author$project$DataElement$Expression$cyclic$globalDateDecoder(),
								dateTimeCompare: $author$project$DataElement$Expression$GlobalEqualDateTime,
								dateTimeDecoder: $author$project$DataElement$Expression$cyclic$globalDateTimeDecoder(),
								numberCompare: $author$project$DataElement$Expression$GlobalEqualNumber,
								numberDecoder: $author$project$DataElement$Expression$cyclic$globalNumberDecoder(),
								stringCompare: $author$project$DataElement$Expression$GlobalEqualString,
								stringDecoder: $author$project$DataElement$Expression$cyclic$globalStringDecoder()
							});
					case 'not equal':
						return $author$project$DataElement$Expression$compareFieldDecoder(
							{
								boolCompare: $author$project$DataElement$Expression$GlobalNotEqualBool,
								boolDecoder: $author$project$DataElement$Expression$cyclic$globalBoolDecoder(),
								dateCompare: $author$project$DataElement$Expression$GlobalNotEqualDate,
								dateDecoder: $author$project$DataElement$Expression$cyclic$globalDateDecoder(),
								dateTimeCompare: $author$project$DataElement$Expression$GlobalNotEqualDateTime,
								dateTimeDecoder: $author$project$DataElement$Expression$cyclic$globalDateTimeDecoder(),
								numberCompare: $author$project$DataElement$Expression$GlobalNotEqualNumber,
								numberDecoder: $author$project$DataElement$Expression$cyclic$globalNumberDecoder(),
								stringCompare: $author$project$DataElement$Expression$GlobalNotEqualString,
								stringDecoder: $author$project$DataElement$Expression$cyclic$globalStringDecoder()
							});
					case 'in':
						return A3(
							$elm$json$Json$Decode$map2,
							$author$project$DataElement$Expression$GlobalStringIn,
							A2(
								$elm$json$Json$Decode$field,
								'expression1',
								$author$project$DataElement$Expression$cyclic$globalStringDecoder()),
							A2(
								$elm$json$Json$Decode$field,
								'expression2',
								$author$project$DataElement$Expression$cyclic$globalStringListDecoder()));
					case 'not in':
						return A3(
							$elm$json$Json$Decode$map2,
							$author$project$DataElement$Expression$GlobalStringNotIn,
							A2(
								$elm$json$Json$Decode$field,
								'expression1',
								$author$project$DataElement$Expression$cyclic$globalStringDecoder()),
							A2(
								$elm$json$Json$Decode$field,
								'expression2',
								$author$project$DataElement$Expression$cyclic$globalStringListDecoder()));
					case 'not':
						return A2(
							$elm$json$Json$Decode$map,
							$author$project$DataElement$Expression$GlobalNot,
							A2(
								$elm$json$Json$Decode$field,
								'expression',
								$author$project$DataElement$Expression$cyclic$globalBoolDecoder()));
					case 'all':
						return A2(
							$elm$json$Json$Decode$map,
							$author$project$DataElement$Expression$GlobalAll,
							A2(
								$elm$json$Json$Decode$field,
								'expression',
								$author$project$DataElement$Expression$cyclic$globalBoolListDecoder()));
					case 'any':
						return A2(
							$elm$json$Json$Decode$map,
							$author$project$DataElement$Expression$GlobalAny,
							A2(
								$elm$json$Json$Decode$field,
								'expression',
								$author$project$DataElement$Expression$cyclic$globalBoolListDecoder()));
					case 'pick one':
						return A2(
							$author$project$DataElement$Expression$pickOneDecoder,
							$author$project$DataElement$Expression$GlobalPickBool,
							$author$project$DataElement$Expression$cyclic$globalBoolListDecoder());
					case 'if':
						return A3(
							$author$project$DataElement$Expression$ifDecoder,
							$author$project$DataElement$Expression$GlobalBoolIf,
							$author$project$DataElement$Expression$cyclic$globalBoolDecoder(),
							$author$project$DataElement$Expression$cyclic$globalBoolDecoder());
					case 'is null':
						return A2(
							$elm$json$Json$Decode$map,
							$author$project$DataElement$Expression$GlobalIsNull,
							A2(
								$elm$json$Json$Decode$field,
								'expression',
								$author$project$DataElement$Expression$cyclic$globalFieldDecoder()));
					case 'is not null':
						return A2(
							$elm$json$Json$Decode$map,
							$author$project$DataElement$Expression$GlobalIsNotNull,
							A2(
								$elm$json$Json$Decode$field,
								'expression',
								$author$project$DataElement$Expression$cyclic$globalFieldDecoder()));
					default:
						return $elm$json$Json$Decode$fail('Could not parse \'' + (words + '\' as a Global Bool Expression'));
				}
			}));
}
function $author$project$DataElement$Expression$cyclic$globalBoolListDecoder() {
	return A2(
		$author$project$DataElement$Expression$confirmDataType,
		$author$project$FieldType$BoolType,
		$author$project$DataElement$Expression$typeDecoder(
			function (words) {
				var _v10 = $elm$core$String$toLower(words);
				switch (_v10) {
					case 'field in list':
						return A3(
							$elm$json$Json$Decode$map2,
							$author$project$DataElement$Expression$GlobalAllBoolsInField,
							A2($elm$json$Json$Decode$field, 'dataElement', $author$project$DataElement$Reference$recordListReferenceDecoder),
							A2($elm$json$Json$Decode$field, 'field', $author$project$FieldName$decoder));
					case 'list of expressions':
						return A2(
							$elm$json$Json$Decode$map,
							$author$project$DataElement$Expression$GlobalBoolsAsList,
							A2(
								$elm$json$Json$Decode$field,
								'expressions',
								$elm$json$Json$Decode$list(
									$author$project$DataElement$Expression$cyclic$globalBoolDecoder())));
					case 'if':
						return A3(
							$author$project$DataElement$Expression$ifDecoder,
							$author$project$DataElement$Expression$GlobalBoolListIf,
							$author$project$DataElement$Expression$cyclic$globalBoolDecoder(),
							$author$project$DataElement$Expression$cyclic$globalBoolListDecoder());
					default:
						return $elm$json$Json$Decode$fail('Could not parse \'' + (words + '\' as a Global Bool List Expression'));
				}
			}));
}
function $author$project$DataElement$Expression$cyclic$globalComparableListDecoder() {
	return A2(
		$elm$json$Json$Decode$andThen,
		function (fieldType) {
			switch (fieldType.$) {
				case 'StringType':
					return A2(
						$elm$json$Json$Decode$map,
						$author$project$DataElement$Expression$GlobalCompStringListExpr,
						$author$project$DataElement$Expression$cyclic$globalStringListDecoder());
				case 'NumberType':
					return A2(
						$elm$json$Json$Decode$map,
						$author$project$DataElement$Expression$GlobalCompNumberListExpr,
						$author$project$DataElement$Expression$cyclic$globalNumberListDecoder());
				case 'DateType':
					return A2(
						$elm$json$Json$Decode$map,
						$author$project$DataElement$Expression$GlobalCompDateListExpr,
						$author$project$DataElement$Expression$cyclic$globalDateListDecoder());
				case 'DateTimeType':
					return A2(
						$elm$json$Json$Decode$map,
						$author$project$DataElement$Expression$GlobalCompDateTimeListExpr,
						$author$project$DataElement$Expression$cyclic$globalDateTimeListDecoder());
				default:
					return $elm$json$Json$Decode$fail(
						'Data type \'' + ($author$project$FieldType$toString(fieldType) + '\' is not supported as a Global Comparable List Expression'));
			}
		},
		A2($elm$json$Json$Decode$field, 'dataType', $author$project$FieldType$decoder));
}
function $author$project$DataElement$Expression$cyclic$globalDateDecoder() {
	return A2(
		$author$project$DataElement$Expression$confirmDataType,
		$author$project$FieldType$DateType,
		$author$project$DataElement$Expression$typeDecoder(
			function (words) {
				var _v8 = $elm$core$String$toLower(words);
				switch (_v8) {
					case 'singleton field':
						return A3(
							$elm$json$Json$Decode$map2,
							$author$project$DataElement$Expression$GlobalDateLookup,
							A2($elm$json$Json$Decode$field, 'dataElement', $author$project$DataElement$Reference$singletonReferenceDecoder),
							A2($elm$json$Json$Decode$field, 'field', $author$project$FieldName$decoder));
					case 'static':
						return A2(
							$elm$json$Json$Decode$map,
							$author$project$DataElement$Expression$GlobalDateHardcoded,
							A2($elm$json$Json$Decode$field, 'value', $author$project$DataElement$Expression$dateDecoder));
					case 'date/time to date':
						return A2(
							$elm$json$Json$Decode$map,
							$author$project$DataElement$Expression$GlobalDateTimeToDate,
							A2(
								$elm$json$Json$Decode$field,
								'dateTimeExpression',
								$author$project$DataElement$Expression$cyclic$globalDateTimeDecoder()));
					case 'date ceiling':
						return A3(
							$elm$json$Json$Decode$map2,
							$author$project$DataElement$Expression$GlobalDateCeiling,
							A2($elm$json$Json$Decode$field, 'dateInterval', $author$project$DateInterval$decoder),
							A2(
								$elm$json$Json$Decode$field,
								'expression',
								$author$project$DataElement$Expression$cyclic$globalDateDecoder()));
					case 'date floor':
						return A3(
							$elm$json$Json$Decode$map2,
							$author$project$DataElement$Expression$GlobalDateFloor,
							A2($elm$json$Json$Decode$field, 'dateInterval', $author$project$DateInterval$decoder),
							A2(
								$elm$json$Json$Decode$field,
								'expression',
								$author$project$DataElement$Expression$cyclic$globalDateDecoder()));
					case 'date addition':
						return A4(
							$elm$json$Json$Decode$map3,
							$author$project$DataElement$Expression$GlobalDateAdd,
							A2($elm$json$Json$Decode$field, 'dateUnit', $author$project$DateUnit$decoder),
							A2(
								$elm$json$Json$Decode$field,
								'expression2',
								$author$project$DataElement$Expression$cyclic$globalNumberDecoder()),
							A2(
								$elm$json$Json$Decode$field,
								'expression1',
								$author$project$DataElement$Expression$cyclic$globalDateDecoder()));
					case 'date subtraction':
						return A4(
							$elm$json$Json$Decode$map3,
							$author$project$DataElement$Expression$GlobalDateSubtract,
							A2($elm$json$Json$Decode$field, 'dateUnit', $author$project$DateUnit$decoder),
							A2(
								$elm$json$Json$Decode$field,
								'expression2',
								$author$project$DataElement$Expression$cyclic$globalNumberDecoder()),
							A2(
								$elm$json$Json$Decode$field,
								'expression1',
								$author$project$DataElement$Expression$cyclic$globalDateDecoder()));
					case 'pick one':
						return A2(
							$author$project$DataElement$Expression$pickOneDecoder,
							$author$project$DataElement$Expression$GlobalPickDate,
							$author$project$DataElement$Expression$cyclic$globalDateListDecoder());
					case 'max':
						return A2(
							$elm$json$Json$Decode$map,
							$author$project$DataElement$Expression$GlobalMaxDate,
							A2(
								$elm$json$Json$Decode$field,
								'expression',
								$author$project$DataElement$Expression$cyclic$globalDateListDecoder()));
					case 'min':
						return A2(
							$elm$json$Json$Decode$map,
							$author$project$DataElement$Expression$GlobalMinDate,
							A2(
								$elm$json$Json$Decode$field,
								'expression',
								$author$project$DataElement$Expression$cyclic$globalDateListDecoder()));
					case 'if':
						return A3(
							$author$project$DataElement$Expression$ifDecoder,
							$author$project$DataElement$Expression$GlobalDateIf,
							$author$project$DataElement$Expression$cyclic$globalBoolDecoder(),
							$author$project$DataElement$Expression$cyclic$globalDateDecoder());
					default:
						return $elm$json$Json$Decode$fail('Could not parse \'' + (words + '\' as a Global Date Expression'));
				}
			}));
}
function $author$project$DataElement$Expression$cyclic$globalDateListDecoder() {
	return A2(
		$author$project$DataElement$Expression$confirmDataType,
		$author$project$FieldType$DateType,
		$author$project$DataElement$Expression$typeDecoder(
			function (words) {
				var _v7 = $elm$core$String$toLower(words);
				switch (_v7) {
					case 'field in list':
						return A3(
							$elm$json$Json$Decode$map2,
							$author$project$DataElement$Expression$GlobalAllDatesInField,
							A2($elm$json$Json$Decode$field, 'dataElement', $author$project$DataElement$Reference$recordListReferenceDecoder),
							A2($elm$json$Json$Decode$field, 'field', $author$project$FieldName$decoder));
					case 'list of expressions':
						return A2(
							$elm$json$Json$Decode$map,
							$author$project$DataElement$Expression$GlobalDatesAsList,
							A2(
								$elm$json$Json$Decode$field,
								'expressions',
								$elm$json$Json$Decode$list(
									$author$project$DataElement$Expression$cyclic$globalDateDecoder())));
					case 'if':
						return A3(
							$author$project$DataElement$Expression$ifDecoder,
							$author$project$DataElement$Expression$GlobalDateListIf,
							$author$project$DataElement$Expression$cyclic$globalBoolDecoder(),
							$author$project$DataElement$Expression$cyclic$globalDateListDecoder());
					default:
						return $elm$json$Json$Decode$fail('Could not parse \'' + (words + '\' as a Global Date List Expression'));
				}
			}));
}
function $author$project$DataElement$Expression$cyclic$globalDateTimeDecoder() {
	return A2(
		$author$project$DataElement$Expression$confirmDataType,
		$author$project$FieldType$DateTimeType,
		$author$project$DataElement$Expression$typeDecoder(
			function (words) {
				var _v6 = $elm$core$String$toLower(words);
				switch (_v6) {
					case 'singleton field':
						return A3(
							$elm$json$Json$Decode$map2,
							$author$project$DataElement$Expression$GlobalDateTimeLookup,
							A2($elm$json$Json$Decode$field, 'dataElement', $author$project$DataElement$Reference$singletonReferenceDecoder),
							A2($elm$json$Json$Decode$field, 'field', $author$project$FieldName$decoder));
					case 'static':
						return A2(
							$elm$json$Json$Decode$map,
							$author$project$DataElement$Expression$GlobalDateTimeHardcoded,
							A2($elm$json$Json$Decode$field, 'value', $rtfeldman$elm_iso8601_date_strings$Iso8601$decoder));
					case 'pick one':
						return A2(
							$author$project$DataElement$Expression$pickOneDecoder,
							$author$project$DataElement$Expression$GlobalPickDateTime,
							$author$project$DataElement$Expression$cyclic$globalDateTimeListDecoder());
					case 'max':
						return A2(
							$elm$json$Json$Decode$map,
							$author$project$DataElement$Expression$GlobalMaxDateTime,
							A2(
								$elm$json$Json$Decode$field,
								'expression',
								$author$project$DataElement$Expression$cyclic$globalDateTimeListDecoder()));
					case 'min':
						return A2(
							$elm$json$Json$Decode$map,
							$author$project$DataElement$Expression$GlobalMinDateTime,
							A2(
								$elm$json$Json$Decode$field,
								'expression',
								$author$project$DataElement$Expression$cyclic$globalDateTimeListDecoder()));
					case 'if':
						return A3(
							$author$project$DataElement$Expression$ifDecoder,
							$author$project$DataElement$Expression$GlobalDateTimeIf,
							$author$project$DataElement$Expression$cyclic$globalBoolDecoder(),
							$author$project$DataElement$Expression$cyclic$globalDateTimeDecoder());
					default:
						return $elm$json$Json$Decode$fail('Could not parse \'' + (words + '\' as a Global DateTime Expression'));
				}
			}));
}
function $author$project$DataElement$Expression$cyclic$globalDateTimeListDecoder() {
	return A2(
		$author$project$DataElement$Expression$confirmDataType,
		$author$project$FieldType$DateTimeType,
		$author$project$DataElement$Expression$typeDecoder(
			function (words) {
				var _v5 = $elm$core$String$toLower(words);
				switch (_v5) {
					case 'field in list':
						return A3(
							$elm$json$Json$Decode$map2,
							$author$project$DataElement$Expression$GlobalAllDateTimesInField,
							A2($elm$json$Json$Decode$field, 'dataElement', $author$project$DataElement$Reference$recordListReferenceDecoder),
							A2($elm$json$Json$Decode$field, 'field', $author$project$FieldName$decoder));
					case 'list of expressions':
						return A2(
							$elm$json$Json$Decode$map,
							$author$project$DataElement$Expression$GlobalDateTimesAsList,
							A2(
								$elm$json$Json$Decode$field,
								'expressions',
								$elm$json$Json$Decode$list(
									$author$project$DataElement$Expression$cyclic$globalDateTimeDecoder())));
					case 'if':
						return A3(
							$author$project$DataElement$Expression$ifDecoder,
							$author$project$DataElement$Expression$GlobalDateTimeListIf,
							$author$project$DataElement$Expression$cyclic$globalBoolDecoder(),
							$author$project$DataElement$Expression$cyclic$globalDateTimeListDecoder());
					default:
						return $elm$json$Json$Decode$fail('Could not parse \'' + (words + '\' as a Global DateTime List Expression'));
				}
			}));
}
function $author$project$DataElement$Expression$cyclic$globalFieldDecoder() {
	return A2(
		$elm$json$Json$Decode$andThen,
		function (fieldType) {
			switch (fieldType.$) {
				case 'StringType':
					return A2(
						$elm$json$Json$Decode$map,
						$author$project$DataElement$Expression$GlobalStringExpr,
						$author$project$DataElement$Expression$cyclic$globalStringDecoder());
				case 'NumberType':
					return A2(
						$elm$json$Json$Decode$map,
						$author$project$DataElement$Expression$GlobalNumberExpr,
						$author$project$DataElement$Expression$cyclic$globalNumberDecoder());
				case 'DateType':
					return A2(
						$elm$json$Json$Decode$map,
						$author$project$DataElement$Expression$GlobalDateExpr,
						$author$project$DataElement$Expression$cyclic$globalDateDecoder());
				case 'DateTimeType':
					return A2(
						$elm$json$Json$Decode$map,
						$author$project$DataElement$Expression$GlobalDateTimeExpr,
						$author$project$DataElement$Expression$cyclic$globalDateTimeDecoder());
				default:
					return A2(
						$elm$json$Json$Decode$map,
						$author$project$DataElement$Expression$GlobalBoolExpr,
						$author$project$DataElement$Expression$cyclic$globalBoolDecoder());
			}
		},
		A2($elm$json$Json$Decode$field, 'dataType', $author$project$FieldType$decoder));
}
function $author$project$DataElement$Expression$cyclic$globalNumberDecoder() {
	return A2(
		$author$project$DataElement$Expression$confirmDataType,
		$author$project$FieldType$NumberType,
		$author$project$DataElement$Expression$typeDecoder(
			function (words) {
				var _v3 = $elm$core$String$toLower(words);
				switch (_v3) {
					case 'singleton field':
						return A3(
							$elm$json$Json$Decode$map2,
							$author$project$DataElement$Expression$GlobalNumberLookup,
							A2($elm$json$Json$Decode$field, 'dataElement', $author$project$DataElement$Reference$singletonReferenceDecoder),
							A2($elm$json$Json$Decode$field, 'field', $author$project$FieldName$decoder));
					case 'static':
						return A2(
							$elm$json$Json$Decode$map,
							$author$project$DataElement$Expression$GlobalNumberHardcoded,
							A2($elm$json$Json$Decode$field, 'value', $elm$json$Json$Decode$float));
					case 'count unique':
						return A2(
							$elm$json$Json$Decode$map,
							$author$project$DataElement$Expression$GlobalCountUnique,
							A2(
								$elm$json$Json$Decode$field,
								'expression',
								$author$project$DataElement$Expression$cyclic$globalComparableListDecoder()));
					case 'round number':
						return A2(
							$elm$json$Json$Decode$map,
							$author$project$DataElement$Expression$GlobalRound,
							A2(
								$elm$json$Json$Decode$field,
								'expression',
								$author$project$DataElement$Expression$cyclic$globalNumberDecoder()));
					case 'sum':
						return A2(
							$elm$json$Json$Decode$map,
							$author$project$DataElement$Expression$GlobalSum,
							A2(
								$elm$json$Json$Decode$field,
								'expression',
								$author$project$DataElement$Expression$cyclic$globalNumberListDecoder()));
					case 'product':
						return A2(
							$elm$json$Json$Decode$map,
							$author$project$DataElement$Expression$GlobalProduct,
							A2(
								$elm$json$Json$Decode$field,
								'expression',
								$author$project$DataElement$Expression$cyclic$globalNumberListDecoder()));
					case 'add number':
						return A3(
							$elm$json$Json$Decode$map2,
							$author$project$DataElement$Expression$GlobalAdd,
							A2(
								$elm$json$Json$Decode$field,
								'expression1',
								$author$project$DataElement$Expression$cyclic$globalNumberDecoder()),
							A2(
								$elm$json$Json$Decode$field,
								'expression2',
								$author$project$DataElement$Expression$cyclic$globalNumberDecoder()));
					case 'subtract number':
						return A3(
							$elm$json$Json$Decode$map2,
							$author$project$DataElement$Expression$GlobalSubtract,
							A2(
								$elm$json$Json$Decode$field,
								'expression1',
								$author$project$DataElement$Expression$cyclic$globalNumberDecoder()),
							A2(
								$elm$json$Json$Decode$field,
								'expression2',
								$author$project$DataElement$Expression$cyclic$globalNumberDecoder()));
					case 'multiply number':
						return A3(
							$elm$json$Json$Decode$map2,
							$author$project$DataElement$Expression$GlobalMultiply,
							A2(
								$elm$json$Json$Decode$field,
								'expression1',
								$author$project$DataElement$Expression$cyclic$globalNumberDecoder()),
							A2(
								$elm$json$Json$Decode$field,
								'expression2',
								$author$project$DataElement$Expression$cyclic$globalNumberDecoder()));
					case 'divide number':
						return A3(
							$elm$json$Json$Decode$map2,
							$author$project$DataElement$Expression$GlobalDivide,
							A2(
								$elm$json$Json$Decode$field,
								'expression1',
								$author$project$DataElement$Expression$cyclic$globalNumberDecoder()),
							A2(
								$elm$json$Json$Decode$field,
								'expression2',
								$author$project$DataElement$Expression$cyclic$globalNumberDecoder()));
					case 'date month':
						return A2(
							$elm$json$Json$Decode$map,
							$author$project$DataElement$Expression$GlobalMonthNumber,
							A2(
								$elm$json$Json$Decode$field,
								'expression',
								$author$project$DataElement$Expression$cyclic$globalDateDecoder()));
					case 'date year':
						return A2(
							$elm$json$Json$Decode$map,
							$author$project$DataElement$Expression$GlobalYearNumber,
							A2(
								$elm$json$Json$Decode$field,
								'expression',
								$author$project$DataElement$Expression$cyclic$globalDateDecoder()));
					case 'date day in month':
						return A2(
							$elm$json$Json$Decode$map,
							$author$project$DataElement$Expression$GlobalDayInMonth,
							A2(
								$elm$json$Json$Decode$field,
								'expression',
								$author$project$DataElement$Expression$cyclic$globalDateDecoder()));
					case 'pick one':
						return A2(
							$author$project$DataElement$Expression$pickOneDecoder,
							$author$project$DataElement$Expression$GlobalPickNumber,
							$author$project$DataElement$Expression$cyclic$globalNumberListDecoder());
					case 'max':
						return A2(
							$elm$json$Json$Decode$map,
							$author$project$DataElement$Expression$GlobalMaxNumber,
							A2(
								$elm$json$Json$Decode$field,
								'expression',
								$author$project$DataElement$Expression$cyclic$globalNumberListDecoder()));
					case 'min':
						return A2(
							$elm$json$Json$Decode$map,
							$author$project$DataElement$Expression$GlobalMinNumber,
							A2(
								$elm$json$Json$Decode$field,
								'expression',
								$author$project$DataElement$Expression$cyclic$globalNumberListDecoder()));
					case 'if':
						return A3(
							$author$project$DataElement$Expression$ifDecoder,
							$author$project$DataElement$Expression$GlobalNumberIf,
							$author$project$DataElement$Expression$cyclic$globalBoolDecoder(),
							$author$project$DataElement$Expression$cyclic$globalNumberDecoder());
					default:
						return $elm$json$Json$Decode$fail('Could not parse \'' + (words + '\' as a Global Float Expression'));
				}
			}));
}
function $author$project$DataElement$Expression$cyclic$globalNumberListDecoder() {
	return A2(
		$author$project$DataElement$Expression$confirmDataType,
		$author$project$FieldType$NumberType,
		$author$project$DataElement$Expression$typeDecoder(
			function (words) {
				var _v2 = $elm$core$String$toLower(words);
				switch (_v2) {
					case 'field in list':
						return A3(
							$elm$json$Json$Decode$map2,
							$author$project$DataElement$Expression$GlobalAllNumbersInField,
							A2($elm$json$Json$Decode$field, 'dataElement', $author$project$DataElement$Reference$recordListReferenceDecoder),
							A2($elm$json$Json$Decode$field, 'field', $author$project$FieldName$decoder));
					case 'list of expressions':
						return A2(
							$elm$json$Json$Decode$map,
							$author$project$DataElement$Expression$GlobalNumbersAsList,
							A2(
								$elm$json$Json$Decode$field,
								'expressions',
								$elm$json$Json$Decode$list(
									$author$project$DataElement$Expression$cyclic$globalNumberDecoder())));
					case 'if':
						return A3(
							$author$project$DataElement$Expression$ifDecoder,
							$author$project$DataElement$Expression$GlobalNumberListIf,
							$author$project$DataElement$Expression$cyclic$globalBoolDecoder(),
							$author$project$DataElement$Expression$cyclic$globalNumberListDecoder());
					default:
						return $elm$json$Json$Decode$fail('Could not parse \'' + (words + '\' as a Global Number List Expression'));
				}
			}));
}
function $author$project$DataElement$Expression$cyclic$globalStringDecoder() {
	return A2(
		$author$project$DataElement$Expression$confirmDataType,
		$author$project$FieldType$StringType,
		$author$project$DataElement$Expression$typeDecoder(
			function (words) {
				var _v1 = $elm$core$String$toLower(words);
				switch (_v1) {
					case 'static':
						return A2(
							$elm$json$Json$Decode$map,
							$author$project$DataElement$Expression$GlobalStringHardcoded,
							A2($elm$json$Json$Decode$field, 'value', $elm$json$Json$Decode$string));
					case 'singleton field':
						return A3(
							$elm$json$Json$Decode$map2,
							$author$project$DataElement$Expression$GlobalStringLookup,
							A2($elm$json$Json$Decode$field, 'dataElement', $author$project$DataElement$Reference$singletonReferenceDecoder),
							A2($elm$json$Json$Decode$field, 'field', $author$project$FieldName$decoder));
					case 'format date':
						return A3(
							$elm$json$Json$Decode$map2,
							A2(
								$elm$core$Basics$composeR,
								$elm$core$Maybe$map($author$project$DataElement$Expression$GlobalFormatDate),
								$elm$core$Maybe$withDefault($author$project$DataElement$Expression$GlobalFormatDateLocaleAware)),
							A2(
								$elm_community$json_extra$Json$Decode$Extra$optionalNullableField,
								'formatExpression',
								$author$project$DataElement$Expression$cyclic$globalStringDecoder()),
							A2(
								$elm$json$Json$Decode$field,
								'dateExpression',
								$author$project$DataElement$Expression$cyclic$globalDateDecoder()));
					case 'format date/time':
						return A2(
							$elm$json$Json$Decode$map,
							$author$project$DataElement$Expression$GlobalFormatDateTime,
							A2(
								$elm$json$Json$Decode$field,
								'dateTimeExpression',
								$author$project$DataElement$Expression$cyclic$globalDateTimeDecoder()));
					case 'float to string':
						return A3(
							$elm$json$Json$Decode$map2,
							$author$project$DataElement$Expression$GlobalFormatNumber,
							A2($elm$json$Json$Decode$field, 'decimals', $elm$json$Json$Decode$int),
							A2(
								$elm$json$Json$Decode$field,
								'expression',
								$author$project$DataElement$Expression$cyclic$globalNumberDecoder()));
					case 'number to string':
						return A3(
							$elm$json$Json$Decode$map2,
							$author$project$DataElement$Expression$GlobalFormatNumber,
							A2($elm$json$Json$Decode$field, 'decimals', $elm$json$Json$Decode$int),
							A2(
								$elm$json$Json$Decode$field,
								'expression',
								$author$project$DataElement$Expression$cyclic$globalNumberDecoder()));
					case 'concat':
						return A3(
							$elm$json$Json$Decode$map2,
							$author$project$DataElement$Expression$GlobalConcat,
							A2(
								$elm$json$Json$Decode$field,
								'joinExpression',
								$author$project$DataElement$Expression$cyclic$globalStringDecoder()),
							A2(
								$elm$json$Json$Decode$field,
								'listExpression',
								$author$project$DataElement$Expression$cyclic$globalStringListDecoder()));
					case 'pick one':
						return A2(
							$author$project$DataElement$Expression$pickOneDecoder,
							$author$project$DataElement$Expression$GlobalPickString,
							$author$project$DataElement$Expression$cyclic$globalStringListDecoder());
					case 'max':
						return A2(
							$elm$json$Json$Decode$map,
							$author$project$DataElement$Expression$GlobalMaxString,
							A2(
								$elm$json$Json$Decode$field,
								'expression',
								$author$project$DataElement$Expression$cyclic$globalStringListDecoder()));
					case 'min':
						return A2(
							$elm$json$Json$Decode$map,
							$author$project$DataElement$Expression$GlobalMinString,
							A2(
								$elm$json$Json$Decode$field,
								'expression',
								$author$project$DataElement$Expression$cyclic$globalStringListDecoder()));
					case 'if':
						return A3(
							$author$project$DataElement$Expression$ifDecoder,
							$author$project$DataElement$Expression$GlobalStringIf,
							$author$project$DataElement$Expression$cyclic$globalBoolDecoder(),
							$author$project$DataElement$Expression$cyclic$globalStringDecoder());
					default:
						return $elm$json$Json$Decode$fail('Could not parse \'' + (words + '\' as a Global String Expression'));
				}
			}));
}
function $author$project$DataElement$Expression$cyclic$globalStringListDecoder() {
	return A2(
		$author$project$DataElement$Expression$confirmDataType,
		$author$project$FieldType$StringType,
		$author$project$DataElement$Expression$typeDecoder(
			function (words) {
				var _v0 = $elm$core$String$toLower(words);
				switch (_v0) {
					case 'field in list':
						return A3(
							$elm$json$Json$Decode$map2,
							$author$project$DataElement$Expression$GlobalAllStringsInField,
							A2($elm$json$Json$Decode$field, 'dataElement', $author$project$DataElement$Reference$recordListReferenceDecoder),
							A2($elm$json$Json$Decode$field, 'field', $author$project$FieldName$decoder));
					case 'list of expressions':
						return A2(
							$elm$json$Json$Decode$map,
							$author$project$DataElement$Expression$GlobalStringsAsList,
							A2(
								$elm$json$Json$Decode$field,
								'expressions',
								$elm$json$Json$Decode$list(
									$author$project$DataElement$Expression$cyclic$globalStringDecoder())));
					case 'if':
						return A3(
							$author$project$DataElement$Expression$ifDecoder,
							$author$project$DataElement$Expression$GlobalStringListIf,
							$author$project$DataElement$Expression$cyclic$globalBoolDecoder(),
							$author$project$DataElement$Expression$cyclic$globalStringListDecoder());
					case 'challenge reasons':
						return A2(
							$elm$json$Json$Decode$map,
							$author$project$DataElement$Expression$GlobalChallengeReasons,
							A2(
								$elm$json$Json$Decode$field,
								'expression',
								$author$project$DataElement$Expression$cyclic$globalStringDecoder()));
					case 'target challenge reasons':
						return A2(
							$elm$json$Json$Decode$map,
							$author$project$DataElement$Expression$GlobalTargetChallengeReasons,
							A2(
								$elm$json$Json$Decode$field,
								'expression',
								$author$project$DataElement$Expression$cyclic$globalStringDecoder()));
					default:
						return $elm$json$Json$Decode$fail('Could not parse \'' + (words + '\' as a Global String List Expression'));
				}
			}));
}
try {
	var $author$project$DataElement$Expression$globalBoolDecoder = $author$project$DataElement$Expression$cyclic$globalBoolDecoder();
	$author$project$DataElement$Expression$cyclic$globalBoolDecoder = function () {
		return $author$project$DataElement$Expression$globalBoolDecoder;
	};
	var $author$project$DataElement$Expression$globalBoolListDecoder = $author$project$DataElement$Expression$cyclic$globalBoolListDecoder();
	$author$project$DataElement$Expression$cyclic$globalBoolListDecoder = function () {
		return $author$project$DataElement$Expression$globalBoolListDecoder;
	};
	var $author$project$DataElement$Expression$globalComparableListDecoder = $author$project$DataElement$Expression$cyclic$globalComparableListDecoder();
	$author$project$DataElement$Expression$cyclic$globalComparableListDecoder = function () {
		return $author$project$DataElement$Expression$globalComparableListDecoder;
	};
	var $author$project$DataElement$Expression$globalDateDecoder = $author$project$DataElement$Expression$cyclic$globalDateDecoder();
	$author$project$DataElement$Expression$cyclic$globalDateDecoder = function () {
		return $author$project$DataElement$Expression$globalDateDecoder;
	};
	var $author$project$DataElement$Expression$globalDateListDecoder = $author$project$DataElement$Expression$cyclic$globalDateListDecoder();
	$author$project$DataElement$Expression$cyclic$globalDateListDecoder = function () {
		return $author$project$DataElement$Expression$globalDateListDecoder;
	};
	var $author$project$DataElement$Expression$globalDateTimeDecoder = $author$project$DataElement$Expression$cyclic$globalDateTimeDecoder();
	$author$project$DataElement$Expression$cyclic$globalDateTimeDecoder = function () {
		return $author$project$DataElement$Expression$globalDateTimeDecoder;
	};
	var $author$project$DataElement$Expression$globalDateTimeListDecoder = $author$project$DataElement$Expression$cyclic$globalDateTimeListDecoder();
	$author$project$DataElement$Expression$cyclic$globalDateTimeListDecoder = function () {
		return $author$project$DataElement$Expression$globalDateTimeListDecoder;
	};
	var $author$project$DataElement$Expression$globalFieldDecoder = $author$project$DataElement$Expression$cyclic$globalFieldDecoder();
	$author$project$DataElement$Expression$cyclic$globalFieldDecoder = function () {
		return $author$project$DataElement$Expression$globalFieldDecoder;
	};
	var $author$project$DataElement$Expression$globalNumberDecoder = $author$project$DataElement$Expression$cyclic$globalNumberDecoder();
	$author$project$DataElement$Expression$cyclic$globalNumberDecoder = function () {
		return $author$project$DataElement$Expression$globalNumberDecoder;
	};
	var $author$project$DataElement$Expression$globalNumberListDecoder = $author$project$DataElement$Expression$cyclic$globalNumberListDecoder();
	$author$project$DataElement$Expression$cyclic$globalNumberListDecoder = function () {
		return $author$project$DataElement$Expression$globalNumberListDecoder;
	};
	var $author$project$DataElement$Expression$globalStringDecoder = $author$project$DataElement$Expression$cyclic$globalStringDecoder();
	$author$project$DataElement$Expression$cyclic$globalStringDecoder = function () {
		return $author$project$DataElement$Expression$globalStringDecoder;
	};
	var $author$project$DataElement$Expression$globalStringListDecoder = $author$project$DataElement$Expression$cyclic$globalStringListDecoder();
	$author$project$DataElement$Expression$cyclic$globalStringListDecoder = function () {
		return $author$project$DataElement$Expression$globalStringListDecoder;
	};
} catch ($) {
	throw 'Some top-level definitions from `DataElement.Expression` are causing infinite recursion:\n\n  ┌─────┐\n  │    globalBoolDecoder\n  │     ↓\n  │    globalBoolListDecoder\n  │     ↓\n  │    globalComparableListDecoder\n  │     ↓\n  │    globalDateDecoder\n  │     ↓\n  │    globalDateListDecoder\n  │     ↓\n  │    globalDateTimeDecoder\n  │     ↓\n  │    globalDateTimeListDecoder\n  │     ↓\n  │    globalFieldDecoder\n  │     ↓\n  │    globalNumberDecoder\n  │     ↓\n  │    globalNumberListDecoder\n  │     ↓\n  │    globalStringDecoder\n  │     ↓\n  │    globalStringListDecoder\n  └─────┘\n\nThese errors are very tricky, so read https://elm-lang.org/0.19.1/bad-recursion to learn how to fix it!';}
var $author$project$DataElement$CrmDataEngine$Where$getCorrectBetweenDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (fieldType) {
		switch (fieldType.$) {
			case 'StringType':
				return A2($author$project$DataElement$CrmDataEngine$Where$betweenDecoder, $author$project$DataElement$CrmDataEngine$Where$BetweenString, $author$project$DataElement$Expression$globalStringDecoder);
			case 'NumberType':
				return A2($author$project$DataElement$CrmDataEngine$Where$betweenDecoder, $author$project$DataElement$CrmDataEngine$Where$BetweenNumber, $author$project$DataElement$Expression$globalNumberDecoder);
			case 'DateType':
				return A2($author$project$DataElement$CrmDataEngine$Where$betweenDecoder, $author$project$DataElement$CrmDataEngine$Where$BetweenDate, $author$project$DataElement$Expression$globalDateDecoder);
			case 'DateTimeType':
				return A2($author$project$DataElement$CrmDataEngine$Where$betweenDecoder, $author$project$DataElement$CrmDataEngine$Where$BetweenDateTime, $author$project$DataElement$Expression$globalDateTimeDecoder);
			default:
				return $elm$json$Json$Decode$fail(
					'Data type \'' + ($author$project$FieldType$toString(fieldType) + '\' is not supported in Between.'));
		}
	},
	A2(
		$elm$json$Json$Decode$at,
		_List_fromArray(
			['startValue', 'dataType']),
		$author$project$FieldType$decoder));
var $author$project$DataElement$Expression$GlobalCompDateExpr = function (a) {
	return {$: 'GlobalCompDateExpr', a: a};
};
var $author$project$DataElement$Expression$GlobalCompDateTimeExpr = function (a) {
	return {$: 'GlobalCompDateTimeExpr', a: a};
};
var $author$project$DataElement$Expression$GlobalCompNumberExpr = function (a) {
	return {$: 'GlobalCompNumberExpr', a: a};
};
var $author$project$DataElement$Expression$GlobalCompStringExpr = function (a) {
	return {$: 'GlobalCompStringExpr', a: a};
};
var $author$project$DataElement$Expression$globalComparableDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (fieldType) {
		switch (fieldType.$) {
			case 'StringType':
				return A2($elm$json$Json$Decode$map, $author$project$DataElement$Expression$GlobalCompStringExpr, $author$project$DataElement$Expression$globalStringDecoder);
			case 'NumberType':
				return A2($elm$json$Json$Decode$map, $author$project$DataElement$Expression$GlobalCompNumberExpr, $author$project$DataElement$Expression$globalNumberDecoder);
			case 'DateType':
				return A2($elm$json$Json$Decode$map, $author$project$DataElement$Expression$GlobalCompDateExpr, $author$project$DataElement$Expression$globalDateDecoder);
			case 'DateTimeType':
				return A2($elm$json$Json$Decode$map, $author$project$DataElement$Expression$GlobalCompDateTimeExpr, $author$project$DataElement$Expression$globalDateTimeDecoder);
			default:
				return $elm$json$Json$Decode$fail(
					'Data type \'' + ($author$project$FieldType$toString(fieldType) + '\' is not supported as a Global Comparable Expression'));
		}
	},
	A2($elm$json$Json$Decode$field, 'dataType', $author$project$FieldType$decoder));
var $author$project$DataElement$CrmDataEngine$Where$individualWhereDecoder = function (words) {
	var _v0 = $elm$core$String$toLower(words);
	switch (_v0) {
		case 'all_of':
			return A2(
				$elm$json$Json$Decode$map,
				$author$project$DataElement$CrmDataEngine$Where$AllOf,
				A2(
					$elm$json$Json$Decode$field,
					'conditions',
					$elm$json$Json$Decode$list(
						$author$project$DataElement$CrmDataEngine$Where$cyclic$decoder())));
		case 'any_of':
			return A2(
				$elm$json$Json$Decode$map,
				$author$project$DataElement$CrmDataEngine$Where$AnyOf,
				A2(
					$elm$json$Json$Decode$field,
					'conditions',
					$elm$json$Json$Decode$list(
						$author$project$DataElement$CrmDataEngine$Where$cyclic$decoder())));
		case 'equal':
			return A3(
				$elm$json$Json$Decode$map2,
				$author$project$DataElement$CrmDataEngine$Where$Eq,
				A2($elm$json$Json$Decode$field, 'field', $author$project$FieldName$decoder),
				A2($elm$json$Json$Decode$field, 'value', $author$project$DataElement$Expression$globalFieldDecoder));
		case 'not_equal':
			return A3(
				$elm$json$Json$Decode$map2,
				$author$project$DataElement$CrmDataEngine$Where$NotEq,
				A2($elm$json$Json$Decode$field, 'field', $author$project$FieldName$decoder),
				A2($elm$json$Json$Decode$field, 'value', $author$project$DataElement$Expression$globalFieldDecoder));
		case 'greater_than':
			return A3(
				$elm$json$Json$Decode$map2,
				$author$project$DataElement$CrmDataEngine$Where$Gt,
				A2($elm$json$Json$Decode$field, 'field', $author$project$FieldName$decoder),
				A2($elm$json$Json$Decode$field, 'value', $author$project$DataElement$Expression$globalComparableDecoder));
		case 'greater_than_or_equal':
			return A3(
				$elm$json$Json$Decode$map2,
				$author$project$DataElement$CrmDataEngine$Where$Gte,
				A2($elm$json$Json$Decode$field, 'field', $author$project$FieldName$decoder),
				A2($elm$json$Json$Decode$field, 'value', $author$project$DataElement$Expression$globalComparableDecoder));
		case 'less_than':
			return A3(
				$elm$json$Json$Decode$map2,
				$author$project$DataElement$CrmDataEngine$Where$Lt,
				A2($elm$json$Json$Decode$field, 'field', $author$project$FieldName$decoder),
				A2($elm$json$Json$Decode$field, 'value', $author$project$DataElement$Expression$globalComparableDecoder));
		case 'less_than_or_equal':
			return A3(
				$elm$json$Json$Decode$map2,
				$author$project$DataElement$CrmDataEngine$Where$Lte,
				A2($elm$json$Json$Decode$field, 'field', $author$project$FieldName$decoder),
				A2($elm$json$Json$Decode$field, 'value', $author$project$DataElement$Expression$globalComparableDecoder));
		case 'between':
			return $author$project$DataElement$CrmDataEngine$Where$getCorrectBetweenDecoder;
		case 'in':
			return A3(
				$elm$json$Json$Decode$map2,
				$author$project$DataElement$CrmDataEngine$Where$In,
				A2($elm$json$Json$Decode$field, 'field', $author$project$FieldName$decoder),
				A2($elm$json$Json$Decode$field, 'values', $author$project$DataElement$Expression$globalStringListDecoder));
		case 'is_null':
			return A2(
				$elm$json$Json$Decode$map,
				$author$project$DataElement$CrmDataEngine$Where$IsNull,
				A2($elm$json$Json$Decode$field, 'field', $author$project$FieldName$decoder));
		case 'is_not_null':
			return A2(
				$elm$json$Json$Decode$map,
				$author$project$DataElement$CrmDataEngine$Where$IsNotNull,
				A2($elm$json$Json$Decode$field, 'field', $author$project$FieldName$decoder));
		default:
			return $elm$json$Json$Decode$fail('Could not parse \'' + (words + '\' as a Where clause'));
	}
};
function $author$project$DataElement$CrmDataEngine$Where$cyclic$decoder() {
	return A2(
		$elm$json$Json$Decode$andThen,
		$author$project$DataElement$CrmDataEngine$Where$individualWhereDecoder,
		A2($elm$json$Json$Decode$field, 'type', $elm$json$Json$Decode$string));
}
try {
	var $author$project$DataElement$CrmDataEngine$Where$decoder = $author$project$DataElement$CrmDataEngine$Where$cyclic$decoder();
	$author$project$DataElement$CrmDataEngine$Where$cyclic$decoder = function () {
		return $author$project$DataElement$CrmDataEngine$Where$decoder;
	};
} catch ($) {
	throw 'Some top-level definitions from `DataElement.CrmDataEngine.Where` are causing infinite recursion:\n\n  ┌─────┐\n  │    decoder\n  │     ↓\n  │    individualWhereDecoder\n  └─────┘\n\nThese errors are very tricky, so read https://elm-lang.org/0.19.1/bad-recursion to learn how to fix it!';}
var $author$project$DataElement$SortKey$SortKey = F2(
	function (field, direction) {
		return {direction: direction, field: field};
	});
var $author$project$SortDirection$Ascending = {$: 'Ascending'};
var $author$project$SortDirection$Descending = {$: 'Descending'};
var $author$project$SortDirection$fromString = function (words) {
	var _v0 = $elm$core$String$toUpper(words);
	switch (_v0) {
		case 'ASC':
			return $elm$core$Result$Ok($author$project$SortDirection$Ascending);
		case 'DESC':
			return $elm$core$Result$Ok($author$project$SortDirection$Descending);
		default:
			return $elm$core$Result$Err('Could not parse \'' + (words + '\' as a sort direction'));
	}
};
var $author$project$SortDirection$decoder = A2(
	$elm$json$Json$Decode$andThen,
	A2($elm$core$Basics$composeR, $author$project$SortDirection$fromString, $elm_community$json_extra$Json$Decode$Extra$fromResult),
	$elm$json$Json$Decode$string);
var $author$project$DataElement$SortKey$decoder = A3(
	$elm$json$Json$Decode$map2,
	$author$project$DataElement$SortKey$SortKey,
	A2(
		$elm$json$Json$Decode$at,
		_List_fromArray(
			['key', 'name']),
		$author$project$FieldName$decoder),
	A2(
		$elm$json$Json$Decode$at,
		_List_fromArray(
			['sortDir', 'value']),
		$author$project$SortDirection$decoder));
var $mgold$elm_nonempty_list$List$Nonempty$fromList = function (ys) {
	if (ys.b) {
		var x = ys.a;
		var xs = ys.b;
		return $elm$core$Maybe$Just(
			A2($mgold$elm_nonempty_list$List$Nonempty$Nonempty, x, xs));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $elm$json$Json$Decode$maybe = function (decoder) {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, decoder),
				$elm$json$Json$Decode$succeed($elm$core$Maybe$Nothing)
			]));
};
var $author$project$DataElement$CrmDataEngineQuery$decoder = A6(
	$elm$json$Json$Decode$map5,
	$author$project$DataElement$CrmDataEngineQuery$Info,
	A2($elm$json$Json$Decode$field, 'table', $author$project$ObjectName$decoder),
	A2(
		$elm$json$Json$Decode$andThen,
		A2(
			$elm$core$Basics$composeR,
			$mgold$elm_nonempty_list$List$Nonempty$fromList,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$Result$fromMaybe('\'fields\' cannot be empty'),
				$elm_community$json_extra$Json$Decode$Extra$fromResult)),
		A2(
			$elm$json$Json$Decode$field,
			'fields',
			$elm$json$Json$Decode$list($author$project$DataElement$CrmDataEngine$Field$decoder))),
	$elm$json$Json$Decode$maybe(
		A2($elm$json$Json$Decode$field, 'where', $author$project$DataElement$CrmDataEngine$Where$decoder)),
	A2(
		$elm$json$Json$Decode$map,
		$elm$core$Maybe$withDefault(_List_Nil),
		$elm$json$Json$Decode$maybe(
			A2(
				$elm$json$Json$Decode$field,
				'sort',
				$elm$json$Json$Decode$list($author$project$DataElement$SortKey$decoder)))),
	$elm$json$Json$Decode$maybe(
		A2($elm$json$Json$Decode$field, 'limit', $elm$json$Json$Decode$int)));
var $author$project$DataElement$Datepicker$Info = function (_default) {
	return {_default: _default};
};
var $author$project$DataElement$Datepicker$decoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$DataElement$Datepicker$Info,
	A2($elm_community$json_extra$Json$Decode$Extra$optionalNullableField, 'default', $author$project$DataElement$Expression$globalDateDecoder));
var $author$project$DataElement$Dropdown$Info = F3(
	function (options, placeholder, requireSelection) {
		return {options: options, placeholder: placeholder, requireSelection: requireSelection};
	});
var $author$project$DataElement$Dropdown$decoder = A4(
	$elm$json$Json$Decode$map3,
	$author$project$DataElement$Dropdown$Info,
	A2($elm$json$Json$Decode$field, 'options', $author$project$DataElement$Expression$globalStringListDecoder),
	A2($elm_community$json_extra$Json$Decode$Extra$optionalNullableField, 'placeholder', $author$project$DataElement$Expression$globalStringDecoder),
	A2($elm$json$Json$Decode$field, 'requireSelection', $elm$json$Json$Decode$bool));
var $author$project$DataElement$SalesQuery$Info = F7(
	function (limit, sort, scale, dataType, accountIds, startDate, endDate) {
		return {accountIds: accountIds, dataType: dataType, endDate: endDate, limit: limit, scale: scale, sort: sort, startDate: startDate};
	});
var $author$project$DataElement$SalesQuery$Scale$Month = {$: 'Month'};
var $author$project$DataElement$SalesQuery$Scale$Week = {$: 'Week'};
var $author$project$DataElement$SalesQuery$Scale$fromString = function (words) {
	var _v0 = $elm$core$String$toLower(words);
	switch (_v0) {
		case 'week_vod':
			return $elm$core$Result$Ok($author$project$DataElement$SalesQuery$Scale$Week);
		case 'month_vod':
			return $elm$core$Result$Ok($author$project$DataElement$SalesQuery$Scale$Month);
		default:
			return $elm$core$Result$Err('Could not parse \'' + (words + '\' as a scale'));
	}
};
var $author$project$DataElement$SalesQuery$Scale$decoder = A2(
	$elm$json$Json$Decode$andThen,
	A2($elm$core$Basics$composeR, $author$project$DataElement$SalesQuery$Scale$fromString, $elm_community$json_extra$Json$Decode$Extra$fromResult),
	$elm$json$Json$Decode$string);
var $elm$json$Json$Decode$map7 = _Json_map7;
var $author$project$DataElement$SalesQuery$decoder = A8(
	$elm$json$Json$Decode$map7,
	$author$project$DataElement$SalesQuery$Info,
	$elm$json$Json$Decode$maybe(
		A2($elm$json$Json$Decode$field, 'limit', $elm$json$Json$Decode$int)),
	A2(
		$elm$json$Json$Decode$map,
		$elm$core$Maybe$withDefault(_List_Nil),
		$elm$json$Json$Decode$maybe(
			A2(
				$elm$json$Json$Decode$field,
				'sort',
				$elm$json$Json$Decode$list($author$project$DataElement$SortKey$decoder)))),
	A2($elm$json$Json$Decode$field, 'scale', $author$project$DataElement$SalesQuery$Scale$decoder),
	A2($elm$json$Json$Decode$field, 'dataType', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'accountIds', $author$project$DataElement$Expression$globalStringListDecoder),
	$elm$json$Json$Decode$maybe(
		A2($elm$json$Json$Decode$field, 'startDate', $author$project$DataElement$Expression$globalDateDecoder)),
	$elm$json$Json$Decode$maybe(
		A2($elm$json$Json$Decode$field, 'endDate', $author$project$DataElement$Expression$globalDateDecoder)));
var $author$project$DataElement$FieldTranslation = function (a) {
	return {$: 'FieldTranslation', a: a};
};
var $author$project$DataElement$FieldTranslation$Info = F2(
	function (object, fields) {
		return {fields: fields, object: object};
	});
var $author$project$DataElement$fieldTranslationDecoder = A2(
	$elm$json$Json$Decode$map,
	A2($elm$core$Basics$composeR, $author$project$DataElement$FieldTranslation, $author$project$DataElement$Singleton),
	A3(
		$elm$json$Json$Decode$map2,
		$author$project$DataElement$FieldTranslation$Info,
		$elm$json$Json$Decode$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$json$Json$Decode$at,
					_List_fromArray(
						['object', 'name']),
					$author$project$ObjectName$decoder),
					A2($elm$json$Json$Decode$field, 'object', $author$project$ObjectName$decoder)
				])),
		A2(
			$elm$json$Json$Decode$field,
			'fields',
			A2(
				$elm$json$Json$Decode$andThen,
				A2(
					$elm$core$Basics$composeR,
					$mgold$elm_nonempty_list$List$Nonempty$fromList,
					A2(
						$elm$core$Basics$composeR,
						$elm$core$Result$fromMaybe('\'fields\' cannot be empty'),
						$elm_community$json_extra$Json$Decode$Extra$fromResult)),
				A2(
					$elm$json$Json$Decode$map,
					$elm$core$List$map(
						A2($elm$core$Basics$composeR, $elm$core$Tuple$first, $author$project$FieldName$fromString)),
					$elm$json$Json$Decode$keyValuePairs(
						$elm$json$Json$Decode$succeed(_Utils_Tuple0)))))));
var $author$project$DataElement$CalcFilterList = function (a) {
	return {$: 'CalcFilterList', a: a};
};
var $author$project$DataElement$FilterList$Info = F2(
	function (original, filter) {
		return {filter: filter, original: original};
	});
var $author$project$DataElement$Expression$LocalAdd = F2(
	function (a, b) {
		return {$: 'LocalAdd', a: a, b: b};
	});
var $author$project$DataElement$Expression$LocalAll = function (a) {
	return {$: 'LocalAll', a: a};
};
var $author$project$DataElement$Expression$LocalAllBoolsInField = F2(
	function (a, b) {
		return {$: 'LocalAllBoolsInField', a: a, b: b};
	});
var $author$project$DataElement$Expression$LocalAllDateTimesInField = F2(
	function (a, b) {
		return {$: 'LocalAllDateTimesInField', a: a, b: b};
	});
var $author$project$DataElement$Expression$LocalAllDatesInField = F2(
	function (a, b) {
		return {$: 'LocalAllDatesInField', a: a, b: b};
	});
var $author$project$DataElement$Expression$LocalAllNumbersInField = F2(
	function (a, b) {
		return {$: 'LocalAllNumbersInField', a: a, b: b};
	});
var $author$project$DataElement$Expression$LocalAllStringsInField = F2(
	function (a, b) {
		return {$: 'LocalAllStringsInField', a: a, b: b};
	});
var $author$project$DataElement$Expression$LocalAny = function (a) {
	return {$: 'LocalAny', a: a};
};
var $author$project$DataElement$Expression$LocalBool = function (a) {
	return {$: 'LocalBool', a: a};
};
var $author$project$DataElement$Expression$LocalBoolExpr = function (a) {
	return {$: 'LocalBoolExpr', a: a};
};
var $author$project$DataElement$Expression$LocalBoolHardcoded = function (a) {
	return {$: 'LocalBoolHardcoded', a: a};
};
var $author$project$DataElement$Expression$LocalBoolIf = F3(
	function (a, b, c) {
		return {$: 'LocalBoolIf', a: a, b: b, c: c};
	});
var $author$project$DataElement$Expression$LocalBoolListIf = F3(
	function (a, b, c) {
		return {$: 'LocalBoolListIf', a: a, b: b, c: c};
	});
var $author$project$DataElement$Expression$LocalBoolsAsList = function (a) {
	return {$: 'LocalBoolsAsList', a: a};
};
var $author$project$DataElement$Expression$LocalChallengeReasons = function (a) {
	return {$: 'LocalChallengeReasons', a: a};
};
var $author$project$DataElement$Expression$LocalCompDateListExpr = function (a) {
	return {$: 'LocalCompDateListExpr', a: a};
};
var $author$project$DataElement$Expression$LocalCompDateTimeListExpr = function (a) {
	return {$: 'LocalCompDateTimeListExpr', a: a};
};
var $author$project$DataElement$Expression$LocalCompNumberListExpr = function (a) {
	return {$: 'LocalCompNumberListExpr', a: a};
};
var $author$project$DataElement$Expression$LocalCompStringListExpr = function (a) {
	return {$: 'LocalCompStringListExpr', a: a};
};
var $author$project$DataElement$Expression$LocalConcat = F2(
	function (a, b) {
		return {$: 'LocalConcat', a: a, b: b};
	});
var $author$project$DataElement$Expression$LocalCountUnique = function (a) {
	return {$: 'LocalCountUnique', a: a};
};
var $author$project$DataElement$Expression$LocalDate = function (a) {
	return {$: 'LocalDate', a: a};
};
var $author$project$DataElement$Expression$LocalDateAdd = F3(
	function (a, b, c) {
		return {$: 'LocalDateAdd', a: a, b: b, c: c};
	});
var $author$project$DataElement$Expression$LocalDateCeiling = F2(
	function (a, b) {
		return {$: 'LocalDateCeiling', a: a, b: b};
	});
var $author$project$DataElement$Expression$LocalDateExpr = function (a) {
	return {$: 'LocalDateExpr', a: a};
};
var $author$project$DataElement$Expression$LocalDateFloor = F2(
	function (a, b) {
		return {$: 'LocalDateFloor', a: a, b: b};
	});
var $author$project$DataElement$Expression$LocalDateHardcoded = function (a) {
	return {$: 'LocalDateHardcoded', a: a};
};
var $author$project$DataElement$Expression$LocalDateIf = F3(
	function (a, b, c) {
		return {$: 'LocalDateIf', a: a, b: b, c: c};
	});
var $author$project$DataElement$Expression$LocalDateListIf = F3(
	function (a, b, c) {
		return {$: 'LocalDateListIf', a: a, b: b, c: c};
	});
var $author$project$DataElement$Expression$LocalDateSubtract = F3(
	function (a, b, c) {
		return {$: 'LocalDateSubtract', a: a, b: b, c: c};
	});
var $author$project$DataElement$Expression$LocalDateTime = function (a) {
	return {$: 'LocalDateTime', a: a};
};
var $author$project$DataElement$Expression$LocalDateTimeExpr = function (a) {
	return {$: 'LocalDateTimeExpr', a: a};
};
var $author$project$DataElement$Expression$LocalDateTimeHardcoded = function (a) {
	return {$: 'LocalDateTimeHardcoded', a: a};
};
var $author$project$DataElement$Expression$LocalDateTimeIf = F3(
	function (a, b, c) {
		return {$: 'LocalDateTimeIf', a: a, b: b, c: c};
	});
var $author$project$DataElement$Expression$LocalDateTimeListIf = F3(
	function (a, b, c) {
		return {$: 'LocalDateTimeListIf', a: a, b: b, c: c};
	});
var $author$project$DataElement$Expression$LocalDateTimeToDate = function (a) {
	return {$: 'LocalDateTimeToDate', a: a};
};
var $author$project$DataElement$Expression$LocalDateTimesAsList = function (a) {
	return {$: 'LocalDateTimesAsList', a: a};
};
var $author$project$DataElement$Expression$LocalDatesAsList = function (a) {
	return {$: 'LocalDatesAsList', a: a};
};
var $author$project$DataElement$Expression$LocalDayInMonth = function (a) {
	return {$: 'LocalDayInMonth', a: a};
};
var $author$project$DataElement$Expression$LocalDivide = F2(
	function (a, b) {
		return {$: 'LocalDivide', a: a, b: b};
	});
var $author$project$DataElement$Expression$LocalEqualBool = F2(
	function (a, b) {
		return {$: 'LocalEqualBool', a: a, b: b};
	});
var $author$project$DataElement$Expression$LocalEqualDate = F2(
	function (a, b) {
		return {$: 'LocalEqualDate', a: a, b: b};
	});
var $author$project$DataElement$Expression$LocalEqualDateTime = F2(
	function (a, b) {
		return {$: 'LocalEqualDateTime', a: a, b: b};
	});
var $author$project$DataElement$Expression$LocalEqualNumber = F2(
	function (a, b) {
		return {$: 'LocalEqualNumber', a: a, b: b};
	});
var $author$project$DataElement$Expression$LocalEqualString = F2(
	function (a, b) {
		return {$: 'LocalEqualString', a: a, b: b};
	});
var $author$project$DataElement$Expression$LocalFormatDate = F2(
	function (a, b) {
		return {$: 'LocalFormatDate', a: a, b: b};
	});
var $author$project$DataElement$Expression$LocalFormatDateLocaleAware = function (a) {
	return {$: 'LocalFormatDateLocaleAware', a: a};
};
var $author$project$DataElement$Expression$LocalFormatDateTime = function (a) {
	return {$: 'LocalFormatDateTime', a: a};
};
var $author$project$DataElement$Expression$LocalFormatNumber = F2(
	function (a, b) {
		return {$: 'LocalFormatNumber', a: a, b: b};
	});
var $author$project$DataElement$Expression$LocalGTDate = F2(
	function (a, b) {
		return {$: 'LocalGTDate', a: a, b: b};
	});
var $author$project$DataElement$Expression$LocalGTDateTime = F2(
	function (a, b) {
		return {$: 'LocalGTDateTime', a: a, b: b};
	});
var $author$project$DataElement$Expression$LocalGTEDate = F2(
	function (a, b) {
		return {$: 'LocalGTEDate', a: a, b: b};
	});
var $author$project$DataElement$Expression$LocalGTEDateTime = F2(
	function (a, b) {
		return {$: 'LocalGTEDateTime', a: a, b: b};
	});
var $author$project$DataElement$Expression$LocalGTENumber = F2(
	function (a, b) {
		return {$: 'LocalGTENumber', a: a, b: b};
	});
var $author$project$DataElement$Expression$LocalGTEString = F2(
	function (a, b) {
		return {$: 'LocalGTEString', a: a, b: b};
	});
var $author$project$DataElement$Expression$LocalGTNumber = F2(
	function (a, b) {
		return {$: 'LocalGTNumber', a: a, b: b};
	});
var $author$project$DataElement$Expression$LocalGTString = F2(
	function (a, b) {
		return {$: 'LocalGTString', a: a, b: b};
	});
var $author$project$DataElement$Expression$LocalIsNotNull = function (a) {
	return {$: 'LocalIsNotNull', a: a};
};
var $author$project$DataElement$Expression$LocalIsNull = function (a) {
	return {$: 'LocalIsNull', a: a};
};
var $author$project$DataElement$Expression$LocalLTDate = F2(
	function (a, b) {
		return {$: 'LocalLTDate', a: a, b: b};
	});
var $author$project$DataElement$Expression$LocalLTDateTime = F2(
	function (a, b) {
		return {$: 'LocalLTDateTime', a: a, b: b};
	});
var $author$project$DataElement$Expression$LocalLTEDate = F2(
	function (a, b) {
		return {$: 'LocalLTEDate', a: a, b: b};
	});
var $author$project$DataElement$Expression$LocalLTEDateTime = F2(
	function (a, b) {
		return {$: 'LocalLTEDateTime', a: a, b: b};
	});
var $author$project$DataElement$Expression$LocalLTENumber = F2(
	function (a, b) {
		return {$: 'LocalLTENumber', a: a, b: b};
	});
var $author$project$DataElement$Expression$LocalLTEString = F2(
	function (a, b) {
		return {$: 'LocalLTEString', a: a, b: b};
	});
var $author$project$DataElement$Expression$LocalLTNumber = F2(
	function (a, b) {
		return {$: 'LocalLTNumber', a: a, b: b};
	});
var $author$project$DataElement$Expression$LocalLTString = F2(
	function (a, b) {
		return {$: 'LocalLTString', a: a, b: b};
	});
var $author$project$DataElement$Expression$LocalMaxDate = function (a) {
	return {$: 'LocalMaxDate', a: a};
};
var $author$project$DataElement$Expression$LocalMaxDateTime = function (a) {
	return {$: 'LocalMaxDateTime', a: a};
};
var $author$project$DataElement$Expression$LocalMaxNumber = function (a) {
	return {$: 'LocalMaxNumber', a: a};
};
var $author$project$DataElement$Expression$LocalMaxString = function (a) {
	return {$: 'LocalMaxString', a: a};
};
var $author$project$DataElement$Expression$LocalMinDate = function (a) {
	return {$: 'LocalMinDate', a: a};
};
var $author$project$DataElement$Expression$LocalMinDateTime = function (a) {
	return {$: 'LocalMinDateTime', a: a};
};
var $author$project$DataElement$Expression$LocalMinNumber = function (a) {
	return {$: 'LocalMinNumber', a: a};
};
var $author$project$DataElement$Expression$LocalMinString = function (a) {
	return {$: 'LocalMinString', a: a};
};
var $author$project$DataElement$Expression$LocalMonthNumber = function (a) {
	return {$: 'LocalMonthNumber', a: a};
};
var $author$project$DataElement$Expression$LocalMultiply = F2(
	function (a, b) {
		return {$: 'LocalMultiply', a: a, b: b};
	});
var $author$project$DataElement$Expression$LocalNot = function (a) {
	return {$: 'LocalNot', a: a};
};
var $author$project$DataElement$Expression$LocalNotEqualBool = F2(
	function (a, b) {
		return {$: 'LocalNotEqualBool', a: a, b: b};
	});
var $author$project$DataElement$Expression$LocalNotEqualDate = F2(
	function (a, b) {
		return {$: 'LocalNotEqualDate', a: a, b: b};
	});
var $author$project$DataElement$Expression$LocalNotEqualDateTime = F2(
	function (a, b) {
		return {$: 'LocalNotEqualDateTime', a: a, b: b};
	});
var $author$project$DataElement$Expression$LocalNotEqualNumber = F2(
	function (a, b) {
		return {$: 'LocalNotEqualNumber', a: a, b: b};
	});
var $author$project$DataElement$Expression$LocalNotEqualString = F2(
	function (a, b) {
		return {$: 'LocalNotEqualString', a: a, b: b};
	});
var $author$project$DataElement$Expression$LocalNumber = function (a) {
	return {$: 'LocalNumber', a: a};
};
var $author$project$DataElement$Expression$LocalNumberExpr = function (a) {
	return {$: 'LocalNumberExpr', a: a};
};
var $author$project$DataElement$Expression$LocalNumberHardcoded = function (a) {
	return {$: 'LocalNumberHardcoded', a: a};
};
var $author$project$DataElement$Expression$LocalNumberIf = F3(
	function (a, b, c) {
		return {$: 'LocalNumberIf', a: a, b: b, c: c};
	});
var $author$project$DataElement$Expression$LocalNumberListIf = F3(
	function (a, b, c) {
		return {$: 'LocalNumberListIf', a: a, b: b, c: c};
	});
var $author$project$DataElement$Expression$LocalNumbersAsList = function (a) {
	return {$: 'LocalNumbersAsList', a: a};
};
var $author$project$DataElement$Expression$LocalPickBool = function (a) {
	return {$: 'LocalPickBool', a: a};
};
var $author$project$DataElement$Expression$LocalPickDate = function (a) {
	return {$: 'LocalPickDate', a: a};
};
var $author$project$DataElement$Expression$LocalPickDateTime = function (a) {
	return {$: 'LocalPickDateTime', a: a};
};
var $author$project$DataElement$Expression$LocalPickNumber = function (a) {
	return {$: 'LocalPickNumber', a: a};
};
var $author$project$DataElement$Expression$LocalPickString = function (a) {
	return {$: 'LocalPickString', a: a};
};
var $author$project$DataElement$Expression$LocalProduct = function (a) {
	return {$: 'LocalProduct', a: a};
};
var $author$project$DataElement$Expression$LocalRound = function (a) {
	return {$: 'LocalRound', a: a};
};
var $author$project$DataElement$Expression$LocalSingletonBool = F2(
	function (a, b) {
		return {$: 'LocalSingletonBool', a: a, b: b};
	});
var $author$project$DataElement$Expression$LocalSingletonDate = F2(
	function (a, b) {
		return {$: 'LocalSingletonDate', a: a, b: b};
	});
var $author$project$DataElement$Expression$LocalSingletonDateTime = F2(
	function (a, b) {
		return {$: 'LocalSingletonDateTime', a: a, b: b};
	});
var $author$project$DataElement$Expression$LocalSingletonNumber = F2(
	function (a, b) {
		return {$: 'LocalSingletonNumber', a: a, b: b};
	});
var $author$project$DataElement$Expression$LocalSingletonString = F2(
	function (a, b) {
		return {$: 'LocalSingletonString', a: a, b: b};
	});
var $author$project$DataElement$Expression$LocalString = function (a) {
	return {$: 'LocalString', a: a};
};
var $author$project$DataElement$Expression$LocalStringExpr = function (a) {
	return {$: 'LocalStringExpr', a: a};
};
var $author$project$DataElement$Expression$LocalStringHardcoded = function (a) {
	return {$: 'LocalStringHardcoded', a: a};
};
var $author$project$DataElement$Expression$LocalStringIf = F3(
	function (a, b, c) {
		return {$: 'LocalStringIf', a: a, b: b, c: c};
	});
var $author$project$DataElement$Expression$LocalStringIn = F2(
	function (a, b) {
		return {$: 'LocalStringIn', a: a, b: b};
	});
var $author$project$DataElement$Expression$LocalStringListIf = F3(
	function (a, b, c) {
		return {$: 'LocalStringListIf', a: a, b: b, c: c};
	});
var $author$project$DataElement$Expression$LocalStringNotIn = F2(
	function (a, b) {
		return {$: 'LocalStringNotIn', a: a, b: b};
	});
var $author$project$DataElement$Expression$LocalStringsAsList = function (a) {
	return {$: 'LocalStringsAsList', a: a};
};
var $author$project$DataElement$Expression$LocalSubtract = F2(
	function (a, b) {
		return {$: 'LocalSubtract', a: a, b: b};
	});
var $author$project$DataElement$Expression$LocalSum = function (a) {
	return {$: 'LocalSum', a: a};
};
var $author$project$DataElement$Expression$LocalTargetChallengeReasons = function (a) {
	return {$: 'LocalTargetChallengeReasons', a: a};
};
var $author$project$DataElement$Expression$LocalYearNumber = function (a) {
	return {$: 'LocalYearNumber', a: a};
};
var $author$project$DataElement$Expression$RelatedBool = F2(
	function (a, b) {
		return {$: 'RelatedBool', a: a, b: b};
	});
var $author$project$DataElement$Expression$RelatedDate = F2(
	function (a, b) {
		return {$: 'RelatedDate', a: a, b: b};
	});
var $author$project$DataElement$Expression$RelatedDateTime = F2(
	function (a, b) {
		return {$: 'RelatedDateTime', a: a, b: b};
	});
var $author$project$DataElement$Expression$RelatedNumber = F2(
	function (a, b) {
		return {$: 'RelatedNumber', a: a, b: b};
	});
var $author$project$DataElement$Expression$RelatedString = F2(
	function (a, b) {
		return {$: 'RelatedString', a: a, b: b};
	});
var $author$project$DataElement$Expression$RelationshipInfo = F4(
	function (nextElement, idToMatch, localIds, optionalFilter) {
		return {idToMatch: idToMatch, localIds: localIds, nextElement: nextElement, optionalFilter: optionalFilter};
	});
var $elm$json$Json$Decode$map4 = _Json_map4;
function $author$project$DataElement$Expression$cyclic$relationshipDecoder() {
	return A5(
		$elm$json$Json$Decode$map4,
		$author$project$DataElement$Expression$RelationshipInfo,
		A2($elm$json$Json$Decode$field, 'nextElement', $author$project$DataElement$Reference$recordListReferenceDecoder),
		A2(
			$elm$json$Json$Decode$field,
			'idToMatch',
			$author$project$DataElement$Expression$cyclic$localStringDecoder()),
		A2(
			$elm$json$Json$Decode$field,
			'localIds',
			$author$project$DataElement$Expression$cyclic$localStringListDecoder()),
		A2(
			$elm_community$json_extra$Json$Decode$Extra$optionalNullableField,
			'filterBy',
			$author$project$DataElement$Expression$cyclic$localBoolDecoder()));
}
function $author$project$DataElement$Expression$cyclic$localBoolDecoder() {
	return A2(
		$author$project$DataElement$Expression$confirmDataType,
		$author$project$FieldType$BoolType,
		$author$project$DataElement$Expression$typeDecoder(
			function (words) {
				var _v11 = $elm$core$String$toLower(words);
				switch (_v11) {
					case 'local field':
						return A2(
							$elm$json$Json$Decode$map,
							$author$project$DataElement$Expression$LocalBool,
							A2($elm$json$Json$Decode$field, 'field', $author$project$FieldName$decoder));
					case 'singleton field':
						return A3(
							$elm$json$Json$Decode$map2,
							$author$project$DataElement$Expression$LocalSingletonBool,
							A2($elm$json$Json$Decode$field, 'dataElement', $author$project$DataElement$Reference$singletonReferenceDecoder),
							A2($elm$json$Json$Decode$field, 'field', $author$project$FieldName$decoder));
					case 'static':
						return A2(
							$elm$json$Json$Decode$map,
							$author$project$DataElement$Expression$LocalBoolHardcoded,
							A2($elm$json$Json$Decode$field, 'value', $elm$json$Json$Decode$bool));
					case 'gt':
						return $author$project$DataElement$Expression$compareDecoder(
							{
								dateCompare: $author$project$DataElement$Expression$LocalGTDate,
								dateDecoder: $author$project$DataElement$Expression$cyclic$localDateDecoder(),
								dateTimeCompare: $author$project$DataElement$Expression$LocalGTDateTime,
								dateTimeDecoder: $author$project$DataElement$Expression$cyclic$localDateTimeDecoder(),
								numberCompare: $author$project$DataElement$Expression$LocalGTNumber,
								numberDecoder: $author$project$DataElement$Expression$cyclic$localNumberDecoder(),
								stringCompare: $author$project$DataElement$Expression$LocalGTString,
								stringDecoder: $author$project$DataElement$Expression$cyclic$localStringDecoder()
							});
					case 'gte':
						return $author$project$DataElement$Expression$compareDecoder(
							{
								dateCompare: $author$project$DataElement$Expression$LocalGTEDate,
								dateDecoder: $author$project$DataElement$Expression$cyclic$localDateDecoder(),
								dateTimeCompare: $author$project$DataElement$Expression$LocalGTEDateTime,
								dateTimeDecoder: $author$project$DataElement$Expression$cyclic$localDateTimeDecoder(),
								numberCompare: $author$project$DataElement$Expression$LocalGTENumber,
								numberDecoder: $author$project$DataElement$Expression$cyclic$localNumberDecoder(),
								stringCompare: $author$project$DataElement$Expression$LocalGTEString,
								stringDecoder: $author$project$DataElement$Expression$cyclic$localStringDecoder()
							});
					case 'lt':
						return $author$project$DataElement$Expression$compareDecoder(
							{
								dateCompare: $author$project$DataElement$Expression$LocalLTDate,
								dateDecoder: $author$project$DataElement$Expression$cyclic$localDateDecoder(),
								dateTimeCompare: $author$project$DataElement$Expression$LocalLTDateTime,
								dateTimeDecoder: $author$project$DataElement$Expression$cyclic$localDateTimeDecoder(),
								numberCompare: $author$project$DataElement$Expression$LocalLTNumber,
								numberDecoder: $author$project$DataElement$Expression$cyclic$localNumberDecoder(),
								stringCompare: $author$project$DataElement$Expression$LocalLTString,
								stringDecoder: $author$project$DataElement$Expression$cyclic$localStringDecoder()
							});
					case 'lte':
						return $author$project$DataElement$Expression$compareDecoder(
							{
								dateCompare: $author$project$DataElement$Expression$LocalLTEDate,
								dateDecoder: $author$project$DataElement$Expression$cyclic$localDateDecoder(),
								dateTimeCompare: $author$project$DataElement$Expression$LocalLTEDateTime,
								dateTimeDecoder: $author$project$DataElement$Expression$cyclic$localDateTimeDecoder(),
								numberCompare: $author$project$DataElement$Expression$LocalLTENumber,
								numberDecoder: $author$project$DataElement$Expression$cyclic$localNumberDecoder(),
								stringCompare: $author$project$DataElement$Expression$LocalLTEString,
								stringDecoder: $author$project$DataElement$Expression$cyclic$localStringDecoder()
							});
					case 'equal':
						return $author$project$DataElement$Expression$compareFieldDecoder(
							{
								boolCompare: $author$project$DataElement$Expression$LocalEqualBool,
								boolDecoder: $author$project$DataElement$Expression$cyclic$localBoolDecoder(),
								dateCompare: $author$project$DataElement$Expression$LocalEqualDate,
								dateDecoder: $author$project$DataElement$Expression$cyclic$localDateDecoder(),
								dateTimeCompare: $author$project$DataElement$Expression$LocalEqualDateTime,
								dateTimeDecoder: $author$project$DataElement$Expression$cyclic$localDateTimeDecoder(),
								numberCompare: $author$project$DataElement$Expression$LocalEqualNumber,
								numberDecoder: $author$project$DataElement$Expression$cyclic$localNumberDecoder(),
								stringCompare: $author$project$DataElement$Expression$LocalEqualString,
								stringDecoder: $author$project$DataElement$Expression$cyclic$localStringDecoder()
							});
					case 'not equal':
						return $author$project$DataElement$Expression$compareFieldDecoder(
							{
								boolCompare: $author$project$DataElement$Expression$LocalNotEqualBool,
								boolDecoder: $author$project$DataElement$Expression$cyclic$localBoolDecoder(),
								dateCompare: $author$project$DataElement$Expression$LocalNotEqualDate,
								dateDecoder: $author$project$DataElement$Expression$cyclic$localDateDecoder(),
								dateTimeCompare: $author$project$DataElement$Expression$LocalNotEqualDateTime,
								dateTimeDecoder: $author$project$DataElement$Expression$cyclic$localDateTimeDecoder(),
								numberCompare: $author$project$DataElement$Expression$LocalNotEqualNumber,
								numberDecoder: $author$project$DataElement$Expression$cyclic$localNumberDecoder(),
								stringCompare: $author$project$DataElement$Expression$LocalNotEqualString,
								stringDecoder: $author$project$DataElement$Expression$cyclic$localStringDecoder()
							});
					case 'in':
						return A3(
							$elm$json$Json$Decode$map2,
							$author$project$DataElement$Expression$LocalStringIn,
							A2(
								$elm$json$Json$Decode$field,
								'expression1',
								$author$project$DataElement$Expression$cyclic$localStringDecoder()),
							A2(
								$elm$json$Json$Decode$field,
								'expression2',
								$author$project$DataElement$Expression$cyclic$localStringListDecoder()));
					case 'not in':
						return A3(
							$elm$json$Json$Decode$map2,
							$author$project$DataElement$Expression$LocalStringNotIn,
							A2(
								$elm$json$Json$Decode$field,
								'expression1',
								$author$project$DataElement$Expression$cyclic$localStringDecoder()),
							A2(
								$elm$json$Json$Decode$field,
								'expression2',
								$author$project$DataElement$Expression$cyclic$localStringListDecoder()));
					case 'not':
						return A2(
							$elm$json$Json$Decode$map,
							$author$project$DataElement$Expression$LocalNot,
							A2(
								$elm$json$Json$Decode$field,
								'expression',
								$author$project$DataElement$Expression$cyclic$localBoolDecoder()));
					case 'all':
						return A2(
							$elm$json$Json$Decode$map,
							$author$project$DataElement$Expression$LocalAll,
							A2(
								$elm$json$Json$Decode$field,
								'expression',
								$author$project$DataElement$Expression$cyclic$localBoolListDecoder()));
					case 'any':
						return A2(
							$elm$json$Json$Decode$map,
							$author$project$DataElement$Expression$LocalAny,
							A2(
								$elm$json$Json$Decode$field,
								'expression',
								$author$project$DataElement$Expression$cyclic$localBoolListDecoder()));
					case 'pick one':
						return A2(
							$author$project$DataElement$Expression$pickOneDecoder,
							$author$project$DataElement$Expression$LocalPickBool,
							$author$project$DataElement$Expression$cyclic$localBoolListDecoder());
					case 'if':
						return A3(
							$author$project$DataElement$Expression$ifDecoder,
							$author$project$DataElement$Expression$LocalBoolIf,
							$author$project$DataElement$Expression$cyclic$localBoolDecoder(),
							$author$project$DataElement$Expression$cyclic$localBoolDecoder());
					case 'is null':
						return A2(
							$elm$json$Json$Decode$map,
							$author$project$DataElement$Expression$LocalIsNull,
							A2(
								$elm$json$Json$Decode$field,
								'expression',
								$author$project$DataElement$Expression$cyclic$localFieldDecoder()));
					case 'is not null':
						return A2(
							$elm$json$Json$Decode$map,
							$author$project$DataElement$Expression$LocalIsNotNull,
							A2(
								$elm$json$Json$Decode$field,
								'expression',
								$author$project$DataElement$Expression$cyclic$localFieldDecoder()));
					default:
						return $elm$json$Json$Decode$fail('Could not parse \'' + (words + '\' as a Local Bool Expression'));
				}
			}));
}
function $author$project$DataElement$Expression$cyclic$localBoolListDecoder() {
	return A2(
		$author$project$DataElement$Expression$confirmDataType,
		$author$project$FieldType$BoolType,
		$author$project$DataElement$Expression$typeDecoder(
			function (words) {
				var _v10 = $elm$core$String$toLower(words);
				switch (_v10) {
					case 'related field':
						return A3(
							$elm$json$Json$Decode$map2,
							$author$project$DataElement$Expression$RelatedBool,
							A2(
								$elm$json$Json$Decode$field,
								'relationship',
								$author$project$DataElement$Expression$cyclic$relationshipDecoder()),
							A2($elm$json$Json$Decode$field, 'field', $author$project$FieldName$decoder));
					case 'field in list':
						return A3(
							$elm$json$Json$Decode$map2,
							$author$project$DataElement$Expression$LocalAllBoolsInField,
							A2($elm$json$Json$Decode$field, 'dataElement', $author$project$DataElement$Reference$recordListReferenceDecoder),
							A2($elm$json$Json$Decode$field, 'field', $author$project$FieldName$decoder));
					case 'list of expressions':
						return A2(
							$elm$json$Json$Decode$map,
							$author$project$DataElement$Expression$LocalBoolsAsList,
							A2(
								$elm$json$Json$Decode$field,
								'expressions',
								$elm$json$Json$Decode$list(
									$author$project$DataElement$Expression$cyclic$localBoolDecoder())));
					case 'if':
						return A3(
							$author$project$DataElement$Expression$ifDecoder,
							$author$project$DataElement$Expression$LocalBoolListIf,
							$author$project$DataElement$Expression$cyclic$localBoolDecoder(),
							$author$project$DataElement$Expression$cyclic$localBoolListDecoder());
					default:
						return $elm$json$Json$Decode$fail('Could not parse \'' + (words + '\' as a Local Bool List Expression'));
				}
			}));
}
function $author$project$DataElement$Expression$cyclic$localComparableListDecoder() {
	return A2(
		$elm$json$Json$Decode$andThen,
		function (fieldType) {
			switch (fieldType.$) {
				case 'StringType':
					return A2(
						$elm$json$Json$Decode$map,
						$author$project$DataElement$Expression$LocalCompStringListExpr,
						$author$project$DataElement$Expression$cyclic$localStringListDecoder());
				case 'NumberType':
					return A2(
						$elm$json$Json$Decode$map,
						$author$project$DataElement$Expression$LocalCompNumberListExpr,
						$author$project$DataElement$Expression$cyclic$localNumberListDecoder());
				case 'DateType':
					return A2(
						$elm$json$Json$Decode$map,
						$author$project$DataElement$Expression$LocalCompDateListExpr,
						$author$project$DataElement$Expression$cyclic$localDateListDecoder());
				case 'DateTimeType':
					return A2(
						$elm$json$Json$Decode$map,
						$author$project$DataElement$Expression$LocalCompDateTimeListExpr,
						$author$project$DataElement$Expression$cyclic$localDateTimeListDecoder());
				default:
					return $elm$json$Json$Decode$fail(
						'Data type \'' + ($author$project$FieldType$toString(fieldType) + '\' is not supported as a Local Comparable List Expression'));
			}
		},
		A2($elm$json$Json$Decode$field, 'dataType', $author$project$FieldType$decoder));
}
function $author$project$DataElement$Expression$cyclic$localDateDecoder() {
	return A2(
		$author$project$DataElement$Expression$confirmDataType,
		$author$project$FieldType$DateType,
		$author$project$DataElement$Expression$typeDecoder(
			function (words) {
				var _v8 = $elm$core$String$toLower(words);
				switch (_v8) {
					case 'local field':
						return A2(
							$elm$json$Json$Decode$map,
							$author$project$DataElement$Expression$LocalDate,
							A2($elm$json$Json$Decode$field, 'field', $author$project$FieldName$decoder));
					case 'singleton field':
						return A3(
							$elm$json$Json$Decode$map2,
							$author$project$DataElement$Expression$LocalSingletonDate,
							A2($elm$json$Json$Decode$field, 'dataElement', $author$project$DataElement$Reference$singletonReferenceDecoder),
							A2($elm$json$Json$Decode$field, 'field', $author$project$FieldName$decoder));
					case 'static':
						return A2(
							$elm$json$Json$Decode$map,
							$author$project$DataElement$Expression$LocalDateHardcoded,
							A2($elm$json$Json$Decode$field, 'value', $author$project$DataElement$Expression$dateDecoder));
					case 'date/time to date':
						return A2(
							$elm$json$Json$Decode$map,
							$author$project$DataElement$Expression$LocalDateTimeToDate,
							A2(
								$elm$json$Json$Decode$field,
								'dateTimeExpression',
								$author$project$DataElement$Expression$cyclic$localDateTimeDecoder()));
					case 'date ceiling':
						return A3(
							$elm$json$Json$Decode$map2,
							$author$project$DataElement$Expression$LocalDateCeiling,
							A2($elm$json$Json$Decode$field, 'dateInterval', $author$project$DateInterval$decoder),
							A2(
								$elm$json$Json$Decode$field,
								'expression',
								$author$project$DataElement$Expression$cyclic$localDateDecoder()));
					case 'date floor':
						return A3(
							$elm$json$Json$Decode$map2,
							$author$project$DataElement$Expression$LocalDateFloor,
							A2($elm$json$Json$Decode$field, 'dateInterval', $author$project$DateInterval$decoder),
							A2(
								$elm$json$Json$Decode$field,
								'expression',
								$author$project$DataElement$Expression$cyclic$localDateDecoder()));
					case 'date addition':
						return A4(
							$elm$json$Json$Decode$map3,
							$author$project$DataElement$Expression$LocalDateAdd,
							A2($elm$json$Json$Decode$field, 'dateUnit', $author$project$DateUnit$decoder),
							A2(
								$elm$json$Json$Decode$field,
								'expression2',
								$author$project$DataElement$Expression$cyclic$localNumberDecoder()),
							A2(
								$elm$json$Json$Decode$field,
								'expression1',
								$author$project$DataElement$Expression$cyclic$localDateDecoder()));
					case 'date subtraction':
						return A4(
							$elm$json$Json$Decode$map3,
							$author$project$DataElement$Expression$LocalDateSubtract,
							A2($elm$json$Json$Decode$field, 'dateUnit', $author$project$DateUnit$decoder),
							A2(
								$elm$json$Json$Decode$field,
								'expression2',
								$author$project$DataElement$Expression$cyclic$localNumberDecoder()),
							A2(
								$elm$json$Json$Decode$field,
								'expression1',
								$author$project$DataElement$Expression$cyclic$localDateDecoder()));
					case 'pick one':
						return A2(
							$author$project$DataElement$Expression$pickOneDecoder,
							$author$project$DataElement$Expression$LocalPickDate,
							$author$project$DataElement$Expression$cyclic$localDateListDecoder());
					case 'max':
						return A2(
							$elm$json$Json$Decode$map,
							$author$project$DataElement$Expression$LocalMaxDate,
							A2(
								$elm$json$Json$Decode$field,
								'expression',
								$author$project$DataElement$Expression$cyclic$localDateListDecoder()));
					case 'min':
						return A2(
							$elm$json$Json$Decode$map,
							$author$project$DataElement$Expression$LocalMinDate,
							A2(
								$elm$json$Json$Decode$field,
								'expression',
								$author$project$DataElement$Expression$cyclic$localDateListDecoder()));
					case 'if':
						return A3(
							$author$project$DataElement$Expression$ifDecoder,
							$author$project$DataElement$Expression$LocalDateIf,
							$author$project$DataElement$Expression$cyclic$localBoolDecoder(),
							$author$project$DataElement$Expression$cyclic$localDateDecoder());
					default:
						return $elm$json$Json$Decode$fail('Could not parse \'' + (words + '\' as a Local Date Expression'));
				}
			}));
}
function $author$project$DataElement$Expression$cyclic$localDateListDecoder() {
	return A2(
		$author$project$DataElement$Expression$confirmDataType,
		$author$project$FieldType$DateType,
		$author$project$DataElement$Expression$typeDecoder(
			function (words) {
				var _v7 = $elm$core$String$toLower(words);
				switch (_v7) {
					case 'related field':
						return A3(
							$elm$json$Json$Decode$map2,
							$author$project$DataElement$Expression$RelatedDate,
							A2(
								$elm$json$Json$Decode$field,
								'relationship',
								$author$project$DataElement$Expression$cyclic$relationshipDecoder()),
							A2($elm$json$Json$Decode$field, 'field', $author$project$FieldName$decoder));
					case 'field in list':
						return A3(
							$elm$json$Json$Decode$map2,
							$author$project$DataElement$Expression$LocalAllDatesInField,
							A2($elm$json$Json$Decode$field, 'dataElement', $author$project$DataElement$Reference$recordListReferenceDecoder),
							A2($elm$json$Json$Decode$field, 'field', $author$project$FieldName$decoder));
					case 'list of expressions':
						return A2(
							$elm$json$Json$Decode$map,
							$author$project$DataElement$Expression$LocalDatesAsList,
							A2(
								$elm$json$Json$Decode$field,
								'expressions',
								$elm$json$Json$Decode$list(
									$author$project$DataElement$Expression$cyclic$localDateDecoder())));
					case 'if':
						return A3(
							$author$project$DataElement$Expression$ifDecoder,
							$author$project$DataElement$Expression$LocalDateListIf,
							$author$project$DataElement$Expression$cyclic$localBoolDecoder(),
							$author$project$DataElement$Expression$cyclic$localDateListDecoder());
					default:
						return $elm$json$Json$Decode$fail('Could not parse \'' + (words + '\' as a Local Date List Expression'));
				}
			}));
}
function $author$project$DataElement$Expression$cyclic$localDateTimeDecoder() {
	return A2(
		$author$project$DataElement$Expression$confirmDataType,
		$author$project$FieldType$DateTimeType,
		$author$project$DataElement$Expression$typeDecoder(
			function (words) {
				var _v6 = $elm$core$String$toLower(words);
				switch (_v6) {
					case 'local field':
						return A2(
							$elm$json$Json$Decode$map,
							$author$project$DataElement$Expression$LocalDateTime,
							A2($elm$json$Json$Decode$field, 'field', $author$project$FieldName$decoder));
					case 'singleton field':
						return A3(
							$elm$json$Json$Decode$map2,
							$author$project$DataElement$Expression$LocalSingletonDateTime,
							A2($elm$json$Json$Decode$field, 'dataElement', $author$project$DataElement$Reference$singletonReferenceDecoder),
							A2($elm$json$Json$Decode$field, 'field', $author$project$FieldName$decoder));
					case 'static':
						return A2(
							$elm$json$Json$Decode$map,
							$author$project$DataElement$Expression$LocalDateTimeHardcoded,
							A2($elm$json$Json$Decode$field, 'value', $rtfeldman$elm_iso8601_date_strings$Iso8601$decoder));
					case 'pick one':
						return A2(
							$author$project$DataElement$Expression$pickOneDecoder,
							$author$project$DataElement$Expression$LocalPickDateTime,
							$author$project$DataElement$Expression$cyclic$localDateTimeListDecoder());
					case 'max':
						return A2(
							$elm$json$Json$Decode$map,
							$author$project$DataElement$Expression$LocalMaxDateTime,
							A2(
								$elm$json$Json$Decode$field,
								'expression',
								$author$project$DataElement$Expression$cyclic$localDateTimeListDecoder()));
					case 'min':
						return A2(
							$elm$json$Json$Decode$map,
							$author$project$DataElement$Expression$LocalMinDateTime,
							A2(
								$elm$json$Json$Decode$field,
								'expression',
								$author$project$DataElement$Expression$cyclic$localDateTimeListDecoder()));
					case 'if':
						return A3(
							$author$project$DataElement$Expression$ifDecoder,
							$author$project$DataElement$Expression$LocalDateTimeIf,
							$author$project$DataElement$Expression$cyclic$localBoolDecoder(),
							$author$project$DataElement$Expression$cyclic$localDateTimeDecoder());
					default:
						return $elm$json$Json$Decode$fail('Could not parse \'' + (words + '\' as a Local DateTime Expression'));
				}
			}));
}
function $author$project$DataElement$Expression$cyclic$localDateTimeListDecoder() {
	return A2(
		$author$project$DataElement$Expression$confirmDataType,
		$author$project$FieldType$DateTimeType,
		$author$project$DataElement$Expression$typeDecoder(
			function (words) {
				var _v5 = $elm$core$String$toLower(words);
				switch (_v5) {
					case 'related field':
						return A3(
							$elm$json$Json$Decode$map2,
							$author$project$DataElement$Expression$RelatedDateTime,
							A2(
								$elm$json$Json$Decode$field,
								'relationship',
								$author$project$DataElement$Expression$cyclic$relationshipDecoder()),
							A2($elm$json$Json$Decode$field, 'field', $author$project$FieldName$decoder));
					case 'field in list':
						return A3(
							$elm$json$Json$Decode$map2,
							$author$project$DataElement$Expression$LocalAllDateTimesInField,
							A2($elm$json$Json$Decode$field, 'dataElement', $author$project$DataElement$Reference$recordListReferenceDecoder),
							A2($elm$json$Json$Decode$field, 'field', $author$project$FieldName$decoder));
					case 'list of expressions':
						return A2(
							$elm$json$Json$Decode$map,
							$author$project$DataElement$Expression$LocalDateTimesAsList,
							A2(
								$elm$json$Json$Decode$field,
								'expressions',
								$elm$json$Json$Decode$list(
									$author$project$DataElement$Expression$cyclic$localDateTimeDecoder())));
					case 'if':
						return A3(
							$author$project$DataElement$Expression$ifDecoder,
							$author$project$DataElement$Expression$LocalDateTimeListIf,
							$author$project$DataElement$Expression$cyclic$localBoolDecoder(),
							$author$project$DataElement$Expression$cyclic$localDateTimeListDecoder());
					default:
						return $elm$json$Json$Decode$fail('Could not parse \'' + (words + '\' as a Local DateTime List Expression'));
				}
			}));
}
function $author$project$DataElement$Expression$cyclic$localFieldDecoder() {
	return A2(
		$elm$json$Json$Decode$andThen,
		function (fieldType) {
			switch (fieldType.$) {
				case 'StringType':
					return A2(
						$elm$json$Json$Decode$map,
						$author$project$DataElement$Expression$LocalStringExpr,
						$author$project$DataElement$Expression$cyclic$localStringDecoder());
				case 'NumberType':
					return A2(
						$elm$json$Json$Decode$map,
						$author$project$DataElement$Expression$LocalNumberExpr,
						$author$project$DataElement$Expression$cyclic$localNumberDecoder());
				case 'DateType':
					return A2(
						$elm$json$Json$Decode$map,
						$author$project$DataElement$Expression$LocalDateExpr,
						$author$project$DataElement$Expression$cyclic$localDateDecoder());
				case 'DateTimeType':
					return A2(
						$elm$json$Json$Decode$map,
						$author$project$DataElement$Expression$LocalDateTimeExpr,
						$author$project$DataElement$Expression$cyclic$localDateTimeDecoder());
				default:
					return A2(
						$elm$json$Json$Decode$map,
						$author$project$DataElement$Expression$LocalBoolExpr,
						$author$project$DataElement$Expression$cyclic$localBoolDecoder());
			}
		},
		A2($elm$json$Json$Decode$field, 'dataType', $author$project$FieldType$decoder));
}
function $author$project$DataElement$Expression$cyclic$localNumberDecoder() {
	return A2(
		$author$project$DataElement$Expression$confirmDataType,
		$author$project$FieldType$NumberType,
		$author$project$DataElement$Expression$typeDecoder(
			function (words) {
				var _v3 = $elm$core$String$toLower(words);
				switch (_v3) {
					case 'local field':
						return A2(
							$elm$json$Json$Decode$map,
							$author$project$DataElement$Expression$LocalNumber,
							A2($elm$json$Json$Decode$field, 'field', $author$project$FieldName$decoder));
					case 'singleton field':
						return A3(
							$elm$json$Json$Decode$map2,
							$author$project$DataElement$Expression$LocalSingletonNumber,
							A2($elm$json$Json$Decode$field, 'dataElement', $author$project$DataElement$Reference$singletonReferenceDecoder),
							A2($elm$json$Json$Decode$field, 'field', $author$project$FieldName$decoder));
					case 'static':
						return A2(
							$elm$json$Json$Decode$map,
							$author$project$DataElement$Expression$LocalNumberHardcoded,
							A2($elm$json$Json$Decode$field, 'value', $elm$json$Json$Decode$float));
					case 'count unique':
						return A2(
							$elm$json$Json$Decode$map,
							$author$project$DataElement$Expression$LocalCountUnique,
							A2(
								$elm$json$Json$Decode$field,
								'expression',
								$author$project$DataElement$Expression$cyclic$localComparableListDecoder()));
					case 'round number':
						return A2(
							$elm$json$Json$Decode$map,
							$author$project$DataElement$Expression$LocalRound,
							A2(
								$elm$json$Json$Decode$field,
								'expression',
								$author$project$DataElement$Expression$cyclic$localNumberDecoder()));
					case 'sum':
						return A2(
							$elm$json$Json$Decode$map,
							$author$project$DataElement$Expression$LocalSum,
							A2(
								$elm$json$Json$Decode$field,
								'expression',
								$author$project$DataElement$Expression$cyclic$localNumberListDecoder()));
					case 'product':
						return A2(
							$elm$json$Json$Decode$map,
							$author$project$DataElement$Expression$LocalProduct,
							A2(
								$elm$json$Json$Decode$field,
								'expression',
								$author$project$DataElement$Expression$cyclic$localNumberListDecoder()));
					case 'add number':
						return A3(
							$elm$json$Json$Decode$map2,
							$author$project$DataElement$Expression$LocalAdd,
							A2(
								$elm$json$Json$Decode$field,
								'expression1',
								$author$project$DataElement$Expression$cyclic$localNumberDecoder()),
							A2(
								$elm$json$Json$Decode$field,
								'expression2',
								$author$project$DataElement$Expression$cyclic$localNumberDecoder()));
					case 'subtract number':
						return A3(
							$elm$json$Json$Decode$map2,
							$author$project$DataElement$Expression$LocalSubtract,
							A2(
								$elm$json$Json$Decode$field,
								'expression1',
								$author$project$DataElement$Expression$cyclic$localNumberDecoder()),
							A2(
								$elm$json$Json$Decode$field,
								'expression2',
								$author$project$DataElement$Expression$cyclic$localNumberDecoder()));
					case 'multiply number':
						return A3(
							$elm$json$Json$Decode$map2,
							$author$project$DataElement$Expression$LocalMultiply,
							A2(
								$elm$json$Json$Decode$field,
								'expression1',
								$author$project$DataElement$Expression$cyclic$localNumberDecoder()),
							A2(
								$elm$json$Json$Decode$field,
								'expression2',
								$author$project$DataElement$Expression$cyclic$localNumberDecoder()));
					case 'divide number':
						return A3(
							$elm$json$Json$Decode$map2,
							$author$project$DataElement$Expression$LocalDivide,
							A2(
								$elm$json$Json$Decode$field,
								'expression1',
								$author$project$DataElement$Expression$cyclic$localNumberDecoder()),
							A2(
								$elm$json$Json$Decode$field,
								'expression2',
								$author$project$DataElement$Expression$cyclic$localNumberDecoder()));
					case 'date month':
						return A2(
							$elm$json$Json$Decode$map,
							$author$project$DataElement$Expression$LocalMonthNumber,
							A2(
								$elm$json$Json$Decode$field,
								'expression',
								$author$project$DataElement$Expression$cyclic$localDateDecoder()));
					case 'date year':
						return A2(
							$elm$json$Json$Decode$map,
							$author$project$DataElement$Expression$LocalYearNumber,
							A2(
								$elm$json$Json$Decode$field,
								'expression',
								$author$project$DataElement$Expression$cyclic$localDateDecoder()));
					case 'date day in month':
						return A2(
							$elm$json$Json$Decode$map,
							$author$project$DataElement$Expression$LocalDayInMonth,
							A2(
								$elm$json$Json$Decode$field,
								'expression',
								$author$project$DataElement$Expression$cyclic$localDateDecoder()));
					case 'pick one':
						return A2(
							$author$project$DataElement$Expression$pickOneDecoder,
							$author$project$DataElement$Expression$LocalPickNumber,
							$author$project$DataElement$Expression$cyclic$localNumberListDecoder());
					case 'max':
						return A2(
							$elm$json$Json$Decode$map,
							$author$project$DataElement$Expression$LocalMaxNumber,
							A2(
								$elm$json$Json$Decode$field,
								'expression',
								$author$project$DataElement$Expression$cyclic$localNumberListDecoder()));
					case 'min':
						return A2(
							$elm$json$Json$Decode$map,
							$author$project$DataElement$Expression$LocalMinNumber,
							A2(
								$elm$json$Json$Decode$field,
								'expression',
								$author$project$DataElement$Expression$cyclic$localNumberListDecoder()));
					case 'if':
						return A3(
							$author$project$DataElement$Expression$ifDecoder,
							$author$project$DataElement$Expression$LocalNumberIf,
							$author$project$DataElement$Expression$cyclic$localBoolDecoder(),
							$author$project$DataElement$Expression$cyclic$localNumberDecoder());
					default:
						return $elm$json$Json$Decode$fail('Could not parse \'' + (words + '\' as a Local Number Expression'));
				}
			}));
}
function $author$project$DataElement$Expression$cyclic$localNumberListDecoder() {
	return A2(
		$author$project$DataElement$Expression$confirmDataType,
		$author$project$FieldType$NumberType,
		$author$project$DataElement$Expression$typeDecoder(
			function (words) {
				var _v2 = $elm$core$String$toLower(words);
				switch (_v2) {
					case 'related field':
						return A3(
							$elm$json$Json$Decode$map2,
							$author$project$DataElement$Expression$RelatedNumber,
							A2(
								$elm$json$Json$Decode$field,
								'relationship',
								$author$project$DataElement$Expression$cyclic$relationshipDecoder()),
							A2($elm$json$Json$Decode$field, 'field', $author$project$FieldName$decoder));
					case 'field in list':
						return A3(
							$elm$json$Json$Decode$map2,
							$author$project$DataElement$Expression$LocalAllNumbersInField,
							A2($elm$json$Json$Decode$field, 'dataElement', $author$project$DataElement$Reference$recordListReferenceDecoder),
							A2($elm$json$Json$Decode$field, 'field', $author$project$FieldName$decoder));
					case 'list of expressions':
						return A2(
							$elm$json$Json$Decode$map,
							$author$project$DataElement$Expression$LocalNumbersAsList,
							A2(
								$elm$json$Json$Decode$field,
								'expressions',
								$elm$json$Json$Decode$list(
									$author$project$DataElement$Expression$cyclic$localNumberDecoder())));
					case 'if':
						return A3(
							$author$project$DataElement$Expression$ifDecoder,
							$author$project$DataElement$Expression$LocalNumberListIf,
							$author$project$DataElement$Expression$cyclic$localBoolDecoder(),
							$author$project$DataElement$Expression$cyclic$localNumberListDecoder());
					default:
						return $elm$json$Json$Decode$fail('Could not parse \'' + (words + '\' as a Local Number List Expression'));
				}
			}));
}
function $author$project$DataElement$Expression$cyclic$localStringDecoder() {
	return A2(
		$author$project$DataElement$Expression$confirmDataType,
		$author$project$FieldType$StringType,
		$author$project$DataElement$Expression$typeDecoder(
			function (words) {
				var _v1 = $elm$core$String$toLower(words);
				switch (_v1) {
					case 'local field':
						return A2(
							$elm$json$Json$Decode$map,
							$author$project$DataElement$Expression$LocalString,
							A2($elm$json$Json$Decode$field, 'field', $author$project$FieldName$decoder));
					case 'singleton field':
						return A3(
							$elm$json$Json$Decode$map2,
							$author$project$DataElement$Expression$LocalSingletonString,
							A2($elm$json$Json$Decode$field, 'dataElement', $author$project$DataElement$Reference$singletonReferenceDecoder),
							A2($elm$json$Json$Decode$field, 'field', $author$project$FieldName$decoder));
					case 'static':
						return A2(
							$elm$json$Json$Decode$map,
							$author$project$DataElement$Expression$LocalStringHardcoded,
							A2($elm$json$Json$Decode$field, 'value', $elm$json$Json$Decode$string));
					case 'format date':
						return A3(
							$elm$json$Json$Decode$map2,
							A2(
								$elm$core$Basics$composeR,
								$elm$core$Maybe$map($author$project$DataElement$Expression$LocalFormatDate),
								$elm$core$Maybe$withDefault($author$project$DataElement$Expression$LocalFormatDateLocaleAware)),
							A2(
								$elm_community$json_extra$Json$Decode$Extra$optionalNullableField,
								'formatExpression',
								$author$project$DataElement$Expression$cyclic$localStringDecoder()),
							A2(
								$elm$json$Json$Decode$field,
								'dateExpression',
								$author$project$DataElement$Expression$cyclic$localDateDecoder()));
					case 'format date/time':
						return A2(
							$elm$json$Json$Decode$map,
							$author$project$DataElement$Expression$LocalFormatDateTime,
							A2(
								$elm$json$Json$Decode$field,
								'dateTimeExpression',
								$author$project$DataElement$Expression$cyclic$localDateTimeDecoder()));
					case 'float to string':
						return A3(
							$elm$json$Json$Decode$map2,
							$author$project$DataElement$Expression$LocalFormatNumber,
							A2($elm$json$Json$Decode$field, 'decimals', $elm$json$Json$Decode$int),
							A2(
								$elm$json$Json$Decode$field,
								'expression',
								$author$project$DataElement$Expression$cyclic$localNumberDecoder()));
					case 'number to string':
						return A3(
							$elm$json$Json$Decode$map2,
							$author$project$DataElement$Expression$LocalFormatNumber,
							A2($elm$json$Json$Decode$field, 'decimals', $elm$json$Json$Decode$int),
							A2(
								$elm$json$Json$Decode$field,
								'expression',
								$author$project$DataElement$Expression$cyclic$localNumberDecoder()));
					case 'concat':
						return A3(
							$elm$json$Json$Decode$map2,
							$author$project$DataElement$Expression$LocalConcat,
							A2(
								$elm$json$Json$Decode$field,
								'joinExpression',
								$author$project$DataElement$Expression$cyclic$localStringDecoder()),
							A2(
								$elm$json$Json$Decode$field,
								'listExpression',
								$author$project$DataElement$Expression$cyclic$localStringListDecoder()));
					case 'pick one':
						return A2(
							$author$project$DataElement$Expression$pickOneDecoder,
							$author$project$DataElement$Expression$LocalPickString,
							$author$project$DataElement$Expression$cyclic$localStringListDecoder());
					case 'max':
						return A2(
							$elm$json$Json$Decode$map,
							$author$project$DataElement$Expression$LocalMaxString,
							A2(
								$elm$json$Json$Decode$field,
								'expression',
								$author$project$DataElement$Expression$cyclic$localStringListDecoder()));
					case 'min':
						return A2(
							$elm$json$Json$Decode$map,
							$author$project$DataElement$Expression$LocalMinString,
							A2(
								$elm$json$Json$Decode$field,
								'expression',
								$author$project$DataElement$Expression$cyclic$localStringListDecoder()));
					case 'if':
						return A3(
							$author$project$DataElement$Expression$ifDecoder,
							$author$project$DataElement$Expression$LocalStringIf,
							$author$project$DataElement$Expression$cyclic$localBoolDecoder(),
							$author$project$DataElement$Expression$cyclic$localStringDecoder());
					default:
						return $elm$json$Json$Decode$fail('Could not parse \'' + (words + '\' as a Local String Expression'));
				}
			}));
}
function $author$project$DataElement$Expression$cyclic$localStringListDecoder() {
	return A2(
		$author$project$DataElement$Expression$confirmDataType,
		$author$project$FieldType$StringType,
		$author$project$DataElement$Expression$typeDecoder(
			function (words) {
				var _v0 = $elm$core$String$toLower(words);
				switch (_v0) {
					case 'related field':
						return A3(
							$elm$json$Json$Decode$map2,
							$author$project$DataElement$Expression$RelatedString,
							A2(
								$elm$json$Json$Decode$field,
								'relationship',
								$author$project$DataElement$Expression$cyclic$relationshipDecoder()),
							A2($elm$json$Json$Decode$field, 'field', $author$project$FieldName$decoder));
					case 'field in list':
						return A3(
							$elm$json$Json$Decode$map2,
							$author$project$DataElement$Expression$LocalAllStringsInField,
							A2($elm$json$Json$Decode$field, 'dataElement', $author$project$DataElement$Reference$recordListReferenceDecoder),
							A2($elm$json$Json$Decode$field, 'field', $author$project$FieldName$decoder));
					case 'list of expressions':
						return A2(
							$elm$json$Json$Decode$map,
							$author$project$DataElement$Expression$LocalStringsAsList,
							A2(
								$elm$json$Json$Decode$field,
								'expressions',
								$elm$json$Json$Decode$list(
									$author$project$DataElement$Expression$cyclic$localStringDecoder())));
					case 'if':
						return A3(
							$author$project$DataElement$Expression$ifDecoder,
							$author$project$DataElement$Expression$LocalStringListIf,
							$author$project$DataElement$Expression$cyclic$localBoolDecoder(),
							$author$project$DataElement$Expression$cyclic$localStringListDecoder());
					case 'challenge reasons':
						return A2(
							$elm$json$Json$Decode$map,
							$author$project$DataElement$Expression$LocalChallengeReasons,
							A2(
								$elm$json$Json$Decode$field,
								'expression',
								$author$project$DataElement$Expression$cyclic$localStringDecoder()));
					case 'target challenge reasons':
						return A2(
							$elm$json$Json$Decode$map,
							$author$project$DataElement$Expression$LocalTargetChallengeReasons,
							A2(
								$elm$json$Json$Decode$field,
								'expression',
								$author$project$DataElement$Expression$cyclic$localStringDecoder()));
					default:
						return $elm$json$Json$Decode$fail('Could not parse \'' + (words + '\' as a Local String List Expression'));
				}
			}));
}
try {
	var $author$project$DataElement$Expression$relationshipDecoder = $author$project$DataElement$Expression$cyclic$relationshipDecoder();
	$author$project$DataElement$Expression$cyclic$relationshipDecoder = function () {
		return $author$project$DataElement$Expression$relationshipDecoder;
	};
	var $author$project$DataElement$Expression$localBoolDecoder = $author$project$DataElement$Expression$cyclic$localBoolDecoder();
	$author$project$DataElement$Expression$cyclic$localBoolDecoder = function () {
		return $author$project$DataElement$Expression$localBoolDecoder;
	};
	var $author$project$DataElement$Expression$localBoolListDecoder = $author$project$DataElement$Expression$cyclic$localBoolListDecoder();
	$author$project$DataElement$Expression$cyclic$localBoolListDecoder = function () {
		return $author$project$DataElement$Expression$localBoolListDecoder;
	};
	var $author$project$DataElement$Expression$localComparableListDecoder = $author$project$DataElement$Expression$cyclic$localComparableListDecoder();
	$author$project$DataElement$Expression$cyclic$localComparableListDecoder = function () {
		return $author$project$DataElement$Expression$localComparableListDecoder;
	};
	var $author$project$DataElement$Expression$localDateDecoder = $author$project$DataElement$Expression$cyclic$localDateDecoder();
	$author$project$DataElement$Expression$cyclic$localDateDecoder = function () {
		return $author$project$DataElement$Expression$localDateDecoder;
	};
	var $author$project$DataElement$Expression$localDateListDecoder = $author$project$DataElement$Expression$cyclic$localDateListDecoder();
	$author$project$DataElement$Expression$cyclic$localDateListDecoder = function () {
		return $author$project$DataElement$Expression$localDateListDecoder;
	};
	var $author$project$DataElement$Expression$localDateTimeDecoder = $author$project$DataElement$Expression$cyclic$localDateTimeDecoder();
	$author$project$DataElement$Expression$cyclic$localDateTimeDecoder = function () {
		return $author$project$DataElement$Expression$localDateTimeDecoder;
	};
	var $author$project$DataElement$Expression$localDateTimeListDecoder = $author$project$DataElement$Expression$cyclic$localDateTimeListDecoder();
	$author$project$DataElement$Expression$cyclic$localDateTimeListDecoder = function () {
		return $author$project$DataElement$Expression$localDateTimeListDecoder;
	};
	var $author$project$DataElement$Expression$localFieldDecoder = $author$project$DataElement$Expression$cyclic$localFieldDecoder();
	$author$project$DataElement$Expression$cyclic$localFieldDecoder = function () {
		return $author$project$DataElement$Expression$localFieldDecoder;
	};
	var $author$project$DataElement$Expression$localNumberDecoder = $author$project$DataElement$Expression$cyclic$localNumberDecoder();
	$author$project$DataElement$Expression$cyclic$localNumberDecoder = function () {
		return $author$project$DataElement$Expression$localNumberDecoder;
	};
	var $author$project$DataElement$Expression$localNumberListDecoder = $author$project$DataElement$Expression$cyclic$localNumberListDecoder();
	$author$project$DataElement$Expression$cyclic$localNumberListDecoder = function () {
		return $author$project$DataElement$Expression$localNumberListDecoder;
	};
	var $author$project$DataElement$Expression$localStringDecoder = $author$project$DataElement$Expression$cyclic$localStringDecoder();
	$author$project$DataElement$Expression$cyclic$localStringDecoder = function () {
		return $author$project$DataElement$Expression$localStringDecoder;
	};
	var $author$project$DataElement$Expression$localStringListDecoder = $author$project$DataElement$Expression$cyclic$localStringListDecoder();
	$author$project$DataElement$Expression$cyclic$localStringListDecoder = function () {
		return $author$project$DataElement$Expression$localStringListDecoder;
	};
} catch ($) {
	throw 'Some top-level definitions from `DataElement.Expression` are causing infinite recursion:\n\n  ┌─────┐\n  │    relationshipDecoder\n  │     ↓\n  │    localBoolDecoder\n  │     ↓\n  │    localBoolListDecoder\n  │     ↓\n  │    localComparableListDecoder\n  │     ↓\n  │    localDateDecoder\n  │     ↓\n  │    localDateListDecoder\n  │     ↓\n  │    localDateTimeDecoder\n  │     ↓\n  │    localDateTimeListDecoder\n  │     ↓\n  │    localFieldDecoder\n  │     ↓\n  │    localNumberDecoder\n  │     ↓\n  │    localNumberListDecoder\n  │     ↓\n  │    localStringDecoder\n  │     ↓\n  │    localStringListDecoder\n  └─────┘\n\nThese errors are very tricky, so read https://elm-lang.org/0.19.1/bad-recursion to learn how to fix it!';}
var $author$project$DataElement$filterListDecoder = A2(
	$elm$json$Json$Decode$map,
	A2($elm$core$Basics$composeR, $author$project$DataElement$CalcFilterList, $author$project$DataElement$RecordList),
	A3(
		$elm$json$Json$Decode$map2,
		$author$project$DataElement$FilterList$Info,
		A2($elm$json$Json$Decode$field, 'original', $author$project$DataElement$Reference$recordListReferenceDecoder),
		A2($elm$json$Json$Decode$field, 'filter', $author$project$DataElement$Expression$localBoolDecoder)));
var $author$project$DataElement$CalcMergeList = function (a) {
	return {$: 'CalcMergeList', a: a};
};
var $author$project$DataElement$MergeList$ListCombineMatrix = function (a) {
	return {$: 'ListCombineMatrix', a: a};
};
var $elm$core$List$append = F2(
	function (xs, ys) {
		if (!ys.b) {
			return xs;
		} else {
			return A3($elm$core$List$foldr, $elm$core$List$cons, ys, xs);
		}
	});
var $elm$core$List$concat = function (lists) {
	return A3($elm$core$List$foldr, $elm$core$List$append, _List_Nil, lists);
};
var $pzp1997$assoc_list$AssocList$keys = function (_v0) {
	var alist = _v0.a;
	return A2($elm$core$List$map, $elm$core$Tuple$first, alist);
};
var $elm_community$list_extra$List$Extra$uniqueHelp = F4(
	function (f, existing, remaining, accumulator) {
		uniqueHelp:
		while (true) {
			if (!remaining.b) {
				return $elm$core$List$reverse(accumulator);
			} else {
				var first = remaining.a;
				var rest = remaining.b;
				var computedFirst = f(first);
				if (A2($elm$core$List$member, computedFirst, existing)) {
					var $temp$f = f,
						$temp$existing = existing,
						$temp$remaining = rest,
						$temp$accumulator = accumulator;
					f = $temp$f;
					existing = $temp$existing;
					remaining = $temp$remaining;
					accumulator = $temp$accumulator;
					continue uniqueHelp;
				} else {
					var $temp$f = f,
						$temp$existing = A2($elm$core$List$cons, computedFirst, existing),
						$temp$remaining = rest,
						$temp$accumulator = A2($elm$core$List$cons, first, accumulator);
					f = $temp$f;
					existing = $temp$existing;
					remaining = $temp$remaining;
					accumulator = $temp$accumulator;
					continue uniqueHelp;
				}
			}
		}
	});
var $elm_community$list_extra$List$Extra$unique = function (list) {
	return A4($elm_community$list_extra$List$Extra$uniqueHelp, $elm$core$Basics$identity, _List_Nil, list, _List_Nil);
};
var $author$project$DataElement$MergeList$fromDict = function (inputList) {
	var fieldLabels = function (_v2) {
		var fieldDict = _v2.b;
		return A2(
			$elm$core$List$map,
			$author$project$FieldName$toString,
			$pzp1997$assoc_list$AssocList$keys(fieldDict));
	};
	var containsFieldLabelList = function (fieldLabelList) {
		return A2(
			$elm$core$List$map,
			function (fieldLabel) {
				return A2($elm$core$List$member, fieldLabel, fieldLabelList);
			},
			$elm_community$list_extra$List$Extra$unique(
				$elm$core$List$concat(
					A2($elm$core$List$map, fieldLabels, inputList))));
	};
	var validDataSource = function (innerFieldsList) {
		var _v1 = $elm_community$list_extra$List$Extra$unique(
			containsFieldLabelList(innerFieldsList));
		if ((_v1.b && _v1.a) && (!_v1.b.b)) {
			return true;
		} else {
			return false;
		}
	};
	var getDataSourceStatuses = A2(
		$elm$core$List$map,
		A2($elm$core$Basics$composeR, fieldLabels, validDataSource),
		inputList);
	var validMergeList = function () {
		var _v0 = $elm_community$list_extra$List$Extra$unique(getDataSourceStatuses);
		if ((_v0.b && _v0.a) && (!_v0.b.b)) {
			return true;
		} else {
			return false;
		}
	}();
	return validMergeList ? $elm$core$Result$Ok(
		$author$project$DataElement$MergeList$ListCombineMatrix(inputList)) : $elm$core$Result$Err('Merge list is not valid. Each field label needs a field value from each datasource.');
};
var $author$project$DataElement$MergeList$innerDictDecoder = A2(
	$elm$json$Json$Decode$map,
	A2(
		$elm$core$Basics$composeR,
		$elm$core$List$map(
			$elm$core$Tuple$mapFirst($author$project$FieldName$fromString)),
		$pzp1997$assoc_list$AssocList$fromList),
	$elm$json$Json$Decode$keyValuePairs($author$project$FieldName$decoder));
var $author$project$DataElement$MergeList$listDecoder = $elm$json$Json$Decode$list(
	A3(
		$elm$json$Json$Decode$map2,
		$elm$core$Tuple$pair,
		A2($elm$json$Json$Decode$field, 'dataSource', $author$project$DataElement$Reference$recordListReferenceDecoder),
		A2($elm$json$Json$Decode$field, 'dict', $author$project$DataElement$MergeList$innerDictDecoder)));
var $author$project$DataElement$MergeList$decoder = A2(
	$elm$json$Json$Decode$andThen,
	A2($elm$core$Basics$composeR, $author$project$DataElement$MergeList$fromDict, $elm_community$json_extra$Json$Decode$Extra$fromResult),
	$author$project$DataElement$MergeList$listDecoder);
var $author$project$DataElement$mergeListDecoder = A2(
	$elm$json$Json$Decode$map,
	A2($elm$core$Basics$composeR, $author$project$DataElement$CalcMergeList, $author$project$DataElement$RecordList),
	A2($elm$json$Json$Decode$field, 'sources', $author$project$DataElement$MergeList$decoder));
var $author$project$DataElement$ObjectTranslation = function (a) {
	return {$: 'ObjectTranslation', a: a};
};
var $author$project$DataElement$objectTranslationDecoder = A2(
	$elm$json$Json$Decode$map,
	A2($elm$core$Basics$composeR, $author$project$DataElement$ObjectTranslation, $author$project$DataElement$Singleton),
	$elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$json$Json$Decode$at,
				_List_fromArray(
					['object', 'name']),
				$author$project$ObjectName$decoder),
				A2($elm$json$Json$Decode$field, 'object', $author$project$ObjectName$decoder)
			])));
var $author$project$DataElement$CalcOneForOne = function (a) {
	return {$: 'CalcOneForOne', a: a};
};
var $author$project$DataElement$OneForOneInfo = F2(
	function (original, fields) {
		return {fields: fields, original: original};
	});
var $author$project$DataElement$oneForOneDecoder = A2(
	$elm$json$Json$Decode$map,
	A2($elm$core$Basics$composeR, $author$project$DataElement$CalcOneForOne, $author$project$DataElement$RecordList),
	A3(
		$elm$json$Json$Decode$map2,
		$author$project$DataElement$OneForOneInfo,
		A2($elm$json$Json$Decode$field, 'original', $author$project$DataElement$Reference$recordListReferenceDecoder),
		A2(
			$elm$json$Json$Decode$field,
			'fields',
			A2(
				$elm$json$Json$Decode$map,
				A2(
					$elm$core$Basics$composeR,
					$elm$core$List$map(
						$elm$core$Tuple$mapFirst($author$project$FieldName$fromString)),
					$pzp1997$assoc_list$AssocList$fromList),
				$elm$json$Json$Decode$keyValuePairs($author$project$DataElement$Expression$localFieldDecoder)))));
var $author$project$DataElement$FeedbackOverview = function (a) {
	return {$: 'FeedbackOverview', a: a};
};
var $author$project$DataElement$FeedbackOverviewInfo = function (fields) {
	return {fields: fields};
};
var $author$project$DataElement$overviewDecoder = A2(
	$elm$json$Json$Decode$map,
	A2($elm$core$Basics$composeR, $author$project$DataElement$FeedbackOverview, $author$project$DataElement$Singleton),
	A2($elm$json$Json$Decode$map, $author$project$DataElement$FeedbackOverviewInfo, $author$project$DataElement$selectedFieldsDecoder));
var $author$project$DataElement$FeedbackProductGoals = function (a) {
	return {$: 'FeedbackProductGoals', a: a};
};
var $author$project$DataElement$FeedbackProductGoals$Info = function (fields) {
	return {fields: fields};
};
var $author$project$DataElement$productGoalsDecoder = A2(
	$elm$json$Json$Decode$map,
	A2($elm$core$Basics$composeR, $author$project$DataElement$FeedbackProductGoals, $author$project$DataElement$RecordList),
	A2($elm$json$Json$Decode$map, $author$project$DataElement$FeedbackProductGoals$Info, $author$project$DataElement$selectedFieldsDecoder));
var $author$project$DataElement$QueryInfo = F6(
	function (objectName, fields, limit, sort, whereClause, objectTags) {
		return {fields: fields, limit: limit, objectName: objectName, objectTags: objectTags, sort: sort, whereClause: whereClause};
	});
var $author$project$DataElement$WhereClause$WhereAnd = function (a) {
	return {$: 'WhereAnd', a: a};
};
var $author$project$DataElement$WhereClause$WhereIndividual = function (a) {
	return {$: 'WhereIndividual', a: a};
};
var $author$project$DataElement$WhereClause$WhereOr = function (a) {
	return {$: 'WhereOr', a: a};
};
var $author$project$DataElement$WhereClause$WhereEqual = F2(
	function (a, b) {
		return {$: 'WhereEqual', a: a, b: b};
	});
var $author$project$DataElement$WhereClause$WhereGT = F2(
	function (a, b) {
		return {$: 'WhereGT', a: a, b: b};
	});
var $author$project$DataElement$WhereClause$WhereGTE = F2(
	function (a, b) {
		return {$: 'WhereGTE', a: a, b: b};
	});
var $author$project$DataElement$WhereClause$WhereIn = F2(
	function (a, b) {
		return {$: 'WhereIn', a: a, b: b};
	});
var $author$project$DataElement$WhereClause$WhereLT = F2(
	function (a, b) {
		return {$: 'WhereLT', a: a, b: b};
	});
var $author$project$DataElement$WhereClause$WhereLTE = F2(
	function (a, b) {
		return {$: 'WhereLTE', a: a, b: b};
	});
var $author$project$DataElement$WhereClause$WhereNotEqual = F2(
	function (a, b) {
		return {$: 'WhereNotEqual', a: a, b: b};
	});
var $author$project$DataElement$WhereClause$pickWhereIndividualDecoder = function (words) {
	var _v0 = $elm$core$String$toLower(words);
	switch (_v0) {
		case 'in':
			return A3(
				$elm$json$Json$Decode$map2,
				$author$project$DataElement$WhereClause$WhereIn,
				A2(
					$elm$json$Json$Decode$at,
					_List_fromArray(
						['field', 'name']),
					$author$project$FieldName$decoder),
				A2($elm$json$Json$Decode$field, 'expression', $author$project$DataElement$Expression$globalStringListDecoder));
		case 'equal':
			return A3(
				$elm$json$Json$Decode$map2,
				$author$project$DataElement$WhereClause$WhereEqual,
				A2(
					$elm$json$Json$Decode$at,
					_List_fromArray(
						['field', 'name']),
					$author$project$FieldName$decoder),
				A2($elm$json$Json$Decode$field, 'expression', $author$project$DataElement$Expression$globalFieldDecoder));
		case 'not equal':
			return A3(
				$elm$json$Json$Decode$map2,
				$author$project$DataElement$WhereClause$WhereNotEqual,
				A2(
					$elm$json$Json$Decode$at,
					_List_fromArray(
						['field', 'name']),
					$author$project$FieldName$decoder),
				A2($elm$json$Json$Decode$field, 'expression', $author$project$DataElement$Expression$globalFieldDecoder));
		case 'gt':
			return A3(
				$elm$json$Json$Decode$map2,
				$author$project$DataElement$WhereClause$WhereGT,
				A2(
					$elm$json$Json$Decode$at,
					_List_fromArray(
						['field', 'name']),
					$author$project$FieldName$decoder),
				A2($elm$json$Json$Decode$field, 'expression', $author$project$DataElement$Expression$globalComparableDecoder));
		case 'gte':
			return A3(
				$elm$json$Json$Decode$map2,
				$author$project$DataElement$WhereClause$WhereGTE,
				A2(
					$elm$json$Json$Decode$at,
					_List_fromArray(
						['field', 'name']),
					$author$project$FieldName$decoder),
				A2($elm$json$Json$Decode$field, 'expression', $author$project$DataElement$Expression$globalComparableDecoder));
		case 'lt':
			return A3(
				$elm$json$Json$Decode$map2,
				$author$project$DataElement$WhereClause$WhereLT,
				A2(
					$elm$json$Json$Decode$at,
					_List_fromArray(
						['field', 'name']),
					$author$project$FieldName$decoder),
				A2($elm$json$Json$Decode$field, 'expression', $author$project$DataElement$Expression$globalComparableDecoder));
		case 'lte':
			return A3(
				$elm$json$Json$Decode$map2,
				$author$project$DataElement$WhereClause$WhereLTE,
				A2(
					$elm$json$Json$Decode$at,
					_List_fromArray(
						['field', 'name']),
					$author$project$FieldName$decoder),
				A2($elm$json$Json$Decode$field, 'expression', $author$project$DataElement$Expression$globalComparableDecoder));
		default:
			return $elm$json$Json$Decode$fail('Could not parse \'' + (words + '\' as a valid where clause type'));
	}
};
var $author$project$DataElement$WhereClause$pickWhereClauseDecoder = function (words) {
	var _v0 = $elm$core$String$toLower(words);
	switch (_v0) {
		case 'and':
			return A2(
				$elm$json$Json$Decode$map,
				$author$project$DataElement$WhereClause$WhereAnd,
				A2(
					$elm$json$Json$Decode$field,
					'subclauses',
					$elm$json$Json$Decode$list(
						$author$project$DataElement$WhereClause$cyclic$decoder())));
		case 'or':
			return A2(
				$elm$json$Json$Decode$map,
				$author$project$DataElement$WhereClause$WhereOr,
				A2(
					$elm$json$Json$Decode$field,
					'subclauses',
					$elm$json$Json$Decode$list(
						$author$project$DataElement$WhereClause$cyclic$decoder())));
		default:
			return A2(
				$elm$json$Json$Decode$map,
				$author$project$DataElement$WhereClause$WhereIndividual,
				$author$project$DataElement$WhereClause$pickWhereIndividualDecoder(words));
	}
};
function $author$project$DataElement$WhereClause$cyclic$decoder() {
	return A2(
		$elm$json$Json$Decode$andThen,
		$author$project$DataElement$WhereClause$pickWhereClauseDecoder,
		A2(
			$elm$json$Json$Decode$at,
			_List_fromArray(
				['type', 'value']),
			$elm$json$Json$Decode$string));
}
try {
	var $author$project$DataElement$WhereClause$decoder = $author$project$DataElement$WhereClause$cyclic$decoder();
	$author$project$DataElement$WhereClause$cyclic$decoder = function () {
		return $author$project$DataElement$WhereClause$decoder;
	};
} catch ($) {
	throw 'Some top-level definitions from `DataElement.WhereClause` are causing infinite recursion:\n\n  ┌─────┐\n  │    decoder\n  │     ↓\n  │    pickWhereClauseDecoder\n  └─────┘\n\nThese errors are very tricky, so read https://elm-lang.org/0.19.1/bad-recursion to learn how to fix it!';}
var $author$project$DataElement$FieldInfo = F2(
	function (fieldType, _default) {
		return {_default: _default, fieldType: fieldType};
	});
var $author$project$DataElement$fieldInfoDecoder = A3(
	$elm$json$Json$Decode$map2,
	$author$project$DataElement$FieldInfo,
	A2($elm$json$Json$Decode$field, 'dataType', $author$project$FieldType$decoder),
	$elm$json$Json$Decode$succeed($elm$core$Maybe$Nothing));
var $author$project$DataElement$fieldInfoPicklistTupleDecoder = A3(
	$elm$json$Json$Decode$map2,
	$elm$core$Tuple$pair,
	$author$project$DataElement$fieldInfoDecoder,
	A2(
		$elm$json$Json$Decode$map,
		$elm$core$Maybe$withDefault(false),
		A2($elm_community$json_extra$Json$Decode$Extra$optionalNullableField, 'isPicklist', $elm$json$Json$Decode$bool)));
var $author$project$DataElement$addPicklistTranslationField = F2(
	function (_v0, dict) {
		var fieldName = _v0.a;
		var _v1 = _v0.b;
		var fieldInfo = _v1.a;
		var isPicklist = _v1.b;
		return isPicklist ? A3(
			$pzp1997$assoc_list$AssocList$insert,
			fieldName,
			fieldInfo,
			A3(
				$pzp1997$assoc_list$AssocList$insert,
				$author$project$FieldName$fromString(
					A2(
						$elm$core$String$append,
						$author$project$FieldName$toString(fieldName),
						'_Translation')),
				{_default: $elm$core$Maybe$Nothing, fieldType: fieldInfo.fieldType},
				dict)) : A3($pzp1997$assoc_list$AssocList$insert, fieldName, fieldInfo, dict);
	});
var $author$project$DataElement$getFieldNameDictWithTranslations = function (initialList) {
	return A3($elm$core$List$foldl, $author$project$DataElement$addPicklistTranslationField, $pzp1997$assoc_list$AssocList$empty, initialList);
};
var $elm$json$Json$Decode$map6 = _Json_map6;
var $author$project$DataElement$queryInfoDecoder = A7(
	$elm$json$Json$Decode$map6,
	$author$project$DataElement$QueryInfo,
	$elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$json$Json$Decode$at,
				_List_fromArray(
					['object', 'name']),
				$author$project$ObjectName$decoder),
				A2($elm$json$Json$Decode$field, 'object', $author$project$ObjectName$decoder)
			])),
	A2(
		$elm$json$Json$Decode$field,
		'fields',
		A2(
			$elm$json$Json$Decode$map,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$map(
					$elm$core$Tuple$mapFirst($author$project$FieldName$fromString)),
				$author$project$DataElement$getFieldNameDictWithTranslations),
			$elm$json$Json$Decode$keyValuePairs($author$project$DataElement$fieldInfoPicklistTupleDecoder))),
	$elm$json$Json$Decode$maybe(
		A2($elm$json$Json$Decode$field, 'limit', $elm$json$Json$Decode$int)),
	A2(
		$elm$json$Json$Decode$map,
		$elm$core$Maybe$withDefault(_List_Nil),
		$elm$json$Json$Decode$maybe(
			A2(
				$elm$json$Json$Decode$field,
				'sort',
				$elm$json$Json$Decode$list($author$project$DataElement$SortKey$decoder)))),
	$elm$json$Json$Decode$maybe(
		A2($elm$json$Json$Decode$field, 'where', $author$project$DataElement$WhereClause$decoder)),
	$author$project$DataElement$objectTagsDecoder);
var $author$project$DataElement$CalcSortList = function (a) {
	return {$: 'CalcSortList', a: a};
};
var $author$project$DataElement$SortList$Info = F2(
	function (original, sortBy) {
		return {original: original, sortBy: sortBy};
	});
var $author$project$DataElement$SortList$SortKey = F2(
	function (expression, direction) {
		return {direction: direction, expression: expression};
	});
var $author$project$DataElement$Expression$LocalCompDateExpr = function (a) {
	return {$: 'LocalCompDateExpr', a: a};
};
var $author$project$DataElement$Expression$LocalCompDateTimeExpr = function (a) {
	return {$: 'LocalCompDateTimeExpr', a: a};
};
var $author$project$DataElement$Expression$LocalCompNumberExpr = function (a) {
	return {$: 'LocalCompNumberExpr', a: a};
};
var $author$project$DataElement$Expression$LocalCompStringExpr = function (a) {
	return {$: 'LocalCompStringExpr', a: a};
};
var $author$project$DataElement$Expression$localComparableDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (fieldType) {
		switch (fieldType.$) {
			case 'StringType':
				return A2($elm$json$Json$Decode$map, $author$project$DataElement$Expression$LocalCompStringExpr, $author$project$DataElement$Expression$localStringDecoder);
			case 'NumberType':
				return A2($elm$json$Json$Decode$map, $author$project$DataElement$Expression$LocalCompNumberExpr, $author$project$DataElement$Expression$localNumberDecoder);
			case 'DateType':
				return A2($elm$json$Json$Decode$map, $author$project$DataElement$Expression$LocalCompDateExpr, $author$project$DataElement$Expression$localDateDecoder);
			case 'DateTimeType':
				return A2($elm$json$Json$Decode$map, $author$project$DataElement$Expression$LocalCompDateTimeExpr, $author$project$DataElement$Expression$localDateTimeDecoder);
			default:
				return $elm$json$Json$Decode$fail(
					'Data type \'' + ($author$project$FieldType$toString(fieldType) + '\' is not supported as a Local Comparable Expression'));
		}
	},
	A2($elm$json$Json$Decode$field, 'dataType', $author$project$FieldType$decoder));
var $author$project$DataElement$sortListKeyDecoder = A3(
	$elm$json$Json$Decode$map2,
	$author$project$DataElement$SortList$SortKey,
	A2($elm$json$Json$Decode$field, 'expression', $author$project$DataElement$Expression$localComparableDecoder),
	A2(
		$elm$json$Json$Decode$at,
		_List_fromArray(
			['sortDir', 'value']),
		$author$project$SortDirection$decoder));
var $author$project$DataElement$sortListDecoder = A2(
	$elm$json$Json$Decode$map,
	A2($elm$core$Basics$composeR, $author$project$DataElement$CalcSortList, $author$project$DataElement$RecordList),
	A3(
		$elm$json$Json$Decode$map2,
		$author$project$DataElement$SortList$Info,
		A2($elm$json$Json$Decode$field, 'original', $author$project$DataElement$Reference$recordListReferenceDecoder),
		A2(
			$elm$json$Json$Decode$andThen,
			A2(
				$elm$core$Basics$composeR,
				$mgold$elm_nonempty_list$List$Nonempty$fromList,
				A2(
					$elm$core$Basics$composeR,
					$elm$core$Result$fromMaybe('\'sort\' cannot be empty'),
					$elm_community$json_extra$Json$Decode$Extra$fromResult)),
			A2(
				$elm$json$Json$Decode$field,
				'sort',
				$elm$json$Json$Decode$list($author$project$DataElement$sortListKeyDecoder)))));
var $author$project$DataElement$CalcSublist = function (a) {
	return {$: 'CalcSublist', a: a};
};
var $author$project$DataElement$Sublist$Info = F3(
	function (original, skipThisMany, keepThisMany) {
		return {keepThisMany: keepThisMany, original: original, skipThisMany: skipThisMany};
	});
var $author$project$DataElement$sublistDecoder = A2(
	$elm$json$Json$Decode$map,
	A2($elm$core$Basics$composeR, $author$project$DataElement$CalcSublist, $author$project$DataElement$RecordList),
	A4(
		$elm$json$Json$Decode$map3,
		$author$project$DataElement$Sublist$Info,
		A2($elm$json$Json$Decode$field, 'original', $author$project$DataElement$Reference$recordListReferenceDecoder),
		A2($elm$json$Json$Decode$field, 'skip', $elm$json$Json$Decode$int),
		A2($elm$json$Json$Decode$field, 'keep', $elm$json$Json$Decode$int)));
var $author$project$DataElement$CalcSummarize = function (a) {
	return {$: 'CalcSummarize', a: a};
};
var $author$project$DataElement$SummarizeInfo = function (fields) {
	return {fields: fields};
};
var $author$project$DataElement$summarizeDecoder = A2(
	$elm$json$Json$Decode$map,
	A2(
		$elm$core$Basics$composeR,
		$author$project$DataElement$SummarizeInfo,
		A2($elm$core$Basics$composeR, $author$project$DataElement$CalcSummarize, $author$project$DataElement$Singleton)),
	A2(
		$elm$json$Json$Decode$field,
		'fields',
		A2(
			$elm$json$Json$Decode$map,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$map(
					$elm$core$Tuple$mapFirst($author$project$FieldName$fromString)),
				$pzp1997$assoc_list$AssocList$fromList),
			$elm$json$Json$Decode$keyValuePairs($author$project$DataElement$Expression$globalFieldDecoder))));
var $author$project$DataElement$VeevaMessages$Info = function (tokens) {
	return {tokens: tokens};
};
var $author$project$DataElement$VeevaMessages = function (a) {
	return {$: 'VeevaMessages', a: a};
};
var $author$project$DataElement$VeevaMessages$Token = F2(
	function (name, category) {
		return {category: category, name: name};
	});
var $author$project$DataElement$veevaMessageTokenDecoder = A3(
	$elm$json$Json$Decode$map2,
	$author$project$DataElement$VeevaMessages$Token,
	A2($elm$json$Json$Decode$field, 'name', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'category', $elm$json$Json$Decode$string));
var $author$project$DataElement$veevaMessagesDecoder = A2(
	$elm$json$Json$Decode$map,
	A2(
		$elm$core$Basics$composeR,
		$author$project$DataElement$VeevaMessages$Info,
		A2($elm$core$Basics$composeR, $author$project$DataElement$VeevaMessages, $author$project$DataElement$Singleton)),
	A2(
		$elm$json$Json$Decode$field,
		'messages',
		$elm$json$Json$Decode$list($author$project$DataElement$veevaMessageTokenDecoder)));
var $author$project$DataElement$CrmQuery = function (a) {
	return {$: 'CrmQuery', a: a};
};
var $author$project$DataElement$LimitOneCrmQuery = function (a) {
	return {$: 'LimitOneCrmQuery', a: a};
};
var $author$project$DataElement$wrapCrmQuery = function (info) {
	var _v0 = info.limit;
	if ((_v0.$ === 'Just') && (_v0.a === 1)) {
		return $author$project$DataElement$Singleton(
			$author$project$DataElement$LimitOneCrmQuery(info));
	} else {
		return $author$project$DataElement$RecordList(
			$author$project$DataElement$CrmQuery(info));
	}
};
var $author$project$DataElement$CrmDataEngineQuery = function (a) {
	return {$: 'CrmDataEngineQuery', a: a};
};
var $author$project$DataElement$LimitOneCrmDataEngineQuery = function (a) {
	return {$: 'LimitOneCrmDataEngineQuery', a: a};
};
var $author$project$DataElement$wrapDataEngineQuery = function (info) {
	var _v0 = info.limit;
	if ((_v0.$ === 'Just') && (_v0.a === 1)) {
		return $author$project$DataElement$Singleton(
			$author$project$DataElement$LimitOneCrmDataEngineQuery(info));
	} else {
		return $author$project$DataElement$RecordList(
			$author$project$DataElement$CrmDataEngineQuery(info));
	}
};
var $author$project$DataElement$LimitOneNitroQuery = function (a) {
	return {$: 'LimitOneNitroQuery', a: a};
};
var $author$project$DataElement$NitroQuery = function (a) {
	return {$: 'NitroQuery', a: a};
};
var $author$project$DataElement$wrapNitroQuery = function (info) {
	var _v0 = info.limit;
	if ((_v0.$ === 'Just') && (_v0.a === 1)) {
		return $author$project$DataElement$Singleton(
			$author$project$DataElement$LimitOneNitroQuery(info));
	} else {
		return $author$project$DataElement$RecordList(
			$author$project$DataElement$NitroQuery(info));
	}
};
var $author$project$DataElement$LimitOneSalesQuery = function (a) {
	return {$: 'LimitOneSalesQuery', a: a};
};
var $author$project$DataElement$SalesQuery = function (a) {
	return {$: 'SalesQuery', a: a};
};
var $author$project$DataElement$wrapSalesQuery = function (info) {
	var _v0 = info.limit;
	if ((_v0.$ === 'Just') && (_v0.a === 1)) {
		return $author$project$DataElement$Singleton(
			$author$project$DataElement$LimitOneSalesQuery(info));
	} else {
		return $author$project$DataElement$RecordList(
			$author$project$DataElement$SalesQuery(info));
	}
};
var $author$project$DataElement$pickDecoder = function (typeWords) {
	switch (typeWords) {
		case 'DATA_EL_CONTEXT_QUERY':
			return $author$project$DataElement$contextQueryDecoder;
		case 'Context Query':
			return $author$project$DataElement$contextQueryDecoder;
		case 'DATA_EL_CRM_QUERY':
			return A2($elm$json$Json$Decode$map, $author$project$DataElement$wrapCrmQuery, $author$project$DataElement$queryInfoDecoder);
		case 'CRM Query':
			return A2($elm$json$Json$Decode$map, $author$project$DataElement$wrapCrmQuery, $author$project$DataElement$queryInfoDecoder);
		case 'DATA_EL_SALES_DATA_QUERY':
			return A2($elm$json$Json$Decode$map, $author$project$DataElement$wrapSalesQuery, $author$project$DataElement$SalesQuery$decoder);
		case 'DATA_EL_NITRO_QUERY':
			return A2($elm$json$Json$Decode$map, $author$project$DataElement$wrapNitroQuery, $author$project$DataElement$queryInfoDecoder);
		case 'DATA_EL_CRM_DATA_ENGINE':
			return A2($elm$json$Json$Decode$map, $author$project$DataElement$wrapDataEngineQuery, $author$project$DataElement$CrmDataEngineQuery$decoder);
		case 'DATA_EL_ONE_FOR_ONE':
			return $author$project$DataElement$oneForOneDecoder;
		case 'One for One':
			return $author$project$DataElement$oneForOneDecoder;
		case 'DATA_EL_SORT_LIST':
			return $author$project$DataElement$sortListDecoder;
		case 'DATA_EL_FILTER_LIST':
			return $author$project$DataElement$filterListDecoder;
		case 'DATA_EL_SUBLIST':
			return $author$project$DataElement$sublistDecoder;
		case 'DATA_EL_ALIGNED_TERRITORIES':
			return $author$project$DataElement$alignedTerritoriesDecoder;
		case 'DATA_EL_CALL_ATTENDEES':
			return $elm$json$Json$Decode$succeed(
				$author$project$DataElement$RecordList($author$project$DataElement$CallAttendees));
		case 'DATA_EL_TODAY':
			return $elm$json$Json$Decode$succeed(
				$author$project$DataElement$Singleton($author$project$DataElement$Today));
		case 'Today':
			return $elm$json$Json$Decode$succeed(
				$author$project$DataElement$Singleton($author$project$DataElement$Today));
		case 'Now':
			return $elm$json$Json$Decode$succeed(
				$author$project$DataElement$Singleton($author$project$DataElement$Now));
		case 'DATA_EL_NOW':
			return $elm$json$Json$Decode$succeed(
				$author$project$DataElement$Singleton($author$project$DataElement$Now));
		case 'DATA_EL_SUMMARIZE':
			return $author$project$DataElement$summarizeDecoder;
		case 'Summarize':
			return $author$project$DataElement$summarizeDecoder;
		case 'DATA_EL_OBJECT_TRANSLATION':
			return $author$project$DataElement$objectTranslationDecoder;
		case 'DATA_EL_FIELD_TRANSLATION':
			return $author$project$DataElement$fieldTranslationDecoder;
		case 'DATA_EL_VEEVA_MESSAGES':
			return $author$project$DataElement$veevaMessagesDecoder;
		case 'DATA_EL_MERGE_LIST':
			return $author$project$DataElement$mergeListDecoder;
		case 'Date Picker State':
			return A2(
				$elm$json$Json$Decode$map,
				A2($elm$core$Basics$composeR, $author$project$DataElement$DatepickerSelection, $author$project$DataElement$Singleton),
				$author$project$DataElement$Datepicker$decoder);
		case 'Dropdown State':
			return A2(
				$elm$json$Json$Decode$map,
				A2($elm$core$Basics$composeR, $author$project$DataElement$InteractiveSelectSelection, $author$project$DataElement$Singleton),
				$author$project$DataElement$Dropdown$decoder);
		case 'DATA_EL_FEEDBACK_OVERVIEW':
			return $author$project$DataElement$overviewDecoder;
		case 'DATA_EL_FEEDBACK_CHANNEL_GOALS':
			return $author$project$DataElement$channelGoalsDecoder;
		case 'DATA_EL_FEEDBACK_PRODUCT_GOALS':
			return $author$project$DataElement$productGoalsDecoder;
		case 'DATA_EL_FEEDBACK_ACCOUNT_DATA':
			return $author$project$DataElement$accountDataDecoder;
		case 'DATA_EL_FEEDBACK_ACCOUNT_CHANNEL_GOALS':
			return $author$project$DataElement$accountChannelGoalsDecoder;
		case 'DATA_EL_FEEDBACK_ACCOUNT_PRODUCT_GOALS':
			return $author$project$DataElement$accountProductGoalsDecoder;
		case 'DATA_EL_FEEDBACK_ACCOUNT_PRODUCT_METRICS':
			return $author$project$DataElement$accountProductMetricsDecoder;
		default:
			return $elm$json$Json$Decode$fail('Could not parse \'' + (typeWords + '\' as a Data Element'));
	}
};
var $author$project$DataElement$decoder = A3(
	$elm$json$Json$Decode$map2,
	$author$project$DataElement$DataElement,
	A2($elm$json$Json$Decode$field, 'name', $elm$json$Json$Decode$string),
	A2(
		$elm$json$Json$Decode$andThen,
		$author$project$DataElement$pickDecoder,
		A2($elm$json$Json$Decode$field, 'type', $elm$json$Json$Decode$string)));
var $author$project$UuidDict$checkUuidKey = function (words) {
	return A2(
		$elm$core$Result$fromMaybe,
		'\'' + (words + '\' is not a valid UUID'),
		$danyx23$elm_uuid$Uuid$fromString(words));
};
var $elm_community$result_extra$Result$Extra$combineMap = function (f) {
	return A2(
		$elm$core$Basics$composeL,
		$elm_community$result_extra$Result$Extra$combine,
		$elm$core$List$map(f));
};
var $elm_community$result_extra$Result$Extra$combineFirst = function (_v0) {
	var rx = _v0.a;
	var y = _v0.b;
	return A2(
		$elm$core$Result$map,
		function (x) {
			return A2($elm$core$Tuple$pair, x, y);
		},
		rx);
};
var $elm_community$result_extra$Result$Extra$combineMapFirst = function (f) {
	return A2(
		$elm$core$Basics$composeL,
		$elm_community$result_extra$Result$Extra$combineFirst,
		$elm$core$Tuple$mapFirst(f));
};
var $elm_community$dict_extra$Dict$Extra$fromListBy = F2(
	function (keyfn, xs) {
		return A3(
			$elm$core$List$foldl,
			F2(
				function (x, acc) {
					return A3(
						$elm$core$Dict$insert,
						keyfn(x),
						x,
						acc);
				}),
			$elm$core$Dict$empty,
			xs);
	});
var $danyx23$elm_uuid$Uuid$toString = function (_v0) {
	var internalString = _v0.a;
	return internalString;
};
var $author$project$UuidDict$decoder = function (innerDecoder) {
	return A2(
		$elm$json$Json$Decode$map,
		A2(
			$elm$core$Basics$composeR,
			$elm_community$dict_extra$Dict$Extra$fromListBy(
				A2($elm$core$Basics$composeR, $elm$core$Tuple$first, $danyx23$elm_uuid$Uuid$toString)),
			$author$project$UuidDict$UuidDict),
		A2(
			$elm$json$Json$Decode$andThen,
			A2(
				$elm$core$Basics$composeR,
				$elm_community$result_extra$Result$Extra$combineMap(
					$elm_community$result_extra$Result$Extra$combineMapFirst($author$project$UuidDict$checkUuidKey)),
				$elm_community$json_extra$Json$Decode$Extra$fromResult),
			$elm$json$Json$Decode$keyValuePairs(innerDecoder)));
};
var $author$project$DataElement$collectionDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$DataElement$DataElementCollection,
	$author$project$UuidDict$decoder($author$project$DataElement$decoder));
var $author$project$DisplayElement$Custom = function (a) {
	return {$: 'Custom', a: a};
};
var $author$project$DisplayElement$Datepicker = function (a) {
	return {$: 'Datepicker', a: a};
};
var $author$project$DisplayElement$FieldList = function (a) {
	return {$: 'FieldList', a: a};
};
var $author$project$DisplayElement$MetricHighlight = function (a) {
	return {$: 'MetricHighlight', a: a};
};
var $author$project$DisplayElement$ProgressChart = function (a) {
	return {$: 'ProgressChart', a: a};
};
var $author$project$DisplayElement$Row = F2(
	function (a, b) {
		return {$: 'Row', a: a, b: b};
	});
var $author$project$DisplayElement$Section = F2(
	function (a, b) {
		return {$: 'Section', a: a, b: b};
	});
var $author$project$DisplayElement$Select = function (a) {
	return {$: 'Select', a: a};
};
var $author$project$DisplayElement$Table = function (a) {
	return {$: 'Table', a: a};
};
var $author$project$DisplayElement$TrendChart = function (a) {
	return {$: 'TrendChart', a: a};
};
var $author$project$DisplayElement$Custom$Info = F3(
	function (widgetUuid, versionUuid, properties) {
		return {properties: properties, versionUuid: versionUuid, widgetUuid: widgetUuid};
	});
var $elm$json$Json$Decode$dict = function (decoder) {
	return A2(
		$elm$json$Json$Decode$map,
		$elm$core$Dict$fromList,
		$elm$json$Json$Decode$keyValuePairs(decoder));
};
var $author$project$DisplayElement$Custom$ArrayValue = F2(
	function (a, b) {
		return {$: 'ArrayValue', a: a, b: b};
	});
var $author$project$DisplayElement$Custom$arrayValueDecoder = A3(
	$elm$json$Json$Decode$map2,
	$author$project$DisplayElement$Custom$ArrayValue,
	A2($elm$json$Json$Decode$field, 'dataSource', $author$project$DataElement$Reference$recordListReferenceDecoder),
	A2(
		$elm$json$Json$Decode$field,
		'fields',
		$elm$json$Json$Decode$dict($author$project$DataElement$Expression$localFieldDecoder)));
var $author$project$DisplayElement$Custom$SingleValue = function (a) {
	return {$: 'SingleValue', a: a};
};
var $author$project$DisplayElement$Custom$singleValueDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$DisplayElement$Custom$SingleValue,
	A2($elm$json$Json$Decode$field, 'expression', $author$project$DataElement$Expression$globalFieldDecoder));
var $author$project$DisplayElement$Custom$propertyDecoder = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[$author$project$DisplayElement$Custom$singleValueDecoder, $author$project$DisplayElement$Custom$arrayValueDecoder]));
var $author$project$DisplayElement$Custom$decoder = A4(
	$elm$json$Json$Decode$map3,
	$author$project$DisplayElement$Custom$Info,
	A2($elm$json$Json$Decode$field, 'uuid', $danyx23$elm_uuid$Uuid$decoder),
	A2($elm$json$Json$Decode$field, 'versionUuid', $danyx23$elm_uuid$Uuid$decoder),
	A2(
		$elm$json$Json$Decode$field,
		'properties',
		$elm$json$Json$Decode$dict($author$project$DisplayElement$Custom$propertyDecoder)));
var $author$project$DisplayElement$Datepicker$Info = F2(
	function (state, label) {
		return {label: label, state: state};
	});
var $author$project$DisplayElement$Datepicker$decoder = A3(
	$elm$json$Json$Decode$map2,
	$author$project$DisplayElement$Datepicker$Info,
	A2($elm$json$Json$Decode$field, 'state', $author$project$DataElement$Reference$singletonReferenceDecoder),
	A2($elm$json$Json$Decode$field, 'label', $author$project$DataElement$Expression$globalStringDecoder));
var $author$project$DisplayElement$FieldList$Info = function (a) {
	return {$: 'Info', a: a};
};
var $author$project$DisplayElement$FieldList$InnerInfo = F2(
	function (style, labelValuePairs) {
		return {labelValuePairs: labelValuePairs, style: style};
	});
var $author$project$View$FieldList$Style$Above = {$: 'Above'};
var $author$project$View$FieldList$Style$Horizontal = {$: 'Horizontal'};
var $author$project$View$FieldList$Style$Inline = {$: 'Inline'};
var $author$project$View$FieldList$Style$fromString = function (words) {
	var _v0 = $elm$core$String$toLower(words);
	switch (_v0) {
		case 'above':
			return $elm$core$Result$Ok($author$project$View$FieldList$Style$Above);
		case 'inline':
			return $elm$core$Result$Ok($author$project$View$FieldList$Style$Inline);
		case 'horizontal':
			return $elm$core$Result$Ok($author$project$View$FieldList$Style$Horizontal);
		default:
			return $elm$core$Result$Err('Could not parse \'' + (words + '\' as a Field List Style'));
	}
};
var $author$project$View$FieldList$Style$decoder = A2(
	$elm$json$Json$Decode$andThen,
	A2($elm$core$Basics$composeR, $author$project$View$FieldList$Style$fromString, $elm_community$json_extra$Json$Decode$Extra$fromResult),
	$elm$json$Json$Decode$string);
var $author$project$DisplayElement$FieldList$LabelValuePair = F4(
	function (label, value, valueAction, icon) {
		return {icon: icon, label: label, value: value, valueAction: valueAction};
	});
var $author$project$Icon$Icon = function (a) {
	return {$: 'Icon', a: a};
};
var $author$project$Icon$makeIcon = F2(
	function (name, category) {
		return $author$project$Icon$Icon(
			{category: category, name: name});
	});
var $author$project$Icon$decoder = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Icon$makeIcon,
	A2($elm$json$Json$Decode$field, 'name', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'category', $elm$json$Json$Decode$string));
var $author$project$UserAction$UserActions = function (navigation) {
	return {navigation: navigation};
};
var $author$project$UserAction$EditRecord = function (a) {
	return {$: 'EditRecord', a: a};
};
var $author$project$UserAction$ViewRecord = F2(
	function (a, b) {
		return {$: 'ViewRecord', a: a, b: b};
	});
var $author$project$UserAction$ViewSection = function (a) {
	return {$: 'ViewSection', a: a};
};
var $author$project$StudioContentId$StudioContentId = function (a) {
	return {$: 'StudioContentId', a: a};
};
var $author$project$StudioContentId$fromUuid = function (uuid) {
	return $author$project$StudioContentId$StudioContentId(uuid);
};
var $author$project$StudioContentId$decoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$StudioContentId$fromUuid,
	A2($elm$json$Json$Decode$field, 'Studio_Id_vod__c', $danyx23$elm_uuid$Uuid$decoder));
var $author$project$UserAction$listOfTargetDecoder = $elm$json$Json$Decode$list($author$project$StudioContentId$decoder);
var $elm_community$json_extra$Json$Decode$Extra$fromMaybe = F2(
	function (error, val) {
		if (val.$ === 'Just') {
			var v = val.a;
			return $elm$json$Json$Decode$succeed(v);
		} else {
			return $elm$json$Json$Decode$fail(error);
		}
	});
var $author$project$UserAction$nonEmptyTargetDecoder = A2(
	$elm$json$Json$Decode$andThen,
	A2(
		$elm$core$Basics$composeR,
		$mgold$elm_nonempty_list$List$Nonempty$fromList,
		$elm_community$json_extra$Json$Decode$Extra$fromMaybe('The targets list must not be empty for ViewSection')),
	$elm$json$Json$Decode$list($author$project$StudioContentId$decoder));
var $author$project$UserAction$chooseNavigationActionDecoder = F2(
	function (exprDecoder, typeString) {
		var _v0 = $elm$core$String$toUpper(typeString);
		switch (_v0) {
			case 'EDIT_RECORD':
				return A2(
					$elm$json$Json$Decode$map,
					$author$project$UserAction$EditRecord,
					A2($elm$json$Json$Decode$field, 'recordId', exprDecoder));
			case 'VIEW_RECORD':
				return A3(
					$elm$json$Json$Decode$map2,
					$author$project$UserAction$ViewRecord,
					A2($elm$json$Json$Decode$field, 'recordId', exprDecoder),
					A2(
						$elm$json$Json$Decode$map,
						$elm$core$Maybe$withDefault(_List_Nil),
						A2($elm_community$json_extra$Json$Decode$Extra$optionalField, 'target', $author$project$UserAction$listOfTargetDecoder)));
			case 'VIEW_SECTION':
				return A2(
					$elm$json$Json$Decode$map,
					$author$project$UserAction$ViewSection,
					A2($elm$json$Json$Decode$field, 'target', $author$project$UserAction$nonEmptyTargetDecoder));
			default:
				return $elm$json$Json$Decode$fail('Could not parse \'' + (typeString + '\' as a navigation action'));
		}
	});
var $author$project$UserAction$navigationActionDecoder = function (exprDecoder) {
	return A2(
		$elm$json$Json$Decode$andThen,
		$author$project$UserAction$chooseNavigationActionDecoder(exprDecoder),
		A2($elm$json$Json$Decode$field, 'type', $elm$json$Json$Decode$string));
};
var $author$project$UserAction$decoder = function (exprDecoder) {
	return A2(
		$elm$json$Json$Decode$map,
		$author$project$UserAction$UserActions,
		A2(
			$elm_community$json_extra$Json$Decode$Extra$optionalNullableField,
			'navigation',
			$author$project$UserAction$navigationActionDecoder(exprDecoder)));
};
var $author$project$UserAction$empty = {navigation: $elm$core$Maybe$Nothing};
var $author$project$DisplayElement$FieldList$labelValuePairDecoder = A5(
	$elm$json$Json$Decode$map4,
	$author$project$DisplayElement$FieldList$LabelValuePair,
	A2($elm$json$Json$Decode$field, 'label', $author$project$DataElement$Expression$globalStringDecoder),
	A2($elm$json$Json$Decode$field, 'value', $author$project$DataElement$Expression$globalStringDecoder),
	A2(
		$elm$json$Json$Decode$map,
		$elm$core$Maybe$withDefault($author$project$UserAction$empty),
		A2(
			$elm_community$json_extra$Json$Decode$Extra$optionalNullableField,
			'valueAction',
			$author$project$UserAction$decoder($author$project$DataElement$Expression$globalStringDecoder))),
	A2($elm_community$json_extra$Json$Decode$Extra$optionalNullableField, 'icon', $author$project$Icon$decoder));
var $author$project$DisplayElement$FieldList$decoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$DisplayElement$FieldList$Info,
	A3(
		$elm$json$Json$Decode$map2,
		$author$project$DisplayElement$FieldList$InnerInfo,
		A2($elm$json$Json$Decode$field, 'style', $author$project$View$FieldList$Style$decoder),
		A2(
			$elm$json$Json$Decode$field,
			'items',
			$elm$json$Json$Decode$list($author$project$DisplayElement$FieldList$labelValuePairDecoder))));
var $author$project$DisplayElement$MetricHighlight$Info = function (a) {
	return {$: 'Info', a: a};
};
var $author$project$DisplayElement$MetricHighlight$InnerInfo = F2(
	function (first, second) {
		return {first: first, second: second};
	});
var $author$project$DisplayElement$MetricHighlight$LabelValuePair = F4(
	function (label, value, action, icon) {
		return {action: action, icon: icon, label: label, value: value};
	});
var $author$project$DisplayElement$MetricHighlight$BoolValue = function (a) {
	return {$: 'BoolValue', a: a};
};
var $author$project$DisplayElement$MetricHighlight$NumberValue = F2(
	function (a, b) {
		return {$: 'NumberValue', a: a, b: b};
	});
var $author$project$DisplayElement$MetricHighlight$StringValue = function (a) {
	return {$: 'StringValue', a: a};
};
var $author$project$DisplayElement$MetricHighlight$DateValue = F2(
	function (a, b) {
		return {$: 'DateValue', a: a, b: b};
	});
var $author$project$DisplayElement$MetricHighlight$pickDateMetric = F2(
	function (globalDate, maybeGlobalString) {
		if (maybeGlobalString.$ === 'Nothing') {
			return $author$project$DisplayElement$MetricHighlight$StringValue(
				$author$project$DataElement$Expression$GlobalFormatDateLocaleAware(globalDate));
		} else {
			var globalString = maybeGlobalString.a;
			return A2($author$project$DisplayElement$MetricHighlight$DateValue, globalDate, globalString);
		}
	});
var $author$project$DisplayElement$MetricHighlight$pickMetricValueDecoder = function (fieldType) {
	switch (fieldType.$) {
		case 'StringType':
			return A2(
				$elm$json$Json$Decode$map,
				$author$project$DisplayElement$MetricHighlight$StringValue,
				A2($elm$json$Json$Decode$field, 'value', $author$project$DataElement$Expression$globalStringDecoder));
		case 'NumberType':
			return A3(
				$elm$json$Json$Decode$map2,
				$author$project$DisplayElement$MetricHighlight$NumberValue,
				A2($elm$json$Json$Decode$field, 'value', $author$project$DataElement$Expression$globalNumberDecoder),
				A2($elm$json$Json$Decode$field, 'decimals', $elm$json$Json$Decode$int));
		case 'DateType':
			return A3(
				$elm$json$Json$Decode$map2,
				$author$project$DisplayElement$MetricHighlight$pickDateMetric,
				A2($elm$json$Json$Decode$field, 'value', $author$project$DataElement$Expression$globalDateDecoder),
				A2($elm_community$json_extra$Json$Decode$Extra$optionalNullableField, 'formatExpression', $author$project$DataElement$Expression$globalStringDecoder));
		case 'DateTimeType':
			return A2(
				$elm$json$Json$Decode$map,
				$author$project$DisplayElement$MetricHighlight$StringValue,
				A2(
					$elm$json$Json$Decode$map,
					$author$project$DataElement$Expression$GlobalFormatDateTime,
					A2($elm$json$Json$Decode$field, 'value', $author$project$DataElement$Expression$globalDateTimeDecoder)));
		default:
			return A2(
				$elm$json$Json$Decode$map,
				$author$project$DisplayElement$MetricHighlight$BoolValue,
				A2($elm$json$Json$Decode$field, 'value', $author$project$DataElement$Expression$globalBoolDecoder));
	}
};
var $author$project$DisplayElement$MetricHighlight$metricValueDecoder = A2(
	$elm$json$Json$Decode$andThen,
	$author$project$DisplayElement$MetricHighlight$pickMetricValueDecoder,
	A2(
		$elm$json$Json$Decode$at,
		_List_fromArray(
			['value', 'dataType']),
		$author$project$FieldType$decoder));
var $author$project$DisplayElement$MetricHighlight$labelValuePairDecoder = A5(
	$elm$json$Json$Decode$map4,
	$author$project$DisplayElement$MetricHighlight$LabelValuePair,
	A2($elm$json$Json$Decode$field, 'label', $author$project$DataElement$Expression$globalStringDecoder),
	$author$project$DisplayElement$MetricHighlight$metricValueDecoder,
	A2(
		$elm$json$Json$Decode$map,
		$elm$core$Maybe$withDefault($author$project$UserAction$empty),
		A2(
			$elm_community$json_extra$Json$Decode$Extra$optionalNullableField,
			'valueAction',
			$author$project$UserAction$decoder($author$project$DataElement$Expression$globalStringDecoder))),
	A2($elm_community$json_extra$Json$Decode$Extra$optionalNullableField, 'icon', $author$project$Icon$decoder));
var $author$project$DisplayElement$MetricHighlight$decoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$DisplayElement$MetricHighlight$Info,
	A3(
		$elm$json$Json$Decode$map2,
		$author$project$DisplayElement$MetricHighlight$InnerInfo,
		A2($elm$json$Json$Decode$field, 'first', $author$project$DisplayElement$MetricHighlight$labelValuePairDecoder),
		A2($elm_community$json_extra$Json$Decode$Extra$optionalNullableField, 'second', $author$project$DisplayElement$MetricHighlight$labelValuePairDecoder)));
var $author$project$DisplayElement$ProgressChart$Info = function (a) {
	return {$: 'Info', a: a};
};
var $author$project$DisplayElement$ProgressChart$InnerInfo = F3(
	function (value, goal, allowOverflow) {
		return {allowOverflow: allowOverflow, goal: goal, value: value};
	});
var $author$project$DisplayElement$ProgressChart$decoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$DisplayElement$ProgressChart$Info,
	A4(
		$elm$json$Json$Decode$map3,
		$author$project$DisplayElement$ProgressChart$InnerInfo,
		A2($elm$json$Json$Decode$field, 'value', $author$project$DataElement$Expression$globalNumberDecoder),
		A2($elm$json$Json$Decode$field, 'goal', $author$project$DataElement$Expression$globalNumberDecoder),
		A2($elm$json$Json$Decode$field, 'overflow', $elm$json$Json$Decode$bool)));
var $author$project$DisplayElement$Section$SectionWithHeader = function (a) {
	return {$: 'SectionWithHeader', a: a};
};
var $author$project$DisplayElement$Section$SectionWithoutHeader = {$: 'SectionWithoutHeader'};
var $author$project$DisplayElement$Section$Header$Header = F3(
	function (title, icon, action) {
		return {action: action, icon: icon, title: title};
	});
var $author$project$DisplayElement$Section$Header$decoder = A4(
	$elm$json$Json$Decode$map3,
	$author$project$DisplayElement$Section$Header$Header,
	A2(
		$elm$json$Json$Decode$at,
		_List_fromArray(
			['title', 'expression']),
		$author$project$DataElement$Expression$globalStringDecoder),
	A2($elm_community$json_extra$Json$Decode$Extra$optionalNullableField, 'icon', $author$project$Icon$decoder),
	A2(
		$elm$json$Json$Decode$field,
		'title',
		A2(
			$elm$json$Json$Decode$map,
			$elm$core$Maybe$withDefault($author$project$UserAction$empty),
			A2(
				$elm_community$json_extra$Json$Decode$Extra$optionalNullableField,
				'action',
				$author$project$UserAction$decoder($author$project$DataElement$Expression$globalStringDecoder)))));
var $author$project$DisplayElement$Section$decoder = A2(
	$elm$json$Json$Decode$map,
	$elm$core$Maybe$withDefault($author$project$DisplayElement$Section$SectionWithoutHeader),
	$elm$json$Json$Decode$maybe(
		A2(
			$elm$json$Json$Decode$map,
			$author$project$DisplayElement$Section$SectionWithHeader,
			A2($elm$json$Json$Decode$field, 'header', $author$project$DisplayElement$Section$Header$decoder))));
var $author$project$DisplayElement$Select$Info = F2(
	function (state, label) {
		return {label: label, state: state};
	});
var $author$project$DisplayElement$Select$decoder = A3(
	$elm$json$Json$Decode$map2,
	$author$project$DisplayElement$Select$Info,
	A2($elm$json$Json$Decode$field, 'state', $author$project$DataElement$Reference$singletonReferenceDecoder),
	A2($elm$json$Json$Decode$field, 'label', $author$project$DataElement$Expression$globalStringDecoder));
var $author$project$DisplayElement$Table$Info = function (a) {
	return {$: 'Info', a: a};
};
var $author$project$DisplayElement$Table$Internals = F2(
	function (dataElement, columns) {
		return {columns: columns, dataElement: dataElement};
	});
var $author$project$DisplayElement$Table$BoolColumn = function (a) {
	return {$: 'BoolColumn', a: a};
};
var $author$project$DisplayElement$Table$DateColumn = function (a) {
	return {$: 'DateColumn', a: a};
};
var $author$project$DisplayElement$Table$DateTimeColumn = function (a) {
	return {$: 'DateTimeColumn', a: a};
};
var $author$project$DisplayElement$Table$NumberColumn = function (a) {
	return {$: 'NumberColumn', a: a};
};
var $author$project$DisplayElement$Table$StringColumn = function (a) {
	return {$: 'StringColumn', a: a};
};
var $author$project$DisplayElement$Table$BasicColumn = F5(
	function (header, value, valueAction, lineWrap, userSortable) {
		return {header: header, lineWrap: lineWrap, userSortable: userSortable, value: value, valueAction: valueAction};
	});
var $author$project$DisplayElement$Table$basicColumnDecoder = A6(
	$elm$json$Json$Decode$map5,
	$author$project$DisplayElement$Table$BasicColumn,
	A2($elm$json$Json$Decode$field, 'headerExpression', $author$project$DataElement$Expression$globalStringDecoder),
	A2(
		$elm$json$Json$Decode$at,
		_List_fromArray(
			['field', 'name']),
		$author$project$FieldName$decoder),
	A2(
		$elm$json$Json$Decode$field,
		'field',
		A2(
			$elm$json$Json$Decode$map,
			$elm$core$Maybe$withDefault($author$project$UserAction$empty),
			A2(
				$elm_community$json_extra$Json$Decode$Extra$optionalNullableField,
				'action',
				$author$project$UserAction$decoder($author$project$DataElement$Expression$localStringDecoder)))),
	A2(
		$elm$json$Json$Decode$map,
		$elm$core$Maybe$withDefault(false),
		A2($elm_community$json_extra$Json$Decode$Extra$optionalNullableField, 'lineWrap', $elm$json$Json$Decode$bool)),
	A2(
		$elm$json$Json$Decode$map,
		$elm$core$Maybe$withDefault(false),
		A2($elm_community$json_extra$Json$Decode$Extra$optionalNullableField, 'userSortable', $elm$json$Json$Decode$bool)));
var $author$project$DisplayElement$Table$DateColumnInfo = F6(
	function (header, value, format, valueAction, lineWrap, userSortable) {
		return {format: format, header: header, lineWrap: lineWrap, userSortable: userSortable, value: value, valueAction: valueAction};
	});
var $author$project$DisplayElement$Table$dateColumnDecoder = A7(
	$elm$json$Json$Decode$map6,
	$author$project$DisplayElement$Table$DateColumnInfo,
	A2($elm$json$Json$Decode$field, 'headerExpression', $author$project$DataElement$Expression$globalStringDecoder),
	A2(
		$elm$json$Json$Decode$at,
		_List_fromArray(
			['field', 'name']),
		$author$project$FieldName$decoder),
	A2(
		$elm$json$Json$Decode$field,
		'field',
		A2($elm_community$json_extra$Json$Decode$Extra$optionalNullableField, 'format', $elm$json$Json$Decode$string)),
	A2(
		$elm$json$Json$Decode$field,
		'field',
		A2(
			$elm$json$Json$Decode$map,
			$elm$core$Maybe$withDefault($author$project$UserAction$empty),
			A2(
				$elm_community$json_extra$Json$Decode$Extra$optionalNullableField,
				'action',
				$author$project$UserAction$decoder($author$project$DataElement$Expression$localStringDecoder)))),
	A2(
		$elm$json$Json$Decode$map,
		$elm$core$Maybe$withDefault(false),
		A2($elm_community$json_extra$Json$Decode$Extra$optionalNullableField, 'lineWrap', $elm$json$Json$Decode$bool)),
	A2(
		$elm$json$Json$Decode$map,
		$elm$core$Maybe$withDefault(false),
		A2($elm_community$json_extra$Json$Decode$Extra$optionalNullableField, 'userSortable', $elm$json$Json$Decode$bool)));
var $author$project$DisplayElement$Table$pickColumnDecoder = function (fieldType) {
	switch (fieldType.$) {
		case 'StringType':
			return A2($elm$json$Json$Decode$map, $author$project$DisplayElement$Table$StringColumn, $author$project$DisplayElement$Table$basicColumnDecoder);
		case 'NumberType':
			return A2($elm$json$Json$Decode$map, $author$project$DisplayElement$Table$NumberColumn, $author$project$DisplayElement$Table$basicColumnDecoder);
		case 'DateType':
			return A2($elm$json$Json$Decode$map, $author$project$DisplayElement$Table$DateColumn, $author$project$DisplayElement$Table$dateColumnDecoder);
		case 'DateTimeType':
			return A2($elm$json$Json$Decode$map, $author$project$DisplayElement$Table$DateTimeColumn, $author$project$DisplayElement$Table$basicColumnDecoder);
		default:
			return A2($elm$json$Json$Decode$map, $author$project$DisplayElement$Table$BoolColumn, $author$project$DisplayElement$Table$basicColumnDecoder);
	}
};
var $author$project$DisplayElement$Table$columnDecoder = A2(
	$elm$json$Json$Decode$andThen,
	$author$project$DisplayElement$Table$pickColumnDecoder,
	A2(
		$elm$json$Json$Decode$at,
		_List_fromArray(
			['field', 'dataType']),
		$author$project$FieldType$decoder));
var $author$project$DisplayElement$Table$decoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$DisplayElement$Table$Info,
	A3(
		$elm$json$Json$Decode$map2,
		$author$project$DisplayElement$Table$Internals,
		A2($elm$json$Json$Decode$field, 'dataSource', $author$project$DataElement$Reference$recordListReferenceDecoder),
		A2(
			$elm$json$Json$Decode$field,
			'columns',
			$elm$json$Json$Decode$list($author$project$DisplayElement$Table$columnDecoder))));
var $author$project$DisplayElement$TrendChart$Info = function (a) {
	return {$: 'Info', a: a};
};
var $author$project$DisplayElement$TrendChart$InnerInfo = F5(
	function (dataSource, date, value, series, dateUnit) {
		return {dataSource: dataSource, date: date, dateUnit: dateUnit, series: series, value: value};
	});
var $author$project$DisplayElement$TrendChart$decoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$DisplayElement$TrendChart$Info,
	A6(
		$elm$json$Json$Decode$map5,
		$author$project$DisplayElement$TrendChart$InnerInfo,
		A2($elm$json$Json$Decode$field, 'dataSource', $author$project$DataElement$Reference$recordListReferenceDecoder),
		A2($elm$json$Json$Decode$field, 'date', $author$project$DataElement$Expression$localDateDecoder),
		A2($elm$json$Json$Decode$field, 'value', $author$project$DataElement$Expression$localNumberDecoder),
		A2(
			$elm$json$Json$Decode$map,
			$elm$core$Maybe$withDefault(
				$author$project$DataElement$Expression$LocalStringHardcoded('')),
			A2($elm_community$json_extra$Json$Decode$Extra$optionalNullableField, 'series', $author$project$DataElement$Expression$localStringDecoder)),
		A2($elm$json$Json$Decode$field, 'timeUnit', $author$project$DateUnit$decoder)));
var $author$project$View$Row$Config = function (a) {
	return {$: 'Config', a: a};
};
var $author$project$View$Row$defaultConfig = $author$project$View$Row$Config(_Utils_Tuple0);
var $author$project$View$Row$decoder = $elm$json$Json$Decode$succeed($author$project$View$Row$defaultConfig);
var $author$project$DisplayElement$pickDecoder = function (typeWords) {
	var _v0 = $elm$core$String$toLower(typeWords);
	switch (_v0) {
		case 'column':
			return A2(
				$elm$json$Json$Decode$map,
				$author$project$DisplayElement$Column,
				A2(
					$elm$json$Json$Decode$field,
					'children',
					$elm$json$Json$Decode$list(
						$author$project$DisplayElement$cyclic$decoder())));
		case 'row':
			return A3(
				$elm$json$Json$Decode$map2,
				$author$project$DisplayElement$Row,
				$author$project$View$Row$decoder,
				A2(
					$elm$json$Json$Decode$field,
					'children',
					$elm$json$Json$Decode$list(
						$author$project$DisplayElement$cyclic$decoder())));
		case 'section':
			return A3(
				$elm$json$Json$Decode$map2,
				$author$project$DisplayElement$Section,
				$author$project$DisplayElement$Section$decoder,
				A2(
					$elm_community$json_extra$Json$Decode$Extra$optionalNullableField,
					'body',
					$author$project$DisplayElement$cyclic$decoder()));
		case 'table':
			return A2($elm$json$Json$Decode$map, $author$project$DisplayElement$Table, $author$project$DisplayElement$Table$decoder);
		case 'trend chart':
			return A2($elm$json$Json$Decode$map, $author$project$DisplayElement$TrendChart, $author$project$DisplayElement$TrendChart$decoder);
		case 'category chart':
			return $elm$json$Json$Decode$fail('CategoryChart not supported yet');
		case 'progress chart':
			return A2($elm$json$Json$Decode$map, $author$project$DisplayElement$ProgressChart, $author$project$DisplayElement$ProgressChart$decoder);
		case 'field list':
			return A2($elm$json$Json$Decode$map, $author$project$DisplayElement$FieldList, $author$project$DisplayElement$FieldList$decoder);
		case 'metric highlight':
			return A2($elm$json$Json$Decode$map, $author$project$DisplayElement$MetricHighlight, $author$project$DisplayElement$MetricHighlight$decoder);
		case 'custom':
			return A2($elm$json$Json$Decode$map, $author$project$DisplayElement$Custom, $author$project$DisplayElement$Custom$decoder);
		case 'dropdown':
			return A2($elm$json$Json$Decode$map, $author$project$DisplayElement$Select, $author$project$DisplayElement$Select$decoder);
		case 'date picker':
			return A2($elm$json$Json$Decode$map, $author$project$DisplayElement$Datepicker, $author$project$DisplayElement$Datepicker$decoder);
		case 'date range picker':
			return $elm$json$Json$Decode$fail('DateRangePicker not supported yet');
		case 'button':
			return $elm$json$Json$Decode$fail('Button not supported yet');
		default:
			return $elm$json$Json$Decode$fail('Could not decode \'' + (typeWords + '\' as a valid DisplayElement type'));
	}
};
function $author$project$DisplayElement$cyclic$decoder() {
	return A2(
		$elm$json$Json$Decode$andThen,
		$author$project$DisplayElement$pickDecoder,
		A2($elm$json$Json$Decode$field, 'type', $elm$json$Json$Decode$string));
}
try {
	var $author$project$DisplayElement$decoder = $author$project$DisplayElement$cyclic$decoder();
	$author$project$DisplayElement$cyclic$decoder = function () {
		return $author$project$DisplayElement$decoder;
	};
} catch ($) {
	throw 'Some top-level definitions from `DisplayElement` are causing infinite recursion:\n\n  ┌─────┐\n  │    decoder\n  │     ↓\n  │    pickDecoder\n  └─────┘\n\nThese errors are very tricky, so read https://elm-lang.org/0.19.1/bad-recursion to learn how to fix it!';}
var $author$project$Page$decoder = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Page$Page,
	A2($elm$json$Json$Decode$field, 'name', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'display', $author$project$DisplayElement$decoder));
var $author$project$StudioApp$decoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$StudioApp$App,
	A3(
		$elm$json$Json$Decode$map2,
		$author$project$StudioApp$AppInternals,
		A2(
			$elm$json$Json$Decode$map,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$Maybe$andThen($mgold$elm_nonempty_list$List$Nonempty$fromList),
				$elm$core$Maybe$withDefault(
					$mgold$elm_nonempty_list$List$Nonempty$fromElement(
						A2(
							$author$project$Page$new,
							'Default Page',
							$author$project$DisplayElement$Column(_List_Nil))))),
			A2(
				$elm_community$json_extra$Json$Decode$Extra$optionalNullableField,
				'pages',
				$elm$json$Json$Decode$list($author$project$Page$decoder))),
		A2(
			$elm$json$Json$Decode$map,
			$elm$core$Maybe$withDefault($author$project$DataElement$emptyCollection),
			A2($elm_community$json_extra$Json$Decode$Extra$optionalNullableField, 'dataElements', $author$project$DataElement$collectionDecoder))));
var $author$project$Compiler$FromFrontEndMsg$pickDecoder = function (typeWords) {
	switch (typeWords) {
		case 'ConfigChange':
			return A2(
				$elm$json$Json$Decode$map,
				$author$project$Compiler$FromFrontEndMsg$ConfigChange,
				A2($elm$json$Json$Decode$field, 'app', $author$project$StudioApp$decoder));
		case 'PurgeAllDataElementsAndManifests':
			return $elm$json$Json$Decode$succeed($author$project$Compiler$FromFrontEndMsg$PurgeAllDataElementsAndManifests);
		case 'RxManifests':
			return A2(
				$elm$json$Json$Decode$map,
				$author$project$Compiler$FromFrontEndMsg$RxManifests,
				A2(
					$elm$json$Json$Decode$field,
					'manifests',
					$elm$json$Json$Decode$list($author$project$Manifest$decoder)));
		default:
			return $elm$json$Json$Decode$fail('Could not decode \'' + (typeWords + '\' as a valid ToEngineMsg type'));
	}
};
var $author$project$Compiler$FromFrontEndMsg$decoder = A2(
	$elm$json$Json$Decode$andThen,
	$author$project$Compiler$FromFrontEndMsg$pickDecoder,
	A2($elm$json$Json$Decode$field, 'type', $elm$json$Json$Decode$string));
var $author$project$FeedbackData$FeedbackData = F3(
	function (value, challengeReasonsDict, targetChallengeReasonsDict) {
		return {challengeReasonsDict: challengeReasonsDict, targetChallengeReasonsDict: targetChallengeReasonsDict, value: value};
	});
var $elm_community$string_extra$String$Extra$humanize = function (string) {
	return $elm_community$string_extra$String$Extra$toSentenceCase(
		$elm$core$String$toLower(
			$elm$core$String$trim(
				A3(
					$elm$regex$Regex$replace,
					$elm_community$string_extra$String$Extra$regexFromString('_id$|[-_\\s]+'),
					$elm$core$Basics$always(' '),
					A3(
						$elm$regex$Regex$replace,
						$elm_community$string_extra$String$Extra$regexFromString('[A-Z]+'),
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.match;
							},
							$elm$core$String$append('-')),
						string)))));
};
var $author$project$FeedbackData$cleanChallengeReasonsForIpad = function (apiName) {
	return $elm_community$string_extra$String$Extra$toTitleCase(
		$elm_community$string_extra$String$Extra$humanize(
			A3($elm$core$String$replace, '__c', '', apiName)));
};
var $author$project$StudioString$StudioString = F2(
	function (text, object) {
		return {object: object, text: text};
	});
var $author$project$StudioString$withoutObject = function (text) {
	return A2($author$project$StudioString$StudioString, text, $elm$core$Maybe$Nothing);
};
var $author$project$FeedbackData$acctDecoder = function (fieldName) {
	return A3(
		$elm$json$Json$Decode$map2,
		$elm$core$Tuple$pair,
		A2($elm$json$Json$Decode$field, 'id', $elm$json$Json$Decode$string),
		A2(
			$elm$json$Json$Decode$field,
			fieldName,
			$elm$json$Json$Decode$list(
				A2(
					$elm$json$Json$Decode$map,
					A2($elm$core$Basics$composeL, $elm$core$Maybe$Just, $author$project$StudioString$withoutObject),
					$elm$json$Json$Decode$oneOf(
						_List_fromArray(
							[
								A2($elm$json$Json$Decode$field, 'label', $elm$json$Json$Decode$string),
								A2($elm$json$Json$Decode$map, $author$project$FeedbackData$cleanChallengeReasonsForIpad, $elm$json$Json$Decode$string)
							]))))));
};
var $author$project$FeedbackData$challengeReasonsDecoder = A2(
	$elm$json$Json$Decode$map,
	$elm$core$Dict$fromList,
	A2(
		$elm$json$Json$Decode$field,
		'accountData',
		$elm$json$Json$Decode$list(
			$author$project$FeedbackData$acctDecoder('accountChallengeReasons'))));
var $author$project$FeedbackData$targetChallengeReasonsDecoder = A2(
	$elm$json$Json$Decode$map,
	$elm$core$Dict$fromList,
	A2(
		$elm$json$Json$Decode$field,
		'accountData',
		$elm$json$Json$Decode$list(
			$author$project$FeedbackData$acctDecoder('targetChallengeReasons'))));
var $author$project$FeedbackData$decoder = A4($elm$json$Json$Decode$map3, $author$project$FeedbackData$FeedbackData, $elm$json$Json$Decode$value, $author$project$FeedbackData$challengeReasonsDecoder, $author$project$FeedbackData$targetChallengeReasonsDecoder);
var $author$project$Preview$ToEngineMsg$NewDatepickerSelection = F2(
	function (a, b) {
		return {$: 'NewDatepickerSelection', a: a, b: b};
	});
var $author$project$Preview$ToEngineMsg$NewDropdownSelection = F2(
	function (a, b) {
		return {$: 'NewDropdownSelection', a: a, b: b};
	});
var $author$project$Preview$ToEngineMsg$Request = function (a) {
	return {$: 'Request', a: a};
};
var $author$project$Preview$Request$Data = function (a) {
	return {$: 'Data', a: a};
};
var $author$project$Preview$Request$Page = function (a) {
	return {$: 'Page', a: a};
};
var $author$project$DataElement$Reference$genericReferenceDecoder = A2($elm$json$Json$Decode$map, $author$project$DataElement$Reference$Reference, $danyx23$elm_uuid$Uuid$decoder);
var $author$project$Preview$Request$pickDecoder = function (typeWords) {
	switch (typeWords) {
		case 'Data':
			return A2(
				$elm$json$Json$Decode$map,
				$author$project$Preview$Request$Data,
				A2($elm$json$Json$Decode$field, 'uuid', $author$project$DataElement$Reference$genericReferenceDecoder));
		case 'Page':
			return A2(
				$elm$json$Json$Decode$map,
				$author$project$Preview$Request$Page,
				A2($elm$json$Json$Decode$field, 'pageName', $elm$json$Json$Decode$string));
		default:
			return $elm$json$Json$Decode$fail('Could not decode \'' + (typeWords + '\' as a valid Preview.Request type'));
	}
};
var $author$project$Preview$Request$decoder = A2(
	$elm$json$Json$Decode$andThen,
	$author$project$Preview$Request$pickDecoder,
	A2($elm$json$Json$Decode$field, 'type', $elm$json$Json$Decode$string));
var $author$project$Preview$ToEngineMsg$pickDecoder = function (typeWords) {
	switch (typeWords) {
		case 'Request':
			return A2(
				$elm$json$Json$Decode$map,
				$author$project$Preview$ToEngineMsg$Request,
				A2($elm$json$Json$Decode$field, 'request', $author$project$Preview$Request$decoder));
		case 'NewDropdownSelection':
			return A3(
				$elm$json$Json$Decode$map2,
				$author$project$Preview$ToEngineMsg$NewDropdownSelection,
				A2($elm$json$Json$Decode$field, 'dataElementUuid', $author$project$DataElement$Reference$singletonReferenceDecoder),
				A2($elm$json$Json$Decode$field, 'newSelection', $elm$json$Json$Decode$string));
		case 'NewDatepickerSelection':
			return A3(
				$elm$json$Json$Decode$map2,
				$author$project$Preview$ToEngineMsg$NewDatepickerSelection,
				A2($elm$json$Json$Decode$field, 'dataElementUuid', $author$project$DataElement$Reference$singletonReferenceDecoder),
				A2($elm$json$Json$Decode$field, 'newSelection', $elm$json$Json$Decode$string));
		default:
			return $elm$json$Json$Decode$fail('Could not decode \'' + (typeWords + '\' as a valid ToEngineMsg type'));
	}
};
var $author$project$Preview$ToEngineMsg$decoder = A2(
	$elm$json$Json$Decode$andThen,
	$author$project$Preview$ToEngineMsg$pickDecoder,
	A2($elm$json$Json$Decode$field, 'type', $elm$json$Json$Decode$string));
var $author$project$MyInsights$QueryListener = function (a) {
	return {$: 'QueryListener', a: a};
};
var $elm$core$Result$andThen = F2(
	function (callback, result) {
		if (result.$ === 'Ok') {
			var value = result.a;
			return callback(value);
		} else {
			var msg = result.a;
			return $elm$core$Result$Err(msg);
		}
	});
var $author$project$MyInsights$DecodeError = function (a) {
	return {$: 'DecodeError', a: a};
};
var $author$project$MyInsights$decode = function (decoder) {
	return A2(
		$elm$core$Basics$composeR,
		$elm$json$Json$Decode$decodeValue(decoder),
		$elm$core$Result$mapError($author$project$MyInsights$DecodeError));
};
var $author$project$MyInsights$getCurrentUserLocaleListener = F3(
	function (queryId, localeDecoder, resultToMsg) {
		var decoder = A2(
			$elm$json$Json$Decode$at,
			_List_fromArray(
				['User', 'LocaleSidKey']),
			localeDecoder);
		return $author$project$MyInsights$QueryListener(
			{
				queryId: queryId,
				toMsg: A2(
					$elm$core$Basics$composeR,
					$elm$core$Result$andThen(
						$author$project$MyInsights$decode(decoder)),
					resultToMsg)
			});
	});
var $author$project$MyInsights$getDataForCurrentObjectListener = F5(
	function (queryId, objectName, fieldName, fieldDecoder, resultToMsg) {
		var decoder = A2(
			$elm$json$Json$Decode$at,
			_List_fromArray(
				[objectName, fieldName]),
			fieldDecoder);
		return $author$project$MyInsights$QueryListener(
			{
				queryId: queryId,
				toMsg: A2(
					$elm$core$Basics$composeR,
					$elm$core$Result$andThen(
						$author$project$MyInsights$decode(decoder)),
					resultToMsg)
			});
	});
var $author$project$MyInsights$getFeedbackDataListener = F3(
	function (queryId, feedbackDecoder, resultToMsg) {
		var decoder = A2($elm$json$Json$Decode$field, 'terrData', feedbackDecoder);
		return $author$project$MyInsights$QueryListener(
			{
				queryId: queryId,
				toMsg: A2(
					$elm$core$Basics$composeR,
					$elm$core$Result$andThen(
						$author$project$MyInsights$decode(decoder)),
					resultToMsg)
			});
	});
var $author$project$StudioApp$dataElements = function (_v0) {
	var internals = _v0.a;
	return internals.dataElements;
};
var $author$project$DataEngine$CacheState$Loading = {$: 'Loading'};
var $author$project$DataElement$Reference$getReferenceFromUuid = function (uuid) {
	return $author$project$DataElement$Reference$Reference(uuid);
};
var $elm$core$Dict$values = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, valueList) {
				return A2($elm$core$List$cons, value, valueList);
			}),
		_List_Nil,
		dict);
};
var $author$project$UuidDict$toList = function (_v0) {
	var dict = _v0.a;
	return $elm$core$Dict$values(dict);
};
var $author$project$DataEngine$DataCache$getLoading = function (_v0) {
	var internal = _v0.a;
	return A2(
		$elm$core$List$map,
		$author$project$DataElement$Reference$getReferenceFromUuid,
		A2(
			$elm$core$List$map,
			$elm$core$Tuple$first,
			A2(
				$elm$core$List$filter,
				A2(
					$elm$core$Basics$composeR,
					$elm$core$Tuple$second,
					$elm$core$Basics$eq($author$project$DataEngine$CacheState$Loading)),
				$author$project$UuidDict$toList(internal.dataElementStates))));
};
var $author$project$DataEngine$QueryToRun$QueryToRun = F2(
	function (ref, query) {
		return {query: query, ref: ref};
	});
var $author$project$DataElement$Reference$getUuid = function (_v0) {
	var uuid = _v0.a;
	return uuid;
};
var $author$project$DataElement$Reference$IsRecordList = function (a) {
	return {$: 'IsRecordList', a: a};
};
var $author$project$DataElement$Reference$listFromUuid = function (uuid) {
	return $author$project$DataElement$Reference$IsRecordList(
		$author$project$DataElement$Reference$Reference(uuid));
};
var $author$project$DataElement$Reference$IsSingleton = function (a) {
	return {$: 'IsSingleton', a: a};
};
var $author$project$DataElement$Reference$singletonFromUuid = function (uuid) {
	return $author$project$DataElement$Reference$IsSingleton(
		$author$project$DataElement$Reference$Reference(uuid));
};
var $author$project$DataElement$unwrapElement = function (_v0) {
	var el = _v0.b;
	return el;
};
var $author$project$DataElement$eitherReference = F2(
	function (ref, element) {
		var uuid = $author$project$DataElement$Reference$getUuid(ref);
		var _v0 = $author$project$DataElement$unwrapElement(element);
		if (_v0.$ === 'RecordList') {
			return $author$project$DataElement$Reference$listFromUuid(uuid);
		} else {
			return $author$project$DataElement$Reference$singletonFromUuid(uuid);
		}
	});
var $author$project$UuidDict$get = F2(
	function (uuid, _v0) {
		var dict = _v0.a;
		return A2(
			$elm$core$Maybe$map,
			$elm$core$Tuple$second,
			A2(
				$elm$core$Dict$get,
				$danyx23$elm_uuid$Uuid$toString(uuid),
				dict));
	});
var $author$project$DataElement$getDataElementFromReferenceElement = F2(
	function (_v0, ref) {
		var uuidDict = _v0.a;
		return A2(
			$author$project$UuidDict$get,
			$author$project$DataElement$Reference$getUuid(ref),
			uuidDict);
	});
var $author$project$DataEngine$QueryToRun$AlignedTerritories = function (a) {
	return {$: 'AlignedTerritories', a: a};
};
var $author$project$DataEngine$QueryToRun$CallAttendees = {$: 'CallAttendees'};
var $author$project$DataEngine$QueryToRun$FieldTranslation = function (a) {
	return {$: 'FieldTranslation', a: a};
};
var $author$project$DataEngine$QueryToRun$Now = {$: 'Now'};
var $author$project$DataEngine$QueryToRun$ObjectTranslation = function (a) {
	return {$: 'ObjectTranslation', a: a};
};
var $author$project$DataEngine$QueryToRun$Today = {$: 'Today'};
var $author$project$DataEngine$QueryToRun$VeevaMessages = function (a) {
	return {$: 'VeevaMessages', a: a};
};
var $author$project$DataEngine$QueryToRun$ContextQuery = F4(
	function (a, b, c, d) {
		return {$: 'ContextQuery', a: a, b: b, c: c, d: d};
	});
var $author$project$DataEngine$RecordCache$RecordCache = function (a) {
	return {$: 'RecordCache', a: a};
};
var $author$project$DataEngine$RecordCache$empty = $author$project$DataEngine$RecordCache$RecordCache(
	{bools: $elm$core$Dict$empty, dates: $elm$core$Dict$empty, datetimes: $elm$core$Dict$empty, numbers: $elm$core$Dict$empty, strings: $elm$core$Dict$empty});
var $author$project$FieldValue$BoolValue = function (a) {
	return {$: 'BoolValue', a: a};
};
var $author$project$FieldValue$DateTimeValue = function (a) {
	return {$: 'DateTimeValue', a: a};
};
var $author$project$FieldValue$DateValue = function (a) {
	return {$: 'DateValue', a: a};
};
var $author$project$FieldValue$NumberValue = function (a) {
	return {$: 'NumberValue', a: a};
};
var $author$project$FieldValue$StringValue = function (a) {
	return {$: 'StringValue', a: a};
};
var $elm$core$Basics$clamp = F3(
	function (low, high, number) {
		return (_Utils_cmp(number, low) < 0) ? low : ((_Utils_cmp(number, high) > 0) ? high : number);
	});
var $justinmimbs$date$Date$fromCalendarDate = F3(
	function (y, m, d) {
		return $justinmimbs$date$Date$RD(
			($justinmimbs$date$Date$daysBeforeYear(y) + A2($justinmimbs$date$Date$daysBeforeMonth, y, m)) + A3(
				$elm$core$Basics$clamp,
				1,
				A2($justinmimbs$date$Date$daysInMonth, y, m),
				d));
	});
var $elm$time$Time$flooredDiv = F2(
	function (numerator, denominator) {
		return $elm$core$Basics$floor(numerator / denominator);
	});
var $elm$time$Time$posixToMillis = function (_v0) {
	var millis = _v0.a;
	return millis;
};
var $elm$time$Time$toAdjustedMinutesHelp = F3(
	function (defaultOffset, posixMinutes, eras) {
		toAdjustedMinutesHelp:
		while (true) {
			if (!eras.b) {
				return posixMinutes + defaultOffset;
			} else {
				var era = eras.a;
				var olderEras = eras.b;
				if (_Utils_cmp(era.start, posixMinutes) < 0) {
					return posixMinutes + era.offset;
				} else {
					var $temp$defaultOffset = defaultOffset,
						$temp$posixMinutes = posixMinutes,
						$temp$eras = olderEras;
					defaultOffset = $temp$defaultOffset;
					posixMinutes = $temp$posixMinutes;
					eras = $temp$eras;
					continue toAdjustedMinutesHelp;
				}
			}
		}
	});
var $elm$time$Time$toAdjustedMinutes = F2(
	function (_v0, time) {
		var defaultOffset = _v0.a;
		var eras = _v0.b;
		return A3(
			$elm$time$Time$toAdjustedMinutesHelp,
			defaultOffset,
			A2(
				$elm$time$Time$flooredDiv,
				$elm$time$Time$posixToMillis(time),
				60000),
			eras);
	});
var $elm$time$Time$toCivil = function (minutes) {
	var rawDay = A2($elm$time$Time$flooredDiv, minutes, 60 * 24) + 719468;
	var era = (((rawDay >= 0) ? rawDay : (rawDay - 146096)) / 146097) | 0;
	var dayOfEra = rawDay - (era * 146097);
	var yearOfEra = ((((dayOfEra - ((dayOfEra / 1460) | 0)) + ((dayOfEra / 36524) | 0)) - ((dayOfEra / 146096) | 0)) / 365) | 0;
	var dayOfYear = dayOfEra - (((365 * yearOfEra) + ((yearOfEra / 4) | 0)) - ((yearOfEra / 100) | 0));
	var mp = (((5 * dayOfYear) + 2) / 153) | 0;
	var month = mp + ((mp < 10) ? 3 : (-9));
	var year = yearOfEra + (era * 400);
	return {
		day: (dayOfYear - ((((153 * mp) + 2) / 5) | 0)) + 1,
		month: month,
		year: year + ((month <= 2) ? 1 : 0)
	};
};
var $elm$time$Time$toDay = F2(
	function (zone, time) {
		return $elm$time$Time$toCivil(
			A2($elm$time$Time$toAdjustedMinutes, zone, time)).day;
	});
var $elm$time$Time$toMonth = F2(
	function (zone, time) {
		var _v0 = $elm$time$Time$toCivil(
			A2($elm$time$Time$toAdjustedMinutes, zone, time)).month;
		switch (_v0) {
			case 1:
				return $elm$time$Time$Jan;
			case 2:
				return $elm$time$Time$Feb;
			case 3:
				return $elm$time$Time$Mar;
			case 4:
				return $elm$time$Time$Apr;
			case 5:
				return $elm$time$Time$May;
			case 6:
				return $elm$time$Time$Jun;
			case 7:
				return $elm$time$Time$Jul;
			case 8:
				return $elm$time$Time$Aug;
			case 9:
				return $elm$time$Time$Sep;
			case 10:
				return $elm$time$Time$Oct;
			case 11:
				return $elm$time$Time$Nov;
			default:
				return $elm$time$Time$Dec;
		}
	});
var $elm$time$Time$toYear = F2(
	function (zone, time) {
		return $elm$time$Time$toCivil(
			A2($elm$time$Time$toAdjustedMinutes, zone, time)).year;
	});
var $justinmimbs$date$Date$fromPosix = F2(
	function (zone, posix) {
		return A3(
			$justinmimbs$date$Date$fromCalendarDate,
			A2($elm$time$Time$toYear, zone, posix),
			A2($elm$time$Time$toMonth, zone, posix),
			A2($elm$time$Time$toDay, zone, posix));
	});
var $elm$time$Time$Zone = F2(
	function (a, b) {
		return {$: 'Zone', a: a, b: b};
	});
var $elm$time$Time$utc = A2($elm$time$Time$Zone, 0, _List_Nil);
var $author$project$DataEngine$RecordCache$dateDecoder = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$json$Json$Decode$andThen,
			A2($elm$core$Basics$composeR, $justinmimbs$date$Date$fromIsoString, $elm_community$json_extra$Json$Decode$Extra$fromResult),
			$elm$json$Json$Decode$string),
			A2(
			$elm$json$Json$Decode$map,
			A2(
				$elm$core$Basics$composeR,
				$elm$time$Time$millisToPosix,
				$justinmimbs$date$Date$fromPosix($elm$time$Time$utc)),
			$elm$json$Json$Decode$int)
		]));
var $author$project$MyInsights$Helpers$dateTimeDecoder = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[
			$rtfeldman$elm_iso8601_date_strings$Iso8601$decoder,
			A2(
			$elm$json$Json$Decode$andThen,
			function (text) {
				var _v0 = $rtfeldman$elm_iso8601_date_strings$Iso8601$toTime(
					A3($elm$core$String$replace, ' ', 'T', text));
				if (_v0.$ === 'Ok') {
					var time = _v0.a;
					return $elm$json$Json$Decode$succeed(time);
				} else {
					return $elm$json$Json$Decode$fail('Could not parse \'' + (text + '\' as a date time value.'));
				}
			},
			$elm$json$Json$Decode$string),
			A2($elm$json$Json$Decode$map, $elm$time$Time$millisToPosix, $elm$json$Json$Decode$int)
		]));
var $author$project$MyInsights$Helpers$numberDecoder = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[
			$elm$json$Json$Decode$float,
			A2($elm$json$Json$Decode$map, $elm$core$Basics$toFloat, $elm$json$Json$Decode$int),
			A2(
			$elm$json$Json$Decode$andThen,
			A2(
				$elm$core$Basics$composeR,
				A2($elm$core$String$replace, ',', '.'),
				A2(
					$elm$core$Basics$composeR,
					$elm$core$String$toFloat,
					A2(
						$elm$core$Basics$composeR,
						$elm$core$Result$fromMaybe('Unable to parse text as a number'),
						$elm_community$json_extra$Json$Decode$Extra$fromResult))),
			$elm$json$Json$Decode$string)
		]));
var $author$project$MyInsights$Helpers$stringDecoder = function (objectTag) {
	return A2(
		$elm$json$Json$Decode$map,
		function (words) {
			return A2($author$project$StudioString$StudioString, words, objectTag);
		},
		$elm$json$Json$Decode$string);
};
var $author$project$Preview$Helpers$stringToBoolean = function (words) {
	var _v0 = $elm$core$String$toLower(words);
	switch (_v0) {
		case 'true':
			return $elm$core$Result$Ok(true);
		case 'false':
			return $elm$core$Result$Ok(false);
		default:
			return $elm$core$Result$Err('Could not decode string value as boolean');
	}
};
var $author$project$Preview$Helpers$decoderForFieldType = F2(
	function (fieldType, objectTag) {
		switch (fieldType.$) {
			case 'StringType':
				return A2(
					$elm$json$Json$Decode$map,
					$author$project$FieldValue$StringValue,
					$author$project$MyInsights$Helpers$stringDecoder(objectTag));
			case 'NumberType':
				return A2($elm$json$Json$Decode$map, $author$project$FieldValue$NumberValue, $author$project$MyInsights$Helpers$numberDecoder);
			case 'DateType':
				return A2($elm$json$Json$Decode$map, $author$project$FieldValue$DateValue, $author$project$DataEngine$RecordCache$dateDecoder);
			case 'DateTimeType':
				return A2($elm$json$Json$Decode$map, $author$project$FieldValue$DateTimeValue, $author$project$MyInsights$Helpers$dateTimeDecoder);
			default:
				return A2(
					$elm$json$Json$Decode$map,
					$author$project$FieldValue$BoolValue,
					$elm$json$Json$Decode$oneOf(
						_List_fromArray(
							[
								$elm$json$Json$Decode$bool,
								A2(
								$elm$json$Json$Decode$andThen,
								A2($elm$core$Basics$composeR, $author$project$Preview$Helpers$stringToBoolean, $elm_community$json_extra$Json$Decode$Extra$fromResult),
								$elm$json$Json$Decode$string)
							])));
		}
	});
var $author$project$Preview$Helpers$fieldDecoder = F2(
	function (_v0, objectTag) {
		var fieldType = _v0.fieldType;
		var _default = _v0._default;
		return $elm$json$Json$Decode$oneOf(
			_List_fromArray(
				[
					$elm$json$Json$Decode$maybe(
					A2($author$project$Preview$Helpers$decoderForFieldType, fieldType, objectTag)),
					$elm$json$Json$Decode$null(_default)
				]));
	});
var $author$project$DataEngine$RecordMetadata$RecordMetadata = function (a) {
	return {$: 'RecordMetadata', a: a};
};
var $author$project$DataEngine$RecordMetadata$fromList = function (list) {
	return $author$project$DataEngine$RecordMetadata$RecordMetadata(
		$elm$core$Dict$fromList(
			A2(
				$elm$core$List$map,
				$elm$core$Tuple$mapFirst($author$project$FieldName$toString),
				list)));
};
var $author$project$DataEngine$RecordCache$mapCache = F2(
	function (transform, _v0) {
		var cache = _v0.a;
		return $author$project$DataEngine$RecordCache$RecordCache(
			transform(cache));
	});
var $author$project$DataEngine$RecordCache$insert = F2(
	function (fieldName, fieldValue) {
		switch (fieldValue.$) {
			case 'StringValue':
				var value = fieldValue.a;
				return $author$project$DataEngine$RecordCache$mapCache(
					function (cache) {
						return _Utils_update(
							cache,
							{
								strings: A3(
									$elm$core$Dict$insert,
									$author$project$FieldName$toString(fieldName),
									value,
									cache.strings)
							});
					});
			case 'NumberValue':
				var value = fieldValue.a;
				return $author$project$DataEngine$RecordCache$mapCache(
					function (cache) {
						return _Utils_update(
							cache,
							{
								numbers: A3(
									$elm$core$Dict$insert,
									$author$project$FieldName$toString(fieldName),
									value,
									cache.numbers)
							});
					});
			case 'DateValue':
				var value = fieldValue.a;
				return $author$project$DataEngine$RecordCache$mapCache(
					function (cache) {
						return _Utils_update(
							cache,
							{
								dates: A3(
									$elm$core$Dict$insert,
									$author$project$FieldName$toString(fieldName),
									value,
									cache.dates)
							});
					});
			case 'DateTimeValue':
				var value = fieldValue.a;
				return $author$project$DataEngine$RecordCache$mapCache(
					function (cache) {
						return _Utils_update(
							cache,
							{
								datetimes: A3(
									$elm$core$Dict$insert,
									$author$project$FieldName$toString(fieldName),
									value,
									cache.datetimes)
							});
					});
			default:
				var value = fieldValue.a;
				return $author$project$DataEngine$RecordCache$mapCache(
					function (cache) {
						return _Utils_update(
							cache,
							{
								bools: A3(
									$elm$core$Dict$insert,
									$author$project$FieldName$toString(fieldName),
									value,
									cache.bools)
							});
					});
		}
	});
var $author$project$Preview$Helpers$maybeApply = F2(
	function (fun, maybe) {
		return A2(
			$elm$core$Maybe$withDefault,
			$elm$core$Basics$identity,
			A2($elm$core$Maybe$map, fun, maybe));
	});
var $author$project$DataElement$contextQueryToQueryDetails = function (info) {
	return A4(
		$author$project$DataEngine$QueryToRun$ContextQuery,
		info.objectName,
		info.fieldName,
		$author$project$DataEngine$RecordMetadata$fromList(
			_List_fromArray(
				[
					_Utils_Tuple2(info.fieldName, info.fieldType)
				])),
		A2(
			$elm$json$Json$Decode$map,
			function (maybeValue) {
				return A3(
					$author$project$Preview$Helpers$maybeApply,
					$author$project$DataEngine$RecordCache$insert(info.fieldName),
					maybeValue,
					$author$project$DataEngine$RecordCache$empty);
			},
			A2(
				$author$project$Preview$Helpers$fieldDecoder,
				{_default: $elm$core$Maybe$Nothing, fieldType: info.fieldType},
				info.objectTag)));
};
var $author$project$DataEngine$QueryToRun$CrmDataEngineQuery = F3(
	function (a, b, c) {
		return {$: 'CrmDataEngineQuery', a: a, b: b, c: c};
	});
var $author$project$Preview$Helpers$addFieldWithCustomNameDecoder = F4(
	function (customFieldNames, objectTags, _v0, decoderSoFar) {
		var fieldName = _v0.a;
		var fieldInfo = _v0.b;
		var nameToInsert = A2(
			$elm$core$Maybe$withDefault,
			fieldName,
			A2($pzp1997$assoc_list$AssocList$get, fieldName, customFieldNames));
		return A3(
			$elm$json$Json$Decode$map2,
			$author$project$Preview$Helpers$maybeApply(
				$author$project$DataEngine$RecordCache$insert(nameToInsert)),
			A2(
				$elm$json$Json$Decode$field,
				$author$project$FieldName$toString(fieldName),
				A2(
					$author$project$Preview$Helpers$fieldDecoder,
					fieldInfo,
					A2($pzp1997$assoc_list$AssocList$get, fieldName, objectTags))),
			decoderSoFar);
	});
var $author$project$Preview$Helpers$addFieldDecoder = $author$project$Preview$Helpers$addFieldWithCustomNameDecoder($pzp1997$assoc_list$AssocList$empty);
var $author$project$DataElement$CrmDataEngine$Field$toFieldName = function (field) {
	switch (field.$) {
		case 'PureField':
			var fieldName = field.a;
			return fieldName;
		case 'DimensionField':
			var fieldName = field.a;
			return fieldName;
		default:
			var fieldName = field.a;
			return fieldName;
	}
};
var $author$project$ComparableType$toFieldType = function (comp) {
	switch (comp.$) {
		case 'StringComp':
			return $author$project$FieldType$StringType;
		case 'NumberComp':
			return $author$project$FieldType$NumberType;
		case 'DateComp':
			return $author$project$FieldType$DateType;
		default:
			return $author$project$FieldType$DateTimeType;
	}
};
var $author$project$DataElement$CrmDataEngine$Field$toFieldType = function (field) {
	switch (field.$) {
		case 'PureField':
			var fieldType = field.b;
			return fieldType;
		case 'DimensionField':
			var dimension = field.b;
			switch (dimension.$) {
				case 'Concat':
					return $author$project$FieldType$StringType;
				case 'DateTruncate':
					return $author$project$FieldType$DateType;
				case 'DateTimeTruncate':
					return $author$project$FieldType$DateTimeType;
				case 'Divide':
					return $author$project$FieldType$NumberType;
				case 'Multiply':
					return $author$project$FieldType$NumberType;
				case 'Minus':
					return $author$project$FieldType$NumberType;
				default:
					return $author$project$FieldType$NumberType;
			}
		default:
			var metric = field.b;
			switch (metric.$) {
				case 'Sum':
					return $author$project$FieldType$NumberType;
				case 'Count':
					return $author$project$FieldType$NumberType;
				case 'CountDistinct':
					return $author$project$FieldType$NumberType;
				case 'Max':
					var comparableType = metric.b;
					return $author$project$ComparableType$toFieldType(comparableType);
				default:
					var comparableType = metric.b;
					return $author$project$ComparableType$toFieldType(comparableType);
			}
	}
};
var $author$project$DataElement$CrmDataEngineQuery$fieldToKvPair = function (field) {
	return _Utils_Tuple2(
		$author$project$DataElement$CrmDataEngine$Field$toFieldName(field),
		$author$project$DataElement$CrmDataEngine$Field$toFieldType(field));
};
var $mgold$elm_nonempty_list$List$Nonempty$map = F2(
	function (f, _v0) {
		var x = _v0.a;
		var xs = _v0.b;
		return A2(
			$mgold$elm_nonempty_list$List$Nonempty$Nonempty,
			f(x),
			A2($elm$core$List$map, f, xs));
	});
var $mgold$elm_nonempty_list$List$Nonempty$toList = function (_v0) {
	var x = _v0.a;
	var xs = _v0.b;
	return A2($elm$core$List$cons, x, xs);
};
var $author$project$DataElement$CrmDataEngineQuery$fields = function (info) {
	return $pzp1997$assoc_list$AssocList$fromList(
		$mgold$elm_nonempty_list$List$Nonempty$toList(
			A2($mgold$elm_nonempty_list$List$Nonempty$map, $author$project$DataElement$CrmDataEngineQuery$fieldToKvPair, info.fields)));
};
var $pzp1997$assoc_list$AssocList$map = F2(
	function (alter, _v0) {
		var alist = _v0.a;
		return $pzp1997$assoc_list$AssocList$D(
			A2(
				$elm$core$List$map,
				function (_v1) {
					var key = _v1.a;
					var value = _v1.b;
					return _Utils_Tuple2(
						key,
						A2(alter, key, value));
				},
				alist));
	});
var $pzp1997$assoc_list$AssocList$toList = function (_v0) {
	var alist = _v0.a;
	return alist;
};
var $author$project$DataElement$crmDataEngineQueryDecoder = function (info) {
	return A3(
		$elm$core$List$foldl,
		$author$project$Preview$Helpers$addFieldDecoder($pzp1997$assoc_list$AssocList$empty),
		$elm$json$Json$Decode$succeed($author$project$DataEngine$RecordCache$empty),
		$pzp1997$assoc_list$AssocList$toList(
			A2(
				$pzp1997$assoc_list$AssocList$map,
				F2(
					function (_v0, fieldType) {
						return {_default: $elm$core$Maybe$Nothing, fieldType: fieldType};
					}),
				$author$project$DataElement$CrmDataEngineQuery$fields(info))));
};
var $author$project$MyInsights$CrmDataEngineQuery$AllOf = function (a) {
	return {$: 'AllOf', a: a};
};
var $author$project$MyInsights$CrmDataEngineQuery$AnyOf = function (a) {
	return {$: 'AnyOf', a: a};
};
var $author$project$MyInsights$CrmDataEngineQuery$IsNotNull = function (a) {
	return {$: 'IsNotNull', a: a};
};
var $author$project$MyInsights$CrmDataEngineQuery$IsNull = function (a) {
	return {$: 'IsNull', a: a};
};
var $krisajenkins$remotedata$RemoteData$Success = function (a) {
	return {$: 'Success', a: a};
};
var $krisajenkins$remotedata$RemoteData$Failure = function (a) {
	return {$: 'Failure', a: a};
};
var $krisajenkins$remotedata$RemoteData$Loading = {$: 'Loading'};
var $krisajenkins$remotedata$RemoteData$andMap = F2(
	function (wrappedValue, wrappedFunction) {
		var _v0 = _Utils_Tuple2(wrappedFunction, wrappedValue);
		_v0$2:
		while (true) {
			_v0$3:
			while (true) {
				_v0$4:
				while (true) {
					_v0$5:
					while (true) {
						switch (_v0.a.$) {
							case 'Success':
								switch (_v0.b.$) {
									case 'Success':
										var f = _v0.a.a;
										var value = _v0.b.a;
										return $krisajenkins$remotedata$RemoteData$Success(
											f(value));
									case 'Failure':
										break _v0$2;
									case 'Loading':
										break _v0$4;
									default:
										var _v4 = _v0.b;
										return $krisajenkins$remotedata$RemoteData$NotAsked;
								}
							case 'Failure':
								var error = _v0.a.a;
								return $krisajenkins$remotedata$RemoteData$Failure(error);
							case 'Loading':
								switch (_v0.b.$) {
									case 'Failure':
										break _v0$2;
									case 'Loading':
										break _v0$3;
									case 'NotAsked':
										break _v0$3;
									default:
										break _v0$3;
								}
							default:
								switch (_v0.b.$) {
									case 'Failure':
										break _v0$2;
									case 'Loading':
										break _v0$4;
									case 'NotAsked':
										break _v0$5;
									default:
										break _v0$5;
								}
						}
					}
					var _v3 = _v0.a;
					return $krisajenkins$remotedata$RemoteData$NotAsked;
				}
				var _v2 = _v0.b;
				return $krisajenkins$remotedata$RemoteData$Loading;
			}
			var _v1 = _v0.a;
			return $krisajenkins$remotedata$RemoteData$Loading;
		}
		var error = _v0.b.a;
		return $krisajenkins$remotedata$RemoteData$Failure(error);
	});
var $krisajenkins$remotedata$RemoteData$map = F2(
	function (f, data) {
		switch (data.$) {
			case 'Success':
				var value = data.a;
				return $krisajenkins$remotedata$RemoteData$Success(
					f(value));
			case 'Loading':
				return $krisajenkins$remotedata$RemoteData$Loading;
			case 'NotAsked':
				return $krisajenkins$remotedata$RemoteData$NotAsked;
			default:
				var error = data.a;
				return $krisajenkins$remotedata$RemoteData$Failure(error);
		}
	});
var $krisajenkins$remotedata$RemoteData$map2 = F3(
	function (f, a, b) {
		return A2(
			$krisajenkins$remotedata$RemoteData$andMap,
			b,
			A2($krisajenkins$remotedata$RemoteData$map, f, a));
	});
var $author$project$RemoteData$Helpers$combine = A2(
	$elm$core$List$foldr,
	$krisajenkins$remotedata$RemoteData$map2($elm$core$List$cons),
	$krisajenkins$remotedata$RemoteData$Success(_List_Nil));
var $author$project$MyInsights$CrmDataEngineQuery$BetweenDate = F3(
	function (a, b, c) {
		return {$: 'BetweenDate', a: a, b: b, c: c};
	});
var $author$project$MyInsights$CrmDataEngineQuery$Unmatchable = function (a) {
	return {$: 'Unmatchable', a: a};
};
var $author$project$MyInsights$CrmDataEngineQuery$betweenDate = F3(
	function (fieldName, start, end) {
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$MyInsights$CrmDataEngineQuery$Unmatchable(fieldName),
			A3(
				$elm$core$Maybe$map2,
				$author$project$MyInsights$CrmDataEngineQuery$BetweenDate(fieldName),
				start,
				end));
	});
var $author$project$DataElement$crmDataEnginePlaceholderClause = function (fieldName) {
	return $author$project$MyInsights$CrmDataEngineQuery$Unmatchable(
		$author$project$FieldName$toString(fieldName));
};
var $author$project$DataElement$crmDataEngineWhereDateBetweenHelper = F3(
	function (fieldName, startDate, endDate) {
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$DataElement$crmDataEnginePlaceholderClause(fieldName),
			A3(
				$elm$core$Maybe$map2,
				$author$project$MyInsights$CrmDataEngineQuery$betweenDate(
					$author$project$FieldName$toString(fieldName)),
				$elm$core$Maybe$Just(startDate),
				$elm$core$Maybe$Just(endDate)));
	});
var $author$project$MyInsights$CrmDataEngineQuery$BetweenDateTime = F3(
	function (a, b, c) {
		return {$: 'BetweenDateTime', a: a, b: b, c: c};
	});
var $author$project$MyInsights$CrmDataEngineQuery$betweenDateTime = F3(
	function (fieldName, start, end) {
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$MyInsights$CrmDataEngineQuery$Unmatchable(fieldName),
			A3(
				$elm$core$Maybe$map2,
				$author$project$MyInsights$CrmDataEngineQuery$BetweenDateTime(fieldName),
				start,
				end));
	});
var $author$project$DataElement$crmDataEngineWhereDateTimeBetweenHelper = F3(
	function (fieldName, startDateTime, endDateTime) {
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$DataElement$crmDataEnginePlaceholderClause(fieldName),
			A3(
				$elm$core$Maybe$map2,
				$author$project$MyInsights$CrmDataEngineQuery$betweenDateTime(
					$author$project$FieldName$toString(fieldName)),
				$elm$core$Maybe$Just(startDateTime),
				$elm$core$Maybe$Just(endDateTime)));
	});
var $author$project$MyInsights$CrmDataEngineQuery$DateEq = F2(
	function (a, b) {
		return {$: 'DateEq', a: a, b: b};
	});
var $author$project$MyInsights$CrmDataEngineQuery$dateEq = F2(
	function (fieldName, dateValue) {
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$MyInsights$CrmDataEngineQuery$Unmatchable(fieldName),
			A2(
				$elm$core$Maybe$map,
				$author$project$MyInsights$CrmDataEngineQuery$DateEq(fieldName),
				dateValue));
	});
var $author$project$MyInsights$CrmDataEngineQuery$DateTimeEq = F2(
	function (a, b) {
		return {$: 'DateTimeEq', a: a, b: b};
	});
var $author$project$MyInsights$CrmDataEngineQuery$dateTimeEq = F2(
	function (fieldName, dateTimeValue) {
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$MyInsights$CrmDataEngineQuery$Unmatchable(fieldName),
			A2(
				$elm$core$Maybe$map,
				$author$project$MyInsights$CrmDataEngineQuery$DateTimeEq(fieldName),
				dateTimeValue));
	});
var $author$project$MyInsights$CrmDataEngineQuery$NumberEq = F2(
	function (a, b) {
		return {$: 'NumberEq', a: a, b: b};
	});
var $author$project$MyInsights$CrmDataEngineQuery$numberEq = F2(
	function (fieldName, numberValue) {
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$MyInsights$CrmDataEngineQuery$Unmatchable(fieldName),
			A2(
				$elm$core$Maybe$map,
				$author$project$MyInsights$CrmDataEngineQuery$NumberEq(fieldName),
				numberValue));
	});
var $author$project$MyInsights$CrmDataEngineQuery$StringEq = F2(
	function (a, b) {
		return {$: 'StringEq', a: a, b: b};
	});
var $elm_community$maybe_extra$Maybe$Extra$unwrap = F3(
	function (_default, f, m) {
		if (m.$ === 'Nothing') {
			return _default;
		} else {
			var a = m.a;
			return f(a);
		}
	});
var $author$project$MyInsights$CrmDataEngineQuery$stringEq = F2(
	function (fieldName, stringValue) {
		return A2(
			$author$project$MyInsights$CrmDataEngineQuery$StringEq,
			fieldName,
			A3(
				$elm_community$maybe_extra$Maybe$Extra$unwrap,
				'',
				function ($) {
					return $.text;
				},
				stringValue));
	});
var $author$project$DataElement$crmDataEngineWhereEqualsHelper = F2(
	function (fieldName, maybeValue) {
		if (maybeValue.$ === 'Just') {
			switch (maybeValue.a.$) {
				case 'StringValue':
					var words = maybeValue.a.a;
					return A2(
						$author$project$MyInsights$CrmDataEngineQuery$stringEq,
						$author$project$FieldName$toString(fieldName),
						$elm$core$Maybe$Just(words));
				case 'NumberValue':
					var _float = maybeValue.a.a;
					return A2(
						$author$project$MyInsights$CrmDataEngineQuery$numberEq,
						$author$project$FieldName$toString(fieldName),
						$elm$core$Maybe$Just(_float));
				case 'DateValue':
					var date = maybeValue.a.a;
					return A2(
						$author$project$MyInsights$CrmDataEngineQuery$dateEq,
						$author$project$FieldName$toString(fieldName),
						$elm$core$Maybe$Just(date));
				case 'DateTimeValue':
					var datetime = maybeValue.a.a;
					return A2(
						$author$project$MyInsights$CrmDataEngineQuery$dateTimeEq,
						$author$project$FieldName$toString(fieldName),
						$elm$core$Maybe$Just(datetime));
				default:
					return $author$project$DataElement$crmDataEnginePlaceholderClause(fieldName);
			}
		} else {
			return $author$project$MyInsights$CrmDataEngineQuery$IsNull(
				$author$project$FieldName$toString(fieldName));
		}
	});
var $author$project$MyInsights$CrmDataEngineQuery$DateGt = F2(
	function (a, b) {
		return {$: 'DateGt', a: a, b: b};
	});
var $author$project$MyInsights$CrmDataEngineQuery$dateGt = F2(
	function (fieldName, dateValue) {
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$MyInsights$CrmDataEngineQuery$Unmatchable(fieldName),
			A2(
				$elm$core$Maybe$map,
				$author$project$MyInsights$CrmDataEngineQuery$DateGt(fieldName),
				dateValue));
	});
var $author$project$MyInsights$CrmDataEngineQuery$DateTimeGt = F2(
	function (a, b) {
		return {$: 'DateTimeGt', a: a, b: b};
	});
var $author$project$MyInsights$CrmDataEngineQuery$dateTimeGt = F2(
	function (fieldName, dateTimeValue) {
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$MyInsights$CrmDataEngineQuery$Unmatchable(fieldName),
			A2(
				$elm$core$Maybe$map,
				$author$project$MyInsights$CrmDataEngineQuery$DateTimeGt(fieldName),
				dateTimeValue));
	});
var $author$project$MyInsights$CrmDataEngineQuery$NumberGt = F2(
	function (a, b) {
		return {$: 'NumberGt', a: a, b: b};
	});
var $author$project$MyInsights$CrmDataEngineQuery$numberGt = F2(
	function (fieldName, numberValue) {
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$MyInsights$CrmDataEngineQuery$Unmatchable(fieldName),
			A2(
				$elm$core$Maybe$map,
				$author$project$MyInsights$CrmDataEngineQuery$NumberGt(fieldName),
				numberValue));
	});
var $author$project$MyInsights$CrmDataEngineQuery$StringGt = F2(
	function (a, b) {
		return {$: 'StringGt', a: a, b: b};
	});
var $author$project$MyInsights$CrmDataEngineQuery$stringGt = F2(
	function (fieldName, stringValue) {
		return A2(
			$author$project$MyInsights$CrmDataEngineQuery$StringGt,
			fieldName,
			A3(
				$elm_community$maybe_extra$Maybe$Extra$unwrap,
				'',
				function ($) {
					return $.text;
				},
				stringValue));
	});
var $author$project$DataElement$crmDataEngineWhereGtHelper = F2(
	function (fieldName, maybeValue) {
		if (maybeValue.$ === 'Just') {
			switch (maybeValue.a.$) {
				case 'StringValue':
					var words = maybeValue.a.a;
					return A2(
						$author$project$MyInsights$CrmDataEngineQuery$stringGt,
						$author$project$FieldName$toString(fieldName),
						$elm$core$Maybe$Just(words));
				case 'NumberValue':
					var _float = maybeValue.a.a;
					return A2(
						$author$project$MyInsights$CrmDataEngineQuery$numberGt,
						$author$project$FieldName$toString(fieldName),
						$elm$core$Maybe$Just(_float));
				case 'DateValue':
					var date = maybeValue.a.a;
					return A2(
						$author$project$MyInsights$CrmDataEngineQuery$dateGt,
						$author$project$FieldName$toString(fieldName),
						$elm$core$Maybe$Just(date));
				case 'DateTimeValue':
					var datetime = maybeValue.a.a;
					return A2(
						$author$project$MyInsights$CrmDataEngineQuery$dateTimeGt,
						$author$project$FieldName$toString(fieldName),
						$elm$core$Maybe$Just(datetime));
				default:
					return $author$project$DataElement$crmDataEnginePlaceholderClause(fieldName);
			}
		} else {
			return $author$project$DataElement$crmDataEnginePlaceholderClause(fieldName);
		}
	});
var $author$project$MyInsights$CrmDataEngineQuery$DateGte = F2(
	function (a, b) {
		return {$: 'DateGte', a: a, b: b};
	});
var $author$project$MyInsights$CrmDataEngineQuery$dateGte = F2(
	function (fieldName, dateValue) {
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$MyInsights$CrmDataEngineQuery$Unmatchable(fieldName),
			A2(
				$elm$core$Maybe$map,
				$author$project$MyInsights$CrmDataEngineQuery$DateGte(fieldName),
				dateValue));
	});
var $author$project$MyInsights$CrmDataEngineQuery$DateTimeGte = F2(
	function (a, b) {
		return {$: 'DateTimeGte', a: a, b: b};
	});
var $author$project$MyInsights$CrmDataEngineQuery$dateTimeGte = F2(
	function (fieldName, dateTimeValue) {
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$MyInsights$CrmDataEngineQuery$Unmatchable(fieldName),
			A2(
				$elm$core$Maybe$map,
				$author$project$MyInsights$CrmDataEngineQuery$DateTimeGte(fieldName),
				dateTimeValue));
	});
var $author$project$MyInsights$CrmDataEngineQuery$NumberGte = F2(
	function (a, b) {
		return {$: 'NumberGte', a: a, b: b};
	});
var $author$project$MyInsights$CrmDataEngineQuery$numberGte = F2(
	function (fieldName, numberValue) {
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$MyInsights$CrmDataEngineQuery$Unmatchable(fieldName),
			A2(
				$elm$core$Maybe$map,
				$author$project$MyInsights$CrmDataEngineQuery$NumberGte(fieldName),
				numberValue));
	});
var $author$project$MyInsights$CrmDataEngineQuery$StringGte = F2(
	function (a, b) {
		return {$: 'StringGte', a: a, b: b};
	});
var $author$project$MyInsights$CrmDataEngineQuery$stringGte = F2(
	function (fieldName, stringValue) {
		return A2(
			$author$project$MyInsights$CrmDataEngineQuery$StringGte,
			fieldName,
			A3(
				$elm_community$maybe_extra$Maybe$Extra$unwrap,
				'',
				function ($) {
					return $.text;
				},
				stringValue));
	});
var $author$project$DataElement$crmDataEngineWhereGteHelper = F2(
	function (fieldName, maybeValue) {
		if (maybeValue.$ === 'Just') {
			switch (maybeValue.a.$) {
				case 'StringValue':
					var words = maybeValue.a.a;
					return A2(
						$author$project$MyInsights$CrmDataEngineQuery$stringGte,
						$author$project$FieldName$toString(fieldName),
						$elm$core$Maybe$Just(words));
				case 'NumberValue':
					var _float = maybeValue.a.a;
					return A2(
						$author$project$MyInsights$CrmDataEngineQuery$numberGte,
						$author$project$FieldName$toString(fieldName),
						$elm$core$Maybe$Just(_float));
				case 'DateValue':
					var date = maybeValue.a.a;
					return A2(
						$author$project$MyInsights$CrmDataEngineQuery$dateGte,
						$author$project$FieldName$toString(fieldName),
						$elm$core$Maybe$Just(date));
				case 'DateTimeValue':
					var datetime = maybeValue.a.a;
					return A2(
						$author$project$MyInsights$CrmDataEngineQuery$dateTimeGte,
						$author$project$FieldName$toString(fieldName),
						$elm$core$Maybe$Just(datetime));
				default:
					return $author$project$DataElement$crmDataEnginePlaceholderClause(fieldName);
			}
		} else {
			return $author$project$DataElement$crmDataEnginePlaceholderClause(fieldName);
		}
	});
var $author$project$MyInsights$CrmDataEngineQuery$In = F2(
	function (a, b) {
		return {$: 'In', a: a, b: b};
	});
var $elm_community$maybe_extra$Maybe$Extra$cons = F2(
	function (item, list) {
		if (item.$ === 'Just') {
			var v = item.a;
			return A2($elm$core$List$cons, v, list);
		} else {
			return list;
		}
	});
var $elm_community$maybe_extra$Maybe$Extra$values = A2($elm$core$List$foldr, $elm_community$maybe_extra$Maybe$Extra$cons, _List_Nil);
var $author$project$MyInsights$CrmDataEngineQuery$stringIn = F2(
	function (fieldName, words) {
		return A2(
			$author$project$MyInsights$CrmDataEngineQuery$In,
			fieldName,
			A2(
				$elm$core$List$map,
				function ($) {
					return $.text;
				},
				$elm_community$maybe_extra$Maybe$Extra$values(words)));
	});
var $author$project$DataElement$crmDataEngineWhereInHelper = F2(
	function (fieldName, words) {
		return A2(
			$author$project$MyInsights$CrmDataEngineQuery$stringIn,
			$author$project$FieldName$toString(fieldName),
			words);
	});
var $author$project$MyInsights$CrmDataEngineQuery$DateLt = F2(
	function (a, b) {
		return {$: 'DateLt', a: a, b: b};
	});
var $author$project$MyInsights$CrmDataEngineQuery$dateLt = F2(
	function (fieldName, dateValue) {
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$MyInsights$CrmDataEngineQuery$Unmatchable(fieldName),
			A2(
				$elm$core$Maybe$map,
				$author$project$MyInsights$CrmDataEngineQuery$DateLt(fieldName),
				dateValue));
	});
var $author$project$MyInsights$CrmDataEngineQuery$DateTimeLt = F2(
	function (a, b) {
		return {$: 'DateTimeLt', a: a, b: b};
	});
var $author$project$MyInsights$CrmDataEngineQuery$dateTimeLt = F2(
	function (fieldName, dateTimeValue) {
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$MyInsights$CrmDataEngineQuery$Unmatchable(fieldName),
			A2(
				$elm$core$Maybe$map,
				$author$project$MyInsights$CrmDataEngineQuery$DateTimeLt(fieldName),
				dateTimeValue));
	});
var $author$project$MyInsights$CrmDataEngineQuery$NumberLt = F2(
	function (a, b) {
		return {$: 'NumberLt', a: a, b: b};
	});
var $author$project$MyInsights$CrmDataEngineQuery$numberLt = F2(
	function (fieldName, numberValue) {
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$MyInsights$CrmDataEngineQuery$Unmatchable(fieldName),
			A2(
				$elm$core$Maybe$map,
				$author$project$MyInsights$CrmDataEngineQuery$NumberLt(fieldName),
				numberValue));
	});
var $author$project$MyInsights$CrmDataEngineQuery$StringLt = F2(
	function (a, b) {
		return {$: 'StringLt', a: a, b: b};
	});
var $author$project$MyInsights$CrmDataEngineQuery$stringLt = F2(
	function (fieldName, stringValue) {
		return A2(
			$author$project$MyInsights$CrmDataEngineQuery$StringLt,
			fieldName,
			A3(
				$elm_community$maybe_extra$Maybe$Extra$unwrap,
				'',
				function ($) {
					return $.text;
				},
				stringValue));
	});
var $author$project$DataElement$crmDataEngineWhereLtHelper = F2(
	function (fieldName, maybeValue) {
		if (maybeValue.$ === 'Just') {
			switch (maybeValue.a.$) {
				case 'StringValue':
					var words = maybeValue.a.a;
					return A2(
						$author$project$MyInsights$CrmDataEngineQuery$stringLt,
						$author$project$FieldName$toString(fieldName),
						$elm$core$Maybe$Just(words));
				case 'NumberValue':
					var _float = maybeValue.a.a;
					return A2(
						$author$project$MyInsights$CrmDataEngineQuery$numberLt,
						$author$project$FieldName$toString(fieldName),
						$elm$core$Maybe$Just(_float));
				case 'DateValue':
					var date = maybeValue.a.a;
					return A2(
						$author$project$MyInsights$CrmDataEngineQuery$dateLt,
						$author$project$FieldName$toString(fieldName),
						$elm$core$Maybe$Just(date));
				case 'DateTimeValue':
					var datetime = maybeValue.a.a;
					return A2(
						$author$project$MyInsights$CrmDataEngineQuery$dateTimeLt,
						$author$project$FieldName$toString(fieldName),
						$elm$core$Maybe$Just(datetime));
				default:
					return $author$project$DataElement$crmDataEnginePlaceholderClause(fieldName);
			}
		} else {
			return $author$project$DataElement$crmDataEnginePlaceholderClause(fieldName);
		}
	});
var $author$project$MyInsights$CrmDataEngineQuery$DateLte = F2(
	function (a, b) {
		return {$: 'DateLte', a: a, b: b};
	});
var $author$project$MyInsights$CrmDataEngineQuery$dateLte = F2(
	function (fieldName, dateValue) {
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$MyInsights$CrmDataEngineQuery$Unmatchable(fieldName),
			A2(
				$elm$core$Maybe$map,
				$author$project$MyInsights$CrmDataEngineQuery$DateLte(fieldName),
				dateValue));
	});
var $author$project$MyInsights$CrmDataEngineQuery$DateTimeLte = F2(
	function (a, b) {
		return {$: 'DateTimeLte', a: a, b: b};
	});
var $author$project$MyInsights$CrmDataEngineQuery$dateTimeLte = F2(
	function (fieldName, dateTimeValue) {
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$MyInsights$CrmDataEngineQuery$Unmatchable(fieldName),
			A2(
				$elm$core$Maybe$map,
				$author$project$MyInsights$CrmDataEngineQuery$DateTimeLte(fieldName),
				dateTimeValue));
	});
var $author$project$MyInsights$CrmDataEngineQuery$NumberLte = F2(
	function (a, b) {
		return {$: 'NumberLte', a: a, b: b};
	});
var $author$project$MyInsights$CrmDataEngineQuery$numberLte = F2(
	function (fieldName, numberValue) {
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$MyInsights$CrmDataEngineQuery$Unmatchable(fieldName),
			A2(
				$elm$core$Maybe$map,
				$author$project$MyInsights$CrmDataEngineQuery$NumberLte(fieldName),
				numberValue));
	});
var $author$project$MyInsights$CrmDataEngineQuery$StringLte = F2(
	function (a, b) {
		return {$: 'StringLte', a: a, b: b};
	});
var $author$project$MyInsights$CrmDataEngineQuery$stringLte = F2(
	function (fieldName, stringValue) {
		return A2(
			$author$project$MyInsights$CrmDataEngineQuery$StringLte,
			fieldName,
			A3(
				$elm_community$maybe_extra$Maybe$Extra$unwrap,
				'',
				function ($) {
					return $.text;
				},
				stringValue));
	});
var $author$project$DataElement$crmDataEngineWhereLteHelper = F2(
	function (fieldName, maybeValue) {
		if (maybeValue.$ === 'Just') {
			switch (maybeValue.a.$) {
				case 'StringValue':
					var words = maybeValue.a.a;
					return A2(
						$author$project$MyInsights$CrmDataEngineQuery$stringLte,
						$author$project$FieldName$toString(fieldName),
						$elm$core$Maybe$Just(words));
				case 'NumberValue':
					var _float = maybeValue.a.a;
					return A2(
						$author$project$MyInsights$CrmDataEngineQuery$numberLte,
						$author$project$FieldName$toString(fieldName),
						$elm$core$Maybe$Just(_float));
				case 'DateValue':
					var date = maybeValue.a.a;
					return A2(
						$author$project$MyInsights$CrmDataEngineQuery$dateLte,
						$author$project$FieldName$toString(fieldName),
						$elm$core$Maybe$Just(date));
				case 'DateTimeValue':
					var datetime = maybeValue.a.a;
					return A2(
						$author$project$MyInsights$CrmDataEngineQuery$dateTimeLte,
						$author$project$FieldName$toString(fieldName),
						$elm$core$Maybe$Just(datetime));
				default:
					return $author$project$DataElement$crmDataEnginePlaceholderClause(fieldName);
			}
		} else {
			return $author$project$DataElement$crmDataEnginePlaceholderClause(fieldName);
		}
	});
var $author$project$MyInsights$CrmDataEngineQuery$DateNotEq = F2(
	function (a, b) {
		return {$: 'DateNotEq', a: a, b: b};
	});
var $author$project$MyInsights$CrmDataEngineQuery$dateNotEq = F2(
	function (fieldName, dateValue) {
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$MyInsights$CrmDataEngineQuery$Unmatchable(fieldName),
			A2(
				$elm$core$Maybe$map,
				$author$project$MyInsights$CrmDataEngineQuery$DateNotEq(fieldName),
				dateValue));
	});
var $author$project$MyInsights$CrmDataEngineQuery$DateTimeNotEq = F2(
	function (a, b) {
		return {$: 'DateTimeNotEq', a: a, b: b};
	});
var $author$project$MyInsights$CrmDataEngineQuery$dateTimeNotEq = F2(
	function (fieldName, dateTimeValue) {
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$MyInsights$CrmDataEngineQuery$Unmatchable(fieldName),
			A2(
				$elm$core$Maybe$map,
				$author$project$MyInsights$CrmDataEngineQuery$DateTimeNotEq(fieldName),
				dateTimeValue));
	});
var $author$project$MyInsights$CrmDataEngineQuery$NumberNotEq = F2(
	function (a, b) {
		return {$: 'NumberNotEq', a: a, b: b};
	});
var $author$project$MyInsights$CrmDataEngineQuery$numberNotEq = F2(
	function (fieldName, numberValue) {
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$MyInsights$CrmDataEngineQuery$Unmatchable(fieldName),
			A2(
				$elm$core$Maybe$map,
				$author$project$MyInsights$CrmDataEngineQuery$NumberNotEq(fieldName),
				numberValue));
	});
var $author$project$MyInsights$CrmDataEngineQuery$StringNotEq = F2(
	function (a, b) {
		return {$: 'StringNotEq', a: a, b: b};
	});
var $author$project$MyInsights$CrmDataEngineQuery$stringNotEq = F2(
	function (fieldName, stringValue) {
		return A2(
			$author$project$MyInsights$CrmDataEngineQuery$StringNotEq,
			fieldName,
			A3(
				$elm_community$maybe_extra$Maybe$Extra$unwrap,
				'',
				function ($) {
					return $.text;
				},
				stringValue));
	});
var $author$project$DataElement$crmDataEngineWhereNotEqualsHelper = F2(
	function (fieldName, maybeValue) {
		if (maybeValue.$ === 'Just') {
			switch (maybeValue.a.$) {
				case 'StringValue':
					var words = maybeValue.a.a;
					return A2(
						$author$project$MyInsights$CrmDataEngineQuery$stringNotEq,
						$author$project$FieldName$toString(fieldName),
						$elm$core$Maybe$Just(words));
				case 'NumberValue':
					var _float = maybeValue.a.a;
					return A2(
						$author$project$MyInsights$CrmDataEngineQuery$numberNotEq,
						$author$project$FieldName$toString(fieldName),
						$elm$core$Maybe$Just(_float));
				case 'DateValue':
					var date = maybeValue.a.a;
					return A2(
						$author$project$MyInsights$CrmDataEngineQuery$dateNotEq,
						$author$project$FieldName$toString(fieldName),
						$elm$core$Maybe$Just(date));
				case 'DateTimeValue':
					var datetime = maybeValue.a.a;
					return A2(
						$author$project$MyInsights$CrmDataEngineQuery$dateTimeNotEq,
						$author$project$FieldName$toString(fieldName),
						$elm$core$Maybe$Just(datetime));
				default:
					return $author$project$DataElement$crmDataEnginePlaceholderClause(fieldName);
			}
		} else {
			return $author$project$MyInsights$CrmDataEngineQuery$IsNotNull(
				$author$project$FieldName$toString(fieldName));
		}
	});
var $author$project$MyInsights$CrmDataEngineQuery$BetweenNumber = F3(
	function (a, b, c) {
		return {$: 'BetweenNumber', a: a, b: b, c: c};
	});
var $author$project$MyInsights$CrmDataEngineQuery$betweenNumber = F3(
	function (fieldName, start, end) {
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$MyInsights$CrmDataEngineQuery$Unmatchable(fieldName),
			A3(
				$elm$core$Maybe$map2,
				$author$project$MyInsights$CrmDataEngineQuery$BetweenNumber(fieldName),
				start,
				end));
	});
var $author$project$DataElement$crmDataEngineWhereNumberBetweenHelper = F3(
	function (fieldName, maybeValue, maybeValueB) {
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$DataElement$crmDataEnginePlaceholderClause(fieldName),
			A3(
				$elm$core$Maybe$map2,
				$author$project$MyInsights$CrmDataEngineQuery$betweenNumber(
					$author$project$FieldName$toString(fieldName)),
				$elm$core$Maybe$Just(maybeValue),
				$elm$core$Maybe$Just(maybeValueB)));
	});
var $author$project$MyInsights$CrmDataEngineQuery$BetweenString = F3(
	function (a, b, c) {
		return {$: 'BetweenString', a: a, b: b, c: c};
	});
var $author$project$MyInsights$CrmDataEngineQuery$betweenString = F3(
	function (fieldName, start, end) {
		return A3(
			$author$project$MyInsights$CrmDataEngineQuery$BetweenString,
			fieldName,
			A3(
				$elm_community$maybe_extra$Maybe$Extra$unwrap,
				'',
				function ($) {
					return $.text;
				},
				start),
			A3(
				$elm_community$maybe_extra$Maybe$Extra$unwrap,
				'',
				function ($) {
					return $.text;
				},
				end));
	});
var $author$project$DataElement$crmDataEngineWhereStringBetweenHelper = F3(
	function (fieldName, maybeValue, maybeValueB) {
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$DataElement$crmDataEnginePlaceholderClause(fieldName),
			A3(
				$elm$core$Maybe$map2,
				$author$project$MyInsights$CrmDataEngineQuery$betweenString(
					$author$project$FieldName$toString(fieldName)),
				$elm$core$Maybe$Just(maybeValue),
				$elm$core$Maybe$Just(maybeValueB)));
	});
var $author$project$Calc$add = $elm$core$Maybe$map2($elm$core$Basics$add);
var $author$project$Calc$all = A2(
	$elm$core$Basics$composeR,
	$elm$core$List$all(
		$elm$core$Maybe$withDefault(false)),
	$elm$core$Maybe$Just);
var $author$project$Calc$any = A2(
	$elm$core$Basics$composeR,
	$elm$core$List$any(
		$elm$core$Maybe$withDefault(false)),
	$elm$core$Maybe$Just);
var $author$project$Calc$challengeReasons = F2(
	function (feedbackData, maybeAcctId) {
		if (maybeAcctId.$ === 'Just') {
			var acctId = maybeAcctId.a;
			return A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2($elm$core$Dict$get, acctId.text, feedbackData.challengeReasonsDict));
		} else {
			return _List_Nil;
		}
	});
var $author$project$Calc$comparableEqual = function (compareFun) {
	return $elm$core$Maybe$map2(
		F2(
			function (a, b) {
				return _Utils_eq(
					A2(compareFun, a, b),
					$elm$core$Basics$EQ);
			}));
};
var $author$project$Calc$comparableNotEqual = function (compareFun) {
	return $elm$core$Maybe$map2(
		F2(
			function (a, b) {
				return !_Utils_eq(
					A2(compareFun, a, b),
					$elm$core$Basics$EQ);
			}));
};
var $justinmimbs$date$Date$compare = F2(
	function (_v0, _v1) {
		var a = _v0.a;
		var b = _v1.a;
		return A2($elm$core$Basics$compare, a, b);
	});
var $NoRedInk$elm_compare$Compare$by = F3(
	function (fn, a, b) {
		return A2(
			$elm$core$Basics$compare,
			fn(a),
			fn(b));
	});
var $author$project$StudioString$compare = $NoRedInk$elm_compare$Compare$by(
	function ($) {
		return $.text;
	});
var $author$project$Calc$compareDateTime = F2(
	function (a, b) {
		return A2(
			$elm$core$Basics$compare,
			$elm$time$Time$posixToMillis(a),
			$elm$time$Time$posixToMillis(b));
	});
var $author$project$Calc$concat = F2(
	function (maybeJoin, listOfMaybes) {
		return $elm$core$Maybe$Just(
			$author$project$StudioString$withoutObject(
				A2(
					$elm$core$String$join,
					A2(
						$elm$core$Maybe$withDefault,
						'',
						A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.text;
							},
							maybeJoin)),
					A2(
						$elm$core$List$map,
						function ($) {
							return $.text;
						},
						A2($elm$core$List$filterMap, $elm$core$Basics$identity, listOfMaybes)))));
	});
var $elm$core$Dict$sizeHelp = F2(
	function (n, dict) {
		sizeHelp:
		while (true) {
			if (dict.$ === 'RBEmpty_elm_builtin') {
				return n;
			} else {
				var left = dict.d;
				var right = dict.e;
				var $temp$n = A2($elm$core$Dict$sizeHelp, n + 1, right),
					$temp$dict = left;
				n = $temp$n;
				dict = $temp$dict;
				continue sizeHelp;
			}
		}
	});
var $elm$core$Dict$size = function (dict) {
	return A2($elm$core$Dict$sizeHelp, 0, dict);
};
var $elm$core$Set$size = function (_v0) {
	var dict = _v0.a;
	return $elm$core$Dict$size(dict);
};
var $author$project$Calc$countUnique = F2(
	function (toComparable, items) {
		return $elm$core$Maybe$Just(
			$elm$core$Set$size(
				$elm$core$Set$fromList(
					A2(
						$elm$core$List$filterMap,
						$elm$core$Maybe$map(toComparable),
						items))));
	});
var $justinmimbs$date$Date$monthToNumber = function (m) {
	switch (m.$) {
		case 'Jan':
			return 1;
		case 'Feb':
			return 2;
		case 'Mar':
			return 3;
		case 'Apr':
			return 4;
		case 'May':
			return 5;
		case 'Jun':
			return 6;
		case 'Jul':
			return 7;
		case 'Aug':
			return 8;
		case 'Sep':
			return 9;
		case 'Oct':
			return 10;
		case 'Nov':
			return 11;
		default:
			return 12;
	}
};
var $justinmimbs$date$Date$toCalendarDateHelp = F3(
	function (y, m, d) {
		toCalendarDateHelp:
		while (true) {
			var monthDays = A2($justinmimbs$date$Date$daysInMonth, y, m);
			var mn = $justinmimbs$date$Date$monthToNumber(m);
			if ((mn < 12) && (_Utils_cmp(d, monthDays) > 0)) {
				var $temp$y = y,
					$temp$m = $justinmimbs$date$Date$numberToMonth(mn + 1),
					$temp$d = d - monthDays;
				y = $temp$y;
				m = $temp$m;
				d = $temp$d;
				continue toCalendarDateHelp;
			} else {
				return {day: d, month: m, year: y};
			}
		}
	});
var $justinmimbs$date$Date$divWithRemainder = F2(
	function (a, b) {
		return _Utils_Tuple2(
			A2($justinmimbs$date$Date$floorDiv, a, b),
			A2($elm$core$Basics$modBy, b, a));
	});
var $justinmimbs$date$Date$year = function (_v0) {
	var rd = _v0.a;
	var _v1 = A2($justinmimbs$date$Date$divWithRemainder, rd, 146097);
	var n400 = _v1.a;
	var r400 = _v1.b;
	var _v2 = A2($justinmimbs$date$Date$divWithRemainder, r400, 36524);
	var n100 = _v2.a;
	var r100 = _v2.b;
	var _v3 = A2($justinmimbs$date$Date$divWithRemainder, r100, 1461);
	var n4 = _v3.a;
	var r4 = _v3.b;
	var _v4 = A2($justinmimbs$date$Date$divWithRemainder, r4, 365);
	var n1 = _v4.a;
	var r1 = _v4.b;
	var n = (!r1) ? 0 : 1;
	return ((((n400 * 400) + (n100 * 100)) + (n4 * 4)) + n1) + n;
};
var $justinmimbs$date$Date$toOrdinalDate = function (_v0) {
	var rd = _v0.a;
	var y = $justinmimbs$date$Date$year(
		$justinmimbs$date$Date$RD(rd));
	return {
		ordinalDay: rd - $justinmimbs$date$Date$daysBeforeYear(y),
		year: y
	};
};
var $justinmimbs$date$Date$toCalendarDate = function (_v0) {
	var rd = _v0.a;
	var date = $justinmimbs$date$Date$toOrdinalDate(
		$justinmimbs$date$Date$RD(rd));
	return A3($justinmimbs$date$Date$toCalendarDateHelp, date.year, $elm$time$Time$Jan, date.ordinalDay);
};
var $justinmimbs$date$Date$day = A2(
	$elm$core$Basics$composeR,
	$justinmimbs$date$Date$toCalendarDate,
	function ($) {
		return $.day;
	});
var $elm$core$String$left = F2(
	function (n, string) {
		return (n < 1) ? '' : A3($elm$core$String$slice, 0, n, string);
	});
var $justinmimbs$date$Date$month = A2(
	$elm$core$Basics$composeR,
	$justinmimbs$date$Date$toCalendarDate,
	function ($) {
		return $.month;
	});
var $justinmimbs$date$Date$monthNumber = A2($elm$core$Basics$composeR, $justinmimbs$date$Date$month, $justinmimbs$date$Date$monthToNumber);
var $justinmimbs$date$Date$ordinalDay = A2(
	$elm$core$Basics$composeR,
	$justinmimbs$date$Date$toOrdinalDate,
	function ($) {
		return $.ordinalDay;
	});
var $elm$core$String$fromChar = function (_char) {
	return A2($elm$core$String$cons, _char, '');
};
var $elm$core$String$padLeft = F3(
	function (n, _char, string) {
		return _Utils_ap(
			A2(
				$elm$core$String$repeat,
				n - $elm$core$String$length(string),
				$elm$core$String$fromChar(_char)),
			string);
	});
var $elm$core$Basics$abs = function (n) {
	return (n < 0) ? (-n) : n;
};
var $justinmimbs$date$Date$padSignedInt = F2(
	function (length, _int) {
		return _Utils_ap(
			(_int < 0) ? '-' : '',
			A3(
				$elm$core$String$padLeft,
				length,
				_Utils_chr('0'),
				$elm$core$String$fromInt(
					$elm$core$Basics$abs(_int))));
	});
var $justinmimbs$date$Date$monthToQuarter = function (m) {
	return (($justinmimbs$date$Date$monthToNumber(m) + 2) / 3) | 0;
};
var $justinmimbs$date$Date$quarter = A2($elm$core$Basics$composeR, $justinmimbs$date$Date$month, $justinmimbs$date$Date$monthToQuarter);
var $elm$core$String$right = F2(
	function (n, string) {
		return (n < 1) ? '' : A3(
			$elm$core$String$slice,
			-n,
			$elm$core$String$length(string),
			string);
	});
var $elm$time$Time$Fri = {$: 'Fri'};
var $elm$time$Time$Mon = {$: 'Mon'};
var $elm$time$Time$Sat = {$: 'Sat'};
var $elm$time$Time$Sun = {$: 'Sun'};
var $elm$time$Time$Thu = {$: 'Thu'};
var $elm$time$Time$Tue = {$: 'Tue'};
var $elm$time$Time$Wed = {$: 'Wed'};
var $justinmimbs$date$Date$numberToWeekday = function (wdn) {
	var _v0 = A2($elm$core$Basics$max, 1, wdn);
	switch (_v0) {
		case 1:
			return $elm$time$Time$Mon;
		case 2:
			return $elm$time$Time$Tue;
		case 3:
			return $elm$time$Time$Wed;
		case 4:
			return $elm$time$Time$Thu;
		case 5:
			return $elm$time$Time$Fri;
		case 6:
			return $elm$time$Time$Sat;
		default:
			return $elm$time$Time$Sun;
	}
};
var $justinmimbs$date$Date$toWeekDate = function (_v0) {
	var rd = _v0.a;
	var wdn = $justinmimbs$date$Date$weekdayNumber(
		$justinmimbs$date$Date$RD(rd));
	var wy = $justinmimbs$date$Date$year(
		$justinmimbs$date$Date$RD(rd + (4 - wdn)));
	var week1Day1 = $justinmimbs$date$Date$daysBeforeWeekYear(wy) + 1;
	return {
		weekNumber: 1 + (((rd - week1Day1) / 7) | 0),
		weekYear: wy,
		weekday: $justinmimbs$date$Date$numberToWeekday(wdn)
	};
};
var $justinmimbs$date$Date$weekNumber = A2(
	$elm$core$Basics$composeR,
	$justinmimbs$date$Date$toWeekDate,
	function ($) {
		return $.weekNumber;
	});
var $justinmimbs$date$Date$weekYear = A2(
	$elm$core$Basics$composeR,
	$justinmimbs$date$Date$toWeekDate,
	function ($) {
		return $.weekYear;
	});
var $justinmimbs$date$Date$weekday = A2($elm$core$Basics$composeR, $justinmimbs$date$Date$weekdayNumber, $justinmimbs$date$Date$numberToWeekday);
var $elm$core$Basics$min = F2(
	function (x, y) {
		return (_Utils_cmp(x, y) < 0) ? x : y;
	});
var $justinmimbs$date$Date$ordinalSuffix = function (n) {
	var nn = A2($elm$core$Basics$modBy, 100, n);
	var _v0 = A2(
		$elm$core$Basics$min,
		(nn < 20) ? nn : A2($elm$core$Basics$modBy, 10, nn),
		4);
	switch (_v0) {
		case 1:
			return 'st';
		case 2:
			return 'nd';
		case 3:
			return 'rd';
		default:
			return 'th';
	}
};
var $justinmimbs$date$Date$withOrdinalSuffix = function (n) {
	return _Utils_ap(
		$elm$core$String$fromInt(n),
		$justinmimbs$date$Date$ordinalSuffix(n));
};
var $justinmimbs$date$Date$formatField = F4(
	function (language, _char, length, date) {
		switch (_char.valueOf()) {
			case 'y':
				if (length === 2) {
					return A2(
						$elm$core$String$right,
						2,
						A3(
							$elm$core$String$padLeft,
							2,
							_Utils_chr('0'),
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$year(date))));
				} else {
					return A2(
						$justinmimbs$date$Date$padSignedInt,
						length,
						$justinmimbs$date$Date$year(date));
				}
			case 'Y':
				if (length === 2) {
					return A2(
						$elm$core$String$right,
						2,
						A3(
							$elm$core$String$padLeft,
							2,
							_Utils_chr('0'),
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$weekYear(date))));
				} else {
					return A2(
						$justinmimbs$date$Date$padSignedInt,
						length,
						$justinmimbs$date$Date$weekYear(date));
				}
			case 'Q':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$quarter(date));
					case 2:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$quarter(date));
					case 3:
						return 'Q' + $elm$core$String$fromInt(
							$justinmimbs$date$Date$quarter(date));
					case 4:
						return $justinmimbs$date$Date$withOrdinalSuffix(
							$justinmimbs$date$Date$quarter(date));
					case 5:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$quarter(date));
					default:
						return '';
				}
			case 'M':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$monthNumber(date));
					case 2:
						return A3(
							$elm$core$String$padLeft,
							2,
							_Utils_chr('0'),
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$monthNumber(date)));
					case 3:
						return language.monthNameShort(
							$justinmimbs$date$Date$month(date));
					case 4:
						return language.monthName(
							$justinmimbs$date$Date$month(date));
					case 5:
						return A2(
							$elm$core$String$left,
							1,
							language.monthNameShort(
								$justinmimbs$date$Date$month(date)));
					default:
						return '';
				}
			case 'w':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$weekNumber(date));
					case 2:
						return A3(
							$elm$core$String$padLeft,
							2,
							_Utils_chr('0'),
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$weekNumber(date)));
					default:
						return '';
				}
			case 'd':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$day(date));
					case 2:
						return A3(
							$elm$core$String$padLeft,
							2,
							_Utils_chr('0'),
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$day(date)));
					case 3:
						return language.dayWithSuffix(
							$justinmimbs$date$Date$day(date));
					default:
						return '';
				}
			case 'D':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$ordinalDay(date));
					case 2:
						return A3(
							$elm$core$String$padLeft,
							2,
							_Utils_chr('0'),
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$ordinalDay(date)));
					case 3:
						return A3(
							$elm$core$String$padLeft,
							3,
							_Utils_chr('0'),
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$ordinalDay(date)));
					default:
						return '';
				}
			case 'E':
				switch (length) {
					case 1:
						return language.weekdayNameShort(
							$justinmimbs$date$Date$weekday(date));
					case 2:
						return language.weekdayNameShort(
							$justinmimbs$date$Date$weekday(date));
					case 3:
						return language.weekdayNameShort(
							$justinmimbs$date$Date$weekday(date));
					case 4:
						return language.weekdayName(
							$justinmimbs$date$Date$weekday(date));
					case 5:
						return A2(
							$elm$core$String$left,
							1,
							language.weekdayNameShort(
								$justinmimbs$date$Date$weekday(date)));
					case 6:
						return A2(
							$elm$core$String$left,
							2,
							language.weekdayNameShort(
								$justinmimbs$date$Date$weekday(date)));
					default:
						return '';
				}
			case 'e':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$weekdayNumber(date));
					case 2:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$weekdayNumber(date));
					default:
						return A4(
							$justinmimbs$date$Date$formatField,
							language,
							_Utils_chr('E'),
							length,
							date);
				}
			default:
				return '';
		}
	});
var $justinmimbs$date$Date$formatWithTokens = F3(
	function (language, tokens, date) {
		return A3(
			$elm$core$List$foldl,
			F2(
				function (token, formatted) {
					if (token.$ === 'Field') {
						var _char = token.a;
						var length = token.b;
						return _Utils_ap(
							A4($justinmimbs$date$Date$formatField, language, _char, length, date),
							formatted);
					} else {
						var str = token.a;
						return _Utils_ap(str, formatted);
					}
				}),
			'',
			tokens);
	});
var $justinmimbs$date$Pattern$Literal = function (a) {
	return {$: 'Literal', a: a};
};
var $justinmimbs$date$Pattern$escapedQuote = A2(
	$elm$parser$Parser$ignorer,
	$elm$parser$Parser$succeed(
		$justinmimbs$date$Pattern$Literal('\'')),
	$elm$parser$Parser$token('\'\''));
var $justinmimbs$date$Pattern$Field = F2(
	function (a, b) {
		return {$: 'Field', a: a, b: b};
	});
var $elm$parser$Parser$Advanced$getOffset = $elm$parser$Parser$Advanced$Parser(
	function (s) {
		return A3($elm$parser$Parser$Advanced$Good, false, s.offset, s);
	});
var $elm$parser$Parser$getOffset = $elm$parser$Parser$Advanced$getOffset;
var $justinmimbs$date$Pattern$fieldRepeats = function (str) {
	var _v0 = $elm$core$String$toList(str);
	if (_v0.b && (!_v0.b.b)) {
		var _char = _v0.a;
		return A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$keeper,
				$elm$parser$Parser$succeed(
					F2(
						function (x, y) {
							return A2($justinmimbs$date$Pattern$Field, _char, 1 + (y - x));
						})),
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$getOffset,
					$elm$parser$Parser$chompWhile(
						$elm$core$Basics$eq(_char)))),
			$elm$parser$Parser$getOffset);
	} else {
		return $elm$parser$Parser$problem('expected exactly one char');
	}
};
var $justinmimbs$date$Pattern$field = A2(
	$elm$parser$Parser$andThen,
	$justinmimbs$date$Pattern$fieldRepeats,
	$elm$parser$Parser$getChompedString(
		$elm$parser$Parser$chompIf($elm$core$Char$isAlpha)));
var $justinmimbs$date$Pattern$finalize = A2(
	$elm$core$List$foldl,
	F2(
		function (token, tokens) {
			var _v0 = _Utils_Tuple2(token, tokens);
			if (((_v0.a.$ === 'Literal') && _v0.b.b) && (_v0.b.a.$ === 'Literal')) {
				var x = _v0.a.a;
				var _v1 = _v0.b;
				var y = _v1.a.a;
				var rest = _v1.b;
				return A2(
					$elm$core$List$cons,
					$justinmimbs$date$Pattern$Literal(
						_Utils_ap(x, y)),
					rest);
			} else {
				return A2($elm$core$List$cons, token, tokens);
			}
		}),
	_List_Nil);
var $elm$parser$Parser$Advanced$lazy = function (thunk) {
	return $elm$parser$Parser$Advanced$Parser(
		function (s) {
			var _v0 = thunk(_Utils_Tuple0);
			var parse = _v0.a;
			return parse(s);
		});
};
var $elm$parser$Parser$lazy = $elm$parser$Parser$Advanced$lazy;
var $justinmimbs$date$Pattern$isLiteralChar = function (_char) {
	return (!_Utils_eq(
		_char,
		_Utils_chr('\''))) && (!$elm$core$Char$isAlpha(_char));
};
var $justinmimbs$date$Pattern$literal = A2(
	$elm$parser$Parser$map,
	$justinmimbs$date$Pattern$Literal,
	$elm$parser$Parser$getChompedString(
		A2(
			$elm$parser$Parser$ignorer,
			A2(
				$elm$parser$Parser$ignorer,
				$elm$parser$Parser$succeed(_Utils_Tuple0),
				$elm$parser$Parser$chompIf($justinmimbs$date$Pattern$isLiteralChar)),
			$elm$parser$Parser$chompWhile($justinmimbs$date$Pattern$isLiteralChar))));
var $justinmimbs$date$Pattern$quotedHelp = function (result) {
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$andThen,
				function (str) {
					return $justinmimbs$date$Pattern$quotedHelp(
						_Utils_ap(result, str));
				},
				$elm$parser$Parser$getChompedString(
					A2(
						$elm$parser$Parser$ignorer,
						A2(
							$elm$parser$Parser$ignorer,
							$elm$parser$Parser$succeed(_Utils_Tuple0),
							$elm$parser$Parser$chompIf(
								$elm$core$Basics$neq(
									_Utils_chr('\'')))),
						$elm$parser$Parser$chompWhile(
							$elm$core$Basics$neq(
								_Utils_chr('\'')))))),
				A2(
				$elm$parser$Parser$andThen,
				function (_v0) {
					return $justinmimbs$date$Pattern$quotedHelp(result + '\'');
				},
				$elm$parser$Parser$token('\'\'')),
				$elm$parser$Parser$succeed(result)
			]));
};
var $justinmimbs$date$Pattern$quoted = A2(
	$elm$parser$Parser$keeper,
	A2(
		$elm$parser$Parser$ignorer,
		$elm$parser$Parser$succeed($justinmimbs$date$Pattern$Literal),
		$elm$parser$Parser$chompIf(
			$elm$core$Basics$eq(
				_Utils_chr('\'')))),
	A2(
		$elm$parser$Parser$ignorer,
		$justinmimbs$date$Pattern$quotedHelp(''),
		$elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					$elm$parser$Parser$chompIf(
					$elm$core$Basics$eq(
						_Utils_chr('\''))),
					$elm$parser$Parser$end
				]))));
var $justinmimbs$date$Pattern$patternHelp = function (tokens) {
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$andThen,
				function (token) {
					return $justinmimbs$date$Pattern$patternHelp(
						A2($elm$core$List$cons, token, tokens));
				},
				$elm$parser$Parser$oneOf(
					_List_fromArray(
						[$justinmimbs$date$Pattern$field, $justinmimbs$date$Pattern$literal, $justinmimbs$date$Pattern$escapedQuote, $justinmimbs$date$Pattern$quoted]))),
				$elm$parser$Parser$lazy(
				function (_v0) {
					return $elm$parser$Parser$succeed(
						$justinmimbs$date$Pattern$finalize(tokens));
				})
			]));
};
var $elm$core$Result$withDefault = F2(
	function (def, result) {
		if (result.$ === 'Ok') {
			var a = result.a;
			return a;
		} else {
			return def;
		}
	});
var $justinmimbs$date$Pattern$fromString = function (str) {
	return A2(
		$elm$core$Result$withDefault,
		_List_fromArray(
			[
				$justinmimbs$date$Pattern$Literal(str)
			]),
		A2(
			$elm$parser$Parser$run,
			$justinmimbs$date$Pattern$patternHelp(_List_Nil),
			str));
};
var $justinmimbs$date$Date$formatWithLanguage = F2(
	function (language, pattern) {
		var tokens = $elm$core$List$reverse(
			$justinmimbs$date$Pattern$fromString(pattern));
		return A2($justinmimbs$date$Date$formatWithTokens, language, tokens);
	});
var $justinmimbs$date$Date$weekdayToName = function (wd) {
	switch (wd.$) {
		case 'Mon':
			return 'Monday';
		case 'Tue':
			return 'Tuesday';
		case 'Wed':
			return 'Wednesday';
		case 'Thu':
			return 'Thursday';
		case 'Fri':
			return 'Friday';
		case 'Sat':
			return 'Saturday';
		default:
			return 'Sunday';
	}
};
var $justinmimbs$date$Date$language_en = {
	dayWithSuffix: $justinmimbs$date$Date$withOrdinalSuffix,
	monthName: $justinmimbs$date$Date$monthToName,
	monthNameShort: A2(
		$elm$core$Basics$composeR,
		$justinmimbs$date$Date$monthToName,
		$elm$core$String$left(3)),
	weekdayName: $justinmimbs$date$Date$weekdayToName,
	weekdayNameShort: A2(
		$elm$core$Basics$composeR,
		$justinmimbs$date$Date$weekdayToName,
		$elm$core$String$left(3))
};
var $justinmimbs$date$Date$format = function (pattern) {
	return A2($justinmimbs$date$Date$formatWithLanguage, $justinmimbs$date$Date$language_en, pattern);
};
var $justinmimbs$date$Date$toIsoString = $justinmimbs$date$Date$format('yyyy-MM-dd');
var $author$project$DataElement$Expression$Preview$countUniqueComparableTransform = {
	date: $author$project$Calc$countUnique($justinmimbs$date$Date$toIsoString),
	datetime: $author$project$Calc$countUnique($elm$time$Time$posixToMillis),
	number: $author$project$Calc$countUnique($elm$core$Basics$identity),
	string: $author$project$Calc$countUnique(
		function ($) {
			return $.text;
		})
};
var $justinmimbs$date$Date$Months = {$: 'Months'};
var $justinmimbs$date$Date$add = F3(
	function (unit, n, _v0) {
		var rd = _v0.a;
		switch (unit.$) {
			case 'Years':
				return A3(
					$justinmimbs$date$Date$add,
					$justinmimbs$date$Date$Months,
					12 * n,
					$justinmimbs$date$Date$RD(rd));
			case 'Months':
				var date = $justinmimbs$date$Date$toCalendarDate(
					$justinmimbs$date$Date$RD(rd));
				var wholeMonths = ((12 * (date.year - 1)) + ($justinmimbs$date$Date$monthToNumber(date.month) - 1)) + n;
				var m = $justinmimbs$date$Date$numberToMonth(
					A2($elm$core$Basics$modBy, 12, wholeMonths) + 1);
				var y = A2($justinmimbs$date$Date$floorDiv, wholeMonths, 12) + 1;
				return $justinmimbs$date$Date$RD(
					($justinmimbs$date$Date$daysBeforeYear(y) + A2($justinmimbs$date$Date$daysBeforeMonth, y, m)) + A2(
						$elm$core$Basics$min,
						date.day,
						A2($justinmimbs$date$Date$daysInMonth, y, m)));
			case 'Weeks':
				return $justinmimbs$date$Date$RD(rd + (7 * n));
			default:
				return $justinmimbs$date$Date$RD(rd + n);
		}
	});
var $author$project$Calc$dateAdd = function (dateUnit) {
	return $elm$core$Maybe$map2(
		F2(
			function (num, date) {
				return A3(
					$justinmimbs$date$Date$add,
					dateUnit,
					$elm$core$Basics$round(num),
					date);
			}));
};
var $justinmimbs$date$Date$Days = {$: 'Days'};
var $justinmimbs$date$Date$weekdayToNumber = function (wd) {
	switch (wd.$) {
		case 'Mon':
			return 1;
		case 'Tue':
			return 2;
		case 'Wed':
			return 3;
		case 'Thu':
			return 4;
		case 'Fri':
			return 5;
		case 'Sat':
			return 6;
		default:
			return 7;
	}
};
var $justinmimbs$date$Date$daysSincePreviousWeekday = F2(
	function (wd, date) {
		return A2(
			$elm$core$Basics$modBy,
			7,
			($justinmimbs$date$Date$weekdayNumber(date) + 7) - $justinmimbs$date$Date$weekdayToNumber(wd));
	});
var $justinmimbs$date$Date$firstOfMonth = F2(
	function (y, m) {
		return $justinmimbs$date$Date$RD(
			($justinmimbs$date$Date$daysBeforeYear(y) + A2($justinmimbs$date$Date$daysBeforeMonth, y, m)) + 1);
	});
var $justinmimbs$date$Date$quarterToMonth = function (q) {
	return $justinmimbs$date$Date$numberToMonth((q * 3) - 2);
};
var $justinmimbs$date$Date$floor = F2(
	function (interval, date) {
		var rd = date.a;
		switch (interval.$) {
			case 'Year':
				return $justinmimbs$date$Date$firstOfYear(
					$justinmimbs$date$Date$year(date));
			case 'Quarter':
				return A2(
					$justinmimbs$date$Date$firstOfMonth,
					$justinmimbs$date$Date$year(date),
					$justinmimbs$date$Date$quarterToMonth(
						$justinmimbs$date$Date$quarter(date)));
			case 'Month':
				return A2(
					$justinmimbs$date$Date$firstOfMonth,
					$justinmimbs$date$Date$year(date),
					$justinmimbs$date$Date$month(date));
			case 'Week':
				return $justinmimbs$date$Date$RD(
					rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, $elm$time$Time$Mon, date));
			case 'Monday':
				return $justinmimbs$date$Date$RD(
					rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, $elm$time$Time$Mon, date));
			case 'Tuesday':
				return $justinmimbs$date$Date$RD(
					rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, $elm$time$Time$Tue, date));
			case 'Wednesday':
				return $justinmimbs$date$Date$RD(
					rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, $elm$time$Time$Wed, date));
			case 'Thursday':
				return $justinmimbs$date$Date$RD(
					rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, $elm$time$Time$Thu, date));
			case 'Friday':
				return $justinmimbs$date$Date$RD(
					rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, $elm$time$Time$Fri, date));
			case 'Saturday':
				return $justinmimbs$date$Date$RD(
					rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, $elm$time$Time$Sat, date));
			case 'Sunday':
				return $justinmimbs$date$Date$RD(
					rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, $elm$time$Time$Sun, date));
			default:
				return date;
		}
	});
var $justinmimbs$date$Date$Weeks = {$: 'Weeks'};
var $justinmimbs$date$Date$Years = {$: 'Years'};
var $justinmimbs$date$Date$intervalToUnits = function (interval) {
	switch (interval.$) {
		case 'Year':
			return _Utils_Tuple2(1, $justinmimbs$date$Date$Years);
		case 'Quarter':
			return _Utils_Tuple2(3, $justinmimbs$date$Date$Months);
		case 'Month':
			return _Utils_Tuple2(1, $justinmimbs$date$Date$Months);
		case 'Day':
			return _Utils_Tuple2(1, $justinmimbs$date$Date$Days);
		default:
			var week = interval;
			return _Utils_Tuple2(1, $justinmimbs$date$Date$Weeks);
	}
};
var $justinmimbs$date$Date$ceiling = F2(
	function (interval, date) {
		var floored = A2($justinmimbs$date$Date$floor, interval, date);
		if (_Utils_eq(date, floored)) {
			return date;
		} else {
			var _v0 = $justinmimbs$date$Date$intervalToUnits(interval);
			var n = _v0.a;
			var unit = _v0.b;
			return A3($justinmimbs$date$Date$add, unit, n, floored);
		}
	});
var $author$project$Calc$dateCeilingHelper = F2(
	function (interval, date) {
		return A3(
			$justinmimbs$date$Date$add,
			$justinmimbs$date$Date$Days,
			-1,
			A2($justinmimbs$date$Date$ceiling, interval, date));
	});
var $author$project$Calc$dateCeiling = function (dateInterval) {
	return $elm$core$Maybe$map(
		$author$project$Calc$dateCeilingHelper(dateInterval));
};
var $author$project$Calc$dateFloor = function (dateInterval) {
	return $elm$core$Maybe$map(
		$justinmimbs$date$Date$floor(dateInterval));
};
var $author$project$Calc$dateSubtract = function (dateUnit) {
	return $elm$core$Maybe$map2(
		F2(
			function (num, date) {
				return A3(
					$justinmimbs$date$Date$add,
					dateUnit,
					(-1) * $elm$core$Basics$round(num),
					date);
			}));
};
var $author$project$LoadableTimeZone$toMaybe = function (_v0) {
	var user = _v0.a;
	var device = _v0.b;
	switch (user.$) {
		case 'NotAsked':
			return $elm$core$Maybe$Nothing;
		case 'Loading':
			return $elm$core$Maybe$Nothing;
		case 'Failure':
			return device;
		default:
			var _v2 = user.a;
			var zone = _v2.b;
			return $elm$core$Maybe$Just(zone);
	}
};
var $author$project$Calc$dateTimeToDate = F2(
	function (ltz, maybeDateTime) {
		return A3(
			$elm$core$Maybe$map2,
			$justinmimbs$date$Date$fromPosix,
			$author$project$LoadableTimeZone$toMaybe(ltz),
			maybeDateTime);
	});
var $author$project$Calc$dayInMonth = $elm$core$Maybe$map(
	A2($elm$core$Basics$composeR, $justinmimbs$date$Date$day, $elm$core$Basics$toFloat));
var $author$project$Calc$divide = $elm$core$Maybe$map2($elm$core$Basics$fdiv);
var $author$project$Calc$equal = $elm$core$Maybe$map2($elm$core$Basics$eq);
var $author$project$Calc$formatDate = $elm$core$Maybe$map2(
	F2(
		function (formatString, date) {
			return $author$project$StudioString$withoutObject(
				A2($justinmimbs$date$Date$format, formatString.text, date));
		}));
var $enkidatron$elm_cldr$Cldr$Format$Length$Short = {$: 'Short'};
var $enkidatron$elm_cldr$Cldr$Format$Date$WithLength = function (a) {
	return {$: 'WithLength', a: a};
};
var $enkidatron$elm_cldr$Internal$Format$number = F2(
	function (numberWidth, num) {
		if (numberWidth.$ === 'MinimumDigits') {
			return $elm$core$String$fromInt(num);
		} else {
			return A3(
				$elm$core$String$padLeft,
				2,
				_Utils_chr('0'),
				A2(
					$elm$core$String$right,
					2,
					$elm$core$String$fromInt(num)));
		}
	});
var $enkidatron$elm_cldr$Cldr$Format$Date$formatDay = F2(
	function (numberWidth, date) {
		return A2(
			$enkidatron$elm_cldr$Internal$Format$number,
			numberWidth,
			$justinmimbs$date$Date$day(date));
	});
var $enkidatron$elm_cldr$Internal$Format$era = F2(
	function (eraNames, yr) {
		return (yr > 0) ? eraNames.ad : eraNames.bc;
	});
var $enkidatron$elm_cldr$Cldr$Format$Date$formatEraHelper = F2(
	function (eraNames, date) {
		return A2(
			$enkidatron$elm_cldr$Internal$Format$era,
			eraNames,
			$justinmimbs$date$Date$year(date));
	});
var $enkidatron$elm_cldr$Internal$Structures$getPattern3 = F2(
	function (pattern, textWidth) {
		switch (textWidth.$) {
			case 'Abbreviated':
				return pattern.abbreviated;
			case 'Wide':
				return pattern.wide;
			default:
				return pattern.narrow;
		}
	});
var $enkidatron$elm_cldr$Cldr$Format$Date$formatTextWidthHelper = F3(
	function (formatFun, patterns, textWidth) {
		return formatFun(
			A2($enkidatron$elm_cldr$Internal$Structures$getPattern3, patterns, textWidth));
	});
var $enkidatron$elm_cldr$Cldr$Format$Date$formatEra = $enkidatron$elm_cldr$Cldr$Format$Date$formatTextWidthHelper($enkidatron$elm_cldr$Cldr$Format$Date$formatEraHelper);
var $enkidatron$elm_cldr$Internal$Format$month = F2(
	function (monthNames, mnth) {
		switch (mnth.$) {
			case 'Jan':
				return monthNames.jan;
			case 'Feb':
				return monthNames.feb;
			case 'Mar':
				return monthNames.mar;
			case 'Apr':
				return monthNames.apr;
			case 'May':
				return monthNames.may;
			case 'Jun':
				return monthNames.jun;
			case 'Jul':
				return monthNames.jul;
			case 'Aug':
				return monthNames.aug;
			case 'Sep':
				return monthNames.sep;
			case 'Oct':
				return monthNames.oct;
			case 'Nov':
				return monthNames.nov;
			default:
				return monthNames.dec;
		}
	});
var $enkidatron$elm_cldr$Cldr$Format$Date$formatMonthHelper = F2(
	function (monthNames, date) {
		return A2(
			$enkidatron$elm_cldr$Internal$Format$month,
			monthNames,
			$justinmimbs$date$Date$month(date));
	});
var $enkidatron$elm_cldr$Cldr$Format$Date$formatMonthNumberHelper = F2(
	function (numberWidth, date) {
		return A2(
			$enkidatron$elm_cldr$Internal$Format$number,
			numberWidth,
			$justinmimbs$date$Date$monthNumber(date));
	});
var $enkidatron$elm_cldr$Cldr$Format$Date$formatMonth = F2(
	function (monthPattern3, width) {
		if (width.$ === 'Text') {
			var textWidth = width.a;
			return A3($enkidatron$elm_cldr$Cldr$Format$Date$formatTextWidthHelper, $enkidatron$elm_cldr$Cldr$Format$Date$formatMonthHelper, monthPattern3, textWidth);
		} else {
			var numberWidth = width.a;
			return $enkidatron$elm_cldr$Cldr$Format$Date$formatMonthNumberHelper(numberWidth);
		}
	});
var $enkidatron$elm_cldr$Internal$Format$weekday = F2(
	function (weekdayNames, wkday) {
		switch (wkday.$) {
			case 'Mon':
				return weekdayNames.mon;
			case 'Tue':
				return weekdayNames.tue;
			case 'Wed':
				return weekdayNames.wed;
			case 'Thu':
				return weekdayNames.thu;
			case 'Fri':
				return weekdayNames.fri;
			case 'Sat':
				return weekdayNames.sat;
			default:
				return weekdayNames.sun;
		}
	});
var $enkidatron$elm_cldr$Cldr$Format$Date$formatWeekdayHelper = F2(
	function (weekdayNames, date) {
		return A2(
			$enkidatron$elm_cldr$Internal$Format$weekday,
			weekdayNames,
			$justinmimbs$date$Date$weekday(date));
	});
var $enkidatron$elm_cldr$Cldr$Format$Date$formatWeekday = $enkidatron$elm_cldr$Cldr$Format$Date$formatTextWidthHelper($enkidatron$elm_cldr$Cldr$Format$Date$formatWeekdayHelper);
var $enkidatron$elm_cldr$Internal$Format$year = F2(
	function (numberWidth, yr) {
		var yearNum = (yr > 0) ? yr : ((yr * (-1)) + 1);
		return A2($enkidatron$elm_cldr$Internal$Format$number, numberWidth, yearNum);
	});
var $enkidatron$elm_cldr$Cldr$Format$Date$formatYear = F2(
	function (numberWidth, date) {
		return A2(
			$enkidatron$elm_cldr$Internal$Format$year,
			numberWidth,
			$justinmimbs$date$Date$year(date));
	});
var $enkidatron$elm_cldr$Cldr$Format$Date$formatYearOfWeek = F2(
	function (numberWidth, date) {
		return A2(
			$enkidatron$elm_cldr$Internal$Format$year,
			numberWidth,
			$justinmimbs$date$Date$weekYear(date));
	});
var $enkidatron$elm_cldr$Cldr$Format$Date$formatSymbol = F3(
	function (internal, date, symbol) {
		switch (symbol.$) {
			case 'Era':
				var textWidth = symbol.a;
				return A3($enkidatron$elm_cldr$Cldr$Format$Date$formatEra, internal.eraNames, textWidth, date);
			case 'Year':
				var numberWidth = symbol.a;
				return A2($enkidatron$elm_cldr$Cldr$Format$Date$formatYear, numberWidth, date);
			case 'YearOfWeek':
				var numberWidth = symbol.a;
				return A2($enkidatron$elm_cldr$Cldr$Format$Date$formatYearOfWeek, numberWidth, date);
			case 'Month':
				var width = symbol.a;
				return A3($enkidatron$elm_cldr$Cldr$Format$Date$formatMonth, internal.monthFormatNames, width, date);
			case 'MonthStandalone':
				var width = symbol.a;
				return A3($enkidatron$elm_cldr$Cldr$Format$Date$formatMonth, internal.monthStandaloneNames, width, date);
			case 'Weekday':
				var textWidth = symbol.a;
				return A3($enkidatron$elm_cldr$Cldr$Format$Date$formatWeekday, internal.weekdayFormatNames, textWidth, date);
			case 'WeekdayStandalone':
				var textWidth = symbol.a;
				return A3($enkidatron$elm_cldr$Cldr$Format$Date$formatWeekday, internal.weekdayStandaloneNames, textWidth, date);
			default:
				var numberWidth = symbol.a;
				return A2($enkidatron$elm_cldr$Cldr$Format$Date$formatDay, numberWidth, date);
		}
	});
var $enkidatron$elm_cldr$Internal$FormatSymbols$unwrap = F2(
	function (fun, withLiteral) {
		if (withLiteral.$ === 'Literal') {
			var words = withLiteral.a;
			return words;
		} else {
			var a = withLiteral.a;
			return fun(a);
		}
	});
var $enkidatron$elm_cldr$Cldr$Format$Date$formatDate = F3(
	function (internal, symbols, date) {
		return $elm$core$String$concat(
			A2(
				$elm$core$List$map,
				$enkidatron$elm_cldr$Internal$FormatSymbols$unwrap(
					A2($enkidatron$elm_cldr$Cldr$Format$Date$formatSymbol, internal, date)),
				symbols));
	});
var $enkidatron$elm_cldr$Internal$Options$rankNumber = function (opt) {
	if (opt.$ === 'TwoDigit') {
		return 0;
	} else {
		return 1;
	}
};
var $enkidatron$elm_cldr$Internal$Options$rankText = function (opt) {
	switch (opt.$) {
		case 'Narrow':
			return 2;
		case 'Short':
			return 3;
		default:
			return 4;
	}
};
var $enkidatron$elm_cldr$Internal$Options$rankNumberOrText = function (opt) {
	if (opt.$ === 'Text') {
		var textOpt = opt.a;
		return $enkidatron$elm_cldr$Internal$Options$rankText(textOpt);
	} else {
		var numOpt = opt.a;
		return $enkidatron$elm_cldr$Internal$Options$rankNumber(numOpt);
	}
};
var $enkidatron$elm_cldr$Internal$Options$additionPenalty = -20;
var $enkidatron$elm_cldr$Internal$Options$removalPenalty = -120;
var $enkidatron$elm_cldr$Internal$Options$longLessPenalty = -8;
var $enkidatron$elm_cldr$Internal$Options$longMorePenalty = -6;
var $enkidatron$elm_cldr$Internal$Options$shortLessPenalty = -6;
var $enkidatron$elm_cldr$Internal$Options$shortMorePenalty = -3;
var $enkidatron$elm_cldr$Internal$Options$scoreForDistance = function (distance) {
	return (distance >= 2) ? $enkidatron$elm_cldr$Internal$Options$longMorePenalty : ((distance === 1) ? $enkidatron$elm_cldr$Internal$Options$shortMorePenalty : ((!distance) ? 0 : (_Utils_eq(distance, -1) ? $enkidatron$elm_cldr$Internal$Options$shortLessPenalty : $enkidatron$elm_cldr$Internal$Options$longLessPenalty)));
};
var $enkidatron$elm_cldr$Internal$Options$score = F3(
	function (scoreFun, requested, candidate) {
		var _v0 = _Utils_Tuple2(requested, candidate);
		if (_v0.a.$ === 'Nothing') {
			if (_v0.b.$ === 'Nothing') {
				var _v1 = _v0.a;
				var _v2 = _v0.b;
				return 0;
			} else {
				var _v4 = _v0.a;
				return $enkidatron$elm_cldr$Internal$Options$additionPenalty;
			}
		} else {
			if (_v0.b.$ === 'Nothing') {
				var _v3 = _v0.b;
				return $enkidatron$elm_cldr$Internal$Options$removalPenalty;
			} else {
				var req = _v0.a.a;
				var can = _v0.b.a;
				return $enkidatron$elm_cldr$Internal$Options$scoreForDistance(
					scoreFun(can) - scoreFun(req));
			}
		}
	});
var $elm$core$List$sum = function (numbers) {
	return A3($elm$core$List$foldl, $elm$core$Basics$add, 0, numbers);
};
var $enkidatron$elm_cldr$Internal$Options$dateMatchScore = F2(
	function (requested, candidate) {
		return $elm$core$List$sum(
			_List_fromArray(
				[
					A3($enkidatron$elm_cldr$Internal$Options$score, $enkidatron$elm_cldr$Internal$Options$rankText, requested.era, candidate.era),
					A3($enkidatron$elm_cldr$Internal$Options$score, $enkidatron$elm_cldr$Internal$Options$rankNumber, requested.year, candidate.year),
					A3($enkidatron$elm_cldr$Internal$Options$score, $enkidatron$elm_cldr$Internal$Options$rankNumberOrText, requested.month, candidate.month),
					A3($enkidatron$elm_cldr$Internal$Options$score, $enkidatron$elm_cldr$Internal$Options$rankNumber, requested.day, candidate.day),
					A3($enkidatron$elm_cldr$Internal$Options$score, $enkidatron$elm_cldr$Internal$Options$rankText, requested.weekday, candidate.weekday)
				]));
	});
var $enkidatron$elm_cldr$Internal$FormatSymbols$Convert$numberWidth = function (opt) {
	if (opt.$ === 'Numeric') {
		return $enkidatron$elm_cldr$Internal$FormatSymbols$MinimumDigits;
	} else {
		return $enkidatron$elm_cldr$Internal$FormatSymbols$TwoDigit;
	}
};
var $enkidatron$elm_cldr$Internal$FormatSymbols$Convert$textWidth = function (opt) {
	switch (opt.$) {
		case 'Short':
			return $enkidatron$elm_cldr$Internal$FormatSymbols$Abbreviated;
		case 'Long':
			return $enkidatron$elm_cldr$Internal$FormatSymbols$Wide;
		default:
			return $enkidatron$elm_cldr$Internal$FormatSymbols$Narrow;
	}
};
var $enkidatron$elm_cldr$Internal$FormatSymbols$Convert$width = function (opt) {
	if (opt.$ === 'Text') {
		var text = opt.a;
		return $enkidatron$elm_cldr$Internal$FormatSymbols$Text(
			$enkidatron$elm_cldr$Internal$FormatSymbols$Convert$textWidth(text));
	} else {
		var number = opt.a;
		return $enkidatron$elm_cldr$Internal$FormatSymbols$Number(
			$enkidatron$elm_cldr$Internal$FormatSymbols$Convert$numberWidth(number));
	}
};
var $enkidatron$elm_cldr$Internal$FormatSymbols$Expand$date = F2(
	function (requested, symbol) {
		switch (symbol.$) {
			case 'Era':
				var era = symbol.a;
				return $enkidatron$elm_cldr$Internal$FormatSymbols$Era(
					A3($elm_community$maybe_extra$Maybe$Extra$unwrap, era, $enkidatron$elm_cldr$Internal$FormatSymbols$Convert$textWidth, requested.era));
			case 'Year':
				var year = symbol.a;
				return $enkidatron$elm_cldr$Internal$FormatSymbols$Year(
					A3($elm_community$maybe_extra$Maybe$Extra$unwrap, year, $enkidatron$elm_cldr$Internal$FormatSymbols$Convert$numberWidth, requested.year));
			case 'YearOfWeek':
				var year = symbol.a;
				return $enkidatron$elm_cldr$Internal$FormatSymbols$YearOfWeek(
					A3($elm_community$maybe_extra$Maybe$Extra$unwrap, year, $enkidatron$elm_cldr$Internal$FormatSymbols$Convert$numberWidth, requested.year));
			case 'Month':
				var month = symbol.a;
				return $enkidatron$elm_cldr$Internal$FormatSymbols$Month(
					A3($elm_community$maybe_extra$Maybe$Extra$unwrap, month, $enkidatron$elm_cldr$Internal$FormatSymbols$Convert$width, requested.month));
			case 'MonthStandalone':
				var month = symbol.a;
				return $enkidatron$elm_cldr$Internal$FormatSymbols$MonthStandalone(
					A3($elm_community$maybe_extra$Maybe$Extra$unwrap, month, $enkidatron$elm_cldr$Internal$FormatSymbols$Convert$width, requested.month));
			case 'Weekday':
				var weekday = symbol.a;
				return $enkidatron$elm_cldr$Internal$FormatSymbols$Weekday(
					A3($elm_community$maybe_extra$Maybe$Extra$unwrap, weekday, $enkidatron$elm_cldr$Internal$FormatSymbols$Convert$textWidth, requested.weekday));
			case 'WeekdayStandalone':
				var weekday = symbol.a;
				return $enkidatron$elm_cldr$Internal$FormatSymbols$WeekdayStandalone(
					A3($elm_community$maybe_extra$Maybe$Extra$unwrap, weekday, $enkidatron$elm_cldr$Internal$FormatSymbols$Convert$textWidth, requested.weekday));
			default:
				var day = symbol.a;
				return $enkidatron$elm_cldr$Internal$FormatSymbols$Day(
					A3($elm_community$maybe_extra$Maybe$Extra$unwrap, day, $enkidatron$elm_cldr$Internal$FormatSymbols$Convert$numberWidth, requested.day));
		}
	});
var $enkidatron$elm_cldr$Internal$FormatSymbols$mapLiteral = F2(
	function (fun, withLiteral) {
		if (withLiteral.$ === 'Literal') {
			var words = withLiteral.a;
			return $enkidatron$elm_cldr$Internal$FormatSymbols$Literal(words);
		} else {
			var a = withLiteral.a;
			return $enkidatron$elm_cldr$Internal$FormatSymbols$Symbol(
				fun(a));
		}
	});
var $enkidatron$elm_cldr$Cldr$Format$Date$expandFormatDateSymbols = F2(
	function (requested, formatSymbols) {
		return A2(
			$elm$core$List$map,
			$enkidatron$elm_cldr$Internal$FormatSymbols$mapLiteral(
				$enkidatron$elm_cldr$Internal$FormatSymbols$Expand$date(requested)),
			formatSymbols);
	});
var $elm_community$list_extra$List$Extra$maximumBy = F2(
	function (f, ls) {
		var maxBy = F2(
			function (x, _v1) {
				var y = _v1.a;
				var fy = _v1.b;
				var fx = f(x);
				return (_Utils_cmp(fx, fy) > 0) ? _Utils_Tuple2(x, fx) : _Utils_Tuple2(y, fy);
			});
		if (ls.b) {
			if (!ls.b.b) {
				var l_ = ls.a;
				return $elm$core$Maybe$Just(l_);
			} else {
				var l_ = ls.a;
				var ls_ = ls.b;
				return $elm$core$Maybe$Just(
					A3(
						$elm$core$List$foldl,
						maxBy,
						_Utils_Tuple2(
							l_,
							f(l_)),
						ls_).a);
			}
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $enkidatron$elm_cldr$Internal$Locale$toDateAvailableFormat = function (af) {
	switch (af.$) {
		case 'DateAF':
			var format = af.a;
			return $elm$core$Maybe$Just(format);
		case 'DateTimeAF':
			return $elm$core$Maybe$Nothing;
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $enkidatron$elm_cldr$Cldr$Format$Date$formatDateSymbolsFromOptions = F2(
	function (internal, requestedOptions) {
		return A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.formatSymbols;
					},
					$enkidatron$elm_cldr$Cldr$Format$Date$expandFormatDateSymbols(requestedOptions)),
				A2(
					$elm_community$list_extra$List$Extra$maximumBy,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.options;
						},
						$enkidatron$elm_cldr$Internal$Options$dateMatchScore(requestedOptions)),
					A2($elm$core$List$filterMap, $enkidatron$elm_cldr$Internal$Locale$toDateAvailableFormat, internal.availableFormats))));
	});
var $enkidatron$elm_cldr$Internal$Structures$getPattern = F2(
	function (patterns, length) {
		switch (length.$) {
			case 'Short':
				return patterns._short;
			case 'Medium':
				return patterns.medium;
			case 'Long':
				return patterns._long;
			default:
				return patterns.full;
		}
	});
var $enkidatron$elm_cldr$Cldr$Format$Date$formatDateSymbolsForType = F2(
	function (internal, formatType) {
		if (formatType.$ === 'WithLength') {
			var length = formatType.a;
			return A2($enkidatron$elm_cldr$Internal$Structures$getPattern, internal.dateSymbols, length);
		} else {
			var options = formatType.a;
			return A2($enkidatron$elm_cldr$Cldr$Format$Date$formatDateSymbolsFromOptions, internal, options);
		}
	});
var $enkidatron$elm_cldr$Cldr$Format$Date$format = F2(
	function (formatType, _v0) {
		var internal = _v0.a;
		return A2(
			$enkidatron$elm_cldr$Cldr$Format$Date$formatDate,
			internal,
			A2($enkidatron$elm_cldr$Cldr$Format$Date$formatDateSymbolsForType, internal, formatType));
	});
var $author$project$Calc$formatDateLocaleAware = F2(
	function (locale, maybeDate) {
		return A2(
			$elm$core$Maybe$map,
			$author$project$StudioString$withoutObject,
			A2(
				$elm$core$Maybe$map,
				A2(
					$enkidatron$elm_cldr$Cldr$Format$Date$format,
					$enkidatron$elm_cldr$Cldr$Format$Date$WithLength($enkidatron$elm_cldr$Cldr$Format$Length$Short),
					locale),
				maybeDate));
	});
var $elm$time$Time$toHour = F2(
	function (zone, time) {
		return A2(
			$elm$core$Basics$modBy,
			24,
			A2(
				$elm$time$Time$flooredDiv,
				A2($elm$time$Time$toAdjustedMinutes, zone, time),
				60));
	});
var $elm$time$Time$toMinute = F2(
	function (zone, time) {
		return A2(
			$elm$core$Basics$modBy,
			60,
			A2($elm$time$Time$toAdjustedMinutes, zone, time));
	});
var $justinmimbs$date$Date$toRataDie = function (_v0) {
	var rd = _v0.a;
	return rd;
};
var $elm$time$Time$toSecond = F2(
	function (_v0, time) {
		return A2(
			$elm$core$Basics$modBy,
			60,
			A2(
				$elm$time$Time$flooredDiv,
				$elm$time$Time$posixToMillis(time),
				1000));
	});
var $enkidatron$elm_cldr$Cldr$Format$DateTime$getOffsets = F2(
	function (zone, posix) {
		var secondOffset = A2($elm$time$Time$toSecond, zone, posix) - A2($elm$time$Time$toSecond, $elm$time$Time$utc, posix);
		var rataDieOffset = $justinmimbs$date$Date$toRataDie(
			A2($justinmimbs$date$Date$fromPosix, zone, posix)) - $justinmimbs$date$Date$toRataDie(
			A2($justinmimbs$date$Date$fromPosix, $elm$time$Time$utc, posix));
		var minuteOffset = A2($elm$time$Time$toMinute, zone, posix) - A2($elm$time$Time$toMinute, $elm$time$Time$utc, posix);
		var hourOffset = A2($elm$time$Time$toHour, zone, posix) - A2($elm$time$Time$toHour, $elm$time$Time$utc, posix);
		var totalSecondsOffset = (((((rataDieOffset * 24) * 60) * 60) + ((hourOffset * 60) * 60)) + (minuteOffset * 60)) + secondOffset;
		return {
			hours: $elm$core$Basics$abs((totalSecondsOffset / 3600) | 0),
			minutes: $elm$core$Basics$abs(((totalSecondsOffset % 3600) / 60) | 0),
			offsetIsPositive: totalSecondsOffset >= 0,
			seconds: $elm$core$Basics$abs(totalSecondsOffset % 60)
		};
	});
var $enkidatron$elm_cldr$Cldr$Format$DateTime$iso8601BasicFormatOffsets = function (offsets) {
	var showSeconds = !(!offsets.seconds);
	return $elm$core$String$concat(
		A2(
			$elm$core$List$map,
			$elm$core$Tuple$second,
			A2(
				$elm$core$List$filter,
				$elm$core$Tuple$first,
				_List_fromArray(
					[
						_Utils_Tuple2(offsets.offsetIsPositive, '+'),
						_Utils_Tuple2(
						true,
						A3(
							$elm$core$String$padLeft,
							2,
							_Utils_chr('0'),
							$elm$core$String$fromInt(offsets.hours))),
						_Utils_Tuple2(
						true,
						A3(
							$elm$core$String$padLeft,
							2,
							_Utils_chr('0'),
							$elm$core$String$fromInt(offsets.minutes))),
						_Utils_Tuple2(
						showSeconds,
						A3(
							$elm$core$String$padLeft,
							2,
							_Utils_chr('0'),
							$elm$core$String$fromInt(offsets.seconds)))
					]))));
};
var $enkidatron$elm_cldr$Cldr$Format$DateTime$foramtZoneIso8601Basic = F2(
	function (zone, posix) {
		return $enkidatron$elm_cldr$Cldr$Format$DateTime$iso8601BasicFormatOffsets(
			A2($enkidatron$elm_cldr$Cldr$Format$DateTime$getOffsets, zone, posix));
	});
var $enkidatron$elm_cldr$Cldr$Format$DateTime$formatDay = F3(
	function (numberWidth, zone, posix) {
		return A2(
			$enkidatron$elm_cldr$Internal$Format$number,
			numberWidth,
			A2($elm$time$Time$toDay, zone, posix));
	});
var $enkidatron$elm_cldr$Cldr$Format$DateTime$formatEra = F3(
	function (eraNames, zone, posix) {
		return A2(
			$enkidatron$elm_cldr$Internal$Format$era,
			eraNames,
			A2($elm$time$Time$toYear, zone, posix));
	});
var $enkidatron$elm_cldr$Internal$DayPeriodRule$bestMatch = F2(
	function (ruleA, ruleB) {
		var _v0 = _Utils_Tuple2(ruleA, ruleB);
		if (_v0.a.$ === 'At') {
			if (_v0.b.$ === 'At') {
				var _v1 = _v0.a;
				var _v2 = _v0.b;
				return $elm$core$Basics$EQ;
			} else {
				var _v3 = _v0.a;
				var _v4 = _v0.b;
				return $elm$core$Basics$GT;
			}
		} else {
			if (_v0.b.$ === 'At') {
				var _v5 = _v0.a;
				var _v6 = _v0.b;
				return $elm$core$Basics$LT;
			} else {
				var _v7 = _v0.a;
				var _v8 = _v0.b;
				return $elm$core$Basics$EQ;
			}
		}
	});
var $enkidatron$elm_cldr$Internal$DayPeriodRule$dayPeriod = function (rule) {
	if (rule.$ === 'At') {
		var name = rule.b;
		return name;
	} else {
		var name = rule.c;
		return name;
	}
};
var $enkidatron$elm_cldr$Internal$Format$period = F2(
	function (periodNames, hour) {
		return (hour > 11) ? periodNames.pm : periodNames.am;
	});
var $enkidatron$elm_cldr$Cldr$Format$DateTime$formatPeriod = F3(
	function (periodNames, zone, posix) {
		return A2(
			$enkidatron$elm_cldr$Internal$Format$period,
			periodNames,
			A2($elm$time$Time$toHour, zone, posix));
	});
var $enkidatron$elm_cldr$Internal$DayPeriodRule$compareHelper = F4(
	function (gran, _v0, zone, posix) {
		var hour = _v0.a;
		var minute = _v0.b;
		switch (gran.$) {
			case 'MatchHour':
				return A2(
					$elm$core$Basics$compare,
					A2($elm$time$Time$toHour, zone, posix),
					hour);
			case 'MatchMinute':
				return A2(
					$elm$core$Basics$compare,
					_Utils_Tuple2(
						A2($elm$time$Time$toHour, zone, posix),
						A2($elm$time$Time$toMinute, zone, posix)),
					_Utils_Tuple2(hour, minute));
			default:
				return A2(
					$elm$core$Basics$compare,
					_Utils_Tuple3(
						A2($elm$time$Time$toHour, zone, posix),
						A2($elm$time$Time$toMinute, zone, posix),
						A2($elm$time$Time$toSecond, zone, posix)),
					_Utils_Tuple3(hour, minute, 0));
		}
	});
var $enkidatron$elm_cldr$Internal$DayPeriodRule$isMatch = F4(
	function (gran, zone, posix, rule) {
		if (rule.$ === 'At') {
			var at = rule.a;
			return _Utils_eq(
				A4($enkidatron$elm_cldr$Internal$DayPeriodRule$compareHelper, gran, at, zone, posix),
				$elm$core$Basics$EQ);
		} else {
			var from = rule.a;
			var before = rule.b;
			return (!_Utils_eq(
				A4($enkidatron$elm_cldr$Internal$DayPeriodRule$compareHelper, gran, from, zone, posix),
				$elm$core$Basics$LT)) && _Utils_eq(
				A4($enkidatron$elm_cldr$Internal$DayPeriodRule$compareHelper, gran, before, zone, posix),
				$elm$core$Basics$LT);
		}
	});
var $elm_community$list_extra$List$Extra$foldl1 = F2(
	function (func, list) {
		if (!list.b) {
			return $elm$core$Maybe$Nothing;
		} else {
			var x = list.a;
			var xs = list.b;
			return $elm$core$Maybe$Just(
				A3($elm$core$List$foldl, func, x, xs));
		}
	});
var $elm_community$list_extra$List$Extra$maximumWith = F2(
	function (comparator, list) {
		return A2(
			$elm_community$list_extra$List$Extra$foldl1,
			F2(
				function (x, y) {
					var _v0 = A2(comparator, x, y);
					if (_v0.$ === 'GT') {
						return x;
					} else {
						return y;
					}
				}),
			list);
	});
var $enkidatron$elm_cldr$Cldr$Format$DateTime$formatFlexibleDayPeriod = F5(
	function (rules, granularity, periodNames, zone, posix) {
		return A2(
			$elm$core$Maybe$withDefault,
			A3($enkidatron$elm_cldr$Cldr$Format$DateTime$formatPeriod, periodNames, zone, posix),
			A2(
				$elm$core$Maybe$andThen,
				function (dayPeriod) {
					return A2($elm$core$Dict$get, dayPeriod, periodNames.dayPeriods);
				},
				A2(
					$elm$core$Maybe$map,
					$enkidatron$elm_cldr$Internal$DayPeriodRule$dayPeriod,
					A2(
						$elm_community$list_extra$List$Extra$maximumWith,
						$enkidatron$elm_cldr$Internal$DayPeriodRule$bestMatch,
						A2(
							$elm$core$List$filter,
							A3($enkidatron$elm_cldr$Internal$DayPeriodRule$isMatch, granularity, zone, posix),
							rules)))));
	});
var $enkidatron$elm_cldr$Cldr$Format$DateTime$doThreeDigitRounding = F2(
	function (decimals, millis) {
		return $elm$core$Basics$round(
			millis / A2($elm$core$Basics$pow, 10, 3 - decimals));
	});
var $elm$time$Time$toMillis = F2(
	function (_v0, time) {
		return A2(
			$elm$core$Basics$modBy,
			1000,
			$elm$time$Time$posixToMillis(time));
	});
var $enkidatron$elm_cldr$Cldr$Format$DateTime$formatFractionalSeconds = F3(
	function (decimals, zone, posix) {
		return $elm$core$String$fromInt(
			A2(
				$enkidatron$elm_cldr$Cldr$Format$DateTime$doThreeDigitRounding,
				decimals,
				A2($elm$time$Time$toMillis, zone, posix)));
	});
var $enkidatron$elm_cldr$Cldr$Format$DateTime$formatHour12From0 = F3(
	function (numberWidth, zone, posix) {
		return A2(
			$enkidatron$elm_cldr$Internal$Format$number,
			numberWidth,
			A2(
				$elm$core$Basics$modBy,
				12,
				A2($elm$time$Time$toHour, zone, posix)));
	});
var $enkidatron$elm_cldr$Cldr$Format$DateTime$replaceZeroWith = F2(
	function (_default, num) {
		return (!num) ? _default : num;
	});
var $enkidatron$elm_cldr$Cldr$Format$DateTime$formatHour12From1 = F3(
	function (numberWidth, zone, posix) {
		return A2(
			$enkidatron$elm_cldr$Internal$Format$number,
			numberWidth,
			A2(
				$enkidatron$elm_cldr$Cldr$Format$DateTime$replaceZeroWith,
				12,
				A2(
					$elm$core$Basics$modBy,
					12,
					A2($elm$time$Time$toHour, zone, posix))));
	});
var $enkidatron$elm_cldr$Cldr$Format$DateTime$formatHour24From0 = F3(
	function (numberWidth, zone, posix) {
		return A2(
			$enkidatron$elm_cldr$Internal$Format$number,
			numberWidth,
			A2($elm$time$Time$toHour, zone, posix));
	});
var $enkidatron$elm_cldr$Cldr$Format$DateTime$formatHour24From1 = F3(
	function (numberWidth, zone, posix) {
		return A2(
			$enkidatron$elm_cldr$Internal$Format$number,
			numberWidth,
			A2(
				$enkidatron$elm_cldr$Cldr$Format$DateTime$replaceZeroWith,
				24,
				A2($elm$time$Time$toHour, zone, posix)));
	});
var $enkidatron$elm_cldr$Cldr$Format$DateTime$formatMinute = F3(
	function (numberWidth, zone, posix) {
		return A2(
			$enkidatron$elm_cldr$Internal$Format$number,
			numberWidth,
			A2($elm$time$Time$toMinute, zone, posix));
	});
var $enkidatron$elm_cldr$Cldr$Format$DateTime$formatMonthHelper = F3(
	function (monthNames, zone, posix) {
		return A2(
			$enkidatron$elm_cldr$Internal$Format$month,
			monthNames,
			A2($elm$time$Time$toMonth, zone, posix));
	});
var $enkidatron$elm_cldr$Cldr$Format$DateTime$formatMonthNumberHelper = F3(
	function (numberWidth, zone, posix) {
		return A2(
			$enkidatron$elm_cldr$Internal$Format$number,
			numberWidth,
			$justinmimbs$date$Date$monthToNumber(
				A2($elm$time$Time$toMonth, zone, posix)));
	});
var $enkidatron$elm_cldr$Cldr$Format$DateTime$formatTextWidthHelper = F3(
	function (formatFun, patterns, textWidth) {
		return formatFun(
			A2($enkidatron$elm_cldr$Internal$Structures$getPattern3, patterns, textWidth));
	});
var $enkidatron$elm_cldr$Cldr$Format$DateTime$formatMonth = F2(
	function (monthPattern3, width) {
		if (width.$ === 'Text') {
			var textWidth = width.a;
			return A3($enkidatron$elm_cldr$Cldr$Format$DateTime$formatTextWidthHelper, $enkidatron$elm_cldr$Cldr$Format$DateTime$formatMonthHelper, monthPattern3, textWidth);
		} else {
			var numberWidth = width.a;
			return $enkidatron$elm_cldr$Cldr$Format$DateTime$formatMonthNumberHelper(numberWidth);
		}
	});
var $enkidatron$elm_cldr$Cldr$Format$DateTime$formatSecond = F3(
	function (numberWidth, zone, posix) {
		return A2(
			$enkidatron$elm_cldr$Internal$Format$number,
			numberWidth,
			A2($elm$time$Time$toSecond, zone, posix));
	});
var $elm$time$Time$toWeekday = F2(
	function (zone, time) {
		var _v0 = A2(
			$elm$core$Basics$modBy,
			7,
			A2(
				$elm$time$Time$flooredDiv,
				A2($elm$time$Time$toAdjustedMinutes, zone, time),
				60 * 24));
		switch (_v0) {
			case 0:
				return $elm$time$Time$Thu;
			case 1:
				return $elm$time$Time$Fri;
			case 2:
				return $elm$time$Time$Sat;
			case 3:
				return $elm$time$Time$Sun;
			case 4:
				return $elm$time$Time$Mon;
			case 5:
				return $elm$time$Time$Tue;
			default:
				return $elm$time$Time$Wed;
		}
	});
var $enkidatron$elm_cldr$Cldr$Format$DateTime$formatWeekday = F3(
	function (weekdayNames, zone, posix) {
		return A2(
			$enkidatron$elm_cldr$Internal$Format$weekday,
			weekdayNames,
			A2($elm$time$Time$toWeekday, zone, posix));
	});
var $enkidatron$elm_cldr$Cldr$Format$DateTime$formatYear = F3(
	function (numberWidth, zone, posix) {
		return A2(
			$enkidatron$elm_cldr$Internal$Format$year,
			numberWidth,
			A2($elm$time$Time$toYear, zone, posix));
	});
var $enkidatron$elm_cldr$Cldr$Format$DateTime$formatYearOfWeek = F3(
	function (numberWidth, zone, posix) {
		return A2(
			$enkidatron$elm_cldr$Internal$Format$year,
			numberWidth,
			$justinmimbs$date$Date$weekYear(
				A2($justinmimbs$date$Date$fromPosix, zone, posix)));
	});
var $enkidatron$elm_cldr$Cldr$Format$DateTime$gmtFormatOffsets = F2(
	function (nameWidth, offsets) {
		var showSeconds = !(!offsets.seconds);
		var showMinutes = (!(!offsets.minutes)) || ((!(!offsets.seconds)) || ((!(!offsets.hours)) && _Utils_eq(nameWidth, $enkidatron$elm_cldr$Internal$FormatSymbols$Long)));
		var showHours = (!(!offsets.hours)) || ((!(!offsets.minutes)) || (!(!offsets.seconds)));
		return $elm$core$String$concat(
			A2(
				$elm$core$List$map,
				$elm$core$Tuple$second,
				A2(
					$elm$core$List$filter,
					$elm$core$Tuple$first,
					_List_fromArray(
						[
							_Utils_Tuple2(true, 'GMT'),
							_Utils_Tuple2(showHours && offsets.offsetIsPositive, '+'),
							_Utils_Tuple2(showHours && (!offsets.offsetIsPositive), '-'),
							_Utils_Tuple2(
							showHours,
							$elm$core$String$fromInt(offsets.hours)),
							_Utils_Tuple2(showMinutes, ':'),
							_Utils_Tuple2(
							showMinutes,
							A3(
								$elm$core$String$padLeft,
								2,
								_Utils_chr('0'),
								$elm$core$String$fromInt(offsets.minutes))),
							_Utils_Tuple2(showSeconds, ':'),
							_Utils_Tuple2(
							showSeconds,
							A3(
								$elm$core$String$padLeft,
								2,
								_Utils_chr('0'),
								$elm$core$String$fromInt(offsets.seconds)))
						]))));
	});
var $enkidatron$elm_cldr$Cldr$Format$DateTime$formatZoneGmtFormat = F3(
	function (nameWidth, zone, posix) {
		return A2(
			$enkidatron$elm_cldr$Cldr$Format$DateTime$gmtFormatOffsets,
			nameWidth,
			A2($enkidatron$elm_cldr$Cldr$Format$DateTime$getOffsets, zone, posix));
	});
var $enkidatron$elm_cldr$Cldr$Format$DateTime$formatZoneGenericNonLocationFormat = $enkidatron$elm_cldr$Cldr$Format$DateTime$formatZoneGmtFormat;
var $enkidatron$elm_cldr$Cldr$Format$DateTime$formatZoneNonLocationFormat = $enkidatron$elm_cldr$Cldr$Format$DateTime$formatZoneGmtFormat;
var $enkidatron$elm_cldr$Cldr$Format$DateTime$formatSymbol = F5(
	function (granularity, internal, zone, posix, symbol) {
		if (symbol.$ === 'Date') {
			switch (symbol.a.$) {
				case 'Era':
					var textWidth = symbol.a.a;
					return A5($enkidatron$elm_cldr$Cldr$Format$DateTime$formatTextWidthHelper, $enkidatron$elm_cldr$Cldr$Format$DateTime$formatEra, internal.eraNames, textWidth, zone, posix);
				case 'Year':
					var numberWidth = symbol.a.a;
					return A3($enkidatron$elm_cldr$Cldr$Format$DateTime$formatYear, numberWidth, zone, posix);
				case 'YearOfWeek':
					var numberWidth = symbol.a.a;
					return A3($enkidatron$elm_cldr$Cldr$Format$DateTime$formatYearOfWeek, numberWidth, zone, posix);
				case 'Month':
					var width = symbol.a.a;
					return A4($enkidatron$elm_cldr$Cldr$Format$DateTime$formatMonth, internal.monthFormatNames, width, zone, posix);
				case 'MonthStandalone':
					var width = symbol.a.a;
					return A4($enkidatron$elm_cldr$Cldr$Format$DateTime$formatMonth, internal.monthStandaloneNames, width, zone, posix);
				case 'Weekday':
					var textWidth = symbol.a.a;
					return A5($enkidatron$elm_cldr$Cldr$Format$DateTime$formatTextWidthHelper, $enkidatron$elm_cldr$Cldr$Format$DateTime$formatWeekday, internal.weekdayFormatNames, textWidth, zone, posix);
				case 'WeekdayStandalone':
					var textWidth = symbol.a.a;
					return A5($enkidatron$elm_cldr$Cldr$Format$DateTime$formatTextWidthHelper, $enkidatron$elm_cldr$Cldr$Format$DateTime$formatWeekday, internal.weekdayStandaloneNames, textWidth, zone, posix);
				default:
					var numberWidth = symbol.a.a;
					return A3($enkidatron$elm_cldr$Cldr$Format$DateTime$formatDay, numberWidth, zone, posix);
			}
		} else {
			switch (symbol.a.$) {
				case 'Period':
					var textWidth = symbol.a.a;
					return A5($enkidatron$elm_cldr$Cldr$Format$DateTime$formatTextWidthHelper, $enkidatron$elm_cldr$Cldr$Format$DateTime$formatPeriod, internal.periodNames, textWidth, zone, posix);
				case 'FlexibleDayPeriod':
					var textWidth = symbol.a.a;
					return A5(
						$enkidatron$elm_cldr$Cldr$Format$DateTime$formatTextWidthHelper,
						A2($enkidatron$elm_cldr$Cldr$Format$DateTime$formatFlexibleDayPeriod, internal.dayPeriodRuleSet, granularity),
						internal.periodNames,
						textWidth,
						zone,
						posix);
				case 'Hour12From1':
					var numberWidth = symbol.a.a;
					return A3($enkidatron$elm_cldr$Cldr$Format$DateTime$formatHour12From1, numberWidth, zone, posix);
				case 'Hour24From0':
					var numberWidth = symbol.a.a;
					return A3($enkidatron$elm_cldr$Cldr$Format$DateTime$formatHour24From0, numberWidth, zone, posix);
				case 'Hour12From0':
					var numberWidth = symbol.a.a;
					return A3($enkidatron$elm_cldr$Cldr$Format$DateTime$formatHour12From0, numberWidth, zone, posix);
				case 'Hour24From1':
					var numberWidth = symbol.a.a;
					return A3($enkidatron$elm_cldr$Cldr$Format$DateTime$formatHour24From1, numberWidth, zone, posix);
				case 'Minute':
					var numberWidth = symbol.a.a;
					return A3($enkidatron$elm_cldr$Cldr$Format$DateTime$formatMinute, numberWidth, zone, posix);
				case 'Second':
					var numberWidth = symbol.a.a;
					return A3($enkidatron$elm_cldr$Cldr$Format$DateTime$formatSecond, numberWidth, zone, posix);
				case 'FractionalSeconds':
					var decimals = symbol.a.a;
					return A3($enkidatron$elm_cldr$Cldr$Format$DateTime$formatFractionalSeconds, decimals, zone, posix);
				case 'ZoneNonLocationFormat':
					var nameWidth = symbol.a.a;
					return A3($enkidatron$elm_cldr$Cldr$Format$DateTime$formatZoneNonLocationFormat, nameWidth, zone, posix);
				case 'ZoneIso8601Basic':
					var _v1 = symbol.a;
					return A2($enkidatron$elm_cldr$Cldr$Format$DateTime$foramtZoneIso8601Basic, zone, posix);
				case 'ZoneGmtFormat':
					var nameWidth = symbol.a.a;
					return A3($enkidatron$elm_cldr$Cldr$Format$DateTime$formatZoneGmtFormat, nameWidth, zone, posix);
				default:
					var nameWidth = symbol.a.a;
					return A3($enkidatron$elm_cldr$Cldr$Format$DateTime$formatZoneGenericNonLocationFormat, nameWidth, zone, posix);
			}
		}
	});
var $enkidatron$elm_cldr$Internal$DayPeriodRule$MatchHour = {$: 'MatchHour'};
var $enkidatron$elm_cldr$Internal$DayPeriodRule$MatchMinute = {$: 'MatchMinute'};
var $enkidatron$elm_cldr$Internal$DayPeriodRule$MatchSecond = {$: 'MatchSecond'};
var $enkidatron$elm_cldr$Internal$DayPeriodRule$granularityHelper = F2(
	function (granSoFar, symbols) {
		granularityHelper:
		while (true) {
			_v0$3:
			while (true) {
				if (!symbols.b) {
					return granSoFar;
				} else {
					if ((symbols.a.$ === 'Symbol') && (symbols.a.a.$ === 'Time')) {
						switch (symbols.a.a.a.$) {
							case 'Minute':
								var rest = symbols.b;
								var $temp$granSoFar = $enkidatron$elm_cldr$Internal$DayPeriodRule$MatchMinute,
									$temp$symbols = rest;
								granSoFar = $temp$granSoFar;
								symbols = $temp$symbols;
								continue granularityHelper;
							case 'Second':
								return $enkidatron$elm_cldr$Internal$DayPeriodRule$MatchSecond;
							default:
								break _v0$3;
						}
					} else {
						break _v0$3;
					}
				}
			}
			var rest = symbols.b;
			var $temp$granSoFar = granSoFar,
				$temp$symbols = rest;
			granSoFar = $temp$granSoFar;
			symbols = $temp$symbols;
			continue granularityHelper;
		}
	});
var $enkidatron$elm_cldr$Internal$DayPeriodRule$granularity = $enkidatron$elm_cldr$Internal$DayPeriodRule$granularityHelper($enkidatron$elm_cldr$Internal$DayPeriodRule$MatchHour);
var $enkidatron$elm_cldr$Cldr$Format$DateTime$formatDateTime = F4(
	function (internal, symbols, zone, posix) {
		return $elm$core$String$concat(
			A2(
				$elm$core$List$map,
				$enkidatron$elm_cldr$Internal$FormatSymbols$unwrap(
					A4(
						$enkidatron$elm_cldr$Cldr$Format$DateTime$formatSymbol,
						$enkidatron$elm_cldr$Internal$DayPeriodRule$granularity(symbols),
						internal,
						zone,
						posix)),
				symbols));
	});
var $elm$core$List$concatMap = F2(
	function (f, list) {
		return $elm$core$List$concat(
			A2($elm$core$List$map, f, list));
	});
var $enkidatron$elm_cldr$Cldr$Format$DateTime$expandDateTimeTokenToFormatSymbols = F3(
	function (dateSymbols, timeSymbols, token) {
		switch (token.$) {
			case 'DateGoesHere':
				return A2(
					$elm$core$List$map,
					$enkidatron$elm_cldr$Internal$FormatSymbols$mapLiteral($enkidatron$elm_cldr$Internal$FormatSymbols$Date),
					dateSymbols);
			case 'TimeGoesHere':
				return A2(
					$elm$core$List$map,
					$enkidatron$elm_cldr$Internal$FormatSymbols$mapLiteral($enkidatron$elm_cldr$Internal$FormatSymbols$Time),
					timeSymbols);
			default:
				var words = token.a;
				return _List_fromArray(
					[
						$enkidatron$elm_cldr$Internal$FormatSymbols$Literal(words)
					]);
		}
	});
var $enkidatron$elm_cldr$Internal$Options$rankFractionalDigits = function (digits) {
	switch (digits.$) {
		case 'One':
			return 1;
		case 'Two':
			return 2;
		default:
			return 3;
	}
};
var $enkidatron$elm_cldr$Internal$Options$rankName = function (name) {
	if (name.$ === 'ShortName') {
		return 4;
	} else {
		return 5;
	}
};
var $enkidatron$elm_cldr$Internal$Options$scoreHour12 = F2(
	function (requested, candidate) {
		var _v0 = _Utils_Tuple2(requested, candidate);
		if ((_v0.a.$ === 'Just') && (_v0.b.$ === 'Just')) {
			var req = _v0.a.a;
			var can = _v0.b.a;
			return (!_Utils_eq(req, can)) ? (-1000) : 0;
		} else {
			return 0;
		}
	});
var $enkidatron$elm_cldr$Internal$Options$timeMatchScore = F2(
	function (requested, candidate) {
		return $elm$core$List$sum(
			_List_fromArray(
				[
					A3($enkidatron$elm_cldr$Internal$Options$score, $enkidatron$elm_cldr$Internal$Options$rankText, requested.period, candidate.period),
					A3($enkidatron$elm_cldr$Internal$Options$score, $enkidatron$elm_cldr$Internal$Options$rankText, requested.dayPeriod, candidate.dayPeriod),
					A3($enkidatron$elm_cldr$Internal$Options$score, $enkidatron$elm_cldr$Internal$Options$rankNumber, requested.hour, candidate.hour),
					A3($enkidatron$elm_cldr$Internal$Options$score, $enkidatron$elm_cldr$Internal$Options$rankNumber, requested.minute, candidate.minute),
					A3($enkidatron$elm_cldr$Internal$Options$score, $enkidatron$elm_cldr$Internal$Options$rankNumber, requested.second, candidate.second),
					A3($enkidatron$elm_cldr$Internal$Options$score, $enkidatron$elm_cldr$Internal$Options$rankFractionalDigits, requested.fractionalSecondDigits, candidate.fractionalSecondDigits),
					A3($enkidatron$elm_cldr$Internal$Options$score, $enkidatron$elm_cldr$Internal$Options$rankName, requested.zone, candidate.zone),
					A2($enkidatron$elm_cldr$Internal$Options$scoreHour12, requested.hour12, candidate.hour12)
				]));
	});
var $enkidatron$elm_cldr$Internal$Options$dateTimeMatchScore = F2(
	function (requested, candidate) {
		return A2($enkidatron$elm_cldr$Internal$Options$dateMatchScore, requested, candidate) + A2($enkidatron$elm_cldr$Internal$Options$timeMatchScore, requested, candidate);
	});
var $enkidatron$elm_cldr$Internal$Options$dateToDateTime = function (opts) {
	return {day: opts.day, dayPeriod: $elm$core$Maybe$Nothing, era: opts.era, fractionalSecondDigits: $elm$core$Maybe$Nothing, hour: $elm$core$Maybe$Nothing, hour12: $elm$core$Maybe$Nothing, minute: $elm$core$Maybe$Nothing, month: opts.month, period: $elm$core$Maybe$Nothing, second: $elm$core$Maybe$Nothing, weekday: opts.weekday, year: opts.year, zone: $elm$core$Maybe$Nothing};
};
var $enkidatron$elm_cldr$Internal$Options$timeToDateTime = function (opts) {
	return {day: $elm$core$Maybe$Nothing, dayPeriod: opts.dayPeriod, era: $elm$core$Maybe$Nothing, fractionalSecondDigits: opts.fractionalSecondDigits, hour: opts.hour, hour12: opts.hour12, minute: opts.minute, month: $elm$core$Maybe$Nothing, period: opts.period, second: opts.second, weekday: $elm$core$Maybe$Nothing, year: $elm$core$Maybe$Nothing, zone: opts.zone};
};
var $enkidatron$elm_cldr$Internal$Locale$toDateTimeAvailableFormat = function (af) {
	switch (af.$) {
		case 'DateTimeAF':
			var format = af.a;
			return format;
		case 'TimeAF':
			var options = af.a.options;
			var formatSymbols = af.a.formatSymbols;
			return {
				formatSymbols: A2(
					$elm$core$List$map,
					$enkidatron$elm_cldr$Internal$FormatSymbols$mapLiteral($enkidatron$elm_cldr$Internal$FormatSymbols$Time),
					formatSymbols),
				options: $enkidatron$elm_cldr$Internal$Options$timeToDateTime(options)
			};
		default:
			var options = af.a.options;
			var formatSymbols = af.a.formatSymbols;
			return {
				formatSymbols: A2(
					$elm$core$List$map,
					$enkidatron$elm_cldr$Internal$FormatSymbols$mapLiteral($enkidatron$elm_cldr$Internal$FormatSymbols$Date),
					formatSymbols),
				options: $enkidatron$elm_cldr$Internal$Options$dateToDateTime(options)
			};
	}
};
var $enkidatron$elm_cldr$Internal$FormatSymbols$Convert$fractionalSeconds = function (opt) {
	switch (opt.$) {
		case 'One':
			return 1;
		case 'Two':
			return 2;
		default:
			return 3;
	}
};
var $enkidatron$elm_cldr$Internal$FormatSymbols$Expand$hourHelper = F4(
	function (requestedHourType, info, currentWidth, requested) {
		var width = A3($elm_community$maybe_extra$Maybe$Extra$unwrap, currentWidth, $enkidatron$elm_cldr$Internal$FormatSymbols$Convert$numberWidth, requested);
		if (requestedHourType.$ === 'Just') {
			if (requestedHourType.a.$ === 'Hour12') {
				var _v1 = requestedHourType.a;
				return info.hour12(width);
			} else {
				var _v2 = requestedHourType.a;
				return info.hour24(width);
			}
		} else {
			return info._default(width);
		}
	});
var $enkidatron$elm_cldr$Internal$FormatSymbols$Convert$nameWidth = function (opt) {
	if (opt.$ === 'LongName') {
		return $enkidatron$elm_cldr$Internal$FormatSymbols$Long;
	} else {
		return $enkidatron$elm_cldr$Internal$FormatSymbols$Short;
	}
};
var $enkidatron$elm_cldr$Internal$FormatSymbols$Expand$time = F2(
	function (requested, symbol) {
		switch (symbol.$) {
			case 'Period':
				var period = symbol.a;
				return $enkidatron$elm_cldr$Internal$FormatSymbols$Period(
					A3($elm_community$maybe_extra$Maybe$Extra$unwrap, period, $enkidatron$elm_cldr$Internal$FormatSymbols$Convert$textWidth, requested.period));
			case 'FlexibleDayPeriod':
				var flexDayPeriod = symbol.a;
				return $enkidatron$elm_cldr$Internal$FormatSymbols$FlexibleDayPeriod(
					A3($elm_community$maybe_extra$Maybe$Extra$unwrap, flexDayPeriod, $enkidatron$elm_cldr$Internal$FormatSymbols$Convert$textWidth, requested.dayPeriod));
			case 'Hour12From1':
				var hour = symbol.a;
				return A4(
					$enkidatron$elm_cldr$Internal$FormatSymbols$Expand$hourHelper,
					requested.hour12,
					{_default: $enkidatron$elm_cldr$Internal$FormatSymbols$Hour12From1, hour12: $enkidatron$elm_cldr$Internal$FormatSymbols$Hour12From1, hour24: $enkidatron$elm_cldr$Internal$FormatSymbols$Hour24From1},
					hour,
					requested.hour);
			case 'Hour24From0':
				var hour = symbol.a;
				return A4(
					$enkidatron$elm_cldr$Internal$FormatSymbols$Expand$hourHelper,
					requested.hour12,
					{_default: $enkidatron$elm_cldr$Internal$FormatSymbols$Hour24From0, hour12: $enkidatron$elm_cldr$Internal$FormatSymbols$Hour12From0, hour24: $enkidatron$elm_cldr$Internal$FormatSymbols$Hour24From0},
					hour,
					requested.hour);
			case 'Hour12From0':
				var hour = symbol.a;
				return A4(
					$enkidatron$elm_cldr$Internal$FormatSymbols$Expand$hourHelper,
					requested.hour12,
					{_default: $enkidatron$elm_cldr$Internal$FormatSymbols$Hour12From0, hour12: $enkidatron$elm_cldr$Internal$FormatSymbols$Hour12From0, hour24: $enkidatron$elm_cldr$Internal$FormatSymbols$Hour24From0},
					hour,
					requested.hour);
			case 'Hour24From1':
				var hour = symbol.a;
				return A4(
					$enkidatron$elm_cldr$Internal$FormatSymbols$Expand$hourHelper,
					requested.hour12,
					{_default: $enkidatron$elm_cldr$Internal$FormatSymbols$Hour24From1, hour12: $enkidatron$elm_cldr$Internal$FormatSymbols$Hour12From1, hour24: $enkidatron$elm_cldr$Internal$FormatSymbols$Hour24From1},
					hour,
					requested.hour);
			case 'Minute':
				var minute = symbol.a;
				return $enkidatron$elm_cldr$Internal$FormatSymbols$Minute(
					A3($elm_community$maybe_extra$Maybe$Extra$unwrap, minute, $enkidatron$elm_cldr$Internal$FormatSymbols$Convert$numberWidth, requested.minute));
			case 'Second':
				var second = symbol.a;
				return $enkidatron$elm_cldr$Internal$FormatSymbols$Second(
					A3($elm_community$maybe_extra$Maybe$Extra$unwrap, second, $enkidatron$elm_cldr$Internal$FormatSymbols$Convert$numberWidth, requested.second));
			case 'FractionalSeconds':
				var frac = symbol.a;
				return $enkidatron$elm_cldr$Internal$FormatSymbols$FractionalSeconds(
					A3($elm_community$maybe_extra$Maybe$Extra$unwrap, frac, $enkidatron$elm_cldr$Internal$FormatSymbols$Convert$fractionalSeconds, requested.fractionalSecondDigits));
			case 'ZoneNonLocationFormat':
				var zone = symbol.a;
				return $enkidatron$elm_cldr$Internal$FormatSymbols$ZoneNonLocationFormat(
					A3($elm_community$maybe_extra$Maybe$Extra$unwrap, zone, $enkidatron$elm_cldr$Internal$FormatSymbols$Convert$nameWidth, requested.zone));
			case 'ZoneIso8601Basic':
				return $enkidatron$elm_cldr$Internal$FormatSymbols$ZoneIso8601Basic;
			case 'ZoneGmtFormat':
				var zone = symbol.a;
				return $enkidatron$elm_cldr$Internal$FormatSymbols$ZoneGmtFormat(
					A3($elm_community$maybe_extra$Maybe$Extra$unwrap, zone, $enkidatron$elm_cldr$Internal$FormatSymbols$Convert$nameWidth, requested.zone));
			default:
				var zone = symbol.a;
				return $enkidatron$elm_cldr$Internal$FormatSymbols$ZoneGenericNonLocationFormat(
					A3($elm_community$maybe_extra$Maybe$Extra$unwrap, zone, $enkidatron$elm_cldr$Internal$FormatSymbols$Convert$nameWidth, requested.zone));
		}
	});
var $enkidatron$elm_cldr$Cldr$Format$DateTime$expandSymbol = F2(
	function (requested, symbol) {
		if (symbol.$ === 'Date') {
			var dateSymbol = symbol.a;
			return $enkidatron$elm_cldr$Internal$FormatSymbols$Date(
				A2($enkidatron$elm_cldr$Internal$FormatSymbols$Expand$date, requested, dateSymbol));
		} else {
			var timeSymbol = symbol.a;
			return $enkidatron$elm_cldr$Internal$FormatSymbols$Time(
				A2($enkidatron$elm_cldr$Internal$FormatSymbols$Expand$time, requested, timeSymbol));
		}
	});
var $enkidatron$elm_cldr$Cldr$Format$DateTime$matchMaybe = F2(
	function (left, right) {
		var _v0 = _Utils_Tuple2(left, right);
		_v0$2:
		while (true) {
			if (_v0.a.$ === 'Just') {
				if (_v0.b.$ === 'Just') {
					return true;
				} else {
					break _v0$2;
				}
			} else {
				if (_v0.b.$ === 'Nothing') {
					var _v1 = _v0.a;
					var _v2 = _v0.b;
					return true;
				} else {
					break _v0$2;
				}
			}
		}
		return false;
	});
var $enkidatron$elm_cldr$Cldr$Format$DateTime$fieldsDoNotMatch = F2(
	function (a, b) {
		return !A2(
			$elm$core$List$all,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A2($enkidatron$elm_cldr$Cldr$Format$DateTime$matchMaybe, a.era, b.era),
					A2($enkidatron$elm_cldr$Cldr$Format$DateTime$matchMaybe, a.year, b.year),
					A2($enkidatron$elm_cldr$Cldr$Format$DateTime$matchMaybe, a.month, b.month),
					A2($enkidatron$elm_cldr$Cldr$Format$DateTime$matchMaybe, a.day, b.day),
					A2($enkidatron$elm_cldr$Cldr$Format$DateTime$matchMaybe, a.weekday, b.weekday),
					A2($enkidatron$elm_cldr$Cldr$Format$DateTime$matchMaybe, a.period, b.period),
					A2($enkidatron$elm_cldr$Cldr$Format$DateTime$matchMaybe, a.hour, b.hour),
					A2($enkidatron$elm_cldr$Cldr$Format$DateTime$matchMaybe, a.minute, b.minute),
					A2($enkidatron$elm_cldr$Cldr$Format$DateTime$matchMaybe, a.second, b.second),
					A2($enkidatron$elm_cldr$Cldr$Format$DateTime$matchMaybe, a.fractionalSecondDigits, b.fractionalSecondDigits),
					A2($enkidatron$elm_cldr$Cldr$Format$DateTime$matchMaybe, a.zone, b.zone)
				]));
	});
var $enkidatron$elm_cldr$Cldr$Format$DateTime$FoundNeither = {$: 'FoundNeither'};
var $enkidatron$elm_cldr$Cldr$Format$DateTime$FoundWeekday = {$: 'FoundWeekday'};
var $enkidatron$elm_cldr$Cldr$Format$DateTime$FoundWideMonth = {$: 'FoundWideMonth'};
var $enkidatron$elm_cldr$Cldr$Format$Length$Full = {$: 'Full'};
var $enkidatron$elm_cldr$Cldr$Format$Length$Long = {$: 'Long'};
var $enkidatron$elm_cldr$Cldr$Format$Length$Medium = {$: 'Medium'};
var $enkidatron$elm_cldr$Cldr$Format$DateTime$lengthForDatePatternHelper = F2(
	function (foundSoFar, symbols) {
		lengthForDatePatternHelper:
		while (true) {
			var _v0 = _Utils_Tuple2(foundSoFar, symbols);
			_v0$7:
			while (true) {
				if (!_v0.b.b) {
					if (_v0.a.$ === 'FoundWideMonth') {
						var _v1 = _v0.a;
						return $enkidatron$elm_cldr$Cldr$Format$Length$Long;
					} else {
						return $enkidatron$elm_cldr$Cldr$Format$Length$Short;
					}
				} else {
					if (_v0.b.a.$ === 'Symbol') {
						switch (_v0.b.a.a.$) {
							case 'Weekday':
								if (_v0.a.$ === 'FoundWideMonth') {
									var _v7 = _v0.a;
									var _v8 = _v0.b;
									return $enkidatron$elm_cldr$Cldr$Format$Length$Full;
								} else {
									var _v9 = _v0.b;
									var rest = _v9.b;
									var $temp$foundSoFar = $enkidatron$elm_cldr$Cldr$Format$DateTime$FoundWeekday,
										$temp$symbols = rest;
									foundSoFar = $temp$foundSoFar;
									symbols = $temp$symbols;
									continue lengthForDatePatternHelper;
								}
							case 'Month':
								if (_v0.b.a.a.a.$ === 'Text') {
									switch (_v0.b.a.a.a.a.$) {
										case 'Wide':
											if (_v0.a.$ === 'FoundWeekday') {
												var _v2 = _v0.a;
												var _v3 = _v0.b;
												var _v4 = _v3.a.a.a.a;
												return $enkidatron$elm_cldr$Cldr$Format$Length$Full;
											} else {
												var _v5 = _v0.b;
												var _v6 = _v5.a.a.a.a;
												var rest = _v5.b;
												var $temp$foundSoFar = $enkidatron$elm_cldr$Cldr$Format$DateTime$FoundWideMonth,
													$temp$symbols = rest;
												foundSoFar = $temp$foundSoFar;
												symbols = $temp$symbols;
												continue lengthForDatePatternHelper;
											}
										case 'Abbreviated':
											var _v10 = _v0.b;
											var _v11 = _v10.a.a.a.a;
											return $enkidatron$elm_cldr$Cldr$Format$Length$Medium;
										default:
											break _v0$7;
									}
								} else {
									break _v0$7;
								}
							default:
								break _v0$7;
						}
					} else {
						break _v0$7;
					}
				}
			}
			var _v12 = _v0.b;
			var rest = _v12.b;
			var $temp$foundSoFar = foundSoFar,
				$temp$symbols = rest;
			foundSoFar = $temp$foundSoFar;
			symbols = $temp$symbols;
			continue lengthForDatePatternHelper;
		}
	});
var $enkidatron$elm_cldr$Cldr$Format$DateTime$lengthForDatePattern = $enkidatron$elm_cldr$Cldr$Format$DateTime$lengthForDatePatternHelper($enkidatron$elm_cldr$Cldr$Format$DateTime$FoundNeither);
var $enkidatron$elm_cldr$Cldr$Format$DateTime$combineBestFormats = F3(
	function (internal, dateSymbols, timeSymbols) {
		return A2(
			$elm$core$List$concatMap,
			A2($enkidatron$elm_cldr$Cldr$Format$DateTime$expandDateTimeTokenToFormatSymbols, dateSymbols, timeSymbols),
			A2(
				$enkidatron$elm_cldr$Internal$Structures$getPattern,
				internal.dateTimeTokens,
				$enkidatron$elm_cldr$Cldr$Format$DateTime$lengthForDatePattern(dateSymbols)));
	});
var $enkidatron$elm_cldr$Cldr$Format$DateTime$findBestDateFormat = F2(
	function (internal, requestedDateOptions) {
		return A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.formatSymbols;
				},
				A2(
					$elm_community$list_extra$List$Extra$maximumBy,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.options;
						},
						$enkidatron$elm_cldr$Internal$Options$dateMatchScore(requestedDateOptions)),
					A2($elm$core$List$filterMap, $enkidatron$elm_cldr$Internal$Locale$toDateAvailableFormat, internal.availableFormats))));
	});
var $enkidatron$elm_cldr$Internal$Locale$toTimeAvailableFormat = function (af) {
	switch (af.$) {
		case 'TimeAF':
			var format = af.a;
			return $elm$core$Maybe$Just(format);
		case 'DateTimeAF':
			return $elm$core$Maybe$Nothing;
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $enkidatron$elm_cldr$Cldr$Format$DateTime$findBestTimeFormat = F2(
	function (internal, requestedTimeOptions) {
		return A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.formatSymbols;
				},
				A2(
					$elm_community$list_extra$List$Extra$maximumBy,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.options;
						},
						$enkidatron$elm_cldr$Internal$Options$timeMatchScore(requestedTimeOptions)),
					A2($elm$core$List$filterMap, $enkidatron$elm_cldr$Internal$Locale$toTimeAvailableFormat, internal.availableFormats))));
	});
var $enkidatron$elm_cldr$Cldr$Format$DateTime$findAndCombineBestFormats = F3(
	function (internal, dateOptions, timeOptions) {
		return A3(
			$enkidatron$elm_cldr$Cldr$Format$DateTime$combineBestFormats,
			internal,
			A2(
				$elm$core$List$map,
				$enkidatron$elm_cldr$Internal$FormatSymbols$mapLiteral(
					$enkidatron$elm_cldr$Internal$FormatSymbols$Expand$date(dateOptions)),
				A2($enkidatron$elm_cldr$Cldr$Format$DateTime$findBestDateFormat, internal, dateOptions)),
			A2(
				$elm$core$List$map,
				$enkidatron$elm_cldr$Internal$FormatSymbols$mapLiteral(
					$enkidatron$elm_cldr$Internal$FormatSymbols$Expand$time(timeOptions)),
				A2($enkidatron$elm_cldr$Cldr$Format$DateTime$findBestTimeFormat, internal, timeOptions)));
	});
var $enkidatron$elm_cldr$Internal$Options$splitOptions = function (fullOptions) {
	return ($enkidatron$elm_cldr$Internal$Options$hasDateFields(fullOptions) && $enkidatron$elm_cldr$Internal$Options$hasTimeFields(fullOptions)) ? $elm$core$Maybe$Just(
		_Utils_Tuple2(
			$enkidatron$elm_cldr$Internal$Options$dateSubset(fullOptions),
			$enkidatron$elm_cldr$Internal$Options$timeSubset(fullOptions))) : $elm$core$Maybe$Nothing;
};
var $enkidatron$elm_cldr$Cldr$Format$DateTime$useCombinedFormatsIfNecessary = F3(
	function (internal, requestedOptions, bestMatch) {
		var _v0 = _Utils_Tuple2(
			$enkidatron$elm_cldr$Internal$Options$splitOptions(requestedOptions),
			A2($enkidatron$elm_cldr$Cldr$Format$DateTime$fieldsDoNotMatch, requestedOptions, bestMatch.options));
		if ((_v0.a.$ === 'Just') && _v0.b) {
			var _v1 = _v0.a.a;
			var dateOptions = _v1.a;
			var timeOptions = _v1.b;
			return A3($enkidatron$elm_cldr$Cldr$Format$DateTime$findAndCombineBestFormats, internal, dateOptions, timeOptions);
		} else {
			return A2(
				$elm$core$List$map,
				$enkidatron$elm_cldr$Internal$FormatSymbols$mapLiteral(
					$enkidatron$elm_cldr$Cldr$Format$DateTime$expandSymbol(requestedOptions)),
				bestMatch.formatSymbols);
		}
	});
var $enkidatron$elm_cldr$Cldr$Format$DateTime$formatSymbolsFromOptions = F2(
	function (internal, requestedOptions) {
		return A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				A2($enkidatron$elm_cldr$Cldr$Format$DateTime$useCombinedFormatsIfNecessary, internal, requestedOptions),
				A2(
					$elm_community$list_extra$List$Extra$maximumBy,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.options;
						},
						$enkidatron$elm_cldr$Internal$Options$dateTimeMatchScore(requestedOptions)),
					A2($elm$core$List$map, $enkidatron$elm_cldr$Internal$Locale$toDateTimeAvailableFormat, internal.availableFormats))));
	});
var $enkidatron$elm_cldr$Internal$Options$toHourType = function (hour12ByDefault) {
	return hour12ByDefault ? $enkidatron$elm_cldr$Cldr$Format$Options$Hour12 : $enkidatron$elm_cldr$Cldr$Format$Options$Hour24;
};
var $enkidatron$elm_cldr$Internal$Options$setLocaleDefaultHourType = F2(
	function (hour12ByDefault, opts) {
		return _Utils_update(
			opts,
			{
				hour12: $elm$core$Maybe$Just(
					A2(
						$elm$core$Maybe$withDefault,
						$enkidatron$elm_cldr$Internal$Options$toHourType(hour12ByDefault),
						opts.hour12))
			});
	});
var $enkidatron$elm_cldr$Cldr$Format$DateTime$formatSymbolsForType = F2(
	function (internal, formatType) {
		switch (formatType.$) {
			case 'DateOnly':
				var length = formatType.a;
				return A2(
					$elm$core$List$map,
					$enkidatron$elm_cldr$Internal$FormatSymbols$mapLiteral($enkidatron$elm_cldr$Internal$FormatSymbols$Date),
					A2($enkidatron$elm_cldr$Internal$Structures$getPattern, internal.dateSymbols, length));
			case 'TimeOnly':
				var length = formatType.a;
				return A2(
					$elm$core$List$map,
					$enkidatron$elm_cldr$Internal$FormatSymbols$mapLiteral($enkidatron$elm_cldr$Internal$FormatSymbols$Time),
					A2($enkidatron$elm_cldr$Internal$Structures$getPattern, internal.timeSymbols, length));
			case 'DateAndTime':
				var date = formatType.a.date;
				var time = formatType.a.time;
				return A2(
					$elm$core$List$concatMap,
					A2(
						$enkidatron$elm_cldr$Cldr$Format$DateTime$expandDateTimeTokenToFormatSymbols,
						A2($enkidatron$elm_cldr$Internal$Structures$getPattern, internal.dateSymbols, date),
						A2($enkidatron$elm_cldr$Internal$Structures$getPattern, internal.timeSymbols, time)),
					A2($enkidatron$elm_cldr$Internal$Structures$getPattern, internal.dateTimeTokens, date));
			default:
				var options = formatType.a;
				return A2(
					$enkidatron$elm_cldr$Cldr$Format$DateTime$formatSymbolsFromOptions,
					internal,
					A2($enkidatron$elm_cldr$Internal$Options$setLocaleDefaultHourType, internal.hour12ByDefault, options));
		}
	});
var $enkidatron$elm_cldr$Cldr$Format$DateTime$format = F2(
	function (formatType, _v0) {
		var internal = _v0.a;
		return A2(
			$enkidatron$elm_cldr$Cldr$Format$DateTime$formatDateTime,
			internal,
			A2($enkidatron$elm_cldr$Cldr$Format$DateTime$formatSymbolsForType, internal, formatType));
	});
var $enkidatron$elm_cldr$Cldr$Format$DateTime$DateAndTime = function (a) {
	return {$: 'DateAndTime', a: a};
};
var $enkidatron$elm_cldr$Cldr$Format$DateTime$short = $enkidatron$elm_cldr$Cldr$Format$DateTime$DateAndTime(
	{date: $enkidatron$elm_cldr$Cldr$Format$Length$Short, time: $enkidatron$elm_cldr$Cldr$Format$Length$Short});
var $author$project$Calc$formatDateTimeLocaleAware = F3(
	function (locale, timeZone, maybePosix) {
		return A2(
			$elm$core$Maybe$map,
			$author$project$StudioString$withoutObject,
			A2(
				$elm$core$Maybe$map,
				A3($enkidatron$elm_cldr$Cldr$Format$DateTime$format, $enkidatron$elm_cldr$Cldr$Format$DateTime$short, locale, timeZone),
				maybePosix));
	});
var $myrho$elm_round$Round$addSign = F2(
	function (signed, str) {
		var isNotZero = A2(
			$elm$core$List$any,
			function (c) {
				return (!_Utils_eq(
					c,
					_Utils_chr('0'))) && (!_Utils_eq(
					c,
					_Utils_chr('.')));
			},
			$elm$core$String$toList(str));
		return _Utils_ap(
			(signed && isNotZero) ? '-' : '',
			str);
	});
var $elm$core$String$fromFloat = _String_fromNumber;
var $elm$core$Char$fromCode = _Char_fromCode;
var $myrho$elm_round$Round$increaseNum = function (_v0) {
	var head = _v0.a;
	var tail = _v0.b;
	if (_Utils_eq(
		head,
		_Utils_chr('9'))) {
		var _v1 = $elm$core$String$uncons(tail);
		if (_v1.$ === 'Nothing') {
			return '01';
		} else {
			var headtail = _v1.a;
			return A2(
				$elm$core$String$cons,
				_Utils_chr('0'),
				$myrho$elm_round$Round$increaseNum(headtail));
		}
	} else {
		var c = $elm$core$Char$toCode(head);
		return ((c >= 48) && (c < 57)) ? A2(
			$elm$core$String$cons,
			$elm$core$Char$fromCode(c + 1),
			tail) : '0';
	}
};
var $elm$core$Basics$isInfinite = _Basics_isInfinite;
var $elm$core$Basics$isNaN = _Basics_isNaN;
var $elm$core$String$padRight = F3(
	function (n, _char, string) {
		return _Utils_ap(
			string,
			A2(
				$elm$core$String$repeat,
				n - $elm$core$String$length(string),
				$elm$core$String$fromChar(_char)));
	});
var $elm$core$String$reverse = _String_reverse;
var $myrho$elm_round$Round$splitComma = function (str) {
	var _v0 = A2($elm$core$String$split, '.', str);
	if (_v0.b) {
		if (_v0.b.b) {
			var before = _v0.a;
			var _v1 = _v0.b;
			var after = _v1.a;
			return _Utils_Tuple2(before, after);
		} else {
			var before = _v0.a;
			return _Utils_Tuple2(before, '0');
		}
	} else {
		return _Utils_Tuple2('0', '0');
	}
};
var $elm$core$String$dropLeft = F2(
	function (n, string) {
		return (n < 1) ? string : A3(
			$elm$core$String$slice,
			n,
			$elm$core$String$length(string),
			string);
	});
var $myrho$elm_round$Round$toDecimal = function (fl) {
	var _v0 = A2(
		$elm$core$String$split,
		'e',
		$elm$core$String$fromFloat(
			$elm$core$Basics$abs(fl)));
	if (_v0.b) {
		if (_v0.b.b) {
			var num = _v0.a;
			var _v1 = _v0.b;
			var exp = _v1.a;
			var e = A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$String$toInt(
					A2($elm$core$String$startsWith, '+', exp) ? A2($elm$core$String$dropLeft, 1, exp) : exp));
			var _v2 = $myrho$elm_round$Round$splitComma(num);
			var before = _v2.a;
			var after = _v2.b;
			var total = _Utils_ap(before, after);
			var zeroed = (e < 0) ? A2(
				$elm$core$Maybe$withDefault,
				'0',
				A2(
					$elm$core$Maybe$map,
					function (_v3) {
						var a = _v3.a;
						var b = _v3.b;
						return a + ('.' + b);
					},
					A2(
						$elm$core$Maybe$map,
						$elm$core$Tuple$mapFirst($elm$core$String$fromChar),
						$elm$core$String$uncons(
							_Utils_ap(
								A2(
									$elm$core$String$repeat,
									$elm$core$Basics$abs(e),
									'0'),
								total))))) : A3(
				$elm$core$String$padRight,
				e + 1,
				_Utils_chr('0'),
				total);
			return _Utils_ap(
				(fl < 0) ? '-' : '',
				zeroed);
		} else {
			var num = _v0.a;
			return _Utils_ap(
				(fl < 0) ? '-' : '',
				num);
		}
	} else {
		return '';
	}
};
var $myrho$elm_round$Round$roundFun = F3(
	function (functor, s, fl) {
		if ($elm$core$Basics$isInfinite(fl) || $elm$core$Basics$isNaN(fl)) {
			return $elm$core$String$fromFloat(fl);
		} else {
			var signed = fl < 0;
			var _v0 = $myrho$elm_round$Round$splitComma(
				$myrho$elm_round$Round$toDecimal(
					$elm$core$Basics$abs(fl)));
			var before = _v0.a;
			var after = _v0.b;
			var r = $elm$core$String$length(before) + s;
			var normalized = _Utils_ap(
				A2($elm$core$String$repeat, (-r) + 1, '0'),
				A3(
					$elm$core$String$padRight,
					r,
					_Utils_chr('0'),
					_Utils_ap(before, after)));
			var totalLen = $elm$core$String$length(normalized);
			var roundDigitIndex = A2($elm$core$Basics$max, 1, r);
			var increase = A2(
				functor,
				signed,
				A3($elm$core$String$slice, roundDigitIndex, totalLen, normalized));
			var remains = A3($elm$core$String$slice, 0, roundDigitIndex, normalized);
			var num = increase ? $elm$core$String$reverse(
				A2(
					$elm$core$Maybe$withDefault,
					'1',
					A2(
						$elm$core$Maybe$map,
						$myrho$elm_round$Round$increaseNum,
						$elm$core$String$uncons(
							$elm$core$String$reverse(remains))))) : remains;
			var numLen = $elm$core$String$length(num);
			var numZeroed = (num === '0') ? num : ((s <= 0) ? _Utils_ap(
				num,
				A2(
					$elm$core$String$repeat,
					$elm$core$Basics$abs(s),
					'0')) : ((_Utils_cmp(
				s,
				$elm$core$String$length(after)) < 0) ? (A3($elm$core$String$slice, 0, numLen - s, num) + ('.' + A3($elm$core$String$slice, numLen - s, numLen, num))) : _Utils_ap(
				before + '.',
				A3(
					$elm$core$String$padRight,
					s,
					_Utils_chr('0'),
					after))));
			return A2($myrho$elm_round$Round$addSign, signed, numZeroed);
		}
	});
var $myrho$elm_round$Round$round = $myrho$elm_round$Round$roundFun(
	F2(
		function (signed, str) {
			var _v0 = $elm$core$String$uncons(str);
			if (_v0.$ === 'Nothing') {
				return false;
			} else {
				if ('5' === _v0.a.a.valueOf()) {
					if (_v0.a.b === '') {
						var _v1 = _v0.a;
						return !signed;
					} else {
						var _v2 = _v0.a;
						return true;
					}
				} else {
					var _v3 = _v0.a;
					var _int = _v3.a;
					return function (i) {
						return ((i > 53) && signed) || ((i >= 53) && (!signed));
					}(
						$elm$core$Char$toCode(_int));
				}
			}
		}));
var $author$project$Calc$formatNumber = function (decimals) {
	return $elm$core$Maybe$map(
		A2(
			$elm$core$Basics$composeR,
			$myrho$elm_round$Round$round(decimals),
			$author$project$StudioString$withoutObject));
};
var $author$project$DataEngine$RecordCache$getBool = F2(
	function (fieldName, _v0) {
		var cache = _v0.a;
		return A2(
			$elm$core$Dict$get,
			$author$project$FieldName$toString(fieldName),
			cache.bools);
	});
var $author$project$DataEngine$RecordCache$getDate = F2(
	function (fieldName, _v0) {
		var cache = _v0.a;
		return A2(
			$elm$core$Dict$get,
			$author$project$FieldName$toString(fieldName),
			cache.dates);
	});
var $author$project$DataEngine$RecordCache$getDateTime = F2(
	function (fieldName, _v0) {
		var cache = _v0.a;
		return A2(
			$elm$core$Dict$get,
			$author$project$FieldName$toString(fieldName),
			cache.datetimes);
	});
var $author$project$DataEngine$DataCache$getFeedbackData = function (_v0) {
	var internal = _v0.a;
	return internal.feedbackData;
};
var $author$project$DataEngine$DataCache$getLoadableTimeZone = function (_v0) {
	var internal = _v0.a;
	return internal.timeZone;
};
var $author$project$LoadableLocale$toRemoteData = function (locale) {
	switch (locale.a.$) {
		case 'NotAsked':
			var _v1 = locale.a;
			return $krisajenkins$remotedata$RemoteData$NotAsked;
		case 'Loading':
			var _v2 = locale.a;
			return $krisajenkins$remotedata$RemoteData$Loading;
		case 'Failure':
			if (locale.b.$ === 'Nothing') {
				var e = locale.a.a;
				var _v3 = locale.b;
				return $krisajenkins$remotedata$RemoteData$Failure(e);
			} else {
				var e = locale.a.a;
				var device = locale.b.a;
				return $krisajenkins$remotedata$RemoteData$Success(device);
			}
		default:
			var user = locale.a.a;
			return $krisajenkins$remotedata$RemoteData$Success(user);
	}
};
var $author$project$DataEngine$DataCache$getLocaleRemoteData = function (_v0) {
	var internal = _v0.a;
	return $author$project$LoadableLocale$toRemoteData(internal.locale);
};
var $author$project$DataEngine$RecordCache$getNumber = F2(
	function (fieldName, _v0) {
		var cache = _v0.a;
		return A2(
			$elm$core$Dict$get,
			$author$project$FieldName$toString(fieldName),
			cache.numbers);
	});
var $author$project$DataEngine$RecordCache$getString = F2(
	function (fieldName, _v0) {
		var cache = _v0.a;
		return A2(
			$elm$core$Dict$get,
			$author$project$FieldName$toString(fieldName),
			cache.strings);
	});
var $author$project$LoadableTimeZone$toRemoteData = function (_v0) {
	var user = _v0.a;
	var device = _v0.b;
	switch (user.$) {
		case 'NotAsked':
			return $krisajenkins$remotedata$RemoteData$NotAsked;
		case 'Loading':
			return $krisajenkins$remotedata$RemoteData$Loading;
		case 'Failure':
			if (device.$ === 'Nothing') {
				return $krisajenkins$remotedata$RemoteData$Loading;
			} else {
				var zone = device.a;
				return $krisajenkins$remotedata$RemoteData$Success(zone);
			}
		default:
			var _v3 = user.a;
			var zone = _v3.b;
			return $krisajenkins$remotedata$RemoteData$Success(zone);
	}
};
var $author$project$DataEngine$DataCache$getTimeZoneRemoteData = function (_v0) {
	var internal = _v0.a;
	return $author$project$LoadableTimeZone$toRemoteData(internal.timeZone);
};
var $author$project$Calc$gtWith = function (compareFun) {
	return $elm$core$Maybe$map2(
		F2(
			function (a, b) {
				return _Utils_eq(
					A2(compareFun, a, b),
					$elm$core$Basics$GT);
			}));
};
var $author$project$Calc$gteWith = function (compareFun) {
	return $elm$core$Maybe$map2(
		F2(
			function (a, b) {
				return !_Utils_eq(
					A2(compareFun, a, b),
					$elm$core$Basics$LT);
			}));
};
var $author$project$Calc$if_ = F3(
	function (cond, then_, else_) {
		return A2($elm$core$Maybe$withDefault, false, cond) ? then_ : else_;
	});
var $elm_community$maybe_extra$Maybe$Extra$isNothing = function (m) {
	if (m.$ === 'Nothing') {
		return true;
	} else {
		return false;
	}
};
var $author$project$Calc$isNull = function (exp) {
	return $elm$core$Maybe$Just(
		$elm_community$maybe_extra$Maybe$Extra$isNothing(exp));
};
var $author$project$Calc$not = $elm$core$Maybe$map($elm$core$Basics$not);
var $author$project$Calc$isNotNull = function (exp) {
	return $author$project$Calc$not(
		$author$project$Calc$isNull(exp));
};
var $author$project$DataEngine$DataCache$getDataElementState = F2(
	function (ref, _v0) {
		var internal = _v0.a;
		return A2(
			$author$project$UuidDict$get,
			$author$project$DataElement$Reference$getUuid(ref),
			internal.dataElementStates);
	});
var $author$project$DataEngine$DataElementCache$toList = function (deCache) {
	if (deCache.$ === 'SingletonCache') {
		var record = deCache.b;
		return _List_fromArray(
			[record]);
	} else {
		var records = deCache.b;
		return records;
	}
};
var $author$project$DataEngine$CacheState$toRemoteData = function (maybeState) {
	if (maybeState.$ === 'Nothing') {
		return $krisajenkins$remotedata$RemoteData$NotAsked;
	} else {
		switch (maybeState.a.$) {
			case 'Loading':
				var _v1 = maybeState.a;
				return $krisajenkins$remotedata$RemoteData$Loading;
			case 'Failure':
				var err = maybeState.a.a;
				return $krisajenkins$remotedata$RemoteData$Failure(err);
			case 'Success':
				var a = maybeState.a.a;
				return $krisajenkins$remotedata$RemoteData$Success(a);
			default:
				return $krisajenkins$remotedata$RemoteData$NotAsked;
		}
	}
};
var $author$project$DataElement$Expression$Preview$listReference = F2(
	function (cache, listRef) {
		return A2(
			$krisajenkins$remotedata$RemoteData$map,
			$author$project$DataEngine$DataElementCache$toList,
			$author$project$DataEngine$CacheState$toRemoteData(
				A2($author$project$DataEngine$DataCache$getDataElementState, listRef, cache)));
	});
var $author$project$Calc$ltWith = function (compareFun) {
	return $elm$core$Maybe$map2(
		F2(
			function (a, b) {
				return _Utils_eq(
					A2(compareFun, a, b),
					$elm$core$Basics$LT);
			}));
};
var $author$project$Calc$lteWith = function (compareFun) {
	return $elm$core$Maybe$map2(
		F2(
			function (a, b) {
				return !_Utils_eq(
					A2(compareFun, a, b),
					$elm$core$Basics$GT);
			}));
};
var $krisajenkins$remotedata$RemoteData$map3 = F4(
	function (f, a, b, c) {
		return A2(
			$krisajenkins$remotedata$RemoteData$andMap,
			c,
			A2(
				$krisajenkins$remotedata$RemoteData$andMap,
				b,
				A2($krisajenkins$remotedata$RemoteData$map, f, a)));
	});
var $author$project$Calc$maxWith = function (toOrder) {
	return A2(
		$elm$core$Basics$composeR,
		$elm$core$List$filterMap($elm$core$Basics$identity),
		$elm_community$list_extra$List$Extra$maximumWith(toOrder));
};
var $elm_community$list_extra$List$Extra$minimumWith = F2(
	function (comparator, list) {
		return A2(
			$elm_community$list_extra$List$Extra$foldl1,
			F2(
				function (x, y) {
					var _v0 = A2(comparator, x, y);
					if (_v0.$ === 'LT') {
						return x;
					} else {
						return y;
					}
				}),
			list);
	});
var $author$project$Calc$minWith = function (toOrder) {
	return A2(
		$elm$core$Basics$composeR,
		$elm$core$List$filterMap($elm$core$Basics$identity),
		$elm_community$list_extra$List$Extra$minimumWith(toOrder));
};
var $author$project$Calc$monthToInt = function (month) {
	switch (month.$) {
		case 'Jan':
			return 1;
		case 'Feb':
			return 2;
		case 'Mar':
			return 3;
		case 'Apr':
			return 4;
		case 'May':
			return 5;
		case 'Jun':
			return 6;
		case 'Jul':
			return 7;
		case 'Aug':
			return 8;
		case 'Sep':
			return 9;
		case 'Oct':
			return 10;
		case 'Nov':
			return 11;
		default:
			return 12;
	}
};
var $author$project$Calc$monthNumber = $elm$core$Maybe$map(
	A2(
		$elm$core$Basics$composeR,
		$justinmimbs$date$Date$month,
		A2($elm$core$Basics$composeR, $author$project$Calc$monthToInt, $elm$core$Basics$toFloat)));
var $author$project$Calc$multiply = $elm$core$Maybe$map2($elm$core$Basics$mul);
var $author$project$Calc$notEqual = $elm$core$Maybe$map2($elm$core$Basics$neq);
var $author$project$Calc$pickOne = A2(
	$elm$core$Basics$composeR,
	$elm$core$List$filterMap($elm$core$Basics$identity),
	$elm$core$List$head);
var $elm$core$List$product = function (numbers) {
	return A3($elm$core$List$foldl, $elm$core$Basics$mul, 1, numbers);
};
var $author$project$Calc$product = A2(
	$elm$core$Basics$composeR,
	$elm$core$List$filterMap($elm$core$Basics$identity),
	A2($elm$core$Basics$composeR, $elm$core$List$product, $elm$core$Maybe$Just));
var $author$project$Calc$round = $elm$core$Maybe$map(
	A2($elm$core$Basics$composeR, $elm$core$Basics$round, $elm$core$Basics$toFloat));
var $author$project$MyInsights$ApiError = F2(
	function (a, b) {
		return {$: 'ApiError', a: a, b: b};
	});
var $krisajenkins$remotedata$RemoteData$andThen = F2(
	function (f, data) {
		switch (data.$) {
			case 'Success':
				var a = data.a;
				return f(a);
			case 'Failure':
				var e = data.a;
				return $krisajenkins$remotedata$RemoteData$Failure(e);
			case 'NotAsked':
				return $krisajenkins$remotedata$RemoteData$NotAsked;
			default:
				return $krisajenkins$remotedata$RemoteData$Loading;
		}
	});
var $author$project$DataElement$Expression$Preview$singletonReference = F2(
	function (cache, singleRef) {
		return A2(
			$krisajenkins$remotedata$RemoteData$andThen,
			function (deCache) {
				if (deCache.$ === 'SingletonCache') {
					var recordCache = deCache.b;
					return $krisajenkins$remotedata$RemoteData$Success(recordCache);
				} else {
					return $krisajenkins$remotedata$RemoteData$Failure(
						A2($author$project$MyInsights$ApiError, -5, 'This is actually a validation error. Tried to use a ListCache as a Singleton during previewSingletonReference'));
				}
			},
			$author$project$DataEngine$CacheState$toRemoteData(
				A2($author$project$DataEngine$DataCache$getDataElementState, singleRef, cache)));
	});
var $author$project$Calc$stringIn = F2(
	function (maybeWords, maybeWordList) {
		var wordList = A2(
			$elm$core$List$map,
			function ($) {
				return $.text;
			},
			A2($elm$core$List$filterMap, $elm$core$Basics$identity, maybeWordList));
		return A2(
			$elm$core$Maybe$map,
			function (words) {
				return A2($elm$core$List$member, words.text, wordList);
			},
			maybeWords);
	});
var $author$project$Calc$stringNotIn = F2(
	function (maybeWords, maybeWordList) {
		var wordList = A2(
			$elm$core$List$map,
			function ($) {
				return $.text;
			},
			A2($elm$core$List$filterMap, $elm$core$Basics$identity, maybeWordList));
		return A2(
			$elm$core$Maybe$map,
			function (words) {
				return !A2($elm$core$List$member, words.text, wordList);
			},
			maybeWords);
	});
var $author$project$Calc$subtract = $elm$core$Maybe$map2($elm$core$Basics$sub);
var $author$project$Calc$sum = A2(
	$elm$core$Basics$composeR,
	$elm$core$List$filterMap($elm$core$Basics$identity),
	A2($elm$core$Basics$composeR, $elm$core$List$sum, $elm$core$Maybe$Just));
var $author$project$Calc$targetChallengeReasons = F2(
	function (feedbackData, maybeAcctId) {
		if (maybeAcctId.$ === 'Just') {
			var acctId = maybeAcctId.a;
			return A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2($elm$core$Dict$get, acctId.text, feedbackData.targetChallengeReasonsDict));
		} else {
			return _List_Nil;
		}
	});
var $justinmimbs$date$Date$Month = {$: 'Month'};
var $justinmimbs$date$Date$Quarter = {$: 'Quarter'};
var $justinmimbs$date$Date$Sunday = {$: 'Sunday'};
var $justinmimbs$date$Date$Year = {$: 'Year'};
var $author$project$DateInterval$toInterval = function (interval) {
	switch (interval.$) {
		case 'Week':
			return $justinmimbs$date$Date$Sunday;
		case 'Month':
			return $justinmimbs$date$Date$Month;
		case 'Quarter':
			return $justinmimbs$date$Date$Quarter;
		default:
			return $justinmimbs$date$Date$Year;
	}
};
var $author$project$DateUnit$toUnit = function (interval) {
	switch (interval.$) {
		case 'Days':
			return $justinmimbs$date$Date$Days;
		case 'Weeks':
			return $justinmimbs$date$Date$Weeks;
		case 'Months':
			return $justinmimbs$date$Date$Months;
		default:
			return $justinmimbs$date$Date$Years;
	}
};
var $author$project$Calc$yearNumber = $elm$core$Maybe$map(
	A2($elm$core$Basics$composeR, $justinmimbs$date$Date$year, $elm$core$Basics$toFloat));
var $author$project$DataElement$Expression$Preview$globalBool = F2(
	function (cache, bool) {
		switch (bool.$) {
			case 'GlobalBoolLookup':
				var singletonRef = bool.a;
				var fieldName = bool.b;
				return A2(
					$krisajenkins$remotedata$RemoteData$map,
					$author$project$DataEngine$RecordCache$getBool(fieldName),
					A2($author$project$DataElement$Expression$Preview$singletonReference, cache, singletonRef));
			case 'GlobalBoolHardcoded':
				var hardcodedBool = bool.a;
				return $krisajenkins$remotedata$RemoteData$Success(
					$elm$core$Maybe$Just(hardcodedBool));
			case 'GlobalGTString':
				var innerA = bool.a;
				var innerB = bool.b;
				return A3(
					$krisajenkins$remotedata$RemoteData$map2,
					$author$project$Calc$gtWith($author$project$StudioString$compare),
					A2($author$project$DataElement$Expression$Preview$globalString, cache, innerA),
					A2($author$project$DataElement$Expression$Preview$globalString, cache, innerB));
			case 'GlobalGTNumber':
				var innerA = bool.a;
				var innerB = bool.b;
				return A3(
					$krisajenkins$remotedata$RemoteData$map2,
					$author$project$Calc$gtWith($elm$core$Basics$compare),
					A2($author$project$DataElement$Expression$Preview$globalNumber, cache, innerA),
					A2($author$project$DataElement$Expression$Preview$globalNumber, cache, innerB));
			case 'GlobalGTDate':
				var innerA = bool.a;
				var innerB = bool.b;
				return A3(
					$krisajenkins$remotedata$RemoteData$map2,
					$author$project$Calc$gtWith($justinmimbs$date$Date$compare),
					A2($author$project$DataElement$Expression$Preview$globalDate, cache, innerA),
					A2($author$project$DataElement$Expression$Preview$globalDate, cache, innerB));
			case 'GlobalGTDateTime':
				var innerA = bool.a;
				var innerB = bool.b;
				return A3(
					$krisajenkins$remotedata$RemoteData$map2,
					$author$project$Calc$gtWith($author$project$Calc$compareDateTime),
					A2($author$project$DataElement$Expression$Preview$globalDateTime, cache, innerA),
					A2($author$project$DataElement$Expression$Preview$globalDateTime, cache, innerB));
			case 'GlobalGTEString':
				var innerA = bool.a;
				var innerB = bool.b;
				return A3(
					$krisajenkins$remotedata$RemoteData$map2,
					$author$project$Calc$gteWith($author$project$StudioString$compare),
					A2($author$project$DataElement$Expression$Preview$globalString, cache, innerA),
					A2($author$project$DataElement$Expression$Preview$globalString, cache, innerB));
			case 'GlobalGTENumber':
				var innerA = bool.a;
				var innerB = bool.b;
				return A3(
					$krisajenkins$remotedata$RemoteData$map2,
					$author$project$Calc$gteWith($elm$core$Basics$compare),
					A2($author$project$DataElement$Expression$Preview$globalNumber, cache, innerA),
					A2($author$project$DataElement$Expression$Preview$globalNumber, cache, innerB));
			case 'GlobalGTEDate':
				var innerA = bool.a;
				var innerB = bool.b;
				return A3(
					$krisajenkins$remotedata$RemoteData$map2,
					$author$project$Calc$gteWith($justinmimbs$date$Date$compare),
					A2($author$project$DataElement$Expression$Preview$globalDate, cache, innerA),
					A2($author$project$DataElement$Expression$Preview$globalDate, cache, innerB));
			case 'GlobalGTEDateTime':
				var innerA = bool.a;
				var innerB = bool.b;
				return A3(
					$krisajenkins$remotedata$RemoteData$map2,
					$author$project$Calc$gteWith($author$project$Calc$compareDateTime),
					A2($author$project$DataElement$Expression$Preview$globalDateTime, cache, innerA),
					A2($author$project$DataElement$Expression$Preview$globalDateTime, cache, innerB));
			case 'GlobalLTString':
				var innerA = bool.a;
				var innerB = bool.b;
				return A3(
					$krisajenkins$remotedata$RemoteData$map2,
					$author$project$Calc$ltWith($author$project$StudioString$compare),
					A2($author$project$DataElement$Expression$Preview$globalString, cache, innerA),
					A2($author$project$DataElement$Expression$Preview$globalString, cache, innerB));
			case 'GlobalLTNumber':
				var innerA = bool.a;
				var innerB = bool.b;
				return A3(
					$krisajenkins$remotedata$RemoteData$map2,
					$author$project$Calc$ltWith($elm$core$Basics$compare),
					A2($author$project$DataElement$Expression$Preview$globalNumber, cache, innerA),
					A2($author$project$DataElement$Expression$Preview$globalNumber, cache, innerB));
			case 'GlobalLTDate':
				var innerA = bool.a;
				var innerB = bool.b;
				return A3(
					$krisajenkins$remotedata$RemoteData$map2,
					$author$project$Calc$ltWith($justinmimbs$date$Date$compare),
					A2($author$project$DataElement$Expression$Preview$globalDate, cache, innerA),
					A2($author$project$DataElement$Expression$Preview$globalDate, cache, innerB));
			case 'GlobalLTDateTime':
				var innerA = bool.a;
				var innerB = bool.b;
				return A3(
					$krisajenkins$remotedata$RemoteData$map2,
					$author$project$Calc$ltWith($author$project$Calc$compareDateTime),
					A2($author$project$DataElement$Expression$Preview$globalDateTime, cache, innerA),
					A2($author$project$DataElement$Expression$Preview$globalDateTime, cache, innerB));
			case 'GlobalLTEString':
				var innerA = bool.a;
				var innerB = bool.b;
				return A3(
					$krisajenkins$remotedata$RemoteData$map2,
					$author$project$Calc$lteWith($author$project$StudioString$compare),
					A2($author$project$DataElement$Expression$Preview$globalString, cache, innerA),
					A2($author$project$DataElement$Expression$Preview$globalString, cache, innerB));
			case 'GlobalLTENumber':
				var innerA = bool.a;
				var innerB = bool.b;
				return A3(
					$krisajenkins$remotedata$RemoteData$map2,
					$author$project$Calc$lteWith($elm$core$Basics$compare),
					A2($author$project$DataElement$Expression$Preview$globalNumber, cache, innerA),
					A2($author$project$DataElement$Expression$Preview$globalNumber, cache, innerB));
			case 'GlobalLTEDate':
				var innerA = bool.a;
				var innerB = bool.b;
				return A3(
					$krisajenkins$remotedata$RemoteData$map2,
					$author$project$Calc$lteWith($justinmimbs$date$Date$compare),
					A2($author$project$DataElement$Expression$Preview$globalDate, cache, innerA),
					A2($author$project$DataElement$Expression$Preview$globalDate, cache, innerB));
			case 'GlobalLTEDateTime':
				var innerA = bool.a;
				var innerB = bool.b;
				return A3(
					$krisajenkins$remotedata$RemoteData$map2,
					$author$project$Calc$lteWith($author$project$Calc$compareDateTime),
					A2($author$project$DataElement$Expression$Preview$globalDateTime, cache, innerA),
					A2($author$project$DataElement$Expression$Preview$globalDateTime, cache, innerB));
			case 'GlobalEqualString':
				var innerA = bool.a;
				var innerB = bool.b;
				return A3(
					$krisajenkins$remotedata$RemoteData$map2,
					$author$project$Calc$comparableEqual($author$project$StudioString$compare),
					A2($author$project$DataElement$Expression$Preview$globalString, cache, innerA),
					A2($author$project$DataElement$Expression$Preview$globalString, cache, innerB));
			case 'GlobalEqualNumber':
				var innerA = bool.a;
				var innerB = bool.b;
				return A3(
					$krisajenkins$remotedata$RemoteData$map2,
					$author$project$Calc$comparableEqual($elm$core$Basics$compare),
					A2($author$project$DataElement$Expression$Preview$globalNumber, cache, innerA),
					A2($author$project$DataElement$Expression$Preview$globalNumber, cache, innerB));
			case 'GlobalEqualDate':
				var innerA = bool.a;
				var innerB = bool.b;
				return A3(
					$krisajenkins$remotedata$RemoteData$map2,
					$author$project$Calc$comparableEqual($justinmimbs$date$Date$compare),
					A2($author$project$DataElement$Expression$Preview$globalDate, cache, innerA),
					A2($author$project$DataElement$Expression$Preview$globalDate, cache, innerB));
			case 'GlobalEqualDateTime':
				var innerA = bool.a;
				var innerB = bool.b;
				return A3(
					$krisajenkins$remotedata$RemoteData$map2,
					$author$project$Calc$comparableEqual($author$project$Calc$compareDateTime),
					A2($author$project$DataElement$Expression$Preview$globalDateTime, cache, innerA),
					A2($author$project$DataElement$Expression$Preview$globalDateTime, cache, innerB));
			case 'GlobalEqualBool':
				var innerA = bool.a;
				var innerB = bool.b;
				return A3(
					$krisajenkins$remotedata$RemoteData$map2,
					$author$project$Calc$equal,
					A2($author$project$DataElement$Expression$Preview$globalBool, cache, innerA),
					A2($author$project$DataElement$Expression$Preview$globalBool, cache, innerB));
			case 'GlobalNotEqualString':
				var innerA = bool.a;
				var innerB = bool.b;
				return A3(
					$krisajenkins$remotedata$RemoteData$map2,
					$author$project$Calc$comparableNotEqual($author$project$StudioString$compare),
					A2($author$project$DataElement$Expression$Preview$globalString, cache, innerA),
					A2($author$project$DataElement$Expression$Preview$globalString, cache, innerB));
			case 'GlobalNotEqualNumber':
				var innerA = bool.a;
				var innerB = bool.b;
				return A3(
					$krisajenkins$remotedata$RemoteData$map2,
					$author$project$Calc$comparableNotEqual($elm$core$Basics$compare),
					A2($author$project$DataElement$Expression$Preview$globalNumber, cache, innerA),
					A2($author$project$DataElement$Expression$Preview$globalNumber, cache, innerB));
			case 'GlobalNotEqualDate':
				var innerA = bool.a;
				var innerB = bool.b;
				return A3(
					$krisajenkins$remotedata$RemoteData$map2,
					$author$project$Calc$comparableNotEqual($justinmimbs$date$Date$compare),
					A2($author$project$DataElement$Expression$Preview$globalDate, cache, innerA),
					A2($author$project$DataElement$Expression$Preview$globalDate, cache, innerB));
			case 'GlobalNotEqualDateTime':
				var innerA = bool.a;
				var innerB = bool.b;
				return A3(
					$krisajenkins$remotedata$RemoteData$map2,
					$author$project$Calc$comparableNotEqual($author$project$Calc$compareDateTime),
					A2($author$project$DataElement$Expression$Preview$globalDateTime, cache, innerA),
					A2($author$project$DataElement$Expression$Preview$globalDateTime, cache, innerB));
			case 'GlobalNotEqualBool':
				var innerA = bool.a;
				var innerB = bool.b;
				return A3(
					$krisajenkins$remotedata$RemoteData$map2,
					$author$project$Calc$notEqual,
					A2($author$project$DataElement$Expression$Preview$globalBool, cache, innerA),
					A2($author$project$DataElement$Expression$Preview$globalBool, cache, innerB));
			case 'GlobalStringIn':
				var string = bool.a;
				var list = bool.b;
				return A3(
					$krisajenkins$remotedata$RemoteData$map2,
					$author$project$Calc$stringIn,
					A2($author$project$DataElement$Expression$Preview$globalString, cache, string),
					A2($author$project$DataElement$Expression$Preview$globalStringList, cache, list));
			case 'GlobalStringNotIn':
				var string = bool.a;
				var list = bool.b;
				return A3(
					$krisajenkins$remotedata$RemoteData$map2,
					$author$project$Calc$stringNotIn,
					A2($author$project$DataElement$Expression$Preview$globalString, cache, string),
					A2($author$project$DataElement$Expression$Preview$globalStringList, cache, list));
			case 'GlobalNot':
				var innerBool = bool.a;
				return A2(
					$krisajenkins$remotedata$RemoteData$map,
					$author$project$Calc$not,
					A2($author$project$DataElement$Expression$Preview$globalBool, cache, innerBool));
			case 'GlobalBoolIf':
				var cond = bool.a;
				var then_ = bool.b;
				var else_ = bool.c;
				return A4(
					$krisajenkins$remotedata$RemoteData$map3,
					$author$project$Calc$if_,
					A2($author$project$DataElement$Expression$Preview$globalBool, cache, cond),
					A2($author$project$DataElement$Expression$Preview$globalBool, cache, then_),
					A2($author$project$DataElement$Expression$Preview$globalBool, cache, else_));
			case 'GlobalPickBool':
				var innerList = bool.a;
				return A2(
					$krisajenkins$remotedata$RemoteData$map,
					$author$project$Calc$pickOne,
					A2($author$project$DataElement$Expression$Preview$globalBoolList, cache, innerList));
			case 'GlobalAll':
				var innerList = bool.a;
				return A2(
					$krisajenkins$remotedata$RemoteData$map,
					$author$project$Calc$all,
					A2($author$project$DataElement$Expression$Preview$globalBoolList, cache, innerList));
			case 'GlobalAny':
				var innerList = bool.a;
				return A2(
					$krisajenkins$remotedata$RemoteData$map,
					$author$project$Calc$any,
					A2($author$project$DataElement$Expression$Preview$globalBoolList, cache, innerList));
			case 'GlobalIsNull':
				var field = bool.a;
				return A2(
					$krisajenkins$remotedata$RemoteData$map,
					$author$project$Calc$isNull,
					A2($author$project$DataElement$Expression$Preview$globalField, cache, field));
			default:
				var field = bool.a;
				return A2(
					$krisajenkins$remotedata$RemoteData$map,
					$author$project$Calc$isNotNull,
					A2($author$project$DataElement$Expression$Preview$globalField, cache, field));
		}
	});
var $author$project$DataElement$Expression$Preview$globalBoolList = F2(
	function (cache, boolList) {
		switch (boolList.$) {
			case 'GlobalAllBoolsInField':
				var listRef = boolList.a;
				var fieldName = boolList.b;
				return A2(
					$krisajenkins$remotedata$RemoteData$map,
					$elm$core$List$map(
						$author$project$DataEngine$RecordCache$getBool(fieldName)),
					A2($author$project$DataElement$Expression$Preview$listReference, cache, listRef));
			case 'GlobalBoolsAsList':
				var globalBools = boolList.a;
				return $author$project$RemoteData$Helpers$combine(
					A2(
						$elm$core$List$map,
						$author$project$DataElement$Expression$Preview$globalBool(cache),
						globalBools));
			default:
				var cond = boolList.a;
				var then_ = boolList.b;
				var else_ = boolList.c;
				return A4(
					$krisajenkins$remotedata$RemoteData$map3,
					$author$project$Calc$if_,
					A2($author$project$DataElement$Expression$Preview$globalBool, cache, cond),
					A2($author$project$DataElement$Expression$Preview$globalBoolList, cache, then_),
					A2($author$project$DataElement$Expression$Preview$globalBoolList, cache, else_));
		}
	});
var $author$project$DataElement$Expression$Preview$globalComparableWithTransform = F3(
	function (transform, cache, globalCompList) {
		switch (globalCompList.$) {
			case 'GlobalCompStringListExpr':
				var stringList = globalCompList.a;
				return A2(
					$krisajenkins$remotedata$RemoteData$map,
					transform.string,
					A2($author$project$DataElement$Expression$Preview$globalStringList, cache, stringList));
			case 'GlobalCompNumberListExpr':
				var numberList = globalCompList.a;
				return A2(
					$krisajenkins$remotedata$RemoteData$map,
					transform.number,
					A2($author$project$DataElement$Expression$Preview$globalNumberList, cache, numberList));
			case 'GlobalCompDateListExpr':
				var dateList = globalCompList.a;
				return A2(
					$krisajenkins$remotedata$RemoteData$map,
					transform.date,
					A2($author$project$DataElement$Expression$Preview$globalDateList, cache, dateList));
			default:
				var dateTimeList = globalCompList.a;
				return A2(
					$krisajenkins$remotedata$RemoteData$map,
					transform.datetime,
					A2($author$project$DataElement$Expression$Preview$globalDateTimeList, cache, dateTimeList));
		}
	});
var $author$project$DataElement$Expression$Preview$globalDate = F2(
	function (cache, date) {
		switch (date.$) {
			case 'GlobalDateLookup':
				var singletonRef = date.a;
				var fieldName = date.b;
				return A2(
					$krisajenkins$remotedata$RemoteData$map,
					$author$project$DataEngine$RecordCache$getDate(fieldName),
					A2($author$project$DataElement$Expression$Preview$singletonReference, cache, singletonRef));
			case 'GlobalDateHardcoded':
				var hardcodedDate = date.a;
				return $krisajenkins$remotedata$RemoteData$Success(
					$elm$core$Maybe$Just(hardcodedDate));
			case 'GlobalDateTimeToDate':
				var dateTime = date.a;
				return A2(
					$krisajenkins$remotedata$RemoteData$map,
					$author$project$Calc$dateTimeToDate(
						$author$project$DataEngine$DataCache$getLoadableTimeZone(cache)),
					A2($author$project$DataElement$Expression$Preview$globalDateTime, cache, dateTime));
			case 'GlobalDateCeiling':
				var dateInterval = date.a;
				var innerDate = date.b;
				return A2(
					$krisajenkins$remotedata$RemoteData$map,
					$author$project$Calc$dateCeiling(
						$author$project$DateInterval$toInterval(dateInterval)),
					A2($author$project$DataElement$Expression$Preview$globalDate, cache, innerDate));
			case 'GlobalDateFloor':
				var dateInterval = date.a;
				var innerDate = date.b;
				return A2(
					$krisajenkins$remotedata$RemoteData$map,
					$author$project$Calc$dateFloor(
						$author$project$DateInterval$toInterval(dateInterval)),
					A2($author$project$DataElement$Expression$Preview$globalDate, cache, innerDate));
			case 'GlobalDateAdd':
				var dateUnit = date.a;
				var innerNum = date.b;
				var innerDate = date.c;
				return A3(
					$krisajenkins$remotedata$RemoteData$map2,
					$author$project$Calc$dateAdd(
						$author$project$DateUnit$toUnit(dateUnit)),
					A2($author$project$DataElement$Expression$Preview$globalNumber, cache, innerNum),
					A2($author$project$DataElement$Expression$Preview$globalDate, cache, innerDate));
			case 'GlobalDateSubtract':
				var dateUnit = date.a;
				var innerNum = date.b;
				var innerDate = date.c;
				return A3(
					$krisajenkins$remotedata$RemoteData$map2,
					$author$project$Calc$dateSubtract(
						$author$project$DateUnit$toUnit(dateUnit)),
					A2($author$project$DataElement$Expression$Preview$globalNumber, cache, innerNum),
					A2($author$project$DataElement$Expression$Preview$globalDate, cache, innerDate));
			case 'GlobalDateIf':
				var cond = date.a;
				var then_ = date.b;
				var else_ = date.c;
				return A4(
					$krisajenkins$remotedata$RemoteData$map3,
					$author$project$Calc$if_,
					A2($author$project$DataElement$Expression$Preview$globalBool, cache, cond),
					A2($author$project$DataElement$Expression$Preview$globalDate, cache, then_),
					A2($author$project$DataElement$Expression$Preview$globalDate, cache, else_));
			case 'GlobalPickDate':
				var innerList = date.a;
				return A2(
					$krisajenkins$remotedata$RemoteData$map,
					$author$project$Calc$pickOne,
					A2($author$project$DataElement$Expression$Preview$globalDateList, cache, innerList));
			case 'GlobalMaxDate':
				var list = date.a;
				return A2(
					$krisajenkins$remotedata$RemoteData$map,
					$author$project$Calc$maxWith($justinmimbs$date$Date$compare),
					A2($author$project$DataElement$Expression$Preview$globalDateList, cache, list));
			default:
				var list = date.a;
				return A2(
					$krisajenkins$remotedata$RemoteData$map,
					$author$project$Calc$minWith($justinmimbs$date$Date$compare),
					A2($author$project$DataElement$Expression$Preview$globalDateList, cache, list));
		}
	});
var $author$project$DataElement$Expression$Preview$globalDateList = F2(
	function (cache, dateList) {
		switch (dateList.$) {
			case 'GlobalAllDatesInField':
				var listRef = dateList.a;
				var fieldName = dateList.b;
				return A2(
					$krisajenkins$remotedata$RemoteData$map,
					$elm$core$List$map(
						$author$project$DataEngine$RecordCache$getDate(fieldName)),
					A2($author$project$DataElement$Expression$Preview$listReference, cache, listRef));
			case 'GlobalDatesAsList':
				var globalDates = dateList.a;
				return $author$project$RemoteData$Helpers$combine(
					A2(
						$elm$core$List$map,
						$author$project$DataElement$Expression$Preview$globalDate(cache),
						globalDates));
			default:
				var cond = dateList.a;
				var then_ = dateList.b;
				var else_ = dateList.c;
				return A4(
					$krisajenkins$remotedata$RemoteData$map3,
					$author$project$Calc$if_,
					A2($author$project$DataElement$Expression$Preview$globalBool, cache, cond),
					A2($author$project$DataElement$Expression$Preview$globalDateList, cache, then_),
					A2($author$project$DataElement$Expression$Preview$globalDateList, cache, else_));
		}
	});
var $author$project$DataElement$Expression$Preview$globalDateTime = F2(
	function (cache, dateTime) {
		switch (dateTime.$) {
			case 'GlobalDateTimeLookup':
				var singletonRef = dateTime.a;
				var fieldName = dateTime.b;
				return A2(
					$krisajenkins$remotedata$RemoteData$map,
					$author$project$DataEngine$RecordCache$getDateTime(fieldName),
					A2($author$project$DataElement$Expression$Preview$singletonReference, cache, singletonRef));
			case 'GlobalDateTimeHardcoded':
				var posix = dateTime.a;
				return $krisajenkins$remotedata$RemoteData$Success(
					$elm$core$Maybe$Just(posix));
			case 'GlobalDateTimeIf':
				var cond = dateTime.a;
				var then_ = dateTime.b;
				var else_ = dateTime.c;
				return A4(
					$krisajenkins$remotedata$RemoteData$map3,
					$author$project$Calc$if_,
					A2($author$project$DataElement$Expression$Preview$globalBool, cache, cond),
					A2($author$project$DataElement$Expression$Preview$globalDateTime, cache, then_),
					A2($author$project$DataElement$Expression$Preview$globalDateTime, cache, else_));
			case 'GlobalPickDateTime':
				var innerList = dateTime.a;
				return A2(
					$krisajenkins$remotedata$RemoteData$map,
					$author$project$Calc$pickOne,
					A2($author$project$DataElement$Expression$Preview$globalDateTimeList, cache, innerList));
			case 'GlobalMaxDateTime':
				var list = dateTime.a;
				return A2(
					$krisajenkins$remotedata$RemoteData$map,
					$author$project$Calc$maxWith($author$project$Calc$compareDateTime),
					A2($author$project$DataElement$Expression$Preview$globalDateTimeList, cache, list));
			default:
				var list = dateTime.a;
				return A2(
					$krisajenkins$remotedata$RemoteData$map,
					$author$project$Calc$minWith($author$project$Calc$compareDateTime),
					A2($author$project$DataElement$Expression$Preview$globalDateTimeList, cache, list));
		}
	});
var $author$project$DataElement$Expression$Preview$globalDateTimeList = F2(
	function (cache, dateTimeList) {
		switch (dateTimeList.$) {
			case 'GlobalAllDateTimesInField':
				var listRef = dateTimeList.a;
				var fieldName = dateTimeList.b;
				return A2(
					$krisajenkins$remotedata$RemoteData$map,
					$elm$core$List$map(
						$author$project$DataEngine$RecordCache$getDateTime(fieldName)),
					A2($author$project$DataElement$Expression$Preview$listReference, cache, listRef));
			case 'GlobalDateTimesAsList':
				var globalDateTimes = dateTimeList.a;
				return $author$project$RemoteData$Helpers$combine(
					A2(
						$elm$core$List$map,
						$author$project$DataElement$Expression$Preview$globalDateTime(cache),
						globalDateTimes));
			default:
				var cond = dateTimeList.a;
				var then_ = dateTimeList.b;
				var else_ = dateTimeList.c;
				return A4(
					$krisajenkins$remotedata$RemoteData$map3,
					$author$project$Calc$if_,
					A2($author$project$DataElement$Expression$Preview$globalBool, cache, cond),
					A2($author$project$DataElement$Expression$Preview$globalDateTimeList, cache, then_),
					A2($author$project$DataElement$Expression$Preview$globalDateTimeList, cache, else_));
		}
	});
var $author$project$DataElement$Expression$Preview$globalField = F2(
	function (cache, field) {
		switch (field.$) {
			case 'GlobalStringExpr':
				var expr = field.a;
				return A2(
					$krisajenkins$remotedata$RemoteData$map,
					$elm$core$Maybe$map($author$project$FieldValue$StringValue),
					A2($author$project$DataElement$Expression$Preview$globalString, cache, expr));
			case 'GlobalNumberExpr':
				var number = field.a;
				return A2(
					$krisajenkins$remotedata$RemoteData$map,
					$elm$core$Maybe$map($author$project$FieldValue$NumberValue),
					A2($author$project$DataElement$Expression$Preview$globalNumber, cache, number));
			case 'GlobalDateExpr':
				var date = field.a;
				return A2(
					$krisajenkins$remotedata$RemoteData$map,
					$elm$core$Maybe$map($author$project$FieldValue$DateValue),
					A2($author$project$DataElement$Expression$Preview$globalDate, cache, date));
			case 'GlobalDateTimeExpr':
				var dateTime = field.a;
				return A2(
					$krisajenkins$remotedata$RemoteData$map,
					$elm$core$Maybe$map($author$project$FieldValue$DateTimeValue),
					A2($author$project$DataElement$Expression$Preview$globalDateTime, cache, dateTime));
			default:
				var bool = field.a;
				return A2(
					$krisajenkins$remotedata$RemoteData$map,
					$elm$core$Maybe$map($author$project$FieldValue$BoolValue),
					A2($author$project$DataElement$Expression$Preview$globalBool, cache, bool));
		}
	});
var $author$project$DataElement$Expression$Preview$globalNumber = F2(
	function (cache, number) {
		switch (number.$) {
			case 'GlobalNumberLookup':
				var singletonRef = number.a;
				var fieldName = number.b;
				return A2(
					$krisajenkins$remotedata$RemoteData$map,
					$author$project$DataEngine$RecordCache$getNumber(fieldName),
					A2($author$project$DataElement$Expression$Preview$singletonReference, cache, singletonRef));
			case 'GlobalNumberHardcoded':
				var hardcodedNumber = number.a;
				return $krisajenkins$remotedata$RemoteData$Success(
					$elm$core$Maybe$Just(hardcodedNumber));
			case 'GlobalCountUnique':
				var globalCompList = number.a;
				return A3($author$project$DataElement$Expression$Preview$globalComparableWithTransform, $author$project$DataElement$Expression$Preview$countUniqueComparableTransform, cache, globalCompList);
			case 'GlobalRound':
				var innerNumber = number.a;
				return A2(
					$krisajenkins$remotedata$RemoteData$map,
					$author$project$Calc$round,
					A2($author$project$DataElement$Expression$Preview$globalNumber, cache, innerNumber));
			case 'GlobalSum':
				var numberList = number.a;
				return A2(
					$krisajenkins$remotedata$RemoteData$map,
					$author$project$Calc$sum,
					A2($author$project$DataElement$Expression$Preview$globalNumberList, cache, numberList));
			case 'GlobalProduct':
				var numberList = number.a;
				return A2(
					$krisajenkins$remotedata$RemoteData$map,
					$author$project$Calc$product,
					A2($author$project$DataElement$Expression$Preview$globalNumberList, cache, numberList));
			case 'GlobalAdd':
				var globalNumA = number.a;
				var globalNumB = number.b;
				return A3(
					$krisajenkins$remotedata$RemoteData$map2,
					$author$project$Calc$add,
					A2($author$project$DataElement$Expression$Preview$globalNumber, cache, globalNumA),
					A2($author$project$DataElement$Expression$Preview$globalNumber, cache, globalNumB));
			case 'GlobalSubtract':
				var globalNumA = number.a;
				var globalNumB = number.b;
				return A3(
					$krisajenkins$remotedata$RemoteData$map2,
					$author$project$Calc$subtract,
					A2($author$project$DataElement$Expression$Preview$globalNumber, cache, globalNumA),
					A2($author$project$DataElement$Expression$Preview$globalNumber, cache, globalNumB));
			case 'GlobalMultiply':
				var globalNumA = number.a;
				var globalNumB = number.b;
				return A3(
					$krisajenkins$remotedata$RemoteData$map2,
					$author$project$Calc$multiply,
					A2($author$project$DataElement$Expression$Preview$globalNumber, cache, globalNumA),
					A2($author$project$DataElement$Expression$Preview$globalNumber, cache, globalNumB));
			case 'GlobalDivide':
				var globalNumA = number.a;
				var globalNumB = number.b;
				return A3(
					$krisajenkins$remotedata$RemoteData$map2,
					$author$project$Calc$divide,
					A2($author$project$DataElement$Expression$Preview$globalNumber, cache, globalNumA),
					A2($author$project$DataElement$Expression$Preview$globalNumber, cache, globalNumB));
			case 'GlobalMonthNumber':
				var innerDate = number.a;
				return A2(
					$krisajenkins$remotedata$RemoteData$map,
					$author$project$Calc$monthNumber,
					A2($author$project$DataElement$Expression$Preview$globalDate, cache, innerDate));
			case 'GlobalYearNumber':
				var innerDate = number.a;
				return A2(
					$krisajenkins$remotedata$RemoteData$map,
					$author$project$Calc$yearNumber,
					A2($author$project$DataElement$Expression$Preview$globalDate, cache, innerDate));
			case 'GlobalDayInMonth':
				var innerDate = number.a;
				return A2(
					$krisajenkins$remotedata$RemoteData$map,
					$author$project$Calc$dayInMonth,
					A2($author$project$DataElement$Expression$Preview$globalDate, cache, innerDate));
			case 'GlobalNumberIf':
				var cond = number.a;
				var then_ = number.b;
				var else_ = number.c;
				return A4(
					$krisajenkins$remotedata$RemoteData$map3,
					$author$project$Calc$if_,
					A2($author$project$DataElement$Expression$Preview$globalBool, cache, cond),
					A2($author$project$DataElement$Expression$Preview$globalNumber, cache, then_),
					A2($author$project$DataElement$Expression$Preview$globalNumber, cache, else_));
			case 'GlobalPickNumber':
				var innerList = number.a;
				return A2(
					$krisajenkins$remotedata$RemoteData$map,
					$author$project$Calc$pickOne,
					A2($author$project$DataElement$Expression$Preview$globalNumberList, cache, innerList));
			case 'GlobalMaxNumber':
				var list = number.a;
				return A2(
					$krisajenkins$remotedata$RemoteData$map,
					$author$project$Calc$maxWith($elm$core$Basics$compare),
					A2($author$project$DataElement$Expression$Preview$globalNumberList, cache, list));
			default:
				var list = number.a;
				return A2(
					$krisajenkins$remotedata$RemoteData$map,
					$author$project$Calc$minWith($elm$core$Basics$compare),
					A2($author$project$DataElement$Expression$Preview$globalNumberList, cache, list));
		}
	});
var $author$project$DataElement$Expression$Preview$globalNumberList = F2(
	function (cache, numberList) {
		switch (numberList.$) {
			case 'GlobalAllNumbersInField':
				var listRef = numberList.a;
				var fieldName = numberList.b;
				return A2(
					$krisajenkins$remotedata$RemoteData$map,
					$elm$core$List$map(
						$author$project$DataEngine$RecordCache$getNumber(fieldName)),
					A2($author$project$DataElement$Expression$Preview$listReference, cache, listRef));
			case 'GlobalNumbersAsList':
				var globalNumbers = numberList.a;
				return $author$project$RemoteData$Helpers$combine(
					A2(
						$elm$core$List$map,
						$author$project$DataElement$Expression$Preview$globalNumber(cache),
						globalNumbers));
			default:
				var cond = numberList.a;
				var then_ = numberList.b;
				var else_ = numberList.c;
				return A4(
					$krisajenkins$remotedata$RemoteData$map3,
					$author$project$Calc$if_,
					A2($author$project$DataElement$Expression$Preview$globalBool, cache, cond),
					A2($author$project$DataElement$Expression$Preview$globalNumberList, cache, then_),
					A2($author$project$DataElement$Expression$Preview$globalNumberList, cache, else_));
		}
	});
var $author$project$DataElement$Expression$Preview$globalString = F2(
	function (cache, string) {
		switch (string.$) {
			case 'GlobalStringLookup':
				var singletonRef = string.a;
				var fieldName = string.b;
				return A2(
					$krisajenkins$remotedata$RemoteData$map,
					$author$project$DataEngine$RecordCache$getString(fieldName),
					A2($author$project$DataElement$Expression$Preview$singletonReference, cache, singletonRef));
			case 'GlobalStringHardcoded':
				var words = string.a;
				return $krisajenkins$remotedata$RemoteData$Success(
					$elm$core$Maybe$Just(
						$author$project$StudioString$withoutObject(words)));
			case 'GlobalFormatDate':
				var innerString = string.a;
				var innerDate = string.b;
				return A3(
					$krisajenkins$remotedata$RemoteData$map2,
					$author$project$Calc$formatDate,
					A2($author$project$DataElement$Expression$Preview$globalString, cache, innerString),
					A2($author$project$DataElement$Expression$Preview$globalDate, cache, innerDate));
			case 'GlobalFormatDateLocaleAware':
				var innerDate = string.a;
				return A3(
					$krisajenkins$remotedata$RemoteData$map2,
					$author$project$Calc$formatDateLocaleAware,
					$author$project$DataEngine$DataCache$getLocaleRemoteData(cache),
					A2($author$project$DataElement$Expression$Preview$globalDate, cache, innerDate));
			case 'GlobalFormatDateTime':
				var innerDateTime = string.a;
				return A4(
					$krisajenkins$remotedata$RemoteData$map3,
					$author$project$Calc$formatDateTimeLocaleAware,
					$author$project$DataEngine$DataCache$getLocaleRemoteData(cache),
					$author$project$DataEngine$DataCache$getTimeZoneRemoteData(cache),
					A2($author$project$DataElement$Expression$Preview$globalDateTime, cache, innerDateTime));
			case 'GlobalFormatNumber':
				var decimals = string.a;
				var innerNumber = string.b;
				return A2(
					$krisajenkins$remotedata$RemoteData$map,
					$author$project$Calc$formatNumber(decimals),
					A2($author$project$DataElement$Expression$Preview$globalNumber, cache, innerNumber));
			case 'GlobalStringIf':
				var cond = string.a;
				var then_ = string.b;
				var else_ = string.c;
				return A4(
					$krisajenkins$remotedata$RemoteData$map3,
					$author$project$Calc$if_,
					A2($author$project$DataElement$Expression$Preview$globalBool, cache, cond),
					A2($author$project$DataElement$Expression$Preview$globalString, cache, then_),
					A2($author$project$DataElement$Expression$Preview$globalString, cache, else_));
			case 'GlobalPickString':
				var innerList = string.a;
				return A2(
					$krisajenkins$remotedata$RemoteData$map,
					$author$project$Calc$pickOne,
					A2($author$project$DataElement$Expression$Preview$globalStringList, cache, innerList));
			case 'GlobalConcat':
				var join = string.a;
				var list = string.b;
				return A3(
					$krisajenkins$remotedata$RemoteData$map2,
					$author$project$Calc$concat,
					A2($author$project$DataElement$Expression$Preview$globalString, cache, join),
					A2($author$project$DataElement$Expression$Preview$globalStringList, cache, list));
			case 'GlobalMaxString':
				var list = string.a;
				return A2(
					$krisajenkins$remotedata$RemoteData$map,
					$author$project$Calc$maxWith($author$project$StudioString$compare),
					A2($author$project$DataElement$Expression$Preview$globalStringList, cache, list));
			default:
				var list = string.a;
				return A2(
					$krisajenkins$remotedata$RemoteData$map,
					$author$project$Calc$minWith($author$project$StudioString$compare),
					A2($author$project$DataElement$Expression$Preview$globalStringList, cache, list));
		}
	});
var $author$project$DataElement$Expression$Preview$globalStringList = F2(
	function (cache, stringList) {
		switch (stringList.$) {
			case 'GlobalAllStringsInField':
				var listRef = stringList.a;
				var fieldName = stringList.b;
				return A2(
					$krisajenkins$remotedata$RemoteData$map,
					$elm$core$List$map(
						$author$project$DataEngine$RecordCache$getString(fieldName)),
					A2($author$project$DataElement$Expression$Preview$listReference, cache, listRef));
			case 'GlobalStringsAsList':
				var globalStrings = stringList.a;
				return $author$project$RemoteData$Helpers$combine(
					A2(
						$elm$core$List$map,
						$author$project$DataElement$Expression$Preview$globalString(cache),
						globalStrings));
			case 'GlobalStringListIf':
				var cond = stringList.a;
				var then_ = stringList.b;
				var else_ = stringList.c;
				return A4(
					$krisajenkins$remotedata$RemoteData$map3,
					$author$project$Calc$if_,
					A2($author$project$DataElement$Expression$Preview$globalBool, cache, cond),
					A2($author$project$DataElement$Expression$Preview$globalStringList, cache, then_),
					A2($author$project$DataElement$Expression$Preview$globalStringList, cache, else_));
			case 'GlobalChallengeReasons':
				var acctId = stringList.a;
				return A3(
					$krisajenkins$remotedata$RemoteData$map2,
					$author$project$Calc$challengeReasons,
					$author$project$DataEngine$DataCache$getFeedbackData(cache),
					A2($author$project$DataElement$Expression$Preview$globalString, cache, acctId));
			default:
				var acctId = stringList.a;
				return A3(
					$krisajenkins$remotedata$RemoteData$map2,
					$author$project$Calc$targetChallengeReasons,
					$author$project$DataEngine$DataCache$getFeedbackData(cache),
					A2($author$project$DataElement$Expression$Preview$globalString, cache, acctId));
		}
	});
var $author$project$DataElement$Expression$Preview$globalComparable = F2(
	function (cache, field) {
		switch (field.$) {
			case 'GlobalCompStringExpr':
				var expr = field.a;
				return A2(
					$krisajenkins$remotedata$RemoteData$map,
					$elm$core$Maybe$map($author$project$FieldValue$StringValue),
					A2($author$project$DataElement$Expression$Preview$globalString, cache, expr));
			case 'GlobalCompNumberExpr':
				var number = field.a;
				return A2(
					$krisajenkins$remotedata$RemoteData$map,
					$elm$core$Maybe$map($author$project$FieldValue$NumberValue),
					A2($author$project$DataElement$Expression$Preview$globalNumber, cache, number));
			case 'GlobalCompDateExpr':
				var date = field.a;
				return A2(
					$krisajenkins$remotedata$RemoteData$map,
					$elm$core$Maybe$map($author$project$FieldValue$DateValue),
					A2($author$project$DataElement$Expression$Preview$globalDate, cache, date));
			default:
				var dateTime = field.a;
				return A2(
					$krisajenkins$remotedata$RemoteData$map,
					$elm$core$Maybe$map($author$project$FieldValue$DateTimeValue),
					A2($author$project$DataElement$Expression$Preview$globalDateTime, cache, dateTime));
		}
	});
var $krisajenkins$remotedata$RemoteData$succeed = $krisajenkins$remotedata$RemoteData$Success;
var $author$project$DataElement$previewCrmDataEngineWhereClause = F2(
	function (cache, whereClause) {
		switch (whereClause.$) {
			case 'AllOf':
				var wheres = whereClause.a;
				return A2(
					$krisajenkins$remotedata$RemoteData$map,
					$author$project$MyInsights$CrmDataEngineQuery$AllOf,
					$author$project$RemoteData$Helpers$combine(
						A2(
							$elm$core$List$map,
							$author$project$DataElement$previewCrmDataEngineWhereClause(cache),
							wheres)));
			case 'AnyOf':
				var wheres = whereClause.a;
				return A2(
					$krisajenkins$remotedata$RemoteData$map,
					$author$project$MyInsights$CrmDataEngineQuery$AnyOf,
					$author$project$RemoteData$Helpers$combine(
						A2(
							$elm$core$List$map,
							$author$project$DataElement$previewCrmDataEngineWhereClause(cache),
							wheres)));
			case 'Eq':
				var fieldName = whereClause.a;
				var globalField = whereClause.b;
				return A2(
					$krisajenkins$remotedata$RemoteData$map,
					$author$project$DataElement$crmDataEngineWhereEqualsHelper(fieldName),
					A2($author$project$DataElement$Expression$Preview$globalField, cache, globalField));
			case 'NotEq':
				var fieldName = whereClause.a;
				var globalField = whereClause.b;
				return A2(
					$krisajenkins$remotedata$RemoteData$map,
					$author$project$DataElement$crmDataEngineWhereNotEqualsHelper(fieldName),
					A2($author$project$DataElement$Expression$Preview$globalField, cache, globalField));
			case 'Gt':
				var fieldName = whereClause.a;
				var globalComparable = whereClause.b;
				return A2(
					$krisajenkins$remotedata$RemoteData$map,
					$author$project$DataElement$crmDataEngineWhereGtHelper(fieldName),
					A2($author$project$DataElement$Expression$Preview$globalComparable, cache, globalComparable));
			case 'Gte':
				var fieldName = whereClause.a;
				var globalComparable = whereClause.b;
				return A2(
					$krisajenkins$remotedata$RemoteData$map,
					$author$project$DataElement$crmDataEngineWhereGteHelper(fieldName),
					A2($author$project$DataElement$Expression$Preview$globalComparable, cache, globalComparable));
			case 'Lt':
				var fieldName = whereClause.a;
				var globalComparable = whereClause.b;
				return A2(
					$krisajenkins$remotedata$RemoteData$map,
					$author$project$DataElement$crmDataEngineWhereLtHelper(fieldName),
					A2($author$project$DataElement$Expression$Preview$globalComparable, cache, globalComparable));
			case 'Lte':
				var fieldName = whereClause.a;
				var globalComparable = whereClause.b;
				return A2(
					$krisajenkins$remotedata$RemoteData$map,
					$author$project$DataElement$crmDataEngineWhereLteHelper(fieldName),
					A2($author$project$DataElement$Expression$Preview$globalComparable, cache, globalComparable));
			case 'In':
				var fieldName = whereClause.a;
				var globalStringList = whereClause.b;
				return A2(
					$krisajenkins$remotedata$RemoteData$map,
					$author$project$DataElement$crmDataEngineWhereInHelper(fieldName),
					A2($author$project$DataElement$Expression$Preview$globalStringList, cache, globalStringList));
			case 'BetweenString':
				var fieldName = whereClause.a;
				var globalString = whereClause.b;
				var globalStringB = whereClause.c;
				return A3(
					$krisajenkins$remotedata$RemoteData$map2,
					$author$project$DataElement$crmDataEngineWhereStringBetweenHelper(fieldName),
					A2($author$project$DataElement$Expression$Preview$globalString, cache, globalString),
					A2($author$project$DataElement$Expression$Preview$globalString, cache, globalStringB));
			case 'BetweenDate':
				var fieldName = whereClause.a;
				var globalDate = whereClause.b;
				var globalDateB = whereClause.c;
				return A3(
					$krisajenkins$remotedata$RemoteData$map2,
					$author$project$DataElement$crmDataEngineWhereDateBetweenHelper(fieldName),
					A2($author$project$DataElement$Expression$Preview$globalDate, cache, globalDate),
					A2($author$project$DataElement$Expression$Preview$globalDate, cache, globalDateB));
			case 'BetweenDateTime':
				var fieldName = whereClause.a;
				var globalDateTime = whereClause.b;
				var globalDateTimeB = whereClause.c;
				return A3(
					$krisajenkins$remotedata$RemoteData$map2,
					$author$project$DataElement$crmDataEngineWhereDateTimeBetweenHelper(fieldName),
					A2($author$project$DataElement$Expression$Preview$globalDateTime, cache, globalDateTime),
					A2($author$project$DataElement$Expression$Preview$globalDateTime, cache, globalDateTimeB));
			case 'BetweenNumber':
				var fieldName = whereClause.a;
				var globalNumber = whereClause.b;
				var globalNumberB = whereClause.c;
				return A3(
					$krisajenkins$remotedata$RemoteData$map2,
					$author$project$DataElement$crmDataEngineWhereNumberBetweenHelper(fieldName),
					A2($author$project$DataElement$Expression$Preview$globalNumber, cache, globalNumber),
					A2($author$project$DataElement$Expression$Preview$globalNumber, cache, globalNumberB));
			case 'IsNull':
				var fieldName = whereClause.a;
				return $krisajenkins$remotedata$RemoteData$succeed(
					$author$project$MyInsights$CrmDataEngineQuery$IsNull(
						$author$project$FieldName$toString(fieldName)));
			default:
				var fieldName = whereClause.a;
				return $krisajenkins$remotedata$RemoteData$succeed(
					$author$project$MyInsights$CrmDataEngineQuery$IsNotNull(
						$author$project$FieldName$toString(fieldName)));
		}
	});
var $krisajenkins$remotedata$RemoteData$withDefault = F2(
	function (_default, data) {
		if (data.$ === 'Success') {
			var x = data.a;
			return x;
		} else {
			return _default;
		}
	});
var $krisajenkins$remotedata$RemoteData$toMaybe = A2(
	$elm$core$Basics$composeR,
	$krisajenkins$remotedata$RemoteData$map($elm$core$Maybe$Just),
	$krisajenkins$remotedata$RemoteData$withDefault($elm$core$Maybe$Nothing));
var $author$project$MyInsights$CrmDataEngineQuery$DimensionField = F2(
	function (a, b) {
		return {$: 'DimensionField', a: a, b: b};
	});
var $author$project$MyInsights$CrmDataEngineQuery$MetricField = F2(
	function (a, b) {
		return {$: 'MetricField', a: a, b: b};
	});
var $author$project$MyInsights$CrmDataEngineQuery$PureField = function (a) {
	return {$: 'PureField', a: a};
};
var $author$project$MyInsights$CrmDataEngineQuery$Concat = function (a) {
	return {$: 'Concat', a: a};
};
var $author$project$MyInsights$CrmDataEngineQuery$DateTimeTruncate = F2(
	function (a, b) {
		return {$: 'DateTimeTruncate', a: a, b: b};
	});
var $author$project$MyInsights$CrmDataEngineQuery$DateTruncate = F2(
	function (a, b) {
		return {$: 'DateTruncate', a: a, b: b};
	});
var $author$project$MyInsights$CrmDataEngineQuery$Divide = F2(
	function (a, b) {
		return {$: 'Divide', a: a, b: b};
	});
var $author$project$MyInsights$CrmDataEngineQuery$Minus = F2(
	function (a, b) {
		return {$: 'Minus', a: a, b: b};
	});
var $author$project$MyInsights$CrmDataEngineQuery$Multiply = F2(
	function (a, b) {
		return {$: 'Multiply', a: a, b: b};
	});
var $author$project$MyInsights$CrmDataEngineQuery$Plus = F2(
	function (a, b) {
		return {$: 'Plus', a: a, b: b};
	});
var $author$project$MyInsights$CrmDataEngineQuery$ConcatField = function (a) {
	return {$: 'ConcatField', a: a};
};
var $author$project$MyInsights$CrmDataEngineQuery$ConcatQuote = function (a) {
	return {$: 'ConcatQuote', a: a};
};
var $author$project$DataElement$CrmDataEngine$Field$toMyInsightsConcatFragment = function (fragment) {
	if (fragment.$ === 'ConcatQuote') {
		var string = fragment.a;
		return $author$project$MyInsights$CrmDataEngineQuery$ConcatQuote(string);
	} else {
		var fieldName = fragment.a;
		return $author$project$MyInsights$CrmDataEngineQuery$ConcatField(
			$author$project$FieldName$toString(fieldName));
	}
};
var $author$project$DataElement$CrmDataEngine$ExpandedDateInterval$toString = function (interval) {
	switch (interval.$) {
		case 'Milliseconds':
			return 'MILLISECONDS';
		case 'Second':
			return 'SECOND';
		case 'Minute':
			return 'MINUTE';
		case 'Hour':
			return 'HOUR';
		case 'Day':
			return 'DAY';
		case 'Week':
			return 'WEEK';
		case 'Month':
			return 'MONTH';
		case 'Quarter':
			return 'QUARTER';
		case 'Year':
			return 'YEAR';
		case 'Decade':
			return 'DECADE';
		case 'Century':
			return 'CENTURY';
		default:
			return 'MILLENNIUM';
	}
};
var $author$project$DataElement$CrmDataEngine$Field$toMyInsightsDimension = function (dimension) {
	switch (dimension.$) {
		case 'Concat':
			var concatFragments = dimension.a;
			return $author$project$MyInsights$CrmDataEngineQuery$Concat(
				A2($elm$core$List$map, $author$project$DataElement$CrmDataEngine$Field$toMyInsightsConcatFragment, concatFragments));
		case 'DateTruncate':
			var fieldName = dimension.a;
			var expandedDateInterval = dimension.b;
			return A2(
				$author$project$MyInsights$CrmDataEngineQuery$DateTruncate,
				$author$project$FieldName$toString(fieldName),
				$author$project$DataElement$CrmDataEngine$ExpandedDateInterval$toString(expandedDateInterval));
		case 'DateTimeTruncate':
			var fieldName = dimension.a;
			var expandedDateInterval = dimension.b;
			return A2(
				$author$project$MyInsights$CrmDataEngineQuery$DateTimeTruncate,
				$author$project$FieldName$toString(fieldName),
				$author$project$DataElement$CrmDataEngine$ExpandedDateInterval$toString(expandedDateInterval));
		case 'Divide':
			var fieldName = dimension.a;
			var fieldNameB = dimension.b;
			return A2(
				$author$project$MyInsights$CrmDataEngineQuery$Divide,
				$author$project$FieldName$toString(fieldName),
				$author$project$FieldName$toString(fieldNameB));
		case 'Multiply':
			var fieldName = dimension.a;
			var fieldNameB = dimension.b;
			return A2(
				$author$project$MyInsights$CrmDataEngineQuery$Multiply,
				$author$project$FieldName$toString(fieldName),
				$author$project$FieldName$toString(fieldNameB));
		case 'Minus':
			var fieldName = dimension.a;
			var fieldNameB = dimension.b;
			return A2(
				$author$project$MyInsights$CrmDataEngineQuery$Minus,
				$author$project$FieldName$toString(fieldName),
				$author$project$FieldName$toString(fieldNameB));
		default:
			var fieldName = dimension.a;
			var fieldNameB = dimension.b;
			return A2(
				$author$project$MyInsights$CrmDataEngineQuery$Plus,
				$author$project$FieldName$toString(fieldName),
				$author$project$FieldName$toString(fieldNameB));
	}
};
var $author$project$MyInsights$CrmDataEngineQuery$Count = function (a) {
	return {$: 'Count', a: a};
};
var $author$project$MyInsights$CrmDataEngineQuery$CountDistinct = function (a) {
	return {$: 'CountDistinct', a: a};
};
var $author$project$MyInsights$CrmDataEngineQuery$Max = function (a) {
	return {$: 'Max', a: a};
};
var $author$project$MyInsights$CrmDataEngineQuery$Min = function (a) {
	return {$: 'Min', a: a};
};
var $author$project$MyInsights$CrmDataEngineQuery$Sum = function (a) {
	return {$: 'Sum', a: a};
};
var $author$project$DataElement$CrmDataEngine$Field$toMyInsightsMetric = function (metric) {
	switch (metric.$) {
		case 'Sum':
			var fieldName = metric.a;
			return $author$project$MyInsights$CrmDataEngineQuery$Sum(
				$author$project$FieldName$toString(fieldName));
		case 'Count':
			var fieldName = metric.a;
			return $author$project$MyInsights$CrmDataEngineQuery$Count(
				$author$project$FieldName$toString(fieldName));
		case 'CountDistinct':
			var fieldName = metric.a;
			return $author$project$MyInsights$CrmDataEngineQuery$CountDistinct(
				$author$project$FieldName$toString(fieldName));
		case 'Max':
			var fieldName = metric.a;
			return $author$project$MyInsights$CrmDataEngineQuery$Max(
				$author$project$FieldName$toString(fieldName));
		default:
			var fieldName = metric.a;
			return $author$project$MyInsights$CrmDataEngineQuery$Min(
				$author$project$FieldName$toString(fieldName));
	}
};
var $author$project$DataElement$CrmDataEngine$Field$toMyInsightsField = function (field) {
	switch (field.$) {
		case 'PureField':
			var fieldName = field.a;
			return $author$project$MyInsights$CrmDataEngineQuery$PureField(
				$author$project$FieldName$toString(fieldName));
		case 'DimensionField':
			var dimensionName = field.a;
			var dimension = field.b;
			return A2(
				$author$project$MyInsights$CrmDataEngineQuery$DimensionField,
				$author$project$FieldName$toString(dimensionName),
				$author$project$DataElement$CrmDataEngine$Field$toMyInsightsDimension(dimension));
		default:
			var metricName = field.a;
			var metric = field.b;
			return A2(
				$author$project$MyInsights$CrmDataEngineQuery$MetricField,
				$author$project$FieldName$toString(metricName),
				$author$project$DataElement$CrmDataEngine$Field$toMyInsightsMetric(metric));
	}
};
var $author$project$MyInsights$CrmDataEngineQuery$Ascending = {$: 'Ascending'};
var $author$project$MyInsights$CrmDataEngineQuery$Descending = {$: 'Descending'};
var $author$project$DataElement$SortKey$toMyInsightsDirection = function (dir) {
	if (dir.$ === 'Ascending') {
		return $author$project$MyInsights$CrmDataEngineQuery$Ascending;
	} else {
		return $author$project$MyInsights$CrmDataEngineQuery$Descending;
	}
};
var $author$project$DataElement$SortKey$toMyInsightsSort = function (sort) {
	return {
		direction: $author$project$DataElement$SortKey$toMyInsightsDirection(sort.direction),
		field: $author$project$FieldName$toString(sort.field)
	};
};
var $author$project$ObjectName$toString = function (_v0) {
	var name = _v0.a;
	return name;
};
var $author$project$DataElement$crmDataEngineQueryToQueryDetails = F2(
	function (cache, info) {
		var _v0 = info.whereClause;
		if (_v0.$ === 'Nothing') {
			return $elm$core$Maybe$Just(
				A3(
					$author$project$DataEngine$QueryToRun$CrmDataEngineQuery,
					{
						fields: $mgold$elm_nonempty_list$List$Nonempty$toList(
							A2($mgold$elm_nonempty_list$List$Nonempty$map, $author$project$DataElement$CrmDataEngine$Field$toMyInsightsField, info.fields)),
						limit: info.limit,
						sort: A2($elm$core$List$map, $author$project$DataElement$SortKey$toMyInsightsSort, info.sort),
						table: $author$project$ObjectName$toString(info.table),
						whereClause: $elm$core$Maybe$Nothing
					},
					$author$project$DataEngine$RecordMetadata$fromList(
						$pzp1997$assoc_list$AssocList$toList(
							$author$project$DataElement$CrmDataEngineQuery$fields(info))),
					$author$project$DataElement$crmDataEngineQueryDecoder(info)));
		} else {
			var whereClause = _v0.a;
			return A2(
				$elm$core$Maybe$map,
				function (where_) {
					return A3(
						$author$project$DataEngine$QueryToRun$CrmDataEngineQuery,
						{
							fields: $mgold$elm_nonempty_list$List$Nonempty$toList(
								A2($mgold$elm_nonempty_list$List$Nonempty$map, $author$project$DataElement$CrmDataEngine$Field$toMyInsightsField, info.fields)),
							limit: info.limit,
							sort: A2($elm$core$List$map, $author$project$DataElement$SortKey$toMyInsightsSort, info.sort),
							table: $author$project$ObjectName$toString(info.table),
							whereClause: $elm$core$Maybe$Just(where_)
						},
						$author$project$DataEngine$RecordMetadata$fromList(
							$pzp1997$assoc_list$AssocList$toList(
								$author$project$DataElement$CrmDataEngineQuery$fields(info))),
						$author$project$DataElement$crmDataEngineQueryDecoder(info));
				},
				$krisajenkins$remotedata$RemoteData$toMaybe(
					A2($author$project$DataElement$previewCrmDataEngineWhereClause, cache, whereClause)));
		}
	});
var $author$project$MyInsights$Helpers$Crm = {$: 'Crm'};
var $author$project$DataEngine$QueryToRun$CrmQuery = F3(
	function (a, b, c) {
		return {$: 'CrmQuery', a: a, b: b, c: c};
	});
var $author$project$MyInsights$QueryConfig = function (a) {
	return {$: 'QueryConfig', a: a};
};
var $author$project$MyInsights$blankQuery = {fields: _List_Nil, limit: $elm$core$Maybe$Nothing, object: '', picklists: _List_Nil, sort: _List_Nil, where_: $elm$core$Maybe$Nothing};
var $author$project$MyInsights$crmQuery = F2(
	function (object, fields) {
		return $author$project$MyInsights$QueryConfig(
			_Utils_update(
				$author$project$MyInsights$blankQuery,
				{fields: fields, object: object}));
	});
var $author$project$MyInsights$setLimit = F2(
	function (limit, _v0) {
		var config = _v0.a;
		return $author$project$MyInsights$QueryConfig(
			_Utils_update(
				config,
				{
					limit: $elm$core$Maybe$Just(limit)
				}));
	});
var $author$project$MyInsights$setSort = F2(
	function (sort, _v0) {
		var config = _v0.a;
		return $author$project$MyInsights$QueryConfig(
			_Utils_update(
				config,
				{sort: sort}));
	});
var $author$project$SortDirection$toQuerySortString = function (dir) {
	if (dir.$ === 'Ascending') {
		return 'ASC';
	} else {
		return 'DESC';
	}
};
var $author$project$DataElement$SortKey$toQuerySortString = function (_v0) {
	var field = _v0.field;
	var direction = _v0.direction;
	return $author$project$FieldName$toString(field) + (' ' + $author$project$SortDirection$toQuerySortString(direction));
};
var $author$project$DataElement$basicCrmQuery = function (info) {
	return A2(
		$author$project$MyInsights$setSort,
		A2($elm$core$List$map, $author$project$DataElement$SortKey$toQuerySortString, info.sort),
		A3(
			$author$project$Preview$Helpers$maybeApply,
			$author$project$MyInsights$setLimit,
			info.limit,
			A2(
				$author$project$MyInsights$crmQuery,
				$author$project$ObjectName$toString(info.objectName),
				A2(
					$elm$core$List$map,
					$author$project$FieldName$toString,
					$pzp1997$assoc_list$AssocList$keys(info.fields)))));
};
var $author$project$DataElement$basicQueryDecoder = function (info) {
	return A3(
		$elm$core$List$foldl,
		$author$project$Preview$Helpers$addFieldDecoder(info.objectTags),
		$elm$json$Json$Decode$succeed($author$project$DataEngine$RecordCache$empty),
		$pzp1997$assoc_list$AssocList$toList(info.fields));
};
var $elm$core$Tuple$mapSecond = F2(
	function (func, _v0) {
		var x = _v0.a;
		var y = _v0.b;
		return _Utils_Tuple2(
			x,
			func(y));
	});
var $author$project$DataElement$metadataForFieldInfoDict = function (dict) {
	return $author$project$DataEngine$RecordMetadata$fromList(
		A2(
			$elm$core$List$map,
			$elm$core$Tuple$mapSecond(
				function ($) {
					return $.fieldType;
				}),
			$pzp1997$assoc_list$AssocList$toList(dict)));
};
var $author$project$MyInsights$WhereAnd = function (a) {
	return {$: 'WhereAnd', a: a};
};
var $author$project$MyInsights$WhereOr = function (a) {
	return {$: 'WhereOr', a: a};
};
var $author$project$MyInsights$Online = {$: 'Online'};
var $author$project$MyInsights$Where = function (a) {
	return {$: 'Where', a: a};
};
var $author$project$MyInsights$Helpers$getPlaceholderClause = function (crmOrNitro) {
	switch (crmOrNitro.$) {
		case 'Crm':
			return '(ID=NULL AND ID=\'000000000000000\')';
		case 'Nitro':
			return '(TRUE=False)';
		default:
			return '(ID=NULL AND ID=\'000000000000000\')';
	}
};
var $author$project$MyInsights$Helpers$Never = {$: 'Never'};
var $author$project$MyInsights$Helpers$OfflineOnly = {$: 'OfflineOnly'};
var $author$project$MyInsights$Helpers$WindowsOnly = {$: 'WindowsOnly'};
var $author$project$MyInsights$Helpers$boolQuoteUsage = function (crmOrNitro) {
	switch (crmOrNitro.$) {
		case 'Crm':
			return $author$project$MyInsights$Helpers$WindowsOnly;
		case 'Nitro':
			return $author$project$MyInsights$Helpers$OfflineOnly;
		default:
			return $author$project$MyInsights$Helpers$Never;
	}
};
var $author$project$MyInsights$Helpers$boolToString = function (bool) {
	return bool ? 'true' : 'false';
};
var $author$project$MyInsights$Helpers$wrapInQuotes = function (words) {
	return '\'' + (A3(
		$elm$core$String$replace,
		'\'',
		'\\\'',
		A3($elm$core$String$replace, '\\', '\\\\', words)) + '\'');
};
var $author$project$MyInsights$Helpers$wrapInQuotesIfNecessary = F3(
	function (useQuotes, onlineStatus, words) {
		var _v0 = _Utils_Tuple2(useQuotes, onlineStatus);
		_v0$5:
		while (true) {
			switch (_v0.a.$) {
				case 'Always':
					var _v1 = _v0.a;
					return $author$project$MyInsights$Helpers$wrapInQuotes(words);
				case 'OnlineOnly':
					if (_v0.b.$ === 'Online') {
						var _v2 = _v0.a;
						var _v3 = _v0.b;
						return $author$project$MyInsights$Helpers$wrapInQuotes(words);
					} else {
						break _v0$5;
					}
				case 'OfflineOnly':
					switch (_v0.b.$) {
						case 'Windows':
							var _v4 = _v0.a;
							var _v5 = _v0.b;
							return $author$project$MyInsights$Helpers$wrapInQuotes(words);
						case 'IOs':
							var _v6 = _v0.a;
							var _v7 = _v0.b;
							return $author$project$MyInsights$Helpers$wrapInQuotes(words);
						default:
							break _v0$5;
					}
				case 'WindowsOnly':
					if (_v0.b.$ === 'Windows') {
						var _v8 = _v0.a;
						var _v9 = _v0.b;
						return $author$project$MyInsights$Helpers$wrapInQuotes(words);
					} else {
						break _v0$5;
					}
				default:
					break _v0$5;
			}
		}
		return $elm$core$String$isEmpty(words) ? '\'\'' : words;
	});
var $author$project$MyInsights$Helpers$complexWhere = F5(
	function (info, crmOrNitro, onlineStatus, fieldName, maybeValue) {
		return $author$project$MyInsights$Where(
			A2(
				$elm$core$String$join,
				'',
				_List_fromArray(
					[
						fieldName,
						info.symbol,
						A2(info.postSymbolTag, crmOrNitro, onlineStatus),
						A3(
						$author$project$MyInsights$Helpers$wrapInQuotesIfNecessary,
						info.useSingleQuotes(crmOrNitro),
						onlineStatus,
						A2(
							$elm$core$Maybe$withDefault,
							'',
							A2($elm$core$Maybe$map, info.toString, maybeValue)))
					])));
	});
var $author$project$MyInsights$Helpers$whereBoolEquals = $author$project$MyInsights$Helpers$complexWhere(
	{
		postSymbolTag: F2(
			function (_v0, _v1) {
				return '';
			}),
		symbol: '=',
		toString: $author$project$MyInsights$Helpers$boolToString,
		useSingleQuotes: $author$project$MyInsights$Helpers$boolQuoteUsage
	});
var $author$project$MyInsights$Helpers$datePostSymbolTag = F2(
	function (crmOrNitro, platform) {
		var _v0 = _Utils_Tuple2(crmOrNitro, platform);
		if ((_v0.a.$ === 'Nitro') && (_v0.b.$ === 'Online')) {
			var _v1 = _v0.a;
			var _v2 = _v0.b;
			return ' date ';
		} else {
			return '';
		}
	});
var $author$project$MyInsights$Helpers$Always = {$: 'Always'};
var $author$project$MyInsights$Helpers$dateQuoteUsage = function (crmOrNitro) {
	switch (crmOrNitro.$) {
		case 'Crm':
			return $author$project$MyInsights$Helpers$OfflineOnly;
		case 'Nitro':
			return $author$project$MyInsights$Helpers$Always;
		default:
			return $author$project$MyInsights$Helpers$Always;
	}
};
var $author$project$MyInsights$Helpers$whereDateEquals = $author$project$MyInsights$Helpers$complexWhere(
	{postSymbolTag: $author$project$MyInsights$Helpers$datePostSymbolTag, symbol: '=', toString: $justinmimbs$date$Date$toIsoString, useSingleQuotes: $author$project$MyInsights$Helpers$dateQuoteUsage});
var $author$project$MyInsights$Helpers$dateTimePostSymbolTag = F2(
	function (crmOrNitro, platform) {
		var _v0 = _Utils_Tuple2(crmOrNitro, platform);
		if ((_v0.a.$ === 'Nitro') && (_v0.b.$ === 'Online')) {
			var _v1 = _v0.a;
			var _v2 = _v0.b;
			return ' from_iso8601_timestamp(';
		} else {
			return '';
		}
	});
var $author$project$MyInsights$Helpers$dateTimePostValueTag = F2(
	function (crmOrNitro, platform) {
		var _v0 = _Utils_Tuple2(crmOrNitro, platform);
		if ((_v0.a.$ === 'Nitro') && (_v0.b.$ === 'Online')) {
			var _v1 = _v0.a;
			var _v2 = _v0.b;
			return ')';
		} else {
			return '';
		}
	});
var $rtfeldman$elm_iso8601_date_strings$Iso8601$fromMonth = function (month) {
	switch (month.$) {
		case 'Jan':
			return 1;
		case 'Feb':
			return 2;
		case 'Mar':
			return 3;
		case 'Apr':
			return 4;
		case 'May':
			return 5;
		case 'Jun':
			return 6;
		case 'Jul':
			return 7;
		case 'Aug':
			return 8;
		case 'Sep':
			return 9;
		case 'Oct':
			return 10;
		case 'Nov':
			return 11;
		default:
			return 12;
	}
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$toPaddedString = F2(
	function (digits, time) {
		return A3(
			$elm$core$String$padLeft,
			digits,
			_Utils_chr('0'),
			$elm$core$String$fromInt(time));
	});
var $rtfeldman$elm_iso8601_date_strings$Iso8601$fromTime = function (time) {
	return A2(
		$rtfeldman$elm_iso8601_date_strings$Iso8601$toPaddedString,
		4,
		A2($elm$time$Time$toYear, $elm$time$Time$utc, time)) + ('-' + (A2(
		$rtfeldman$elm_iso8601_date_strings$Iso8601$toPaddedString,
		2,
		$rtfeldman$elm_iso8601_date_strings$Iso8601$fromMonth(
			A2($elm$time$Time$toMonth, $elm$time$Time$utc, time))) + ('-' + (A2(
		$rtfeldman$elm_iso8601_date_strings$Iso8601$toPaddedString,
		2,
		A2($elm$time$Time$toDay, $elm$time$Time$utc, time)) + ('T' + (A2(
		$rtfeldman$elm_iso8601_date_strings$Iso8601$toPaddedString,
		2,
		A2($elm$time$Time$toHour, $elm$time$Time$utc, time)) + (':' + (A2(
		$rtfeldman$elm_iso8601_date_strings$Iso8601$toPaddedString,
		2,
		A2($elm$time$Time$toMinute, $elm$time$Time$utc, time)) + (':' + (A2(
		$rtfeldman$elm_iso8601_date_strings$Iso8601$toPaddedString,
		2,
		A2($elm$time$Time$toSecond, $elm$time$Time$utc, time)) + ('.' + (A2(
		$rtfeldman$elm_iso8601_date_strings$Iso8601$toPaddedString,
		3,
		A2($elm$time$Time$toMillis, $elm$time$Time$utc, time)) + 'Z'))))))))))));
};
var $author$project$MyInsights$Helpers$quiteComplexWhere = F5(
	function (info, crmOrNitro, onlineStatus, fieldName, maybeValue) {
		return $author$project$MyInsights$Where(
			A2(
				$elm$core$String$join,
				'',
				_List_fromArray(
					[
						fieldName,
						info.symbol,
						A2(info.postSymbolTag, crmOrNitro, onlineStatus),
						A3(
						$author$project$MyInsights$Helpers$wrapInQuotesIfNecessary,
						info.useSingleQuotes(crmOrNitro),
						onlineStatus,
						A2(
							$elm$core$Maybe$withDefault,
							'',
							A2($elm$core$Maybe$map, info.toString, maybeValue))),
						A2(info.postValueTag, crmOrNitro, onlineStatus)
					])));
	});
var $author$project$MyInsights$Helpers$whereDateTimeEquals = $author$project$MyInsights$Helpers$quiteComplexWhere(
	{postSymbolTag: $author$project$MyInsights$Helpers$dateTimePostSymbolTag, postValueTag: $author$project$MyInsights$Helpers$dateTimePostValueTag, symbol: '=', toString: $rtfeldman$elm_iso8601_date_strings$Iso8601$fromTime, useSingleQuotes: $author$project$MyInsights$Helpers$dateQuoteUsage});
var $author$project$MyInsights$Helpers$basicWhere = F4(
	function (info, onlineStatus, fieldName, maybeValue) {
		return $author$project$MyInsights$Where(
			A2(
				$elm$core$String$join,
				' ',
				_List_fromArray(
					[
						fieldName,
						info.symbol,
						A3(
						$author$project$MyInsights$Helpers$wrapInQuotesIfNecessary,
						info.useSingleQuotes,
						onlineStatus,
						A2(
							$elm$core$Maybe$withDefault,
							'',
							A2($elm$core$Maybe$map, info.toString, maybeValue)))
					])));
	});
var $author$project$MyInsights$Helpers$whereNumberEquals = $author$project$MyInsights$Helpers$basicWhere(
	{symbol: '=', toString: $elm$core$String$fromFloat, useSingleQuotes: $author$project$MyInsights$Helpers$Never});
var $author$project$MyInsights$Helpers$whereStringEquals = $author$project$MyInsights$Helpers$basicWhere(
	{
		symbol: '=',
		toString: function ($) {
			return $.text;
		},
		useSingleQuotes: $author$project$MyInsights$Helpers$Always
	});
var $author$project$DataElement$whereEqualsEngineHelper = F3(
	function (crmOrNitro, fieldName, maybeValue) {
		if (maybeValue.$ === 'Just') {
			switch (maybeValue.a.$) {
				case 'StringValue':
					var words = maybeValue.a.a;
					return A3(
						$author$project$MyInsights$Helpers$whereStringEquals,
						$author$project$MyInsights$Online,
						$author$project$FieldName$toString(fieldName),
						$elm$core$Maybe$Just(words));
				case 'NumberValue':
					var _float = maybeValue.a.a;
					return A3(
						$author$project$MyInsights$Helpers$whereNumberEquals,
						$author$project$MyInsights$Online,
						$author$project$FieldName$toString(fieldName),
						$elm$core$Maybe$Just(_float));
				case 'DateValue':
					var date = maybeValue.a.a;
					return A4(
						$author$project$MyInsights$Helpers$whereDateEquals,
						crmOrNitro,
						$author$project$MyInsights$Online,
						$author$project$FieldName$toString(fieldName),
						$elm$core$Maybe$Just(date));
				case 'DateTimeValue':
					var datetime = maybeValue.a.a;
					return A4(
						$author$project$MyInsights$Helpers$whereDateTimeEquals,
						crmOrNitro,
						$author$project$MyInsights$Online,
						$author$project$FieldName$toString(fieldName),
						$elm$core$Maybe$Just(datetime));
				default:
					var bool = maybeValue.a.a;
					return A4(
						$author$project$MyInsights$Helpers$whereBoolEquals,
						crmOrNitro,
						$author$project$MyInsights$Online,
						$author$project$FieldName$toString(fieldName),
						$elm$core$Maybe$Just(bool));
			}
		} else {
			return $author$project$MyInsights$Where(
				$author$project$MyInsights$Helpers$getPlaceholderClause(crmOrNitro));
		}
	});
var $author$project$MyInsights$Helpers$whereDateGTE = $author$project$MyInsights$Helpers$complexWhere(
	{postSymbolTag: $author$project$MyInsights$Helpers$datePostSymbolTag, symbol: '>=', toString: $justinmimbs$date$Date$toIsoString, useSingleQuotes: $author$project$MyInsights$Helpers$dateQuoteUsage});
var $author$project$MyInsights$Helpers$whereDateTimeGTE = $author$project$MyInsights$Helpers$quiteComplexWhere(
	{postSymbolTag: $author$project$MyInsights$Helpers$dateTimePostSymbolTag, postValueTag: $author$project$MyInsights$Helpers$dateTimePostValueTag, symbol: '>=', toString: $rtfeldman$elm_iso8601_date_strings$Iso8601$fromTime, useSingleQuotes: $author$project$MyInsights$Helpers$dateQuoteUsage});
var $author$project$MyInsights$Helpers$whereNumberGTE = $author$project$MyInsights$Helpers$basicWhere(
	{symbol: '>=', toString: $elm$core$String$fromFloat, useSingleQuotes: $author$project$MyInsights$Helpers$Never});
var $author$project$MyInsights$Helpers$whereStringGTE = $author$project$MyInsights$Helpers$basicWhere(
	{
		symbol: '>=',
		toString: function ($) {
			return $.text;
		},
		useSingleQuotes: $author$project$MyInsights$Helpers$Always
	});
var $author$project$DataElement$whereGTEEngineHelper = F3(
	function (crmOrNitro, fieldName, maybeValue) {
		if (maybeValue.$ === 'Just') {
			switch (maybeValue.a.$) {
				case 'StringValue':
					var words = maybeValue.a.a;
					return A3(
						$author$project$MyInsights$Helpers$whereStringGTE,
						$author$project$MyInsights$Online,
						$author$project$FieldName$toString(fieldName),
						$elm$core$Maybe$Just(words));
				case 'NumberValue':
					var _float = maybeValue.a.a;
					return A3(
						$author$project$MyInsights$Helpers$whereNumberGTE,
						$author$project$MyInsights$Online,
						$author$project$FieldName$toString(fieldName),
						$elm$core$Maybe$Just(_float));
				case 'DateValue':
					var date = maybeValue.a.a;
					return A4(
						$author$project$MyInsights$Helpers$whereDateGTE,
						crmOrNitro,
						$author$project$MyInsights$Online,
						$author$project$FieldName$toString(fieldName),
						$elm$core$Maybe$Just(date));
				case 'DateTimeValue':
					var datetime = maybeValue.a.a;
					return A4(
						$author$project$MyInsights$Helpers$whereDateTimeGTE,
						crmOrNitro,
						$author$project$MyInsights$Online,
						$author$project$FieldName$toString(fieldName),
						$elm$core$Maybe$Just(datetime));
				default:
					return $author$project$MyInsights$Where(
						$author$project$MyInsights$Helpers$getPlaceholderClause(crmOrNitro));
			}
		} else {
			return $author$project$MyInsights$Where(
				$author$project$MyInsights$Helpers$getPlaceholderClause(crmOrNitro));
		}
	});
var $author$project$MyInsights$Helpers$whereDateGT = $author$project$MyInsights$Helpers$complexWhere(
	{postSymbolTag: $author$project$MyInsights$Helpers$datePostSymbolTag, symbol: '>', toString: $justinmimbs$date$Date$toIsoString, useSingleQuotes: $author$project$MyInsights$Helpers$dateQuoteUsage});
var $author$project$MyInsights$Helpers$whereDateTimeGT = $author$project$MyInsights$Helpers$quiteComplexWhere(
	{postSymbolTag: $author$project$MyInsights$Helpers$dateTimePostSymbolTag, postValueTag: $author$project$MyInsights$Helpers$dateTimePostValueTag, symbol: '>', toString: $rtfeldman$elm_iso8601_date_strings$Iso8601$fromTime, useSingleQuotes: $author$project$MyInsights$Helpers$dateQuoteUsage});
var $author$project$MyInsights$Helpers$whereNumberGT = $author$project$MyInsights$Helpers$basicWhere(
	{symbol: '>', toString: $elm$core$String$fromFloat, useSingleQuotes: $author$project$MyInsights$Helpers$Never});
var $author$project$MyInsights$Helpers$whereStringGT = $author$project$MyInsights$Helpers$basicWhere(
	{
		symbol: '>',
		toString: function ($) {
			return $.text;
		},
		useSingleQuotes: $author$project$MyInsights$Helpers$Always
	});
var $author$project$DataElement$whereGTEngineHelper = F3(
	function (crmOrNitro, fieldName, maybeValue) {
		if (maybeValue.$ === 'Just') {
			switch (maybeValue.a.$) {
				case 'StringValue':
					var words = maybeValue.a.a;
					return A3(
						$author$project$MyInsights$Helpers$whereStringGT,
						$author$project$MyInsights$Online,
						$author$project$FieldName$toString(fieldName),
						$elm$core$Maybe$Just(words));
				case 'NumberValue':
					var _float = maybeValue.a.a;
					return A3(
						$author$project$MyInsights$Helpers$whereNumberGT,
						$author$project$MyInsights$Online,
						$author$project$FieldName$toString(fieldName),
						$elm$core$Maybe$Just(_float));
				case 'DateValue':
					var date = maybeValue.a.a;
					return A4(
						$author$project$MyInsights$Helpers$whereDateGT,
						crmOrNitro,
						$author$project$MyInsights$Online,
						$author$project$FieldName$toString(fieldName),
						$elm$core$Maybe$Just(date));
				case 'DateTimeValue':
					var datetime = maybeValue.a.a;
					return A4(
						$author$project$MyInsights$Helpers$whereDateTimeGT,
						crmOrNitro,
						$author$project$MyInsights$Online,
						$author$project$FieldName$toString(fieldName),
						$elm$core$Maybe$Just(datetime));
				default:
					return $author$project$MyInsights$Where(
						$author$project$MyInsights$Helpers$getPlaceholderClause(crmOrNitro));
			}
		} else {
			return $author$project$MyInsights$Where(
				$author$project$MyInsights$Helpers$getPlaceholderClause(crmOrNitro));
		}
	});
var $author$project$MyInsights$WhereEmptyList = function (a) {
	return {$: 'WhereEmptyList', a: a};
};
var $author$project$MyInsights$wrapInSingleQuote = function (words) {
	return '\'' + (words + '\'');
};
var $author$project$MyInsights$getInStatement = F2(
	function (status, values) {
		var _v0 = function () {
			switch (status.$) {
				case 'Online':
					return _Utils_Tuple2('(', ')');
				case 'Windows':
					return _Utils_Tuple2('{', '}');
				default:
					return _Utils_Tuple2('{', '}');
			}
		}();
		var start = _v0.a;
		var end = _v0.b;
		return _Utils_ap(
			start,
			_Utils_ap(
				A2(
					$elm$core$String$join,
					',',
					A2($elm$core$List$map, $author$project$MyInsights$wrapInSingleQuote, values)),
				end));
	});
var $author$project$MyInsights$whereIn = F3(
	function (onlineStatus, field, values) {
		if (!values.b) {
			return $author$project$MyInsights$WhereEmptyList(
				field + (' IN ' + A2($author$project$MyInsights$getInStatement, onlineStatus, values)));
		} else {
			return $author$project$MyInsights$Where(
				field + (' IN ' + A2($author$project$MyInsights$getInStatement, onlineStatus, values)));
		}
	});
var $author$project$MyInsights$Helpers$whereDateLTE = $author$project$MyInsights$Helpers$complexWhere(
	{postSymbolTag: $author$project$MyInsights$Helpers$datePostSymbolTag, symbol: '<=', toString: $justinmimbs$date$Date$toIsoString, useSingleQuotes: $author$project$MyInsights$Helpers$dateQuoteUsage});
var $author$project$MyInsights$Helpers$whereDateTimeLTE = $author$project$MyInsights$Helpers$quiteComplexWhere(
	{postSymbolTag: $author$project$MyInsights$Helpers$dateTimePostSymbolTag, postValueTag: $author$project$MyInsights$Helpers$dateTimePostValueTag, symbol: '<=', toString: $rtfeldman$elm_iso8601_date_strings$Iso8601$fromTime, useSingleQuotes: $author$project$MyInsights$Helpers$dateQuoteUsage});
var $author$project$MyInsights$Helpers$whereNumberLTE = $author$project$MyInsights$Helpers$basicWhere(
	{symbol: '<=', toString: $elm$core$String$fromFloat, useSingleQuotes: $author$project$MyInsights$Helpers$Never});
var $author$project$MyInsights$Helpers$whereStringLTE = $author$project$MyInsights$Helpers$basicWhere(
	{
		symbol: '<=',
		toString: function ($) {
			return $.text;
		},
		useSingleQuotes: $author$project$MyInsights$Helpers$Always
	});
var $author$project$DataElement$whereLTEEngineHelper = F3(
	function (crmOrNitro, fieldName, maybeValue) {
		if (maybeValue.$ === 'Just') {
			switch (maybeValue.a.$) {
				case 'StringValue':
					var words = maybeValue.a.a;
					return A3(
						$author$project$MyInsights$Helpers$whereStringLTE,
						$author$project$MyInsights$Online,
						$author$project$FieldName$toString(fieldName),
						$elm$core$Maybe$Just(words));
				case 'NumberValue':
					var _float = maybeValue.a.a;
					return A3(
						$author$project$MyInsights$Helpers$whereNumberLTE,
						$author$project$MyInsights$Online,
						$author$project$FieldName$toString(fieldName),
						$elm$core$Maybe$Just(_float));
				case 'DateValue':
					var date = maybeValue.a.a;
					return A4(
						$author$project$MyInsights$Helpers$whereDateLTE,
						crmOrNitro,
						$author$project$MyInsights$Online,
						$author$project$FieldName$toString(fieldName),
						$elm$core$Maybe$Just(date));
				case 'DateTimeValue':
					var datetime = maybeValue.a.a;
					return A4(
						$author$project$MyInsights$Helpers$whereDateTimeLTE,
						crmOrNitro,
						$author$project$MyInsights$Online,
						$author$project$FieldName$toString(fieldName),
						$elm$core$Maybe$Just(datetime));
				default:
					return $author$project$MyInsights$Where(
						$author$project$MyInsights$Helpers$getPlaceholderClause(crmOrNitro));
			}
		} else {
			return $author$project$MyInsights$Where(
				$author$project$MyInsights$Helpers$getPlaceholderClause(crmOrNitro));
		}
	});
var $author$project$MyInsights$Helpers$whereDateLT = $author$project$MyInsights$Helpers$complexWhere(
	{postSymbolTag: $author$project$MyInsights$Helpers$datePostSymbolTag, symbol: '<', toString: $justinmimbs$date$Date$toIsoString, useSingleQuotes: $author$project$MyInsights$Helpers$dateQuoteUsage});
var $author$project$MyInsights$Helpers$whereDateTimeLT = $author$project$MyInsights$Helpers$quiteComplexWhere(
	{postSymbolTag: $author$project$MyInsights$Helpers$dateTimePostSymbolTag, postValueTag: $author$project$MyInsights$Helpers$dateTimePostValueTag, symbol: '<', toString: $rtfeldman$elm_iso8601_date_strings$Iso8601$fromTime, useSingleQuotes: $author$project$MyInsights$Helpers$dateQuoteUsage});
var $author$project$MyInsights$Helpers$whereNumberLT = $author$project$MyInsights$Helpers$basicWhere(
	{symbol: '<', toString: $elm$core$String$fromFloat, useSingleQuotes: $author$project$MyInsights$Helpers$Never});
var $author$project$MyInsights$Helpers$whereStringLT = $author$project$MyInsights$Helpers$basicWhere(
	{
		symbol: '<',
		toString: function ($) {
			return $.text;
		},
		useSingleQuotes: $author$project$MyInsights$Helpers$Always
	});
var $author$project$DataElement$whereLTEngineHelper = F3(
	function (crmOrNitro, fieldName, maybeValue) {
		if (maybeValue.$ === 'Just') {
			switch (maybeValue.a.$) {
				case 'StringValue':
					var words = maybeValue.a.a;
					return A3(
						$author$project$MyInsights$Helpers$whereStringLT,
						$author$project$MyInsights$Online,
						$author$project$FieldName$toString(fieldName),
						$elm$core$Maybe$Just(words));
				case 'NumberValue':
					var _float = maybeValue.a.a;
					return A3(
						$author$project$MyInsights$Helpers$whereNumberLT,
						$author$project$MyInsights$Online,
						$author$project$FieldName$toString(fieldName),
						$elm$core$Maybe$Just(_float));
				case 'DateValue':
					var date = maybeValue.a.a;
					return A4(
						$author$project$MyInsights$Helpers$whereDateLT,
						crmOrNitro,
						$author$project$MyInsights$Online,
						$author$project$FieldName$toString(fieldName),
						$elm$core$Maybe$Just(date));
				case 'DateTimeValue':
					var datetime = maybeValue.a.a;
					return A4(
						$author$project$MyInsights$Helpers$whereDateTimeLT,
						crmOrNitro,
						$author$project$MyInsights$Online,
						$author$project$FieldName$toString(fieldName),
						$elm$core$Maybe$Just(datetime));
				default:
					return $author$project$MyInsights$Where(
						$author$project$MyInsights$Helpers$getPlaceholderClause(crmOrNitro));
			}
		} else {
			return $author$project$MyInsights$Where(
				$author$project$MyInsights$Helpers$getPlaceholderClause(crmOrNitro));
		}
	});
var $author$project$MyInsights$Helpers$whereBoolNotEquals = $author$project$MyInsights$Helpers$complexWhere(
	{
		postSymbolTag: F2(
			function (_v0, _v1) {
				return '';
			}),
		symbol: '!=',
		toString: $author$project$MyInsights$Helpers$boolToString,
		useSingleQuotes: $author$project$MyInsights$Helpers$boolQuoteUsage
	});
var $author$project$MyInsights$IOs = {$: 'IOs'};
var $author$project$MyInsights$Helpers$iOsWhereEqualsNull = function (fieldName) {
	return $author$project$MyInsights$Where(fieldName + ' = null');
};
var $author$project$MyInsights$Helpers$iosComplexWhereNotEquals = F4(
	function (info, crmOrNitro, fieldName, maybeValue) {
		return $author$project$MyInsights$WhereOr(
			_List_fromArray(
				[
					A5($author$project$MyInsights$Helpers$complexWhere, info, crmOrNitro, $author$project$MyInsights$IOs, fieldName, maybeValue),
					$author$project$MyInsights$Helpers$iOsWhereEqualsNull(fieldName)
				]));
	});
var $author$project$MyInsights$Helpers$whereDateNotEquals = F2(
	function (queryType, platform) {
		if (platform.$ === 'IOs') {
			return A2(
				$author$project$MyInsights$Helpers$iosComplexWhereNotEquals,
				{postSymbolTag: $author$project$MyInsights$Helpers$datePostSymbolTag, symbol: '!=', toString: $justinmimbs$date$Date$toIsoString, useSingleQuotes: $author$project$MyInsights$Helpers$dateQuoteUsage},
				queryType);
		} else {
			return A3(
				$author$project$MyInsights$Helpers$complexWhere,
				{postSymbolTag: $author$project$MyInsights$Helpers$datePostSymbolTag, symbol: '!=', toString: $justinmimbs$date$Date$toIsoString, useSingleQuotes: $author$project$MyInsights$Helpers$dateQuoteUsage},
				queryType,
				platform);
		}
	});
var $author$project$MyInsights$Helpers$iosQuiteComplexWhereNotEquals = F4(
	function (info, crmOrNitro, fieldName, maybeValue) {
		return $author$project$MyInsights$WhereOr(
			_List_fromArray(
				[
					A5($author$project$MyInsights$Helpers$quiteComplexWhere, info, crmOrNitro, $author$project$MyInsights$IOs, fieldName, maybeValue),
					$author$project$MyInsights$Helpers$iOsWhereEqualsNull(fieldName)
				]));
	});
var $author$project$MyInsights$Helpers$whereDateTimeNotEquals = F2(
	function (queryType, platform) {
		if (platform.$ === 'IOs') {
			return A2(
				$author$project$MyInsights$Helpers$iosQuiteComplexWhereNotEquals,
				{postSymbolTag: $author$project$MyInsights$Helpers$dateTimePostSymbolTag, postValueTag: $author$project$MyInsights$Helpers$dateTimePostValueTag, symbol: '!=', toString: $rtfeldman$elm_iso8601_date_strings$Iso8601$fromTime, useSingleQuotes: $author$project$MyInsights$Helpers$dateQuoteUsage},
				queryType);
		} else {
			return A3(
				$author$project$MyInsights$Helpers$quiteComplexWhere,
				{postSymbolTag: $author$project$MyInsights$Helpers$dateTimePostSymbolTag, postValueTag: $author$project$MyInsights$Helpers$dateTimePostValueTag, symbol: '!=', toString: $rtfeldman$elm_iso8601_date_strings$Iso8601$fromTime, useSingleQuotes: $author$project$MyInsights$Helpers$dateQuoteUsage},
				queryType,
				platform);
		}
	});
var $author$project$MyInsights$Helpers$iOsBasicWhereNotEquals = F3(
	function (info, fieldName, maybeValue) {
		return $author$project$MyInsights$WhereOr(
			_List_fromArray(
				[
					A4($author$project$MyInsights$Helpers$basicWhere, info, $author$project$MyInsights$IOs, fieldName, maybeValue),
					$author$project$MyInsights$Helpers$iOsWhereEqualsNull(fieldName)
				]));
	});
var $author$project$MyInsights$Helpers$whereNumberNotEquals = function (platform) {
	if (platform.$ === 'IOs') {
		return $author$project$MyInsights$Helpers$iOsBasicWhereNotEquals(
			{symbol: '!=', toString: $elm$core$String$fromFloat, useSingleQuotes: $author$project$MyInsights$Helpers$Never});
	} else {
		return A2(
			$author$project$MyInsights$Helpers$basicWhere,
			{symbol: '!=', toString: $elm$core$String$fromFloat, useSingleQuotes: $author$project$MyInsights$Helpers$Never},
			platform);
	}
};
var $author$project$MyInsights$Helpers$whereStringNotEquals = function (platform) {
	if (platform.$ === 'IOs') {
		return $author$project$MyInsights$Helpers$iOsBasicWhereNotEquals(
			{
				symbol: '!=',
				toString: function ($) {
					return $.text;
				},
				useSingleQuotes: $author$project$MyInsights$Helpers$Always
			});
	} else {
		return A2(
			$author$project$MyInsights$Helpers$basicWhere,
			{
				symbol: '!=',
				toString: function ($) {
					return $.text;
				},
				useSingleQuotes: $author$project$MyInsights$Helpers$Always
			},
			platform);
	}
};
var $author$project$DataElement$whereNotEqualEngineHelper = F3(
	function (crmOrNitro, fieldName, maybeValue) {
		if (maybeValue.$ === 'Just') {
			switch (maybeValue.a.$) {
				case 'StringValue':
					var words = maybeValue.a.a;
					return A3(
						$author$project$MyInsights$Helpers$whereStringNotEquals,
						$author$project$MyInsights$Online,
						$author$project$FieldName$toString(fieldName),
						$elm$core$Maybe$Just(words));
				case 'NumberValue':
					var _float = maybeValue.a.a;
					return A3(
						$author$project$MyInsights$Helpers$whereNumberNotEquals,
						$author$project$MyInsights$Online,
						$author$project$FieldName$toString(fieldName),
						$elm$core$Maybe$Just(_float));
				case 'DateValue':
					var date = maybeValue.a.a;
					return A4(
						$author$project$MyInsights$Helpers$whereDateNotEquals,
						crmOrNitro,
						$author$project$MyInsights$Online,
						$author$project$FieldName$toString(fieldName),
						$elm$core$Maybe$Just(date));
				case 'DateTimeValue':
					var datetime = maybeValue.a.a;
					return A4(
						$author$project$MyInsights$Helpers$whereDateTimeNotEquals,
						crmOrNitro,
						$author$project$MyInsights$Online,
						$author$project$FieldName$toString(fieldName),
						$elm$core$Maybe$Just(datetime));
				default:
					var bool = maybeValue.a.a;
					return A4(
						$author$project$MyInsights$Helpers$whereBoolNotEquals,
						crmOrNitro,
						$author$project$MyInsights$Online,
						$author$project$FieldName$toString(fieldName),
						$elm$core$Maybe$Just(bool));
			}
		} else {
			return $author$project$MyInsights$Where(
				$author$project$MyInsights$Helpers$getPlaceholderClause(crmOrNitro));
		}
	});
var $author$project$DataElement$previewWhereIndividual = F3(
	function (crmOrNitro, cache, individual) {
		switch (individual.$) {
			case 'WhereIn':
				var fieldName = individual.a;
				var globalStringListExpr = individual.b;
				return A2(
					$krisajenkins$remotedata$RemoteData$map,
					A2(
						$elm$core$Basics$composeR,
						$elm$core$List$filterMap($elm$core$Basics$identity),
						A2(
							$elm$core$Basics$composeR,
							$elm$core$List$map(
								function ($) {
									return $.text;
								}),
							A2(
								$author$project$MyInsights$whereIn,
								$author$project$MyInsights$Online,
								$author$project$FieldName$toString(fieldName)))),
					A2($author$project$DataElement$Expression$Preview$globalStringList, cache, globalStringListExpr));
			case 'WhereEqual':
				var fieldName = individual.a;
				var globalFieldExpr = individual.b;
				return A2(
					$krisajenkins$remotedata$RemoteData$map,
					A2($author$project$DataElement$whereEqualsEngineHelper, crmOrNitro, fieldName),
					A2($author$project$DataElement$Expression$Preview$globalField, cache, globalFieldExpr));
			case 'WhereNotEqual':
				var fieldName = individual.a;
				var globalFieldExpr = individual.b;
				return A2(
					$krisajenkins$remotedata$RemoteData$map,
					A2($author$project$DataElement$whereNotEqualEngineHelper, crmOrNitro, fieldName),
					A2($author$project$DataElement$Expression$Preview$globalField, cache, globalFieldExpr));
			case 'WhereGT':
				var fieldName = individual.a;
				var globalCompExpr = individual.b;
				return A2(
					$krisajenkins$remotedata$RemoteData$map,
					A2($author$project$DataElement$whereGTEngineHelper, crmOrNitro, fieldName),
					A2($author$project$DataElement$Expression$Preview$globalComparable, cache, globalCompExpr));
			case 'WhereGTE':
				var fieldName = individual.a;
				var globalCompExpr = individual.b;
				return A2(
					$krisajenkins$remotedata$RemoteData$map,
					A2($author$project$DataElement$whereGTEEngineHelper, crmOrNitro, fieldName),
					A2($author$project$DataElement$Expression$Preview$globalComparable, cache, globalCompExpr));
			case 'WhereLT':
				var fieldName = individual.a;
				var globalCompExpr = individual.b;
				return A2(
					$krisajenkins$remotedata$RemoteData$map,
					A2($author$project$DataElement$whereLTEngineHelper, crmOrNitro, fieldName),
					A2($author$project$DataElement$Expression$Preview$globalComparable, cache, globalCompExpr));
			default:
				var fieldName = individual.a;
				var globalCompExpr = individual.b;
				return A2(
					$krisajenkins$remotedata$RemoteData$map,
					A2($author$project$DataElement$whereLTEEngineHelper, crmOrNitro, fieldName),
					A2($author$project$DataElement$Expression$Preview$globalComparable, cache, globalCompExpr));
		}
	});
var $author$project$DataElement$previewWhereClause = F3(
	function (crmOrNitro, cache, whereClause) {
		switch (whereClause.$) {
			case 'WhereAnd':
				var children = whereClause.a;
				return A2(
					$krisajenkins$remotedata$RemoteData$map,
					$author$project$MyInsights$WhereAnd,
					$author$project$RemoteData$Helpers$combine(
						A2(
							$elm$core$List$map,
							A2($author$project$DataElement$previewWhereClause, crmOrNitro, cache),
							children)));
			case 'WhereOr':
				var children = whereClause.a;
				return A2(
					$krisajenkins$remotedata$RemoteData$map,
					$author$project$MyInsights$WhereOr,
					$author$project$RemoteData$Helpers$combine(
						A2(
							$elm$core$List$map,
							A2($author$project$DataElement$previewWhereClause, crmOrNitro, cache),
							children)));
			default:
				var individual = whereClause.a;
				return A3($author$project$DataElement$previewWhereIndividual, crmOrNitro, cache, individual);
		}
	});
var $author$project$MyInsights$setComplexWhere = F2(
	function (clause, _v0) {
		var config = _v0.a;
		return $author$project$MyInsights$QueryConfig(
			_Utils_update(
				config,
				{
					where_: $elm$core$Maybe$Just(clause)
				}));
	});
var $author$project$DataElement$crmQueryToQueryDetails = F2(
	function (cache, info) {
		var _v0 = info.whereClause;
		if (_v0.$ === 'Nothing') {
			return $elm$core$Maybe$Just(
				A3(
					$author$project$DataEngine$QueryToRun$CrmQuery,
					$author$project$DataElement$basicCrmQuery(info),
					$author$project$DataElement$metadataForFieldInfoDict(info.fields),
					$author$project$DataElement$basicQueryDecoder(info)));
		} else {
			var whereClause = _v0.a;
			return A2(
				$elm$core$Maybe$map,
				function (query) {
					return A3(
						$author$project$DataEngine$QueryToRun$CrmQuery,
						query,
						$author$project$DataElement$metadataForFieldInfoDict(info.fields),
						$author$project$DataElement$basicQueryDecoder(info));
				},
				A2(
					$elm$core$Maybe$map,
					function (complexWhere) {
						return A2(
							$author$project$MyInsights$setComplexWhere,
							complexWhere,
							$author$project$DataElement$basicCrmQuery(info));
					},
					$krisajenkins$remotedata$RemoteData$toMaybe(
						A3($author$project$DataElement$previewWhereClause, $author$project$MyInsights$Helpers$Crm, cache, whereClause))));
		}
	});
var $author$project$MyInsights$Helpers$Nitro = {$: 'Nitro'};
var $author$project$DataEngine$QueryToRun$NitroQuery = F3(
	function (a, b, c) {
		return {$: 'NitroQuery', a: a, b: b, c: c};
	});
var $author$project$MyInsights$nitroQuery = F2(
	function (object, fields) {
		return $author$project$MyInsights$QueryConfig(
			_Utils_update(
				$author$project$MyInsights$blankQuery,
				{fields: fields, object: object}));
	});
var $author$project$DataElement$basicNitroQuery = function (info) {
	return A2(
		$author$project$MyInsights$setSort,
		A2($elm$core$List$map, $author$project$DataElement$SortKey$toQuerySortString, info.sort),
		A3(
			$author$project$Preview$Helpers$maybeApply,
			$author$project$MyInsights$setLimit,
			info.limit,
			A2(
				$author$project$MyInsights$nitroQuery,
				$author$project$ObjectName$toString(info.objectName),
				A2(
					$elm$core$List$map,
					$author$project$FieldName$toString,
					$pzp1997$assoc_list$AssocList$keys(info.fields)))));
};
var $author$project$DataElement$nitroQueryToQueryDetails = F2(
	function (cache, info) {
		var _v0 = info.whereClause;
		if (_v0.$ === 'Nothing') {
			return $elm$core$Maybe$Just(
				A3(
					$author$project$DataEngine$QueryToRun$NitroQuery,
					$author$project$DataElement$basicNitroQuery(info),
					$author$project$DataElement$metadataForFieldInfoDict(info.fields),
					$author$project$DataElement$basicQueryDecoder(info)));
		} else {
			var whereClause = _v0.a;
			return A2(
				$elm$core$Maybe$map,
				function (query) {
					return A3(
						$author$project$DataEngine$QueryToRun$NitroQuery,
						query,
						$author$project$DataElement$metadataForFieldInfoDict(info.fields),
						$author$project$DataElement$basicQueryDecoder(info));
				},
				A2(
					$elm$core$Maybe$map,
					function (complexWhere) {
						return A2(
							$author$project$MyInsights$setComplexWhere,
							complexWhere,
							$author$project$DataElement$basicNitroQuery(info));
					},
					$krisajenkins$remotedata$RemoteData$toMaybe(
						A3($author$project$DataElement$previewWhereClause, $author$project$MyInsights$Helpers$Nitro, cache, whereClause))));
		}
	});
var $author$project$MyInsights$Helpers$Sales = {$: 'Sales'};
var $author$project$DataEngine$QueryToRun$SalesQuery = F3(
	function (a, b, c) {
		return {$: 'SalesQuery', a: a, b: b, c: c};
	});
var $author$project$DataElement$SalesQuery$fieldList = A2(
	$elm$core$List$map,
	$elm$core$Tuple$mapFirst($author$project$FieldName$fromString),
	_List_fromArray(
		[
			_Utils_Tuple2('Account_Id_vod__c', $author$project$FieldType$StringType),
			_Utils_Tuple2('ID_vod__c', $author$project$FieldType$StringType),
			_Utils_Tuple2('Market_vod__c', $author$project$FieldType$StringType),
			_Utils_Tuple2('Market_Id_vod__c', $author$project$FieldType$StringType),
			_Utils_Tuple2('Product_Group_vod__c', $author$project$FieldType$StringType),
			_Utils_Tuple2('Product_Group_Id_vod__c', $author$project$FieldType$StringType),
			_Utils_Tuple2('Sales_Date_vod__c', $author$project$FieldType$DateType),
			_Utils_Tuple2('Sales_Data_vod__c', $author$project$FieldType$NumberType)
		]));
var $author$project$DataElement$SalesQuery$fields = $pzp1997$assoc_list$AssocList$fromList($author$project$DataElement$SalesQuery$fieldList);
var $author$project$MyInsights$salesDataQuery = F2(
	function (fields, whereClause) {
		return $author$project$MyInsights$QueryConfig(
			_Utils_update(
				$author$project$MyInsights$blankQuery,
				{
					fields: fields,
					object: 'Account_Sales_Summary_Insights',
					where_: $elm$core$Maybe$Just(whereClause)
				}));
	});
var $author$project$DataElement$basicSalesQuery = F2(
	function (info, whereClause) {
		return A2(
			$author$project$MyInsights$setSort,
			A2($elm$core$List$map, $author$project$DataElement$SortKey$toQuerySortString, info.sort),
			A3(
				$author$project$Preview$Helpers$maybeApply,
				$author$project$MyInsights$setLimit,
				info.limit,
				A2(
					$author$project$MyInsights$salesDataQuery,
					A2(
						$elm$core$List$map,
						$author$project$FieldName$toString,
						$pzp1997$assoc_list$AssocList$keys($author$project$DataElement$SalesQuery$fields)),
					whereClause)));
	});
var $author$project$DataElement$SalesQuery$Scale$toString = function (scale) {
	if (scale.$ === 'Week') {
		return 'Week_vod';
	} else {
		return 'Month_vod';
	}
};
var $author$project$DataElement$makeSalesQueryWhereClause = function (info) {
	return $author$project$DataElement$WhereClause$WhereAnd(
		_Utils_ap(
			_List_fromArray(
				[
					$author$project$DataElement$WhereClause$WhereIndividual(
					A2(
						$author$project$DataElement$WhereClause$WhereEqual,
						$author$project$FieldName$fromString('scale'),
						$author$project$DataElement$Expression$GlobalStringExpr(
							$author$project$DataElement$Expression$GlobalStringHardcoded(
								$author$project$DataElement$SalesQuery$Scale$toString(info.scale))))),
					$author$project$DataElement$WhereClause$WhereIndividual(
					A2(
						$author$project$DataElement$WhereClause$WhereEqual,
						$author$project$FieldName$fromString('dataType'),
						$author$project$DataElement$Expression$GlobalStringExpr(
							$author$project$DataElement$Expression$GlobalStringHardcoded(info.dataType)))),
					$author$project$DataElement$WhereClause$WhereIndividual(
					A2(
						$author$project$DataElement$WhereClause$WhereIn,
						$author$project$FieldName$fromString('Account_Id_vod__c'),
						info.accountIds))
				]),
			A2(
				$elm$core$List$filterMap,
				$elm$core$Basics$identity,
				_List_fromArray(
					[
						A2(
						$elm$core$Maybe$map,
						function (startDate) {
							return $author$project$DataElement$WhereClause$WhereIndividual(
								A2(
									$author$project$DataElement$WhereClause$WhereEqual,
									$author$project$FieldName$fromString('startDate'),
									$author$project$DataElement$Expression$GlobalDateExpr(startDate)));
						},
						info.startDate),
						A2(
						$elm$core$Maybe$map,
						function (endDate) {
							return $author$project$DataElement$WhereClause$WhereIndividual(
								A2(
									$author$project$DataElement$WhereClause$WhereEqual,
									$author$project$FieldName$fromString('endDate'),
									$author$project$DataElement$Expression$GlobalDateExpr(endDate)));
						},
						info.endDate)
					]))));
};
var $author$project$DataElement$SalesQuery$metadata = $author$project$DataEngine$RecordMetadata$fromList($author$project$DataElement$SalesQuery$fieldList);
var $author$project$ObjectName$fromString = $author$project$ObjectName$ObjectName;
var $author$project$DataElement$turnSalesQueryToGenericQuery = function (info) {
	return {
		fields: A2(
			$pzp1997$assoc_list$AssocList$map,
			F2(
				function (_v0, v) {
					return {_default: $elm$core$Maybe$Nothing, fieldType: v};
				}),
			$author$project$DataElement$SalesQuery$fields),
		limit: info.limit,
		objectName: $author$project$ObjectName$fromString('Account_Sales_Summary_Insights'),
		objectTags: $pzp1997$assoc_list$AssocList$fromList(
			_List_fromArray(
				[
					_Utils_Tuple2(
					$author$project$FieldName$fromString('Account_ID_vod__c'),
					$author$project$ObjectName$fromString('Account'))
				])),
		sort: info.sort,
		whereClause: $elm$core$Maybe$Just(
			$author$project$DataElement$makeSalesQueryWhereClause(info))
	};
};
var $author$project$DataElement$salesQueryPreviewHelper = F2(
	function (cache, info) {
		return A2(
			$krisajenkins$remotedata$RemoteData$map,
			function (complexWhere) {
				return A3(
					$author$project$DataEngine$QueryToRun$SalesQuery,
					A2($author$project$DataElement$basicSalesQuery, info, complexWhere),
					$author$project$DataElement$SalesQuery$metadata,
					$author$project$DataElement$basicQueryDecoder(
						$author$project$DataElement$turnSalesQueryToGenericQuery(info)));
			},
			A3(
				$author$project$DataElement$previewWhereClause,
				$author$project$MyInsights$Helpers$Sales,
				cache,
				$author$project$DataElement$makeSalesQueryWhereClause(info)));
	});
var $author$project$DataElement$salesQueryToQueryDetails = F2(
	function (cache, info) {
		return $krisajenkins$remotedata$RemoteData$toMaybe(
			A2($author$project$DataElement$salesQueryPreviewHelper, cache, info));
	});
var $author$project$DataElement$toQueryDetails = F2(
	function (cache, _v0) {
		var element = _v0.b;
		if (element.$ === 'RecordList') {
			switch (element.a.$) {
				case 'CrmQuery':
					var info = element.a.a;
					return A2($author$project$DataElement$crmQueryToQueryDetails, cache, info);
				case 'SalesQuery':
					var info = element.a.a;
					return A2($author$project$DataElement$salesQueryToQueryDetails, cache, info);
				case 'NitroQuery':
					var info = element.a.a;
					return A2($author$project$DataElement$nitroQueryToQueryDetails, cache, info);
				case 'CrmDataEngineQuery':
					var info = element.a.a;
					return A2($author$project$DataElement$crmDataEngineQueryToQueryDetails, cache, info);
				case 'CalcOneForOne':
					return $elm$core$Maybe$Nothing;
				case 'CalcSortList':
					return $elm$core$Maybe$Nothing;
				case 'CalcFilterList':
					return $elm$core$Maybe$Nothing;
				case 'CalcSublist':
					return $elm$core$Maybe$Nothing;
				case 'CalcMergeList':
					return $elm$core$Maybe$Nothing;
				case 'AlignedTerritories':
					var info = element.a.a;
					return $elm$core$Maybe$Just(
						$author$project$DataEngine$QueryToRun$AlignedTerritories(info.includeChildren));
				case 'CallAttendees':
					var _v2 = element.a;
					return $elm$core$Maybe$Just($author$project$DataEngine$QueryToRun$CallAttendees);
				case 'FeedbackChannelGoals':
					return $elm$core$Maybe$Nothing;
				case 'FeedbackProductGoals':
					return $elm$core$Maybe$Nothing;
				case 'FeedbackAccountData':
					return $elm$core$Maybe$Nothing;
				case 'FeedbackAccountChannelGoals':
					return $elm$core$Maybe$Nothing;
				case 'FeedbackAccountProductGoals':
					return $elm$core$Maybe$Nothing;
				default:
					return $elm$core$Maybe$Nothing;
			}
		} else {
			switch (element.a.$) {
				case 'FeedbackOverview':
					return $elm$core$Maybe$Nothing;
				case 'ContextQuery':
					var info = element.a.a;
					return $elm$core$Maybe$Just(
						$author$project$DataElement$contextQueryToQueryDetails(info));
				case 'LimitOneCrmQuery':
					var info = element.a.a;
					return A2($author$project$DataElement$crmQueryToQueryDetails, cache, info);
				case 'LimitOneSalesQuery':
					var info = element.a.a;
					return A2($author$project$DataElement$salesQueryToQueryDetails, cache, info);
				case 'LimitOneNitroQuery':
					var info = element.a.a;
					return A2($author$project$DataElement$nitroQueryToQueryDetails, cache, info);
				case 'LimitOneCrmDataEngineQuery':
					var info = element.a.a;
					return A2($author$project$DataElement$crmDataEngineQueryToQueryDetails, cache, info);
				case 'Today':
					var _v3 = element.a;
					return $elm$core$Maybe$Just($author$project$DataEngine$QueryToRun$Today);
				case 'Now':
					var _v4 = element.a;
					return $elm$core$Maybe$Just($author$project$DataEngine$QueryToRun$Now);
				case 'CalcSummarize':
					return $elm$core$Maybe$Nothing;
				case 'ObjectTranslation':
					var objectName = element.a.a;
					return $elm$core$Maybe$Just(
						$author$project$DataEngine$QueryToRun$ObjectTranslation(objectName));
				case 'FieldTranslation':
					var fieldTranslationInfo = element.a.a;
					return $elm$core$Maybe$Just(
						$author$project$DataEngine$QueryToRun$FieldTranslation(fieldTranslationInfo));
				case 'VeevaMessages':
					var vmInfo = element.a.a;
					return $elm$core$Maybe$Just(
						$author$project$DataEngine$QueryToRun$VeevaMessages(vmInfo));
				case 'DatepickerSelection':
					return $elm$core$Maybe$Nothing;
				default:
					return $elm$core$Maybe$Nothing;
			}
		}
	});
var $author$project$DataElement$getQueryToRun = F3(
	function (allElements, cache, ref) {
		var _v0 = A2($author$project$DataElement$getDataElementFromReferenceElement, allElements, ref);
		if (_v0.$ === 'Just') {
			var dataElement = _v0.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$DataEngine$QueryToRun$QueryToRun(
					A2($author$project$DataElement$eitherReference, ref, dataElement)),
				A2($author$project$DataElement$toQueryDetails, cache, dataElement));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Compiler$getRunningQueries = function (model) {
	return A2(
		$elm$core$List$filterMap,
		A2(
			$author$project$DataElement$getQueryToRun,
			$author$project$StudioApp$dataElements(model.app),
			model.cache),
		$author$project$DataEngine$DataCache$getLoading(model.cache));
};
var $author$project$Compiler$RxListOfRecords = F3(
	function (a, b, c) {
		return {$: 'RxListOfRecords', a: a, b: b, c: c};
	});
var $author$project$Compiler$RxSingleton = F3(
	function (a, b, c) {
		return {$: 'RxSingleton', a: a, b: b, c: c};
	});
var $author$project$Compiler$RxVeevaMessageTwoStep = F3(
	function (a, b, c) {
		return {$: 'RxVeevaMessageTwoStep', a: a, b: b, c: c};
	});
var $author$project$Compiler$crmQueryHandlerForLimit = F3(
	function (limit, ref, metadata) {
		if (ref.$ === 'IsSingleton') {
			var singleRef = ref.a;
			return A2(
				$elm$core$Basics$composeR,
				$elm$core$Result$map(
					A2(
						$elm$core$Basics$composeR,
						$elm$core$List$head,
						$elm$core$Maybe$withDefault($author$project$DataEngine$RecordCache$empty))),
				A2($author$project$Compiler$RxSingleton, singleRef, metadata));
		} else {
			var listRef = ref.a;
			return A2($author$project$Compiler$RxListOfRecords, listRef, metadata);
		}
	});
var $author$project$MyInsights$Helpers$CallAttendee = function (c_accountID) {
	return {c_accountID: c_accountID};
};
var $author$project$MyInsights$Helpers$callAttendeeDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$MyInsights$Helpers$CallAttendee,
	A2(
		$elm$json$Json$Decode$map,
		$elm$core$Maybe$Just,
		$author$project$MyInsights$Helpers$stringDecoder(
			$elm$core$Maybe$Just(
				$author$project$ObjectName$fromString('Account')))));
var $author$project$DataElement$CallAttendees$fieldName = 'Account ID';
var $author$project$DataElement$CallAttendees$toRecordCache = function (callAttendee) {
	return A4(
		$elm_community$maybe_extra$Maybe$Extra$unwrap,
		$elm$core$Basics$identity,
		function (string) {
			return A2(
				$author$project$DataEngine$RecordCache$insert,
				$author$project$FieldName$fromString($author$project$DataElement$CallAttendees$fieldName),
				$author$project$FieldValue$StringValue(string));
		},
		callAttendee.c_accountID,
		$author$project$DataEngine$RecordCache$empty);
};
var $author$project$DataElement$CallAttendees$decoder = A2($elm$json$Json$Decode$map, $author$project$DataElement$CallAttendees$toRecordCache, $author$project$MyInsights$Helpers$callAttendeeDecoder);
var $author$project$MyInsights$getFieldLabelsListener = F3(
	function (queryId, object, resultToMsg) {
		var fieldNameDecoder = A3(
			$elm$json$Json$Decode$map2,
			F2(
				function (a, b) {
					return _Utils_Tuple2(a, b);
				}),
			A2($elm$json$Json$Decode$field, 'name', $elm$json$Json$Decode$string),
			A2($elm$json$Json$Decode$field, 'display', $elm$json$Json$Decode$string));
		var decoder = $elm$json$Json$Decode$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$json$Json$Decode$map,
					$elm$core$Dict$fromList,
					A2(
						$elm$json$Json$Decode$field,
						object,
						$elm$json$Json$Decode$list(fieldNameDecoder))),
					A2(
					$elm$json$Json$Decode$map,
					$elm$core$Dict$fromList,
					$elm$json$Json$Decode$list(fieldNameDecoder))
				]));
		return $author$project$MyInsights$QueryListener(
			{
				queryId: queryId,
				toMsg: A2(
					$elm$core$Basics$composeR,
					$elm$core$Result$andThen(
						$author$project$MyInsights$decode(decoder)),
					resultToMsg)
			});
	});
var $author$project$MyInsights$getLimit = function (_v0) {
	var limit = _v0.a.limit;
	return limit;
};
var $author$project$MyInsights$ObjectLabel = F2(
	function (singular, plural) {
		return {plural: plural, singular: singular};
	});
var $author$project$MyInsights$nothingIfValueIsNothing = function (_v0) {
	var a = _v0.a;
	var maybeB = _v0.b;
	return A2(
		$elm$core$Maybe$map,
		$elm$core$Tuple$pair(a),
		maybeB);
};
var $author$project$MyInsights$getObjectLabelsListener = F2(
	function (queryId, resultToMsg) {
		var objectLabelDecoder = $elm$json$Json$Decode$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$json$Json$Decode$index,
					0,
					A3(
						$elm$json$Json$Decode$map2,
						$author$project$MyInsights$ObjectLabel,
						A2($elm$json$Json$Decode$field, 'singular', $elm$json$Json$Decode$string),
						A2($elm$json$Json$Decode$field, 'plural', $elm$json$Json$Decode$string))),
					A3(
					$elm$json$Json$Decode$map2,
					$author$project$MyInsights$ObjectLabel,
					A2($elm$json$Json$Decode$field, 'singular', $elm$json$Json$Decode$string),
					A2($elm$json$Json$Decode$field, 'plural', $elm$json$Json$Decode$string))
				]));
		var decoder = A2(
			$elm$json$Json$Decode$map,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$filterMap($author$project$MyInsights$nothingIfValueIsNothing),
				$elm$core$Dict$fromList),
			$elm$json$Json$Decode$keyValuePairs(
				$elm$json$Json$Decode$maybe(objectLabelDecoder)));
		return $author$project$MyInsights$QueryListener(
			{
				queryId: queryId,
				toMsg: A2(
					$elm$core$Basics$composeR,
					$elm$core$Result$andThen(
						$author$project$MyInsights$decode(decoder)),
					resultToMsg)
			});
	});
var $author$project$MyInsights$getObjectName = function (_v0) {
	var object = _v0.a.object;
	return object;
};
var $author$project$MyInsights$GotLanguageLocaleKey = function (a) {
	return {$: 'GotLanguageLocaleKey', a: a};
};
var $author$project$MyInsights$GotMessages = function (a) {
	return {$: 'GotMessages', a: a};
};
var $author$project$MyInsights$getVeevaMessagesTwoStepListener = F2(
	function (queryId, resultToMsg) {
		var messagesDecoder = A2(
			$elm$json$Json$Decode$map,
			A2($elm$core$Basics$composeR, $elm$core$Dict$fromList, $author$project$MyInsights$GotMessages),
			$elm$json$Json$Decode$list(
				A4(
					$elm$json$Json$Decode$map3,
					F3(
						function (category, name, value) {
							return _Utils_Tuple2(
								_Utils_Tuple2(category, name),
								value);
						}),
					$elm$json$Json$Decode$oneOf(
						_List_fromArray(
							[
								A2($elm$json$Json$Decode$field, 'Category_vod__c', $elm$json$Json$Decode$string),
								A2(
								$elm$json$Json$Decode$at,
								_List_fromArray(
									['Category_vod__c', 'value']),
								$elm$json$Json$Decode$string)
							])),
					$elm$json$Json$Decode$oneOf(
						_List_fromArray(
							[
								A2($elm$json$Json$Decode$field, 'Name', $elm$json$Json$Decode$string),
								A2(
								$elm$json$Json$Decode$at,
								_List_fromArray(
									['Name', 'value']),
								$elm$json$Json$Decode$string)
							])),
					$elm$json$Json$Decode$oneOf(
						_List_fromArray(
							[
								A2($elm$json$Json$Decode$field, 'Text_vod__c', $elm$json$Json$Decode$string),
								A2(
								$elm$json$Json$Decode$at,
								_List_fromArray(
									['Text_vod__c', 'value']),
								$elm$json$Json$Decode$string)
							])))));
		var languageDecoder = A2(
			$elm$json$Json$Decode$map,
			$author$project$MyInsights$GotLanguageLocaleKey,
			A2(
				$elm$json$Json$Decode$at,
				_List_fromArray(
					['User', 'LanguageLocaleKey']),
				$elm$json$Json$Decode$string));
		var decoder = $elm$json$Json$Decode$oneOf(
			_List_fromArray(
				[languageDecoder, messagesDecoder]));
		return $author$project$MyInsights$QueryListener(
			{
				queryId: queryId,
				toMsg: A2(
					$elm$core$Basics$composeR,
					$elm$core$Result$andThen(
						$author$project$MyInsights$decode(decoder)),
					resultToMsg)
			});
	});
var $author$project$DataElement$AlignedTerritories$fieldList = A2(
	$elm$core$List$map,
	$elm$core$Tuple$mapFirst($author$project$FieldName$fromString),
	_List_fromArray(
		[
			_Utils_Tuple2('name', $author$project$FieldType$StringType),
			_Utils_Tuple2('id', $author$project$FieldType$StringType),
			_Utils_Tuple2('description', $author$project$FieldType$StringType),
			_Utils_Tuple2('developerName', $author$project$FieldType$StringType),
			_Utils_Tuple2('parentTerritoryId', $author$project$FieldType$StringType)
		]));
var $author$project$DataElement$AlignedTerritories$metadata = $author$project$DataEngine$RecordMetadata$fromList($author$project$DataElement$AlignedTerritories$fieldList);
var $author$project$DataElement$CallAttendees$fieldList = A2(
	$elm$core$List$map,
	$elm$core$Tuple$mapFirst($author$project$FieldName$fromString),
	_List_fromArray(
		[
			_Utils_Tuple2($author$project$DataElement$CallAttendees$fieldName, $author$project$FieldType$StringType)
		]));
var $author$project$DataElement$CallAttendees$metadata = $author$project$DataEngine$RecordMetadata$fromList($author$project$DataElement$CallAttendees$fieldList);
var $author$project$DataElement$FieldTranslation$fieldNames = function (info) {
	return $mgold$elm_nonempty_list$List$Nonempty$toList(info.fields);
};
var $author$project$DataElement$FieldTranslation$metadata = A2(
	$elm$core$Basics$composeR,
	$author$project$DataElement$FieldTranslation$fieldNames,
	A2(
		$elm$core$Basics$composeR,
		$elm$core$List$map(
			function (name) {
				return _Utils_Tuple2(name, $author$project$FieldType$StringType);
			}),
		$author$project$DataEngine$RecordMetadata$fromList));
var $author$project$DataElement$ObjectTranslation$fieldNames = A2(
	$elm$core$List$map,
	$author$project$FieldName$fromString,
	_List_fromArray(
		['Singular', 'Plural']));
var $author$project$DataElement$ObjectTranslation$metadata = $author$project$DataEngine$RecordMetadata$fromList(
	A2(
		$elm$core$List$map,
		function (name) {
			return _Utils_Tuple2(name, $author$project$FieldType$StringType);
		},
		$author$project$DataElement$ObjectTranslation$fieldNames));
var $author$project$Compiler$nitroQueryHandlerForLimit = F3(
	function (limit, ref, metadata) {
		if (ref.$ === 'IsSingleton') {
			var singleRef = ref.a;
			return A2(
				$elm$core$Basics$composeR,
				$elm$core$Result$map(
					A2(
						$elm$core$Basics$composeR,
						$elm$core$List$head,
						$elm$core$Maybe$withDefault($author$project$DataEngine$RecordCache$empty))),
				A2($author$project$Compiler$RxSingleton, singleRef, metadata));
		} else {
			var listRef = ref.a;
			return A2($author$project$Compiler$RxListOfRecords, listRef, metadata);
		}
	});
var $author$project$MyInsights$queryAlignedTerritoriesListener = F3(
	function (queryId, innerDecoder, resultToMsg) {
		var decoder = A2(
			$elm$json$Json$Decode$field,
			'data',
			$elm$json$Json$Decode$list(innerDecoder));
		return $author$project$MyInsights$QueryListener(
			{
				queryId: queryId,
				toMsg: A2(
					$elm$core$Basics$composeR,
					$elm$core$Result$andThen(
						$author$project$MyInsights$decode(decoder)),
					resultToMsg)
			});
	});
var $author$project$MyInsights$queryCallAttendeesListener = F3(
	function (queryId, innerDecoder, resultToMsg) {
		var decoder = A2(
			$elm$json$Json$Decode$at,
			_List_fromArray(
				['data', 'attendeeIds']),
			$elm$json$Json$Decode$list(innerDecoder));
		return $author$project$MyInsights$QueryListener(
			{
				queryId: queryId,
				toMsg: A2(
					$elm$core$Basics$composeR,
					$elm$core$Result$andThen(
						$author$project$MyInsights$decode(decoder)),
					resultToMsg)
			});
	});
var $author$project$MyInsights$queryCrmDataEngineListener = F3(
	function (queryId, itemDecoder, resultToMsg) {
		var decoder = A2(
			$elm$json$Json$Decode$field,
			'data',
			$elm$json$Json$Decode$list(itemDecoder));
		return $author$project$MyInsights$QueryListener(
			{
				queryId: queryId,
				toMsg: A2(
					$elm$core$Basics$composeR,
					$elm$core$Result$andThen(
						$author$project$MyInsights$decode(decoder)),
					resultToMsg)
			});
	});
var $author$project$MyInsights$queryRecordListener = F4(
	function (queryId, objectName, itemDecoder, resultToMsg) {
		var decoder = A2(
			$elm$json$Json$Decode$field,
			objectName,
			$elm$json$Json$Decode$list(itemDecoder));
		return $author$project$MyInsights$QueryListener(
			{
				queryId: queryId,
				toMsg: A2(
					$elm$core$Basics$composeR,
					$elm$core$Result$andThen(
						$author$project$MyInsights$decode(decoder)),
					resultToMsg)
			});
	});
var $author$project$MyInsights$querySalesDataListener = F3(
	function (queryId, itemDecoder, resultToMsg) {
		var decoder = A2(
			$elm$json$Json$Decode$field,
			'Account_Sales_Summary_Insights',
			$elm$json$Json$Decode$list(itemDecoder));
		return $author$project$MyInsights$QueryListener(
			{
				queryId: queryId,
				toMsg: A2(
					$elm$core$Basics$composeR,
					$elm$core$Result$andThen(
						$author$project$MyInsights$decode(decoder)),
					resultToMsg)
			});
	});
var $author$project$MyInsights$queryVDSRecordListener = F4(
	function (queryId, objectName, itemDecoder, resultToMsg) {
		var decoder = $elm$json$Json$Decode$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$json$Json$Decode$field,
					objectName,
					$elm$json$Json$Decode$list(itemDecoder)),
					A2(
					$elm$json$Json$Decode$at,
					_List_fromArray(
						['data', 'records']),
					$elm$json$Json$Decode$list(itemDecoder))
				]));
		return $author$project$MyInsights$QueryListener(
			{
				queryId: queryId,
				toMsg: A2(
					$elm$core$Basics$composeR,
					$elm$core$Result$andThen(
						$author$project$MyInsights$decode(decoder)),
					resultToMsg)
			});
	});
var $author$project$DataElement$AlignedTerritories$makeRecordCache = F5(
	function (name, id, description, developerName, parentId) {
		return A4(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			$elm$core$Basics$identity,
			function (words) {
				return A2(
					$author$project$DataEngine$RecordCache$insert,
					$author$project$FieldName$fromString('parentTerritoryId'),
					$author$project$FieldValue$StringValue(
						A2(
							$author$project$StudioString$StudioString,
							words,
							$elm$core$Maybe$Just(
								$author$project$ObjectName$fromString('Territory2')))));
			},
			parentId,
			A4(
				$elm_community$maybe_extra$Maybe$Extra$unwrap,
				$elm$core$Basics$identity,
				function (words) {
					return A2(
						$author$project$DataEngine$RecordCache$insert,
						$author$project$FieldName$fromString('developerName'),
						$author$project$FieldValue$StringValue(
							$author$project$StudioString$withoutObject(words)));
				},
				developerName,
				A4(
					$elm_community$maybe_extra$Maybe$Extra$unwrap,
					$elm$core$Basics$identity,
					function (words) {
						return A2(
							$author$project$DataEngine$RecordCache$insert,
							$author$project$FieldName$fromString('description'),
							$author$project$FieldValue$StringValue(
								$author$project$StudioString$withoutObject(words)));
					},
					description,
					A4(
						$elm_community$maybe_extra$Maybe$Extra$unwrap,
						$elm$core$Basics$identity,
						function (words) {
							return A2(
								$author$project$DataEngine$RecordCache$insert,
								$author$project$FieldName$fromString('id'),
								$author$project$FieldValue$StringValue(
									A2(
										$author$project$StudioString$StudioString,
										words,
										$elm$core$Maybe$Just(
											$author$project$ObjectName$fromString('Territory2')))));
						},
						id,
						A4(
							$elm_community$maybe_extra$Maybe$Extra$unwrap,
							$elm$core$Basics$identity,
							function (words) {
								return A2(
									$author$project$DataEngine$RecordCache$insert,
									$author$project$FieldName$fromString('name'),
									$author$project$FieldValue$StringValue(
										$author$project$StudioString$withoutObject(words)));
							},
							name,
							$author$project$DataEngine$RecordCache$empty)))));
	});
var $author$project$DataElement$AlignedTerritories$recordCacheDecoder = A6(
	$elm$json$Json$Decode$map5,
	$author$project$DataElement$AlignedTerritories$makeRecordCache,
	A2($elm_community$json_extra$Json$Decode$Extra$optionalNullableField, 'name', $elm$json$Json$Decode$string),
	A2($elm_community$json_extra$Json$Decode$Extra$optionalNullableField, 'id', $elm$json$Json$Decode$string),
	A2($elm_community$json_extra$Json$Decode$Extra$optionalNullableField, 'description', $elm$json$Json$Decode$string),
	A2($elm_community$json_extra$Json$Decode$Extra$optionalNullableField, 'developerName', $elm$json$Json$Decode$string),
	A2($elm_community$json_extra$Json$Decode$Extra$optionalNullableField, 'parentTerritoryId', $elm$json$Json$Decode$string));
var $author$project$ValidContextObject$toKeyword = function (obj) {
	switch (obj.$) {
		case 'Account':
			return 'Account';
		case 'AccountPlan':
			return 'AccountPlan';
		case 'HTMLReport':
			return 'HTMLReport';
		case 'Order':
			return 'Order';
		case 'TSF':
			return 'TSF';
		case 'User':
			return 'User';
		case 'InventoryMonitoring':
			return 'InventoryMonitoring';
		case 'EMSpeaker':
			return 'EM_Speaker_vod__c';
		default:
			return 'Call2_vod__c';
	}
};
var $author$project$DataElement$FieldTranslation$insert = function (_v0) {
	var key = _v0.a;
	var value = _v0.b;
	return A2(
		$author$project$DataEngine$RecordCache$insert,
		$author$project$FieldName$fromString(key),
		$author$project$FieldValue$StringValue(
			$author$project$StudioString$withoutObject(value)));
};
var $author$project$DataElement$FieldTranslation$toRecordCache = A2(
	$elm$core$Basics$composeR,
	$elm$core$Dict$toList,
	A2($elm$core$List$foldl, $author$project$DataElement$FieldTranslation$insert, $author$project$DataEngine$RecordCache$empty));
var $author$project$DataElement$Reference$toStringFromEither = function (either) {
	if (either.$ === 'IsRecordList') {
		var uuid = either.a.a;
		return $danyx23$elm_uuid$Uuid$toString(uuid);
	} else {
		var uuid = either.a.a;
		return $danyx23$elm_uuid$Uuid$toString(uuid);
	}
};
var $author$project$DataElement$ObjectTranslation$toRecordCache = function (_v0) {
	var singular = _v0.singular;
	var plural = _v0.plural;
	return A3(
		$author$project$DataEngine$RecordCache$insert,
		$author$project$FieldName$fromString('Plural'),
		$author$project$FieldValue$StringValue(
			$author$project$StudioString$withoutObject(plural)),
		A3(
			$author$project$DataEngine$RecordCache$insert,
			$author$project$FieldName$fromString('Singular'),
			$author$project$FieldValue$StringValue(
				$author$project$StudioString$withoutObject(singular)),
			$author$project$DataEngine$RecordCache$empty));
};
var $author$project$Compiler$translationsForObject = F2(
	function (objectName, translations) {
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$DataEngine$RecordCache$empty,
			A2(
				$elm$core$Maybe$map,
				$author$project$DataElement$ObjectTranslation$toRecordCache,
				A2(
					$elm$core$Dict$get,
					$author$project$ObjectName$toString(objectName),
					translations)));
	});
var $author$project$Compiler$makeListener = function (_v0) {
	var ref = _v0.ref;
	var query = _v0.query;
	switch (query.$) {
		case 'ContextQuery':
			var objectName = query.a;
			var fieldName = query.b;
			var metadata = query.c;
			var recordDecoder = query.d;
			if (ref.$ === 'IsSingleton') {
				var singleRef = ref.a;
				return $elm$core$Maybe$Just(
					A5(
						$author$project$MyInsights$getDataForCurrentObjectListener,
						$author$project$DataElement$Reference$toStringFromEither(ref),
						$author$project$ValidContextObject$toKeyword(objectName),
						$author$project$FieldName$toString(fieldName),
						recordDecoder,
						A2($author$project$Compiler$RxSingleton, singleRef, metadata)));
			} else {
				return $elm$core$Maybe$Nothing;
			}
		case 'CrmQuery':
			var config = query.a;
			var metadata = query.b;
			var recordDecoder = query.c;
			return $elm$core$Maybe$Just(
				A4(
					$author$project$MyInsights$queryRecordListener,
					$author$project$DataElement$Reference$toStringFromEither(ref),
					$author$project$MyInsights$getObjectName(config),
					recordDecoder,
					A3(
						$author$project$Compiler$crmQueryHandlerForLimit,
						$author$project$MyInsights$getLimit(config),
						ref,
						metadata)));
		case 'SalesQuery':
			var config = query.a;
			var metadata = query.b;
			var recordDecoder = query.c;
			return $elm$core$Maybe$Just(
				A3(
					$author$project$MyInsights$querySalesDataListener,
					$author$project$DataElement$Reference$toStringFromEither(ref),
					recordDecoder,
					A3(
						$author$project$Compiler$crmQueryHandlerForLimit,
						$author$project$MyInsights$getLimit(config),
						ref,
						metadata)));
		case 'NitroQuery':
			var config = query.a;
			var metadata = query.b;
			var recordDecoder = query.c;
			return $elm$core$Maybe$Just(
				A4(
					$author$project$MyInsights$queryVDSRecordListener,
					$author$project$DataElement$Reference$toStringFromEither(ref),
					$author$project$MyInsights$getObjectName(config),
					recordDecoder,
					A3(
						$author$project$Compiler$nitroQueryHandlerForLimit,
						$author$project$MyInsights$getLimit(config),
						ref,
						metadata)));
		case 'CrmDataEngineQuery':
			var config = query.a;
			var metadata = query.b;
			var recordDecoder = query.c;
			return $elm$core$Maybe$Just(
				A3(
					$author$project$MyInsights$queryCrmDataEngineListener,
					$author$project$DataElement$Reference$toStringFromEither(ref),
					recordDecoder,
					A3($author$project$Compiler$crmQueryHandlerForLimit, config.limit, ref, metadata)));
		case 'AlignedTerritories':
			if (ref.$ === 'IsSingleton') {
				return $elm$core$Maybe$Nothing;
			} else {
				var recordList = ref.a;
				return $elm$core$Maybe$Just(
					A3(
						$author$project$MyInsights$queryAlignedTerritoriesListener,
						$author$project$DataElement$Reference$toStringFromEither(ref),
						$author$project$DataElement$AlignedTerritories$recordCacheDecoder,
						A2($author$project$Compiler$RxListOfRecords, recordList, $author$project$DataElement$AlignedTerritories$metadata)));
			}
		case 'CallAttendees':
			if (ref.$ === 'IsSingleton') {
				return $elm$core$Maybe$Nothing;
			} else {
				var recordList = ref.a;
				return $elm$core$Maybe$Just(
					A3(
						$author$project$MyInsights$queryCallAttendeesListener,
						$author$project$DataElement$Reference$toStringFromEither(ref),
						$author$project$DataElement$CallAttendees$decoder,
						A2($author$project$Compiler$RxListOfRecords, recordList, $author$project$DataElement$CallAttendees$metadata)));
			}
		case 'Today':
			return $elm$core$Maybe$Nothing;
		case 'Now':
			return $elm$core$Maybe$Nothing;
		case 'ObjectTranslation':
			var objectName = query.a;
			if (ref.$ === 'IsSingleton') {
				var singleRef = ref.a;
				return $elm$core$Maybe$Just(
					A2(
						$author$project$MyInsights$getObjectLabelsListener,
						$author$project$DataElement$Reference$toStringFromEither(ref),
						A2(
							$elm$core$Basics$composeR,
							$elm$core$Result$map(
								$author$project$Compiler$translationsForObject(objectName)),
							A2($author$project$Compiler$RxSingleton, singleRef, $author$project$DataElement$ObjectTranslation$metadata))));
			} else {
				return $elm$core$Maybe$Nothing;
			}
		case 'FieldTranslation':
			var info = query.a;
			if (ref.$ === 'IsSingleton') {
				var singleRef = ref.a;
				return $elm$core$Maybe$Just(
					A3(
						$author$project$MyInsights$getFieldLabelsListener,
						$author$project$DataElement$Reference$toStringFromEither(ref),
						$author$project$ObjectName$toString(info.object),
						A2(
							$elm$core$Basics$composeR,
							$elm$core$Result$map($author$project$DataElement$FieldTranslation$toRecordCache),
							A2(
								$author$project$Compiler$RxSingleton,
								singleRef,
								$author$project$DataElement$FieldTranslation$metadata(info)))));
			} else {
				return $elm$core$Maybe$Nothing;
			}
		default:
			var info = query.a;
			if (ref.$ === 'IsSingleton') {
				var singleRef = ref.a;
				return $elm$core$Maybe$Just(
					A2(
						$author$project$MyInsights$getVeevaMessagesTwoStepListener,
						$author$project$DataElement$Reference$toStringFromEither(ref),
						A2($author$project$Compiler$RxVeevaMessageTwoStep, singleRef, info)));
			} else {
				return $elm$core$Maybe$Nothing;
			}
	}
};
var $author$project$Compiler$rxFromFrontEnd = _Platform_incomingPort('rxFromFrontEnd', $elm$json$Json$Decode$value);
var $author$project$Compiler$rxFromPreview = _Platform_incomingPort('rxFromPreview', $elm$json$Json$Decode$value);
var $author$project$MyInsights$jsToElmMyInsights = _Platform_incomingPort(
	'jsToElmMyInsights',
	A2(
		$elm$json$Json$Decode$andThen,
		function (_v0) {
			return A2(
				$elm$json$Json$Decode$andThen,
				function (_v1) {
					return $elm$json$Json$Decode$succeed(
						_Utils_Tuple2(_v0, _v1));
				},
				A2($elm$json$Json$Decode$index, 1, $elm$json$Json$Decode$value));
		},
		A2($elm$json$Json$Decode$index, 0, $elm$json$Json$Decode$string)));
var $author$project$MyInsights$getListenerMsgForJsonResult = F2(
	function (jsonResult, _v0) {
		var listener = _v0.a;
		return listener.toMsg(jsonResult);
	});
var $author$project$MyInsights$listenerIsForId = F2(
	function (queryId, _v0) {
		var listener = _v0.a;
		return _Utils_eq(listener.queryId, queryId);
	});
var $author$project$MyInsights$apiErrorDecoder = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[
			A3(
			$elm$json$Json$Decode$map2,
			$author$project$MyInsights$ApiError,
			A2($elm$json$Json$Decode$field, 'code', $elm$json$Json$Decode$int),
			A2($elm$json$Json$Decode$field, 'message', $elm$json$Json$Decode$string)),
			A3(
			$elm$json$Json$Decode$map2,
			$author$project$MyInsights$ApiError,
			$elm$json$Json$Decode$succeed(-2),
			$elm$json$Json$Decode$string),
			A2(
			$elm$json$Json$Decode$map,
			$author$project$MyInsights$ApiError(-2),
			A2($elm$json$Json$Decode$field, 'message', $elm$json$Json$Decode$string))
		]));
var $author$project$MyInsights$apiResultStringDecoder = function (resultWords) {
	if (resultWords.$ === 'Just') {
		if (resultWords.a) {
			return A2($elm$json$Json$Decode$map, $elm$core$Result$Ok, $elm$json$Json$Decode$value);
		} else {
			return $elm$json$Json$Decode$oneOf(
				_List_fromArray(
					[
						A2($elm$json$Json$Decode$map, $elm$core$Result$Err, $author$project$MyInsights$apiErrorDecoder),
						$elm$json$Json$Decode$succeed(
						$elm$core$Result$Err(
							A2($author$project$MyInsights$ApiError, -1, 'Unknown Error (Could not decode error JSON) \n\n Please see if your Test Record is configured correctly.')))
					]));
		}
	} else {
		return $elm$json$Json$Decode$oneOf(
			_List_fromArray(
				[
					A2($elm$json$Json$Decode$map, $elm$core$Result$Err, $author$project$MyInsights$apiErrorDecoder),
					$elm$json$Json$Decode$fail('Unknown Error (Could not decode error JSON)')
				]));
	}
};
var $author$project$MyInsights$apiResultDecoder = A2(
	$elm$json$Json$Decode$andThen,
	$author$project$MyInsights$apiResultStringDecoder,
	$elm$json$Json$Decode$maybe(
		A2($elm$json$Json$Decode$field, 'success', $elm$json$Json$Decode$bool)));
var $author$project$MyInsights$unwrapJsonToApiResult = function (value) {
	return A2(
		$elm$core$Result$withDefault,
		$elm$core$Result$Ok(value),
		A2($elm$json$Json$Decode$decodeValue, $author$project$MyInsights$apiResultDecoder, value));
};
var $author$project$MyInsights$subHelper = F3(
	function (defaultMsg, listeners, _v0) {
		var queryId = _v0.a;
		var json = _v0.b;
		return A2(
			$elm$core$Maybe$withDefault,
			defaultMsg,
			A2(
				$elm$core$Maybe$map,
				$author$project$MyInsights$getListenerMsgForJsonResult(
					$author$project$MyInsights$unwrapJsonToApiResult(json)),
				$elm$core$List$head(
					A2(
						$elm$core$List$filter,
						$author$project$MyInsights$listenerIsForId(queryId),
						listeners))));
	});
var $author$project$MyInsights$sub = F2(
	function (defaultMsg, listeners) {
		return $author$project$MyInsights$jsToElmMyInsights(
			A2($author$project$MyInsights$subHelper, defaultMsg, listeners));
	});
var $author$project$Compiler$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				$author$project$Compiler$rxFromFrontEnd(
				A2(
					$elm$core$Basics$composeR,
					$elm$json$Json$Decode$decodeValue($author$project$Compiler$FromFrontEndMsg$decoder),
					$author$project$Compiler$FromFrontEnd)),
				$author$project$Compiler$rxFromPreview(
				A2(
					$elm$core$Basics$composeR,
					$elm$json$Json$Decode$decodeValue($author$project$Preview$ToEngineMsg$decoder),
					$author$project$Compiler$FromPreview)),
				A2(
				$author$project$MyInsights$sub,
				$author$project$Compiler$NoOp,
				A2(
					$elm$core$List$cons,
					A5($author$project$MyInsights$getDataForCurrentObjectListener, 'UserTimeZone___', 'User', 'TimeZoneSidKey', $elm$json$Json$Decode$string, $author$project$Compiler$RxUserTimeZone),
					A2(
						$elm$core$List$cons,
						A3($author$project$MyInsights$getCurrentUserLocaleListener, 'UserLocale___', $author$project$LoadableLocale$localeDecoder, $author$project$Compiler$RxUserLocale),
						A2(
							$elm$core$List$cons,
							A3($author$project$MyInsights$getFeedbackDataListener, 'FeedbackData___', $author$project$FeedbackData$decoder, $author$project$Compiler$RxFeedbackData),
							A2(
								$elm$core$List$filterMap,
								$author$project$Compiler$makeListener,
								$author$project$Compiler$getRunningQueries(model))))))
			]));
};
var $author$project$Compiler$ToFrontEndMsg$ConfigValidationResponse = function (a) {
	return {$: 'ConfigValidationResponse', a: a};
};
var $author$project$Compiler$ToFrontEndMsg$JsonError = function (a) {
	return {$: 'JsonError', a: a};
};
var $Fresheyeball$elm_return$Return$andThen = F2(
	function (f, _v0) {
		var model = _v0.a;
		var cmd = _v0.b;
		var _v1 = f(model);
		var model_ = _v1.a;
		var cmd_ = _v1.b;
		return _Utils_Tuple2(
			model_,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[cmd, cmd_])));
	});
var $Fresheyeball$elm_return$Return$command = F2(
	function (cmd, _v0) {
		var model = _v0.a;
		var cmd_ = _v0.b;
		return _Utils_Tuple2(
			model,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[cmd, cmd_])));
	});
var $author$project$MyInsights$GetVeevaMessages = F3(
	function (a, b, c) {
		return {$: 'GetVeevaMessages', a: a, b: b, c: c};
	});
var $author$project$MyInsights$elmToJsMyInsights = _Platform_outgoingPort('elmToJsMyInsights', $elm$core$Basics$identity);
var $author$project$MyInsights$DoNotFixEmptyList = {$: 'DoNotFixEmptyList'};
var $author$project$MyInsights$FixEmptyList = {$: 'FixEmptyList'};
var $elm$json$Json$Encode$bool = _Json_wrap;
var $elm$json$Json$Encode$object = function (pairs) {
	return _Json_wrap(
		A3(
			$elm$core$List$foldl,
			F2(
				function (_v0, obj) {
					var k = _v0.a;
					var v = _v0.b;
					return A3(_Json_addField, k, v, obj);
				}),
			_Json_emptyObject(_Utils_Tuple0),
			pairs));
};
var $elm$json$Json$Encode$string = _Json_wrap;
var $author$project$MyInsights$CrmDataEngineQuery$concatFragmentEncoder = function (concatFragment) {
	if (concatFragment.$ === 'ConcatQuote') {
		var string = concatFragment.a;
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'type',
					$elm$json$Json$Encode$string('QUOTE')),
					_Utils_Tuple2(
					'text',
					$elm$json$Json$Encode$string(string))
				]));
	} else {
		var fieldName = concatFragment.a;
		return $elm$json$Json$Encode$string(fieldName);
	}
};
var $elm$json$Json$Encode$list = F2(
	function (func, entries) {
		return _Json_wrap(
			A3(
				$elm$core$List$foldl,
				_Json_addEntry(func),
				_Json_emptyArray(_Utils_Tuple0),
				entries));
	});
var $author$project$MyInsights$CrmDataEngineQuery$dimensionEncoder = F2(
	function (dimensionName, dimension) {
		switch (dimension.$) {
			case 'Concat':
				var concatFragments = dimension.a;
				return $elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'type',
							$elm$json$Json$Encode$string('CONCAT')),
							_Utils_Tuple2(
							'as',
							$elm$json$Json$Encode$string(dimensionName)),
							_Utils_Tuple2(
							'arguments',
							A2($elm$json$Json$Encode$list, $author$project$MyInsights$CrmDataEngineQuery$concatFragmentEncoder, concatFragments))
						]));
			case 'DateTruncate':
				var fieldName = dimension.a;
				var dateInterval = dimension.b;
				return $elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'type',
							$elm$json$Json$Encode$string('DATE_TRUNC')),
							_Utils_Tuple2(
							'as',
							$elm$json$Json$Encode$string(dimensionName)),
							_Utils_Tuple2(
							'interval',
							$elm$json$Json$Encode$string(dateInterval)),
							_Utils_Tuple2(
							'field',
							$elm$json$Json$Encode$string(fieldName))
						]));
			case 'DateTimeTruncate':
				var fieldName = dimension.a;
				var dateInterval = dimension.b;
				return $elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'type',
							$elm$json$Json$Encode$string('DATE_TRUNC')),
							_Utils_Tuple2(
							'as',
							$elm$json$Json$Encode$string(dimensionName)),
							_Utils_Tuple2(
							'interval',
							$elm$json$Json$Encode$string(dateInterval)),
							_Utils_Tuple2(
							'field',
							$elm$json$Json$Encode$string(fieldName))
						]));
			case 'Divide':
				var dividend = dimension.a;
				var divisor = dimension.b;
				return $elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'type',
							$elm$json$Json$Encode$string('DIV')),
							_Utils_Tuple2(
							'as',
							$elm$json$Json$Encode$string(dimensionName)),
							_Utils_Tuple2(
							'fieldA',
							$elm$json$Json$Encode$string(dividend)),
							_Utils_Tuple2(
							'fieldB',
							$elm$json$Json$Encode$string(divisor))
						]));
			case 'Multiply':
				var firstFactor = dimension.a;
				var secondFactor = dimension.b;
				return $elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'type',
							$elm$json$Json$Encode$string('MULTI')),
							_Utils_Tuple2(
							'as',
							$elm$json$Json$Encode$string(dimensionName)),
							_Utils_Tuple2(
							'fieldA',
							$elm$json$Json$Encode$string(firstFactor)),
							_Utils_Tuple2(
							'fieldB',
							$elm$json$Json$Encode$string(secondFactor))
						]));
			case 'Minus':
				var minuend = dimension.a;
				var subtrahend = dimension.b;
				return $elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'type',
							$elm$json$Json$Encode$string('MINUS')),
							_Utils_Tuple2(
							'as',
							$elm$json$Json$Encode$string(dimensionName)),
							_Utils_Tuple2(
							'fieldA',
							$elm$json$Json$Encode$string(minuend)),
							_Utils_Tuple2(
							'fieldB',
							$elm$json$Json$Encode$string(subtrahend))
						]));
			default:
				var firstAddend = dimension.a;
				var secondAddend = dimension.b;
				return $elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'type',
							$elm$json$Json$Encode$string('PLUS')),
							_Utils_Tuple2(
							'as',
							$elm$json$Json$Encode$string(dimensionName)),
							_Utils_Tuple2(
							'fieldA',
							$elm$json$Json$Encode$string(firstAddend)),
							_Utils_Tuple2(
							'fieldB',
							$elm$json$Json$Encode$string(secondAddend))
						]));
		}
	});
var $author$project$MyInsights$CrmDataEngineQuery$metricEncoder = F2(
	function (metricName, metric) {
		switch (metric.$) {
			case 'Sum':
				var sourceField = metric.a;
				return $elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'type',
							$elm$json$Json$Encode$string('SUM')),
							_Utils_Tuple2(
							'field',
							$elm$json$Json$Encode$string(sourceField)),
							_Utils_Tuple2(
							'as',
							$elm$json$Json$Encode$string(metricName))
						]));
			case 'Count':
				var sourceField = metric.a;
				return $elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'type',
							$elm$json$Json$Encode$string('COUNT')),
							_Utils_Tuple2(
							'field',
							$elm$json$Json$Encode$string(sourceField)),
							_Utils_Tuple2(
							'as',
							$elm$json$Json$Encode$string(metricName))
						]));
			case 'CountDistinct':
				var sourceField = metric.a;
				return $elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'type',
							$elm$json$Json$Encode$string('COUNT_DISTINCT')),
							_Utils_Tuple2(
							'field',
							$elm$json$Json$Encode$string(sourceField)),
							_Utils_Tuple2(
							'as',
							$elm$json$Json$Encode$string(metricName))
						]));
			case 'Max':
				var sourceField = metric.a;
				return $elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'type',
							$elm$json$Json$Encode$string('MAX')),
							_Utils_Tuple2(
							'field',
							$elm$json$Json$Encode$string(sourceField)),
							_Utils_Tuple2(
							'as',
							$elm$json$Json$Encode$string(metricName))
						]));
			default:
				var sourceField = metric.a;
				return $elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'type',
							$elm$json$Json$Encode$string('MIN')),
							_Utils_Tuple2(
							'field',
							$elm$json$Json$Encode$string(sourceField)),
							_Utils_Tuple2(
							'as',
							$elm$json$Json$Encode$string(metricName))
						]));
		}
	});
var $author$project$MyInsights$CrmDataEngineQuery$crmDataEngineFieldEncoder = function (field) {
	switch (field.$) {
		case 'PureField':
			var string = field.a;
			return $elm$json$Json$Encode$string(string);
		case 'DimensionField':
			var fieldName = field.a;
			var dimension = field.b;
			return A2($author$project$MyInsights$CrmDataEngineQuery$dimensionEncoder, fieldName, dimension);
		default:
			var fieldName = field.a;
			var metric = field.b;
			return A2($author$project$MyInsights$CrmDataEngineQuery$metricEncoder, fieldName, metric);
	}
};
var $author$project$MyInsights$CrmDataEngineQuery$encodeSortDirection = function (dir) {
	if (dir.$ === 'Ascending') {
		return $elm$json$Json$Encode$string('ASC');
	} else {
		return $elm$json$Json$Encode$string('DESC');
	}
};
var $author$project$MyInsights$CrmDataEngineQuery$encodeSort = function (sort) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'field',
				$elm$json$Json$Encode$string(sort.field)),
				_Utils_Tuple2(
				'direction',
				$author$project$MyInsights$CrmDataEngineQuery$encodeSortDirection(sort.direction))
			]));
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$encode = A2($elm$core$Basics$composeR, $rtfeldman$elm_iso8601_date_strings$Iso8601$fromTime, $elm$json$Json$Encode$string);
var $elm$json$Json$Encode$float = _Json_wrap;
var $author$project$MyInsights$CrmDataEngineQuery$encodeWhereClause = function (whereClause) {
	encodeWhereClause:
	while (true) {
		switch (whereClause.$) {
			case 'AllOf':
				var clauseList = whereClause.a;
				return $elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'type',
							$elm$json$Json$Encode$string('ALL_OF')),
							_Utils_Tuple2(
							'conditions',
							A2($elm$json$Json$Encode$list, $author$project$MyInsights$CrmDataEngineQuery$encodeWhereClause, clauseList))
						]));
			case 'AnyOf':
				var clauseList = whereClause.a;
				return $elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'type',
							$elm$json$Json$Encode$string('ANY_OF')),
							_Utils_Tuple2(
							'conditions',
							A2($elm$json$Json$Encode$list, $author$project$MyInsights$CrmDataEngineQuery$encodeWhereClause, clauseList))
						]));
			case 'StringEq':
				var field = whereClause.a;
				var stringValue = whereClause.b;
				return $elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'type',
							$elm$json$Json$Encode$string('EQUAL')),
							_Utils_Tuple2(
							'field',
							$elm$json$Json$Encode$string(field)),
							_Utils_Tuple2(
							'value',
							$elm$json$Json$Encode$string(stringValue))
						]));
			case 'NumberEq':
				var field = whereClause.a;
				var numValue = whereClause.b;
				return $elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'type',
							$elm$json$Json$Encode$string('EQUAL')),
							_Utils_Tuple2(
							'field',
							$elm$json$Json$Encode$string(field)),
							_Utils_Tuple2(
							'value',
							$elm$json$Json$Encode$float(numValue))
						]));
			case 'DateEq':
				var field = whereClause.a;
				var dateValue = whereClause.b;
				return $elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'type',
							$elm$json$Json$Encode$string('EQUAL')),
							_Utils_Tuple2(
							'field',
							$elm$json$Json$Encode$string(field)),
							_Utils_Tuple2(
							'value',
							$elm$json$Json$Encode$string(
								$justinmimbs$date$Date$toIsoString(dateValue)))
						]));
			case 'DateTimeEq':
				var field = whereClause.a;
				var dateTimeValue = whereClause.b;
				return $elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'type',
							$elm$json$Json$Encode$string('EQUAL')),
							_Utils_Tuple2(
							'field',
							$elm$json$Json$Encode$string(field)),
							_Utils_Tuple2(
							'value',
							$rtfeldman$elm_iso8601_date_strings$Iso8601$encode(dateTimeValue))
						]));
			case 'BoolEq':
				var field = whereClause.a;
				var bool = whereClause.b;
				return $elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'type',
							$elm$json$Json$Encode$string('EQUAL')),
							_Utils_Tuple2(
							'field',
							$elm$json$Json$Encode$string(field)),
							_Utils_Tuple2(
							'value',
							$elm$json$Json$Encode$bool(bool))
						]));
			case 'StringNotEq':
				var field = whereClause.a;
				var stringValue = whereClause.b;
				return $elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'type',
							$elm$json$Json$Encode$string('NOT_EQUAL')),
							_Utils_Tuple2(
							'field',
							$elm$json$Json$Encode$string(field)),
							_Utils_Tuple2(
							'value',
							$elm$json$Json$Encode$string(stringValue))
						]));
			case 'NumberNotEq':
				var field = whereClause.a;
				var numValue = whereClause.b;
				return $elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'type',
							$elm$json$Json$Encode$string('NOT_EQUAL')),
							_Utils_Tuple2(
							'field',
							$elm$json$Json$Encode$string(field)),
							_Utils_Tuple2(
							'value',
							$elm$json$Json$Encode$float(numValue))
						]));
			case 'DateNotEq':
				var field = whereClause.a;
				var dateValue = whereClause.b;
				return $elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'type',
							$elm$json$Json$Encode$string('NOT_EQUAL')),
							_Utils_Tuple2(
							'field',
							$elm$json$Json$Encode$string(field)),
							_Utils_Tuple2(
							'value',
							$elm$json$Json$Encode$string(
								$justinmimbs$date$Date$toIsoString(dateValue)))
						]));
			case 'DateTimeNotEq':
				var field = whereClause.a;
				var dateTimeValue = whereClause.b;
				return $elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'type',
							$elm$json$Json$Encode$string('NOT_EQUAL')),
							_Utils_Tuple2(
							'field',
							$elm$json$Json$Encode$string(field)),
							_Utils_Tuple2(
							'value',
							$rtfeldman$elm_iso8601_date_strings$Iso8601$encode(dateTimeValue))
						]));
			case 'BoolNotEq':
				var field = whereClause.a;
				var bool = whereClause.b;
				return $elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'type',
							$elm$json$Json$Encode$string('NOT_EQUAL')),
							_Utils_Tuple2(
							'field',
							$elm$json$Json$Encode$string(field)),
							_Utils_Tuple2(
							'value',
							$elm$json$Json$Encode$bool(bool))
						]));
			case 'StringGt':
				var field = whereClause.a;
				var stringValue = whereClause.b;
				return $elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'type',
							$elm$json$Json$Encode$string('GREATER_THAN')),
							_Utils_Tuple2(
							'field',
							$elm$json$Json$Encode$string(field)),
							_Utils_Tuple2(
							'value',
							$elm$json$Json$Encode$string(stringValue))
						]));
			case 'NumberGt':
				var field = whereClause.a;
				var numValue = whereClause.b;
				return $elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'type',
							$elm$json$Json$Encode$string('GREATER_THAN')),
							_Utils_Tuple2(
							'field',
							$elm$json$Json$Encode$string(field)),
							_Utils_Tuple2(
							'value',
							$elm$json$Json$Encode$float(numValue))
						]));
			case 'DateGt':
				var field = whereClause.a;
				var dateValue = whereClause.b;
				return $elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'type',
							$elm$json$Json$Encode$string('GREATER_THAN')),
							_Utils_Tuple2(
							'field',
							$elm$json$Json$Encode$string(field)),
							_Utils_Tuple2(
							'value',
							$elm$json$Json$Encode$string(
								$justinmimbs$date$Date$toIsoString(dateValue)))
						]));
			case 'DateTimeGt':
				var field = whereClause.a;
				var dateTimeValue = whereClause.b;
				return $elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'type',
							$elm$json$Json$Encode$string('GREATER_THAN')),
							_Utils_Tuple2(
							'field',
							$elm$json$Json$Encode$string(field)),
							_Utils_Tuple2(
							'value',
							$rtfeldman$elm_iso8601_date_strings$Iso8601$encode(dateTimeValue))
						]));
			case 'StringGte':
				var field = whereClause.a;
				var stringValue = whereClause.b;
				return $elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'type',
							$elm$json$Json$Encode$string('GREATER_THAN_OR_EQUAL')),
							_Utils_Tuple2(
							'field',
							$elm$json$Json$Encode$string(field)),
							_Utils_Tuple2(
							'value',
							$elm$json$Json$Encode$string(stringValue))
						]));
			case 'NumberGte':
				var field = whereClause.a;
				var numValue = whereClause.b;
				return $elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'type',
							$elm$json$Json$Encode$string('GREATER_THAN_OR_EQUAL')),
							_Utils_Tuple2(
							'field',
							$elm$json$Json$Encode$string(field)),
							_Utils_Tuple2(
							'value',
							$elm$json$Json$Encode$float(numValue))
						]));
			case 'DateGte':
				var field = whereClause.a;
				var dateValue = whereClause.b;
				return $elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'type',
							$elm$json$Json$Encode$string('GREATER_THAN_OR_EQUAL')),
							_Utils_Tuple2(
							'field',
							$elm$json$Json$Encode$string(field)),
							_Utils_Tuple2(
							'value',
							$elm$json$Json$Encode$string(
								$justinmimbs$date$Date$toIsoString(dateValue)))
						]));
			case 'DateTimeGte':
				var field = whereClause.a;
				var dateTimeValue = whereClause.b;
				return $elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'type',
							$elm$json$Json$Encode$string('GREATER_THAN_OR_EQUAL')),
							_Utils_Tuple2(
							'field',
							$elm$json$Json$Encode$string(field)),
							_Utils_Tuple2(
							'value',
							$rtfeldman$elm_iso8601_date_strings$Iso8601$encode(dateTimeValue))
						]));
			case 'StringLt':
				var field = whereClause.a;
				var stringValue = whereClause.b;
				return $elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'type',
							$elm$json$Json$Encode$string('LESS_THAN')),
							_Utils_Tuple2(
							'field',
							$elm$json$Json$Encode$string(field)),
							_Utils_Tuple2(
							'value',
							$elm$json$Json$Encode$string(stringValue))
						]));
			case 'NumberLt':
				var field = whereClause.a;
				var numValue = whereClause.b;
				return $elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'type',
							$elm$json$Json$Encode$string('LESS_THAN')),
							_Utils_Tuple2(
							'field',
							$elm$json$Json$Encode$string(field)),
							_Utils_Tuple2(
							'value',
							$elm$json$Json$Encode$float(numValue))
						]));
			case 'DateLt':
				var field = whereClause.a;
				var dateValue = whereClause.b;
				return $elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'type',
							$elm$json$Json$Encode$string('LESS_THAN')),
							_Utils_Tuple2(
							'field',
							$elm$json$Json$Encode$string(field)),
							_Utils_Tuple2(
							'value',
							$elm$json$Json$Encode$string(
								$justinmimbs$date$Date$toIsoString(dateValue)))
						]));
			case 'DateTimeLt':
				var field = whereClause.a;
				var dateTimeValue = whereClause.b;
				return $elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'type',
							$elm$json$Json$Encode$string('LESS_THAN')),
							_Utils_Tuple2(
							'field',
							$elm$json$Json$Encode$string(field)),
							_Utils_Tuple2(
							'value',
							$rtfeldman$elm_iso8601_date_strings$Iso8601$encode(dateTimeValue))
						]));
			case 'StringLte':
				var field = whereClause.a;
				var stringValue = whereClause.b;
				return $elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'type',
							$elm$json$Json$Encode$string('LESS_THAN_OR_EQUAL')),
							_Utils_Tuple2(
							'field',
							$elm$json$Json$Encode$string(field)),
							_Utils_Tuple2(
							'value',
							$elm$json$Json$Encode$string(stringValue))
						]));
			case 'NumberLte':
				var field = whereClause.a;
				var numValue = whereClause.b;
				return $elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'type',
							$elm$json$Json$Encode$string('LESS_THAN_OR_EQUAL')),
							_Utils_Tuple2(
							'field',
							$elm$json$Json$Encode$string(field)),
							_Utils_Tuple2(
							'value',
							$elm$json$Json$Encode$float(numValue))
						]));
			case 'DateLte':
				var field = whereClause.a;
				var dateValue = whereClause.b;
				return $elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'type',
							$elm$json$Json$Encode$string('LESS_THAN_OR_EQUAL')),
							_Utils_Tuple2(
							'field',
							$elm$json$Json$Encode$string(field)),
							_Utils_Tuple2(
							'value',
							$elm$json$Json$Encode$string(
								$justinmimbs$date$Date$toIsoString(dateValue)))
						]));
			case 'DateTimeLte':
				var field = whereClause.a;
				var dateTimeValue = whereClause.b;
				return $elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'type',
							$elm$json$Json$Encode$string('LESS_THAN_OR_EQUAL')),
							_Utils_Tuple2(
							'field',
							$elm$json$Json$Encode$string(field)),
							_Utils_Tuple2(
							'value',
							$rtfeldman$elm_iso8601_date_strings$Iso8601$encode(dateTimeValue))
						]));
			case 'In':
				var field = whereClause.a;
				var stringValues = whereClause.b;
				return $elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'type',
							$elm$json$Json$Encode$string('IN')),
							_Utils_Tuple2(
							'field',
							$elm$json$Json$Encode$string(field)),
							_Utils_Tuple2(
							'values',
							A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, stringValues))
						]));
			case 'BetweenString':
				var field = whereClause.a;
				var startString = whereClause.b;
				var endString = whereClause.c;
				return $elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'type',
							$elm$json$Json$Encode$string('BETWEEN')),
							_Utils_Tuple2(
							'field',
							$elm$json$Json$Encode$string(field)),
							_Utils_Tuple2(
							'start',
							$elm$json$Json$Encode$string(startString)),
							_Utils_Tuple2(
							'end',
							$elm$json$Json$Encode$string(endString))
						]));
			case 'BetweenNumber':
				var field = whereClause.a;
				var startNum = whereClause.b;
				var endNum = whereClause.c;
				return $elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'type',
							$elm$json$Json$Encode$string('BETWEEN')),
							_Utils_Tuple2(
							'field',
							$elm$json$Json$Encode$string(field)),
							_Utils_Tuple2(
							'start',
							$elm$json$Json$Encode$float(startNum)),
							_Utils_Tuple2(
							'end',
							$elm$json$Json$Encode$float(endNum))
						]));
			case 'BetweenDate':
				var field = whereClause.a;
				var startDate = whereClause.b;
				var endDate = whereClause.c;
				return $elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'type',
							$elm$json$Json$Encode$string('BETWEEN')),
							_Utils_Tuple2(
							'field',
							$elm$json$Json$Encode$string(field)),
							_Utils_Tuple2(
							'start',
							$elm$json$Json$Encode$string(
								$justinmimbs$date$Date$toIsoString(startDate))),
							_Utils_Tuple2(
							'end',
							$elm$json$Json$Encode$string(
								$justinmimbs$date$Date$toIsoString(endDate)))
						]));
			case 'BetweenDateTime':
				var field = whereClause.a;
				var startDateTime = whereClause.b;
				var endDateTime = whereClause.c;
				return $elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'type',
							$elm$json$Json$Encode$string('BETWEEN')),
							_Utils_Tuple2(
							'field',
							$elm$json$Json$Encode$string(field)),
							_Utils_Tuple2(
							'start',
							$rtfeldman$elm_iso8601_date_strings$Iso8601$encode(startDateTime)),
							_Utils_Tuple2(
							'end',
							$rtfeldman$elm_iso8601_date_strings$Iso8601$encode(endDateTime))
						]));
			case 'IsNull':
				var field = whereClause.a;
				return $elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'type',
							$elm$json$Json$Encode$string('IS_NULL')),
							_Utils_Tuple2(
							'field',
							$elm$json$Json$Encode$string(field))
						]));
			case 'IsNotNull':
				var field = whereClause.a;
				return $elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'type',
							$elm$json$Json$Encode$string('IS_NOT_NULL')),
							_Utils_Tuple2(
							'field',
							$elm$json$Json$Encode$string(field))
						]));
			default:
				var field = whereClause.a;
				var $temp$whereClause = $author$project$MyInsights$CrmDataEngineQuery$AllOf(
					_List_fromArray(
						[
							$author$project$MyInsights$CrmDataEngineQuery$IsNull(field),
							$author$project$MyInsights$CrmDataEngineQuery$IsNotNull(field)
						]));
				whereClause = $temp$whereClause;
				continue encodeWhereClause;
		}
	}
};
var $elm$json$Json$Encode$int = _Json_wrap;
var $author$project$MyInsights$CrmDataEngineQuery$encode = function (config) {
	return $elm$json$Json$Encode$object(
		A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					$elm$core$Maybe$Just(
					_Utils_Tuple2(
						'table',
						$elm$json$Json$Encode$string(config.table))),
					$elm$core$Maybe$Just(
					_Utils_Tuple2(
						'fields',
						A2($elm$json$Json$Encode$list, $author$project$MyInsights$CrmDataEngineQuery$crmDataEngineFieldEncoder, config.fields))),
					A2(
					$elm$core$Maybe$map,
					function (where_) {
						return _Utils_Tuple2(
							'where',
							$author$project$MyInsights$CrmDataEngineQuery$encodeWhereClause(where_));
					},
					config.whereClause),
					A2(
					$elm$core$Maybe$map,
					function (_v0) {
						return _Utils_Tuple2(
							'sort',
							A2($elm$json$Json$Encode$list, $author$project$MyInsights$CrmDataEngineQuery$encodeSort, config.sort));
					},
					$elm$core$List$head(config.sort)),
					A2(
					$elm$core$Maybe$map,
					function (limit) {
						return _Utils_Tuple2(
							'limit',
							$elm$json$Json$Encode$int(limit));
					},
					config.limit)
				])));
};
var $author$project$MyInsights$NoParent = {$: 'NoParent'};
var $author$project$MyInsights$ParentIsAnd = {$: 'ParentIsAnd'};
var $author$project$MyInsights$ParentIsOr = {$: 'ParentIsOr'};
var $author$project$MyInsights$addParen = function (text) {
	return '(' + (text + ')');
};
var $author$project$MyInsights$addParenIfNecessary = F2(
	function (shouldAddParen, words) {
		return shouldAddParen ? $author$project$MyInsights$addParen(words) : words;
	});
var $author$project$MyInsights$flattenWhereClause = F3(
	function (whereParent, handleEmptyList, clause) {
		switch (clause.$) {
			case 'WhereAnd':
				var children = clause.a;
				return A2(
					$author$project$MyInsights$addParenIfNecessary,
					_Utils_eq(whereParent, $author$project$MyInsights$ParentIsOr),
					A2(
						$elm$core$String$join,
						' AND ',
						A2(
							$elm$core$List$map,
							A2($author$project$MyInsights$flattenWhereClause, $author$project$MyInsights$ParentIsAnd, handleEmptyList),
							children)));
			case 'WhereOr':
				var children = clause.a;
				return A2(
					$author$project$MyInsights$addParenIfNecessary,
					_Utils_eq(whereParent, $author$project$MyInsights$ParentIsAnd),
					A2(
						$elm$core$String$join,
						' OR ',
						A2(
							$elm$core$List$map,
							A2($author$project$MyInsights$flattenWhereClause, $author$project$MyInsights$ParentIsOr, handleEmptyList),
							children)));
			case 'Where':
				var text = clause.a;
				return text;
			default:
				var text = clause.a;
				if (handleEmptyList.$ === 'FixEmptyList') {
					return '(ID=NULL AND ID=\'000000000000000\')';
				} else {
					return text;
				}
		}
	});
var $elm_community$string_extra$String$Extra$isBlank = function (string) {
	return A2(
		$elm$regex$Regex$contains,
		$elm_community$string_extra$String$Extra$regexFromString('^\\s*$'),
		string);
};
var $elm_community$string_extra$String$Extra$nonBlank = function (string) {
	return $elm_community$string_extra$String$Extra$isBlank(string) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(string);
};
var $author$project$MyInsights$shakeWhereTree = function (whereClause) {
	switch (whereClause.$) {
		case 'WhereAnd':
			var children = whereClause.a;
			var _v1 = A2($elm$core$List$filterMap, $author$project$MyInsights$shakeWhereTree, children);
			if (!_v1.b) {
				return $elm$core$Maybe$Nothing;
			} else {
				var shakenChildren = _v1;
				return $elm$core$Maybe$Just(
					$author$project$MyInsights$WhereAnd(shakenChildren));
			}
		case 'WhereOr':
			var children = whereClause.a;
			var _v2 = A2($elm$core$List$filterMap, $author$project$MyInsights$shakeWhereTree, children);
			if (!_v2.b) {
				return $elm$core$Maybe$Nothing;
			} else {
				var shakenChildren = _v2;
				return $elm$core$Maybe$Just(
					$author$project$MyInsights$WhereOr(shakenChildren));
			}
		case 'Where':
			var text = whereClause.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$MyInsights$Where,
				$elm_community$string_extra$String$Extra$nonBlank(text));
		default:
			var text = whereClause.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$MyInsights$WhereEmptyList,
				$elm_community$string_extra$String$Extra$nonBlank(text));
	}
};
var $author$project$MyInsights$encodeQueryConfig = F2(
	function (handleEmptyList, _v0) {
		var query = _v0.a;
		return $elm$json$Json$Encode$object(
			A2(
				$elm$core$List$filterMap,
				$elm$core$Basics$identity,
				_List_fromArray(
					[
						$elm$core$Maybe$Just(
						_Utils_Tuple2(
							'object',
							$elm$json$Json$Encode$string(query.object))),
						$elm$core$Maybe$Just(
						_Utils_Tuple2(
							'fields',
							A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, query.fields))),
						A2(
						$elm$core$Maybe$map,
						function (where_) {
							return _Utils_Tuple2(
								'where',
								$elm$json$Json$Encode$string(
									A3($author$project$MyInsights$flattenWhereClause, $author$project$MyInsights$NoParent, handleEmptyList, where_)));
						},
						A2($elm$core$Maybe$andThen, $author$project$MyInsights$shakeWhereTree, query.where_)),
						A2(
						$elm$core$Maybe$map,
						function (_v1) {
							return _Utils_Tuple2(
								'sort',
								A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, query.sort));
						},
						$elm$core$List$head(query.sort)),
						A2(
						$elm$core$Maybe$map,
						function (limit) {
							return _Utils_Tuple2(
								'limit',
								$elm$json$Json$Encode$int(limit));
						},
						query.limit),
						A2(
						$elm$core$Maybe$map,
						function (_v2) {
							return _Utils_Tuple2(
								'picklists',
								A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, query.picklists));
						},
						$elm$core$List$head(query.picklists))
					])));
	});
var $author$project$MyInsights$encodeVeevaMessageToken = function (token) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'msgName',
				$elm$json$Json$Encode$string(token.msgName)),
				_Utils_Tuple2(
				'msgCategory',
				$elm$json$Json$Encode$string(token.msgCategory))
			]));
};
var $danyx23$elm_uuid$Uuid$encode = A2($elm$core$Basics$composeR, $danyx23$elm_uuid$Uuid$toString, $elm$json$Json$Encode$string);
var $author$project$StudioContentId$encode = function (_v0) {
	var uuid = _v0.a;
	return $danyx23$elm_uuid$Uuid$encode(uuid);
};
var $author$project$MyInsights$navTargetEncoder = function (target) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'Studio_Id_vod__c',
				$author$project$StudioContentId$encode(target))
			]));
};
var $elm$json$Json$Encode$null = _Json_encodeNull;
var $author$project$MyInsights$encodeOutMsg = function (msg) {
	switch (msg.$) {
		case 'GetDataForCurrentObject':
			var queryId = msg.a;
			var object = msg.b;
			var field = msg.c;
			var isDateTime = msg.d;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('getDataForCurrentObject')),
						_Utils_Tuple2(
						'queryId',
						$elm$json$Json$Encode$string(queryId)),
						_Utils_Tuple2(
						'object',
						$elm$json$Json$Encode$string(object)),
						_Utils_Tuple2(
						'field',
						$elm$json$Json$Encode$string(field)),
						_Utils_Tuple2(
						'config',
						$elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'dateTimeFieldNames',
									isDateTime ? A2(
										$elm$json$Json$Encode$list,
										$elm$json$Json$Encode$string,
										_List_fromArray(
											[field])) : A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, _List_Nil)),
									_Utils_Tuple2(
									'locale',
									$elm$json$Json$Encode$string('')),
									_Utils_Tuple2('timeZone', $elm$json$Json$Encode$null),
									_Utils_Tuple2(
									'object',
									$elm$json$Json$Encode$string(object))
								])))
					]));
		case 'GetCurrentUserLocale':
			var queryId = msg.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('getCurrentUserLocale')),
						_Utils_Tuple2(
						'queryId',
						$elm$json$Json$Encode$string(queryId))
					]));
		case 'GetFeedbackData':
			var queryId = msg.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('getFeedbackData')),
						_Utils_Tuple2(
						'queryId',
						$elm$json$Json$Encode$string(queryId))
					]));
		case 'GetFieldLabels':
			var queryId = msg.a;
			var object = msg.b;
			var fields = msg.c;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('getFieldLabels')),
						_Utils_Tuple2(
						'queryId',
						$elm$json$Json$Encode$string(queryId)),
						_Utils_Tuple2(
						'object',
						$elm$json$Json$Encode$string(object)),
						_Utils_Tuple2(
						'fields',
						A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, fields))
					]));
		case 'GetObjectLabels':
			var queryId = msg.a;
			var objects = msg.b;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('getObjectLabels')),
						_Utils_Tuple2(
						'queryId',
						$elm$json$Json$Encode$string(queryId)),
						_Utils_Tuple2(
						'objects',
						A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, objects))
					]));
		case 'GetPicklistValueLabels':
			var queryId = msg.a;
			var object = msg.b;
			var field = msg.c;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('getPicklistValueLabels')),
						_Utils_Tuple2(
						'queryId',
						$elm$json$Json$Encode$string(queryId)),
						_Utils_Tuple2(
						'object',
						$elm$json$Json$Encode$string(object)),
						_Utils_Tuple2(
						'field',
						$elm$json$Json$Encode$string(field))
					]));
		case 'GetVeevaMessages':
			var queryId = msg.a;
			var language = msg.b;
			var tokens = msg.c;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('getVeevaMessages')),
						_Utils_Tuple2(
						'queryId',
						$elm$json$Json$Encode$string(queryId)),
						_Utils_Tuple2(
						'language',
						$elm$json$Json$Encode$string(language)),
						_Utils_Tuple2(
						'tokens',
						A2($elm$json$Json$Encode$list, $author$project$MyInsights$encodeVeevaMessageToken, tokens))
					]));
		case 'RunQuery':
			var queryId = msg.a;
			var config = msg.b;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('runQuery')),
						_Utils_Tuple2(
						'queryId',
						$elm$json$Json$Encode$string(queryId)),
						_Utils_Tuple2(
						'config',
						A2($author$project$MyInsights$encodeQueryConfig, $author$project$MyInsights$FixEmptyList, config))
					]));
		case 'QuerySalesData':
			var queryId = msg.a;
			var config = msg.b;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('querySalesData')),
						_Utils_Tuple2(
						'queryId',
						$elm$json$Json$Encode$string(queryId)),
						_Utils_Tuple2(
						'config',
						A2($author$project$MyInsights$encodeQueryConfig, $author$project$MyInsights$DoNotFixEmptyList, config))
					]));
		case 'RunCrmDataEngineQuery':
			var queryId = msg.a;
			var queryConfig = msg.b;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('queryDataEngine')),
						_Utils_Tuple2(
						'queryId',
						$elm$json$Json$Encode$string(queryId)),
						_Utils_Tuple2(
						'config',
						$author$project$MyInsights$CrmDataEngineQuery$encode(queryConfig))
					]));
		case 'QueryRecord':
			var queryId = msg.a;
			var config = msg.b;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('queryRecord')),
						_Utils_Tuple2(
						'queryId',
						$elm$json$Json$Encode$string(queryId)),
						_Utils_Tuple2(
						'config',
						A2($author$project$MyInsights$encodeQueryConfig, $author$project$MyInsights$FixEmptyList, config))
					]));
		case 'QueryVDSRecord':
			var queryId = msg.a;
			var config = msg.b;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('queryVDSRecord')),
						_Utils_Tuple2(
						'queryId',
						$elm$json$Json$Encode$string(queryId)),
						_Utils_Tuple2(
						'config',
						A2($author$project$MyInsights$encodeQueryConfig, $author$project$MyInsights$DoNotFixEmptyList, config))
					]));
		case 'EditRecord':
			var object = msg.a;
			var fieldValues = msg.b;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('editRecord')),
						_Utils_Tuple2(
						'object',
						$elm$json$Json$Encode$string(object)),
						_Utils_Tuple2(
						'fieldValues',
						$elm$json$Json$Encode$object(
							A2(
								$elm$core$List$map,
								function (_v1) {
									var k = _v1.a;
									var v = _v1.b;
									return _Utils_Tuple2(
										k,
										$elm$json$Json$Encode$string(v));
								},
								$elm$core$Dict$toList(fieldValues))))
					]));
		case 'NewRecord':
			var object = msg.a;
			var fieldValues = msg.b;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('newRecord')),
						_Utils_Tuple2(
						'object',
						$elm$json$Json$Encode$string(object)),
						_Utils_Tuple2(
						'fieldValues',
						$elm$json$Json$Encode$object(
							A2(
								$elm$core$List$map,
								function (_v2) {
									var k = _v2.a;
									var v = _v2.b;
									return _Utils_Tuple2(
										k,
										$elm$json$Json$Encode$string(v));
								},
								$elm$core$Dict$toList(fieldValues))))
					]));
		case 'ViewRecord':
			var object = msg.a;
			var fieldValues = msg.b;
			var targets = msg.c;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('viewRecord')),
						_Utils_Tuple2(
						'object',
						$elm$json$Json$Encode$string(object)),
						_Utils_Tuple2(
						'fieldValues',
						$elm$json$Json$Encode$object(
							A2(
								$elm$core$List$map,
								function (_v3) {
									var k = _v3.a;
									var v = _v3.b;
									return _Utils_Tuple2(
										k,
										$elm$json$Json$Encode$string(v));
								},
								$elm$core$Dict$toList(fieldValues)))),
						_Utils_Tuple2(
						'target',
						A2($elm$json$Json$Encode$list, $author$project$MyInsights$navTargetEncoder, targets))
					]));
		case 'ViewSection':
			var targets = msg.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('viewSection')),
						_Utils_Tuple2(
						'target',
						A2(
							$elm$json$Json$Encode$list,
							$author$project$MyInsights$navTargetEncoder,
							$mgold$elm_nonempty_list$List$Nonempty$toList(targets)))
					]));
		case 'GetAvailableObjects':
			var queryId = msg.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('getAvailableObjects')),
						_Utils_Tuple2(
						'queryId',
						$elm$json$Json$Encode$string(queryId))
					]));
		case 'GetObjectMetadata':
			var queryId = msg.a;
			var object = msg.b;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('getObjectMetadata')),
						_Utils_Tuple2(
						'queryId',
						$elm$json$Json$Encode$string(queryId)),
						_Utils_Tuple2(
						'object',
						$elm$json$Json$Encode$string(object))
					]));
		case 'GetRecordTypeLabels':
			var queryId = msg.a;
			var object = msg.b;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('getRecordTypeLabels')),
						_Utils_Tuple2(
						'queryId',
						$elm$json$Json$Encode$string(queryId)),
						_Utils_Tuple2(
						'object',
						$elm$json$Json$Encode$string(object))
					]));
		case 'GetAlignedTerritories':
			var queryId = msg.a;
			var includeChildren = msg.b;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('getAlignedTerritories')),
						_Utils_Tuple2(
						'queryId',
						$elm$json$Json$Encode$string(queryId)),
						_Utils_Tuple2(
						'config',
						$elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'includeChildren',
									$elm$json$Json$Encode$bool(
										_Utils_eq(includeChildren, $author$project$MyInsights$IncludeChildTerritories)))
								])))
					]));
		default:
			var queryId = msg.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('getAttendeeDataForCurrentCall')),
						_Utils_Tuple2(
						'queryId',
						$elm$json$Json$Encode$string(queryId))
					]));
	}
};
var $author$project$MyInsights$sendMsg = function (msg) {
	return $author$project$MyInsights$elmToJsMyInsights(
		$author$project$MyInsights$encodeOutMsg(msg));
};
var $author$project$MyInsights$getVeevaMessages = F3(
	function (queryId, language, tokens) {
		return $author$project$MyInsights$sendMsg(
			A3($author$project$MyInsights$GetVeevaMessages, queryId, language, tokens));
	});
var $author$project$MyInsights$getTwoStepCmd = F3(
	function (queryId, tokens, twoStep) {
		if (twoStep.$ === 'GotLanguageLocaleKey') {
			var key = twoStep.a;
			return A3($author$project$MyInsights$getVeevaMessages, queryId, key, tokens);
		} else {
			return $elm$core$Platform$Cmd$none;
		}
	});
var $author$project$MyInsights$getTwoStepMessages = function (twoStep) {
	if (twoStep.$ === 'GotMessages') {
		var dict = twoStep.a;
		return $elm$core$Maybe$Just(dict);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $krisajenkins$remotedata$RemoteData$fromResult = function (result) {
	if (result.$ === 'Err') {
		var e = result.a;
		return $krisajenkins$remotedata$RemoteData$Failure(e);
	} else {
		var x = result.a;
		return $krisajenkins$remotedata$RemoteData$Success(x);
	}
};
var $author$project$DataEngine$DataCache$insertFeedbackData = F2(
	function (result, _v0) {
		var internal = _v0.a;
		return $author$project$DataEngine$DataCache$DataCache(
			_Utils_update(
				internal,
				{
					feedbackData: $krisajenkins$remotedata$RemoteData$fromResult(result)
				}));
	});
var $author$project$DataEngine$DataElementCache$ListCache = F2(
	function (a, b) {
		return {$: 'ListCache', a: a, b: b};
	});
var $author$project$UuidDict$mapInnerDict = F2(
	function (_function, _v0) {
		var dict = _v0.a;
		return $author$project$UuidDict$UuidDict(
			_function(dict));
	});
var $author$project$UuidDict$insert = F2(
	function (uuid, value) {
		return $author$project$UuidDict$mapInnerDict(
			A2(
				$elm$core$Dict$insert,
				$danyx23$elm_uuid$Uuid$toString(uuid),
				_Utils_Tuple2(uuid, value)));
	});
var $author$project$DataEngine$DataCache$mapCache = F2(
	function (transform, _v0) {
		var internal = _v0.a;
		return $author$project$DataEngine$DataCache$DataCache(
			_Utils_update(
				internal,
				{
					dataElementStates: transform(internal.dataElementStates)
				}));
	});
var $author$project$DataEngine$CacheState$Failure = function (a) {
	return {$: 'Failure', a: a};
};
var $author$project$DataEngine$CacheState$Success = function (a) {
	return {$: 'Success', a: a};
};
var $author$project$DataEngine$DataCache$stateFromResult = function (result) {
	if (result.$ === 'Err') {
		var err = result.a;
		return $author$project$DataEngine$CacheState$Failure(err);
	} else {
		var deCache = result.a;
		return $author$project$DataEngine$CacheState$Success(deCache);
	}
};
var $author$project$DataEngine$DataCache$insertListOfRecords = F3(
	function (ref, metadata, result) {
		return $author$project$DataEngine$DataCache$mapCache(
			A2(
				$author$project$UuidDict$insert,
				$author$project$DataElement$Reference$getUuid(ref),
				$author$project$DataEngine$DataCache$stateFromResult(
					A2(
						$elm$core$Result$map,
						$author$project$DataEngine$DataElementCache$ListCache(metadata),
						result))));
	});
var $author$project$DataEngine$DataElementCache$SingletonCache = F2(
	function (a, b) {
		return {$: 'SingletonCache', a: a, b: b};
	});
var $author$project$DataEngine$DataCache$insertSingleton = F3(
	function (ref, metadata, result) {
		return $author$project$DataEngine$DataCache$mapCache(
			A2(
				$author$project$UuidDict$insert,
				$author$project$DataElement$Reference$getUuid(ref),
				$author$project$DataEngine$DataCache$stateFromResult(
					A2(
						$elm$core$Result$map,
						$author$project$DataEngine$DataElementCache$SingletonCache(metadata),
						result))));
	});
var $elm$core$Debug$log = _Debug_log;
var $author$project$DataEngine$DataCache$mapTimeZone = F2(
	function (transform, _v0) {
		var internal = _v0.a;
		return $author$project$DataEngine$DataCache$DataCache(
			_Utils_update(
				internal,
				{
					timeZone: transform(internal.timeZone)
				}));
	});
var $author$project$DataElement$VeevaMessages$tokenToFieldName = function (_v0) {
	var name = _v0.name;
	var category = _v0.category;
	return $author$project$FieldName$fromString(name + (';;' + category));
};
var $author$project$DataElement$VeevaMessages$fieldNames = function (_v0) {
	var tokens = _v0.tokens;
	return A2($elm$core$List$map, $author$project$DataElement$VeevaMessages$tokenToFieldName, tokens);
};
var $author$project$DataElement$VeevaMessages$metadata = A2(
	$elm$core$Basics$composeR,
	$author$project$DataElement$VeevaMessages$fieldNames,
	A2(
		$elm$core$Basics$composeR,
		$elm$core$List$map(
			function (name) {
				return _Utils_Tuple2(name, $author$project$FieldType$StringType);
			}),
		$author$project$DataEngine$RecordMetadata$fromList));
var $author$project$DependencyGraph$DependencyGraph = function (a) {
	return {$: 'DependencyGraph', a: a};
};
var $author$project$DataElement$Expression$applyGlobalBool = F2(
	function (transformers, globalBool) {
		switch (globalBool.$) {
			case 'GlobalBoolLookup':
				var singletonRef = globalBool.a;
				var fieldName = globalBool.b;
				return A2(transformers.globalBoolLookup, singletonRef, fieldName);
			case 'GlobalBoolHardcoded':
				var bool = globalBool.a;
				return transformers.hardcodedBool(bool);
			case 'GlobalGTString':
				var stringA = globalBool.a;
				var stringB = globalBool.b;
				return A3(
					transformers.greaterThan,
					$author$project$ComparableType$StringComp,
					A2($author$project$DataElement$Expression$applyGlobalString, transformers, stringA),
					A2($author$project$DataElement$Expression$applyGlobalString, transformers, stringB));
			case 'GlobalGTNumber':
				var numberA = globalBool.a;
				var numberB = globalBool.b;
				return A3(
					transformers.greaterThan,
					$author$project$ComparableType$NumberComp,
					A2($author$project$DataElement$Expression$applyGlobalNumber, transformers, numberA),
					A2($author$project$DataElement$Expression$applyGlobalNumber, transformers, numberB));
			case 'GlobalGTDate':
				var dateA = globalBool.a;
				var dateB = globalBool.b;
				return A3(
					transformers.greaterThan,
					$author$project$ComparableType$DateComp,
					A2($author$project$DataElement$Expression$applyGlobalDate, transformers, dateA),
					A2($author$project$DataElement$Expression$applyGlobalDate, transformers, dateB));
			case 'GlobalGTDateTime':
				var dateTimeA = globalBool.a;
				var dateTimeB = globalBool.b;
				return A3(
					transformers.greaterThan,
					$author$project$ComparableType$DateTimeComp,
					A2($author$project$DataElement$Expression$applyGlobalDateTime, transformers, dateTimeA),
					A2($author$project$DataElement$Expression$applyGlobalDateTime, transformers, dateTimeB));
			case 'GlobalGTEString':
				var stringA = globalBool.a;
				var stringB = globalBool.b;
				return A3(
					transformers.greaterThanOrEqual,
					$author$project$ComparableType$StringComp,
					A2($author$project$DataElement$Expression$applyGlobalString, transformers, stringA),
					A2($author$project$DataElement$Expression$applyGlobalString, transformers, stringB));
			case 'GlobalGTENumber':
				var numberA = globalBool.a;
				var numberB = globalBool.b;
				return A3(
					transformers.greaterThanOrEqual,
					$author$project$ComparableType$NumberComp,
					A2($author$project$DataElement$Expression$applyGlobalNumber, transformers, numberA),
					A2($author$project$DataElement$Expression$applyGlobalNumber, transformers, numberB));
			case 'GlobalGTEDate':
				var dateA = globalBool.a;
				var dateB = globalBool.b;
				return A3(
					transformers.greaterThanOrEqual,
					$author$project$ComparableType$DateComp,
					A2($author$project$DataElement$Expression$applyGlobalDate, transformers, dateA),
					A2($author$project$DataElement$Expression$applyGlobalDate, transformers, dateB));
			case 'GlobalGTEDateTime':
				var dateTimeA = globalBool.a;
				var dateTimeB = globalBool.b;
				return A3(
					transformers.greaterThanOrEqual,
					$author$project$ComparableType$DateTimeComp,
					A2($author$project$DataElement$Expression$applyGlobalDateTime, transformers, dateTimeA),
					A2($author$project$DataElement$Expression$applyGlobalDateTime, transformers, dateTimeB));
			case 'GlobalLTString':
				var stringA = globalBool.a;
				var stringB = globalBool.b;
				return A3(
					transformers.lessThan,
					$author$project$ComparableType$StringComp,
					A2($author$project$DataElement$Expression$applyGlobalString, transformers, stringA),
					A2($author$project$DataElement$Expression$applyGlobalString, transformers, stringB));
			case 'GlobalLTNumber':
				var numberA = globalBool.a;
				var numberB = globalBool.b;
				return A3(
					transformers.lessThan,
					$author$project$ComparableType$NumberComp,
					A2($author$project$DataElement$Expression$applyGlobalNumber, transformers, numberA),
					A2($author$project$DataElement$Expression$applyGlobalNumber, transformers, numberB));
			case 'GlobalLTDate':
				var dateA = globalBool.a;
				var dateB = globalBool.b;
				return A3(
					transformers.lessThan,
					$author$project$ComparableType$DateComp,
					A2($author$project$DataElement$Expression$applyGlobalDate, transformers, dateA),
					A2($author$project$DataElement$Expression$applyGlobalDate, transformers, dateB));
			case 'GlobalLTDateTime':
				var dateTimeA = globalBool.a;
				var dateTimeB = globalBool.b;
				return A3(
					transformers.lessThan,
					$author$project$ComparableType$DateTimeComp,
					A2($author$project$DataElement$Expression$applyGlobalDateTime, transformers, dateTimeA),
					A2($author$project$DataElement$Expression$applyGlobalDateTime, transformers, dateTimeB));
			case 'GlobalLTEString':
				var stringA = globalBool.a;
				var stringB = globalBool.b;
				return A3(
					transformers.lessThanOrEqual,
					$author$project$ComparableType$StringComp,
					A2($author$project$DataElement$Expression$applyGlobalString, transformers, stringA),
					A2($author$project$DataElement$Expression$applyGlobalString, transformers, stringB));
			case 'GlobalLTENumber':
				var numberA = globalBool.a;
				var numberB = globalBool.b;
				return A3(
					transformers.lessThanOrEqual,
					$author$project$ComparableType$NumberComp,
					A2($author$project$DataElement$Expression$applyGlobalNumber, transformers, numberA),
					A2($author$project$DataElement$Expression$applyGlobalNumber, transformers, numberB));
			case 'GlobalLTEDate':
				var dateA = globalBool.a;
				var dateB = globalBool.b;
				return A3(
					transformers.lessThanOrEqual,
					$author$project$ComparableType$DateComp,
					A2($author$project$DataElement$Expression$applyGlobalDate, transformers, dateA),
					A2($author$project$DataElement$Expression$applyGlobalDate, transformers, dateB));
			case 'GlobalLTEDateTime':
				var dateTimeA = globalBool.a;
				var dateTimeB = globalBool.b;
				return A3(
					transformers.lessThanOrEqual,
					$author$project$ComparableType$DateTimeComp,
					A2($author$project$DataElement$Expression$applyGlobalDateTime, transformers, dateTimeA),
					A2($author$project$DataElement$Expression$applyGlobalDateTime, transformers, dateTimeB));
			case 'GlobalEqualString':
				var stringA = globalBool.a;
				var stringB = globalBool.b;
				return A3(
					transformers.comparableEqual,
					$author$project$ComparableType$StringComp,
					A2($author$project$DataElement$Expression$applyGlobalString, transformers, stringA),
					A2($author$project$DataElement$Expression$applyGlobalString, transformers, stringB));
			case 'GlobalEqualNumber':
				var numberA = globalBool.a;
				var numberB = globalBool.b;
				return A3(
					transformers.comparableEqual,
					$author$project$ComparableType$NumberComp,
					A2($author$project$DataElement$Expression$applyGlobalNumber, transformers, numberA),
					A2($author$project$DataElement$Expression$applyGlobalNumber, transformers, numberB));
			case 'GlobalEqualDate':
				var dateA = globalBool.a;
				var dateB = globalBool.b;
				return A3(
					transformers.comparableEqual,
					$author$project$ComparableType$DateComp,
					A2($author$project$DataElement$Expression$applyGlobalDate, transformers, dateA),
					A2($author$project$DataElement$Expression$applyGlobalDate, transformers, dateB));
			case 'GlobalEqualDateTime':
				var dateTimeA = globalBool.a;
				var dateTimeB = globalBool.b;
				return A3(
					transformers.comparableEqual,
					$author$project$ComparableType$DateTimeComp,
					A2($author$project$DataElement$Expression$applyGlobalDateTime, transformers, dateTimeA),
					A2($author$project$DataElement$Expression$applyGlobalDateTime, transformers, dateTimeB));
			case 'GlobalEqualBool':
				var boolA = globalBool.a;
				var boolB = globalBool.b;
				return A3(
					transformers.equal,
					$author$project$FieldType$BoolType,
					A2($author$project$DataElement$Expression$applyGlobalBool, transformers, boolA),
					A2($author$project$DataElement$Expression$applyGlobalBool, transformers, boolB));
			case 'GlobalNotEqualString':
				var stringA = globalBool.a;
				var stringB = globalBool.b;
				return A3(
					transformers.comparableNotEqual,
					$author$project$ComparableType$StringComp,
					A2($author$project$DataElement$Expression$applyGlobalString, transformers, stringA),
					A2($author$project$DataElement$Expression$applyGlobalString, transformers, stringB));
			case 'GlobalNotEqualNumber':
				var numberA = globalBool.a;
				var numberB = globalBool.b;
				return A3(
					transformers.comparableNotEqual,
					$author$project$ComparableType$NumberComp,
					A2($author$project$DataElement$Expression$applyGlobalNumber, transformers, numberA),
					A2($author$project$DataElement$Expression$applyGlobalNumber, transformers, numberB));
			case 'GlobalNotEqualDate':
				var dateA = globalBool.a;
				var dateB = globalBool.b;
				return A3(
					transformers.comparableNotEqual,
					$author$project$ComparableType$DateComp,
					A2($author$project$DataElement$Expression$applyGlobalDate, transformers, dateA),
					A2($author$project$DataElement$Expression$applyGlobalDate, transformers, dateB));
			case 'GlobalNotEqualDateTime':
				var dateTimeA = globalBool.a;
				var dateTimeB = globalBool.b;
				return A3(
					transformers.comparableNotEqual,
					$author$project$ComparableType$DateTimeComp,
					A2($author$project$DataElement$Expression$applyGlobalDateTime, transformers, dateTimeA),
					A2($author$project$DataElement$Expression$applyGlobalDateTime, transformers, dateTimeB));
			case 'GlobalNotEqualBool':
				var boolA = globalBool.a;
				var boolB = globalBool.b;
				return A3(
					transformers.notEqual,
					$author$project$FieldType$BoolType,
					A2($author$project$DataElement$Expression$applyGlobalBool, transformers, boolA),
					A2($author$project$DataElement$Expression$applyGlobalBool, transformers, boolB));
			case 'GlobalStringIn':
				var string = globalBool.a;
				var list = globalBool.b;
				return A2(
					transformers.stringIn,
					A2($author$project$DataElement$Expression$applyGlobalString, transformers, string),
					A2($author$project$DataElement$Expression$applyGlobalStringList, transformers, list));
			case 'GlobalStringNotIn':
				var string = globalBool.a;
				var list = globalBool.b;
				return A2(
					transformers.stringNotIn,
					A2($author$project$DataElement$Expression$applyGlobalString, transformers, string),
					A2($author$project$DataElement$Expression$applyGlobalStringList, transformers, list));
			case 'GlobalNot':
				var innerBool = globalBool.a;
				return transformers.not(
					A2($author$project$DataElement$Expression$applyGlobalBool, transformers, innerBool));
			case 'GlobalBoolIf':
				var cond = globalBool.a;
				var then_ = globalBool.b;
				var else_ = globalBool.c;
				return A4(
					transformers.if_,
					$author$project$FieldType$BoolType,
					A2($author$project$DataElement$Expression$applyGlobalBool, transformers, cond),
					A2($author$project$DataElement$Expression$applyGlobalBool, transformers, then_),
					A2($author$project$DataElement$Expression$applyGlobalBool, transformers, else_));
			case 'GlobalPickBool':
				var innerList = globalBool.a;
				return A2(
					transformers.pickOne,
					$author$project$FieldType$BoolType,
					A2($author$project$DataElement$Expression$applyGlobalBoolList, transformers, innerList));
			case 'GlobalAll':
				var innerList = globalBool.a;
				return transformers.all(
					A2($author$project$DataElement$Expression$applyGlobalBoolList, transformers, innerList));
			case 'GlobalAny':
				var innerList = globalBool.a;
				return transformers.any(
					A2($author$project$DataElement$Expression$applyGlobalBoolList, transformers, innerList));
			case 'GlobalIsNull':
				var field = globalBool.a;
				return transformers.isNull(
					A2($author$project$DataElement$Expression$applyGlobalField, transformers, field));
			default:
				var field = globalBool.a;
				return transformers.isNotNull(
					A2($author$project$DataElement$Expression$applyGlobalField, transformers, field));
		}
	});
var $author$project$DataElement$Expression$applyGlobalBoolList = F2(
	function (transformers, globalBoolList) {
		switch (globalBoolList.$) {
			case 'GlobalAllBoolsInField':
				var listRef = globalBoolList.a;
				var fieldName = globalBoolList.b;
				return A2(transformers.allBoolsInField, listRef, fieldName);
			case 'GlobalBoolsAsList':
				var globalBools = globalBoolList.a;
				return transformers.boolsAsList(
					A2(
						$elm$core$List$map,
						$author$project$DataElement$Expression$applyGlobalBool(transformers),
						globalBools));
			default:
				var cond = globalBoolList.a;
				var then_ = globalBoolList.b;
				var else_ = globalBoolList.c;
				return A4(
					transformers.if_,
					$author$project$FieldType$BoolType,
					A2($author$project$DataElement$Expression$applyGlobalBool, transformers, cond),
					A2($author$project$DataElement$Expression$applyGlobalBoolList, transformers, then_),
					A2($author$project$DataElement$Expression$applyGlobalBoolList, transformers, else_));
		}
	});
var $author$project$DataElement$Expression$applyGlobalComparableList = F2(
	function (transformers, globalCompList) {
		switch (globalCompList.$) {
			case 'GlobalCompStringListExpr':
				var globalStringList = globalCompList.a;
				return _Utils_Tuple2(
					$author$project$ComparableType$StringComp,
					A2($author$project$DataElement$Expression$applyGlobalStringList, transformers, globalStringList));
			case 'GlobalCompNumberListExpr':
				var globalNumberList = globalCompList.a;
				return _Utils_Tuple2(
					$author$project$ComparableType$NumberComp,
					A2($author$project$DataElement$Expression$applyGlobalNumberList, transformers, globalNumberList));
			case 'GlobalCompDateListExpr':
				var globalDateList = globalCompList.a;
				return _Utils_Tuple2(
					$author$project$ComparableType$DateComp,
					A2($author$project$DataElement$Expression$applyGlobalDateList, transformers, globalDateList));
			default:
				var globalDateTimeList = globalCompList.a;
				return _Utils_Tuple2(
					$author$project$ComparableType$DateTimeComp,
					A2($author$project$DataElement$Expression$applyGlobalDateTimeList, transformers, globalDateTimeList));
		}
	});
var $author$project$DataElement$Expression$applyGlobalDate = F2(
	function (transformers, globalDate) {
		switch (globalDate.$) {
			case 'GlobalDateLookup':
				var singletonRef = globalDate.a;
				var fieldName = globalDate.b;
				return A2(transformers.globalDateLookup, singletonRef, fieldName);
			case 'GlobalDateHardcoded':
				var date = globalDate.a;
				return transformers.hardcodedDate(date);
			case 'GlobalDateTimeToDate':
				var dateTime = globalDate.a;
				return transformers.dateTimeToDate(
					A2($author$project$DataElement$Expression$applyGlobalDateTime, transformers, dateTime));
			case 'GlobalDateCeiling':
				var dateInterval = globalDate.a;
				var innerDate = globalDate.b;
				return A2(
					transformers.dateCeiling,
					dateInterval,
					A2($author$project$DataElement$Expression$applyGlobalDate, transformers, innerDate));
			case 'GlobalDateFloor':
				var dateInterval = globalDate.a;
				var innerDate = globalDate.b;
				return A2(
					transformers.dateFloor,
					dateInterval,
					A2($author$project$DataElement$Expression$applyGlobalDate, transformers, innerDate));
			case 'GlobalDateAdd':
				var dateUnit = globalDate.a;
				var innerNum = globalDate.b;
				var innerDate = globalDate.c;
				return A3(
					transformers.dateAdd,
					dateUnit,
					A2($author$project$DataElement$Expression$applyGlobalNumber, transformers, innerNum),
					A2($author$project$DataElement$Expression$applyGlobalDate, transformers, innerDate));
			case 'GlobalDateSubtract':
				var dateUnit = globalDate.a;
				var innerNum = globalDate.b;
				var innerDate = globalDate.c;
				return A3(
					transformers.dateSubtract,
					dateUnit,
					A2($author$project$DataElement$Expression$applyGlobalNumber, transformers, innerNum),
					A2($author$project$DataElement$Expression$applyGlobalDate, transformers, innerDate));
			case 'GlobalDateIf':
				var cond = globalDate.a;
				var then_ = globalDate.b;
				var else_ = globalDate.c;
				return A4(
					transformers.if_,
					$author$project$FieldType$DateType,
					A2($author$project$DataElement$Expression$applyGlobalBool, transformers, cond),
					A2($author$project$DataElement$Expression$applyGlobalDate, transformers, then_),
					A2($author$project$DataElement$Expression$applyGlobalDate, transformers, else_));
			case 'GlobalPickDate':
				var innerList = globalDate.a;
				return A2(
					transformers.pickOne,
					$author$project$FieldType$DateType,
					A2($author$project$DataElement$Expression$applyGlobalDateList, transformers, innerList));
			case 'GlobalMaxDate':
				var list = globalDate.a;
				return A2(
					transformers.max,
					$author$project$ComparableType$DateComp,
					A2($author$project$DataElement$Expression$applyGlobalDateList, transformers, list));
			default:
				var list = globalDate.a;
				return A2(
					transformers.min,
					$author$project$ComparableType$DateComp,
					A2($author$project$DataElement$Expression$applyGlobalDateList, transformers, list));
		}
	});
var $author$project$DataElement$Expression$applyGlobalDateList = F2(
	function (transformers, globalDateList) {
		switch (globalDateList.$) {
			case 'GlobalAllDatesInField':
				var listRef = globalDateList.a;
				var fieldName = globalDateList.b;
				return A2(transformers.allDatesInField, listRef, fieldName);
			case 'GlobalDatesAsList':
				var globalDates = globalDateList.a;
				return transformers.datesAsList(
					A2(
						$elm$core$List$map,
						$author$project$DataElement$Expression$applyGlobalDate(transformers),
						globalDates));
			default:
				var cond = globalDateList.a;
				var then_ = globalDateList.b;
				var else_ = globalDateList.c;
				return A4(
					transformers.if_,
					$author$project$FieldType$DateType,
					A2($author$project$DataElement$Expression$applyGlobalBool, transformers, cond),
					A2($author$project$DataElement$Expression$applyGlobalDateList, transformers, then_),
					A2($author$project$DataElement$Expression$applyGlobalDateList, transformers, else_));
		}
	});
var $author$project$DataElement$Expression$applyGlobalDateTime = F2(
	function (transformers, globalDateTime) {
		switch (globalDateTime.$) {
			case 'GlobalDateTimeLookup':
				var singletonRef = globalDateTime.a;
				var fieldName = globalDateTime.b;
				return A2(transformers.globalDateTimeLookup, singletonRef, fieldName);
			case 'GlobalDateTimeHardcoded':
				var posix = globalDateTime.a;
				return transformers.hardcodedDateTime(posix);
			case 'GlobalDateTimeIf':
				var cond = globalDateTime.a;
				var then_ = globalDateTime.b;
				var else_ = globalDateTime.c;
				return A4(
					transformers.if_,
					$author$project$FieldType$DateTimeType,
					A2($author$project$DataElement$Expression$applyGlobalBool, transformers, cond),
					A2($author$project$DataElement$Expression$applyGlobalDateTime, transformers, then_),
					A2($author$project$DataElement$Expression$applyGlobalDateTime, transformers, else_));
			case 'GlobalPickDateTime':
				var innerList = globalDateTime.a;
				return A2(
					transformers.pickOne,
					$author$project$FieldType$DateTimeType,
					A2($author$project$DataElement$Expression$applyGlobalDateTimeList, transformers, innerList));
			case 'GlobalMaxDateTime':
				var list = globalDateTime.a;
				return A2(
					transformers.max,
					$author$project$ComparableType$DateTimeComp,
					A2($author$project$DataElement$Expression$applyGlobalDateTimeList, transformers, list));
			default:
				var list = globalDateTime.a;
				return A2(
					transformers.min,
					$author$project$ComparableType$DateTimeComp,
					A2($author$project$DataElement$Expression$applyGlobalDateTimeList, transformers, list));
		}
	});
var $author$project$DataElement$Expression$applyGlobalDateTimeList = F2(
	function (transformers, globalDateTimeList) {
		switch (globalDateTimeList.$) {
			case 'GlobalAllDateTimesInField':
				var listRef = globalDateTimeList.a;
				var fieldName = globalDateTimeList.b;
				return A2(transformers.allDateTimesInField, listRef, fieldName);
			case 'GlobalDateTimesAsList':
				var globalDateTimes = globalDateTimeList.a;
				return transformers.dateTimesAsList(
					A2(
						$elm$core$List$map,
						$author$project$DataElement$Expression$applyGlobalDateTime(transformers),
						globalDateTimes));
			default:
				var cond = globalDateTimeList.a;
				var then_ = globalDateTimeList.b;
				var else_ = globalDateTimeList.c;
				return A4(
					transformers.if_,
					$author$project$FieldType$DateTimeType,
					A2($author$project$DataElement$Expression$applyGlobalBool, transformers, cond),
					A2($author$project$DataElement$Expression$applyGlobalDateTimeList, transformers, then_),
					A2($author$project$DataElement$Expression$applyGlobalDateTimeList, transformers, else_));
		}
	});
var $author$project$DataElement$Expression$applyGlobalField = F2(
	function (transformers, globalField) {
		switch (globalField.$) {
			case 'GlobalStringExpr':
				var globalString = globalField.a;
				return A2($author$project$DataElement$Expression$applyGlobalString, transformers, globalString);
			case 'GlobalNumberExpr':
				var globalNumber = globalField.a;
				return A2($author$project$DataElement$Expression$applyGlobalNumber, transformers, globalNumber);
			case 'GlobalDateExpr':
				var globalDate = globalField.a;
				return A2($author$project$DataElement$Expression$applyGlobalDate, transformers, globalDate);
			case 'GlobalDateTimeExpr':
				var globalDateTime = globalField.a;
				return A2($author$project$DataElement$Expression$applyGlobalDateTime, transformers, globalDateTime);
			default:
				var globalBool = globalField.a;
				return A2($author$project$DataElement$Expression$applyGlobalBool, transformers, globalBool);
		}
	});
var $author$project$DataElement$Expression$applyGlobalNumber = F2(
	function (transformers, globalNumber) {
		switch (globalNumber.$) {
			case 'GlobalNumberLookup':
				var singletonRef = globalNumber.a;
				var fieldName = globalNumber.b;
				return A2(transformers.globalNumberLookup, singletonRef, fieldName);
			case 'GlobalNumberHardcoded':
				var number = globalNumber.a;
				return transformers.hardcodedNumber(number);
			case 'GlobalCountUnique':
				var globalCompList = globalNumber.a;
				return function (_v4) {
					var compType = _v4.a;
					var item = _v4.b;
					return A2(transformers.countUnique, compType, item);
				}(
					A2($author$project$DataElement$Expression$applyGlobalComparableList, transformers, globalCompList));
			case 'GlobalRound':
				var innerNumber = globalNumber.a;
				return transformers.round(
					A2($author$project$DataElement$Expression$applyGlobalNumber, transformers, innerNumber));
			case 'GlobalSum':
				var globalNumberList = globalNumber.a;
				return transformers.sum(
					A2($author$project$DataElement$Expression$applyGlobalNumberList, transformers, globalNumberList));
			case 'GlobalProduct':
				var globalNumberList = globalNumber.a;
				return transformers.product(
					A2($author$project$DataElement$Expression$applyGlobalNumberList, transformers, globalNumberList));
			case 'GlobalAdd':
				var globalNumA = globalNumber.a;
				var globalNumB = globalNumber.b;
				return A2(
					transformers.add,
					A2($author$project$DataElement$Expression$applyGlobalNumber, transformers, globalNumA),
					A2($author$project$DataElement$Expression$applyGlobalNumber, transformers, globalNumB));
			case 'GlobalSubtract':
				var globalNumA = globalNumber.a;
				var globalNumB = globalNumber.b;
				return A2(
					transformers.subtract,
					A2($author$project$DataElement$Expression$applyGlobalNumber, transformers, globalNumA),
					A2($author$project$DataElement$Expression$applyGlobalNumber, transformers, globalNumB));
			case 'GlobalMultiply':
				var globalNumA = globalNumber.a;
				var globalNumB = globalNumber.b;
				return A2(
					transformers.multiply,
					A2($author$project$DataElement$Expression$applyGlobalNumber, transformers, globalNumA),
					A2($author$project$DataElement$Expression$applyGlobalNumber, transformers, globalNumB));
			case 'GlobalDivide':
				var globalNumA = globalNumber.a;
				var globalNumB = globalNumber.b;
				return A2(
					transformers.divide,
					A2($author$project$DataElement$Expression$applyGlobalNumber, transformers, globalNumA),
					A2($author$project$DataElement$Expression$applyGlobalNumber, transformers, globalNumB));
			case 'GlobalMonthNumber':
				var innerDate = globalNumber.a;
				return transformers.monthNumber(
					A2($author$project$DataElement$Expression$applyGlobalDate, transformers, innerDate));
			case 'GlobalYearNumber':
				var innerDate = globalNumber.a;
				return transformers.yearNumber(
					A2($author$project$DataElement$Expression$applyGlobalDate, transformers, innerDate));
			case 'GlobalDayInMonth':
				var innerDate = globalNumber.a;
				return transformers.dayInMonth(
					A2($author$project$DataElement$Expression$applyGlobalDate, transformers, innerDate));
			case 'GlobalNumberIf':
				var cond = globalNumber.a;
				var then_ = globalNumber.b;
				var else_ = globalNumber.c;
				return A4(
					transformers.if_,
					$author$project$FieldType$NumberType,
					A2($author$project$DataElement$Expression$applyGlobalBool, transformers, cond),
					A2($author$project$DataElement$Expression$applyGlobalNumber, transformers, then_),
					A2($author$project$DataElement$Expression$applyGlobalNumber, transformers, else_));
			case 'GlobalPickNumber':
				var innerList = globalNumber.a;
				return A2(
					transformers.pickOne,
					$author$project$FieldType$NumberType,
					A2($author$project$DataElement$Expression$applyGlobalNumberList, transformers, innerList));
			case 'GlobalMaxNumber':
				var list = globalNumber.a;
				return A2(
					transformers.max,
					$author$project$ComparableType$NumberComp,
					A2($author$project$DataElement$Expression$applyGlobalNumberList, transformers, list));
			default:
				var list = globalNumber.a;
				return A2(
					transformers.min,
					$author$project$ComparableType$NumberComp,
					A2($author$project$DataElement$Expression$applyGlobalNumberList, transformers, list));
		}
	});
var $author$project$DataElement$Expression$applyGlobalNumberList = F2(
	function (transformers, globalNumberList) {
		switch (globalNumberList.$) {
			case 'GlobalAllNumbersInField':
				var listRef = globalNumberList.a;
				var fieldName = globalNumberList.b;
				return A2(transformers.allNumbersInField, listRef, fieldName);
			case 'GlobalNumbersAsList':
				var globalNumbers = globalNumberList.a;
				return transformers.numbersAsList(
					A2(
						$elm$core$List$map,
						$author$project$DataElement$Expression$applyGlobalNumber(transformers),
						globalNumbers));
			default:
				var cond = globalNumberList.a;
				var then_ = globalNumberList.b;
				var else_ = globalNumberList.c;
				return A4(
					transformers.if_,
					$author$project$FieldType$NumberType,
					A2($author$project$DataElement$Expression$applyGlobalBool, transformers, cond),
					A2($author$project$DataElement$Expression$applyGlobalNumberList, transformers, then_),
					A2($author$project$DataElement$Expression$applyGlobalNumberList, transformers, else_));
		}
	});
var $author$project$DataElement$Expression$applyGlobalString = F2(
	function (transformers, globalString) {
		switch (globalString.$) {
			case 'GlobalStringHardcoded':
				var words = globalString.a;
				return transformers.hardcodedString(words);
			case 'GlobalStringLookup':
				var singletonRef = globalString.a;
				var fieldName = globalString.b;
				return A2(transformers.globalStringLookup, singletonRef, fieldName);
			case 'GlobalFormatDate':
				var innerString = globalString.a;
				var innerDate = globalString.b;
				return A2(
					transformers.formatDate,
					A2($author$project$DataElement$Expression$applyGlobalString, transformers, innerString),
					A2($author$project$DataElement$Expression$applyGlobalDate, transformers, innerDate));
			case 'GlobalFormatDateLocaleAware':
				var innerDate = globalString.a;
				return transformers.formatDateLocaleAware(
					A2($author$project$DataElement$Expression$applyGlobalDate, transformers, innerDate));
			case 'GlobalFormatDateTime':
				var innerDateTime = globalString.a;
				return transformers.formatDateTime(
					A2($author$project$DataElement$Expression$applyGlobalDateTime, transformers, innerDateTime));
			case 'GlobalFormatNumber':
				var decimals = globalString.a;
				var innerNumber = globalString.b;
				return A2(
					transformers.formatNumber,
					decimals,
					A2($author$project$DataElement$Expression$applyGlobalNumber, transformers, innerNumber));
			case 'GlobalStringIf':
				var cond = globalString.a;
				var then_ = globalString.b;
				var else_ = globalString.c;
				return A4(
					transformers.if_,
					$author$project$FieldType$StringType,
					A2($author$project$DataElement$Expression$applyGlobalBool, transformers, cond),
					A2($author$project$DataElement$Expression$applyGlobalString, transformers, then_),
					A2($author$project$DataElement$Expression$applyGlobalString, transformers, else_));
			case 'GlobalPickString':
				var innerList = globalString.a;
				return A2(
					transformers.pickOne,
					$author$project$FieldType$StringType,
					A2($author$project$DataElement$Expression$applyGlobalStringList, transformers, innerList));
			case 'GlobalConcat':
				var join = globalString.a;
				var list = globalString.b;
				return A2(
					transformers.concat,
					A2($author$project$DataElement$Expression$applyGlobalString, transformers, join),
					A2($author$project$DataElement$Expression$applyGlobalStringList, transformers, list));
			case 'GlobalMaxString':
				var list = globalString.a;
				return A2(
					transformers.max,
					$author$project$ComparableType$StringComp,
					A2($author$project$DataElement$Expression$applyGlobalStringList, transformers, list));
			default:
				var list = globalString.a;
				return A2(
					transformers.min,
					$author$project$ComparableType$StringComp,
					A2($author$project$DataElement$Expression$applyGlobalStringList, transformers, list));
		}
	});
var $author$project$DataElement$Expression$applyGlobalStringList = F2(
	function (transformers, globalStringList) {
		switch (globalStringList.$) {
			case 'GlobalAllStringsInField':
				var listRef = globalStringList.a;
				var fieldName = globalStringList.b;
				return A2(transformers.allStringsInField, listRef, fieldName);
			case 'GlobalStringsAsList':
				var globalStrings = globalStringList.a;
				return transformers.stringsAsList(
					A2(
						$elm$core$List$map,
						$author$project$DataElement$Expression$applyGlobalString(transformers),
						globalStrings));
			case 'GlobalStringListIf':
				var cond = globalStringList.a;
				var then_ = globalStringList.b;
				var else_ = globalStringList.c;
				return A4(
					transformers.if_,
					$author$project$FieldType$StringType,
					A2($author$project$DataElement$Expression$applyGlobalBool, transformers, cond),
					A2($author$project$DataElement$Expression$applyGlobalStringList, transformers, then_),
					A2($author$project$DataElement$Expression$applyGlobalStringList, transformers, else_));
			case 'GlobalChallengeReasons':
				var acctId = globalStringList.a;
				return transformers.challengeReasons(
					A2($author$project$DataElement$Expression$applyGlobalString, transformers, acctId));
			default:
				var acctId = globalStringList.a;
				return transformers.targetChallengeReasons(
					A2($author$project$DataElement$Expression$applyGlobalString, transformers, acctId));
		}
	});
var $author$project$DataElement$Expression$applyLocalBool = F2(
	function (transformers, localBool) {
		switch (localBool.$) {
			case 'LocalBool':
				var fieldName = localBool.a;
				return transformers.localBool(fieldName);
			case 'LocalSingletonBool':
				var singletonRef = localBool.a;
				var fieldName = localBool.b;
				return A2(transformers.globalBoolLookup, singletonRef, fieldName);
			case 'LocalBoolHardcoded':
				var bool = localBool.a;
				return transformers.hardcodedBool(bool);
			case 'LocalGTString':
				var stringA = localBool.a;
				var stringB = localBool.b;
				return A3(
					transformers.greaterThan,
					$author$project$ComparableType$StringComp,
					A2($author$project$DataElement$Expression$applyLocalString, transformers, stringA),
					A2($author$project$DataElement$Expression$applyLocalString, transformers, stringB));
			case 'LocalGTNumber':
				var numberA = localBool.a;
				var numberB = localBool.b;
				return A3(
					transformers.greaterThan,
					$author$project$ComparableType$NumberComp,
					A2($author$project$DataElement$Expression$applyLocalNumber, transformers, numberA),
					A2($author$project$DataElement$Expression$applyLocalNumber, transformers, numberB));
			case 'LocalGTDate':
				var dateA = localBool.a;
				var dateB = localBool.b;
				return A3(
					transformers.greaterThan,
					$author$project$ComparableType$DateComp,
					A2($author$project$DataElement$Expression$applyLocalDate, transformers, dateA),
					A2($author$project$DataElement$Expression$applyLocalDate, transformers, dateB));
			case 'LocalGTDateTime':
				var dateTimeA = localBool.a;
				var dateTimeB = localBool.b;
				return A3(
					transformers.greaterThan,
					$author$project$ComparableType$DateTimeComp,
					A2($author$project$DataElement$Expression$applyLocalDateTime, transformers, dateTimeA),
					A2($author$project$DataElement$Expression$applyLocalDateTime, transformers, dateTimeB));
			case 'LocalGTEString':
				var stringA = localBool.a;
				var stringB = localBool.b;
				return A3(
					transformers.greaterThanOrEqual,
					$author$project$ComparableType$StringComp,
					A2($author$project$DataElement$Expression$applyLocalString, transformers, stringA),
					A2($author$project$DataElement$Expression$applyLocalString, transformers, stringB));
			case 'LocalGTENumber':
				var numberA = localBool.a;
				var numberB = localBool.b;
				return A3(
					transformers.greaterThanOrEqual,
					$author$project$ComparableType$NumberComp,
					A2($author$project$DataElement$Expression$applyLocalNumber, transformers, numberA),
					A2($author$project$DataElement$Expression$applyLocalNumber, transformers, numberB));
			case 'LocalGTEDate':
				var dateA = localBool.a;
				var dateB = localBool.b;
				return A3(
					transformers.greaterThanOrEqual,
					$author$project$ComparableType$DateComp,
					A2($author$project$DataElement$Expression$applyLocalDate, transformers, dateA),
					A2($author$project$DataElement$Expression$applyLocalDate, transformers, dateB));
			case 'LocalGTEDateTime':
				var dateTimeA = localBool.a;
				var dateTimeB = localBool.b;
				return A3(
					transformers.greaterThanOrEqual,
					$author$project$ComparableType$DateTimeComp,
					A2($author$project$DataElement$Expression$applyLocalDateTime, transformers, dateTimeA),
					A2($author$project$DataElement$Expression$applyLocalDateTime, transformers, dateTimeB));
			case 'LocalLTString':
				var stringA = localBool.a;
				var stringB = localBool.b;
				return A3(
					transformers.lessThan,
					$author$project$ComparableType$StringComp,
					A2($author$project$DataElement$Expression$applyLocalString, transformers, stringA),
					A2($author$project$DataElement$Expression$applyLocalString, transformers, stringB));
			case 'LocalLTNumber':
				var numberA = localBool.a;
				var numberB = localBool.b;
				return A3(
					transformers.lessThan,
					$author$project$ComparableType$NumberComp,
					A2($author$project$DataElement$Expression$applyLocalNumber, transformers, numberA),
					A2($author$project$DataElement$Expression$applyLocalNumber, transformers, numberB));
			case 'LocalLTDate':
				var dateA = localBool.a;
				var dateB = localBool.b;
				return A3(
					transformers.lessThan,
					$author$project$ComparableType$DateComp,
					A2($author$project$DataElement$Expression$applyLocalDate, transformers, dateA),
					A2($author$project$DataElement$Expression$applyLocalDate, transformers, dateB));
			case 'LocalLTDateTime':
				var dateTimeA = localBool.a;
				var dateTimeB = localBool.b;
				return A3(
					transformers.lessThan,
					$author$project$ComparableType$DateTimeComp,
					A2($author$project$DataElement$Expression$applyLocalDateTime, transformers, dateTimeA),
					A2($author$project$DataElement$Expression$applyLocalDateTime, transformers, dateTimeB));
			case 'LocalLTEString':
				var stringA = localBool.a;
				var stringB = localBool.b;
				return A3(
					transformers.lessThanOrEqual,
					$author$project$ComparableType$StringComp,
					A2($author$project$DataElement$Expression$applyLocalString, transformers, stringA),
					A2($author$project$DataElement$Expression$applyLocalString, transformers, stringB));
			case 'LocalLTENumber':
				var numberA = localBool.a;
				var numberB = localBool.b;
				return A3(
					transformers.lessThanOrEqual,
					$author$project$ComparableType$NumberComp,
					A2($author$project$DataElement$Expression$applyLocalNumber, transformers, numberA),
					A2($author$project$DataElement$Expression$applyLocalNumber, transformers, numberB));
			case 'LocalLTEDate':
				var dateA = localBool.a;
				var dateB = localBool.b;
				return A3(
					transformers.lessThanOrEqual,
					$author$project$ComparableType$DateComp,
					A2($author$project$DataElement$Expression$applyLocalDate, transformers, dateA),
					A2($author$project$DataElement$Expression$applyLocalDate, transformers, dateB));
			case 'LocalLTEDateTime':
				var dateTimeA = localBool.a;
				var dateTimeB = localBool.b;
				return A3(
					transformers.lessThanOrEqual,
					$author$project$ComparableType$DateTimeComp,
					A2($author$project$DataElement$Expression$applyLocalDateTime, transformers, dateTimeA),
					A2($author$project$DataElement$Expression$applyLocalDateTime, transformers, dateTimeB));
			case 'LocalEqualString':
				var stringA = localBool.a;
				var stringB = localBool.b;
				return A3(
					transformers.comparableEqual,
					$author$project$ComparableType$StringComp,
					A2($author$project$DataElement$Expression$applyLocalString, transformers, stringA),
					A2($author$project$DataElement$Expression$applyLocalString, transformers, stringB));
			case 'LocalEqualNumber':
				var numberA = localBool.a;
				var numberB = localBool.b;
				return A3(
					transformers.comparableEqual,
					$author$project$ComparableType$NumberComp,
					A2($author$project$DataElement$Expression$applyLocalNumber, transformers, numberA),
					A2($author$project$DataElement$Expression$applyLocalNumber, transformers, numberB));
			case 'LocalEqualDate':
				var dateA = localBool.a;
				var dateB = localBool.b;
				return A3(
					transformers.comparableEqual,
					$author$project$ComparableType$DateComp,
					A2($author$project$DataElement$Expression$applyLocalDate, transformers, dateA),
					A2($author$project$DataElement$Expression$applyLocalDate, transformers, dateB));
			case 'LocalEqualDateTime':
				var dateTimeA = localBool.a;
				var dateTimeB = localBool.b;
				return A3(
					transformers.comparableEqual,
					$author$project$ComparableType$DateTimeComp,
					A2($author$project$DataElement$Expression$applyLocalDateTime, transformers, dateTimeA),
					A2($author$project$DataElement$Expression$applyLocalDateTime, transformers, dateTimeB));
			case 'LocalEqualBool':
				var boolA = localBool.a;
				var boolB = localBool.b;
				return A3(
					transformers.equal,
					$author$project$FieldType$BoolType,
					A2($author$project$DataElement$Expression$applyLocalBool, transformers, boolA),
					A2($author$project$DataElement$Expression$applyLocalBool, transformers, boolB));
			case 'LocalNotEqualString':
				var stringA = localBool.a;
				var stringB = localBool.b;
				return A3(
					transformers.comparableNotEqual,
					$author$project$ComparableType$StringComp,
					A2($author$project$DataElement$Expression$applyLocalString, transformers, stringA),
					A2($author$project$DataElement$Expression$applyLocalString, transformers, stringB));
			case 'LocalNotEqualNumber':
				var numberA = localBool.a;
				var numberB = localBool.b;
				return A3(
					transformers.comparableNotEqual,
					$author$project$ComparableType$NumberComp,
					A2($author$project$DataElement$Expression$applyLocalNumber, transformers, numberA),
					A2($author$project$DataElement$Expression$applyLocalNumber, transformers, numberB));
			case 'LocalNotEqualDate':
				var dateA = localBool.a;
				var dateB = localBool.b;
				return A3(
					transformers.comparableNotEqual,
					$author$project$ComparableType$DateComp,
					A2($author$project$DataElement$Expression$applyLocalDate, transformers, dateA),
					A2($author$project$DataElement$Expression$applyLocalDate, transformers, dateB));
			case 'LocalNotEqualDateTime':
				var dateTimeA = localBool.a;
				var dateTimeB = localBool.b;
				return A3(
					transformers.comparableNotEqual,
					$author$project$ComparableType$DateTimeComp,
					A2($author$project$DataElement$Expression$applyLocalDateTime, transformers, dateTimeA),
					A2($author$project$DataElement$Expression$applyLocalDateTime, transformers, dateTimeB));
			case 'LocalNotEqualBool':
				var boolA = localBool.a;
				var boolB = localBool.b;
				return A3(
					transformers.notEqual,
					$author$project$FieldType$BoolType,
					A2($author$project$DataElement$Expression$applyLocalBool, transformers, boolA),
					A2($author$project$DataElement$Expression$applyLocalBool, transformers, boolB));
			case 'LocalStringIn':
				var string = localBool.a;
				var list = localBool.b;
				return A2(
					transformers.stringIn,
					A2($author$project$DataElement$Expression$applyLocalString, transformers, string),
					A2($author$project$DataElement$Expression$applyLocalStringList, transformers, list));
			case 'LocalStringNotIn':
				var string = localBool.a;
				var list = localBool.b;
				return A2(
					transformers.stringNotIn,
					A2($author$project$DataElement$Expression$applyLocalString, transformers, string),
					A2($author$project$DataElement$Expression$applyLocalStringList, transformers, list));
			case 'LocalNot':
				var innerBool = localBool.a;
				return transformers.not(
					A2($author$project$DataElement$Expression$applyLocalBool, transformers, innerBool));
			case 'LocalBoolIf':
				var cond = localBool.a;
				var then_ = localBool.b;
				var else_ = localBool.c;
				return A4(
					transformers.if_,
					$author$project$FieldType$BoolType,
					A2($author$project$DataElement$Expression$applyLocalBool, transformers, cond),
					A2($author$project$DataElement$Expression$applyLocalBool, transformers, then_),
					A2($author$project$DataElement$Expression$applyLocalBool, transformers, else_));
			case 'LocalPickBool':
				var innerList = localBool.a;
				return A2(
					transformers.pickOne,
					$author$project$FieldType$BoolType,
					A2($author$project$DataElement$Expression$applyLocalBoolList, transformers, innerList));
			case 'LocalAll':
				var innerList = localBool.a;
				return transformers.all(
					A2($author$project$DataElement$Expression$applyLocalBoolList, transformers, innerList));
			case 'LocalAny':
				var innerList = localBool.a;
				return transformers.any(
					A2($author$project$DataElement$Expression$applyLocalBoolList, transformers, innerList));
			case 'LocalIsNull':
				var field = localBool.a;
				return transformers.isNull(
					A2($author$project$DataElement$Expression$applyLocalField, transformers, field));
			default:
				var field = localBool.a;
				return transformers.isNotNull(
					A2($author$project$DataElement$Expression$applyLocalField, transformers, field));
		}
	});
var $author$project$DataElement$Expression$applyLocalBoolList = F2(
	function (transformers, localBoolList) {
		switch (localBoolList.$) {
			case 'RelatedBool':
				var relationship = localBoolList.a;
				var fieldName = localBoolList.b;
				return A2(transformers.relatedBool, relationship, fieldName);
			case 'LocalAllBoolsInField':
				var listRef = localBoolList.a;
				var fieldName = localBoolList.b;
				return A2(transformers.allBoolsInField, listRef, fieldName);
			case 'LocalBoolsAsList':
				var localBools = localBoolList.a;
				return transformers.boolsAsList(
					A2(
						$elm$core$List$map,
						$author$project$DataElement$Expression$applyLocalBool(transformers),
						localBools));
			default:
				var cond = localBoolList.a;
				var then_ = localBoolList.b;
				var else_ = localBoolList.c;
				return A4(
					transformers.if_,
					$author$project$FieldType$BoolType,
					A2($author$project$DataElement$Expression$applyLocalBool, transformers, cond),
					A2($author$project$DataElement$Expression$applyLocalBoolList, transformers, then_),
					A2($author$project$DataElement$Expression$applyLocalBoolList, transformers, else_));
		}
	});
var $author$project$DataElement$Expression$applyLocalComparableList = F2(
	function (transformers, localCompList) {
		switch (localCompList.$) {
			case 'LocalCompStringListExpr':
				var localStringList = localCompList.a;
				return _Utils_Tuple2(
					$author$project$ComparableType$StringComp,
					A2($author$project$DataElement$Expression$applyLocalStringList, transformers, localStringList));
			case 'LocalCompNumberListExpr':
				var localNumberList = localCompList.a;
				return _Utils_Tuple2(
					$author$project$ComparableType$NumberComp,
					A2($author$project$DataElement$Expression$applyLocalNumberList, transformers, localNumberList));
			case 'LocalCompDateListExpr':
				var localDateList = localCompList.a;
				return _Utils_Tuple2(
					$author$project$ComparableType$DateComp,
					A2($author$project$DataElement$Expression$applyLocalDateList, transformers, localDateList));
			default:
				var localDateTimeList = localCompList.a;
				return _Utils_Tuple2(
					$author$project$ComparableType$DateTimeComp,
					A2($author$project$DataElement$Expression$applyLocalDateTimeList, transformers, localDateTimeList));
		}
	});
var $author$project$DataElement$Expression$applyLocalDate = F2(
	function (transformers, localDate) {
		switch (localDate.$) {
			case 'LocalDate':
				var fieldName = localDate.a;
				return transformers.localDate(fieldName);
			case 'LocalSingletonDate':
				var singletonRef = localDate.a;
				var fieldName = localDate.b;
				return A2(transformers.globalDateLookup, singletonRef, fieldName);
			case 'LocalDateHardcoded':
				var date = localDate.a;
				return transformers.hardcodedDate(date);
			case 'LocalDateTimeToDate':
				var dateTime = localDate.a;
				return transformers.dateTimeToDate(
					A2($author$project$DataElement$Expression$applyLocalDateTime, transformers, dateTime));
			case 'LocalDateCeiling':
				var dateInterval = localDate.a;
				var innerDate = localDate.b;
				return A2(
					transformers.dateCeiling,
					dateInterval,
					A2($author$project$DataElement$Expression$applyLocalDate, transformers, innerDate));
			case 'LocalDateFloor':
				var dateInterval = localDate.a;
				var innerDate = localDate.b;
				return A2(
					transformers.dateFloor,
					dateInterval,
					A2($author$project$DataElement$Expression$applyLocalDate, transformers, innerDate));
			case 'LocalDateAdd':
				var dateUnit = localDate.a;
				var innerNum = localDate.b;
				var innerDate = localDate.c;
				return A3(
					transformers.dateAdd,
					dateUnit,
					A2($author$project$DataElement$Expression$applyLocalNumber, transformers, innerNum),
					A2($author$project$DataElement$Expression$applyLocalDate, transformers, innerDate));
			case 'LocalDateSubtract':
				var dateUnit = localDate.a;
				var innerNum = localDate.b;
				var innerDate = localDate.c;
				return A3(
					transformers.dateSubtract,
					dateUnit,
					A2($author$project$DataElement$Expression$applyLocalNumber, transformers, innerNum),
					A2($author$project$DataElement$Expression$applyLocalDate, transformers, innerDate));
			case 'LocalDateIf':
				var cond = localDate.a;
				var then_ = localDate.b;
				var else_ = localDate.c;
				return A4(
					transformers.if_,
					$author$project$FieldType$DateType,
					A2($author$project$DataElement$Expression$applyLocalBool, transformers, cond),
					A2($author$project$DataElement$Expression$applyLocalDate, transformers, then_),
					A2($author$project$DataElement$Expression$applyLocalDate, transformers, else_));
			case 'LocalPickDate':
				var innerList = localDate.a;
				return A2(
					transformers.pickOne,
					$author$project$FieldType$DateType,
					A2($author$project$DataElement$Expression$applyLocalDateList, transformers, innerList));
			case 'LocalMaxDate':
				var list = localDate.a;
				return A2(
					transformers.max,
					$author$project$ComparableType$DateComp,
					A2($author$project$DataElement$Expression$applyLocalDateList, transformers, list));
			default:
				var list = localDate.a;
				return A2(
					transformers.min,
					$author$project$ComparableType$DateComp,
					A2($author$project$DataElement$Expression$applyLocalDateList, transformers, list));
		}
	});
var $author$project$DataElement$Expression$applyLocalDateList = F2(
	function (transformers, localDateList) {
		switch (localDateList.$) {
			case 'RelatedDate':
				var relationship = localDateList.a;
				var fieldName = localDateList.b;
				return A2(transformers.relatedDate, relationship, fieldName);
			case 'LocalAllDatesInField':
				var listRef = localDateList.a;
				var fieldName = localDateList.b;
				return A2(transformers.allDatesInField, listRef, fieldName);
			case 'LocalDatesAsList':
				var localDates = localDateList.a;
				return transformers.datesAsList(
					A2(
						$elm$core$List$map,
						$author$project$DataElement$Expression$applyLocalDate(transformers),
						localDates));
			default:
				var cond = localDateList.a;
				var then_ = localDateList.b;
				var else_ = localDateList.c;
				return A4(
					transformers.if_,
					$author$project$FieldType$DateType,
					A2($author$project$DataElement$Expression$applyLocalBool, transformers, cond),
					A2($author$project$DataElement$Expression$applyLocalDateList, transformers, then_),
					A2($author$project$DataElement$Expression$applyLocalDateList, transformers, else_));
		}
	});
var $author$project$DataElement$Expression$applyLocalDateTime = F2(
	function (transformers, localDateTime) {
		switch (localDateTime.$) {
			case 'LocalDateTime':
				var fieldName = localDateTime.a;
				return transformers.localDateTime(fieldName);
			case 'LocalSingletonDateTime':
				var singletonRef = localDateTime.a;
				var fieldName = localDateTime.b;
				return A2(transformers.globalDateTimeLookup, singletonRef, fieldName);
			case 'LocalDateTimeHardcoded':
				var posix = localDateTime.a;
				return transformers.hardcodedDateTime(posix);
			case 'LocalDateTimeIf':
				var cond = localDateTime.a;
				var then_ = localDateTime.b;
				var else_ = localDateTime.c;
				return A4(
					transformers.if_,
					$author$project$FieldType$DateTimeType,
					A2($author$project$DataElement$Expression$applyLocalBool, transformers, cond),
					A2($author$project$DataElement$Expression$applyLocalDateTime, transformers, then_),
					A2($author$project$DataElement$Expression$applyLocalDateTime, transformers, else_));
			case 'LocalPickDateTime':
				var innerList = localDateTime.a;
				return A2(
					transformers.pickOne,
					$author$project$FieldType$DateTimeType,
					A2($author$project$DataElement$Expression$applyLocalDateTimeList, transformers, innerList));
			case 'LocalMaxDateTime':
				var list = localDateTime.a;
				return A2(
					transformers.max,
					$author$project$ComparableType$DateTimeComp,
					A2($author$project$DataElement$Expression$applyLocalDateTimeList, transformers, list));
			default:
				var list = localDateTime.a;
				return A2(
					transformers.min,
					$author$project$ComparableType$DateTimeComp,
					A2($author$project$DataElement$Expression$applyLocalDateTimeList, transformers, list));
		}
	});
var $author$project$DataElement$Expression$applyLocalDateTimeList = F2(
	function (transformers, localDateTimeList) {
		switch (localDateTimeList.$) {
			case 'RelatedDateTime':
				var relationship = localDateTimeList.a;
				var fieldName = localDateTimeList.b;
				return A2(transformers.relatedDateTime, relationship, fieldName);
			case 'LocalAllDateTimesInField':
				var listRef = localDateTimeList.a;
				var fieldName = localDateTimeList.b;
				return A2(transformers.allDateTimesInField, listRef, fieldName);
			case 'LocalDateTimesAsList':
				var localDateTimes = localDateTimeList.a;
				return transformers.dateTimesAsList(
					A2(
						$elm$core$List$map,
						$author$project$DataElement$Expression$applyLocalDateTime(transformers),
						localDateTimes));
			default:
				var cond = localDateTimeList.a;
				var then_ = localDateTimeList.b;
				var else_ = localDateTimeList.c;
				return A4(
					transformers.if_,
					$author$project$FieldType$DateTimeType,
					A2($author$project$DataElement$Expression$applyLocalBool, transformers, cond),
					A2($author$project$DataElement$Expression$applyLocalDateTimeList, transformers, then_),
					A2($author$project$DataElement$Expression$applyLocalDateTimeList, transformers, else_));
		}
	});
var $author$project$DataElement$Expression$applyLocalField = F2(
	function (transformers, localField) {
		switch (localField.$) {
			case 'LocalStringExpr':
				var localString = localField.a;
				return A2($author$project$DataElement$Expression$applyLocalString, transformers, localString);
			case 'LocalNumberExpr':
				var localNumber = localField.a;
				return A2($author$project$DataElement$Expression$applyLocalNumber, transformers, localNumber);
			case 'LocalDateExpr':
				var localDate = localField.a;
				return A2($author$project$DataElement$Expression$applyLocalDate, transformers, localDate);
			case 'LocalDateTimeExpr':
				var localDateTime = localField.a;
				return A2($author$project$DataElement$Expression$applyLocalDateTime, transformers, localDateTime);
			default:
				var localBool = localField.a;
				return A2($author$project$DataElement$Expression$applyLocalBool, transformers, localBool);
		}
	});
var $author$project$DataElement$Expression$applyLocalNumber = F2(
	function (transformers, localNumber) {
		switch (localNumber.$) {
			case 'LocalNumber':
				var fieldName = localNumber.a;
				return transformers.localNumber(fieldName);
			case 'LocalSingletonNumber':
				var singletonRef = localNumber.a;
				var fieldName = localNumber.b;
				return A2(transformers.globalNumberLookup, singletonRef, fieldName);
			case 'LocalNumberHardcoded':
				var number = localNumber.a;
				return transformers.hardcodedNumber(number);
			case 'LocalCountUnique':
				var localComparableList = localNumber.a;
				return function (_v4) {
					var compType = _v4.a;
					var item = _v4.b;
					return A2(transformers.countUnique, compType, item);
				}(
					A2($author$project$DataElement$Expression$applyLocalComparableList, transformers, localComparableList));
			case 'LocalRound':
				var innerNumber = localNumber.a;
				return transformers.round(
					A2($author$project$DataElement$Expression$applyLocalNumber, transformers, innerNumber));
			case 'LocalSum':
				var localNumberList = localNumber.a;
				return transformers.sum(
					A2($author$project$DataElement$Expression$applyLocalNumberList, transformers, localNumberList));
			case 'LocalProduct':
				var localNumberList = localNumber.a;
				return transformers.product(
					A2($author$project$DataElement$Expression$applyLocalNumberList, transformers, localNumberList));
			case 'LocalAdd':
				var localNumA = localNumber.a;
				var localNumB = localNumber.b;
				return A2(
					transformers.add,
					A2($author$project$DataElement$Expression$applyLocalNumber, transformers, localNumA),
					A2($author$project$DataElement$Expression$applyLocalNumber, transformers, localNumB));
			case 'LocalSubtract':
				var localNumA = localNumber.a;
				var localNumB = localNumber.b;
				return A2(
					transformers.subtract,
					A2($author$project$DataElement$Expression$applyLocalNumber, transformers, localNumA),
					A2($author$project$DataElement$Expression$applyLocalNumber, transformers, localNumB));
			case 'LocalMultiply':
				var localNumA = localNumber.a;
				var localNumB = localNumber.b;
				return A2(
					transformers.multiply,
					A2($author$project$DataElement$Expression$applyLocalNumber, transformers, localNumA),
					A2($author$project$DataElement$Expression$applyLocalNumber, transformers, localNumB));
			case 'LocalDivide':
				var localNumA = localNumber.a;
				var localNumB = localNumber.b;
				return A2(
					transformers.divide,
					A2($author$project$DataElement$Expression$applyLocalNumber, transformers, localNumA),
					A2($author$project$DataElement$Expression$applyLocalNumber, transformers, localNumB));
			case 'LocalMonthNumber':
				var innerDate = localNumber.a;
				return transformers.monthNumber(
					A2($author$project$DataElement$Expression$applyLocalDate, transformers, innerDate));
			case 'LocalYearNumber':
				var innerDate = localNumber.a;
				return transformers.yearNumber(
					A2($author$project$DataElement$Expression$applyLocalDate, transformers, innerDate));
			case 'LocalDayInMonth':
				var innerDate = localNumber.a;
				return transformers.dayInMonth(
					A2($author$project$DataElement$Expression$applyLocalDate, transformers, innerDate));
			case 'LocalNumberIf':
				var cond = localNumber.a;
				var then_ = localNumber.b;
				var else_ = localNumber.c;
				return A4(
					transformers.if_,
					$author$project$FieldType$NumberType,
					A2($author$project$DataElement$Expression$applyLocalBool, transformers, cond),
					A2($author$project$DataElement$Expression$applyLocalNumber, transformers, then_),
					A2($author$project$DataElement$Expression$applyLocalNumber, transformers, else_));
			case 'LocalPickNumber':
				var innerList = localNumber.a;
				return A2(
					transformers.pickOne,
					$author$project$FieldType$NumberType,
					A2($author$project$DataElement$Expression$applyLocalNumberList, transformers, innerList));
			case 'LocalMaxNumber':
				var list = localNumber.a;
				return A2(
					transformers.max,
					$author$project$ComparableType$NumberComp,
					A2($author$project$DataElement$Expression$applyLocalNumberList, transformers, list));
			default:
				var list = localNumber.a;
				return A2(
					transformers.min,
					$author$project$ComparableType$NumberComp,
					A2($author$project$DataElement$Expression$applyLocalNumberList, transformers, list));
		}
	});
var $author$project$DataElement$Expression$applyLocalNumberList = F2(
	function (transformers, localNumberList) {
		switch (localNumberList.$) {
			case 'RelatedNumber':
				var relationship = localNumberList.a;
				var fieldName = localNumberList.b;
				return A2(transformers.relatedNumber, relationship, fieldName);
			case 'LocalAllNumbersInField':
				var listRef = localNumberList.a;
				var fieldName = localNumberList.b;
				return A2(transformers.allNumbersInField, listRef, fieldName);
			case 'LocalNumbersAsList':
				var localNumbers = localNumberList.a;
				return transformers.numbersAsList(
					A2(
						$elm$core$List$map,
						$author$project$DataElement$Expression$applyLocalNumber(transformers),
						localNumbers));
			default:
				var cond = localNumberList.a;
				var then_ = localNumberList.b;
				var else_ = localNumberList.c;
				return A4(
					transformers.if_,
					$author$project$FieldType$NumberType,
					A2($author$project$DataElement$Expression$applyLocalBool, transformers, cond),
					A2($author$project$DataElement$Expression$applyLocalNumberList, transformers, then_),
					A2($author$project$DataElement$Expression$applyLocalNumberList, transformers, else_));
		}
	});
var $author$project$DataElement$Expression$applyLocalString = F2(
	function (transformers, localString) {
		switch (localString.$) {
			case 'LocalString':
				var fieldName = localString.a;
				return transformers.localString(fieldName);
			case 'LocalSingletonString':
				var singletonRef = localString.a;
				var fieldName = localString.b;
				return A2(transformers.globalStringLookup, singletonRef, fieldName);
			case 'LocalStringHardcoded':
				var words = localString.a;
				return transformers.hardcodedString(words);
			case 'LocalFormatDate':
				var innerString = localString.a;
				var innerDate = localString.b;
				return A2(
					transformers.formatDate,
					A2($author$project$DataElement$Expression$applyLocalString, transformers, innerString),
					A2($author$project$DataElement$Expression$applyLocalDate, transformers, innerDate));
			case 'LocalFormatDateLocaleAware':
				var innerDate = localString.a;
				return transformers.formatDateLocaleAware(
					A2($author$project$DataElement$Expression$applyLocalDate, transformers, innerDate));
			case 'LocalFormatDateTime':
				var innerDateTime = localString.a;
				return transformers.formatDateTime(
					A2($author$project$DataElement$Expression$applyLocalDateTime, transformers, innerDateTime));
			case 'LocalFormatNumber':
				var decimals = localString.a;
				var innerNumber = localString.b;
				return A2(
					transformers.formatNumber,
					decimals,
					A2($author$project$DataElement$Expression$applyLocalNumber, transformers, innerNumber));
			case 'LocalStringIf':
				var cond = localString.a;
				var then_ = localString.b;
				var else_ = localString.c;
				return A4(
					transformers.if_,
					$author$project$FieldType$StringType,
					A2($author$project$DataElement$Expression$applyLocalBool, transformers, cond),
					A2($author$project$DataElement$Expression$applyLocalString, transformers, then_),
					A2($author$project$DataElement$Expression$applyLocalString, transformers, else_));
			case 'LocalPickString':
				var innerList = localString.a;
				return A2(
					transformers.pickOne,
					$author$project$FieldType$StringType,
					A2($author$project$DataElement$Expression$applyLocalStringList, transformers, innerList));
			case 'LocalConcat':
				var join = localString.a;
				var list = localString.b;
				return A2(
					transformers.concat,
					A2($author$project$DataElement$Expression$applyLocalString, transformers, join),
					A2($author$project$DataElement$Expression$applyLocalStringList, transformers, list));
			case 'LocalMaxString':
				var list = localString.a;
				return A2(
					transformers.max,
					$author$project$ComparableType$StringComp,
					A2($author$project$DataElement$Expression$applyLocalStringList, transformers, list));
			default:
				var list = localString.a;
				return A2(
					transformers.min,
					$author$project$ComparableType$StringComp,
					A2($author$project$DataElement$Expression$applyLocalStringList, transformers, list));
		}
	});
var $author$project$DataElement$Expression$applyLocalStringList = F2(
	function (transformers, localStringList) {
		switch (localStringList.$) {
			case 'RelatedString':
				var relationship = localStringList.a;
				var fieldName = localStringList.b;
				return A2(transformers.relatedString, relationship, fieldName);
			case 'LocalAllStringsInField':
				var listRef = localStringList.a;
				var fieldName = localStringList.b;
				return A2(transformers.allStringsInField, listRef, fieldName);
			case 'LocalStringsAsList':
				var localStrings = localStringList.a;
				return transformers.stringsAsList(
					A2(
						$elm$core$List$map,
						$author$project$DataElement$Expression$applyLocalString(transformers),
						localStrings));
			case 'LocalStringListIf':
				var cond = localStringList.a;
				var then_ = localStringList.b;
				var else_ = localStringList.c;
				return A4(
					transformers.if_,
					$author$project$FieldType$StringType,
					A2($author$project$DataElement$Expression$applyLocalBool, transformers, cond),
					A2($author$project$DataElement$Expression$applyLocalStringList, transformers, then_),
					A2($author$project$DataElement$Expression$applyLocalStringList, transformers, else_));
			case 'LocalChallengeReasons':
				var acctId = localStringList.a;
				return transformers.challengeReasons(
					A2($author$project$DataElement$Expression$applyLocalString, transformers, acctId));
			default:
				var acctId = localStringList.a;
				return transformers.targetChallengeReasons(
					A2($author$project$DataElement$Expression$applyLocalString, transformers, acctId));
		}
	});
var $author$project$DataElement$Reference$getGenericReference = function (_v0) {
	var uuid = _v0.a;
	return $author$project$DataElement$Reference$Reference(uuid);
};
var $author$project$DataElement$Expression$relatedFieldDependencies = F2(
	function (relationship, _v0) {
		return _Utils_ap(
			_List_fromArray(
				[
					$author$project$DataElement$Reference$getGenericReference(relationship.nextElement)
				]),
			_Utils_ap(
				A2(
					$author$project$DataElement$Expression$applyLocalString,
					$author$project$DataElement$Expression$cyclic$dependencyTransformer(),
					relationship.idToMatch),
				_Utils_ap(
					A2(
						$author$project$DataElement$Expression$applyLocalStringList,
						$author$project$DataElement$Expression$cyclic$dependencyTransformer(),
						relationship.localIds),
					A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2(
							$elm$core$Maybe$map,
							$author$project$DataElement$Expression$applyLocalBool(
								$author$project$DataElement$Expression$cyclic$dependencyTransformer()),
							relationship.optionalFilter)))));
	});
function $author$project$DataElement$Expression$cyclic$dependencyTransformer() {
	return {
		add: $elm$core$Basics$append,
		all: $elm$core$Basics$identity,
		allBoolsInField: F2(
			function (ref, _v1) {
				return _List_fromArray(
					[
						$author$project$DataElement$Reference$getGenericReference(ref)
					]);
			}),
		allDateTimesInField: F2(
			function (ref, _v2) {
				return _List_fromArray(
					[
						$author$project$DataElement$Reference$getGenericReference(ref)
					]);
			}),
		allDatesInField: F2(
			function (ref, _v3) {
				return _List_fromArray(
					[
						$author$project$DataElement$Reference$getGenericReference(ref)
					]);
			}),
		allNumbersInField: F2(
			function (ref, _v4) {
				return _List_fromArray(
					[
						$author$project$DataElement$Reference$getGenericReference(ref)
					]);
			}),
		allStringsInField: F2(
			function (ref, _v5) {
				return _List_fromArray(
					[
						$author$project$DataElement$Reference$getGenericReference(ref)
					]);
			}),
		any: $elm$core$Basics$identity,
		boolsAsList: $elm$core$List$concat,
		challengeReasons: function (_v6) {
			return _List_Nil;
		},
		comparableEqual: function (_v7) {
			return $elm$core$Basics$append;
		},
		comparableNotEqual: function (_v8) {
			return $elm$core$Basics$append;
		},
		concat: $elm$core$Basics$append,
		countUnique: F2(
			function (_v9, a) {
				return a;
			}),
		dateAdd: function (_v10) {
			return $elm$core$Basics$append;
		},
		dateCeiling: F2(
			function (_v11, deps) {
				return deps;
			}),
		dateFloor: F2(
			function (_v12, deps) {
				return deps;
			}),
		dateSubtract: function (_v13) {
			return $elm$core$Basics$append;
		},
		dateTimeToDate: $elm$core$Basics$identity,
		dateTimesAsList: $elm$core$List$concat,
		datesAsList: $elm$core$List$concat,
		dayInMonth: $elm$core$Basics$identity,
		divide: $elm$core$Basics$append,
		equal: function (_v14) {
			return $elm$core$Basics$append;
		},
		formatDate: $elm$core$Basics$append,
		formatDateLocaleAware: $elm$core$Basics$identity,
		formatDateTime: $elm$core$Basics$identity,
		formatNumber: function (_v15) {
			return $elm$core$Basics$identity;
		},
		globalBoolLookup: F2(
			function (ref, _v16) {
				return _List_fromArray(
					[
						$author$project$DataElement$Reference$getGenericReference(ref)
					]);
			}),
		globalDateLookup: F2(
			function (ref, _v17) {
				return _List_fromArray(
					[
						$author$project$DataElement$Reference$getGenericReference(ref)
					]);
			}),
		globalDateTimeLookup: F2(
			function (ref, _v18) {
				return _List_fromArray(
					[
						$author$project$DataElement$Reference$getGenericReference(ref)
					]);
			}),
		globalNumberLookup: F2(
			function (ref, _v19) {
				return _List_fromArray(
					[
						$author$project$DataElement$Reference$getGenericReference(ref)
					]);
			}),
		globalStringLookup: F2(
			function (ref, _v20) {
				return _List_fromArray(
					[
						$author$project$DataElement$Reference$getGenericReference(ref)
					]);
			}),
		greaterThan: function (_v21) {
			return $elm$core$Basics$append;
		},
		greaterThanOrEqual: function (_v22) {
			return $elm$core$Basics$append;
		},
		hardcodedBool: function (_v23) {
			return _List_Nil;
		},
		hardcodedDate: function (_v24) {
			return _List_Nil;
		},
		hardcodedDateTime: function (_v25) {
			return _List_Nil;
		},
		hardcodedNumber: function (_v26) {
			return _List_Nil;
		},
		hardcodedString: function (_v27) {
			return _List_Nil;
		},
		if_: F4(
			function (_v28, a, b, c) {
				return _Utils_ap(
					a,
					_Utils_ap(b, c));
			}),
		isNotNull: $elm$core$Basics$identity,
		isNull: $elm$core$Basics$identity,
		lessThan: function (_v29) {
			return $elm$core$Basics$append;
		},
		lessThanOrEqual: function (_v30) {
			return $elm$core$Basics$append;
		},
		localBool: function (_v31) {
			return _List_Nil;
		},
		localDate: function (_v32) {
			return _List_Nil;
		},
		localDateTime: function (_v33) {
			return _List_Nil;
		},
		localNumber: function (_v34) {
			return _List_Nil;
		},
		localString: function (_v35) {
			return _List_Nil;
		},
		max: function (_v36) {
			return $elm$core$Basics$identity;
		},
		min: function (_v37) {
			return $elm$core$Basics$identity;
		},
		monthNumber: $elm$core$Basics$identity,
		multiply: $elm$core$Basics$append,
		not: $elm$core$Basics$identity,
		notEqual: function (_v38) {
			return $elm$core$Basics$append;
		},
		numbersAsList: $elm$core$List$concat,
		pickOne: function (_v39) {
			return $elm$core$Basics$identity;
		},
		product: $elm$core$Basics$identity,
		relatedBool: $author$project$DataElement$Expression$relatedFieldDependencies,
		relatedDate: $author$project$DataElement$Expression$relatedFieldDependencies,
		relatedDateTime: $author$project$DataElement$Expression$relatedFieldDependencies,
		relatedNumber: $author$project$DataElement$Expression$relatedFieldDependencies,
		relatedString: $author$project$DataElement$Expression$relatedFieldDependencies,
		round: $elm$core$Basics$identity,
		stringIn: $elm$core$Basics$append,
		stringNotIn: $elm$core$Basics$append,
		stringsAsList: $elm$core$List$concat,
		subtract: $elm$core$Basics$append,
		sum: $elm$core$Basics$identity,
		targetChallengeReasons: function (_v40) {
			return _List_Nil;
		},
		yearNumber: $elm$core$Basics$identity
	};
}
try {
	var $author$project$DataElement$Expression$dependencyTransformer = $author$project$DataElement$Expression$cyclic$dependencyTransformer();
	$author$project$DataElement$Expression$cyclic$dependencyTransformer = function () {
		return $author$project$DataElement$Expression$dependencyTransformer;
	};
} catch ($) {
	throw 'Some top-level definitions from `DataElement.Expression` are causing infinite recursion:\n\n  ┌─────┐\n  │    dependencyTransformer\n  │     ↓\n  │    relatedFieldDependencies\n  └─────┘\n\nThese errors are very tricky, so read https://elm-lang.org/0.19.1/bad-recursion to learn how to fix it!';}
var $author$project$DataElement$calcDatepickerDependencies = function (info) {
	return A2(
		$elm$core$Maybe$withDefault,
		_List_Nil,
		A2(
			$elm$core$Maybe$map,
			$author$project$DataElement$Expression$applyGlobalDate($author$project$DataElement$Expression$dependencyTransformer),
			info._default));
};
var $author$project$DataElement$calcDropdownDependencies = function (info) {
	var placeholderDependencies = A2(
		$elm$core$Maybe$withDefault,
		_List_Nil,
		A2(
			$elm$core$Maybe$map,
			$author$project$DataElement$Expression$applyGlobalString($author$project$DataElement$Expression$dependencyTransformer),
			info.placeholder));
	var optionsDependencies = A2($author$project$DataElement$Expression$applyGlobalStringList, $author$project$DataElement$Expression$dependencyTransformer, info.options);
	return _Utils_ap(optionsDependencies, placeholderDependencies);
};
var $author$project$DataElement$calcFilterListDependencies = function (info) {
	return A2(
		$elm$core$List$cons,
		$author$project$DataElement$Reference$getGenericReference(info.original),
		A2($author$project$DataElement$Expression$applyLocalBool, $author$project$DataElement$Expression$dependencyTransformer, info.filter));
};
var $author$project$DataElement$MergeList$getRefList = function (_v0) {
	var matrix = _v0.a;
	return A2(
		$elm$core$List$map,
		function (_v1) {
			var listElem = _v1.a;
			var dict = _v1.b;
			return _Utils_Tuple2(listElem, dict);
		},
		matrix);
};
var $author$project$DataElement$calcMergeListDependencies = function (info) {
	return $author$project$DataElement$MergeList$getRefList(info);
};
var $pzp1997$assoc_list$AssocList$values = function (_v0) {
	var alist = _v0.a;
	return A2($elm$core$List$map, $elm$core$Tuple$second, alist);
};
var $author$project$DataElement$calcOneForOneDependencies = function (oneForOne) {
	var fieldDependencies = A2(
		$elm$core$List$concatMap,
		$author$project$DataElement$Expression$applyLocalField($author$project$DataElement$Expression$dependencyTransformer),
		$pzp1997$assoc_list$AssocList$values(oneForOne.fields));
	return A2(
		$elm$core$List$cons,
		$author$project$DataElement$Reference$getGenericReference(oneForOne.original),
		fieldDependencies);
};
var $author$project$DataElement$Expression$applyLocalComparable = F2(
	function (transformers, globalComparable) {
		switch (globalComparable.$) {
			case 'LocalCompStringExpr':
				var localString = globalComparable.a;
				return A2($author$project$DataElement$Expression$applyLocalString, transformers, localString);
			case 'LocalCompNumberExpr':
				var localNumber = globalComparable.a;
				return A2($author$project$DataElement$Expression$applyLocalNumber, transformers, localNumber);
			case 'LocalCompDateExpr':
				var localDate = globalComparable.a;
				return A2($author$project$DataElement$Expression$applyLocalDate, transformers, localDate);
			default:
				var localDateTime = globalComparable.a;
				return A2($author$project$DataElement$Expression$applyLocalDateTime, transformers, localDateTime);
		}
	});
var $author$project$DataElement$calcSortListDependencies = function (info) {
	var sortByDependencies = A2(
		$elm$core$List$concatMap,
		$author$project$DataElement$Expression$applyLocalComparable($author$project$DataElement$Expression$dependencyTransformer),
		A2(
			$elm$core$List$map,
			function ($) {
				return $.expression;
			},
			$mgold$elm_nonempty_list$List$Nonempty$toList(info.sortBy)));
	return A2(
		$elm$core$List$cons,
		$author$project$DataElement$Reference$getGenericReference(info.original),
		sortByDependencies);
};
var $author$project$DataElement$calcSublistDependencies = function (info) {
	return _List_fromArray(
		[
			$author$project$DataElement$Reference$getGenericReference(info.original)
		]);
};
var $author$project$DataElement$Expression$applyGlobalComparable = F2(
	function (transformers, globalComparable) {
		switch (globalComparable.$) {
			case 'GlobalCompStringExpr':
				var globalString = globalComparable.a;
				return A2($author$project$DataElement$Expression$applyGlobalString, transformers, globalString);
			case 'GlobalCompNumberExpr':
				var globalNumber = globalComparable.a;
				return A2($author$project$DataElement$Expression$applyGlobalNumber, transformers, globalNumber);
			case 'GlobalCompDateExpr':
				var globalDate = globalComparable.a;
				return A2($author$project$DataElement$Expression$applyGlobalDate, transformers, globalDate);
			default:
				var globalDateTime = globalComparable.a;
				return A2($author$project$DataElement$Expression$applyGlobalDateTime, transformers, globalDateTime);
		}
	});
var $author$project$DataElement$CrmDataEngine$Where$dependencies = function (clause) {
	switch (clause.$) {
		case 'AllOf':
			var wheres = clause.a;
			return $elm$core$List$concat(
				A2($elm$core$List$map, $author$project$DataElement$CrmDataEngine$Where$dependencies, wheres));
		case 'AnyOf':
			var wheres = clause.a;
			return $elm$core$List$concat(
				A2($elm$core$List$map, $author$project$DataElement$CrmDataEngine$Where$dependencies, wheres));
		case 'Eq':
			var globalField = clause.b;
			return A2($author$project$DataElement$Expression$applyGlobalField, $author$project$DataElement$Expression$dependencyTransformer, globalField);
		case 'NotEq':
			var globalField = clause.b;
			return A2($author$project$DataElement$Expression$applyGlobalField, $author$project$DataElement$Expression$dependencyTransformer, globalField);
		case 'Gt':
			var globalComparable = clause.b;
			return A2($author$project$DataElement$Expression$applyGlobalComparable, $author$project$DataElement$Expression$dependencyTransformer, globalComparable);
		case 'Gte':
			var globalComparable = clause.b;
			return A2($author$project$DataElement$Expression$applyGlobalComparable, $author$project$DataElement$Expression$dependencyTransformer, globalComparable);
		case 'Lt':
			var globalComparable = clause.b;
			return A2($author$project$DataElement$Expression$applyGlobalComparable, $author$project$DataElement$Expression$dependencyTransformer, globalComparable);
		case 'Lte':
			var globalComparable = clause.b;
			return A2($author$project$DataElement$Expression$applyGlobalComparable, $author$project$DataElement$Expression$dependencyTransformer, globalComparable);
		case 'In':
			var globalStringList = clause.b;
			return A2($author$project$DataElement$Expression$applyGlobalStringList, $author$project$DataElement$Expression$dependencyTransformer, globalStringList);
		case 'BetweenString':
			var globalStringA = clause.b;
			var globalStringB = clause.c;
			return _Utils_ap(
				A2($author$project$DataElement$Expression$applyGlobalString, $author$project$DataElement$Expression$dependencyTransformer, globalStringA),
				A2($author$project$DataElement$Expression$applyGlobalString, $author$project$DataElement$Expression$dependencyTransformer, globalStringB));
		case 'BetweenDate':
			var globalDateA = clause.b;
			var globalDateB = clause.c;
			return _Utils_ap(
				A2($author$project$DataElement$Expression$applyGlobalDate, $author$project$DataElement$Expression$dependencyTransformer, globalDateA),
				A2($author$project$DataElement$Expression$applyGlobalDate, $author$project$DataElement$Expression$dependencyTransformer, globalDateB));
		case 'BetweenDateTime':
			var globalDateTimeA = clause.b;
			var globalDateTimeB = clause.c;
			return _Utils_ap(
				A2($author$project$DataElement$Expression$applyGlobalDateTime, $author$project$DataElement$Expression$dependencyTransformer, globalDateTimeA),
				A2($author$project$DataElement$Expression$applyGlobalDateTime, $author$project$DataElement$Expression$dependencyTransformer, globalDateTimeB));
		case 'BetweenNumber':
			var globalNumberA = clause.b;
			var globalNumberB = clause.c;
			return _Utils_ap(
				A2($author$project$DataElement$Expression$applyGlobalNumber, $author$project$DataElement$Expression$dependencyTransformer, globalNumberA),
				A2($author$project$DataElement$Expression$applyGlobalNumber, $author$project$DataElement$Expression$dependencyTransformer, globalNumberB));
		case 'IsNull':
			return _List_Nil;
		default:
			return _List_Nil;
	}
};
var $author$project$DataElement$WhereClause$dependencies = function (whereIndividual) {
	switch (whereIndividual.$) {
		case 'WhereIn':
			var globalStringListExpr = whereIndividual.b;
			return A2($author$project$DataElement$Expression$applyGlobalStringList, $author$project$DataElement$Expression$dependencyTransformer, globalStringListExpr);
		case 'WhereEqual':
			var globalFieldExpr = whereIndividual.b;
			return A2($author$project$DataElement$Expression$applyGlobalField, $author$project$DataElement$Expression$dependencyTransformer, globalFieldExpr);
		case 'WhereNotEqual':
			var globalFieldExpr = whereIndividual.b;
			return A2($author$project$DataElement$Expression$applyGlobalField, $author$project$DataElement$Expression$dependencyTransformer, globalFieldExpr);
		case 'WhereGT':
			var globalCompExpr = whereIndividual.b;
			return A2($author$project$DataElement$Expression$applyGlobalComparable, $author$project$DataElement$Expression$dependencyTransformer, globalCompExpr);
		case 'WhereGTE':
			var globalCompExpr = whereIndividual.b;
			return A2($author$project$DataElement$Expression$applyGlobalComparable, $author$project$DataElement$Expression$dependencyTransformer, globalCompExpr);
		case 'WhereLT':
			var globalCompExpr = whereIndividual.b;
			return A2($author$project$DataElement$Expression$applyGlobalComparable, $author$project$DataElement$Expression$dependencyTransformer, globalCompExpr);
		default:
			var globalCompExpr = whereIndividual.b;
			return A2($author$project$DataElement$Expression$applyGlobalComparable, $author$project$DataElement$Expression$dependencyTransformer, globalCompExpr);
	}
};
var $elm$core$List$singleton = function (value) {
	return _List_fromArray(
		[value]);
};
var $author$project$DataElement$CrmDataEngine$Where$flatten = function (clause) {
	switch (clause.$) {
		case 'AnyOf':
			var children = clause.a;
			return A2($elm$core$List$concatMap, $author$project$DataElement$CrmDataEngine$Where$flatten, children);
		case 'AllOf':
			var children = clause.a;
			return A2($elm$core$List$concatMap, $author$project$DataElement$CrmDataEngine$Where$flatten, children);
		case 'Eq':
			return $elm$core$List$singleton(clause);
		case 'NotEq':
			return $elm$core$List$singleton(clause);
		case 'Gt':
			return $elm$core$List$singleton(clause);
		case 'Gte':
			return $elm$core$List$singleton(clause);
		case 'Lt':
			return $elm$core$List$singleton(clause);
		case 'Lte':
			return $elm$core$List$singleton(clause);
		case 'In':
			return $elm$core$List$singleton(clause);
		case 'BetweenString':
			return $elm$core$List$singleton(clause);
		case 'BetweenDate':
			return $elm$core$List$singleton(clause);
		case 'BetweenDateTime':
			return $elm$core$List$singleton(clause);
		case 'BetweenNumber':
			return $elm$core$List$singleton(clause);
		case 'IsNull':
			return $elm$core$List$singleton(clause);
		default:
			return $elm$core$List$singleton(clause);
	}
};
var $author$project$DataElement$WhereClause$flatten = function (clause) {
	switch (clause.$) {
		case 'WhereAnd':
			var children = clause.a;
			return A2($elm$core$List$concatMap, $author$project$DataElement$WhereClause$flatten, children);
		case 'WhereOr':
			var children = clause.a;
			return A2($elm$core$List$concatMap, $author$project$DataElement$WhereClause$flatten, children);
		default:
			var individual = clause.a;
			return _List_fromArray(
				[individual]);
	}
};
var $author$project$DataElement$findAllDependencyUuids = function (element) {
	if (element.$ === 'RecordList') {
		switch (element.a.$) {
			case 'CrmQuery':
				var queryInfo = element.a.a;
				return A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						A2(
							$elm$core$Basics$composeR,
							$author$project$DataElement$WhereClause$flatten,
							$elm$core$List$concatMap($author$project$DataElement$WhereClause$dependencies)),
						queryInfo.whereClause));
			case 'SalesQuery':
				var queryInfo = element.a.a;
				return A2(
					$elm$core$List$concatMap,
					$author$project$DataElement$WhereClause$dependencies,
					$author$project$DataElement$WhereClause$flatten(
						$author$project$DataElement$makeSalesQueryWhereClause(queryInfo)));
			case 'NitroQuery':
				var queryInfo = element.a.a;
				return A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						A2(
							$elm$core$Basics$composeR,
							$author$project$DataElement$WhereClause$flatten,
							$elm$core$List$concatMap($author$project$DataElement$WhereClause$dependencies)),
						queryInfo.whereClause));
			case 'CrmDataEngineQuery':
				var info = element.a.a;
				return A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						A2(
							$elm$core$Basics$composeR,
							$author$project$DataElement$CrmDataEngine$Where$flatten,
							$elm$core$List$concatMap($author$project$DataElement$CrmDataEngine$Where$dependencies)),
						info.whereClause));
			case 'CalcOneForOne':
				var oneForOne = element.a.a;
				return $author$project$DataElement$calcOneForOneDependencies(oneForOne);
			case 'CalcSortList':
				var info = element.a.a;
				return $author$project$DataElement$calcSortListDependencies(info);
			case 'CalcFilterList':
				var info = element.a.a;
				return $author$project$DataElement$calcFilterListDependencies(info);
			case 'CalcSublist':
				var info = element.a.a;
				return $author$project$DataElement$calcSublistDependencies(info);
			case 'CalcMergeList':
				var info = element.a.a;
				return A2(
					$elm$core$List$map,
					function (_v1) {
						var listRef = _v1.a;
						return $author$project$DataElement$Reference$getGenericReference(listRef);
					},
					$author$project$DataElement$calcMergeListDependencies(info));
			case 'AlignedTerritories':
				return _List_Nil;
			case 'FeedbackChannelGoals':
				return _List_Nil;
			case 'FeedbackProductGoals':
				return _List_Nil;
			case 'FeedbackAccountData':
				return _List_Nil;
			case 'FeedbackAccountChannelGoals':
				return _List_Nil;
			case 'FeedbackAccountProductGoals':
				return _List_Nil;
			case 'FeedbackAccountProductMetrics':
				return _List_Nil;
			default:
				var _v2 = element.a;
				return _List_Nil;
		}
	} else {
		switch (element.a.$) {
			case 'FeedbackOverview':
				return _List_Nil;
			case 'ContextQuery':
				return _List_Nil;
			case 'LimitOneCrmQuery':
				var queryInfo = element.a.a;
				return A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						A2(
							$elm$core$Basics$composeR,
							$author$project$DataElement$WhereClause$flatten,
							$elm$core$List$concatMap($author$project$DataElement$WhereClause$dependencies)),
						queryInfo.whereClause));
			case 'LimitOneSalesQuery':
				var queryInfo = element.a.a;
				return A2(
					$elm$core$List$concatMap,
					$author$project$DataElement$WhereClause$dependencies,
					$author$project$DataElement$WhereClause$flatten(
						$author$project$DataElement$makeSalesQueryWhereClause(queryInfo)));
			case 'LimitOneNitroQuery':
				var queryInfo = element.a.a;
				return A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						A2(
							$elm$core$Basics$composeR,
							$author$project$DataElement$WhereClause$flatten,
							$elm$core$List$concatMap($author$project$DataElement$WhereClause$dependencies)),
						queryInfo.whereClause));
			case 'LimitOneCrmDataEngineQuery':
				var info = element.a.a;
				return A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						A2(
							$elm$core$Basics$composeR,
							$author$project$DataElement$CrmDataEngine$Where$flatten,
							$elm$core$List$concatMap($author$project$DataElement$CrmDataEngine$Where$dependencies)),
						info.whereClause));
			case 'Today':
				var _v3 = element.a;
				return _List_Nil;
			case 'Now':
				var _v4 = element.a;
				return _List_Nil;
			case 'CalcSummarize':
				var summarizeInfo = element.a.a;
				return A2(
					$elm$core$List$concatMap,
					$author$project$DataElement$Expression$applyGlobalField($author$project$DataElement$Expression$dependencyTransformer),
					$pzp1997$assoc_list$AssocList$values(summarizeInfo.fields));
			case 'ObjectTranslation':
				return _List_Nil;
			case 'FieldTranslation':
				return _List_Nil;
			case 'VeevaMessages':
				return _List_Nil;
			case 'DatepickerSelection':
				var info = element.a.a;
				return $author$project$DataElement$calcDatepickerDependencies(info);
			default:
				var dropdownInfo = element.a.a;
				return $author$project$DataElement$calcDropdownDependencies(dropdownInfo);
		}
	}
};
var $drathier$elm_graph$Graph$Graph = function (a) {
	return {$: 'Graph', a: a};
};
var $drathier$elm_graph$Graph$Node = function (a) {
	return {$: 'Node', a: a};
};
var $drathier$elm_graph$Graph$emptyNode = $drathier$elm_graph$Graph$Node(
	{data: $elm$core$Maybe$Nothing, incoming: $elm$core$Set$empty, outgoing: $elm$core$Dict$empty, reachable: $elm$core$Set$empty});
var $drathier$elm_graph$Graph$get = F2(
	function (key, _v0) {
		var graph = _v0.a;
		return A2($elm$core$Dict$get, key, graph.nodes);
	});
var $drathier$elm_graph$Graph$getOrCreate = F2(
	function (key, graph) {
		return A2(
			$elm$core$Maybe$withDefault,
			$drathier$elm_graph$Graph$emptyNode,
			A2($drathier$elm_graph$Graph$get, key, graph));
	});
var $drathier$elm_graph$Graph$insertData = F3(
	function (key, data, _v0) {
		var graph = _v0.a;
		var _v1 = A2(
			$drathier$elm_graph$Graph$getOrCreate,
			key,
			$drathier$elm_graph$Graph$Graph(graph));
		var node = _v1.a;
		return $drathier$elm_graph$Graph$Graph(
			_Utils_update(
				graph,
				{
					nodes: A3(
						$elm$core$Dict$insert,
						key,
						$drathier$elm_graph$Graph$Node(
							_Utils_update(
								node,
								{
									data: $elm$core$Maybe$Just(data)
								})),
						graph.nodes)
				}));
	});
var $drathier$elm_graph$Graph$insertRawNode = F3(
	function (key, node, _v0) {
		var graph = _v0.a;
		return $drathier$elm_graph$Graph$Graph(
			_Utils_update(
				graph,
				{
					nodes: A3($elm$core$Dict$insert, key, node, graph.nodes)
				}));
	});
var $drathier$elm_graph$Graph$insertEdgeDataHelper = F4(
	function (from, to, wrappedEdgeData, graph) {
		var _v0 = A2($drathier$elm_graph$Graph$getOrCreate, to, graph);
		var toNode = _v0.a;
		var _v1 = A2($drathier$elm_graph$Graph$getOrCreate, from, graph);
		var fromNode = _v1.a;
		return _Utils_eq(from, to) ? A3(
			$drathier$elm_graph$Graph$insertRawNode,
			from,
			$drathier$elm_graph$Graph$Node(
				_Utils_update(
					fromNode,
					{
						incoming: A2($elm$core$Set$insert, from, fromNode.incoming),
						outgoing: A3($elm$core$Dict$insert, from, wrappedEdgeData, fromNode.outgoing)
					})),
			graph) : A3(
			$drathier$elm_graph$Graph$insertRawNode,
			from,
			$drathier$elm_graph$Graph$Node(
				_Utils_update(
					fromNode,
					{
						outgoing: A3($elm$core$Dict$insert, to, wrappedEdgeData, fromNode.outgoing)
					})),
			A3(
				$drathier$elm_graph$Graph$insertRawNode,
				to,
				$drathier$elm_graph$Graph$Node(
					_Utils_update(
						toNode,
						{
							incoming: A2($elm$core$Set$insert, from, toNode.incoming)
						})),
				graph));
	});
var $drathier$elm_graph$Graph$insertEdge = F3(
	function (from, to, graph) {
		return A4($drathier$elm_graph$Graph$insertEdgeDataHelper, from, to, $elm$core$Maybe$Nothing, graph);
	});
var $author$project$DataElement$Reference$toString = function (_v0) {
	var uuid = _v0.a;
	return $danyx23$elm_uuid$Uuid$toString(uuid);
};
var $author$project$DataElement$addToDependencyGraph = F2(
	function (_v0, graph) {
		var ref = _v0.a;
		var _v1 = _v0.b;
		var element = _v1.b;
		return A3(
			$elm$core$List$foldl,
			function (depUuid) {
				return A2(
					$drathier$elm_graph$Graph$insertEdge,
					$author$project$DataElement$Reference$toString(depUuid),
					$author$project$DataElement$Reference$toString(ref));
			},
			A3(
				$drathier$elm_graph$Graph$insertData,
				$author$project$DataElement$Reference$toString(ref),
				$author$project$DataElement$Reference$getGenericReference(ref),
				graph),
			$author$project$DataElement$findAllDependencyUuids(element));
	});
var $author$project$DataElement$collectionToList = function (_v0) {
	var uuidDict = _v0.a;
	return A2(
		$elm$core$List$map,
		$elm$core$Tuple$mapFirst($author$project$DataElement$Reference$getReferenceFromUuid),
		$author$project$UuidDict$toList(uuidDict));
};
var $drathier$elm_graph$Graph$empty = $drathier$elm_graph$Graph$Graph(
	{nodes: $elm$core$Dict$empty});
var $author$project$DependencyGraph$fromDataElements = function (dataElementsDict) {
	return $author$project$DependencyGraph$DependencyGraph(
		A3(
			$elm$core$List$foldl,
			$author$project$DataElement$addToDependencyGraph,
			$drathier$elm_graph$Graph$empty,
			$author$project$DataElement$collectionToList(dataElementsDict)));
};
var $elm_community$list_extra$List$Extra$mapAccuml = F3(
	function (f, acc0, list) {
		var _v0 = A3(
			$elm$core$List$foldl,
			F2(
				function (x, _v1) {
					var acc1 = _v1.a;
					var ys = _v1.b;
					var _v2 = A2(f, acc1, x);
					var acc2 = _v2.a;
					var y = _v2.b;
					return _Utils_Tuple2(
						acc2,
						A2($elm$core$List$cons, y, ys));
				}),
			_Utils_Tuple2(acc0, _List_Nil),
			list);
		var accFinal = _v0.a;
		var generatedList = _v0.b;
		return _Utils_Tuple2(
			accFinal,
			$elm$core$List$reverse(generatedList));
	});
var $author$project$DataEngine$DataCache$member = F2(
	function (ref, _v0) {
		var internal = _v0.a;
		var _v1 = A2(
			$author$project$UuidDict$get,
			$author$project$DataElement$Reference$getUuid(ref),
			internal.dataElementStates);
		if (_v1.$ === 'Just') {
			if (_v1.a.$ === 'Deleted') {
				return false;
			} else {
				return true;
			}
		} else {
			return false;
		}
	});
var $author$project$DataEngine$CacheUpdateStep$RunQuery = function (a) {
	return {$: 'RunQuery', a: a};
};
var $author$project$DataEngine$CacheUpdateStep$Insert = function (a) {
	return {$: 'Insert', a: a};
};
var $author$project$Preview$Helpers$feedbackIdFieldDecoder = function (fieldName) {
	return A2(
		$elm$json$Json$Decode$field,
		fieldName,
		A2(
			$elm$json$Json$Decode$map,
			A2($elm$core$Basics$composeR, $author$project$StudioString$withoutObject, $author$project$FieldValue$StringValue),
			$elm$json$Json$Decode$string));
};
var $krisajenkins$remotedata$RemoteData$mapError = F2(
	function (f, data) {
		switch (data.$) {
			case 'Success':
				var x = data.a;
				return $krisajenkins$remotedata$RemoteData$Success(x);
			case 'Failure':
				var e = data.a;
				return $krisajenkins$remotedata$RemoteData$Failure(
					f(e));
			case 'Loading':
				return $krisajenkins$remotedata$RemoteData$Loading;
			default:
				return $krisajenkins$remotedata$RemoteData$NotAsked;
		}
	});
var $author$project$DataElement$FeedbackAccountChannelGoals$addAccountId = function (items) {
	return A2(
		$elm$core$List$cons,
		_Utils_Tuple2(
			$author$project$FieldName$fromString('Account ID'),
			$author$project$FieldType$StringType),
		items);
};
var $author$project$DataElement$FeedbackAccountChannelGoals$fixChannelId = function (_v0) {
	var fieldName = _v0.a;
	var fieldType = _v0.b;
	return _Utils_eq(
		fieldName,
		$author$project$FieldName$fromString('channelOrProductId')) ? _Utils_Tuple2(
		$author$project$FieldName$fromString('Channel ID'),
		fieldType) : _Utils_Tuple2(fieldName, fieldType);
};
var $author$project$DataElement$FeedbackAccountChannelGoals$metadata = function (info) {
	return $author$project$DataEngine$RecordMetadata$fromList(
		$author$project$DataElement$FeedbackAccountChannelGoals$addAccountId(
			A2(
				$elm$core$List$map,
				$author$project$DataElement$FeedbackAccountChannelGoals$fixChannelId,
				$pzp1997$assoc_list$AssocList$toList(info.fields))));
};
var $pzp1997$assoc_list$AssocList$singleton = F2(
	function (key, value) {
		return $pzp1997$assoc_list$AssocList$D(
			_List_fromArray(
				[
					_Utils_Tuple2(key, value)
				]));
	});
var $author$project$DataElement$FeedbackAccountChannelGoals$recordCacheDecoder = function (info) {
	return A3(
		$elm$core$List$foldl,
		A2(
			$author$project$Preview$Helpers$addFieldWithCustomNameDecoder,
			A2(
				$pzp1997$assoc_list$AssocList$singleton,
				$author$project$FieldName$fromString('channelOrProductId'),
				$author$project$FieldName$fromString('Channel ID')),
			$pzp1997$assoc_list$AssocList$empty),
		$elm$json$Json$Decode$succeed($author$project$DataEngine$RecordCache$empty),
		$pzp1997$assoc_list$AssocList$toList(
			A2(
				$pzp1997$assoc_list$AssocList$map,
				F2(
					function (_v0, fieldType) {
						return {_default: $elm$core$Maybe$Nothing, fieldType: fieldType};
					}),
				info.fields)));
};
var $author$project$DataElement$toCacheUpdateStep = F2(
	function (handleSuccess, loadable) {
		switch (loadable.$) {
			case 'NotAsked':
				return $elm$core$Maybe$Nothing;
			case 'Loading':
				return $elm$core$Maybe$Nothing;
			case 'Failure':
				var err = loadable.a;
				return $elm$core$Maybe$Just(
					$author$project$DataEngine$CacheUpdateStep$Insert(
						$elm$core$Result$Err(err)));
			default:
				var a = loadable.a;
				return $elm$core$Maybe$Just(
					handleSuccess(a));
		}
	});
var $author$project$DataElement$previewAccountChannelGoals = F2(
	function (cache, info) {
		var goalsForAccountDecoder = A2(
			$elm$json$Json$Decode$field,
			'goalDetails',
			$elm$json$Json$Decode$list(
				$author$project$DataElement$FeedbackAccountChannelGoals$recordCacheDecoder(info)));
		var addGoalsToRecordCache = F2(
			function (accountId, records) {
				return A2(
					$elm$core$List$map,
					A2(
						$author$project$DataEngine$RecordCache$insert,
						$author$project$FieldName$fromString('Account ID'),
						accountId),
					records);
			});
		var channelGoalsForAccountsDecoder = A3(
			$elm$json$Json$Decode$map2,
			addGoalsToRecordCache,
			$author$project$Preview$Helpers$feedbackIdFieldDecoder('id'),
			goalsForAccountDecoder);
		var accountDecoder = A2(
			$elm$json$Json$Decode$map,
			$elm$core$List$concat,
			A2(
				$elm$json$Json$Decode$field,
				'accountData',
				$elm$json$Json$Decode$list(channelGoalsForAccountsDecoder)));
		var calcFeedbackAccountChannelGoals = function (feedbackData) {
			return A2(
				$krisajenkins$remotedata$RemoteData$mapError,
				$author$project$MyInsights$DecodeError,
				$krisajenkins$remotedata$RemoteData$fromResult(
					A2($elm$json$Json$Decode$decodeValue, accountDecoder, feedbackData.value)));
		};
		return A2(
			$author$project$DataElement$toCacheUpdateStep,
			A2($elm$core$Basics$composeR, $elm$core$Result$Ok, $author$project$DataEngine$CacheUpdateStep$Insert),
			A2(
				$krisajenkins$remotedata$RemoteData$map,
				$author$project$DataEngine$DataElementCache$ListCache(
					$author$project$DataElement$FeedbackAccountChannelGoals$metadata(info)),
				A2(
					$krisajenkins$remotedata$RemoteData$andThen,
					calcFeedbackAccountChannelGoals,
					$author$project$DataEngine$DataCache$getFeedbackData(cache))));
	});
var $author$project$DataElement$FeedbackAccountData$metadata = function (info) {
	return $author$project$DataEngine$RecordMetadata$fromList(
		$pzp1997$assoc_list$AssocList$toList(info.fields));
};
var $author$project$DataElement$FeedbackAccountData$recordCacheDecoder = function (info) {
	var accountFieldDecoder = function (_v1) {
		var fieldName = _v1.a;
		var fieldType = _v1.b;
		return $elm$json$Json$Decode$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$json$Json$Decode$field,
					$author$project$FieldName$toString(fieldName),
					$elm$json$Json$Decode$maybe(
						A2($author$project$Preview$Helpers$decoderForFieldType, fieldType, $elm$core$Maybe$Nothing))),
					A2(
					$elm$json$Json$Decode$at,
					_List_fromArray(
						[
							'accountDetails',
							$author$project$FieldName$toString(fieldName)
						]),
					$elm$json$Json$Decode$maybe(
						A2($author$project$Preview$Helpers$decoderForFieldType, fieldType, $elm$core$Maybe$Nothing)))
				]));
	};
	var addFieldForAccountDataDecoder = F2(
		function (_v0, decoderSoFar) {
			var fieldName = _v0.a;
			var fieldType = _v0.b;
			return A3(
				$elm$json$Json$Decode$map2,
				$author$project$Preview$Helpers$maybeApply(
					$author$project$DataEngine$RecordCache$insert(fieldName)),
				accountFieldDecoder(
					_Utils_Tuple2(fieldName, fieldType)),
				decoderSoFar);
		});
	return A3(
		$elm$core$List$foldl,
		addFieldForAccountDataDecoder,
		$elm$json$Json$Decode$succeed($author$project$DataEngine$RecordCache$empty),
		$pzp1997$assoc_list$AssocList$toList(info.fields));
};
var $author$project$DataElement$previewAccountData = F2(
	function (cache, info) {
		var acctDataDecoder = A2(
			$elm$json$Json$Decode$field,
			'accountData',
			$elm$json$Json$Decode$list(
				$author$project$DataElement$FeedbackAccountData$recordCacheDecoder(info)));
		var calcFeedbackAccountData = function (feedbackData) {
			return A2(
				$krisajenkins$remotedata$RemoteData$mapError,
				$author$project$MyInsights$DecodeError,
				$krisajenkins$remotedata$RemoteData$fromResult(
					A2($elm$json$Json$Decode$decodeValue, acctDataDecoder, feedbackData.value)));
		};
		return A2(
			$author$project$DataElement$toCacheUpdateStep,
			A2($elm$core$Basics$composeR, $elm$core$Result$Ok, $author$project$DataEngine$CacheUpdateStep$Insert),
			A2(
				$krisajenkins$remotedata$RemoteData$map,
				$author$project$DataEngine$DataElementCache$ListCache(
					$author$project$DataElement$FeedbackAccountData$metadata(info)),
				A2(
					$krisajenkins$remotedata$RemoteData$andThen,
					calcFeedbackAccountData,
					$author$project$DataEngine$DataCache$getFeedbackData(cache))));
	});
var $author$project$DataElement$FeedbackAccountProductGoals$addAccountId = function (items) {
	return A2(
		$elm$core$List$cons,
		_Utils_Tuple2(
			$author$project$FieldName$fromString('Account ID'),
			$author$project$FieldType$StringType),
		items);
};
var $author$project$DataElement$FeedbackAccountProductGoals$addChannelId = function (items) {
	return A2(
		$elm$core$List$cons,
		_Utils_Tuple2(
			$author$project$FieldName$fromString('Channel ID'),
			$author$project$FieldType$StringType),
		items);
};
var $author$project$DataElement$FeedbackAccountProductGoals$fixProductId = function (_v0) {
	var fieldName = _v0.a;
	var fieldType = _v0.b;
	return _Utils_eq(
		fieldName,
		$author$project$FieldName$fromString('channelOrProductId')) ? _Utils_Tuple2(
		$author$project$FieldName$fromString('Product ID'),
		fieldType) : _Utils_Tuple2(fieldName, fieldType);
};
var $author$project$DataElement$FeedbackAccountProductGoals$metadata = function (info) {
	return $author$project$DataEngine$RecordMetadata$fromList(
		$author$project$DataElement$FeedbackAccountProductGoals$addAccountId(
			$author$project$DataElement$FeedbackAccountProductGoals$addChannelId(
				A2(
					$elm$core$List$map,
					$author$project$DataElement$FeedbackAccountProductGoals$fixProductId,
					$pzp1997$assoc_list$AssocList$toList(info.fields)))));
};
var $author$project$DataElement$FeedbackAccountProductGoals$recordCacheDecoder = function (info) {
	return A3(
		$elm$core$List$foldl,
		A2(
			$author$project$Preview$Helpers$addFieldWithCustomNameDecoder,
			A2(
				$pzp1997$assoc_list$AssocList$singleton,
				$author$project$FieldName$fromString('channelOrProductId'),
				$author$project$FieldName$fromString('Product ID')),
			$pzp1997$assoc_list$AssocList$empty),
		$elm$json$Json$Decode$succeed($author$project$DataEngine$RecordCache$empty),
		$pzp1997$assoc_list$AssocList$toList(
			A2(
				$pzp1997$assoc_list$AssocList$map,
				F2(
					function (_v0, fieldType) {
						return {_default: $elm$core$Maybe$Nothing, fieldType: fieldType};
					}),
				info.fields)));
};
var $author$project$DataElement$previewAccountProductGoals = F2(
	function (cache, info) {
		var addFieldToRecordCacheList = F3(
			function (fieldName, fieldValue, records) {
				return A2(
					$elm$core$List$map,
					A2($author$project$DataEngine$RecordCache$insert, fieldName, fieldValue),
					records);
			});
		var productGoalsForChannelGoalDecoder = A3(
			$elm$json$Json$Decode$map2,
			addFieldToRecordCacheList(
				$author$project$FieldName$fromString('Channel ID')),
			$author$project$Preview$Helpers$feedbackIdFieldDecoder('channelOrProductId'),
			A2(
				$elm$json$Json$Decode$field,
				'productGoals',
				$elm$json$Json$Decode$list(
					$author$project$DataElement$FeedbackAccountProductGoals$recordCacheDecoder(info))));
		var goalsForAccountDecoder = A2(
			$elm$json$Json$Decode$map,
			$elm$core$List$concat,
			A2(
				$elm$json$Json$Decode$field,
				'goalDetails',
				$elm$json$Json$Decode$list(productGoalsForChannelGoalDecoder)));
		var productGoalsForAccountDecoder = A3(
			$elm$json$Json$Decode$map2,
			addFieldToRecordCacheList(
				$author$project$FieldName$fromString('Account ID')),
			$author$project$Preview$Helpers$feedbackIdFieldDecoder('id'),
			goalsForAccountDecoder);
		var accountsDecoder = A2(
			$elm$json$Json$Decode$map,
			$elm$core$List$concat,
			A2(
				$elm$json$Json$Decode$field,
				'accountData',
				$elm$json$Json$Decode$list(productGoalsForAccountDecoder)));
		var calcFeedbackAccountProductGoals = function (feedbackData) {
			return A2(
				$krisajenkins$remotedata$RemoteData$mapError,
				$author$project$MyInsights$DecodeError,
				$krisajenkins$remotedata$RemoteData$fromResult(
					A2($elm$json$Json$Decode$decodeValue, accountsDecoder, feedbackData.value)));
		};
		return A2(
			$author$project$DataElement$toCacheUpdateStep,
			A2($elm$core$Basics$composeR, $elm$core$Result$Ok, $author$project$DataEngine$CacheUpdateStep$Insert),
			A2(
				$krisajenkins$remotedata$RemoteData$map,
				$author$project$DataEngine$DataElementCache$ListCache(
					$author$project$DataElement$FeedbackAccountProductGoals$metadata(info)),
				A2(
					$krisajenkins$remotedata$RemoteData$andThen,
					calcFeedbackAccountProductGoals,
					$author$project$DataEngine$DataCache$getFeedbackData(cache))));
	});
var $author$project$MyInsights$Helpers$listOfProductsForMetrics = function (metrics) {
	return $elm_community$list_extra$List$Extra$unique(
		A2(
			$elm$core$List$concatMap,
			$elm$core$Dict$keys,
			$elm$core$Dict$values(metrics)));
};
var $author$project$DataElement$FeedbackAccountProductMetrics$addAccountId = function (items) {
	return A2(
		$elm$core$List$cons,
		_Utils_Tuple2(
			$author$project$FieldName$fromString('Account ID'),
			$author$project$FieldType$StringType),
		items);
};
var $author$project$DataElement$FeedbackAccountProductMetrics$metadata = function (info) {
	return $author$project$DataEngine$RecordMetadata$fromList(
		$author$project$DataElement$FeedbackAccountProductMetrics$addAccountId(
			$pzp1997$assoc_list$AssocList$toList(info.fields)));
};
var $author$project$MyInsights$Helpers$innerMetricsDictDecoder = A3(
	$elm$json$Json$Decode$map2,
	$elm$core$Tuple$pair,
	A2($elm$json$Json$Decode$field, 'metric', $elm$json$Json$Decode$string),
	A2(
		$elm$json$Json$Decode$field,
		'productMetricValues',
		$elm$json$Json$Decode$dict($elm$json$Json$Decode$value)));
var $author$project$MyInsights$Helpers$metricsDictDecoder = A2(
	$elm$json$Json$Decode$field,
	'productMetricDetails',
	A2(
		$elm$json$Json$Decode$map,
		$elm$core$Dict$fromList,
		$elm$json$Json$Decode$list($author$project$MyInsights$Helpers$innerMetricsDictDecoder)));
var $author$project$DataElement$previewAccountProductMetrics = F2(
	function (cache, info) {
		var makeRecordCache = F2(
			function (metricsDict, productName) {
				var addFieldToRecordCache = F2(
					function (_v3, resultSoFar) {
						var fieldName = _v3.a;
						var fieldType = _v3.b;
						if (resultSoFar.$ === 'Err') {
							var e = resultSoFar.a;
							return $elm$core$Result$Err(e);
						} else {
							var recordCacheSoFar = resultSoFar.a;
							var _v1 = A2(
								$elm$core$Dict$get,
								$author$project$FieldName$toString(fieldName),
								metricsDict);
							if (_v1.$ === 'Nothing') {
								return $elm$core$Result$Err('Cannot find field');
							} else {
								var innerDict = _v1.a;
								var _v2 = A2($elm$core$Dict$get, productName, innerDict);
								if (_v2.$ === 'Nothing') {
									return $elm$core$Result$Ok(recordCacheSoFar);
								} else {
									var value = _v2.a;
									return A2(
										$elm$core$Result$map,
										function (maybeFieldValue) {
											return A4(
												$elm_community$maybe_extra$Maybe$Extra$unwrap,
												$elm$core$Basics$identity,
												$author$project$DataEngine$RecordCache$insert(fieldName),
												maybeFieldValue,
												recordCacheSoFar);
										},
										A2(
											$elm$core$Result$mapError,
											$elm$json$Json$Decode$errorToString,
											A2(
												$elm$json$Json$Decode$decodeValue,
												A2(
													$author$project$Preview$Helpers$fieldDecoder,
													{_default: $elm$core$Maybe$Nothing, fieldType: fieldType},
													$elm$core$Maybe$Nothing),
												value)));
								}
							}
						}
					});
				return A3(
					$elm$core$List$foldl,
					addFieldToRecordCache,
					$elm$core$Result$Ok($author$project$DataEngine$RecordCache$empty),
					$pzp1997$assoc_list$AssocList$toList(info.fields));
			});
		var productRecordCacheDecoder = function (metricsDict) {
			return $elm_community$json_extra$Json$Decode$Extra$fromResult(
				$elm_community$result_extra$Result$Extra$combine(
					A2(
						$elm$core$List$map,
						makeRecordCache(metricsDict),
						$author$project$MyInsights$Helpers$listOfProductsForMetrics(metricsDict))));
		};
		var addAccountIdToMetricRecordCaches = F2(
			function (accountId, records) {
				return A2(
					$elm$core$List$map,
					A2(
						$author$project$DataEngine$RecordCache$insert,
						$author$project$FieldName$fromString('Account ID'),
						accountId),
					records);
			});
		var productMetricsForAccountsDecoder = A3(
			$elm$json$Json$Decode$map2,
			addAccountIdToMetricRecordCaches,
			$author$project$Preview$Helpers$feedbackIdFieldDecoder('id'),
			A2($elm$json$Json$Decode$andThen, productRecordCacheDecoder, $author$project$MyInsights$Helpers$metricsDictDecoder));
		var accountDecoder = A2(
			$elm$json$Json$Decode$map,
			$elm$core$List$concat,
			A2(
				$elm$json$Json$Decode$field,
				'accountData',
				$elm$json$Json$Decode$list(productMetricsForAccountsDecoder)));
		var calcFeedbackAccountProductMetrics = function (feedbackData) {
			return A2(
				$krisajenkins$remotedata$RemoteData$mapError,
				$author$project$MyInsights$DecodeError,
				$krisajenkins$remotedata$RemoteData$fromResult(
					A2($elm$json$Json$Decode$decodeValue, accountDecoder, feedbackData.value)));
		};
		return A2(
			$author$project$DataElement$toCacheUpdateStep,
			A2($elm$core$Basics$composeR, $elm$core$Result$Ok, $author$project$DataEngine$CacheUpdateStep$Insert),
			A2(
				$krisajenkins$remotedata$RemoteData$map,
				$author$project$DataEngine$DataElementCache$ListCache(
					$author$project$DataElement$FeedbackAccountProductMetrics$metadata(info)),
				A2(
					$krisajenkins$remotedata$RemoteData$andThen,
					calcFeedbackAccountProductMetrics,
					$author$project$DataEngine$DataCache$getFeedbackData(cache))));
	});
var $author$project$DataElement$FeedbackChannelGoals$fixChannelId = function (_v0) {
	var fieldName = _v0.a;
	var fieldType = _v0.b;
	return _Utils_eq(
		fieldName,
		$author$project$FieldName$fromString('channelOrProductId')) ? _Utils_Tuple2(
		$author$project$FieldName$fromString('Channel ID'),
		fieldType) : _Utils_Tuple2(fieldName, fieldType);
};
var $author$project$DataElement$FeedbackChannelGoals$metadata = function (info) {
	return $author$project$DataEngine$RecordMetadata$fromList(
		A2(
			$elm$core$List$map,
			$author$project$DataElement$FeedbackChannelGoals$fixChannelId,
			$pzp1997$assoc_list$AssocList$toList(info.fields)));
};
var $author$project$DataElement$FeedbackChannelGoals$recordCacheDecoder = function (info) {
	return A3(
		$elm$core$List$foldl,
		A2(
			$author$project$Preview$Helpers$addFieldWithCustomNameDecoder,
			A2(
				$pzp1997$assoc_list$AssocList$singleton,
				$author$project$FieldName$fromString('channelOrProductId'),
				$author$project$FieldName$fromString('Channel ID')),
			$pzp1997$assoc_list$AssocList$empty),
		$elm$json$Json$Decode$succeed($author$project$DataEngine$RecordCache$empty),
		$pzp1997$assoc_list$AssocList$toList(
			A2(
				$pzp1997$assoc_list$AssocList$map,
				F2(
					function (_v0, fieldType) {
						return {_default: $elm$core$Maybe$Nothing, fieldType: fieldType};
					}),
				info.fields)));
};
var $author$project$DataElement$previewChannelGoals = F2(
	function (cache, info) {
		var goalsDecoder = A2(
			$elm$json$Json$Decode$field,
			'totalGoals',
			$elm$json$Json$Decode$list(
				$author$project$DataElement$FeedbackChannelGoals$recordCacheDecoder(info)));
		var calcFeedbackChannelGoals = function (feedbackData) {
			return A2(
				$krisajenkins$remotedata$RemoteData$mapError,
				$author$project$MyInsights$DecodeError,
				$krisajenkins$remotedata$RemoteData$fromResult(
					A2($elm$json$Json$Decode$decodeValue, goalsDecoder, feedbackData.value)));
		};
		return A2(
			$author$project$DataElement$toCacheUpdateStep,
			A2($elm$core$Basics$composeR, $elm$core$Result$Ok, $author$project$DataEngine$CacheUpdateStep$Insert),
			A2(
				$krisajenkins$remotedata$RemoteData$map,
				$author$project$DataEngine$DataElementCache$ListCache(
					$author$project$DataElement$FeedbackChannelGoals$metadata(info)),
				A2(
					$krisajenkins$remotedata$RemoteData$andThen,
					calcFeedbackChannelGoals,
					$author$project$DataEngine$DataCache$getFeedbackData(cache))));
	});
var $author$project$DataElement$previewCrmDataEngineQuery = F2(
	function (cache, info) {
		return A2(
			$elm$core$Maybe$map,
			$author$project$DataEngine$CacheUpdateStep$RunQuery,
			A2($author$project$DataElement$crmDataEngineQueryToQueryDetails, cache, info));
	});
var $author$project$DataElement$previewCrmQuery = F2(
	function (cache, info) {
		var _v0 = info.whereClause;
		if (_v0.$ === 'Nothing') {
			return $elm$core$Maybe$Just(
				$author$project$DataEngine$CacheUpdateStep$RunQuery(
					A3(
						$author$project$DataEngine$QueryToRun$CrmQuery,
						$author$project$DataElement$basicCrmQuery(info),
						$author$project$DataElement$metadataForFieldInfoDict(info.fields),
						$author$project$DataElement$basicQueryDecoder(info))));
		} else {
			var whereClause = _v0.a;
			return A2(
				$author$project$DataElement$toCacheUpdateStep,
				$author$project$DataEngine$CacheUpdateStep$RunQuery,
				A2(
					$krisajenkins$remotedata$RemoteData$map,
					function (complexWhere) {
						return A3(
							$author$project$DataEngine$QueryToRun$CrmQuery,
							A2(
								$author$project$MyInsights$setComplexWhere,
								complexWhere,
								$author$project$DataElement$basicCrmQuery(info)),
							$author$project$DataElement$metadataForFieldInfoDict(info.fields),
							$author$project$DataElement$basicQueryDecoder(info));
					},
					A3($author$project$DataElement$previewWhereClause, $author$project$MyInsights$Helpers$Crm, cache, whereClause)));
		}
	});
var $author$project$DataElement$AlignedTerritories$fields = $pzp1997$assoc_list$AssocList$fromList($author$project$DataElement$AlignedTerritories$fieldList);
var $author$project$DataElement$CallAttendees$fields = A2(
	$pzp1997$assoc_list$AssocList$singleton,
	$author$project$FieldName$fromString($author$project$DataElement$CallAttendees$fieldName),
	$author$project$FieldType$StringType);
var $author$project$DataElement$Datepicker$fieldName = $author$project$FieldName$fromString('Selection');
var $author$project$DataElement$Datepicker$fields = $pzp1997$assoc_list$AssocList$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2($author$project$DataElement$Datepicker$fieldName, $author$project$FieldType$DateType)
		]));
var $author$project$DataElement$Dropdown$fieldName = $author$project$FieldName$fromString('Selection');
var $author$project$DataElement$Dropdown$fields = $pzp1997$assoc_list$AssocList$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2($author$project$DataElement$Dropdown$fieldName, $author$project$FieldType$StringType)
		]));
var $author$project$DataElement$FeedbackAccountChannelGoals$fields = function (info) {
	return $pzp1997$assoc_list$AssocList$fromList(
		$author$project$DataElement$FeedbackAccountChannelGoals$addAccountId(
			A2(
				$elm$core$List$map,
				$author$project$DataElement$FeedbackAccountChannelGoals$fixChannelId,
				$pzp1997$assoc_list$AssocList$toList(info.fields))));
};
var $author$project$DataElement$FeedbackAccountData$fields = function (info) {
	return info.fields;
};
var $author$project$DataElement$FeedbackAccountProductGoals$fields = function (info) {
	return $pzp1997$assoc_list$AssocList$fromList(
		$author$project$DataElement$FeedbackAccountProductGoals$addAccountId(
			$author$project$DataElement$FeedbackAccountProductGoals$addChannelId(
				A2(
					$elm$core$List$map,
					$author$project$DataElement$FeedbackAccountProductGoals$fixProductId,
					$pzp1997$assoc_list$AssocList$toList(info.fields)))));
};
var $author$project$DataElement$FeedbackAccountProductMetrics$fields = function (info) {
	return $pzp1997$assoc_list$AssocList$fromList(
		$author$project$DataElement$FeedbackAccountProductMetrics$addAccountId(
			$pzp1997$assoc_list$AssocList$toList(info.fields)));
};
var $author$project$DataElement$FeedbackChannelGoals$fields = function (info) {
	return $pzp1997$assoc_list$AssocList$fromList(
		A2(
			$elm$core$List$map,
			$author$project$DataElement$FeedbackChannelGoals$fixChannelId,
			$pzp1997$assoc_list$AssocList$toList(info.fields)));
};
var $author$project$DataElement$FeedbackProductGoals$addChannelId = function (items) {
	return A2(
		$elm$core$List$cons,
		_Utils_Tuple2(
			$author$project$FieldName$fromString('Channel ID'),
			$author$project$FieldType$StringType),
		items);
};
var $author$project$DataElement$FeedbackProductGoals$fixProductId = function (_v0) {
	var fieldName = _v0.a;
	var fieldType = _v0.b;
	return _Utils_eq(
		fieldName,
		$author$project$FieldName$fromString('channelOrProductId')) ? _Utils_Tuple2(
		$author$project$FieldName$fromString('Product ID'),
		fieldType) : _Utils_Tuple2(fieldName, fieldType);
};
var $author$project$DataElement$FeedbackProductGoals$fields = function (info) {
	return $pzp1997$assoc_list$AssocList$fromList(
		$author$project$DataElement$FeedbackProductGoals$addChannelId(
			A2(
				$elm$core$List$map,
				$author$project$DataElement$FeedbackProductGoals$fixProductId,
				$pzp1997$assoc_list$AssocList$toList(info.fields))));
};
var $pzp1997$assoc_list$AssocList$update = F3(
	function (targetKey, alter, dict) {
		var alist = dict.a;
		var maybeValue = A2($pzp1997$assoc_list$AssocList$get, targetKey, dict);
		if (maybeValue.$ === 'Just') {
			var _v1 = alter(maybeValue);
			if (_v1.$ === 'Just') {
				var alteredValue = _v1.a;
				return $pzp1997$assoc_list$AssocList$D(
					A2(
						$elm$core$List$map,
						function (entry) {
							var key = entry.a;
							return _Utils_eq(key, targetKey) ? _Utils_Tuple2(targetKey, alteredValue) : entry;
						},
						alist));
			} else {
				return A2($pzp1997$assoc_list$AssocList$remove, targetKey, dict);
			}
		} else {
			var _v2 = alter($elm$core$Maybe$Nothing);
			if (_v2.$ === 'Just') {
				var alteredValue = _v2.a;
				return $pzp1997$assoc_list$AssocList$D(
					A2(
						$elm$core$List$cons,
						_Utils_Tuple2(targetKey, alteredValue),
						alist));
			} else {
				return dict;
			}
		}
	});
var $author$project$DataElement$MergeList$fields = function (_v0) {
	var matrix = _v0.a;
	var addFieldForRef = F2(
		function (listElem, _v2) {
			var label = _v2.a;
			var fieldName = _v2.b;
			return A2(
				$pzp1997$assoc_list$AssocList$update,
				label,
				function (currentList) {
					return $elm$core$Maybe$Just(
						A2(
							$elm$core$List$cons,
							_Utils_Tuple2(listElem, fieldName),
							A2($elm$core$Maybe$withDefault, _List_Nil, currentList)));
				});
		});
	var addAllFieldsForRef = F2(
		function (_v1, currentDict) {
			var listElem = _v1.a;
			var fieldDict = _v1.b;
			return A3(
				$elm$core$List$foldl,
				addFieldForRef(listElem),
				currentDict,
				$pzp1997$assoc_list$AssocList$toList(fieldDict));
		});
	return A3($elm$core$List$foldr, addAllFieldsForRef, $pzp1997$assoc_list$AssocList$empty, matrix);
};
var $author$project$DataElement$Now$fieldName = $author$project$FieldName$fromString('Now');
var $author$project$DataElement$Now$fields = $pzp1997$assoc_list$AssocList$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2($author$project$DataElement$Now$fieldName, $author$project$FieldType$DateTimeType)
		]));
var $author$project$DataElement$Today$fieldName = $author$project$FieldName$fromString('Today');
var $author$project$DataElement$Today$fields = $pzp1997$assoc_list$AssocList$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2($author$project$DataElement$Today$fieldName, $author$project$FieldType$DateType)
		]));
var $author$project$DataElement$Expression$localFieldDataType = function (localField) {
	switch (localField.$) {
		case 'LocalStringExpr':
			return $author$project$FieldType$StringType;
		case 'LocalNumberExpr':
			return $author$project$FieldType$NumberType;
		case 'LocalDateExpr':
			return $author$project$FieldType$DateType;
		case 'LocalDateTimeExpr':
			return $author$project$FieldType$DateTimeType;
		default:
			return $author$project$FieldType$BoolType;
	}
};
var $author$project$DataElement$getFieldTypeByRefAndName = F3(
	function (elementCollection, listRef, fieldName) {
		getFieldTypeByRefAndName:
		while (true) {
			var _v2 = A2(
				$elm$core$Maybe$map,
				$author$project$DataElement$unwrapElement,
				A2($author$project$DataElement$getDataElementFromReferenceElement, elementCollection, listRef));
			if (_v2.$ === 'Just') {
				if (_v2.a.$ === 'RecordList') {
					switch (_v2.a.a.$) {
						case 'CrmQuery':
							var queryInfo = _v2.a.a.a;
							return A2(
								$elm$core$Maybe$map,
								function ($) {
									return $.fieldType;
								},
								A2($pzp1997$assoc_list$AssocList$get, fieldName, queryInfo.fields));
						case 'SalesQuery':
							return A2($pzp1997$assoc_list$AssocList$get, fieldName, $author$project$DataElement$SalesQuery$fields);
						case 'NitroQuery':
							var queryInfo = _v2.a.a.a;
							return A2(
								$elm$core$Maybe$map,
								function ($) {
									return $.fieldType;
								},
								A2($pzp1997$assoc_list$AssocList$get, fieldName, queryInfo.fields));
						case 'CrmDataEngineQuery':
							var queryInfo = _v2.a.a.a;
							return A2(
								$pzp1997$assoc_list$AssocList$get,
								fieldName,
								$author$project$DataElement$CrmDataEngineQuery$fields(queryInfo));
						case 'CalcOneForOne':
							var oneForOne = _v2.a.a.a;
							return A2(
								$elm$core$Maybe$map,
								$author$project$DataElement$Expression$localFieldDataType,
								A2($pzp1997$assoc_list$AssocList$get, fieldName, oneForOne.fields));
						case 'CalcSortList':
							var sortInfo = _v2.a.a.a;
							var $temp$elementCollection = elementCollection,
								$temp$listRef = sortInfo.original,
								$temp$fieldName = fieldName;
							elementCollection = $temp$elementCollection;
							listRef = $temp$listRef;
							fieldName = $temp$fieldName;
							continue getFieldTypeByRefAndName;
						case 'CalcFilterList':
							var filterInfo = _v2.a.a.a;
							var $temp$elementCollection = elementCollection,
								$temp$listRef = filterInfo.original,
								$temp$fieldName = fieldName;
							elementCollection = $temp$elementCollection;
							listRef = $temp$listRef;
							fieldName = $temp$fieldName;
							continue getFieldTypeByRefAndName;
						case 'CalcSublist':
							var sublistInfo = _v2.a.a.a;
							var $temp$elementCollection = elementCollection,
								$temp$listRef = sublistInfo.original,
								$temp$fieldName = fieldName;
							elementCollection = $temp$elementCollection;
							listRef = $temp$listRef;
							fieldName = $temp$fieldName;
							continue getFieldTypeByRefAndName;
						case 'CalcMergeList':
							var mergeListInfo = _v2.a.a.a;
							return A3($author$project$DataElement$getMergeListFieldTypeByRefAndName, mergeListInfo, elementCollection, fieldName);
						case 'AlignedTerritories':
							return A2($pzp1997$assoc_list$AssocList$get, fieldName, $author$project$DataElement$AlignedTerritories$fields);
						case 'FeedbackChannelGoals':
							var feedbackChannelGoalsInfo = _v2.a.a.a;
							return A2(
								$pzp1997$assoc_list$AssocList$get,
								fieldName,
								$author$project$DataElement$FeedbackChannelGoals$fields(feedbackChannelGoalsInfo));
						case 'FeedbackProductGoals':
							var feedbackProductGoalsInfo = _v2.a.a.a;
							return A2(
								$pzp1997$assoc_list$AssocList$get,
								fieldName,
								$author$project$DataElement$FeedbackProductGoals$fields(feedbackProductGoalsInfo));
						case 'FeedbackAccountData':
							var feedbackAccountDataInfo = _v2.a.a.a;
							return A2(
								$pzp1997$assoc_list$AssocList$get,
								fieldName,
								$author$project$DataElement$FeedbackAccountData$fields(feedbackAccountDataInfo));
						case 'FeedbackAccountChannelGoals':
							var feedbackAccountChannelGoalsInfo = _v2.a.a.a;
							return A2(
								$pzp1997$assoc_list$AssocList$get,
								fieldName,
								$author$project$DataElement$FeedbackAccountChannelGoals$fields(feedbackAccountChannelGoalsInfo));
						case 'FeedbackAccountProductGoals':
							var feedbackAccountProductGoalsInfo = _v2.a.a.a;
							return A2(
								$pzp1997$assoc_list$AssocList$get,
								fieldName,
								$author$project$DataElement$FeedbackAccountProductGoals$fields(feedbackAccountProductGoalsInfo));
						case 'FeedbackAccountProductMetrics':
							var feedbackAccountProductMetricsInfo = _v2.a.a.a;
							return A2(
								$pzp1997$assoc_list$AssocList$get,
								fieldName,
								$author$project$DataElement$FeedbackAccountProductMetrics$fields(feedbackAccountProductMetricsInfo));
						default:
							var _v3 = _v2.a.a;
							return A2($pzp1997$assoc_list$AssocList$get, fieldName, $author$project$DataElement$CallAttendees$fields);
					}
				} else {
					if (_v2.a.a.$ === 'FeedbackOverview') {
						var feedbackOverviewInfo = _v2.a.a.a;
						return A2($pzp1997$assoc_list$AssocList$get, fieldName, feedbackOverviewInfo.fields);
					} else {
						return $elm$core$Maybe$Nothing;
					}
				}
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}
	});
var $author$project$DataElement$getMergeListFieldTypeByRefAndName = F3(
	function (info, elementDict, fieldName) {
		var fieldTypePerUuid = function (_v1) {
			var listRef = _v1.a;
			var inputFieldName = _v1.b;
			return A3($author$project$DataElement$getFieldTypeByRefAndName, elementDict, listRef, inputFieldName);
		};
		var checkSameFieldType = function (fieldTypes) {
			var _v0 = $elm_community$list_extra$List$Extra$unique(fieldTypes);
			if (_v0.b && (!_v0.b.b)) {
				var item = _v0.a;
				return item;
			} else {
				return $elm$core$Maybe$Nothing;
			}
		};
		var getFieldType = function (fieldsByUuids) {
			return checkSameFieldType(
				A2($elm$core$List$map, fieldTypePerUuid, fieldsByUuids));
		};
		return A2(
			$elm$core$Maybe$andThen,
			getFieldType,
			A2(
				$pzp1997$assoc_list$AssocList$get,
				fieldName,
				$author$project$DataElement$MergeList$fields(info)));
	});
var $author$project$DataElement$Expression$globalFieldDataType = function (globalField) {
	switch (globalField.$) {
		case 'GlobalStringExpr':
			return $author$project$FieldType$StringType;
		case 'GlobalNumberExpr':
			return $author$project$FieldType$NumberType;
		case 'GlobalDateExpr':
			return $author$project$FieldType$DateType;
		case 'GlobalDateTimeExpr':
			return $author$project$FieldType$DateTimeType;
		default:
			return $author$project$FieldType$BoolType;
	}
};
var $author$project$DataElement$fieldDict = F2(
	function (dataElements, element) {
		if (element.$ === 'RecordList') {
			switch (element.a.$) {
				case 'CrmQuery':
					var queryInfo = element.a.a;
					return A2(
						$pzp1997$assoc_list$AssocList$map,
						function (_v1) {
							return function ($) {
								return $.fieldType;
							};
						},
						queryInfo.fields);
				case 'SalesQuery':
					return $author$project$DataElement$SalesQuery$fields;
				case 'NitroQuery':
					var queryInfo = element.a.a;
					return A2(
						$pzp1997$assoc_list$AssocList$map,
						function (_v2) {
							return function ($) {
								return $.fieldType;
							};
						},
						queryInfo.fields);
				case 'CrmDataEngineQuery':
					var queryInfo = element.a.a;
					return $author$project$DataElement$CrmDataEngineQuery$fields(queryInfo);
				case 'CalcOneForOne':
					var oneForOne = element.a.a;
					return A2(
						$pzp1997$assoc_list$AssocList$map,
						function (_v3) {
							return $author$project$DataElement$Expression$localFieldDataType;
						},
						oneForOne.fields);
				case 'CalcSortList':
					var sortInfo = element.a.a;
					return A2(
						$elm$core$Maybe$withDefault,
						$pzp1997$assoc_list$AssocList$empty,
						A2(
							$elm$core$Maybe$map,
							A2(
								$elm$core$Basics$composeR,
								$author$project$DataElement$unwrapElement,
								$author$project$DataElement$fieldDict(dataElements)),
							A2($author$project$DataElement$getDataElementFromReferenceElement, dataElements, sortInfo.original)));
				case 'CalcFilterList':
					var filterInfo = element.a.a;
					return A2(
						$elm$core$Maybe$withDefault,
						$pzp1997$assoc_list$AssocList$empty,
						A2(
							$elm$core$Maybe$map,
							A2(
								$elm$core$Basics$composeR,
								$author$project$DataElement$unwrapElement,
								$author$project$DataElement$fieldDict(dataElements)),
							A2($author$project$DataElement$getDataElementFromReferenceElement, dataElements, filterInfo.original)));
				case 'CalcSublist':
					var sublistInfo = element.a.a;
					return A2(
						$elm$core$Maybe$withDefault,
						$pzp1997$assoc_list$AssocList$empty,
						A2(
							$elm$core$Maybe$map,
							A2(
								$elm$core$Basics$composeR,
								$author$project$DataElement$unwrapElement,
								$author$project$DataElement$fieldDict(dataElements)),
							A2($author$project$DataElement$getDataElementFromReferenceElement, dataElements, sublistInfo.original)));
				case 'CalcMergeList':
					var mergeListInfo = element.a.a;
					return $pzp1997$assoc_list$AssocList$fromList(
						A2(
							$elm$core$List$filterMap,
							function (fieldName) {
								return A2(
									$elm$core$Maybe$map,
									$elm$core$Tuple$pair(fieldName),
									A3($author$project$DataElement$getMergeListFieldTypeByRefAndName, mergeListInfo, dataElements, fieldName));
							},
							$pzp1997$assoc_list$AssocList$keys(
								$author$project$DataElement$MergeList$fields(mergeListInfo))));
				case 'AlignedTerritories':
					return $author$project$DataElement$AlignedTerritories$fields;
				case 'FeedbackChannelGoals':
					var feedbackChannelGoalsInfo = element.a.a;
					return $author$project$DataElement$FeedbackChannelGoals$fields(feedbackChannelGoalsInfo);
				case 'FeedbackProductGoals':
					var feedbackProductGoalsInfo = element.a.a;
					return $author$project$DataElement$FeedbackProductGoals$fields(feedbackProductGoalsInfo);
				case 'FeedbackAccountData':
					var feedbackAccountDataInfo = element.a.a;
					return $author$project$DataElement$FeedbackAccountData$fields(feedbackAccountDataInfo);
				case 'FeedbackAccountChannelGoals':
					var feedbackAccountChannelGoalsInfo = element.a.a;
					return $author$project$DataElement$FeedbackAccountChannelGoals$fields(feedbackAccountChannelGoalsInfo);
				case 'FeedbackAccountProductGoals':
					var feedbackAccountProductGoalsInfo = element.a.a;
					return $author$project$DataElement$FeedbackAccountProductGoals$fields(feedbackAccountProductGoalsInfo);
				case 'FeedbackAccountProductMetrics':
					var feedbackAccountProductMetricsInfo = element.a.a;
					return $author$project$DataElement$FeedbackAccountProductMetrics$fields(feedbackAccountProductMetricsInfo);
				default:
					var _v4 = element.a;
					return $author$project$DataElement$CallAttendees$fields;
			}
		} else {
			switch (element.a.$) {
				case 'FeedbackOverview':
					var overviewInfo = element.a.a;
					return overviewInfo.fields;
				case 'ContextQuery':
					var contextInfo = element.a.a;
					return $pzp1997$assoc_list$AssocList$fromList(
						_List_fromArray(
							[
								_Utils_Tuple2(contextInfo.fieldName, contextInfo.fieldType)
							]));
				case 'LimitOneCrmQuery':
					var queryInfo = element.a.a;
					return A2(
						$pzp1997$assoc_list$AssocList$map,
						function (_v5) {
							return function ($) {
								return $.fieldType;
							};
						},
						queryInfo.fields);
				case 'LimitOneSalesQuery':
					return $author$project$DataElement$SalesQuery$fields;
				case 'LimitOneNitroQuery':
					var queryInfo = element.a.a;
					return A2(
						$pzp1997$assoc_list$AssocList$map,
						function (_v6) {
							return function ($) {
								return $.fieldType;
							};
						},
						queryInfo.fields);
				case 'LimitOneCrmDataEngineQuery':
					var queryInfo = element.a.a;
					return $author$project$DataElement$CrmDataEngineQuery$fields(queryInfo);
				case 'Today':
					var _v7 = element.a;
					return $author$project$DataElement$Today$fields;
				case 'Now':
					var _v8 = element.a;
					return $author$project$DataElement$Now$fields;
				case 'CalcSummarize':
					var summarizeInfo = element.a.a;
					return A2(
						$pzp1997$assoc_list$AssocList$map,
						function (_v9) {
							return $author$project$DataElement$Expression$globalFieldDataType;
						},
						summarizeInfo.fields);
				case 'ObjectTranslation':
					return $pzp1997$assoc_list$AssocList$fromList(
						A2(
							$elm$core$List$map,
							function (fieldName) {
								return _Utils_Tuple2(fieldName, $author$project$FieldType$StringType);
							},
							$author$project$DataElement$ObjectTranslation$fieldNames));
				case 'FieldTranslation':
					var fieldTranslationInfo = element.a.a;
					return $pzp1997$assoc_list$AssocList$fromList(
						A2(
							$elm$core$List$map,
							function (fieldName) {
								return _Utils_Tuple2(fieldName, $author$project$FieldType$StringType);
							},
							$author$project$DataElement$FieldTranslation$fieldNames(fieldTranslationInfo)));
				case 'VeevaMessages':
					var vmInfo = element.a.a;
					return $pzp1997$assoc_list$AssocList$fromList(
						A2(
							$elm$core$List$map,
							function (fieldName) {
								return _Utils_Tuple2(fieldName, $author$project$FieldType$StringType);
							},
							$author$project$DataElement$VeevaMessages$fieldNames(vmInfo)));
				case 'DatepickerSelection':
					return $author$project$DataElement$Datepicker$fields;
				default:
					return $author$project$DataElement$Dropdown$fields;
			}
		}
	});
var $author$project$DataEngine$DataElementCache$getSingletonRecordCache = function (deCache) {
	if (deCache.$ === 'SingletonCache') {
		var recordCache = deCache.b;
		return $elm$core$Maybe$Just(recordCache);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$DataElement$previewDatepicker = F4(
	function (dataElements, cache, ref, info) {
		var recordCacheFromSelection = function (maybeSelection) {
			if (maybeSelection.$ === 'Nothing') {
				return $author$project$DataEngine$RecordCache$empty;
			} else {
				var selection = maybeSelection.a;
				return A3(
					$author$project$DataEngine$RecordCache$insert,
					$author$project$DataElement$Datepicker$fieldName,
					$author$project$FieldValue$DateValue(selection),
					$author$project$DataEngine$RecordCache$empty);
			}
		};
		var metadata = $author$project$DataEngine$RecordMetadata$fromList(
			$pzp1997$assoc_list$AssocList$toList(
				A2(
					$author$project$DataElement$fieldDict,
					dataElements,
					$author$project$DataElement$Singleton(
						$author$project$DataElement$DatepickerSelection(info)))));
		var defaultDate = A2(
			$elm$core$Maybe$withDefault,
			$krisajenkins$remotedata$RemoteData$Success($elm$core$Maybe$Nothing),
			A2(
				$elm$core$Maybe$map,
				$author$project$DataElement$Expression$Preview$globalDate(cache),
				info._default));
		var currentSelection = A2(
			$krisajenkins$remotedata$RemoteData$withDefault,
			$elm$core$Maybe$Nothing,
			A2(
				$krisajenkins$remotedata$RemoteData$map,
				A2(
					$elm$core$Basics$composeR,
					$author$project$DataEngine$DataElementCache$getSingletonRecordCache,
					$elm$core$Maybe$andThen(
						$author$project$DataEngine$RecordCache$getDate($author$project$DataElement$Datepicker$fieldName))),
				$author$project$DataEngine$CacheState$toRemoteData(
					A2($author$project$DataEngine$DataCache$getDataElementState, ref, cache))));
		return A2(
			$author$project$DataElement$toCacheUpdateStep,
			A2($elm$core$Basics$composeR, $elm$core$Result$Ok, $author$project$DataEngine$CacheUpdateStep$Insert),
			A2(
				$krisajenkins$remotedata$RemoteData$map,
				A2(
					$elm$core$Basics$composeR,
					recordCacheFromSelection,
					$author$project$DataEngine$DataElementCache$SingletonCache(metadata)),
				A2(
					$krisajenkins$remotedata$RemoteData$map,
					$elm_community$maybe_extra$Maybe$Extra$or(currentSelection),
					defaultDate)));
	});
var $author$project$DataEngine$CacheState$toRemoteDataRestored = function (maybeState) {
	if (maybeState.$ === 'Nothing') {
		return $krisajenkins$remotedata$RemoteData$NotAsked;
	} else {
		switch (maybeState.a.$) {
			case 'Loading':
				var _v1 = maybeState.a;
				return $krisajenkins$remotedata$RemoteData$Loading;
			case 'Failure':
				var err = maybeState.a.a;
				return $krisajenkins$remotedata$RemoteData$Failure(err);
			case 'Success':
				var a = maybeState.a.a;
				return $krisajenkins$remotedata$RemoteData$Success(a);
			default:
				var a = maybeState.a.a;
				return $krisajenkins$remotedata$RemoteData$Success(a);
		}
	}
};
var $author$project$ViewTypes$Select$reservedString = '___Veeva_Reserved_Placeholder___';
var $author$project$Calc$isNotReservedString = function (selection) {
	return _Utils_eq(
		function ($) {
			return $.text;
		}(selection),
		$author$project$ViewTypes$Select$reservedString) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(selection);
};
var $author$project$Calc$updateDropdownSelection = F3(
	function (requireSelection, currentSelection, options) {
		var notReservedSelection = A2($elm$core$Maybe$andThen, $author$project$Calc$isNotReservedString, currentSelection);
		var extractedOptions = $elm_community$maybe_extra$Maybe$Extra$values(options);
		if (notReservedSelection.$ === 'Just') {
			var selection = notReservedSelection.a;
			return A2(
				$elm$core$List$member,
				function ($) {
					return $.text;
				}(selection),
				A2(
					$elm$core$List$map,
					function ($) {
						return $.text;
					},
					extractedOptions)) ? notReservedSelection : (requireSelection ? $elm$core$List$head(extractedOptions) : $elm$core$Maybe$Nothing);
		} else {
			return requireSelection ? $elm$core$List$head(extractedOptions) : $elm$core$Maybe$Nothing;
		}
	});
var $author$project$DataElement$previewDropdown = F4(
	function (dataElements, cache, ref, info) {
		var recordCacheFromSelection = function (maybeSelection) {
			if (maybeSelection.$ === 'Nothing') {
				return $author$project$DataEngine$RecordCache$empty;
			} else {
				var selection = maybeSelection.a;
				return A3(
					$author$project$DataEngine$RecordCache$insert,
					$author$project$DataElement$Dropdown$fieldName,
					$author$project$FieldValue$StringValue(selection),
					$author$project$DataEngine$RecordCache$empty);
			}
		};
		var options = A2($author$project$DataElement$Expression$Preview$globalStringList, cache, info.options);
		var metadata = $author$project$DataEngine$RecordMetadata$fromList(
			$pzp1997$assoc_list$AssocList$toList(
				A2(
					$author$project$DataElement$fieldDict,
					dataElements,
					$author$project$DataElement$Singleton(
						$author$project$DataElement$InteractiveSelectSelection(info)))));
		var currentSelection = A2(
			$krisajenkins$remotedata$RemoteData$withDefault,
			$elm$core$Maybe$Nothing,
			A2(
				$krisajenkins$remotedata$RemoteData$map,
				A2(
					$elm$core$Basics$composeR,
					$author$project$DataEngine$DataElementCache$getSingletonRecordCache,
					$elm$core$Maybe$andThen(
						$author$project$DataEngine$RecordCache$getString($author$project$DataElement$Dropdown$fieldName))),
				$author$project$DataEngine$CacheState$toRemoteDataRestored(
					A2($author$project$DataEngine$DataCache$getDataElementState, ref, cache))));
		return A2(
			$author$project$DataElement$toCacheUpdateStep,
			A2($elm$core$Basics$composeR, $elm$core$Result$Ok, $author$project$DataEngine$CacheUpdateStep$Insert),
			A2(
				$krisajenkins$remotedata$RemoteData$map,
				A2(
					$elm$core$Basics$composeR,
					recordCacheFromSelection,
					$author$project$DataEngine$DataElementCache$SingletonCache(metadata)),
				A2(
					$krisajenkins$remotedata$RemoteData$map,
					A2($author$project$Calc$updateDropdownSelection, info.requireSelection, currentSelection),
					options)));
	});
var $author$project$DataElement$previewFeedbackOverview = F2(
	function (cache, info) {
		var recordCacheDecoder = A3(
			$elm$core$List$foldl,
			$author$project$Preview$Helpers$addFieldDecoder($pzp1997$assoc_list$AssocList$empty),
			$elm$json$Json$Decode$succeed($author$project$DataEngine$RecordCache$empty),
			$pzp1997$assoc_list$AssocList$toList(
				A2(
					$pzp1997$assoc_list$AssocList$map,
					F2(
						function (_v0, fieldType) {
							return {_default: $elm$core$Maybe$Nothing, fieldType: fieldType};
						}),
					info.fields)));
		var metadata = $author$project$DataEngine$RecordMetadata$fromList(
			$pzp1997$assoc_list$AssocList$toList(info.fields));
		var calcFeedbackOverview = function (feedbackData) {
			return A2(
				$krisajenkins$remotedata$RemoteData$mapError,
				$author$project$MyInsights$DecodeError,
				$krisajenkins$remotedata$RemoteData$fromResult(
					A2($elm$json$Json$Decode$decodeValue, recordCacheDecoder, feedbackData.value)));
		};
		return A2(
			$author$project$DataElement$toCacheUpdateStep,
			A2($elm$core$Basics$composeR, $elm$core$Result$Ok, $author$project$DataEngine$CacheUpdateStep$Insert),
			A2(
				$krisajenkins$remotedata$RemoteData$map,
				$author$project$DataEngine$DataElementCache$SingletonCache(metadata),
				A2(
					$krisajenkins$remotedata$RemoteData$andThen,
					calcFeedbackOverview,
					$author$project$DataEngine$DataCache$getFeedbackData(cache))));
	});
var $author$project$Calc$RelatedFieldInfo = F2(
	function (rightHandDict, localIds) {
		return {localIds: localIds, rightHandDict: rightHandDict};
	});
var $author$project$DataElement$Expression$IdToValue = function (a) {
	return {$: 'IdToValue', a: a};
};
var $Evelios$elm_hash$Hash$Hash = function (a) {
	return {$: 'Hash', a: a};
};
var $chain_partners$elm_bignum$Integer$Integer = F2(
	function (a, b) {
		return {$: 'Integer', a: a, b: b};
	});
var $chain_partners$elm_bignum$Integer$Negative = {$: 'Negative'};
var $chain_partners$elm_bignum$Integer$Positive = {$: 'Positive'};
var $chain_partners$elm_bignum$Integer$Zero = {$: 'Zero'};
var $chain_partners$elm_bignum$Integer$addMagnitudes_ = F3(
	function (m1, m2, acc) {
		addMagnitudes_:
		while (true) {
			var _v0 = _Utils_Tuple2(m1, m2);
			if (!_v0.a.b) {
				if (!_v0.b.b) {
					return $elm$core$List$reverse(acc);
				} else {
					return _Utils_ap(
						$elm$core$List$reverse(acc),
						m2);
				}
			} else {
				if (!_v0.b.b) {
					return _Utils_ap(
						$elm$core$List$reverse(acc),
						m1);
				} else {
					var _v1 = _v0.a;
					var d1 = _v1.a;
					var ds1 = _v1.b;
					var _v2 = _v0.b;
					var d2 = _v2.a;
					var ds2 = _v2.b;
					var $temp$m1 = ds1,
						$temp$m2 = ds2,
						$temp$acc = A2($elm$core$List$cons, d1 + d2, acc);
					m1 = $temp$m1;
					m2 = $temp$m2;
					acc = $temp$acc;
					continue addMagnitudes_;
				}
			}
		}
	});
var $chain_partners$elm_bignum$Integer$handleFinalCarry = function (_v0) {
	var c = _v0.a;
	var m = _v0.b;
	if (!c) {
		return m;
	} else {
		if (!m.b) {
			return _List_Nil;
		} else {
			var d = m.a;
			var ds = m.b;
			return (!(d + c)) ? ds : A2($elm$core$List$cons, c, m);
		}
	}
};
var $chain_partners$elm_bignum$Integer$defaultBase = A2($elm$core$Basics$pow, 10, 7);
var $chain_partners$elm_bignum$Integer$normalizeDigit = F2(
	function (d, _v0) {
		var prevCarry = _v0.a;
		var acc = _v0.b;
		var sum = d + prevCarry;
		var d_ = A2($elm$core$Basics$modBy, $chain_partners$elm_bignum$Integer$defaultBase, sum);
		var carry = (sum < 0) ? (-1) : ((sum / $chain_partners$elm_bignum$Integer$defaultBase) | 0);
		return _Utils_Tuple2(
			carry,
			A2($elm$core$List$cons, d_, acc));
	});
var $elm$core$List$isEmpty = function (xs) {
	if (!xs.b) {
		return true;
	} else {
		return false;
	}
};
var $chain_partners$elm_bignum$Integer$trimLeadingZeroFromMag = A2(
	$elm$core$List$foldr,
	F2(
		function (x, xs) {
			return ((!x) && $elm$core$List$isEmpty(xs)) ? _List_Nil : A2($elm$core$List$cons, x, xs);
		}),
	_List_Nil);
var $chain_partners$elm_bignum$Integer$normalizeMagnitude = function (m) {
	return $chain_partners$elm_bignum$Integer$trimLeadingZeroFromMag(
		$elm$core$List$reverse(
			$chain_partners$elm_bignum$Integer$handleFinalCarry(
				A3(
					$elm$core$List$foldl,
					$chain_partners$elm_bignum$Integer$normalizeDigit,
					_Utils_Tuple2(0, _List_Nil),
					m))));
};
var $chain_partners$elm_bignum$Integer$addMagnitudes = F2(
	function (m1, m2) {
		return $chain_partners$elm_bignum$Integer$normalizeMagnitude(
			A3($chain_partners$elm_bignum$Integer$addMagnitudes_, m1, m2, _List_Nil));
	});
var $chain_partners$elm_bignum$Integer$compareMag_ = F2(
	function (m1, m2) {
		compareMag_:
		while (true) {
			var _v0 = _Utils_Tuple2(m1, m2);
			if (!_v0.a.b) {
				if (!_v0.b.b) {
					return $elm$core$Basics$EQ;
				} else {
					var _v2 = _v0.b;
					var d = _v2.a;
					var ds = _v2.b;
					return $elm$core$Basics$LT;
				}
			} else {
				if (!_v0.b.b) {
					var _v1 = _v0.a;
					var d = _v1.a;
					var ds = _v1.b;
					return $elm$core$Basics$GT;
				} else {
					var _v3 = _v0.a;
					var d1 = _v3.a;
					var ds1 = _v3.b;
					var _v4 = _v0.b;
					var d2 = _v4.a;
					var ds2 = _v4.b;
					var _v5 = A2($elm$core$Basics$compare, d1, d2);
					switch (_v5.$) {
						case 'GT':
							return $elm$core$Basics$GT;
						case 'EQ':
							var $temp$m1 = ds1,
								$temp$m2 = ds2;
							m1 = $temp$m1;
							m2 = $temp$m2;
							continue compareMag_;
						default:
							return $elm$core$Basics$LT;
					}
				}
			}
		}
	});
var $chain_partners$elm_bignum$Integer$compareMag = F2(
	function (m1, m2) {
		var _v0 = A2(
			$elm$core$Basics$compare,
			$elm$core$List$length(m1),
			$elm$core$List$length(m2));
		switch (_v0.$) {
			case 'GT':
				return $elm$core$Basics$GT;
			case 'LT':
				return $elm$core$Basics$LT;
			default:
				return A2(
					$chain_partners$elm_bignum$Integer$compareMag_,
					$elm$core$List$reverse(m1),
					$elm$core$List$reverse(m2));
		}
	});
var $chain_partners$elm_bignum$Integer$add = F2(
	function (i1, i2) {
		var _v0 = _Utils_Tuple2(i1, i2);
		_v0$4:
		while (true) {
			if (_v0.a.$ === 'Zero') {
				var _v1 = _v0.a;
				return i2;
			} else {
				if (_v0.b.$ === 'Zero') {
					var _v2 = _v0.b;
					return i1;
				} else {
					if (_v0.a.a.$ === 'Positive') {
						if (_v0.b.a.$ === 'Negative') {
							var _v3 = _v0.a;
							var _v4 = _v3.a;
							var m1 = _v3.b;
							var _v5 = _v0.b;
							var _v6 = _v5.a;
							var m2 = _v5.b;
							var _v7 = A2($chain_partners$elm_bignum$Integer$compareMag, m1, m2);
							switch (_v7.$) {
								case 'GT':
									return A2(
										$chain_partners$elm_bignum$Integer$Integer,
										$chain_partners$elm_bignum$Integer$Positive,
										A2(
											$chain_partners$elm_bignum$Integer$addMagnitudes,
											m1,
											A2($elm$core$List$map, $elm$core$Basics$negate, m2)));
								case 'EQ':
									return $chain_partners$elm_bignum$Integer$Zero;
								default:
									return A2(
										$chain_partners$elm_bignum$Integer$Integer,
										$chain_partners$elm_bignum$Integer$Negative,
										A2(
											$chain_partners$elm_bignum$Integer$addMagnitudes,
											A2($elm$core$List$map, $elm$core$Basics$negate, m1),
											m2));
							}
						} else {
							break _v0$4;
						}
					} else {
						if (_v0.b.a.$ === 'Positive') {
							var _v8 = _v0.a;
							var _v9 = _v8.a;
							var m1 = _v8.b;
							var _v10 = _v0.b;
							var _v11 = _v10.a;
							var m2 = _v10.b;
							var _v12 = A2($chain_partners$elm_bignum$Integer$compareMag, m1, m2);
							switch (_v12.$) {
								case 'GT':
									return A2(
										$chain_partners$elm_bignum$Integer$Integer,
										$chain_partners$elm_bignum$Integer$Negative,
										A2(
											$chain_partners$elm_bignum$Integer$addMagnitudes,
											m1,
											A2($elm$core$List$map, $elm$core$Basics$negate, m2)));
								case 'EQ':
									return $chain_partners$elm_bignum$Integer$Zero;
								default:
									return A2(
										$chain_partners$elm_bignum$Integer$Integer,
										$chain_partners$elm_bignum$Integer$Positive,
										A2(
											$chain_partners$elm_bignum$Integer$addMagnitudes,
											A2($elm$core$List$map, $elm$core$Basics$negate, m1),
											m2));
							}
						} else {
							break _v0$4;
						}
					}
				}
			}
		}
		var _v13 = _v0.a;
		var s1 = _v13.a;
		var m1 = _v13.b;
		var _v14 = _v0.b;
		var s2 = _v14.a;
		var m2 = _v14.b;
		return A2(
			$chain_partners$elm_bignum$Integer$Integer,
			s1,
			A2($chain_partners$elm_bignum$Integer$addMagnitudes, m1, m2));
	});
var $chain_partners$elm_bignum$Integer$abs = function (i) {
	if (i.$ === 'Zero') {
		return $chain_partners$elm_bignum$Integer$Zero;
	} else {
		if (i.a.$ === 'Positive') {
			var _v1 = i.a;
			return i;
		} else {
			var _v2 = i.a;
			var m = i.b;
			return A2($chain_partners$elm_bignum$Integer$Integer, $chain_partners$elm_bignum$Integer$Positive, m);
		}
	}
};
var $chain_partners$elm_bignum$Integer$negate = function (i) {
	if (i.$ === 'Zero') {
		return $chain_partners$elm_bignum$Integer$Zero;
	} else {
		if (i.a.$ === 'Positive') {
			var _v1 = i.a;
			var m = i.b;
			return A2($chain_partners$elm_bignum$Integer$Integer, $chain_partners$elm_bignum$Integer$Negative, m);
		} else {
			var _v2 = i.a;
			var m = i.b;
			return A2($chain_partners$elm_bignum$Integer$Integer, $chain_partners$elm_bignum$Integer$Positive, m);
		}
	}
};
var $chain_partners$elm_bignum$Integer$adjustSign = F3(
	function (dividend, divisor, _v0) {
		var q = _v0.a;
		var r = _v0.b;
		var _v1 = _Utils_Tuple2(dividend, divisor);
		_v1$3:
		while (true) {
			if (_v1.a.$ === 'Integer') {
				if (_v1.a.a.$ === 'Positive') {
					if ((_v1.b.$ === 'Integer') && (_v1.b.a.$ === 'Negative')) {
						var _v2 = _v1.a;
						var _v3 = _v2.a;
						var _v4 = _v1.b;
						var _v5 = _v4.a;
						return _Utils_Tuple2(
							$chain_partners$elm_bignum$Integer$negate(q),
							r);
					} else {
						break _v1$3;
					}
				} else {
					if (_v1.b.$ === 'Integer') {
						if (_v1.b.a.$ === 'Positive') {
							var _v6 = _v1.a;
							var _v7 = _v6.a;
							var _v8 = _v1.b;
							var _v9 = _v8.a;
							return _Utils_Tuple2(
								$chain_partners$elm_bignum$Integer$negate(q),
								$chain_partners$elm_bignum$Integer$negate(r));
						} else {
							var _v10 = _v1.a;
							var _v11 = _v10.a;
							var _v12 = _v1.b;
							var _v13 = _v12.a;
							return _Utils_Tuple2(
								q,
								$chain_partners$elm_bignum$Integer$negate(r));
						}
					} else {
						break _v1$3;
					}
				}
			} else {
				break _v1$3;
			}
		}
		return _Utils_Tuple2(q, r);
	});
var $chain_partners$elm_bignum$Integer$reverseOrder = function (o) {
	switch (o.$) {
		case 'GT':
			return $elm$core$Basics$LT;
		case 'EQ':
			return $elm$core$Basics$EQ;
		default:
			return $elm$core$Basics$GT;
	}
};
var $chain_partners$elm_bignum$Integer$compare = F2(
	function (i1, i2) {
		var _v0 = _Utils_Tuple2(i1, i2);
		_v0$7:
		while (true) {
			if (_v0.a.$ === 'Zero') {
				if (_v0.b.$ === 'Zero') {
					var _v1 = _v0.a;
					var _v2 = _v0.b;
					return $elm$core$Basics$EQ;
				} else {
					if (_v0.b.a.$ === 'Positive') {
						var _v3 = _v0.a;
						var _v4 = _v0.b;
						var _v5 = _v4.a;
						return $elm$core$Basics$LT;
					} else {
						var _v6 = _v0.a;
						var _v7 = _v0.b;
						var _v8 = _v7.a;
						return $elm$core$Basics$GT;
					}
				}
			} else {
				if (_v0.b.$ === 'Zero') {
					if (_v0.a.a.$ === 'Positive') {
						var _v9 = _v0.a;
						var _v10 = _v9.a;
						var _v11 = _v0.b;
						return $elm$core$Basics$GT;
					} else {
						var _v12 = _v0.a;
						var _v13 = _v12.a;
						var _v14 = _v0.b;
						return $elm$core$Basics$LT;
					}
				} else {
					if (_v0.a.a.$ === 'Positive') {
						if (_v0.b.a.$ === 'Negative') {
							var _v15 = _v0.a;
							var _v16 = _v15.a;
							var _v17 = _v0.b;
							var _v18 = _v17.a;
							return $elm$core$Basics$GT;
						} else {
							break _v0$7;
						}
					} else {
						if (_v0.b.a.$ === 'Positive') {
							var _v19 = _v0.a;
							var _v20 = _v19.a;
							var _v21 = _v0.b;
							var _v22 = _v21.a;
							return $elm$core$Basics$LT;
						} else {
							break _v0$7;
						}
					}
				}
			}
		}
		var _v23 = _v0.a;
		var s1 = _v23.a;
		var m1 = _v23.b;
		var _v24 = _v0.b;
		var s2 = _v24.a;
		var m2 = _v24.b;
		var ord = A2($chain_partners$elm_bignum$Integer$compareMag, m1, m2);
		return (_Utils_eq(s1, $chain_partners$elm_bignum$Integer$Negative) && _Utils_eq(s2, $chain_partners$elm_bignum$Integer$Negative)) ? $chain_partners$elm_bignum$Integer$reverseOrder(ord) : ord;
	});
var $chain_partners$elm_bignum$Integer$magnitudeFromInt_ = F2(
	function (acc, i) {
		magnitudeFromInt_:
		while (true) {
			var q = (i / $chain_partners$elm_bignum$Integer$defaultBase) | 0;
			if (!q) {
				return $elm$core$List$reverse(
					A2($elm$core$List$cons, i, acc));
			} else {
				var $temp$acc = A2($elm$core$List$cons, i % $chain_partners$elm_bignum$Integer$defaultBase, acc),
					$temp$i = q;
				acc = $temp$acc;
				i = $temp$i;
				continue magnitudeFromInt_;
			}
		}
	});
var $chain_partners$elm_bignum$Integer$magnitudeFromInt = $chain_partners$elm_bignum$Integer$magnitudeFromInt_(_List_Nil);
var $chain_partners$elm_bignum$Integer$fromInt = function (i) {
	var _v0 = A2($elm$core$Basics$compare, i, 0);
	switch (_v0.$) {
		case 'GT':
			return A2(
				$chain_partners$elm_bignum$Integer$Integer,
				$chain_partners$elm_bignum$Integer$Positive,
				$chain_partners$elm_bignum$Integer$magnitudeFromInt(i));
		case 'EQ':
			return $chain_partners$elm_bignum$Integer$Zero;
		default:
			return A2(
				$chain_partners$elm_bignum$Integer$Integer,
				$chain_partners$elm_bignum$Integer$Negative,
				$chain_partners$elm_bignum$Integer$magnitudeFromInt(
					$elm$core$Basics$abs(i)));
	}
};
var $elm$core$List$repeatHelp = F3(
	function (result, n, value) {
		repeatHelp:
		while (true) {
			if (n <= 0) {
				return result;
			} else {
				var $temp$result = A2($elm$core$List$cons, value, result),
					$temp$n = n - 1,
					$temp$value = value;
				result = $temp$result;
				n = $temp$n;
				value = $temp$value;
				continue repeatHelp;
			}
		}
	});
var $elm$core$List$repeat = F2(
	function (n, value) {
		return A3($elm$core$List$repeatHelp, _List_Nil, n, value);
	});
var $chain_partners$elm_bignum$Integer$addScaleToPartialProducts = function (magList) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (m, _v0) {
				var digit = _v0.a;
				var acc = _v0.b;
				return _Utils_Tuple2(
					digit + 1,
					A2(
						$elm$core$List$cons,
						A2(
							$elm$core$List$append,
							A2($elm$core$List$repeat, digit, 0),
							m),
						acc));
			}),
		_Utils_Tuple2(0, _List_Nil),
		magList).b;
};
var $chain_partners$elm_bignum$Integer$calculatePartialProducts = F2(
	function (m1, m2) {
		return A2(
			$elm$core$List$map,
			function (d) {
				return A2(
					$elm$core$List$map,
					$elm$core$Basics$mul(d),
					m1);
			},
			m2);
	});
var $chain_partners$elm_bignum$Integer$sumPartialProducts = function (magList) {
	return A3($elm$core$List$foldl, $chain_partners$elm_bignum$Integer$addMagnitudes, _List_Nil, magList);
};
var $chain_partners$elm_bignum$Integer$multiplyMagnitudes = F2(
	function (m1, m2) {
		return $chain_partners$elm_bignum$Integer$normalizeMagnitude(
			$chain_partners$elm_bignum$Integer$sumPartialProducts(
				$chain_partners$elm_bignum$Integer$addScaleToPartialProducts(
					A2($chain_partners$elm_bignum$Integer$calculatePartialProducts, m1, m2))));
	});
var $chain_partners$elm_bignum$Integer$mul = F2(
	function (i1, i2) {
		var _v0 = _Utils_Tuple2(i1, i2);
		if (_v0.a.$ === 'Zero') {
			var _v1 = _v0.a;
			return $chain_partners$elm_bignum$Integer$Zero;
		} else {
			if (_v0.b.$ === 'Zero') {
				var _v2 = _v0.b;
				return $chain_partners$elm_bignum$Integer$Zero;
			} else {
				var _v3 = _v0.a;
				var s1 = _v3.a;
				var m1 = _v3.b;
				var _v4 = _v0.b;
				var s2 = _v4.a;
				var m2 = _v4.b;
				var sign = _Utils_eq(s1, s2) ? $chain_partners$elm_bignum$Integer$Positive : $chain_partners$elm_bignum$Integer$Negative;
				var magnitude = function () {
					var _v5 = A2(
						$elm$core$Basics$compare,
						$elm$core$List$length(m1),
						$elm$core$List$length(m2));
					if (_v5.$ === 'GT') {
						return A2($chain_partners$elm_bignum$Integer$multiplyMagnitudes, m1, m2);
					} else {
						return A2($chain_partners$elm_bignum$Integer$multiplyMagnitudes, m2, m1);
					}
				}();
				return A2($chain_partners$elm_bignum$Integer$Integer, sign, magnitude);
			}
		}
	});
var $chain_partners$elm_bignum$Integer$one = A2(
	$chain_partners$elm_bignum$Integer$Integer,
	$chain_partners$elm_bignum$Integer$Positive,
	_List_fromArray(
		[1]));
var $chain_partners$elm_bignum$Integer$sub = F2(
	function (i1, i2) {
		var _v0 = _Utils_Tuple2(i1, i2);
		if (_v0.a.$ === 'Zero') {
			var _v1 = _v0.a;
			return $chain_partners$elm_bignum$Integer$negate(i2);
		} else {
			if (_v0.b.$ === 'Zero') {
				var _v2 = _v0.b;
				return i1;
			} else {
				var _v3 = _v0.a;
				var s1 = _v3.a;
				var m1 = _v3.b;
				var _v4 = _v0.b;
				var s2 = _v4.a;
				var m2 = _v4.b;
				return A2(
					$chain_partners$elm_bignum$Integer$add,
					i1,
					$chain_partners$elm_bignum$Integer$negate(i2));
			}
		}
	});
var $chain_partners$elm_bignum$Integer$divmodPartialDividend = F4(
	function (dividend, divisor, divExpediter, acc) {
		divmodPartialDividend:
		while (true) {
			var _v0 = A2($chain_partners$elm_bignum$Integer$compare, dividend, divisor);
			switch (_v0.$) {
				case 'LT':
					return _Utils_Tuple2(acc, dividend);
				case 'EQ':
					return _Utils_Tuple2(
						A2($chain_partners$elm_bignum$Integer$add, acc, $chain_partners$elm_bignum$Integer$one),
						$chain_partners$elm_bignum$Integer$Zero);
				default:
					var divisorTimesDivExpediter = A2(
						$chain_partners$elm_bignum$Integer$mul,
						divisor,
						$chain_partners$elm_bignum$Integer$fromInt(divExpediter));
					var _v1 = A2($chain_partners$elm_bignum$Integer$compare, dividend, divisorTimesDivExpediter);
					switch (_v1.$) {
						case 'LT':
							var $temp$dividend = dividend,
								$temp$divisor = divisor,
								$temp$divExpediter = (divExpediter / 2) | 0,
								$temp$acc = acc;
							dividend = $temp$dividend;
							divisor = $temp$divisor;
							divExpediter = $temp$divExpediter;
							acc = $temp$acc;
							continue divmodPartialDividend;
						case 'EQ':
							return _Utils_Tuple2(
								A2(
									$chain_partners$elm_bignum$Integer$add,
									acc,
									$chain_partners$elm_bignum$Integer$fromInt(divExpediter)),
								$chain_partners$elm_bignum$Integer$Zero);
						default:
							var dividend_ = A2($chain_partners$elm_bignum$Integer$sub, dividend, divisorTimesDivExpediter);
							var $temp$dividend = dividend_,
								$temp$divisor = divisor,
								$temp$divExpediter = divExpediter,
								$temp$acc = A2(
								$chain_partners$elm_bignum$Integer$add,
								acc,
								$chain_partners$elm_bignum$Integer$fromInt(divExpediter));
							dividend = $temp$dividend;
							divisor = $temp$divisor;
							divExpediter = $temp$divExpediter;
							acc = $temp$acc;
							continue divmodPartialDividend;
					}
			}
		}
	});
var $chain_partners$elm_bignum$Integer$headAndTail = function (i) {
	if (i.$ === 'Zero') {
		return _Utils_Tuple2($chain_partners$elm_bignum$Integer$Zero, $chain_partners$elm_bignum$Integer$Zero);
	} else {
		var s = i.a;
		var m = i.b;
		var rM = $elm$core$List$reverse(m);
		if (!rM.b) {
			return _Utils_Tuple2($chain_partners$elm_bignum$Integer$Zero, $chain_partners$elm_bignum$Integer$Zero);
		} else {
			if (!rM.b.b) {
				var d = rM.a;
				return _Utils_Tuple2(
					$chain_partners$elm_bignum$Integer$fromInt(d),
					$chain_partners$elm_bignum$Integer$Zero);
			} else {
				var d = rM.a;
				var ds = rM.b;
				return _Utils_Tuple2(
					$chain_partners$elm_bignum$Integer$fromInt(d),
					A2(
						$chain_partners$elm_bignum$Integer$Integer,
						s,
						$elm$core$List$reverse(ds)));
			}
		}
	}
};
var $chain_partners$elm_bignum$Integer$shiftRightBy = F2(
	function (n, i) {
		shiftRightBy:
		while (true) {
			if (i.$ === 'Zero') {
				return $chain_partners$elm_bignum$Integer$Zero;
			} else {
				var s = i.a;
				var m = i.b;
				if (n <= 0) {
					return i;
				} else {
					var $temp$n = n - 1,
						$temp$i = A2(
						$chain_partners$elm_bignum$Integer$Integer,
						s,
						A2($elm$core$List$cons, 0, m));
					n = $temp$n;
					i = $temp$i;
					continue shiftRightBy;
				}
			}
		}
	});
var $chain_partners$elm_bignum$Integer$divmod_ = F4(
	function (dividend, divisor, qAcc, prevR) {
		divmod_:
		while (true) {
			var _v0 = _Utils_Tuple2(dividend, divisor);
			if (_v0.a.$ === 'Zero') {
				var _v1 = _v0.a;
				return $elm$core$Maybe$Just(
					_Utils_Tuple2(qAcc, prevR));
			} else {
				var _v2 = $chain_partners$elm_bignum$Integer$headAndTail(dividend);
				var firstDigit = _v2.a;
				var remainingDigits = _v2.b;
				var currentDividend = A2(
					$chain_partners$elm_bignum$Integer$add,
					firstDigit,
					A2($chain_partners$elm_bignum$Integer$shiftRightBy, 1, prevR));
				var _v3 = A4($chain_partners$elm_bignum$Integer$divmodPartialDividend, currentDividend, divisor, $chain_partners$elm_bignum$Integer$defaultBase, $chain_partners$elm_bignum$Integer$Zero);
				var q = _v3.a;
				var r = _v3.b;
				var qAcc_ = A2(
					$chain_partners$elm_bignum$Integer$add,
					q,
					A2($chain_partners$elm_bignum$Integer$shiftRightBy, 1, qAcc));
				var $temp$dividend = remainingDigits,
					$temp$divisor = divisor,
					$temp$qAcc = qAcc_,
					$temp$prevR = r;
				dividend = $temp$dividend;
				divisor = $temp$divisor;
				qAcc = $temp$qAcc;
				prevR = $temp$prevR;
				continue divmod_;
			}
		}
	});
var $chain_partners$elm_bignum$Integer$divmod = F2(
	function (dividend, divisor) {
		var _v0 = _Utils_Tuple2(dividend, divisor);
		_v0$0:
		while (true) {
			_v0$4:
			while (true) {
				if (_v0.b.$ === 'Zero') {
					if (_v0.a.$ === 'Zero') {
						break _v0$0;
					} else {
						var _v2 = _v0.b;
						return $elm$core$Maybe$Nothing;
					}
				} else {
					if (_v0.a.$ === 'Zero') {
						break _v0$0;
					} else {
						if (_v0.b.a.$ === 'Positive') {
							if ((_v0.b.b.b && (_v0.b.b.a === 1)) && (!_v0.b.b.b.b)) {
								var _v3 = _v0.b;
								var _v4 = _v3.a;
								var _v5 = _v3.b;
								return $elm$core$Maybe$Just(
									_Utils_Tuple2(dividend, $chain_partners$elm_bignum$Integer$Zero));
							} else {
								break _v0$4;
							}
						} else {
							if ((_v0.b.b.b && (_v0.b.b.a === 1)) && (!_v0.b.b.b.b)) {
								var _v6 = _v0.b;
								var _v7 = _v6.a;
								var _v8 = _v6.b;
								return $elm$core$Maybe$Just(
									_Utils_Tuple2(
										$chain_partners$elm_bignum$Integer$negate(dividend),
										$chain_partners$elm_bignum$Integer$Zero));
							} else {
								break _v0$4;
							}
						}
					}
				}
			}
			var _v9 = _v0.a;
			var s1 = _v9.a;
			var m1 = _v9.b;
			var _v10 = _v0.b;
			var s2 = _v10.a;
			var m2 = _v10.b;
			var _v11 = A2($chain_partners$elm_bignum$Integer$compareMag, m1, m2);
			switch (_v11.$) {
				case 'LT':
					return $elm$core$Maybe$Just(
						_Utils_Tuple2($chain_partners$elm_bignum$Integer$Zero, dividend));
				case 'EQ':
					var sign = _Utils_eq(s1, s2) ? $chain_partners$elm_bignum$Integer$Positive : $chain_partners$elm_bignum$Integer$Negative;
					return $elm$core$Maybe$Just(
						_Utils_Tuple2(
							A2(
								$chain_partners$elm_bignum$Integer$Integer,
								sign,
								_List_fromArray(
									[1])),
							$chain_partners$elm_bignum$Integer$Zero));
				default:
					return A2(
						$elm$core$Maybe$map,
						A2($chain_partners$elm_bignum$Integer$adjustSign, dividend, divisor),
						A4(
							$chain_partners$elm_bignum$Integer$divmod_,
							$chain_partners$elm_bignum$Integer$abs(dividend),
							$chain_partners$elm_bignum$Integer$abs(divisor),
							$chain_partners$elm_bignum$Integer$Zero,
							$chain_partners$elm_bignum$Integer$Zero));
			}
		}
		var _v1 = _v0.a;
		return $elm$core$Maybe$Just(
			_Utils_Tuple2($chain_partners$elm_bignum$Integer$Zero, $chain_partners$elm_bignum$Integer$Zero));
	});
var $chain_partners$elm_bignum$Integer$div = F2(
	function (dividend, divisor) {
		return A2(
			$elm$core$Maybe$map,
			$elm$core$Tuple$first,
			A2($chain_partners$elm_bignum$Integer$divmod, dividend, divisor));
	});
var $chain_partners$elm_bignum$Integer$zero = $chain_partners$elm_bignum$Integer$Zero;
var $Evelios$elm_hash$Hash$dependent = F2(
	function (_v0, _v1) {
		var x = _v0.a;
		var y = _v1.a;
		return $Evelios$elm_hash$Hash$Hash(
			A2(
				$elm$core$Maybe$withDefault,
				$chain_partners$elm_bignum$Integer$fromInt(0),
				function (from) {
					return A2(
						$chain_partners$elm_bignum$Integer$div,
						from,
						$chain_partners$elm_bignum$Integer$fromInt(2));
				}(
					A3(
						$elm$core$List$foldl,
						$chain_partners$elm_bignum$Integer$add,
						$chain_partners$elm_bignum$Integer$zero,
						_List_fromArray(
							[
								A2($chain_partners$elm_bignum$Integer$mul, x, x),
								A2(
								$chain_partners$elm_bignum$Integer$mul,
								$chain_partners$elm_bignum$Integer$fromInt(3),
								x),
								A2(
								$chain_partners$elm_bignum$Integer$mul,
								$chain_partners$elm_bignum$Integer$fromInt(3),
								A2($chain_partners$elm_bignum$Integer$mul, y, x)),
								y,
								A2($chain_partners$elm_bignum$Integer$mul, y, y)
							])))));
	});
var $Evelios$elm_hash$Hash$expTolerance = 6;
var $Evelios$elm_hash$Hash$fromInt = A2($elm$core$Basics$composeR, $chain_partners$elm_bignum$Integer$fromInt, $Evelios$elm_hash$Hash$Hash);
var $bonzaico$murmur3$Murmur3$HashData = F4(
	function (shift, seed, hash, charsProcessed) {
		return {charsProcessed: charsProcessed, hash: hash, seed: seed, shift: shift};
	});
var $bonzaico$murmur3$Murmur3$c1 = 3432918353;
var $bonzaico$murmur3$Murmur3$c2 = 461845907;
var $elm$core$Bitwise$shiftLeftBy = _Bitwise_shiftLeftBy;
var $elm$core$Bitwise$shiftRightZfBy = _Bitwise_shiftRightZfBy;
var $bonzaico$murmur3$Murmur3$multiplyBy = F2(
	function (b, a) {
		return ((a & 65535) * b) + ((((a >>> 16) * b) & 65535) << 16);
	});
var $elm$core$Bitwise$or = _Bitwise_or;
var $bonzaico$murmur3$Murmur3$rotlBy = F2(
	function (b, a) {
		return (a << b) | (a >>> (32 - b));
	});
var $elm$core$Bitwise$xor = _Bitwise_xor;
var $bonzaico$murmur3$Murmur3$finalize = function (data) {
	var acc = (!(!data.hash)) ? (data.seed ^ A2(
		$bonzaico$murmur3$Murmur3$multiplyBy,
		$bonzaico$murmur3$Murmur3$c2,
		A2(
			$bonzaico$murmur3$Murmur3$rotlBy,
			15,
			A2($bonzaico$murmur3$Murmur3$multiplyBy, $bonzaico$murmur3$Murmur3$c1, data.hash)))) : data.seed;
	var h0 = acc ^ data.charsProcessed;
	var h1 = A2($bonzaico$murmur3$Murmur3$multiplyBy, 2246822507, h0 ^ (h0 >>> 16));
	var h2 = A2($bonzaico$murmur3$Murmur3$multiplyBy, 3266489909, h1 ^ (h1 >>> 13));
	return (h2 ^ (h2 >>> 16)) >>> 0;
};
var $elm$core$String$foldl = _String_foldl;
var $bonzaico$murmur3$Murmur3$mix = F2(
	function (h1, k1) {
		return A2(
			$bonzaico$murmur3$Murmur3$multiplyBy,
			5,
			A2(
				$bonzaico$murmur3$Murmur3$rotlBy,
				13,
				h1 ^ A2(
					$bonzaico$murmur3$Murmur3$multiplyBy,
					$bonzaico$murmur3$Murmur3$c2,
					A2(
						$bonzaico$murmur3$Murmur3$rotlBy,
						15,
						A2($bonzaico$murmur3$Murmur3$multiplyBy, $bonzaico$murmur3$Murmur3$c1, k1))))) + 3864292196;
	});
var $bonzaico$murmur3$Murmur3$hashFold = F2(
	function (c, data) {
		var res = data.hash | ((255 & $elm$core$Char$toCode(c)) << data.shift);
		var _v0 = data.shift;
		if (_v0 === 24) {
			return {
				charsProcessed: data.charsProcessed + 1,
				hash: 0,
				seed: A2($bonzaico$murmur3$Murmur3$mix, data.seed, res),
				shift: 0
			};
		} else {
			return {charsProcessed: data.charsProcessed + 1, hash: res, seed: data.seed, shift: data.shift + 8};
		}
	});
var $bonzaico$murmur3$Murmur3$hashString = F2(
	function (seed, str) {
		return $bonzaico$murmur3$Murmur3$finalize(
			A3(
				$elm$core$String$foldl,
				$bonzaico$murmur3$Murmur3$hashFold,
				A4($bonzaico$murmur3$Murmur3$HashData, 0, seed, 0, 0),
				str));
	});
var $Evelios$elm_hash$Hash$fromString = A2(
	$elm$core$Basics$composeR,
	$bonzaico$murmur3$Murmur3$hashString($Evelios$elm_hash$Hash$expTolerance),
	$Evelios$elm_hash$Hash$fromInt);
var $author$project$FieldName$hash = function (_v0) {
	var name = _v0.a;
	return $Evelios$elm_hash$Hash$fromString(name);
};
var $author$project$DataElement$Reference$hashListElement = function (_v0) {
	var uuid = _v0.a;
	return $Evelios$elm_hash$Hash$fromString(
		$danyx23$elm_uuid$Uuid$toString(uuid));
};
var $Evelios$elm_hash$Hash$fromFloat = A2(
	$elm$core$Basics$composeR,
	$myrho$elm_round$Round$round($Evelios$elm_hash$Hash$expTolerance),
	$Evelios$elm_hash$Hash$fromString);
var $author$project$DateInterval$toString = function (interval) {
	switch (interval.$) {
		case 'Week':
			return 'Week';
		case 'Month':
			return 'Month';
		case 'Quarter':
			return 'Quarter';
		default:
			return 'Year';
	}
};
var $author$project$DateInterval$hash = function (interval) {
	return $Evelios$elm_hash$Hash$fromString(
		$author$project$DateInterval$toString(interval));
};
var $author$project$DataElement$Reference$hashSingletonElement = function (_v0) {
	var uuid = _v0.a;
	return $Evelios$elm_hash$Hash$fromString(
		$danyx23$elm_uuid$Uuid$toString(uuid));
};
var $author$project$ComparableType$toString = function (comp) {
	switch (comp.$) {
		case 'StringComp':
			return 'String';
		case 'NumberComp':
			return 'Number';
		case 'DateComp':
			return 'Date';
		default:
			return 'Date/Time';
	}
};
var $author$project$DataElement$Expression$relatedFieldHash = F2(
	function (info, name) {
		return A2(
			$Evelios$elm_hash$Hash$dependent,
			$author$project$DataElement$Expression$relationshipInfoHash(info),
			$author$project$FieldName$hash(name));
	});
var $author$project$DataElement$Expression$relationshipInfoHash = function (info) {
	var optionalFilter = A2(
		$elm$core$Maybe$map,
		$author$project$DataElement$Expression$applyLocalBool(
			$author$project$DataElement$Expression$cyclic$hashTransformer()),
		info.optionalFilter);
	var nextElementHash = $author$project$DataElement$Reference$hashListElement(info.nextElement);
	var localIdsHash = A2(
		$author$project$DataElement$Expression$applyLocalStringList,
		$author$project$DataElement$Expression$cyclic$hashTransformer(),
		info.localIds);
	var idToMatchHash = A2(
		$author$project$DataElement$Expression$applyLocalString,
		$author$project$DataElement$Expression$cyclic$hashTransformer(),
		info.idToMatch);
	return function (hashSoFar) {
		return A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			hashSoFar,
			$Evelios$elm_hash$Hash$dependent(hashSoFar),
			optionalFilter);
	}(
		A2(
			$Evelios$elm_hash$Hash$dependent,
			idToMatchHash,
			A2($Evelios$elm_hash$Hash$dependent, nextElementHash, localIdsHash)));
};
function $author$project$DataElement$Expression$cyclic$hashTransformer() {
	return {
		add: function (dep) {
			return $Evelios$elm_hash$Hash$dependent(
				A2(
					$Evelios$elm_hash$Hash$dependent,
					$Evelios$elm_hash$Hash$fromString('add'),
					dep));
		},
		all: function (dep) {
			return A2(
				$Evelios$elm_hash$Hash$dependent,
				$Evelios$elm_hash$Hash$fromString('all'),
				dep);
		},
		allBoolsInField: F2(
			function (ref, name) {
				return A2(
					$Evelios$elm_hash$Hash$dependent,
					$author$project$DataElement$Reference$hashListElement(ref),
					$author$project$FieldName$hash(name));
			}),
		allDateTimesInField: F2(
			function (ref, name) {
				return A2(
					$Evelios$elm_hash$Hash$dependent,
					$author$project$DataElement$Reference$hashListElement(ref),
					$author$project$FieldName$hash(name));
			}),
		allDatesInField: F2(
			function (ref, name) {
				return A2(
					$Evelios$elm_hash$Hash$dependent,
					$author$project$DataElement$Reference$hashListElement(ref),
					$author$project$FieldName$hash(name));
			}),
		allNumbersInField: F2(
			function (ref, name) {
				return A2(
					$Evelios$elm_hash$Hash$dependent,
					$author$project$DataElement$Reference$hashListElement(ref),
					$author$project$FieldName$hash(name));
			}),
		allStringsInField: F2(
			function (ref, name) {
				return A2(
					$Evelios$elm_hash$Hash$dependent,
					$author$project$DataElement$Reference$hashListElement(ref),
					$author$project$FieldName$hash(name));
			}),
		any: function (dep) {
			return A2(
				$Evelios$elm_hash$Hash$dependent,
				$Evelios$elm_hash$Hash$fromString('any'),
				dep);
		},
		boolsAsList: function (boolList) {
			return A3(
				$elm$core$List$foldl,
				$Evelios$elm_hash$Hash$dependent,
				$Evelios$elm_hash$Hash$fromString('boolList'),
				boolList);
		},
		challengeReasons: function (dep) {
			return A2(
				$Evelios$elm_hash$Hash$dependent,
				$Evelios$elm_hash$Hash$fromString('challengeReasons'),
				dep);
		},
		comparableEqual: F2(
			function (compType, dep) {
				return $Evelios$elm_hash$Hash$dependent(
					A2(
						$Evelios$elm_hash$Hash$dependent,
						dep,
						A2(
							$Evelios$elm_hash$Hash$dependent,
							$Evelios$elm_hash$Hash$fromString(
								$author$project$ComparableType$toString(compType)),
							$Evelios$elm_hash$Hash$fromString('comparableEqual'))));
			}),
		comparableNotEqual: F2(
			function (compType, dep) {
				return $Evelios$elm_hash$Hash$dependent(
					A2(
						$Evelios$elm_hash$Hash$dependent,
						dep,
						A2(
							$Evelios$elm_hash$Hash$dependent,
							$Evelios$elm_hash$Hash$fromString(
								$author$project$ComparableType$toString(compType)),
							$Evelios$elm_hash$Hash$fromString('comparableNotEqual'))));
			}),
		concat: $Evelios$elm_hash$Hash$dependent,
		countUnique: function (compType) {
			return $Evelios$elm_hash$Hash$dependent(
				A2(
					$Evelios$elm_hash$Hash$dependent,
					$Evelios$elm_hash$Hash$fromString('countUnique'),
					$Evelios$elm_hash$Hash$fromString(
						$author$project$ComparableType$toString(compType))));
		},
		dateAdd: F3(
			function (_v0, a, b) {
				return A2($Evelios$elm_hash$Hash$dependent, a, b);
			}),
		dateCeiling: F2(
			function (interval, dep) {
				return A2(
					$Evelios$elm_hash$Hash$dependent,
					$author$project$DateInterval$hash(interval),
					dep);
			}),
		dateFloor: F2(
			function (interval, dep) {
				return A2(
					$Evelios$elm_hash$Hash$dependent,
					$author$project$DateInterval$hash(interval),
					dep);
			}),
		dateSubtract: F3(
			function (_v1, a, b) {
				return A2($Evelios$elm_hash$Hash$dependent, a, b);
			}),
		dateTimeToDate: $Evelios$elm_hash$Hash$dependent(
			$Evelios$elm_hash$Hash$fromString('dateTimeToDate')),
		dateTimesAsList: A2(
			$elm$core$List$foldl,
			$Evelios$elm_hash$Hash$dependent,
			$Evelios$elm_hash$Hash$fromString('dateTimeList')),
		datesAsList: A2(
			$elm$core$List$foldl,
			$Evelios$elm_hash$Hash$dependent,
			$Evelios$elm_hash$Hash$fromInt(0)),
		dayInMonth: $Evelios$elm_hash$Hash$dependent(
			$Evelios$elm_hash$Hash$fromString('identity')),
		divide: function (dep) {
			return $Evelios$elm_hash$Hash$dependent(
				A2(
					$Evelios$elm_hash$Hash$dependent,
					$Evelios$elm_hash$Hash$fromString('divide'),
					dep));
		},
		equal: F2(
			function (fieldType, dep) {
				return $Evelios$elm_hash$Hash$dependent(
					A2(
						$Evelios$elm_hash$Hash$dependent,
						dep,
						A2(
							$Evelios$elm_hash$Hash$dependent,
							$Evelios$elm_hash$Hash$fromString(
								$author$project$FieldType$toString(fieldType)),
							$Evelios$elm_hash$Hash$fromString('equal'))));
			}),
		formatDate: function (dep) {
			return $Evelios$elm_hash$Hash$dependent(
				A2(
					$Evelios$elm_hash$Hash$dependent,
					$Evelios$elm_hash$Hash$fromString('formatDate'),
					dep));
		},
		formatDateLocaleAware: $Evelios$elm_hash$Hash$dependent(
			$Evelios$elm_hash$Hash$fromString('formatDateLocaleAware')),
		formatDateTime: $Evelios$elm_hash$Hash$dependent(
			$Evelios$elm_hash$Hash$fromString('formatDateTime')),
		formatNumber: function (num) {
			return $Evelios$elm_hash$Hash$dependent(
				$Evelios$elm_hash$Hash$fromInt(num));
		},
		globalBoolLookup: F2(
			function (ref, name) {
				return A2(
					$Evelios$elm_hash$Hash$dependent,
					$author$project$DataElement$Reference$hashSingletonElement(ref),
					$author$project$FieldName$hash(name));
			}),
		globalDateLookup: F2(
			function (ref, name) {
				return A2(
					$Evelios$elm_hash$Hash$dependent,
					$author$project$DataElement$Reference$hashSingletonElement(ref),
					$author$project$FieldName$hash(name));
			}),
		globalDateTimeLookup: F2(
			function (ref, name) {
				return A2(
					$Evelios$elm_hash$Hash$dependent,
					$author$project$DataElement$Reference$hashSingletonElement(ref),
					$author$project$FieldName$hash(name));
			}),
		globalNumberLookup: F2(
			function (ref, name) {
				return A2(
					$Evelios$elm_hash$Hash$dependent,
					$author$project$DataElement$Reference$hashSingletonElement(ref),
					$author$project$FieldName$hash(name));
			}),
		globalStringLookup: F2(
			function (ref, name) {
				return A2(
					$Evelios$elm_hash$Hash$dependent,
					$author$project$DataElement$Reference$hashSingletonElement(ref),
					$author$project$FieldName$hash(name));
			}),
		greaterThan: F2(
			function (compType, dep) {
				return $Evelios$elm_hash$Hash$dependent(
					A2(
						$Evelios$elm_hash$Hash$dependent,
						dep,
						A2(
							$Evelios$elm_hash$Hash$dependent,
							$Evelios$elm_hash$Hash$fromString(
								$author$project$ComparableType$toString(compType)),
							$Evelios$elm_hash$Hash$fromString('greaterThan'))));
			}),
		greaterThanOrEqual: F2(
			function (compType, dep) {
				return $Evelios$elm_hash$Hash$dependent(
					A2(
						$Evelios$elm_hash$Hash$dependent,
						dep,
						A2(
							$Evelios$elm_hash$Hash$dependent,
							$Evelios$elm_hash$Hash$fromString(
								$author$project$ComparableType$toString(compType)),
							$Evelios$elm_hash$Hash$fromString('greaterThanOrEqual'))));
			}),
		hardcodedBool: function (bool) {
			if (bool) {
				return A2(
					$Evelios$elm_hash$Hash$dependent,
					$Evelios$elm_hash$Hash$fromInt(1),
					$Evelios$elm_hash$Hash$fromString('hardcodedBool'));
			} else {
				return A2(
					$Evelios$elm_hash$Hash$dependent,
					$Evelios$elm_hash$Hash$fromInt(0),
					$Evelios$elm_hash$Hash$fromString('hardcodedBool'));
			}
		},
		hardcodedDate: function (date) {
			return $Evelios$elm_hash$Hash$fromInt(
				$justinmimbs$date$Date$toRataDie(date));
		},
		hardcodedDateTime: function (dateTime) {
			return $Evelios$elm_hash$Hash$fromInt(
				$elm$time$Time$posixToMillis(dateTime));
		},
		hardcodedNumber: $Evelios$elm_hash$Hash$fromFloat,
		hardcodedString: $Evelios$elm_hash$Hash$fromString,
		if_: F4(
			function (fieldType, a, b, c) {
				return A2(
					$Evelios$elm_hash$Hash$dependent,
					c,
					A2(
						$Evelios$elm_hash$Hash$dependent,
						b,
						A2(
							$Evelios$elm_hash$Hash$dependent,
							a,
							$Evelios$elm_hash$Hash$fromString(
								$author$project$FieldType$toString(fieldType)))));
			}),
		isNotNull: function (dep) {
			return A2(
				$Evelios$elm_hash$Hash$dependent,
				$Evelios$elm_hash$Hash$fromString('isNotNull'),
				dep);
		},
		isNull: function (dep) {
			return A2(
				$Evelios$elm_hash$Hash$dependent,
				$Evelios$elm_hash$Hash$fromString('isNull'),
				dep);
		},
		lessThan: F2(
			function (compType, dep) {
				return $Evelios$elm_hash$Hash$dependent(
					A2(
						$Evelios$elm_hash$Hash$dependent,
						dep,
						A2(
							$Evelios$elm_hash$Hash$dependent,
							$Evelios$elm_hash$Hash$fromString(
								$author$project$ComparableType$toString(compType)),
							$Evelios$elm_hash$Hash$fromString('lessThan'))));
			}),
		lessThanOrEqual: F2(
			function (compType, dep) {
				return $Evelios$elm_hash$Hash$dependent(
					A2(
						$Evelios$elm_hash$Hash$dependent,
						dep,
						A2(
							$Evelios$elm_hash$Hash$dependent,
							$Evelios$elm_hash$Hash$fromString(
								$author$project$ComparableType$toString(compType)),
							$Evelios$elm_hash$Hash$fromString('lessThanOrEqual'))));
			}),
		localBool: function (name) {
			return $author$project$FieldName$hash(name);
		},
		localDate: $author$project$FieldName$hash,
		localDateTime: $author$project$FieldName$hash,
		localNumber: $author$project$FieldName$hash,
		localString: $author$project$FieldName$hash,
		max: F2(
			function (compType, dep) {
				return A2(
					$Evelios$elm_hash$Hash$dependent,
					$Evelios$elm_hash$Hash$fromString(
						$author$project$ComparableType$toString(compType)),
					dep);
			}),
		min: F2(
			function (compType, dep) {
				return A2(
					$Evelios$elm_hash$Hash$dependent,
					$Evelios$elm_hash$Hash$fromString(
						$author$project$ComparableType$toString(compType)),
					dep);
			}),
		monthNumber: $Evelios$elm_hash$Hash$dependent(
			$Evelios$elm_hash$Hash$fromString('monthNumber')),
		multiply: function (dep) {
			return $Evelios$elm_hash$Hash$dependent(
				A2(
					$Evelios$elm_hash$Hash$dependent,
					$Evelios$elm_hash$Hash$fromString('multiply'),
					dep));
		},
		not: function (dep) {
			return A2(
				$Evelios$elm_hash$Hash$dependent,
				$Evelios$elm_hash$Hash$fromString('not'),
				dep);
		},
		notEqual: F2(
			function (fieldType, dep) {
				return $Evelios$elm_hash$Hash$dependent(
					A2(
						$Evelios$elm_hash$Hash$dependent,
						dep,
						A2(
							$Evelios$elm_hash$Hash$dependent,
							$Evelios$elm_hash$Hash$fromString(
								$author$project$FieldType$toString(fieldType)),
							$Evelios$elm_hash$Hash$fromString('notEqual'))));
			}),
		numbersAsList: A2(
			$elm$core$List$foldl,
			$Evelios$elm_hash$Hash$dependent,
			$Evelios$elm_hash$Hash$fromInt(0)),
		pickOne: F2(
			function (fieldType, dep) {
				return A2(
					$Evelios$elm_hash$Hash$dependent,
					$Evelios$elm_hash$Hash$fromString(
						$author$project$FieldType$toString(fieldType)),
					dep);
			}),
		product: $Evelios$elm_hash$Hash$dependent(
			$Evelios$elm_hash$Hash$fromString('product')),
		relatedBool: $author$project$DataElement$Expression$relatedFieldHash,
		relatedDate: $author$project$DataElement$Expression$relatedFieldHash,
		relatedDateTime: $author$project$DataElement$Expression$relatedFieldHash,
		relatedNumber: $author$project$DataElement$Expression$relatedFieldHash,
		relatedString: $author$project$DataElement$Expression$relatedFieldHash,
		round: $Evelios$elm_hash$Hash$dependent(
			$Evelios$elm_hash$Hash$fromString('round')),
		stringIn: function (dep) {
			return $Evelios$elm_hash$Hash$dependent(
				A2(
					$Evelios$elm_hash$Hash$dependent,
					$Evelios$elm_hash$Hash$fromString('stringIn'),
					dep));
		},
		stringNotIn: function (dep) {
			return $Evelios$elm_hash$Hash$dependent(
				A2(
					$Evelios$elm_hash$Hash$dependent,
					$Evelios$elm_hash$Hash$fromString('stringNotIn'),
					dep));
		},
		stringsAsList: A2(
			$elm$core$List$foldl,
			$Evelios$elm_hash$Hash$dependent,
			$Evelios$elm_hash$Hash$fromInt(0)),
		subtract: function (dep) {
			return $Evelios$elm_hash$Hash$dependent(
				A2(
					$Evelios$elm_hash$Hash$dependent,
					$Evelios$elm_hash$Hash$fromString('subtract'),
					dep));
		},
		sum: $Evelios$elm_hash$Hash$dependent(
			$Evelios$elm_hash$Hash$fromString('sum')),
		targetChallengeReasons: function (dep) {
			return A2(
				$Evelios$elm_hash$Hash$dependent,
				$Evelios$elm_hash$Hash$fromString('targetChallengeReasons'),
				dep);
		},
		yearNumber: $Evelios$elm_hash$Hash$dependent(
			$Evelios$elm_hash$Hash$fromString('yearNumber'))
	};
}
try {
	var $author$project$DataElement$Expression$hashTransformer = $author$project$DataElement$Expression$cyclic$hashTransformer();
	$author$project$DataElement$Expression$cyclic$hashTransformer = function () {
		return $author$project$DataElement$Expression$hashTransformer;
	};
} catch ($) {
	throw 'Some top-level definitions from `DataElement.Expression` are causing infinite recursion:\n\n  ┌─────┐\n  │    hashTransformer\n  │     ↓\n  │    relatedFieldHash\n  │     ↓\n  │    relationshipInfoHash\n  └─────┘\n\nThese errors are very tricky, so read https://elm-lang.org/0.19.1/bad-recursion to learn how to fix it!';}
var $author$project$DataElement$Expression$hashRelatedFieldDictionaryInfo = function (dict) {
	var record = dict.a;
	return A2(
		$Evelios$elm_hash$Hash$dependent,
		A2(
			$author$project$DataElement$Expression$applyLocalBool,
			$author$project$DataElement$Expression$hashTransformer,
			A2(
				$elm$core$Maybe$withDefault,
				$author$project$DataElement$Expression$LocalBoolHardcoded(true),
				record.filter)),
		A2(
			$Evelios$elm_hash$Hash$dependent,
			$author$project$DataElement$Reference$hashListElement(record.nextElement),
			A2(
				$Evelios$elm_hash$Hash$dependent,
				A2($author$project$DataElement$Expression$applyLocalString, $author$project$DataElement$Expression$hashTransformer, record.id),
				$author$project$FieldName$hash(record.value))));
};
var $chain_partners$elm_bignum$Integer$trimLeadingZeroFromStr = A2(
	$elm$regex$Regex$replace,
	A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('^0*')),
	function (_v0) {
		return '';
	});
var $chain_partners$elm_bignum$Integer$toString = function (i) {
	if (i.$ === 'Zero') {
		return '0';
	} else {
		var s = i.a;
		var m = i.b;
		var sign = _Utils_eq(s, $chain_partners$elm_bignum$Integer$Negative) ? '-' : '';
		var num = $chain_partners$elm_bignum$Integer$trimLeadingZeroFromStr(
			A3(
				$elm$core$List$foldl,
				$elm$core$Basics$append,
				'',
				A2(
					$elm$core$List$map,
					A2(
						$elm$core$Basics$composeR,
						$elm$core$String$fromInt,
						A2(
							$elm$core$String$padLeft,
							7,
							_Utils_chr('0'))),
					m)));
		return _Utils_ap(sign, num);
	}
};
var $Evelios$elm_hash$Hash$toString = function (_v0) {
	var integer = _v0.a;
	return $chain_partners$elm_bignum$Integer$toString(integer);
};
var $author$project$DataEngine$RfDictCache$boolValue = F2(
	function (_v0, record) {
		var internal = _v0.a;
		var hashString = $Evelios$elm_hash$Hash$toString(
			$author$project$DataElement$Expression$hashRelatedFieldDictionaryInfo(
				$author$project$DataElement$Expression$IdToValue(record)));
		return A2(
			$elm$core$Maybe$withDefault,
			$krisajenkins$remotedata$RemoteData$NotAsked,
			A2($elm$core$Dict$get, hashString, internal.boolDicts));
	});
var $author$project$DataEngine$RfDictCache$dateTimeValue = F2(
	function (_v0, record) {
		var internal = _v0.a;
		var hashString = $Evelios$elm_hash$Hash$toString(
			$author$project$DataElement$Expression$hashRelatedFieldDictionaryInfo(
				$author$project$DataElement$Expression$IdToValue(record)));
		return A2(
			$elm$core$Maybe$withDefault,
			$krisajenkins$remotedata$RemoteData$NotAsked,
			A2($elm$core$Dict$get, hashString, internal.dateTimeDicts));
	});
var $author$project$DataEngine$RfDictCache$dateValue = F2(
	function (_v0, record) {
		var internal = _v0.a;
		var hashString = $Evelios$elm_hash$Hash$toString(
			$author$project$DataElement$Expression$hashRelatedFieldDictionaryInfo(
				$author$project$DataElement$Expression$IdToValue(record)));
		return A2(
			$elm$core$Maybe$withDefault,
			$krisajenkins$remotedata$RemoteData$NotAsked,
			A2($elm$core$Dict$get, hashString, internal.dateDicts));
	});
var $author$project$DataEngine$RfDictCache$numberValue = F2(
	function (_v0, record) {
		var internal = _v0.a;
		var hashString = $Evelios$elm_hash$Hash$toString(
			$author$project$DataElement$Expression$hashRelatedFieldDictionaryInfo(
				$author$project$DataElement$Expression$IdToValue(record)));
		return A2(
			$elm$core$Maybe$withDefault,
			$krisajenkins$remotedata$RemoteData$NotAsked,
			A2($elm$core$Dict$get, hashString, internal.numberDicts));
	});
var $author$project$Calc$relatedField = function (_v0) {
	var rightHandDict = _v0.rightHandDict;
	var localIds = _v0.localIds;
	return A2(
		$elm$core$List$concatMap,
		function (localId) {
			return A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2($elm$core$Dict$get, localId, rightHandDict));
		},
		$elm_community$list_extra$List$Extra$unique(
			A2(
				$elm$core$List$map,
				function ($) {
					return $.text;
				},
				A2($elm$core$List$filterMap, $elm$core$Basics$identity, localIds))));
};
var $author$project$DataEngine$RfDictCache$stringValue = F2(
	function (_v0, record) {
		var internal = _v0.a;
		var hashString = $Evelios$elm_hash$Hash$toString(
			$author$project$DataElement$Expression$hashRelatedFieldDictionaryInfo(
				$author$project$DataElement$Expression$IdToValue(record)));
		return A2(
			$elm$core$Maybe$withDefault,
			$krisajenkins$remotedata$RemoteData$NotAsked,
			A2($elm$core$Dict$get, hashString, internal.stringDicts));
	});
var $author$project$DataElement$Expression$Preview$localBool = F4(
	function (cache, rfDictCache, baseRecord, bool) {
		switch (bool.$) {
			case 'LocalBool':
				var fieldName = bool.a;
				return $krisajenkins$remotedata$RemoteData$Success(
					A2($author$project$DataEngine$RecordCache$getBool, fieldName, baseRecord));
			case 'LocalSingletonBool':
				var singletonRef = bool.a;
				var fieldName = bool.b;
				return A2(
					$krisajenkins$remotedata$RemoteData$map,
					$author$project$DataEngine$RecordCache$getBool(fieldName),
					A2($author$project$DataElement$Expression$Preview$singletonReference, cache, singletonRef));
			case 'LocalBoolHardcoded':
				var hardcodedBool = bool.a;
				return $krisajenkins$remotedata$RemoteData$Success(
					$elm$core$Maybe$Just(hardcodedBool));
			case 'LocalGTString':
				var innerA = bool.a;
				var innerB = bool.b;
				return A3(
					$krisajenkins$remotedata$RemoteData$map2,
					$author$project$Calc$gtWith($author$project$StudioString$compare),
					A4($author$project$DataElement$Expression$Preview$localString, cache, rfDictCache, baseRecord, innerA),
					A4($author$project$DataElement$Expression$Preview$localString, cache, rfDictCache, baseRecord, innerB));
			case 'LocalGTNumber':
				var innerA = bool.a;
				var innerB = bool.b;
				return A3(
					$krisajenkins$remotedata$RemoteData$map2,
					$author$project$Calc$gtWith($elm$core$Basics$compare),
					A4($author$project$DataElement$Expression$Preview$localNumber, cache, rfDictCache, baseRecord, innerA),
					A4($author$project$DataElement$Expression$Preview$localNumber, cache, rfDictCache, baseRecord, innerB));
			case 'LocalGTDate':
				var innerA = bool.a;
				var innerB = bool.b;
				return A3(
					$krisajenkins$remotedata$RemoteData$map2,
					$author$project$Calc$gtWith($justinmimbs$date$Date$compare),
					A4($author$project$DataElement$Expression$Preview$localDate, cache, rfDictCache, baseRecord, innerA),
					A4($author$project$DataElement$Expression$Preview$localDate, cache, rfDictCache, baseRecord, innerB));
			case 'LocalGTDateTime':
				var innerA = bool.a;
				var innerB = bool.b;
				return A3(
					$krisajenkins$remotedata$RemoteData$map2,
					$author$project$Calc$gtWith($author$project$Calc$compareDateTime),
					A4($author$project$DataElement$Expression$Preview$localDateTime, cache, rfDictCache, baseRecord, innerA),
					A4($author$project$DataElement$Expression$Preview$localDateTime, cache, rfDictCache, baseRecord, innerB));
			case 'LocalGTEString':
				var innerA = bool.a;
				var innerB = bool.b;
				return A3(
					$krisajenkins$remotedata$RemoteData$map2,
					$author$project$Calc$gteWith($author$project$StudioString$compare),
					A4($author$project$DataElement$Expression$Preview$localString, cache, rfDictCache, baseRecord, innerA),
					A4($author$project$DataElement$Expression$Preview$localString, cache, rfDictCache, baseRecord, innerB));
			case 'LocalGTENumber':
				var innerA = bool.a;
				var innerB = bool.b;
				return A3(
					$krisajenkins$remotedata$RemoteData$map2,
					$author$project$Calc$gteWith($elm$core$Basics$compare),
					A4($author$project$DataElement$Expression$Preview$localNumber, cache, rfDictCache, baseRecord, innerA),
					A4($author$project$DataElement$Expression$Preview$localNumber, cache, rfDictCache, baseRecord, innerB));
			case 'LocalGTEDate':
				var innerA = bool.a;
				var innerB = bool.b;
				return A3(
					$krisajenkins$remotedata$RemoteData$map2,
					$author$project$Calc$gteWith($justinmimbs$date$Date$compare),
					A4($author$project$DataElement$Expression$Preview$localDate, cache, rfDictCache, baseRecord, innerA),
					A4($author$project$DataElement$Expression$Preview$localDate, cache, rfDictCache, baseRecord, innerB));
			case 'LocalGTEDateTime':
				var innerA = bool.a;
				var innerB = bool.b;
				return A3(
					$krisajenkins$remotedata$RemoteData$map2,
					$author$project$Calc$gteWith($author$project$Calc$compareDateTime),
					A4($author$project$DataElement$Expression$Preview$localDateTime, cache, rfDictCache, baseRecord, innerA),
					A4($author$project$DataElement$Expression$Preview$localDateTime, cache, rfDictCache, baseRecord, innerB));
			case 'LocalLTString':
				var innerA = bool.a;
				var innerB = bool.b;
				return A3(
					$krisajenkins$remotedata$RemoteData$map2,
					$author$project$Calc$ltWith($author$project$StudioString$compare),
					A4($author$project$DataElement$Expression$Preview$localString, cache, rfDictCache, baseRecord, innerA),
					A4($author$project$DataElement$Expression$Preview$localString, cache, rfDictCache, baseRecord, innerB));
			case 'LocalLTNumber':
				var innerA = bool.a;
				var innerB = bool.b;
				return A3(
					$krisajenkins$remotedata$RemoteData$map2,
					$author$project$Calc$ltWith($elm$core$Basics$compare),
					A4($author$project$DataElement$Expression$Preview$localNumber, cache, rfDictCache, baseRecord, innerA),
					A4($author$project$DataElement$Expression$Preview$localNumber, cache, rfDictCache, baseRecord, innerB));
			case 'LocalLTDate':
				var innerA = bool.a;
				var innerB = bool.b;
				return A3(
					$krisajenkins$remotedata$RemoteData$map2,
					$author$project$Calc$ltWith($justinmimbs$date$Date$compare),
					A4($author$project$DataElement$Expression$Preview$localDate, cache, rfDictCache, baseRecord, innerA),
					A4($author$project$DataElement$Expression$Preview$localDate, cache, rfDictCache, baseRecord, innerB));
			case 'LocalLTDateTime':
				var innerA = bool.a;
				var innerB = bool.b;
				return A3(
					$krisajenkins$remotedata$RemoteData$map2,
					$author$project$Calc$ltWith($author$project$Calc$compareDateTime),
					A4($author$project$DataElement$Expression$Preview$localDateTime, cache, rfDictCache, baseRecord, innerA),
					A4($author$project$DataElement$Expression$Preview$localDateTime, cache, rfDictCache, baseRecord, innerB));
			case 'LocalLTEString':
				var innerA = bool.a;
				var innerB = bool.b;
				return A3(
					$krisajenkins$remotedata$RemoteData$map2,
					$author$project$Calc$lteWith($author$project$StudioString$compare),
					A4($author$project$DataElement$Expression$Preview$localString, cache, rfDictCache, baseRecord, innerA),
					A4($author$project$DataElement$Expression$Preview$localString, cache, rfDictCache, baseRecord, innerB));
			case 'LocalLTENumber':
				var innerA = bool.a;
				var innerB = bool.b;
				return A3(
					$krisajenkins$remotedata$RemoteData$map2,
					$author$project$Calc$lteWith($elm$core$Basics$compare),
					A4($author$project$DataElement$Expression$Preview$localNumber, cache, rfDictCache, baseRecord, innerA),
					A4($author$project$DataElement$Expression$Preview$localNumber, cache, rfDictCache, baseRecord, innerB));
			case 'LocalLTEDate':
				var innerA = bool.a;
				var innerB = bool.b;
				return A3(
					$krisajenkins$remotedata$RemoteData$map2,
					$author$project$Calc$lteWith($justinmimbs$date$Date$compare),
					A4($author$project$DataElement$Expression$Preview$localDate, cache, rfDictCache, baseRecord, innerA),
					A4($author$project$DataElement$Expression$Preview$localDate, cache, rfDictCache, baseRecord, innerB));
			case 'LocalLTEDateTime':
				var innerA = bool.a;
				var innerB = bool.b;
				return A3(
					$krisajenkins$remotedata$RemoteData$map2,
					$author$project$Calc$lteWith($author$project$Calc$compareDateTime),
					A4($author$project$DataElement$Expression$Preview$localDateTime, cache, rfDictCache, baseRecord, innerA),
					A4($author$project$DataElement$Expression$Preview$localDateTime, cache, rfDictCache, baseRecord, innerB));
			case 'LocalEqualString':
				var innerA = bool.a;
				var innerB = bool.b;
				return A3(
					$krisajenkins$remotedata$RemoteData$map2,
					$author$project$Calc$comparableEqual($author$project$StudioString$compare),
					A4($author$project$DataElement$Expression$Preview$localString, cache, rfDictCache, baseRecord, innerA),
					A4($author$project$DataElement$Expression$Preview$localString, cache, rfDictCache, baseRecord, innerB));
			case 'LocalEqualNumber':
				var innerA = bool.a;
				var innerB = bool.b;
				return A3(
					$krisajenkins$remotedata$RemoteData$map2,
					$author$project$Calc$comparableEqual($elm$core$Basics$compare),
					A4($author$project$DataElement$Expression$Preview$localNumber, cache, rfDictCache, baseRecord, innerA),
					A4($author$project$DataElement$Expression$Preview$localNumber, cache, rfDictCache, baseRecord, innerB));
			case 'LocalEqualDate':
				var innerA = bool.a;
				var innerB = bool.b;
				return A3(
					$krisajenkins$remotedata$RemoteData$map2,
					$author$project$Calc$comparableEqual($justinmimbs$date$Date$compare),
					A4($author$project$DataElement$Expression$Preview$localDate, cache, rfDictCache, baseRecord, innerA),
					A4($author$project$DataElement$Expression$Preview$localDate, cache, rfDictCache, baseRecord, innerB));
			case 'LocalEqualDateTime':
				var innerA = bool.a;
				var innerB = bool.b;
				return A3(
					$krisajenkins$remotedata$RemoteData$map2,
					$author$project$Calc$comparableEqual($author$project$Calc$compareDateTime),
					A4($author$project$DataElement$Expression$Preview$localDateTime, cache, rfDictCache, baseRecord, innerA),
					A4($author$project$DataElement$Expression$Preview$localDateTime, cache, rfDictCache, baseRecord, innerB));
			case 'LocalEqualBool':
				var innerA = bool.a;
				var innerB = bool.b;
				return A3(
					$krisajenkins$remotedata$RemoteData$map2,
					$author$project$Calc$equal,
					A4($author$project$DataElement$Expression$Preview$localBool, cache, rfDictCache, baseRecord, innerA),
					A4($author$project$DataElement$Expression$Preview$localBool, cache, rfDictCache, baseRecord, innerB));
			case 'LocalNotEqualString':
				var innerA = bool.a;
				var innerB = bool.b;
				return A3(
					$krisajenkins$remotedata$RemoteData$map2,
					$author$project$Calc$comparableNotEqual($author$project$StudioString$compare),
					A4($author$project$DataElement$Expression$Preview$localString, cache, rfDictCache, baseRecord, innerA),
					A4($author$project$DataElement$Expression$Preview$localString, cache, rfDictCache, baseRecord, innerB));
			case 'LocalNotEqualNumber':
				var innerA = bool.a;
				var innerB = bool.b;
				return A3(
					$krisajenkins$remotedata$RemoteData$map2,
					$author$project$Calc$comparableNotEqual($elm$core$Basics$compare),
					A4($author$project$DataElement$Expression$Preview$localNumber, cache, rfDictCache, baseRecord, innerA),
					A4($author$project$DataElement$Expression$Preview$localNumber, cache, rfDictCache, baseRecord, innerB));
			case 'LocalNotEqualDate':
				var innerA = bool.a;
				var innerB = bool.b;
				return A3(
					$krisajenkins$remotedata$RemoteData$map2,
					$author$project$Calc$comparableNotEqual($justinmimbs$date$Date$compare),
					A4($author$project$DataElement$Expression$Preview$localDate, cache, rfDictCache, baseRecord, innerA),
					A4($author$project$DataElement$Expression$Preview$localDate, cache, rfDictCache, baseRecord, innerB));
			case 'LocalNotEqualDateTime':
				var innerA = bool.a;
				var innerB = bool.b;
				return A3(
					$krisajenkins$remotedata$RemoteData$map2,
					$author$project$Calc$comparableNotEqual($author$project$Calc$compareDateTime),
					A4($author$project$DataElement$Expression$Preview$localDateTime, cache, rfDictCache, baseRecord, innerA),
					A4($author$project$DataElement$Expression$Preview$localDateTime, cache, rfDictCache, baseRecord, innerB));
			case 'LocalNotEqualBool':
				var innerA = bool.a;
				var innerB = bool.b;
				return A3(
					$krisajenkins$remotedata$RemoteData$map2,
					$author$project$Calc$notEqual,
					A4($author$project$DataElement$Expression$Preview$localBool, cache, rfDictCache, baseRecord, innerA),
					A4($author$project$DataElement$Expression$Preview$localBool, cache, rfDictCache, baseRecord, innerB));
			case 'LocalStringIn':
				var string = bool.a;
				var list = bool.b;
				return A3(
					$krisajenkins$remotedata$RemoteData$map2,
					$author$project$Calc$stringIn,
					A4($author$project$DataElement$Expression$Preview$localString, cache, rfDictCache, baseRecord, string),
					A4($author$project$DataElement$Expression$Preview$localStringList, cache, rfDictCache, baseRecord, list));
			case 'LocalStringNotIn':
				var string = bool.a;
				var list = bool.b;
				return A3(
					$krisajenkins$remotedata$RemoteData$map2,
					$author$project$Calc$stringNotIn,
					A4($author$project$DataElement$Expression$Preview$localString, cache, rfDictCache, baseRecord, string),
					A4($author$project$DataElement$Expression$Preview$localStringList, cache, rfDictCache, baseRecord, list));
			case 'LocalNot':
				var innerBool = bool.a;
				return A2(
					$krisajenkins$remotedata$RemoteData$map,
					$author$project$Calc$not,
					A4($author$project$DataElement$Expression$Preview$localBool, cache, rfDictCache, baseRecord, innerBool));
			case 'LocalBoolIf':
				var cond = bool.a;
				var then_ = bool.b;
				var else_ = bool.c;
				return A4(
					$krisajenkins$remotedata$RemoteData$map3,
					$author$project$Calc$if_,
					A4($author$project$DataElement$Expression$Preview$localBool, cache, rfDictCache, baseRecord, cond),
					A4($author$project$DataElement$Expression$Preview$localBool, cache, rfDictCache, baseRecord, then_),
					A4($author$project$DataElement$Expression$Preview$localBool, cache, rfDictCache, baseRecord, else_));
			case 'LocalPickBool':
				var innerList = bool.a;
				return A2(
					$krisajenkins$remotedata$RemoteData$map,
					$author$project$Calc$pickOne,
					A4($author$project$DataElement$Expression$Preview$localBoolList, cache, rfDictCache, baseRecord, innerList));
			case 'LocalAll':
				var innerList = bool.a;
				return A2(
					$krisajenkins$remotedata$RemoteData$map,
					$author$project$Calc$all,
					A4($author$project$DataElement$Expression$Preview$localBoolList, cache, rfDictCache, baseRecord, innerList));
			case 'LocalAny':
				var innerList = bool.a;
				return A2(
					$krisajenkins$remotedata$RemoteData$map,
					$author$project$Calc$any,
					A4($author$project$DataElement$Expression$Preview$localBoolList, cache, rfDictCache, baseRecord, innerList));
			case 'LocalIsNull':
				var field = bool.a;
				return A2(
					$krisajenkins$remotedata$RemoteData$map,
					$author$project$Calc$isNull,
					A4($author$project$DataElement$Expression$Preview$localField, cache, rfDictCache, baseRecord, field));
			default:
				var field = bool.a;
				return A2(
					$krisajenkins$remotedata$RemoteData$map,
					$author$project$Calc$isNotNull,
					A4($author$project$DataElement$Expression$Preview$localField, cache, rfDictCache, baseRecord, field));
		}
	});
var $author$project$DataElement$Expression$Preview$localBoolList = F4(
	function (cache, rfDictCache, baseRecord, boolList) {
		switch (boolList.$) {
			case 'RelatedBool':
				var relationship = boolList.a;
				var fieldName = boolList.b;
				return A5($author$project$DataElement$Expression$Preview$previewRelatedBool, cache, rfDictCache, baseRecord, relationship, fieldName);
			case 'LocalAllBoolsInField':
				var listRef = boolList.a;
				var fieldName = boolList.b;
				return A2(
					$krisajenkins$remotedata$RemoteData$map,
					$elm$core$List$map(
						$author$project$DataEngine$RecordCache$getBool(fieldName)),
					A2($author$project$DataElement$Expression$Preview$listReference, cache, listRef));
			case 'LocalBoolsAsList':
				var localBools = boolList.a;
				return $author$project$RemoteData$Helpers$combine(
					A2(
						$elm$core$List$map,
						A3($author$project$DataElement$Expression$Preview$localBool, cache, rfDictCache, baseRecord),
						localBools));
			default:
				var cond = boolList.a;
				var then_ = boolList.b;
				var else_ = boolList.c;
				return A4(
					$krisajenkins$remotedata$RemoteData$map3,
					$author$project$Calc$if_,
					A4($author$project$DataElement$Expression$Preview$localBool, cache, rfDictCache, baseRecord, cond),
					A4($author$project$DataElement$Expression$Preview$localBoolList, cache, rfDictCache, baseRecord, then_),
					A4($author$project$DataElement$Expression$Preview$localBoolList, cache, rfDictCache, baseRecord, else_));
		}
	});
var $author$project$DataElement$Expression$Preview$localComparableWithTransformation = F5(
	function (transform, cache, rfDictCache, baseRecord, localComparableList) {
		switch (localComparableList.$) {
			case 'LocalCompStringListExpr':
				var stringList = localComparableList.a;
				return A2(
					$krisajenkins$remotedata$RemoteData$map,
					transform.string,
					A4($author$project$DataElement$Expression$Preview$localStringList, cache, rfDictCache, baseRecord, stringList));
			case 'LocalCompNumberListExpr':
				var numberList = localComparableList.a;
				return A2(
					$krisajenkins$remotedata$RemoteData$map,
					transform.number,
					A4($author$project$DataElement$Expression$Preview$localNumberList, cache, rfDictCache, baseRecord, numberList));
			case 'LocalCompDateListExpr':
				var dateList = localComparableList.a;
				return A2(
					$krisajenkins$remotedata$RemoteData$map,
					transform.date,
					A4($author$project$DataElement$Expression$Preview$localDateList, cache, rfDictCache, baseRecord, dateList));
			default:
				var dateTimeList = localComparableList.a;
				return A2(
					$krisajenkins$remotedata$RemoteData$map,
					transform.datetime,
					A4($author$project$DataElement$Expression$Preview$localDateTimeList, cache, rfDictCache, baseRecord, dateTimeList));
		}
	});
var $author$project$DataElement$Expression$Preview$localDate = F4(
	function (cache, rfDictCache, baseRecord, date) {
		switch (date.$) {
			case 'LocalDate':
				var fieldName = date.a;
				return $krisajenkins$remotedata$RemoteData$Success(
					A2($author$project$DataEngine$RecordCache$getDate, fieldName, baseRecord));
			case 'LocalSingletonDate':
				var singletonRef = date.a;
				var fieldName = date.b;
				return A2(
					$krisajenkins$remotedata$RemoteData$map,
					$author$project$DataEngine$RecordCache$getDate(fieldName),
					A2($author$project$DataElement$Expression$Preview$singletonReference, cache, singletonRef));
			case 'LocalDateHardcoded':
				var hardcodedDate = date.a;
				return $krisajenkins$remotedata$RemoteData$Success(
					$elm$core$Maybe$Just(hardcodedDate));
			case 'LocalDateTimeToDate':
				var innerDateTime = date.a;
				return A2(
					$krisajenkins$remotedata$RemoteData$map,
					$author$project$Calc$dateTimeToDate(
						$author$project$DataEngine$DataCache$getLoadableTimeZone(cache)),
					A4($author$project$DataElement$Expression$Preview$localDateTime, cache, rfDictCache, baseRecord, innerDateTime));
			case 'LocalDateCeiling':
				var dateInterval = date.a;
				var innerDate = date.b;
				return A2(
					$krisajenkins$remotedata$RemoteData$map,
					$author$project$Calc$dateCeiling(
						$author$project$DateInterval$toInterval(dateInterval)),
					A4($author$project$DataElement$Expression$Preview$localDate, cache, rfDictCache, baseRecord, innerDate));
			case 'LocalDateFloor':
				var dateInterval = date.a;
				var innerDate = date.b;
				return A2(
					$krisajenkins$remotedata$RemoteData$map,
					$author$project$Calc$dateFloor(
						$author$project$DateInterval$toInterval(dateInterval)),
					A4($author$project$DataElement$Expression$Preview$localDate, cache, rfDictCache, baseRecord, innerDate));
			case 'LocalDateAdd':
				var dateUnit = date.a;
				var innerNum = date.b;
				var innerDate = date.c;
				return A3(
					$krisajenkins$remotedata$RemoteData$map2,
					$author$project$Calc$dateAdd(
						$author$project$DateUnit$toUnit(dateUnit)),
					A4($author$project$DataElement$Expression$Preview$localNumber, cache, rfDictCache, baseRecord, innerNum),
					A4($author$project$DataElement$Expression$Preview$localDate, cache, rfDictCache, baseRecord, innerDate));
			case 'LocalDateSubtract':
				var dateUnit = date.a;
				var innerNum = date.b;
				var innerDate = date.c;
				return A3(
					$krisajenkins$remotedata$RemoteData$map2,
					$author$project$Calc$dateSubtract(
						$author$project$DateUnit$toUnit(dateUnit)),
					A4($author$project$DataElement$Expression$Preview$localNumber, cache, rfDictCache, baseRecord, innerNum),
					A4($author$project$DataElement$Expression$Preview$localDate, cache, rfDictCache, baseRecord, innerDate));
			case 'LocalDateIf':
				var cond = date.a;
				var then_ = date.b;
				var else_ = date.c;
				return A4(
					$krisajenkins$remotedata$RemoteData$map3,
					$author$project$Calc$if_,
					A4($author$project$DataElement$Expression$Preview$localBool, cache, rfDictCache, baseRecord, cond),
					A4($author$project$DataElement$Expression$Preview$localDate, cache, rfDictCache, baseRecord, then_),
					A4($author$project$DataElement$Expression$Preview$localDate, cache, rfDictCache, baseRecord, else_));
			case 'LocalPickDate':
				var innerList = date.a;
				return A2(
					$krisajenkins$remotedata$RemoteData$map,
					$author$project$Calc$pickOne,
					A4($author$project$DataElement$Expression$Preview$localDateList, cache, rfDictCache, baseRecord, innerList));
			case 'LocalMaxDate':
				var list = date.a;
				return A2(
					$krisajenkins$remotedata$RemoteData$map,
					$author$project$Calc$maxWith($justinmimbs$date$Date$compare),
					A4($author$project$DataElement$Expression$Preview$localDateList, cache, rfDictCache, baseRecord, list));
			default:
				var list = date.a;
				return A2(
					$krisajenkins$remotedata$RemoteData$map,
					$author$project$Calc$minWith($justinmimbs$date$Date$compare),
					A4($author$project$DataElement$Expression$Preview$localDateList, cache, rfDictCache, baseRecord, list));
		}
	});
var $author$project$DataElement$Expression$Preview$localDateList = F4(
	function (cache, rfDictCache, baseRecord, dateList) {
		switch (dateList.$) {
			case 'RelatedDate':
				var relationship = dateList.a;
				var fieldName = dateList.b;
				return A5($author$project$DataElement$Expression$Preview$previewRelatedDate, cache, rfDictCache, baseRecord, relationship, fieldName);
			case 'LocalAllDatesInField':
				var listRef = dateList.a;
				var fieldName = dateList.b;
				return A2(
					$krisajenkins$remotedata$RemoteData$map,
					$elm$core$List$map(
						$author$project$DataEngine$RecordCache$getDate(fieldName)),
					A2($author$project$DataElement$Expression$Preview$listReference, cache, listRef));
			case 'LocalDatesAsList':
				var localDates = dateList.a;
				return $author$project$RemoteData$Helpers$combine(
					A2(
						$elm$core$List$map,
						A3($author$project$DataElement$Expression$Preview$localDate, cache, rfDictCache, baseRecord),
						localDates));
			default:
				var cond = dateList.a;
				var then_ = dateList.b;
				var else_ = dateList.c;
				return A4(
					$krisajenkins$remotedata$RemoteData$map3,
					$author$project$Calc$if_,
					A4($author$project$DataElement$Expression$Preview$localBool, cache, rfDictCache, baseRecord, cond),
					A4($author$project$DataElement$Expression$Preview$localDateList, cache, rfDictCache, baseRecord, then_),
					A4($author$project$DataElement$Expression$Preview$localDateList, cache, rfDictCache, baseRecord, else_));
		}
	});
var $author$project$DataElement$Expression$Preview$localDateTime = F4(
	function (cache, rfDictCache, baseRecord, dateTime) {
		switch (dateTime.$) {
			case 'LocalDateTime':
				var fieldName = dateTime.a;
				return $krisajenkins$remotedata$RemoteData$Success(
					A2($author$project$DataEngine$RecordCache$getDateTime, fieldName, baseRecord));
			case 'LocalSingletonDateTime':
				var singletonRef = dateTime.a;
				var fieldName = dateTime.b;
				return A2(
					$krisajenkins$remotedata$RemoteData$map,
					$author$project$DataEngine$RecordCache$getDateTime(fieldName),
					A2($author$project$DataElement$Expression$Preview$singletonReference, cache, singletonRef));
			case 'LocalDateTimeHardcoded':
				var posix = dateTime.a;
				return $krisajenkins$remotedata$RemoteData$Success(
					$elm$core$Maybe$Just(posix));
			case 'LocalDateTimeIf':
				var cond = dateTime.a;
				var then_ = dateTime.b;
				var else_ = dateTime.c;
				return A4(
					$krisajenkins$remotedata$RemoteData$map3,
					$author$project$Calc$if_,
					A4($author$project$DataElement$Expression$Preview$localBool, cache, rfDictCache, baseRecord, cond),
					A4($author$project$DataElement$Expression$Preview$localDateTime, cache, rfDictCache, baseRecord, then_),
					A4($author$project$DataElement$Expression$Preview$localDateTime, cache, rfDictCache, baseRecord, else_));
			case 'LocalPickDateTime':
				var innerList = dateTime.a;
				return A2(
					$krisajenkins$remotedata$RemoteData$map,
					$author$project$Calc$pickOne,
					A4($author$project$DataElement$Expression$Preview$localDateTimeList, cache, rfDictCache, baseRecord, innerList));
			case 'LocalMaxDateTime':
				var list = dateTime.a;
				return A2(
					$krisajenkins$remotedata$RemoteData$map,
					$author$project$Calc$maxWith($author$project$Calc$compareDateTime),
					A4($author$project$DataElement$Expression$Preview$localDateTimeList, cache, rfDictCache, baseRecord, list));
			default:
				var list = dateTime.a;
				return A2(
					$krisajenkins$remotedata$RemoteData$map,
					$author$project$Calc$minWith($author$project$Calc$compareDateTime),
					A4($author$project$DataElement$Expression$Preview$localDateTimeList, cache, rfDictCache, baseRecord, list));
		}
	});
var $author$project$DataElement$Expression$Preview$localDateTimeList = F4(
	function (cache, rfDictCache, baseRecord, dateTimeList) {
		switch (dateTimeList.$) {
			case 'RelatedDateTime':
				var relationship = dateTimeList.a;
				var fieldName = dateTimeList.b;
				return A5($author$project$DataElement$Expression$Preview$previewRelatedDateTime, cache, rfDictCache, baseRecord, relationship, fieldName);
			case 'LocalAllDateTimesInField':
				var listRef = dateTimeList.a;
				var fieldName = dateTimeList.b;
				return A2(
					$krisajenkins$remotedata$RemoteData$map,
					$elm$core$List$map(
						$author$project$DataEngine$RecordCache$getDateTime(fieldName)),
					A2($author$project$DataElement$Expression$Preview$listReference, cache, listRef));
			case 'LocalDateTimesAsList':
				var localDateTimes = dateTimeList.a;
				return $author$project$RemoteData$Helpers$combine(
					A2(
						$elm$core$List$map,
						A3($author$project$DataElement$Expression$Preview$localDateTime, cache, rfDictCache, baseRecord),
						localDateTimes));
			default:
				var cond = dateTimeList.a;
				var then_ = dateTimeList.b;
				var else_ = dateTimeList.c;
				return A4(
					$krisajenkins$remotedata$RemoteData$map3,
					$author$project$Calc$if_,
					A4($author$project$DataElement$Expression$Preview$localBool, cache, rfDictCache, baseRecord, cond),
					A4($author$project$DataElement$Expression$Preview$localDateTimeList, cache, rfDictCache, baseRecord, then_),
					A4($author$project$DataElement$Expression$Preview$localDateTimeList, cache, rfDictCache, baseRecord, else_));
		}
	});
var $author$project$DataElement$Expression$Preview$localField = F4(
	function (cache, rfDictCache, baseRecord, field) {
		switch (field.$) {
			case 'LocalStringExpr':
				var string = field.a;
				return A2(
					$krisajenkins$remotedata$RemoteData$map,
					$elm$core$Maybe$map($author$project$FieldValue$StringValue),
					A4($author$project$DataElement$Expression$Preview$localString, cache, rfDictCache, baseRecord, string));
			case 'LocalNumberExpr':
				var number = field.a;
				return A2(
					$krisajenkins$remotedata$RemoteData$map,
					$elm$core$Maybe$map($author$project$FieldValue$NumberValue),
					A4($author$project$DataElement$Expression$Preview$localNumber, cache, rfDictCache, baseRecord, number));
			case 'LocalDateExpr':
				var date = field.a;
				return A2(
					$krisajenkins$remotedata$RemoteData$map,
					$elm$core$Maybe$map($author$project$FieldValue$DateValue),
					A4($author$project$DataElement$Expression$Preview$localDate, cache, rfDictCache, baseRecord, date));
			case 'LocalDateTimeExpr':
				var dateTime = field.a;
				return A2(
					$krisajenkins$remotedata$RemoteData$map,
					$elm$core$Maybe$map($author$project$FieldValue$DateTimeValue),
					A4($author$project$DataElement$Expression$Preview$localDateTime, cache, rfDictCache, baseRecord, dateTime));
			default:
				var bool = field.a;
				return A2(
					$krisajenkins$remotedata$RemoteData$map,
					$elm$core$Maybe$map($author$project$FieldValue$BoolValue),
					A4($author$project$DataElement$Expression$Preview$localBool, cache, rfDictCache, baseRecord, bool));
		}
	});
var $author$project$DataElement$Expression$Preview$localNumber = F4(
	function (cache, rfDictCache, baseRecord, number) {
		switch (number.$) {
			case 'LocalNumber':
				var fieldName = number.a;
				return $krisajenkins$remotedata$RemoteData$Success(
					A2($author$project$DataEngine$RecordCache$getNumber, fieldName, baseRecord));
			case 'LocalSingletonNumber':
				var singletonRef = number.a;
				var fieldName = number.b;
				return A2(
					$krisajenkins$remotedata$RemoteData$map,
					$author$project$DataEngine$RecordCache$getNumber(fieldName),
					A2($author$project$DataElement$Expression$Preview$singletonReference, cache, singletonRef));
			case 'LocalNumberHardcoded':
				var hardcodedNumber = number.a;
				return $krisajenkins$remotedata$RemoteData$Success(
					$elm$core$Maybe$Just(hardcodedNumber));
			case 'LocalCountUnique':
				var localComparable = number.a;
				return A5($author$project$DataElement$Expression$Preview$localComparableWithTransformation, $author$project$DataElement$Expression$Preview$countUniqueComparableTransform, cache, rfDictCache, baseRecord, localComparable);
			case 'LocalRound':
				var innerNumber = number.a;
				return A2(
					$krisajenkins$remotedata$RemoteData$map,
					$author$project$Calc$round,
					A4($author$project$DataElement$Expression$Preview$localNumber, cache, rfDictCache, baseRecord, innerNumber));
			case 'LocalSum':
				var numberList = number.a;
				return A2(
					$krisajenkins$remotedata$RemoteData$map,
					$author$project$Calc$sum,
					A4($author$project$DataElement$Expression$Preview$localNumberList, cache, rfDictCache, baseRecord, numberList));
			case 'LocalProduct':
				var numberList = number.a;
				return A2(
					$krisajenkins$remotedata$RemoteData$map,
					$author$project$Calc$product,
					A4($author$project$DataElement$Expression$Preview$localNumberList, cache, rfDictCache, baseRecord, numberList));
			case 'LocalAdd':
				var localNumA = number.a;
				var localNumB = number.b;
				return A3(
					$krisajenkins$remotedata$RemoteData$map2,
					$author$project$Calc$add,
					A4($author$project$DataElement$Expression$Preview$localNumber, cache, rfDictCache, baseRecord, localNumA),
					A4($author$project$DataElement$Expression$Preview$localNumber, cache, rfDictCache, baseRecord, localNumB));
			case 'LocalSubtract':
				var localNumA = number.a;
				var localNumB = number.b;
				return A3(
					$krisajenkins$remotedata$RemoteData$map2,
					$author$project$Calc$subtract,
					A4($author$project$DataElement$Expression$Preview$localNumber, cache, rfDictCache, baseRecord, localNumA),
					A4($author$project$DataElement$Expression$Preview$localNumber, cache, rfDictCache, baseRecord, localNumB));
			case 'LocalMultiply':
				var localNumA = number.a;
				var localNumB = number.b;
				return A3(
					$krisajenkins$remotedata$RemoteData$map2,
					$author$project$Calc$multiply,
					A4($author$project$DataElement$Expression$Preview$localNumber, cache, rfDictCache, baseRecord, localNumA),
					A4($author$project$DataElement$Expression$Preview$localNumber, cache, rfDictCache, baseRecord, localNumB));
			case 'LocalDivide':
				var localNumA = number.a;
				var localNumB = number.b;
				return A3(
					$krisajenkins$remotedata$RemoteData$map2,
					$author$project$Calc$divide,
					A4($author$project$DataElement$Expression$Preview$localNumber, cache, rfDictCache, baseRecord, localNumA),
					A4($author$project$DataElement$Expression$Preview$localNumber, cache, rfDictCache, baseRecord, localNumB));
			case 'LocalMonthNumber':
				var innerDate = number.a;
				return A2(
					$krisajenkins$remotedata$RemoteData$map,
					$author$project$Calc$monthNumber,
					A4($author$project$DataElement$Expression$Preview$localDate, cache, rfDictCache, baseRecord, innerDate));
			case 'LocalYearNumber':
				var innerDate = number.a;
				return A2(
					$krisajenkins$remotedata$RemoteData$map,
					$author$project$Calc$yearNumber,
					A4($author$project$DataElement$Expression$Preview$localDate, cache, rfDictCache, baseRecord, innerDate));
			case 'LocalDayInMonth':
				var innerDate = number.a;
				return A2(
					$krisajenkins$remotedata$RemoteData$map,
					$author$project$Calc$dayInMonth,
					A4($author$project$DataElement$Expression$Preview$localDate, cache, rfDictCache, baseRecord, innerDate));
			case 'LocalNumberIf':
				var cond = number.a;
				var then_ = number.b;
				var else_ = number.c;
				return A4(
					$krisajenkins$remotedata$RemoteData$map3,
					$author$project$Calc$if_,
					A4($author$project$DataElement$Expression$Preview$localBool, cache, rfDictCache, baseRecord, cond),
					A4($author$project$DataElement$Expression$Preview$localNumber, cache, rfDictCache, baseRecord, then_),
					A4($author$project$DataElement$Expression$Preview$localNumber, cache, rfDictCache, baseRecord, else_));
			case 'LocalPickNumber':
				var innerList = number.a;
				return A2(
					$krisajenkins$remotedata$RemoteData$map,
					$author$project$Calc$pickOne,
					A4($author$project$DataElement$Expression$Preview$localNumberList, cache, rfDictCache, baseRecord, innerList));
			case 'LocalMaxNumber':
				var list = number.a;
				return A2(
					$krisajenkins$remotedata$RemoteData$map,
					$author$project$Calc$maxWith($elm$core$Basics$compare),
					A4($author$project$DataElement$Expression$Preview$localNumberList, cache, rfDictCache, baseRecord, list));
			default:
				var list = number.a;
				return A2(
					$krisajenkins$remotedata$RemoteData$map,
					$author$project$Calc$minWith($elm$core$Basics$compare),
					A4($author$project$DataElement$Expression$Preview$localNumberList, cache, rfDictCache, baseRecord, list));
		}
	});
var $author$project$DataElement$Expression$Preview$localNumberList = F4(
	function (cache, rfDictCache, baseRecord, numberList) {
		switch (numberList.$) {
			case 'RelatedNumber':
				var relationship = numberList.a;
				var number = numberList.b;
				return A5($author$project$DataElement$Expression$Preview$previewRelatedNumber, cache, rfDictCache, baseRecord, relationship, number);
			case 'LocalAllNumbersInField':
				var listRef = numberList.a;
				var fieldName = numberList.b;
				return A2(
					$krisajenkins$remotedata$RemoteData$map,
					$elm$core$List$map(
						$author$project$DataEngine$RecordCache$getNumber(fieldName)),
					A2($author$project$DataElement$Expression$Preview$listReference, cache, listRef));
			case 'LocalNumbersAsList':
				var localNumbers = numberList.a;
				return $author$project$RemoteData$Helpers$combine(
					A2(
						$elm$core$List$map,
						A3($author$project$DataElement$Expression$Preview$localNumber, cache, rfDictCache, baseRecord),
						localNumbers));
			default:
				var cond = numberList.a;
				var then_ = numberList.b;
				var else_ = numberList.c;
				return A4(
					$krisajenkins$remotedata$RemoteData$map3,
					$author$project$Calc$if_,
					A4($author$project$DataElement$Expression$Preview$localBool, cache, rfDictCache, baseRecord, cond),
					A4($author$project$DataElement$Expression$Preview$localNumberList, cache, rfDictCache, baseRecord, then_),
					A4($author$project$DataElement$Expression$Preview$localNumberList, cache, rfDictCache, baseRecord, else_));
		}
	});
var $author$project$DataElement$Expression$Preview$localString = F4(
	function (cache, rfDictCache, baseRecord, string) {
		switch (string.$) {
			case 'LocalString':
				var fieldName = string.a;
				return $krisajenkins$remotedata$RemoteData$Success(
					A2($author$project$DataEngine$RecordCache$getString, fieldName, baseRecord));
			case 'LocalSingletonString':
				var singletonRef = string.a;
				var fieldName = string.b;
				return A2(
					$krisajenkins$remotedata$RemoteData$map,
					$author$project$DataEngine$RecordCache$getString(fieldName),
					A2($author$project$DataElement$Expression$Preview$singletonReference, cache, singletonRef));
			case 'LocalStringHardcoded':
				var words = string.a;
				return $krisajenkins$remotedata$RemoteData$Success(
					$elm$core$Maybe$Just(
						$author$project$StudioString$withoutObject(words)));
			case 'LocalFormatDate':
				var innerString = string.a;
				var innerDate = string.b;
				return A3(
					$krisajenkins$remotedata$RemoteData$map2,
					$author$project$Calc$formatDate,
					A4($author$project$DataElement$Expression$Preview$localString, cache, rfDictCache, baseRecord, innerString),
					A4($author$project$DataElement$Expression$Preview$localDate, cache, rfDictCache, baseRecord, innerDate));
			case 'LocalFormatDateLocaleAware':
				var innerDate = string.a;
				return A3(
					$krisajenkins$remotedata$RemoteData$map2,
					$author$project$Calc$formatDateLocaleAware,
					$author$project$DataEngine$DataCache$getLocaleRemoteData(cache),
					A4($author$project$DataElement$Expression$Preview$localDate, cache, rfDictCache, baseRecord, innerDate));
			case 'LocalFormatDateTime':
				var innerDateTime = string.a;
				return A4(
					$krisajenkins$remotedata$RemoteData$map3,
					$author$project$Calc$formatDateTimeLocaleAware,
					$author$project$DataEngine$DataCache$getLocaleRemoteData(cache),
					$author$project$DataEngine$DataCache$getTimeZoneRemoteData(cache),
					A4($author$project$DataElement$Expression$Preview$localDateTime, cache, rfDictCache, baseRecord, innerDateTime));
			case 'LocalFormatNumber':
				var decimals = string.a;
				var innerNumber = string.b;
				return A2(
					$krisajenkins$remotedata$RemoteData$map,
					$author$project$Calc$formatNumber(decimals),
					A4($author$project$DataElement$Expression$Preview$localNumber, cache, rfDictCache, baseRecord, innerNumber));
			case 'LocalStringIf':
				var cond = string.a;
				var then_ = string.b;
				var else_ = string.c;
				return A4(
					$krisajenkins$remotedata$RemoteData$map3,
					$author$project$Calc$if_,
					A4($author$project$DataElement$Expression$Preview$localBool, cache, rfDictCache, baseRecord, cond),
					A4($author$project$DataElement$Expression$Preview$localString, cache, rfDictCache, baseRecord, then_),
					A4($author$project$DataElement$Expression$Preview$localString, cache, rfDictCache, baseRecord, else_));
			case 'LocalPickString':
				var innerList = string.a;
				return A2(
					$krisajenkins$remotedata$RemoteData$map,
					$author$project$Calc$pickOne,
					A4($author$project$DataElement$Expression$Preview$localStringList, cache, rfDictCache, baseRecord, innerList));
			case 'LocalConcat':
				var join = string.a;
				var list = string.b;
				return A3(
					$krisajenkins$remotedata$RemoteData$map2,
					$author$project$Calc$concat,
					A4($author$project$DataElement$Expression$Preview$localString, cache, rfDictCache, baseRecord, join),
					A4($author$project$DataElement$Expression$Preview$localStringList, cache, rfDictCache, baseRecord, list));
			case 'LocalMaxString':
				var list = string.a;
				return A2(
					$krisajenkins$remotedata$RemoteData$map,
					$author$project$Calc$maxWith($author$project$StudioString$compare),
					A4($author$project$DataElement$Expression$Preview$localStringList, cache, rfDictCache, baseRecord, list));
			default:
				var list = string.a;
				return A2(
					$krisajenkins$remotedata$RemoteData$map,
					$author$project$Calc$minWith($author$project$StudioString$compare),
					A4($author$project$DataElement$Expression$Preview$localStringList, cache, rfDictCache, baseRecord, list));
		}
	});
var $author$project$DataElement$Expression$Preview$localStringList = F4(
	function (cache, rfDictCache, baseRecord, stringList) {
		switch (stringList.$) {
			case 'RelatedString':
				var relationship = stringList.a;
				var fieldName = stringList.b;
				return A5($author$project$DataElement$Expression$Preview$previewRelatedString, cache, rfDictCache, baseRecord, relationship, fieldName);
			case 'LocalAllStringsInField':
				var listRef = stringList.a;
				var fieldName = stringList.b;
				return A2(
					$krisajenkins$remotedata$RemoteData$map,
					$elm$core$List$map(
						$author$project$DataEngine$RecordCache$getString(fieldName)),
					A2($author$project$DataElement$Expression$Preview$listReference, cache, listRef));
			case 'LocalStringsAsList':
				var localStrings = stringList.a;
				return $author$project$RemoteData$Helpers$combine(
					A2(
						$elm$core$List$map,
						A3($author$project$DataElement$Expression$Preview$localString, cache, rfDictCache, baseRecord),
						localStrings));
			case 'LocalStringListIf':
				var cond = stringList.a;
				var then_ = stringList.b;
				var else_ = stringList.c;
				return A4(
					$krisajenkins$remotedata$RemoteData$map3,
					$author$project$Calc$if_,
					A4($author$project$DataElement$Expression$Preview$localBool, cache, rfDictCache, baseRecord, cond),
					A4($author$project$DataElement$Expression$Preview$localStringList, cache, rfDictCache, baseRecord, then_),
					A4($author$project$DataElement$Expression$Preview$localStringList, cache, rfDictCache, baseRecord, else_));
			case 'LocalChallengeReasons':
				var acctId = stringList.a;
				return A3(
					$krisajenkins$remotedata$RemoteData$map2,
					$author$project$Calc$challengeReasons,
					$author$project$DataEngine$DataCache$getFeedbackData(cache),
					A4($author$project$DataElement$Expression$Preview$localString, cache, rfDictCache, baseRecord, acctId));
			default:
				var acctId = stringList.a;
				return A3(
					$krisajenkins$remotedata$RemoteData$map2,
					$author$project$Calc$targetChallengeReasons,
					$author$project$DataEngine$DataCache$getFeedbackData(cache),
					A4($author$project$DataElement$Expression$Preview$localString, cache, rfDictCache, baseRecord, acctId));
		}
	});
var $author$project$DataElement$Expression$Preview$previewRelatedBool = F5(
	function (cache, rfDictCache, baseRecord, relationship, fieldName) {
		return A2(
			$krisajenkins$remotedata$RemoteData$map,
			$author$project$Calc$relatedField,
			A2(
				$krisajenkins$remotedata$RemoteData$andMap,
				A4($author$project$DataElement$Expression$Preview$localStringList, cache, rfDictCache, baseRecord, relationship.localIds),
				A2(
					$krisajenkins$remotedata$RemoteData$map,
					$author$project$Calc$RelatedFieldInfo,
					A2(
						$author$project$DataEngine$RfDictCache$boolValue,
						rfDictCache,
						{fieldType: $author$project$FieldType$BoolType, filter: relationship.optionalFilter, id: relationship.idToMatch, nextElement: relationship.nextElement, value: fieldName}))));
	});
var $author$project$DataElement$Expression$Preview$previewRelatedDate = F5(
	function (cache, rfDictCache, baseRecord, relationship, fieldName) {
		return A2(
			$krisajenkins$remotedata$RemoteData$map,
			$author$project$Calc$relatedField,
			A2(
				$krisajenkins$remotedata$RemoteData$andMap,
				A4($author$project$DataElement$Expression$Preview$localStringList, cache, rfDictCache, baseRecord, relationship.localIds),
				A2(
					$krisajenkins$remotedata$RemoteData$map,
					$author$project$Calc$RelatedFieldInfo,
					A2(
						$author$project$DataEngine$RfDictCache$dateValue,
						rfDictCache,
						{fieldType: $author$project$FieldType$DateType, filter: relationship.optionalFilter, id: relationship.idToMatch, nextElement: relationship.nextElement, value: fieldName}))));
	});
var $author$project$DataElement$Expression$Preview$previewRelatedDateTime = F5(
	function (cache, rfDictCache, baseRecord, relationship, fieldName) {
		return A2(
			$krisajenkins$remotedata$RemoteData$map,
			$author$project$Calc$relatedField,
			A2(
				$krisajenkins$remotedata$RemoteData$andMap,
				A4($author$project$DataElement$Expression$Preview$localStringList, cache, rfDictCache, baseRecord, relationship.localIds),
				A2(
					$krisajenkins$remotedata$RemoteData$map,
					$author$project$Calc$RelatedFieldInfo,
					A2(
						$author$project$DataEngine$RfDictCache$dateTimeValue,
						rfDictCache,
						{fieldType: $author$project$FieldType$DateTimeType, filter: relationship.optionalFilter, id: relationship.idToMatch, nextElement: relationship.nextElement, value: fieldName}))));
	});
var $author$project$DataElement$Expression$Preview$previewRelatedNumber = F5(
	function (cache, rfDictCache, baseRecord, relationship, fieldName) {
		return A2(
			$krisajenkins$remotedata$RemoteData$map,
			$author$project$Calc$relatedField,
			A2(
				$krisajenkins$remotedata$RemoteData$andMap,
				A4($author$project$DataElement$Expression$Preview$localStringList, cache, rfDictCache, baseRecord, relationship.localIds),
				A2(
					$krisajenkins$remotedata$RemoteData$map,
					$author$project$Calc$RelatedFieldInfo,
					A2(
						$author$project$DataEngine$RfDictCache$numberValue,
						rfDictCache,
						{fieldType: $author$project$FieldType$NumberType, filter: relationship.optionalFilter, id: relationship.idToMatch, nextElement: relationship.nextElement, value: fieldName}))));
	});
var $author$project$DataElement$Expression$Preview$previewRelatedString = F5(
	function (cache, rfDictCache, baseRecord, relationship, fieldName) {
		return A2(
			$krisajenkins$remotedata$RemoteData$map,
			$author$project$Calc$relatedField,
			A2(
				$krisajenkins$remotedata$RemoteData$andMap,
				A4($author$project$DataElement$Expression$Preview$localStringList, cache, rfDictCache, baseRecord, relationship.localIds),
				A2(
					$krisajenkins$remotedata$RemoteData$map,
					$author$project$Calc$RelatedFieldInfo,
					A2(
						$author$project$DataEngine$RfDictCache$stringValue,
						rfDictCache,
						{fieldType: $author$project$FieldType$StringType, filter: relationship.optionalFilter, id: relationship.idToMatch, nextElement: relationship.nextElement, value: fieldName}))));
	});
var $author$project$DataElement$Expression$Preview$dictCachePreviewDependencies = {listReference: $author$project$DataElement$Expression$Preview$listReference, localBool: $author$project$DataElement$Expression$Preview$localBool, localString: $author$project$DataElement$Expression$Preview$localString};
var $author$project$DataEngine$RfDictCache$RfDictCache = function (a) {
	return {$: 'RfDictCache', a: a};
};
var $author$project$DataEngine$RfDictCache$empty = $author$project$DataEngine$RfDictCache$RfDictCache(
	{boolDicts: $elm$core$Dict$empty, dateDicts: $elm$core$Dict$empty, dateTimeDicts: $elm$core$Dict$empty, numberDicts: $elm$core$Dict$empty, stringDicts: $elm$core$Dict$empty});
var $author$project$Calc$filter = function (toMaybeBool) {
	return $elm$core$List$filter(
		A2(
			$elm$core$Basics$composeR,
			toMaybeBool,
			$elm$core$Maybe$withDefault(false)));
};
var $author$project$Calc$filterRemoteData = function (func) {
	return A2(
		$elm$core$Basics$composeR,
		$elm$core$List$map(
			function (item) {
				return A2(
					$krisajenkins$remotedata$RemoteData$map,
					$elm$core$Tuple$pair(item),
					func(item));
			}),
		A2(
			$elm$core$Basics$composeR,
			$author$project$RemoteData$Helpers$combine,
			$krisajenkins$remotedata$RemoteData$map(
				A2(
					$elm$core$Basics$composeR,
					$author$project$Calc$filter($elm$core$Tuple$second),
					$elm$core$List$map($elm$core$Tuple$first)))));
};
var $elm$core$Dict$getMin = function (dict) {
	getMin:
	while (true) {
		if ((dict.$ === 'RBNode_elm_builtin') && (dict.d.$ === 'RBNode_elm_builtin')) {
			var left = dict.d;
			var $temp$dict = left;
			dict = $temp$dict;
			continue getMin;
		} else {
			return dict;
		}
	}
};
var $elm$core$Dict$moveRedLeft = function (dict) {
	if (((dict.$ === 'RBNode_elm_builtin') && (dict.d.$ === 'RBNode_elm_builtin')) && (dict.e.$ === 'RBNode_elm_builtin')) {
		if ((dict.e.d.$ === 'RBNode_elm_builtin') && (dict.e.d.a.$ === 'Red')) {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v1 = dict.d;
			var lClr = _v1.a;
			var lK = _v1.b;
			var lV = _v1.c;
			var lLeft = _v1.d;
			var lRight = _v1.e;
			var _v2 = dict.e;
			var rClr = _v2.a;
			var rK = _v2.b;
			var rV = _v2.c;
			var rLeft = _v2.d;
			var _v3 = rLeft.a;
			var rlK = rLeft.b;
			var rlV = rLeft.c;
			var rlL = rLeft.d;
			var rlR = rLeft.e;
			var rRight = _v2.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				$elm$core$Dict$Red,
				rlK,
				rlV,
				A5(
					$elm$core$Dict$RBNode_elm_builtin,
					$elm$core$Dict$Black,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, $elm$core$Dict$Red, lK, lV, lLeft, lRight),
					rlL),
				A5($elm$core$Dict$RBNode_elm_builtin, $elm$core$Dict$Black, rK, rV, rlR, rRight));
		} else {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v4 = dict.d;
			var lClr = _v4.a;
			var lK = _v4.b;
			var lV = _v4.c;
			var lLeft = _v4.d;
			var lRight = _v4.e;
			var _v5 = dict.e;
			var rClr = _v5.a;
			var rK = _v5.b;
			var rV = _v5.c;
			var rLeft = _v5.d;
			var rRight = _v5.e;
			if (clr.$ === 'Black') {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					$elm$core$Dict$Black,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, $elm$core$Dict$Red, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, $elm$core$Dict$Red, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					$elm$core$Dict$Black,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, $elm$core$Dict$Red, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, $elm$core$Dict$Red, rK, rV, rLeft, rRight));
			}
		}
	} else {
		return dict;
	}
};
var $elm$core$Dict$moveRedRight = function (dict) {
	if (((dict.$ === 'RBNode_elm_builtin') && (dict.d.$ === 'RBNode_elm_builtin')) && (dict.e.$ === 'RBNode_elm_builtin')) {
		if ((dict.d.d.$ === 'RBNode_elm_builtin') && (dict.d.d.a.$ === 'Red')) {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v1 = dict.d;
			var lClr = _v1.a;
			var lK = _v1.b;
			var lV = _v1.c;
			var _v2 = _v1.d;
			var _v3 = _v2.a;
			var llK = _v2.b;
			var llV = _v2.c;
			var llLeft = _v2.d;
			var llRight = _v2.e;
			var lRight = _v1.e;
			var _v4 = dict.e;
			var rClr = _v4.a;
			var rK = _v4.b;
			var rV = _v4.c;
			var rLeft = _v4.d;
			var rRight = _v4.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				$elm$core$Dict$Red,
				lK,
				lV,
				A5($elm$core$Dict$RBNode_elm_builtin, $elm$core$Dict$Black, llK, llV, llLeft, llRight),
				A5(
					$elm$core$Dict$RBNode_elm_builtin,
					$elm$core$Dict$Black,
					k,
					v,
					lRight,
					A5($elm$core$Dict$RBNode_elm_builtin, $elm$core$Dict$Red, rK, rV, rLeft, rRight)));
		} else {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v5 = dict.d;
			var lClr = _v5.a;
			var lK = _v5.b;
			var lV = _v5.c;
			var lLeft = _v5.d;
			var lRight = _v5.e;
			var _v6 = dict.e;
			var rClr = _v6.a;
			var rK = _v6.b;
			var rV = _v6.c;
			var rLeft = _v6.d;
			var rRight = _v6.e;
			if (clr.$ === 'Black') {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					$elm$core$Dict$Black,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, $elm$core$Dict$Red, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, $elm$core$Dict$Red, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					$elm$core$Dict$Black,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, $elm$core$Dict$Red, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, $elm$core$Dict$Red, rK, rV, rLeft, rRight));
			}
		}
	} else {
		return dict;
	}
};
var $elm$core$Dict$removeHelpPrepEQGT = F7(
	function (targetKey, dict, color, key, value, left, right) {
		if ((left.$ === 'RBNode_elm_builtin') && (left.a.$ === 'Red')) {
			var _v1 = left.a;
			var lK = left.b;
			var lV = left.c;
			var lLeft = left.d;
			var lRight = left.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				color,
				lK,
				lV,
				lLeft,
				A5($elm$core$Dict$RBNode_elm_builtin, $elm$core$Dict$Red, key, value, lRight, right));
		} else {
			_v2$2:
			while (true) {
				if ((right.$ === 'RBNode_elm_builtin') && (right.a.$ === 'Black')) {
					if (right.d.$ === 'RBNode_elm_builtin') {
						if (right.d.a.$ === 'Black') {
							var _v3 = right.a;
							var _v4 = right.d;
							var _v5 = _v4.a;
							return $elm$core$Dict$moveRedRight(dict);
						} else {
							break _v2$2;
						}
					} else {
						var _v6 = right.a;
						var _v7 = right.d;
						return $elm$core$Dict$moveRedRight(dict);
					}
				} else {
					break _v2$2;
				}
			}
			return dict;
		}
	});
var $elm$core$Dict$removeMin = function (dict) {
	if ((dict.$ === 'RBNode_elm_builtin') && (dict.d.$ === 'RBNode_elm_builtin')) {
		var color = dict.a;
		var key = dict.b;
		var value = dict.c;
		var left = dict.d;
		var lColor = left.a;
		var lLeft = left.d;
		var right = dict.e;
		if (lColor.$ === 'Black') {
			if ((lLeft.$ === 'RBNode_elm_builtin') && (lLeft.a.$ === 'Red')) {
				var _v3 = lLeft.a;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					color,
					key,
					value,
					$elm$core$Dict$removeMin(left),
					right);
			} else {
				var _v4 = $elm$core$Dict$moveRedLeft(dict);
				if (_v4.$ === 'RBNode_elm_builtin') {
					var nColor = _v4.a;
					var nKey = _v4.b;
					var nValue = _v4.c;
					var nLeft = _v4.d;
					var nRight = _v4.e;
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						$elm$core$Dict$removeMin(nLeft),
						nRight);
				} else {
					return $elm$core$Dict$RBEmpty_elm_builtin;
				}
			}
		} else {
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				color,
				key,
				value,
				$elm$core$Dict$removeMin(left),
				right);
		}
	} else {
		return $elm$core$Dict$RBEmpty_elm_builtin;
	}
};
var $elm$core$Dict$removeHelp = F2(
	function (targetKey, dict) {
		if (dict.$ === 'RBEmpty_elm_builtin') {
			return $elm$core$Dict$RBEmpty_elm_builtin;
		} else {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			if (_Utils_cmp(targetKey, key) < 0) {
				if ((left.$ === 'RBNode_elm_builtin') && (left.a.$ === 'Black')) {
					var _v4 = left.a;
					var lLeft = left.d;
					if ((lLeft.$ === 'RBNode_elm_builtin') && (lLeft.a.$ === 'Red')) {
						var _v6 = lLeft.a;
						return A5(
							$elm$core$Dict$RBNode_elm_builtin,
							color,
							key,
							value,
							A2($elm$core$Dict$removeHelp, targetKey, left),
							right);
					} else {
						var _v7 = $elm$core$Dict$moveRedLeft(dict);
						if (_v7.$ === 'RBNode_elm_builtin') {
							var nColor = _v7.a;
							var nKey = _v7.b;
							var nValue = _v7.c;
							var nLeft = _v7.d;
							var nRight = _v7.e;
							return A5(
								$elm$core$Dict$balance,
								nColor,
								nKey,
								nValue,
								A2($elm$core$Dict$removeHelp, targetKey, nLeft),
								nRight);
						} else {
							return $elm$core$Dict$RBEmpty_elm_builtin;
						}
					}
				} else {
					return A5(
						$elm$core$Dict$RBNode_elm_builtin,
						color,
						key,
						value,
						A2($elm$core$Dict$removeHelp, targetKey, left),
						right);
				}
			} else {
				return A2(
					$elm$core$Dict$removeHelpEQGT,
					targetKey,
					A7($elm$core$Dict$removeHelpPrepEQGT, targetKey, dict, color, key, value, left, right));
			}
		}
	});
var $elm$core$Dict$removeHelpEQGT = F2(
	function (targetKey, dict) {
		if (dict.$ === 'RBNode_elm_builtin') {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			if (_Utils_eq(targetKey, key)) {
				var _v1 = $elm$core$Dict$getMin(right);
				if (_v1.$ === 'RBNode_elm_builtin') {
					var minKey = _v1.b;
					var minValue = _v1.c;
					return A5(
						$elm$core$Dict$balance,
						color,
						minKey,
						minValue,
						left,
						$elm$core$Dict$removeMin(right));
				} else {
					return $elm$core$Dict$RBEmpty_elm_builtin;
				}
			} else {
				return A5(
					$elm$core$Dict$balance,
					color,
					key,
					value,
					left,
					A2($elm$core$Dict$removeHelp, targetKey, right));
			}
		} else {
			return $elm$core$Dict$RBEmpty_elm_builtin;
		}
	});
var $elm$core$Dict$remove = F2(
	function (key, dict) {
		var _v0 = A2($elm$core$Dict$removeHelp, key, dict);
		if ((_v0.$ === 'RBNode_elm_builtin') && (_v0.a.$ === 'Red')) {
			var _v1 = _v0.a;
			var k = _v0.b;
			var v = _v0.c;
			var l = _v0.d;
			var r = _v0.e;
			return A5($elm$core$Dict$RBNode_elm_builtin, $elm$core$Dict$Black, k, v, l, r);
		} else {
			var x = _v0;
			return x;
		}
	});
var $elm$core$Dict$update = F3(
	function (targetKey, alter, dictionary) {
		var _v0 = alter(
			A2($elm$core$Dict$get, targetKey, dictionary));
		if (_v0.$ === 'Just') {
			var value = _v0.a;
			return A3($elm$core$Dict$insert, targetKey, value, dictionary);
		} else {
			return A2($elm$core$Dict$remove, targetKey, dictionary);
		}
	});
var $elm_community$dict_extra$Dict$Extra$insertDedupe = F4(
	function (combine, key, value, dict) {
		var _with = function (mbValue) {
			if (mbValue.$ === 'Just') {
				var oldValue = mbValue.a;
				return $elm$core$Maybe$Just(
					A2(combine, oldValue, value));
			} else {
				return $elm$core$Maybe$Just(value);
			}
		};
		return A3($elm$core$Dict$update, key, _with, dict);
	});
var $elm_community$dict_extra$Dict$Extra$fromListDedupe = F2(
	function (combine, xs) {
		return A3(
			$elm$core$List$foldl,
			F2(
				function (_v0, acc) {
					var key = _v0.a;
					var value = _v0.b;
					return A4($elm_community$dict_extra$Dict$Extra$insertDedupe, combine, key, value, acc);
				}),
			$elm$core$Dict$empty,
			xs);
	});
var $author$project$Calc$toDict = F3(
	function (toId, toValue, records) {
		return A2(
			$elm_community$dict_extra$Dict$Extra$fromListDedupe,
			$elm$core$List$append,
			A2(
				$elm$core$List$filterMap,
				function (account) {
					return A2(
						$elm$core$Maybe$map,
						function (id) {
							return _Utils_Tuple2(
								id.text,
								_List_fromArray(
									[
										toValue(account)
									]));
						},
						toId(account));
				},
				records));
	});
var $author$project$DataEngine$RfDictCache$insert = F4(
	function (previewFunctions, dataCache, relationship, _v0) {
		var internal = _v0.a;
		var nextElementAfterFilter = F2(
			function (localBool, list) {
				if (localBool.$ === 'Just') {
					var filter = localBool.a;
					return A2(
						$elm$core$List$filter,
						function (recordCache) {
							return A2(
								$elm$core$Maybe$withDefault,
								false,
								A2(
									$krisajenkins$remotedata$RemoteData$withDefault,
									$elm$core$Maybe$Nothing,
									A4(
										previewFunctions.localBool,
										dataCache,
										$author$project$DataEngine$RfDictCache$RfDictCache(internal),
										recordCache,
										filter)));
						},
						list);
				} else {
					return list;
				}
			});
		var hashString = $Evelios$elm_hash$Hash$toString(
			$author$project$DataElement$Expression$hashRelatedFieldDictionaryInfo(relationship));
		var addToDict = F2(
			function (relatedFieldInfo, accessFunction) {
				var getResultDict = A2(
					$author$project$Calc$toDict,
					function (recordCache) {
						return A2(
							$krisajenkins$remotedata$RemoteData$withDefault,
							$elm$core$Maybe$Nothing,
							A4(
								previewFunctions.localString,
								dataCache,
								$author$project$DataEngine$RfDictCache$RfDictCache(internal),
								recordCache,
								relatedFieldInfo.id));
					},
					accessFunction(relatedFieldInfo.value));
				var resultDict = A2(
					$krisajenkins$remotedata$RemoteData$map,
					getResultDict,
					A2(
						$krisajenkins$remotedata$RemoteData$map,
						nextElementAfterFilter(relatedFieldInfo.filter),
						A2(previewFunctions.listReference, dataCache, relatedFieldInfo.nextElement)));
				return A2($elm$core$Dict$insert, hashString, resultDict);
			});
		var record = relationship.a;
		var _v2 = record.fieldType;
		switch (_v2.$) {
			case 'StringType':
				return $author$project$DataEngine$RfDictCache$RfDictCache(
					_Utils_update(
						internal,
						{
							stringDicts: A3(addToDict, record, $author$project$DataEngine$RecordCache$getString, internal.stringDicts)
						}));
			case 'NumberType':
				return $author$project$DataEngine$RfDictCache$RfDictCache(
					_Utils_update(
						internal,
						{
							numberDicts: A3(addToDict, record, $author$project$DataEngine$RecordCache$getNumber, internal.numberDicts)
						}));
			case 'DateType':
				return $author$project$DataEngine$RfDictCache$RfDictCache(
					_Utils_update(
						internal,
						{
							dateDicts: A3(addToDict, record, $author$project$DataEngine$RecordCache$getDate, internal.dateDicts)
						}));
			case 'DateTimeType':
				return $author$project$DataEngine$RfDictCache$RfDictCache(
					_Utils_update(
						internal,
						{
							dateTimeDicts: A3(addToDict, record, $author$project$DataEngine$RecordCache$getDateTime, internal.dateTimeDicts)
						}));
			default:
				return $author$project$DataEngine$RfDictCache$RfDictCache(
					_Utils_update(
						internal,
						{
							boolDicts: A3(addToDict, record, $author$project$DataEngine$RecordCache$getBool, internal.boolDicts)
						}));
		}
	});
var $author$project$DataElement$Expression$relatedFieldValueDictionary = F3(
	function (fieldType, info, fieldName) {
		return $author$project$DataElement$Expression$IdToValue(
			{fieldType: fieldType, filter: info.optionalFilter, id: info.idToMatch, nextElement: info.nextElement, value: fieldName});
	});
var $author$project$DataElement$Expression$relatedFieldDictionaries = F3(
	function (fieldType, info, fieldName) {
		var valueDictionary = A3($author$project$DataElement$Expression$relatedFieldValueDictionary, fieldType, info, fieldName);
		var filterDependenciesOptionalFilter = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				$author$project$DataElement$Expression$applyLocalBool(
					$author$project$DataElement$Expression$cyclic$relatedFieldLookupTransformers()),
				info.optionalFilter));
		var filterDependenciesLocalIds = A2(
			$author$project$DataElement$Expression$applyLocalStringList,
			$author$project$DataElement$Expression$cyclic$relatedFieldLookupTransformers(),
			info.localIds);
		return _Utils_ap(
			filterDependenciesOptionalFilter,
			_Utils_ap(
				filterDependenciesLocalIds,
				_List_fromArray(
					[valueDictionary])));
	});
function $author$project$DataElement$Expression$cyclic$relatedFieldLookupTransformers() {
	return {
		add: $elm$core$Basics$append,
		all: $elm$core$Basics$identity,
		allBoolsInField: F2(
			function (_v0, _v1) {
				return _List_Nil;
			}),
		allDateTimesInField: F2(
			function (_v2, _v3) {
				return _List_Nil;
			}),
		allDatesInField: F2(
			function (_v4, _v5) {
				return _List_Nil;
			}),
		allNumbersInField: F2(
			function (_v6, _v7) {
				return _List_Nil;
			}),
		allStringsInField: F2(
			function (_v8, _v9) {
				return _List_Nil;
			}),
		any: $elm$core$Basics$identity,
		boolsAsList: $elm$core$List$concat,
		challengeReasons: function (_v10) {
			return _List_Nil;
		},
		comparableEqual: function (_v11) {
			return $elm$core$Basics$append;
		},
		comparableNotEqual: function (_v12) {
			return $elm$core$Basics$append;
		},
		concat: $elm$core$Basics$append,
		countUnique: $elm$core$Basics$always($elm$core$Basics$identity),
		dateAdd: function (_v13) {
			return $elm$core$Basics$append;
		},
		dateCeiling: F2(
			function (_v14, deps) {
				return deps;
			}),
		dateFloor: F2(
			function (_v15, deps) {
				return deps;
			}),
		dateSubtract: function (_v16) {
			return $elm$core$Basics$append;
		},
		dateTimeToDate: $elm$core$Basics$identity,
		dateTimesAsList: $elm$core$List$concat,
		datesAsList: $elm$core$List$concat,
		dayInMonth: $elm$core$Basics$identity,
		divide: $elm$core$Basics$append,
		equal: function (_v17) {
			return $elm$core$Basics$append;
		},
		formatDate: $elm$core$Basics$append,
		formatDateLocaleAware: $elm$core$Basics$identity,
		formatDateTime: $elm$core$Basics$identity,
		formatNumber: function (_v18) {
			return $elm$core$Basics$identity;
		},
		globalBoolLookup: F2(
			function (_v19, _v20) {
				return _List_Nil;
			}),
		globalDateLookup: F2(
			function (_v21, _v22) {
				return _List_Nil;
			}),
		globalDateTimeLookup: F2(
			function (_v23, _v24) {
				return _List_Nil;
			}),
		globalNumberLookup: F2(
			function (_v25, _v26) {
				return _List_Nil;
			}),
		globalStringLookup: F2(
			function (_v27, _v28) {
				return _List_Nil;
			}),
		greaterThan: function (_v29) {
			return $elm$core$Basics$append;
		},
		greaterThanOrEqual: function (_v30) {
			return $elm$core$Basics$append;
		},
		hardcodedBool: function (_v31) {
			return _List_Nil;
		},
		hardcodedDate: function (_v32) {
			return _List_Nil;
		},
		hardcodedDateTime: function (_v33) {
			return _List_Nil;
		},
		hardcodedNumber: function (_v34) {
			return _List_Nil;
		},
		hardcodedString: function (_v35) {
			return _List_Nil;
		},
		if_: F4(
			function (_v36, a, b, c) {
				return _Utils_ap(
					a,
					_Utils_ap(b, c));
			}),
		isNotNull: $elm$core$Basics$identity,
		isNull: $elm$core$Basics$identity,
		lessThan: function (_v37) {
			return $elm$core$Basics$append;
		},
		lessThanOrEqual: function (_v38) {
			return $elm$core$Basics$append;
		},
		localBool: function (_v39) {
			return _List_Nil;
		},
		localDate: function (_v40) {
			return _List_Nil;
		},
		localDateTime: function (_v41) {
			return _List_Nil;
		},
		localNumber: function (_v42) {
			return _List_Nil;
		},
		localString: function (_v43) {
			return _List_Nil;
		},
		max: function (_v44) {
			return $elm$core$Basics$identity;
		},
		min: function (_v45) {
			return $elm$core$Basics$identity;
		},
		monthNumber: $elm$core$Basics$identity,
		multiply: $elm$core$Basics$append,
		not: $elm$core$Basics$identity,
		notEqual: function (_v46) {
			return $elm$core$Basics$append;
		},
		numbersAsList: $elm$core$List$concat,
		pickOne: function (_v47) {
			return $elm$core$Basics$identity;
		},
		product: $elm$core$Basics$identity,
		relatedBool: $author$project$DataElement$Expression$relatedFieldDictionaries($author$project$FieldType$BoolType),
		relatedDate: $author$project$DataElement$Expression$relatedFieldDictionaries($author$project$FieldType$DateType),
		relatedDateTime: $author$project$DataElement$Expression$relatedFieldDictionaries($author$project$FieldType$DateTimeType),
		relatedNumber: $author$project$DataElement$Expression$relatedFieldDictionaries($author$project$FieldType$NumberType),
		relatedString: $author$project$DataElement$Expression$relatedFieldDictionaries($author$project$FieldType$StringType),
		round: $elm$core$Basics$identity,
		stringIn: $elm$core$Basics$append,
		stringNotIn: $elm$core$Basics$append,
		stringsAsList: $elm$core$List$concat,
		subtract: $elm$core$Basics$append,
		sum: $elm$core$Basics$identity,
		targetChallengeReasons: function (_v48) {
			return _List_Nil;
		},
		yearNumber: $elm$core$Basics$identity
	};
}
try {
	var $author$project$DataElement$Expression$relatedFieldLookupTransformers = $author$project$DataElement$Expression$cyclic$relatedFieldLookupTransformers();
	$author$project$DataElement$Expression$cyclic$relatedFieldLookupTransformers = function () {
		return $author$project$DataElement$Expression$relatedFieldLookupTransformers;
	};
} catch ($) {
	throw 'Some top-level definitions from `DataElement.Expression` are causing infinite recursion:\n\n  ┌─────┐\n  │    relatedFieldLookupTransformers\n  │     ↓\n  │    relatedFieldDictionaries\n  └─────┘\n\nThese errors are very tricky, so read https://elm-lang.org/0.19.1/bad-recursion to learn how to fix it!';}
var $author$project$DataElement$previewFilterList = F3(
	function (dataElements, cache, info) {
		var metadata = $author$project$DataEngine$RecordMetadata$fromList(
			$pzp1997$assoc_list$AssocList$toList(
				A2(
					$author$project$DataElement$fieldDict,
					dataElements,
					$author$project$DataElement$RecordList(
						$author$project$DataElement$CalcFilterList(info)))));
		var listOfRfDictionaries = $elm_community$list_extra$List$Extra$unique(
			A2($author$project$DataElement$Expression$applyLocalBool, $author$project$DataElement$Expression$relatedFieldLookupTransformers, info.filter));
		var rfDictCache = A3(
			$elm$core$List$foldr,
			A2($author$project$DataEngine$RfDictCache$insert, $author$project$DataElement$Expression$Preview$dictCachePreviewDependencies, cache),
			$author$project$DataEngine$RfDictCache$empty,
			listOfRfDictionaries);
		var performFilter = $author$project$Calc$filterRemoteData(
			function (recordCache) {
				return A4($author$project$DataElement$Expression$Preview$localBool, cache, rfDictCache, recordCache, info.filter);
			});
		return A2(
			$author$project$DataElement$toCacheUpdateStep,
			A2($elm$core$Basics$composeR, $elm$core$Result$Ok, $author$project$DataEngine$CacheUpdateStep$Insert),
			A2(
				$krisajenkins$remotedata$RemoteData$map,
				$author$project$DataEngine$DataElementCache$ListCache(metadata),
				A2(
					$krisajenkins$remotedata$RemoteData$andThen,
					performFilter,
					A2($author$project$DataElement$Expression$Preview$listReference, cache, info.original))));
	});
var $author$project$DataEngine$RecordMetadata$fields = function (_v0) {
	var dict = _v0.a;
	return A2(
		$elm$core$List$map,
		$elm$core$Tuple$mapFirst($author$project$FieldName$fromString),
		$elm$core$Dict$toList(dict));
};
var $krisajenkins$remotedata$RemoteData$fromList = A2(
	$elm$core$List$foldr,
	$krisajenkins$remotedata$RemoteData$map2($elm$core$List$cons),
	$krisajenkins$remotedata$RemoteData$Success(_List_Nil));
var $author$project$DataElement$previewMergeList = F3(
	function (dataElements, cache, info) {
		var metadata = $author$project$DataEngine$RecordMetadata$fromList(
			$pzp1997$assoc_list$AssocList$toList(
				A2(
					$author$project$DataElement$fieldDict,
					dataElements,
					$author$project$DataElement$RecordList(
						$author$project$DataElement$CalcMergeList(info)))));
		var getFieldValueFromRecord = F3(
			function (fieldType, recordCache, fieldName) {
				switch (fieldType.$) {
					case 'StringType':
						return A2(
							$elm$core$Maybe$map,
							$author$project$FieldValue$StringValue,
							A2($author$project$DataEngine$RecordCache$getString, fieldName, recordCache));
					case 'NumberType':
						return A2(
							$elm$core$Maybe$map,
							$author$project$FieldValue$NumberValue,
							A2($author$project$DataEngine$RecordCache$getNumber, fieldName, recordCache));
					case 'DateType':
						return A2(
							$elm$core$Maybe$map,
							$author$project$FieldValue$DateValue,
							A2($author$project$DataEngine$RecordCache$getDate, fieldName, recordCache));
					case 'DateTimeType':
						return A2(
							$elm$core$Maybe$map,
							$author$project$FieldValue$DateTimeValue,
							A2($author$project$DataEngine$RecordCache$getDateTime, fieldName, recordCache));
					default:
						return A2(
							$elm$core$Maybe$map,
							$author$project$FieldValue$BoolValue,
							A2($author$project$DataEngine$RecordCache$getBool, fieldName, recordCache));
				}
			});
		var buildOutputCache = F4(
			function (inputDict, inputCache, _v1, cacheSoFar) {
				var outputFieldName = _v1.a;
				var outputFieldType = _v1.b;
				return A2(
					$elm$core$Maybe$withDefault,
					cacheSoFar,
					A2(
						$elm$core$Maybe$map,
						function (fieldValue) {
							return A3($author$project$DataEngine$RecordCache$insert, outputFieldName, fieldValue, cacheSoFar);
						},
						A2(
							$elm$core$Maybe$andThen,
							A2(getFieldValueFromRecord, outputFieldType, inputCache),
							A2($pzp1997$assoc_list$AssocList$get, outputFieldName, inputDict))));
			});
		var transformRecordCache = F2(
			function (inputDict, inputCache) {
				return A3(
					$elm$core$List$foldl,
					A2(buildOutputCache, inputDict, inputCache),
					$author$project$DataEngine$RecordCache$empty,
					$author$project$DataEngine$RecordMetadata$fields(metadata));
			});
		var findAndTransformRecordCacheList = function (_v0) {
			var inputRef = _v0.a;
			var inputDict = _v0.b;
			return A2(
				$krisajenkins$remotedata$RemoteData$map,
				$elm$core$List$map(
					transformRecordCache(inputDict)),
				A2($author$project$DataElement$Expression$Preview$listReference, cache, inputRef));
		};
		return A2(
			$author$project$DataElement$toCacheUpdateStep,
			A2($elm$core$Basics$composeR, $elm$core$Result$Ok, $author$project$DataEngine$CacheUpdateStep$Insert),
			A2(
				$krisajenkins$remotedata$RemoteData$map,
				A2(
					$elm$core$Basics$composeR,
					$elm$core$List$concat,
					$author$project$DataEngine$DataElementCache$ListCache(metadata)),
				$krisajenkins$remotedata$RemoteData$fromList(
					A2(
						$elm$core$List$map,
						findAndTransformRecordCacheList,
						$author$project$DataElement$MergeList$getRefList(info)))));
	});
var $author$project$DataElement$previewNitroQuery = F2(
	function (cache, info) {
		var _v0 = info.whereClause;
		if (_v0.$ === 'Nothing') {
			return $elm$core$Maybe$Just(
				$author$project$DataEngine$CacheUpdateStep$RunQuery(
					A3(
						$author$project$DataEngine$QueryToRun$NitroQuery,
						$author$project$DataElement$basicNitroQuery(info),
						$author$project$DataElement$metadataForFieldInfoDict(info.fields),
						$author$project$DataElement$basicQueryDecoder(info))));
		} else {
			var whereClause = _v0.a;
			return A2(
				$author$project$DataElement$toCacheUpdateStep,
				$author$project$DataEngine$CacheUpdateStep$RunQuery,
				A2(
					$krisajenkins$remotedata$RemoteData$map,
					function (complexWhere) {
						return A3(
							$author$project$DataEngine$QueryToRun$NitroQuery,
							A2(
								$author$project$MyInsights$setComplexWhere,
								complexWhere,
								$author$project$DataElement$basicNitroQuery(info)),
							$author$project$DataElement$metadataForFieldInfoDict(info.fields),
							$author$project$DataElement$basicQueryDecoder(info));
					},
					A3($author$project$DataElement$previewWhereClause, $author$project$MyInsights$Helpers$Nitro, cache, whereClause)));
		}
	});
var $author$project$DataElement$metadataForFieldExpressionDict = function (dict) {
	return $author$project$DataEngine$RecordMetadata$fromList(
		A2(
			$elm$core$List$map,
			$elm$core$Tuple$mapSecond($author$project$DataElement$Expression$localFieldDataType),
			$pzp1997$assoc_list$AssocList$toList(dict)));
};
var $author$project$DataElement$previewOneForOneAddRecordField = F5(
	function (cache, rfDictCache, baseRecord, _v0, recordSoFar) {
		var fieldName = _v0.a;
		var localField = _v0.b;
		return A2(
			$krisajenkins$remotedata$RemoteData$map,
			function (maybeFieldValue) {
				if (maybeFieldValue.$ === 'Nothing') {
					return recordSoFar;
				} else {
					var fieldValue = maybeFieldValue.a;
					return A3($author$project$DataEngine$RecordCache$insert, fieldName, fieldValue, recordSoFar);
				}
			},
			A4($author$project$DataElement$Expression$Preview$localField, cache, rfDictCache, baseRecord, localField));
	});
var $author$project$DataElement$previewOneForOneIndividualRecord = F4(
	function (cache, rfDictCache, fields, baseRecord) {
		return A3(
			$elm$core$List$foldl,
			F2(
				function (tuple, recordSoFar) {
					return A2(
						$krisajenkins$remotedata$RemoteData$andThen,
						A4($author$project$DataElement$previewOneForOneAddRecordField, cache, rfDictCache, baseRecord, tuple),
						recordSoFar);
				}),
			$krisajenkins$remotedata$RemoteData$Success($author$project$DataEngine$RecordCache$empty),
			$pzp1997$assoc_list$AssocList$toList(fields));
	});
var $author$project$DataElement$previewOneForOne = F2(
	function (cache, _v0) {
		var original = _v0.original;
		var fields = _v0.fields;
		var listOfDictionaries = $elm_community$list_extra$List$Extra$unique(
			A2(
				$elm$core$List$concatMap,
				$author$project$DataElement$Expression$applyLocalField($author$project$DataElement$Expression$relatedFieldLookupTransformers),
				$pzp1997$assoc_list$AssocList$values(fields)));
		var rfDictCache = A3(
			$elm$core$List$foldl,
			A2($author$project$DataEngine$RfDictCache$insert, $author$project$DataElement$Expression$Preview$dictCachePreviewDependencies, cache),
			$author$project$DataEngine$RfDictCache$empty,
			listOfDictionaries);
		return A2(
			$author$project$DataElement$toCacheUpdateStep,
			A2($elm$core$Basics$composeR, $elm$core$Result$Ok, $author$project$DataEngine$CacheUpdateStep$Insert),
			A2(
				$krisajenkins$remotedata$RemoteData$map,
				$author$project$DataEngine$DataElementCache$ListCache(
					$author$project$DataElement$metadataForFieldExpressionDict(fields)),
				A2(
					$krisajenkins$remotedata$RemoteData$andThen,
					$author$project$RemoteData$Helpers$combine,
					A2(
						$krisajenkins$remotedata$RemoteData$map,
						$elm$core$List$map(
							A3($author$project$DataElement$previewOneForOneIndividualRecord, cache, rfDictCache, fields)),
						A2($author$project$DataElement$Expression$Preview$listReference, cache, original)))));
	});
var $author$project$DataElement$FeedbackProductGoals$metadata = function (info) {
	return $author$project$DataEngine$RecordMetadata$fromList(
		$author$project$DataElement$FeedbackProductGoals$addChannelId(
			A2(
				$elm$core$List$map,
				$author$project$DataElement$FeedbackProductGoals$fixProductId,
				$pzp1997$assoc_list$AssocList$toList(info.fields))));
};
var $author$project$DataElement$FeedbackProductGoals$recordCacheDecoder = function (info) {
	return A3(
		$elm$core$List$foldl,
		A2(
			$author$project$Preview$Helpers$addFieldWithCustomNameDecoder,
			A2(
				$pzp1997$assoc_list$AssocList$singleton,
				$author$project$FieldName$fromString('channelOrProductId'),
				$author$project$FieldName$fromString('Product ID')),
			$pzp1997$assoc_list$AssocList$empty),
		$elm$json$Json$Decode$succeed($author$project$DataEngine$RecordCache$empty),
		$pzp1997$assoc_list$AssocList$toList(
			A2(
				$pzp1997$assoc_list$AssocList$map,
				F2(
					function (_v0, fieldType) {
						return {_default: $elm$core$Maybe$Nothing, fieldType: fieldType};
					}),
				info.fields)));
};
var $author$project$DataElement$previewProductGoals = F2(
	function (cache, info) {
		var goalsForProductDecoder = A2(
			$elm$json$Json$Decode$field,
			'products',
			$elm$json$Json$Decode$list(
				$author$project$DataElement$FeedbackProductGoals$recordCacheDecoder(info)));
		var addChannelGoalsToRecordCache = F2(
			function (channelId, records) {
				return A2(
					$elm$core$List$map,
					A2(
						$author$project$DataEngine$RecordCache$insert,
						$author$project$FieldName$fromString('Channel ID'),
						channelId),
					records);
			});
		var goalsForChannelDecoder = A3(
			$elm$json$Json$Decode$map2,
			addChannelGoalsToRecordCache,
			$author$project$Preview$Helpers$feedbackIdFieldDecoder('channelOrProductId'),
			goalsForProductDecoder);
		var goalsDecoder = A2(
			$elm$json$Json$Decode$map,
			$elm$core$List$concat,
			A2(
				$elm$json$Json$Decode$field,
				'totalGoals',
				$elm$json$Json$Decode$list(goalsForChannelDecoder)));
		var calcFeedbackProductGoals = function (feedbackData) {
			return A2(
				$krisajenkins$remotedata$RemoteData$mapError,
				$author$project$MyInsights$DecodeError,
				$krisajenkins$remotedata$RemoteData$fromResult(
					A2($elm$json$Json$Decode$decodeValue, goalsDecoder, feedbackData.value)));
		};
		return A2(
			$author$project$DataElement$toCacheUpdateStep,
			A2($elm$core$Basics$composeR, $elm$core$Result$Ok, $author$project$DataEngine$CacheUpdateStep$Insert),
			A2(
				$krisajenkins$remotedata$RemoteData$map,
				$author$project$DataEngine$DataElementCache$ListCache(
					$author$project$DataElement$FeedbackProductGoals$metadata(info)),
				A2(
					$krisajenkins$remotedata$RemoteData$andThen,
					calcFeedbackProductGoals,
					$author$project$DataEngine$DataCache$getFeedbackData(cache))));
	});
var $author$project$DataElement$previewSalesQuery = F2(
	function (cache, info) {
		return A2(
			$author$project$DataElement$toCacheUpdateStep,
			$author$project$DataEngine$CacheUpdateStep$RunQuery,
			A2($author$project$DataElement$salesQueryPreviewHelper, cache, info));
	});
var $author$project$Calc$performSort = F3(
	function (sorters, left, right) {
		performSort:
		while (true) {
			if (!sorters.b) {
				return $elm$core$Basics$EQ;
			} else {
				var headSorter = sorters.a;
				var tiebreakers = sorters.b;
				var _v1 = A2(headSorter, left, right);
				switch (_v1.$) {
					case 'LT':
						return $elm$core$Basics$LT;
					case 'GT':
						return $elm$core$Basics$GT;
					default:
						var $temp$sorters = tiebreakers,
							$temp$left = left,
							$temp$right = right;
						sorters = $temp$sorters;
						left = $temp$left;
						right = $temp$right;
						continue performSort;
				}
			}
		}
	});
var $elm$core$List$sortWith = _List_sortWith;
var $author$project$Calc$sort = F2(
	function (sorters, listToSort) {
		return A2(
			$elm$core$List$sortWith,
			$author$project$Calc$performSort(sorters),
			listToSort);
	});
var $author$project$Calc$sortByHelper = F5(
	function (innerSorter, toMaybeComparable, sortDir, a, b) {
		var _v0 = _Utils_Tuple3(
			toMaybeComparable(a),
			toMaybeComparable(b),
			sortDir);
		if (_v0.a.$ === 'Nothing') {
			if (_v0.b.$ === 'Nothing') {
				var _v1 = _v0.a;
				var _v2 = _v0.b;
				return $elm$core$Basics$EQ;
			} else {
				var _v3 = _v0.a;
				return $elm$core$Basics$GT;
			}
		} else {
			if (_v0.b.$ === 'Nothing') {
				var _v4 = _v0.b;
				return $elm$core$Basics$LT;
			} else {
				if (_v0.c.$ === 'Ascending') {
					var left = _v0.a.a;
					var right = _v0.b.a;
					var _v5 = _v0.c;
					return A2(innerSorter, left, right);
				} else {
					var left = _v0.a.a;
					var right = _v0.b.a;
					var _v6 = _v0.c;
					return A2(innerSorter, right, left);
				}
			}
		}
	});
var $author$project$Calc$sortByDate = $author$project$Calc$sortByHelper($justinmimbs$date$Date$compare);
var $author$project$Calc$sortByDateTime = $author$project$Calc$sortByHelper($author$project$Calc$compareDateTime);
var $author$project$Calc$sortByNumber = $author$project$Calc$sortByHelper($elm$core$Basics$compare);
var $author$project$Calc$sortByString = $author$project$Calc$sortByHelper($author$project$StudioString$compare);
var $author$project$DataElement$previewSortList = F3(
	function (dataElements, cache, info) {
		var sortKeyToExpression = function (_v2) {
			var expression = _v2.expression;
			var direction = _v2.direction;
			return expression;
		};
		var metadata = $author$project$DataEngine$RecordMetadata$fromList(
			$pzp1997$assoc_list$AssocList$toList(
				A2(
					$author$project$DataElement$fieldDict,
					dataElements,
					$author$project$DataElement$RecordList(
						$author$project$DataElement$CalcSortList(info)))));
		var listOfRfDictionaries = $elm_community$list_extra$List$Extra$unique(
			A2(
				$elm$core$List$concatMap,
				$author$project$DataElement$Expression$applyLocalComparable($author$project$DataElement$Expression$relatedFieldLookupTransformers),
				A2(
					$elm$core$List$map,
					sortKeyToExpression,
					$mgold$elm_nonempty_list$List$Nonempty$toList(info.sortBy))));
		var rfDictCache = A3(
			$elm$core$List$foldr,
			A2($author$project$DataEngine$RfDictCache$insert, $author$project$DataElement$Expression$Preview$dictCachePreviewDependencies, cache),
			$author$project$DataEngine$RfDictCache$empty,
			listOfRfDictionaries);
		var sortKeyToSorter = function (_v1) {
			var expression = _v1.expression;
			var direction = _v1.direction;
			switch (expression.$) {
				case 'LocalCompStringExpr':
					var localString = expression.a;
					return A2(
						$author$project$Calc$sortByString,
						function (recordCache) {
							return A2(
								$krisajenkins$remotedata$RemoteData$withDefault,
								$elm$core$Maybe$Nothing,
								A4($author$project$DataElement$Expression$Preview$localString, cache, rfDictCache, recordCache, localString));
						},
						direction);
				case 'LocalCompNumberExpr':
					var localNumber = expression.a;
					return A2(
						$author$project$Calc$sortByNumber,
						function (recordCache) {
							return A2(
								$krisajenkins$remotedata$RemoteData$withDefault,
								$elm$core$Maybe$Nothing,
								A4($author$project$DataElement$Expression$Preview$localNumber, cache, rfDictCache, recordCache, localNumber));
						},
						direction);
				case 'LocalCompDateExpr':
					var localDate = expression.a;
					return A2(
						$author$project$Calc$sortByDate,
						function (recordCache) {
							return A2(
								$krisajenkins$remotedata$RemoteData$withDefault,
								$elm$core$Maybe$Nothing,
								A4($author$project$DataElement$Expression$Preview$localDate, cache, rfDictCache, recordCache, localDate));
						},
						direction);
				default:
					var localDateTime = expression.a;
					return A2(
						$author$project$Calc$sortByDateTime,
						function (recordCache) {
							return A2(
								$krisajenkins$remotedata$RemoteData$withDefault,
								$elm$core$Maybe$Nothing,
								A4($author$project$DataElement$Expression$Preview$localDateTime, cache, rfDictCache, recordCache, localDateTime));
						},
						direction);
			}
		};
		var performSort = $author$project$Calc$sort(
			A2(
				$elm$core$List$map,
				sortKeyToSorter,
				$mgold$elm_nonempty_list$List$Nonempty$toList(info.sortBy)));
		return A2(
			$author$project$DataElement$toCacheUpdateStep,
			A2($elm$core$Basics$composeR, $elm$core$Result$Ok, $author$project$DataEngine$CacheUpdateStep$Insert),
			A2(
				$krisajenkins$remotedata$RemoteData$map,
				$author$project$DataEngine$DataElementCache$ListCache(metadata),
				A2(
					$krisajenkins$remotedata$RemoteData$map,
					performSort,
					A2($author$project$DataElement$Expression$Preview$listReference, cache, info.original))));
	});
var $elm$core$List$drop = F2(
	function (n, list) {
		drop:
		while (true) {
			if (n <= 0) {
				return list;
			} else {
				if (!list.b) {
					return list;
				} else {
					var x = list.a;
					var xs = list.b;
					var $temp$n = n - 1,
						$temp$list = xs;
					n = $temp$n;
					list = $temp$list;
					continue drop;
				}
			}
		}
	});
var $elm$core$List$takeReverse = F3(
	function (n, list, kept) {
		takeReverse:
		while (true) {
			if (n <= 0) {
				return kept;
			} else {
				if (!list.b) {
					return kept;
				} else {
					var x = list.a;
					var xs = list.b;
					var $temp$n = n - 1,
						$temp$list = xs,
						$temp$kept = A2($elm$core$List$cons, x, kept);
					n = $temp$n;
					list = $temp$list;
					kept = $temp$kept;
					continue takeReverse;
				}
			}
		}
	});
var $elm$core$List$takeTailRec = F2(
	function (n, list) {
		return $elm$core$List$reverse(
			A3($elm$core$List$takeReverse, n, list, _List_Nil));
	});
var $elm$core$List$takeFast = F3(
	function (ctr, n, list) {
		if (n <= 0) {
			return _List_Nil;
		} else {
			var _v0 = _Utils_Tuple2(n, list);
			_v0$1:
			while (true) {
				_v0$5:
				while (true) {
					if (!_v0.b.b) {
						return list;
					} else {
						if (_v0.b.b.b) {
							switch (_v0.a) {
								case 1:
									break _v0$1;
								case 2:
									var _v2 = _v0.b;
									var x = _v2.a;
									var _v3 = _v2.b;
									var y = _v3.a;
									return _List_fromArray(
										[x, y]);
								case 3:
									if (_v0.b.b.b.b) {
										var _v4 = _v0.b;
										var x = _v4.a;
										var _v5 = _v4.b;
										var y = _v5.a;
										var _v6 = _v5.b;
										var z = _v6.a;
										return _List_fromArray(
											[x, y, z]);
									} else {
										break _v0$5;
									}
								default:
									if (_v0.b.b.b.b && _v0.b.b.b.b.b) {
										var _v7 = _v0.b;
										var x = _v7.a;
										var _v8 = _v7.b;
										var y = _v8.a;
										var _v9 = _v8.b;
										var z = _v9.a;
										var _v10 = _v9.b;
										var w = _v10.a;
										var tl = _v10.b;
										return (ctr > 1000) ? A2(
											$elm$core$List$cons,
											x,
											A2(
												$elm$core$List$cons,
												y,
												A2(
													$elm$core$List$cons,
													z,
													A2(
														$elm$core$List$cons,
														w,
														A2($elm$core$List$takeTailRec, n - 4, tl))))) : A2(
											$elm$core$List$cons,
											x,
											A2(
												$elm$core$List$cons,
												y,
												A2(
													$elm$core$List$cons,
													z,
													A2(
														$elm$core$List$cons,
														w,
														A3($elm$core$List$takeFast, ctr + 1, n - 4, tl)))));
									} else {
										break _v0$5;
									}
							}
						} else {
							if (_v0.a === 1) {
								break _v0$1;
							} else {
								break _v0$5;
							}
						}
					}
				}
				return list;
			}
			var _v1 = _v0.b;
			var x = _v1.a;
			return _List_fromArray(
				[x]);
		}
	});
var $elm$core$List$take = F2(
	function (n, list) {
		return A3($elm$core$List$takeFast, 0, n, list);
	});
var $author$project$Calc$sublist = function (_v0) {
	var skipThisMany = _v0.skipThisMany;
	var keepThisMany = _v0.keepThisMany;
	return A2(
		$elm$core$Basics$composeR,
		$elm$core$List$drop(skipThisMany),
		$elm$core$List$take(keepThisMany));
};
var $author$project$DataElement$previewSublist = F3(
	function (dataElements, cache, info) {
		var performSublist = $author$project$Calc$sublist(
			{keepThisMany: info.keepThisMany, skipThisMany: info.skipThisMany});
		var metadata = $author$project$DataEngine$RecordMetadata$fromList(
			$pzp1997$assoc_list$AssocList$toList(
				A2(
					$author$project$DataElement$fieldDict,
					dataElements,
					$author$project$DataElement$RecordList(
						$author$project$DataElement$CalcSublist(info)))));
		return A2(
			$author$project$DataElement$toCacheUpdateStep,
			A2($elm$core$Basics$composeR, $elm$core$Result$Ok, $author$project$DataEngine$CacheUpdateStep$Insert),
			A2(
				$krisajenkins$remotedata$RemoteData$map,
				$author$project$DataEngine$DataElementCache$ListCache(metadata),
				A2(
					$krisajenkins$remotedata$RemoteData$map,
					performSublist,
					A2($author$project$DataElement$Expression$Preview$listReference, cache, info.original))));
	});
var $author$project$DataElement$previewSummarizeAddRecordField = F3(
	function (cache, _v0, recordSoFar) {
		var fieldName = _v0.a;
		var globalField = _v0.b;
		return A2(
			$krisajenkins$remotedata$RemoteData$map,
			function (maybeFieldValue) {
				if (maybeFieldValue.$ === 'Nothing') {
					return recordSoFar;
				} else {
					var fieldValue = maybeFieldValue.a;
					return A3($author$project$DataEngine$RecordCache$insert, fieldName, fieldValue, recordSoFar);
				}
			},
			A2($author$project$DataElement$Expression$Preview$globalField, cache, globalField));
	});
var $author$project$DataElement$previewSummarize = F2(
	function (cache, _v0) {
		var fields = _v0.fields;
		var metadata = $author$project$DataEngine$RecordMetadata$fromList(
			A2(
				$elm$core$List$map,
				$elm$core$Tuple$mapSecond($author$project$DataElement$Expression$globalFieldDataType),
				$pzp1997$assoc_list$AssocList$toList(fields)));
		return A2(
			$author$project$DataElement$toCacheUpdateStep,
			A2($elm$core$Basics$composeR, $elm$core$Result$Ok, $author$project$DataEngine$CacheUpdateStep$Insert),
			A2(
				$krisajenkins$remotedata$RemoteData$map,
				$author$project$DataEngine$DataElementCache$SingletonCache(metadata),
				A3(
					$elm$core$List$foldl,
					F2(
						function (tuple, recordSoFar) {
							return A2(
								$krisajenkins$remotedata$RemoteData$andThen,
								A2($author$project$DataElement$previewSummarizeAddRecordField, cache, tuple),
								recordSoFar);
						}),
					$krisajenkins$remotedata$RemoteData$Success($author$project$DataEngine$RecordCache$empty),
					$pzp1997$assoc_list$AssocList$toList(fields))));
	});
var $author$project$DataElement$getCacheUpdateStep = F4(
	function (dataElements, cache, ref, dataElement) {
		var element = $author$project$DataElement$unwrapElement(dataElement);
		if (element.$ === 'RecordList') {
			switch (element.a.$) {
				case 'CrmQuery':
					var info = element.a.a;
					return A2($author$project$DataElement$previewCrmQuery, cache, info);
				case 'SalesQuery':
					var info = element.a.a;
					return A2($author$project$DataElement$previewSalesQuery, cache, info);
				case 'NitroQuery':
					var info = element.a.a;
					return A2($author$project$DataElement$previewNitroQuery, cache, info);
				case 'CrmDataEngineQuery':
					var info = element.a.a;
					return A2($author$project$DataElement$previewCrmDataEngineQuery, cache, info);
				case 'CalcOneForOne':
					var info = element.a.a;
					return A2($author$project$DataElement$previewOneForOne, cache, info);
				case 'CalcSortList':
					var info = element.a.a;
					return A3($author$project$DataElement$previewSortList, dataElements, cache, info);
				case 'CalcFilterList':
					var info = element.a.a;
					return A3($author$project$DataElement$previewFilterList, dataElements, cache, info);
				case 'CalcSublist':
					var info = element.a.a;
					return A3($author$project$DataElement$previewSublist, dataElements, cache, info);
				case 'CalcMergeList':
					var info = element.a.a;
					return A3($author$project$DataElement$previewMergeList, dataElements, cache, info);
				case 'AlignedTerritories':
					var info = element.a.a;
					return $elm$core$Maybe$Just(
						$author$project$DataEngine$CacheUpdateStep$RunQuery(
							$author$project$DataEngine$QueryToRun$AlignedTerritories(info.includeChildren)));
				case 'CallAttendees':
					var _v1 = element.a;
					return $elm$core$Maybe$Just(
						$author$project$DataEngine$CacheUpdateStep$RunQuery($author$project$DataEngine$QueryToRun$CallAttendees));
				case 'FeedbackChannelGoals':
					var info = element.a.a;
					return A2($author$project$DataElement$previewChannelGoals, cache, info);
				case 'FeedbackProductGoals':
					var info = element.a.a;
					return A2($author$project$DataElement$previewProductGoals, cache, info);
				case 'FeedbackAccountData':
					var info = element.a.a;
					return A2($author$project$DataElement$previewAccountData, cache, info);
				case 'FeedbackAccountChannelGoals':
					var info = element.a.a;
					return A2($author$project$DataElement$previewAccountChannelGoals, cache, info);
				case 'FeedbackAccountProductGoals':
					var info = element.a.a;
					return A2($author$project$DataElement$previewAccountProductGoals, cache, info);
				default:
					var info = element.a.a;
					return A2($author$project$DataElement$previewAccountProductMetrics, cache, info);
			}
		} else {
			switch (element.a.$) {
				case 'FeedbackOverview':
					var info = element.a.a;
					return A2($author$project$DataElement$previewFeedbackOverview, cache, info);
				case 'ContextQuery':
					var info = element.a.a;
					return $elm$core$Maybe$Just(
						$author$project$DataEngine$CacheUpdateStep$RunQuery(
							$author$project$DataElement$contextQueryToQueryDetails(info)));
				case 'LimitOneCrmQuery':
					var info = element.a.a;
					return A2($author$project$DataElement$previewCrmQuery, cache, info);
				case 'LimitOneSalesQuery':
					var info = element.a.a;
					return A2($author$project$DataElement$previewSalesQuery, cache, info);
				case 'LimitOneNitroQuery':
					var info = element.a.a;
					return A2($author$project$DataElement$previewNitroQuery, cache, info);
				case 'LimitOneCrmDataEngineQuery':
					var info = element.a.a;
					return A2($author$project$DataElement$previewCrmDataEngineQuery, cache, info);
				case 'Today':
					var _v2 = element.a;
					return $elm$core$Maybe$Just(
						$author$project$DataEngine$CacheUpdateStep$RunQuery($author$project$DataEngine$QueryToRun$Today));
				case 'Now':
					var _v3 = element.a;
					return $elm$core$Maybe$Just(
						$author$project$DataEngine$CacheUpdateStep$RunQuery($author$project$DataEngine$QueryToRun$Now));
				case 'CalcSummarize':
					var info = element.a.a;
					return A2($author$project$DataElement$previewSummarize, cache, info);
				case 'ObjectTranslation':
					var objectName = element.a.a;
					return $elm$core$Maybe$Just(
						$author$project$DataEngine$CacheUpdateStep$RunQuery(
							$author$project$DataEngine$QueryToRun$ObjectTranslation(objectName)));
				case 'FieldTranslation':
					var fieldTranslationInfo = element.a.a;
					return $elm$core$Maybe$Just(
						$author$project$DataEngine$CacheUpdateStep$RunQuery(
							$author$project$DataEngine$QueryToRun$FieldTranslation(fieldTranslationInfo)));
				case 'VeevaMessages':
					var vmInfo = element.a.a;
					return $elm$core$Maybe$Just(
						$author$project$DataEngine$CacheUpdateStep$RunQuery(
							$author$project$DataEngine$QueryToRun$VeevaMessages(vmInfo)));
				case 'DatepickerSelection':
					var info = element.a.a;
					var _v4 = A2($author$project$DataElement$eitherReference, ref, dataElement);
					if (_v4.$ === 'IsSingleton') {
						var singleRef = _v4.a;
						return A4($author$project$DataElement$previewDatepicker, dataElements, cache, singleRef, info);
					} else {
						return $elm$core$Maybe$Nothing;
					}
				default:
					var dropdownInfo = element.a.a;
					var _v5 = A2($author$project$DataElement$eitherReference, ref, dataElement);
					if (_v5.$ === 'IsSingleton') {
						var singleRef = _v5.a;
						return A4($author$project$DataElement$previewDropdown, dataElements, cache, singleRef, dropdownInfo);
					} else {
						return $elm$core$Maybe$Nothing;
					}
			}
		}
	});
var $author$project$DataElement$getEitherFromReferenceElement = F2(
	function (_v0, ref) {
		var uuidDict = _v0.a;
		return A2(
			$elm$core$Maybe$map,
			$author$project$DataElement$eitherReference(ref),
			A2(
				$author$project$UuidDict$get,
				$author$project$DataElement$Reference$getUuid(ref),
				uuidDict));
	});
var $author$project$DataEngine$DataCache$insert = F2(
	function (ref, result) {
		return $author$project$DataEngine$DataCache$mapCache(
			A2(
				$author$project$UuidDict$insert,
				$author$project$DataElement$Reference$getUuid(ref),
				$author$project$DataEngine$DataCache$stateFromResult(result)));
	});
var $author$project$DataEngine$DataCache$markLoading = function (ref) {
	return $author$project$DataEngine$DataCache$mapCache(
		A2(
			$author$project$UuidDict$insert,
			$author$project$DataElement$Reference$getUuid(ref),
			$author$project$DataEngine$CacheState$Loading));
};
var $author$project$DataEngine$populateCacheHelper = F3(
	function (allElements, cache, ourRef) {
		var _v0 = A2($author$project$DataElement$getDataElementFromReferenceElement, allElements, ourRef);
		if (_v0.$ === 'Nothing') {
			return _Utils_Tuple2(cache, $elm$core$Maybe$Nothing);
		} else {
			var dataElement = _v0.a;
			var _v1 = A4(
				$author$project$DataElement$getCacheUpdateStep,
				allElements,
				cache,
				$author$project$DataElement$Reference$getGenericReference(ourRef),
				dataElement);
			if (_v1.$ === 'Nothing') {
				return _Utils_Tuple2(cache, $elm$core$Maybe$Nothing);
			} else {
				if (_v1.a.$ === 'Insert') {
					var result = _v1.a.a;
					return _Utils_Tuple2(
						A3(
							$author$project$DataEngine$DataCache$insert,
							$author$project$DataElement$Reference$getGenericReference(ourRef),
							result,
							cache),
						$elm$core$Maybe$Nothing);
				} else {
					var queryDetails = _v1.a.a;
					var _v2 = A2($author$project$DataElement$getEitherFromReferenceElement, allElements, ourRef);
					if (_v2.$ === 'Just') {
						var eitherRef = _v2.a;
						return _Utils_Tuple2(
							A2(
								$author$project$DataEngine$DataCache$markLoading,
								$author$project$DataElement$Reference$getGenericReference(ourRef),
								cache),
							$elm$core$Maybe$Just(
								A2($author$project$DataEngine$QueryToRun$QueryToRun, eitherRef, queryDetails)));
					} else {
						return _Utils_Tuple2(cache, $elm$core$Maybe$Nothing);
					}
				}
			}
		}
	});
var $drathier$elm_graph$Graph$getData = F2(
	function (key, graph) {
		return A2(
			$elm$core$Maybe$andThen,
			function (_v0) {
				var node = _v0.a;
				return node.data;
			},
			A2($drathier$elm_graph$Graph$get, key, graph));
	});
var $drathier$elm_graph$Graph$incoming = F2(
	function (key, graph) {
		return A2(
			$elm$core$Maybe$withDefault,
			$elm$core$Set$empty,
			A2(
				$elm$core$Maybe$map,
				function (_v0) {
					var node = _v0.a;
					return node.incoming;
				},
				A2($drathier$elm_graph$Graph$get, key, graph)));
	});
var $elm$core$Dict$foldl = F3(
	function (func, acc, dict) {
		foldl:
		while (true) {
			if (dict.$ === 'RBEmpty_elm_builtin') {
				return acc;
			} else {
				var key = dict.b;
				var value = dict.c;
				var left = dict.d;
				var right = dict.e;
				var $temp$func = func,
					$temp$acc = A3(
					func,
					key,
					value,
					A3($elm$core$Dict$foldl, func, acc, left)),
					$temp$dict = right;
				func = $temp$func;
				acc = $temp$acc;
				dict = $temp$dict;
				continue foldl;
			}
		}
	});
var $elm$core$Dict$filter = F2(
	function (isGood, dict) {
		return A3(
			$elm$core$Dict$foldl,
			F3(
				function (k, v, d) {
					return A2(isGood, k, v) ? A3($elm$core$Dict$insert, k, v, d) : d;
				}),
			$elm$core$Dict$empty,
			dict);
	});
var $elm$core$Dict$intersect = F2(
	function (t1, t2) {
		return A2(
			$elm$core$Dict$filter,
			F2(
				function (k, _v0) {
					return A2($elm$core$Dict$member, k, t2);
				}),
			t1);
	});
var $elm$core$Set$intersect = F2(
	function (_v0, _v1) {
		var dict1 = _v0.a;
		var dict2 = _v1.a;
		return $elm$core$Set$Set_elm_builtin(
			A2($elm$core$Dict$intersect, dict1, dict2));
	});
var $elm$core$Dict$isEmpty = function (dict) {
	if (dict.$ === 'RBEmpty_elm_builtin') {
		return true;
	} else {
		return false;
	}
};
var $elm$core$Set$isEmpty = function (_v0) {
	var dict = _v0.a;
	return $elm$core$Dict$isEmpty(dict);
};
var $drathier$elm_graph$Graph$isAcyclicHelper = F3(
	function (topSortedNodes, seen, graph) {
		isAcyclicHelper:
		while (true) {
			if (!topSortedNodes.b) {
				return true;
			} else {
				var k = topSortedNodes.a;
				var ks = topSortedNodes.b;
				if (A2(
					$elm$core$Set$member,
					k,
					A2($drathier$elm_graph$Graph$incoming, k, graph))) {
					return false;
				} else {
					if (!$elm$core$Set$isEmpty(
						A2(
							$elm$core$Set$intersect,
							seen,
							A2($drathier$elm_graph$Graph$incoming, k, graph)))) {
						return false;
					} else {
						var $temp$topSortedNodes = ks,
							$temp$seen = A2($elm$core$Set$insert, k, seen),
							$temp$graph = graph;
						topSortedNodes = $temp$topSortedNodes;
						seen = $temp$seen;
						graph = $temp$graph;
						continue isAcyclicHelper;
					}
				}
			}
		}
	});
var $drathier$elm_graph$Graph$outgoing = F2(
	function (key, graph) {
		return A2(
			$elm$core$Maybe$withDefault,
			$elm$core$Set$empty,
			A2(
				$elm$core$Maybe$map,
				function (_v0) {
					var node = _v0.a;
					return $elm$core$Set$fromList(
						$elm$core$Dict$keys(node.outgoing));
				},
				A2($drathier$elm_graph$Graph$get, key, graph)));
	});
var $drathier$elm_graph$Graph$reversePostOrderHelper = F4(
	function (nodeKeys, keyOrder, seenKeys, graph) {
		reversePostOrderHelper:
		while (true) {
			if (!nodeKeys.b) {
				return _Utils_Tuple2(seenKeys, keyOrder);
			} else {
				var k = nodeKeys.a;
				var ks = nodeKeys.b;
				if (A2($elm$core$Set$member, k, seenKeys)) {
					var $temp$nodeKeys = ks,
						$temp$keyOrder = keyOrder,
						$temp$seenKeys = seenKeys,
						$temp$graph = graph;
					nodeKeys = $temp$nodeKeys;
					keyOrder = $temp$keyOrder;
					seenKeys = $temp$seenKeys;
					graph = $temp$graph;
					continue reversePostOrderHelper;
				} else {
					var _v1 = A4(
						$drathier$elm_graph$Graph$reversePostOrderHelper,
						$elm$core$Set$toList(
							A2($drathier$elm_graph$Graph$outgoing, k, graph)),
						keyOrder,
						A2($elm$core$Set$insert, k, seenKeys),
						graph);
					var seen = _v1.a;
					var order = _v1.b;
					var $temp$nodeKeys = ks,
						$temp$keyOrder = A2($elm$core$List$cons, k, order),
						$temp$seenKeys = seen,
						$temp$graph = graph;
					nodeKeys = $temp$nodeKeys;
					keyOrder = $temp$keyOrder;
					seenKeys = $temp$seenKeys;
					graph = $temp$graph;
					continue reversePostOrderHelper;
				}
			}
		}
	});
var $drathier$elm_graph$Graph$reversePostOrder = function (_v0) {
	var graph = _v0.a;
	return A4(
		$drathier$elm_graph$Graph$reversePostOrderHelper,
		$elm$core$Dict$keys(graph.nodes),
		_List_Nil,
		$elm$core$Set$empty,
		$drathier$elm_graph$Graph$Graph(graph)).b;
};
var $drathier$elm_graph$Graph$topologicalSort = function (graph) {
	var revpo = $drathier$elm_graph$Graph$reversePostOrder(graph);
	return A3(
		$drathier$elm_graph$Graph$isAcyclicHelper,
		$elm$core$List$reverse(revpo),
		$elm$core$Set$empty,
		graph) ? $elm$core$Maybe$Just(revpo) : $elm$core$Maybe$Nothing;
};
var $author$project$DependencyGraph$topologicalSort = function (_v0) {
	var graph = _v0.a;
	return A2(
		$elm$core$Maybe$map,
		$elm$core$List$filterMap(
			function (comp) {
				return A2($drathier$elm_graph$Graph$getData, comp, graph);
			}),
		$drathier$elm_graph$Graph$topologicalSort(graph));
};
var $author$project$DataEngine$populateCache = F2(
	function (app, cache) {
		return A2(
			$elm$core$Tuple$mapSecond,
			$elm$core$List$filterMap($elm$core$Basics$identity),
			A3(
				$elm_community$list_extra$List$Extra$mapAccuml,
				$author$project$DataEngine$populateCacheHelper(
					$author$project$StudioApp$dataElements(app)),
				cache,
				A2(
					$elm$core$List$filter,
					function (ref) {
						return !A2($author$project$DataEngine$DataCache$member, ref, cache);
					},
					A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						$author$project$DependencyGraph$topologicalSort(
							$author$project$DependencyGraph$fromDataElements(
								$author$project$StudioApp$dataElements(app)))))));
	});
var $author$project$Compiler$enforceCrmDataEnginePreviewLimit = function (config) {
	var newLimit = A2(
		$elm$core$Maybe$withDefault,
		200,
		A2(
			$elm$core$Maybe$map,
			$elm$core$Basics$min(200),
			config.limit));
	return _Utils_update(
		config,
		{
			limit: $elm$core$Maybe$Just(newLimit)
		});
};
var $author$project$Compiler$enforcePreviewLimit = function (config) {
	var newLimit = A2(
		$elm$core$Maybe$withDefault,
		200,
		A2(
			$elm$core$Maybe$map,
			$elm$core$Basics$min(200),
			$author$project$MyInsights$getLimit(config)));
	return A2($author$project$MyInsights$setLimit, newLimit, config);
};
var $author$project$MyInsights$GetDataForCurrentObject = F4(
	function (a, b, c, d) {
		return {$: 'GetDataForCurrentObject', a: a, b: b, c: c, d: d};
	});
var $author$project$MyInsights$getDataForCurrentObject = F3(
	function (queryId, object, field) {
		return $author$project$MyInsights$sendMsg(
			A4($author$project$MyInsights$GetDataForCurrentObject, queryId, object, field, false));
	});
var $author$project$MyInsights$getDateTimeForCurrentObject = F3(
	function (queryId, object, field) {
		return $author$project$MyInsights$sendMsg(
			A4($author$project$MyInsights$GetDataForCurrentObject, queryId, object, field, true));
	});
var $author$project$MyInsights$GetFieldLabels = F3(
	function (a, b, c) {
		return {$: 'GetFieldLabels', a: a, b: b, c: c};
	});
var $author$project$MyInsights$getFieldLabels = F3(
	function (queryId, object, fields) {
		return $author$project$MyInsights$sendMsg(
			A3($author$project$MyInsights$GetFieldLabels, queryId, object, fields));
	});
var $author$project$MyInsights$GetObjectLabels = F2(
	function (a, b) {
		return {$: 'GetObjectLabels', a: a, b: b};
	});
var $author$project$MyInsights$getObjectLabels = F2(
	function (queryId, objects) {
		return $author$project$MyInsights$sendMsg(
			A2($author$project$MyInsights$GetObjectLabels, queryId, objects));
	});
var $author$project$MyInsights$getVeevaMessagesTwoStep = function (queryId) {
	return $author$project$MyInsights$sendMsg(
		A4($author$project$MyInsights$GetDataForCurrentObject, queryId, 'User', 'LanguageLocaleKey', false));
};
var $elm$time$Time$Name = function (a) {
	return {$: 'Name', a: a};
};
var $elm$time$Time$Offset = function (a) {
	return {$: 'Offset', a: a};
};
var $elm$time$Time$customZone = $elm$time$Time$Zone;
var $elm$time$Time$here = _Time_here(_Utils_Tuple0);
var $elm$core$Task$andThen = _Scheduler_andThen;
var $elm$core$Task$succeed = _Scheduler_succeed;
var $elm$core$Task$map2 = F3(
	function (func, taskA, taskB) {
		return A2(
			$elm$core$Task$andThen,
			function (a) {
				return A2(
					$elm$core$Task$andThen,
					function (b) {
						return $elm$core$Task$succeed(
							A2(func, a, b));
					},
					taskB);
			},
			taskA);
	});
var $author$project$DataElement$Now$metadata = $author$project$DataEngine$RecordMetadata$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2($author$project$DataElement$Now$fieldName, $author$project$FieldType$DateTimeType)
		]));
var $author$project$DataElement$Today$metadata = $author$project$DataEngine$RecordMetadata$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2($author$project$DataElement$Today$fieldName, $author$project$FieldType$DateType)
		]));
var $author$project$Compiler$metadataHasDateTimeFields = function (metadata) {
	return A2(
		$elm$core$List$any,
		A2(
			$elm$core$Basics$composeR,
			$elm$core$Tuple$second,
			$elm$core$Basics$eq($author$project$FieldType$DateTimeType)),
		$author$project$DataEngine$RecordMetadata$fields(metadata));
};
var $elm$time$Time$now = _Time_now($elm$time$Time$millisToPosix);
var $elm$core$Task$Perform = function (a) {
	return {$: 'Perform', a: a};
};
var $elm$core$Task$init = $elm$core$Task$succeed(_Utils_Tuple0);
var $elm$core$Task$map = F2(
	function (func, taskA) {
		return A2(
			$elm$core$Task$andThen,
			function (a) {
				return $elm$core$Task$succeed(
					func(a));
			},
			taskA);
	});
var $elm$core$Task$sequence = function (tasks) {
	return A3(
		$elm$core$List$foldr,
		$elm$core$Task$map2($elm$core$List$cons),
		$elm$core$Task$succeed(_List_Nil),
		tasks);
};
var $elm$core$Platform$sendToApp = _Platform_sendToApp;
var $elm$core$Task$spawnCmd = F2(
	function (router, _v0) {
		var task = _v0.a;
		return _Scheduler_spawn(
			A2(
				$elm$core$Task$andThen,
				$elm$core$Platform$sendToApp(router),
				task));
	});
var $elm$core$Task$onEffects = F3(
	function (router, commands, state) {
		return A2(
			$elm$core$Task$map,
			function (_v0) {
				return _Utils_Tuple0;
			},
			$elm$core$Task$sequence(
				A2(
					$elm$core$List$map,
					$elm$core$Task$spawnCmd(router),
					commands)));
	});
var $elm$core$Task$onSelfMsg = F3(
	function (_v0, _v1, _v2) {
		return $elm$core$Task$succeed(_Utils_Tuple0);
	});
var $elm$core$Task$cmdMap = F2(
	function (tagger, _v0) {
		var task = _v0.a;
		return $elm$core$Task$Perform(
			A2($elm$core$Task$map, tagger, task));
	});
_Platform_effectManagers['Task'] = _Platform_createManager($elm$core$Task$init, $elm$core$Task$onEffects, $elm$core$Task$onSelfMsg, $elm$core$Task$cmdMap);
var $elm$core$Task$command = _Platform_leaf('Task');
var $elm$core$Task$perform = F2(
	function (toMessage, task) {
		return $elm$core$Task$command(
			$elm$core$Task$Perform(
				A2($elm$core$Task$map, toMessage, task)));
	});
var $author$project$MyInsights$GetAlignedTerritories = F2(
	function (a, b) {
		return {$: 'GetAlignedTerritories', a: a, b: b};
	});
var $author$project$MyInsights$queryAlignedTerritories = F2(
	function (queryId, includeChildren) {
		return $author$project$MyInsights$sendMsg(
			A2($author$project$MyInsights$GetAlignedTerritories, queryId, includeChildren));
	});
var $author$project$MyInsights$GetCallAttendees = function (a) {
	return {$: 'GetCallAttendees', a: a};
};
var $author$project$MyInsights$queryCallAttendees = function (queryId) {
	return $author$project$MyInsights$sendMsg(
		$author$project$MyInsights$GetCallAttendees(queryId));
};
var $author$project$MyInsights$RunCrmDataEngineQuery = F2(
	function (a, b) {
		return {$: 'RunCrmDataEngineQuery', a: a, b: b};
	});
var $author$project$MyInsights$queryCrmDataEngine = F2(
	function (queryId, config) {
		return $author$project$MyInsights$sendMsg(
			A2($author$project$MyInsights$RunCrmDataEngineQuery, queryId, config));
	});
var $author$project$MyInsights$QueryRecord = F2(
	function (a, b) {
		return {$: 'QueryRecord', a: a, b: b};
	});
var $author$project$MyInsights$queryRecord = F2(
	function (queryId, config) {
		return $author$project$MyInsights$sendMsg(
			A2($author$project$MyInsights$QueryRecord, queryId, config));
	});
var $author$project$MyInsights$QuerySalesData = F2(
	function (a, b) {
		return {$: 'QuerySalesData', a: a, b: b};
	});
var $author$project$MyInsights$querySalesData = F2(
	function (queryId, config) {
		return $author$project$MyInsights$sendMsg(
			A2($author$project$MyInsights$QuerySalesData, queryId, config));
	});
var $author$project$MyInsights$QueryVDSRecord = F2(
	function (a, b) {
		return {$: 'QueryVDSRecord', a: a, b: b};
	});
var $author$project$MyInsights$queryVDSRecord = F2(
	function (queryId, config) {
		return $author$project$MyInsights$sendMsg(
			A2($author$project$MyInsights$QueryVDSRecord, queryId, config));
	});
var $author$project$DataElement$Now$toRecordCache = function (now) {
	return A3(
		$author$project$DataEngine$RecordCache$insert,
		$author$project$DataElement$Now$fieldName,
		$author$project$FieldValue$DateTimeValue(now),
		$author$project$DataEngine$RecordCache$empty);
};
var $author$project$DataElement$Today$toRecordCache = function (today) {
	return A3(
		$author$project$DataEngine$RecordCache$insert,
		$author$project$DataElement$Today$fieldName,
		$author$project$FieldValue$DateValue(today),
		$author$project$DataEngine$RecordCache$empty);
};
var $author$project$Compiler$runQuery = function (_v0) {
	var ref = _v0.ref;
	var query = _v0.query;
	switch (query.$) {
		case 'ContextQuery':
			var objectName = query.a;
			var fieldName = query.b;
			var metadata = query.c;
			return $author$project$Compiler$metadataHasDateTimeFields(metadata) ? A3(
				$author$project$MyInsights$getDateTimeForCurrentObject,
				$author$project$DataElement$Reference$toStringFromEither(ref),
				$author$project$ValidContextObject$toKeyword(objectName),
				$author$project$FieldName$toString(fieldName)) : A3(
				$author$project$MyInsights$getDataForCurrentObject,
				$author$project$DataElement$Reference$toStringFromEither(ref),
				$author$project$ValidContextObject$toKeyword(objectName),
				$author$project$FieldName$toString(fieldName));
		case 'CrmQuery':
			var config = query.a;
			return A2(
				$author$project$MyInsights$queryRecord,
				$author$project$DataElement$Reference$toStringFromEither(ref),
				$author$project$Compiler$enforcePreviewLimit(config));
		case 'SalesQuery':
			var config = query.a;
			return A2(
				$author$project$MyInsights$querySalesData,
				$author$project$DataElement$Reference$toStringFromEither(ref),
				$author$project$Compiler$enforcePreviewLimit(config));
		case 'NitroQuery':
			var config = query.a;
			return A2(
				$author$project$MyInsights$queryVDSRecord,
				$author$project$DataElement$Reference$toStringFromEither(ref),
				$author$project$Compiler$enforcePreviewLimit(config));
		case 'CrmDataEngineQuery':
			var config = query.a;
			return A2(
				$author$project$MyInsights$queryCrmDataEngine,
				$author$project$DataElement$Reference$toStringFromEither(ref),
				$author$project$Compiler$enforceCrmDataEnginePreviewLimit(config));
		case 'AlignedTerritories':
			var includeChildren = query.a;
			return A2(
				$author$project$MyInsights$queryAlignedTerritories,
				$author$project$DataElement$Reference$toStringFromEither(ref),
				includeChildren);
		case 'CallAttendees':
			return $author$project$MyInsights$queryCallAttendees(
				$author$project$DataElement$Reference$toStringFromEither(ref));
		case 'Today':
			if (ref.$ === 'IsSingleton') {
				var singleRef = ref.a;
				return A2(
					$elm$core$Task$perform,
					function (today) {
						return A3(
							$author$project$Compiler$RxSingleton,
							singleRef,
							$author$project$DataElement$Today$metadata,
							$elm$core$Result$Ok(
								$author$project$DataElement$Today$toRecordCache(today)));
					},
					A3($elm$core$Task$map2, $justinmimbs$date$Date$fromPosix, $elm$time$Time$here, $elm$time$Time$now));
			} else {
				return $elm$core$Platform$Cmd$none;
			}
		case 'Now':
			if (ref.$ === 'IsSingleton') {
				var singleRef = ref.a;
				return A2(
					$elm$core$Task$perform,
					function (now) {
						return A3(
							$author$project$Compiler$RxSingleton,
							singleRef,
							$author$project$DataElement$Now$metadata,
							$elm$core$Result$Ok(
								$author$project$DataElement$Now$toRecordCache(now)));
					},
					$elm$time$Time$now);
			} else {
				return $elm$core$Platform$Cmd$none;
			}
		case 'ObjectTranslation':
			var objectName = query.a;
			return A2(
				$author$project$MyInsights$getObjectLabels,
				$author$project$DataElement$Reference$toStringFromEither(ref),
				_List_fromArray(
					[
						$author$project$ObjectName$toString(objectName)
					]));
		case 'FieldTranslation':
			var info = query.a;
			return A3(
				$author$project$MyInsights$getFieldLabels,
				$author$project$DataElement$Reference$toStringFromEither(ref),
				$author$project$ObjectName$toString(info.object),
				A2(
					$elm$core$List$map,
					$author$project$FieldName$toString,
					$author$project$DataElement$FieldTranslation$fieldNames(info)));
		default:
			return $author$project$MyInsights$getVeevaMessagesTwoStep(
				$author$project$DataElement$Reference$toStringFromEither(ref));
	}
};
var $Fresheyeball$elm_return$Return$singleton = function (a) {
	return _Utils_Tuple2(a, $elm$core$Platform$Cmd$none);
};
var $author$project$Compiler$populateCache = function (model) {
	var _v0 = A2($author$project$DataEngine$populateCache, model.app, model.cache);
	var newCache = _v0.a;
	var queries = _v0.b;
	return A2(
		$Fresheyeball$elm_return$Return$command,
		$elm$core$Platform$Cmd$batch(
			A2($elm$core$List$map, $author$project$Compiler$runQuery, queries)),
		$Fresheyeball$elm_return$Return$singleton(
			_Utils_update(
				model,
				{cache: newCache})));
};
var $author$project$Preview$ToPreviewMsg$DataDatepickerPreviewResponse = F3(
	function (a, b, c) {
		return {$: 'DataDatepickerPreviewResponse', a: a, b: b, c: c};
	});
var $author$project$Preview$ToPreviewMsg$DataDropdownPreviewResponse = F3(
	function (a, b, c) {
		return {$: 'DataDropdownPreviewResponse', a: a, b: b, c: c};
	});
var $author$project$Preview$ToPreviewMsg$DataPreviewResponse = F2(
	function (a, b) {
		return {$: 'DataPreviewResponse', a: a, b: b};
	});
var $author$project$Preview$ToPreviewMsg$ErrorDuringQuery = F2(
	function (a, b) {
		return {$: 'ErrorDuringQuery', a: a, b: b};
	});
var $author$project$Preview$ToPreviewMsg$ErrorsDuringValidation = F2(
	function (a, b) {
		return {$: 'ErrorsDuringValidation', a: a, b: b};
	});
var $author$project$Preview$ToPreviewMsg$RequestNotFound = function (a) {
	return {$: 'RequestNotFound', a: a};
};
var $author$project$DataElement$Reference$getGenericReferenceFromEither = function (either) {
	if (either.$ === 'IsRecordList') {
		var uuid = either.a.a;
		return $author$project$DataElement$Reference$Reference(uuid);
	} else {
		var uuid = either.a.a;
		return $author$project$DataElement$Reference$Reference(uuid);
	}
};
var $author$project$DataEngine$DatepickerResponse = F2(
	function (a, b) {
		return {$: 'DatepickerResponse', a: a, b: b};
	});
var $author$project$DataEngine$DropdownResponse = F2(
	function (a, b) {
		return {$: 'DropdownResponse', a: a, b: b};
	});
var $author$project$DataEngine$NormalResponse = function (a) {
	return {$: 'NormalResponse', a: a};
};
var $author$project$DataEngine$Output$NotFound = function (a) {
	return {$: 'NotFound', a: a};
};
var $author$project$DataEngine$Output$QueryError = function (a) {
	return {$: 'QueryError', a: a};
};
var $author$project$DataEngine$Output$QueryRunningPleaseWait = {$: 'QueryRunningPleaseWait'};
var $author$project$DataEngine$Output$Ready = function (a) {
	return {$: 'Ready', a: a};
};
var $author$project$DataElement$PreviewDatepickerSelection = function (a) {
	return {$: 'PreviewDatepickerSelection', a: a};
};
var $author$project$DataElement$PreviewInteractiveSelection = function (a) {
	return {$: 'PreviewInteractiveSelection', a: a};
};
var $author$project$DataElement$PreviewNormal = {$: 'PreviewNormal'};
var $author$project$DataElement$toSpecialPreview = function (dataElement) {
	var _v0 = $author$project$DataElement$unwrapElement(dataElement);
	_v0$2:
	while (true) {
		if (_v0.$ === 'Singleton') {
			switch (_v0.a.$) {
				case 'DatepickerSelection':
					var info = _v0.a.a;
					return $author$project$DataElement$PreviewDatepickerSelection(info);
				case 'InteractiveSelectSelection':
					var info = _v0.a.a;
					return $author$project$DataElement$PreviewInteractiveSelection(info);
				default:
					break _v0$2;
			}
		} else {
			break _v0$2;
		}
	}
	return $author$project$DataElement$PreviewNormal;
};
var $author$project$UuidDict$filter = F2(
	function (filterFun, _v0) {
		var dict = _v0.a;
		return $author$project$UuidDict$UuidDict(
			A2(
				$elm$core$Dict$filter,
				F2(
					function (_v1, _v2) {
						var uuid = _v2.a;
						var value = _v2.b;
						return A2(filterFun, uuid, value);
					}),
				dict));
	});
var $author$project$DataEngine$DataCache$removeAllExcept = function (uuidsToKeep) {
	return $author$project$DataEngine$DataCache$mapCache(
		$author$project$UuidDict$filter(
			F2(
				function (uuid, _v0) {
					return A2(
						$elm$core$List$member,
						uuid,
						A2($elm$core$List$map, $author$project$DataElement$Reference$getUuid, uuidsToKeep));
				})));
};
var $author$project$DataEngine$trimDataCacheForDatepicker = F3(
	function (ref, info, cache) {
		return A2(
			$author$project$DataEngine$DataCache$removeAllExcept,
			A2(
				$elm$core$List$cons,
				$author$project$DataElement$Reference$getGenericReference(ref),
				$author$project$DataElement$calcDatepickerDependencies(info)),
			cache);
	});
var $author$project$DataEngine$trimDataCacheForDropdown = F3(
	function (ref, dropdownInfo, cache) {
		return A2(
			$author$project$DataEngine$DataCache$removeAllExcept,
			A2(
				$elm$core$List$cons,
				$author$project$DataElement$Reference$getGenericReference(ref),
				$author$project$DataElement$calcDropdownDependencies(dropdownInfo)),
			cache);
	});
var $author$project$DataEngine$confirmDataElementAndFetchFromCache = F3(
	function (app, cache, ref) {
		var maybeEitherRef = A2(
			$author$project$DataElement$getEitherFromReferenceElement,
			$author$project$StudioApp$dataElements(app),
			ref);
		var _v0 = A2(
			$elm$core$Maybe$map,
			$author$project$DataElement$toSpecialPreview,
			A2(
				$author$project$DataElement$getDataElementFromReferenceElement,
				$author$project$StudioApp$dataElements(app),
				ref));
		if (_v0.$ === 'Just') {
			switch (_v0.a.$) {
				case 'PreviewInteractiveSelection':
					var info = _v0.a.a;
					if (maybeEitherRef.$ === 'Just') {
						var eitherRef = maybeEitherRef.a;
						if (eitherRef.$ === 'IsSingleton') {
							var singleRef = eitherRef.a;
							return $author$project$DataEngine$Output$Ready(
								A2(
									$author$project$DataEngine$DropdownResponse,
									info,
									A3($author$project$DataEngine$trimDataCacheForDropdown, singleRef, info, cache)));
						} else {
							return $author$project$DataEngine$Output$NotFound(
								$author$project$DataElement$Reference$getGenericReference(ref));
						}
					} else {
						return $author$project$DataEngine$Output$NotFound(
							$author$project$DataElement$Reference$getGenericReference(ref));
					}
				case 'PreviewDatepickerSelection':
					var info = _v0.a.a;
					if (maybeEitherRef.$ === 'Just') {
						var eitherRef = maybeEitherRef.a;
						if (eitherRef.$ === 'IsSingleton') {
							var singleRef = eitherRef.a;
							return $author$project$DataEngine$Output$Ready(
								A2(
									$author$project$DataEngine$DatepickerResponse,
									info,
									A3($author$project$DataEngine$trimDataCacheForDatepicker, singleRef, info, cache)));
						} else {
							return $author$project$DataEngine$Output$NotFound(
								$author$project$DataElement$Reference$getGenericReference(ref));
						}
					} else {
						return $author$project$DataEngine$Output$NotFound(
							$author$project$DataElement$Reference$getGenericReference(ref));
					}
				default:
					var _v5 = _v0.a;
					var _v6 = A2($author$project$DataEngine$DataCache$getDataElementState, ref, cache);
					if (_v6.$ === 'Just') {
						switch (_v6.a.$) {
							case 'Loading':
								var _v7 = _v6.a;
								return $author$project$DataEngine$Output$QueryRunningPleaseWait;
							case 'Failure':
								var err = _v6.a.a;
								return $author$project$DataEngine$Output$QueryError(err);
							case 'Success':
								var deCache = _v6.a.a;
								return $author$project$DataEngine$Output$Ready(
									$author$project$DataEngine$NormalResponse(deCache));
							default:
								return $author$project$DataEngine$Output$NotFound(
									$author$project$DataElement$Reference$getGenericReference(ref));
						}
					} else {
						return $author$project$DataEngine$Output$QueryRunningPleaseWait;
					}
			}
		} else {
			return $author$project$DataEngine$Output$NotFound(
				$author$project$DataElement$Reference$getGenericReference(ref));
		}
	});
var $author$project$DataEngine$DataCache$getManifests = function (_v0) {
	var internal = _v0.a;
	return internal.manifests;
};
var $author$project$Page$empty = A2(
	$author$project$Page$new,
	'',
	$author$project$DisplayElement$Column(_List_Nil));
var $author$project$StudioApp$mapDataElements = F2(
	function (transform, _v0) {
		var internals = _v0.a;
		return $author$project$StudioApp$App(
			_Utils_update(
				internals,
				{
					dataElements: transform(internals.dataElements)
				}));
	});
var $author$project$StudioApp$mapPages = F2(
	function (transform, _v0) {
		var internals = _v0.a;
		return $author$project$StudioApp$App(
			_Utils_update(
				internals,
				{
					pages: transform(internals.pages)
				}));
	});
var $author$project$DataElement$dataElementCollectionFilter = F2(
	function (elementsToKeep, _v0) {
		var uuidDict = _v0.a;
		return $author$project$DataElement$DataElementCollection(
			A2(
				$author$project$UuidDict$filter,
				F2(
					function (uuid, _v1) {
						return A2(
							$elm$core$List$member,
							uuid,
							A2($elm$core$List$map, $author$project$DataElement$Reference$getUuid, elementsToKeep));
					}),
				uuidDict));
	});
var $elm$core$Set$foldl = F3(
	function (func, initialState, _v0) {
		var dict = _v0.a;
		return A3(
			$elm$core$Dict$foldl,
			F3(
				function (key, _v1, state) {
					return A2(func, key, state);
				}),
			initialState,
			dict);
	});
var $elm$core$Dict$union = F2(
	function (t1, t2) {
		return A3($elm$core$Dict$foldl, $elm$core$Dict$insert, t2, t1);
	});
var $elm$core$Set$union = F2(
	function (_v0, _v1) {
		var dict1 = _v0.a;
		var dict2 = _v1.a;
		return $elm$core$Set$Set_elm_builtin(
			A2($elm$core$Dict$union, dict1, dict2));
	});
var $stoeffel$set_extra$Set$Extra$concatMap = F2(
	function (f, s) {
		return A3(
			$elm$core$Set$foldl,
			A2($elm$core$Basics$composeL, $elm$core$Set$union, f),
			$elm$core$Set$empty,
			s);
	});
var $elm$core$Dict$diff = F2(
	function (t1, t2) {
		return A3(
			$elm$core$Dict$foldl,
			F3(
				function (k, v, t) {
					return A2($elm$core$Dict$remove, k, t);
				}),
			t1,
			t2);
	});
var $elm$core$Set$diff = F2(
	function (_v0, _v1) {
		var dict1 = _v0.a;
		var dict2 = _v1.a;
		return $elm$core$Set$Set_elm_builtin(
			A2($elm$core$Dict$diff, dict1, dict2));
	});
var $author$project$DependencyGraph$findAllDependenciesHelper = F3(
	function (foundSoFar, nextToInvestigate, graph) {
		var newFoundSoFar = A2($elm$core$Set$insert, nextToInvestigate, foundSoFar);
		var newDependencies = function (foundDependencies) {
			return A2($elm$core$Set$diff, foundDependencies, newFoundSoFar);
		}(
			A2($drathier$elm_graph$Graph$incoming, nextToInvestigate, graph));
		return $elm$core$Set$isEmpty(newDependencies) ? newFoundSoFar : A2(
			$stoeffel$set_extra$Set$Extra$concatMap,
			function (depToInvestigate) {
				return A3(
					$author$project$DependencyGraph$findAllDependenciesHelper,
					A2($elm$core$Set$union, newFoundSoFar, newDependencies),
					depToInvestigate,
					graph);
			},
			newDependencies);
	});
var $author$project$DependencyGraph$findAllDependencies = F2(
	function (ref, _v0) {
		var graph = _v0.a;
		return A2(
			$elm$core$List$filterMap,
			function (comp) {
				return A2($drathier$elm_graph$Graph$getData, comp, graph);
			},
			$elm$core$Set$toList(
				A3(
					$author$project$DependencyGraph$findAllDependenciesHelper,
					$elm$core$Set$empty,
					$author$project$DataElement$Reference$toString(ref),
					graph)));
	});
var $author$project$DependencyGraph$findAllDependenciesFrom = F2(
	function (depGraph, ref) {
		return A2($author$project$DependencyGraph$findAllDependencies, ref, depGraph);
	});
var $author$project$StudioApp$shakeDataElementTree = F2(
	function (elementsNeeded, elementsByUuid) {
		var dependencyGraph = $author$project$DependencyGraph$fromDataElements(elementsByUuid);
		var elementsToKeep = A2(
			$elm$core$List$concatMap,
			$author$project$DependencyGraph$findAllDependenciesFrom(dependencyGraph),
			elementsNeeded);
		return A2($author$project$DataElement$dataElementCollectionFilter, elementsToKeep, elementsByUuid);
	});
var $author$project$StudioApp$trimAppByDataElement = F2(
	function (ref, app) {
		return A2(
			$author$project$StudioApp$mapDataElements,
			$author$project$StudioApp$shakeDataElementTree(
				_List_fromArray(
					[
						$author$project$DataElement$Reference$getGenericReference(ref)
					])),
			A2(
				$author$project$StudioApp$mapPages,
				$elm$core$Basics$always(
					$mgold$elm_nonempty_list$List$Nonempty$fromElement($author$project$Page$empty)),
				app));
	});
var $author$project$DisplayElement$Custom$UuidPair = F2(
	function (widgetUuid, versionUuid) {
		return {versionUuid: versionUuid, widgetUuid: widgetUuid};
	});
var $author$project$DisplayElement$getCDEList = function (element) {
	switch (element.$) {
		case 'Column':
			var children = element.a;
			return A2($elm$core$List$concatMap, $author$project$DisplayElement$getCDEList, children);
		case 'Row':
			var children = element.b;
			return A2($elm$core$List$concatMap, $author$project$DisplayElement$getCDEList, children);
		case 'Section':
			var maybeBody = element.b;
			return A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2($elm$core$Maybe$map, $author$project$DisplayElement$getCDEList, maybeBody));
		case 'Table':
			return _List_Nil;
		case 'ProgressChart':
			return _List_Nil;
		case 'TrendChart':
			return _List_Nil;
		case 'FieldList':
			return _List_Nil;
		case 'MetricHighlight':
			return _List_Nil;
		case 'Custom':
			var info = element.a;
			return _List_fromArray(
				[
					A2($author$project$DisplayElement$Custom$UuidPair, info.widgetUuid, info.versionUuid)
				]);
		case 'Select':
			return _List_Nil;
		default:
			return _List_Nil;
	}
};
var $author$project$Page$getCDEList = function (_v0) {
	var element = _v0.b;
	return $author$project$DisplayElement$getCDEList(element);
};
var $author$project$StudioApp$pages = function (_v0) {
	var internals = _v0.a;
	return internals.pages;
};
var $elm_community$list_extra$List$Extra$uniqueBy = F2(
	function (f, list) {
		return A4($elm_community$list_extra$List$Extra$uniqueHelp, f, _List_Nil, list, _List_Nil);
	});
var $author$project$DisplayElement$Custom$uuidPairToComparable = function (_v0) {
	var widgetUuid = _v0.widgetUuid;
	var versionUuid = _v0.versionUuid;
	return _Utils_Tuple2(
		$danyx23$elm_uuid$Uuid$toString(widgetUuid),
		$danyx23$elm_uuid$Uuid$toString(versionUuid));
};
var $author$project$StudioApp$listCdesInStudioApp = function (app) {
	return A2(
		$elm_community$list_extra$List$Extra$uniqueBy,
		$author$project$DisplayElement$Custom$uuidPairToComparable,
		A2(
			$elm$core$List$concatMap,
			$author$project$Page$getCDEList,
			$mgold$elm_nonempty_list$List$Nonempty$toList(
				$author$project$StudioApp$pages(app))));
};
var $author$project$StudioApp$manifestToUuidPair = function (manifest) {
	return A2($author$project$DisplayElement$Custom$UuidPair, manifest.widgetUuid, manifest.versionUuid);
};
var $author$project$StudioApp$findUsedManifests = F2(
	function (innerApp, manifests) {
		var uuidPairsToKeep = $author$project$StudioApp$listCdesInStudioApp(
			$author$project$StudioApp$App(innerApp));
		var shouldKeepManifest = function (manifest) {
			return A2(
				$elm$core$List$member,
				$author$project$StudioApp$manifestToUuidPair(manifest),
				uuidPairsToKeep);
		};
		return A2(
			$elm_community$list_extra$List$Extra$uniqueBy,
			A2($elm$core$Basics$composeR, $author$project$StudioApp$manifestToUuidPair, $author$project$DisplayElement$Custom$uuidPairToComparable),
			A2($elm$core$List$filter, shouldKeepManifest, manifests));
	});
var $author$project$UuidDict$values = function (_v0) {
	var dict = _v0.a;
	return A2(
		$elm$core$List$map,
		$elm$core$Tuple$second,
		$elm$core$Dict$values(dict));
};
var $author$project$DataElement$getDataElements = function (_v0) {
	var uuidDict = _v0.a;
	return $author$project$UuidDict$values(uuidDict);
};
var $author$project$StudioApp$Error$DataElementMissingFields = function (a) {
	return {$: 'DataElementMissingFields', a: a};
};
var $pzp1997$assoc_list$AssocList$isEmpty = function (dict) {
	return _Utils_eq(
		dict,
		$pzp1997$assoc_list$AssocList$D(_List_Nil));
};
var $author$project$DataElement$checkForEmptyFieldDict = F2(
	function (elementName, fields) {
		return $pzp1997$assoc_list$AssocList$isEmpty(fields) ? $elm$core$Maybe$Just(
			$author$project$StudioApp$Error$DataElementMissingFields(elementName)) : $elm$core$Maybe$Nothing;
	});
var $author$project$DataElement$VeevaMessages$fields = A2(
	$elm$core$Basics$composeR,
	$author$project$DataElement$VeevaMessages$fieldNames,
	A2(
		$elm$core$Basics$composeR,
		$elm$core$List$map(
			function (innerName) {
				return _Utils_Tuple2(innerName, $author$project$FieldType$StringType);
			}),
		$pzp1997$assoc_list$AssocList$fromList));
var $author$project$DataElement$validateHasFields = function (_v0) {
	var elementName = _v0.a;
	var element = _v0.b;
	if (element.$ === 'RecordList') {
		switch (element.a.$) {
			case 'CrmQuery':
				var fields = element.a.a.fields;
				return A2($author$project$DataElement$checkForEmptyFieldDict, elementName, fields);
			case 'SalesQuery':
				return $elm$core$Maybe$Nothing;
			case 'NitroQuery':
				var fields = element.a.a.fields;
				return A2($author$project$DataElement$checkForEmptyFieldDict, elementName, fields);
			case 'CrmDataEngineQuery':
				var info = element.a.a;
				return A2(
					$author$project$DataElement$checkForEmptyFieldDict,
					elementName,
					$author$project$DataElement$CrmDataEngineQuery$fields(info));
			case 'CalcOneForOne':
				var fields = element.a.a.fields;
				return A2($author$project$DataElement$checkForEmptyFieldDict, elementName, fields);
			case 'CalcSortList':
				return $elm$core$Maybe$Nothing;
			case 'CalcFilterList':
				return $elm$core$Maybe$Nothing;
			case 'CalcSublist':
				return $elm$core$Maybe$Nothing;
			case 'CalcMergeList':
				var info = element.a.a;
				return A2(
					$author$project$DataElement$checkForEmptyFieldDict,
					elementName,
					$author$project$DataElement$MergeList$fields(info));
			case 'AlignedTerritories':
				return $elm$core$Maybe$Nothing;
			case 'FeedbackChannelGoals':
				var fields = element.a.a.fields;
				return A2($author$project$DataElement$checkForEmptyFieldDict, elementName, fields);
			case 'FeedbackProductGoals':
				var fields = element.a.a.fields;
				return A2($author$project$DataElement$checkForEmptyFieldDict, elementName, fields);
			case 'FeedbackAccountData':
				var fields = element.a.a.fields;
				return A2($author$project$DataElement$checkForEmptyFieldDict, elementName, fields);
			case 'FeedbackAccountChannelGoals':
				var fields = element.a.a.fields;
				return A2($author$project$DataElement$checkForEmptyFieldDict, elementName, fields);
			case 'FeedbackAccountProductGoals':
				var fields = element.a.a.fields;
				return A2($author$project$DataElement$checkForEmptyFieldDict, elementName, fields);
			case 'FeedbackAccountProductMetrics':
				var fields = element.a.a.fields;
				return A2($author$project$DataElement$checkForEmptyFieldDict, elementName, fields);
			default:
				var _v2 = element.a;
				return $elm$core$Maybe$Nothing;
		}
	} else {
		switch (element.a.$) {
			case 'FeedbackOverview':
				var fields = element.a.a.fields;
				return A2($author$project$DataElement$checkForEmptyFieldDict, elementName, fields);
			case 'ContextQuery':
				return $elm$core$Maybe$Nothing;
			case 'LimitOneCrmQuery':
				var fields = element.a.a.fields;
				return A2($author$project$DataElement$checkForEmptyFieldDict, elementName, fields);
			case 'LimitOneNitroQuery':
				var fields = element.a.a.fields;
				return A2($author$project$DataElement$checkForEmptyFieldDict, elementName, fields);
			case 'LimitOneSalesQuery':
				return $elm$core$Maybe$Nothing;
			case 'LimitOneCrmDataEngineQuery':
				var info = element.a.a;
				return A2(
					$author$project$DataElement$checkForEmptyFieldDict,
					elementName,
					$author$project$DataElement$CrmDataEngineQuery$fields(info));
			case 'Today':
				var _v3 = element.a;
				return $elm$core$Maybe$Nothing;
			case 'Now':
				var _v4 = element.a;
				return $elm$core$Maybe$Nothing;
			case 'CalcSummarize':
				var fields = element.a.a.fields;
				return A2($author$project$DataElement$checkForEmptyFieldDict, elementName, fields);
			case 'ObjectTranslation':
				return $elm$core$Maybe$Nothing;
			case 'FieldTranslation':
				return $elm$core$Maybe$Nothing;
			case 'VeevaMessages':
				var vmInfo = element.a.a;
				return A2(
					$author$project$DataElement$checkForEmptyFieldDict,
					elementName,
					$author$project$DataElement$VeevaMessages$fields(vmInfo));
			case 'DatepickerSelection':
				return $elm$core$Maybe$Nothing;
			default:
				return $elm$core$Maybe$Nothing;
		}
	}
};
var $author$project$StudioApp$validateAllDataElementsHaveFields = function (innerApp) {
	return A2(
		$elm$core$List$filterMap,
		$author$project$DataElement$validateHasFields,
		$author$project$DataElement$getDataElements(innerApp.dataElements));
};
var $author$project$StudioApp$Error$MoreThanOneVeevaMessagesDataElement = {$: 'MoreThanOneVeevaMessagesDataElement'};
var $author$project$DataElement$isVeevaMessage = function (_v0) {
	var el = _v0.b;
	if ((el.$ === 'Singleton') && (el.a.$ === 'VeevaMessages')) {
		return true;
	} else {
		return false;
	}
};
var $author$project$DataElement$validateAtMostOneVeevaMessagesDataElement = function (elementsByUuid) {
	return function (length) {
		return (length > 1) ? _List_fromArray(
			[$author$project$StudioApp$Error$MoreThanOneVeevaMessagesDataElement]) : _List_Nil;
	}(
		$elm$core$List$length(
			A2(
				$elm$core$List$filter,
				$author$project$DataElement$isVeevaMessage,
				$author$project$DataElement$getDataElements(elementsByUuid))));
};
var $author$project$StudioApp$validateAtMostOneVeevaMessagesDataElement = function (innerApp) {
	return $author$project$DataElement$validateAtMostOneVeevaMessagesDataElement(innerApp.dataElements);
};
var $author$project$StudioApp$Error$InDataElements = {$: 'InDataElements'};
var $elm$core$String$fromList = _String_fromList;
var $author$project$CodeGen$Helpers$allowedNonAlphaNumChars = _List_fromArray(
	[
		_Utils_chr(' '),
		_Utils_chr('_')
	]);
var $author$project$CodeGen$Helpers$trimAndClean = function (words) {
	return A2(
		$elm$core$List$filter,
		function (_char) {
			return A2($elm$core$List$member, _char, $author$project$CodeGen$Helpers$allowedNonAlphaNumChars) || $elm$core$Char$isAlphaNum(_char);
		},
		$elm$core$String$toList(
			$elm$core$String$trim(words)));
};
var $author$project$CodeGen$Helpers$cleanRef = function (ref) {
	return A2(
		$elm$core$String$append,
		'___',
		$elm$core$String$fromList(
			$author$project$CodeGen$Helpers$trimAndClean(
				$author$project$DataElement$Reference$toString(ref))));
};
var $elm_community$string_extra$String$Extra$camelize = function (string) {
	return A3(
		$elm$regex$Regex$replace,
		$elm_community$string_extra$String$Extra$regexFromString('[-_\\s]+(.)?'),
		function (_v0) {
			var submatches = _v0.submatches;
			if (submatches.b && (submatches.a.$ === 'Just')) {
				var match = submatches.a.a;
				return $elm$core$String$toUpper(match);
			} else {
				return '';
			}
		},
		$elm$core$String$trim(string));
};
var $elm$core$Char$toLower = _Char_toLower;
var $elm_community$string_extra$String$Extra$decapitalize = function (word) {
	return A2($elm_community$string_extra$String$Extra$changeCase, $elm$core$Char$toLower, word);
};
var $author$project$CodeGen$Helpers$fixReservedNames = function (words) {
	return 'c_' + words;
};
var $author$project$CodeGen$Helpers$toSafeFieldName = function (words) {
	var _v0 = $author$project$CodeGen$Helpers$trimAndClean(words);
	if (!_v0.b) {
		return 'unnamed_field';
	} else {
		var cleanedChars = _v0;
		return $author$project$CodeGen$Helpers$fixReservedNames(
			$elm_community$string_extra$String$Extra$decapitalize(
				$elm_community$string_extra$String$Extra$camelize(
					$elm$core$String$fromList(cleanedChars))));
	}
};
var $author$project$CodeGen$Helpers$modelFieldName = function (_v0) {
	var ref = _v0.a;
	var words = _v0.b;
	return _Utils_ap(
		$author$project$CodeGen$Helpers$toSafeFieldName(words),
		$author$project$CodeGen$Helpers$cleanRef(ref));
};
var $author$project$DataElement$name = function (_v0) {
	var elementName = _v0.a;
	return elementName;
};
var $author$project$CodeGen$Helpers$toDecoderName = function (_v0) {
	var ref = _v0.a;
	var words = _v0.b;
	return $author$project$CodeGen$Helpers$toSafeFieldName(words) + ($author$project$CodeGen$Helpers$cleanRef(ref) + '_Decoder');
};
var $author$project$CodeGen$Helpers$fixReservedTypeNames = function (words) {
	return 'C_' + words;
};
var $author$project$CodeGen$Helpers$toSafeTypeName = function (words) {
	var _v0 = $author$project$CodeGen$Helpers$trimAndClean(words);
	if (!_v0.b) {
		return 'Unnamed_Type';
	} else {
		var cleanedChars = _v0;
		return $author$project$CodeGen$Helpers$fixReservedTypeNames(
			$elm_community$string_extra$String$Extra$camelize(
				$elm_community$string_extra$String$Extra$toTitleCase(
					$elm$core$String$fromList(cleanedChars))));
	}
};
var $author$project$CodeGen$Helpers$toMsgConstructorName = function (_v0) {
	var ref = _v0.a;
	var words = _v0.b;
	return 'Rx_' + ($author$project$CodeGen$Helpers$toSafeTypeName(words) + $author$project$CodeGen$Helpers$cleanRef(ref));
};
var $author$project$CodeGen$Helpers$toQueryFunName = function (_v0) {
	var ref = _v0.a;
	var words = _v0.b;
	return 'tryToExecute_' + ($elm_community$string_extra$String$Extra$camelize(
		'-' + $author$project$CodeGen$Helpers$toSafeFieldName(words)) + $author$project$CodeGen$Helpers$cleanRef(ref));
};
var $author$project$CodeGen$Helpers$typeAliasName = function (_v0) {
	var ref = _v0.a;
	var words = _v0.b;
	return _Utils_ap(
		$author$project$CodeGen$Helpers$toSafeTypeName(words),
		$author$project$CodeGen$Helpers$cleanRef(ref));
};
var $author$project$StudioApp$Error$InDataElement = function (a) {
	return {$: 'InDataElement', a: a};
};
var $author$project$DataElement$CrmDataEngineQuery$fieldNames = function (queryInfo) {
	return $mgold$elm_nonempty_list$List$Nonempty$toList(
		A2($mgold$elm_nonempty_list$List$Nonempty$map, $author$project$DataElement$CrmDataEngine$Field$toFieldName, queryInfo.fields));
};
var $author$project$DataElement$fieldNames = F2(
	function (dataElements, element) {
		if (element.$ === 'RecordList') {
			switch (element.a.$) {
				case 'CrmQuery':
					var queryInfo = element.a.a;
					return $pzp1997$assoc_list$AssocList$keys(queryInfo.fields);
				case 'SalesQuery':
					return $pzp1997$assoc_list$AssocList$keys($author$project$DataElement$SalesQuery$fields);
				case 'NitroQuery':
					var queryInfo = element.a.a;
					return $pzp1997$assoc_list$AssocList$keys(queryInfo.fields);
				case 'CrmDataEngineQuery':
					var queryInfo = element.a.a;
					return $author$project$DataElement$CrmDataEngineQuery$fieldNames(queryInfo);
				case 'CalcOneForOne':
					var oneForOne = element.a.a;
					return $pzp1997$assoc_list$AssocList$keys(oneForOne.fields);
				case 'CalcSortList':
					var sortInfo = element.a.a;
					return A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2(
							$elm$core$Maybe$map,
							A2(
								$elm$core$Basics$composeR,
								$author$project$DataElement$unwrapElement,
								$author$project$DataElement$fieldNames(dataElements)),
							A2($author$project$DataElement$getDataElementFromReferenceElement, dataElements, sortInfo.original)));
				case 'CalcFilterList':
					var filterInfo = element.a.a;
					return A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2(
							$elm$core$Maybe$map,
							A2(
								$elm$core$Basics$composeR,
								$author$project$DataElement$unwrapElement,
								$author$project$DataElement$fieldNames(dataElements)),
							A2($author$project$DataElement$getDataElementFromReferenceElement, dataElements, filterInfo.original)));
				case 'CalcSublist':
					var sublistInfo = element.a.a;
					return A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2(
							$elm$core$Maybe$map,
							A2(
								$elm$core$Basics$composeR,
								$author$project$DataElement$unwrapElement,
								$author$project$DataElement$fieldNames(dataElements)),
							A2($author$project$DataElement$getDataElementFromReferenceElement, dataElements, sublistInfo.original)));
				case 'AlignedTerritories':
					return $pzp1997$assoc_list$AssocList$keys($author$project$DataElement$AlignedTerritories$fields);
				case 'CallAttendees':
					var _v1 = element.a;
					return $pzp1997$assoc_list$AssocList$keys($author$project$DataElement$CallAttendees$fields);
				case 'CalcMergeList':
					var mergeListInfo = element.a.a;
					return $pzp1997$assoc_list$AssocList$keys(
						$author$project$DataElement$MergeList$fields(mergeListInfo));
				case 'FeedbackChannelGoals':
					var feedbackChannelGoalsInfo = element.a.a;
					return $pzp1997$assoc_list$AssocList$keys(
						$author$project$DataElement$FeedbackChannelGoals$fields(feedbackChannelGoalsInfo));
				case 'FeedbackProductGoals':
					var feedbackProductGoalsInfo = element.a.a;
					return $pzp1997$assoc_list$AssocList$keys(
						$author$project$DataElement$FeedbackProductGoals$fields(feedbackProductGoalsInfo));
				case 'FeedbackAccountData':
					var feedbackAccountDataInfo = element.a.a;
					return $pzp1997$assoc_list$AssocList$keys(
						$author$project$DataElement$FeedbackAccountData$fields(feedbackAccountDataInfo));
				case 'FeedbackAccountChannelGoals':
					var feedbackAccountChannelGoalsInfo = element.a.a;
					return $pzp1997$assoc_list$AssocList$keys(
						$author$project$DataElement$FeedbackAccountChannelGoals$fields(feedbackAccountChannelGoalsInfo));
				case 'FeedbackAccountProductGoals':
					var feedbackAccountProductGoalsInfo = element.a.a;
					return $pzp1997$assoc_list$AssocList$keys(
						$author$project$DataElement$FeedbackAccountProductGoals$fields(feedbackAccountProductGoalsInfo));
				default:
					var feedbackAccountProductMetricsInfo = element.a.a;
					return $pzp1997$assoc_list$AssocList$keys(
						$author$project$DataElement$FeedbackAccountProductMetrics$fields(feedbackAccountProductMetricsInfo));
			}
		} else {
			switch (element.a.$) {
				case 'FeedbackOverview':
					var feedbackOverviewInfo = element.a.a;
					return $pzp1997$assoc_list$AssocList$keys(feedbackOverviewInfo.fields);
				case 'ContextQuery':
					var contextInfo = element.a.a;
					return _List_fromArray(
						[contextInfo.fieldName]);
				case 'LimitOneCrmQuery':
					var queryInfo = element.a.a;
					return $pzp1997$assoc_list$AssocList$keys(queryInfo.fields);
				case 'LimitOneSalesQuery':
					return $pzp1997$assoc_list$AssocList$keys($author$project$DataElement$SalesQuery$fields);
				case 'LimitOneNitroQuery':
					var queryInfo = element.a.a;
					return $pzp1997$assoc_list$AssocList$keys(queryInfo.fields);
				case 'LimitOneCrmDataEngineQuery':
					var queryInfo = element.a.a;
					return $pzp1997$assoc_list$AssocList$keys(
						$author$project$DataElement$CrmDataEngineQuery$fields(queryInfo));
				case 'Today':
					var _v2 = element.a;
					return $pzp1997$assoc_list$AssocList$keys($author$project$DataElement$Today$fields);
				case 'Now':
					var _v3 = element.a;
					return $pzp1997$assoc_list$AssocList$keys($author$project$DataElement$Now$fields);
				case 'CalcSummarize':
					var summarizeInfo = element.a.a;
					return $pzp1997$assoc_list$AssocList$keys(summarizeInfo.fields);
				case 'ObjectTranslation':
					return $author$project$DataElement$ObjectTranslation$fieldNames;
				case 'FieldTranslation':
					var fieldTranslationInfo = element.a.a;
					return $author$project$DataElement$FieldTranslation$fieldNames(fieldTranslationInfo);
				case 'VeevaMessages':
					var vmInfo = element.a.a;
					return $author$project$DataElement$VeevaMessages$fieldNames(vmInfo);
				case 'DatepickerSelection':
					return $pzp1997$assoc_list$AssocList$keys($author$project$DataElement$Datepicker$fields);
				default:
					return $pzp1997$assoc_list$AssocList$keys($author$project$DataElement$Dropdown$fields);
			}
		}
	});
var $author$project$FieldName$toSafeFieldName = function (_v0) {
	var name = _v0.a;
	return $author$project$CodeGen$Helpers$toSafeFieldName(name);
};
var $author$project$StudioApp$Error$NamesTooSimilar = F4(
	function (a, b, c, d) {
		return {$: 'NamesTooSimilar', a: a, b: b, c: c, d: d};
	});
var $elm$core$List$partition = F2(
	function (pred, list) {
		var step = F2(
			function (x, _v0) {
				var trues = _v0.a;
				var falses = _v0.b;
				return pred(x) ? _Utils_Tuple2(
					A2($elm$core$List$cons, x, trues),
					falses) : _Utils_Tuple2(
					trues,
					A2($elm$core$List$cons, x, falses));
			});
		return A3(
			$elm$core$List$foldr,
			step,
			_Utils_Tuple2(_List_Nil, _List_Nil),
			list);
	});
var $elm_community$list_extra$List$Extra$gatherWith = F2(
	function (testFn, list) {
		var helper = F2(
			function (scattered, gathered) {
				helper:
				while (true) {
					if (!scattered.b) {
						return $elm$core$List$reverse(gathered);
					} else {
						var toGather = scattered.a;
						var population = scattered.b;
						var _v1 = A2(
							$elm$core$List$partition,
							testFn(toGather),
							population);
						var gathering = _v1.a;
						var remaining = _v1.b;
						var $temp$scattered = remaining,
							$temp$gathered = A2(
							$elm$core$List$cons,
							_Utils_Tuple2(toGather, gathering),
							gathered);
						scattered = $temp$scattered;
						gathered = $temp$gathered;
						continue helper;
					}
				}
			});
		return A2(helper, list, _List_Nil);
	});
var $elm_community$list_extra$List$Extra$gatherEquals = function (list) {
	return A2($elm_community$list_extra$List$Extra$gatherWith, $elm$core$Basics$eq, list);
};
var $author$project$Validation$Helpers$validateSimilarNames = F3(
	function (transform, context, names) {
		var toError = function (_v1) {
			var item = _v1.a;
			var moreItems = _v1.b;
			if (!moreItems.b) {
				return $elm$core$Maybe$Nothing;
			} else {
				var firstExtra = moreItems.a;
				var rest = moreItems.b;
				return $elm$core$Maybe$Just(
					A4($author$project$StudioApp$Error$NamesTooSimilar, context, item, firstExtra, rest));
			}
		};
		return A2(
			$elm$core$List$filterMap,
			toError,
			$elm_community$list_extra$List$Extra$gatherEquals(
				A2($elm$core$List$map, transform, names)));
	});
var $author$project$DataElement$validateRecordFieldNames = F2(
	function (dataElements, _v0) {
		var elementName = _v0.a;
		var element = _v0.b;
		return A3(
			$author$project$Validation$Helpers$validateSimilarNames,
			$author$project$FieldName$toSafeFieldName,
			$author$project$StudioApp$Error$InDataElement(elementName),
			A2($author$project$DataElement$fieldNames, dataElements, element));
	});
var $author$project$StudioApp$Error$TripleUnderscoreNotAllowed = F2(
	function (a, b) {
		return {$: 'TripleUnderscoreNotAllowed', a: a, b: b};
	});
var $author$project$DataElement$validateTripleUnderscore = function (names) {
	return A2(
		$elm$core$List$filterMap,
		function (elementName) {
			return A2($elm$core$String$contains, '___', elementName) ? $elm$core$Maybe$Just(
				A2($author$project$StudioApp$Error$TripleUnderscoreNotAllowed, $author$project$StudioApp$Error$InDataElements, elementName)) : $elm$core$Maybe$Nothing;
		},
		names);
};
var $author$project$DataElement$validateNames = function (dataElements) {
	var refElementNames = A2(
		$elm$core$List$map,
		function (_v0) {
			var ref = _v0.a;
			var elem = _v0.b;
			return _Utils_Tuple2(
				ref,
				$author$project$DataElement$name(elem));
		},
		$author$project$DataElement$collectionToList(dataElements));
	var namedElements = $author$project$DataElement$getDataElements(dataElements);
	var elementNames = A2($elm$core$List$map, $author$project$DataElement$name, namedElements);
	return $elm$core$List$concat(
		_List_fromArray(
			[
				$author$project$DataElement$validateTripleUnderscore(elementNames),
				A3($author$project$Validation$Helpers$validateSimilarNames, $author$project$CodeGen$Helpers$modelFieldName, $author$project$StudioApp$Error$InDataElements, refElementNames),
				A2(
				$elm$core$List$concatMap,
				$author$project$DataElement$validateRecordFieldNames(dataElements),
				namedElements),
				A3($author$project$Validation$Helpers$validateSimilarNames, $author$project$CodeGen$Helpers$typeAliasName, $author$project$StudioApp$Error$InDataElements, refElementNames),
				A3($author$project$Validation$Helpers$validateSimilarNames, $author$project$CodeGen$Helpers$toMsgConstructorName, $author$project$StudioApp$Error$InDataElements, refElementNames),
				A3($author$project$Validation$Helpers$validateSimilarNames, $author$project$CodeGen$Helpers$toQueryFunName, $author$project$StudioApp$Error$InDataElements, refElementNames),
				A3($author$project$Validation$Helpers$validateSimilarNames, $author$project$CodeGen$Helpers$toDecoderName, $author$project$StudioApp$Error$InDataElements, refElementNames)
			]));
};
var $author$project$StudioApp$validateDataElementNames = function (innerApp) {
	return $author$project$DataElement$validateNames(innerApp.dataElements);
};
var $author$project$StudioApp$Error$CyclicDependency = F3(
	function (a, b, c) {
		return {$: 'CyclicDependency', a: a, b: b, c: c};
	});
var $author$project$DependencyGraph$findCycleErrorHelper = F4(
	function (originalKey, pathToHere, graph, currentKey) {
		var outgoingKeys = A2(
			$drathier$elm_graph$Graph$outgoing,
			$author$project$DataElement$Reference$toString(currentKey),
			graph);
		return $elm$core$Set$isEmpty(outgoingKeys) ? $elm$core$Maybe$Nothing : (A2(
			$elm$core$Set$member,
			$author$project$DataElement$Reference$toString(originalKey),
			outgoingKeys) ? $elm$core$Maybe$Just(
			_Utils_Tuple2(
				originalKey,
				A2($elm$core$List$cons, currentKey, pathToHere))) : (A2(
			$elm$core$List$any,
			function (pathKey) {
				return A2(
					$elm$core$Set$member,
					$author$project$DataElement$Reference$toString(pathKey),
					outgoingKeys);
			},
			pathToHere) ? $elm$core$Maybe$Nothing : $elm$core$List$head(
			A2(
				$elm$core$List$filterMap,
				A3(
					$author$project$DependencyGraph$findCycleErrorHelper,
					originalKey,
					A2($elm$core$List$cons, currentKey, pathToHere),
					graph),
				A2(
					$elm$core$List$filterMap,
					function (comp) {
						return A2($drathier$elm_graph$Graph$getData, comp, graph);
					},
					$elm$core$Set$toList(outgoingKeys))))));
	});
var $author$project$DependencyGraph$findCycleError = F2(
	function (_v0, key) {
		var graph = _v0.a;
		return A4($author$project$DependencyGraph$findCycleErrorHelper, key, _List_Nil, graph, key);
	});
var $drathier$elm_graph$Graph$isAcyclic = function (graph) {
	return A3(
		$drathier$elm_graph$Graph$isAcyclicHelper,
		$elm$core$List$reverse(
			$drathier$elm_graph$Graph$reversePostOrder(graph)),
		$elm$core$Set$empty,
		graph);
};
var $author$project$DependencyGraph$isAcyclic = function (_v0) {
	var graph = _v0.a;
	return $drathier$elm_graph$Graph$isAcyclic(graph);
};
var $drathier$elm_graph$Graph$foldl = F3(
	function (func, acc, _v0) {
		var graph = _v0.a;
		return A3(
			$elm$core$Dict$foldl,
			F2(
				function (key, _v1) {
					var node = _v1.a;
					return A2(func, key, node.data);
				}),
			acc,
			graph.nodes);
	});
var $drathier$elm_graph$Graph$nodes = A2(
	$drathier$elm_graph$Graph$foldl,
	F3(
		function (key, data, list) {
			return A2(
				$elm$core$List$cons,
				_Utils_Tuple2(key, data),
				list);
		}),
	_List_Nil);
var $author$project$DependencyGraph$keys = function (_v0) {
	var graph = _v0.a;
	return A2(
		$elm$core$List$filterMap,
		$elm$core$Tuple$second,
		$drathier$elm_graph$Graph$nodes(graph));
};
var $author$project$StudioApp$validateDataGraphIsAcyclic = function (innerApp) {
	var graph = $author$project$DependencyGraph$fromDataElements(innerApp.dataElements);
	var getNameForRef = function (ref) {
		return A2(
			$elm$core$Maybe$map,
			$author$project$DataElement$name,
			A2($author$project$DataElement$getDataElementFromReferenceElement, innerApp.dataElements, ref));
	};
	var findNamesForError = function (_v1) {
		var firstNode = _v1.a;
		var others = _v1.b;
		return A2(
			$elm$core$Maybe$map,
			function (firstName) {
				return _Utils_Tuple2(
					firstName,
					A2($elm$core$List$filterMap, getNameForRef, others));
			},
			getNameForRef(firstNode));
	};
	return $author$project$DependencyGraph$isAcyclic(graph) ? _List_Nil : A2(
		$elm$core$List$map,
		function (_v0) {
			var node = _v0.a;
			var othersInCycle = _v0.b;
			return A3($author$project$StudioApp$Error$CyclicDependency, $author$project$StudioApp$Error$InDataElements, node, othersInCycle);
		},
		A2(
			$elm$core$List$filterMap,
			findNamesForError,
			A2(
				$elm$core$List$filterMap,
				$author$project$DependencyGraph$findCycleError(graph),
				$author$project$DependencyGraph$keys(graph))));
};
var $author$project$StudioApp$Error$CannotFindManifest = F2(
	function (a, b) {
		return {$: 'CannotFindManifest', a: a, b: b};
	});
var $author$project$DisplayElement$Custom$findManifest = F2(
	function (manifests, info) {
		return $elm$core$List$head(
			A2(
				$elm$core$List$filter,
				function (m) {
					return _Utils_eq(m.widgetUuid, info.widgetUuid) && _Utils_eq(m.versionUuid, info.versionUuid);
				},
				manifests));
	});
var $author$project$StudioApp$Error$InPage = function (a) {
	return {$: 'InPage', a: a};
};
var $elm_community$maybe_extra$Maybe$Extra$toList = function (m) {
	if (m.$ === 'Nothing') {
		return _List_Nil;
	} else {
		var x = m.a;
		return _List_fromArray(
			[x]);
	}
};
var $author$project$StudioApp$Error$FieldNotFound = F2(
	function (a, b) {
		return {$: 'FieldNotFound', a: a, b: b};
	});
var $author$project$StudioApp$Error$WrongTypeError = F4(
	function (a, b, c, d) {
		return {$: 'WrongTypeError', a: a, b: b, c: c, d: d};
	});
var $author$project$DataElement$validateFieldTypeByRefAndName = F5(
	function (elementCollection, context, listRef, expectedType, fieldName) {
		var _v0 = A3($author$project$DataElement$getFieldTypeByRefAndName, elementCollection, listRef, fieldName);
		if (_v0.$ === 'Just') {
			var fieldType = _v0.a;
			return _Utils_eq(fieldType, expectedType) ? _List_Nil : _List_fromArray(
				[
					A4(
					$author$project$StudioApp$Error$WrongTypeError,
					context,
					$author$project$FieldName$toString(fieldName),
					expectedType,
					fieldType)
				]);
		} else {
			return _List_fromArray(
				[
					A2(
					$author$project$StudioApp$Error$FieldNotFound,
					context,
					$author$project$FieldName$toString(fieldName))
				]);
		}
	});
var $author$project$StudioApp$Error$InvalidRecordListReference = F2(
	function (a, b) {
		return {$: 'InvalidRecordListReference', a: a, b: b};
	});
var $author$project$StudioApp$Error$RecordListReferenceNotFound = F2(
	function (a, b) {
		return {$: 'RecordListReferenceNotFound', a: a, b: b};
	});
var $author$project$DataElement$validateRecordListReference = F3(
	function (allDataElements, ref, context) {
		var _v0 = A2(
			$elm$core$Maybe$map,
			$author$project$DataElement$unwrapElement,
			A2($author$project$DataElement$getDataElementFromReferenceElement, allDataElements, ref));
		if (_v0.$ === 'Just') {
			if (_v0.a.$ === 'RecordList') {
				return $elm$core$Maybe$Nothing;
			} else {
				return $elm$core$Maybe$Just(
					A2($author$project$StudioApp$Error$InvalidRecordListReference, context, ref));
			}
		} else {
			return $elm$core$Maybe$Just(
				A2($author$project$StudioApp$Error$RecordListReferenceNotFound, context, ref));
		}
	});
var $author$project$DataElement$validateAllValuesInField = F5(
	function (elementsByName, context, fieldType, listRef, fieldName) {
		var refError = A3($author$project$DataElement$validateRecordListReference, elementsByName, listRef, context);
		var fieldErrors = A5($author$project$DataElement$validateFieldTypeByRefAndName, elementsByName, context, listRef, fieldType, fieldName);
		return _Utils_ap(
			$elm_community$maybe_extra$Maybe$Extra$toList(refError),
			fieldErrors);
	});
var $author$project$DataElement$FieldTranslation$fields = A2(
	$elm$core$Basics$composeR,
	$author$project$DataElement$FieldTranslation$fieldNames,
	A2(
		$elm$core$Basics$composeR,
		$elm$core$List$map(
			function (innerName) {
				return _Utils_Tuple2(innerName, $author$project$FieldType$StringType);
			}),
		$pzp1997$assoc_list$AssocList$fromList));
var $author$project$DataElement$ObjectTranslation$fields = $pzp1997$assoc_list$AssocList$fromList(
	A2(
		$elm$core$List$map,
		function (name) {
			return _Utils_Tuple2(name, $author$project$FieldType$StringType);
		},
		$author$project$DataElement$ObjectTranslation$fieldNames));
var $author$project$DataElement$getSingletonFieldTypeByRefAndName = F3(
	function (allElements, ref, fieldName) {
		var _v0 = A2(
			$elm$core$Maybe$map,
			$author$project$DataElement$unwrapElement,
			A2($author$project$DataElement$getDataElementFromReferenceElement, allElements, ref));
		if (_v0.$ === 'Just') {
			if (_v0.a.$ === 'Singleton') {
				switch (_v0.a.a.$) {
					case 'ContextQuery':
						var contextInfo = _v0.a.a.a;
						return _Utils_eq(contextInfo.fieldName, fieldName) ? $elm$core$Maybe$Just(contextInfo.fieldType) : $elm$core$Maybe$Nothing;
					case 'LimitOneCrmQuery':
						var queryInfo = _v0.a.a.a;
						return A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.fieldType;
							},
							A2($pzp1997$assoc_list$AssocList$get, fieldName, queryInfo.fields));
					case 'LimitOneSalesQuery':
						return A2($pzp1997$assoc_list$AssocList$get, fieldName, $author$project$DataElement$SalesQuery$fields);
					case 'LimitOneNitroQuery':
						var queryInfo = _v0.a.a.a;
						return A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.fieldType;
							},
							A2($pzp1997$assoc_list$AssocList$get, fieldName, queryInfo.fields));
					case 'LimitOneCrmDataEngineQuery':
						var queryInfo = _v0.a.a.a;
						return A2(
							$pzp1997$assoc_list$AssocList$get,
							fieldName,
							$author$project$DataElement$CrmDataEngineQuery$fields(queryInfo));
					case 'Today':
						var _v1 = _v0.a.a;
						return A2($pzp1997$assoc_list$AssocList$get, fieldName, $author$project$DataElement$Today$fields);
					case 'Now':
						var _v2 = _v0.a.a;
						return A2($pzp1997$assoc_list$AssocList$get, fieldName, $author$project$DataElement$Now$fields);
					case 'CalcSummarize':
						var summarizeInfo = _v0.a.a.a;
						return A2(
							$elm$core$Maybe$map,
							$author$project$DataElement$Expression$globalFieldDataType,
							A2($pzp1997$assoc_list$AssocList$get, fieldName, summarizeInfo.fields));
					case 'ObjectTranslation':
						return A2($pzp1997$assoc_list$AssocList$get, fieldName, $author$project$DataElement$ObjectTranslation$fields);
					case 'FieldTranslation':
						var fieldTranslationInfo = _v0.a.a.a;
						return A2(
							$pzp1997$assoc_list$AssocList$get,
							fieldName,
							$author$project$DataElement$FieldTranslation$fields(fieldTranslationInfo));
					case 'VeevaMessages':
						var vmInfo = _v0.a.a.a;
						return A2(
							$pzp1997$assoc_list$AssocList$get,
							fieldName,
							$author$project$DataElement$VeevaMessages$fields(vmInfo));
					case 'DatepickerSelection':
						return A2($pzp1997$assoc_list$AssocList$get, fieldName, $author$project$DataElement$Datepicker$fields);
					case 'InteractiveSelectSelection':
						return A2($pzp1997$assoc_list$AssocList$get, fieldName, $author$project$DataElement$Dropdown$fields);
					default:
						var overviewInfo = _v0.a.a.a;
						return A2($pzp1997$assoc_list$AssocList$get, fieldName, overviewInfo.fields);
				}
			} else {
				return $elm$core$Maybe$Nothing;
			}
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$DataElement$validateSingletonFieldByRefAndName = F5(
	function (elementsByName, context, expectedType, ref, fieldName) {
		var _v0 = A3($author$project$DataElement$getSingletonFieldTypeByRefAndName, elementsByName, ref, fieldName);
		if (_v0.$ === 'Just') {
			var fieldType = _v0.a;
			return _Utils_eq(fieldType, expectedType) ? _List_Nil : _List_fromArray(
				[
					A4(
					$author$project$StudioApp$Error$WrongTypeError,
					context,
					$author$project$FieldName$toString(fieldName),
					expectedType,
					fieldType)
				]);
		} else {
			return _List_fromArray(
				[
					A2(
					$author$project$StudioApp$Error$FieldNotFound,
					context,
					$author$project$FieldName$toString(fieldName))
				]);
		}
	});
var $author$project$DataElement$validateGlobalTransformer = F2(
	function (elementsByName, context) {
		return {
			add: $elm$core$Basics$append,
			all: $elm$core$Basics$identity,
			allBoolsInField: A3($author$project$DataElement$validateAllValuesInField, elementsByName, context, $author$project$FieldType$BoolType),
			allDateTimesInField: A3($author$project$DataElement$validateAllValuesInField, elementsByName, context, $author$project$FieldType$DateTimeType),
			allDatesInField: A3($author$project$DataElement$validateAllValuesInField, elementsByName, context, $author$project$FieldType$DateType),
			allNumbersInField: A3($author$project$DataElement$validateAllValuesInField, elementsByName, context, $author$project$FieldType$NumberType),
			allStringsInField: A3($author$project$DataElement$validateAllValuesInField, elementsByName, context, $author$project$FieldType$StringType),
			any: $elm$core$Basics$identity,
			boolsAsList: $elm$core$List$concat,
			challengeReasons: $elm$core$Basics$identity,
			comparableEqual: function (_v0) {
				return $elm$core$Basics$append;
			},
			comparableNotEqual: function (_v1) {
				return $elm$core$Basics$append;
			},
			concat: $elm$core$Basics$append,
			countUnique: $elm$core$Basics$always($elm$core$Basics$identity),
			dateAdd: function (_v2) {
				return $elm$core$Basics$append;
			},
			dateCeiling: F2(
				function (_v3, errors) {
					return errors;
				}),
			dateFloor: F2(
				function (_v4, errors) {
					return errors;
				}),
			dateSubtract: function (_v5) {
				return $elm$core$Basics$append;
			},
			dateTimeToDate: $elm$core$Basics$identity,
			dateTimesAsList: $elm$core$List$concat,
			datesAsList: $elm$core$List$concat,
			dayInMonth: $elm$core$Basics$identity,
			divide: $elm$core$Basics$append,
			equal: function (_v6) {
				return $elm$core$Basics$append;
			},
			formatDate: $elm$core$Basics$append,
			formatDateLocaleAware: $elm$core$Basics$identity,
			formatDateTime: $elm$core$Basics$identity,
			formatNumber: function (_v7) {
				return $elm$core$Basics$identity;
			},
			globalBoolLookup: A3($author$project$DataElement$validateSingletonFieldByRefAndName, elementsByName, context, $author$project$FieldType$BoolType),
			globalDateLookup: A3($author$project$DataElement$validateSingletonFieldByRefAndName, elementsByName, context, $author$project$FieldType$DateType),
			globalDateTimeLookup: A3($author$project$DataElement$validateSingletonFieldByRefAndName, elementsByName, context, $author$project$FieldType$DateTimeType),
			globalNumberLookup: A3($author$project$DataElement$validateSingletonFieldByRefAndName, elementsByName, context, $author$project$FieldType$NumberType),
			globalStringLookup: A3($author$project$DataElement$validateSingletonFieldByRefAndName, elementsByName, context, $author$project$FieldType$StringType),
			greaterThan: function (_v8) {
				return $elm$core$Basics$append;
			},
			greaterThanOrEqual: function (_v9) {
				return $elm$core$Basics$append;
			},
			hardcodedBool: function (_v10) {
				return _List_Nil;
			},
			hardcodedDate: function (_v11) {
				return _List_Nil;
			},
			hardcodedDateTime: function (_v12) {
				return _List_Nil;
			},
			hardcodedNumber: function (_v13) {
				return _List_Nil;
			},
			hardcodedString: function (_v14) {
				return _List_Nil;
			},
			if_: F4(
				function (_v15, a, b, c) {
					return _Utils_ap(
						a,
						_Utils_ap(b, c));
				}),
			isNotNull: $elm$core$Basics$identity,
			isNull: $elm$core$Basics$identity,
			lessThan: function (_v16) {
				return $elm$core$Basics$append;
			},
			lessThanOrEqual: function (_v17) {
				return $elm$core$Basics$append;
			},
			max: function (_v18) {
				return $elm$core$Basics$identity;
			},
			min: function (_v19) {
				return $elm$core$Basics$identity;
			},
			monthNumber: $elm$core$Basics$identity,
			multiply: $elm$core$Basics$append,
			not: $elm$core$Basics$identity,
			notEqual: function (_v20) {
				return $elm$core$Basics$append;
			},
			numbersAsList: $elm$core$List$concat,
			pickOne: function (_v21) {
				return $elm$core$Basics$identity;
			},
			product: $elm$core$Basics$identity,
			round: $elm$core$Basics$identity,
			stringIn: $elm$core$Basics$append,
			stringNotIn: $elm$core$Basics$append,
			stringsAsList: $elm$core$List$concat,
			subtract: $elm$core$Basics$append,
			sum: $elm$core$Basics$identity,
			targetChallengeReasons: $elm$core$Basics$identity,
			yearNumber: $elm$core$Basics$identity
		};
	});
var $author$project$DataElement$validateLocalTransformer = F3(
	function (allElements, context, listRef) {
		return {
			add: $elm$core$Basics$append,
			all: $elm$core$Basics$identity,
			allBoolsInField: A3($author$project$DataElement$validateAllValuesInField, allElements, context, $author$project$FieldType$BoolType),
			allDateTimesInField: A3($author$project$DataElement$validateAllValuesInField, allElements, context, $author$project$FieldType$DateTimeType),
			allDatesInField: A3($author$project$DataElement$validateAllValuesInField, allElements, context, $author$project$FieldType$DateType),
			allNumbersInField: A3($author$project$DataElement$validateAllValuesInField, allElements, context, $author$project$FieldType$NumberType),
			allStringsInField: A3($author$project$DataElement$validateAllValuesInField, allElements, context, $author$project$FieldType$StringType),
			any: $elm$core$Basics$identity,
			boolsAsList: $elm$core$List$concat,
			challengeReasons: $elm$core$Basics$identity,
			comparableEqual: function (_v0) {
				return $elm$core$Basics$append;
			},
			comparableNotEqual: function (_v1) {
				return $elm$core$Basics$append;
			},
			concat: $elm$core$Basics$append,
			countUnique: $elm$core$Basics$always($elm$core$Basics$identity),
			dateAdd: function (_v2) {
				return $elm$core$Basics$append;
			},
			dateCeiling: F2(
				function (_v3, errors) {
					return errors;
				}),
			dateFloor: F2(
				function (_v4, errors) {
					return errors;
				}),
			dateSubtract: function (_v5) {
				return $elm$core$Basics$append;
			},
			dateTimeToDate: $elm$core$Basics$identity,
			dateTimesAsList: $elm$core$List$concat,
			datesAsList: $elm$core$List$concat,
			dayInMonth: $elm$core$Basics$identity,
			divide: $elm$core$Basics$append,
			equal: function (_v6) {
				return $elm$core$Basics$append;
			},
			formatDate: $elm$core$Basics$append,
			formatDateLocaleAware: $elm$core$Basics$identity,
			formatDateTime: $elm$core$Basics$identity,
			formatNumber: function (_v7) {
				return $elm$core$Basics$identity;
			},
			globalBoolLookup: A3($author$project$DataElement$validateSingletonFieldByRefAndName, allElements, context, $author$project$FieldType$BoolType),
			globalDateLookup: A3($author$project$DataElement$validateSingletonFieldByRefAndName, allElements, context, $author$project$FieldType$DateType),
			globalDateTimeLookup: A3($author$project$DataElement$validateSingletonFieldByRefAndName, allElements, context, $author$project$FieldType$DateTimeType),
			globalNumberLookup: A3($author$project$DataElement$validateSingletonFieldByRefAndName, allElements, context, $author$project$FieldType$NumberType),
			globalStringLookup: A3($author$project$DataElement$validateSingletonFieldByRefAndName, allElements, context, $author$project$FieldType$StringType),
			greaterThan: function (_v8) {
				return $elm$core$Basics$append;
			},
			greaterThanOrEqual: function (_v9) {
				return $elm$core$Basics$append;
			},
			hardcodedBool: function (_v10) {
				return _List_Nil;
			},
			hardcodedDate: function (_v11) {
				return _List_Nil;
			},
			hardcodedDateTime: function (_v12) {
				return _List_Nil;
			},
			hardcodedNumber: function (_v13) {
				return _List_Nil;
			},
			hardcodedString: function (_v14) {
				return _List_Nil;
			},
			if_: F4(
				function (_v15, a, b, c) {
					return _Utils_ap(
						a,
						_Utils_ap(b, c));
				}),
			isNotNull: $elm$core$Basics$identity,
			isNull: $elm$core$Basics$identity,
			lessThan: function (_v16) {
				return $elm$core$Basics$append;
			},
			lessThanOrEqual: function (_v17) {
				return $elm$core$Basics$append;
			},
			localBool: A4($author$project$DataElement$validateFieldTypeByRefAndName, allElements, context, listRef, $author$project$FieldType$BoolType),
			localDate: A4($author$project$DataElement$validateFieldTypeByRefAndName, allElements, context, listRef, $author$project$FieldType$DateType),
			localDateTime: A4($author$project$DataElement$validateFieldTypeByRefAndName, allElements, context, listRef, $author$project$FieldType$DateTimeType),
			localNumber: A4($author$project$DataElement$validateFieldTypeByRefAndName, allElements, context, listRef, $author$project$FieldType$NumberType),
			localString: A4($author$project$DataElement$validateFieldTypeByRefAndName, allElements, context, listRef, $author$project$FieldType$StringType),
			max: function (_v18) {
				return $elm$core$Basics$identity;
			},
			min: function (_v19) {
				return $elm$core$Basics$identity;
			},
			monthNumber: $elm$core$Basics$identity,
			multiply: $elm$core$Basics$append,
			not: $elm$core$Basics$identity,
			notEqual: function (_v20) {
				return $elm$core$Basics$append;
			},
			numbersAsList: $elm$core$List$concat,
			pickOne: function (_v21) {
				return $elm$core$Basics$identity;
			},
			product: $elm$core$Basics$identity,
			relatedBool: A4($author$project$DataElement$validateRelatedField, allElements, context, listRef, $author$project$FieldType$BoolType),
			relatedDate: A4($author$project$DataElement$validateRelatedField, allElements, context, listRef, $author$project$FieldType$DateType),
			relatedDateTime: A4($author$project$DataElement$validateRelatedField, allElements, context, listRef, $author$project$FieldType$DateTimeType),
			relatedNumber: A4($author$project$DataElement$validateRelatedField, allElements, context, listRef, $author$project$FieldType$NumberType),
			relatedString: A4($author$project$DataElement$validateRelatedField, allElements, context, listRef, $author$project$FieldType$StringType),
			round: $elm$core$Basics$identity,
			stringIn: $elm$core$Basics$append,
			stringNotIn: $elm$core$Basics$append,
			stringsAsList: $elm$core$List$concat,
			subtract: $elm$core$Basics$append,
			sum: $elm$core$Basics$identity,
			targetChallengeReasons: $elm$core$Basics$identity,
			yearNumber: $elm$core$Basics$identity
		};
	});
var $author$project$DataElement$validateRelatedField = F6(
	function (elementsByName, context, listRef, fieldType, relationship, fieldName) {
		return _Utils_ap(
			A2(
				$author$project$DataElement$Expression$applyLocalStringList,
				A3($author$project$DataElement$validateLocalTransformer, elementsByName, context, listRef),
				relationship.localIds),
			_Utils_ap(
				A2(
					$author$project$DataElement$Expression$applyLocalString,
					A3($author$project$DataElement$validateLocalTransformer, elementsByName, context, relationship.nextElement),
					relationship.idToMatch),
				_Utils_ap(
					A5($author$project$DataElement$validateFieldTypeByRefAndName, elementsByName, context, relationship.nextElement, fieldType, fieldName),
					A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2(
							$elm$core$Maybe$map,
							$author$project$DataElement$Expression$applyLocalBool(
								A3($author$project$DataElement$validateLocalTransformer, elementsByName, context, relationship.nextElement)),
							relationship.optionalFilter)))));
	});
var $author$project$DisplayElement$Custom$validateDataTypesAndRefsForProperty = F3(
	function (dataByUuid, pageName, property) {
		if (property.$ === 'SingleValue') {
			var exp = property.a;
			return A2(
				$author$project$DataElement$Expression$applyGlobalField,
				A2(
					$author$project$DataElement$validateGlobalTransformer,
					dataByUuid,
					$author$project$StudioApp$Error$InPage(pageName)),
				exp);
		} else {
			var ref = property.a;
			var fields = property.b;
			return $elm$core$List$concat(
				_List_fromArray(
					[
						$elm_community$maybe_extra$Maybe$Extra$toList(
						A3(
							$author$project$DataElement$validateRecordListReference,
							dataByUuid,
							ref,
							$author$project$StudioApp$Error$InPage(pageName))),
						A2(
						$elm$core$List$concatMap,
						$author$project$DataElement$Expression$applyLocalField(
							A3(
								$author$project$DataElement$validateLocalTransformer,
								dataByUuid,
								$author$project$StudioApp$Error$InPage(pageName),
								ref)),
						$elm$core$Dict$values(fields))
					]));
		}
	});
var $author$project$StudioApp$Error$InCustomDisplayElement = F2(
	function (a, b) {
		return {$: 'InCustomDisplayElement', a: a, b: b};
	});
var $author$project$StudioApp$Error$FieldMisMatched = F2(
	function (a, b) {
		return {$: 'FieldMisMatched', a: a, b: b};
	});
var $author$project$DisplayElement$Custom$fieldInBoth = F5(
	function (context, key, element, exp, errors) {
		return _Utils_eq(
			element.fieldType,
			$author$project$DataElement$Expression$localFieldDataType(exp)) ? errors : A2(
			$elm$core$List$cons,
			A4(
				$author$project$StudioApp$Error$WrongTypeError,
				context,
				key,
				element.fieldType,
				$author$project$DataElement$Expression$localFieldDataType(exp)),
			errors);
	});
var $author$project$DisplayElement$Custom$fieldInLeft = F4(
	function (context, key, element, errors) {
		var _v0 = element.required;
		if (_v0.$ === 'Required') {
			return A2(
				$elm$core$List$cons,
				A2($author$project$StudioApp$Error$FieldNotFound, context, key),
				errors);
		} else {
			return errors;
		}
	});
var $author$project$DisplayElement$Custom$fieldInRight = F3(
	function (_v0, _v1, errors) {
		return errors;
	});
var $elm$core$Dict$merge = F6(
	function (leftStep, bothStep, rightStep, leftDict, rightDict, initialResult) {
		var stepState = F3(
			function (rKey, rValue, _v0) {
				stepState:
				while (true) {
					var list = _v0.a;
					var result = _v0.b;
					if (!list.b) {
						return _Utils_Tuple2(
							list,
							A3(rightStep, rKey, rValue, result));
					} else {
						var _v2 = list.a;
						var lKey = _v2.a;
						var lValue = _v2.b;
						var rest = list.b;
						if (_Utils_cmp(lKey, rKey) < 0) {
							var $temp$rKey = rKey,
								$temp$rValue = rValue,
								$temp$_v0 = _Utils_Tuple2(
								rest,
								A3(leftStep, lKey, lValue, result));
							rKey = $temp$rKey;
							rValue = $temp$rValue;
							_v0 = $temp$_v0;
							continue stepState;
						} else {
							if (_Utils_cmp(lKey, rKey) > 0) {
								return _Utils_Tuple2(
									list,
									A3(rightStep, rKey, rValue, result));
							} else {
								return _Utils_Tuple2(
									rest,
									A4(bothStep, lKey, lValue, rValue, result));
							}
						}
					}
				}
			});
		var _v3 = A3(
			$elm$core$Dict$foldl,
			stepState,
			_Utils_Tuple2(
				$elm$core$Dict$toList(leftDict),
				initialResult),
			rightDict);
		var leftovers = _v3.a;
		var intermediateResult = _v3.b;
		return A3(
			$elm$core$List$foldl,
			F2(
				function (_v4, result) {
					var k = _v4.a;
					var v = _v4.b;
					return A3(leftStep, k, v, result);
				}),
			intermediateResult,
			leftovers);
	});
var $author$project$DisplayElement$Custom$keyInBoth = F5(
	function (context, key, manifestProp, property, errors) {
		var _v0 = _Utils_Tuple2(manifestProp, property);
		_v0$2:
		while (true) {
			if (_v0.a.$ === 'SingleValue') {
				if (_v0.b.$ === 'SingleValue') {
					var _v1 = _v0.a;
					var fieldType = _v1.b;
					var exp = _v0.b.a;
					return _Utils_eq(
						fieldType,
						$author$project$DataElement$Expression$globalFieldDataType(exp)) ? errors : A2(
						$elm$core$List$cons,
						A4(
							$author$project$StudioApp$Error$WrongTypeError,
							context,
							key,
							fieldType,
							$author$project$DataElement$Expression$globalFieldDataType(exp)),
						errors);
				} else {
					break _v0$2;
				}
			} else {
				if (_v0.b.$ === 'ArrayValue') {
					var _v2 = _v0.a;
					var arrayElements = _v2.b;
					var _v3 = _v0.b;
					var fields = _v3.b;
					return A6(
						$elm$core$Dict$merge,
						$author$project$DisplayElement$Custom$fieldInLeft(context),
						$author$project$DisplayElement$Custom$fieldInBoth(context),
						$author$project$DisplayElement$Custom$fieldInRight,
						arrayElements,
						fields,
						errors);
				} else {
					break _v0$2;
				}
			}
		}
		return A2(
			$elm$core$List$cons,
			A2($author$project$StudioApp$Error$FieldMisMatched, context, key),
			errors);
	});
var $author$project$Manifest$isRequired = function (prop) {
	if (prop.$ === 'SingleValue') {
		var required = prop.a;
		return required;
	} else {
		var required = prop.a;
		return required;
	}
};
var $author$project$DisplayElement$Custom$keyInLeft = F4(
	function (context, key, prop, errors) {
		var _v0 = $author$project$Manifest$isRequired(prop);
		if (_v0.$ === 'Required') {
			return A2(
				$elm$core$List$cons,
				A2($author$project$StudioApp$Error$FieldNotFound, context, key),
				errors);
		} else {
			return errors;
		}
	});
var $author$project$DisplayElement$Custom$keyInRight = F3(
	function (_v0, _v1, errors) {
		return errors;
	});
var $author$project$DisplayElement$Custom$validateManifestProperties = F2(
	function (manifest, properties) {
		var context = A2($author$project$StudioApp$Error$InCustomDisplayElement, manifest.widgetUuid, manifest.versionUuid);
		return A6(
			$elm$core$Dict$merge,
			$author$project$DisplayElement$Custom$keyInLeft(context),
			$author$project$DisplayElement$Custom$keyInBoth(context),
			$author$project$DisplayElement$Custom$keyInRight,
			manifest.properties,
			properties,
			_List_Nil);
	});
var $author$project$DisplayElement$Custom$validateDataTypesAndRefs = F4(
	function (manifests, dataByUuid, pageName, info) {
		var _v0 = A2($author$project$DisplayElement$Custom$findManifest, manifests, info);
		if (_v0.$ === 'Just') {
			var manifest = _v0.a;
			return _Utils_ap(
				A2(
					$elm$core$List$concatMap,
					A2($author$project$DisplayElement$Custom$validateDataTypesAndRefsForProperty, dataByUuid, pageName),
					$elm$core$Dict$values(info.properties)),
				A2($author$project$DisplayElement$Custom$validateManifestProperties, manifest, info.properties));
		} else {
			return _List_fromArray(
				[
					A2($author$project$StudioApp$Error$CannotFindManifest, info.widgetUuid, info.versionUuid)
				]);
		}
	});
var $author$project$StudioApp$Error$DatepickerReferenceNotFound = F2(
	function (a, b) {
		return {$: 'DatepickerReferenceNotFound', a: a, b: b};
	});
var $author$project$StudioApp$Error$InvalidDatepickerReference = F2(
	function (a, b) {
		return {$: 'InvalidDatepickerReference', a: a, b: b};
	});
var $author$project$DataElement$validateDatepickerReference = F3(
	function (elementCollection, ref, context) {
		var _v0 = A2(
			$elm$core$Maybe$map,
			$author$project$DataElement$unwrapElement,
			A2($author$project$DataElement$getDataElementFromReferenceElement, elementCollection, ref));
		if (_v0.$ === 'Just') {
			if ((_v0.a.$ === 'Singleton') && (_v0.a.a.$ === 'DatepickerSelection')) {
				return $elm$core$Maybe$Nothing;
			} else {
				return $elm$core$Maybe$Just(
					A2($author$project$StudioApp$Error$InvalidDatepickerReference, context, ref));
			}
		} else {
			return $elm$core$Maybe$Just(
				A2($author$project$StudioApp$Error$DatepickerReferenceNotFound, context, ref));
		}
	});
var $author$project$DisplayElement$Datepicker$validateDataTypesAndRefs = F3(
	function (dataByUuid, pageName, inner) {
		var referenceError = $elm_community$maybe_extra$Maybe$Extra$toList(
			A3(
				$author$project$DataElement$validateDatepickerReference,
				dataByUuid,
				inner.state,
				$author$project$StudioApp$Error$InPage(pageName)));
		var labelError = A2(
			$author$project$DataElement$Expression$applyGlobalString,
			A2(
				$author$project$DataElement$validateGlobalTransformer,
				dataByUuid,
				$author$project$StudioApp$Error$InPage(pageName)),
			inner.label);
		return _Utils_ap(referenceError, labelError);
	});
var $author$project$UserAction$validateNavigationDataTypesAndRefs = F2(
	function (validateExpr, navAction) {
		switch (navAction.$) {
			case 'EditRecord':
				var info = navAction.a;
				return validateExpr(info);
			case 'ViewRecord':
				var info = navAction.a;
				return validateExpr(info);
			default:
				return _List_Nil;
		}
	});
var $author$project$UserAction$validateDataTypesAndRefs = F2(
	function (validateExpr, actions) {
		return A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				$author$project$UserAction$validateNavigationDataTypesAndRefs(validateExpr),
				actions.navigation));
	});
var $author$project$DisplayElement$FieldList$validateLabelValuePair = F3(
	function (dataByRef, pageName, _v0) {
		var label = _v0.label;
		var value = _v0.value;
		var valueAction = _v0.valueAction;
		return _Utils_ap(
			A2(
				$author$project$DataElement$Expression$applyGlobalString,
				A2(
					$author$project$DataElement$validateGlobalTransformer,
					dataByRef,
					$author$project$StudioApp$Error$InPage(pageName)),
				label),
			_Utils_ap(
				A2(
					$author$project$DataElement$Expression$applyGlobalString,
					A2(
						$author$project$DataElement$validateGlobalTransformer,
						dataByRef,
						$author$project$StudioApp$Error$InPage(pageName)),
					value),
				A2(
					$author$project$UserAction$validateDataTypesAndRefs,
					$author$project$DataElement$Expression$applyGlobalString(
						A2(
							$author$project$DataElement$validateGlobalTransformer,
							dataByRef,
							$author$project$StudioApp$Error$InPage(pageName))),
					valueAction)));
	});
var $author$project$DisplayElement$FieldList$validateDataTypesAndRefs = F3(
	function (dataByRef, pageName, _v0) {
		var inner = _v0.a;
		return A2(
			$elm$core$List$concatMap,
			A2($author$project$DisplayElement$FieldList$validateLabelValuePair, dataByRef, pageName),
			inner.labelValuePairs);
	});
var $author$project$DisplayElement$MetricHighlight$validateMetricValue = F3(
	function (dataByRef, pageName, metricValue) {
		switch (metricValue.$) {
			case 'StringValue':
				var globalString = metricValue.a;
				return A2(
					$author$project$DataElement$Expression$applyGlobalString,
					A2(
						$author$project$DataElement$validateGlobalTransformer,
						dataByRef,
						$author$project$StudioApp$Error$InPage(pageName)),
					globalString);
			case 'NumberValue':
				var globalNumber = metricValue.a;
				return A2(
					$author$project$DataElement$Expression$applyGlobalNumber,
					A2(
						$author$project$DataElement$validateGlobalTransformer,
						dataByRef,
						$author$project$StudioApp$Error$InPage(pageName)),
					globalNumber);
			case 'DateValue':
				var globalDate = metricValue.a;
				var formatExpression = metricValue.b;
				return _Utils_ap(
					A2(
						$author$project$DataElement$Expression$applyGlobalDate,
						A2(
							$author$project$DataElement$validateGlobalTransformer,
							dataByRef,
							$author$project$StudioApp$Error$InPage(pageName)),
						globalDate),
					A2(
						$author$project$DataElement$Expression$applyGlobalString,
						A2(
							$author$project$DataElement$validateGlobalTransformer,
							dataByRef,
							$author$project$StudioApp$Error$InPage(pageName)),
						formatExpression));
			default:
				var globalBool = metricValue.a;
				return A2(
					$author$project$DataElement$Expression$applyGlobalBool,
					A2(
						$author$project$DataElement$validateGlobalTransformer,
						dataByRef,
						$author$project$StudioApp$Error$InPage(pageName)),
					globalBool);
		}
	});
var $author$project$DisplayElement$MetricHighlight$validateLabelValuePair = F3(
	function (dataByRef, pageName, _v0) {
		var label = _v0.label;
		var value = _v0.value;
		var action = _v0.action;
		return _Utils_ap(
			A2(
				$author$project$DataElement$Expression$applyGlobalString,
				A2(
					$author$project$DataElement$validateGlobalTransformer,
					dataByRef,
					$author$project$StudioApp$Error$InPage(pageName)),
				label),
			_Utils_ap(
				A3($author$project$DisplayElement$MetricHighlight$validateMetricValue, dataByRef, pageName, value),
				A2(
					$author$project$UserAction$validateDataTypesAndRefs,
					$author$project$DataElement$Expression$applyGlobalString(
						A2(
							$author$project$DataElement$validateGlobalTransformer,
							dataByRef,
							$author$project$StudioApp$Error$InPage(pageName))),
					action)));
	});
var $author$project$DisplayElement$MetricHighlight$validateDataTypesAndRefs = F3(
	function (dataByRef, pageName, _v0) {
		var inner = _v0.a;
		return _Utils_ap(
			A3($author$project$DisplayElement$MetricHighlight$validateLabelValuePair, dataByRef, pageName, inner.first),
			A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					$elm$core$Maybe$map,
					A2($author$project$DisplayElement$MetricHighlight$validateLabelValuePair, dataByRef, pageName),
					inner.second)));
	});
var $author$project$DisplayElement$ProgressChart$validateDataTypesAndRefs = F3(
	function (dataByRef, pageName, _v0) {
		var info = _v0.a;
		return _Utils_ap(
			A2(
				$author$project$DataElement$Expression$applyGlobalNumber,
				A2(
					$author$project$DataElement$validateGlobalTransformer,
					dataByRef,
					$author$project$StudioApp$Error$InPage(pageName)),
				info.value),
			A2(
				$author$project$DataElement$Expression$applyGlobalNumber,
				A2(
					$author$project$DataElement$validateGlobalTransformer,
					dataByRef,
					$author$project$StudioApp$Error$InPage(pageName)),
				info.goal));
	});
var $author$project$DisplayElement$Section$validateDataTypesAndRefs = F3(
	function (dataByRef, pageName, info) {
		if (info.$ === 'SectionWithoutHeader') {
			return _List_Nil;
		} else {
			var header = info.a;
			return _Utils_ap(
				A2(
					$author$project$DataElement$Expression$applyGlobalString,
					A2(
						$author$project$DataElement$validateGlobalTransformer,
						dataByRef,
						$author$project$StudioApp$Error$InPage(pageName)),
					header.title),
				A2(
					$author$project$UserAction$validateDataTypesAndRefs,
					$author$project$DataElement$Expression$applyGlobalString(
						A2(
							$author$project$DataElement$validateGlobalTransformer,
							dataByRef,
							$author$project$StudioApp$Error$InPage(pageName))),
					header.action));
		}
	});
var $author$project$StudioApp$Error$DropdownReferenceNotFound = F2(
	function (a, b) {
		return {$: 'DropdownReferenceNotFound', a: a, b: b};
	});
var $author$project$StudioApp$Error$InvalidDropdownReference = F2(
	function (a, b) {
		return {$: 'InvalidDropdownReference', a: a, b: b};
	});
var $author$project$DataElement$validateDropdownReference = F3(
	function (elementCollection, ref, context) {
		var _v0 = A2(
			$elm$core$Maybe$map,
			$author$project$DataElement$unwrapElement,
			A2($author$project$DataElement$getDataElementFromReferenceElement, elementCollection, ref));
		if (_v0.$ === 'Just') {
			if ((_v0.a.$ === 'Singleton') && (_v0.a.a.$ === 'InteractiveSelectSelection')) {
				return $elm$core$Maybe$Nothing;
			} else {
				return $elm$core$Maybe$Just(
					A2($author$project$StudioApp$Error$InvalidDropdownReference, context, ref));
			}
		} else {
			return $elm$core$Maybe$Just(
				A2($author$project$StudioApp$Error$DropdownReferenceNotFound, context, ref));
		}
	});
var $author$project$DisplayElement$Select$validateDataTypesAndRefs = F3(
	function (dataByRef, pageName, inner) {
		var referenceError = $elm_community$maybe_extra$Maybe$Extra$toList(
			A3(
				$author$project$DataElement$validateDropdownReference,
				dataByRef,
				inner.state,
				$author$project$StudioApp$Error$InPage(pageName)));
		var labelError = A2(
			$author$project$DataElement$Expression$applyGlobalString,
			A2(
				$author$project$DataElement$validateGlobalTransformer,
				dataByRef,
				$author$project$StudioApp$Error$InPage(pageName)),
			inner.label);
		return _Utils_ap(referenceError, labelError);
	});
var $author$project$DisplayElement$Table$validateDataTypesAndRefsForColumn = F4(
	function (dataByRef, pageName, listRef, column) {
		switch (column.$) {
			case 'StringColumn':
				var header = column.a.header;
				var value = column.a.value;
				var valueAction = column.a.valueAction;
				return _Utils_ap(
					A2(
						$author$project$DataElement$Expression$applyGlobalString,
						A2(
							$author$project$DataElement$validateGlobalTransformer,
							dataByRef,
							$author$project$StudioApp$Error$InPage(pageName)),
						header),
					_Utils_ap(
						A2(
							$author$project$DataElement$Expression$applyLocalString,
							A3(
								$author$project$DataElement$validateLocalTransformer,
								dataByRef,
								$author$project$StudioApp$Error$InPage(pageName),
								listRef),
							$author$project$DataElement$Expression$LocalString(value)),
						A2(
							$author$project$UserAction$validateDataTypesAndRefs,
							$author$project$DataElement$Expression$applyLocalString(
								A3(
									$author$project$DataElement$validateLocalTransformer,
									dataByRef,
									$author$project$StudioApp$Error$InPage(pageName),
									listRef)),
							valueAction)));
			case 'NumberColumn':
				var header = column.a.header;
				var value = column.a.value;
				var valueAction = column.a.valueAction;
				return _Utils_ap(
					A2(
						$author$project$DataElement$Expression$applyGlobalString,
						A2(
							$author$project$DataElement$validateGlobalTransformer,
							dataByRef,
							$author$project$StudioApp$Error$InPage(pageName)),
						header),
					_Utils_ap(
						A2(
							$author$project$DataElement$Expression$applyLocalNumber,
							A3(
								$author$project$DataElement$validateLocalTransformer,
								dataByRef,
								$author$project$StudioApp$Error$InPage(pageName),
								listRef),
							$author$project$DataElement$Expression$LocalNumber(value)),
						A2(
							$author$project$UserAction$validateDataTypesAndRefs,
							$author$project$DataElement$Expression$applyLocalString(
								A3(
									$author$project$DataElement$validateLocalTransformer,
									dataByRef,
									$author$project$StudioApp$Error$InPage(pageName),
									listRef)),
							valueAction)));
			case 'DateColumn':
				var header = column.a.header;
				var value = column.a.value;
				var valueAction = column.a.valueAction;
				return _Utils_ap(
					A2(
						$author$project$DataElement$Expression$applyGlobalString,
						A2(
							$author$project$DataElement$validateGlobalTransformer,
							dataByRef,
							$author$project$StudioApp$Error$InPage(pageName)),
						header),
					_Utils_ap(
						A2(
							$author$project$DataElement$Expression$applyLocalDate,
							A3(
								$author$project$DataElement$validateLocalTransformer,
								dataByRef,
								$author$project$StudioApp$Error$InPage(pageName),
								listRef),
							$author$project$DataElement$Expression$LocalDate(value)),
						A2(
							$author$project$UserAction$validateDataTypesAndRefs,
							$author$project$DataElement$Expression$applyLocalString(
								A3(
									$author$project$DataElement$validateLocalTransformer,
									dataByRef,
									$author$project$StudioApp$Error$InPage(pageName),
									listRef)),
							valueAction)));
			case 'DateTimeColumn':
				var header = column.a.header;
				var value = column.a.value;
				var valueAction = column.a.valueAction;
				return _Utils_ap(
					A2(
						$author$project$DataElement$Expression$applyGlobalString,
						A2(
							$author$project$DataElement$validateGlobalTransformer,
							dataByRef,
							$author$project$StudioApp$Error$InPage(pageName)),
						header),
					_Utils_ap(
						A2(
							$author$project$DataElement$Expression$applyLocalDateTime,
							A3(
								$author$project$DataElement$validateLocalTransformer,
								dataByRef,
								$author$project$StudioApp$Error$InPage(pageName),
								listRef),
							$author$project$DataElement$Expression$LocalDateTime(value)),
						A2(
							$author$project$UserAction$validateDataTypesAndRefs,
							$author$project$DataElement$Expression$applyLocalString(
								A3(
									$author$project$DataElement$validateLocalTransformer,
									dataByRef,
									$author$project$StudioApp$Error$InPage(pageName),
									listRef)),
							valueAction)));
			default:
				var header = column.a.header;
				var value = column.a.value;
				var valueAction = column.a.valueAction;
				return _Utils_ap(
					A2(
						$author$project$DataElement$Expression$applyGlobalString,
						A2(
							$author$project$DataElement$validateGlobalTransformer,
							dataByRef,
							$author$project$StudioApp$Error$InPage(pageName)),
						header),
					_Utils_ap(
						A2(
							$author$project$DataElement$Expression$applyLocalBool,
							A3(
								$author$project$DataElement$validateLocalTransformer,
								dataByRef,
								$author$project$StudioApp$Error$InPage(pageName),
								listRef),
							$author$project$DataElement$Expression$LocalBool(value)),
						A2(
							$author$project$UserAction$validateDataTypesAndRefs,
							$author$project$DataElement$Expression$applyLocalString(
								A3(
									$author$project$DataElement$validateLocalTransformer,
									dataByRef,
									$author$project$StudioApp$Error$InPage(pageName),
									listRef)),
							valueAction)));
		}
	});
var $author$project$DisplayElement$Table$validateDataTypesAndRefs = F3(
	function (dataByRef, pageName, _v0) {
		var info = _v0.a;
		var referenceError = $elm_community$maybe_extra$Maybe$Extra$toList(
			A3(
				$author$project$DataElement$validateRecordListReference,
				dataByRef,
				info.dataElement,
				$author$project$StudioApp$Error$InPage(pageName)));
		return _Utils_ap(
			referenceError,
			A2(
				$elm$core$List$concatMap,
				A3($author$project$DisplayElement$Table$validateDataTypesAndRefsForColumn, dataByRef, pageName, info.dataElement),
				info.columns));
	});
var $author$project$DisplayElement$TrendChart$validateDataTypesAndRefs = F3(
	function (dataByRef, pageName, _v0) {
		var inner = _v0.a;
		return _Utils_ap(
			A2(
				$author$project$DataElement$Expression$applyLocalDate,
				A3(
					$author$project$DataElement$validateLocalTransformer,
					dataByRef,
					$author$project$StudioApp$Error$InPage(pageName),
					inner.dataSource),
				inner.date),
			_Utils_ap(
				A2(
					$author$project$DataElement$Expression$applyLocalNumber,
					A3(
						$author$project$DataElement$validateLocalTransformer,
						dataByRef,
						$author$project$StudioApp$Error$InPage(pageName),
						inner.dataSource),
					inner.value),
				A2(
					$author$project$DataElement$Expression$applyLocalString,
					A3(
						$author$project$DataElement$validateLocalTransformer,
						dataByRef,
						$author$project$StudioApp$Error$InPage(pageName),
						inner.dataSource),
					inner.series)));
	});
var $author$project$DisplayElement$validateDataTypesAndRefs = F4(
	function (manifests, dataByUuid, pageName, element) {
		switch (element.$) {
			case 'Column':
				var children = element.a;
				return A2(
					$elm$core$List$concatMap,
					A3($author$project$DisplayElement$validateDataTypesAndRefs, manifests, dataByUuid, pageName),
					children);
			case 'Row':
				var children = element.b;
				return A2(
					$elm$core$List$concatMap,
					A3($author$project$DisplayElement$validateDataTypesAndRefs, manifests, dataByUuid, pageName),
					children);
			case 'Section':
				var sectionInfo = element.a;
				var maybeBody = element.b;
				return _Utils_ap(
					A3($author$project$DisplayElement$Section$validateDataTypesAndRefs, dataByUuid, pageName, sectionInfo),
					A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2(
							$elm$core$Maybe$map,
							A3($author$project$DisplayElement$validateDataTypesAndRefs, manifests, dataByUuid, pageName),
							maybeBody)));
			case 'Table':
				var tableInfo = element.a;
				return A3($author$project$DisplayElement$Table$validateDataTypesAndRefs, dataByUuid, pageName, tableInfo);
			case 'ProgressChart':
				var progressInfo = element.a;
				return A3($author$project$DisplayElement$ProgressChart$validateDataTypesAndRefs, dataByUuid, pageName, progressInfo);
			case 'TrendChart':
				var trendInfo = element.a;
				return A3($author$project$DisplayElement$TrendChart$validateDataTypesAndRefs, dataByUuid, pageName, trendInfo);
			case 'FieldList':
				var fieldListInfo = element.a;
				return A3($author$project$DisplayElement$FieldList$validateDataTypesAndRefs, dataByUuid, pageName, fieldListInfo);
			case 'MetricHighlight':
				var metricHighlightInfo = element.a;
				return A3($author$project$DisplayElement$MetricHighlight$validateDataTypesAndRefs, dataByUuid, pageName, metricHighlightInfo);
			case 'Custom':
				var customInfo = element.a;
				return A4($author$project$DisplayElement$Custom$validateDataTypesAndRefs, manifests, dataByUuid, pageName, customInfo);
			case 'Select':
				var selectInfo = element.a;
				return A3($author$project$DisplayElement$Select$validateDataTypesAndRefs, dataByUuid, pageName, selectInfo);
			default:
				var info = element.a;
				return A3($author$project$DisplayElement$Datepicker$validateDataTypesAndRefs, dataByUuid, pageName, info);
		}
	});
var $author$project$Page$validateDataTypesAndRefs = F3(
	function (manifests, dataByRef, _v0) {
		var pageName = _v0.a;
		var displayElement = _v0.b;
		return A4($author$project$DisplayElement$validateDataTypesAndRefs, manifests, dataByRef, pageName, displayElement);
	});
var $author$project$StudioApp$validateDataTypesAndRefsInDisplayElements = F2(
	function (manifests, innerApp) {
		return A2(
			$elm$core$List$concatMap,
			A2($author$project$Page$validateDataTypesAndRefs, manifests, innerApp.dataElements),
			$mgold$elm_nonempty_list$List$Nonempty$toList(innerApp.pages));
	});
var $author$project$DataElement$validateDataEngineWhereClauseDataTypes = F3(
	function (elementsByName, elementName, whereClause) {
		switch (whereClause.$) {
			case 'AllOf':
				var wheres = whereClause.a;
				return A2(
					$elm$core$List$concatMap,
					A2($author$project$DataElement$validateDataEngineWhereClauseDataTypes, elementsByName, elementName),
					wheres);
			case 'AnyOf':
				var wheres = whereClause.a;
				return A2(
					$elm$core$List$concatMap,
					A2($author$project$DataElement$validateDataEngineWhereClauseDataTypes, elementsByName, elementName),
					wheres);
			case 'Eq':
				var fieldName = whereClause.a;
				var globalField = whereClause.b;
				return A2(
					$author$project$DataElement$Expression$applyGlobalField,
					A2(
						$author$project$DataElement$validateGlobalTransformer,
						elementsByName,
						$author$project$StudioApp$Error$InDataElement(
							$author$project$FieldName$toString(fieldName))),
					globalField);
			case 'NotEq':
				var fieldName = whereClause.a;
				var globalField = whereClause.b;
				return A2(
					$author$project$DataElement$Expression$applyGlobalField,
					A2(
						$author$project$DataElement$validateGlobalTransformer,
						elementsByName,
						$author$project$StudioApp$Error$InDataElement(
							$author$project$FieldName$toString(fieldName))),
					globalField);
			case 'Gt':
				var fieldName = whereClause.a;
				var globalComparable = whereClause.b;
				return A2(
					$author$project$DataElement$Expression$applyGlobalComparable,
					A2(
						$author$project$DataElement$validateGlobalTransformer,
						elementsByName,
						$author$project$StudioApp$Error$InDataElement(
							$author$project$FieldName$toString(fieldName))),
					globalComparable);
			case 'Gte':
				var fieldName = whereClause.a;
				var globalComparable = whereClause.b;
				return A2(
					$author$project$DataElement$Expression$applyGlobalComparable,
					A2(
						$author$project$DataElement$validateGlobalTransformer,
						elementsByName,
						$author$project$StudioApp$Error$InDataElement(
							$author$project$FieldName$toString(fieldName))),
					globalComparable);
			case 'Lt':
				var fieldName = whereClause.a;
				var globalComparable = whereClause.b;
				return A2(
					$author$project$DataElement$Expression$applyGlobalComparable,
					A2(
						$author$project$DataElement$validateGlobalTransformer,
						elementsByName,
						$author$project$StudioApp$Error$InDataElement(
							$author$project$FieldName$toString(fieldName))),
					globalComparable);
			case 'Lte':
				var fieldName = whereClause.a;
				var globalComparable = whereClause.b;
				return A2(
					$author$project$DataElement$Expression$applyGlobalComparable,
					A2(
						$author$project$DataElement$validateGlobalTransformer,
						elementsByName,
						$author$project$StudioApp$Error$InDataElement(
							$author$project$FieldName$toString(fieldName))),
					globalComparable);
			case 'In':
				var fieldName = whereClause.a;
				var globalStringList = whereClause.b;
				return A2(
					$author$project$DataElement$Expression$applyGlobalStringList,
					A2(
						$author$project$DataElement$validateGlobalTransformer,
						elementsByName,
						$author$project$StudioApp$Error$InDataElement(
							$author$project$FieldName$toString(fieldName))),
					globalStringList);
			case 'BetweenString':
				var fieldName = whereClause.a;
				var globalStringStart = whereClause.b;
				var globalStringEnd = whereClause.c;
				return A2(
					$elm$core$List$concatMap,
					$author$project$DataElement$Expression$applyGlobalString(
						A2(
							$author$project$DataElement$validateGlobalTransformer,
							elementsByName,
							$author$project$StudioApp$Error$InDataElement(
								$author$project$FieldName$toString(fieldName)))),
					_List_fromArray(
						[globalStringStart, globalStringEnd]));
			case 'BetweenDate':
				var fieldName = whereClause.a;
				var globalDateStart = whereClause.b;
				var globalDateEnd = whereClause.c;
				return A2(
					$elm$core$List$concatMap,
					$author$project$DataElement$Expression$applyGlobalDate(
						A2(
							$author$project$DataElement$validateGlobalTransformer,
							elementsByName,
							$author$project$StudioApp$Error$InDataElement(
								$author$project$FieldName$toString(fieldName)))),
					_List_fromArray(
						[globalDateStart, globalDateEnd]));
			case 'BetweenDateTime':
				var fieldName = whereClause.a;
				var globalDateTimeStart = whereClause.b;
				var globalDateTimeEnd = whereClause.c;
				return A2(
					$elm$core$List$concatMap,
					$author$project$DataElement$Expression$applyGlobalDateTime(
						A2(
							$author$project$DataElement$validateGlobalTransformer,
							elementsByName,
							$author$project$StudioApp$Error$InDataElement(
								$author$project$FieldName$toString(fieldName)))),
					_List_fromArray(
						[globalDateTimeStart, globalDateTimeEnd]));
			case 'BetweenNumber':
				var fieldName = whereClause.a;
				var globalNumberStart = whereClause.b;
				var globalNumberEnd = whereClause.c;
				return A2(
					$elm$core$List$concatMap,
					$author$project$DataElement$Expression$applyGlobalNumber(
						A2(
							$author$project$DataElement$validateGlobalTransformer,
							elementsByName,
							$author$project$StudioApp$Error$InDataElement(
								$author$project$FieldName$toString(fieldName)))),
					_List_fromArray(
						[globalNumberStart, globalNumberEnd]));
			case 'IsNull':
				return _List_Nil;
			default:
				return _List_Nil;
		}
	});
var $author$project$DataElement$MergeList$getReferences = function (_v0) {
	var matrix = _v0.a;
	return A2(
		$elm$core$List$map,
		function (listElem) {
			return listElem.a;
		},
		matrix);
};
var $author$project$DataElement$validateMergeListDataElements = F3(
	function (allElements, info, context) {
		return A2(
			$elm$core$List$filterMap,
			function (ref) {
				return A3($author$project$DataElement$validateRecordListReference, allElements, ref, context);
			},
			$author$project$DataElement$MergeList$getReferences(info));
	});
var $author$project$StudioApp$Error$CannotDetermineFieldType = F2(
	function (a, b) {
		return {$: 'CannotDetermineFieldType', a: a, b: b};
	});
var $author$project$DataElement$validateMergeListFields = F3(
	function (allElements, info, context) {
		var helper = F2(
			function (maybeType, fieldName) {
				if (maybeType.$ === 'Just') {
					return $elm$core$Maybe$Nothing;
				} else {
					return $elm$core$Maybe$Just(
						A2(
							$author$project$StudioApp$Error$CannotDetermineFieldType,
							context,
							$author$project$FieldName$toString(fieldName)));
				}
			});
		return A2(
			$elm$core$List$filterMap,
			function (fieldName) {
				return A2(
					helper,
					A3($author$project$DataElement$getMergeListFieldTypeByRefAndName, info, allElements, fieldName),
					fieldName);
			},
			$pzp1997$assoc_list$AssocList$keys(
				$author$project$DataElement$MergeList$fields(info)));
	});
var $author$project$FieldValue$toFieldType = function (val) {
	switch (val.$) {
		case 'StringValue':
			return $author$project$FieldType$StringType;
		case 'NumberValue':
			return $author$project$FieldType$NumberType;
		case 'DateValue':
			return $author$project$FieldType$DateType;
		case 'DateTimeValue':
			return $author$project$FieldType$DateTimeType;
		default:
			return $author$project$FieldType$BoolType;
	}
};
var $author$project$DataElement$validateQueryFieldDataTypes = F2(
	function (elementName, _v0) {
		var fieldName = _v0.a;
		var fieldInfo = _v0.b;
		return A2(
			$elm$core$Maybe$andThen,
			function (_default) {
				return (!_Utils_eq(
					$author$project$FieldValue$toFieldType(_default),
					fieldInfo.fieldType)) ? $elm$core$Maybe$Just(
					A4(
						$author$project$StudioApp$Error$WrongTypeError,
						$author$project$StudioApp$Error$InDataElement(elementName),
						$author$project$FieldName$toString(fieldName),
						fieldInfo.fieldType,
						$author$project$FieldValue$toFieldType(_default))) : $elm$core$Maybe$Nothing;
			},
			fieldInfo._default);
	});
var $author$project$DataElement$validateWhereClauseDataTypes = F3(
	function (elementsByName, elementName, whereClause) {
		switch (whereClause.$) {
			case 'WhereAnd':
				var subClauses = whereClause.a;
				return A2(
					$elm$core$List$concatMap,
					A2($author$project$DataElement$validateWhereClauseDataTypes, elementsByName, elementName),
					subClauses);
			case 'WhereOr':
				var subClauses = whereClause.a;
				return A2(
					$elm$core$List$concatMap,
					A2($author$project$DataElement$validateWhereClauseDataTypes, elementsByName, elementName),
					subClauses);
			default:
				switch (whereClause.a.$) {
					case 'WhereIn':
						var _v1 = whereClause.a;
						var globalStringListExpr = _v1.b;
						return A2(
							$author$project$DataElement$Expression$applyGlobalStringList,
							A2(
								$author$project$DataElement$validateGlobalTransformer,
								elementsByName,
								$author$project$StudioApp$Error$InDataElement(elementName)),
							globalStringListExpr);
					case 'WhereEqual':
						var _v2 = whereClause.a;
						var globalFieldExpr = _v2.b;
						return A2(
							$author$project$DataElement$Expression$applyGlobalField,
							A2(
								$author$project$DataElement$validateGlobalTransformer,
								elementsByName,
								$author$project$StudioApp$Error$InDataElement(elementName)),
							globalFieldExpr);
					case 'WhereNotEqual':
						var _v3 = whereClause.a;
						var globalFieldExpr = _v3.b;
						return A2(
							$author$project$DataElement$Expression$applyGlobalField,
							A2(
								$author$project$DataElement$validateGlobalTransformer,
								elementsByName,
								$author$project$StudioApp$Error$InDataElement(elementName)),
							globalFieldExpr);
					case 'WhereGT':
						var _v4 = whereClause.a;
						var globalCompExpr = _v4.b;
						return A2(
							$author$project$DataElement$Expression$applyGlobalComparable,
							A2(
								$author$project$DataElement$validateGlobalTransformer,
								elementsByName,
								$author$project$StudioApp$Error$InDataElement(elementName)),
							globalCompExpr);
					case 'WhereGTE':
						var _v5 = whereClause.a;
						var globalCompExpr = _v5.b;
						return A2(
							$author$project$DataElement$Expression$applyGlobalComparable,
							A2(
								$author$project$DataElement$validateGlobalTransformer,
								elementsByName,
								$author$project$StudioApp$Error$InDataElement(elementName)),
							globalCompExpr);
					case 'WhereLT':
						var _v6 = whereClause.a;
						var globalCompExpr = _v6.b;
						return A2(
							$author$project$DataElement$Expression$applyGlobalComparable,
							A2(
								$author$project$DataElement$validateGlobalTransformer,
								elementsByName,
								$author$project$StudioApp$Error$InDataElement(elementName)),
							globalCompExpr);
					default:
						var _v7 = whereClause.a;
						var globalCompExpr = _v7.b;
						return A2(
							$author$project$DataElement$Expression$applyGlobalComparable,
							A2(
								$author$project$DataElement$validateGlobalTransformer,
								elementsByName,
								$author$project$StudioApp$Error$InDataElement(elementName)),
							globalCompExpr);
				}
		}
	});
var $author$project$DataElement$validateDataElementDataTypes = F2(
	function (allElements, _v0) {
		var elementName = _v0.a;
		var element = _v0.b;
		if (element.$ === 'RecordList') {
			switch (element.a.$) {
				case 'CrmQuery':
					var whereClause = element.a.a.whereClause;
					var fields = element.a.a.fields;
					return _Utils_ap(
						A2(
							$elm$core$Maybe$withDefault,
							_List_Nil,
							A2(
								$elm$core$Maybe$map,
								A2($author$project$DataElement$validateWhereClauseDataTypes, allElements, elementName),
								whereClause)),
						A2(
							$elm$core$List$filterMap,
							$author$project$DataElement$validateQueryFieldDataTypes(elementName),
							$pzp1997$assoc_list$AssocList$toList(fields)));
				case 'SalesQuery':
					var accountIds = element.a.a.accountIds;
					var startDate = element.a.a.startDate;
					var endDate = element.a.a.endDate;
					return _Utils_ap(
						A2(
							$author$project$DataElement$Expression$applyGlobalStringList,
							A2(
								$author$project$DataElement$validateGlobalTransformer,
								allElements,
								$author$project$StudioApp$Error$InDataElement(elementName)),
							accountIds),
						_Utils_ap(
							A2(
								$elm$core$Maybe$withDefault,
								_List_Nil,
								A2(
									$elm$core$Maybe$map,
									$author$project$DataElement$Expression$applyGlobalDate(
										A2(
											$author$project$DataElement$validateGlobalTransformer,
											allElements,
											$author$project$StudioApp$Error$InDataElement(elementName))),
									startDate)),
							A2(
								$elm$core$Maybe$withDefault,
								_List_Nil,
								A2(
									$elm$core$Maybe$map,
									$author$project$DataElement$Expression$applyGlobalDate(
										A2(
											$author$project$DataElement$validateGlobalTransformer,
											allElements,
											$author$project$StudioApp$Error$InDataElement(elementName))),
									endDate))));
				case 'NitroQuery':
					var whereClause = element.a.a.whereClause;
					var fields = element.a.a.fields;
					return _Utils_ap(
						A2(
							$elm$core$Maybe$withDefault,
							_List_Nil,
							A2(
								$elm$core$Maybe$map,
								A2($author$project$DataElement$validateWhereClauseDataTypes, allElements, elementName),
								whereClause)),
						A2(
							$elm$core$List$filterMap,
							$author$project$DataElement$validateQueryFieldDataTypes(elementName),
							$pzp1997$assoc_list$AssocList$toList(fields)));
				case 'CrmDataEngineQuery':
					var info = element.a.a;
					return A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2(
							$elm$core$Maybe$map,
							A2($author$project$DataElement$validateDataEngineWhereClauseDataTypes, allElements, elementName),
							info.whereClause));
				case 'CalcOneForOne':
					var oneForOne = element.a.a;
					var refError = A3(
						$author$project$DataElement$validateRecordListReference,
						allElements,
						oneForOne.original,
						$author$project$StudioApp$Error$InDataElement(elementName));
					var fieldErrors = A2(
						$elm$core$List$concatMap,
						$author$project$DataElement$Expression$applyLocalField(
							A3(
								$author$project$DataElement$validateLocalTransformer,
								allElements,
								$author$project$StudioApp$Error$InDataElement(elementName),
								oneForOne.original)),
						$pzp1997$assoc_list$AssocList$values(oneForOne.fields));
					return _Utils_ap(
						$elm_community$maybe_extra$Maybe$Extra$toList(refError),
						fieldErrors);
				case 'CalcSortList':
					var info = element.a.a;
					var sortErrors = A2(
						$elm$core$List$concatMap,
						$author$project$DataElement$Expression$applyLocalComparable(
							A3(
								$author$project$DataElement$validateLocalTransformer,
								allElements,
								$author$project$StudioApp$Error$InDataElement(elementName),
								info.original)),
						A2(
							$elm$core$List$map,
							function ($) {
								return $.expression;
							},
							$mgold$elm_nonempty_list$List$Nonempty$toList(info.sortBy)));
					var refError = A3(
						$author$project$DataElement$validateRecordListReference,
						allElements,
						info.original,
						$author$project$StudioApp$Error$InDataElement(elementName));
					return _Utils_ap(
						$elm_community$maybe_extra$Maybe$Extra$toList(refError),
						sortErrors);
				case 'CalcFilterList':
					var info = element.a.a;
					var refError = A3(
						$author$project$DataElement$validateRecordListReference,
						allElements,
						info.original,
						$author$project$StudioApp$Error$InDataElement(elementName));
					var filterErrors = A2(
						$author$project$DataElement$Expression$applyLocalBool,
						A3(
							$author$project$DataElement$validateLocalTransformer,
							allElements,
							$author$project$StudioApp$Error$InDataElement(elementName),
							info.original),
						info.filter);
					return _Utils_ap(
						$elm_community$maybe_extra$Maybe$Extra$toList(refError),
						filterErrors);
				case 'CalcSublist':
					var info = element.a.a;
					return $elm_community$maybe_extra$Maybe$Extra$toList(
						A3(
							$author$project$DataElement$validateRecordListReference,
							allElements,
							info.original,
							$author$project$StudioApp$Error$InDataElement(elementName)));
				case 'CalcMergeList':
					var info = element.a.a;
					var refError = A3(
						$author$project$DataElement$validateMergeListDataElements,
						allElements,
						info,
						$author$project$StudioApp$Error$InDataElement(elementName));
					var fieldErrors = A3(
						$author$project$DataElement$validateMergeListFields,
						allElements,
						info,
						$author$project$StudioApp$Error$InDataElement(elementName));
					return _Utils_ap(refError, fieldErrors);
				case 'AlignedTerritories':
					return _List_Nil;
				case 'FeedbackChannelGoals':
					return _List_Nil;
				case 'FeedbackProductGoals':
					return _List_Nil;
				case 'FeedbackAccountData':
					return _List_Nil;
				case 'FeedbackAccountChannelGoals':
					return _List_Nil;
				case 'FeedbackAccountProductGoals':
					return _List_Nil;
				case 'FeedbackAccountProductMetrics':
					return _List_Nil;
				default:
					var _v2 = element.a;
					return _List_Nil;
			}
		} else {
			switch (element.a.$) {
				case 'FeedbackOverview':
					return _List_Nil;
				case 'ContextQuery':
					return _List_Nil;
				case 'LimitOneCrmQuery':
					var whereClause = element.a.a.whereClause;
					var fields = element.a.a.fields;
					return _Utils_ap(
						A2(
							$elm$core$Maybe$withDefault,
							_List_Nil,
							A2(
								$elm$core$Maybe$map,
								A2($author$project$DataElement$validateWhereClauseDataTypes, allElements, elementName),
								whereClause)),
						A2(
							$elm$core$List$filterMap,
							$author$project$DataElement$validateQueryFieldDataTypes(elementName),
							$pzp1997$assoc_list$AssocList$toList(fields)));
				case 'LimitOneSalesQuery':
					var accountIds = element.a.a.accountIds;
					var startDate = element.a.a.startDate;
					var endDate = element.a.a.endDate;
					return _Utils_ap(
						A2(
							$author$project$DataElement$Expression$applyGlobalStringList,
							A2(
								$author$project$DataElement$validateGlobalTransformer,
								allElements,
								$author$project$StudioApp$Error$InDataElement(elementName)),
							accountIds),
						_Utils_ap(
							A2(
								$elm$core$Maybe$withDefault,
								_List_Nil,
								A2(
									$elm$core$Maybe$map,
									$author$project$DataElement$Expression$applyGlobalDate(
										A2(
											$author$project$DataElement$validateGlobalTransformer,
											allElements,
											$author$project$StudioApp$Error$InDataElement(elementName))),
									startDate)),
							A2(
								$elm$core$Maybe$withDefault,
								_List_Nil,
								A2(
									$elm$core$Maybe$map,
									$author$project$DataElement$Expression$applyGlobalDate(
										A2(
											$author$project$DataElement$validateGlobalTransformer,
											allElements,
											$author$project$StudioApp$Error$InDataElement(elementName))),
									endDate))));
				case 'LimitOneNitroQuery':
					var whereClause = element.a.a.whereClause;
					var fields = element.a.a.fields;
					return _Utils_ap(
						A2(
							$elm$core$Maybe$withDefault,
							_List_Nil,
							A2(
								$elm$core$Maybe$map,
								A2($author$project$DataElement$validateWhereClauseDataTypes, allElements, elementName),
								whereClause)),
						A2(
							$elm$core$List$filterMap,
							$author$project$DataElement$validateQueryFieldDataTypes(elementName),
							$pzp1997$assoc_list$AssocList$toList(fields)));
				case 'LimitOneCrmDataEngineQuery':
					var info = element.a.a;
					return A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2(
							$elm$core$Maybe$map,
							A2($author$project$DataElement$validateDataEngineWhereClauseDataTypes, allElements, elementName),
							info.whereClause));
				case 'Today':
					var _v3 = element.a;
					return _List_Nil;
				case 'Now':
					var _v4 = element.a;
					return _List_Nil;
				case 'CalcSummarize':
					var fields = element.a.a.fields;
					return A2(
						$elm$core$List$concatMap,
						$author$project$DataElement$Expression$applyGlobalField(
							A2(
								$author$project$DataElement$validateGlobalTransformer,
								allElements,
								$author$project$StudioApp$Error$InDataElement(elementName))),
						$pzp1997$assoc_list$AssocList$values(fields));
				case 'ObjectTranslation':
					return _List_Nil;
				case 'FieldTranslation':
					return _List_Nil;
				case 'VeevaMessages':
					return _List_Nil;
				case 'DatepickerSelection':
					var _default = element.a.a._default;
					return A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2(
							$elm$core$Maybe$map,
							$author$project$DataElement$Expression$applyGlobalDate(
								A2(
									$author$project$DataElement$validateGlobalTransformer,
									allElements,
									$author$project$StudioApp$Error$InDataElement(elementName))),
							_default));
				default:
					var options = element.a.a.options;
					var placeholder = element.a.a.placeholder;
					var placeholderErrors = A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2(
							$elm$core$Maybe$map,
							$author$project$DataElement$Expression$applyGlobalString(
								A2(
									$author$project$DataElement$validateGlobalTransformer,
									allElements,
									$author$project$StudioApp$Error$InDataElement(elementName))),
							placeholder));
					var optionErrors = A2(
						$author$project$DataElement$Expression$applyGlobalStringList,
						A2(
							$author$project$DataElement$validateGlobalTransformer,
							allElements,
							$author$project$StudioApp$Error$InDataElement(elementName)),
						options);
					return _Utils_ap(optionErrors, placeholderErrors);
			}
		}
	});
var $author$project$StudioApp$validateDataTypesInDataElements = function (innerApp) {
	return A2(
		$elm$core$List$concatMap,
		$author$project$DataElement$validateDataElementDataTypes(innerApp.dataElements),
		$author$project$DataElement$getDataElements(innerApp.dataElements));
};
var $elm_community$list_extra$List$Extra$gatherEqualsBy = F2(
	function (extract, list) {
		return A2(
			$elm_community$list_extra$List$Extra$gatherWith,
			F2(
				function (a, b) {
					return _Utils_eq(
						extract(a),
						extract(b));
				}),
			list);
	});
var $author$project$StudioApp$Error$ManifestsConflict = F2(
	function (a, b) {
		return {$: 'ManifestsConflict', a: a, b: b};
	});
var $author$project$StudioApp$groupIsOk = function (_v0) {
	var first = _v0.a;
	var rest = _v0.b;
	return A2(
		$elm$core$List$all,
		$elm$core$Basics$eq(first),
		rest) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
		A2($author$project$StudioApp$Error$ManifestsConflict, first.widgetUuid, first.versionUuid));
};
var $author$project$StudioApp$validateManifestsUniqueness = function (manifests) {
	return A2(
		$elm$core$List$filterMap,
		$author$project$StudioApp$groupIsOk,
		A2($elm_community$list_extra$List$Extra$gatherEqualsBy, $author$project$StudioApp$manifestToUuidPair, manifests));
};
var $author$project$Page$safeTypeName = function (_v0) {
	var pageName = _v0.a;
	return $author$project$CodeGen$Helpers$toSafeTypeName(pageName);
};
var $author$project$Page$viewFunctionName = function (page) {
	return 'view' + $author$project$Page$safeTypeName(page);
};
var $author$project$Page$validateNames = function (pages) {
	return $elm$core$List$concat(
		_List_fromArray(
			[
				A3($author$project$Validation$Helpers$validateSimilarNames, $author$project$Page$safeTypeName, $author$project$StudioApp$Error$InDataElements, pages),
				A3($author$project$Validation$Helpers$validateSimilarNames, $author$project$Page$viewFunctionName, $author$project$StudioApp$Error$InDataElements, pages)
			]));
};
var $author$project$StudioApp$validatePageNames = function (innerApp) {
	return $author$project$Page$validateNames(
		$mgold$elm_nonempty_list$List$Nonempty$toList(innerApp.pages));
};
var $author$project$StudioApp$Error$TagNamesTooSimilar = {$: 'TagNamesTooSimilar'};
var $elm_community$list_extra$List$Extra$allDifferentBy = F2(
	function (f, list) {
		return _Utils_eq(
			$elm$core$List$length(list),
			$elm$core$List$length(
				A2($elm_community$list_extra$List$Extra$uniqueBy, f, list)));
	});
var $elm_community$list_extra$List$Extra$allDifferent = function (list) {
	return A2($elm_community$list_extra$List$Extra$allDifferentBy, $elm$core$Basics$identity, list);
};
var $author$project$View$Custom$toWrapperTagName = function (tagName) {
	return tagName + '-wrapper';
};
var $author$project$StudioApp$validateTagNames = function (manifests) {
	return $elm_community$list_extra$List$Extra$allDifferent(
		A2(
			$elm$core$List$concatMap,
			function (m) {
				return _List_fromArray(
					[
						m.tagName,
						$author$project$View$Custom$toWrapperTagName(m.tagName)
					]);
			},
			manifests)) ? _List_Nil : _List_fromArray(
		[$author$project$StudioApp$Error$TagNamesTooSimilar]);
};
var $author$project$StudioApp$validate = F2(
	function (manifests, _v0) {
		var innerApp = _v0.a;
		var usedManifests = A2($author$project$StudioApp$findUsedManifests, innerApp, manifests);
		var allErrors = _Utils_ap(
			A2(
				$elm$core$List$concatMap,
				function (validator) {
					return validator(innerApp);
				},
				_List_fromArray(
					[
						$author$project$StudioApp$validateDataElementNames,
						$author$project$StudioApp$validatePageNames,
						$author$project$StudioApp$validateDataGraphIsAcyclic,
						$author$project$StudioApp$validateAllDataElementsHaveFields,
						$author$project$StudioApp$validateDataTypesInDataElements,
						$author$project$StudioApp$validateDataTypesAndRefsInDisplayElements(manifests),
						$author$project$StudioApp$validateAtMostOneVeevaMessagesDataElement
					])),
			_Utils_ap(
				$author$project$StudioApp$validateManifestsUniqueness(manifests),
				$author$project$StudioApp$validateTagNames(usedManifests)));
		var _v1 = $mgold$elm_nonempty_list$List$Nonempty$fromList(allErrors);
		if (_v1.$ === 'Nothing') {
			return $elm$core$Result$Ok(
				$author$project$StudioApp$App(innerApp));
		} else {
			var errors = _v1.a;
			return $elm$core$Result$Err(errors);
		}
	});
var $author$project$DataEngine$processDataRequest = F3(
	function (ref, app, cache) {
		return A2(
			$elm$core$Result$map,
			function (validatedApp) {
				return A3($author$project$DataEngine$confirmDataElementAndFetchFromCache, validatedApp, cache, ref);
			},
			A2(
				$author$project$StudioApp$validate,
				$author$project$DataEngine$DataCache$getManifests(cache),
				A2($author$project$StudioApp$trimAppByDataElement, ref, app)));
	});
var $author$project$DataElement$AlignedTerritories$encode = F2(
	function (elementName, info) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'type',
					$elm$json$Json$Encode$string('DATA_EL_ALIGNED_TERRITORIES')),
					_Utils_Tuple2(
					'name',
					$elm$json$Json$Encode$string(elementName)),
					_Utils_Tuple2(
					'includeChildren',
					$elm$json$Json$Encode$bool(
						_Utils_eq(info.includeChildren, $author$project$MyInsights$IncludeChildTerritories)))
				]));
	});
var $author$project$DataElement$CallAttendees$encode = function (elementName) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'type',
				$elm$json$Json$Encode$string('DATA_EL_CALL_ATTENDEES')),
				_Utils_Tuple2(
				'name',
				$elm$json$Json$Encode$string(elementName))
			]));
};
var $author$project$FieldName$encode = function (_v0) {
	var name = _v0.a;
	return $elm$json$Json$Encode$string(name);
};
var $author$project$ComparableType$encode = function (fieldType) {
	return $elm$json$Json$Encode$string(
		$author$project$ComparableType$toString(fieldType));
};
var $author$project$FieldType$encode = function (fieldType) {
	return $elm$json$Json$Encode$string(
		$author$project$FieldType$toString(fieldType));
};
var $author$project$DataElement$Expression$encodeAddition = F2(
	function (innerValA, innerValB) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'type',
					$elm$json$Json$Encode$string('Add Number')),
					_Utils_Tuple2(
					'dataType',
					$author$project$FieldType$encode($author$project$FieldType$NumberType)),
					_Utils_Tuple2('expression1', innerValA),
					_Utils_Tuple2('expression2', innerValB)
				]));
	});
var $author$project$DataElement$Expression$encodeAll = function (innerVal) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'type',
				$elm$json$Json$Encode$string('All')),
				_Utils_Tuple2(
				'dataType',
				$author$project$FieldType$encode($author$project$FieldType$BoolType)),
				_Utils_Tuple2('expression', innerVal)
			]));
};
var $author$project$DataElement$Reference$encoder = function (_v0) {
	var uuid = _v0.a;
	return $danyx23$elm_uuid$Uuid$encode(uuid);
};
var $author$project$DataElement$Expression$encodeAllValuesInField = F3(
	function (fieldType, listRef, fieldName) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'type',
					$elm$json$Json$Encode$string('Field in List')),
					_Utils_Tuple2(
					'dataType',
					$author$project$FieldType$encode(fieldType)),
					_Utils_Tuple2(
					'dataElement',
					$author$project$DataElement$Reference$encoder(listRef)),
					_Utils_Tuple2(
					'field',
					$author$project$FieldName$encode(fieldName))
				]));
	});
var $author$project$DataElement$Expression$encodeAny = function (innerVal) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'type',
				$elm$json$Json$Encode$string('Any')),
				_Utils_Tuple2(
				'dataType',
				$author$project$FieldType$encode($author$project$FieldType$BoolType)),
				_Utils_Tuple2('expression', innerVal)
			]));
};
var $author$project$DataElement$Expression$encodeChallengeReasons = function (innerVal) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'type',
				$elm$json$Json$Encode$string('Challenge Reasons')),
				_Utils_Tuple2(
				'dataType',
				$author$project$FieldType$encode($author$project$FieldType$StringType)),
				_Utils_Tuple2('expression', innerVal)
			]));
};
var $author$project$DataElement$Expression$encodeCompare = F5(
	function (label, encodeInputType, inputType, innerA, innerB) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'type',
					$elm$json$Json$Encode$string(label)),
					_Utils_Tuple2(
					'dataType',
					$author$project$FieldType$encode($author$project$FieldType$BoolType)),
					_Utils_Tuple2('expression1', innerA),
					_Utils_Tuple2('expression2', innerB),
					_Utils_Tuple2(
					'inputDataType',
					encodeInputType(inputType))
				]));
	});
var $author$project$DataElement$Expression$encodeConcat = F2(
	function (joinVal, listVal) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'type',
					$elm$json$Json$Encode$string('Concat')),
					_Utils_Tuple2(
					'dataType',
					$author$project$FieldType$encode($author$project$FieldType$StringType)),
					_Utils_Tuple2('joinExpression', joinVal),
					_Utils_Tuple2('listExpression', listVal)
				]));
	});
var $author$project$DataElement$Expression$encodeCountUnique = function (innerVal) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'type',
				$elm$json$Json$Encode$string('Count Unique')),
				_Utils_Tuple2(
				'dataType',
				$author$project$FieldType$encode($author$project$FieldType$NumberType)),
				_Utils_Tuple2('expression', innerVal)
			]));
};
var $author$project$DateUnit$toString = function (interval) {
	switch (interval.$) {
		case 'Days':
			return 'Days';
		case 'Weeks':
			return 'Weeks';
		case 'Months':
			return 'Months';
		default:
			return 'Years';
	}
};
var $author$project$DateUnit$encode = function (interval) {
	return $elm$json$Json$Encode$string(
		$author$project$DateUnit$toString(interval));
};
var $author$project$DataElement$Expression$encodeDateAdd = F3(
	function (dateUnit, numVal, innerDateVal) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'type',
					$elm$json$Json$Encode$string('Date Addition')),
					_Utils_Tuple2(
					'dataType',
					$author$project$FieldType$encode($author$project$FieldType$DateType)),
					_Utils_Tuple2('expression1', innerDateVal),
					_Utils_Tuple2('expression2', numVal),
					_Utils_Tuple2(
					'dateUnit',
					$author$project$DateUnit$encode(dateUnit))
				]));
	});
var $author$project$DateInterval$encode = function (interval) {
	return $elm$json$Json$Encode$string(
		$author$project$DateInterval$toString(interval));
};
var $author$project$DataElement$Expression$encodeDateCeiling = F2(
	function (interval, innerVal) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'type',
					$elm$json$Json$Encode$string('Date Ceiling')),
					_Utils_Tuple2(
					'dataType',
					$author$project$FieldType$encode($author$project$FieldType$DateType)),
					_Utils_Tuple2('expression', innerVal),
					_Utils_Tuple2(
					'dateInterval',
					$author$project$DateInterval$encode(interval))
				]));
	});
var $author$project$DataElement$Expression$encodeDateFloor = F2(
	function (interval, innerVal) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'type',
					$elm$json$Json$Encode$string('Date Floor')),
					_Utils_Tuple2(
					'dataType',
					$author$project$FieldType$encode($author$project$FieldType$DateType)),
					_Utils_Tuple2('expression', innerVal),
					_Utils_Tuple2(
					'dateInterval',
					$author$project$DateInterval$encode(interval))
				]));
	});
var $author$project$DataElement$Expression$encodeDateSubtract = F3(
	function (dateUnit, numVal, innerDateVal) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'type',
					$elm$json$Json$Encode$string('Date Subtraction')),
					_Utils_Tuple2(
					'dataType',
					$author$project$FieldType$encode($author$project$FieldType$DateType)),
					_Utils_Tuple2('expression1', innerDateVal),
					_Utils_Tuple2('expression2', numVal),
					_Utils_Tuple2(
					'dateUnit',
					$author$project$DateUnit$encode(dateUnit))
				]));
	});
var $author$project$DataElement$Expression$encodeDateTimeToDate = function (innerVal) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'type',
				$elm$json$Json$Encode$string('Date/Time to Date')),
				_Utils_Tuple2(
				'dataType',
				$author$project$FieldType$encode($author$project$FieldType$DateType)),
				_Utils_Tuple2('dateTimeExpression', innerVal)
			]));
};
var $author$project$DataElement$Expression$encodeDayInMonth = function (innerVal) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'type',
				$elm$json$Json$Encode$string('Date Day in Month')),
				_Utils_Tuple2(
				'dataType',
				$author$project$FieldType$encode($author$project$FieldType$NumberType)),
				_Utils_Tuple2('expression', innerVal)
			]));
};
var $author$project$DataElement$Expression$encodeDivision = F2(
	function (innerValA, innerValB) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'type',
					$elm$json$Json$Encode$string('Divide Number')),
					_Utils_Tuple2(
					'dataType',
					$author$project$FieldType$encode($author$project$FieldType$NumberType)),
					_Utils_Tuple2('expression1', innerValA),
					_Utils_Tuple2('expression2', innerValB)
				]));
	});
var $author$project$DataElement$Expression$encodeFormatDate = F2(
	function (stringVal, dateVal) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'type',
					$elm$json$Json$Encode$string('Format Date')),
					_Utils_Tuple2(
					'dataType',
					$author$project$FieldType$encode($author$project$FieldType$StringType)),
					_Utils_Tuple2('dateExpression', dateVal),
					_Utils_Tuple2('formatExpression', stringVal)
				]));
	});
var $author$project$DataElement$Expression$encodeFormatDateLocaleAware = function (dateVal) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'type',
				$elm$json$Json$Encode$string('Format Date')),
				_Utils_Tuple2(
				'dataType',
				$author$project$FieldType$encode($author$project$FieldType$StringType)),
				_Utils_Tuple2('dateExpression', dateVal)
			]));
};
var $author$project$DataElement$Expression$encodeFormatDateTime = function (dateTimeVal) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'type',
				$elm$json$Json$Encode$string('Format Date/Time')),
				_Utils_Tuple2(
				'dataType',
				$author$project$FieldType$encode($author$project$FieldType$StringType)),
				_Utils_Tuple2('dateTimeExpression', dateTimeVal)
			]));
};
var $author$project$DataElement$Expression$encodeFormatNumber = F2(
	function (decimals, innerVal) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'type',
					$elm$json$Json$Encode$string('Number to String')),
					_Utils_Tuple2(
					'dataType',
					$author$project$FieldType$encode($author$project$FieldType$StringType)),
					_Utils_Tuple2('expression', innerVal),
					_Utils_Tuple2(
					'decimals',
					$elm$json$Json$Encode$int(decimals))
				]));
	});
var $author$project$DataElement$Expression$encodeGlobalLookup = F3(
	function (fieldType, singletonRef, fieldName) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'type',
					$elm$json$Json$Encode$string('Singleton Field')),
					_Utils_Tuple2(
					'dataType',
					$author$project$FieldType$encode(fieldType)),
					_Utils_Tuple2(
					'dataElement',
					$author$project$DataElement$Reference$encoder(singletonRef)),
					_Utils_Tuple2(
					'field',
					$author$project$FieldName$encode(fieldName))
				]));
	});
var $author$project$DataElement$Expression$encodeHardcodedBool = function (bool) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'type',
				$elm$json$Json$Encode$string('Static')),
				_Utils_Tuple2(
				'dataType',
				$author$project$FieldType$encode($author$project$FieldType$BoolType)),
				_Utils_Tuple2(
				'value',
				$elm$json$Json$Encode$bool(bool))
			]));
};
var $author$project$DataElement$Expression$encodeHardcodedDate = function (date) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'type',
				$elm$json$Json$Encode$string('Static')),
				_Utils_Tuple2(
				'dataType',
				$author$project$FieldType$encode($author$project$FieldType$DateType)),
				_Utils_Tuple2(
				'value',
				$elm$json$Json$Encode$string(
					$justinmimbs$date$Date$toIsoString(date)))
			]));
};
var $author$project$DataElement$Expression$encodeHardcodedDateTime = function (posix) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'type',
				$elm$json$Json$Encode$string('Static')),
				_Utils_Tuple2(
				'dataType',
				$author$project$FieldType$encode($author$project$FieldType$DateTimeType)),
				_Utils_Tuple2(
				'value',
				$rtfeldman$elm_iso8601_date_strings$Iso8601$encode(posix))
			]));
};
var $author$project$DataElement$Expression$encodeHardcodedNumber = function (number) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'type',
				$elm$json$Json$Encode$string('Static')),
				_Utils_Tuple2(
				'dataType',
				$author$project$FieldType$encode($author$project$FieldType$NumberType)),
				_Utils_Tuple2(
				'value',
				$elm$json$Json$Encode$float(number))
			]));
};
var $author$project$DataElement$Expression$encodeHardcodedString = function (words) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'type',
				$elm$json$Json$Encode$string('Static')),
				_Utils_Tuple2(
				'dataType',
				$author$project$FieldType$encode($author$project$FieldType$StringType)),
				_Utils_Tuple2(
				'value',
				$elm$json$Json$Encode$string(words))
			]));
};
var $author$project$DataElement$Expression$encodeIf = F4(
	function (fieldType, condVal, thenVal, elseVal) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'type',
					$elm$json$Json$Encode$string('If')),
					_Utils_Tuple2(
					'dataType',
					$author$project$FieldType$encode(fieldType)),
					_Utils_Tuple2('ifExpression', condVal),
					_Utils_Tuple2('thenExpression', thenVal),
					_Utils_Tuple2('elseExpression', elseVal)
				]));
	});
var $author$project$DataElement$Expression$encodeIsNotNull = function (innerVal) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'type',
				$elm$json$Json$Encode$string('Is Not Null')),
				_Utils_Tuple2(
				'dataType',
				$author$project$FieldType$encode($author$project$FieldType$BoolType)),
				_Utils_Tuple2('expression', innerVal)
			]));
};
var $author$project$DataElement$Expression$encodeIsNull = function (innerVal) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'type',
				$elm$json$Json$Encode$string('Is Null')),
				_Utils_Tuple2(
				'dataType',
				$author$project$FieldType$encode($author$project$FieldType$BoolType)),
				_Utils_Tuple2('expression', innerVal)
			]));
};
var $author$project$DataElement$Expression$encodeListOfExpressions = F2(
	function (fieldType, values) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'type',
					$elm$json$Json$Encode$string('List of Expressions')),
					_Utils_Tuple2(
					'dataType',
					$author$project$FieldType$encode(fieldType)),
					_Utils_Tuple2(
					'expressions',
					A2($elm$json$Json$Encode$list, $elm$core$Basics$identity, values))
				]));
	});
var $author$project$DataElement$Expression$encodeLocalBoolField = function (fieldName) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'type',
				$elm$json$Json$Encode$string('Local Field')),
				_Utils_Tuple2(
				'dataType',
				$author$project$FieldType$encode($author$project$FieldType$BoolType)),
				_Utils_Tuple2(
				'field',
				$author$project$FieldName$encode(fieldName))
			]));
};
var $author$project$DataElement$Expression$encodeLocalDateField = function (fieldName) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'type',
				$elm$json$Json$Encode$string('Local Field')),
				_Utils_Tuple2(
				'dataType',
				$author$project$FieldType$encode($author$project$FieldType$DateType)),
				_Utils_Tuple2(
				'field',
				$author$project$FieldName$encode(fieldName))
			]));
};
var $author$project$DataElement$Expression$encodeLocalDateTimeField = function (fieldName) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'type',
				$elm$json$Json$Encode$string('Local Field')),
				_Utils_Tuple2(
				'dataType',
				$author$project$FieldType$encode($author$project$FieldType$DateTimeType)),
				_Utils_Tuple2(
				'field',
				$author$project$FieldName$encode(fieldName))
			]));
};
var $author$project$DataElement$Expression$encodeLocalNumberField = function (fieldName) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'type',
				$elm$json$Json$Encode$string('Local Field')),
				_Utils_Tuple2(
				'dataType',
				$author$project$FieldType$encode($author$project$FieldType$NumberType)),
				_Utils_Tuple2(
				'field',
				$author$project$FieldName$encode(fieldName))
			]));
};
var $author$project$DataElement$Expression$encodeLocalStringField = function (fieldName) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'type',
				$elm$json$Json$Encode$string('Local Field')),
				_Utils_Tuple2(
				'dataType',
				$author$project$FieldType$encode($author$project$FieldType$StringType)),
				_Utils_Tuple2(
				'field',
				$author$project$FieldName$encode(fieldName))
			]));
};
var $author$project$DataElement$Expression$encodeMax = F2(
	function (compType, innerVal) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'type',
					$elm$json$Json$Encode$string('Max')),
					_Utils_Tuple2(
					'dataType',
					$author$project$ComparableType$encode(compType)),
					_Utils_Tuple2('expression', innerVal)
				]));
	});
var $author$project$DataElement$Expression$encodeMin = F2(
	function (compType, innerVal) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'type',
					$elm$json$Json$Encode$string('Min')),
					_Utils_Tuple2(
					'dataType',
					$author$project$ComparableType$encode(compType)),
					_Utils_Tuple2('expression', innerVal)
				]));
	});
var $author$project$DataElement$Expression$encodeMonthNumber = function (innerVal) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'type',
				$elm$json$Json$Encode$string('Date Month')),
				_Utils_Tuple2(
				'dataType',
				$author$project$FieldType$encode($author$project$FieldType$NumberType)),
				_Utils_Tuple2('expression', innerVal)
			]));
};
var $author$project$DataElement$Expression$encodeMultiplication = F2(
	function (innerValA, innerValB) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'type',
					$elm$json$Json$Encode$string('Multiply Number')),
					_Utils_Tuple2(
					'dataType',
					$author$project$FieldType$encode($author$project$FieldType$NumberType)),
					_Utils_Tuple2('expression1', innerValA),
					_Utils_Tuple2('expression2', innerValB)
				]));
	});
var $author$project$DataElement$Expression$encodeNot = function (innerVal) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'type',
				$elm$json$Json$Encode$string('Not')),
				_Utils_Tuple2(
				'dataType',
				$author$project$FieldType$encode($author$project$FieldType$BoolType)),
				_Utils_Tuple2('expression', innerVal)
			]));
};
var $author$project$DataElement$Expression$encodePickOne = F2(
	function (fieldType, innerVal) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'type',
					$elm$json$Json$Encode$string('Pick One')),
					_Utils_Tuple2(
					'dataType',
					$author$project$FieldType$encode(fieldType)),
					_Utils_Tuple2('expression', innerVal)
				]));
	});
var $author$project$DataElement$Expression$encodeProduct = function (innerVal) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'type',
				$elm$json$Json$Encode$string('Product')),
				_Utils_Tuple2(
				'dataType',
				$author$project$FieldType$encode($author$project$FieldType$NumberType)),
				_Utils_Tuple2('expression', innerVal)
			]));
};
var $author$project$DataElement$Expression$encodeRound = function (innerVal) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'type',
				$elm$json$Json$Encode$string('Round Number')),
				_Utils_Tuple2(
				'dataType',
				$author$project$FieldType$encode($author$project$FieldType$NumberType)),
				_Utils_Tuple2('expression', innerVal)
			]));
};
var $author$project$DataElement$Expression$encodeStringIn = F2(
	function (stringVal, listVal) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'type',
					$elm$json$Json$Encode$string('In')),
					_Utils_Tuple2(
					'dataType',
					$author$project$FieldType$encode($author$project$FieldType$BoolType)),
					_Utils_Tuple2('expression1', stringVal),
					_Utils_Tuple2('expression2', listVal)
				]));
	});
var $author$project$DataElement$Expression$encodeStringNotIn = F2(
	function (stringVal, listVal) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'type',
					$elm$json$Json$Encode$string('Not In')),
					_Utils_Tuple2(
					'dataType',
					$author$project$FieldType$encode($author$project$FieldType$BoolType)),
					_Utils_Tuple2('expression1', stringVal),
					_Utils_Tuple2('expression2', listVal)
				]));
	});
var $author$project$DataElement$Expression$encodeSubtraction = F2(
	function (innerValA, innerValB) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'type',
					$elm$json$Json$Encode$string('Subtract Number')),
					_Utils_Tuple2(
					'dataType',
					$author$project$FieldType$encode($author$project$FieldType$NumberType)),
					_Utils_Tuple2('expression1', innerValA),
					_Utils_Tuple2('expression2', innerValB)
				]));
	});
var $author$project$DataElement$Expression$encodeSum = function (innerVal) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'type',
				$elm$json$Json$Encode$string('Sum')),
				_Utils_Tuple2(
				'dataType',
				$author$project$FieldType$encode($author$project$FieldType$NumberType)),
				_Utils_Tuple2('expression', innerVal)
			]));
};
var $author$project$DataElement$Expression$encodeTargetChallengeReasons = function (innerVal) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'type',
				$elm$json$Json$Encode$string('Target Challenge Reasons')),
				_Utils_Tuple2(
				'dataType',
				$author$project$FieldType$encode($author$project$FieldType$StringType)),
				_Utils_Tuple2('expression', innerVal)
			]));
};
var $author$project$DataElement$Expression$encodeYearNumber = function (innerVal) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'type',
				$elm$json$Json$Encode$string('Date Year')),
				_Utils_Tuple2(
				'dataType',
				$author$project$FieldType$encode($author$project$FieldType$NumberType)),
				_Utils_Tuple2('expression', innerVal)
			]));
};
var $author$project$DataElement$Expression$encodeRelatedField = F3(
	function (fieldType, relationship, fieldName) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'type',
					$elm$json$Json$Encode$string('Related Field')),
					_Utils_Tuple2(
					'dataType',
					$author$project$FieldType$encode(fieldType)),
					_Utils_Tuple2(
					'relationship',
					$author$project$DataElement$Expression$encodeRelationship(relationship)),
					_Utils_Tuple2(
					'field',
					$author$project$FieldName$encode(fieldName))
				]));
	});
var $author$project$DataElement$Expression$encodeRelationship = function (_v0) {
	var localIds = _v0.localIds;
	var nextElement = _v0.nextElement;
	var idToMatch = _v0.idToMatch;
	var optionalFilter = _v0.optionalFilter;
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'nextElement',
				$author$project$DataElement$Reference$encoder(nextElement)),
				_Utils_Tuple2(
				'idToMatch',
				A2(
					$author$project$DataElement$Expression$applyLocalString,
					$author$project$DataElement$Expression$cyclic$encodeTransformer(),
					idToMatch)),
				_Utils_Tuple2(
				'localIds',
				A2(
					$author$project$DataElement$Expression$applyLocalStringList,
					$author$project$DataElement$Expression$cyclic$encodeTransformer(),
					localIds)),
				_Utils_Tuple2(
				'filterBy',
				A2(
					$elm$core$Maybe$withDefault,
					$elm$json$Json$Encode$null,
					A2(
						$elm$core$Maybe$map,
						$author$project$DataElement$Expression$applyLocalBool(
							$author$project$DataElement$Expression$cyclic$encodeTransformer()),
						optionalFilter)))
			]));
};
function $author$project$DataElement$Expression$cyclic$encodeTransformer() {
	return {
		add: $author$project$DataElement$Expression$encodeAddition,
		all: $author$project$DataElement$Expression$encodeAll,
		allBoolsInField: $author$project$DataElement$Expression$encodeAllValuesInField($author$project$FieldType$BoolType),
		allDateTimesInField: $author$project$DataElement$Expression$encodeAllValuesInField($author$project$FieldType$DateTimeType),
		allDatesInField: $author$project$DataElement$Expression$encodeAllValuesInField($author$project$FieldType$DateType),
		allNumbersInField: $author$project$DataElement$Expression$encodeAllValuesInField($author$project$FieldType$NumberType),
		allStringsInField: $author$project$DataElement$Expression$encodeAllValuesInField($author$project$FieldType$StringType),
		any: $author$project$DataElement$Expression$encodeAny,
		boolsAsList: $author$project$DataElement$Expression$encodeListOfExpressions($author$project$FieldType$BoolType),
		challengeReasons: $author$project$DataElement$Expression$encodeChallengeReasons,
		comparableEqual: A2($author$project$DataElement$Expression$encodeCompare, 'Equal', $author$project$ComparableType$encode),
		comparableNotEqual: A2($author$project$DataElement$Expression$encodeCompare, 'Not Equal', $author$project$ComparableType$encode),
		concat: $author$project$DataElement$Expression$encodeConcat,
		countUnique: $elm$core$Basics$always($author$project$DataElement$Expression$encodeCountUnique),
		dateAdd: $author$project$DataElement$Expression$encodeDateAdd,
		dateCeiling: $author$project$DataElement$Expression$encodeDateCeiling,
		dateFloor: $author$project$DataElement$Expression$encodeDateFloor,
		dateSubtract: $author$project$DataElement$Expression$encodeDateSubtract,
		dateTimeToDate: $author$project$DataElement$Expression$encodeDateTimeToDate,
		dateTimesAsList: $author$project$DataElement$Expression$encodeListOfExpressions($author$project$FieldType$DateTimeType),
		datesAsList: $author$project$DataElement$Expression$encodeListOfExpressions($author$project$FieldType$DateType),
		dayInMonth: $author$project$DataElement$Expression$encodeDayInMonth,
		divide: $author$project$DataElement$Expression$encodeDivision,
		equal: A2($author$project$DataElement$Expression$encodeCompare, 'Equal', $author$project$FieldType$encode),
		formatDate: $author$project$DataElement$Expression$encodeFormatDate,
		formatDateLocaleAware: $author$project$DataElement$Expression$encodeFormatDateLocaleAware,
		formatDateTime: $author$project$DataElement$Expression$encodeFormatDateTime,
		formatNumber: $author$project$DataElement$Expression$encodeFormatNumber,
		globalBoolLookup: $author$project$DataElement$Expression$encodeGlobalLookup($author$project$FieldType$BoolType),
		globalDateLookup: $author$project$DataElement$Expression$encodeGlobalLookup($author$project$FieldType$DateType),
		globalDateTimeLookup: $author$project$DataElement$Expression$encodeGlobalLookup($author$project$FieldType$DateTimeType),
		globalNumberLookup: $author$project$DataElement$Expression$encodeGlobalLookup($author$project$FieldType$NumberType),
		globalStringLookup: $author$project$DataElement$Expression$encodeGlobalLookup($author$project$FieldType$StringType),
		greaterThan: A2($author$project$DataElement$Expression$encodeCompare, 'GT', $author$project$ComparableType$encode),
		greaterThanOrEqual: A2($author$project$DataElement$Expression$encodeCompare, 'GTE', $author$project$ComparableType$encode),
		hardcodedBool: $author$project$DataElement$Expression$encodeHardcodedBool,
		hardcodedDate: $author$project$DataElement$Expression$encodeHardcodedDate,
		hardcodedDateTime: $author$project$DataElement$Expression$encodeHardcodedDateTime,
		hardcodedNumber: $author$project$DataElement$Expression$encodeHardcodedNumber,
		hardcodedString: $author$project$DataElement$Expression$encodeHardcodedString,
		if_: $author$project$DataElement$Expression$encodeIf,
		isNotNull: $author$project$DataElement$Expression$encodeIsNotNull,
		isNull: $author$project$DataElement$Expression$encodeIsNull,
		lessThan: A2($author$project$DataElement$Expression$encodeCompare, 'LT', $author$project$ComparableType$encode),
		lessThanOrEqual: A2($author$project$DataElement$Expression$encodeCompare, 'LTE', $author$project$ComparableType$encode),
		localBool: $author$project$DataElement$Expression$encodeLocalBoolField,
		localDate: $author$project$DataElement$Expression$encodeLocalDateField,
		localDateTime: $author$project$DataElement$Expression$encodeLocalDateTimeField,
		localNumber: $author$project$DataElement$Expression$encodeLocalNumberField,
		localString: $author$project$DataElement$Expression$encodeLocalStringField,
		max: $author$project$DataElement$Expression$encodeMax,
		min: $author$project$DataElement$Expression$encodeMin,
		monthNumber: $author$project$DataElement$Expression$encodeMonthNumber,
		multiply: $author$project$DataElement$Expression$encodeMultiplication,
		not: $author$project$DataElement$Expression$encodeNot,
		notEqual: A2($author$project$DataElement$Expression$encodeCompare, 'Not Equal', $author$project$FieldType$encode),
		numbersAsList: $author$project$DataElement$Expression$encodeListOfExpressions($author$project$FieldType$NumberType),
		pickOne: $author$project$DataElement$Expression$encodePickOne,
		product: $author$project$DataElement$Expression$encodeProduct,
		relatedBool: $author$project$DataElement$Expression$encodeRelatedField($author$project$FieldType$BoolType),
		relatedDate: $author$project$DataElement$Expression$encodeRelatedField($author$project$FieldType$DateType),
		relatedDateTime: $author$project$DataElement$Expression$encodeRelatedField($author$project$FieldType$DateTimeType),
		relatedNumber: $author$project$DataElement$Expression$encodeRelatedField($author$project$FieldType$NumberType),
		relatedString: $author$project$DataElement$Expression$encodeRelatedField($author$project$FieldType$StringType),
		round: $author$project$DataElement$Expression$encodeRound,
		stringIn: $author$project$DataElement$Expression$encodeStringIn,
		stringNotIn: $author$project$DataElement$Expression$encodeStringNotIn,
		stringsAsList: $author$project$DataElement$Expression$encodeListOfExpressions($author$project$FieldType$StringType),
		subtract: $author$project$DataElement$Expression$encodeSubtraction,
		sum: $author$project$DataElement$Expression$encodeSum,
		targetChallengeReasons: $author$project$DataElement$Expression$encodeTargetChallengeReasons,
		yearNumber: $author$project$DataElement$Expression$encodeYearNumber
	};
}
try {
	var $author$project$DataElement$Expression$encodeTransformer = $author$project$DataElement$Expression$cyclic$encodeTransformer();
	$author$project$DataElement$Expression$cyclic$encodeTransformer = function () {
		return $author$project$DataElement$Expression$encodeTransformer;
	};
} catch ($) {
	throw 'Some top-level definitions from `DataElement.Expression` are causing infinite recursion:\n\n  ┌─────┐\n  │    encodeTransformer\n  │     ↓\n  │    encodeRelatedField\n  │     ↓\n  │    encodeRelationship\n  └─────┘\n\nThese errors are very tricky, so read https://elm-lang.org/0.19.1/bad-recursion to learn how to fix it!';}
var $author$project$DataElement$CrmDataEngine$Where$encode = function (whereClause) {
	switch (whereClause.$) {
		case 'AllOf':
			var clauseList = whereClause.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('ALL_OF')),
						_Utils_Tuple2(
						'conditions',
						A2($elm$json$Json$Encode$list, $author$project$DataElement$CrmDataEngine$Where$encode, clauseList))
					]));
		case 'AnyOf':
			var clauseList = whereClause.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('ANY_OF')),
						_Utils_Tuple2(
						'conditions',
						A2($elm$json$Json$Encode$list, $author$project$DataElement$CrmDataEngine$Where$encode, clauseList))
					]));
		case 'Eq':
			var fieldName = whereClause.a;
			var globalField = whereClause.b;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('EQUAL')),
						_Utils_Tuple2(
						'field',
						$author$project$FieldName$encode(fieldName)),
						_Utils_Tuple2(
						'value',
						A2($author$project$DataElement$Expression$applyGlobalField, $author$project$DataElement$Expression$encodeTransformer, globalField))
					]));
		case 'NotEq':
			var fieldName = whereClause.a;
			var globalField = whereClause.b;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('NOT_EQUAL')),
						_Utils_Tuple2(
						'field',
						$author$project$FieldName$encode(fieldName)),
						_Utils_Tuple2(
						'value',
						A2($author$project$DataElement$Expression$applyGlobalField, $author$project$DataElement$Expression$encodeTransformer, globalField))
					]));
		case 'Gt':
			var fieldName = whereClause.a;
			var globalComparable = whereClause.b;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('GREATER_THAN')),
						_Utils_Tuple2(
						'field',
						$author$project$FieldName$encode(fieldName)),
						_Utils_Tuple2(
						'value',
						A2($author$project$DataElement$Expression$applyGlobalComparable, $author$project$DataElement$Expression$encodeTransformer, globalComparable))
					]));
		case 'Gte':
			var fieldName = whereClause.a;
			var globalComparable = whereClause.b;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('GREATER_THAN_OR_EQUAL')),
						_Utils_Tuple2(
						'field',
						$author$project$FieldName$encode(fieldName)),
						_Utils_Tuple2(
						'value',
						A2($author$project$DataElement$Expression$applyGlobalComparable, $author$project$DataElement$Expression$encodeTransformer, globalComparable))
					]));
		case 'Lt':
			var fieldName = whereClause.a;
			var globalComparable = whereClause.b;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('LESS_THAN')),
						_Utils_Tuple2(
						'field',
						$author$project$FieldName$encode(fieldName)),
						_Utils_Tuple2(
						'value',
						A2($author$project$DataElement$Expression$applyGlobalComparable, $author$project$DataElement$Expression$encodeTransformer, globalComparable))
					]));
		case 'Lte':
			var fieldName = whereClause.a;
			var globalComparable = whereClause.b;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('LESS_THAN_OR_EQUAL')),
						_Utils_Tuple2(
						'field',
						$author$project$FieldName$encode(fieldName)),
						_Utils_Tuple2(
						'value',
						A2($author$project$DataElement$Expression$applyGlobalComparable, $author$project$DataElement$Expression$encodeTransformer, globalComparable))
					]));
		case 'BetweenString':
			var fieldName = whereClause.a;
			var globalStringA = whereClause.b;
			var globalStringB = whereClause.c;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('BETWEEN')),
						_Utils_Tuple2(
						'field',
						$author$project$FieldName$encode(fieldName)),
						_Utils_Tuple2(
						'startValue',
						A2($author$project$DataElement$Expression$applyGlobalString, $author$project$DataElement$Expression$encodeTransformer, globalStringA)),
						_Utils_Tuple2(
						'endValue',
						A2($author$project$DataElement$Expression$applyGlobalString, $author$project$DataElement$Expression$encodeTransformer, globalStringB))
					]));
		case 'BetweenDate':
			var fieldName = whereClause.a;
			var globalDateA = whereClause.b;
			var globalDateB = whereClause.c;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('BETWEEN')),
						_Utils_Tuple2(
						'field',
						$author$project$FieldName$encode(fieldName)),
						_Utils_Tuple2(
						'startValue',
						A2($author$project$DataElement$Expression$applyGlobalDate, $author$project$DataElement$Expression$encodeTransformer, globalDateA)),
						_Utils_Tuple2(
						'endValue',
						A2($author$project$DataElement$Expression$applyGlobalDate, $author$project$DataElement$Expression$encodeTransformer, globalDateB))
					]));
		case 'BetweenDateTime':
			var fieldName = whereClause.a;
			var globalDateTimeA = whereClause.b;
			var globalDateTimeB = whereClause.c;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('BETWEEN')),
						_Utils_Tuple2(
						'field',
						$author$project$FieldName$encode(fieldName)),
						_Utils_Tuple2(
						'startValue',
						A2($author$project$DataElement$Expression$applyGlobalDateTime, $author$project$DataElement$Expression$encodeTransformer, globalDateTimeA)),
						_Utils_Tuple2(
						'endValue',
						A2($author$project$DataElement$Expression$applyGlobalDateTime, $author$project$DataElement$Expression$encodeTransformer, globalDateTimeB))
					]));
		case 'BetweenNumber':
			var fieldName = whereClause.a;
			var globalNumberA = whereClause.b;
			var globalNumberB = whereClause.c;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('BETWEEN')),
						_Utils_Tuple2(
						'field',
						$author$project$FieldName$encode(fieldName)),
						_Utils_Tuple2(
						'startValue',
						A2($author$project$DataElement$Expression$applyGlobalNumber, $author$project$DataElement$Expression$encodeTransformer, globalNumberA)),
						_Utils_Tuple2(
						'endValue',
						A2($author$project$DataElement$Expression$applyGlobalNumber, $author$project$DataElement$Expression$encodeTransformer, globalNumberB))
					]));
		case 'In':
			var fieldName = whereClause.a;
			var globalStringList = whereClause.b;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('IN')),
						_Utils_Tuple2(
						'field',
						$author$project$FieldName$encode(fieldName)),
						_Utils_Tuple2(
						'values',
						A2($author$project$DataElement$Expression$applyGlobalStringList, $author$project$DataElement$Expression$encodeTransformer, globalStringList))
					]));
		case 'IsNull':
			var fieldName = whereClause.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('IS_NULL')),
						_Utils_Tuple2(
						'field',
						$author$project$FieldName$encode(fieldName))
					]));
		default:
			var fieldName = whereClause.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('IS_NOT_NULL')),
						_Utils_Tuple2(
						'field',
						$author$project$FieldName$encode(fieldName))
					]));
	}
};
var $author$project$SortDirection$encode = function (dir) {
	if (dir.$ === 'Ascending') {
		return $elm$json$Json$Encode$string('ASC');
	} else {
		return $elm$json$Json$Encode$string('DESC');
	}
};
var $author$project$DataElement$SortKey$encode = function (_v0) {
	var field = _v0.field;
	var direction = _v0.direction;
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'key',
				$elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'name',
							$author$project$FieldName$encode(field))
						]))),
				_Utils_Tuple2(
				'sortDir',
				$elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'value',
							$author$project$SortDirection$encode(direction))
						])))
			]));
};
var $author$project$ObjectName$encode = function (_v0) {
	var name = _v0.a;
	return $elm$json$Json$Encode$string(name);
};
var $author$project$DataElement$CrmDataEngine$Field$concatFragmentEncoder = function (concatFragment) {
	if (concatFragment.$ === 'ConcatQuote') {
		var string = concatFragment.a;
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'type',
					$elm$json$Json$Encode$string('QUOTE')),
					_Utils_Tuple2(
					'text',
					$elm$json$Json$Encode$string(string))
				]));
	} else {
		var fieldName = concatFragment.a;
		return $author$project$FieldName$encode(fieldName);
	}
};
var $author$project$DataElement$CrmDataEngine$ExpandedDateInterval$encode = function (interval) {
	return $elm$json$Json$Encode$string(
		$author$project$DataElement$CrmDataEngine$ExpandedDateInterval$toString(interval));
};
var $author$project$DataElement$CrmDataEngine$Field$dimensionEncoder = F2(
	function (dimensionName, dimension) {
		switch (dimension.$) {
			case 'Concat':
				var concatFragments = dimension.a;
				return $elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'type',
							$elm$json$Json$Encode$string('CONCAT')),
							_Utils_Tuple2(
							'as',
							$author$project$FieldName$encode(dimensionName)),
							_Utils_Tuple2(
							'arguments',
							A2($elm$json$Json$Encode$list, $author$project$DataElement$CrmDataEngine$Field$concatFragmentEncoder, concatFragments)),
							_Utils_Tuple2(
							'dataType',
							$author$project$FieldType$encode($author$project$FieldType$StringType))
						]));
			case 'DateTruncate':
				var fieldName = dimension.a;
				var dateInterval = dimension.b;
				return $elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'type',
							$elm$json$Json$Encode$string('DATE_TRUNC')),
							_Utils_Tuple2(
							'as',
							$author$project$FieldName$encode(dimensionName)),
							_Utils_Tuple2(
							'interval',
							$author$project$DataElement$CrmDataEngine$ExpandedDateInterval$encode(dateInterval)),
							_Utils_Tuple2(
							'field',
							$author$project$FieldName$encode(fieldName)),
							_Utils_Tuple2(
							'dataType',
							$author$project$FieldType$encode($author$project$FieldType$DateType))
						]));
			case 'DateTimeTruncate':
				var fieldName = dimension.a;
				var dateInterval = dimension.b;
				return $elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'type',
							$elm$json$Json$Encode$string('DATE_TRUNC')),
							_Utils_Tuple2(
							'as',
							$author$project$FieldName$encode(dimensionName)),
							_Utils_Tuple2(
							'interval',
							$author$project$DataElement$CrmDataEngine$ExpandedDateInterval$encode(dateInterval)),
							_Utils_Tuple2(
							'field',
							$author$project$FieldName$encode(fieldName)),
							_Utils_Tuple2(
							'dataType',
							$author$project$FieldType$encode($author$project$FieldType$DateTimeType))
						]));
			case 'Divide':
				var dividend = dimension.a;
				var divisor = dimension.b;
				return $elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'type',
							$elm$json$Json$Encode$string('DIV')),
							_Utils_Tuple2(
							'as',
							$author$project$FieldName$encode(dimensionName)),
							_Utils_Tuple2(
							'fieldA',
							$author$project$FieldName$encode(dividend)),
							_Utils_Tuple2(
							'fieldB',
							$author$project$FieldName$encode(divisor)),
							_Utils_Tuple2(
							'dataType',
							$author$project$FieldType$encode($author$project$FieldType$NumberType))
						]));
			case 'Multiply':
				var firstFactor = dimension.a;
				var secondFactor = dimension.b;
				return $elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'type',
							$elm$json$Json$Encode$string('MULTI')),
							_Utils_Tuple2(
							'as',
							$author$project$FieldName$encode(dimensionName)),
							_Utils_Tuple2(
							'fieldA',
							$author$project$FieldName$encode(firstFactor)),
							_Utils_Tuple2(
							'fieldB',
							$author$project$FieldName$encode(secondFactor)),
							_Utils_Tuple2(
							'dataType',
							$author$project$FieldType$encode($author$project$FieldType$NumberType))
						]));
			case 'Minus':
				var minuend = dimension.a;
				var subtrahend = dimension.b;
				return $elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'type',
							$elm$json$Json$Encode$string('MINUS')),
							_Utils_Tuple2(
							'as',
							$author$project$FieldName$encode(dimensionName)),
							_Utils_Tuple2(
							'fieldA',
							$author$project$FieldName$encode(minuend)),
							_Utils_Tuple2(
							'fieldB',
							$author$project$FieldName$encode(subtrahend)),
							_Utils_Tuple2(
							'dataType',
							$author$project$FieldType$encode($author$project$FieldType$NumberType))
						]));
			default:
				var firstAddend = dimension.a;
				var secondAddend = dimension.b;
				return $elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'type',
							$elm$json$Json$Encode$string('PLUS')),
							_Utils_Tuple2(
							'as',
							$author$project$FieldName$encode(dimensionName)),
							_Utils_Tuple2(
							'fieldA',
							$author$project$FieldName$encode(firstAddend)),
							_Utils_Tuple2(
							'fieldB',
							$author$project$FieldName$encode(secondAddend)),
							_Utils_Tuple2(
							'dataType',
							$author$project$FieldType$encode($author$project$FieldType$NumberType))
						]));
		}
	});
var $author$project$DataElement$CrmDataEngine$Field$metricEncoder = F2(
	function (metricName, metric) {
		switch (metric.$) {
			case 'Sum':
				var sourceField = metric.a;
				return $elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'type',
							$elm$json$Json$Encode$string('SUM')),
							_Utils_Tuple2(
							'field',
							$author$project$FieldName$encode(sourceField)),
							_Utils_Tuple2(
							'as',
							$author$project$FieldName$encode(metricName)),
							_Utils_Tuple2(
							'dataType',
							$author$project$FieldType$encode($author$project$FieldType$NumberType))
						]));
			case 'Count':
				var sourceField = metric.a;
				return $elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'type',
							$elm$json$Json$Encode$string('COUNT')),
							_Utils_Tuple2(
							'field',
							$author$project$FieldName$encode(sourceField)),
							_Utils_Tuple2(
							'as',
							$author$project$FieldName$encode(metricName)),
							_Utils_Tuple2(
							'dataType',
							$author$project$FieldType$encode($author$project$FieldType$NumberType))
						]));
			case 'CountDistinct':
				var sourceField = metric.a;
				return $elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'type',
							$elm$json$Json$Encode$string('COUNT_DISTINCT')),
							_Utils_Tuple2(
							'field',
							$author$project$FieldName$encode(sourceField)),
							_Utils_Tuple2(
							'as',
							$author$project$FieldName$encode(metricName)),
							_Utils_Tuple2(
							'dataType',
							$author$project$FieldType$encode($author$project$FieldType$NumberType))
						]));
			case 'Max':
				var sourceField = metric.a;
				var comparableType = metric.b;
				return $elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'type',
							$elm$json$Json$Encode$string('MAX')),
							_Utils_Tuple2(
							'field',
							$author$project$FieldName$encode(sourceField)),
							_Utils_Tuple2(
							'as',
							$author$project$FieldName$encode(metricName)),
							_Utils_Tuple2(
							'dataType',
							$author$project$ComparableType$encode(comparableType))
						]));
			default:
				var sourceField = metric.a;
				var comparableType = metric.b;
				return $elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'type',
							$elm$json$Json$Encode$string('MIN')),
							_Utils_Tuple2(
							'field',
							$author$project$FieldName$encode(sourceField)),
							_Utils_Tuple2(
							'as',
							$author$project$FieldName$encode(metricName)),
							_Utils_Tuple2(
							'dataType',
							$author$project$ComparableType$encode(comparableType))
						]));
		}
	});
var $author$project$DataElement$CrmDataEngine$Field$pureFieldEncoder = F2(
	function (sourceField, dataType) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'type',
					$elm$json$Json$Encode$string('FIELD')),
					_Utils_Tuple2(
					'field',
					$author$project$FieldName$encode(sourceField)),
					_Utils_Tuple2(
					'dataType',
					$author$project$FieldType$encode(dataType))
				]));
	});
var $author$project$DataElement$CrmDataEngine$Field$fieldEncoder = function (field) {
	switch (field.$) {
		case 'PureField':
			var fieldName = field.a;
			var fieldType = field.b;
			return A2($author$project$DataElement$CrmDataEngine$Field$pureFieldEncoder, fieldName, fieldType);
		case 'DimensionField':
			var fieldName = field.a;
			var dimension = field.b;
			return A2($author$project$DataElement$CrmDataEngine$Field$dimensionEncoder, fieldName, dimension);
		default:
			var fieldName = field.a;
			var metric = field.b;
			return A2($author$project$DataElement$CrmDataEngine$Field$metricEncoder, fieldName, metric);
	}
};
var $author$project$DataElement$CrmDataEngineQuery$encode = F2(
	function (elementName, dataEngineQuery) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'type',
					$elm$json$Json$Encode$string('DATA_EL_CRM_DATA_ENGINE')),
					_Utils_Tuple2(
					'name',
					$elm$json$Json$Encode$string(elementName)),
					_Utils_Tuple2(
					'table',
					$author$project$ObjectName$encode(dataEngineQuery.table)),
					_Utils_Tuple2(
					'fields',
					A2(
						$elm$json$Json$Encode$list,
						$author$project$DataElement$CrmDataEngine$Field$fieldEncoder,
						$mgold$elm_nonempty_list$List$Nonempty$toList(dataEngineQuery.fields))),
					_Utils_Tuple2(
					'where',
					A2(
						$elm$core$Maybe$withDefault,
						$elm$json$Json$Encode$null,
						A2($elm$core$Maybe$map, $author$project$DataElement$CrmDataEngine$Where$encode, dataEngineQuery.whereClause))),
					_Utils_Tuple2(
					'limit',
					A2(
						$elm$core$Maybe$withDefault,
						$elm$json$Json$Encode$null,
						A2($elm$core$Maybe$map, $elm$json$Json$Encode$int, dataEngineQuery.limit))),
					_Utils_Tuple2(
					'sort',
					A2($elm$json$Json$Encode$list, $author$project$DataElement$SortKey$encode, dataEngineQuery.sort))
				]));
	});
var $author$project$DataElement$Datepicker$encode = F2(
	function (elementName, _v0) {
		var _default = _v0._default;
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'type',
					$elm$json$Json$Encode$string('Date Picker State')),
					_Utils_Tuple2(
					'name',
					$elm$json$Json$Encode$string(elementName)),
					_Utils_Tuple2(
					'default',
					A3(
						$elm_community$maybe_extra$Maybe$Extra$unwrap,
						$elm$json$Json$Encode$null,
						$author$project$DataElement$Expression$applyGlobalDate($author$project$DataElement$Expression$encodeTransformer),
						_default))
				]));
	});
var $author$project$DataElement$Dropdown$encode = F2(
	function (elementName, _v0) {
		var options = _v0.options;
		var placeholder = _v0.placeholder;
		var requireSelection = _v0.requireSelection;
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'type',
					$elm$json$Json$Encode$string('Dropdown State')),
					_Utils_Tuple2(
					'name',
					$elm$json$Json$Encode$string(elementName)),
					_Utils_Tuple2(
					'options',
					A2($author$project$DataElement$Expression$applyGlobalStringList, $author$project$DataElement$Expression$encodeTransformer, options)),
					_Utils_Tuple2(
					'placeholder',
					A2(
						$elm$core$Maybe$withDefault,
						$elm$json$Json$Encode$null,
						A2(
							$elm$core$Maybe$map,
							$author$project$DataElement$Expression$applyGlobalString($author$project$DataElement$Expression$encodeTransformer),
							placeholder))),
					_Utils_Tuple2(
					'requireSelection',
					$elm$json$Json$Encode$bool(requireSelection))
				]));
	});
var $author$project$DataElement$Helpers$fieldToValueHelper = function (_v0) {
	var fieldName = _v0.a;
	var fieldType = _v0.b;
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'name',
				$author$project$FieldName$encode(fieldName)),
				_Utils_Tuple2(
				'type',
				$author$project$FieldType$encode(fieldType))
			]));
};
var $author$project$DataElement$FeedbackAccountChannelGoals$encode = F2(
	function (elementName, info) {
		var encodeFields = A2(
			$elm$json$Json$Encode$list,
			$author$project$DataElement$Helpers$fieldToValueHelper,
			$pzp1997$assoc_list$AssocList$toList(info.fields));
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'type',
					$elm$json$Json$Encode$string('DATA_EL_FEEDBACK_ACCOUNT_CHANNEL_GOALS')),
					_Utils_Tuple2(
					'name',
					$elm$json$Json$Encode$string(elementName)),
					_Utils_Tuple2('selectedFields', encodeFields)
				]));
	});
var $author$project$DataElement$FeedbackAccountData$encode = F2(
	function (elementName, info) {
		var encodeFields = A2(
			$elm$json$Json$Encode$list,
			$author$project$DataElement$Helpers$fieldToValueHelper,
			$pzp1997$assoc_list$AssocList$toList(info.fields));
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'type',
					$elm$json$Json$Encode$string('DATA_EL_FEEDBACK_ACCOUNT_DATA')),
					_Utils_Tuple2(
					'name',
					$elm$json$Json$Encode$string(elementName)),
					_Utils_Tuple2('selectedFields', encodeFields)
				]));
	});
var $author$project$DataElement$FeedbackAccountProductGoals$encode = F2(
	function (elementName, info) {
		var encodeFields = A2(
			$elm$json$Json$Encode$list,
			$author$project$DataElement$Helpers$fieldToValueHelper,
			$pzp1997$assoc_list$AssocList$toList(info.fields));
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'type',
					$elm$json$Json$Encode$string('DATA_EL_FEEDBACK_ACCOUNT_PRODUCT_GOALS')),
					_Utils_Tuple2(
					'name',
					$elm$json$Json$Encode$string(elementName)),
					_Utils_Tuple2('selectedFields', encodeFields)
				]));
	});
var $author$project$DataElement$FeedbackAccountProductMetrics$encode = F2(
	function (elementName, info) {
		var encodeFields = A2(
			$elm$json$Json$Encode$list,
			$author$project$DataElement$Helpers$fieldToValueHelper,
			$pzp1997$assoc_list$AssocList$toList(info.fields));
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'type',
					$elm$json$Json$Encode$string('DATA_EL_FEEDBACK_ACCOUNT_PRODUCT_METRICS')),
					_Utils_Tuple2(
					'name',
					$elm$json$Json$Encode$string(elementName)),
					_Utils_Tuple2('selectedFields', encodeFields)
				]));
	});
var $author$project$DataElement$FeedbackChannelGoals$encode = F2(
	function (elementName, info) {
		var encodeFields = A2(
			$elm$json$Json$Encode$list,
			$author$project$DataElement$Helpers$fieldToValueHelper,
			$pzp1997$assoc_list$AssocList$toList(info.fields));
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'type',
					$elm$json$Json$Encode$string('DATA_EL_FEEDBACK_CHANNEL_GOALS')),
					_Utils_Tuple2(
					'name',
					$elm$json$Json$Encode$string(elementName)),
					_Utils_Tuple2('selectedFields', encodeFields)
				]));
	});
var $author$project$DataElement$FeedbackProductGoals$encode = F2(
	function (elementName, info) {
		var encodeFields = A2(
			$elm$json$Json$Encode$list,
			$author$project$DataElement$Helpers$fieldToValueHelper,
			$pzp1997$assoc_list$AssocList$toList(info.fields));
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'type',
					$elm$json$Json$Encode$string('DATA_EL_FEEDBACK_PRODUCT_GOALS')),
					_Utils_Tuple2(
					'name',
					$elm$json$Json$Encode$string(elementName)),
					_Utils_Tuple2('selectedFields', encodeFields)
				]));
	});
var $author$project$DataElement$SalesQuery$Scale$encode = function (scale) {
	return $elm$json$Json$Encode$string(
		$author$project$DataElement$SalesQuery$Scale$toString(scale));
};
var $author$project$DataElement$SalesQuery$encode = F2(
	function (elementName, salesQueryInfo) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'type',
					$elm$json$Json$Encode$string('DATA_EL_SALES_DATA_QUERY')),
					_Utils_Tuple2(
					'name',
					$elm$json$Json$Encode$string(elementName)),
					_Utils_Tuple2(
					'limit',
					A2(
						$elm$core$Maybe$withDefault,
						$elm$json$Json$Encode$null,
						A2($elm$core$Maybe$map, $elm$json$Json$Encode$int, salesQueryInfo.limit))),
					_Utils_Tuple2(
					'sort',
					A2($elm$json$Json$Encode$list, $author$project$DataElement$SortKey$encode, salesQueryInfo.sort)),
					_Utils_Tuple2(
					'scale',
					$author$project$DataElement$SalesQuery$Scale$encode(salesQueryInfo.scale)),
					_Utils_Tuple2(
					'dataType',
					$elm$json$Json$Encode$string(salesQueryInfo.dataType)),
					_Utils_Tuple2(
					'accountIds',
					A2($author$project$DataElement$Expression$applyGlobalStringList, $author$project$DataElement$Expression$encodeTransformer, salesQueryInfo.accountIds)),
					_Utils_Tuple2(
					'startDate',
					A2(
						$elm$core$Maybe$withDefault,
						$elm$json$Json$Encode$null,
						A2(
							$elm$core$Maybe$map,
							$author$project$DataElement$Expression$applyGlobalDate($author$project$DataElement$Expression$encodeTransformer),
							salesQueryInfo.startDate))),
					_Utils_Tuple2(
					'endDate',
					A2(
						$elm$core$Maybe$withDefault,
						$elm$json$Json$Encode$null,
						A2(
							$elm$core$Maybe$map,
							$author$project$DataElement$Expression$applyGlobalDate($author$project$DataElement$Expression$encodeTransformer),
							salesQueryInfo.endDate)))
				]));
	});
var $author$project$ValidContextObject$encode = function (obj) {
	switch (obj.$) {
		case 'Account':
			return $elm$json$Json$Encode$string('Account');
		case 'AccountPlan':
			return $elm$json$Json$Encode$string('Account_Plan_vod__c');
		case 'HTMLReport':
			return $elm$json$Json$Encode$string('HTML_Report_vod__c');
		case 'Order':
			return $elm$json$Json$Encode$string('Order_vod__c');
		case 'TSF':
			return $elm$json$Json$Encode$string('TSF_vod__c');
		case 'User':
			return $elm$json$Json$Encode$string('User');
		case 'InventoryMonitoring':
			return $elm$json$Json$Encode$string('Inventory_Monitoring_vod__c');
		case 'EMSpeaker':
			return $elm$json$Json$Encode$string('EM_Speaker_vod__c');
		default:
			return $elm$json$Json$Encode$string('Call2_vod__c');
	}
};
var $author$project$DataElement$encodeContextQuery = F2(
	function (elementName, info) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'type',
					$elm$json$Json$Encode$string('Context Query')),
					_Utils_Tuple2(
					'name',
					$elm$json$Json$Encode$string(elementName)),
					_Utils_Tuple2(
					'object',
					$author$project$ValidContextObject$encode(info.objectName)),
					_Utils_Tuple2(
					'fields',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								$author$project$FieldName$toString(info.fieldName),
								$elm$json$Json$Encode$object(
									_List_fromArray(
										[
											_Utils_Tuple2(
											'dataType',
											$author$project$FieldType$encode(info.fieldType))
										])))
							])))
				]));
	});
var $author$project$DataElement$WhereClause$encodeWhereIndividual = function (individual) {
	switch (individual.$) {
		case 'WhereIn':
			var fieldName = individual.a;
			var globalStringList = individual.b;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'value',
									$elm$json$Json$Encode$string('In'))
								]))),
						_Utils_Tuple2(
						'field',
						$elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'name',
									$author$project$FieldName$encode(fieldName))
								]))),
						_Utils_Tuple2(
						'expression',
						A2($author$project$DataElement$Expression$applyGlobalStringList, $author$project$DataElement$Expression$encodeTransformer, globalStringList))
					]));
		case 'WhereEqual':
			var fieldName = individual.a;
			var globalField = individual.b;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'value',
									$elm$json$Json$Encode$string('Equal'))
								]))),
						_Utils_Tuple2(
						'field',
						$elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'name',
									$author$project$FieldName$encode(fieldName))
								]))),
						_Utils_Tuple2(
						'expression',
						A2($author$project$DataElement$Expression$applyGlobalField, $author$project$DataElement$Expression$encodeTransformer, globalField))
					]));
		case 'WhereNotEqual':
			var fieldName = individual.a;
			var globalField = individual.b;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'value',
									$elm$json$Json$Encode$string('Not Equal'))
								]))),
						_Utils_Tuple2(
						'field',
						$elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'name',
									$author$project$FieldName$encode(fieldName))
								]))),
						_Utils_Tuple2(
						'expression',
						A2($author$project$DataElement$Expression$applyGlobalField, $author$project$DataElement$Expression$encodeTransformer, globalField))
					]));
		case 'WhereGT':
			var fieldName = individual.a;
			var globalComp = individual.b;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'value',
									$elm$json$Json$Encode$string('GT'))
								]))),
						_Utils_Tuple2(
						'field',
						$elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'name',
									$author$project$FieldName$encode(fieldName))
								]))),
						_Utils_Tuple2(
						'expression',
						A2($author$project$DataElement$Expression$applyGlobalComparable, $author$project$DataElement$Expression$encodeTransformer, globalComp))
					]));
		case 'WhereGTE':
			var fieldName = individual.a;
			var globalComp = individual.b;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'value',
									$elm$json$Json$Encode$string('GTE'))
								]))),
						_Utils_Tuple2(
						'field',
						$elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'name',
									$author$project$FieldName$encode(fieldName))
								]))),
						_Utils_Tuple2(
						'expression',
						A2($author$project$DataElement$Expression$applyGlobalComparable, $author$project$DataElement$Expression$encodeTransformer, globalComp))
					]));
		case 'WhereLT':
			var fieldName = individual.a;
			var globalComp = individual.b;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'value',
									$elm$json$Json$Encode$string('LT'))
								]))),
						_Utils_Tuple2(
						'field',
						$elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'name',
									$author$project$FieldName$encode(fieldName))
								]))),
						_Utils_Tuple2(
						'expression',
						A2($author$project$DataElement$Expression$applyGlobalComparable, $author$project$DataElement$Expression$encodeTransformer, globalComp))
					]));
		default:
			var fieldName = individual.a;
			var globalComp = individual.b;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'value',
									$elm$json$Json$Encode$string('LTE'))
								]))),
						_Utils_Tuple2(
						'field',
						$elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'name',
									$author$project$FieldName$encode(fieldName))
								]))),
						_Utils_Tuple2(
						'expression',
						A2($author$project$DataElement$Expression$applyGlobalComparable, $author$project$DataElement$Expression$encodeTransformer, globalComp))
					]));
	}
};
var $author$project$DataElement$WhereClause$encode = function (clause) {
	switch (clause.$) {
		case 'WhereAnd':
			var children = clause.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'value',
									$elm$json$Json$Encode$string('And'))
								]))),
						_Utils_Tuple2(
						'subclauses',
						A2($elm$json$Json$Encode$list, $author$project$DataElement$WhereClause$encode, children))
					]));
		case 'WhereOr':
			var children = clause.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'value',
									$elm$json$Json$Encode$string('Or'))
								]))),
						_Utils_Tuple2(
						'subclauses',
						A2($elm$json$Json$Encode$list, $author$project$DataElement$WhereClause$encode, children))
					]));
		default:
			var individual = clause.a;
			return $author$project$DataElement$WhereClause$encodeWhereIndividual(individual);
	}
};
var $author$project$DataElement$encodeFieldInfo = function (_v0) {
	var fieldType = _v0.fieldType;
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'dataType',
				$author$project$FieldType$encode(fieldType))
			]));
};
var $elm$core$Tuple$mapBoth = F3(
	function (funcA, funcB, _v0) {
		var x = _v0.a;
		var y = _v0.b;
		return _Utils_Tuple2(
			funcA(x),
			funcB(y));
	});
var $author$project$DataElement$encodeStandardQuery = F3(
	function (typeString, elementName, queryInfo) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'type',
					$elm$json$Json$Encode$string(typeString)),
					_Utils_Tuple2(
					'name',
					$elm$json$Json$Encode$string(elementName)),
					_Utils_Tuple2(
					'object',
					$author$project$ObjectName$encode(queryInfo.objectName)),
					_Utils_Tuple2(
					'objectTags',
					$elm$json$Json$Encode$object(
						A2(
							$elm$core$List$map,
							A2($elm$core$Tuple$mapBoth, $author$project$FieldName$toString, $author$project$ObjectName$encode),
							$pzp1997$assoc_list$AssocList$toList(queryInfo.objectTags)))),
					_Utils_Tuple2(
					'fields',
					$elm$json$Json$Encode$object(
						A2(
							$elm$core$List$map,
							A2($elm$core$Tuple$mapBoth, $author$project$FieldName$toString, $author$project$DataElement$encodeFieldInfo),
							$pzp1997$assoc_list$AssocList$toList(queryInfo.fields)))),
					_Utils_Tuple2(
					'limit',
					A2(
						$elm$core$Maybe$withDefault,
						$elm$json$Json$Encode$null,
						A2($elm$core$Maybe$map, $elm$json$Json$Encode$int, queryInfo.limit))),
					_Utils_Tuple2(
					'sort',
					A2($elm$json$Json$Encode$list, $author$project$DataElement$SortKey$encode, queryInfo.sort)),
					_Utils_Tuple2(
					'where',
					A2(
						$elm$core$Maybe$withDefault,
						$elm$json$Json$Encode$null,
						A2($elm$core$Maybe$map, $author$project$DataElement$WhereClause$encode, queryInfo.whereClause)))
				]));
	});
var $author$project$DataElement$encodeCrmQuery = $author$project$DataElement$encodeStandardQuery('CRM Query');
var $author$project$DataElement$encodeFieldTranslation = F2(
	function (elementName, _v0) {
		var object = _v0.object;
		var fields = _v0.fields;
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'type',
					$elm$json$Json$Encode$string('DATA_EL_FIELD_TRANSLATION')),
					_Utils_Tuple2(
					'name',
					$elm$json$Json$Encode$string(elementName)),
					_Utils_Tuple2(
					'object',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'name',
								$author$project$ObjectName$encode(object))
							]))),
					_Utils_Tuple2(
					'fields',
					$elm$json$Json$Encode$object(
						A2(
							$elm$core$List$map,
							function (fieldName) {
								return _Utils_Tuple2(
									$author$project$FieldName$toString(fieldName),
									$elm$json$Json$Encode$object(_List_Nil));
							},
							$mgold$elm_nonempty_list$List$Nonempty$toList(fields))))
				]));
	});
var $author$project$DataElement$encodeFilterList = F2(
	function (elementName, info) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'type',
					$elm$json$Json$Encode$string('DATA_EL_FILTER_LIST')),
					_Utils_Tuple2(
					'name',
					$elm$json$Json$Encode$string(elementName)),
					_Utils_Tuple2(
					'original',
					$author$project$DataElement$Reference$encoder(info.original)),
					_Utils_Tuple2(
					'filter',
					A2($author$project$DataElement$Expression$applyLocalBool, $author$project$DataElement$Expression$encodeTransformer, info.filter))
				]));
	});
var $author$project$DataElement$MergeList$innerDictEncode = function (dict) {
	return $elm$json$Json$Encode$object(
		A2(
			$elm$core$List$map,
			A2($elm$core$Tuple$mapBoth, $author$project$FieldName$toString, $author$project$FieldName$encode),
			$pzp1997$assoc_list$AssocList$toList(dict)));
};
var $author$project$DataElement$MergeList$encode = function (_v0) {
	var info = _v0.a;
	return A2(
		$elm$json$Json$Encode$list,
		$elm$json$Json$Encode$object,
		A2(
			$elm$core$List$map,
			function (_v1) {
				var ref = _v1.a;
				var dict = _v1.b;
				return _List_fromArray(
					[
						_Utils_Tuple2(
						'dataSource',
						$author$project$DataElement$Reference$encoder(ref)),
						_Utils_Tuple2(
						'dict',
						$author$project$DataElement$MergeList$innerDictEncode(dict))
					]);
			},
			info));
};
var $author$project$DataElement$encodeMergeList = F2(
	function (elementName, info) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'type',
					$elm$json$Json$Encode$string('DATA_EL_MERGE_LIST')),
					_Utils_Tuple2(
					'name',
					$elm$json$Json$Encode$string(elementName)),
					_Utils_Tuple2(
					'sources',
					$author$project$DataElement$MergeList$encode(info))
				]));
	});
var $author$project$DataElement$encodeNitroQuery = $author$project$DataElement$encodeStandardQuery('DATA_EL_NITRO_QUERY');
var $author$project$DataElement$encodeNow = function (elementName) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'type',
				$elm$json$Json$Encode$string('Now')),
				_Utils_Tuple2(
				'name',
				$elm$json$Json$Encode$string(elementName))
			]));
};
var $author$project$DataElement$encodeObjectTranslation = F2(
	function (elementName, objectName) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'type',
					$elm$json$Json$Encode$string('DATA_EL_OBJECT_TRANSLATION')),
					_Utils_Tuple2(
					'name',
					$elm$json$Json$Encode$string(elementName)),
					_Utils_Tuple2(
					'object',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'name',
								$author$project$ObjectName$encode(objectName))
							])))
				]));
	});
var $author$project$DataElement$encodeOneForOne = F2(
	function (elementName, info) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'type',
					$elm$json$Json$Encode$string('One for One')),
					_Utils_Tuple2(
					'name',
					$elm$json$Json$Encode$string(elementName)),
					_Utils_Tuple2(
					'original',
					$author$project$DataElement$Reference$encoder(info.original)),
					_Utils_Tuple2(
					'fields',
					$elm$json$Json$Encode$object(
						A2(
							$elm$core$List$map,
							A2(
								$elm$core$Tuple$mapBoth,
								$author$project$FieldName$toString,
								$author$project$DataElement$Expression$applyLocalField($author$project$DataElement$Expression$encodeTransformer)),
							$pzp1997$assoc_list$AssocList$toList(info.fields))))
				]));
	});
var $author$project$DataElement$encodeOverview = F2(
	function (elementName, info) {
		var encodeFields = A2(
			$elm$json$Json$Encode$list,
			$author$project$DataElement$Helpers$fieldToValueHelper,
			$pzp1997$assoc_list$AssocList$toList(info.fields));
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'type',
					$elm$json$Json$Encode$string('DATA_EL_FEEDBACK_OVERVIEW')),
					_Utils_Tuple2(
					'name',
					$elm$json$Json$Encode$string(elementName)),
					_Utils_Tuple2('selectedFields', encodeFields)
				]));
	});
var $author$project$DataElement$encodeSortListKey = function (key) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'expression',
				A2($author$project$DataElement$Expression$applyLocalComparable, $author$project$DataElement$Expression$encodeTransformer, key.expression)),
				_Utils_Tuple2(
				'sortDir',
				$elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'value',
							$author$project$SortDirection$encode(key.direction))
						])))
			]));
};
var $author$project$DataElement$encodeSortList = F2(
	function (elementName, info) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'type',
					$elm$json$Json$Encode$string('DATA_EL_SORT_LIST')),
					_Utils_Tuple2(
					'name',
					$elm$json$Json$Encode$string(elementName)),
					_Utils_Tuple2(
					'original',
					$author$project$DataElement$Reference$encoder(info.original)),
					_Utils_Tuple2(
					'sort',
					A2(
						$elm$json$Json$Encode$list,
						$author$project$DataElement$encodeSortListKey,
						$mgold$elm_nonempty_list$List$Nonempty$toList(info.sortBy)))
				]));
	});
var $author$project$DataElement$encodeSublist = F2(
	function (elementName, info) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'type',
					$elm$json$Json$Encode$string('DATA_EL_SUBLIST')),
					_Utils_Tuple2(
					'name',
					$elm$json$Json$Encode$string(elementName)),
					_Utils_Tuple2(
					'original',
					$author$project$DataElement$Reference$encoder(info.original)),
					_Utils_Tuple2(
					'skip',
					$elm$json$Json$Encode$int(info.skipThisMany)),
					_Utils_Tuple2(
					'keep',
					$elm$json$Json$Encode$int(info.keepThisMany))
				]));
	});
var $author$project$DataElement$encodeSummarize = F2(
	function (elementName, _v0) {
		var fields = _v0.fields;
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'type',
					$elm$json$Json$Encode$string('Summarize')),
					_Utils_Tuple2(
					'name',
					$elm$json$Json$Encode$string(elementName)),
					_Utils_Tuple2(
					'fields',
					$elm$json$Json$Encode$object(
						A2(
							$elm$core$List$map,
							A2(
								$elm$core$Tuple$mapBoth,
								$author$project$FieldName$toString,
								$author$project$DataElement$Expression$applyGlobalField($author$project$DataElement$Expression$encodeTransformer)),
							$pzp1997$assoc_list$AssocList$toList(fields))))
				]));
	});
var $author$project$DataElement$encodeToday = function (elementName) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'type',
				$elm$json$Json$Encode$string('Today')),
				_Utils_Tuple2(
				'name',
				$elm$json$Json$Encode$string(elementName))
			]));
};
var $author$project$DataElement$encodeVeevaMessageToken = function (info) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'name',
				$elm$json$Json$Encode$string(info.name)),
				_Utils_Tuple2(
				'category',
				$elm$json$Json$Encode$string(info.category))
			]));
};
var $author$project$DataElement$encodeVeevaMessages = F2(
	function (elementName, _v0) {
		var tokens = _v0.tokens;
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'type',
					$elm$json$Json$Encode$string('DATA_EL_VEEVA_MESSAGES')),
					_Utils_Tuple2(
					'name',
					$elm$json$Json$Encode$string(elementName)),
					_Utils_Tuple2(
					'messages',
					A2($elm$json$Json$Encode$list, $author$project$DataElement$encodeVeevaMessageToken, tokens))
				]));
	});
var $author$project$DataElement$encode = function (element) {
	if (element.b.$ === 'RecordList') {
		switch (element.b.a.$) {
			case 'CrmQuery':
				var elementName = element.a;
				var queryInfo = element.b.a.a;
				return A2($author$project$DataElement$encodeCrmQuery, elementName, queryInfo);
			case 'NitroQuery':
				var elementName = element.a;
				var queryInfo = element.b.a.a;
				return A2($author$project$DataElement$encodeNitroQuery, elementName, queryInfo);
			case 'SalesQuery':
				var elementName = element.a;
				var queryInfo = element.b.a.a;
				return A2($author$project$DataElement$SalesQuery$encode, elementName, queryInfo);
			case 'CrmDataEngineQuery':
				var elementName = element.a;
				var queryInfo = element.b.a.a;
				return A2($author$project$DataElement$CrmDataEngineQuery$encode, elementName, queryInfo);
			case 'CalcOneForOne':
				var elementName = element.a;
				var info = element.b.a.a;
				return A2($author$project$DataElement$encodeOneForOne, elementName, info);
			case 'CalcSortList':
				var elementName = element.a;
				var info = element.b.a.a;
				return A2($author$project$DataElement$encodeSortList, elementName, info);
			case 'CalcFilterList':
				var elementName = element.a;
				var info = element.b.a.a;
				return A2($author$project$DataElement$encodeFilterList, elementName, info);
			case 'CalcSublist':
				var elementName = element.a;
				var info = element.b.a.a;
				return A2($author$project$DataElement$encodeSublist, elementName, info);
			case 'AlignedTerritories':
				var elementName = element.a;
				var info = element.b.a.a;
				return A2($author$project$DataElement$AlignedTerritories$encode, elementName, info);
			case 'FeedbackChannelGoals':
				var elementName = element.a;
				var info = element.b.a.a;
				return A2($author$project$DataElement$FeedbackChannelGoals$encode, elementName, info);
			case 'FeedbackProductGoals':
				var elementName = element.a;
				var info = element.b.a.a;
				return A2($author$project$DataElement$FeedbackProductGoals$encode, elementName, info);
			case 'FeedbackAccountData':
				var elementName = element.a;
				var info = element.b.a.a;
				return A2($author$project$DataElement$FeedbackAccountData$encode, elementName, info);
			case 'FeedbackAccountChannelGoals':
				var elementName = element.a;
				var info = element.b.a.a;
				return A2($author$project$DataElement$FeedbackAccountChannelGoals$encode, elementName, info);
			case 'FeedbackAccountProductGoals':
				var elementName = element.a;
				var info = element.b.a.a;
				return A2($author$project$DataElement$FeedbackAccountProductGoals$encode, elementName, info);
			case 'FeedbackAccountProductMetrics':
				var elementName = element.a;
				var info = element.b.a.a;
				return A2($author$project$DataElement$FeedbackAccountProductMetrics$encode, elementName, info);
			case 'CallAttendees':
				var elementName = element.a;
				var _v1 = element.b.a;
				return $author$project$DataElement$CallAttendees$encode(elementName);
			default:
				var elementName = element.a;
				var info = element.b.a.a;
				return A2($author$project$DataElement$encodeMergeList, elementName, info);
		}
	} else {
		switch (element.b.a.$) {
			case 'FeedbackOverview':
				var elementName = element.a;
				var info = element.b.a.a;
				return A2($author$project$DataElement$encodeOverview, elementName, info);
			case 'ContextQuery':
				var elementName = element.a;
				var info = element.b.a.a;
				return A2($author$project$DataElement$encodeContextQuery, elementName, info);
			case 'LimitOneCrmQuery':
				var elementName = element.a;
				var queryInfo = element.b.a.a;
				return A2($author$project$DataElement$encodeCrmQuery, elementName, queryInfo);
			case 'LimitOneSalesQuery':
				var elementName = element.a;
				var queryInfo = element.b.a.a;
				return A2($author$project$DataElement$SalesQuery$encode, elementName, queryInfo);
			case 'LimitOneNitroQuery':
				var elementName = element.a;
				var queryInfo = element.b.a.a;
				return A2($author$project$DataElement$encodeNitroQuery, elementName, queryInfo);
			case 'LimitOneCrmDataEngineQuery':
				var elementName = element.a;
				var queryInfo = element.b.a.a;
				return A2($author$project$DataElement$CrmDataEngineQuery$encode, elementName, queryInfo);
			case 'Today':
				var elementName = element.a;
				var _v2 = element.b.a;
				return $author$project$DataElement$encodeToday(elementName);
			case 'Now':
				var elementName = element.a;
				var _v3 = element.b.a;
				return $author$project$DataElement$encodeNow(elementName);
			case 'CalcSummarize':
				var elementName = element.a;
				var info = element.b.a.a;
				return A2($author$project$DataElement$encodeSummarize, elementName, info);
			case 'ObjectTranslation':
				var elementName = element.a;
				var objectName = element.b.a.a;
				return A2($author$project$DataElement$encodeObjectTranslation, elementName, objectName);
			case 'FieldTranslation':
				var elementName = element.a;
				var fieldTranslationInfo = element.b.a.a;
				return A2($author$project$DataElement$encodeFieldTranslation, elementName, fieldTranslationInfo);
			case 'VeevaMessages':
				var elementName = element.a;
				var vmInfo = element.b.a.a;
				return A2($author$project$DataElement$encodeVeevaMessages, elementName, vmInfo);
			case 'DatepickerSelection':
				var elementName = element.a;
				var selectInfo = element.b.a.a;
				return A2($author$project$DataElement$Datepicker$encode, elementName, selectInfo);
			default:
				var elementName = element.a;
				var selectInfo = element.b.a.a;
				return A2($author$project$DataElement$Dropdown$encode, elementName, selectInfo);
		}
	}
};
var $author$project$DataElement$collectionEncoder = function (collection) {
	return $elm$json$Json$Encode$object(
		A2(
			$elm$core$List$map,
			$elm$core$Tuple$mapSecond(
				A2($elm$core$Basics$composeR, $elm$core$Tuple$second, $author$project$DataElement$encode)),
			A2(
				$elm$core$List$map,
				function (_v0) {
					var first = _v0.a;
					var second = _v0.b;
					return _Utils_Tuple2(
						$author$project$DataElement$Reference$toString(first),
						_Utils_Tuple2(first, second));
				},
				$author$project$DataElement$collectionToList(collection))));
};
var $author$project$MyInsights$encodeJsonDecodeError = function (err) {
	switch (err.$) {
		case 'Field':
			var name = err.a;
			var innerError = err.b;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('Field')),
						_Utils_Tuple2(
						'name',
						$elm$json$Json$Encode$string(name)),
						_Utils_Tuple2(
						'error',
						$author$project$MyInsights$encodeJsonDecodeError(innerError))
					]));
		case 'Index':
			var index = err.a;
			var innerError = err.b;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('Index')),
						_Utils_Tuple2(
						'index',
						$elm$json$Json$Encode$int(index)),
						_Utils_Tuple2(
						'error',
						$author$project$MyInsights$encodeJsonDecodeError(innerError))
					]));
		case 'OneOf':
			var innerErrors = err.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('OneOf')),
						_Utils_Tuple2(
						'errors',
						A2($elm$json$Json$Encode$list, $author$project$MyInsights$encodeJsonDecodeError, innerErrors))
					]));
		default:
			var label = err.a;
			var value = err.b;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('Failure')),
						_Utils_Tuple2(
						'label',
						$elm$json$Json$Encode$string(label)),
						_Utils_Tuple2('value', value)
					]));
	}
};
var $author$project$MyInsights$encodeError = function (error) {
	switch (error.$) {
		case 'Timeout':
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('Timeout'))
					]));
		case 'ApiError':
			var code = error.a;
			var message = error.b;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('ApiError')),
						_Utils_Tuple2(
						'code',
						$elm$json$Json$Encode$int(code)),
						_Utils_Tuple2(
						'message',
						$elm$json$Json$Encode$string(message))
					]));
		default:
			var decodeError = error.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('DecodeError')),
						_Utils_Tuple2(
						'error',
						$author$project$MyInsights$encodeJsonDecodeError(decodeError))
					]));
	}
};
var $author$project$DataEngine$CacheState$encode = F2(
	function (innerEncode, cacheState) {
		switch (cacheState.$) {
			case 'Loading':
				return $elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'type',
							$elm$json$Json$Encode$string('Loading'))
						]));
			case 'Failure':
				var err = cacheState.a;
				return $elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'type',
							$elm$json$Json$Encode$string('Failure')),
							_Utils_Tuple2(
							'error',
							$author$project$MyInsights$encodeError(err))
						]));
			case 'Success':
				var a = cacheState.a;
				return $elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'type',
							$elm$json$Json$Encode$string('Success')),
							_Utils_Tuple2(
							'item',
							innerEncode(a))
						]));
			default:
				var a = cacheState.a;
				return $elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'type',
							$elm$json$Json$Encode$string('Deleted')),
							_Utils_Tuple2(
							'item',
							innerEncode(a))
						]));
		}
	});
var $elm$json$Json$Encode$dict = F3(
	function (toKey, toValue, dictionary) {
		return _Json_wrap(
			A3(
				$elm$core$Dict$foldl,
				F3(
					function (key, value, obj) {
						return A3(
							_Json_addField,
							toKey(key),
							toValue(value),
							obj);
					}),
				_Json_emptyObject(_Utils_Tuple0),
				dictionary));
	});
var $author$project$StudioString$encode = function (studioString) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'text',
				$elm$json$Json$Encode$string(studioString.text)),
				_Utils_Tuple2(
				'object',
				A2(
					$elm$core$Maybe$withDefault,
					$elm$json$Json$Encode$null,
					A2($elm$core$Maybe$map, $author$project$ObjectName$encode, studioString.object)))
			]));
};
var $author$project$DataEngine$RecordCache$encode = function (_v0) {
	var cache = _v0.a;
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'strings',
				A3($elm$json$Json$Encode$dict, $elm$core$Basics$identity, $author$project$StudioString$encode, cache.strings)),
				_Utils_Tuple2(
				'numbers',
				A3($elm$json$Json$Encode$dict, $elm$core$Basics$identity, $elm$json$Json$Encode$float, cache.numbers)),
				_Utils_Tuple2(
				'dates',
				A3(
					$elm$json$Json$Encode$dict,
					$elm$core$Basics$identity,
					A2($elm$core$Basics$composeR, $justinmimbs$date$Date$toIsoString, $elm$json$Json$Encode$string),
					cache.dates)),
				_Utils_Tuple2(
				'datetimes',
				A3($elm$json$Json$Encode$dict, $elm$core$Basics$identity, $rtfeldman$elm_iso8601_date_strings$Iso8601$encode, cache.datetimes)),
				_Utils_Tuple2(
				'bools',
				A3($elm$json$Json$Encode$dict, $elm$core$Basics$identity, $elm$json$Json$Encode$bool, cache.bools))
			]));
};
var $author$project$DataEngine$RecordMetadata$encode = function (_v0) {
	var dict = _v0.a;
	return A3($elm$json$Json$Encode$dict, $elm$core$Basics$identity, $author$project$FieldType$encode, dict);
};
var $author$project$DataEngine$DataElementCache$encode = function (cache) {
	if (cache.$ === 'SingletonCache') {
		var metadata = cache.a;
		var record = cache.b;
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'type',
					$elm$json$Json$Encode$string('Singleton')),
					_Utils_Tuple2(
					'record',
					$author$project$DataEngine$RecordCache$encode(record)),
					_Utils_Tuple2(
					'metadata',
					$author$project$DataEngine$RecordMetadata$encode(metadata))
				]));
	} else {
		var metadata = cache.a;
		var records = cache.b;
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'type',
					$elm$json$Json$Encode$string('List')),
					_Utils_Tuple2(
					'records',
					A2($elm$json$Json$Encode$list, $author$project$DataEngine$RecordCache$encode, records)),
					_Utils_Tuple2(
					'metadata',
					$author$project$DataEngine$RecordMetadata$encode(metadata))
				]));
	}
};
var $author$project$FeedbackData$encode = function (feedbackData) {
	return feedbackData.value;
};
var $joneshf$elm_tagged$Tagged$untag = function (_v0) {
	var x = _v0.a;
	return x;
};
var $enkidatron$elm_cldr$Internal$Locale$languageIdToUnicode = function (lang) {
	if (lang.$ === 'Root') {
		return 'root';
	} else {
		var langTag = lang.a;
		var maybeScript = lang.b;
		var maybeRegion = lang.c;
		var maybeVariant = lang.d;
		return A2(
			$elm$core$String$join,
			'-',
			A2(
				$elm$core$List$filterMap,
				$elm$core$Basics$identity,
				_List_fromArray(
					[
						$elm$core$Maybe$Just(
						$elm$core$String$toLower(
							$joneshf$elm_tagged$Tagged$untag(langTag))),
						A2($elm$core$Maybe$map, $joneshf$elm_tagged$Tagged$untag, maybeScript),
						A2(
						$elm$core$Maybe$map,
						A2($elm$core$Basics$composeR, $joneshf$elm_tagged$Tagged$untag, $elm$core$String$toUpper),
						maybeRegion),
						A2(
						$elm$core$Maybe$map,
						A2($elm$core$Basics$composeR, $joneshf$elm_tagged$Tagged$untag, $elm$core$String$toLower),
						maybeVariant)
					])));
	}
};
var $enkidatron$elm_cldr$Internal$Locale$toUnicode = function (_v0) {
	var internal = _v0.a;
	return $enkidatron$elm_cldr$Internal$Locale$languageIdToUnicode(internal.languageId);
};
var $enkidatron$elm_cldr$Cldr$Locale$toUnicode = function (locale) {
	return $enkidatron$elm_cldr$Internal$Locale$toUnicode(locale);
};
var $author$project$LoadableLocale$encodeLocale = function (locale) {
	return $elm$json$Json$Encode$string(
		$enkidatron$elm_cldr$Cldr$Locale$toUnicode(locale));
};
var $author$project$LoadableLocale$encode = function (_v0) {
	var user = _v0.a;
	var device = _v0.b;
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'user',
				A2(
					$krisajenkins$remotedata$RemoteData$withDefault,
					$elm$json$Json$Encode$null,
					A2($krisajenkins$remotedata$RemoteData$map, $author$project$LoadableLocale$encodeLocale, user))),
				_Utils_Tuple2(
				'device',
				A2(
					$elm$core$Maybe$withDefault,
					$elm$json$Json$Encode$null,
					A2($elm$core$Maybe$map, $author$project$LoadableLocale$encodeLocale, device)))
			]));
};
var $author$project$LoadableTimeZone$encode = function (_v0) {
	var user = _v0.a;
	return A2(
		$krisajenkins$remotedata$RemoteData$withDefault,
		$elm$json$Json$Encode$null,
		A2(
			$krisajenkins$remotedata$RemoteData$map,
			A2($elm$core$Basics$composeR, $elm$core$Tuple$first, $elm$json$Json$Encode$string),
			user));
};
var $author$project$Manifest$encode = function (manifest) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'widgetUuid',
				$danyx23$elm_uuid$Uuid$encode(manifest.widgetUuid)),
				_Utils_Tuple2(
				'versionUuid',
				$danyx23$elm_uuid$Uuid$encode(manifest.versionUuid)),
				_Utils_Tuple2(
				'tagName',
				$elm$json$Json$Encode$string(manifest.tagName)),
				_Utils_Tuple2(
				'properties',
				A2($elm$json$Json$Encode$list, $elm$core$Basics$identity, _List_Nil)),
				_Utils_Tuple2(
				'fileName',
				$elm$json$Json$Encode$string(manifest.fileName))
			]));
};
var $author$project$UuidDict$encode = F2(
	function (encodeValue, _v0) {
		var dict = _v0.a;
		return $elm$json$Json$Encode$object(
			A2(
				$elm$core$List$map,
				$elm$core$Tuple$mapSecond(
					A2($elm$core$Basics$composeR, $elm$core$Tuple$second, encodeValue)),
				$elm$core$Dict$toList(dict)));
	});
var $author$project$RemoteData$Helpers$encodeRemoteData = F3(
	function (innerEncode, errorEncode, remoteData) {
		switch (remoteData.$) {
			case 'NotAsked':
				return $elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'type',
							$elm$json$Json$Encode$string('NotAsked'))
						]));
			case 'Loading':
				return $elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'type',
							$elm$json$Json$Encode$string('Loading'))
						]));
			case 'Failure':
				var e = remoteData.a;
				return $elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'type',
							$elm$json$Json$Encode$string('Failure')),
							_Utils_Tuple2(
							'error',
							errorEncode(e))
						]));
			default:
				var a = remoteData.a;
				return $elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'type',
							$elm$json$Json$Encode$string('Success')),
							_Utils_Tuple2(
							'item',
							innerEncode(a))
						]));
		}
	});
var $author$project$DataEngine$DataCache$encode = function (_v0) {
	var internal = _v0.a;
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'dataElements',
				A2(
					$author$project$UuidDict$encode,
					$author$project$DataEngine$CacheState$encode($author$project$DataEngine$DataElementCache$encode),
					internal.dataElementStates)),
				_Utils_Tuple2(
				'timeZone',
				$author$project$LoadableTimeZone$encode(internal.timeZone)),
				_Utils_Tuple2(
				'locale',
				$author$project$LoadableLocale$encode(internal.locale)),
				_Utils_Tuple2(
				'feedbackData',
				A3($author$project$RemoteData$Helpers$encodeRemoteData, $author$project$FeedbackData$encode, $author$project$MyInsights$encodeError, internal.feedbackData)),
				_Utils_Tuple2(
				'manifests',
				A2($elm$json$Json$Encode$list, $author$project$Manifest$encode, internal.manifests))
			]));
};
var $author$project$DisplayElement$Custom$encodeProperty = function (property) {
	if (property.$ === 'SingleValue') {
		var exp = property.a;
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'expression',
					A2($author$project$DataElement$Expression$applyGlobalField, $author$project$DataElement$Expression$encodeTransformer, exp))
				]));
	} else {
		var reference = property.a;
		var fields = property.b;
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'dataSource',
					$author$project$DataElement$Reference$encoder(reference)),
					_Utils_Tuple2(
					'fields',
					A3(
						$elm$json$Json$Encode$dict,
						$elm$core$Basics$identity,
						$author$project$DataElement$Expression$applyLocalField($author$project$DataElement$Expression$encodeTransformer),
						fields))
				]));
	}
};
var $author$project$DisplayElement$Custom$encode = function (info) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'uuid',
				$danyx23$elm_uuid$Uuid$encode(info.widgetUuid)),
				_Utils_Tuple2(
				'versionUuid',
				$danyx23$elm_uuid$Uuid$encode(info.versionUuid)),
				_Utils_Tuple2(
				'type',
				$elm$json$Json$Encode$string('Custom')),
				_Utils_Tuple2(
				'properties',
				A3($elm$json$Json$Encode$dict, $elm$core$Basics$identity, $author$project$DisplayElement$Custom$encodeProperty, info.properties))
			]));
};
var $author$project$DisplayElement$Datepicker$encode = function (info) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'state',
				$author$project$DataElement$Reference$encoder(info.state)),
				_Utils_Tuple2(
				'label',
				A2($author$project$DataElement$Expression$applyGlobalString, $author$project$DataElement$Expression$encodeTransformer, info.label)),
				_Utils_Tuple2(
				'type',
				$elm$json$Json$Encode$string('Date Picker'))
			]));
};
var $author$project$View$FieldList$Style$encode = function (style) {
	switch (style.$) {
		case 'Above':
			return $elm$json$Json$Encode$string('Above');
		case 'Inline':
			return $elm$json$Json$Encode$string('Inline');
		default:
			return $elm$json$Json$Encode$string('Horizontal');
	}
};
var $author$project$Icon$encode = function (_v0) {
	var category = _v0.a.category;
	var name = _v0.a.name;
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'name',
				$elm$json$Json$Encode$string(name)),
				_Utils_Tuple2(
				'category',
				$elm$json$Json$Encode$string(category))
			]));
};
var $author$project$UserAction$targetEncoder = function (target) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'Studio_Id_vod__c',
				$author$project$StudioContentId$encode(target))
			]));
};
var $author$project$UserAction$encodeNavigation = F2(
	function (encodeExpr, navAction) {
		switch (navAction.$) {
			case 'EditRecord':
				var info = navAction.a;
				return $elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'type',
							$elm$json$Json$Encode$string('EDIT_RECORD')),
							_Utils_Tuple2(
							'recordId',
							encodeExpr(info))
						]));
			case 'ViewRecord':
				var info = navAction.a;
				var targets = navAction.b;
				return $elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'type',
							$elm$json$Json$Encode$string('VIEW_RECORD')),
							_Utils_Tuple2(
							'recordId',
							encodeExpr(info)),
							_Utils_Tuple2(
							'target',
							A2($elm$json$Json$Encode$list, $author$project$UserAction$targetEncoder, targets))
						]));
			default:
				var targets = navAction.a;
				return $elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'type',
							$elm$json$Json$Encode$string('VIEW_SECTION')),
							_Utils_Tuple2(
							'target',
							A2(
								$elm$json$Json$Encode$list,
								$author$project$UserAction$targetEncoder,
								$mgold$elm_nonempty_list$List$Nonempty$toList(targets)))
						]));
		}
	});
var $author$project$UserAction$encode = F2(
	function (encodeExpr, actions) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'navigation',
					A2(
						$elm$core$Maybe$withDefault,
						$elm$json$Json$Encode$null,
						A2(
							$elm$core$Maybe$map,
							$author$project$UserAction$encodeNavigation(encodeExpr),
							actions.navigation)))
				]));
	});
var $author$project$DisplayElement$FieldList$encodeLabelValuePair = function (_v0) {
	var label = _v0.label;
	var value = _v0.value;
	var valueAction = _v0.valueAction;
	var icon = _v0.icon;
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'label',
				A2($author$project$DataElement$Expression$applyGlobalString, $author$project$DataElement$Expression$encodeTransformer, label)),
				_Utils_Tuple2(
				'value',
				A2($author$project$DataElement$Expression$applyGlobalString, $author$project$DataElement$Expression$encodeTransformer, value)),
				_Utils_Tuple2(
				'valueAction',
				A2(
					$author$project$UserAction$encode,
					$author$project$DataElement$Expression$applyGlobalString($author$project$DataElement$Expression$encodeTransformer),
					valueAction)),
				_Utils_Tuple2(
				'icon',
				A2(
					$elm$core$Maybe$withDefault,
					$elm$json$Json$Encode$null,
					A2($elm$core$Maybe$map, $author$project$Icon$encode, icon)))
			]));
};
var $author$project$DisplayElement$FieldList$encode = function (_v0) {
	var info = _v0.a;
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'type',
				$elm$json$Json$Encode$string('Field List')),
				_Utils_Tuple2(
				'style',
				$author$project$View$FieldList$Style$encode(info.style)),
				_Utils_Tuple2(
				'items',
				A2($elm$json$Json$Encode$list, $author$project$DisplayElement$FieldList$encodeLabelValuePair, info.labelValuePairs))
			]));
};
var $author$project$DisplayElement$MetricHighlight$encodeMetricValue = function (metricValue) {
	switch (metricValue.$) {
		case 'StringValue':
			var globalString = metricValue.a;
			return _List_fromArray(
				[
					_Utils_Tuple2(
					'value',
					A2($author$project$DataElement$Expression$applyGlobalString, $author$project$DataElement$Expression$encodeTransformer, globalString))
				]);
		case 'NumberValue':
			var globalNumber = metricValue.a;
			var decimals = metricValue.b;
			return _List_fromArray(
				[
					_Utils_Tuple2(
					'value',
					A2($author$project$DataElement$Expression$applyGlobalNumber, $author$project$DataElement$Expression$encodeTransformer, globalNumber)),
					_Utils_Tuple2(
					'decimals',
					$elm$json$Json$Encode$int(decimals))
				]);
		case 'DateValue':
			var globalDate = metricValue.a;
			var formatExpression = metricValue.b;
			return _List_fromArray(
				[
					_Utils_Tuple2(
					'value',
					A2($author$project$DataElement$Expression$applyGlobalDate, $author$project$DataElement$Expression$encodeTransformer, globalDate)),
					_Utils_Tuple2(
					'formatExpression',
					A2($author$project$DataElement$Expression$applyGlobalString, $author$project$DataElement$Expression$encodeTransformer, formatExpression))
				]);
		default:
			var globalBool = metricValue.a;
			return _List_fromArray(
				[
					_Utils_Tuple2(
					'value',
					A2($author$project$DataElement$Expression$applyGlobalBool, $author$project$DataElement$Expression$encodeTransformer, globalBool))
				]);
	}
};
var $author$project$DisplayElement$MetricHighlight$encodeLabelValuePair = function (_v0) {
	var label = _v0.label;
	var value = _v0.value;
	var action = _v0.action;
	var icon = _v0.icon;
	return $elm$json$Json$Encode$object(
		_Utils_ap(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'label',
					A2($author$project$DataElement$Expression$applyGlobalString, $author$project$DataElement$Expression$encodeTransformer, label)),
					_Utils_Tuple2(
					'valueAction',
					A2(
						$author$project$UserAction$encode,
						$author$project$DataElement$Expression$applyGlobalString($author$project$DataElement$Expression$encodeTransformer),
						action)),
					_Utils_Tuple2(
					'icon',
					A2(
						$elm$core$Maybe$withDefault,
						$elm$json$Json$Encode$null,
						A2($elm$core$Maybe$map, $author$project$Icon$encode, icon)))
				]),
			$author$project$DisplayElement$MetricHighlight$encodeMetricValue(value)));
};
var $author$project$DisplayElement$MetricHighlight$encode = function (_v0) {
	var info = _v0.a;
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'type',
				$elm$json$Json$Encode$string('Metric Highlight')),
				_Utils_Tuple2(
				'first',
				$author$project$DisplayElement$MetricHighlight$encodeLabelValuePair(info.first)),
				_Utils_Tuple2(
				'second',
				A2(
					$elm$core$Maybe$withDefault,
					$elm$json$Json$Encode$null,
					A2($elm$core$Maybe$map, $author$project$DisplayElement$MetricHighlight$encodeLabelValuePair, info.second)))
			]));
};
var $author$project$DisplayElement$ProgressChart$encode = function (_v0) {
	var info = _v0.a;
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'type',
				$elm$json$Json$Encode$string('Progress Chart')),
				_Utils_Tuple2(
				'value',
				A2($author$project$DataElement$Expression$applyGlobalNumber, $author$project$DataElement$Expression$encodeTransformer, info.value)),
				_Utils_Tuple2(
				'goal',
				A2($author$project$DataElement$Expression$applyGlobalNumber, $author$project$DataElement$Expression$encodeTransformer, info.goal)),
				_Utils_Tuple2(
				'overflow',
				$elm$json$Json$Encode$bool(info.allowOverflow))
			]));
};
var $author$project$DisplayElement$Section$Header$encode = function (_v0) {
	var title = _v0.title;
	var action = _v0.action;
	var icon = _v0.icon;
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'title',
				$elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'expression',
							A2($author$project$DataElement$Expression$applyGlobalString, $author$project$DataElement$Expression$encodeTransformer, title)),
							_Utils_Tuple2(
							'action',
							A2(
								$author$project$UserAction$encode,
								$author$project$DataElement$Expression$applyGlobalString($author$project$DataElement$Expression$encodeTransformer),
								action))
						]))),
				_Utils_Tuple2(
				'icon',
				A2(
					$elm$core$Maybe$withDefault,
					$elm$json$Json$Encode$null,
					A2($elm$core$Maybe$map, $author$project$Icon$encode, icon)))
			]));
};
var $author$project$DisplayElement$Section$encode = function (info) {
	if (info.$ === 'SectionWithoutHeader') {
		return $elm$core$Maybe$Nothing;
	} else {
		var header = info.a;
		return $elm$core$Maybe$Just(
			_Utils_Tuple2(
				'header',
				$author$project$DisplayElement$Section$Header$encode(header)));
	}
};
var $author$project$DisplayElement$Select$encode = function (info) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'state',
				$author$project$DataElement$Reference$encoder(info.state)),
				_Utils_Tuple2(
				'label',
				A2($author$project$DataElement$Expression$applyGlobalString, $author$project$DataElement$Expression$encodeTransformer, info.label)),
				_Utils_Tuple2(
				'type',
				$elm$json$Json$Encode$string('Dropdown'))
			]));
};
var $author$project$DisplayElement$Table$encodeBasicColumn = F2(
	function (fieldType, _v0) {
		var header = _v0.header;
		var value = _v0.value;
		var valueAction = _v0.valueAction;
		var lineWrap = _v0.lineWrap;
		var userSortable = _v0.userSortable;
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'field',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'dataType',
								$author$project$FieldType$encode(fieldType)),
								_Utils_Tuple2(
								'name',
								$author$project$FieldName$encode(value)),
								_Utils_Tuple2(
								'action',
								A2(
									$author$project$UserAction$encode,
									$author$project$DataElement$Expression$applyLocalString($author$project$DataElement$Expression$encodeTransformer),
									valueAction))
							]))),
					_Utils_Tuple2(
					'headerExpression',
					A2($author$project$DataElement$Expression$applyGlobalString, $author$project$DataElement$Expression$encodeTransformer, header)),
					_Utils_Tuple2(
					'lineWrap',
					$elm$json$Json$Encode$bool(lineWrap)),
					_Utils_Tuple2(
					'userSortable',
					$elm$json$Json$Encode$bool(userSortable))
				]));
	});
var $author$project$DisplayElement$Table$encodeDateColumn = function (_v0) {
	var header = _v0.header;
	var value = _v0.value;
	var format = _v0.format;
	var valueAction = _v0.valueAction;
	var lineWrap = _v0.lineWrap;
	var userSortable = _v0.userSortable;
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'field',
				$elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'dataType',
							$author$project$FieldType$encode($author$project$FieldType$DateType)),
							_Utils_Tuple2(
							'name',
							$author$project$FieldName$encode(value)),
							_Utils_Tuple2(
							'format',
							A2(
								$elm$core$Maybe$withDefault,
								$elm$json$Json$Encode$null,
								A2($elm$core$Maybe$map, $elm$json$Json$Encode$string, format))),
							_Utils_Tuple2(
							'action',
							A2(
								$author$project$UserAction$encode,
								$author$project$DataElement$Expression$applyLocalString($author$project$DataElement$Expression$encodeTransformer),
								valueAction))
						]))),
				_Utils_Tuple2(
				'headerExpression',
				A2($author$project$DataElement$Expression$applyGlobalString, $author$project$DataElement$Expression$encodeTransformer, header)),
				_Utils_Tuple2(
				'lineWrap',
				$elm$json$Json$Encode$bool(lineWrap)),
				_Utils_Tuple2(
				'userSortable',
				$elm$json$Json$Encode$bool(userSortable))
			]));
};
var $author$project$DisplayElement$Table$encodeColumns = function (column) {
	switch (column.$) {
		case 'StringColumn':
			var basicCol = column.a;
			return A2($author$project$DisplayElement$Table$encodeBasicColumn, $author$project$FieldType$StringType, basicCol);
		case 'NumberColumn':
			var basicCol = column.a;
			return A2($author$project$DisplayElement$Table$encodeBasicColumn, $author$project$FieldType$NumberType, basicCol);
		case 'DateColumn':
			var dateCol = column.a;
			return $author$project$DisplayElement$Table$encodeDateColumn(dateCol);
		case 'DateTimeColumn':
			var basicCol = column.a;
			return A2($author$project$DisplayElement$Table$encodeBasicColumn, $author$project$FieldType$DateTimeType, basicCol);
		default:
			var basicCol = column.a;
			return A2($author$project$DisplayElement$Table$encodeBasicColumn, $author$project$FieldType$BoolType, basicCol);
	}
};
var $author$project$DisplayElement$Table$encode = function (_v0) {
	var internals = _v0.a;
	return _List_fromArray(
		[
			_Utils_Tuple2(
			'dataSource',
			$author$project$DataElement$Reference$encoder(internals.dataElement)),
			_Utils_Tuple2(
			'columns',
			A2($elm$json$Json$Encode$list, $author$project$DisplayElement$Table$encodeColumns, internals.columns))
		]);
};
var $author$project$DisplayElement$TrendChart$encode = function (_v0) {
	var inner = _v0.a;
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'type',
				$elm$json$Json$Encode$string('Trend Chart')),
				_Utils_Tuple2(
				'dataSource',
				$author$project$DataElement$Reference$encoder(inner.dataSource)),
				_Utils_Tuple2(
				'date',
				A2($author$project$DataElement$Expression$applyLocalDate, $author$project$DataElement$Expression$encodeTransformer, inner.date)),
				_Utils_Tuple2(
				'value',
				A2($author$project$DataElement$Expression$applyLocalNumber, $author$project$DataElement$Expression$encodeTransformer, inner.value)),
				_Utils_Tuple2(
				'series',
				A2($author$project$DataElement$Expression$applyLocalString, $author$project$DataElement$Expression$encodeTransformer, inner.series)),
				_Utils_Tuple2(
				'timeUnit',
				$author$project$DateUnit$encode(inner.dateUnit))
			]));
};
var $author$project$View$Row$encode = function (_v0) {
	return $elm$json$Json$Encode$null;
};
var $author$project$DisplayElement$encode = function (element) {
	switch (element.$) {
		case 'Column':
			var children = element.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('Column')),
						_Utils_Tuple2(
						'children',
						A2($elm$json$Json$Encode$list, $author$project$DisplayElement$encode, children))
					]));
		case 'Row':
			var config = element.a;
			var children = element.b;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('Row')),
						_Utils_Tuple2(
						'config',
						$author$project$View$Row$encode(config)),
						_Utils_Tuple2(
						'children',
						A2($elm$json$Json$Encode$list, $author$project$DisplayElement$encode, children))
					]));
		case 'Section':
			var section = element.a;
			var maybeBody = element.b;
			return $elm$json$Json$Encode$object(
				A2(
					$elm$core$List$filterMap,
					$elm$core$Basics$identity,
					_List_fromArray(
						[
							$elm$core$Maybe$Just(
							_Utils_Tuple2(
								'type',
								$elm$json$Json$Encode$string('Section'))),
							$author$project$DisplayElement$Section$encode(section),
							$elm$core$Maybe$Just(
							_Utils_Tuple2(
								'body',
								A2(
									$elm$core$Maybe$withDefault,
									$elm$json$Json$Encode$null,
									A2($elm$core$Maybe$map, $author$project$DisplayElement$encode, maybeBody))))
						])));
		case 'Table':
			var info = element.a;
			return $elm$json$Json$Encode$object(
				A2(
					$elm$core$List$cons,
					_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('Table')),
					$author$project$DisplayElement$Table$encode(info)));
		case 'ProgressChart':
			var info = element.a;
			return $author$project$DisplayElement$ProgressChart$encode(info);
		case 'TrendChart':
			var info = element.a;
			return $author$project$DisplayElement$TrendChart$encode(info);
		case 'FieldList':
			var info = element.a;
			return $author$project$DisplayElement$FieldList$encode(info);
		case 'MetricHighlight':
			var info = element.a;
			return $author$project$DisplayElement$MetricHighlight$encode(info);
		case 'Custom':
			var info = element.a;
			return $author$project$DisplayElement$Custom$encode(info);
		case 'Select':
			var info = element.a;
			return $author$project$DisplayElement$Select$encode(info);
		default:
			var info = element.a;
			return $author$project$DisplayElement$Datepicker$encode(info);
	}
};
var $author$project$Page$encode = function (_v0) {
	var pageName = _v0.a;
	var element = _v0.b;
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'name',
				$elm$json$Json$Encode$string(pageName)),
				_Utils_Tuple2(
				'display',
				$author$project$DisplayElement$encode(element))
			]));
};
var $author$project$Preview$Request$encode = function (request) {
	if (request.$ === 'Data') {
		var ref = request.a;
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'type',
					$elm$json$Json$Encode$string('Data')),
					_Utils_Tuple2(
					'uuid',
					$author$project$DataElement$Reference$encoder(ref))
				]));
	} else {
		var pageName = request.a;
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'type',
					$elm$json$Json$Encode$string('Page')),
					_Utils_Tuple2(
					'pageName',
					$elm$json$Json$Encode$string(pageName))
				]));
	}
};
var $author$project$StudioApp$Error$encodeContext = function (context) {
	switch (context.$) {
		case 'InDataElements':
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('InDataElements'))
					]));
		case 'InDataElement':
			var name = context.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('InDataElement')),
						_Utils_Tuple2(
						'name',
						$elm$json$Json$Encode$string(name))
					]));
		case 'InPage':
			var name = context.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('InPage')),
						_Utils_Tuple2(
						'name',
						$elm$json$Json$Encode$string(name))
					]));
		case 'InCustomDisplayElement':
			var widgetUuid = context.a;
			var versionUuid = context.b;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('InCustomDisplayElement')),
						_Utils_Tuple2(
						'widgetUuid',
						$danyx23$elm_uuid$Uuid$encode(widgetUuid)),
						_Utils_Tuple2(
						'versionUuid',
						$danyx23$elm_uuid$Uuid$encode(versionUuid))
					]));
		default:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('InExpressionInput'))
					]));
	}
};
var $author$project$StudioApp$Error$encode = function (error) {
	switch (error.$) {
		case 'NamesTooSimilar':
			var context = error.a;
			var name = error.b;
			var match = error.c;
			var others = error.d;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('NamesTooSimilar')),
						_Utils_Tuple2(
						'context',
						$author$project$StudioApp$Error$encodeContext(context)),
						_Utils_Tuple2(
						'name',
						$elm$json$Json$Encode$string(name)),
						_Utils_Tuple2(
						'match',
						$elm$json$Json$Encode$string(match)),
						_Utils_Tuple2(
						'otherMatches',
						A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, others))
					]));
		case 'TripleUnderscoreNotAllowed':
			var context = error.a;
			var name = error.b;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('TripleUnderscoreNotAllowed')),
						_Utils_Tuple2(
						'context',
						$author$project$StudioApp$Error$encodeContext(context)),
						_Utils_Tuple2(
						'name',
						$elm$json$Json$Encode$string(name))
					]));
		case 'CyclicDependency':
			var context = error.a;
			var name = error.b;
			var others = error.c;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('CyclicDependency')),
						_Utils_Tuple2(
						'context',
						$author$project$StudioApp$Error$encodeContext(context)),
						_Utils_Tuple2(
						'name',
						$elm$json$Json$Encode$string(name)),
						_Utils_Tuple2(
						'others',
						A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, others))
					]));
		case 'InvalidRecordListReference':
			var context = error.a;
			var ref = error.b;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('InvalidRecordListReference')),
						_Utils_Tuple2(
						'context',
						$author$project$StudioApp$Error$encodeContext(context)),
						_Utils_Tuple2(
						'uuid',
						$author$project$DataElement$Reference$encoder(ref))
					]));
		case 'InvalidDatepickerReference':
			var context = error.a;
			var ref = error.b;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('InvalidDatepickerReference')),
						_Utils_Tuple2(
						'context',
						$author$project$StudioApp$Error$encodeContext(context)),
						_Utils_Tuple2(
						'uuid',
						$author$project$DataElement$Reference$encoder(ref))
					]));
		case 'InvalidDropdownReference':
			var context = error.a;
			var ref = error.b;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('InvalidDropdownReference')),
						_Utils_Tuple2(
						'context',
						$author$project$StudioApp$Error$encodeContext(context)),
						_Utils_Tuple2(
						'uuid',
						$author$project$DataElement$Reference$encoder(ref))
					]));
		case 'RecordListReferenceNotFound':
			var context = error.a;
			var ref = error.b;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('RecordListReferenceNotFound')),
						_Utils_Tuple2(
						'context',
						$author$project$StudioApp$Error$encodeContext(context)),
						_Utils_Tuple2(
						'uuid',
						$author$project$DataElement$Reference$encoder(ref))
					]));
		case 'DatepickerReferenceNotFound':
			var context = error.a;
			var ref = error.b;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('DatepickerReferenceNotFound')),
						_Utils_Tuple2(
						'context',
						$author$project$StudioApp$Error$encodeContext(context)),
						_Utils_Tuple2(
						'uuid',
						$author$project$DataElement$Reference$encoder(ref))
					]));
		case 'DropdownReferenceNotFound':
			var context = error.a;
			var ref = error.b;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('DropdownReferenceNotFound')),
						_Utils_Tuple2(
						'context',
						$author$project$StudioApp$Error$encodeContext(context)),
						_Utils_Tuple2(
						'uuid',
						$author$project$DataElement$Reference$encoder(ref))
					]));
		case 'WrongTypeError':
			var context = error.a;
			var name = error.b;
			var expected = error.c;
			var gotInstead = error.d;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('WrongTypeError')),
						_Utils_Tuple2(
						'context',
						$author$project$StudioApp$Error$encodeContext(context)),
						_Utils_Tuple2(
						'name',
						$elm$json$Json$Encode$string(name)),
						_Utils_Tuple2(
						'expected',
						$author$project$FieldType$encode(expected)),
						_Utils_Tuple2(
						'gotInstead',
						$author$project$FieldType$encode(gotInstead))
					]));
		case 'FieldNotFound':
			var context = error.a;
			var name = error.b;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('FieldNotFound')),
						_Utils_Tuple2(
						'context',
						$author$project$StudioApp$Error$encodeContext(context)),
						_Utils_Tuple2(
						'name',
						$elm$json$Json$Encode$string(name))
					]));
		case 'DataElementMissingFields':
			var name = error.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('DataElementMissingFields')),
						_Utils_Tuple2(
						'name',
						$elm$json$Json$Encode$string(name))
					]));
		case 'MoreThanOneVeevaMessagesDataElement':
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('MoreThanOneVeevaMessagesDataElement'))
					]));
		case 'TagNamesTooSimilar':
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('TagNamesTooSimilar'))
					]));
		case 'CannotFindManifest':
			var widgetUuid = error.a;
			var versionUuid = error.b;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('CannotFindManifest')),
						_Utils_Tuple2(
						'widgetUuid',
						$danyx23$elm_uuid$Uuid$encode(widgetUuid)),
						_Utils_Tuple2(
						'versionUuid',
						$danyx23$elm_uuid$Uuid$encode(versionUuid))
					]));
		case 'FieldMisMatched':
			var context = error.a;
			var name = error.b;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('FieldMisMatched')),
						_Utils_Tuple2(
						'context',
						$author$project$StudioApp$Error$encodeContext(context)),
						_Utils_Tuple2(
						'name',
						$elm$json$Json$Encode$string(name))
					]));
		case 'ManifestsConflict':
			var widgetUuid = error.a;
			var versionUuid = error.b;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('ManifestsConflict')),
						_Utils_Tuple2(
						'widgetUuid',
						$danyx23$elm_uuid$Uuid$encode(widgetUuid)),
						_Utils_Tuple2(
						'versionUuid',
						$danyx23$elm_uuid$Uuid$encode(versionUuid))
					]));
		default:
			var context = error.a;
			var fieldName = error.b;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('CannotDetermineFieldType')),
						_Utils_Tuple2(
						'context',
						$author$project$StudioApp$Error$encodeContext(context)),
						_Utils_Tuple2(
						'fieldName',
						$elm$json$Json$Encode$string(fieldName))
					]));
	}
};
var $author$project$Preview$ToPreviewMsg$encode = function (msg) {
	switch (msg.$) {
		case 'DataPreviewResponse':
			var uuid = msg.a;
			var elementCache = msg.b;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('DataPreviewResponse')),
						_Utils_Tuple2(
						'uuid',
						$author$project$DataElement$Reference$encoder(uuid)),
						_Utils_Tuple2(
						'cache',
						$author$project$DataEngine$DataElementCache$encode(elementCache))
					]));
		case 'DataDropdownPreviewResponse':
			var uuid = msg.a;
			var dropdownInfo = msg.b;
			var dataCache = msg.c;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('DataDropdownPreviewResponse')),
						_Utils_Tuple2(
						'uuid',
						$author$project$DataElement$Reference$encoder(uuid)),
						_Utils_Tuple2(
						'dropdownInfo',
						A2($author$project$DataElement$Dropdown$encode, '', dropdownInfo)),
						_Utils_Tuple2(
						'dataCache',
						$author$project$DataEngine$DataCache$encode(dataCache))
					]));
		case 'DataDatepickerPreviewResponse':
			var uuid = msg.a;
			var info = msg.b;
			var dataCache = msg.c;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('DataDatepickerPreviewResponse')),
						_Utils_Tuple2(
						'uuid',
						$author$project$DataElement$Reference$encoder(uuid)),
						_Utils_Tuple2(
						'datepickerInfo',
						A2($author$project$DataElement$Datepicker$encode, '', info)),
						_Utils_Tuple2(
						'dataCache',
						$author$project$DataEngine$DataCache$encode(dataCache))
					]));
		case 'PagePreviewResponse':
			var page = msg.a;
			var cache = msg.b;
			var dataElements = msg.c;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('PagePreviewResponse')),
						_Utils_Tuple2(
						'page',
						$author$project$Page$encode(page)),
						_Utils_Tuple2(
						'cache',
						$author$project$DataEngine$DataCache$encode(cache)),
						_Utils_Tuple2(
						'dataElements',
						$author$project$DataElement$collectionEncoder(dataElements))
					]));
		case 'RequestNotFound':
			var request = msg.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('RequestNotFound')),
						_Utils_Tuple2(
						'request',
						$author$project$Preview$Request$encode(request))
					]));
		case 'ErrorDuringQuery':
			var request = msg.a;
			var err = msg.b;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('ErrorDuringQuery')),
						_Utils_Tuple2(
						'request',
						$author$project$Preview$Request$encode(request)),
						_Utils_Tuple2(
						'error',
						$author$project$MyInsights$encodeError(err))
					]));
		default:
			var request = msg.a;
			var errors = msg.b;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('ErrorsDuringValidation')),
						_Utils_Tuple2(
						'request',
						$author$project$Preview$Request$encode(request)),
						_Utils_Tuple2(
						'errors',
						A2(
							$elm$json$Json$Encode$list,
							$author$project$StudioApp$Error$encode,
							$mgold$elm_nonempty_list$List$Nonempty$toList(errors)))
					]));
	}
};
var $author$project$Compiler$sendToPreview = _Platform_outgoingPort('sendToPreview', $elm$core$Basics$identity);
var $author$project$Compiler$toPreview = A2($elm$core$Basics$composeR, $author$project$Preview$ToPreviewMsg$encode, $author$project$Compiler$sendToPreview);
var $author$project$Compiler$respondToRequest = F2(
	function (toPreviewMsg, model) {
		return A2(
			$Fresheyeball$elm_return$Return$command,
			$author$project$Compiler$toPreview(toPreviewMsg),
			$Fresheyeball$elm_return$Return$singleton(model));
	});
var $author$project$Compiler$processDataRequest = F2(
	function (ref, model) {
		var _v0 = A3($author$project$DataEngine$processDataRequest, ref, model.app, model.cache);
		if (_v0.$ === 'Ok') {
			switch (_v0.a.$) {
				case 'NotFound':
					return A2(
						$author$project$Compiler$respondToRequest,
						$author$project$Preview$ToPreviewMsg$RequestNotFound(
							$author$project$Preview$Request$Data(ref)),
						model);
				case 'PageNotFound':
					return A2(
						$author$project$Compiler$respondToRequest,
						$author$project$Preview$ToPreviewMsg$RequestNotFound(
							$author$project$Preview$Request$Data(ref)),
						model);
				case 'Ready':
					switch (_v0.a.a.$) {
						case 'NormalResponse':
							var elementCache = _v0.a.a.a;
							return A2(
								$author$project$Compiler$respondToRequest,
								A2($author$project$Preview$ToPreviewMsg$DataPreviewResponse, ref, elementCache),
								model);
						case 'DropdownResponse':
							var _v1 = _v0.a.a;
							var dropdownInfo = _v1.a;
							var trimmedCache = _v1.b;
							var _v2 = A2(
								$author$project$DataElement$getEitherFromReferenceElement,
								$author$project$StudioApp$dataElements(model.app),
								ref);
							if (_v2.$ === 'Just') {
								var either = _v2.a;
								if (either.$ === 'IsSingleton') {
									var singleRef = either.a;
									return A2(
										$author$project$Compiler$respondToRequest,
										A3($author$project$Preview$ToPreviewMsg$DataDropdownPreviewResponse, singleRef, dropdownInfo, trimmedCache),
										model);
								} else {
									return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
								}
							} else {
								return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
							}
						default:
							var _v4 = _v0.a.a;
							var datepickerInfo = _v4.a;
							var trimmedCache = _v4.b;
							var _v5 = A2(
								$author$project$DataElement$getEitherFromReferenceElement,
								$author$project$StudioApp$dataElements(model.app),
								ref);
							if (_v5.$ === 'Just') {
								var either = _v5.a;
								if (either.$ === 'IsSingleton') {
									var singleRef = either.a;
									return A2(
										$author$project$Compiler$respondToRequest,
										A3($author$project$Preview$ToPreviewMsg$DataDatepickerPreviewResponse, singleRef, datepickerInfo, trimmedCache),
										model);
								} else {
									return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
								}
							} else {
								return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
							}
					}
				case 'QueryError':
					var err = _v0.a.a;
					return A2(
						$author$project$Compiler$respondToRequest,
						A2(
							$author$project$Preview$ToPreviewMsg$ErrorDuringQuery,
							$author$project$Preview$Request$Data(ref),
							err),
						model);
				case 'QueryRunningPleaseWait':
					var _v7 = _v0.a;
					var _v8 = A2($elm$core$Debug$log, 'Keep Waiting', 'Log this?');
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				default:
					var nextQuery = _v0.a.a;
					return A2(
						$Fresheyeball$elm_return$Return$command,
						$author$project$Compiler$runQuery(nextQuery),
						$Fresheyeball$elm_return$Return$singleton(
							_Utils_update(
								model,
								{
									cache: A2(
										$author$project$DataEngine$DataCache$markLoading,
										$author$project$DataElement$Reference$getGenericReferenceFromEither(nextQuery.ref),
										model.cache)
								})));
			}
		} else {
			var errors = _v0.a;
			return A2(
				$author$project$Compiler$respondToRequest,
				A2(
					$author$project$Preview$ToPreviewMsg$ErrorsDuringValidation,
					$author$project$Preview$Request$Data(ref),
					errors),
				model);
		}
	});
var $author$project$Preview$ToPreviewMsg$PagePreviewResponse = F3(
	function (a, b, c) {
		return {$: 'PagePreviewResponse', a: a, b: b, c: c};
	});
var $author$project$DataEngine$Output$PageNotFound = function (a) {
	return {$: 'PageNotFound', a: a};
};
var $author$project$Page$name = function (_v0) {
	var pageName = _v0.a;
	return pageName;
};
var $author$project$DataEngine$getPageByName = F2(
	function (pageName, app) {
		return $elm$core$List$head(
			A2(
				$elm$core$List$filter,
				function (page) {
					return _Utils_eq(
						$author$project$Page$name(page),
						pageName);
				},
				$mgold$elm_nonempty_list$List$Nonempty$toList(
					$author$project$StudioApp$pages(app))));
	});
var $author$project$DisplayElement$Custom$getPropertyDependencyUuids = function (property) {
	if (property.$ === 'SingleValue') {
		var exp = property.a;
		return A2($author$project$DataElement$Expression$applyGlobalField, $author$project$DataElement$Expression$dependencyTransformer, exp);
	} else {
		var ref = property.a;
		var fields = property.b;
		return A2(
			$elm$core$List$cons,
			$author$project$DataElement$Reference$getGenericReference(ref),
			A2(
				$elm$core$List$concatMap,
				$author$project$DataElement$Expression$applyLocalField($author$project$DataElement$Expression$dependencyTransformer),
				$elm$core$Dict$values(fields)));
	}
};
var $author$project$DisplayElement$Custom$getDependencyReferences = function (info) {
	return A2(
		$elm$core$List$concatMap,
		$author$project$DisplayElement$Custom$getPropertyDependencyUuids,
		$elm$core$Dict$values(info.properties));
};
var $author$project$DataElement$Datepicker$getDependencyReferences = function (info) {
	return A3(
		$elm_community$maybe_extra$Maybe$Extra$unwrap,
		_List_Nil,
		$author$project$DataElement$Expression$applyGlobalDate($author$project$DataElement$Expression$dependencyTransformer),
		info._default);
};
var $author$project$DataElement$toDatepicker = function (_v0) {
	var element = _v0.b;
	if ((element.$ === 'Singleton') && (element.a.$ === 'DatepickerSelection')) {
		var info = element.a.a;
		return $elm$core$Maybe$Just(info);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$DisplayElement$Datepicker$getDependencyReferences = F2(
	function (dataElements, info) {
		var elem = A2(
			$elm$core$Maybe$andThen,
			$author$project$DataElement$toDatepicker,
			A2($author$project$DataElement$getDataElementFromReferenceElement, dataElements, info.state));
		return A2(
			$elm$core$List$cons,
			$author$project$DataElement$Reference$getGenericReference(info.state),
			_Utils_ap(
				A2($author$project$DataElement$Expression$applyGlobalString, $author$project$DataElement$Expression$dependencyTransformer, info.label),
				A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2($elm$core$Maybe$map, $author$project$DataElement$Datepicker$getDependencyReferences, elem))));
	});
var $author$project$UserAction$extractMetadataFromNavigationAction = function (navAction) {
	switch (navAction.$) {
		case 'EditRecord':
			var item = navAction.a;
			return _List_fromArray(
				[item]);
		case 'ViewRecord':
			var item = navAction.a;
			return _List_fromArray(
				[item]);
		default:
			return _List_Nil;
	}
};
var $author$project$UserAction$extractMetadata = function (userActions) {
	return A2(
		$elm$core$Maybe$withDefault,
		_List_Nil,
		A2($elm$core$Maybe$map, $author$project$UserAction$extractMetadataFromNavigationAction, userActions.navigation));
};
var $author$project$DisplayElement$FieldList$getLabelValuePairDependencies = function (_v0) {
	var value = _v0.value;
	var label = _v0.label;
	var valueAction = _v0.valueAction;
	return _Utils_ap(
		A2($author$project$DataElement$Expression$applyGlobalString, $author$project$DataElement$Expression$dependencyTransformer, value),
		_Utils_ap(
			A2($author$project$DataElement$Expression$applyGlobalString, $author$project$DataElement$Expression$dependencyTransformer, label),
			A2(
				$elm$core$List$concatMap,
				$author$project$DataElement$Expression$applyGlobalString($author$project$DataElement$Expression$dependencyTransformer),
				$author$project$UserAction$extractMetadata(valueAction))));
};
var $author$project$DisplayElement$FieldList$getDependencyReferences = function (_v0) {
	var innerInfo = _v0.a;
	return A2($elm$core$List$concatMap, $author$project$DisplayElement$FieldList$getLabelValuePairDependencies, innerInfo.labelValuePairs);
};
var $author$project$DisplayElement$MetricHighlight$getMetricValueDependencies = function (metricValue) {
	switch (metricValue.$) {
		case 'StringValue':
			var globalString = metricValue.a;
			return A2($author$project$DataElement$Expression$applyGlobalString, $author$project$DataElement$Expression$dependencyTransformer, globalString);
		case 'NumberValue':
			var globalNumber = metricValue.a;
			return A2($author$project$DataElement$Expression$applyGlobalNumber, $author$project$DataElement$Expression$dependencyTransformer, globalNumber);
		case 'DateValue':
			var globalDate = metricValue.a;
			var formatExpression = metricValue.b;
			return _Utils_ap(
				A2($author$project$DataElement$Expression$applyGlobalDate, $author$project$DataElement$Expression$dependencyTransformer, globalDate),
				A2($author$project$DataElement$Expression$applyGlobalString, $author$project$DataElement$Expression$dependencyTransformer, formatExpression));
		default:
			var globalBool = metricValue.a;
			return A2($author$project$DataElement$Expression$applyGlobalBool, $author$project$DataElement$Expression$dependencyTransformer, globalBool);
	}
};
var $author$project$DisplayElement$MetricHighlight$getLabelValuePairDependencies = function (_v0) {
	var value = _v0.value;
	var label = _v0.label;
	var action = _v0.action;
	return _Utils_ap(
		A2($author$project$DataElement$Expression$applyGlobalString, $author$project$DataElement$Expression$dependencyTransformer, label),
		_Utils_ap(
			$author$project$DisplayElement$MetricHighlight$getMetricValueDependencies(value),
			A2(
				$elm$core$List$concatMap,
				$author$project$DataElement$Expression$applyGlobalString($author$project$DataElement$Expression$dependencyTransformer),
				$author$project$UserAction$extractMetadata(action))));
};
var $author$project$DisplayElement$MetricHighlight$getDependencyReferences = function (_v0) {
	var innerInfo = _v0.a;
	return _Utils_ap(
		$author$project$DisplayElement$MetricHighlight$getLabelValuePairDependencies(innerInfo.first),
		A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2($elm$core$Maybe$map, $author$project$DisplayElement$MetricHighlight$getLabelValuePairDependencies, innerInfo.second)));
};
var $author$project$DisplayElement$ProgressChart$getDependencyReferences = function (_v0) {
	var innerInfo = _v0.a;
	return _Utils_ap(
		A2($author$project$DataElement$Expression$applyGlobalNumber, $author$project$DataElement$Expression$dependencyTransformer, innerInfo.value),
		A2($author$project$DataElement$Expression$applyGlobalNumber, $author$project$DataElement$Expression$dependencyTransformer, innerInfo.goal));
};
var $author$project$DisplayElement$Section$Header$getDependencyReferences = function (header) {
	return _Utils_ap(
		A2($author$project$DataElement$Expression$applyGlobalString, $author$project$DataElement$Expression$dependencyTransformer, header.title),
		A2(
			$elm$core$List$concatMap,
			$author$project$DataElement$Expression$applyGlobalString($author$project$DataElement$Expression$dependencyTransformer),
			$author$project$UserAction$extractMetadata(header.action)));
};
var $author$project$DisplayElement$Section$getDependencyReferences = function (info) {
	if (info.$ === 'SectionWithoutHeader') {
		return _List_Nil;
	} else {
		var header = info.a;
		return $author$project$DisplayElement$Section$Header$getDependencyReferences(header);
	}
};
var $author$project$DataElement$Dropdown$getDependencyReferences = function (info) {
	return _Utils_ap(
		A2($author$project$DataElement$Expression$applyGlobalStringList, $author$project$DataElement$Expression$dependencyTransformer, info.options),
		A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			_List_Nil,
			$author$project$DataElement$Expression$applyGlobalString($author$project$DataElement$Expression$dependencyTransformer),
			info.placeholder));
};
var $author$project$DataElement$toDropdown = function (_v0) {
	var element = _v0.b;
	if ((element.$ === 'Singleton') && (element.a.$ === 'InteractiveSelectSelection')) {
		var info = element.a.a;
		return $elm$core$Maybe$Just(info);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$DisplayElement$Select$getDependencyReferences = F2(
	function (dataElements, info) {
		var elem = A2(
			$elm$core$Maybe$andThen,
			$author$project$DataElement$toDropdown,
			A2($author$project$DataElement$getDataElementFromReferenceElement, dataElements, info.state));
		return A2(
			$elm$core$List$cons,
			$author$project$DataElement$Reference$getGenericReference(info.state),
			_Utils_ap(
				A2($author$project$DataElement$Expression$applyGlobalString, $author$project$DataElement$Expression$dependencyTransformer, info.label),
				A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2($elm$core$Maybe$map, $author$project$DataElement$Dropdown$getDependencyReferences, elem))));
	});
var $author$project$DisplayElement$Table$getBasicColumnDependencyRefs = function (basicCol) {
	return _Utils_ap(
		A2($author$project$DataElement$Expression$applyGlobalString, $author$project$DataElement$Expression$dependencyTransformer, basicCol.header),
		A2(
			$elm$core$List$concatMap,
			$author$project$DataElement$Expression$applyLocalString($author$project$DataElement$Expression$dependencyTransformer),
			$author$project$UserAction$extractMetadata(basicCol.valueAction)));
};
var $author$project$DisplayElement$Table$unwrapColumn = F2(
	function (f, col) {
		switch (col.$) {
			case 'StringColumn':
				var header = col.a.header;
				var value = col.a.value;
				var valueAction = col.a.valueAction;
				var lineWrap = col.a.lineWrap;
				var userSortable = col.a.userSortable;
				return f(
					{header: header, lineWrap: lineWrap, userSortable: userSortable, value: value, valueAction: valueAction});
			case 'NumberColumn':
				var basicCol = col.a;
				return f(basicCol);
			case 'DateColumn':
				var header = col.a.header;
				var value = col.a.value;
				var valueAction = col.a.valueAction;
				var lineWrap = col.a.lineWrap;
				var userSortable = col.a.userSortable;
				return f(
					{header: header, lineWrap: lineWrap, userSortable: userSortable, value: value, valueAction: valueAction});
			case 'DateTimeColumn':
				var header = col.a.header;
				var value = col.a.value;
				var valueAction = col.a.valueAction;
				var lineWrap = col.a.lineWrap;
				var userSortable = col.a.userSortable;
				return f(
					{header: header, lineWrap: lineWrap, userSortable: userSortable, value: value, valueAction: valueAction});
			default:
				var basicCol = col.a;
				return f(basicCol);
		}
	});
var $author$project$DisplayElement$Table$getDependencyReferences = function (_v0) {
	var innerInfo = _v0.a;
	return A2(
		$elm$core$List$cons,
		$author$project$DataElement$Reference$getGenericReference(innerInfo.dataElement),
		A2(
			$elm$core$List$concatMap,
			$author$project$DisplayElement$Table$unwrapColumn($author$project$DisplayElement$Table$getBasicColumnDependencyRefs),
			innerInfo.columns));
};
var $author$project$DisplayElement$TrendChart$getDependencyReferences = function (_v0) {
	var innerInfo = _v0.a;
	return A2(
		$elm$core$List$cons,
		$author$project$DataElement$Reference$getGenericReference(innerInfo.dataSource),
		_Utils_ap(
			A2($author$project$DataElement$Expression$applyLocalDate, $author$project$DataElement$Expression$dependencyTransformer, innerInfo.date),
			_Utils_ap(
				A2($author$project$DataElement$Expression$applyLocalNumber, $author$project$DataElement$Expression$dependencyTransformer, innerInfo.value),
				A2($author$project$DataElement$Expression$applyLocalString, $author$project$DataElement$Expression$dependencyTransformer, innerInfo.series))));
};
var $author$project$DisplayElement$getDependencyReferences = F2(
	function (dataElements, element) {
		switch (element.$) {
			case 'Column':
				var children = element.a;
				return A2(
					$elm$core$List$concatMap,
					$author$project$DisplayElement$getDependencyReferences(dataElements),
					children);
			case 'Row':
				var children = element.b;
				return A2(
					$elm$core$List$concatMap,
					$author$project$DisplayElement$getDependencyReferences(dataElements),
					children);
			case 'Section':
				var info = element.a;
				var maybeBody = element.b;
				return _Utils_ap(
					$author$project$DisplayElement$Section$getDependencyReferences(info),
					A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2(
							$elm$core$Maybe$map,
							$author$project$DisplayElement$getDependencyReferences(dataElements),
							maybeBody)));
			case 'Table':
				var info = element.a;
				return $author$project$DisplayElement$Table$getDependencyReferences(info);
			case 'ProgressChart':
				var info = element.a;
				return $author$project$DisplayElement$ProgressChart$getDependencyReferences(info);
			case 'TrendChart':
				var info = element.a;
				return $author$project$DisplayElement$TrendChart$getDependencyReferences(info);
			case 'FieldList':
				var info = element.a;
				return $author$project$DisplayElement$FieldList$getDependencyReferences(info);
			case 'MetricHighlight':
				var info = element.a;
				return $author$project$DisplayElement$MetricHighlight$getDependencyReferences(info);
			case 'Custom':
				var info = element.a;
				return $author$project$DisplayElement$Custom$getDependencyReferences(info);
			case 'Select':
				var info = element.a;
				return A2($author$project$DisplayElement$Select$getDependencyReferences, dataElements, info);
			default:
				var info = element.a;
				return A2($author$project$DisplayElement$Datepicker$getDependencyReferences, dataElements, info);
		}
	});
var $author$project$Page$getDependencyReferences = F2(
	function (dataElements, _v0) {
		var displayElement = _v0.b;
		return A2($author$project$DisplayElement$getDependencyReferences, dataElements, displayElement);
	});
var $author$project$DataEngine$trimDataCacheForPage = F3(
	function (page, dataElements, cache) {
		return A2(
			$author$project$DataEngine$DataCache$removeAllExcept,
			A2($author$project$Page$getDependencyReferences, dataElements, page),
			cache);
	});
var $author$project$DataEngine$processPageRequest = F3(
	function (pageName, app, cache) {
		var _v0 = A2($author$project$DataEngine$getPageByName, pageName, app);
		if (_v0.$ === 'Just') {
			var page = _v0.a;
			return $author$project$DataEngine$Output$Ready(
				_Utils_Tuple3(
					page,
					A3(
						$author$project$DataEngine$trimDataCacheForPage,
						page,
						$author$project$StudioApp$dataElements(app),
						cache),
					$author$project$StudioApp$dataElements(app)));
		} else {
			return $author$project$DataEngine$Output$PageNotFound(pageName);
		}
	});
var $author$project$Compiler$processPageRequest = F2(
	function (pageName, model) {
		var _v0 = A3($author$project$DataEngine$processPageRequest, pageName, model.app, model.cache);
		switch (_v0.$) {
			case 'NotFound':
				return A2(
					$author$project$Compiler$respondToRequest,
					$author$project$Preview$ToPreviewMsg$RequestNotFound(
						$author$project$Preview$Request$Page(pageName)),
					model);
			case 'PageNotFound':
				return A2(
					$author$project$Compiler$respondToRequest,
					$author$project$Preview$ToPreviewMsg$RequestNotFound(
						$author$project$Preview$Request$Page(pageName)),
					model);
			case 'Ready':
				var _v1 = _v0.a;
				var page = _v1.a;
				var cache = _v1.b;
				var dataElements = _v1.c;
				return A2(
					$author$project$Compiler$respondToRequest,
					A3($author$project$Preview$ToPreviewMsg$PagePreviewResponse, page, cache, dataElements),
					model);
			case 'QueryError':
				var err = _v0.a;
				return A2(
					$author$project$Compiler$respondToRequest,
					A2(
						$author$project$Preview$ToPreviewMsg$ErrorDuringQuery,
						$author$project$Preview$Request$Page(pageName),
						err),
					model);
			case 'QueryRunningPleaseWait':
				var _v2 = A2($elm$core$Debug$log, 'Keep Waiting', 'Log this?');
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			default:
				var nextQuery = _v0.a;
				return A2(
					$Fresheyeball$elm_return$Return$command,
					$author$project$Compiler$runQuery(nextQuery),
					$Fresheyeball$elm_return$Return$singleton(
						_Utils_update(
							model,
							{
								cache: A2(
									$author$project$DataEngine$DataCache$markLoading,
									$author$project$DataElement$Reference$getGenericReferenceFromEither(nextQuery.ref),
									model.cache)
							})));
		}
	});
var $author$project$Compiler$processRequest = function (model) {
	var _v0 = model.activeRequest;
	if (_v0.$ === 'Nothing') {
		return $Fresheyeball$elm_return$Return$singleton(model);
	} else {
		if (_v0.a.$ === 'Data') {
			var ref = _v0.a.a;
			return A2($author$project$Compiler$processDataRequest, ref, model);
		} else {
			var pageName = _v0.a.a;
			return A2($author$project$Compiler$processPageRequest, pageName, model);
		}
	}
};
var $author$project$LoadableTimeZone$setDevice = F2(
	function (zone, _v0) {
		var user = _v0.a;
		return _Utils_Tuple2(
			user,
			$elm$core$Maybe$Just(zone));
	});
var $author$project$LoadableLocale$setUser = F2(
	function (result, _v0) {
		var device = _v0.b;
		return _Utils_Tuple2(
			$krisajenkins$remotedata$RemoteData$fromResult(result),
			device);
	});
var $author$project$LoadableTimeZone$NameNotFound = function (a) {
	return {$: 'NameNotFound', a: a};
};
var $author$project$LoadableTimeZone$QueryError = function (a) {
	return {$: 'QueryError', a: a};
};
var $justinmimbs$timezone_data$TimeZone$Specification$Save = function (a) {
	return {$: 'Save', a: a};
};
var $justinmimbs$timezone_data$TimeZone$Specification$Zone = F2(
	function (history, current) {
		return {current: current, history: history};
	});
var $justinmimbs$timezone_data$TimeZone$Specification$ZoneState = F2(
	function (standardOffset, zoneRules) {
		return {standardOffset: standardOffset, zoneRules: zoneRules};
	});
var $justinmimbs$timezone_data$TimeZone$maxYear = 2037;
var $justinmimbs$timezone_data$TimeZone$minYear = 1970;
var $justinmimbs$timezone_data$TimeZone$Specification$DateTime = F5(
	function (year, month, day, time, clock) {
		return {clock: clock, day: day, month: month, time: time, year: year};
	});
var $justinmimbs$timezone_data$TimeZone$Specification$Universal = {$: 'Universal'};
var $justinmimbs$timezone_data$TimeZone$Specification$dropChangesBeforeEpoch = function (_v0) {
	dropChangesBeforeEpoch:
	while (true) {
		var initial = _v0.a;
		var changes = _v0.b;
		if (changes.b) {
			var change = changes.a;
			var rest = changes.b;
			if (change.start <= 0) {
				var $temp$_v0 = _Utils_Tuple2(change.offset, rest);
				_v0 = $temp$_v0;
				continue dropChangesBeforeEpoch;
			} else {
				return _Utils_Tuple2(initial, changes);
			}
		} else {
			return _Utils_Tuple2(initial, _List_Nil);
		}
	}
};
var $justinmimbs$timezone_data$RataDie$weekdayNumber = function (rd) {
	var _v0 = A2($elm$core$Basics$modBy, 7, rd);
	if (!_v0) {
		return 7;
	} else {
		var n = _v0;
		return n;
	}
};
var $justinmimbs$timezone_data$RataDie$weekdayToNumber = function (wd) {
	switch (wd.$) {
		case 'Mon':
			return 1;
		case 'Tue':
			return 2;
		case 'Wed':
			return 3;
		case 'Thu':
			return 4;
		case 'Fri':
			return 5;
		case 'Sat':
			return 6;
		default:
			return 7;
	}
};
var $justinmimbs$timezone_data$RataDie$floorWeekday = F2(
	function (weekday, rd) {
		var daysSincePreviousWeekday = A2(
			$elm$core$Basics$modBy,
			7,
			($justinmimbs$timezone_data$RataDie$weekdayNumber(rd) + 7) - $justinmimbs$timezone_data$RataDie$weekdayToNumber(weekday));
		return rd - daysSincePreviousWeekday;
	});
var $justinmimbs$timezone_data$RataDie$ceilingWeekday = F2(
	function (weekday, rd) {
		var floored = A2($justinmimbs$timezone_data$RataDie$floorWeekday, weekday, rd);
		return _Utils_eq(rd, floored) ? rd : (floored + 7);
	});
var $justinmimbs$timezone_data$RataDie$isLeapYear = function (y) {
	return ((!A2($elm$core$Basics$modBy, 4, y)) && (!(!A2($elm$core$Basics$modBy, 100, y)))) || (!A2($elm$core$Basics$modBy, 400, y));
};
var $justinmimbs$timezone_data$RataDie$daysBeforeMonth = F2(
	function (y, m) {
		var leapDays = $justinmimbs$timezone_data$RataDie$isLeapYear(y) ? 1 : 0;
		switch (m.$) {
			case 'Jan':
				return 0;
			case 'Feb':
				return 31;
			case 'Mar':
				return 59 + leapDays;
			case 'Apr':
				return 90 + leapDays;
			case 'May':
				return 120 + leapDays;
			case 'Jun':
				return 151 + leapDays;
			case 'Jul':
				return 181 + leapDays;
			case 'Aug':
				return 212 + leapDays;
			case 'Sep':
				return 243 + leapDays;
			case 'Oct':
				return 273 + leapDays;
			case 'Nov':
				return 304 + leapDays;
			default:
				return 334 + leapDays;
		}
	});
var $justinmimbs$timezone_data$RataDie$daysBeforeYear = function (y1) {
	var y = y1 - 1;
	var leapYears = (((y / 4) | 0) - ((y / 100) | 0)) + ((y / 400) | 0);
	return (365 * y) + leapYears;
};
var $justinmimbs$timezone_data$RataDie$dayOfMonth = F3(
	function (y, m, d) {
		return ($justinmimbs$timezone_data$RataDie$daysBeforeYear(y) + A2($justinmimbs$timezone_data$RataDie$daysBeforeMonth, y, m)) + d;
	});
var $justinmimbs$timezone_data$RataDie$daysInMonth = F2(
	function (y, m) {
		switch (m.$) {
			case 'Jan':
				return 31;
			case 'Feb':
				return $justinmimbs$timezone_data$RataDie$isLeapYear(y) ? 29 : 28;
			case 'Mar':
				return 31;
			case 'Apr':
				return 30;
			case 'May':
				return 31;
			case 'Jun':
				return 30;
			case 'Jul':
				return 31;
			case 'Aug':
				return 31;
			case 'Sep':
				return 30;
			case 'Oct':
				return 31;
			case 'Nov':
				return 30;
			default:
				return 31;
		}
	});
var $justinmimbs$timezone_data$RataDie$lastOfMonth = F2(
	function (y, m) {
		return ($justinmimbs$timezone_data$RataDie$daysBeforeYear(y) + A2($justinmimbs$timezone_data$RataDie$daysBeforeMonth, y, m)) + A2($justinmimbs$timezone_data$RataDie$daysInMonth, y, m);
	});
var $justinmimbs$timezone_data$TimeZone$Specification$minutesFromRataDie = function (rd) {
	return (rd - 719163) * 1440;
};
var $justinmimbs$timezone_data$TimeZone$Specification$utcAdjustment = F2(
	function (clock, _v0) {
		var standard = _v0.standard;
		var save = _v0.save;
		switch (clock.$) {
			case 'Universal':
				return 0;
			case 'Standard':
				return 0 - standard;
			default:
				return 0 - (standard + save);
		}
	});
var $justinmimbs$timezone_data$TimeZone$Specification$minutesFromDateTime = function (_v0) {
	var year = _v0.year;
	var month = _v0.month;
	var day = _v0.day;
	var time = _v0.time;
	return $justinmimbs$timezone_data$TimeZone$Specification$minutesFromRataDie(
		A3($justinmimbs$timezone_data$RataDie$dayOfMonth, year, month, day)) + time;
};
var $justinmimbs$timezone_data$TimeZone$Specification$utcMinutesFromDateTime = F2(
	function (offset, datetime) {
		return $justinmimbs$timezone_data$TimeZone$Specification$minutesFromDateTime(datetime) + A2($justinmimbs$timezone_data$TimeZone$Specification$utcAdjustment, datetime.clock, offset);
	});
var $justinmimbs$timezone_data$TimeZone$Specification$rulesToOffsetChanges = F5(
	function (previousOffset, start, until, standardOffset, rules) {
		var transitions = A2(
			$elm$core$List$concatMap,
			function (year) {
				return A2(
					$elm$core$List$sortBy,
					function ($) {
						return $.start;
					},
					A2(
						$elm$core$List$map,
						function (rule) {
							return {
								clock: rule.clock,
								save: rule.save,
								start: $justinmimbs$timezone_data$TimeZone$Specification$minutesFromRataDie(
									function () {
										var _v2 = rule.day;
										switch (_v2.$) {
											case 'Day':
												var day = _v2.a;
												return A3($justinmimbs$timezone_data$RataDie$dayOfMonth, year, rule.month, day);
											case 'Next':
												var weekday = _v2.a;
												var after = _v2.b;
												return A2(
													$justinmimbs$timezone_data$RataDie$ceilingWeekday,
													weekday,
													A3($justinmimbs$timezone_data$RataDie$dayOfMonth, year, rule.month, after));
											case 'Prev':
												var weekday = _v2.a;
												var before = _v2.b;
												return A2(
													$justinmimbs$timezone_data$RataDie$floorWeekday,
													weekday,
													A3($justinmimbs$timezone_data$RataDie$dayOfMonth, year, rule.month, before));
											default:
												var weekday = _v2.a;
												return A2(
													$justinmimbs$timezone_data$RataDie$floorWeekday,
													weekday,
													A2($justinmimbs$timezone_data$RataDie$lastOfMonth, year, rule.month));
										}
									}()) + rule.time
							};
						},
						A2(
							$elm$core$List$filter,
							function (rule) {
								return (_Utils_cmp(rule.from, year) < 1) && (_Utils_cmp(year, rule.to) < 1);
							},
							rules)));
			},
			A2($elm$core$List$range, start.year - 1, until.year));
		var initialOffset = {save: 0, standard: standardOffset};
		var initialChange = {
			offset: standardOffset,
			start: A2($justinmimbs$timezone_data$TimeZone$Specification$utcMinutesFromDateTime, previousOffset, start)
		};
		var _v0 = A3(
			$elm$core$List$foldl,
			F2(
				function (transition, _v1) {
					var currentOffset = _v1.a;
					var changes = _v1.b;
					var newOffset = {save: transition.save, standard: standardOffset};
					if (_Utils_cmp(
						transition.start + A2($justinmimbs$timezone_data$TimeZone$Specification$utcAdjustment, transition.clock, previousOffset),
						initialChange.start) < 1) {
						var updatedInitialChange = {offset: standardOffset + transition.save, start: initialChange.start};
						return _Utils_Tuple2(
							newOffset,
							_List_fromArray(
								[updatedInitialChange]));
					} else {
						if (_Utils_cmp(
							transition.start + A2($justinmimbs$timezone_data$TimeZone$Specification$utcAdjustment, transition.clock, currentOffset),
							A2($justinmimbs$timezone_data$TimeZone$Specification$utcMinutesFromDateTime, currentOffset, until)) < 0) {
							var change = {
								offset: standardOffset + transition.save,
								start: transition.start + A2($justinmimbs$timezone_data$TimeZone$Specification$utcAdjustment, transition.clock, currentOffset)
							};
							return _Utils_Tuple2(
								newOffset,
								A2($elm$core$List$cons, change, changes));
						} else {
							return _Utils_Tuple2(currentOffset, changes);
						}
					}
				}),
			_Utils_Tuple2(
				initialOffset,
				_List_fromArray(
					[initialChange])),
			transitions);
		var nextOffset = _v0.a;
		var descendingChanges = _v0.b;
		return _Utils_Tuple2(
			$elm$core$List$reverse(descendingChanges),
			nextOffset);
	});
var $justinmimbs$timezone_data$TimeZone$Specification$stateToOffsetChanges = F4(
	function (previousOffset, start, until, _v0) {
		var standardOffset = _v0.standardOffset;
		var zoneRules = _v0.zoneRules;
		if (zoneRules.$ === 'Save') {
			var save = zoneRules.a;
			return _Utils_Tuple2(
				_List_fromArray(
					[
						{
						offset: standardOffset + save,
						start: A2($justinmimbs$timezone_data$TimeZone$Specification$utcMinutesFromDateTime, previousOffset, start)
					}
					]),
				{save: save, standard: standardOffset});
		} else {
			var rules = zoneRules.a;
			return A5($justinmimbs$timezone_data$TimeZone$Specification$rulesToOffsetChanges, previousOffset, start, until, standardOffset, rules);
		}
	});
var $justinmimbs$timezone_data$TimeZone$Specification$stripDuplicatesByHelp = F4(
	function (f, a, rev, list) {
		stripDuplicatesByHelp:
		while (true) {
			if (!list.b) {
				return $elm$core$List$reverse(rev);
			} else {
				var x = list.a;
				var xs = list.b;
				var b = f(x);
				var rev_ = (!_Utils_eq(a, b)) ? A2($elm$core$List$cons, x, rev) : rev;
				var $temp$f = f,
					$temp$a = b,
					$temp$rev = rev_,
					$temp$list = xs;
				f = $temp$f;
				a = $temp$a;
				rev = $temp$rev;
				list = $temp$list;
				continue stripDuplicatesByHelp;
			}
		}
	});
var $justinmimbs$timezone_data$TimeZone$Specification$zoneToRanges = F3(
	function (zoneStart, zoneUntil, zone) {
		var _v0 = A3(
			$elm$core$List$foldl,
			F2(
				function (_v1, _v2) {
					var state = _v1.a;
					var nextStart = _v1.b;
					var start = _v2.a;
					var ranges = _v2.b;
					return _Utils_Tuple2(
						nextStart,
						A2(
							$elm$core$List$cons,
							_Utils_Tuple3(start, state, nextStart),
							ranges));
				}),
			_Utils_Tuple2(zoneStart, _List_Nil),
			zone.history);
		var currentStart = _v0.a;
		var historyRanges = _v0.b;
		return $elm$core$List$reverse(
			A2(
				$elm$core$List$cons,
				_Utils_Tuple3(currentStart, zone.current, zoneUntil),
				historyRanges));
	});
var $justinmimbs$timezone_data$TimeZone$Specification$toOffsets = F3(
	function (minYear, maxYear, zone) {
		var initialState = function () {
			var _v5 = zone.history;
			if (_v5.b) {
				var _v6 = _v5.a;
				var earliest = _v6.a;
				return earliest;
			} else {
				return zone.current;
			}
		}();
		var initialOffset = {
			save: function () {
				var _v4 = initialState.zoneRules;
				if (_v4.$ === 'Save') {
					var save = _v4.a;
					return save;
				} else {
					return 0;
				}
			}(),
			standard: initialState.standardOffset
		};
		var ascendingChanges = A4(
			$justinmimbs$timezone_data$TimeZone$Specification$stripDuplicatesByHelp,
			function ($) {
				return $.offset;
			},
			initialOffset.standard + initialOffset.save,
			_List_Nil,
			A3(
				$elm$core$List$foldl,
				F2(
					function (_v1, _v2) {
						var start = _v1.a;
						var state = _v1.b;
						var until = _v1.c;
						var prevOffset = _v2.a;
						var prevChanges = _v2.b;
						var _v3 = A4($justinmimbs$timezone_data$TimeZone$Specification$stateToOffsetChanges, prevOffset, start, until, state);
						var nextChanges = _v3.a;
						var nextOffset = _v3.b;
						return _Utils_Tuple2(
							nextOffset,
							_Utils_ap(prevChanges, nextChanges));
					}),
				_Utils_Tuple2(initialOffset, _List_Nil),
				A3(
					$justinmimbs$timezone_data$TimeZone$Specification$zoneToRanges,
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, minYear, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$Universal),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, maxYear + 1, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$Universal),
					zone)).b);
		var _v0 = $justinmimbs$timezone_data$TimeZone$Specification$dropChangesBeforeEpoch(
			_Utils_Tuple2(initialOffset.standard + initialOffset.save, ascendingChanges));
		var initial = _v0.a;
		var ascending = _v0.b;
		return _Utils_Tuple2(
			$elm$core$List$reverse(ascending),
			initial);
	});
var $justinmimbs$timezone_data$TimeZone$fromSpecification = function (zone) {
	var _v0 = A3($justinmimbs$timezone_data$TimeZone$Specification$toOffsets, $justinmimbs$timezone_data$TimeZone$minYear, $justinmimbs$timezone_data$TimeZone$maxYear, zone);
	var descending = _v0.a;
	var bottom = _v0.b;
	return A2($elm$time$Time$customZone, bottom, descending);
};
var $justinmimbs$timezone_data$TimeZone$africa__abidjan = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				0,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$Specification$Rules = function (a) {
	return {$: 'Rules', a: a};
};
var $justinmimbs$timezone_data$TimeZone$Specification$WallClock = {$: 'WallClock'};
var $justinmimbs$timezone_data$TimeZone$Specification$Day = function (a) {
	return {$: 'Day', a: a};
};
var $justinmimbs$timezone_data$TimeZone$Specification$Rule = F7(
	function (from, to, month, day, time, clock, save) {
		return {clock: clock, day: day, from: from, month: month, save: save, time: time, to: to};
	});
var $justinmimbs$timezone_data$TimeZone$Specification$Standard = {$: 'Standard'};
var $justinmimbs$timezone_data$TimeZone$rules_Algeria = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1971,
		1971,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(25),
		1380,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1971,
		1971,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(26),
		1380,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1977,
		$elm$time$Time$May,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(6),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1977,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(24),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(22),
		180,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1980,
		1980,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(25),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1980,
		1980,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(31),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$africa__algiers = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						0,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Algeria)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1977, $elm$time$Time$Oct, 21, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Algeria)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1979, $elm$time$Time$Oct, 26, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						0,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Algeria)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, $elm$time$Time$May, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				60,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$africa__bissau = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-60,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1975, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				0,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$Specification$Last = function (a) {
	return {$: 'Last', a: a};
};
var $justinmimbs$timezone_data$TimeZone$Specification$Next = F2(
	function (a, b) {
		return {$: 'Next', a: a, b: b};
	});
var $justinmimbs$timezone_data$TimeZone$rules_Egypt = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1959,
		1981,
		$elm$time$Time$May,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1966,
		1994,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		180,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1982,
		1982,
		$elm$time$Time$Jul,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(25),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1983,
		1983,
		$elm$time$Time$Jul,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(12),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1984,
		1988,
		$elm$time$Time$May,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1989,
		1989,
		$elm$time$Time$May,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(6),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1990,
		1994,
		$elm$time$Time$May,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1995,
		2010,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Fri),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1995,
		2005,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Thu),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2006,
		2006,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2007,
		2007,
		$elm$time$Time$Sep,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Thu, 1),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		2008,
		$elm$time$Time$Aug,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Thu),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2009,
		2009,
		$elm$time$Time$Aug,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2010,
		2010,
		$elm$time$Time$Aug,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(10),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2010,
		2010,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(9),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2010,
		2010,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Thu),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2014,
		2014,
		$elm$time$Time$May,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(15),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2014,
		2014,
		$elm$time$Time$Jun,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(26),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2014,
		2014,
		$elm$time$Time$Jul,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(31),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2014,
		2014,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Thu),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2023,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Fri),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2023,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Thu),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$africa__cairo = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				120,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Egypt))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Morocco = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1974,
		$elm$time$Time$Jun,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(24),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1974,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1976,
		1977,
		$elm$time$Time$May,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1976,
		1976,
		$elm$time$Time$Aug,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1977,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(28),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		$elm$time$Time$Jun,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		$elm$time$Time$Aug,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(4),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		2008,
		$elm$time$Time$Jun,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		2008,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2009,
		2009,
		$elm$time$Time$Jun,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2009,
		2009,
		$elm$time$Time$Aug,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2010,
		2010,
		$elm$time$Time$May,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(2),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2010,
		2010,
		$elm$time$Time$Aug,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(8),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2011,
		2011,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(3),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2011,
		2011,
		$elm$time$Time$Jul,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(31),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2012,
		2013,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2012,
		2012,
		$elm$time$Time$Jul,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		180,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2012,
		2012,
		$elm$time$Time$Aug,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2012,
		2012,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		180,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2013,
		2013,
		$elm$time$Time$Jul,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(7),
		180,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2013,
		2013,
		$elm$time$Time$Aug,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(10),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2013,
		2018,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		180,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2014,
		2018,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2014,
		2014,
		$elm$time$Time$Jun,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(28),
		180,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2014,
		2014,
		$elm$time$Time$Aug,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(2),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2015,
		2015,
		$elm$time$Time$Jun,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(14),
		180,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2015,
		2015,
		$elm$time$Time$Jul,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(19),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2016,
		2016,
		$elm$time$Time$Jun,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(5),
		180,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2016,
		2016,
		$elm$time$Time$Jul,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(10),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2017,
		2017,
		$elm$time$Time$May,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		180,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2017,
		2017,
		$elm$time$Time$Jul,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(2),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2018,
		2018,
		$elm$time$Time$May,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(13),
		180,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2018,
		2018,
		$elm$time$Time$Jun,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(17),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2019,
		2019,
		$elm$time$Time$May,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(5),
		180,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		-60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2019,
		2019,
		$elm$time$Time$Jun,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(9),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2020,
		2020,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(19),
		180,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		-60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2020,
		2020,
		$elm$time$Time$May,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(31),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2021,
		2021,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(11),
		180,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		-60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2021,
		2021,
		$elm$time$Time$May,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(16),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2022,
		2022,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(27),
		180,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		-60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2022,
		2022,
		$elm$time$Time$May,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(8),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2023,
		2023,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(19),
		180,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		-60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2023,
		2023,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(23),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2024,
		2024,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(10),
		180,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		-60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2024,
		2024,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(14),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2025,
		2025,
		$elm$time$Time$Feb,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(23),
		180,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		-60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2025,
		2025,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(6),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2026,
		2026,
		$elm$time$Time$Feb,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(15),
		180,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		-60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2026,
		2026,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(22),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2027,
		2027,
		$elm$time$Time$Feb,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(7),
		180,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		-60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2027,
		2027,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(14),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2028,
		2028,
		$elm$time$Time$Jan,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(23),
		180,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		-60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2028,
		2028,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(5),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2029,
		2029,
		$elm$time$Time$Jan,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(14),
		180,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		-60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2029,
		2029,
		$elm$time$Time$Feb,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(18),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2029,
		2029,
		$elm$time$Time$Dec,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		180,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		-60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2030,
		2030,
		$elm$time$Time$Feb,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(10),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2030,
		2030,
		$elm$time$Time$Dec,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(22),
		180,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		-60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2031,
		2031,
		$elm$time$Time$Jan,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(26),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2031,
		2031,
		$elm$time$Time$Dec,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(14),
		180,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		-60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2032,
		2032,
		$elm$time$Time$Jan,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(18),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2032,
		2032,
		$elm$time$Time$Nov,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(28),
		180,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		-60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2033,
		2033,
		$elm$time$Time$Jan,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(9),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2033,
		2033,
		$elm$time$Time$Nov,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		180,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		-60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2033,
		2033,
		$elm$time$Time$Dec,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(25),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2034,
		2034,
		$elm$time$Time$Nov,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(5),
		180,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		-60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2034,
		2034,
		$elm$time$Time$Dec,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(17),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2035,
		2035,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(28),
		180,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		-60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2035,
		2035,
		$elm$time$Time$Dec,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(9),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2036,
		2036,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(19),
		180,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		-60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2036,
		2036,
		$elm$time$Time$Nov,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(23),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2037,
		2037,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(4),
		180,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		-60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2037,
		2037,
		$elm$time$Time$Nov,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(15),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$africa__casablanca = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						0,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Morocco)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1984, $elm$time$Time$Mar, 16, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1986, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						0,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Morocco)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2018, $elm$time$Time$Oct, 28, 180, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				60,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Morocco))));
};
var $justinmimbs$timezone_data$TimeZone$rules_EU = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1980,
		$elm$time$Time$Apr,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$Universal,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1977,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$Universal,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$Universal,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1995,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$Universal,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1981,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$Universal,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1996,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$Universal,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$rules_SpainAfrica = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1974,
		$elm$time$Time$Jun,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(24),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1974,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1976,
		1977,
		$elm$time$Time$May,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1976,
		1976,
		$elm$time$Time$Aug,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1977,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(28),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		$elm$time$Time$Jun,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		$elm$time$Time$Aug,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(4),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$africa__ceuta = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						0,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_SpainAfrica)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1984, $elm$time$Time$Mar, 16, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1986, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				60,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$africa__el_aaiun = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-60,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1976, $elm$time$Time$Apr, 14, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						0,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Morocco)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2018, $elm$time$Time$Oct, 28, 180, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				60,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Morocco))));
};
var $justinmimbs$timezone_data$TimeZone$africa__johannesburg = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				120,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Sudan = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1970,
		1970,
		$elm$time$Time$May,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1970,
		1985,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(15),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1971,
		1971,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1972,
		1985,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60)
	]);
var $justinmimbs$timezone_data$TimeZone$africa__juba = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Sudan)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, $elm$time$Time$Jan, 15, 720, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2021, $elm$time$Time$Feb, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				120,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$africa__khartoum = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Sudan)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, $elm$time$Time$Jan, 15, 720, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2017, $elm$time$Time$Nov, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				120,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$africa__lagos = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				60,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$africa__maputo = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				120,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$africa__monrovia = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-45,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1972, $elm$time$Time$Jan, 7, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				0,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$africa__nairobi = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$africa__ndjamena = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1979, $elm$time$Time$Oct, 14, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(60)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1980, $elm$time$Time$Mar, 8, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				60,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$africa__sao_tome = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						0,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2018, $elm$time$Time$Jan, 1, 60, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2019, $elm$time$Time$Jan, 1, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				0,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Libya = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1982,
		1984,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1982,
		1985,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1985,
		1985,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(6),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		1986,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(4),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		1986,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(3),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		1989,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		1989,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1997,
		1997,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(4),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1997,
		1997,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(4),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2013,
		2013,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Fri),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2013,
		2013,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Fri),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$africa__tripoli = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1982, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Libya)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1990, $elm$time$Time$May, 4, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1996, $elm$time$Time$Sep, 30, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Libya)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1997, $elm$time$Time$Oct, 4, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2012, $elm$time$Time$Nov, 10, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Libya)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2013, $elm$time$Time$Oct, 25, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				120,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Tunisia = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1977,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1977,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(24),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		$elm$time$Time$May,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1988,
		1988,
		$elm$time$Time$Jun,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1988,
		1990,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1989,
		1989,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(26),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1990,
		1990,
		$elm$time$Time$May,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2005,
		2005,
		$elm$time$Time$May,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2005,
		2005,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2006,
		2008,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2006,
		2008,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$africa__tunis = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				60,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Tunisia))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Namibia = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1994,
		1994,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		-60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1994,
		2017,
		$elm$time$Time$Sep,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1995,
		2017,
		$elm$time$Time$Apr,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		-60)
	]);
var $justinmimbs$timezone_data$TimeZone$africa__windhoek = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1990, $elm$time$Time$Mar, 21, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				120,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Namibia))));
};
var $justinmimbs$timezone_data$TimeZone$rules_US = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1967,
		2006,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1967,
		1973,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1974,
		$elm$time$Time$Jan,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(6),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1975,
		1975,
		$elm$time$Time$Feb,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1976,
		1986,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		2006,
		$elm$time$Time$Apr,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2007,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		$elm$time$Time$Mar,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 8),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2007,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		$elm$time$Time$Nov,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$america__adak = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-660,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1983, $elm$time$Time$Oct, 30, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-600,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1983, $elm$time$Time$Nov, 30, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-600,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$america__anchorage = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-600,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1983, $elm$time$Time$Oct, 30, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-540,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1983, $elm$time$Time$Nov, 30, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-540,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Brazil = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1985,
		1985,
		$elm$time$Time$Nov,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(2),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		1986,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(15),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		1986,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(25),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		1987,
		$elm$time$Time$Feb,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(14),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		1987,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(25),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1988,
		1988,
		$elm$time$Time$Feb,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(7),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1988,
		1988,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(16),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1989,
		1989,
		$elm$time$Time$Jan,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(29),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1989,
		1989,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(15),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1990,
		1990,
		$elm$time$Time$Feb,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(11),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1990,
		1990,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		1991,
		$elm$time$Time$Feb,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(17),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		1991,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1992,
		1992,
		$elm$time$Time$Feb,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(9),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1992,
		1992,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(25),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1993,
		1993,
		$elm$time$Time$Jan,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(31),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1993,
		1995,
		$elm$time$Time$Oct,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 11),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1994,
		1995,
		$elm$time$Time$Feb,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 15),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1996,
		1996,
		$elm$time$Time$Feb,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(11),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1996,
		1996,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(6),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1997,
		1997,
		$elm$time$Time$Feb,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(16),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1997,
		1997,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(6),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1998,
		1998,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1998,
		1998,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(11),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1999,
		1999,
		$elm$time$Time$Feb,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1999,
		1999,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(3),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2000,
		2000,
		$elm$time$Time$Feb,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(27),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2000,
		2001,
		$elm$time$Time$Oct,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 8),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2001,
		2006,
		$elm$time$Time$Feb,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 15),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2002,
		2002,
		$elm$time$Time$Nov,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(3),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2003,
		2003,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(19),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2004,
		2004,
		$elm$time$Time$Nov,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(2),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2005,
		2005,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(16),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2006,
		2006,
		$elm$time$Time$Nov,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(5),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2007,
		2007,
		$elm$time$Time$Feb,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(25),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2007,
		2007,
		$elm$time$Time$Oct,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 8),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		2017,
		$elm$time$Time$Oct,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 15),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		2011,
		$elm$time$Time$Feb,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 15),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2012,
		2012,
		$elm$time$Time$Feb,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 22),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2013,
		2014,
		$elm$time$Time$Feb,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 15),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2015,
		2015,
		$elm$time$Time$Feb,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 22),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2016,
		2019,
		$elm$time$Time$Feb,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 15),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2018,
		2018,
		$elm$time$Time$Nov,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60)
	]);
var $justinmimbs$timezone_data$TimeZone$america__araguaina = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1990, $elm$time$Time$Sep, 17, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1995, $elm$time$Time$Sep, 14, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2003, $elm$time$Time$Sep, 24, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2012, $elm$time$Time$Oct, 21, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2013, $elm$time$Time$Sep, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Arg = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1968,
		1969,
		$elm$time$Time$Apr,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1974,
		$elm$time$Time$Jan,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(23),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1974,
		$elm$time$Time$May,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1988,
		1988,
		$elm$time$Time$Dec,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1989,
		1993,
		$elm$time$Time$Mar,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1989,
		1992,
		$elm$time$Time$Oct,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 15),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1999,
		1999,
		$elm$time$Time$Oct,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2000,
		2000,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(3),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2007,
		2007,
		$elm$time$Time$Dec,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		2009,
		$elm$time$Time$Mar,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 15),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		2008,
		$elm$time$Time$Oct,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 15),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60)
	]);
var $justinmimbs$timezone_data$TimeZone$america__argentina__buenos_aires = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, $elm$time$Time$Oct, 3, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, $elm$time$Time$Mar, 3, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg))));
};
var $justinmimbs$timezone_data$TimeZone$america__argentina__catamarca = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Mar, 3, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Oct, 20, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, $elm$time$Time$Oct, 3, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, $elm$time$Time$Mar, 3, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, $elm$time$Time$Jun, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, $elm$time$Time$Jun, 20, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2008, $elm$time$Time$Oct, 18, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__argentina__cordoba = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Mar, 3, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Oct, 20, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, $elm$time$Time$Oct, 3, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, $elm$time$Time$Mar, 3, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg))));
};
var $justinmimbs$timezone_data$TimeZone$america__argentina__jujuy = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1990, $elm$time$Time$Mar, 4, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1990, $elm$time$Time$Oct, 28, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(60)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Mar, 17, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Oct, 6, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(60)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, $elm$time$Time$Oct, 3, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, $elm$time$Time$Mar, 3, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2008, $elm$time$Time$Oct, 18, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__argentina__la_rioja = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Mar, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$May, 7, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, $elm$time$Time$Oct, 3, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, $elm$time$Time$Mar, 3, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, $elm$time$Time$Jun, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, $elm$time$Time$Jun, 20, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2008, $elm$time$Time$Oct, 18, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__argentina__mendoza = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1990, $elm$time$Time$Mar, 4, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1990, $elm$time$Time$Oct, 15, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(60)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Mar, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Oct, 15, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(60)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, $elm$time$Time$Mar, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, $elm$time$Time$Oct, 18, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, $elm$time$Time$Oct, 3, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, $elm$time$Time$Mar, 3, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, $elm$time$Time$May, 23, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, $elm$time$Time$Sep, 26, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2008, $elm$time$Time$Oct, 18, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__argentina__rio_gallegos = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, $elm$time$Time$Oct, 3, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, $elm$time$Time$Mar, 3, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, $elm$time$Time$Jun, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, $elm$time$Time$Jun, 20, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2008, $elm$time$Time$Oct, 18, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__argentina__salta = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Mar, 3, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Oct, 20, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, $elm$time$Time$Oct, 3, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, $elm$time$Time$Mar, 3, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2008, $elm$time$Time$Oct, 18, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__argentina__san_juan = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Mar, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$May, 7, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, $elm$time$Time$Oct, 3, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, $elm$time$Time$Mar, 3, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, $elm$time$Time$May, 31, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, $elm$time$Time$Jul, 25, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2008, $elm$time$Time$Oct, 18, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_SanLuis = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		2009,
		$elm$time$Time$Mar,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 8),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2007,
		2008,
		$elm$time$Time$Oct,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 8),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60)
	]);
var $justinmimbs$timezone_data$TimeZone$america__argentina__san_luis = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1990, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(60)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1990, $elm$time$Time$Mar, 14, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1990, $elm$time$Time$Oct, 15, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(60)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Mar, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Jun, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, $elm$time$Time$Oct, 3, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(60)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, $elm$time$Time$Mar, 3, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, $elm$time$Time$May, 31, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, $elm$time$Time$Jul, 25, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2008, $elm$time$Time$Jan, 21, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_SanLuis)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2009, $elm$time$Time$Oct, 11, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__argentina__tucuman = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Mar, 3, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Oct, 20, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, $elm$time$Time$Oct, 3, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, $elm$time$Time$Mar, 3, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, $elm$time$Time$Jun, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, $elm$time$Time$Jun, 13, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg))));
};
var $justinmimbs$timezone_data$TimeZone$america__argentina__ushuaia = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, $elm$time$Time$Oct, 3, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, $elm$time$Time$Mar, 3, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, $elm$time$Time$May, 30, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, $elm$time$Time$Jun, 20, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2008, $elm$time$Time$Oct, 18, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Para = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1975,
		1988,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1975,
		1978,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1991,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1989,
		1989,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(22),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1990,
		1990,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		1991,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(6),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1992,
		1992,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1992,
		1992,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(5),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1993,
		1993,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(31),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1993,
		1995,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1994,
		1995,
		$elm$time$Time$Feb,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1996,
		1996,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1996,
		2001,
		$elm$time$Time$Oct,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1997,
		1997,
		$elm$time$Time$Feb,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1998,
		2001,
		$elm$time$Time$Mar,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2002,
		2004,
		$elm$time$Time$Apr,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2002,
		2003,
		$elm$time$Time$Sep,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2004,
		2009,
		$elm$time$Time$Oct,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 15),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2005,
		2009,
		$elm$time$Time$Mar,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 8),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2010,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		$elm$time$Time$Oct,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2010,
		2012,
		$elm$time$Time$Apr,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 8),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2013,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		$elm$time$Time$Mar,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 22),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$america__asuncion = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1972, $elm$time$Time$Oct, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1974, $elm$time$Time$Apr, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-240,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Para))));
};
var $justinmimbs$timezone_data$TimeZone$america__bahia = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2003, $elm$time$Time$Sep, 24, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, $elm$time$Time$Oct, 16, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2012, $elm$time$Time$Oct, 21, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Mexico = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1996,
		2000,
		$elm$time$Time$Apr,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1996,
		2000,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2001,
		2001,
		$elm$time$Time$May,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2001,
		2001,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2002,
		2022,
		$elm$time$Time$Apr,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2002,
		2022,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$america__bahia_banderas = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-480,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1970, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-420,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mexico)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2010, $elm$time$Time$Apr, 4, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-360,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mexico))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Barb = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1977,
		$elm$time$Time$Jun,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(12),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1978,
		$elm$time$Time$Oct,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1980,
		$elm$time$Time$Apr,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 15),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1979,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1980,
		1980,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(25),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$america__barbados = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-240,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Barb))));
};
var $justinmimbs$timezone_data$TimeZone$america__belem = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1988, $elm$time$Time$Sep, 12, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Belize = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1973,
		1973,
		$elm$time$Time$Dec,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(5),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1974,
		$elm$time$Time$Feb,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(9),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1982,
		1982,
		$elm$time$Time$Dec,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(18),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1983,
		1983,
		$elm$time$Time$Feb,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(12),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$america__belize = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-360,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Belize))));
};
var $justinmimbs$timezone_data$TimeZone$america__boa_vista = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1988, $elm$time$Time$Sep, 12, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, $elm$time$Time$Sep, 30, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, $elm$time$Time$Oct, 15, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-240,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_CO = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1992,
		1992,
		$elm$time$Time$May,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(3),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1993,
		1993,
		$elm$time$Time$Feb,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(6),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$america__bogota = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-300,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_CO))));
};
var $justinmimbs$timezone_data$TimeZone$america__boise = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-420,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1974, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-420,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1974, $elm$time$Time$Feb, 3, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-420,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Canada = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1986,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		2006,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		2006,
		$elm$time$Time$Apr,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2007,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		$elm$time$Time$Mar,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 8),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2007,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		$elm$time$Time$Nov,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$rules_NT_YK = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1972,
		1986,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1972,
		2006,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		2006,
		$elm$time$Time$Apr,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60)
	]);
var $justinmimbs$timezone_data$TimeZone$america__cambridge_bay = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-420,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_NT_YK)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, $elm$time$Time$Oct, 31, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, $elm$time$Time$Oct, 29, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, $elm$time$Time$Nov, 5, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2001, $elm$time$Time$Apr, 1, 180, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-420,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada))));
};
var $justinmimbs$timezone_data$TimeZone$america__campo_grande = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-240,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil))));
};
var $justinmimbs$timezone_data$TimeZone$america__cancun = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, $elm$time$Time$Dec, 23, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mexico)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1998, $elm$time$Time$Aug, 2, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mexico)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2015, $elm$time$Time$Feb, 1, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-300,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__caracas = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2007, $elm$time$Time$Dec, 9, 180, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-270,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2016, $elm$time$Time$May, 1, 150, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-240,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__cayenne = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__chicago = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-360,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$america__chihuahua = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1996, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mexico)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1998, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1998, $elm$time$Time$Apr, 5, 180, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-420,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mexico)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2022, $elm$time$Time$Oct, 30, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-360,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__ciudad_juarez = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1996, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mexico)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1998, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1998, $elm$time$Time$Apr, 5, 180, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-420,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mexico)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2010, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-420,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2022, $elm$time$Time$Oct, 30, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2022, $elm$time$Time$Nov, 30, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-420,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$rules_CR = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1980,
		$elm$time$Time$Feb,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1980,
		$elm$time$Time$Jun,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		1992,
		$elm$time$Time$Jan,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sat, 15),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		1991,
		$elm$time$Time$Jul,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1992,
		1992,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(15),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$america__costa_rica = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-360,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_CR))));
};
var $justinmimbs$timezone_data$TimeZone$america__cuiaba = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2003, $elm$time$Time$Sep, 24, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, $elm$time$Time$Oct, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-240,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil))));
};
var $justinmimbs$timezone_data$TimeZone$america__danmarkshavn = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1980, $elm$time$Time$Apr, 6, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1996, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				0,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__dawson = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-540,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1973, $elm$time$Time$Oct, 28, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-480,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1980, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-480,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2020, $elm$time$Time$Nov, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-420,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Vanc = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1946,
		1986,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1962,
		2006,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$america__dawson_creek = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-480,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Vanc)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1972, $elm$time$Time$Aug, 30, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-420,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__denver = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-420,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$america__detroit = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1973, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1975, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1975, $elm$time$Time$Apr, 27, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-300,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Edm = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1972,
		1986,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1972,
		2006,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$america__edmonton = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-420,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Edm)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1987, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-420,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada))));
};
var $justinmimbs$timezone_data$TimeZone$america__eirunepe = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1988, $elm$time$Time$Sep, 12, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1993, $elm$time$Time$Sep, 28, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1994, $elm$time$Time$Sep, 22, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2008, $elm$time$Time$Jun, 24, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2013, $elm$time$Time$Nov, 10, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-300,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Salv = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		1988,
		$elm$time$Time$May,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		1988,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$america__el_salvador = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-360,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Salv))));
};
var $justinmimbs$timezone_data$TimeZone$america__fort_nelson = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-480,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Vanc)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1987, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-480,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2015, $elm$time$Time$Mar, 8, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-420,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__fortaleza = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1990, $elm$time$Time$Sep, 17, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, $elm$time$Time$Sep, 30, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, $elm$time$Time$Oct, 22, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2001, $elm$time$Time$Sep, 13, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2002, $elm$time$Time$Oct, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Halifax = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1962,
		1973,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1962,
		1973,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$america__glace_bay = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1972, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Halifax)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1974, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-240,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada))));
};
var $justinmimbs$timezone_data$TimeZone$rules_StJohns = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1951,
		1986,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1960,
		1986,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		1987,
		$elm$time$Time$Apr,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		1,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		2006,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		1,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1988,
		1988,
		$elm$time$Time$Apr,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		1,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		120),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1989,
		2006,
		$elm$time$Time$Apr,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		1,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2007,
		2011,
		$elm$time$Time$Mar,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 8),
		1,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2007,
		2010,
		$elm$time$Time$Nov,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		1,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$america__goose_bay = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_StJohns)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, $elm$time$Time$Nov, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-240,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada))));
};
var $justinmimbs$timezone_data$TimeZone$america__grand_turk = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1979, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2015, $elm$time$Time$Mar, 8, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2018, $elm$time$Time$Mar, 11, 180, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-300,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Guat = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1973,
		1973,
		$elm$time$Time$Nov,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(25),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1974,
		$elm$time$Time$Feb,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(24),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1983,
		1983,
		$elm$time$Time$May,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1983,
		1983,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(22),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		1991,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(23),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		1991,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(7),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2006,
		2006,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2006,
		2006,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$america__guatemala = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-360,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Guat))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Ecuador = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1992,
		1992,
		$elm$time$Time$Nov,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(28),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1993,
		1993,
		$elm$time$Time$Feb,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(5),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$america__guayaquil = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-300,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Ecuador))));
};
var $justinmimbs$timezone_data$TimeZone$america__guyana = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-225,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1975, $elm$time$Time$Aug, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, $elm$time$Time$Mar, 29, 60, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-240,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__halifax = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Halifax)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1974, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-240,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Cuba = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1969,
		1977,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1969,
		1971,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1972,
		1974,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(8),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1975,
		1977,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		$elm$time$Time$May,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(7),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1990,
		$elm$time$Time$Oct,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 8),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1980,
		$elm$time$Time$Mar,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 15),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1981,
		1985,
		$elm$time$Time$May,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 5),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		1989,
		$elm$time$Time$Mar,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 14),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1990,
		1997,
		$elm$time$Time$Apr,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		1995,
		$elm$time$Time$Oct,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 8),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1996,
		1996,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(6),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1997,
		1997,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(12),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1998,
		1999,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1998,
		2003,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2000,
		2003,
		$elm$time$Time$Apr,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2004,
		2004,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2006,
		2010,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2007,
		2007,
		$elm$time$Time$Mar,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 8),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		2008,
		$elm$time$Time$Mar,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 15),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2009,
		2010,
		$elm$time$Time$Mar,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 8),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2011,
		2011,
		$elm$time$Time$Mar,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 15),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2011,
		2011,
		$elm$time$Time$Nov,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(13),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2012,
		2012,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2012,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		$elm$time$Time$Nov,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2013,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		$elm$time$Time$Mar,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 8),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60)
	]);
var $justinmimbs$timezone_data$TimeZone$america__havana = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-300,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Cuba))));
};
var $justinmimbs$timezone_data$TimeZone$america__hermosillo = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-480,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1970, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-420,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mexico)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-420,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__indiana__indianapolis = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1971, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2006, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-300,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$america__indiana__knox = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Oct, 27, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2006, $elm$time$Time$Apr, 2, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-360,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$america__indiana__marengo = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1974, $elm$time$Time$Jan, 6, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(60)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1974, $elm$time$Time$Oct, 27, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1976, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2006, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-300,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$america__indiana__petersburg = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1977, $elm$time$Time$Oct, 30, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2006, $elm$time$Time$Apr, 2, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2007, $elm$time$Time$Nov, 4, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-300,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$america__indiana__tell_city = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1971, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2006, $elm$time$Time$Apr, 2, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-360,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$america__indiana__vevay = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1973, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2006, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-300,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$america__indiana__vincennes = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1971, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2006, $elm$time$Time$Apr, 2, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2007, $elm$time$Time$Nov, 4, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-300,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$america__indiana__winamac = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1971, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2006, $elm$time$Time$Apr, 2, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2007, $elm$time$Time$Mar, 11, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-300,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$america__inuvik = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-480,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_NT_YK)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1979, $elm$time$Time$Apr, 29, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-420,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_NT_YK)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1980, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-420,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada))));
};
var $justinmimbs$timezone_data$TimeZone$america__iqaluit = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_NT_YK)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, $elm$time$Time$Oct, 31, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, $elm$time$Time$Oct, 29, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-300,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada))));
};
var $justinmimbs$timezone_data$TimeZone$america__jamaica = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1974, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1984, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-300,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__juneau = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-480,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1980, $elm$time$Time$Apr, 27, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-540,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1980, $elm$time$Time$Oct, 26, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-480,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1983, $elm$time$Time$Oct, 30, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-540,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1983, $elm$time$Time$Nov, 30, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-540,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$america__kentucky__louisville = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1974, $elm$time$Time$Jan, 6, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(60)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1974, $elm$time$Time$Oct, 27, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-300,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$america__kentucky__monticello = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, $elm$time$Time$Oct, 29, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-300,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$america__la_paz = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-240,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Peru = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		1987,
		$elm$time$Time$Jan,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		1987,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1990,
		1990,
		$elm$time$Time$Jan,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1990,
		1990,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1994,
		1994,
		$elm$time$Time$Jan,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1994,
		1994,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$america__lima = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-300,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Peru))));
};
var $justinmimbs$timezone_data$TimeZone$america__los_angeles = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-480,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$america__maceio = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1990, $elm$time$Time$Sep, 17, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1995, $elm$time$Time$Oct, 13, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1996, $elm$time$Time$Sep, 4, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, $elm$time$Time$Sep, 30, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, $elm$time$Time$Oct, 22, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2001, $elm$time$Time$Sep, 13, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2002, $elm$time$Time$Oct, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Nic = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1980,
		$elm$time$Time$Mar,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 16),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1980,
		$elm$time$Time$Jun,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Mon, 23),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2005,
		2005,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(10),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2005,
		2005,
		$elm$time$Time$Oct,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2006,
		2006,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2006,
		2006,
		$elm$time$Time$Oct,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$america__managua = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1973, $elm$time$Time$May, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1975, $elm$time$Time$Feb, 16, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Nic)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, $elm$time$Time$Jan, 1, 240, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, $elm$time$Time$Sep, 24, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1993, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1997, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-360,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Nic))));
};
var $justinmimbs$timezone_data$TimeZone$america__manaus = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1988, $elm$time$Time$Sep, 12, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1993, $elm$time$Time$Sep, 28, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1994, $elm$time$Time$Sep, 22, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-240,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__martinique = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1980, $elm$time$Time$Apr, 6, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(60)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1980, $elm$time$Time$Sep, 28, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-240,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__matamoros = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1988, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1989, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mexico)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2010, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-360,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$america__mazatlan = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-480,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1970, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-420,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mexico))));
};
var $justinmimbs$timezone_data$TimeZone$america__menominee = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1973, $elm$time$Time$Apr, 29, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-360,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$america__merida = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, $elm$time$Time$Dec, 23, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1982, $elm$time$Time$Dec, 2, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-360,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mexico))));
};
var $justinmimbs$timezone_data$TimeZone$america__metlakatla = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-480,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1983, $elm$time$Time$Oct, 30, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-480,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2015, $elm$time$Time$Nov, 1, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-540,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2018, $elm$time$Time$Nov, 4, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-480,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2019, $elm$time$Time$Jan, 20, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-540,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$america__mexico_city = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mexico)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2001, $elm$time$Time$Sep, 30, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2002, $elm$time$Time$Feb, 20, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-360,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mexico))));
};
var $justinmimbs$timezone_data$TimeZone$america__miquelon = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1980, $elm$time$Time$May, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1987, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Moncton = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1946,
		1972,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1957,
		1972,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1993,
		2006,
		$elm$time$Time$Apr,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		1,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1993,
		2006,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		1,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$america__moncton = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Moncton)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1973, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1993, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Moncton)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2007, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-240,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada))));
};
var $justinmimbs$timezone_data$TimeZone$america__monterrey = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1988, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1989, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-360,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mexico))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Uruguay = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1970,
		1970,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(25),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1970,
		1970,
		$elm$time$Time$Jun,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(14),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1972,
		1972,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(23),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1972,
		1972,
		$elm$time$Time$Jul,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(16),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1974,
		$elm$time$Time$Jan,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(13),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		90),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1974,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(10),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		30),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1974,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1974,
		$elm$time$Time$Dec,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(22),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1975,
		1975,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1976,
		1976,
		$elm$time$Time$Dec,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(19),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1977,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(6),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1977,
		$elm$time$Time$Dec,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(4),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1979,
		$elm$time$Time$Mar,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		$elm$time$Time$Dec,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(17),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1979,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(29),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1980,
		1980,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(16),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		1987,
		$elm$time$Time$Dec,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(14),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1988,
		1988,
		$elm$time$Time$Feb,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(28),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1988,
		1988,
		$elm$time$Time$Dec,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(11),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1989,
		1989,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(5),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1989,
		1989,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(29),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1990,
		1990,
		$elm$time$Time$Feb,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(25),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1990,
		1991,
		$elm$time$Time$Oct,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 21),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		1992,
		$elm$time$Time$Mar,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1992,
		1992,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(18),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1993,
		1993,
		$elm$time$Time$Feb,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(28),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2004,
		2004,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(19),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2005,
		2005,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(27),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2005,
		2005,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(9),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2006,
		2015,
		$elm$time$Time$Mar,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 8),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2006,
		2014,
		$elm$time$Time$Oct,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60)
	]);
var $justinmimbs$timezone_data$TimeZone$america__montevideo = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Uruguay)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1970, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Uruguay)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1974, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Uruguay)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1974, $elm$time$Time$Mar, 10, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Uruguay)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1974, $elm$time$Time$Dec, 22, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Uruguay))));
};
var $justinmimbs$timezone_data$TimeZone$america__new_york = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-300,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$america__nome = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-660,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1983, $elm$time$Time$Oct, 30, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-540,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1983, $elm$time$Time$Nov, 30, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-540,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$america__noronha = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1990, $elm$time$Time$Sep, 17, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-120,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, $elm$time$Time$Sep, 30, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, $elm$time$Time$Oct, 15, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-120,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2001, $elm$time$Time$Sep, 13, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2002, $elm$time$Time$Oct, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-120,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__north_dakota__beulah = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-420,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2010, $elm$time$Time$Nov, 7, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-360,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$america__north_dakota__center = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-420,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, $elm$time$Time$Oct, 25, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-360,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$america__north_dakota__new_salem = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-420,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2003, $elm$time$Time$Oct, 26, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-360,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$america__nuuk = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1980, $elm$time$Time$Apr, 6, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2023, $elm$time$Time$Mar, 26, 60, $justinmimbs$timezone_data$TimeZone$Specification$Universal)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-120,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2023, $elm$time$Time$Oct, 29, 60, $justinmimbs$timezone_data$TimeZone$Specification$Universal))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-120,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$america__ojinaga = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1996, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mexico)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1998, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1998, $elm$time$Time$Apr, 5, 180, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-420,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mexico)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2010, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-420,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2022, $elm$time$Time$Oct, 30, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2022, $elm$time$Time$Nov, 30, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-360,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$america__panama = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-300,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__paramaribo = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-210,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1984, $elm$time$Time$Oct, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__phoenix = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-420,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Haiti = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1983,
		1983,
		$elm$time$Time$May,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(8),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1984,
		1987,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1983,
		1987,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1988,
		1997,
		$elm$time$Time$Apr,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1988,
		1997,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2005,
		2006,
		$elm$time$Time$Apr,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2005,
		2006,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2012,
		2015,
		$elm$time$Time$Mar,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 8),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2012,
		2015,
		$elm$time$Time$Nov,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2017,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		$elm$time$Time$Mar,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 8),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2017,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		$elm$time$Time$Nov,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$america__port_au_prince = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-300,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Haiti))));
};
var $justinmimbs$timezone_data$TimeZone$america__porto_velho = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1988, $elm$time$Time$Sep, 12, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-240,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__puerto_rico = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-240,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Chile = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1969,
		1969,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		180,
		$justinmimbs$timezone_data$TimeZone$Specification$Universal,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1969,
		1969,
		$elm$time$Time$Nov,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(23),
		240,
		$justinmimbs$timezone_data$TimeZone$Specification$Universal,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1970,
		1970,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(29),
		180,
		$justinmimbs$timezone_data$TimeZone$Specification$Universal,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1971,
		1971,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(14),
		180,
		$justinmimbs$timezone_data$TimeZone$Specification$Universal,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1970,
		1972,
		$elm$time$Time$Oct,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 9),
		240,
		$justinmimbs$timezone_data$TimeZone$Specification$Universal,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1972,
		1986,
		$elm$time$Time$Mar,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 9),
		180,
		$justinmimbs$timezone_data$TimeZone$Specification$Universal,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1973,
		1973,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		240,
		$justinmimbs$timezone_data$TimeZone$Specification$Universal,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1987,
		$elm$time$Time$Oct,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 9),
		240,
		$justinmimbs$timezone_data$TimeZone$Specification$Universal,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		1987,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(12),
		180,
		$justinmimbs$timezone_data$TimeZone$Specification$Universal,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1988,
		1990,
		$elm$time$Time$Mar,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 9),
		180,
		$justinmimbs$timezone_data$TimeZone$Specification$Universal,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1988,
		1989,
		$elm$time$Time$Oct,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 9),
		240,
		$justinmimbs$timezone_data$TimeZone$Specification$Universal,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1990,
		1990,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(16),
		240,
		$justinmimbs$timezone_data$TimeZone$Specification$Universal,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		1996,
		$elm$time$Time$Mar,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 9),
		180,
		$justinmimbs$timezone_data$TimeZone$Specification$Universal,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		1997,
		$elm$time$Time$Oct,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 9),
		240,
		$justinmimbs$timezone_data$TimeZone$Specification$Universal,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1997,
		1997,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		180,
		$justinmimbs$timezone_data$TimeZone$Specification$Universal,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1998,
		1998,
		$elm$time$Time$Mar,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 9),
		180,
		$justinmimbs$timezone_data$TimeZone$Specification$Universal,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1998,
		1998,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(27),
		240,
		$justinmimbs$timezone_data$TimeZone$Specification$Universal,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1999,
		1999,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(4),
		180,
		$justinmimbs$timezone_data$TimeZone$Specification$Universal,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1999,
		2010,
		$elm$time$Time$Oct,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 9),
		240,
		$justinmimbs$timezone_data$TimeZone$Specification$Universal,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2000,
		2007,
		$elm$time$Time$Mar,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 9),
		180,
		$justinmimbs$timezone_data$TimeZone$Specification$Universal,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		2008,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		180,
		$justinmimbs$timezone_data$TimeZone$Specification$Universal,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2009,
		2009,
		$elm$time$Time$Mar,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 9),
		180,
		$justinmimbs$timezone_data$TimeZone$Specification$Universal,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2010,
		2010,
		$elm$time$Time$Apr,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		180,
		$justinmimbs$timezone_data$TimeZone$Specification$Universal,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2011,
		2011,
		$elm$time$Time$May,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 2),
		180,
		$justinmimbs$timezone_data$TimeZone$Specification$Universal,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2011,
		2011,
		$elm$time$Time$Aug,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 16),
		240,
		$justinmimbs$timezone_data$TimeZone$Specification$Universal,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2012,
		2014,
		$elm$time$Time$Apr,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 23),
		180,
		$justinmimbs$timezone_data$TimeZone$Specification$Universal,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2012,
		2014,
		$elm$time$Time$Sep,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 2),
		240,
		$justinmimbs$timezone_data$TimeZone$Specification$Universal,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2016,
		2018,
		$elm$time$Time$May,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 9),
		180,
		$justinmimbs$timezone_data$TimeZone$Specification$Universal,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2016,
		2018,
		$elm$time$Time$Aug,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 9),
		240,
		$justinmimbs$timezone_data$TimeZone$Specification$Universal,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2019,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		$elm$time$Time$Apr,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 2),
		180,
		$justinmimbs$timezone_data$TimeZone$Specification$Universal,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2019,
		2021,
		$elm$time$Time$Sep,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 2),
		240,
		$justinmimbs$timezone_data$TimeZone$Specification$Universal,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2022,
		2022,
		$elm$time$Time$Sep,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 9),
		240,
		$justinmimbs$timezone_data$TimeZone$Specification$Universal,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2023,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		$elm$time$Time$Sep,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 2),
		240,
		$justinmimbs$timezone_data$TimeZone$Specification$Universal,
		60)
	]);
var $justinmimbs$timezone_data$TimeZone$america__punta_arenas = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Chile)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2016, $elm$time$Time$Dec, 4, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__rankin_inlet = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_NT_YK)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, $elm$time$Time$Oct, 29, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2001, $elm$time$Time$Apr, 1, 180, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-360,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada))));
};
var $justinmimbs$timezone_data$TimeZone$america__recife = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1990, $elm$time$Time$Sep, 17, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, $elm$time$Time$Sep, 30, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, $elm$time$Time$Oct, 15, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2001, $elm$time$Time$Sep, 13, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2002, $elm$time$Time$Oct, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__regina = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-360,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__resolute = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_NT_YK)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, $elm$time$Time$Oct, 29, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2001, $elm$time$Time$Apr, 1, 180, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2006, $elm$time$Time$Oct, 29, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2007, $elm$time$Time$Mar, 11, 180, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-360,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada))));
};
var $justinmimbs$timezone_data$TimeZone$america__rio_branco = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1988, $elm$time$Time$Sep, 12, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2008, $elm$time$Time$Jun, 24, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2013, $elm$time$Time$Nov, 10, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-300,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__santarem = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1988, $elm$time$Time$Sep, 12, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2008, $elm$time$Time$Jun, 24, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__santiago = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-240,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Chile))));
};
var $justinmimbs$timezone_data$TimeZone$rules_DR = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1969,
		1973,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		30),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1970,
		1970,
		$elm$time$Time$Feb,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1971,
		1971,
		$elm$time$Time$Jan,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1972,
		1974,
		$elm$time$Time$Jan,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$america__santo_domingo = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_DR)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1974, $elm$time$Time$Oct, 27, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, $elm$time$Time$Oct, 29, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, $elm$time$Time$Dec, 3, 60, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-240,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__sao_paulo = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil))));
};
var $justinmimbs$timezone_data$TimeZone$rules_C_Eur = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1980,
		$elm$time$Time$Apr,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1977,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1995,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1981,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1996,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$america__scoresbysund = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-120,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1980, $elm$time$Time$Apr, 6, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_C_Eur)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, $elm$time$Time$Mar, 29, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-60,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2024, $elm$time$Time$Mar, 31, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-120,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$america__sitka = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-480,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1983, $elm$time$Time$Oct, 30, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-540,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1983, $elm$time$Time$Nov, 30, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-540,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$america__st_johns = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-210,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_StJohns)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, $elm$time$Time$Nov, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-210,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada))));
};
var $justinmimbs$timezone_data$TimeZone$america__swift_current = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-420,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1972, $elm$time$Time$Apr, 30, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-360,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Hond = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		1988,
		$elm$time$Time$May,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		1988,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2006,
		2006,
		$elm$time$Time$May,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2006,
		2006,
		$elm$time$Time$Aug,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Mon, 1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$america__tegucigalpa = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-360,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Hond))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Thule = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		1992,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		1992,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1993,
		2006,
		$elm$time$Time$Apr,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1993,
		2006,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2007,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		$elm$time$Time$Mar,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 8),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2007,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		$elm$time$Time$Nov,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$america__thule = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-240,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Thule))));
};
var $justinmimbs$timezone_data$TimeZone$america__tijuana = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-480,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1976, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-480,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1996, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-480,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mexico)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2001, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-480,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2002, $elm$time$Time$Feb, 20, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-480,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mexico)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2010, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-480,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Toronto = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1950,
		1973,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1957,
		1973,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$america__toronto = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Toronto)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1974, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-300,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada))));
};
var $justinmimbs$timezone_data$TimeZone$america__vancouver = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-480,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Vanc)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1987, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-480,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada))));
};
var $justinmimbs$timezone_data$TimeZone$america__whitehorse = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-480,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1980, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-480,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2020, $elm$time$Time$Nov, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-420,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Winn = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1966,
		1986,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1966,
		2005,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		2005,
		$elm$time$Time$Apr,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60)
	]);
var $justinmimbs$timezone_data$TimeZone$america__winnipeg = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Winn)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2006, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-360,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada))));
};
var $justinmimbs$timezone_data$TimeZone$america__yakutat = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-540,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1983, $elm$time$Time$Nov, 30, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-540,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$antarctica__casey = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						480,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2009, $elm$time$Time$Oct, 18, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						660,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2010, $elm$time$Time$Mar, 5, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						480,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, $elm$time$Time$Oct, 28, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						660,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2012, $elm$time$Time$Feb, 21, 1020, $justinmimbs$timezone_data$TimeZone$Specification$Universal)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						480,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2016, $elm$time$Time$Oct, 22, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						660,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2018, $elm$time$Time$Mar, 11, 240, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						480,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2018, $elm$time$Time$Oct, 7, 240, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						660,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2019, $elm$time$Time$Mar, 17, 180, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						480,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2019, $elm$time$Time$Oct, 4, 180, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						660,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2020, $elm$time$Time$Mar, 8, 180, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						480,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2020, $elm$time$Time$Oct, 4, 1, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						660,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2021, $elm$time$Time$Mar, 14, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						480,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2021, $elm$time$Time$Oct, 3, 1, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						660,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2022, $elm$time$Time$Mar, 13, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						480,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2022, $elm$time$Time$Oct, 2, 1, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						660,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2023, $elm$time$Time$Mar, 9, 180, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				480,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$antarctica__davis = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						420,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2009, $elm$time$Time$Oct, 18, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2010, $elm$time$Time$Mar, 10, 1200, $justinmimbs$timezone_data$TimeZone$Specification$Universal)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						420,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, $elm$time$Time$Oct, 28, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2012, $elm$time$Time$Feb, 21, 1200, $justinmimbs$timezone_data$TimeZone$Specification$Universal))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				420,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_AT = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1968,
		1985,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1969,
		1971,
		$elm$time$Time$Mar,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 8),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1972,
		1972,
		$elm$time$Time$Feb,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1973,
		1981,
		$elm$time$Time$Mar,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1982,
		1983,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1984,
		1986,
		$elm$time$Time$Mar,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		1986,
		$elm$time$Time$Oct,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 15),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		1990,
		$elm$time$Time$Mar,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 15),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		1987,
		$elm$time$Time$Oct,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 22),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1988,
		1990,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		1999,
		$elm$time$Time$Oct,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		2005,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2000,
		2000,
		$elm$time$Time$Aug,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2001,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		$elm$time$Time$Oct,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2006,
		2006,
		$elm$time$Time$Apr,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2007,
		2007,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		$elm$time$Time$Apr,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$antarctica__macquarie = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						600,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_AT)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2010, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						600,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(60)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				600,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_AT))));
};
var $justinmimbs$timezone_data$TimeZone$antarctica__mawson = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2009, $elm$time$Time$Oct, 18, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				300,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$antarctica__palmer = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1982, $elm$time$Time$May, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Chile)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2016, $elm$time$Time$Dec, 4, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$antarctica__rothera = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						0,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1976, $elm$time$Time$Dec, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Troll = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2005,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$Universal,
		120),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2004,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$Universal,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$antarctica__troll = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						0,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2005, $elm$time$Time$Feb, 12, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				0,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Troll))));
};
var $justinmimbs$timezone_data$TimeZone$antarctica__vostok = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						420,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1994, $elm$time$Time$Feb, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						0,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1994, $elm$time$Time$Nov, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						420,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2023, $elm$time$Time$Dec, 18, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				300,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_RussiaAsia = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1981,
		1984,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1981,
		1983,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1984,
		1995,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1985,
		2010,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1996,
		2010,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$asia__almaty = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Mar, 31, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, $elm$time$Time$Jan, 19, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, $elm$time$Time$Oct, 31, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				360,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Jordan = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1973,
		1973,
		$elm$time$Time$Jun,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(6),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1973,
		1975,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1977,
		$elm$time$Time$May,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1976,
		1976,
		$elm$time$Time$Nov,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1977,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1985,
		1985,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1985,
		1985,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		1988,
		$elm$time$Time$Apr,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Fri, 1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		1990,
		$elm$time$Time$Oct,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Fri, 1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1989,
		1989,
		$elm$time$Time$May,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(8),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1990,
		1990,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(27),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		1991,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(17),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		1991,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(27),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1992,
		1992,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(10),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1992,
		1993,
		$elm$time$Time$Oct,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Fri, 1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1993,
		1998,
		$elm$time$Time$Apr,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Fri, 1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1994,
		1994,
		$elm$time$Time$Sep,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Fri, 15),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1995,
		1998,
		$elm$time$Time$Sep,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Fri, 15),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1999,
		1999,
		$elm$time$Time$Jul,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1999,
		2002,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Fri),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2000,
		2001,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Thu),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2002,
		2012,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Thu),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2003,
		2003,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(24),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2004,
		2004,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(15),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2005,
		2005,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Fri),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2006,
		2011,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Fri),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2013,
		2013,
		$elm$time$Time$Dec,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2014,
		2021,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Thu),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2014,
		2022,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Fri),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2022,
		2022,
		$elm$time$Time$Feb,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Thu),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60)
	]);
var $justinmimbs$timezone_data$TimeZone$asia__amman = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Jordan)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2022, $elm$time$Time$Oct, 28, 0, $justinmimbs$timezone_data$TimeZone$Specification$Standard))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Russia = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1981,
		1984,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1981,
		1983,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1984,
		1995,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1985,
		2010,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1996,
		2010,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$asia__anadyr = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						780,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1982, $elm$time$Time$Apr, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						720,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Mar, 31, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						660,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, $elm$time$Time$Jan, 19, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						720,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2010, $elm$time$Time$Mar, 28, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						660,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, $elm$time$Time$Mar, 27, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				720,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__aqtau = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, $elm$time$Time$Oct, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1982, $elm$time$Time$Apr, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Mar, 31, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, $elm$time$Time$Jan, 19, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1994, $elm$time$Time$Sep, 25, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, $elm$time$Time$Oct, 31, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				300,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__aqtobe = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, $elm$time$Time$Apr, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(60)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, $elm$time$Time$Oct, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1982, $elm$time$Time$Apr, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Mar, 31, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, $elm$time$Time$Jan, 19, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, $elm$time$Time$Oct, 31, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				300,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__ashgabat = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Mar, 31, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, $elm$time$Time$Jan, 19, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				300,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__atyrau = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, $elm$time$Time$Oct, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1982, $elm$time$Time$Apr, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Mar, 31, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, $elm$time$Time$Jan, 19, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, $elm$time$Time$Mar, 28, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, $elm$time$Time$Oct, 31, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				300,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Iraq = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1982,
		1982,
		$elm$time$Time$May,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1982,
		1984,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1983,
		1983,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(31),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1984,
		1985,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1985,
		1990,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		1990,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		2007,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		180,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		2007,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		180,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$asia__baghdad = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1982, $elm$time$Time$May, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				180,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Iraq))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Azer = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1997,
		2015,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		240,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1997,
		2015,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		300,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$rules_EUAsia = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1981,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$Universal,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1995,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$Universal,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1996,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$Universal,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$asia__baku = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Mar, 31, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, $elm$time$Time$Sep, 27, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1996, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EUAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1997, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				240,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Azer))));
};
var $justinmimbs$timezone_data$TimeZone$asia__bangkok = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				420,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__barnaul = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						420,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Mar, 31, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, $elm$time$Time$Jan, 19, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						420,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1995, $elm$time$Time$May, 28, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, $elm$time$Time$Mar, 27, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						420,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, $elm$time$Time$Oct, 26, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2016, $elm$time$Time$Mar, 27, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				420,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Lebanon = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1972,
		1972,
		$elm$time$Time$Jun,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(22),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1972,
		1977,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1973,
		1977,
		$elm$time$Time$May,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1984,
		1987,
		$elm$time$Time$May,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1984,
		1991,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(16),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1988,
		1988,
		$elm$time$Time$Jun,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1989,
		1989,
		$elm$time$Time$May,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(10),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1990,
		1992,
		$elm$time$Time$May,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1992,
		1992,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(4),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1993,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1993,
		1998,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1999,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$asia__beirut = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				120,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Lebanon))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Kyrgyz = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1992,
		1996,
		$elm$time$Time$Apr,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 7),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1992,
		1996,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1997,
		2005,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		150,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1997,
		2004,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		150,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$asia__bishkek = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Mar, 31, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Aug, 31, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Kyrgyz)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2005, $elm$time$Time$Aug, 12, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				360,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__chita = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						540,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Mar, 31, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						480,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, $elm$time$Time$Jan, 19, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						540,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, $elm$time$Time$Mar, 27, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						600,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, $elm$time$Time$Oct, 26, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						480,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2016, $elm$time$Time$Mar, 27, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				540,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Mongol = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1983,
		1984,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1983,
		1983,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1985,
		1998,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1984,
		1998,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2001,
		2001,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sat),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2001,
		2006,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sat),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2002,
		2006,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sat),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2015,
		2016,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sat),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2015,
		2016,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sat),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$asia__choibalsan = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						420,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1978, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						480,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1983, $elm$time$Time$Apr, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						540,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mongol)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2008, $elm$time$Time$Mar, 31, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				480,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mongol))));
};
var $justinmimbs$timezone_data$TimeZone$asia__colombo = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						330,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1996, $elm$time$Time$May, 25, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						390,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1996, $elm$time$Time$Oct, 26, 30, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2006, $elm$time$Time$Apr, 15, 30, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				330,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Syria = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1966,
		1976,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1967,
		1978,
		$elm$time$Time$May,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1978,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1983,
		1984,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(9),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1983,
		1984,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		1986,
		$elm$time$Time$Feb,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(16),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		1986,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(9),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		1987,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		1988,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(31),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1988,
		1988,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(15),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1989,
		1989,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(31),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1989,
		1989,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1990,
		1990,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1990,
		1990,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		1991,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		1992,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1992,
		1992,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(8),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1993,
		1993,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(26),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1993,
		1993,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(25),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1994,
		1996,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1994,
		2005,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1997,
		1998,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Mon),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1999,
		2006,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2006,
		2006,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(22),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2007,
		2007,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Fri),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2007,
		2007,
		$elm$time$Time$Nov,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Fri, 1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		2008,
		$elm$time$Time$Apr,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Fri, 1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		2008,
		$elm$time$Time$Nov,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2009,
		2009,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Fri),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2010,
		2011,
		$elm$time$Time$Apr,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Fri, 1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2012,
		2022,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Fri),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2009,
		2022,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Fri),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$asia__damascus = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Syria)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2022, $elm$time$Time$Oct, 28, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Dhaka = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2009,
		2009,
		$elm$time$Time$Jun,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(19),
		1380,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2009,
		2009,
		$elm$time$Time$Dec,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(31),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$asia__dhaka = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2009, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				360,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Dhaka))));
};
var $justinmimbs$timezone_data$TimeZone$asia__dili = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						540,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1976, $elm$time$Time$May, 3, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						480,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, $elm$time$Time$Sep, 17, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				540,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__dubai = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				240,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__dushanbe = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Mar, 31, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(60)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Sep, 9, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				300,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Cyprus = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1975,
		1975,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(13),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1975,
		1975,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(12),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1976,
		1976,
		$elm$time$Time$May,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(15),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1976,
		1976,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(11),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1980,
		$elm$time$Time$Apr,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1977,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(25),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(2),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1997,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1981,
		1998,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60)
	]);
var $justinmimbs$timezone_data$TimeZone$asia__famagusta = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Cyprus)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1998, $elm$time$Time$Sep, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EUAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2016, $elm$time$Time$Sep, 8, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2017, $elm$time$Time$Oct, 29, 60, $justinmimbs$timezone_data$TimeZone$Specification$Universal))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				120,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EUAsia))));
};
var $justinmimbs$timezone_data$TimeZone$Specification$Prev = F2(
	function (a, b) {
		return {$: 'Prev', a: a, b: b};
	});
var $justinmimbs$timezone_data$TimeZone$rules_Palestine = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1999,
		2005,
		$elm$time$Time$Apr,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Fri, 15),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1999,
		2003,
		$elm$time$Time$Oct,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Fri, 15),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2004,
		2004,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2005,
		2005,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(4),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2006,
		2007,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2006,
		2006,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(22),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2007,
		2007,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(13),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		2009,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Fri),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		2008,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2009,
		2009,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(4),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2010,
		2010,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(26),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2010,
		2010,
		$elm$time$Time$Aug,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(11),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2011,
		2011,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		1,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2011,
		2011,
		$elm$time$Time$Aug,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2011,
		2011,
		$elm$time$Time$Aug,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2011,
		2011,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2012,
		2014,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Thu),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2012,
		2012,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2013,
		2013,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(27),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2014,
		2014,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(24),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2015,
		2015,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(28),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2015,
		2015,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(23),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2016,
		2018,
		$elm$time$Time$Mar,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Prev, $elm$time$Time$Sat, 30),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2016,
		2018,
		$elm$time$Time$Oct,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Prev, $elm$time$Time$Sat, 30),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2019,
		2019,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(29),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2019,
		2019,
		$elm$time$Time$Oct,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Prev, $elm$time$Time$Sat, 30),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2020,
		2021,
		$elm$time$Time$Mar,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Prev, $elm$time$Time$Sat, 30),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2020,
		2020,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(24),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2021,
		2021,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(29),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2022,
		2022,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(27),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2022,
		2035,
		$elm$time$Time$Oct,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Prev, $elm$time$Time$Sat, 30),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2023,
		2023,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(29),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2024,
		2024,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(13),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2025,
		2025,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(5),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2026,
		2054,
		$elm$time$Time$Mar,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Prev, $elm$time$Time$Sat, 30),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2036,
		2036,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(18),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2037,
		2037,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(10),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$rules_Zion = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1974,
		$elm$time$Time$Jul,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(6),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1974,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(12),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1975,
		1975,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(19),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1975,
		1975,
		$elm$time$Time$Aug,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1980,
		1980,
		$elm$time$Time$Aug,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(2),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1980,
		1980,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(13),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1984,
		1984,
		$elm$time$Time$May,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(5),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1984,
		1984,
		$elm$time$Time$Aug,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(25),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1985,
		1985,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(13),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1985,
		1985,
		$elm$time$Time$Aug,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(31),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		1986,
		$elm$time$Time$May,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(17),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		1986,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(6),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		1987,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(14),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		1987,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(12),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1988,
		1988,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(9),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1988,
		1988,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(3),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1989,
		1989,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(29),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1989,
		1989,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(2),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1990,
		1990,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(24),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1990,
		1990,
		$elm$time$Time$Aug,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(25),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		1991,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(23),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		1991,
		$elm$time$Time$Aug,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(31),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1992,
		1992,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(28),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1992,
		1992,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(5),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1993,
		1993,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(2),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1993,
		1993,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(5),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1994,
		1994,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1994,
		1994,
		$elm$time$Time$Aug,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(28),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1995,
		1995,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(31),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1995,
		1995,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(3),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1996,
		1996,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(14),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1996,
		1996,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(15),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1997,
		1997,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1997,
		1997,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(13),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1998,
		1998,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1998,
		1998,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(6),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1999,
		1999,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(2),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1999,
		1999,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(3),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2000,
		2000,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(14),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2000,
		2000,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(6),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2001,
		2001,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(9),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2001,
		2001,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(24),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2002,
		2002,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(29),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2002,
		2002,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(7),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2003,
		2003,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(28),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2003,
		2003,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(3),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2004,
		2004,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(7),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2004,
		2004,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(22),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2005,
		2012,
		$elm$time$Time$Apr,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Prev, $elm$time$Time$Fri, 1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2005,
		2005,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(9),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2006,
		2006,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2007,
		2007,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(16),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		2008,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(5),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2009,
		2009,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(27),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2010,
		2010,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(12),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2011,
		2011,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(2),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2012,
		2012,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(23),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2013,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		$elm$time$Time$Mar,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Fri, 23),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2013,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$asia__gaza = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Zion)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1996, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Jordan)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Palestine)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2008, $elm$time$Time$Aug, 29, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2008, $elm$time$Time$Sep, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Palestine)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2010, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2010, $elm$time$Time$Mar, 27, 1, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Palestine)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, $elm$time$Time$Aug, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2012, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				120,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Palestine))));
};
var $justinmimbs$timezone_data$TimeZone$asia__hebron = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Zion)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1996, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Jordan)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				120,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Palestine))));
};
var $justinmimbs$timezone_data$TimeZone$asia__ho_chi_minh = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						480,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1975, $elm$time$Time$Jun, 13, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				420,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_HK = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1965,
		1976,
		$elm$time$Time$Apr,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 16),
		210,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1965,
		1976,
		$elm$time$Time$Oct,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 16),
		210,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1973,
		1973,
		$elm$time$Time$Dec,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		210,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1979,
		$elm$time$Time$May,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(13),
		210,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1979,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		210,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$asia__hong_kong = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				480,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_HK))));
};
var $justinmimbs$timezone_data$TimeZone$asia__hovd = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1978, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				420,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mongol))));
};
var $justinmimbs$timezone_data$TimeZone$asia__irkutsk = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						480,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Mar, 31, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						420,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, $elm$time$Time$Jan, 19, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						480,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, $elm$time$Time$Mar, 27, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						540,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, $elm$time$Time$Oct, 26, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				480,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__jakarta = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				420,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__jayapura = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				540,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__jerusalem = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				120,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Zion))));
};
var $justinmimbs$timezone_data$TimeZone$asia__kabul = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				270,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__kamchatka = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						720,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Mar, 31, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						660,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, $elm$time$Time$Jan, 19, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						720,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2010, $elm$time$Time$Mar, 28, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						660,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, $elm$time$Time$Mar, 27, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				720,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Pakistan = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2002,
		2002,
		$elm$time$Time$Apr,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 2),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2002,
		2002,
		$elm$time$Time$Oct,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 2),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		2008,
		$elm$time$Time$Jun,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		2009,
		$elm$time$Time$Nov,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2009,
		2009,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(15),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60)
	]);
var $justinmimbs$timezone_data$TimeZone$asia__karachi = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1971, $elm$time$Time$Mar, 26, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				300,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Pakistan))));
};
var $justinmimbs$timezone_data$TimeZone$asia__kathmandu = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						330,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1986, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				345,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__khandyga = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						540,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Mar, 31, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						480,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, $elm$time$Time$Jan, 19, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						540,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						600,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, $elm$time$Time$Mar, 27, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						660,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, $elm$time$Time$Sep, 13, 0, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						600,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, $elm$time$Time$Oct, 26, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				540,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__kolkata = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				330,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__krasnoyarsk = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						420,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Mar, 31, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, $elm$time$Time$Jan, 19, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						420,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, $elm$time$Time$Mar, 27, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						480,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, $elm$time$Time$Oct, 26, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				420,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__kuching = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				480,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Macau = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1965,
		1973,
		$elm$time$Time$Apr,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 16),
		210,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1967,
		1976,
		$elm$time$Time$Oct,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 16),
		210,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1973,
		1973,
		$elm$time$Time$Dec,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		210,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1975,
		1976,
		$elm$time$Time$Apr,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 16),
		210,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1979,
		$elm$time$Time$May,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(13),
		210,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1979,
		$elm$time$Time$Oct,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 16),
		210,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$asia__macau = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				480,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Macau))));
};
var $justinmimbs$timezone_data$TimeZone$asia__magadan = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						660,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Mar, 31, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						600,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, $elm$time$Time$Jan, 19, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						660,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, $elm$time$Time$Mar, 27, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						720,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, $elm$time$Time$Oct, 26, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						600,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2016, $elm$time$Time$Apr, 24, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				660,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__makassar = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				480,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Phil = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(22),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$asia__manila = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				480,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Phil))));
};
var $justinmimbs$timezone_data$TimeZone$asia__nicosia = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Cyprus)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1998, $elm$time$Time$Sep, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				120,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EUAsia))));
};
var $justinmimbs$timezone_data$TimeZone$asia__novokuznetsk = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						420,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Mar, 31, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, $elm$time$Time$Jan, 19, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						420,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2010, $elm$time$Time$Mar, 28, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, $elm$time$Time$Mar, 27, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				420,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__novosibirsk = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						420,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Mar, 31, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, $elm$time$Time$Jan, 19, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						420,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1993, $elm$time$Time$May, 23, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, $elm$time$Time$Mar, 27, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						420,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, $elm$time$Time$Oct, 26, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2016, $elm$time$Time$Jul, 24, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				420,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__omsk = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Mar, 31, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, $elm$time$Time$Jan, 19, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, $elm$time$Time$Mar, 27, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						420,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, $elm$time$Time$Oct, 26, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				360,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__oral = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, $elm$time$Time$Apr, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(60)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, $elm$time$Time$Oct, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1982, $elm$time$Time$Apr, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1989, $elm$time$Time$Mar, 26, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, $elm$time$Time$Jan, 19, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, $elm$time$Time$Mar, 29, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, $elm$time$Time$Oct, 31, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				300,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__pontianak = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						480,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1988, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				420,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__pyongyang = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						540,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2015, $elm$time$Time$Aug, 15, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						510,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2018, $elm$time$Time$May, 4, 1410, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				540,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__qatar = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1972, $elm$time$Time$Jun, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__qostanay = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, $elm$time$Time$Apr, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(60)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, $elm$time$Time$Oct, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1982, $elm$time$Time$Apr, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Mar, 31, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, $elm$time$Time$Jan, 19, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, $elm$time$Time$Oct, 31, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				360,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__qyzylorda = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, $elm$time$Time$Apr, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(60)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, $elm$time$Time$Oct, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1982, $elm$time$Time$Apr, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Mar, 31, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Sep, 29, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, $elm$time$Time$Jan, 19, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, $elm$time$Time$Mar, 29, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, $elm$time$Time$Oct, 31, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2018, $elm$time$Time$Dec, 21, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				300,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__riyadh = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__sakhalin = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						660,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Mar, 31, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						600,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, $elm$time$Time$Jan, 19, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						660,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1997, $elm$time$Time$Mar, 30, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						600,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, $elm$time$Time$Mar, 27, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						660,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, $elm$time$Time$Oct, 26, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						600,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2016, $elm$time$Time$Mar, 27, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				660,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__samarkand = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, $elm$time$Time$Apr, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(60)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, $elm$time$Time$Oct, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1982, $elm$time$Time$Apr, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				300,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_ROK = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		1988,
		$elm$time$Time$May,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 8),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		1988,
		$elm$time$Time$Oct,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 8),
		180,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$asia__seoul = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				540,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_ROK))));
};
var $justinmimbs$timezone_data$TimeZone$rules_PRC = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		1986,
		$elm$time$Time$May,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(4),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		1991,
		$elm$time$Time$Sep,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 11),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		1991,
		$elm$time$Time$Apr,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 11),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60)
	]);
var $justinmimbs$timezone_data$TimeZone$asia__shanghai = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				480,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_PRC))));
};
var $justinmimbs$timezone_data$TimeZone$asia__singapore = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						450,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, $elm$time$Time$Dec, 31, 960, $justinmimbs$timezone_data$TimeZone$Specification$Universal))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				480,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__srednekolymsk = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						660,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Mar, 31, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						600,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, $elm$time$Time$Jan, 19, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						660,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, $elm$time$Time$Mar, 27, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						720,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, $elm$time$Time$Oct, 26, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				660,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Taiwan = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1975,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1975,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1979,
		$elm$time$Time$Jul,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1979,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$asia__taipei = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				480,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Taiwan))));
};
var $justinmimbs$timezone_data$TimeZone$asia__tashkent = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Mar, 31, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				300,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_E_EurAsia = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1981,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1995,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1996,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$asia__tbilisi = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Mar, 31, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_E_EurAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1994, $elm$time$Time$Sep, 25, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_E_EurAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1996, $elm$time$Time$Oct, 27, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(60)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1997, $elm$time$Time$Mar, 30, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_E_EurAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, $elm$time$Time$Jun, 27, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2005, $elm$time$Time$Mar, 27, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				240,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Iran = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1977,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		1380,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1977,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(24),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		$elm$time$Time$Aug,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(5),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1979,
		$elm$time$Time$May,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(26),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1979,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(18),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1980,
		1980,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1980,
		1980,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(22),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		1991,
		$elm$time$Time$May,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(2),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1992,
		1995,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		1995,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1996,
		1996,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1996,
		1996,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1997,
		1999,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1997,
		1999,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2000,
		2000,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2000,
		2000,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2001,
		2003,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2001,
		2003,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2004,
		2004,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2004,
		2004,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2005,
		2005,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2005,
		2005,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		2008,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		2008,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2009,
		2011,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2009,
		2011,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2012,
		2012,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2012,
		2012,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2013,
		2015,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2013,
		2015,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2016,
		2016,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2016,
		2016,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2017,
		2019,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2017,
		2019,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2020,
		2020,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2020,
		2020,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2021,
		2022,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2021,
		2022,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$asia__tehran = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						210,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Iran)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1977, $elm$time$Time$Oct, 20, 1440, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Iran)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1979, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				210,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Iran))));
};
var $justinmimbs$timezone_data$TimeZone$asia__thimphu = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						330,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1987, $elm$time$Time$Oct, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				360,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__tokyo = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				540,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__tomsk = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						420,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Mar, 31, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, $elm$time$Time$Jan, 19, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						420,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2002, $elm$time$Time$May, 1, 180, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, $elm$time$Time$Mar, 27, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						420,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, $elm$time$Time$Oct, 26, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2016, $elm$time$Time$May, 29, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				420,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__ulaanbaatar = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						420,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1978, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				480,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mongol))));
};
var $justinmimbs$timezone_data$TimeZone$asia__urumqi = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				360,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__ust_nera = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						540,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, $elm$time$Time$Apr, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						660,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Mar, 31, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						600,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, $elm$time$Time$Jan, 19, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						660,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, $elm$time$Time$Mar, 27, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						720,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, $elm$time$Time$Sep, 13, 0, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						660,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, $elm$time$Time$Oct, 26, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				600,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__vladivostok = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						600,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Mar, 31, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						540,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, $elm$time$Time$Jan, 19, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						600,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, $elm$time$Time$Mar, 27, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						660,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, $elm$time$Time$Oct, 26, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				600,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__yakutsk = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						540,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Mar, 31, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						480,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, $elm$time$Time$Jan, 19, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						540,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, $elm$time$Time$Mar, 27, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						600,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, $elm$time$Time$Oct, 26, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				540,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__yangon = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				390,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__yekaterinburg = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Mar, 31, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, $elm$time$Time$Jan, 19, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, $elm$time$Time$Mar, 27, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, $elm$time$Time$Oct, 26, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				300,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Armenia = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2011,
		2011,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2011,
		2011,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$asia__yerevan = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Mar, 31, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1995, $elm$time$Time$Sep, 24, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1997, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				240,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Armenia))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Port = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1977,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(27),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1977,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(25),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1979,
		$elm$time$Time$Apr,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1982,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1980,
		1980,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1981,
		1982,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1983,
		1983,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60)
	]);
var $justinmimbs$timezone_data$TimeZone$rules_W_Eur = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1980,
		$elm$time$Time$Apr,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1977,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1995,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1981,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1996,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$atlantic__azores = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-60,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Port)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1983, $elm$time$Time$Sep, 25, 60, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-60,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_W_Eur)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, $elm$time$Time$Sep, 27, 60, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						0,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1993, $elm$time$Time$Mar, 28, 60, $justinmimbs$timezone_data$TimeZone$Specification$Universal))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-60,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$atlantic__bermuda = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1974, $elm$time$Time$Apr, 28, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1976, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-240,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$atlantic__canary = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						0,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1980, $elm$time$Time$Apr, 6, 0, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						0,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(60)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1980, $elm$time$Time$Sep, 28, 60, $justinmimbs$timezone_data$TimeZone$Specification$Universal))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				0,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$atlantic__cape_verde = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-120,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1975, $elm$time$Time$Nov, 25, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-60,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$atlantic__faroe = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						0,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				0,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$atlantic__madeira = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						0,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Port)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1983, $elm$time$Time$Sep, 25, 60, $justinmimbs$timezone_data$TimeZone$Specification$Standard))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				0,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$atlantic__south_georgia = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-120,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Falk = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1983,
		1983,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1984,
		1985,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1984,
		1984,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(16),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1985,
		2000,
		$elm$time$Time$Sep,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 9),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		2000,
		$elm$time$Time$Apr,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 16),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2001,
		2010,
		$elm$time$Time$Apr,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 15),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2001,
		2010,
		$elm$time$Time$Sep,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60)
	]);
var $justinmimbs$timezone_data$TimeZone$atlantic__stanley = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Falk)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1983, $elm$time$Time$May, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Falk)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1985, $elm$time$Time$Sep, 15, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Falk)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2010, $elm$time$Time$Sep, 5, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_AS = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1971,
		1985,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		1986,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(19),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		2007,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1972,
		1972,
		$elm$time$Time$Feb,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(27),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1973,
		1985,
		$elm$time$Time$Mar,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		1990,
		$elm$time$Time$Mar,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 15),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		1991,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(3),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1992,
		1992,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(22),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1993,
		1993,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(7),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1994,
		1994,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1995,
		2005,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2006,
		2006,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(2),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2007,
		2007,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		$elm$time$Time$Apr,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		$elm$time$Time$Oct,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60)
	]);
var $justinmimbs$timezone_data$TimeZone$australia__adelaide = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						570,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1971, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				570,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_AS))));
};
var $justinmimbs$timezone_data$TimeZone$rules_AQ = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1971,
		1971,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1972,
		1972,
		$elm$time$Time$Feb,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1989,
		1991,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1990,
		1992,
		$elm$time$Time$Mar,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$australia__brisbane = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						600,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1971, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				600,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_AQ))));
};
var $justinmimbs$timezone_data$TimeZone$rules_AN = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1971,
		1985,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1972,
		1972,
		$elm$time$Time$Feb,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(27),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1973,
		1981,
		$elm$time$Time$Mar,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1982,
		1982,
		$elm$time$Time$Apr,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1983,
		1985,
		$elm$time$Time$Mar,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		1989,
		$elm$time$Time$Mar,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 15),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		1986,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(19),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		1999,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1990,
		1995,
		$elm$time$Time$Mar,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1996,
		2005,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2000,
		2000,
		$elm$time$Time$Aug,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2001,
		2007,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2006,
		2006,
		$elm$time$Time$Apr,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2007,
		2007,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		$elm$time$Time$Apr,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		$elm$time$Time$Oct,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60)
	]);
var $justinmimbs$timezone_data$TimeZone$australia__broken_hill = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						570,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1971, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						570,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_AN)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				570,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_AS))));
};
var $justinmimbs$timezone_data$TimeZone$australia__darwin = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				570,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_AW = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1974,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1975,
		1975,
		$elm$time$Time$Mar,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1983,
		1983,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1984,
		1984,
		$elm$time$Time$Mar,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		1991,
		$elm$time$Time$Nov,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(17),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1992,
		1992,
		$elm$time$Time$Mar,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2006,
		2006,
		$elm$time$Time$Dec,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(3),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2007,
		2009,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2007,
		2008,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60)
	]);
var $justinmimbs$timezone_data$TimeZone$australia__eucla = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				525,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_AW))));
};
var $justinmimbs$timezone_data$TimeZone$australia__hobart = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				600,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_AT))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Holiday = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1992,
		1993,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1993,
		1994,
		$elm$time$Time$Mar,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$australia__lindeman = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						600,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1971, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						600,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_AQ)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, $elm$time$Time$Jul, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				600,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Holiday))));
};
var $justinmimbs$timezone_data$TimeZone$rules_LH = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1981,
		1984,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1982,
		1985,
		$elm$time$Time$Mar,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1985,
		1985,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		30),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		1989,
		$elm$time$Time$Mar,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 15),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		1986,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(19),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		30),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		1999,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		30),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1990,
		1995,
		$elm$time$Time$Mar,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1996,
		2005,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2000,
		2000,
		$elm$time$Time$Aug,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		30),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2001,
		2007,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		30),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2006,
		2006,
		$elm$time$Time$Apr,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2007,
		2007,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		$elm$time$Time$Apr,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		$elm$time$Time$Oct,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		30)
	]);
var $justinmimbs$timezone_data$TimeZone$australia__lord_howe = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						600,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, $elm$time$Time$Mar, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						630,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_LH)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1985, $elm$time$Time$Jul, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				630,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_LH))));
};
var $justinmimbs$timezone_data$TimeZone$rules_AV = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1971,
		1985,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1972,
		1972,
		$elm$time$Time$Feb,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1973,
		1985,
		$elm$time$Time$Mar,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		1990,
		$elm$time$Time$Mar,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 15),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		1987,
		$elm$time$Time$Oct,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 15),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1988,
		1999,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		1994,
		$elm$time$Time$Mar,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1995,
		2005,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2000,
		2000,
		$elm$time$Time$Aug,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2001,
		2007,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2006,
		2006,
		$elm$time$Time$Apr,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2007,
		2007,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		$elm$time$Time$Apr,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		$elm$time$Time$Oct,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60)
	]);
var $justinmimbs$timezone_data$TimeZone$australia__melbourne = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						600,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1971, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				600,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_AV))));
};
var $justinmimbs$timezone_data$TimeZone$australia__perth = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				480,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_AW))));
};
var $justinmimbs$timezone_data$TimeZone$australia__sydney = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						600,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1971, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				600,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_AN))));
};
var $justinmimbs$timezone_data$TimeZone$europe__andorra = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1985, $elm$time$Time$Mar, 31, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				60,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$europe__astrakhan = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1989, $elm$time$Time$Mar, 26, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Mar, 31, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, $elm$time$Time$Mar, 29, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, $elm$time$Time$Mar, 27, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, $elm$time$Time$Oct, 26, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2016, $elm$time$Time$Mar, 27, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				240,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Greece = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1975,
		1975,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(12),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1975,
		1975,
		$elm$time$Time$Nov,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(26),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1976,
		1976,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(11),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1976,
		1976,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(10),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1978,
		$elm$time$Time$Apr,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1977,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(26),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(24),
		240,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1979,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		540,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1979,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(29),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1980,
		1980,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1980,
		1980,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(28),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$europe__athens = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Greece)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				120,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$europe__belgrade = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1982, $elm$time$Time$Nov, 27, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				60,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$europe__berlin = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1980, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				60,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$europe__brussels = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1977, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				60,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$rules_E_Eur = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1980,
		$elm$time$Time$Apr,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1977,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1995,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1981,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1996,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$rules_Romania = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1979,
		$elm$time$Time$May,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(27),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1979,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1980,
		1980,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(5),
		1380,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1980,
		1980,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		1993,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		1993,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$europe__bucharest = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Romania)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, $elm$time$Time$Mar, 29, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_C_Eur)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Romania)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1994, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_E_Eur)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1997, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				120,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Hungary = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1980,
		1980,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(6),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1980,
		1980,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(28),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1981,
		1983,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1981,
		1983,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$europe__budapest = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Hungary)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1984, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				60,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Moldova = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1997,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1997,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		180,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$europe__chisinau = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1990, $elm$time$Time$May, 6, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_E_Eur)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1997, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				120,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Moldova))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Eire = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1971,
		1971,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(31),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Universal,
		-60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1972,
		1980,
		$elm$time$Time$Mar,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 16),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Universal,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1972,
		1980,
		$elm$time$Time$Oct,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 23),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Universal,
		-60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1981,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$Universal,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1981,
		1989,
		$elm$time$Time$Oct,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 23),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$Universal,
		-60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1990,
		1995,
		$elm$time$Time$Oct,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 22),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$Universal,
		-60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1996,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$Universal,
		-60)
	]);
var $justinmimbs$timezone_data$TimeZone$europe__dublin = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				60,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Eire))));
};
var $justinmimbs$timezone_data$TimeZone$europe__gibraltar = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1982, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				60,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Finland = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1981,
		1982,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1981,
		1982,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		180,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$europe__helsinki = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Finland)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1983, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				120,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Turkey = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1973,
		1973,
		$elm$time$Time$Jun,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(3),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1973,
		1976,
		$elm$time$Time$Oct,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 31),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1974,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(31),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1975,
		1975,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(22),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1976,
		1976,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1978,
		$elm$time$Time$Apr,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1978,
		$elm$time$Time$Oct,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 15),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		$elm$time$Time$Jun,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(29),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1983,
		1983,
		$elm$time$Time$Jul,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(31),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1983,
		1983,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(2),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1985,
		1985,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1985,
		1985,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(28),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		1993,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		1995,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1994,
		1994,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1995,
		2006,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1996,
		2006,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$europe__istanbul = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Turkey)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1978, $elm$time$Time$Jun, 29, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Turkey)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1984, $elm$time$Time$Nov, 1, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Turkey)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2007, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, $elm$time$Time$Mar, 27, 60, $justinmimbs$timezone_data$TimeZone$Specification$Universal)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, $elm$time$Time$Mar, 28, 60, $justinmimbs$timezone_data$TimeZone$Specification$Universal)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, $elm$time$Time$Mar, 30, 60, $justinmimbs$timezone_data$TimeZone$Specification$Universal)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, $elm$time$Time$Mar, 31, 60, $justinmimbs$timezone_data$TimeZone$Specification$Universal)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2015, $elm$time$Time$Oct, 25, 60, $justinmimbs$timezone_data$TimeZone$Specification$Universal)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(60)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2015, $elm$time$Time$Nov, 8, 60, $justinmimbs$timezone_data$TimeZone$Specification$Universal)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2016, $elm$time$Time$Sep, 7, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$europe__kaliningrad = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1989, $elm$time$Time$Mar, 26, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, $elm$time$Time$Mar, 27, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, $elm$time$Time$Oct, 26, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				120,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$europe__kirov = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1989, $elm$time$Time$Mar, 26, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Mar, 31, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, $elm$time$Time$Mar, 29, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, $elm$time$Time$Mar, 27, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, $elm$time$Time$Oct, 26, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$europe__kyiv = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1990, $elm$time$Time$Jul, 1, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(60)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Sep, 29, 180, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_C_Eur)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1996, $elm$time$Time$May, 13, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				120,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$europe__lisbon = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1976, $elm$time$Time$Sep, 26, 60, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						0,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Port)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1983, $elm$time$Time$Sep, 25, 60, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						0,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_W_Eur)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, $elm$time$Time$Sep, 27, 60, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1996, $elm$time$Time$Mar, 31, 60, $justinmimbs$timezone_data$TimeZone$Specification$Universal))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				0,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$rules_GB_Eire = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1972,
		1980,
		$elm$time$Time$Mar,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 16),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1972,
		1980,
		$elm$time$Time$Oct,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 23),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1981,
		1995,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$Universal,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1981,
		1989,
		$elm$time$Time$Oct,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 23),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$Universal,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1990,
		1995,
		$elm$time$Time$Oct,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 22),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$Universal,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$europe__london = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1971, $elm$time$Time$Oct, 31, 120, $justinmimbs$timezone_data$TimeZone$Specification$Universal)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						0,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_GB_Eire)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1996, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				0,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Spain = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1975,
		$elm$time$Time$Apr,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sat, 12),
		1380,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1975,
		$elm$time$Time$Oct,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1976,
		1976,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(27),
		1380,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1976,
		1977,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1977,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(2),
		1380,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(2),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$europe__madrid = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Spain)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1979, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				60,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Italy = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1967,
		1969,
		$elm$time$Time$Sep,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 22),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1969,
		1969,
		$elm$time$Time$Jun,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1970,
		1970,
		$elm$time$Time$May,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(31),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1970,
		1970,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1971,
		1972,
		$elm$time$Time$May,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 22),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1971,
		1971,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1972,
		1972,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1973,
		1973,
		$elm$time$Time$Jun,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(3),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1973,
		1974,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1974,
		$elm$time$Time$May,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(26),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1975,
		1975,
		$elm$time$Time$Jun,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1975,
		1977,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1976,
		1976,
		$elm$time$Time$May,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1979,
		$elm$time$Time$May,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 22),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1979,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$rules_Malta = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1973,
		1973,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(31),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1973,
		1973,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(29),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1974,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1974,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(16),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1975,
		1979,
		$elm$time$Time$Apr,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 15),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1975,
		1980,
		$elm$time$Time$Sep,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 15),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1980,
		1980,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(31),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60)
	]);
var $justinmimbs$timezone_data$TimeZone$europe__malta = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Italy)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1973, $elm$time$Time$Mar, 31, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Malta)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				60,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$europe__minsk = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1990, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Mar, 31, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, $elm$time$Time$Mar, 27, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$europe__moscow = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Mar, 31, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, $elm$time$Time$Jan, 19, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, $elm$time$Time$Mar, 27, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, $elm$time$Time$Oct, 26, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_France = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1976,
		1976,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(28),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1976,
		1976,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(26),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$europe__paris = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_France)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1977, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				60,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$europe__prague = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1979, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				60,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Latvia = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1989,
		1996,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1989,
		1996,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$europe__riga = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1989, $elm$time$Time$Mar, 26, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(60)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1989, $elm$time$Time$Sep, 24, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Latvia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1997, $elm$time$Time$Jan, 21, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, $elm$time$Time$Feb, 29, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2001, $elm$time$Time$Jan, 2, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				120,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$europe__rome = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Italy)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1980, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				60,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$europe__samara = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1989, $elm$time$Time$Mar, 26, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Mar, 31, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Sep, 29, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Oct, 20, 180, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2010, $elm$time$Time$Mar, 28, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, $elm$time$Time$Mar, 27, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				240,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$europe__saratov = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1988, $elm$time$Time$Mar, 27, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Mar, 31, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, $elm$time$Time$Mar, 29, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, $elm$time$Time$Mar, 27, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, $elm$time$Time$Oct, 26, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2016, $elm$time$Time$Dec, 4, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				240,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$europe__simferopol = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1990, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1990, $elm$time$Time$Jul, 1, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, $elm$time$Time$Mar, 20, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_C_Eur)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1994, $elm$time$Time$May, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_C_Eur)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1996, $elm$time$Time$Mar, 31, 0, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(60)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1996, $elm$time$Time$Oct, 27, 180, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1997, $elm$time$Time$Mar, 30, 60, $justinmimbs$timezone_data$TimeZone$Specification$Universal)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, $elm$time$Time$Mar, 30, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, $elm$time$Time$Oct, 26, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Bulg = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1979,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(31),
		1380,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1979,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1980,
		1982,
		$elm$time$Time$Apr,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sat, 1),
		1380,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1980,
		1980,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(29),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1981,
		1981,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(27),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$europe__sofia = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1979, $elm$time$Time$Mar, 31, 1380, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Bulg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1982, $elm$time$Time$Sep, 26, 180, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_C_Eur)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_E_Eur)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1997, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				120,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$europe__tallinn = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1989, $elm$time$Time$Mar, 26, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(60)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1989, $elm$time$Time$Sep, 24, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_C_Eur)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1998, $elm$time$Time$Sep, 22, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, $elm$time$Time$Oct, 31, 240, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2002, $elm$time$Time$Feb, 21, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				120,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Albania = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1974,
		$elm$time$Time$May,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(4),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1974,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(2),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1975,
		1975,
		$elm$time$Time$May,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1975,
		1975,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(2),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1976,
		1976,
		$elm$time$Time$May,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(2),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1976,
		1976,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(3),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1977,
		$elm$time$Time$May,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(8),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1977,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(2),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		$elm$time$Time$May,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(6),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1979,
		$elm$time$Time$May,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(5),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1979,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1980,
		1980,
		$elm$time$Time$May,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(3),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1980,
		1980,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(4),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1981,
		1981,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(26),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1981,
		1981,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(27),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1982,
		1982,
		$elm$time$Time$May,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(2),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1982,
		1982,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(3),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1983,
		1983,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(18),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1983,
		1983,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1984,
		1984,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60)
	]);
var $justinmimbs$timezone_data$TimeZone$europe__tirane = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Albania)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1984, $elm$time$Time$Jul, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				60,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$europe__ulyanovsk = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1989, $elm$time$Time$Mar, 26, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Mar, 31, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, $elm$time$Time$Jan, 19, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, $elm$time$Time$Mar, 27, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, $elm$time$Time$Oct, 26, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2016, $elm$time$Time$Mar, 27, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				240,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Austria = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1980,
		1980,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(6),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1980,
		1980,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(28),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$europe__vienna = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Austria)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				60,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$europe__vilnius = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1989, $elm$time$Time$Mar, 26, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Sep, 29, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_C_Eur)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1998, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1998, $elm$time$Time$Mar, 29, 60, $justinmimbs$timezone_data$TimeZone$Specification$Universal)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, $elm$time$Time$Oct, 31, 60, $justinmimbs$timezone_data$TimeZone$Specification$Universal)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2003, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				120,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$europe__volgograd = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1988, $elm$time$Time$Mar, 27, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Mar, 31, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, $elm$time$Time$Mar, 29, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, $elm$time$Time$Mar, 27, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, $elm$time$Time$Oct, 26, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2018, $elm$time$Time$Oct, 28, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2020, $elm$time$Time$Dec, 27, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$europe__warsaw = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1977, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_W_Eur)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1988, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				60,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$europe__zurich = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				60,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$indian__chagos = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1996, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				360,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$indian__maldives = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				300,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Mauritius = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1982,
		1982,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(10),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1983,
		1983,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		2008,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2009,
		2009,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$indian__mauritius = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				240,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mauritius))));
};
var $justinmimbs$timezone_data$TimeZone$rules_WS = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2010,
		2010,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2011,
		2011,
		$elm$time$Time$Apr,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sat, 1),
		240,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2011,
		2011,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sat),
		180,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2012,
		2021,
		$elm$time$Time$Apr,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		240,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2012,
		2020,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		180,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60)
	]);
var $justinmimbs$timezone_data$TimeZone$pacific__apia = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-660,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_WS)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, $elm$time$Time$Dec, 29, 1440, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				780,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_WS))));
};
var $justinmimbs$timezone_data$TimeZone$rules_NZ = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1974,
		$elm$time$Time$Nov,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1975,
		1975,
		$elm$time$Time$Feb,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1975,
		1988,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1976,
		1989,
		$elm$time$Time$Mar,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1989,
		1989,
		$elm$time$Time$Oct,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 8),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1990,
		2006,
		$elm$time$Time$Oct,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1990,
		2007,
		$elm$time$Time$Mar,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 15),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2007,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		$elm$time$Time$Apr,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$pacific__auckland = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				720,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_NZ))));
};
var $justinmimbs$timezone_data$TimeZone$pacific__bougainville = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						600,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, $elm$time$Time$Dec, 28, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				660,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Chatham = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1974,
		$elm$time$Time$Nov,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		165,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1975,
		1975,
		$elm$time$Time$Feb,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		165,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1975,
		1988,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		165,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1976,
		1989,
		$elm$time$Time$Mar,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		165,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1989,
		1989,
		$elm$time$Time$Oct,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 8),
		165,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1990,
		2006,
		$elm$time$Time$Oct,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		165,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1990,
		2007,
		$elm$time$Time$Mar,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 15),
		165,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2007,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		165,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		$elm$time$Time$Apr,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		165,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$pacific__chatham = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				765,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Chatham))));
};
var $justinmimbs$timezone_data$TimeZone$pacific__easter = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-420,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Chile)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1982, $elm$time$Time$Mar, 14, 180, $justinmimbs$timezone_data$TimeZone$Specification$Universal))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-360,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Chile))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Vanuatu = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1973,
		1973,
		$elm$time$Time$Dec,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(22),
		720,
		$justinmimbs$timezone_data$TimeZone$Specification$Universal,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1974,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		720,
		$justinmimbs$timezone_data$TimeZone$Specification$Universal,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1983,
		1991,
		$elm$time$Time$Sep,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sat, 22),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1984,
		1991,
		$elm$time$Time$Mar,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sat, 22),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1992,
		1993,
		$elm$time$Time$Jan,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sat, 22),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1992,
		1992,
		$elm$time$Time$Oct,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sat, 22),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60)
	]);
var $justinmimbs$timezone_data$TimeZone$pacific__efate = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				660,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Vanuatu))));
};
var $justinmimbs$timezone_data$TimeZone$pacific__fakaofo = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-660,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, $elm$time$Time$Dec, 30, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				780,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Fiji = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1998,
		1999,
		$elm$time$Time$Nov,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1999,
		2000,
		$elm$time$Time$Feb,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		180,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2009,
		2009,
		$elm$time$Time$Nov,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(29),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2010,
		2010,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		180,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2010,
		2013,
		$elm$time$Time$Oct,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 21),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2011,
		2011,
		$elm$time$Time$Mar,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		180,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2012,
		2013,
		$elm$time$Time$Jan,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 18),
		180,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2014,
		2014,
		$elm$time$Time$Jan,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 18),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2014,
		2018,
		$elm$time$Time$Nov,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2015,
		2021,
		$elm$time$Time$Jan,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 12),
		180,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2019,
		2019,
		$elm$time$Time$Nov,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 8),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2020,
		2020,
		$elm$time$Time$Dec,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60)
	]);
var $justinmimbs$timezone_data$TimeZone$pacific__fiji = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				720,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Fiji))));
};
var $justinmimbs$timezone_data$TimeZone$pacific__galapagos = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1986, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-360,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Ecuador))));
};
var $justinmimbs$timezone_data$TimeZone$pacific__gambier = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-540,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$pacific__guadalcanal = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				660,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Guam = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1969,
		1969,
		$elm$time$Time$Jan,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(26),
		1,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1969,
		1969,
		$elm$time$Time$Jun,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(22),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1969,
		1969,
		$elm$time$Time$Aug,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(31),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1970,
		1971,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1970,
		1971,
		$elm$time$Time$Sep,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1973,
		1973,
		$elm$time$Time$Dec,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(16),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1974,
		$elm$time$Time$Feb,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(24),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1976,
		1976,
		$elm$time$Time$May,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(26),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1976,
		1976,
		$elm$time$Time$Aug,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(22),
		121,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1977,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(24),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1977,
		$elm$time$Time$Aug,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(28),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$pacific__guam = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						600,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Guam)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, $elm$time$Time$Dec, 23, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				600,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$pacific__honolulu = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-600,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$pacific__kanton = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-720,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1979, $elm$time$Time$Oct, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-660,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1994, $elm$time$Time$Dec, 31, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				780,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$pacific__kiritimati = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-640,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1979, $elm$time$Time$Oct, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-600,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1994, $elm$time$Time$Dec, 31, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				840,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$pacific__kosrae = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						720,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				660,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$pacific__kwajalein = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-720,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1993, $elm$time$Time$Aug, 20, 1440, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				720,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$pacific__marquesas = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-570,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$pacific__nauru = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						690,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1979, $elm$time$Time$Feb, 10, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				720,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$pacific__niue = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-660,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$pacific__norfolk = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						690,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1974, $elm$time$Time$Oct, 27, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						690,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(60)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1975, $elm$time$Time$Mar, 2, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						690,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2015, $elm$time$Time$Oct, 4, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						660,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2019, $elm$time$Time$Jul, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				660,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_AN))));
};
var $justinmimbs$timezone_data$TimeZone$rules_NC = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1978,
		$elm$time$Time$Dec,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1979,
		$elm$time$Time$Feb,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(27),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1996,
		1996,
		$elm$time$Time$Dec,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1997,
		1997,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(2),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$pacific__noumea = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				660,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_NC))));
};
var $justinmimbs$timezone_data$TimeZone$pacific__pago_pago = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-660,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$pacific__palau = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				540,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$pacific__pitcairn = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-510,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1998, $elm$time$Time$Apr, 27, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-480,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$pacific__port_moresby = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				600,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Cook = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		$elm$time$Time$Nov,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(12),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		30),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1991,
		$elm$time$Time$Mar,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1990,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		30)
	]);
var $justinmimbs$timezone_data$TimeZone$pacific__rarotonga = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-630,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1978, $elm$time$Time$Nov, 12, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-600,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Cook))));
};
var $justinmimbs$timezone_data$TimeZone$pacific__tahiti = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-600,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$pacific__tarawa = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				720,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Tonga = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1999,
		1999,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(7),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2000,
		2000,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(19),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2000,
		2001,
		$elm$time$Time$Nov,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2001,
		2002,
		$elm$time$Time$Jan,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2016,
		2016,
		$elm$time$Time$Nov,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2017,
		2017,
		$elm$time$Time$Jan,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 15),
		180,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$pacific__tongatapu = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						780,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				780,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Tonga))));
};
var $justinmimbs$timezone_data$TimeZone$zones = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2('Africa/Abidjan', $justinmimbs$timezone_data$TimeZone$africa__abidjan),
			_Utils_Tuple2('Africa/Algiers', $justinmimbs$timezone_data$TimeZone$africa__algiers),
			_Utils_Tuple2('Africa/Bissau', $justinmimbs$timezone_data$TimeZone$africa__bissau),
			_Utils_Tuple2('Africa/Cairo', $justinmimbs$timezone_data$TimeZone$africa__cairo),
			_Utils_Tuple2('Africa/Casablanca', $justinmimbs$timezone_data$TimeZone$africa__casablanca),
			_Utils_Tuple2('Africa/Ceuta', $justinmimbs$timezone_data$TimeZone$africa__ceuta),
			_Utils_Tuple2('Africa/El_Aaiun', $justinmimbs$timezone_data$TimeZone$africa__el_aaiun),
			_Utils_Tuple2('Africa/Johannesburg', $justinmimbs$timezone_data$TimeZone$africa__johannesburg),
			_Utils_Tuple2('Africa/Juba', $justinmimbs$timezone_data$TimeZone$africa__juba),
			_Utils_Tuple2('Africa/Khartoum', $justinmimbs$timezone_data$TimeZone$africa__khartoum),
			_Utils_Tuple2('Africa/Lagos', $justinmimbs$timezone_data$TimeZone$africa__lagos),
			_Utils_Tuple2('Africa/Maputo', $justinmimbs$timezone_data$TimeZone$africa__maputo),
			_Utils_Tuple2('Africa/Monrovia', $justinmimbs$timezone_data$TimeZone$africa__monrovia),
			_Utils_Tuple2('Africa/Nairobi', $justinmimbs$timezone_data$TimeZone$africa__nairobi),
			_Utils_Tuple2('Africa/Ndjamena', $justinmimbs$timezone_data$TimeZone$africa__ndjamena),
			_Utils_Tuple2('Africa/Sao_Tome', $justinmimbs$timezone_data$TimeZone$africa__sao_tome),
			_Utils_Tuple2('Africa/Tripoli', $justinmimbs$timezone_data$TimeZone$africa__tripoli),
			_Utils_Tuple2('Africa/Tunis', $justinmimbs$timezone_data$TimeZone$africa__tunis),
			_Utils_Tuple2('Africa/Windhoek', $justinmimbs$timezone_data$TimeZone$africa__windhoek),
			_Utils_Tuple2('America/Adak', $justinmimbs$timezone_data$TimeZone$america__adak),
			_Utils_Tuple2('America/Anchorage', $justinmimbs$timezone_data$TimeZone$america__anchorage),
			_Utils_Tuple2('America/Araguaina', $justinmimbs$timezone_data$TimeZone$america__araguaina),
			_Utils_Tuple2('America/Argentina/Buenos_Aires', $justinmimbs$timezone_data$TimeZone$america__argentina__buenos_aires),
			_Utils_Tuple2('America/Argentina/Catamarca', $justinmimbs$timezone_data$TimeZone$america__argentina__catamarca),
			_Utils_Tuple2('America/Argentina/Cordoba', $justinmimbs$timezone_data$TimeZone$america__argentina__cordoba),
			_Utils_Tuple2('America/Argentina/Jujuy', $justinmimbs$timezone_data$TimeZone$america__argentina__jujuy),
			_Utils_Tuple2('America/Argentina/La_Rioja', $justinmimbs$timezone_data$TimeZone$america__argentina__la_rioja),
			_Utils_Tuple2('America/Argentina/Mendoza', $justinmimbs$timezone_data$TimeZone$america__argentina__mendoza),
			_Utils_Tuple2('America/Argentina/Rio_Gallegos', $justinmimbs$timezone_data$TimeZone$america__argentina__rio_gallegos),
			_Utils_Tuple2('America/Argentina/Salta', $justinmimbs$timezone_data$TimeZone$america__argentina__salta),
			_Utils_Tuple2('America/Argentina/San_Juan', $justinmimbs$timezone_data$TimeZone$america__argentina__san_juan),
			_Utils_Tuple2('America/Argentina/San_Luis', $justinmimbs$timezone_data$TimeZone$america__argentina__san_luis),
			_Utils_Tuple2('America/Argentina/Tucuman', $justinmimbs$timezone_data$TimeZone$america__argentina__tucuman),
			_Utils_Tuple2('America/Argentina/Ushuaia', $justinmimbs$timezone_data$TimeZone$america__argentina__ushuaia),
			_Utils_Tuple2('America/Asuncion', $justinmimbs$timezone_data$TimeZone$america__asuncion),
			_Utils_Tuple2('America/Bahia', $justinmimbs$timezone_data$TimeZone$america__bahia),
			_Utils_Tuple2('America/Bahia_Banderas', $justinmimbs$timezone_data$TimeZone$america__bahia_banderas),
			_Utils_Tuple2('America/Barbados', $justinmimbs$timezone_data$TimeZone$america__barbados),
			_Utils_Tuple2('America/Belem', $justinmimbs$timezone_data$TimeZone$america__belem),
			_Utils_Tuple2('America/Belize', $justinmimbs$timezone_data$TimeZone$america__belize),
			_Utils_Tuple2('America/Boa_Vista', $justinmimbs$timezone_data$TimeZone$america__boa_vista),
			_Utils_Tuple2('America/Bogota', $justinmimbs$timezone_data$TimeZone$america__bogota),
			_Utils_Tuple2('America/Boise', $justinmimbs$timezone_data$TimeZone$america__boise),
			_Utils_Tuple2('America/Cambridge_Bay', $justinmimbs$timezone_data$TimeZone$america__cambridge_bay),
			_Utils_Tuple2('America/Campo_Grande', $justinmimbs$timezone_data$TimeZone$america__campo_grande),
			_Utils_Tuple2('America/Cancun', $justinmimbs$timezone_data$TimeZone$america__cancun),
			_Utils_Tuple2('America/Caracas', $justinmimbs$timezone_data$TimeZone$america__caracas),
			_Utils_Tuple2('America/Cayenne', $justinmimbs$timezone_data$TimeZone$america__cayenne),
			_Utils_Tuple2('America/Chicago', $justinmimbs$timezone_data$TimeZone$america__chicago),
			_Utils_Tuple2('America/Chihuahua', $justinmimbs$timezone_data$TimeZone$america__chihuahua),
			_Utils_Tuple2('America/Ciudad_Juarez', $justinmimbs$timezone_data$TimeZone$america__ciudad_juarez),
			_Utils_Tuple2('America/Costa_Rica', $justinmimbs$timezone_data$TimeZone$america__costa_rica),
			_Utils_Tuple2('America/Cuiaba', $justinmimbs$timezone_data$TimeZone$america__cuiaba),
			_Utils_Tuple2('America/Danmarkshavn', $justinmimbs$timezone_data$TimeZone$america__danmarkshavn),
			_Utils_Tuple2('America/Dawson', $justinmimbs$timezone_data$TimeZone$america__dawson),
			_Utils_Tuple2('America/Dawson_Creek', $justinmimbs$timezone_data$TimeZone$america__dawson_creek),
			_Utils_Tuple2('America/Denver', $justinmimbs$timezone_data$TimeZone$america__denver),
			_Utils_Tuple2('America/Detroit', $justinmimbs$timezone_data$TimeZone$america__detroit),
			_Utils_Tuple2('America/Edmonton', $justinmimbs$timezone_data$TimeZone$america__edmonton),
			_Utils_Tuple2('America/Eirunepe', $justinmimbs$timezone_data$TimeZone$america__eirunepe),
			_Utils_Tuple2('America/El_Salvador', $justinmimbs$timezone_data$TimeZone$america__el_salvador),
			_Utils_Tuple2('America/Fort_Nelson', $justinmimbs$timezone_data$TimeZone$america__fort_nelson),
			_Utils_Tuple2('America/Fortaleza', $justinmimbs$timezone_data$TimeZone$america__fortaleza),
			_Utils_Tuple2('America/Glace_Bay', $justinmimbs$timezone_data$TimeZone$america__glace_bay),
			_Utils_Tuple2('America/Goose_Bay', $justinmimbs$timezone_data$TimeZone$america__goose_bay),
			_Utils_Tuple2('America/Grand_Turk', $justinmimbs$timezone_data$TimeZone$america__grand_turk),
			_Utils_Tuple2('America/Guatemala', $justinmimbs$timezone_data$TimeZone$america__guatemala),
			_Utils_Tuple2('America/Guayaquil', $justinmimbs$timezone_data$TimeZone$america__guayaquil),
			_Utils_Tuple2('America/Guyana', $justinmimbs$timezone_data$TimeZone$america__guyana),
			_Utils_Tuple2('America/Halifax', $justinmimbs$timezone_data$TimeZone$america__halifax),
			_Utils_Tuple2('America/Havana', $justinmimbs$timezone_data$TimeZone$america__havana),
			_Utils_Tuple2('America/Hermosillo', $justinmimbs$timezone_data$TimeZone$america__hermosillo),
			_Utils_Tuple2('America/Indiana/Indianapolis', $justinmimbs$timezone_data$TimeZone$america__indiana__indianapolis),
			_Utils_Tuple2('America/Indiana/Knox', $justinmimbs$timezone_data$TimeZone$america__indiana__knox),
			_Utils_Tuple2('America/Indiana/Marengo', $justinmimbs$timezone_data$TimeZone$america__indiana__marengo),
			_Utils_Tuple2('America/Indiana/Petersburg', $justinmimbs$timezone_data$TimeZone$america__indiana__petersburg),
			_Utils_Tuple2('America/Indiana/Tell_City', $justinmimbs$timezone_data$TimeZone$america__indiana__tell_city),
			_Utils_Tuple2('America/Indiana/Vevay', $justinmimbs$timezone_data$TimeZone$america__indiana__vevay),
			_Utils_Tuple2('America/Indiana/Vincennes', $justinmimbs$timezone_data$TimeZone$america__indiana__vincennes),
			_Utils_Tuple2('America/Indiana/Winamac', $justinmimbs$timezone_data$TimeZone$america__indiana__winamac),
			_Utils_Tuple2('America/Inuvik', $justinmimbs$timezone_data$TimeZone$america__inuvik),
			_Utils_Tuple2('America/Iqaluit', $justinmimbs$timezone_data$TimeZone$america__iqaluit),
			_Utils_Tuple2('America/Jamaica', $justinmimbs$timezone_data$TimeZone$america__jamaica),
			_Utils_Tuple2('America/Juneau', $justinmimbs$timezone_data$TimeZone$america__juneau),
			_Utils_Tuple2('America/Kentucky/Louisville', $justinmimbs$timezone_data$TimeZone$america__kentucky__louisville),
			_Utils_Tuple2('America/Kentucky/Monticello', $justinmimbs$timezone_data$TimeZone$america__kentucky__monticello),
			_Utils_Tuple2('America/La_Paz', $justinmimbs$timezone_data$TimeZone$america__la_paz),
			_Utils_Tuple2('America/Lima', $justinmimbs$timezone_data$TimeZone$america__lima),
			_Utils_Tuple2('America/Los_Angeles', $justinmimbs$timezone_data$TimeZone$america__los_angeles),
			_Utils_Tuple2('America/Maceio', $justinmimbs$timezone_data$TimeZone$america__maceio),
			_Utils_Tuple2('America/Managua', $justinmimbs$timezone_data$TimeZone$america__managua),
			_Utils_Tuple2('America/Manaus', $justinmimbs$timezone_data$TimeZone$america__manaus),
			_Utils_Tuple2('America/Martinique', $justinmimbs$timezone_data$TimeZone$america__martinique),
			_Utils_Tuple2('America/Matamoros', $justinmimbs$timezone_data$TimeZone$america__matamoros),
			_Utils_Tuple2('America/Mazatlan', $justinmimbs$timezone_data$TimeZone$america__mazatlan),
			_Utils_Tuple2('America/Menominee', $justinmimbs$timezone_data$TimeZone$america__menominee),
			_Utils_Tuple2('America/Merida', $justinmimbs$timezone_data$TimeZone$america__merida),
			_Utils_Tuple2('America/Metlakatla', $justinmimbs$timezone_data$TimeZone$america__metlakatla),
			_Utils_Tuple2('America/Mexico_City', $justinmimbs$timezone_data$TimeZone$america__mexico_city),
			_Utils_Tuple2('America/Miquelon', $justinmimbs$timezone_data$TimeZone$america__miquelon),
			_Utils_Tuple2('America/Moncton', $justinmimbs$timezone_data$TimeZone$america__moncton),
			_Utils_Tuple2('America/Monterrey', $justinmimbs$timezone_data$TimeZone$america__monterrey),
			_Utils_Tuple2('America/Montevideo', $justinmimbs$timezone_data$TimeZone$america__montevideo),
			_Utils_Tuple2('America/New_York', $justinmimbs$timezone_data$TimeZone$america__new_york),
			_Utils_Tuple2('America/Nome', $justinmimbs$timezone_data$TimeZone$america__nome),
			_Utils_Tuple2('America/Noronha', $justinmimbs$timezone_data$TimeZone$america__noronha),
			_Utils_Tuple2('America/North_Dakota/Beulah', $justinmimbs$timezone_data$TimeZone$america__north_dakota__beulah),
			_Utils_Tuple2('America/North_Dakota/Center', $justinmimbs$timezone_data$TimeZone$america__north_dakota__center),
			_Utils_Tuple2('America/North_Dakota/New_Salem', $justinmimbs$timezone_data$TimeZone$america__north_dakota__new_salem),
			_Utils_Tuple2('America/Nuuk', $justinmimbs$timezone_data$TimeZone$america__nuuk),
			_Utils_Tuple2('America/Ojinaga', $justinmimbs$timezone_data$TimeZone$america__ojinaga),
			_Utils_Tuple2('America/Panama', $justinmimbs$timezone_data$TimeZone$america__panama),
			_Utils_Tuple2('America/Paramaribo', $justinmimbs$timezone_data$TimeZone$america__paramaribo),
			_Utils_Tuple2('America/Phoenix', $justinmimbs$timezone_data$TimeZone$america__phoenix),
			_Utils_Tuple2('America/Port-au-Prince', $justinmimbs$timezone_data$TimeZone$america__port_au_prince),
			_Utils_Tuple2('America/Porto_Velho', $justinmimbs$timezone_data$TimeZone$america__porto_velho),
			_Utils_Tuple2('America/Puerto_Rico', $justinmimbs$timezone_data$TimeZone$america__puerto_rico),
			_Utils_Tuple2('America/Punta_Arenas', $justinmimbs$timezone_data$TimeZone$america__punta_arenas),
			_Utils_Tuple2('America/Rankin_Inlet', $justinmimbs$timezone_data$TimeZone$america__rankin_inlet),
			_Utils_Tuple2('America/Recife', $justinmimbs$timezone_data$TimeZone$america__recife),
			_Utils_Tuple2('America/Regina', $justinmimbs$timezone_data$TimeZone$america__regina),
			_Utils_Tuple2('America/Resolute', $justinmimbs$timezone_data$TimeZone$america__resolute),
			_Utils_Tuple2('America/Rio_Branco', $justinmimbs$timezone_data$TimeZone$america__rio_branco),
			_Utils_Tuple2('America/Santarem', $justinmimbs$timezone_data$TimeZone$america__santarem),
			_Utils_Tuple2('America/Santiago', $justinmimbs$timezone_data$TimeZone$america__santiago),
			_Utils_Tuple2('America/Santo_Domingo', $justinmimbs$timezone_data$TimeZone$america__santo_domingo),
			_Utils_Tuple2('America/Sao_Paulo', $justinmimbs$timezone_data$TimeZone$america__sao_paulo),
			_Utils_Tuple2('America/Scoresbysund', $justinmimbs$timezone_data$TimeZone$america__scoresbysund),
			_Utils_Tuple2('America/Sitka', $justinmimbs$timezone_data$TimeZone$america__sitka),
			_Utils_Tuple2('America/St_Johns', $justinmimbs$timezone_data$TimeZone$america__st_johns),
			_Utils_Tuple2('America/Swift_Current', $justinmimbs$timezone_data$TimeZone$america__swift_current),
			_Utils_Tuple2('America/Tegucigalpa', $justinmimbs$timezone_data$TimeZone$america__tegucigalpa),
			_Utils_Tuple2('America/Thule', $justinmimbs$timezone_data$TimeZone$america__thule),
			_Utils_Tuple2('America/Tijuana', $justinmimbs$timezone_data$TimeZone$america__tijuana),
			_Utils_Tuple2('America/Toronto', $justinmimbs$timezone_data$TimeZone$america__toronto),
			_Utils_Tuple2('America/Vancouver', $justinmimbs$timezone_data$TimeZone$america__vancouver),
			_Utils_Tuple2('America/Whitehorse', $justinmimbs$timezone_data$TimeZone$america__whitehorse),
			_Utils_Tuple2('America/Winnipeg', $justinmimbs$timezone_data$TimeZone$america__winnipeg),
			_Utils_Tuple2('America/Yakutat', $justinmimbs$timezone_data$TimeZone$america__yakutat),
			_Utils_Tuple2('Antarctica/Casey', $justinmimbs$timezone_data$TimeZone$antarctica__casey),
			_Utils_Tuple2('Antarctica/Davis', $justinmimbs$timezone_data$TimeZone$antarctica__davis),
			_Utils_Tuple2('Antarctica/Macquarie', $justinmimbs$timezone_data$TimeZone$antarctica__macquarie),
			_Utils_Tuple2('Antarctica/Mawson', $justinmimbs$timezone_data$TimeZone$antarctica__mawson),
			_Utils_Tuple2('Antarctica/Palmer', $justinmimbs$timezone_data$TimeZone$antarctica__palmer),
			_Utils_Tuple2('Antarctica/Rothera', $justinmimbs$timezone_data$TimeZone$antarctica__rothera),
			_Utils_Tuple2('Antarctica/Troll', $justinmimbs$timezone_data$TimeZone$antarctica__troll),
			_Utils_Tuple2('Antarctica/Vostok', $justinmimbs$timezone_data$TimeZone$antarctica__vostok),
			_Utils_Tuple2('Asia/Almaty', $justinmimbs$timezone_data$TimeZone$asia__almaty),
			_Utils_Tuple2('Asia/Amman', $justinmimbs$timezone_data$TimeZone$asia__amman),
			_Utils_Tuple2('Asia/Anadyr', $justinmimbs$timezone_data$TimeZone$asia__anadyr),
			_Utils_Tuple2('Asia/Aqtau', $justinmimbs$timezone_data$TimeZone$asia__aqtau),
			_Utils_Tuple2('Asia/Aqtobe', $justinmimbs$timezone_data$TimeZone$asia__aqtobe),
			_Utils_Tuple2('Asia/Ashgabat', $justinmimbs$timezone_data$TimeZone$asia__ashgabat),
			_Utils_Tuple2('Asia/Atyrau', $justinmimbs$timezone_data$TimeZone$asia__atyrau),
			_Utils_Tuple2('Asia/Baghdad', $justinmimbs$timezone_data$TimeZone$asia__baghdad),
			_Utils_Tuple2('Asia/Baku', $justinmimbs$timezone_data$TimeZone$asia__baku),
			_Utils_Tuple2('Asia/Bangkok', $justinmimbs$timezone_data$TimeZone$asia__bangkok),
			_Utils_Tuple2('Asia/Barnaul', $justinmimbs$timezone_data$TimeZone$asia__barnaul),
			_Utils_Tuple2('Asia/Beirut', $justinmimbs$timezone_data$TimeZone$asia__beirut),
			_Utils_Tuple2('Asia/Bishkek', $justinmimbs$timezone_data$TimeZone$asia__bishkek),
			_Utils_Tuple2('Asia/Chita', $justinmimbs$timezone_data$TimeZone$asia__chita),
			_Utils_Tuple2('Asia/Choibalsan', $justinmimbs$timezone_data$TimeZone$asia__choibalsan),
			_Utils_Tuple2('Asia/Colombo', $justinmimbs$timezone_data$TimeZone$asia__colombo),
			_Utils_Tuple2('Asia/Damascus', $justinmimbs$timezone_data$TimeZone$asia__damascus),
			_Utils_Tuple2('Asia/Dhaka', $justinmimbs$timezone_data$TimeZone$asia__dhaka),
			_Utils_Tuple2('Asia/Dili', $justinmimbs$timezone_data$TimeZone$asia__dili),
			_Utils_Tuple2('Asia/Dubai', $justinmimbs$timezone_data$TimeZone$asia__dubai),
			_Utils_Tuple2('Asia/Dushanbe', $justinmimbs$timezone_data$TimeZone$asia__dushanbe),
			_Utils_Tuple2('Asia/Famagusta', $justinmimbs$timezone_data$TimeZone$asia__famagusta),
			_Utils_Tuple2('Asia/Gaza', $justinmimbs$timezone_data$TimeZone$asia__gaza),
			_Utils_Tuple2('Asia/Hebron', $justinmimbs$timezone_data$TimeZone$asia__hebron),
			_Utils_Tuple2('Asia/Ho_Chi_Minh', $justinmimbs$timezone_data$TimeZone$asia__ho_chi_minh),
			_Utils_Tuple2('Asia/Hong_Kong', $justinmimbs$timezone_data$TimeZone$asia__hong_kong),
			_Utils_Tuple2('Asia/Hovd', $justinmimbs$timezone_data$TimeZone$asia__hovd),
			_Utils_Tuple2('Asia/Irkutsk', $justinmimbs$timezone_data$TimeZone$asia__irkutsk),
			_Utils_Tuple2('Asia/Jakarta', $justinmimbs$timezone_data$TimeZone$asia__jakarta),
			_Utils_Tuple2('Asia/Jayapura', $justinmimbs$timezone_data$TimeZone$asia__jayapura),
			_Utils_Tuple2('Asia/Jerusalem', $justinmimbs$timezone_data$TimeZone$asia__jerusalem),
			_Utils_Tuple2('Asia/Kabul', $justinmimbs$timezone_data$TimeZone$asia__kabul),
			_Utils_Tuple2('Asia/Kamchatka', $justinmimbs$timezone_data$TimeZone$asia__kamchatka),
			_Utils_Tuple2('Asia/Karachi', $justinmimbs$timezone_data$TimeZone$asia__karachi),
			_Utils_Tuple2('Asia/Kathmandu', $justinmimbs$timezone_data$TimeZone$asia__kathmandu),
			_Utils_Tuple2('Asia/Khandyga', $justinmimbs$timezone_data$TimeZone$asia__khandyga),
			_Utils_Tuple2('Asia/Kolkata', $justinmimbs$timezone_data$TimeZone$asia__kolkata),
			_Utils_Tuple2('Asia/Krasnoyarsk', $justinmimbs$timezone_data$TimeZone$asia__krasnoyarsk),
			_Utils_Tuple2('Asia/Kuching', $justinmimbs$timezone_data$TimeZone$asia__kuching),
			_Utils_Tuple2('Asia/Macau', $justinmimbs$timezone_data$TimeZone$asia__macau),
			_Utils_Tuple2('Asia/Magadan', $justinmimbs$timezone_data$TimeZone$asia__magadan),
			_Utils_Tuple2('Asia/Makassar', $justinmimbs$timezone_data$TimeZone$asia__makassar),
			_Utils_Tuple2('Asia/Manila', $justinmimbs$timezone_data$TimeZone$asia__manila),
			_Utils_Tuple2('Asia/Nicosia', $justinmimbs$timezone_data$TimeZone$asia__nicosia),
			_Utils_Tuple2('Asia/Novokuznetsk', $justinmimbs$timezone_data$TimeZone$asia__novokuznetsk),
			_Utils_Tuple2('Asia/Novosibirsk', $justinmimbs$timezone_data$TimeZone$asia__novosibirsk),
			_Utils_Tuple2('Asia/Omsk', $justinmimbs$timezone_data$TimeZone$asia__omsk),
			_Utils_Tuple2('Asia/Oral', $justinmimbs$timezone_data$TimeZone$asia__oral),
			_Utils_Tuple2('Asia/Pontianak', $justinmimbs$timezone_data$TimeZone$asia__pontianak),
			_Utils_Tuple2('Asia/Pyongyang', $justinmimbs$timezone_data$TimeZone$asia__pyongyang),
			_Utils_Tuple2('Asia/Qatar', $justinmimbs$timezone_data$TimeZone$asia__qatar),
			_Utils_Tuple2('Asia/Qostanay', $justinmimbs$timezone_data$TimeZone$asia__qostanay),
			_Utils_Tuple2('Asia/Qyzylorda', $justinmimbs$timezone_data$TimeZone$asia__qyzylorda),
			_Utils_Tuple2('Asia/Riyadh', $justinmimbs$timezone_data$TimeZone$asia__riyadh),
			_Utils_Tuple2('Asia/Sakhalin', $justinmimbs$timezone_data$TimeZone$asia__sakhalin),
			_Utils_Tuple2('Asia/Samarkand', $justinmimbs$timezone_data$TimeZone$asia__samarkand),
			_Utils_Tuple2('Asia/Seoul', $justinmimbs$timezone_data$TimeZone$asia__seoul),
			_Utils_Tuple2('Asia/Shanghai', $justinmimbs$timezone_data$TimeZone$asia__shanghai),
			_Utils_Tuple2('Asia/Singapore', $justinmimbs$timezone_data$TimeZone$asia__singapore),
			_Utils_Tuple2('Asia/Srednekolymsk', $justinmimbs$timezone_data$TimeZone$asia__srednekolymsk),
			_Utils_Tuple2('Asia/Taipei', $justinmimbs$timezone_data$TimeZone$asia__taipei),
			_Utils_Tuple2('Asia/Tashkent', $justinmimbs$timezone_data$TimeZone$asia__tashkent),
			_Utils_Tuple2('Asia/Tbilisi', $justinmimbs$timezone_data$TimeZone$asia__tbilisi),
			_Utils_Tuple2('Asia/Tehran', $justinmimbs$timezone_data$TimeZone$asia__tehran),
			_Utils_Tuple2('Asia/Thimphu', $justinmimbs$timezone_data$TimeZone$asia__thimphu),
			_Utils_Tuple2('Asia/Tokyo', $justinmimbs$timezone_data$TimeZone$asia__tokyo),
			_Utils_Tuple2('Asia/Tomsk', $justinmimbs$timezone_data$TimeZone$asia__tomsk),
			_Utils_Tuple2('Asia/Ulaanbaatar', $justinmimbs$timezone_data$TimeZone$asia__ulaanbaatar),
			_Utils_Tuple2('Asia/Urumqi', $justinmimbs$timezone_data$TimeZone$asia__urumqi),
			_Utils_Tuple2('Asia/Ust-Nera', $justinmimbs$timezone_data$TimeZone$asia__ust_nera),
			_Utils_Tuple2('Asia/Vladivostok', $justinmimbs$timezone_data$TimeZone$asia__vladivostok),
			_Utils_Tuple2('Asia/Yakutsk', $justinmimbs$timezone_data$TimeZone$asia__yakutsk),
			_Utils_Tuple2('Asia/Yangon', $justinmimbs$timezone_data$TimeZone$asia__yangon),
			_Utils_Tuple2('Asia/Yekaterinburg', $justinmimbs$timezone_data$TimeZone$asia__yekaterinburg),
			_Utils_Tuple2('Asia/Yerevan', $justinmimbs$timezone_data$TimeZone$asia__yerevan),
			_Utils_Tuple2('Atlantic/Azores', $justinmimbs$timezone_data$TimeZone$atlantic__azores),
			_Utils_Tuple2('Atlantic/Bermuda', $justinmimbs$timezone_data$TimeZone$atlantic__bermuda),
			_Utils_Tuple2('Atlantic/Canary', $justinmimbs$timezone_data$TimeZone$atlantic__canary),
			_Utils_Tuple2('Atlantic/Cape_Verde', $justinmimbs$timezone_data$TimeZone$atlantic__cape_verde),
			_Utils_Tuple2('Atlantic/Faroe', $justinmimbs$timezone_data$TimeZone$atlantic__faroe),
			_Utils_Tuple2('Atlantic/Madeira', $justinmimbs$timezone_data$TimeZone$atlantic__madeira),
			_Utils_Tuple2('Atlantic/South_Georgia', $justinmimbs$timezone_data$TimeZone$atlantic__south_georgia),
			_Utils_Tuple2('Atlantic/Stanley', $justinmimbs$timezone_data$TimeZone$atlantic__stanley),
			_Utils_Tuple2('Australia/Adelaide', $justinmimbs$timezone_data$TimeZone$australia__adelaide),
			_Utils_Tuple2('Australia/Brisbane', $justinmimbs$timezone_data$TimeZone$australia__brisbane),
			_Utils_Tuple2('Australia/Broken_Hill', $justinmimbs$timezone_data$TimeZone$australia__broken_hill),
			_Utils_Tuple2('Australia/Darwin', $justinmimbs$timezone_data$TimeZone$australia__darwin),
			_Utils_Tuple2('Australia/Eucla', $justinmimbs$timezone_data$TimeZone$australia__eucla),
			_Utils_Tuple2('Australia/Hobart', $justinmimbs$timezone_data$TimeZone$australia__hobart),
			_Utils_Tuple2('Australia/Lindeman', $justinmimbs$timezone_data$TimeZone$australia__lindeman),
			_Utils_Tuple2('Australia/Lord_Howe', $justinmimbs$timezone_data$TimeZone$australia__lord_howe),
			_Utils_Tuple2('Australia/Melbourne', $justinmimbs$timezone_data$TimeZone$australia__melbourne),
			_Utils_Tuple2('Australia/Perth', $justinmimbs$timezone_data$TimeZone$australia__perth),
			_Utils_Tuple2('Australia/Sydney', $justinmimbs$timezone_data$TimeZone$australia__sydney),
			_Utils_Tuple2('Europe/Andorra', $justinmimbs$timezone_data$TimeZone$europe__andorra),
			_Utils_Tuple2('Europe/Astrakhan', $justinmimbs$timezone_data$TimeZone$europe__astrakhan),
			_Utils_Tuple2('Europe/Athens', $justinmimbs$timezone_data$TimeZone$europe__athens),
			_Utils_Tuple2('Europe/Belgrade', $justinmimbs$timezone_data$TimeZone$europe__belgrade),
			_Utils_Tuple2('Europe/Berlin', $justinmimbs$timezone_data$TimeZone$europe__berlin),
			_Utils_Tuple2('Europe/Brussels', $justinmimbs$timezone_data$TimeZone$europe__brussels),
			_Utils_Tuple2('Europe/Bucharest', $justinmimbs$timezone_data$TimeZone$europe__bucharest),
			_Utils_Tuple2('Europe/Budapest', $justinmimbs$timezone_data$TimeZone$europe__budapest),
			_Utils_Tuple2('Europe/Chisinau', $justinmimbs$timezone_data$TimeZone$europe__chisinau),
			_Utils_Tuple2('Europe/Dublin', $justinmimbs$timezone_data$TimeZone$europe__dublin),
			_Utils_Tuple2('Europe/Gibraltar', $justinmimbs$timezone_data$TimeZone$europe__gibraltar),
			_Utils_Tuple2('Europe/Helsinki', $justinmimbs$timezone_data$TimeZone$europe__helsinki),
			_Utils_Tuple2('Europe/Istanbul', $justinmimbs$timezone_data$TimeZone$europe__istanbul),
			_Utils_Tuple2('Europe/Kaliningrad', $justinmimbs$timezone_data$TimeZone$europe__kaliningrad),
			_Utils_Tuple2('Europe/Kirov', $justinmimbs$timezone_data$TimeZone$europe__kirov),
			_Utils_Tuple2('Europe/Kyiv', $justinmimbs$timezone_data$TimeZone$europe__kyiv),
			_Utils_Tuple2('Europe/Lisbon', $justinmimbs$timezone_data$TimeZone$europe__lisbon),
			_Utils_Tuple2('Europe/London', $justinmimbs$timezone_data$TimeZone$europe__london),
			_Utils_Tuple2('Europe/Madrid', $justinmimbs$timezone_data$TimeZone$europe__madrid),
			_Utils_Tuple2('Europe/Malta', $justinmimbs$timezone_data$TimeZone$europe__malta),
			_Utils_Tuple2('Europe/Minsk', $justinmimbs$timezone_data$TimeZone$europe__minsk),
			_Utils_Tuple2('Europe/Moscow', $justinmimbs$timezone_data$TimeZone$europe__moscow),
			_Utils_Tuple2('Europe/Paris', $justinmimbs$timezone_data$TimeZone$europe__paris),
			_Utils_Tuple2('Europe/Prague', $justinmimbs$timezone_data$TimeZone$europe__prague),
			_Utils_Tuple2('Europe/Riga', $justinmimbs$timezone_data$TimeZone$europe__riga),
			_Utils_Tuple2('Europe/Rome', $justinmimbs$timezone_data$TimeZone$europe__rome),
			_Utils_Tuple2('Europe/Samara', $justinmimbs$timezone_data$TimeZone$europe__samara),
			_Utils_Tuple2('Europe/Saratov', $justinmimbs$timezone_data$TimeZone$europe__saratov),
			_Utils_Tuple2('Europe/Simferopol', $justinmimbs$timezone_data$TimeZone$europe__simferopol),
			_Utils_Tuple2('Europe/Sofia', $justinmimbs$timezone_data$TimeZone$europe__sofia),
			_Utils_Tuple2('Europe/Tallinn', $justinmimbs$timezone_data$TimeZone$europe__tallinn),
			_Utils_Tuple2('Europe/Tirane', $justinmimbs$timezone_data$TimeZone$europe__tirane),
			_Utils_Tuple2('Europe/Ulyanovsk', $justinmimbs$timezone_data$TimeZone$europe__ulyanovsk),
			_Utils_Tuple2('Europe/Vienna', $justinmimbs$timezone_data$TimeZone$europe__vienna),
			_Utils_Tuple2('Europe/Vilnius', $justinmimbs$timezone_data$TimeZone$europe__vilnius),
			_Utils_Tuple2('Europe/Volgograd', $justinmimbs$timezone_data$TimeZone$europe__volgograd),
			_Utils_Tuple2('Europe/Warsaw', $justinmimbs$timezone_data$TimeZone$europe__warsaw),
			_Utils_Tuple2('Europe/Zurich', $justinmimbs$timezone_data$TimeZone$europe__zurich),
			_Utils_Tuple2('Indian/Chagos', $justinmimbs$timezone_data$TimeZone$indian__chagos),
			_Utils_Tuple2('Indian/Maldives', $justinmimbs$timezone_data$TimeZone$indian__maldives),
			_Utils_Tuple2('Indian/Mauritius', $justinmimbs$timezone_data$TimeZone$indian__mauritius),
			_Utils_Tuple2('Pacific/Apia', $justinmimbs$timezone_data$TimeZone$pacific__apia),
			_Utils_Tuple2('Pacific/Auckland', $justinmimbs$timezone_data$TimeZone$pacific__auckland),
			_Utils_Tuple2('Pacific/Bougainville', $justinmimbs$timezone_data$TimeZone$pacific__bougainville),
			_Utils_Tuple2('Pacific/Chatham', $justinmimbs$timezone_data$TimeZone$pacific__chatham),
			_Utils_Tuple2('Pacific/Easter', $justinmimbs$timezone_data$TimeZone$pacific__easter),
			_Utils_Tuple2('Pacific/Efate', $justinmimbs$timezone_data$TimeZone$pacific__efate),
			_Utils_Tuple2('Pacific/Fakaofo', $justinmimbs$timezone_data$TimeZone$pacific__fakaofo),
			_Utils_Tuple2('Pacific/Fiji', $justinmimbs$timezone_data$TimeZone$pacific__fiji),
			_Utils_Tuple2('Pacific/Galapagos', $justinmimbs$timezone_data$TimeZone$pacific__galapagos),
			_Utils_Tuple2('Pacific/Gambier', $justinmimbs$timezone_data$TimeZone$pacific__gambier),
			_Utils_Tuple2('Pacific/Guadalcanal', $justinmimbs$timezone_data$TimeZone$pacific__guadalcanal),
			_Utils_Tuple2('Pacific/Guam', $justinmimbs$timezone_data$TimeZone$pacific__guam),
			_Utils_Tuple2('Pacific/Honolulu', $justinmimbs$timezone_data$TimeZone$pacific__honolulu),
			_Utils_Tuple2('Pacific/Kanton', $justinmimbs$timezone_data$TimeZone$pacific__kanton),
			_Utils_Tuple2('Pacific/Kiritimati', $justinmimbs$timezone_data$TimeZone$pacific__kiritimati),
			_Utils_Tuple2('Pacific/Kosrae', $justinmimbs$timezone_data$TimeZone$pacific__kosrae),
			_Utils_Tuple2('Pacific/Kwajalein', $justinmimbs$timezone_data$TimeZone$pacific__kwajalein),
			_Utils_Tuple2('Pacific/Marquesas', $justinmimbs$timezone_data$TimeZone$pacific__marquesas),
			_Utils_Tuple2('Pacific/Nauru', $justinmimbs$timezone_data$TimeZone$pacific__nauru),
			_Utils_Tuple2('Pacific/Niue', $justinmimbs$timezone_data$TimeZone$pacific__niue),
			_Utils_Tuple2('Pacific/Norfolk', $justinmimbs$timezone_data$TimeZone$pacific__norfolk),
			_Utils_Tuple2('Pacific/Noumea', $justinmimbs$timezone_data$TimeZone$pacific__noumea),
			_Utils_Tuple2('Pacific/Pago_Pago', $justinmimbs$timezone_data$TimeZone$pacific__pago_pago),
			_Utils_Tuple2('Pacific/Palau', $justinmimbs$timezone_data$TimeZone$pacific__palau),
			_Utils_Tuple2('Pacific/Pitcairn', $justinmimbs$timezone_data$TimeZone$pacific__pitcairn),
			_Utils_Tuple2('Pacific/Port_Moresby', $justinmimbs$timezone_data$TimeZone$pacific__port_moresby),
			_Utils_Tuple2('Pacific/Rarotonga', $justinmimbs$timezone_data$TimeZone$pacific__rarotonga),
			_Utils_Tuple2('Pacific/Tahiti', $justinmimbs$timezone_data$TimeZone$pacific__tahiti),
			_Utils_Tuple2('Pacific/Tarawa', $justinmimbs$timezone_data$TimeZone$pacific__tarawa),
			_Utils_Tuple2('Pacific/Tongatapu', $justinmimbs$timezone_data$TimeZone$pacific__tongatapu)
		]));
var $author$project$LoadableTimeZone$setUser = F2(
	function (result, _v0) {
		var device = _v0.b;
		return function (user) {
			return _Utils_Tuple2(user, device);
		}(
			$krisajenkins$remotedata$RemoteData$fromResult(
				A2(
					$elm$core$Result$andThen,
					function (zoneName) {
						return A2(
							$elm$core$Result$fromMaybe,
							$author$project$LoadableTimeZone$NameNotFound(zoneName),
							A2(
								$elm$core$Maybe$map,
								function (f) {
									return _Utils_Tuple2(
										zoneName,
										f(_Utils_Tuple0));
								},
								A2($elm$core$Dict$get, zoneName, $justinmimbs$timezone_data$TimeZone$zones)));
					},
					A2($elm$core$Result$mapError, $author$project$LoadableTimeZone$QueryError, result))));
	});
var $author$project$Compiler$ToFrontEndMsg$encode = function (msg) {
	if (msg.a.$ === 'Ok') {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'type',
					$elm$json$Json$Encode$string('ConfigValidationResponse')),
					_Utils_Tuple2(
					'success',
					$elm$json$Json$Encode$bool(true))
				]));
	} else {
		if (msg.a.a.$ === 'ValidationErrors') {
			var errors = msg.a.a.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('ConfigValidationResponse')),
						_Utils_Tuple2(
						'success',
						$elm$json$Json$Encode$bool(false)),
						_Utils_Tuple2(
						'errors',
						A2(
							$elm$json$Json$Encode$list,
							$author$project$StudioApp$Error$encode,
							$mgold$elm_nonempty_list$List$Nonempty$toList(errors)))
					]));
		} else {
			var err = msg.a.a.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('ConfigValidationResponse')),
						_Utils_Tuple2(
						'success',
						$elm$json$Json$Encode$bool(false)),
						_Utils_Tuple2(
						'errors',
						$elm$json$Json$Encode$string(
							$elm$json$Json$Decode$errorToString(err)))
					]));
		}
	}
};
var $author$project$Compiler$sendToFrontEnd = _Platform_outgoingPort('sendToFrontEnd', $elm$core$Basics$identity);
var $author$project$Compiler$toFrontEnd = A2($elm$core$Basics$composeR, $author$project$Compiler$ToFrontEndMsg$encode, $author$project$Compiler$sendToFrontEnd);
var $author$project$DataElement$VeevaMessages$insert = function (_v0) {
	var _v1 = _v0.a;
	var category = _v1.a;
	var name = _v1.b;
	var value = _v0.b;
	return A2(
		$author$project$DataEngine$RecordCache$insert,
		$author$project$FieldName$fromString(name + (';;' + category)),
		$author$project$FieldValue$StringValue(
			$author$project$StudioString$withoutObject(value)));
};
var $author$project$DataElement$VeevaMessages$toRecordCache = A2(
	$elm$core$Basics$composeR,
	$elm$core$Dict$toList,
	A2($elm$core$List$foldl, $author$project$DataElement$VeevaMessages$insert, $author$project$DataEngine$RecordCache$empty));
var $elm$core$Debug$todo = _Debug_todo;
var $author$project$Compiler$RxTimeZone = function (a) {
	return {$: 'RxTimeZone', a: a};
};
var $author$project$Compiler$confirmTimeZone = $elm$core$Platform$Cmd$batch(
	_List_fromArray(
		[
			A2($elm$core$Task$perform, $author$project$Compiler$RxTimeZone, $elm$time$Time$here),
			A3($author$project$MyInsights$getDataForCurrentObject, 'UserTimeZone___', 'User', 'TimeZoneSidKey')
		]));
var $author$project$Compiler$confirmUserTimeZoneIfNecessary = function (model) {
	var _v0 = $author$project$DataEngine$DataCache$getLoadableTimeZone(model.cache).a;
	if (_v0.$ === 'NotAsked') {
		return $author$project$Compiler$confirmTimeZone;
	} else {
		return $elm$core$Platform$Cmd$none;
	}
};
var $Fresheyeball$elm_return$Return$effect_ = F2(
	function (f, _v0) {
		var model = _v0.a;
		var cmd = _v0.b;
		return _Utils_Tuple2(
			model,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						cmd,
						f(model)
					])));
	});
var $author$project$MyInsights$GetFeedbackData = function (a) {
	return {$: 'GetFeedbackData', a: a};
};
var $author$project$MyInsights$getFeedbackData = function (queryId) {
	return $author$project$MyInsights$sendMsg(
		$author$project$MyInsights$GetFeedbackData(queryId));
};
var $author$project$DataElement$CrmDataEngine$Where$usesDependencyTransformer = F2(
	function (transformer, clause) {
		switch (clause.$) {
			case 'AllOf':
				var wheres = clause.a;
				return A2(
					$elm$core$List$any,
					$elm$core$Basics$identity,
					A2(
						$elm$core$List$map,
						$author$project$DataElement$CrmDataEngine$Where$usesDependencyTransformer(transformer),
						wheres));
			case 'AnyOf':
				var wheres = clause.a;
				return A2(
					$elm$core$List$any,
					$elm$core$Basics$identity,
					A2(
						$elm$core$List$map,
						$author$project$DataElement$CrmDataEngine$Where$usesDependencyTransformer(transformer),
						wheres));
			case 'Eq':
				var globalField = clause.b;
				return A2($author$project$DataElement$Expression$applyGlobalField, transformer, globalField);
			case 'NotEq':
				var globalField = clause.b;
				return A2($author$project$DataElement$Expression$applyGlobalField, transformer, globalField);
			case 'Gt':
				var globalComparable = clause.b;
				return A2($author$project$DataElement$Expression$applyGlobalComparable, transformer, globalComparable);
			case 'Gte':
				var globalComparable = clause.b;
				return A2($author$project$DataElement$Expression$applyGlobalComparable, transformer, globalComparable);
			case 'Lt':
				var globalComparable = clause.b;
				return A2($author$project$DataElement$Expression$applyGlobalComparable, transformer, globalComparable);
			case 'Lte':
				var globalComparable = clause.b;
				return A2($author$project$DataElement$Expression$applyGlobalComparable, transformer, globalComparable);
			case 'In':
				var globalStringList = clause.b;
				return A2($author$project$DataElement$Expression$applyGlobalStringList, transformer, globalStringList);
			case 'BetweenString':
				var globalStringA = clause.b;
				var globalStringB = clause.c;
				return A2($author$project$DataElement$Expression$applyGlobalString, transformer, globalStringA) || A2($author$project$DataElement$Expression$applyGlobalString, transformer, globalStringB);
			case 'BetweenDate':
				var globalDateA = clause.b;
				var globalDateB = clause.c;
				return A2($author$project$DataElement$Expression$applyGlobalDate, transformer, globalDateA) || A2($author$project$DataElement$Expression$applyGlobalDate, transformer, globalDateB);
			case 'BetweenDateTime':
				var globalDateTimeA = clause.b;
				var globalDateTimeB = clause.c;
				return A2($author$project$DataElement$Expression$applyGlobalDateTime, transformer, globalDateTimeA) || A2($author$project$DataElement$Expression$applyGlobalDateTime, transformer, globalDateTimeB);
			case 'BetweenNumber':
				var globalNumberA = clause.b;
				var globalNumberB = clause.c;
				return A2($author$project$DataElement$Expression$applyGlobalNumber, transformer, globalNumberA) || A2($author$project$DataElement$Expression$applyGlobalNumber, transformer, globalNumberB);
			case 'IsNull':
				return false;
			default:
				return false;
		}
	});
var $author$project$DataElement$Expression$baseBooleanTransformer = {
	add: $elm$core$Basics$or,
	all: $elm$core$Basics$identity,
	allBoolsInField: F2(
		function (_v0, _v1) {
			return false;
		}),
	allDateTimesInField: F2(
		function (_v2, _v3) {
			return false;
		}),
	allDatesInField: F2(
		function (_v4, _v5) {
			return false;
		}),
	allNumbersInField: F2(
		function (_v6, _v7) {
			return false;
		}),
	allStringsInField: F2(
		function (_v8, _v9) {
			return false;
		}),
	any: $elm$core$Basics$identity,
	boolsAsList: $elm$core$List$any($elm$core$Basics$identity),
	challengeReasons: $elm$core$Basics$identity,
	comparableEqual: function (_v10) {
		return $elm$core$Basics$or;
	},
	comparableNotEqual: function (_v11) {
		return $elm$core$Basics$or;
	},
	concat: $elm$core$Basics$or,
	countUnique: F2(
		function (_v12, a) {
			return a;
		}),
	dateAdd: function (_v13) {
		return $elm$core$Basics$or;
	},
	dateCeiling: F2(
		function (_v14, a) {
			return a;
		}),
	dateFloor: F2(
		function (_v15, a) {
			return a;
		}),
	dateSubtract: function (_v16) {
		return $elm$core$Basics$or;
	},
	dateTimeToDate: $elm$core$Basics$identity,
	dateTimesAsList: $elm$core$List$any($elm$core$Basics$identity),
	datesAsList: $elm$core$List$any($elm$core$Basics$identity),
	dayInMonth: $elm$core$Basics$identity,
	divide: $elm$core$Basics$or,
	equal: function (_v17) {
		return $elm$core$Basics$or;
	},
	formatDate: $elm$core$Basics$or,
	formatDateLocaleAware: $elm$core$Basics$identity,
	formatDateTime: $elm$core$Basics$identity,
	formatNumber: function (_v18) {
		return $elm$core$Basics$identity;
	},
	globalBoolLookup: F2(
		function (_v19, _v20) {
			return false;
		}),
	globalDateLookup: F2(
		function (_v21, _v22) {
			return false;
		}),
	globalDateTimeLookup: F2(
		function (_v23, _v24) {
			return false;
		}),
	globalNumberLookup: F2(
		function (_v25, _v26) {
			return false;
		}),
	globalStringLookup: F2(
		function (_v27, _v28) {
			return false;
		}),
	greaterThan: function (_v29) {
		return $elm$core$Basics$or;
	},
	greaterThanOrEqual: function (_v30) {
		return $elm$core$Basics$or;
	},
	hardcodedBool: function (_v31) {
		return false;
	},
	hardcodedDate: function (_v32) {
		return false;
	},
	hardcodedDateTime: function (_v33) {
		return false;
	},
	hardcodedNumber: function (_v34) {
		return false;
	},
	hardcodedString: function (_v35) {
		return false;
	},
	if_: F4(
		function (_v36, a, b, c) {
			return a || (b || c);
		}),
	isNotNull: $elm$core$Basics$identity,
	isNull: $elm$core$Basics$identity,
	lessThan: function (_v37) {
		return $elm$core$Basics$or;
	},
	lessThanOrEqual: function (_v38) {
		return $elm$core$Basics$or;
	},
	localBool: function (_v39) {
		return false;
	},
	localDate: function (_v40) {
		return false;
	},
	localDateTime: function (_v41) {
		return false;
	},
	localNumber: function (_v42) {
		return false;
	},
	localString: function (_v43) {
		return false;
	},
	max: function (_v44) {
		return $elm$core$Basics$identity;
	},
	min: function (_v45) {
		return $elm$core$Basics$identity;
	},
	monthNumber: $elm$core$Basics$identity,
	multiply: $elm$core$Basics$or,
	not: $elm$core$Basics$identity,
	notEqual: function (_v46) {
		return $elm$core$Basics$or;
	},
	numbersAsList: $elm$core$List$any($elm$core$Basics$identity),
	pickOne: function (_v47) {
		return $elm$core$Basics$identity;
	},
	product: $elm$core$Basics$identity,
	relatedBool: F2(
		function (_v48, _v49) {
			return false;
		}),
	relatedDate: F2(
		function (_v50, _v51) {
			return false;
		}),
	relatedDateTime: F2(
		function (_v52, _v53) {
			return false;
		}),
	relatedNumber: F2(
		function (_v54, _v55) {
			return false;
		}),
	relatedString: F2(
		function (_v56, _v57) {
			return false;
		}),
	round: $elm$core$Basics$identity,
	stringIn: $elm$core$Basics$or,
	stringNotIn: $elm$core$Basics$or,
	stringsAsList: $elm$core$List$any($elm$core$Basics$identity),
	subtract: $elm$core$Basics$or,
	sum: $elm$core$Basics$identity,
	targetChallengeReasons: $elm$core$Basics$identity,
	yearNumber: $elm$core$Basics$identity
};
var $author$project$DataElement$Expression$relatedFieldUsesFeedback = F2(
	function (relationship, _v0) {
		return A2(
			$author$project$DataElement$Expression$applyLocalString,
			$author$project$DataElement$Expression$cyclic$usesFeedbackTransformer(),
			relationship.idToMatch) || (A2(
			$author$project$DataElement$Expression$applyLocalStringList,
			$author$project$DataElement$Expression$cyclic$usesFeedbackTransformer(),
			relationship.localIds) || A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			false,
			$author$project$DataElement$Expression$applyLocalBool(
				$author$project$DataElement$Expression$cyclic$usesFeedbackTransformer()),
			relationship.optionalFilter));
	});
function $author$project$DataElement$Expression$cyclic$usesFeedbackTransformer() {
	return _Utils_update(
		$author$project$DataElement$Expression$baseBooleanTransformer,
		{
			challengeReasons: function (_v1) {
				return true;
			},
			relatedBool: $author$project$DataElement$Expression$relatedFieldUsesFeedback,
			relatedDate: $author$project$DataElement$Expression$relatedFieldUsesFeedback,
			relatedDateTime: $author$project$DataElement$Expression$relatedFieldUsesFeedback,
			relatedNumber: $author$project$DataElement$Expression$relatedFieldUsesFeedback,
			relatedString: $author$project$DataElement$Expression$relatedFieldUsesFeedback,
			targetChallengeReasons: function (_v2) {
				return true;
			}
		});
}
try {
	var $author$project$DataElement$Expression$usesFeedbackTransformer = $author$project$DataElement$Expression$cyclic$usesFeedbackTransformer();
	$author$project$DataElement$Expression$cyclic$usesFeedbackTransformer = function () {
		return $author$project$DataElement$Expression$usesFeedbackTransformer;
	};
} catch ($) {
	throw 'Some top-level definitions from `DataElement.Expression` are causing infinite recursion:\n\n  ┌─────┐\n  │    usesFeedbackTransformer\n  │     ↓\n  │    relatedFieldUsesFeedback\n  └─────┘\n\nThese errors are very tricky, so read https://elm-lang.org/0.19.1/bad-recursion to learn how to fix it!';}
var $author$project$DataElement$CrmDataEngine$Where$usesFeedbackData = function (clause) {
	return A2($author$project$DataElement$CrmDataEngine$Where$usesDependencyTransformer, $author$project$DataElement$Expression$usesFeedbackTransformer, clause);
};
var $author$project$DataElement$WhereClause$usesTransformer = F2(
	function (transformerToUse, whereIndividual) {
		switch (whereIndividual.$) {
			case 'WhereIn':
				var globalStringListExpr = whereIndividual.b;
				return A2($author$project$DataElement$Expression$applyGlobalStringList, transformerToUse, globalStringListExpr);
			case 'WhereEqual':
				var globalFieldExpr = whereIndividual.b;
				return A2($author$project$DataElement$Expression$applyGlobalField, transformerToUse, globalFieldExpr);
			case 'WhereNotEqual':
				var globalFieldExpr = whereIndividual.b;
				return A2($author$project$DataElement$Expression$applyGlobalField, transformerToUse, globalFieldExpr);
			case 'WhereGT':
				var globalCompExpr = whereIndividual.b;
				return A2($author$project$DataElement$Expression$applyGlobalComparable, transformerToUse, globalCompExpr);
			case 'WhereGTE':
				var globalCompExpr = whereIndividual.b;
				return A2($author$project$DataElement$Expression$applyGlobalComparable, transformerToUse, globalCompExpr);
			case 'WhereLT':
				var globalCompExpr = whereIndividual.b;
				return A2($author$project$DataElement$Expression$applyGlobalComparable, transformerToUse, globalCompExpr);
			default:
				var globalCompExpr = whereIndividual.b;
				return A2($author$project$DataElement$Expression$applyGlobalComparable, transformerToUse, globalCompExpr);
		}
	});
var $author$project$DataElement$WhereClause$usesFeedbackData = function (whereIndividual) {
	return A2($author$project$DataElement$WhereClause$usesTransformer, $author$project$DataElement$Expression$usesFeedbackTransformer, whereIndividual);
};
var $author$project$DataElement$elementUsesFeedbackData = function (_v0) {
	var element = _v0.b;
	if (element.$ === 'RecordList') {
		switch (element.a.$) {
			case 'CrmQuery':
				var info = element.a.a;
				return A2(
					$elm$core$List$any,
					$author$project$DataElement$WhereClause$usesFeedbackData,
					A3($elm_community$maybe_extra$Maybe$Extra$unwrap, _List_Nil, $author$project$DataElement$WhereClause$flatten, info.whereClause));
			case 'NitroQuery':
				var info = element.a.a;
				return A2(
					$elm$core$List$any,
					$author$project$DataElement$WhereClause$usesFeedbackData,
					A3($elm_community$maybe_extra$Maybe$Extra$unwrap, _List_Nil, $author$project$DataElement$WhereClause$flatten, info.whereClause));
			case 'SalesQuery':
				var info = element.a.a;
				return A2($author$project$DataElement$Expression$applyGlobalStringList, $author$project$DataElement$Expression$usesFeedbackTransformer, info.accountIds) || (A3(
					$elm_community$maybe_extra$Maybe$Extra$unwrap,
					false,
					$author$project$DataElement$Expression$applyGlobalDate($author$project$DataElement$Expression$usesFeedbackTransformer),
					info.startDate) || A3(
					$elm_community$maybe_extra$Maybe$Extra$unwrap,
					false,
					$author$project$DataElement$Expression$applyGlobalDate($author$project$DataElement$Expression$usesFeedbackTransformer),
					info.endDate));
			case 'CrmDataEngineQuery':
				var info = element.a.a;
				return A3($elm_community$maybe_extra$Maybe$Extra$unwrap, false, $author$project$DataElement$CrmDataEngine$Where$usesFeedbackData, info.whereClause);
			case 'CalcOneForOne':
				var info = element.a.a;
				return A2(
					$elm$core$List$any,
					$author$project$DataElement$Expression$applyLocalField($author$project$DataElement$Expression$usesFeedbackTransformer),
					$pzp1997$assoc_list$AssocList$values(info.fields));
			case 'CalcSortList':
				var info = element.a.a;
				return A2(
					$elm$core$List$any,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.expression;
						},
						$author$project$DataElement$Expression$applyLocalComparable($author$project$DataElement$Expression$usesFeedbackTransformer)),
					$mgold$elm_nonempty_list$List$Nonempty$toList(info.sortBy));
			case 'CalcFilterList':
				return false;
			case 'CalcSublist':
				return false;
			case 'AlignedTerritories':
				return false;
			case 'FeedbackChannelGoals':
				return true;
			case 'FeedbackProductGoals':
				return true;
			case 'FeedbackAccountData':
				return true;
			case 'FeedbackAccountChannelGoals':
				return true;
			case 'FeedbackAccountProductGoals':
				return true;
			case 'FeedbackAccountProductMetrics':
				return true;
			case 'CallAttendees':
				var _v2 = element.a;
				return false;
			default:
				return false;
		}
	} else {
		switch (element.a.$) {
			case 'FeedbackOverview':
				return true;
			case 'ContextQuery':
				return false;
			case 'LimitOneCrmQuery':
				var info = element.a.a;
				return A2(
					$elm$core$List$any,
					$author$project$DataElement$WhereClause$usesFeedbackData,
					A3($elm_community$maybe_extra$Maybe$Extra$unwrap, _List_Nil, $author$project$DataElement$WhereClause$flatten, info.whereClause));
			case 'LimitOneSalesQuery':
				var info = element.a.a;
				return A2($author$project$DataElement$Expression$applyGlobalStringList, $author$project$DataElement$Expression$usesFeedbackTransformer, info.accountIds) || (A3(
					$elm_community$maybe_extra$Maybe$Extra$unwrap,
					false,
					$author$project$DataElement$Expression$applyGlobalDate($author$project$DataElement$Expression$usesFeedbackTransformer),
					info.startDate) || A3(
					$elm_community$maybe_extra$Maybe$Extra$unwrap,
					false,
					$author$project$DataElement$Expression$applyGlobalDate($author$project$DataElement$Expression$usesFeedbackTransformer),
					info.endDate));
			case 'LimitOneNitroQuery':
				var info = element.a.a;
				return A2(
					$elm$core$List$any,
					$author$project$DataElement$WhereClause$usesFeedbackData,
					A3($elm_community$maybe_extra$Maybe$Extra$unwrap, _List_Nil, $author$project$DataElement$WhereClause$flatten, info.whereClause));
			case 'LimitOneCrmDataEngineQuery':
				var info = element.a.a;
				return A3($elm_community$maybe_extra$Maybe$Extra$unwrap, false, $author$project$DataElement$CrmDataEngine$Where$usesFeedbackData, info.whereClause);
			case 'Today':
				var _v3 = element.a;
				return false;
			case 'Now':
				var _v4 = element.a;
				return false;
			case 'CalcSummarize':
				var info = element.a.a;
				return A2(
					$elm$core$List$any,
					$author$project$DataElement$Expression$applyGlobalField($author$project$DataElement$Expression$usesFeedbackTransformer),
					$pzp1997$assoc_list$AssocList$values(info.fields));
			case 'ObjectTranslation':
				return false;
			case 'FieldTranslation':
				return false;
			case 'VeevaMessages':
				return false;
			case 'DatepickerSelection':
				var info = element.a.a;
				return A3(
					$elm_community$maybe_extra$Maybe$Extra$unwrap,
					false,
					$author$project$DataElement$Expression$applyGlobalDate($author$project$DataElement$Expression$usesFeedbackTransformer),
					info._default);
			default:
				var info = element.a.a;
				return A2($author$project$DataElement$Expression$applyGlobalStringList, $author$project$DataElement$Expression$usesFeedbackTransformer, info.options) || A3(
					$elm_community$maybe_extra$Maybe$Extra$unwrap,
					false,
					$author$project$DataElement$Expression$applyGlobalString($author$project$DataElement$Expression$usesFeedbackTransformer),
					info.placeholder);
		}
	}
};
var $author$project$DataElement$usesFeedbackData = function (_v0) {
	var elementCollection = _v0.a;
	return A2(
		$elm$core$List$any,
		$author$project$DataElement$elementUsesFeedbackData,
		$author$project$UuidDict$values(elementCollection));
};
var $author$project$Compiler$getFeedbackDataIfNecessary = function (model) {
	var _v0 = $author$project$DataEngine$DataCache$getFeedbackData(model.cache);
	if (_v0.$ === 'NotAsked') {
		return $author$project$DataElement$usesFeedbackData(
			$author$project$StudioApp$dataElements(model.app)) ? $author$project$MyInsights$getFeedbackData('FeedbackData___') : $elm$core$Platform$Cmd$none;
	} else {
		return $elm$core$Platform$Cmd$none;
	}
};
var $author$project$MyInsights$GetCurrentUserLocale = function (a) {
	return {$: 'GetCurrentUserLocale', a: a};
};
var $author$project$MyInsights$getCurrentUserLocale = function (queryId) {
	return $author$project$MyInsights$sendMsg(
		$author$project$MyInsights$GetCurrentUserLocale(queryId));
};
var $author$project$DataEngine$DataCache$getLoadableLocale = function (_v0) {
	var internal = _v0.a;
	return internal.locale;
};
var $author$project$Compiler$getUserLocaleIfNecessary = function (model) {
	var _v0 = $author$project$DataEngine$DataCache$getLoadableLocale(model.cache).a;
	if (_v0.$ === 'NotAsked') {
		return $author$project$MyInsights$getCurrentUserLocale('UserLocale___');
	} else {
		return $elm$core$Platform$Cmd$none;
	}
};
var $author$project$DataEngine$DataCache$insertManifests = F2(
	function (manifests, _v0) {
		var internal = _v0.a;
		return $author$project$DataEngine$DataCache$DataCache(
			_Utils_update(
				internal,
				{
					manifests: _Utils_ap(manifests, internal.manifests)
				}));
	});
var $author$project$DataElement$equal = F2(
	function (_v0, _v1) {
		var el1 = _v0.b;
		var el2 = _v1.b;
		return _Utils_eq(el1, el2);
	});
var $author$project$DataElement$getDiffReferencesFromCollection = F2(
	function (oldCollection, _v0) {
		var newDict = _v0.a;
		var filter = function (_v2) {
			var ref = _v2.a;
			var dataElement = _v2.b;
			var _v1 = A2(
				$author$project$UuidDict$get,
				$author$project$DataElement$Reference$getUuid(ref),
				newDict);
			if (_v1.$ === 'Just') {
				var element = _v1.a;
				return A2($author$project$DataElement$equal, dataElement, element) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
					$author$project$DataElement$Reference$getGenericReference(ref));
			} else {
				return $elm$core$Maybe$Just(
					$author$project$DataElement$Reference$getGenericReference(ref));
			}
		};
		return A2(
			$elm$core$List$filterMap,
			filter,
			$author$project$DataElement$collectionToList(oldCollection));
	});
var $author$project$DependencyGraph$findAllDependentsHelper = F3(
	function (foundSoFar, nextToInvestigate, graph) {
		var newFoundSoFar = A2($elm$core$Set$insert, nextToInvestigate, foundSoFar);
		var newDependents = function (foundDependents) {
			return A2($elm$core$Set$diff, foundDependents, newFoundSoFar);
		}(
			A2($drathier$elm_graph$Graph$outgoing, nextToInvestigate, graph));
		return $elm$core$Set$isEmpty(newDependents) ? newFoundSoFar : A2(
			$stoeffel$set_extra$Set$Extra$concatMap,
			function (depToInvestigate) {
				return A3(
					$author$project$DependencyGraph$findAllDependentsHelper,
					A2($elm$core$Set$union, newFoundSoFar, newDependents),
					depToInvestigate,
					graph);
			},
			newDependents);
	});
var $author$project$DependencyGraph$findAllDependents = F2(
	function (ref, _v0) {
		var graph = _v0.a;
		return A2(
			$elm$core$List$filterMap,
			function (comp) {
				return A2($drathier$elm_graph$Graph$getData, comp, graph);
			},
			$elm$core$Set$toList(
				A3(
					$author$project$DependencyGraph$findAllDependentsHelper,
					$elm$core$Set$empty,
					$author$project$DataElement$Reference$toString(ref),
					graph)));
	});
var $author$project$DependencyGraph$findAllDependentsFrom = F2(
	function (depGraph, ref) {
		return A2($author$project$DependencyGraph$findAllDependents, ref, depGraph);
	});
var $author$project$UuidDict$remove = function (uuid) {
	return $author$project$UuidDict$mapInnerDict(
		$elm$core$Dict$remove(
			$danyx23$elm_uuid$Uuid$toString(uuid)));
};
var $author$project$DataEngine$DataCache$purge = function (ref) {
	return $author$project$DataEngine$DataCache$mapCache(
		$author$project$UuidDict$remove(
			$author$project$DataElement$Reference$getUuid(ref)));
};
var $author$project$DataEngine$purgeUuidAndDependents = F3(
	function (dependencies, ref, cache) {
		return A3(
			$elm$core$List$foldl,
			$author$project$DataEngine$DataCache$purge,
			cache,
			A2(
				$author$project$DependencyGraph$findAllDependentsFrom,
				dependencies,
				$author$project$DataElement$Reference$getGenericReference(ref)));
	});
var $author$project$DataEngine$purgeChangedElementsAndDependents = F3(
	function (oldApp, newApp, cache) {
		var dependencies = $author$project$DependencyGraph$fromDataElements(
			$author$project$StudioApp$dataElements(newApp));
		return A3(
			$elm$core$List$foldl,
			$author$project$DataEngine$purgeUuidAndDependents(dependencies),
			cache,
			A2(
				$author$project$DataElement$getDiffReferencesFromCollection,
				$author$project$StudioApp$dataElements(oldApp),
				$author$project$StudioApp$dataElements(newApp)));
	});
var $author$project$DataEngine$DataCache$removeAllElementsAndManifests = function (_v0) {
	var internal = _v0.a;
	return $author$project$DataEngine$DataCache$DataCache(
		_Utils_update(
			internal,
			{dataElementStates: $author$project$UuidDict$empty, feedbackData: $krisajenkins$remotedata$RemoteData$NotAsked, manifests: _List_Nil}));
};
var $author$project$Compiler$ToFrontEndMsg$ValidationErrors = function (a) {
	return {$: 'ValidationErrors', a: a};
};
var $author$project$Compiler$sendValidationResult = function (model) {
	return $author$project$Compiler$toFrontEnd(
		$author$project$Compiler$ToFrontEndMsg$ConfigValidationResponse(
			A2(
				$elm$core$Result$mapError,
				$author$project$Compiler$ToFrontEndMsg$ValidationErrors,
				A2(
					$elm$core$Result$map,
					$elm$core$Basics$always(_Utils_Tuple0),
					A2(
						$author$project$StudioApp$validate,
						$author$project$DataEngine$DataCache$getManifests(model.cache),
						model.app)))));
};
var $author$project$Compiler$updateFromFrontEnd = F2(
	function (frontEndMsg, model) {
		switch (frontEndMsg.$) {
			case 'ConfigChange':
				var newApp = frontEndMsg.a;
				return A2(
					$Fresheyeball$elm_return$Return$andThen,
					$author$project$Compiler$processRequest,
					A2(
						$Fresheyeball$elm_return$Return$andThen,
						$author$project$Compiler$populateCache,
						A2(
							$Fresheyeball$elm_return$Return$effect_,
							$author$project$Compiler$getFeedbackDataIfNecessary,
							A2(
								$Fresheyeball$elm_return$Return$effect_,
								$author$project$Compiler$sendValidationResult,
								_Utils_Tuple2(
									_Utils_update(
										model,
										{
											app: newApp,
											cache: A3($author$project$DataEngine$purgeChangedElementsAndDependents, model.app, newApp, model.cache)
										}),
									$elm$core$Platform$Cmd$none)))));
			case 'PurgeAllDataElementsAndManifests':
				return A2(
					$Fresheyeball$elm_return$Return$andThen,
					$author$project$Compiler$processRequest,
					A2(
						$Fresheyeball$elm_return$Return$andThen,
						$author$project$Compiler$populateCache,
						A2(
							$Fresheyeball$elm_return$Return$effect_,
							$author$project$Compiler$getFeedbackDataIfNecessary,
							A2(
								$Fresheyeball$elm_return$Return$effect_,
								$author$project$Compiler$getUserLocaleIfNecessary,
								A2(
									$Fresheyeball$elm_return$Return$effect_,
									$author$project$Compiler$confirmUserTimeZoneIfNecessary,
									_Utils_Tuple2(
										_Utils_update(
											model,
											{
												cache: $author$project$DataEngine$DataCache$removeAllElementsAndManifests(model.cache)
											}),
										$elm$core$Platform$Cmd$none))))));
			default:
				var manifests = frontEndMsg.a;
				return A2(
					$Fresheyeball$elm_return$Return$andThen,
					$author$project$Compiler$processRequest,
					A2(
						$Fresheyeball$elm_return$Return$andThen,
						$author$project$Compiler$populateCache,
						A2(
							$Fresheyeball$elm_return$Return$effect_,
							$author$project$Compiler$sendValidationResult,
							_Utils_Tuple2(
								_Utils_update(
									model,
									{
										cache: A2($author$project$DataEngine$DataCache$insertManifests, manifests, model.cache)
									}),
								$elm$core$Platform$Cmd$none))));
		}
	});
var $author$project$DataElement$Datepicker$toRecordCache = function (date) {
	return A3(
		$author$project$DataEngine$RecordCache$insert,
		$author$project$DataElement$Datepicker$fieldName,
		$author$project$FieldValue$DateValue(date),
		$author$project$DataEngine$RecordCache$empty);
};
var $author$project$Compiler$insertDatepickerSelection = F3(
	function (dataElementRef, selection, cache) {
		var maybeDate = $elm$core$Result$toMaybe(
			$justinmimbs$date$Date$fromIsoString(selection));
		if (maybeDate.$ === 'Just') {
			var date = maybeDate.a;
			return A4(
				$author$project$DataEngine$DataCache$insertSingleton,
				dataElementRef,
				$author$project$DataEngine$RecordMetadata$fromList(
					$pzp1997$assoc_list$AssocList$toList($author$project$DataElement$Datepicker$fields)),
				$elm$core$Result$Ok(
					$author$project$DataElement$Datepicker$toRecordCache(date)),
				cache);
		} else {
			return cache;
		}
	});
var $author$project$DataEngine$CacheState$Deleted = function (a) {
	return {$: 'Deleted', a: a};
};
var $author$project$DataEngine$DataCache$softDelete = F2(
	function (ref, cache) {
		var _v0 = A2($author$project$DataEngine$DataCache$getDataElementState, ref, cache);
		if ((_v0.$ === 'Just') && (_v0.a.$ === 'Success')) {
			var deCache = _v0.a.a;
			return A2(
				$author$project$DataEngine$DataCache$mapCache,
				A2(
					$author$project$UuidDict$insert,
					$author$project$DataElement$Reference$getUuid(ref),
					$author$project$DataEngine$CacheState$Deleted(deCache)),
				cache);
		} else {
			return A2($author$project$DataEngine$DataCache$purge, ref, cache);
		}
	});
var $author$project$DataEngine$softDeleteUuidAndDependents = F3(
	function (dependencies, ref, cache) {
		return A3(
			$elm$core$List$foldl,
			$author$project$DataEngine$DataCache$softDelete,
			cache,
			A2(
				$author$project$DependencyGraph$findAllDependentsFrom,
				dependencies,
				$author$project$DataElement$Reference$getGenericReference(ref)));
	});
var $author$project$DataElement$Dropdown$toRecordCache = function (maybeSelection) {
	if (maybeSelection.$ === 'Just') {
		var selection = maybeSelection.a;
		return A3(
			$author$project$DataEngine$RecordCache$insert,
			$author$project$DataElement$Dropdown$fieldName,
			$author$project$FieldValue$StringValue(selection),
			$author$project$DataEngine$RecordCache$empty);
	} else {
		return $author$project$DataEngine$RecordCache$empty;
	}
};
var $author$project$Compiler$updateFromPreview = F2(
	function (previewMsg, model) {
		switch (previewMsg.$) {
			case 'Request':
				var request = previewMsg.a;
				return A2(
					$Fresheyeball$elm_return$Return$andThen,
					$author$project$Compiler$processRequest,
					A2(
						$Fresheyeball$elm_return$Return$andThen,
						$author$project$Compiler$populateCache,
						$Fresheyeball$elm_return$Return$singleton(
							_Utils_update(
								model,
								{
									activeRequest: $elm$core$Maybe$Just(request)
								}))));
			case 'NewDatepickerSelection':
				var dataElementRef = previewMsg.a;
				var newSelection = previewMsg.b;
				return A2(
					$Fresheyeball$elm_return$Return$andThen,
					$author$project$Compiler$processRequest,
					A2(
						$Fresheyeball$elm_return$Return$andThen,
						$author$project$Compiler$populateCache,
						$Fresheyeball$elm_return$Return$singleton(
							_Utils_update(
								model,
								{
									cache: A3(
										$author$project$Compiler$insertDatepickerSelection,
										dataElementRef,
										newSelection,
										A3(
											$author$project$DataEngine$softDeleteUuidAndDependents,
											$author$project$DependencyGraph$fromDataElements(
												$author$project$StudioApp$dataElements(model.app)),
											$author$project$DataElement$Reference$getGenericReference(dataElementRef),
											model.cache))
								}))));
			default:
				var dataElementRef = previewMsg.a;
				var newSelection = previewMsg.b;
				return A2(
					$Fresheyeball$elm_return$Return$andThen,
					$author$project$Compiler$processRequest,
					A2(
						$Fresheyeball$elm_return$Return$andThen,
						$author$project$Compiler$populateCache,
						$Fresheyeball$elm_return$Return$singleton(
							_Utils_update(
								model,
								{
									cache: A4(
										$author$project$DataEngine$DataCache$insertSingleton,
										dataElementRef,
										$author$project$DataEngine$RecordMetadata$fromList(
											$pzp1997$assoc_list$AssocList$toList($author$project$DataElement$Dropdown$fields)),
										$elm$core$Result$Ok(
											$author$project$DataElement$Dropdown$toRecordCache(
												$author$project$Calc$isNotReservedString(
													$author$project$StudioString$withoutObject(newSelection)))),
										A3(
											$author$project$DataEngine$softDeleteUuidAndDependents,
											$author$project$DependencyGraph$fromDataElements(
												$author$project$StudioApp$dataElements(model.app)),
											$author$project$DataElement$Reference$getGenericReference(dataElementRef),
											model.cache))
								}))));
		}
	});
var $author$project$Compiler$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 'NoOp':
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 'FromFrontEnd':
				if (msg.a.$ === 'Err') {
					var err = msg.a.a;
					var _v1 = A2(
						$elm$core$Debug$log,
						'message from front end decoding error',
						$elm$json$Json$Decode$errorToString(err));
					return _Utils_Tuple2(
						model,
						$author$project$Compiler$toFrontEnd(
							$author$project$Compiler$ToFrontEndMsg$ConfigValidationResponse(
								$elm$core$Result$Err(
									$author$project$Compiler$ToFrontEndMsg$JsonError(err)))));
				} else {
					var innerMsg = msg.a.a;
					return A2($author$project$Compiler$updateFromFrontEnd, innerMsg, model);
				}
			case 'FromPreview':
				if (msg.a.$ === 'Err') {
					var err = msg.a.a;
					return _Debug_todo(
						'Compiler',
						{
							start: {line: 153, column: 13},
							end: {line: 153, column: 23}
						})('Handle errors in decoding messages from Preview');
				} else {
					var innerMsg = msg.a.a;
					return A2($author$project$Compiler$updateFromPreview, innerMsg, model);
				}
			case 'RxSingleton':
				var ref = msg.a;
				var metadata = msg.b;
				var result = msg.c;
				return A2(
					$Fresheyeball$elm_return$Return$andThen,
					$author$project$Compiler$processRequest,
					A2(
						$Fresheyeball$elm_return$Return$andThen,
						$author$project$Compiler$populateCache,
						$Fresheyeball$elm_return$Return$singleton(
							_Utils_update(
								model,
								{
									cache: A4($author$project$DataEngine$DataCache$insertSingleton, ref, metadata, result, model.cache)
								}))));
			case 'RxListOfRecords':
				var ref = msg.a;
				var metadata = msg.b;
				var result = msg.c;
				return A2(
					$Fresheyeball$elm_return$Return$andThen,
					$author$project$Compiler$processRequest,
					A2(
						$Fresheyeball$elm_return$Return$andThen,
						$author$project$Compiler$populateCache,
						$Fresheyeball$elm_return$Return$singleton(
							_Utils_update(
								model,
								{
									cache: A4($author$project$DataEngine$DataCache$insertListOfRecords, ref, metadata, result, model.cache)
								}))));
			case 'RxVeevaMessageTwoStep':
				var ref = msg.a;
				var vmInfo = msg.b;
				var result = msg.c;
				if (result.$ === 'Err') {
					var err = result.a;
					return A2(
						$Fresheyeball$elm_return$Return$andThen,
						$author$project$Compiler$processRequest,
						A2(
							$Fresheyeball$elm_return$Return$andThen,
							$author$project$Compiler$populateCache,
							$Fresheyeball$elm_return$Return$singleton(
								_Utils_update(
									model,
									{
										cache: A4(
											$author$project$DataEngine$DataCache$insertSingleton,
											ref,
											$author$project$DataElement$VeevaMessages$metadata(vmInfo),
											$elm$core$Result$Err(err),
											model.cache)
									}))));
				} else {
					var twoStep = result.a;
					var _v3 = $author$project$MyInsights$getTwoStepMessages(twoStep);
					if (_v3.$ === 'Nothing') {
						return A2(
							$Fresheyeball$elm_return$Return$command,
							A3(
								$author$project$MyInsights$getTwoStepCmd,
								$author$project$DataElement$Reference$toString(ref),
								A2(
									$elm$core$List$map,
									function (_v4) {
										var name = _v4.name;
										var category = _v4.category;
										return {msgCategory: category, msgName: name};
									},
									vmInfo.tokens),
								twoStep),
							$Fresheyeball$elm_return$Return$singleton(model));
					} else {
						var messages = _v3.a;
						return A2(
							$Fresheyeball$elm_return$Return$andThen,
							$author$project$Compiler$processRequest,
							A2(
								$Fresheyeball$elm_return$Return$andThen,
								$author$project$Compiler$populateCache,
								$Fresheyeball$elm_return$Return$singleton(
									_Utils_update(
										model,
										{
											cache: A4(
												$author$project$DataEngine$DataCache$insertSingleton,
												ref,
												$author$project$DataElement$VeevaMessages$metadata(vmInfo),
												$elm$core$Result$Ok(
													$author$project$DataElement$VeevaMessages$toRecordCache(messages)),
												model.cache)
										}))));
					}
				}
			case 'RxTimeZone':
				var zone = msg.a;
				return $Fresheyeball$elm_return$Return$singleton(
					_Utils_update(
						model,
						{
							cache: A2(
								$author$project$DataEngine$DataCache$mapTimeZone,
								$author$project$LoadableTimeZone$setDevice(zone),
								model.cache)
						}));
			case 'RxUserTimeZone':
				var result = msg.a;
				return A2(
					$Fresheyeball$elm_return$Return$andThen,
					$author$project$Compiler$processRequest,
					A2(
						$Fresheyeball$elm_return$Return$andThen,
						$author$project$Compiler$populateCache,
						$Fresheyeball$elm_return$Return$singleton(
							_Utils_update(
								model,
								{
									cache: A2(
										$author$project$DataEngine$DataCache$mapTimeZone,
										$author$project$LoadableTimeZone$setUser(result),
										model.cache)
								}))));
			case 'RxUserLocale':
				var result = msg.a;
				return A2(
					$Fresheyeball$elm_return$Return$andThen,
					$author$project$Compiler$processRequest,
					A2(
						$Fresheyeball$elm_return$Return$andThen,
						$author$project$Compiler$populateCache,
						$Fresheyeball$elm_return$Return$singleton(
							_Utils_update(
								model,
								{
									cache: A2(
										$author$project$DataEngine$DataCache$mapLocale,
										$author$project$LoadableLocale$setUser(result),
										model.cache)
								}))));
			default:
				var result = msg.a;
				return A2(
					$Fresheyeball$elm_return$Return$andThen,
					$author$project$Compiler$processRequest,
					A2(
						$Fresheyeball$elm_return$Return$andThen,
						$author$project$Compiler$populateCache,
						$Fresheyeball$elm_return$Return$singleton(
							_Utils_update(
								model,
								{
									cache: A2($author$project$DataEngine$DataCache$insertFeedbackData, result, model.cache)
								}))));
		}
	});
var $elm$core$Platform$worker = _Platform_worker;
var $author$project$Compiler$main = $elm$core$Platform$worker(
	{init: $author$project$Compiler$init, subscriptions: $author$project$Compiler$subscriptions, update: $author$project$Compiler$update});
_Platform_export({'Compiler':{'init':$author$project$Compiler$main($elm$json$Json$Decode$value)(0)}});}(this));